/*!
 * Box UI Element
 *
 * Copyright 2019 Box, Inc. All rights reserved.
 *
 * This product includes software developed by Box, Inc. ("Box")
 * (http://www.box.com)
 *
 * ALL BOX SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL BOX BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * See the Box license for the specific language governing permissions
 * and limitations under the license.
 */

/* eslint-disable */

/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ 53095: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      module.exports = __webpack_require__(44569);

      /***/
    },

    /***/ 85846: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      var settle = __webpack_require__(7184);
      var cookies = __webpack_require__(50310);
      var buildURL = __webpack_require__(81036);
      var buildFullPath = __webpack_require__(42629);
      var parseHeaders = __webpack_require__(30902);
      var isURLSameOrigin = __webpack_require__(27004);
      var createError = __webpack_require__(35449);
      var defaults = __webpack_require__(47345);
      var Cancel = __webpack_require__(20918);
      module.exports = function xhrAdapter(config) {
        return new Promise(function dispatchXhrRequest(resolve, reject) {
          var requestData = config.data;
          var requestHeaders = config.headers;
          var responseType = config.responseType;
          var onCanceled;
          function done() {
            if (config.cancelToken) {
              config.cancelToken.unsubscribe(onCanceled);
            }
            if (config.signal) {
              config.signal.removeEventListener('abort', onCanceled);
            }
          }
          if (utils.isFormData(requestData)) {
            delete requestHeaders['Content-Type']; // Let the browser set it
          }
          var request = new XMLHttpRequest();

          // HTTP basic authentication
          if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
          }
          var fullPath = buildFullPath(config.baseURL, config.url);
          request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

          // Set the request timeout in MS
          request.timeout = config.timeout;
          function onloadend() {
            if (!request) {
              return;
            }
            // Prepare the response
            var responseHeaders =
              'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData =
              !responseType || responseType === 'text' || responseType === 'json'
                ? request.responseText
                : request.response;
            var response = {
              data: responseData,
              status: request.status,
              statusText: request.statusText,
              headers: responseHeaders,
              config: config,
              request: request,
            };
            settle(
              function _resolve(value) {
                resolve(value);
                done();
              },
              function _reject(err) {
                reject(err);
                done();
              },
              response,
            );

            // Clean up request
            request = null;
          }
          if ('onloadend' in request) {
            // Use onloadend if available
            request.onloadend = onloadend;
          } else {
            // Listen for ready state to emulate onloadend
            request.onreadystatechange = function handleLoad() {
              if (!request || request.readyState !== 4) {
                return;
              }

              // The request errored out and we didn't get a response, this will be
              // handled by onerror instead
              // With one exception: request that using file: protocol, most browsers
              // will return status as 0 even though it's a successful request
              if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                return;
              }
              // readystate handler is calling before onerror or ontimeout handlers,
              // so we should call onloadend on the next 'tick'
              setTimeout(onloadend);
            };
          }

          // Handle browser request cancellation (as opposed to a manual cancellation)
          request.onabort = function handleAbort() {
            if (!request) {
              return;
            }
            reject(createError('Request aborted', config, 'ECONNABORTED', request));

            // Clean up request
            request = null;
          };

          // Handle low level network errors
          request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError('Network Error', config, null, request));

            // Clean up request
            request = null;
          };

          // Handle timeout
          request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout
              ? 'timeout of ' + config.timeout + 'ms exceeded'
              : 'timeout exceeded';
            var transitional = config.transitional || defaults.transitional;
            if (config.timeoutErrorMessage) {
              timeoutErrorMessage = config.timeoutErrorMessage;
            }
            reject(
              createError(
                timeoutErrorMessage,
                config,
                transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
                request,
              ),
            );

            // Clean up request
            request = null;
          };

          // Add xsrf header
          // This is only done if running in a standard browser environment.
          // Specifically not if we're in a web worker, or react-native.
          if (utils.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue =
              (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName
                ? cookies.read(config.xsrfCookieName)
                : undefined;
            if (xsrfValue) {
              requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
          }

          // Add headers to the request
          if ('setRequestHeader' in request) {
            utils.forEach(requestHeaders, function setRequestHeader(val, key) {
              if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                // Remove Content-Type if data is undefined
                delete requestHeaders[key];
              } else {
                // Otherwise add header to the request
                request.setRequestHeader(key, val);
              }
            });
          }

          // Add withCredentials to request if needed
          if (!utils.isUndefined(config.withCredentials)) {
            request.withCredentials = !!config.withCredentials;
          }

          // Add responseType to request if needed
          if (responseType && responseType !== 'json') {
            request.responseType = config.responseType;
          }

          // Handle progress if needed
          if (typeof config.onDownloadProgress === 'function') {
            request.addEventListener('progress', config.onDownloadProgress);
          }

          // Not all browsers support upload events
          if (typeof config.onUploadProgress === 'function' && request.upload) {
            request.upload.addEventListener('progress', config.onUploadProgress);
          }
          if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function (cancel) {
              if (!request) {
                return;
              }
              reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
              request.abort();
              request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) {
              config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
            }
          }
          if (!requestData) {
            requestData = null;
          }

          // Send the request
          request.send(requestData);
        });
      };

      /***/
    },

    /***/ 44569: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      var bind = __webpack_require__(6654);
      var Axios = __webpack_require__(28905);
      var mergeConfig = __webpack_require__(1441);
      var defaults = __webpack_require__(47345);

      /**
       * Create an instance of Axios
       *
       * @param {Object} defaultConfig The default config for the instance
       * @return {Axios} A new instance of Axios
       */
      function createInstance(defaultConfig) {
        var context = new Axios(defaultConfig);
        var instance = bind(Axios.prototype.request, context);

        // Copy axios.prototype to instance
        utils.extend(instance, Axios.prototype, context);

        // Copy context to instance
        utils.extend(instance, context);

        // Factory for creating new instances
        instance.create = function create(instanceConfig) {
          return createInstance(mergeConfig(defaultConfig, instanceConfig));
        };
        return instance;
      }

      // Create the default instance to be exported
      var axios = createInstance(defaults);

      // Expose Axios class to allow class inheritance
      axios.Axios = Axios;

      // Expose Cancel & CancelToken
      axios.Cancel = __webpack_require__(20918);
      axios.CancelToken = __webpack_require__(87709);
      axios.isCancel = __webpack_require__(7770);
      axios.VERSION = __webpack_require__(78219).version;

      // Expose all/spread
      axios.all = function all(promises) {
        return Promise.all(promises);
      };
      axios.spread = __webpack_require__(27238);

      // Expose isAxiosError
      axios.isAxiosError = __webpack_require__(75657);
      module.exports = axios;

      // Allow use of default import syntax in TypeScript
      module.exports['default'] = axios;

      /***/
    },

    /***/ 20918: /***/ module => {
      'use strict';

      /**
       * A `Cancel` is an object that is thrown when an operation is canceled.
       *
       * @class
       * @param {string=} message The message.
       */
      function Cancel(message) {
        this.message = message;
      }
      Cancel.prototype.toString = function toString() {
        return 'Cancel' + (this.message ? ': ' + this.message : '');
      };
      Cancel.prototype.__CANCEL__ = true;
      module.exports = Cancel;

      /***/
    },

    /***/ 87709: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var Cancel = __webpack_require__(20918);

      /**
       * A `CancelToken` is an object that can be used to request cancellation of an operation.
       *
       * @class
       * @param {Function} executor The executor function.
       */
      function CancelToken(executor) {
        if (typeof executor !== 'function') {
          throw new TypeError('executor must be a function.');
        }
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
          resolvePromise = resolve;
        });
        var token = this;

        // eslint-disable-next-line func-names
        this.promise.then(function (cancel) {
          if (!token._listeners) return;
          var i;
          var l = token._listeners.length;
          for (i = 0; i < l; i++) {
            token._listeners[i](cancel);
          }
          token._listeners = null;
        });

        // eslint-disable-next-line func-names
        this.promise.then = function (onfulfilled) {
          var _resolve;
          // eslint-disable-next-line func-names
          var promise = new Promise(function (resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
          }).then(onfulfilled);
          promise.cancel = function reject() {
            token.unsubscribe(_resolve);
          };
          return promise;
        };
        executor(function cancel(message) {
          if (token.reason) {
            // Cancellation has already been requested
            return;
          }
          token.reason = new Cancel(message);
          resolvePromise(token.reason);
        });
      }

      /**
       * Throws a `Cancel` if cancellation has been requested.
       */
      CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) {
          throw this.reason;
        }
      };

      /**
       * Subscribe to the cancel signal
       */

      CancelToken.prototype.subscribe = function subscribe(listener) {
        if (this.reason) {
          listener(this.reason);
          return;
        }
        if (this._listeners) {
          this._listeners.push(listener);
        } else {
          this._listeners = [listener];
        }
      };

      /**
       * Unsubscribe from the cancel signal
       */

      CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
        if (!this._listeners) {
          return;
        }
        var index = this._listeners.indexOf(listener);
        if (index !== -1) {
          this._listeners.splice(index, 1);
        }
      };

      /**
       * Returns an object that contains a new `CancelToken` and a function that, when called,
       * cancels the `CancelToken`.
       */
      CancelToken.source = function source() {
        var cancel;
        var token = new CancelToken(function executor(c) {
          cancel = c;
        });
        return {
          token: token,
          cancel: cancel,
        };
      };
      module.exports = CancelToken;

      /***/
    },

    /***/ 7770: /***/ module => {
      'use strict';

      module.exports = function isCancel(value) {
        return !!(value && value.__CANCEL__);
      };

      /***/
    },

    /***/ 28905: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      var buildURL = __webpack_require__(81036);
      var InterceptorManager = __webpack_require__(761);
      var dispatchRequest = __webpack_require__(68768);
      var mergeConfig = __webpack_require__(1441);
      var validator = __webpack_require__(89419);
      var validators = validator.validators;
      /**
       * Create a new instance of Axios
       *
       * @param {Object} instanceConfig The default config for the instance
       */
      function Axios(instanceConfig) {
        this.defaults = instanceConfig;
        this.interceptors = {
          request: new InterceptorManager(),
          response: new InterceptorManager(),
        };
      }

      /**
       * Dispatch a request
       *
       * @param {Object} config The config specific for this request (merged with this.defaults)
       */
      Axios.prototype.request = function request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/
        // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
          config = config || {};
          config.url = configOrUrl;
        } else {
          config = configOrUrl || {};
        }
        if (!config.url) {
          throw new Error('Provided config url is not valid');
        }
        config = mergeConfig(this.defaults, config);

        // Set config.method
        if (config.method) {
          config.method = config.method.toLowerCase();
        } else if (this.defaults.method) {
          config.method = this.defaults.method.toLowerCase();
        } else {
          config.method = 'get';
        }
        var transitional = config.transitional;
        if (transitional !== undefined) {
          validator.assertOptions(
            transitional,
            {
              silentJSONParsing: validators.transitional(validators.boolean),
              forcedJSONParsing: validators.transitional(validators.boolean),
              clarifyTimeoutError: validators.transitional(validators.boolean),
            },
            false,
          );
        }

        // filter out skipped interceptors
        var requestInterceptorChain = [];
        var synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
          if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
            return;
          }
          synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
          requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        var responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
          responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        var promise;
        if (!synchronousRequestInterceptors) {
          var chain = [dispatchRequest, undefined];
          Array.prototype.unshift.apply(chain, requestInterceptorChain);
          chain = chain.concat(responseInterceptorChain);
          promise = Promise.resolve(config);
          while (chain.length) {
            promise = promise.then(chain.shift(), chain.shift());
          }
          return promise;
        }
        var newConfig = config;
        while (requestInterceptorChain.length) {
          var onFulfilled = requestInterceptorChain.shift();
          var onRejected = requestInterceptorChain.shift();
          try {
            newConfig = onFulfilled(newConfig);
          } catch (error) {
            onRejected(error);
            break;
          }
        }
        try {
          promise = dispatchRequest(newConfig);
        } catch (error) {
          return Promise.reject(error);
        }
        while (responseInterceptorChain.length) {
          promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
        }
        return promise;
      };
      Axios.prototype.getUri = function getUri(config) {
        if (!config.url) {
          throw new Error('Provided config url is not valid');
        }
        config = mergeConfig(this.defaults, config);
        return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
      };

      // Provide aliases for supported request methods
      utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, config) {
          return this.request(
            mergeConfig(config || {}, {
              method: method,
              url: url,
              data: (config || {}).data,
            }),
          );
        };
      });
      utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, data, config) {
          return this.request(
            mergeConfig(config || {}, {
              method: method,
              url: url,
              data: data,
            }),
          );
        };
      });
      module.exports = Axios;

      /***/
    },

    /***/ 761: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      function InterceptorManager() {
        this.handlers = [];
      }

      /**
       * Add a new interceptor to the stack
       *
       * @param {Function} fulfilled The function to handle `then` for a `Promise`
       * @param {Function} rejected The function to handle `reject` for a `Promise`
       *
       * @return {Number} An ID used to remove interceptor later
       */
      InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
        this.handlers.push({
          fulfilled: fulfilled,
          rejected: rejected,
          synchronous: options ? options.synchronous : false,
          runWhen: options ? options.runWhen : null,
        });
        return this.handlers.length - 1;
      };

      /**
       * Remove an interceptor from the stack
       *
       * @param {Number} id The ID that was returned by `use`
       */
      InterceptorManager.prototype.eject = function eject(id) {
        if (this.handlers[id]) {
          this.handlers[id] = null;
        }
      };

      /**
       * Iterate over all the registered interceptors
       *
       * This method is particularly useful for skipping over any
       * interceptors that may have become `null` calling `eject`.
       *
       * @param {Function} fn The function to call for each interceptor
       */
      InterceptorManager.prototype.forEach = function forEach(fn) {
        utils.forEach(this.handlers, function forEachHandler(h) {
          if (h !== null) {
            fn(h);
          }
        });
      };
      module.exports = InterceptorManager;

      /***/
    },

    /***/ 42629: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var isAbsoluteURL = __webpack_require__(97571);
      var combineURLs = __webpack_require__(51190);

      /**
       * Creates a new URL by combining the baseURL with the requestedURL,
       * only when the requestedURL is not already an absolute URL.
       * If the requestURL is absolute, this function returns the requestedURL untouched.
       *
       * @param {string} baseURL The base URL
       * @param {string} requestedURL Absolute or relative URL to combine
       * @returns {string} The combined full path
       */
      module.exports = function buildFullPath(baseURL, requestedURL) {
        if (baseURL && !isAbsoluteURL(requestedURL)) {
          return combineURLs(baseURL, requestedURL);
        }
        return requestedURL;
      };

      /***/
    },

    /***/ 35449: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var enhanceError = __webpack_require__(9703);

      /**
       * Create an Error with the specified message, config, error code, request and response.
       *
       * @param {string} message The error message.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The created error.
       */
      module.exports = function createError(message, config, code, request, response) {
        var error = new Error(message);
        return enhanceError(error, config, code, request, response);
      };

      /***/
    },

    /***/ 68768: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      var transformData = __webpack_require__(35871);
      var isCancel = __webpack_require__(7770);
      var defaults = __webpack_require__(47345);
      var Cancel = __webpack_require__(20918);

      /**
       * Throws a `Cancel` if cancellation has been requested.
       */
      function throwIfCancellationRequested(config) {
        if (config.cancelToken) {
          config.cancelToken.throwIfRequested();
        }
        if (config.signal && config.signal.aborted) {
          throw new Cancel('canceled');
        }
      }

      /**
       * Dispatch a request to the server using the configured adapter.
       *
       * @param {object} config The config that is to be used for the request
       * @returns {Promise} The Promise to be fulfilled
       */
      module.exports = function dispatchRequest(config) {
        throwIfCancellationRequested(config);

        // Ensure headers exist
        config.headers = config.headers || {};

        // Transform request data
        config.data = transformData.call(config, config.data, config.headers, config.transformRequest);

        // Flatten headers
        config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
        utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
          delete config.headers[method];
        });
        var adapter = config.adapter || defaults.adapter;
        return adapter(config).then(
          function onAdapterResolution(response) {
            throwIfCancellationRequested(config);

            // Transform response data
            response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
            return response;
          },
          function onAdapterRejection(reason) {
            if (!isCancel(reason)) {
              throwIfCancellationRequested(config);

              // Transform response data
              if (reason && reason.response) {
                reason.response.data = transformData.call(
                  config,
                  reason.response.data,
                  reason.response.headers,
                  config.transformResponse,
                );
              }
            }
            return Promise.reject(reason);
          },
        );
      };

      /***/
    },

    /***/ 9703: /***/ module => {
      'use strict';

      /**
       * Update an Error with the specified config, error code, and response.
       *
       * @param {Error} error The error to update.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The error.
       */
      module.exports = function enhanceError(error, config, code, request, response) {
        error.config = config;
        if (code) {
          error.code = code;
        }
        error.request = request;
        error.response = response;
        error.isAxiosError = true;
        error.toJSON = function toJSON() {
          return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null,
          };
        };
        return error;
      };

      /***/
    },

    /***/ 1441: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);

      /**
       * Config-specific merge-function which creates a new config-object
       * by merging two configuration objects together.
       *
       * @param {Object} config1
       * @param {Object} config2
       * @returns {Object} New object resulting from merging config2 to config1
       */
      module.exports = function mergeConfig(config1, config2) {
        // eslint-disable-next-line no-param-reassign
        config2 = config2 || {};
        var config = {};
        function getMergedValue(target, source) {
          if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
            return utils.merge(target, source);
          } else if (utils.isPlainObject(source)) {
            return utils.merge({}, source);
          } else if (utils.isArray(source)) {
            return source.slice();
          }
          return source;
        }

        // eslint-disable-next-line consistent-return
        function mergeDeepProperties(prop) {
          if (!utils.isUndefined(config2[prop])) {
            return getMergedValue(config1[prop], config2[prop]);
          } else if (!utils.isUndefined(config1[prop])) {
            return getMergedValue(undefined, config1[prop]);
          }
        }

        // eslint-disable-next-line consistent-return
        function valueFromConfig2(prop) {
          if (!utils.isUndefined(config2[prop])) {
            return getMergedValue(undefined, config2[prop]);
          }
        }

        // eslint-disable-next-line consistent-return
        function defaultToConfig2(prop) {
          if (!utils.isUndefined(config2[prop])) {
            return getMergedValue(undefined, config2[prop]);
          } else if (!utils.isUndefined(config1[prop])) {
            return getMergedValue(undefined, config1[prop]);
          }
        }

        // eslint-disable-next-line consistent-return
        function mergeDirectKeys(prop) {
          if (prop in config2) {
            return getMergedValue(config1[prop], config2[prop]);
          } else if (prop in config1) {
            return getMergedValue(undefined, config1[prop]);
          }
        }
        var mergeMap = {
          url: valueFromConfig2,
          method: valueFromConfig2,
          data: valueFromConfig2,
          baseURL: defaultToConfig2,
          transformRequest: defaultToConfig2,
          transformResponse: defaultToConfig2,
          paramsSerializer: defaultToConfig2,
          timeout: defaultToConfig2,
          timeoutMessage: defaultToConfig2,
          withCredentials: defaultToConfig2,
          adapter: defaultToConfig2,
          responseType: defaultToConfig2,
          xsrfCookieName: defaultToConfig2,
          xsrfHeaderName: defaultToConfig2,
          onUploadProgress: defaultToConfig2,
          onDownloadProgress: defaultToConfig2,
          decompress: defaultToConfig2,
          maxContentLength: defaultToConfig2,
          maxBodyLength: defaultToConfig2,
          transport: defaultToConfig2,
          httpAgent: defaultToConfig2,
          httpsAgent: defaultToConfig2,
          cancelToken: defaultToConfig2,
          socketPath: defaultToConfig2,
          responseEncoding: defaultToConfig2,
          validateStatus: mergeDirectKeys,
        };
        utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
          var merge = mergeMap[prop] || mergeDeepProperties;
          var configValue = merge(prop);
          (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
        });
        return config;
      };

      /***/
    },

    /***/ 7184: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var createError = __webpack_require__(35449);

      /**
       * Resolve or reject a Promise based on response status.
       *
       * @param {Function} resolve A function that resolves the promise.
       * @param {Function} reject A function that rejects the promise.
       * @param {object} response The response.
       */
      module.exports = function settle(resolve, reject, response) {
        var validateStatus = response.config.validateStatus;
        if (!response.status || !validateStatus || validateStatus(response.status)) {
          resolve(response);
        } else {
          reject(
            createError(
              'Request failed with status code ' + response.status,
              response.config,
              null,
              response.request,
              response,
            ),
          );
        }
      };

      /***/
    },

    /***/ 35871: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      var defaults = __webpack_require__(47345);

      /**
       * Transform the data for a request or a response
       *
       * @param {Object|String} data The data to be transformed
       * @param {Array} headers The headers for the request or response
       * @param {Array|Function} fns A single function or Array of functions
       * @returns {*} The resulting transformed data
       */
      module.exports = function transformData(data, headers, fns) {
        var context = this || defaults;
        /*eslint no-param-reassign:0*/
        utils.forEach(fns, function transform(fn) {
          data = fn.call(context, data, headers);
        });
        return data;
      };

      /***/
    },

    /***/ 47345: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      var normalizeHeaderName = __webpack_require__(41752);
      var enhanceError = __webpack_require__(9703);
      var DEFAULT_CONTENT_TYPE = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };
      function setContentTypeIfUnset(headers, value) {
        if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
          headers['Content-Type'] = value;
        }
      }
      function getDefaultAdapter() {
        var adapter;
        if (typeof XMLHttpRequest !== 'undefined') {
          // For browsers use XHR adapter
          adapter = __webpack_require__(85846);
        } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
          // For node use HTTP adapter
          adapter = __webpack_require__(85846);
        }
        return adapter;
      }
      function stringifySafely(rawValue, parser, encoder) {
        if (utils.isString(rawValue)) {
          try {
            (parser || JSON.parse)(rawValue);
            return utils.trim(rawValue);
          } catch (e) {
            if (e.name !== 'SyntaxError') {
              throw e;
            }
          }
        }
        return (encoder || JSON.stringify)(rawValue);
      }
      var defaults = {
        transitional: {
          silentJSONParsing: true,
          forcedJSONParsing: true,
          clarifyTimeoutError: false,
        },
        adapter: getDefaultAdapter(),
        transformRequest: [
          function transformRequest(data, headers) {
            normalizeHeaderName(headers, 'Accept');
            normalizeHeaderName(headers, 'Content-Type');
            if (
              utils.isFormData(data) ||
              utils.isArrayBuffer(data) ||
              utils.isBuffer(data) ||
              utils.isStream(data) ||
              utils.isFile(data) ||
              utils.isBlob(data)
            ) {
              return data;
            }
            if (utils.isArrayBufferView(data)) {
              return data.buffer;
            }
            if (utils.isURLSearchParams(data)) {
              setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
              return data.toString();
            }
            if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
              setContentTypeIfUnset(headers, 'application/json');
              return stringifySafely(data);
            }
            return data;
          },
        ],
        transformResponse: [
          function transformResponse(data) {
            var transitional = this.transitional || defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
              try {
                return JSON.parse(data);
              } catch (e) {
                if (strictJSONParsing) {
                  if (e.name === 'SyntaxError') {
                    throw enhanceError(e, this, 'E_JSON_PARSE');
                  }
                  throw e;
                }
              }
            }
            return data;
          },
        ],
        /**
         * A timeout in milliseconds to abort a request. If set to 0 (default) a
         * timeout is not created.
         */
        timeout: 0,
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
        maxContentLength: -1,
        maxBodyLength: -1,
        validateStatus: function validateStatus(status) {
          return status >= 200 && status < 300;
        },
        headers: {
          common: {
            Accept: 'application/json, text/plain, */*',
          },
        },
      };
      utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
        defaults.headers[method] = {};
      });
      utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
      });
      module.exports = defaults;

      /***/
    },

    /***/ 78219: /***/ module => {
      module.exports = {
        version: '0.25.0',
      };

      /***/
    },

    /***/ 6654: /***/ module => {
      'use strict';

      module.exports = function bind(fn, thisArg) {
        return function wrap() {
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }
          return fn.apply(thisArg, args);
        };
      };

      /***/
    },

    /***/ 81036: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      function encode(val) {
        return encodeURIComponent(val)
          .replace(/%3A/gi, ':')
          .replace(/%24/g, '$')
          .replace(/%2C/gi, ',')
          .replace(/%20/g, '+')
          .replace(/%5B/gi, '[')
          .replace(/%5D/gi, ']');
      }

      /**
       * Build a URL by appending params to the end
       *
       * @param {string} url The base of the url (e.g., http://www.google.com)
       * @param {object} [params] The params to be appended
       * @returns {string} The formatted url
       */
      module.exports = function buildURL(url, params, paramsSerializer) {
        /*eslint no-param-reassign:0*/
        if (!params) {
          return url;
        }
        var serializedParams;
        if (paramsSerializer) {
          serializedParams = paramsSerializer(params);
        } else if (utils.isURLSearchParams(params)) {
          serializedParams = params.toString();
        } else {
          var parts = [];
          utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') {
              return;
            }
            if (utils.isArray(val)) {
              key = key + '[]';
            } else {
              val = [val];
            }
            utils.forEach(val, function parseValue(v) {
              if (utils.isDate(v)) {
                v = v.toISOString();
              } else if (utils.isObject(v)) {
                v = JSON.stringify(v);
              }
              parts.push(encode(key) + '=' + encode(v));
            });
          });
          serializedParams = parts.join('&');
        }
        if (serializedParams) {
          var hashmarkIndex = url.indexOf('#');
          if (hashmarkIndex !== -1) {
            url = url.slice(0, hashmarkIndex);
          }
          url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }
        return url;
      };

      /***/
    },

    /***/ 51190: /***/ module => {
      'use strict';

      /**
       * Creates a new URL by combining the specified URLs
       *
       * @param {string} baseURL The base URL
       * @param {string} relativeURL The relative URL
       * @returns {string} The combined URL
       */
      module.exports = function combineURLs(baseURL, relativeURL) {
        return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
      };

      /***/
    },

    /***/ 50310: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      module.exports = utils.isStandardBrowserEnv()
        ? // Standard browser envs support document.cookie
          (function standardBrowserEnv() {
            return {
              write: function write(name, value, expires, path, domain, secure) {
                var cookie = [];
                cookie.push(name + '=' + encodeURIComponent(value));
                if (utils.isNumber(expires)) {
                  cookie.push('expires=' + new Date(expires).toGMTString());
                }
                if (utils.isString(path)) {
                  cookie.push('path=' + path);
                }
                if (utils.isString(domain)) {
                  cookie.push('domain=' + domain);
                }
                if (secure === true) {
                  cookie.push('secure');
                }
                document.cookie = cookie.join('; ');
              },
              read: function read(name) {
                var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
                return match ? decodeURIComponent(match[3]) : null;
              },
              remove: function remove(name) {
                this.write(name, '', Date.now() - 86400000);
              },
            };
          })()
        : // Non standard browser env (web workers, react-native) lack needed support.
          (function nonStandardBrowserEnv() {
            return {
              write: function write() {},
              read: function read() {
                return null;
              },
              remove: function remove() {},
            };
          })();

      /***/
    },

    /***/ 97571: /***/ module => {
      'use strict';

      /**
       * Determines whether the specified URL is absolute
       *
       * @param {string} url The URL to test
       * @returns {boolean} True if the specified URL is absolute, otherwise false
       */
      module.exports = function isAbsoluteURL(url) {
        // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
        // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
        // by any combination of letters, digits, plus, period, or hyphen.
        return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
      };

      /***/
    },

    /***/ 75657: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);

      /**
       * Determines whether the payload is an error thrown by Axios
       *
       * @param {*} payload The value to test
       * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
       */
      module.exports = function isAxiosError(payload) {
        return utils.isObject(payload) && payload.isAxiosError === true;
      };

      /***/
    },

    /***/ 27004: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      module.exports = utils.isStandardBrowserEnv()
        ? // Standard browser envs have full support of the APIs needed to test
          // whether the request URL is of the same origin as current location.
          (function standardBrowserEnv() {
            var msie = /(msie|trident)/i.test(navigator.userAgent);
            var urlParsingNode = document.createElement('a');
            var originURL;

            /**
             * Parse a URL to discover it's components
             *
             * @param {String} url The URL to be parsed
             * @returns {Object}
             */
            function resolveURL(url) {
              var href = url;
              if (msie) {
                // IE needs attribute set twice to normalize properties
                urlParsingNode.setAttribute('href', href);
                href = urlParsingNode.href;
              }
              urlParsingNode.setAttribute('href', href);

              // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
              return {
                href: urlParsingNode.href,
                protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
                host: urlParsingNode.host,
                search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
                hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
                hostname: urlParsingNode.hostname,
                port: urlParsingNode.port,
                pathname:
                  urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname,
              };
            }
            originURL = resolveURL(window.location.href);

            /**
             * Determine if a URL shares the same origin as the current location
             *
             * @param {String} requestURL The URL to test
             * @returns {boolean} True if URL shares the same origin, otherwise false
             */
            return function isURLSameOrigin(requestURL) {
              var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
              return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
            };
          })()
        : // Non standard browser envs (web workers, react-native) lack needed support.
          (function nonStandardBrowserEnv() {
            return function isURLSameOrigin() {
              return true;
            };
          })();

      /***/
    },

    /***/ 41752: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);
      module.exports = function normalizeHeaderName(headers, normalizedName) {
        utils.forEach(headers, function processHeader(value, name) {
          if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
          }
        });
      };

      /***/
    },

    /***/ 30902: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var utils = __webpack_require__(40898);

      // Headers whose duplicates are ignored by node
      // c.f. https://nodejs.org/api/http.html#http_message_headers
      var ignoreDuplicateOf = [
        'age',
        'authorization',
        'content-length',
        'content-type',
        'etag',
        'expires',
        'from',
        'host',
        'if-modified-since',
        'if-unmodified-since',
        'last-modified',
        'location',
        'max-forwards',
        'proxy-authorization',
        'referer',
        'retry-after',
        'user-agent',
      ];

      /**
       * Parse headers into an object
       *
       * ```
       * Date: Wed, 27 Aug 2014 08:58:49 GMT
       * Content-Type: application/json
       * Connection: keep-alive
       * Transfer-Encoding: chunked
       * ```
       *
       * @param {String} headers Headers needing to be parsed
       * @returns {Object} Headers parsed into an object
       */
      module.exports = function parseHeaders(headers) {
        var parsed = {};
        var key;
        var val;
        var i;
        if (!headers) {
          return parsed;
        }
        utils.forEach(headers.split('\n'), function parser(line) {
          i = line.indexOf(':');
          key = utils.trim(line.substr(0, i)).toLowerCase();
          val = utils.trim(line.substr(i + 1));
          if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
              return;
            }
            if (key === 'set-cookie') {
              parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
            } else {
              parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
          }
        });
        return parsed;
      };

      /***/
    },

    /***/ 27238: /***/ module => {
      'use strict';

      /**
       * Syntactic sugar for invoking a function and expanding an array for arguments.
       *
       * Common use case would be to use `Function.prototype.apply`.
       *
       *  ```js
       *  function f(x, y, z) {}
       *  var args = [1, 2, 3];
       *  f.apply(null, args);
       *  ```
       *
       * With `spread` this example can be re-written.
       *
       *  ```js
       *  spread(function(x, y, z) {})([1, 2, 3]);
       *  ```
       *
       * @param {Function} callback
       * @returns {Function}
       */
      module.exports = function spread(callback) {
        return function wrap(arr) {
          return callback.apply(null, arr);
        };
      };

      /***/
    },

    /***/ 89419: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var VERSION = __webpack_require__(78219).version;
      var validators = {};

      // eslint-disable-next-line func-names
      ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
        validators[type] = function validator(thing) {
          return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
        };
      });
      var deprecatedWarnings = {};

      /**
       * Transitional option validator
       * @param {function|boolean?} validator - set to false if the transitional option has been removed
       * @param {string?} version - deprecated version / removed since version
       * @param {string?} message - some message with additional info
       * @returns {function}
       */
      validators.transitional = function transitional(validator, version, message) {
        function formatMessage(opt, desc) {
          return '[Axios v' + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
        }

        // eslint-disable-next-line func-names
        return function (value, opt, opts) {
          if (validator === false) {
            throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
          }
          if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(
              formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'),
            );
          }
          return validator ? validator(value, opt, opts) : true;
        };
      };

      /**
       * Assert object's properties type
       * @param {object} options
       * @param {object} schema
       * @param {boolean?} allowUnknown
       */

      function assertOptions(options, schema, allowUnknown) {
        if (typeof options !== 'object') {
          throw new TypeError('options must be an object');
        }
        var keys = Object.keys(options);
        var i = keys.length;
        while (i-- > 0) {
          var opt = keys[i];
          var validator = schema[opt];
          if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) {
              throw new TypeError('option ' + opt + ' must be ' + result);
            }
            continue;
          }
          if (allowUnknown !== true) {
            throw Error('Unknown option ' + opt);
          }
        }
      }
      module.exports = {
        assertOptions: assertOptions,
        validators: validators,
      };

      /***/
    },

    /***/ 40898: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var bind = __webpack_require__(6654);

      // utils is a library of generic helper functions non-specific to axios

      var toString = Object.prototype.toString;

      /**
       * Determine if a value is an Array
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Array, otherwise false
       */
      function isArray(val) {
        return Array.isArray(val);
      }

      /**
       * Determine if a value is undefined
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if the value is undefined, otherwise false
       */
      function isUndefined(val) {
        return typeof val === 'undefined';
      }

      /**
       * Determine if a value is a Buffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Buffer, otherwise false
       */
      function isBuffer(val) {
        return (
          val !== null &&
          !isUndefined(val) &&
          val.constructor !== null &&
          !isUndefined(val.constructor) &&
          typeof val.constructor.isBuffer === 'function' &&
          val.constructor.isBuffer(val)
        );
      }

      /**
       * Determine if a value is an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an ArrayBuffer, otherwise false
       */
      function isArrayBuffer(val) {
        return toString.call(val) === '[object ArrayBuffer]';
      }

      /**
       * Determine if a value is a FormData
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an FormData, otherwise false
       */
      function isFormData(val) {
        return toString.call(val) === '[object FormData]';
      }

      /**
       * Determine if a value is a view on an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
       */
      function isArrayBufferView(val) {
        var result;
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
          result = ArrayBuffer.isView(val);
        } else {
          result = val && val.buffer && isArrayBuffer(val.buffer);
        }
        return result;
      }

      /**
       * Determine if a value is a String
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a String, otherwise false
       */
      function isString(val) {
        return typeof val === 'string';
      }

      /**
       * Determine if a value is a Number
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Number, otherwise false
       */
      function isNumber(val) {
        return typeof val === 'number';
      }

      /**
       * Determine if a value is an Object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Object, otherwise false
       */
      function isObject(val) {
        return val !== null && typeof val === 'object';
      }

      /**
       * Determine if a value is a plain Object
       *
       * @param {Object} val The value to test
       * @return {boolean} True if value is a plain Object, otherwise false
       */
      function isPlainObject(val) {
        if (toString.call(val) !== '[object Object]') {
          return false;
        }
        var prototype = Object.getPrototypeOf(val);
        return prototype === null || prototype === Object.prototype;
      }

      /**
       * Determine if a value is a Date
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Date, otherwise false
       */
      function isDate(val) {
        return toString.call(val) === '[object Date]';
      }

      /**
       * Determine if a value is a File
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a File, otherwise false
       */
      function isFile(val) {
        return toString.call(val) === '[object File]';
      }

      /**
       * Determine if a value is a Blob
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Blob, otherwise false
       */
      function isBlob(val) {
        return toString.call(val) === '[object Blob]';
      }

      /**
       * Determine if a value is a Function
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Function, otherwise false
       */
      function isFunction(val) {
        return toString.call(val) === '[object Function]';
      }

      /**
       * Determine if a value is a Stream
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Stream, otherwise false
       */
      function isStream(val) {
        return isObject(val) && isFunction(val.pipe);
      }

      /**
       * Determine if a value is a URLSearchParams object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a URLSearchParams object, otherwise false
       */
      function isURLSearchParams(val) {
        return toString.call(val) === '[object URLSearchParams]';
      }

      /**
       * Trim excess whitespace off the beginning and end of a string
       *
       * @param {String} str The String to trim
       * @returns {String} The String freed of excess whitespace
       */
      function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
      }

      /**
       * Determine if we're running in a standard browser environment
       *
       * This allows axios to run in a web worker, and react-native.
       * Both environments support XMLHttpRequest, but not fully standard globals.
       *
       * web workers:
       *  typeof window -> undefined
       *  typeof document -> undefined
       *
       * react-native:
       *  navigator.product -> 'ReactNative'
       * nativescript
       *  navigator.product -> 'NativeScript' or 'NS'
       */
      function isStandardBrowserEnv() {
        if (
          typeof navigator !== 'undefined' &&
          (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')
        ) {
          return false;
        }
        return typeof window !== 'undefined' && typeof document !== 'undefined';
      }

      /**
       * Iterate over an Array or an Object invoking a function for each item.
       *
       * If `obj` is an Array callback will be called passing
       * the value, index, and complete array for each item.
       *
       * If 'obj' is an Object callback will be called passing
       * the value, key, and complete object for each property.
       *
       * @param {Object|Array} obj The object to iterate
       * @param {Function} fn The callback to invoke for each item
       */
      function forEach(obj, fn) {
        // Don't bother if no value provided
        if (obj === null || typeof obj === 'undefined') {
          return;
        }

        // Force an array if not already something iterable
        if (typeof obj !== 'object') {
          /*eslint no-param-reassign:0*/
          obj = [obj];
        }
        if (isArray(obj)) {
          // Iterate over array values
          for (var i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
          }
        } else {
          // Iterate over object keys
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              fn.call(null, obj[key], key, obj);
            }
          }
        }
      }

      /**
       * Accepts varargs expecting each argument to be an object, then
       * immutably merges the properties of each object and returns result.
       *
       * When multiple objects contain the same key the later object in
       * the arguments list will take precedence.
       *
       * Example:
       *
       * ```js
       * var result = merge({foo: 123}, {foo: 456});
       * console.log(result.foo); // outputs 456
       * ```
       *
       * @param {Object} obj1 Object to merge
       * @returns {Object} Result of all merge properties
       */
      function merge /* obj1, obj2, obj3, ... */() {
        var result = {};
        function assignValue(val, key) {
          if (isPlainObject(result[key]) && isPlainObject(val)) {
            result[key] = merge(result[key], val);
          } else if (isPlainObject(val)) {
            result[key] = merge({}, val);
          } else if (isArray(val)) {
            result[key] = val.slice();
          } else {
            result[key] = val;
          }
        }
        for (var i = 0, l = arguments.length; i < l; i++) {
          forEach(arguments[i], assignValue);
        }
        return result;
      }

      /**
       * Extends object a by mutably adding to it the properties of object b.
       *
       * @param {Object} a The object to be extended
       * @param {Object} b The object to copy properties from
       * @param {Object} thisArg The object to bind function to
       * @return {Object} The resulting value of object a
       */
      function extend(a, b, thisArg) {
        forEach(b, function assignValue(val, key) {
          if (thisArg && typeof val === 'function') {
            a[key] = bind(val, thisArg);
          } else {
            a[key] = val;
          }
        });
        return a;
      }

      /**
       * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
       *
       * @param {string} content with BOM
       * @return {string} content value without BOM
       */
      function stripBOM(content) {
        if (content.charCodeAt(0) === 0xfeff) {
          content = content.slice(1);
        }
        return content;
      }
      module.exports = {
        isArray: isArray,
        isArrayBuffer: isArrayBuffer,
        isBuffer: isBuffer,
        isFormData: isFormData,
        isArrayBufferView: isArrayBufferView,
        isString: isString,
        isNumber: isNumber,
        isObject: isObject,
        isPlainObject: isPlainObject,
        isUndefined: isUndefined,
        isDate: isDate,
        isFile: isFile,
        isBlob: isBlob,
        isFunction: isFunction,
        isStream: isStream,
        isURLSearchParams: isURLSearchParams,
        isStandardBrowserEnv: isStandardBrowserEnv,
        forEach: forEach,
        merge: merge,
        extend: extend,
        trim: trim,
        stripBOM: stripBOM,
      };

      /***/
    },

    /***/ 6224: /***/ module => {
      'use strict';

      var token = '%[a-f0-9]{2}';
      var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
      var multiMatcher = new RegExp('(' + token + ')+', 'gi');
      function decodeComponents(components, split) {
        try {
          // Try to decode the entire string first
          return [decodeURIComponent(components.join(''))];
        } catch (err) {
          // Do nothing
        }
        if (components.length === 1) {
          return components;
        }
        split = split || 1;

        // Split the array in 2 parts
        var left = components.slice(0, split);
        var right = components.slice(split);
        return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
      }
      function decode(input) {
        try {
          return decodeURIComponent(input);
        } catch (err) {
          var tokens = input.match(singleMatcher) || [];
          for (var i = 1; i < tokens.length; i++) {
            input = decodeComponents(tokens, i).join('');
            tokens = input.match(singleMatcher) || [];
          }
          return input;
        }
      }
      function customDecodeURIComponent(input) {
        // Keep track of all the replacements and prefill the map with the `BOM`
        var replaceMap = {
          '%FE%FF': '\uFFFD\uFFFD',
          '%FF%FE': '\uFFFD\uFFFD',
        };
        var match = multiMatcher.exec(input);
        while (match) {
          try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
          } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) {
              replaceMap[match[0]] = result;
            }
          }
          match = multiMatcher.exec(input);
        }

        // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
        replaceMap['%C2'] = '\uFFFD';
        var entries = Object.keys(replaceMap);
        for (var i = 0; i < entries.length; i++) {
          // Replace all decoded components
          var key = entries[i];
          input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
        }
        return input;
      }
      module.exports = function (encodedURI) {
        if (typeof encodedURI !== 'string') {
          throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
        }
        try {
          encodedURI = encodedURI.replace(/\+/g, ' ');

          // Try the built in decoder first
          return decodeURIComponent(encodedURI);
        } catch (err) {
          // Fallback to a more advanced decoder
          return customDecodeURIComponent(encodedURI);
        }
      };

      /***/
    },

    /***/ 57825: /***/ module => {
      'use strict';
      // Copyright Joyent, Inc. and other Node contributors.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a
      // copy of this software and associated documentation files (the
      // "Software"), to deal in the Software without restriction, including
      // without limitation the rights to use, copy, modify, merge, publish,
      // distribute, sublicense, and/or sell copies of the Software, and to permit
      // persons to whom the Software is furnished to do so, subject to the
      // following conditions:
      //
      // The above copyright notice and this permission notice shall be included
      // in all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
      // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
      // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
      // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
      // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
      // USE OR OTHER DEALINGS IN THE SOFTWARE.

      var R = typeof Reflect === 'object' ? Reflect : null;
      var ReflectApply =
        R && typeof R.apply === 'function'
          ? R.apply
          : function ReflectApply(target, receiver, args) {
              return Function.prototype.apply.call(target, receiver, args);
            };
      var ReflectOwnKeys;
      if (R && typeof R.ownKeys === 'function') {
        ReflectOwnKeys = R.ownKeys;
      } else if (Object.getOwnPropertySymbols) {
        ReflectOwnKeys = function ReflectOwnKeys(target) {
          return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
        };
      } else {
        ReflectOwnKeys = function ReflectOwnKeys(target) {
          return Object.getOwnPropertyNames(target);
        };
      }
      function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
      }
      var NumberIsNaN =
        Number.isNaN ||
        function NumberIsNaN(value) {
          return value !== value;
        };
      function EventEmitter() {
        EventEmitter.init.call(this);
      }
      module.exports = EventEmitter;
      module.exports.once = once;

      // Backwards-compat with node 0.10.x
      EventEmitter.EventEmitter = EventEmitter;
      EventEmitter.prototype._events = undefined;
      EventEmitter.prototype._eventsCount = 0;
      EventEmitter.prototype._maxListeners = undefined;

      // By default EventEmitters will print a warning if more than 10 listeners are
      // added to it. This is a useful default which helps finding memory leaks.
      var defaultMaxListeners = 10;
      function checkListener(listener) {
        if (typeof listener !== 'function') {
          throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
        }
      }
      Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function () {
          return defaultMaxListeners;
        },
        set: function (arg) {
          if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
            throw new RangeError(
              'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
                arg +
                '.',
            );
          }
          defaultMaxListeners = arg;
        },
      });
      EventEmitter.init = function () {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
      };

      // Obviously not all Emitters should be limited to 10. This function allows
      // that to be increased. Set to zero for unlimited.
      EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
          throw new RangeError(
            'The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.',
          );
        }
        this._maxListeners = n;
        return this;
      };
      function _getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
      }
      EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
      };
      EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;

        // If there is no 'error' event listener then throw.
        if (doError) {
          var er;
          if (args.length > 0) er = args[0];
          if (er instanceof Error) {
            // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
          }
          // At least give some kind of context to the user
          var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
          err.context = er;
          throw err; // Unhandled 'error' event
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') {
          ReflectApply(handler, this, args);
        } else {
          var len = handler.length;
          var listeners = arrayClone(handler, len);
          for (var i = 0; i < len; ++i) ReflectApply(listeners[i], this, args);
        }
        return true;
      };
      function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        checkListener(listener);
        events = target._events;
        if (events === undefined) {
          events = target._events = Object.create(null);
          target._eventsCount = 0;
        } else {
          // To avoid recursion in the case that type === "newListener"! Before
          // adding it to the listeners, first emit "newListener".
          if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);

            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
          }
          existing = events[type];
        }
        if (existing === undefined) {
          // Optimize the case of one listener. Don't need the extra array object.
          existing = events[type] = listener;
          ++target._eventsCount;
        } else {
          if (typeof existing === 'function') {
            // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [listener, existing] : [existing, listener];
            // If we've already got an array, just append.
          } else if (prepend) {
            existing.unshift(listener);
          } else {
            existing.push(listener);
          }

          // Check for listener leak
          m = _getMaxListeners(target);
          if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error(
              'Possible EventEmitter memory leak detected. ' +
                existing.length +
                ' ' +
                String(type) +
                ' listeners ' +
                'added. Use emitter.setMaxListeners() to ' +
                'increase limit',
            );
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
          }
        }
        return target;
      }
      EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
      };
      EventEmitter.prototype.on = EventEmitter.prototype.addListener;
      EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
      };
      function onceWrapper() {
        if (!this.fired) {
          this.target.removeListener(this.type, this.wrapFn);
          this.fired = true;
          if (arguments.length === 0) return this.listener.call(this.target);
          return this.listener.apply(this.target, arguments);
        }
      }
      function _onceWrap(target, type, listener) {
        var state = {
          fired: false,
          wrapFn: undefined,
          target: target,
          type: type,
          listener: listener,
        };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
      }
      EventEmitter.prototype.once = function once(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
      };
      EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
      };

      // Emits a 'removeListener' event if and only if the listener was removed.
      EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
          if (--this._eventsCount === 0) this._events = Object.create(null);
          else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
          }
        } else if (typeof list !== 'function') {
          position = -1;
          for (i = list.length - 1; i >= 0; i--) {
            if (list[i] === listener || list[i].listener === listener) {
              originalListener = list[i].listener;
              position = i;
              break;
            }
          }
          if (position < 0) return this;
          if (position === 0) list.shift();
          else {
            spliceOne(list, position);
          }
          if (list.length === 1) events[type] = list[0];
          if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
      };
      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
      EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;

        // not listening for removeListener, no need to emit
        if (events.removeListener === undefined) {
          if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
          } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
          }
          return this;
        }

        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
          var keys = Object.keys(events);
          var key;
          for (i = 0; i < keys.length; ++i) {
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
          }
          this.removeAllListeners('removeListener');
          this._events = Object.create(null);
          this._eventsCount = 0;
          return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') {
          this.removeListener(type, listeners);
        } else if (listeners !== undefined) {
          // LIFO order
          for (i = listeners.length - 1; i >= 0; i--) {
            this.removeListener(type, listeners[i]);
          }
        }
        return this;
      };
      function _listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
      }
      EventEmitter.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
      };
      EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
      };
      EventEmitter.listenerCount = function (emitter, type) {
        if (typeof emitter.listenerCount === 'function') {
          return emitter.listenerCount(type);
        } else {
          return listenerCount.call(emitter, type);
        }
      };
      EventEmitter.prototype.listenerCount = listenerCount;
      function listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
          var evlistener = events[type];
          if (typeof evlistener === 'function') {
            return 1;
          } else if (evlistener !== undefined) {
            return evlistener.length;
          }
        }
        return 0;
      }
      EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
      };
      function arrayClone(arr, n) {
        var copy = new Array(n);
        for (var i = 0; i < n; ++i) copy[i] = arr[i];
        return copy;
      }
      function spliceOne(list, index) {
        for (; index + 1 < list.length; index++) list[index] = list[index + 1];
        list.pop();
      }
      function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for (var i = 0; i < ret.length; ++i) {
          ret[i] = arr[i].listener || arr[i];
        }
        return ret;
      }
      function once(emitter, name) {
        return new Promise(function (resolve, reject) {
          function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
          }
          function resolver() {
            if (typeof emitter.removeListener === 'function') {
              emitter.removeListener('error', errorListener);
            }
            resolve([].slice.call(arguments));
          }
          eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true,
          });
          if (name !== 'error') {
            addErrorHandlerIfEventEmitter(emitter, errorListener, {
              once: true,
            });
          }
        });
      }
      function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') {
          eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
        }
      }
      function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
          if (flags.once) {
            emitter.once(name, listener);
          } else {
            emitter.on(name, listener);
          }
        } else if (typeof emitter.addEventListener === 'function') {
          // EventTarget does not have `error` event semantics like Node
          // EventEmitters, we do not listen for `error` events here.
          emitter.addEventListener(name, function wrapListener(arg) {
            // IE does not have builtin `{ once: true }` support so we
            // have to do it manually.
            if (flags.once) {
              emitter.removeEventListener(name, wrapListener);
            }
            listener(arg);
          });
        } else {
          throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
        }
      }

      /***/
    },

    /***/ 47241: /***/ (module, exports, __webpack_require__) => {
      var __WEBPACK_AMD_DEFINE_RESULT__; /*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
      /* global define */

      (function () {
        'use strict';

        var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
        var ExecutionEnvironment = {
          canUseDOM: canUseDOM,
          canUseWorkers: typeof Worker !== 'undefined',
          canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
          canUseViewport: canUseDOM && !!window.screen,
        };
        if (true) {
          !((__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return ExecutionEnvironment;
          }.call(exports, __webpack_require__, exports, module)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })();

      /***/
    },

    /***/ 57160: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      var reactIs = __webpack_require__(52305);

      /**
       * Copyright 2015, Yahoo! Inc.
       * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
       */
      var REACT_STATICS = {
        childContextTypes: true,
        contextType: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromError: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true,
      };
      var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true,
      };
      var FORWARD_REF_STATICS = {
        $$typeof: true,
        render: true,
        defaultProps: true,
        displayName: true,
        propTypes: true,
      };
      var MEMO_STATICS = {
        $$typeof: true,
        compare: true,
        defaultProps: true,
        displayName: true,
        propTypes: true,
        type: true,
      };
      var TYPE_STATICS = {};
      TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
      TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
      function getStatics(component) {
        // React v16.11 and below
        if (reactIs.isMemo(component)) {
          return MEMO_STATICS;
        } // React v16.12 and above

        return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
      }
      var defineProperty = Object.defineProperty;
      var getOwnPropertyNames = Object.getOwnPropertyNames;
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var getPrototypeOf = Object.getPrototypeOf;
      var objectPrototype = Object.prototype;
      function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
          // don't hoist over string (html) components
          if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
              hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
          }
          var keys = getOwnPropertyNames(sourceComponent);
          if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
          }
          var targetStatics = getStatics(targetComponent);
          var sourceStatics = getStatics(sourceComponent);
          for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (
              !KNOWN_STATICS[key] &&
              !(blacklist && blacklist[key]) &&
              !(sourceStatics && sourceStatics[key]) &&
              !(targetStatics && targetStatics[key])
            ) {
              var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
              try {
                // Avoid failures from read-only properties
                defineProperty(targetComponent, key, descriptor);
              } catch (e) {}
            }
          }
        }
        return targetComponent;
      }
      module.exports = hoistNonReactStatics;

      /***/
    },

    /***/ 5026: /***/ (module, exports, __webpack_require__) => {
      var __WEBPACK_AMD_DEFINE_RESULT__; /*
       * [js-sha1]{@link https://github.com/emn178/js-sha1}
       *
       * @version 0.6.0
       * @author Chen, Yi-Cyuan [emn178@gmail.com]
       * @copyright Chen, Yi-Cyuan 2014-2017
       * @license MIT
       */
      /*jslint bitwise: true */
      (function () {
        'use strict';

        var root = typeof window === 'object' ? window : {};
        var NODE_JS =
          !root.JS_SHA1_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
        if (NODE_JS) {
          root = __webpack_require__.g;
        }
        var COMMON_JS = !root.JS_SHA1_NO_COMMON_JS && 'object' === 'object' && module.exports;
        var AMD = true && __webpack_require__.amdO;
        var HEX_CHARS = '0123456789abcdef'.split('');
        var EXTRA = [-2147483648, 8388608, 32768, 128];
        var SHIFT = [24, 16, 8, 0];
        var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];
        var blocks = [];
        var createOutputMethod = function (outputType) {
          return function (message) {
            return new Sha1(true).update(message)[outputType]();
          };
        };
        var createMethod = function () {
          var method = createOutputMethod('hex');
          if (NODE_JS) {
            method = nodeWrap(method);
          }
          method.create = function () {
            return new Sha1();
          };
          method.update = function (message) {
            return method.create().update(message);
          };
          for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type);
          }
          return method;
        };
        var nodeWrap = function (method) {
          var crypto = eval("require('crypto')");
          var Buffer = eval("require('buffer').Buffer");
          var nodeMethod = function (message) {
            if (typeof message === 'string') {
              return crypto.createHash('sha1').update(message, 'utf8').digest('hex');
            } else if (message.constructor === ArrayBuffer) {
              message = new Uint8Array(message);
            } else if (message.length === undefined) {
              return method(message);
            }
            return crypto.createHash('sha1').update(new Buffer(message)).digest('hex');
          };
          return nodeMethod;
        };
        function Sha1(sharedMemory) {
          if (sharedMemory) {
            blocks[0] =
              blocks[16] =
              blocks[1] =
              blocks[2] =
              blocks[3] =
              blocks[4] =
              blocks[5] =
              blocks[6] =
              blocks[7] =
              blocks[8] =
              blocks[9] =
              blocks[10] =
              blocks[11] =
              blocks[12] =
              blocks[13] =
              blocks[14] =
              blocks[15] =
                0;
            this.blocks = blocks;
          } else {
            this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          }
          this.h0 = 0x67452301;
          this.h1 = 0xefcdab89;
          this.h2 = 0x98badcfe;
          this.h3 = 0x10325476;
          this.h4 = 0xc3d2e1f0;
          this.block = this.start = this.bytes = this.hBytes = 0;
          this.finalized = this.hashed = false;
          this.first = true;
        }
        Sha1.prototype.update = function (message) {
          if (this.finalized) {
            return;
          }
          var notString = typeof message !== 'string';
          if (notString && message.constructor === root.ArrayBuffer) {
            message = new Uint8Array(message);
          }
          var code,
            index = 0,
            i,
            length = message.length || 0,
            blocks = this.blocks;
          while (index < length) {
            if (this.hashed) {
              this.hashed = false;
              blocks[0] = this.block;
              blocks[16] =
                blocks[1] =
                blocks[2] =
                blocks[3] =
                blocks[4] =
                blocks[5] =
                blocks[6] =
                blocks[7] =
                blocks[8] =
                blocks[9] =
                blocks[10] =
                blocks[11] =
                blocks[12] =
                blocks[13] =
                blocks[14] =
                blocks[15] =
                  0;
            }
            if (notString) {
              for (i = this.start; index < length && i < 64; ++index) {
                blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
              }
            } else {
              for (i = this.start; index < length && i < 64; ++index) {
                code = message.charCodeAt(index);
                if (code < 0x80) {
                  blocks[i >> 2] |= code << SHIFT[i++ & 3];
                } else if (code < 0x800) {
                  blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                  blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
                } else {
                  code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
                  blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
                  blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
                }
              }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
              this.block = blocks[16];
              this.start = i - 64;
              this.hash();
              this.hashed = true;
            } else {
              this.start = i;
            }
          }
          if (this.bytes > 4294967295) {
            this.hBytes += (this.bytes / 4294967296) << 0;
            this.bytes = this.bytes % 4294967296;
          }
          return this;
        };
        Sha1.prototype.finalize = function () {
          if (this.finalized) {
            return;
          }
          this.finalized = true;
          var blocks = this.blocks,
            i = this.lastByteIndex;
          blocks[16] = this.block;
          blocks[i >> 2] |= EXTRA[i & 3];
          this.block = blocks[16];
          if (i >= 56) {
            if (!this.hashed) {
              this.hash();
            }
            blocks[0] = this.block;
            blocks[16] =
              blocks[1] =
              blocks[2] =
              blocks[3] =
              blocks[4] =
              blocks[5] =
              blocks[6] =
              blocks[7] =
              blocks[8] =
              blocks[9] =
              blocks[10] =
              blocks[11] =
              blocks[12] =
              blocks[13] =
              blocks[14] =
              blocks[15] =
                0;
          }
          blocks[14] = (this.hBytes << 3) | (this.bytes >>> 29);
          blocks[15] = this.bytes << 3;
          this.hash();
        };
        Sha1.prototype.hash = function () {
          var a = this.h0,
            b = this.h1,
            c = this.h2,
            d = this.h3,
            e = this.h4;
          var f,
            j,
            t,
            blocks = this.blocks;
          for (j = 16; j < 80; ++j) {
            t = blocks[j - 3] ^ blocks[j - 8] ^ blocks[j - 14] ^ blocks[j - 16];
            blocks[j] = (t << 1) | (t >>> 31);
          }
          for (j = 0; j < 20; j += 5) {
            f = (b & c) | (~b & d);
            t = (a << 5) | (a >>> 27);
            e = (t + f + e + 1518500249 + blocks[j]) << 0;
            b = (b << 30) | (b >>> 2);
            f = (a & b) | (~a & c);
            t = (e << 5) | (e >>> 27);
            d = (t + f + d + 1518500249 + blocks[j + 1]) << 0;
            a = (a << 30) | (a >>> 2);
            f = (e & a) | (~e & b);
            t = (d << 5) | (d >>> 27);
            c = (t + f + c + 1518500249 + blocks[j + 2]) << 0;
            e = (e << 30) | (e >>> 2);
            f = (d & e) | (~d & a);
            t = (c << 5) | (c >>> 27);
            b = (t + f + b + 1518500249 + blocks[j + 3]) << 0;
            d = (d << 30) | (d >>> 2);
            f = (c & d) | (~c & e);
            t = (b << 5) | (b >>> 27);
            a = (t + f + a + 1518500249 + blocks[j + 4]) << 0;
            c = (c << 30) | (c >>> 2);
          }
          for (; j < 40; j += 5) {
            f = b ^ c ^ d;
            t = (a << 5) | (a >>> 27);
            e = (t + f + e + 1859775393 + blocks[j]) << 0;
            b = (b << 30) | (b >>> 2);
            f = a ^ b ^ c;
            t = (e << 5) | (e >>> 27);
            d = (t + f + d + 1859775393 + blocks[j + 1]) << 0;
            a = (a << 30) | (a >>> 2);
            f = e ^ a ^ b;
            t = (d << 5) | (d >>> 27);
            c = (t + f + c + 1859775393 + blocks[j + 2]) << 0;
            e = (e << 30) | (e >>> 2);
            f = d ^ e ^ a;
            t = (c << 5) | (c >>> 27);
            b = (t + f + b + 1859775393 + blocks[j + 3]) << 0;
            d = (d << 30) | (d >>> 2);
            f = c ^ d ^ e;
            t = (b << 5) | (b >>> 27);
            a = (t + f + a + 1859775393 + blocks[j + 4]) << 0;
            c = (c << 30) | (c >>> 2);
          }
          for (; j < 60; j += 5) {
            f = (b & c) | (b & d) | (c & d);
            t = (a << 5) | (a >>> 27);
            e = (t + f + e - 1894007588 + blocks[j]) << 0;
            b = (b << 30) | (b >>> 2);
            f = (a & b) | (a & c) | (b & c);
            t = (e << 5) | (e >>> 27);
            d = (t + f + d - 1894007588 + blocks[j + 1]) << 0;
            a = (a << 30) | (a >>> 2);
            f = (e & a) | (e & b) | (a & b);
            t = (d << 5) | (d >>> 27);
            c = (t + f + c - 1894007588 + blocks[j + 2]) << 0;
            e = (e << 30) | (e >>> 2);
            f = (d & e) | (d & a) | (e & a);
            t = (c << 5) | (c >>> 27);
            b = (t + f + b - 1894007588 + blocks[j + 3]) << 0;
            d = (d << 30) | (d >>> 2);
            f = (c & d) | (c & e) | (d & e);
            t = (b << 5) | (b >>> 27);
            a = (t + f + a - 1894007588 + blocks[j + 4]) << 0;
            c = (c << 30) | (c >>> 2);
          }
          for (; j < 80; j += 5) {
            f = b ^ c ^ d;
            t = (a << 5) | (a >>> 27);
            e = (t + f + e - 899497514 + blocks[j]) << 0;
            b = (b << 30) | (b >>> 2);
            f = a ^ b ^ c;
            t = (e << 5) | (e >>> 27);
            d = (t + f + d - 899497514 + blocks[j + 1]) << 0;
            a = (a << 30) | (a >>> 2);
            f = e ^ a ^ b;
            t = (d << 5) | (d >>> 27);
            c = (t + f + c - 899497514 + blocks[j + 2]) << 0;
            e = (e << 30) | (e >>> 2);
            f = d ^ e ^ a;
            t = (c << 5) | (c >>> 27);
            b = (t + f + b - 899497514 + blocks[j + 3]) << 0;
            d = (d << 30) | (d >>> 2);
            f = c ^ d ^ e;
            t = (b << 5) | (b >>> 27);
            a = (t + f + a - 899497514 + blocks[j + 4]) << 0;
            c = (c << 30) | (c >>> 2);
          }
          this.h0 = (this.h0 + a) << 0;
          this.h1 = (this.h1 + b) << 0;
          this.h2 = (this.h2 + c) << 0;
          this.h3 = (this.h3 + d) << 0;
          this.h4 = (this.h4 + e) << 0;
        };
        Sha1.prototype.hex = function () {
          this.finalize();
          var h0 = this.h0,
            h1 = this.h1,
            h2 = this.h2,
            h3 = this.h3,
            h4 = this.h4;
          return (
            HEX_CHARS[(h0 >> 28) & 0x0f] +
            HEX_CHARS[(h0 >> 24) & 0x0f] +
            HEX_CHARS[(h0 >> 20) & 0x0f] +
            HEX_CHARS[(h0 >> 16) & 0x0f] +
            HEX_CHARS[(h0 >> 12) & 0x0f] +
            HEX_CHARS[(h0 >> 8) & 0x0f] +
            HEX_CHARS[(h0 >> 4) & 0x0f] +
            HEX_CHARS[h0 & 0x0f] +
            HEX_CHARS[(h1 >> 28) & 0x0f] +
            HEX_CHARS[(h1 >> 24) & 0x0f] +
            HEX_CHARS[(h1 >> 20) & 0x0f] +
            HEX_CHARS[(h1 >> 16) & 0x0f] +
            HEX_CHARS[(h1 >> 12) & 0x0f] +
            HEX_CHARS[(h1 >> 8) & 0x0f] +
            HEX_CHARS[(h1 >> 4) & 0x0f] +
            HEX_CHARS[h1 & 0x0f] +
            HEX_CHARS[(h2 >> 28) & 0x0f] +
            HEX_CHARS[(h2 >> 24) & 0x0f] +
            HEX_CHARS[(h2 >> 20) & 0x0f] +
            HEX_CHARS[(h2 >> 16) & 0x0f] +
            HEX_CHARS[(h2 >> 12) & 0x0f] +
            HEX_CHARS[(h2 >> 8) & 0x0f] +
            HEX_CHARS[(h2 >> 4) & 0x0f] +
            HEX_CHARS[h2 & 0x0f] +
            HEX_CHARS[(h3 >> 28) & 0x0f] +
            HEX_CHARS[(h3 >> 24) & 0x0f] +
            HEX_CHARS[(h3 >> 20) & 0x0f] +
            HEX_CHARS[(h3 >> 16) & 0x0f] +
            HEX_CHARS[(h3 >> 12) & 0x0f] +
            HEX_CHARS[(h3 >> 8) & 0x0f] +
            HEX_CHARS[(h3 >> 4) & 0x0f] +
            HEX_CHARS[h3 & 0x0f] +
            HEX_CHARS[(h4 >> 28) & 0x0f] +
            HEX_CHARS[(h4 >> 24) & 0x0f] +
            HEX_CHARS[(h4 >> 20) & 0x0f] +
            HEX_CHARS[(h4 >> 16) & 0x0f] +
            HEX_CHARS[(h4 >> 12) & 0x0f] +
            HEX_CHARS[(h4 >> 8) & 0x0f] +
            HEX_CHARS[(h4 >> 4) & 0x0f] +
            HEX_CHARS[h4 & 0x0f]
          );
        };
        Sha1.prototype.toString = Sha1.prototype.hex;
        Sha1.prototype.digest = function () {
          this.finalize();
          var h0 = this.h0,
            h1 = this.h1,
            h2 = this.h2,
            h3 = this.h3,
            h4 = this.h4;
          return [
            (h0 >> 24) & 0xff,
            (h0 >> 16) & 0xff,
            (h0 >> 8) & 0xff,
            h0 & 0xff,
            (h1 >> 24) & 0xff,
            (h1 >> 16) & 0xff,
            (h1 >> 8) & 0xff,
            h1 & 0xff,
            (h2 >> 24) & 0xff,
            (h2 >> 16) & 0xff,
            (h2 >> 8) & 0xff,
            h2 & 0xff,
            (h3 >> 24) & 0xff,
            (h3 >> 16) & 0xff,
            (h3 >> 8) & 0xff,
            h3 & 0xff,
            (h4 >> 24) & 0xff,
            (h4 >> 16) & 0xff,
            (h4 >> 8) & 0xff,
            h4 & 0xff,
          ];
        };
        Sha1.prototype.array = Sha1.prototype.digest;
        Sha1.prototype.arrayBuffer = function () {
          this.finalize();
          var buffer = new ArrayBuffer(20);
          var dataView = new DataView(buffer);
          dataView.setUint32(0, this.h0);
          dataView.setUint32(4, this.h1);
          dataView.setUint32(8, this.h2);
          dataView.setUint32(12, this.h3);
          dataView.setUint32(16, this.h4);
          return buffer;
        };
        var exports = createMethod();
        if (COMMON_JS) {
          module.exports = exports;
        } else {
          root.sha1 = exports;
          if (AMD) {
            !((__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return exports;
            }.call(exports, __webpack_require__, exports, module)),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          }
        }
      })();

      /***/
    },

    /***/ 84708: /***/ function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_RESULT__; /*!
       * jsUri
       * https://github.com/derek-watson/jsUri
       *
       * Copyright 2013, Derek Watson
       * Released under the MIT license.
       *
       * Includes parseUri regular expressions
       * http://blog.stevenlevithan.com/archives/parseuri
       * Copyright 2007, Steven Levithan
       * Released under the MIT license.
       */

      /*globals define, module */

      (function (global) {
        var re = {
          starts_with_slashes: /^\/+/,
          ends_with_slashes: /\/+$/,
          pluses: /\+/g,
          query_separator: /[&;]/,
          uri_parser:
            /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*)(?::([^:@]*))?)?@)?(\[[0-9a-fA-F:.]+\]|[^:\/?#]*)(?::(\d+|(?=:)))?(:)?)((((?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
        };

        /**
         * Define forEach for older js environments
         * @see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/forEach#Compatibility
         */
        if (!Array.prototype.forEach) {
          Array.prototype.forEach = function (callback, thisArg) {
            var T, k;
            if (this == null) {
              throw new TypeError(' this is null or not defined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (typeof callback !== 'function') {
              throw new TypeError(callback + ' is not a function');
            }
            if (arguments.length > 1) {
              T = thisArg;
            }
            k = 0;
            while (k < len) {
              var kValue;
              if (k in O) {
                kValue = O[k];
                callback.call(T, kValue, k, O);
              }
              k++;
            }
          };
        }

        /**
         * unescape a query param value
         * @param  {string} s encoded value
         * @return {string}   decoded value
         */
        function decode(s) {
          if (s) {
            s = s.toString().replace(re.pluses, '%20');
            s = decodeURIComponent(s);
          }
          return s;
        }

        /**
         * Breaks a uri string down into its individual parts
         * @param  {string} str uri
         * @return {object}     parts
         */
        function parseUri(str) {
          var parser = re.uri_parser;
          var parserKeys = [
            'source',
            'protocol',
            'authority',
            'userInfo',
            'user',
            'password',
            'host',
            'port',
            'isColonUri',
            'relative',
            'path',
            'directory',
            'file',
            'query',
            'anchor',
          ];
          var m = parser.exec(str || '');
          var parts = {};
          parserKeys.forEach(function (key, i) {
            parts[key] = m[i] || '';
          });
          return parts;
        }

        /**
         * Breaks a query string down into an array of key/value pairs
         * @param  {string} str query
         * @return {array}      array of arrays (key/value pairs)
         */
        function parseQuery(str) {
          var i, ps, p, n, k, v, l;
          var pairs = [];
          if (typeof str === 'undefined' || str === null || str === '') {
            return pairs;
          }
          if (str.indexOf('?') === 0) {
            str = str.substring(1);
          }
          ps = str.toString().split(re.query_separator);
          for (i = 0, l = ps.length; i < l; i++) {
            p = ps[i];
            n = p.indexOf('=');
            if (n !== 0) {
              k = decode(p.substring(0, n));
              v = decode(p.substring(n + 1));
              pairs.push(n === -1 ? [p, null] : [k, v]);
            }
          }
          return pairs;
        }

        /**
         * Creates a new Uri object
         * @constructor
         * @param {string} str
         */
        function Uri(str) {
          this.uriParts = parseUri(str);
          this.queryPairs = parseQuery(this.uriParts.query);
          this.hasAuthorityPrefixUserPref = null;
        }

        /**
         * Define getter/setter methods
         */
        ['protocol', 'userInfo', 'host', 'port', 'path', 'anchor'].forEach(function (key) {
          Uri.prototype[key] = function (val) {
            if (typeof val !== 'undefined') {
              this.uriParts[key] = val;
            }
            return this.uriParts[key];
          };
        });

        /**
         * if there is no protocol, the leading // can be enabled or disabled
         * @param  {Boolean}  val
         * @return {Boolean}
         */
        Uri.prototype.hasAuthorityPrefix = function (val) {
          if (typeof val !== 'undefined') {
            this.hasAuthorityPrefixUserPref = val;
          }
          if (this.hasAuthorityPrefixUserPref === null) {
            return this.uriParts.source.indexOf('//') !== -1;
          } else {
            return this.hasAuthorityPrefixUserPref;
          }
        };
        Uri.prototype.isColonUri = function (val) {
          if (typeof val !== 'undefined') {
            this.uriParts.isColonUri = !!val;
          } else {
            return !!this.uriParts.isColonUri;
          }
        };

        /**
         * Serializes the internal state of the query pairs
         * @param  {string} [val]   set a new query string
         * @return {string}         query string
         */
        Uri.prototype.query = function (val) {
          var s = '',
            i,
            param,
            l;
          if (typeof val !== 'undefined') {
            this.queryPairs = parseQuery(val);
          }
          for (i = 0, l = this.queryPairs.length; i < l; i++) {
            param = this.queryPairs[i];
            if (s.length > 0) {
              s += '&';
            }
            if (param[1] === null) {
              s += param[0];
            } else {
              s += param[0];
              s += '=';
              if (typeof param[1] !== 'undefined') {
                s += encodeURIComponent(param[1]);
              }
            }
          }
          return s.length > 0 ? '?' + s : s;
        };

        /**
         * returns the first query param value found for the key
         * @param  {string} key query key
         * @return {string}     first value found for key
         */
        Uri.prototype.getQueryParamValue = function (key) {
          var param, i, l;
          for (i = 0, l = this.queryPairs.length; i < l; i++) {
            param = this.queryPairs[i];
            if (key === param[0]) {
              return param[1];
            }
          }
        };

        /**
         * returns an array of query param values for the key
         * @param  {string} key query key
         * @return {array}      array of values
         */
        Uri.prototype.getQueryParamValues = function (key) {
          var arr = [],
            i,
            param,
            l;
          for (i = 0, l = this.queryPairs.length; i < l; i++) {
            param = this.queryPairs[i];
            if (key === param[0]) {
              arr.push(param[1]);
            }
          }
          return arr;
        };

        /**
         * removes query parameters
         * @param  {string} key     remove values for key
         * @param  {val}    [val]   remove a specific value, otherwise removes all
         * @return {Uri}            returns self for fluent chaining
         */
        Uri.prototype.deleteQueryParam = function (key, val) {
          var arr = [],
            i,
            param,
            keyMatchesFilter,
            valMatchesFilter,
            l;
          for (i = 0, l = this.queryPairs.length; i < l; i++) {
            param = this.queryPairs[i];
            keyMatchesFilter = decode(param[0]) === decode(key);
            valMatchesFilter = param[1] === val;
            if (
              (arguments.length === 1 && !keyMatchesFilter) ||
              (arguments.length === 2 && (!keyMatchesFilter || !valMatchesFilter))
            ) {
              arr.push(param);
            }
          }
          this.queryPairs = arr;
          return this;
        };

        /**
         * adds a query parameter
         * @param  {string}  key        add values for key
         * @param  {string}  val        value to add
         * @param  {integer} [index]    specific index to add the value at
         * @return {Uri}                returns self for fluent chaining
         */
        Uri.prototype.addQueryParam = function (key, val, index) {
          if (arguments.length === 3 && index !== -1) {
            index = Math.min(index, this.queryPairs.length);
            this.queryPairs.splice(index, 0, [key, val]);
          } else if (arguments.length > 0) {
            this.queryPairs.push([key, val]);
          }
          return this;
        };

        /**
         * test for the existence of a query parameter
         * @param  {string}  key        add values for key
         * @param  {string}  val        value to add
         * @param  {integer} [index]    specific index to add the value at
         * @return {Uri}                returns self for fluent chaining
         */
        Uri.prototype.hasQueryParam = function (key) {
          var i,
            len = this.queryPairs.length;
          for (i = 0; i < len; i++) {
            if (this.queryPairs[i][0] == key) return true;
          }
          return false;
        };

        /**
         * replaces query param values
         * @param  {string} key         key to replace value for
         * @param  {string} newVal      new value
         * @param  {string} [oldVal]    replace only one specific value (otherwise replaces all)
         * @return {Uri}                returns self for fluent chaining
         */
        Uri.prototype.replaceQueryParam = function (key, newVal, oldVal) {
          var index = -1,
            len = this.queryPairs.length,
            i,
            param;
          if (arguments.length === 3) {
            for (i = 0; i < len; i++) {
              param = this.queryPairs[i];
              if (decode(param[0]) === decode(key) && decodeURIComponent(param[1]) === decode(oldVal)) {
                index = i;
                break;
              }
            }
            if (index >= 0) {
              this.deleteQueryParam(key, decode(oldVal)).addQueryParam(key, newVal, index);
            }
          } else {
            for (i = 0; i < len; i++) {
              param = this.queryPairs[i];
              if (decode(param[0]) === decode(key)) {
                index = i;
                break;
              }
            }
            this.deleteQueryParam(key);
            this.addQueryParam(key, newVal, index);
          }
          return this;
        };

        /**
         * Define fluent setter methods (setProtocol, setHasAuthorityPrefix, etc)
         */
        ['protocol', 'hasAuthorityPrefix', 'isColonUri', 'userInfo', 'host', 'port', 'path', 'query', 'anchor'].forEach(
          function (key) {
            var method = 'set' + key.charAt(0).toUpperCase() + key.slice(1);
            Uri.prototype[method] = function (val) {
              this[key](val);
              return this;
            };
          },
        );

        /**
         * Scheme name, colon and doubleslash, as required
         * @return {string} http:// or possibly just //
         */
        Uri.prototype.scheme = function () {
          var s = '';
          if (this.protocol()) {
            s += this.protocol();
            if (this.protocol().indexOf(':') !== this.protocol().length - 1) {
              s += ':';
            }
            s += '//';
          } else {
            if (this.hasAuthorityPrefix() && this.host()) {
              s += '//';
            }
          }
          return s;
        };

        /**
         * Same as Mozilla nsIURI.prePath
         * @return {string} scheme://user:password@host:port
         * @see  https://developer.mozilla.org/en/nsIURI
         */
        Uri.prototype.origin = function () {
          var s = this.scheme();
          if (this.userInfo() && this.host()) {
            s += this.userInfo();
            if (this.userInfo().indexOf('@') !== this.userInfo().length - 1) {
              s += '@';
            }
          }
          if (this.host()) {
            s += this.host();
            if (this.port() || (this.path() && this.path().substr(0, 1).match(/[0-9]/))) {
              s += ':' + this.port();
            }
          }
          return s;
        };

        /**
         * Adds a trailing slash to the path
         */
        Uri.prototype.addTrailingSlash = function () {
          var path = this.path() || '';
          if (path.substr(-1) !== '/') {
            this.path(path + '/');
          }
          return this;
        };

        /**
         * Serializes the internal state of the Uri object
         * @return {string}
         */
        Uri.prototype.toString = function () {
          var path,
            s = this.origin();
          if (this.isColonUri()) {
            if (this.path()) {
              s += ':' + this.path();
            }
          } else if (this.path()) {
            path = this.path();
            if (!(re.ends_with_slashes.test(s) || re.starts_with_slashes.test(path))) {
              s += '/';
            } else {
              if (s) {
                s.replace(re.ends_with_slashes, '/');
              }
              path = path.replace(re.starts_with_slashes, '/');
            }
            s += path;
          } else {
            if (this.host() && (this.query().toString() || this.anchor())) {
              s += '/';
            }
          }
          if (this.query().toString()) {
            s += this.query().toString();
          }
          if (this.anchor()) {
            if (this.anchor().indexOf('#') !== 0) {
              s += '#';
            }
            s += this.anchor();
          }
          return s;
        };

        /**
         * Clone a Uri object
         * @return {Uri} duplicate copy of the Uri
         */
        Uri.prototype.clone = function () {
          return new Uri(this.toString());
        };

        /**
         * export via AMD or CommonJS, otherwise leak a global
         */
        if (true) {
          !((__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return Uri;
          }.call(exports, __webpack_require__, exports, module)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(this);

      /***/
    },

    /***/ 9438: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264),
        root = __webpack_require__(75619);

      /* Built-in method references that are verified to be native. */
      var DataView = getNative(root, 'DataView');
      module.exports = DataView;

      /***/
    },

    /***/ 22139: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var hashClear = __webpack_require__(45850),
        hashDelete = __webpack_require__(56988),
        hashGet = __webpack_require__(71631),
        hashHas = __webpack_require__(27699),
        hashSet = __webpack_require__(76491);

      /**
       * Creates a hash object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Hash(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      // Add methods to `Hash`.
      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      module.exports = Hash;

      /***/
    },

    /***/ 11649: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var listCacheClear = __webpack_require__(28924),
        listCacheDelete = __webpack_require__(48122),
        listCacheGet = __webpack_require__(31381),
        listCacheHas = __webpack_require__(14489),
        listCacheSet = __webpack_require__(48721);

      /**
       * Creates an list cache object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function ListCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      // Add methods to `ListCache`.
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      module.exports = ListCache;

      /***/
    },

    /***/ 56285: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264),
        root = __webpack_require__(75619);

      /* Built-in method references that are verified to be native. */
      var Map = getNative(root, 'Map');
      module.exports = Map;

      /***/
    },

    /***/ 22583: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var mapCacheClear = __webpack_require__(40126),
        mapCacheDelete = __webpack_require__(85464),
        mapCacheGet = __webpack_require__(45755),
        mapCacheHas = __webpack_require__(12343),
        mapCacheSet = __webpack_require__(55071);

      /**
       * Creates a map cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function MapCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      // Add methods to `MapCache`.
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      module.exports = MapCache;

      /***/
    },

    /***/ 86974: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264),
        root = __webpack_require__(75619);

      /* Built-in method references that are verified to be native. */
      var Promise = getNative(root, 'Promise');
      module.exports = Promise;

      /***/
    },

    /***/ 75867: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264),
        root = __webpack_require__(75619);

      /* Built-in method references that are verified to be native. */
      var Set = getNative(root, 'Set');
      module.exports = Set;

      /***/
    },

    /***/ 66787: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var ListCache = __webpack_require__(11649),
        stackClear = __webpack_require__(73634),
        stackDelete = __webpack_require__(91636),
        stackGet = __webpack_require__(19719),
        stackHas = __webpack_require__(98971),
        stackSet = __webpack_require__(89987);

      /**
       * Creates a stack cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Stack(entries) {
        var data = (this.__data__ = new ListCache(entries));
        this.size = data.size;
      }

      // Add methods to `Stack`.
      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      module.exports = Stack;

      /***/
    },

    /***/ 75799: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var root = __webpack_require__(75619);

      /** Built-in value references. */
      var Symbol = root.Symbol;
      module.exports = Symbol;

      /***/
    },

    /***/ 86882: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var root = __webpack_require__(75619);

      /** Built-in value references. */
      var Uint8Array = root.Uint8Array;
      module.exports = Uint8Array;

      /***/
    },

    /***/ 53173: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264),
        root = __webpack_require__(75619);

      /* Built-in method references that are verified to be native. */
      var WeakMap = getNative(root, 'WeakMap');
      module.exports = WeakMap;

      /***/
    },

    /***/ 44375: /***/ module => {
      /**
       * A faster alternative to `Function#apply`, this function invokes `func`
       * with the `this` binding of `thisArg` and the arguments of `args`.
       *
       * @private
       * @param {Function} func The function to invoke.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} args The arguments to invoke `func` with.
       * @returns {*} Returns the result of `func`.
       */
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      module.exports = apply;

      /***/
    },

    /***/ 7515: /***/ module => {
      /**
       * A specialized version of `_.forEach` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns `array`.
       */
      function arrayEach(array, iteratee) {
        var index = -1,
          length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      module.exports = arrayEach;

      /***/
    },

    /***/ 18472: /***/ module => {
      /**
       * A specialized version of `_.filter` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */
      function arrayFilter(array, predicate) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      module.exports = arrayFilter;

      /***/
    },

    /***/ 74113: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseTimes = __webpack_require__(41458),
        isArguments = __webpack_require__(24254),
        isArray = __webpack_require__(37603),
        isBuffer = __webpack_require__(23470),
        isIndex = __webpack_require__(68327),
        isTypedArray = __webpack_require__(24373);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;
        for (var key in value) {
          if (
            (inherited || hasOwnProperty.call(value, key)) &&
            !(
              skipIndexes &&
              // Safari 9 has enumerable `arguments.length` in strict mode.
              (key == 'length' ||
                // Node.js 0.10 has enumerable non-index properties on buffers.
                (isBuff && (key == 'offset' || key == 'parent')) ||
                // PhantomJS 2 has enumerable non-index properties on typed arrays.
                (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                // Skip index properties.
                isIndex(key, length))
            )
          ) {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = arrayLikeKeys;

      /***/
    },

    /***/ 22654: /***/ module => {
      /**
       * A specialized version of `_.map` for arrays without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */
      function arrayMap(array, iteratee) {
        var index = -1,
          length = array == null ? 0 : array.length,
          result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      module.exports = arrayMap;

      /***/
    },

    /***/ 81026: /***/ module => {
      /**
       * Appends the elements of `values` to `array`.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to append.
       * @returns {Array} Returns `array`.
       */
      function arrayPush(array, values) {
        var index = -1,
          length = values.length,
          offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      module.exports = arrayPush;

      /***/
    },

    /***/ 70104: /***/ module => {
      /**
       * A specialized version of `_.reduce` for arrays without support for
       * iteratee shorthands.
       *
       * @private
       * @param {Array} [array] The array to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @param {boolean} [initAccum] Specify using the first element of `array` as
       *  the initial value.
       * @returns {*} Returns the accumulated value.
       */
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1,
          length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      module.exports = arrayReduce;

      /***/
    },

    /***/ 25983: /***/ module => {
      /** Used to match words composed of alphanumeric characters. */
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

      /**
       * Splits an ASCII `string` into an array of its words.
       *
       * @private
       * @param {string} The string to inspect.
       * @returns {Array} Returns the words of `string`.
       */
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      module.exports = asciiWords;

      /***/
    },

    /***/ 43379: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseAssignValue = __webpack_require__(52162),
        eq = __webpack_require__(91114);

      /**
       * This function is like `assignValue` except that it doesn't assign
       * `undefined` values.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignMergeValue(object, key, value) {
        if ((value !== undefined && !eq(object[key], value)) || (value === undefined && !(key in object))) {
          baseAssignValue(object, key, value);
        }
      }
      module.exports = assignMergeValue;

      /***/
    },

    /***/ 40581: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseAssignValue = __webpack_require__(52162),
        eq = __webpack_require__(91114);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || (value === undefined && !(key in object))) {
          baseAssignValue(object, key, value);
        }
      }
      module.exports = assignValue;

      /***/
    },

    /***/ 98639: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var eq = __webpack_require__(91114);

      /**
       * Gets the index at which the `key` is found in `array` of key-value pairs.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} key The key to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      module.exports = assocIndexOf;

      /***/
    },

    /***/ 96239: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var copyObject = __webpack_require__(96945),
        keys = __webpack_require__(45000);

      /**
       * The base implementation of `_.assign` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      module.exports = baseAssign;

      /***/
    },

    /***/ 51412: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var copyObject = __webpack_require__(96945),
        keysIn = __webpack_require__(83735);

      /**
       * The base implementation of `_.assignIn` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      module.exports = baseAssignIn;

      /***/
    },

    /***/ 52162: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var defineProperty = __webpack_require__(72097);

      /**
       * The base implementation of `assignValue` and `assignMergeValue` without
       * value checks.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            configurable: true,
            enumerable: true,
            value: value,
            writable: true,
          });
        } else {
          object[key] = value;
        }
      }
      module.exports = baseAssignValue;

      /***/
    },

    /***/ 71649: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Stack = __webpack_require__(66787),
        arrayEach = __webpack_require__(7515),
        assignValue = __webpack_require__(40581),
        baseAssign = __webpack_require__(96239),
        baseAssignIn = __webpack_require__(51412),
        cloneBuffer = __webpack_require__(71204),
        copyArray = __webpack_require__(57861),
        copySymbols = __webpack_require__(47605),
        copySymbolsIn = __webpack_require__(97478),
        getAllKeys = __webpack_require__(23280),
        getAllKeysIn = __webpack_require__(65279),
        getTag = __webpack_require__(42711),
        initCloneArray = __webpack_require__(14503),
        initCloneByTag = __webpack_require__(9961),
        initCloneObject = __webpack_require__(42631),
        isArray = __webpack_require__(37603),
        isBuffer = __webpack_require__(23470),
        isMap = __webpack_require__(31204),
        isObject = __webpack_require__(3715),
        isSet = __webpack_require__(13558),
        keys = __webpack_require__(45000),
        keysIn = __webpack_require__(83735);

      /** Used to compose bitmasks for cloning. */
      var CLONE_DEEP_FLAG = 1,
        CLONE_FLAT_FLAG = 2,
        CLONE_SYMBOLS_FLAG = 4;

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        objectTag = '[object Object]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        symbolTag = '[object Symbol]',
        weakMapTag = '[object WeakMap]';
      var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';

      /** Used to identify `toStringTag` values supported by `_.clone`. */
      var cloneableTags = {};
      cloneableTags[argsTag] =
        cloneableTags[arrayTag] =
        cloneableTags[arrayBufferTag] =
        cloneableTags[dataViewTag] =
        cloneableTags[boolTag] =
        cloneableTags[dateTag] =
        cloneableTags[float32Tag] =
        cloneableTags[float64Tag] =
        cloneableTags[int8Tag] =
        cloneableTags[int16Tag] =
        cloneableTags[int32Tag] =
        cloneableTags[mapTag] =
        cloneableTags[numberTag] =
        cloneableTags[objectTag] =
        cloneableTags[regexpTag] =
        cloneableTags[setTag] =
        cloneableTags[stringTag] =
        cloneableTags[symbolTag] =
        cloneableTags[uint8Tag] =
        cloneableTags[uint8ClampedTag] =
        cloneableTags[uint16Tag] =
        cloneableTags[uint32Tag] =
          true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

      /**
       * The base implementation of `_.clone` and `_.cloneDeep` which tracks
       * traversed objects.
       *
       * @private
       * @param {*} value The value to clone.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Deep clone
       *  2 - Flatten inherited properties
       *  4 - Clone symbols
       * @param {Function} [customizer] The function to customize cloning.
       * @param {string} [key] The key of `value`.
       * @param {Object} [object] The parent object of `value`.
       * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
       * @returns {*} Returns the cloned value.
       */
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== undefined) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat
                ? copySymbolsIn(value, baseAssignIn(result, value))
                : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        // Check for circular references and return its corresponding clone.
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);
        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }
        var keysFunc = isFull ? (isFlat ? getAllKeysIn : getAllKeys) : isFlat ? keysIn : keys;
        var props = isArr ? undefined : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          // Recursively populate clone (susceptible to call stack limits).
          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }
      module.exports = baseClone;

      /***/
    },

    /***/ 90938: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isObject = __webpack_require__(3715);

      /** Built-in value references. */
      var objectCreate = Object.create;

      /**
       * The base implementation of `_.create` without support for assigning
       * properties to the created object.
       *
       * @private
       * @param {Object} proto The object to inherit from.
       * @returns {Object} Returns the new object.
       */
      var baseCreate = (function () {
        function object() {}
        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = undefined;
          return result;
        };
      })();
      module.exports = baseCreate;

      /***/
    },

    /***/ 17621: /***/ module => {
      /**
       * The base implementation of `_.findIndex` and `_.findLastIndex` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} predicate The function invoked per iteration.
       * @param {number} fromIndex The index to search from.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      module.exports = baseFindIndex;

      /***/
    },

    /***/ 18142: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayPush = __webpack_require__(81026),
        isFlattenable = __webpack_require__(46609);

      /**
       * The base implementation of `_.flatten` with support for restricting flattening.
       *
       * @private
       * @param {Array} array The array to flatten.
       * @param {number} depth The maximum recursion depth.
       * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
       * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
       * @param {Array} [result=[]] The initial result value.
       * @returns {Array} Returns the new flattened array.
       */
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
          length = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);
        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              // Recursively flatten arrays (susceptible to call stack limits).
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }
      module.exports = baseFlatten;

      /***/
    },

    /***/ 6043: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var createBaseFor = __webpack_require__(68119);

      /**
       * The base implementation of `baseForOwn` which iterates over `object`
       * properties returned by `keysFunc` and invokes `iteratee` for each property.
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseFor = createBaseFor();
      module.exports = baseFor;

      /***/
    },

    /***/ 99216: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var castPath = __webpack_require__(62323),
        toKey = __webpack_require__(60299);

      /**
       * The base implementation of `_.get` without support for default values.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @returns {*} Returns the resolved value.
       */
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0,
          length = path.length;
        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined;
      }
      module.exports = baseGet;

      /***/
    },

    /***/ 51141: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayPush = __webpack_require__(81026),
        isArray = __webpack_require__(37603);

      /**
       * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
       * `keysFunc` and `symbolsFunc` to get the enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @param {Function} symbolsFunc The function to get the symbols of `object`.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }
      module.exports = baseGetAllKeys;

      /***/
    },

    /***/ 33754: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Symbol = __webpack_require__(75799),
        getRawTag = __webpack_require__(36969),
        objectToString = __webpack_require__(11916);

      /** `Object#toString` result references. */
      var nullTag = '[object Null]',
        undefinedTag = '[object Undefined]';

      /** Built-in value references. */
      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }
      module.exports = baseGetTag;

      /***/
    },

    /***/ 38868: /***/ module => {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * The base implementation of `_.has` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      module.exports = baseHas;

      /***/
    },

    /***/ 73989: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseFindIndex = __webpack_require__(17621),
        baseIsNaN = __webpack_require__(5641),
        strictIndexOf = __webpack_require__(5749);

      /**
       * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      module.exports = baseIndexOf;

      /***/
    },

    /***/ 59720: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]';

      /**
       * The base implementation of `_.isArguments`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       */
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      module.exports = baseIsArguments;

      /***/
    },

    /***/ 70422: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getTag = __webpack_require__(42711),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var mapTag = '[object Map]';

      /**
       * The base implementation of `_.isMap` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       */
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      module.exports = baseIsMap;

      /***/
    },

    /***/ 5641: /***/ module => {
      /**
       * The base implementation of `_.isNaN` without support for number objects.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       */
      function baseIsNaN(value) {
        return value !== value;
      }
      module.exports = baseIsNaN;

      /***/
    },

    /***/ 12185: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isFunction = __webpack_require__(51028),
        isMasked = __webpack_require__(33014),
        isObject = __webpack_require__(3715),
        toSource = __webpack_require__(10839);

      /**
       * Used to match `RegExp`
       * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
       */
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

      /** Used to detect host constructors (Safari). */
      var reIsHostCtor = /^\[object .+?Constructor\]$/;

      /** Used for built-in method references. */
      var funcProto = Function.prototype,
        objectProto = Object.prototype;

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to detect if a method is native. */
      var reIsNative = RegExp(
        '^' +
          funcToString
            .call(hasOwnProperty)
            .replace(reRegExpChar, '\\$&')
            .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
          '$',
      );

      /**
       * The base implementation of `_.isNative` without bad shim checks.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       */
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      module.exports = baseIsNative;

      /***/
    },

    /***/ 12068: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getTag = __webpack_require__(42711),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var setTag = '[object Set]';

      /**
       * The base implementation of `_.isSet` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       */
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      module.exports = baseIsSet;

      /***/
    },

    /***/ 42875: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        isLength = __webpack_require__(25404),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        objectTag = '[object Object]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        weakMapTag = '[object WeakMap]';
      var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';

      /** Used to identify `toStringTag` values of typed arrays. */
      var typedArrayTags = {};
      typedArrayTags[float32Tag] =
        typedArrayTags[float64Tag] =
        typedArrayTags[int8Tag] =
        typedArrayTags[int16Tag] =
        typedArrayTags[int32Tag] =
        typedArrayTags[uint8Tag] =
        typedArrayTags[uint8ClampedTag] =
        typedArrayTags[uint16Tag] =
        typedArrayTags[uint32Tag] =
          true;
      typedArrayTags[argsTag] =
        typedArrayTags[arrayTag] =
        typedArrayTags[arrayBufferTag] =
        typedArrayTags[boolTag] =
        typedArrayTags[dataViewTag] =
        typedArrayTags[dateTag] =
        typedArrayTags[errorTag] =
        typedArrayTags[funcTag] =
        typedArrayTags[mapTag] =
        typedArrayTags[numberTag] =
        typedArrayTags[objectTag] =
        typedArrayTags[regexpTag] =
        typedArrayTags[setTag] =
        typedArrayTags[stringTag] =
        typedArrayTags[weakMapTag] =
          false;

      /**
       * The base implementation of `_.isTypedArray` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       */
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      module.exports = baseIsTypedArray;

      /***/
    },

    /***/ 27914: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isPrototype = __webpack_require__(50469),
        nativeKeys = __webpack_require__(64756);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = baseKeys;

      /***/
    },

    /***/ 28141: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isObject = __webpack_require__(3715),
        isPrototype = __webpack_require__(50469),
        nativeKeysIn = __webpack_require__(83163);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
          result = [];
        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = baseKeysIn;

      /***/
    },

    /***/ 59584: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Stack = __webpack_require__(66787),
        assignMergeValue = __webpack_require__(43379),
        baseFor = __webpack_require__(6043),
        baseMergeDeep = __webpack_require__(58686),
        isObject = __webpack_require__(3715),
        keysIn = __webpack_require__(83735),
        safeGet = __webpack_require__(47400);

      /**
       * The base implementation of `_.merge` without support for multiple sources.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} [customizer] The function to customize merged values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(
          source,
          function (srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer
                ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack)
                : undefined;
              if (newValue === undefined) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          },
          keysIn,
        );
      }
      module.exports = baseMerge;

      /***/
    },

    /***/ 58686: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assignMergeValue = __webpack_require__(43379),
        cloneBuffer = __webpack_require__(71204),
        cloneTypedArray = __webpack_require__(90467),
        copyArray = __webpack_require__(57861),
        initCloneObject = __webpack_require__(42631),
        isArguments = __webpack_require__(24254),
        isArray = __webpack_require__(37603),
        isArrayLikeObject = __webpack_require__(53739),
        isBuffer = __webpack_require__(23470),
        isFunction = __webpack_require__(51028),
        isObject = __webpack_require__(3715),
        isPlainObject = __webpack_require__(19961),
        isTypedArray = __webpack_require__(24373),
        safeGet = __webpack_require__(47400),
        toPlainObject = __webpack_require__(43082);

      /**
       * A specialized version of `baseMerge` for arrays and objects which performs
       * deep merges and tracks traversed objects enabling objects with circular
       * references to be merged.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {string} key The key of the value to merge.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} mergeFunc The function to merge values.
       * @param {Function} [customizer] The function to customize assigned values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
        var isCommon = newValue === undefined;
        if (isCommon) {
          var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      module.exports = baseMergeDeep;

      /***/
    },

    /***/ 35022: /***/ module => {
      /**
       * The base implementation of `_.propertyOf` without support for deep paths.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Function} Returns the new accessor function.
       */
      function basePropertyOf(object) {
        return function (key) {
          return object == null ? undefined : object[key];
        };
      }
      module.exports = basePropertyOf;

      /***/
    },

    /***/ 80561: /***/ module => {
      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeCeil = Math.ceil,
        nativeMax = Math.max;

      /**
       * The base implementation of `_.range` and `_.rangeRight` which doesn't
       * coerce arguments.
       *
       * @private
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @param {number} step The value to increment or decrement by.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the range of numbers.
       */
      function baseRange(start, end, step, fromRight) {
        var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);
        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }
        return result;
      }
      module.exports = baseRange;

      /***/
    },

    /***/ 84016: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var identity = __webpack_require__(97286),
        overRest = __webpack_require__(7539),
        setToString = __webpack_require__(81239);

      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }
      module.exports = baseRest;

      /***/
    },

    /***/ 42612: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assignValue = __webpack_require__(40581),
        castPath = __webpack_require__(62323),
        isIndex = __webpack_require__(68327),
        isObject = __webpack_require__(3715),
        toKey = __webpack_require__(60299);

      /**
       * The base implementation of `_.set`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
            newValue = value;
          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      module.exports = baseSet;

      /***/
    },

    /***/ 60280: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var constant = __webpack_require__(18620),
        defineProperty = __webpack_require__(72097),
        identity = __webpack_require__(97286);

      /**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var baseSetToString = !defineProperty
        ? identity
        : function (func, string) {
            return defineProperty(func, 'toString', {
              configurable: true,
              enumerable: false,
              value: constant(string),
              writable: true,
            });
          };
      module.exports = baseSetToString;

      /***/
    },

    /***/ 82982: /***/ module => {
      /**
       * The base implementation of `_.slice` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseSlice(array, start, end) {
        var index = -1,
          length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : (end - start) >>> 0;
        start >>>= 0;
        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }
      module.exports = baseSlice;

      /***/
    },

    /***/ 41458: /***/ module => {
      /**
       * The base implementation of `_.times` without support for iteratee shorthands
       * or max array length checks.
       *
       * @private
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       */
      function baseTimes(n, iteratee) {
        var index = -1,
          result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      module.exports = baseTimes;

      /***/
    },

    /***/ 12258: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Symbol = __webpack_require__(75799),
        arrayMap = __webpack_require__(22654),
        isArray = __webpack_require__(37603),
        isSymbol = __webpack_require__(9924);

      /** Used as references for various `Number` constants. */
      var INFINITY = 1 / 0;

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

      /**
       * The base implementation of `_.toString` which doesn't convert nullish
       * values to empty strings.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {string} Returns the string.
       */
      function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
          return value;
        }
        if (isArray(value)) {
          // Recursively convert values (susceptible to call stack limits).
          return arrayMap(value, baseToString) + '';
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }
      module.exports = baseToString;

      /***/
    },

    /***/ 17406: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var trimmedEndIndex = __webpack_require__(45362);

      /** Used to match leading whitespace. */
      var reTrimStart = /^\s+/;

      /**
       * The base implementation of `_.trim`.
       *
       * @private
       * @param {string} string The string to trim.
       * @returns {string} Returns the trimmed string.
       */
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
      }
      module.exports = baseTrim;

      /***/
    },

    /***/ 45083: /***/ module => {
      /**
       * The base implementation of `_.unary` without support for storing metadata.
       *
       * @private
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       */
      function baseUnary(func) {
        return function (value) {
          return func(value);
        };
      }
      module.exports = baseUnary;

      /***/
    },

    /***/ 2937: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var castPath = __webpack_require__(62323),
        last = __webpack_require__(85272),
        parent = __webpack_require__(75019),
        toKey = __webpack_require__(60299);

      /**
       * The base implementation of `_.unset`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The property path to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       */
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      module.exports = baseUnset;

      /***/
    },

    /***/ 73292: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayMap = __webpack_require__(22654);

      /**
       * The base implementation of `_.values` and `_.valuesIn` which creates an
       * array of `object` property values corresponding to the property names
       * of `props`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} props The property names to get values for.
       * @returns {Object} Returns the array of property values.
       */
      function baseValues(object, props) {
        return arrayMap(props, function (key) {
          return object[key];
        });
      }
      module.exports = baseValues;

      /***/
    },

    /***/ 62323: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isArray = __webpack_require__(37603),
        isKey = __webpack_require__(688),
        stringToPath = __webpack_require__(16648),
        toString = __webpack_require__(96004);

      /**
       * Casts `value` to a path array if it's not one.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {Object} [object] The object to query keys on.
       * @returns {Array} Returns the cast property path array.
       */
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }
      module.exports = castPath;

      /***/
    },

    /***/ 86451: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Uint8Array = __webpack_require__(86882);

      /**
       * Creates a clone of `arrayBuffer`.
       *
       * @private
       * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
       * @returns {ArrayBuffer} Returns the cloned array buffer.
       */
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }
      module.exports = cloneArrayBuffer;

      /***/
    },

    /***/ 71204: /***/ (module, exports, __webpack_require__) => {
      /* module decorator */ module = __webpack_require__.nmd(module);
      var root = __webpack_require__(75619);

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Built-in value references. */
      var Buffer = moduleExports ? root.Buffer : undefined,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

      /**
       * Creates a clone of  `buffer`.
       *
       * @private
       * @param {Buffer} buffer The buffer to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Buffer} Returns the cloned buffer.
       */
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
      }
      module.exports = cloneBuffer;

      /***/
    },

    /***/ 99915: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var cloneArrayBuffer = __webpack_require__(86451);

      /**
       * Creates a clone of `dataView`.
       *
       * @private
       * @param {Object} dataView The data view to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned data view.
       */
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      module.exports = cloneDataView;

      /***/
    },

    /***/ 90923: /***/ module => {
      /** Used to match `RegExp` flags from their coerced string values. */
      var reFlags = /\w*$/;

      /**
       * Creates a clone of `regexp`.
       *
       * @private
       * @param {Object} regexp The regexp to clone.
       * @returns {Object} Returns the cloned regexp.
       */
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }
      module.exports = cloneRegExp;

      /***/
    },

    /***/ 61310: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Symbol = __webpack_require__(75799);

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

      /**
       * Creates a clone of the `symbol` object.
       *
       * @private
       * @param {Object} symbol The symbol object to clone.
       * @returns {Object} Returns the cloned symbol object.
       */
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }
      module.exports = cloneSymbol;

      /***/
    },

    /***/ 90467: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var cloneArrayBuffer = __webpack_require__(86451);

      /**
       * Creates a clone of `typedArray`.
       *
       * @private
       * @param {Object} typedArray The typed array to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned typed array.
       */
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      module.exports = cloneTypedArray;

      /***/
    },

    /***/ 57861: /***/ module => {
      /**
       * Copies the values of `source` to `array`.
       *
       * @private
       * @param {Array} source The array to copy values from.
       * @param {Array} [array=[]] The array to copy values to.
       * @returns {Array} Returns `array`.
       */
      function copyArray(source, array) {
        var index = -1,
          length = source.length;
        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }
      module.exports = copyArray;

      /***/
    },

    /***/ 96945: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assignValue = __webpack_require__(40581),
        baseAssignValue = __webpack_require__(52162);

      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
          length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
          if (newValue === undefined) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      module.exports = copyObject;

      /***/
    },

    /***/ 47605: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var copyObject = __webpack_require__(96945),
        getSymbols = __webpack_require__(83270);

      /**
       * Copies own symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      module.exports = copySymbols;

      /***/
    },

    /***/ 97478: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var copyObject = __webpack_require__(96945),
        getSymbolsIn = __webpack_require__(48145);

      /**
       * Copies own and inherited symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      module.exports = copySymbolsIn;

      /***/
    },

    /***/ 80591: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var root = __webpack_require__(75619);

      /** Used to detect overreaching core-js shims. */
      var coreJsData = root['__core-js_shared__'];
      module.exports = coreJsData;

      /***/
    },

    /***/ 12317: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseRest = __webpack_require__(84016),
        isIterateeCall = __webpack_require__(14494);

      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */
      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }
      module.exports = createAssigner;

      /***/
    },

    /***/ 68119: /***/ module => {
      /**
       * Creates a base function for methods like `_.forIn` and `_.forOwn`.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      module.exports = createBaseFor;

      /***/
    },

    /***/ 78073: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayReduce = __webpack_require__(70104),
        deburr = __webpack_require__(70794),
        words = __webpack_require__(43243);

      /** Used to compose unicode capture groups. */
      var rsApos = "['\u2019]";

      /** Used to match apostrophes. */
      var reApos = RegExp(rsApos, 'g');

      /**
       * Creates a function like `_.camelCase`.
       *
       * @private
       * @param {Function} callback The function to combine each word.
       * @returns {Function} Returns the new compounder function.
       */
      function createCompounder(callback) {
        return function (string) {
          return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
        };
      }
      module.exports = createCompounder;

      /***/
    },

    /***/ 52286: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseRange = __webpack_require__(80561),
        isIterateeCall = __webpack_require__(14494),
        toFinite = __webpack_require__(95134);

      /**
       * Creates a `_.range` or `_.rangeRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new range function.
       */
      function createRange(fromRight) {
        return function (start, end, step) {
          if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
            end = step = undefined;
          }
          // Ensure the sign of `-0` is preserved.
          start = toFinite(start);
          if (end === undefined) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      module.exports = createRange;

      /***/
    },

    /***/ 77292: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isPlainObject = __webpack_require__(19961);

      /**
       * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
       * objects.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {string} key The key of the property to inspect.
       * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
       */
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined : value;
      }
      module.exports = customOmitClone;

      /***/
    },

    /***/ 46177: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var basePropertyOf = __webpack_require__(35022);

      /** Used to map Latin Unicode letters to basic Latin letters. */
      var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's',
      };

      /**
       * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
       * letters to basic Latin letters.
       *
       * @private
       * @param {string} letter The matched letter to deburr.
       * @returns {string} Returns the deburred letter.
       */
      var deburrLetter = basePropertyOf(deburredLetters);
      module.exports = deburrLetter;

      /***/
    },

    /***/ 72097: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264);
      var defineProperty = (function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      })();
      module.exports = defineProperty;

      /***/
    },

    /***/ 63126: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var flatten = __webpack_require__(11616),
        overRest = __webpack_require__(7539),
        setToString = __webpack_require__(81239);

      /**
       * A specialized version of `baseRest` which flattens the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      function flatRest(func) {
        return setToString(overRest(func, undefined, flatten), func + '');
      }
      module.exports = flatRest;

      /***/
    },

    /***/ 57326: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      /** Detect free variable `global` from Node.js. */
      var freeGlobal =
        typeof __webpack_require__.g == 'object' &&
        __webpack_require__.g &&
        __webpack_require__.g.Object === Object &&
        __webpack_require__.g;
      module.exports = freeGlobal;

      /***/
    },

    /***/ 23280: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetAllKeys = __webpack_require__(51141),
        getSymbols = __webpack_require__(83270),
        keys = __webpack_require__(45000);

      /**
       * Creates an array of own enumerable property names and symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      module.exports = getAllKeys;

      /***/
    },

    /***/ 65279: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetAllKeys = __webpack_require__(51141),
        getSymbolsIn = __webpack_require__(48145),
        keysIn = __webpack_require__(83735);

      /**
       * Creates an array of own and inherited enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      module.exports = getAllKeysIn;

      /***/
    },

    /***/ 60113: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isKeyable = __webpack_require__(63492);

      /**
       * Gets the data for `map`.
       *
       * @private
       * @param {Object} map The map to query.
       * @param {string} key The reference key.
       * @returns {*} Returns the map data.
       */
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
      }
      module.exports = getMapData;

      /***/
    },

    /***/ 5264: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseIsNative = __webpack_require__(12185),
        getValue = __webpack_require__(28050);

      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
      }
      module.exports = getNative;

      /***/
    },

    /***/ 86065: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var overArg = __webpack_require__(38233);

      /** Built-in value references. */
      var getPrototype = overArg(Object.getPrototypeOf, Object);
      module.exports = getPrototype;

      /***/
    },

    /***/ 36969: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Symbol = __webpack_require__(75799);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /** Built-in value references. */
      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined;
          var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }
      module.exports = getRawTag;

      /***/
    },

    /***/ 83270: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayFilter = __webpack_require__(18472),
        stubArray = __webpack_require__(94759);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Built-in value references. */
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeGetSymbols = Object.getOwnPropertySymbols;

      /**
       * Creates an array of the own enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbols = !nativeGetSymbols
        ? stubArray
        : function (object) {
            if (object == null) {
              return [];
            }
            object = Object(object);
            return arrayFilter(nativeGetSymbols(object), function (symbol) {
              return propertyIsEnumerable.call(object, symbol);
            });
          };
      module.exports = getSymbols;

      /***/
    },

    /***/ 48145: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayPush = __webpack_require__(81026),
        getPrototype = __webpack_require__(86065),
        getSymbols = __webpack_require__(83270),
        stubArray = __webpack_require__(94759);

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeGetSymbols = Object.getOwnPropertySymbols;

      /**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbolsIn = !nativeGetSymbols
        ? stubArray
        : function (object) {
            var result = [];
            while (object) {
              arrayPush(result, getSymbols(object));
              object = getPrototype(object);
            }
            return result;
          };
      module.exports = getSymbolsIn;

      /***/
    },

    /***/ 42711: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var DataView = __webpack_require__(9438),
        Map = __webpack_require__(56285),
        Promise = __webpack_require__(86974),
        Set = __webpack_require__(75867),
        WeakMap = __webpack_require__(53173),
        baseGetTag = __webpack_require__(33754),
        toSource = __webpack_require__(10839);

      /** `Object#toString` result references. */
      var mapTag = '[object Map]',
        objectTag = '[object Object]',
        promiseTag = '[object Promise]',
        setTag = '[object Set]',
        weakMapTag = '[object WeakMap]';
      var dataViewTag = '[object DataView]';

      /** Used to detect maps, sets, and weakmaps. */
      var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

      /**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      var getTag = baseGetTag;

      // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
      if (
        (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map()) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set()) != setTag) ||
        (WeakMap && getTag(new WeakMap()) != weakMapTag)
      ) {
        getTag = function (value) {
          var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }
      module.exports = getTag;

      /***/
    },

    /***/ 28050: /***/ module => {
      /**
       * Gets the value at `key` of `object`.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function getValue(object, key) {
        return object == null ? undefined : object[key];
      }
      module.exports = getValue;

      /***/
    },

    /***/ 5256: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var castPath = __webpack_require__(62323),
        isArguments = __webpack_require__(24254),
        isArray = __webpack_require__(37603),
        isIndex = __webpack_require__(68327),
        isLength = __webpack_require__(25404),
        toKey = __webpack_require__(60299);

      /**
       * Checks if `path` exists on `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @param {Function} hasFunc The function to check properties.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       */
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          result = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length) {
          return result;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }
      module.exports = hasPath;

      /***/
    },

    /***/ 51856: /***/ module => {
      /** Used to detect strings that need a more robust regexp to match words. */
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

      /**
       * Checks if `string` contains a word composed of Unicode symbols.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {boolean} Returns `true` if a word is found, else `false`.
       */
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      module.exports = hasUnicodeWord;

      /***/
    },

    /***/ 45850: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var nativeCreate = __webpack_require__(73180);

      /**
       * Removes all key-value entries from the hash.
       *
       * @private
       * @name clear
       * @memberOf Hash
       */
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      module.exports = hashClear;

      /***/
    },

    /***/ 56988: /***/ module => {
      /**
       * Removes `key` and its value from the hash.
       *
       * @private
       * @name delete
       * @memberOf Hash
       * @param {Object} hash The hash to modify.
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }
      module.exports = hashDelete;

      /***/
    },

    /***/ 71631: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var nativeCreate = __webpack_require__(73180);

      /** Used to stand-in for `undefined` hash values. */
      var HASH_UNDEFINED = '__lodash_hash_undefined__';

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Gets the hash value for `key`.
       *
       * @private
       * @name get
       * @memberOf Hash
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
      }
      module.exports = hashGet;

      /***/
    },

    /***/ 27699: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var nativeCreate = __webpack_require__(73180);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Checks if a hash value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Hash
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
      }
      module.exports = hashHas;

      /***/
    },

    /***/ 76491: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var nativeCreate = __webpack_require__(73180);

      /** Used to stand-in for `undefined` hash values. */
      var HASH_UNDEFINED = '__lodash_hash_undefined__';

      /**
       * Sets the hash `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Hash
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the hash instance.
       */
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
      }
      module.exports = hashSet;

      /***/
    },

    /***/ 14503: /***/ module => {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Initializes an array clone.
       *
       * @private
       * @param {Array} array The array to clone.
       * @returns {Array} Returns the initialized clone.
       */
      function initCloneArray(array) {
        var length = array.length,
          result = new array.constructor(length);

        // Add properties assigned by `RegExp#exec`.
        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }
      module.exports = initCloneArray;

      /***/
    },

    /***/ 9961: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var cloneArrayBuffer = __webpack_require__(86451),
        cloneDataView = __webpack_require__(99915),
        cloneRegExp = __webpack_require__(90923),
        cloneSymbol = __webpack_require__(61310),
        cloneTypedArray = __webpack_require__(90467);

      /** `Object#toString` result references. */
      var boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        symbolTag = '[object Symbol]';
      var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';

      /**
       * Initializes an object clone based on its `toStringTag`.
       *
       * **Note:** This function only supports cloning values with tags of
       * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
       *
       * @private
       * @param {Object} object The object to clone.
       * @param {string} tag The `toStringTag` of the object to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      module.exports = initCloneByTag;

      /***/
    },

    /***/ 42631: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseCreate = __webpack_require__(90938),
        getPrototype = __webpack_require__(86065),
        isPrototype = __webpack_require__(50469);

      /**
       * Initializes an object clone.
       *
       * @private
       * @param {Object} object The object to clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      module.exports = initCloneObject;

      /***/
    },

    /***/ 46609: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Symbol = __webpack_require__(75799),
        isArguments = __webpack_require__(24254),
        isArray = __webpack_require__(37603);

      /** Built-in value references. */
      var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

      /**
       * Checks if `value` is a flattenable `arguments` object or array.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
       */
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      module.exports = isFlattenable;

      /***/
    },

    /***/ 68327: /***/ module => {
      /** Used as references for various `Number` constants. */
      var MAX_SAFE_INTEGER = 9007199254740991;

      /** Used to detect unsigned integer values. */
      var reIsUint = /^(?:0|[1-9]\d*)$/;

      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return (
          !!length &&
          (type == 'number' || (type != 'symbol' && reIsUint.test(value))) &&
          value > -1 &&
          value % 1 == 0 &&
          value < length
        );
      }
      module.exports = isIndex;

      /***/
    },

    /***/ 14494: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var eq = __webpack_require__(91114),
        isArrayLike = __webpack_require__(52284),
        isIndex = __webpack_require__(68327),
        isObject = __webpack_require__(3715);

      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (
          type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object
        ) {
          return eq(object[index], value);
        }
        return false;
      }
      module.exports = isIterateeCall;

      /***/
    },

    /***/ 688: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isArray = __webpack_require__(37603),
        isSymbol = __webpack_require__(9924);

      /** Used to match property names within property paths. */
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/;

      /**
       * Checks if `value` is a property name and not a property path.
       *
       * @private
       * @param {*} value The value to check.
       * @param {Object} [object] The object to query keys on.
       * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
       */
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || (object != null && value in Object(object));
      }
      module.exports = isKey;

      /***/
    },

    /***/ 63492: /***/ module => {
      /**
       * Checks if `value` is suitable for use as unique object key.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
       */
      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean'
          ? value !== '__proto__'
          : value === null;
      }
      module.exports = isKeyable;

      /***/
    },

    /***/ 33014: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var coreJsData = __webpack_require__(80591);

      /** Used to detect methods masquerading as native. */
      var maskSrcKey = (function () {
        var uid = /[^.]+$/.exec((coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      })();

      /**
       * Checks if `func` has its source masked.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` is masked, else `false`.
       */
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      module.exports = isMasked;

      /***/
    },

    /***/ 50469: /***/ module => {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */
      function isPrototype(value) {
        var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
        return value === proto;
      }
      module.exports = isPrototype;

      /***/
    },

    /***/ 28924: /***/ module => {
      /**
       * Removes all key-value entries from the list cache.
       *
       * @private
       * @name clear
       * @memberOf ListCache
       */
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      module.exports = listCacheClear;

      /***/
    },

    /***/ 48122: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assocIndexOf = __webpack_require__(98639);

      /** Used for built-in method references. */
      var arrayProto = Array.prototype;

      /** Built-in value references. */
      var splice = arrayProto.splice;

      /**
       * Removes `key` and its value from the list cache.
       *
       * @private
       * @name delete
       * @memberOf ListCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function listCacheDelete(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }
      module.exports = listCacheDelete;

      /***/
    },

    /***/ 31381: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assocIndexOf = __webpack_require__(98639);

      /**
       * Gets the list cache value for `key`.
       *
       * @private
       * @name get
       * @memberOf ListCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function listCacheGet(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
      }
      module.exports = listCacheGet;

      /***/
    },

    /***/ 14489: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assocIndexOf = __webpack_require__(98639);

      /**
       * Checks if a list cache value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf ListCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      module.exports = listCacheHas;

      /***/
    },

    /***/ 48721: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var assocIndexOf = __webpack_require__(98639);

      /**
       * Sets the list cache `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf ListCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the list cache instance.
       */
      function listCacheSet(key, value) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }
      module.exports = listCacheSet;

      /***/
    },

    /***/ 40126: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var Hash = __webpack_require__(22139),
        ListCache = __webpack_require__(11649),
        Map = __webpack_require__(56285);

      /**
       * Removes all key-value entries from the map.
       *
       * @private
       * @name clear
       * @memberOf MapCache
       */
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          hash: new Hash(),
          map: new (Map || ListCache)(),
          string: new Hash(),
        };
      }
      module.exports = mapCacheClear;

      /***/
    },

    /***/ 85464: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getMapData = __webpack_require__(60113);

      /**
       * Removes `key` and its value from the map.
       *
       * @private
       * @name delete
       * @memberOf MapCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }
      module.exports = mapCacheDelete;

      /***/
    },

    /***/ 45755: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getMapData = __webpack_require__(60113);

      /**
       * Gets the map value for `key`.
       *
       * @private
       * @name get
       * @memberOf MapCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      module.exports = mapCacheGet;

      /***/
    },

    /***/ 12343: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getMapData = __webpack_require__(60113);

      /**
       * Checks if a map value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf MapCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      module.exports = mapCacheHas;

      /***/
    },

    /***/ 55071: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getMapData = __webpack_require__(60113);

      /**
       * Sets the map `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf MapCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the map cache instance.
       */
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
          size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }
      module.exports = mapCacheSet;

      /***/
    },

    /***/ 27722: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var memoize = __webpack_require__(35446);

      /** Used as the maximum memoize cache size. */
      var MAX_MEMOIZE_SIZE = 500;

      /**
       * A specialized version of `_.memoize` which clears the memoized function's
       * cache when it exceeds `MAX_MEMOIZE_SIZE`.
       *
       * @private
       * @param {Function} func The function to have its output memoized.
       * @returns {Function} Returns the new memoized function.
       */
      function memoizeCapped(func) {
        var result = memoize(func, function (key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result.cache;
        return result;
      }
      module.exports = memoizeCapped;

      /***/
    },

    /***/ 73180: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var getNative = __webpack_require__(5264);

      /* Built-in method references that are verified to be native. */
      var nativeCreate = getNative(Object, 'create');
      module.exports = nativeCreate;

      /***/
    },

    /***/ 64756: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var overArg = __webpack_require__(38233);

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeKeys = overArg(Object.keys, Object);
      module.exports = nativeKeys;

      /***/
    },

    /***/ 83163: /***/ module => {
      /**
       * This function is like
       * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * except that it includes inherited enumerable properties.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = nativeKeysIn;

      /***/
    },

    /***/ 4187: /***/ (module, exports, __webpack_require__) => {
      /* module decorator */ module = __webpack_require__.nmd(module);
      var freeGlobal = __webpack_require__(57326);

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Detect free variable `process` from Node.js. */
      var freeProcess = moduleExports && freeGlobal.process;

      /** Used to access faster Node.js helpers. */
      var nodeUtil = (function () {
        try {
          // Use `util.types` for Node.js 10+.
          var types = freeModule && freeModule.require && freeModule.require('util').types;
          if (types) {
            return types;
          }

          // Legacy `process.binding('util')` for Node.js < 10.
          return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
      })();
      module.exports = nodeUtil;

      /***/
    },

    /***/ 11916: /***/ module => {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      module.exports = objectToString;

      /***/
    },

    /***/ 38233: /***/ module => {
      /**
       * Creates a unary function that invokes `func` with its argument transformed.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {Function} transform The argument transform.
       * @returns {Function} Returns the new function.
       */
      function overArg(func, transform) {
        return function (arg) {
          return func(transform(arg));
        };
      }
      module.exports = overArg;

      /***/
    },

    /***/ 7539: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var apply = __webpack_require__(44375);

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max;

      /**
       * A specialized version of `baseRest` which transforms the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @param {Function} transform The rest array transform.
       * @returns {Function} Returns the new function.
       */
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);
          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }
      module.exports = overRest;

      /***/
    },

    /***/ 75019: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGet = __webpack_require__(99216),
        baseSlice = __webpack_require__(82982);

      /**
       * Gets the parent value at `path` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} path The path to get the parent value of.
       * @returns {*} Returns the parent value.
       */
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      module.exports = parent;

      /***/
    },

    /***/ 75619: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var freeGlobal = __webpack_require__(57326);

      /** Detect free variable `self`. */
      var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

      /** Used as a reference to the global object. */
      var root = freeGlobal || freeSelf || Function('return this')();
      module.exports = root;

      /***/
    },

    /***/ 47400: /***/ module => {
      /**
       * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }
        if (key == '__proto__') {
          return;
        }
        return object[key];
      }
      module.exports = safeGet;

      /***/
    },

    /***/ 81239: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseSetToString = __webpack_require__(60280),
        shortOut = __webpack_require__(84909);

      /**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var setToString = shortOut(baseSetToString);
      module.exports = setToString;

      /***/
    },

    /***/ 84909: /***/ module => {
      /** Used to detect hot functions by number of calls within a span of milliseconds. */
      var HOT_COUNT = 800,
        HOT_SPAN = 16;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeNow = Date.now;

      /**
       * Creates a function that'll short out and invoke `identity` instead
       * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
       * milliseconds.
       *
       * @private
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new shortable function.
       */
      function shortOut(func) {
        var count = 0,
          lastCalled = 0;
        return function () {
          var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined, arguments);
        };
      }
      module.exports = shortOut;

      /***/
    },

    /***/ 73634: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var ListCache = __webpack_require__(11649);

      /**
       * Removes all key-value entries from the stack.
       *
       * @private
       * @name clear
       * @memberOf Stack
       */
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      module.exports = stackClear;

      /***/
    },

    /***/ 91636: /***/ module => {
      /**
       * Removes `key` and its value from the stack.
       *
       * @private
       * @name delete
       * @memberOf Stack
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function stackDelete(key) {
        var data = this.__data__,
          result = data['delete'](key);
        this.size = data.size;
        return result;
      }
      module.exports = stackDelete;

      /***/
    },

    /***/ 19719: /***/ module => {
      /**
       * Gets the stack value for `key`.
       *
       * @private
       * @name get
       * @memberOf Stack
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function stackGet(key) {
        return this.__data__.get(key);
      }
      module.exports = stackGet;

      /***/
    },

    /***/ 98971: /***/ module => {
      /**
       * Checks if a stack value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Stack
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function stackHas(key) {
        return this.__data__.has(key);
      }
      module.exports = stackHas;

      /***/
    },

    /***/ 89987: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var ListCache = __webpack_require__(11649),
        Map = __webpack_require__(56285),
        MapCache = __webpack_require__(22583);

      /** Used as the size to enable large array optimizations. */
      var LARGE_ARRAY_SIZE = 200;

      /**
       * Sets the stack `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Stack
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the stack cache instance.
       */
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      module.exports = stackSet;

      /***/
    },

    /***/ 5749: /***/ module => {
      /**
       * A specialized version of `_.indexOf` which performs strict equality
       * comparisons of values, i.e. `===`.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} fromIndex The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1,
          length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      module.exports = strictIndexOf;

      /***/
    },

    /***/ 16648: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var memoizeCapped = __webpack_require__(27722);

      /** Used to match property names within property paths. */
      var rePropName =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

      /** Used to match backslashes in property paths. */
      var reEscapeChar = /\\(\\)?/g;

      /**
       * Converts `string` to a property path array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the property path array.
       */
      var stringToPath = memoizeCapped(function (string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */) {
          result.push('');
        }
        string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
      });
      module.exports = stringToPath;

      /***/
    },

    /***/ 60299: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isSymbol = __webpack_require__(9924);

      /** Used as references for various `Number` constants. */
      var INFINITY = 1 / 0;

      /**
       * Converts `value` to a string key if it's not a string or symbol.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {string|symbol} Returns the key.
       */
      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }
      module.exports = toKey;

      /***/
    },

    /***/ 10839: /***/ module => {
      /** Used for built-in method references. */
      var funcProto = Function.prototype;

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /**
       * Converts `func` to its source code.
       *
       * @private
       * @param {Function} func The function to convert.
       * @returns {string} Returns the source code.
       */
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return func + '';
          } catch (e) {}
        }
        return '';
      }
      module.exports = toSource;

      /***/
    },

    /***/ 45362: /***/ module => {
      /** Used to match a single whitespace character. */
      var reWhitespace = /\s/;

      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
       * character of `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the index of the last non-whitespace character.
       */
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {}
        return index;
      }
      module.exports = trimmedEndIndex;

      /***/
    },

    /***/ 51095: /***/ module => {
      /** Used to compose unicode character classes. */
      var rsAstralRange = '\\ud800-\\udfff',
        rsComboMarksRange = '\\u0300-\\u036f',
        reComboHalfMarksRange = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange = '\\u20d0-\\u20ff',
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
        rsDingbatRange = '\\u2700-\\u27bf',
        rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
        rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
        rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
        rsPunctuationRange = '\\u2000-\\u206f',
        rsSpaceRange =
          ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
        rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
        rsVarRange = '\\ufe0e\\ufe0f',
        rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

      /** Used to compose unicode capture groups. */
      var rsApos = "['\u2019]",
        rsBreak = '[' + rsBreakRange + ']',
        rsCombo = '[' + rsComboRange + ']',
        rsDigits = '\\d+',
        rsDingbat = '[' + rsDingbatRange + ']',
        rsLower = '[' + rsLowerRange + ']',
        rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
        rsFitz = '\\ud83c[\\udffb-\\udfff]',
        rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
        rsNonAstral = '[^' + rsAstralRange + ']',
        rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        rsUpper = '[' + rsUpperRange + ']',
        rsZWJ = '\\u200d';

      /** Used to compose unicode regexes. */
      var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
        rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
        rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
        rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
        reOptMod = rsModifier + '?',
        rsOptVar = '[' + rsVarRange + ']?',
        rsOptJoin =
          '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
        rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
        rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
        rsSeq = rsOptVar + reOptMod + rsOptJoin,
        rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

      /** Used to match complex or compound words. */
      var reUnicodeWord = RegExp(
        [
          rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
          rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
          rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
          rsUpper + '+' + rsOptContrUpper,
          rsOrdUpper,
          rsOrdLower,
          rsDigits,
          rsEmoji,
        ].join('|'),
        'g',
      );

      /**
       * Splits a Unicode `string` into an array of its words.
       *
       * @private
       * @param {string} The string to inspect.
       * @returns {Array} Returns the words of `string`.
       */
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      module.exports = unicodeWords;

      /***/
    },

    /***/ 47217: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseClone = __webpack_require__(71649);

      /** Used to compose bitmasks for cloning. */
      var CLONE_DEEP_FLAG = 1,
        CLONE_SYMBOLS_FLAG = 4;

      /**
       * This method is like `_.clone` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @returns {*} Returns the deep cloned value.
       * @see _.clone
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var deep = _.cloneDeep(objects);
       * console.log(deep[0] === objects[0]);
       * // => false
       */
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      module.exports = cloneDeep;

      /***/
    },

    /***/ 18620: /***/ module => {
      /**
       * Creates a function that returns `value`.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {*} value The value to return from the new function.
       * @returns {Function} Returns the new constant function.
       * @example
       *
       * var objects = _.times(2, _.constant({ 'a': 1 }));
       *
       * console.log(objects);
       * // => [{ 'a': 1 }, { 'a': 1 }]
       *
       * console.log(objects[0] === objects[1]);
       * // => true
       */
      function constant(value) {
        return function () {
          return value;
        };
      }
      module.exports = constant;

      /***/
    },

    /***/ 24551: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isObject = __webpack_require__(3715),
        now = __webpack_require__(99518),
        toNumber = __webpack_require__(41888);

      /** Error message constants. */
      var FUNC_ERROR_TEXT = 'Expected a function';

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max,
        nativeMin = Math.min;

      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;
          lastArgs = lastThis = undefined;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time;
          // Start the timer for the trailing edge.
          timerId = setTimeout(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return (
            lastCallTime === undefined ||
            timeSinceLastCall >= wait ||
            timeSinceLastCall < 0 ||
            (maxing && timeSinceLastInvoke >= maxWait)
          );
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          // Restart the timer.
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined;

          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined;
          return result;
        }
        function cancel() {
          if (timerId !== undefined) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined;
        }
        function flush() {
          return timerId === undefined ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      module.exports = debounce;

      /***/
    },

    /***/ 70794: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var deburrLetter = __webpack_require__(46177),
        toString = __webpack_require__(96004);

      /** Used to match Latin Unicode letters (excluding mathematical operators). */
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

      /** Used to compose unicode character classes. */
      var rsComboMarksRange = '\\u0300-\\u036f',
        reComboHalfMarksRange = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange = '\\u20d0-\\u20ff',
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

      /** Used to compose unicode capture groups. */
      var rsCombo = '[' + rsComboRange + ']';

      /**
       * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
       * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
       */
      var reComboMark = RegExp(rsCombo, 'g');

      /**
       * Deburrs `string` by converting
       * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
       * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
       * letters to basic Latin letters and removing
       * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to deburr.
       * @returns {string} Returns the deburred string.
       * @example
       *
       * _.deburr('déjà vu');
       * // => 'deja vu'
       */
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
      }
      module.exports = deburr;

      /***/
    },

    /***/ 91114: /***/ module => {
      /**
       * Performs a
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * comparison between two values to determine if they are equivalent.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.eq(object, object);
       * // => true
       *
       * _.eq(object, other);
       * // => false
       *
       * _.eq('a', 'a');
       * // => true
       *
       * _.eq('a', Object('a'));
       * // => false
       *
       * _.eq(NaN, NaN);
       * // => true
       */
      function eq(value, other) {
        return value === other || (value !== value && other !== other);
      }
      module.exports = eq;

      /***/
    },

    /***/ 11616: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseFlatten = __webpack_require__(18142);

      /**
       * Flattens `array` a single level deep.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flatten([1, [2, [3, [4]], 5]]);
       * // => [1, 2, [3, [4]], 5]
       */
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      module.exports = flatten;

      /***/
    },

    /***/ 25358: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGet = __webpack_require__(99216);

      /**
       * Gets the value at `path` of `object`. If the resolved value is
       * `undefined`, the `defaultValue` is returned in its place.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.get(object, 'a[0].b.c');
       * // => 3
       *
       * _.get(object, ['a', '0', 'b', 'c']);
       * // => 3
       *
       * _.get(object, 'a.b.c', 'default');
       * // => 'default'
       */
      function get(object, path, defaultValue) {
        var result = object == null ? undefined : baseGet(object, path);
        return result === undefined ? defaultValue : result;
      }
      module.exports = get;

      /***/
    },

    /***/ 75322: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseHas = __webpack_require__(38868),
        hasPath = __webpack_require__(5256);

      /**
       * Checks if `path` is a direct property of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = { 'a': { 'b': 2 } };
       * var other = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.has(object, 'a');
       * // => true
       *
       * _.has(object, 'a.b');
       * // => true
       *
       * _.has(object, ['a', 'b']);
       * // => true
       *
       * _.has(other, 'a');
       * // => false
       */
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      module.exports = has;

      /***/
    },

    /***/ 97286: /***/ module => {
      /**
       * This method returns the first argument it receives.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {*} value Any value.
       * @returns {*} Returns `value`.
       * @example
       *
       * var object = { 'a': 1 };
       *
       * console.log(_.identity(object) === object);
       * // => true
       */
      function identity(value) {
        return value;
      }
      module.exports = identity;

      /***/
    },

    /***/ 69849: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseIndexOf = __webpack_require__(73989),
        isArrayLike = __webpack_require__(52284),
        isString = __webpack_require__(67373),
        toInteger = __webpack_require__(20263),
        values = __webpack_require__(5570);

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max;

      /**
       * Checks if `value` is in `collection`. If `collection` is a string, it's
       * checked for a substring of `value`, otherwise
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * is used for equality comparisons. If `fromIndex` is negative, it's used as
       * the offset from the end of `collection`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {boolean} Returns `true` if `value` is found, else `false`.
       * @example
       *
       * _.includes([1, 2, 3], 1);
       * // => true
       *
       * _.includes([1, 2, 3], 1, 2);
       * // => false
       *
       * _.includes({ 'a': 1, 'b': 2 }, 1);
       * // => true
       *
       * _.includes('abcd', 'bc');
       * // => true
       */
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection)
          ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1
          : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      module.exports = includes;

      /***/
    },

    /***/ 24254: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseIsArguments = __webpack_require__(59720),
        isObjectLike = __webpack_require__(34140);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Built-in value references. */
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;

      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */
      var isArguments = baseIsArguments(
        (function () {
          return arguments;
        })(),
      )
        ? baseIsArguments
        : function (value) {
            return (
              isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee')
            );
          };
      module.exports = isArguments;

      /***/
    },

    /***/ 37603: /***/ module => {
      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */
      var isArray = Array.isArray;
      module.exports = isArray;

      /***/
    },

    /***/ 52284: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isFunction = __webpack_require__(51028),
        isLength = __webpack_require__(25404);

      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      module.exports = isArrayLike;

      /***/
    },

    /***/ 53739: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isArrayLike = __webpack_require__(52284),
        isObjectLike = __webpack_require__(34140);

      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      module.exports = isArrayLikeObject;

      /***/
    },

    /***/ 23470: /***/ (module, exports, __webpack_require__) => {
      /* module decorator */ module = __webpack_require__.nmd(module);
      var root = __webpack_require__(75619),
        stubFalse = __webpack_require__(55597);

      /** Detect free variable `exports`. */
      var freeExports = true && exports && !exports.nodeType && exports;

      /** Detect free variable `module`. */
      var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

      /** Detect the popular CommonJS extension `module.exports`. */
      var moduleExports = freeModule && freeModule.exports === freeExports;

      /** Built-in value references. */
      var Buffer = moduleExports ? root.Buffer : undefined;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse;
      module.exports = isBuffer;

      /***/
    },

    /***/ 51028: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        isObject = __webpack_require__(3715);

      /** `Object#toString` result references. */
      var asyncTag = '[object AsyncFunction]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        proxyTag = '[object Proxy]';

      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      module.exports = isFunction;

      /***/
    },

    /***/ 25404: /***/ module => {
      /** Used as references for various `Number` constants. */
      var MAX_SAFE_INTEGER = 9007199254740991;

      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */
      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      module.exports = isLength;

      /***/
    },

    /***/ 31204: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseIsMap = __webpack_require__(70422),
        baseUnary = __webpack_require__(45083),
        nodeUtil = __webpack_require__(4187);

      /* Node.js helper references. */
      var nodeIsMap = nodeUtil && nodeUtil.isMap;

      /**
       * Checks if `value` is classified as a `Map` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       * @example
       *
       * _.isMap(new Map);
       * // => true
       *
       * _.isMap(new WeakMap);
       * // => false
       */
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      module.exports = isMap;

      /***/
    },

    /***/ 76519: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var isNumber = __webpack_require__(91553);

      /**
       * Checks if `value` is `NaN`.
       *
       * **Note:** This method is based on
       * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
       * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
       * `undefined` and other non-number values.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       * @example
       *
       * _.isNaN(NaN);
       * // => true
       *
       * _.isNaN(new Number(NaN));
       * // => true
       *
       * isNaN(undefined);
       * // => true
       *
       * _.isNaN(undefined);
       * // => false
       */
      function isNaN(value) {
        // An `NaN` primitive is the only value that is not equal to itself.
        // Perform the `toStringTag` check first to avoid errors with some
        // ActiveX objects in IE.
        return isNumber(value) && value != +value;
      }
      module.exports = isNaN;

      /***/
    },

    /***/ 91553: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var numberTag = '[object Number]';

      /**
       * Checks if `value` is classified as a `Number` primitive or object.
       *
       * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
       * classified as numbers, use the `_.isFinite` method.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a number, else `false`.
       * @example
       *
       * _.isNumber(3);
       * // => true
       *
       * _.isNumber(Number.MIN_VALUE);
       * // => true
       *
       * _.isNumber(Infinity);
       * // => true
       *
       * _.isNumber('3');
       * // => false
       */
      function isNumber(value) {
        return typeof value == 'number' || (isObjectLike(value) && baseGetTag(value) == numberTag);
      }
      module.exports = isNumber;

      /***/
    },

    /***/ 3715: /***/ module => {
      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }
      module.exports = isObject;

      /***/
    },

    /***/ 34140: /***/ module => {
      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }
      module.exports = isObjectLike;

      /***/
    },

    /***/ 19961: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        getPrototype = __webpack_require__(86065),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var objectTag = '[object Object]';

      /** Used for built-in method references. */
      var funcProto = Function.prototype,
        objectProto = Object.prototype;

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to infer the `Object` constructor. */
      var objectCtorString = funcToString.call(Object);

      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      module.exports = isPlainObject;

      /***/
    },

    /***/ 13558: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseIsSet = __webpack_require__(12068),
        baseUnary = __webpack_require__(45083),
        nodeUtil = __webpack_require__(4187);

      /* Node.js helper references. */
      var nodeIsSet = nodeUtil && nodeUtil.isSet;

      /**
       * Checks if `value` is classified as a `Set` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       * @example
       *
       * _.isSet(new Set);
       * // => true
       *
       * _.isSet(new WeakSet);
       * // => false
       */
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      module.exports = isSet;

      /***/
    },

    /***/ 67373: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        isArray = __webpack_require__(37603),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var stringTag = '[object String]';

      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a string, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */
      function isString(value) {
        return typeof value == 'string' || (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
      }
      module.exports = isString;

      /***/
    },

    /***/ 9924: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseGetTag = __webpack_require__(33754),
        isObjectLike = __webpack_require__(34140);

      /** `Object#toString` result references. */
      var symbolTag = '[object Symbol]';

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return typeof value == 'symbol' || (isObjectLike(value) && baseGetTag(value) == symbolTag);
      }
      module.exports = isSymbol;

      /***/
    },

    /***/ 24373: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseIsTypedArray = __webpack_require__(42875),
        baseUnary = __webpack_require__(45083),
        nodeUtil = __webpack_require__(4187);

      /* Node.js helper references. */
      var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

      /**
       * Checks if `value` is classified as a typed array.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       * @example
       *
       * _.isTypedArray(new Uint8Array);
       * // => true
       *
       * _.isTypedArray([]);
       * // => false
       */
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      module.exports = isTypedArray;

      /***/
    },

    /***/ 45000: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayLikeKeys = __webpack_require__(74113),
        baseKeys = __webpack_require__(27914),
        isArrayLike = __webpack_require__(52284);

      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      module.exports = keys;

      /***/
    },

    /***/ 83735: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayLikeKeys = __webpack_require__(74113),
        baseKeysIn = __webpack_require__(28141),
        isArrayLike = __webpack_require__(52284);

      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      module.exports = keysIn;

      /***/
    },

    /***/ 85272: /***/ module => {
      /**
       * Gets the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the last element of `array`.
       * @example
       *
       * _.last([1, 2, 3]);
       * // => 3
       */
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined;
      }
      module.exports = last;

      /***/
    },

    /***/ 59315: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var createCompounder = __webpack_require__(78073);

      /**
       * Converts `string`, as space separated words, to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.lowerCase('--Foo-Bar--');
       * // => 'foo bar'
       *
       * _.lowerCase('fooBar');
       * // => 'foo bar'
       *
       * _.lowerCase('__FOO_BAR__');
       * // => 'foo bar'
       */
      var lowerCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
      });
      module.exports = lowerCase;

      /***/
    },

    /***/ 35446: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var MapCache = __webpack_require__(22583);

      /** Error message constants. */
      var FUNC_ERROR_TEXT = 'Expected a function';

      /**
       * Creates a function that memoizes the result of `func`. If `resolver` is
       * provided, it determines the cache key for storing the result based on the
       * arguments provided to the memoized function. By default, the first argument
       * provided to the memoized function is used as the map cache key. The `func`
       * is invoked with the `this` binding of the memoized function.
       *
       * **Note:** The cache is exposed as the `cache` property on the memoized
       * function. Its creation may be customized by replacing the `_.memoize.Cache`
       * constructor with one whose instances implement the
       * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
       * method interface of `clear`, `delete`, `get`, `has`, and `set`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to have its output memoized.
       * @param {Function} [resolver] The function to resolve the cache key.
       * @returns {Function} Returns the new memoized function.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       * var other = { 'c': 3, 'd': 4 };
       *
       * var values = _.memoize(_.values);
       * values(object);
       * // => [1, 2]
       *
       * values(other);
       * // => [3, 4]
       *
       * object.a = 2;
       * values(object);
       * // => [1, 2]
       *
       * // Modify the result cache.
       * values.cache.set(object, ['a', 'b']);
       * values(object);
       * // => ['a', 'b']
       *
       * // Replace `_.memoize.Cache`.
       * _.memoize.Cache = WeakMap;
       */
      function memoize(func, resolver) {
        if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function () {
          var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }

      // Expose `MapCache`.
      memoize.Cache = MapCache;
      module.exports = memoize;

      /***/
    },

    /***/ 19474: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseMerge = __webpack_require__(59584),
        createAssigner = __webpack_require__(12317);

      /**
       * This method is like `_.assign` except that it recursively merges own and
       * inherited enumerable string keyed properties of source objects into the
       * destination object. Source properties that resolve to `undefined` are
       * skipped if a destination value exists. Array and plain object properties
       * are merged recursively. Other objects and value types are overridden by
       * assignment. Source objects are applied from left to right. Subsequent
       * sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {
       *   'a': [{ 'b': 2 }, { 'd': 4 }]
       * };
       *
       * var other = {
       *   'a': [{ 'c': 3 }, { 'e': 5 }]
       * };
       *
       * _.merge(object, other);
       * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
       */
      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      module.exports = merge;

      /***/
    },

    /***/ 18564: /***/ module => {
      /**
       * This method returns `undefined`.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Util
       * @example
       *
       * _.times(2, _.noop);
       * // => [undefined, undefined]
       */
      function noop() {
        // No operation performed.
      }
      module.exports = noop;

      /***/
    },

    /***/ 99518: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var root = __webpack_require__(75619);

      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */
      var now = function () {
        return root.Date.now();
      };
      module.exports = now;

      /***/
    },

    /***/ 64633: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var arrayMap = __webpack_require__(22654),
        baseClone = __webpack_require__(71649),
        baseUnset = __webpack_require__(2937),
        castPath = __webpack_require__(62323),
        copyObject = __webpack_require__(96945),
        customOmitClone = __webpack_require__(77292),
        flatRest = __webpack_require__(63126),
        getAllKeysIn = __webpack_require__(65279);

      /** Used to compose bitmasks for cloning. */
      var CLONE_DEEP_FLAG = 1,
        CLONE_FLAT_FLAG = 2,
        CLONE_SYMBOLS_FLAG = 4;

      /**
       * The opposite of `_.pick`; this method creates an object composed of the
       * own and inherited enumerable property paths of `object` that are not omitted.
       *
       * **Note:** This method is considerably slower than `_.pick`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to omit.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omit(object, ['a', 'c']);
       * // => { 'b': '2' }
       */
      var omit = flatRest(function (object, paths) {
        var result = {};
        if (object == null) {
          return result;
        }
        var isDeep = false;
        paths = arrayMap(paths, function (path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);
        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result, paths[length]);
        }
        return result;
      });
      module.exports = omit;

      /***/
    },

    /***/ 99351: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var createRange = __webpack_require__(52286);

      /**
       * Creates an array of numbers (positive and/or negative) progressing from
       * `start` up to, but not including, `end`. A step of `-1` is used if a negative
       * `start` is specified without an `end` or `step`. If `end` is not specified,
       * it's set to `start` with `start` then set to `0`.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.rangeRight
       * @example
       *
       * _.range(4);
       * // => [0, 1, 2, 3]
       *
       * _.range(-4);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 5);
       * // => [1, 2, 3, 4]
       *
       * _.range(0, 20, 5);
       * // => [0, 5, 10, 15]
       *
       * _.range(0, -4, -1);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.range(0);
       * // => []
       */
      var range = createRange();
      module.exports = range;

      /***/
    },

    /***/ 19170: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseSet = __webpack_require__(42612);

      /**
       * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
       * it's created. Arrays are created for missing index properties while objects
       * are created for all other missing properties. Use `_.setWith` to customize
       * `path` creation.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.set(object, 'a[0].b.c', 4);
       * console.log(object.a[0].b.c);
       * // => 4
       *
       * _.set(object, ['x', '0', 'y', 'z'], 5);
       * console.log(object.x[0].y.z);
       * // => 5
       */
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      module.exports = set;

      /***/
    },

    /***/ 94759: /***/ module => {
      /**
       * This method returns a new empty array.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Array} Returns the new empty array.
       * @example
       *
       * var arrays = _.times(2, _.stubArray);
       *
       * console.log(arrays);
       * // => [[], []]
       *
       * console.log(arrays[0] === arrays[1]);
       * // => false
       */
      function stubArray() {
        return [];
      }
      module.exports = stubArray;

      /***/
    },

    /***/ 55597: /***/ module => {
      /**
       * This method returns `false`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `false`.
       * @example
       *
       * _.times(2, _.stubFalse);
       * // => [false, false]
       */
      function stubFalse() {
        return false;
      }
      module.exports = stubFalse;

      /***/
    },

    /***/ 95134: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var toNumber = __webpack_require__(41888);

      /** Used as references for various `Number` constants. */
      var INFINITY = 1 / 0,
        MAX_INTEGER = 1.7976931348623157e308;

      /**
       * Converts `value` to a finite number.
       *
       * @static
       * @memberOf _
       * @since 4.12.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted number.
       * @example
       *
       * _.toFinite(3.2);
       * // => 3.2
       *
       * _.toFinite(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toFinite(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toFinite('3.2');
       * // => 3.2
       */
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      module.exports = toFinite;

      /***/
    },

    /***/ 20263: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var toFinite = __webpack_require__(95134);

      /**
       * Converts `value` to an integer.
       *
       * **Note:** This method is loosely based on
       * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toInteger(3.2);
       * // => 3
       *
       * _.toInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toInteger(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toInteger('3.2');
       * // => 3
       */
      function toInteger(value) {
        var result = toFinite(value),
          remainder = result % 1;
        return result === result ? (remainder ? result - remainder : result) : 0;
      }
      module.exports = toInteger;

      /***/
    },

    /***/ 41888: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseTrim = __webpack_require__(17406),
        isObject = __webpack_require__(3715),
        isSymbol = __webpack_require__(9924);

      /** Used as references for various `Number` constants. */
      var NAN = 0 / 0;

      /** Used to detect bad signed hexadecimal string values. */
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

      /** Used to detect binary string values. */
      var reIsBinary = /^0b[01]+$/i;

      /** Used to detect octal string values. */
      var reIsOctal = /^0o[0-7]+$/i;

      /** Built-in method references without a dependency on `root`. */
      var freeParseInt = parseInt;

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value)
          ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
          : reIsBadHex.test(value)
            ? NAN
            : +value;
      }
      module.exports = toNumber;

      /***/
    },

    /***/ 43082: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var copyObject = __webpack_require__(96945),
        keysIn = __webpack_require__(83735);

      /**
       * Converts `value` to a plain object flattening inherited enumerable string
       * keyed properties of `value` to own properties of the plain object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Object} Returns the converted plain object.
       * @example
       *
       * function Foo() {
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.assign({ 'a': 1 }, new Foo);
       * // => { 'a': 1, 'b': 2 }
       *
       * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
       * // => { 'a': 1, 'b': 2, 'c': 3 }
       */
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      module.exports = toPlainObject;

      /***/
    },

    /***/ 96004: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseToString = __webpack_require__(12258);

      /**
       * Converts `value` to a string. An empty string is returned for `null`
       * and `undefined` values. The sign of `-0` is preserved.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.toString(null);
       * // => ''
       *
       * _.toString(-0);
       * // => '-0'
       *
       * _.toString([1, 2, 3]);
       * // => '1,2,3'
       */
      function toString(value) {
        return value == null ? '' : baseToString(value);
      }
      module.exports = toString;

      /***/
    },

    /***/ 70406: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var toString = __webpack_require__(96004);

      /** Used to generate unique IDs. */
      var idCounter = 0;

      /**
       * Generates a unique ID. If `prefix` is given, the ID is appended to it.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {string} [prefix=''] The value to prefix the ID with.
       * @returns {string} Returns the unique ID.
       * @example
       *
       * _.uniqueId('contact_');
       * // => 'contact_104'
       *
       * _.uniqueId();
       * // => '105'
       */
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }
      module.exports = uniqueId;

      /***/
    },

    /***/ 5570: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var baseValues = __webpack_require__(73292),
        keys = __webpack_require__(45000);

      /**
       * Creates an array of the own enumerable string keyed property values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.values(new Foo);
       * // => [1, 2] (iteration order is not guaranteed)
       *
       * _.values('hi');
       * // => ['h', 'i']
       */
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      module.exports = values;

      /***/
    },

    /***/ 43243: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      var asciiWords = __webpack_require__(25983),
        hasUnicodeWord = __webpack_require__(51856),
        toString = __webpack_require__(96004),
        unicodeWords = __webpack_require__(51095);

      /**
       * Splits `string` into an array of its words.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {RegExp|string} [pattern] The pattern to match words.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the words of `string`.
       * @example
       *
       * _.words('fred, barney, & pebbles');
       * // => ['fred', 'barney', 'pebbles']
       *
       * _.words('fred, barney, & pebbles', /[^, ]+/g);
       * // => ['fred', 'barney', '&', 'pebbles']
       */
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined : pattern;
        if (pattern === undefined) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      module.exports = words;

      /***/
    },

    /***/ 17466: /***/ module => {
      'use strict';
      /*
					  object-assign
					  (c) Sindre Sorhus
					  @license MIT
					  */

      /* eslint-disable no-unused-vars */
      function _extends() {
        return (
          (_extends = Object.assign
            ? Object.assign.bind()
            : function (n) {
                for (var e = 1; e < arguments.length; e++) {
                  var t = arguments[e];
                  for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
                }
                return n;
              }),
          _extends.apply(null, arguments)
        );
      }
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;
      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }
        return Object(val);
      }
      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }

          // Detect buggy property enumeration order in older V8 versions.

          // https://bugs.chromium.org/p/v8/issues/detail?id=4118
          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
          test1[5] = 'de';
          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });
          if (order2.join('') !== '0123456789') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });
          if (Object.keys(_extends({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
            return false;
          }
          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }
      module.exports = shouldUseNative()
        ? Object.assign
        : function (target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for (var s = 1; s < arguments.length; s++) {
              from = Object(arguments[s]);
              for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                  to[key] = from[key];
                }
              }
              if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (var i = 0; i < symbols.length; i++) {
                  if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                  }
                }
              }
            }
            return to;
          };

      /***/
    },

    /***/ 74836: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var ReactPropTypesSecret = __webpack_require__(25059);
      function emptyFunction() {}
      function emptyFunctionWithReset() {}
      emptyFunctionWithReset.resetWarningCache = emptyFunction;
      module.exports = function () {
        function shim(props, propName, componentName, location, propFullName, secret) {
          if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
          }
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use PropTypes.checkPropTypes() to call them. ' +
              'Read more at http://fb.me/use-check-prop-types',
          );
          err.name = 'Invariant Violation';
          throw err;
        }
        shim.isRequired = shim;
        function getShim() {
          return shim;
        }
        // Important!
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
          array: shim,
          bigint: shim,
          bool: shim,
          func: shim,
          number: shim,
          object: shim,
          string: shim,
          symbol: shim,
          any: shim,
          arrayOf: getShim,
          element: shim,
          elementType: shim,
          instanceOf: getShim,
          node: shim,
          objectOf: getShim,
          oneOf: getShim,
          oneOfType: getShim,
          shape: getShim,
          exact: getShim,
          checkPropTypes: emptyFunctionWithReset,
          resetWarningCache: emptyFunction,
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
      };

      /***/
    },

    /***/ 39970: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      if (false) {
        var throwOnDirectAccess, ReactIs;
      } else {
        // By explicitly using `prop-types` you are opting into new production behavior.
        // http://fb.me/prop-types-in-prod
        module.exports = __webpack_require__(74836)();
      }

      /***/
    },

    /***/ 25059: /***/ module => {
      'use strict';
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
      module.exports = ReactPropTypesSecret;

      /***/
    },

    /***/ 43165: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      var strictUriEncode = __webpack_require__(12010);
      var objectAssign = __webpack_require__(17466);
      var decodeComponent = __webpack_require__(6224);
      function encoderForArrayFormat(opts) {
        switch (opts.arrayFormat) {
          case 'index':
            return function (key, value, index) {
              return value === null
                ? [encode(key, opts), '[', index, ']'].join('')
                : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
            };
          case 'bracket':
            return function (key, value) {
              return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
            };
          default:
            return function (key, value) {
              return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
            };
        }
      }
      function parserForArrayFormat(opts) {
        var result;
        switch (opts.arrayFormat) {
          case 'index':
            return function (key, value, accumulator) {
              result = /\[(\d*)\]$/.exec(key);
              key = key.replace(/\[\d*\]$/, '');
              if (!result) {
                accumulator[key] = value;
                return;
              }
              if (accumulator[key] === undefined) {
                accumulator[key] = {};
              }
              accumulator[key][result[1]] = value;
            };
          case 'bracket':
            return function (key, value, accumulator) {
              result = /(\[\])$/.exec(key);
              key = key.replace(/\[\]$/, '');
              if (!result) {
                accumulator[key] = value;
                return;
              } else if (accumulator[key] === undefined) {
                accumulator[key] = [value];
                return;
              }
              accumulator[key] = [].concat(accumulator[key], value);
            };
          default:
            return function (key, value, accumulator) {
              if (accumulator[key] === undefined) {
                accumulator[key] = value;
                return;
              }
              accumulator[key] = [].concat(accumulator[key], value);
            };
        }
      }
      function encode(value, opts) {
        if (opts.encode) {
          return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
        }
        return value;
      }
      function keysSorter(input) {
        if (Array.isArray(input)) {
          return input.sort();
        } else if (typeof input === 'object') {
          return keysSorter(Object.keys(input))
            .sort(function (a, b) {
              return Number(a) - Number(b);
            })
            .map(function (key) {
              return input[key];
            });
        }
        return input;
      }
      function extract(str) {
        var queryStart = str.indexOf('?');
        if (queryStart === -1) {
          return '';
        }
        return str.slice(queryStart + 1);
      }
      function parse(str, opts) {
        opts = objectAssign(
          {
            arrayFormat: 'none',
          },
          opts,
        );
        var formatter = parserForArrayFormat(opts);

        // Create an object with no prototype
        // https://github.com/sindresorhus/query-string/issues/47
        var ret = Object.create(null);
        if (typeof str !== 'string') {
          return ret;
        }
        str = str.trim().replace(/^[?#&]/, '');
        if (!str) {
          return ret;
        }
        str.split('&').forEach(function (param) {
          var parts = param.replace(/\+/g, ' ').split('=');
          // Firefox (pre 40) decodes `%3D` to `=`
          // https://github.com/sindresorhus/query-string/pull/37
          var key = parts.shift();
          var val = parts.length > 0 ? parts.join('=') : undefined;

          // missing `=` should be `null`:
          // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
          val = val === undefined ? null : decodeComponent(val);
          formatter(decodeComponent(key), val, ret);
        });
        return Object.keys(ret)
          .sort()
          .reduce(function (result, key) {
            var val = ret[key];
            if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
              // Sort object keys, not values
              result[key] = keysSorter(val);
            } else {
              result[key] = val;
            }
            return result;
          }, Object.create(null));
      }
      exports.extract = extract;
      exports.parse = parse;
      exports.stringify = function (obj, opts) {
        var defaults = {
          encode: true,
          strict: true,
          arrayFormat: 'none',
        };
        opts = objectAssign(defaults, opts);
        if (opts.sort === false) {
          opts.sort = function () {};
        }
        var formatter = encoderForArrayFormat(opts);
        return obj
          ? Object.keys(obj)
              .sort(opts.sort)
              .map(function (key) {
                var val = obj[key];
                if (val === undefined) {
                  return '';
                }
                if (val === null) {
                  return encode(key, opts);
                }
                if (Array.isArray(val)) {
                  var result = [];
                  val.slice().forEach(function (val2) {
                    if (val2 === undefined) {
                      return;
                    }
                    result.push(formatter(key, val2, result.length));
                  });
                  return result.join('&');
                }
                return encode(key, opts) + '=' + encode(val, opts);
              })
              .filter(function (x) {
                return x.length > 0;
              })
              .join('&')
          : '';
      };
      exports.parseUrl = function (str, opts) {
        return {
          url: str.split('?')[0] || '',
          query: parse(extract(str), opts),
        };
      };

      /***/
    },

    /***/ 50213: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';
      /**
       * @license React
       * react-dom.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      /*
					   Modernizr 3.0.0pre (Custom Build) | MIT
					  */

      var aa = __webpack_require__(1986),
        ca = __webpack_require__(46304);
      function p(a) {
        for (var b = 'https://reactjs.org/docs/error-decoder.html?invariant=' + a, c = 1; c < arguments.length; c++)
          b += '&args[]=' + encodeURIComponent(arguments[c]);
        return (
          'Minified React error #' +
          a +
          '; visit ' +
          b +
          ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
        );
      }
      var da = new Set(),
        ea = {};
      function fa(a, b) {
        ha(a, b);
        ha(a + 'Capture', b);
      }
      function ha(a, b) {
        ea[a] = b;
        for (a = 0; a < b.length; a++) da.add(b[a]);
      }
      var ia = !(
          'undefined' === typeof window ||
          'undefined' === typeof window.document ||
          'undefined' === typeof window.document.createElement
        ),
        ja = Object.prototype.hasOwnProperty,
        ka =
          /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
        la = {},
        ma = {};
      function oa(a) {
        if (ja.call(ma, a)) return !0;
        if (ja.call(la, a)) return !1;
        if (ka.test(a)) return (ma[a] = !0);
        la[a] = !0;
        return !1;
      }
      function pa(a, b, c, d) {
        if (null !== c && 0 === c.type) return !1;
        switch (typeof b) {
          case 'function':
          case 'symbol':
            return !0;
          case 'boolean':
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return 'data-' !== a && 'aria-' !== a;
          default:
            return !1;
        }
      }
      function qa(a, b, c, d) {
        if (null === b || 'undefined' === typeof b || pa(a, b, c, d)) return !0;
        if (d) return !1;
        if (null !== c)
          switch (c.type) {
            case 3:
              return !b;
            case 4:
              return !1 === b;
            case 5:
              return isNaN(b);
            case 6:
              return isNaN(b) || 1 > b;
          }
        return !1;
      }
      function v(a, b, c, d, e, f, g) {
        this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
        this.attributeName = d;
        this.attributeNamespace = e;
        this.mustUseProperty = c;
        this.propertyName = a;
        this.type = b;
        this.sanitizeURL = f;
        this.removeEmptyString = g;
      }
      var z = {};
      'children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style'
        .split(' ')
        .forEach(function (a) {
          z[a] = new v(a, 0, !1, a, null, !1, !1);
        });
      [
        ['acceptCharset', 'accept-charset'],
        ['className', 'class'],
        ['htmlFor', 'for'],
        ['httpEquiv', 'http-equiv'],
      ].forEach(function (a) {
        var b = a[0];
        z[b] = new v(b, 1, !1, a[1], null, !1, !1);
      });
      ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (a) {
        z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
      });
      ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (a) {
        z[a] = new v(a, 2, !1, a, null, !1, !1);
      });
      'allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope'
        .split(' ')
        .forEach(function (a) {
          z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
        });
      ['checked', 'multiple', 'muted', 'selected'].forEach(function (a) {
        z[a] = new v(a, 3, !0, a, null, !1, !1);
      });
      ['capture', 'download'].forEach(function (a) {
        z[a] = new v(a, 4, !1, a, null, !1, !1);
      });
      ['cols', 'rows', 'size', 'span'].forEach(function (a) {
        z[a] = new v(a, 6, !1, a, null, !1, !1);
      });
      ['rowSpan', 'start'].forEach(function (a) {
        z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
      });
      var ra = /[\-:]([a-z])/g;
      function sa(a) {
        return a[1].toUpperCase();
      }
      'accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height'
        .split(' ')
        .forEach(function (a) {
          var b = a.replace(ra, sa);
          z[b] = new v(b, 1, !1, a, null, !1, !1);
        });
      'xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type'.split(' ').forEach(function (a) {
        var b = a.replace(ra, sa);
        z[b] = new v(b, 1, !1, a, 'http://www.w3.org/1999/xlink', !1, !1);
      });
      ['xml:base', 'xml:lang', 'xml:space'].forEach(function (a) {
        var b = a.replace(ra, sa);
        z[b] = new v(b, 1, !1, a, 'http://www.w3.org/XML/1998/namespace', !1, !1);
      });
      ['tabIndex', 'crossOrigin'].forEach(function (a) {
        z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
      });
      z.xlinkHref = new v('xlinkHref', 1, !1, 'xlink:href', 'http://www.w3.org/1999/xlink', !0, !1);
      ['src', 'href', 'action', 'formAction'].forEach(function (a) {
        z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
      });
      function ta(a, b, c, d) {
        var e = z.hasOwnProperty(b) ? z[b] : null;
        if (
          null !== e
            ? 0 !== e.type
            : d || !(2 < b.length) || ('o' !== b[0] && 'O' !== b[0]) || ('n' !== b[1] && 'N' !== b[1])
        )
          qa(b, c, e, d) && (c = null),
            d || null === e
              ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, '' + c))
              : e.mustUseProperty
                ? (a[e.propertyName] = null === c ? (3 === e.type ? !1 : '') : c)
                : ((b = e.attributeName),
                  (d = e.attributeNamespace),
                  null === c
                    ? a.removeAttribute(b)
                    : ((e = e.type),
                      (c = 3 === e || (4 === e && !0 === c) ? '' : '' + c),
                      d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
      }
      var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
        va = Symbol.for('react.element'),
        wa = Symbol.for('react.portal'),
        ya = Symbol.for('react.fragment'),
        za = Symbol.for('react.strict_mode'),
        Aa = Symbol.for('react.profiler'),
        Ba = Symbol.for('react.provider'),
        Ca = Symbol.for('react.context'),
        Da = Symbol.for('react.forward_ref'),
        Ea = Symbol.for('react.suspense'),
        Fa = Symbol.for('react.suspense_list'),
        Ga = Symbol.for('react.memo'),
        Ha = Symbol.for('react.lazy');
      Symbol.for('react.scope');
      Symbol.for('react.debug_trace_mode');
      var Ia = Symbol.for('react.offscreen');
      Symbol.for('react.legacy_hidden');
      Symbol.for('react.cache');
      Symbol.for('react.tracing_marker');
      var Ja = Symbol.iterator;
      function Ka(a) {
        if (null === a || 'object' !== typeof a) return null;
        a = (Ja && a[Ja]) || a['@@iterator'];
        return 'function' === typeof a ? a : null;
      }
      var A = Object.assign,
        La;
      function Ma(a) {
        if (void 0 === La)
          try {
            throw Error();
          } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            La = (b && b[1]) || '';
          }
        return '\n' + La + a;
      }
      var Na = !1;
      function Oa(a, b) {
        if (!a || Na) return '';
        Na = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
          if (b) {
            if (
              ((b = function () {
                throw Error();
              }),
              Object.defineProperty(b.prototype, 'props', {
                set: function () {
                  throw Error();
                },
              }),
              'object' === typeof Reflect && Reflect.construct)
            ) {
              try {
                Reflect.construct(b, []);
              } catch (l) {
                var d = l;
              }
              Reflect.construct(a, [], b);
            } else {
              try {
                b.call();
              } catch (l) {
                d = l;
              }
              a.call(b.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (l) {
              d = l;
            }
            a();
          }
        } catch (l) {
          if (l && d && 'string' === typeof l.stack) {
            for (
              var e = l.stack.split('\n'), f = d.stack.split('\n'), g = e.length - 1, h = f.length - 1;
              1 <= g && 0 <= h && e[g] !== f[h];

            )
              h--;
            for (; 1 <= g && 0 <= h; g--, h--)
              if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                  do
                    if ((g--, h--, 0 > h || e[g] !== f[h])) {
                      var k = '\n' + e[g].replace(' at new ', ' at ');
                      a.displayName && k.includes('<anonymous>') && (k = k.replace('<anonymous>', a.displayName));
                      return k;
                    }
                  while (1 <= g && 0 <= h);
                }
                break;
              }
          }
        } finally {
          (Na = !1), (Error.prepareStackTrace = c);
        }
        return (a = a ? a.displayName || a.name : '') ? Ma(a) : '';
      }
      function Pa(a) {
        switch (a.tag) {
          case 5:
            return Ma(a.type);
          case 16:
            return Ma('Lazy');
          case 13:
            return Ma('Suspense');
          case 19:
            return Ma('SuspenseList');
          case 0:
          case 2:
          case 15:
            return (a = Oa(a.type, !1)), a;
          case 11:
            return (a = Oa(a.type.render, !1)), a;
          case 1:
            return (a = Oa(a.type, !0)), a;
          default:
            return '';
        }
      }
      function Qa(a) {
        if (null == a) return null;
        if ('function' === typeof a) return a.displayName || a.name || null;
        if ('string' === typeof a) return a;
        switch (a) {
          case ya:
            return 'Fragment';
          case wa:
            return 'Portal';
          case Aa:
            return 'Profiler';
          case za:
            return 'StrictMode';
          case Ea:
            return 'Suspense';
          case Fa:
            return 'SuspenseList';
        }
        if ('object' === typeof a)
          switch (a.$$typeof) {
            case Ca:
              return (a.displayName || 'Context') + '.Consumer';
            case Ba:
              return (a._context.displayName || 'Context') + '.Provider';
            case Da:
              var b = a.render;
              a = a.displayName;
              a || ((a = b.displayName || b.name || ''), (a = '' !== a ? 'ForwardRef(' + a + ')' : 'ForwardRef'));
              return a;
            case Ga:
              return (b = a.displayName || null), null !== b ? b : Qa(a.type) || 'Memo';
            case Ha:
              b = a._payload;
              a = a._init;
              try {
                return Qa(a(b));
              } catch (c) {}
          }
        return null;
      }
      function Ra(a) {
        var b = a.type;
        switch (a.tag) {
          case 24:
            return 'Cache';
          case 9:
            return (b.displayName || 'Context') + '.Consumer';
          case 10:
            return (b._context.displayName || 'Context') + '.Provider';
          case 18:
            return 'DehydratedFragment';
          case 11:
            return (
              (a = b.render),
              (a = a.displayName || a.name || ''),
              b.displayName || ('' !== a ? 'ForwardRef(' + a + ')' : 'ForwardRef')
            );
          case 7:
            return 'Fragment';
          case 5:
            return b;
          case 4:
            return 'Portal';
          case 3:
            return 'Root';
          case 6:
            return 'Text';
          case 16:
            return Qa(b);
          case 8:
            return b === za ? 'StrictMode' : 'Mode';
          case 22:
            return 'Offscreen';
          case 12:
            return 'Profiler';
          case 21:
            return 'Scope';
          case 13:
            return 'Suspense';
          case 19:
            return 'SuspenseList';
          case 25:
            return 'TracingMarker';
          case 1:
          case 0:
          case 17:
          case 2:
          case 14:
          case 15:
            if ('function' === typeof b) return b.displayName || b.name || null;
            if ('string' === typeof b) return b;
        }
        return null;
      }
      function Sa(a) {
        switch (typeof a) {
          case 'boolean':
          case 'number':
          case 'string':
          case 'undefined':
            return a;
          case 'object':
            return a;
          default:
            return '';
        }
      }
      function Ta(a) {
        var b = a.type;
        return (a = a.nodeName) && 'input' === a.toLowerCase() && ('checkbox' === b || 'radio' === b);
      }
      function Ua(a) {
        var b = Ta(a) ? 'checked' : 'value',
          c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
          d = '' + a[b];
        if (
          !a.hasOwnProperty(b) &&
          'undefined' !== typeof c &&
          'function' === typeof c.get &&
          'function' === typeof c.set
        ) {
          var e = c.get,
            f = c.set;
          Object.defineProperty(a, b, {
            configurable: !0,
            get: function () {
              return e.call(this);
            },
            set: function (a) {
              d = '' + a;
              f.call(this, a);
            },
          });
          Object.defineProperty(a, b, {
            enumerable: c.enumerable,
          });
          return {
            getValue: function () {
              return d;
            },
            setValue: function (a) {
              d = '' + a;
            },
            stopTracking: function () {
              a._valueTracker = null;
              delete a[b];
            },
          };
        }
      }
      function Va(a) {
        a._valueTracker || (a._valueTracker = Ua(a));
      }
      function Wa(a) {
        if (!a) return !1;
        var b = a._valueTracker;
        if (!b) return !0;
        var c = b.getValue();
        var d = '';
        a && (d = Ta(a) ? (a.checked ? 'true' : 'false') : a.value);
        a = d;
        return a !== c ? (b.setValue(a), !0) : !1;
      }
      function Xa(a) {
        a = a || ('undefined' !== typeof document ? document : void 0);
        if ('undefined' === typeof a) return null;
        try {
          return a.activeElement || a.body;
        } catch (b) {
          return a.body;
        }
      }
      function Ya(a, b) {
        var c = b.checked;
        return A({}, b, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: null != c ? c : a._wrapperState.initialChecked,
        });
      }
      function Za(a, b) {
        var c = null == b.defaultValue ? '' : b.defaultValue,
          d = null != b.checked ? b.checked : b.defaultChecked;
        c = Sa(null != b.value ? b.value : c);
        a._wrapperState = {
          initialChecked: d,
          initialValue: c,
          controlled: 'checkbox' === b.type || 'radio' === b.type ? null != b.checked : null != b.value,
        };
      }
      function ab(a, b) {
        b = b.checked;
        null != b && ta(a, 'checked', b, !1);
      }
      function bb(a, b) {
        ab(a, b);
        var c = Sa(b.value),
          d = b.type;
        if (null != c) {
          if ('number' === d) {
            if ((0 === c && '' === a.value) || a.value != c) a.value = '' + c;
          } else a.value !== '' + c && (a.value = '' + c);
        } else if ('submit' === d || 'reset' === d) {
          a.removeAttribute('value');
          return;
        }
        b.hasOwnProperty('value')
          ? cb(a, b.type, c)
          : b.hasOwnProperty('defaultValue') && cb(a, b.type, Sa(b.defaultValue));
        null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
      }
      function db(a, b, c) {
        if (b.hasOwnProperty('value') || b.hasOwnProperty('defaultValue')) {
          var d = b.type;
          if (!(('submit' !== d && 'reset' !== d) || (void 0 !== b.value && null !== b.value))) return;
          b = '' + a._wrapperState.initialValue;
          c || b === a.value || (a.value = b);
          a.defaultValue = b;
        }
        c = a.name;
        '' !== c && (a.name = '');
        a.defaultChecked = !!a._wrapperState.initialChecked;
        '' !== c && (a.name = c);
      }
      function cb(a, b, c) {
        if ('number' !== b || Xa(a.ownerDocument) !== a)
          null == c
            ? (a.defaultValue = '' + a._wrapperState.initialValue)
            : a.defaultValue !== '' + c && (a.defaultValue = '' + c);
      }
      var eb = Array.isArray;
      function fb(a, b, c, d) {
        a = a.options;
        if (b) {
          b = {};
          for (var e = 0; e < c.length; e++) b['$' + c[e]] = !0;
          for (c = 0; c < a.length; c++)
            (e = b.hasOwnProperty('$' + a[c].value)),
              a[c].selected !== e && (a[c].selected = e),
              e && d && (a[c].defaultSelected = !0);
        } else {
          c = '' + Sa(c);
          b = null;
          for (e = 0; e < a.length; e++) {
            if (a[e].value === c) {
              a[e].selected = !0;
              d && (a[e].defaultSelected = !0);
              return;
            }
            null !== b || a[e].disabled || (b = a[e]);
          }
          null !== b && (b.selected = !0);
        }
      }
      function gb(a, b) {
        if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
        return A({}, b, {
          value: void 0,
          defaultValue: void 0,
          children: '' + a._wrapperState.initialValue,
        });
      }
      function hb(a, b) {
        var c = b.value;
        if (null == c) {
          c = b.children;
          b = b.defaultValue;
          if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
              if (1 < c.length) throw Error(p(93));
              c = c[0];
            }
            b = c;
          }
          null == b && (b = '');
          c = b;
        }
        a._wrapperState = {
          initialValue: Sa(c),
        };
      }
      function ib(a, b) {
        var c = Sa(b.value),
          d = Sa(b.defaultValue);
        null != c &&
          ((c = '' + c),
          c !== a.value && (a.value = c),
          null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
        null != d && (a.defaultValue = '' + d);
      }
      function jb(a) {
        var b = a.textContent;
        b === a._wrapperState.initialValue && '' !== b && null !== b && (a.value = b);
      }
      function kb(a) {
        switch (a) {
          case 'svg':
            return 'http://www.w3.org/2000/svg';
          case 'math':
            return 'http://www.w3.org/1998/Math/MathML';
          default:
            return 'http://www.w3.org/1999/xhtml';
        }
      }
      function lb(a, b) {
        return null == a || 'http://www.w3.org/1999/xhtml' === a
          ? kb(b)
          : 'http://www.w3.org/2000/svg' === a && 'foreignObject' === b
            ? 'http://www.w3.org/1999/xhtml'
            : a;
      }
      var mb,
        nb = (function (a) {
          return 'undefined' !== typeof MSApp && MSApp.execUnsafeLocalFunction
            ? function (b, c, d, e) {
                MSApp.execUnsafeLocalFunction(function () {
                  return a(b, c, d, e);
                });
              }
            : a;
        })(function (a, b) {
          if ('http://www.w3.org/2000/svg' !== a.namespaceURI || 'innerHTML' in a) a.innerHTML = b;
          else {
            mb = mb || document.createElement('div');
            mb.innerHTML = '<svg>' + b.valueOf().toString() + '</svg>';
            for (b = mb.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
            for (; b.firstChild; ) a.appendChild(b.firstChild);
          }
        });
      function ob(a, b) {
        if (b) {
          var c = a.firstChild;
          if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
          }
        }
        a.textContent = b;
      }
      var pb = {
          animationIterationCount: !0,
          aspectRatio: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridArea: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0,
        },
        qb = ['Webkit', 'ms', 'Moz', 'O'];
      Object.keys(pb).forEach(function (a) {
        qb.forEach(function (b) {
          b = b + a.charAt(0).toUpperCase() + a.substring(1);
          pb[b] = pb[a];
        });
      });
      function rb(a, b, c) {
        return null == b || 'boolean' === typeof b || '' === b
          ? ''
          : c || 'number' !== typeof b || 0 === b || (pb.hasOwnProperty(a) && pb[a])
            ? ('' + b).trim()
            : b + 'px';
      }
      function sb(a, b) {
        a = a.style;
        for (var c in b)
          if (b.hasOwnProperty(c)) {
            var d = 0 === c.indexOf('--'),
              e = rb(c, b[c], d);
            'float' === c && (c = 'cssFloat');
            d ? a.setProperty(c, e) : (a[c] = e);
          }
      }
      var tb = A(
        {
          menuitem: !0,
        },
        {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0,
        },
      );
      function ub(a, b) {
        if (b) {
          if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
          if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ('object' !== typeof b.dangerouslySetInnerHTML || !('__html' in b.dangerouslySetInnerHTML))
              throw Error(p(61));
          }
          if (null != b.style && 'object' !== typeof b.style) throw Error(p(62));
        }
      }
      function vb(a, b) {
        if (-1 === a.indexOf('-')) return 'string' === typeof b.is;
        switch (a) {
          case 'annotation-xml':
          case 'color-profile':
          case 'font-face':
          case 'font-face-src':
          case 'font-face-uri':
          case 'font-face-format':
          case 'font-face-name':
          case 'missing-glyph':
            return !1;
          default:
            return !0;
        }
      }
      var wb = null;
      function xb(a) {
        a = a.target || a.srcElement || window;
        a.correspondingUseElement && (a = a.correspondingUseElement);
        return 3 === a.nodeType ? a.parentNode : a;
      }
      var yb = null,
        zb = null,
        Ab = null;
      function Bb(a) {
        if ((a = Cb(a))) {
          if ('function' !== typeof yb) throw Error(p(280));
          var b = a.stateNode;
          b && ((b = Db(b)), yb(a.stateNode, a.type, b));
        }
      }
      function Eb(a) {
        zb ? (Ab ? Ab.push(a) : (Ab = [a])) : (zb = a);
      }
      function Fb() {
        if (zb) {
          var a = zb,
            b = Ab;
          Ab = zb = null;
          Bb(a);
          if (b) for (a = 0; a < b.length; a++) Bb(b[a]);
        }
      }
      function Gb(a, b) {
        return a(b);
      }
      function Hb() {}
      var Ib = !1;
      function Jb(a, b, c) {
        if (Ib) return a(b, c);
        Ib = !0;
        try {
          return Gb(a, b, c);
        } finally {
          if (((Ib = !1), null !== zb || null !== Ab)) Hb(), Fb();
        }
      }
      function Kb(a, b) {
        var c = a.stateNode;
        if (null === c) return null;
        var d = Db(c);
        if (null === d) return null;
        c = d[b];
        a: switch (b) {
          case 'onClick':
          case 'onClickCapture':
          case 'onDoubleClick':
          case 'onDoubleClickCapture':
          case 'onMouseDown':
          case 'onMouseDownCapture':
          case 'onMouseMove':
          case 'onMouseMoveCapture':
          case 'onMouseUp':
          case 'onMouseUpCapture':
          case 'onMouseEnter':
            (d = !d.disabled) ||
              ((a = a.type), (d = !('button' === a || 'input' === a || 'select' === a || 'textarea' === a)));
            a = !d;
            break a;
          default:
            a = !1;
        }
        if (a) return null;
        if (c && 'function' !== typeof c) throw Error(p(231, b, typeof c));
        return c;
      }
      var Lb = !1;
      if (ia)
        try {
          var Mb = {};
          Object.defineProperty(Mb, 'passive', {
            get: function () {
              Lb = !0;
            },
          });
          window.addEventListener('test', Mb, Mb);
          window.removeEventListener('test', Mb, Mb);
        } catch (a) {
          Lb = !1;
        }
      function Nb(a, b, c, d, e, f, g, h, k) {
        var l = Array.prototype.slice.call(arguments, 3);
        try {
          b.apply(c, l);
        } catch (m) {
          this.onError(m);
        }
      }
      var Ob = !1,
        Pb = null,
        Qb = !1,
        Rb = null,
        Sb = {
          onError: function (a) {
            Ob = !0;
            Pb = a;
          },
        };
      function Tb(a, b, c, d, e, f, g, h, k) {
        Ob = !1;
        Pb = null;
        Nb.apply(Sb, arguments);
      }
      function Ub(a, b, c, d, e, f, g, h, k) {
        Tb.apply(this, arguments);
        if (Ob) {
          if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
          } else throw Error(p(198));
          Qb || ((Qb = !0), (Rb = l));
        }
      }
      function Vb(a) {
        var b = a,
          c = a;
        if (a.alternate) for (; b.return; ) b = b.return;
        else {
          a = b;
          do (b = a), 0 !== (b.flags & 4098) && (c = b.return), (a = b.return);
          while (a);
        }
        return 3 === b.tag ? c : null;
      }
      function Wb(a) {
        if (13 === a.tag) {
          var b = a.memoizedState;
          null === b && ((a = a.alternate), null !== a && (b = a.memoizedState));
          if (null !== b) return b.dehydrated;
        }
        return null;
      }
      function Xb(a) {
        if (Vb(a) !== a) throw Error(p(188));
      }
      function Yb(a) {
        var b = a.alternate;
        if (!b) {
          b = Vb(a);
          if (null === b) throw Error(p(188));
          return b !== a ? null : a;
        }
        for (var c = a, d = b; ; ) {
          var e = c.return;
          if (null === e) break;
          var f = e.alternate;
          if (null === f) {
            d = e.return;
            if (null !== d) {
              c = d;
              continue;
            }
            break;
          }
          if (e.child === f.child) {
            for (f = e.child; f; ) {
              if (f === c) return Xb(e), a;
              if (f === d) return Xb(e), b;
              f = f.sibling;
            }
            throw Error(p(188));
          }
          if (c.return !== d.return) (c = e), (d = f);
          else {
            for (var g = !1, h = e.child; h; ) {
              if (h === c) {
                g = !0;
                c = e;
                d = f;
                break;
              }
              if (h === d) {
                g = !0;
                d = e;
                c = f;
                break;
              }
              h = h.sibling;
            }
            if (!g) {
              for (h = f.child; h; ) {
                if (h === c) {
                  g = !0;
                  c = f;
                  d = e;
                  break;
                }
                if (h === d) {
                  g = !0;
                  d = f;
                  c = e;
                  break;
                }
                h = h.sibling;
              }
              if (!g) throw Error(p(189));
            }
          }
          if (c.alternate !== d) throw Error(p(190));
        }
        if (3 !== c.tag) throw Error(p(188));
        return c.stateNode.current === c ? a : b;
      }
      function Zb(a) {
        a = Yb(a);
        return null !== a ? $b(a) : null;
      }
      function $b(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for (a = a.child; null !== a; ) {
          var b = $b(a);
          if (null !== b) return b;
          a = a.sibling;
        }
        return null;
      }
      var ac = ca.unstable_scheduleCallback,
        bc = ca.unstable_cancelCallback,
        cc = ca.unstable_shouldYield,
        dc = ca.unstable_requestPaint,
        B = ca.unstable_now,
        ec = ca.unstable_getCurrentPriorityLevel,
        fc = ca.unstable_ImmediatePriority,
        gc = ca.unstable_UserBlockingPriority,
        hc = ca.unstable_NormalPriority,
        ic = ca.unstable_LowPriority,
        jc = ca.unstable_IdlePriority,
        kc = null,
        lc = null;
      function mc(a) {
        if (lc && 'function' === typeof lc.onCommitFiberRoot)
          try {
            lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
          } catch (b) {}
      }
      var oc = Math.clz32 ? Math.clz32 : nc,
        pc = Math.log,
        qc = Math.LN2;
      function nc(a) {
        a >>>= 0;
        return 0 === a ? 32 : (31 - ((pc(a) / qc) | 0)) | 0;
      }
      var rc = 64,
        sc = 4194304;
      function tc(a) {
        switch (a & -a) {
          case 1:
            return 1;
          case 2:
            return 2;
          case 4:
            return 4;
          case 8:
            return 8;
          case 16:
            return 16;
          case 32:
            return 32;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
            return a & 4194240;
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            return a & 130023424;
          case 134217728:
            return 134217728;
          case 268435456:
            return 268435456;
          case 536870912:
            return 536870912;
          case 1073741824:
            return 1073741824;
          default:
            return a;
        }
      }
      function uc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0,
          e = a.suspendedLanes,
          f = a.pingedLanes,
          g = c & 268435455;
        if (0 !== g) {
          var h = g & ~e;
          0 !== h ? (d = tc(h)) : ((f &= g), 0 !== f && (d = tc(f)));
        } else (g = c & ~e), 0 !== g ? (d = tc(g)) : 0 !== f && (d = tc(f));
        if (0 === d) return 0;
        if (
          0 !== b &&
          b !== d &&
          0 === (b & e) &&
          ((e = d & -d), (f = b & -b), e >= f || (16 === e && 0 !== (f & 4194240)))
        )
          return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for (a = a.entanglements, b &= d; 0 < b; ) (c = 31 - oc(b)), (e = 1 << c), (d |= a[c]), (b &= ~e);
        return d;
      }
      function vc(a, b) {
        switch (a) {
          case 1:
          case 2:
          case 4:
            return b + 250;
          case 8:
          case 16:
          case 32:
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
            return b + 5e3;
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            return -1;
          case 134217728:
          case 268435456:
          case 536870912:
          case 1073741824:
            return -1;
          default:
            return -1;
        }
      }
      function wc(a, b) {
        for (var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f; ) {
          var g = 31 - oc(f),
            h = 1 << g,
            k = e[g];
          if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
          } else k <= b && (a.expiredLanes |= h);
          f &= ~h;
        }
      }
      function xc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
      }
      function yc() {
        var a = rc;
        rc <<= 1;
        0 === (rc & 4194240) && (rc = 64);
        return a;
      }
      function zc(a) {
        for (var b = [], c = 0; 31 > c; c++) b.push(a);
        return b;
      }
      function Ac(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && ((a.suspendedLanes = 0), (a.pingedLanes = 0));
        a = a.eventTimes;
        b = 31 - oc(b);
        a[b] = c;
      }
      function Bc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for (a = a.expirationTimes; 0 < c; ) {
          var e = 31 - oc(c),
            f = 1 << e;
          b[e] = 0;
          d[e] = -1;
          a[e] = -1;
          c &= ~f;
        }
      }
      function Cc(a, b) {
        var c = (a.entangledLanes |= b);
        for (a = a.entanglements; c; ) {
          var d = 31 - oc(c),
            e = 1 << d;
          (e & b) | (a[d] & b) && (a[d] |= b);
          c &= ~e;
        }
      }
      var C = 0;
      function Dc(a) {
        a &= -a;
        return 1 < a ? (4 < a ? (0 !== (a & 268435455) ? 16 : 536870912) : 4) : 1;
      }
      var Ec,
        Fc,
        Gc,
        Hc,
        Ic,
        Jc = !1,
        Kc = [],
        Lc = null,
        Mc = null,
        Nc = null,
        Oc = new Map(),
        Pc = new Map(),
        Qc = [],
        Rc =
          'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit'.split(
            ' ',
          );
      function Sc(a, b) {
        switch (a) {
          case 'focusin':
          case 'focusout':
            Lc = null;
            break;
          case 'dragenter':
          case 'dragleave':
            Mc = null;
            break;
          case 'mouseover':
          case 'mouseout':
            Nc = null;
            break;
          case 'pointerover':
          case 'pointerout':
            Oc.delete(b.pointerId);
            break;
          case 'gotpointercapture':
          case 'lostpointercapture':
            Pc.delete(b.pointerId);
        }
      }
      function Tc(a, b, c, d, e, f) {
        if (null === a || a.nativeEvent !== f)
          return (
            (a = {
              blockedOn: b,
              domEventName: c,
              eventSystemFlags: d,
              nativeEvent: f,
              targetContainers: [e],
            }),
            null !== b && ((b = Cb(b)), null !== b && Fc(b)),
            a
          );
        a.eventSystemFlags |= d;
        b = a.targetContainers;
        null !== e && -1 === b.indexOf(e) && b.push(e);
        return a;
      }
      function Uc(a, b, c, d, e) {
        switch (b) {
          case 'focusin':
            return (Lc = Tc(Lc, a, b, c, d, e)), !0;
          case 'dragenter':
            return (Mc = Tc(Mc, a, b, c, d, e)), !0;
          case 'mouseover':
            return (Nc = Tc(Nc, a, b, c, d, e)), !0;
          case 'pointerover':
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
          case 'gotpointercapture':
            return (f = e.pointerId), Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
        }
        return !1;
      }
      function Vc(a) {
        var b = Wc(a.target);
        if (null !== b) {
          var c = Vb(b);
          if (null !== c)
            if (((b = c.tag), 13 === b)) {
              if (((b = Wb(c)), null !== b)) {
                a.blockedOn = b;
                Ic(a.priority, function () {
                  Gc(c);
                });
                return;
              }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
              a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
              return;
            }
        }
        a.blockedOn = null;
      }
      function Xc(a) {
        if (null !== a.blockedOn) return !1;
        for (var b = a.targetContainers; 0 < b.length; ) {
          var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
          if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
          } else return (b = Cb(c)), null !== b && Fc(b), (a.blockedOn = c), !1;
          b.shift();
        }
        return !0;
      }
      function Zc(a, b, c) {
        Xc(a) && c.delete(b);
      }
      function $c() {
        Jc = !1;
        null !== Lc && Xc(Lc) && (Lc = null);
        null !== Mc && Xc(Mc) && (Mc = null);
        null !== Nc && Xc(Nc) && (Nc = null);
        Oc.forEach(Zc);
        Pc.forEach(Zc);
      }
      function ad(a, b) {
        a.blockedOn === b &&
          ((a.blockedOn = null), Jc || ((Jc = !0), ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
      }
      function bd(a) {
        function b(b) {
          return ad(b, a);
        }
        if (0 < Kc.length) {
          ad(Kc[0], a);
          for (var c = 1; c < Kc.length; c++) {
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
          }
        }
        null !== Lc && ad(Lc, a);
        null !== Mc && ad(Mc, a);
        null !== Nc && ad(Nc, a);
        Oc.forEach(b);
        Pc.forEach(b);
        for (c = 0; c < Qc.length; c++) (d = Qc[c]), d.blockedOn === a && (d.blockedOn = null);
        for (; 0 < Qc.length && ((c = Qc[0]), null === c.blockedOn); ) Vc(c), null === c.blockedOn && Qc.shift();
      }
      var cd = ua.ReactCurrentBatchConfig,
        dd = !0;
      function ed(a, b, c, d) {
        var e = C,
          f = cd.transition;
        cd.transition = null;
        try {
          (C = 1), fd(a, b, c, d);
        } finally {
          (C = e), (cd.transition = f);
        }
      }
      function gd(a, b, c, d) {
        var e = C,
          f = cd.transition;
        cd.transition = null;
        try {
          (C = 4), fd(a, b, c, d);
        } finally {
          (C = e), (cd.transition = f);
        }
      }
      function fd(a, b, c, d) {
        if (dd) {
          var e = Yc(a, b, c, d);
          if (null === e) hd(a, b, d, id, c), Sc(a, d);
          else if (Uc(e, a, b, c, d)) d.stopPropagation();
          else if ((Sc(a, d), b & 4 && -1 < Rc.indexOf(a))) {
            for (; null !== e; ) {
              var f = Cb(e);
              null !== f && Ec(f);
              f = Yc(a, b, c, d);
              null === f && hd(a, b, d, id, c);
              if (f === e) break;
              e = f;
            }
            null !== e && d.stopPropagation();
          } else hd(a, b, d, null, c);
        }
      }
      var id = null;
      function Yc(a, b, c, d) {
        id = null;
        a = xb(d);
        a = Wc(a);
        if (null !== a)
          if (((b = Vb(a)), null === b)) a = null;
          else if (((c = b.tag), 13 === c)) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
          } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
          } else b !== a && (a = null);
        id = a;
        return null;
      }
      function jd(a) {
        switch (a) {
          case 'cancel':
          case 'click':
          case 'close':
          case 'contextmenu':
          case 'copy':
          case 'cut':
          case 'auxclick':
          case 'dblclick':
          case 'dragend':
          case 'dragstart':
          case 'drop':
          case 'focusin':
          case 'focusout':
          case 'input':
          case 'invalid':
          case 'keydown':
          case 'keypress':
          case 'keyup':
          case 'mousedown':
          case 'mouseup':
          case 'paste':
          case 'pause':
          case 'play':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointerup':
          case 'ratechange':
          case 'reset':
          case 'resize':
          case 'seeked':
          case 'submit':
          case 'touchcancel':
          case 'touchend':
          case 'touchstart':
          case 'volumechange':
          case 'change':
          case 'selectionchange':
          case 'textInput':
          case 'compositionstart':
          case 'compositionend':
          case 'compositionupdate':
          case 'beforeblur':
          case 'afterblur':
          case 'beforeinput':
          case 'blur':
          case 'fullscreenchange':
          case 'focus':
          case 'hashchange':
          case 'popstate':
          case 'select':
          case 'selectstart':
            return 1;
          case 'drag':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'mousemove':
          case 'mouseout':
          case 'mouseover':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'scroll':
          case 'toggle':
          case 'touchmove':
          case 'wheel':
          case 'mouseenter':
          case 'mouseleave':
          case 'pointerenter':
          case 'pointerleave':
            return 4;
          case 'message':
            switch (ec()) {
              case fc:
                return 1;
              case gc:
                return 4;
              case hc:
              case ic:
                return 16;
              case jc:
                return 536870912;
              default:
                return 16;
            }
          default:
            return 16;
        }
      }
      var kd = null,
        ld = null,
        md = null;
      function nd() {
        if (md) return md;
        var a,
          b = ld,
          c = b.length,
          d,
          e = 'value' in kd ? kd.value : kd.textContent,
          f = e.length;
        for (a = 0; a < c && b[a] === e[a]; a++);
        var g = c - a;
        for (d = 1; d <= g && b[c - d] === e[f - d]; d++);
        return (md = e.slice(a, 1 < d ? 1 - d : void 0));
      }
      function od(a) {
        var b = a.keyCode;
        'charCode' in a ? ((a = a.charCode), 0 === a && 13 === b && (a = 13)) : (a = b);
        10 === a && (a = 13);
        return 32 <= a || 13 === a ? a : 0;
      }
      function pd() {
        return !0;
      }
      function qd() {
        return !1;
      }
      function rd(a) {
        function b(b, d, e, f, g) {
          this._reactName = b;
          this._targetInst = e;
          this.type = d;
          this.nativeEvent = f;
          this.target = g;
          this.currentTarget = null;
          for (var c in a) a.hasOwnProperty(c) && ((b = a[c]), (this[c] = b ? b(f) : f[c]));
          this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
          this.isPropagationStopped = qd;
          return this;
        }
        A(b.prototype, {
          preventDefault: function () {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a &&
              (a.preventDefault ? a.preventDefault() : 'unknown' !== typeof a.returnValue && (a.returnValue = !1),
              (this.isDefaultPrevented = pd));
          },
          stopPropagation: function () {
            var a = this.nativeEvent;
            a &&
              (a.stopPropagation ? a.stopPropagation() : 'unknown' !== typeof a.cancelBubble && (a.cancelBubble = !0),
              (this.isPropagationStopped = pd));
          },
          persist: function () {},
          isPersistent: pd,
        });
        return b;
      }
      var sd = {
          eventPhase: 0,
          bubbles: 0,
          cancelable: 0,
          timeStamp: function (a) {
            return a.timeStamp || Date.now();
          },
          defaultPrevented: 0,
          isTrusted: 0,
        },
        td = rd(sd),
        ud = A({}, sd, {
          view: 0,
          detail: 0,
        }),
        vd = rd(ud),
        wd,
        xd,
        yd,
        Ad = A({}, ud, {
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          pageX: 0,
          pageY: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          getModifierState: zd,
          button: 0,
          buttons: 0,
          relatedTarget: function (a) {
            return void 0 === a.relatedTarget
              ? a.fromElement === a.srcElement
                ? a.toElement
                : a.fromElement
              : a.relatedTarget;
          },
          movementX: function (a) {
            if ('movementX' in a) return a.movementX;
            a !== yd &&
              (yd && 'mousemove' === a.type
                ? ((wd = a.screenX - yd.screenX), (xd = a.screenY - yd.screenY))
                : (xd = wd = 0),
              (yd = a));
            return wd;
          },
          movementY: function (a) {
            return 'movementY' in a ? a.movementY : xd;
          },
        }),
        Bd = rd(Ad),
        Cd = A({}, Ad, {
          dataTransfer: 0,
        }),
        Dd = rd(Cd),
        Ed = A({}, ud, {
          relatedTarget: 0,
        }),
        Fd = rd(Ed),
        Gd = A({}, sd, {
          animationName: 0,
          elapsedTime: 0,
          pseudoElement: 0,
        }),
        Hd = rd(Gd),
        Id = A({}, sd, {
          clipboardData: function (a) {
            return 'clipboardData' in a ? a.clipboardData : window.clipboardData;
          },
        }),
        Jd = rd(Id),
        Kd = A({}, sd, {
          data: 0,
        }),
        Ld = rd(Kd),
        Md = {
          Esc: 'Escape',
          Spacebar: ' ',
          Left: 'ArrowLeft',
          Up: 'ArrowUp',
          Right: 'ArrowRight',
          Down: 'ArrowDown',
          Del: 'Delete',
          Win: 'OS',
          Menu: 'ContextMenu',
          Apps: 'ContextMenu',
          Scroll: 'ScrollLock',
          MozPrintableKey: 'Unidentified',
        },
        Nd = {
          8: 'Backspace',
          9: 'Tab',
          12: 'Clear',
          13: 'Enter',
          16: 'Shift',
          17: 'Control',
          18: 'Alt',
          19: 'Pause',
          20: 'CapsLock',
          27: 'Escape',
          32: ' ',
          33: 'PageUp',
          34: 'PageDown',
          35: 'End',
          36: 'Home',
          37: 'ArrowLeft',
          38: 'ArrowUp',
          39: 'ArrowRight',
          40: 'ArrowDown',
          45: 'Insert',
          46: 'Delete',
          112: 'F1',
          113: 'F2',
          114: 'F3',
          115: 'F4',
          116: 'F5',
          117: 'F6',
          118: 'F7',
          119: 'F8',
          120: 'F9',
          121: 'F10',
          122: 'F11',
          123: 'F12',
          144: 'NumLock',
          145: 'ScrollLock',
          224: 'Meta',
        },
        Od = {
          Alt: 'altKey',
          Control: 'ctrlKey',
          Meta: 'metaKey',
          Shift: 'shiftKey',
        };
      function Pd(a) {
        var b = this.nativeEvent;
        return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
      }
      function zd() {
        return Pd;
      }
      var Qd = A({}, ud, {
          key: function (a) {
            if (a.key) {
              var b = Md[a.key] || a.key;
              if ('Unidentified' !== b) return b;
            }
            return 'keypress' === a.type
              ? ((a = od(a)), 13 === a ? 'Enter' : String.fromCharCode(a))
              : 'keydown' === a.type || 'keyup' === a.type
                ? Nd[a.keyCode] || 'Unidentified'
                : '';
          },
          code: 0,
          location: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          repeat: 0,
          locale: 0,
          getModifierState: zd,
          charCode: function (a) {
            return 'keypress' === a.type ? od(a) : 0;
          },
          keyCode: function (a) {
            return 'keydown' === a.type || 'keyup' === a.type ? a.keyCode : 0;
          },
          which: function (a) {
            return 'keypress' === a.type ? od(a) : 'keydown' === a.type || 'keyup' === a.type ? a.keyCode : 0;
          },
        }),
        Rd = rd(Qd),
        Sd = A({}, Ad, {
          pointerId: 0,
          width: 0,
          height: 0,
          pressure: 0,
          tangentialPressure: 0,
          tiltX: 0,
          tiltY: 0,
          twist: 0,
          pointerType: 0,
          isPrimary: 0,
        }),
        Td = rd(Sd),
        Ud = A({}, ud, {
          touches: 0,
          targetTouches: 0,
          changedTouches: 0,
          altKey: 0,
          metaKey: 0,
          ctrlKey: 0,
          shiftKey: 0,
          getModifierState: zd,
        }),
        Vd = rd(Ud),
        Wd = A({}, sd, {
          propertyName: 0,
          elapsedTime: 0,
          pseudoElement: 0,
        }),
        Xd = rd(Wd),
        Yd = A({}, Ad, {
          deltaX: function (a) {
            return 'deltaX' in a ? a.deltaX : 'wheelDeltaX' in a ? -a.wheelDeltaX : 0;
          },
          deltaY: function (a) {
            return 'deltaY' in a
              ? a.deltaY
              : 'wheelDeltaY' in a
                ? -a.wheelDeltaY
                : 'wheelDelta' in a
                  ? -a.wheelDelta
                  : 0;
          },
          deltaZ: 0,
          deltaMode: 0,
        }),
        Zd = rd(Yd),
        $d = [9, 13, 27, 32],
        ae = ia && 'CompositionEvent' in window,
        be = null;
      ia && 'documentMode' in document && (be = document.documentMode);
      var ce = ia && 'TextEvent' in window && !be,
        de = ia && (!ae || (be && 8 < be && 11 >= be)),
        ee = String.fromCharCode(32),
        fe = !1;
      function ge(a, b) {
        switch (a) {
          case 'keyup':
            return -1 !== $d.indexOf(b.keyCode);
          case 'keydown':
            return 229 !== b.keyCode;
          case 'keypress':
          case 'mousedown':
          case 'focusout':
            return !0;
          default:
            return !1;
        }
      }
      function he(a) {
        a = a.detail;
        return 'object' === typeof a && 'data' in a ? a.data : null;
      }
      var ie = !1;
      function je(a, b) {
        switch (a) {
          case 'compositionend':
            return he(b);
          case 'keypress':
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
          case 'textInput':
            return (a = b.data), a === ee && fe ? null : a;
          default:
            return null;
        }
      }
      function ke(a, b) {
        if (ie)
          return 'compositionend' === a || (!ae && ge(a, b)) ? ((a = nd()), (md = ld = kd = null), (ie = !1), a) : null;
        switch (a) {
          case 'paste':
            return null;
          case 'keypress':
            if (!(b.ctrlKey || b.altKey || b.metaKey) || (b.ctrlKey && b.altKey)) {
              if (b.char && 1 < b.char.length) return b.char;
              if (b.which) return String.fromCharCode(b.which);
            }
            return null;
          case 'compositionend':
            return de && 'ko' !== b.locale ? null : b.data;
          default:
            return null;
        }
      }
      var le = {
        color: !0,
        date: !0,
        datetime: !0,
        'datetime-local': !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0,
      };
      function me(a) {
        var b = a && a.nodeName && a.nodeName.toLowerCase();
        return 'input' === b ? !!le[a.type] : 'textarea' === b ? !0 : !1;
      }
      function ne(a, b, c, d) {
        Eb(d);
        b = oe(b, 'onChange');
        0 < b.length &&
          ((c = new td('onChange', 'change', null, c, d)),
          a.push({
            event: c,
            listeners: b,
          }));
      }
      var pe = null,
        qe = null;
      function re(a) {
        se(a, 0);
      }
      function te(a) {
        var b = ue(a);
        if (Wa(b)) return a;
      }
      function ve(a, b) {
        if ('change' === a) return b;
      }
      var we = !1;
      if (ia) {
        var xe;
        if (ia) {
          var ye = 'oninput' in document;
          if (!ye) {
            var ze = document.createElement('div');
            ze.setAttribute('oninput', 'return;');
            ye = 'function' === typeof ze.oninput;
          }
          xe = ye;
        } else xe = !1;
        we = xe && (!document.documentMode || 9 < document.documentMode);
      }
      function Ae() {
        pe && (pe.detachEvent('onpropertychange', Be), (qe = pe = null));
      }
      function Be(a) {
        if ('value' === a.propertyName && te(qe)) {
          var b = [];
          ne(b, qe, a, xb(a));
          Jb(re, b);
        }
      }
      function Ce(a, b, c) {
        'focusin' === a ? (Ae(), (pe = b), (qe = c), pe.attachEvent('onpropertychange', Be)) : 'focusout' === a && Ae();
      }
      function De(a) {
        if ('selectionchange' === a || 'keyup' === a || 'keydown' === a) return te(qe);
      }
      function Ee(a, b) {
        if ('click' === a) return te(b);
      }
      function Fe(a, b) {
        if ('input' === a || 'change' === a) return te(b);
      }
      function Ge(a, b) {
        return (a === b && (0 !== a || 1 / a === 1 / b)) || (a !== a && b !== b);
      }
      var He = 'function' === typeof Object.is ? Object.is : Ge;
      function Ie(a, b) {
        if (He(a, b)) return !0;
        if ('object' !== typeof a || null === a || 'object' !== typeof b || null === b) return !1;
        var c = Object.keys(a),
          d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for (d = 0; d < c.length; d++) {
          var e = c[d];
          if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
        }
        return !0;
      }
      function Je(a) {
        for (; a && a.firstChild; ) a = a.firstChild;
        return a;
      }
      function Ke(a, b) {
        var c = Je(a);
        a = 0;
        for (var d; c; ) {
          if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b)
              return {
                node: c,
                offset: b - a,
              };
            a = d;
          }
          a: {
            for (; c; ) {
              if (c.nextSibling) {
                c = c.nextSibling;
                break a;
              }
              c = c.parentNode;
            }
            c = void 0;
          }
          c = Je(c);
        }
      }
      function Le(a, b) {
        return a && b
          ? a === b
            ? !0
            : a && 3 === a.nodeType
              ? !1
              : b && 3 === b.nodeType
                ? Le(a, b.parentNode)
                : 'contains' in a
                  ? a.contains(b)
                  : a.compareDocumentPosition
                    ? !!(a.compareDocumentPosition(b) & 16)
                    : !1
          : !1;
      }
      function Me() {
        for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement; ) {
          try {
            var c = 'string' === typeof b.contentWindow.location.href;
          } catch (d) {
            c = !1;
          }
          if (c) a = b.contentWindow;
          else break;
          b = Xa(a.document);
        }
        return b;
      }
      function Ne(a) {
        var b = a && a.nodeName && a.nodeName.toLowerCase();
        return (
          b &&
          (('input' === b &&
            ('text' === a.type ||
              'search' === a.type ||
              'tel' === a.type ||
              'url' === a.type ||
              'password' === a.type)) ||
            'textarea' === b ||
            'true' === a.contentEditable)
        );
      }
      function Oe(a) {
        var b = Me(),
          c = a.focusedElem,
          d = a.selectionRange;
        if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
          if (null !== d && Ne(c))
            if (((b = d.start), (a = d.end), void 0 === a && (a = b), 'selectionStart' in c))
              (c.selectionStart = b), (c.selectionEnd = Math.min(a, c.value.length));
            else if (((a = ((b = c.ownerDocument || document) && b.defaultView) || window), a.getSelection)) {
              a = a.getSelection();
              var e = c.textContent.length,
                f = Math.min(d.start, e);
              d = void 0 === d.end ? f : Math.min(d.end, e);
              !a.extend && f > d && ((e = d), (d = f), (f = e));
              e = Ke(c, f);
              var g = Ke(c, d);
              e &&
                g &&
                (1 !== a.rangeCount ||
                  a.anchorNode !== e.node ||
                  a.anchorOffset !== e.offset ||
                  a.focusNode !== g.node ||
                  a.focusOffset !== g.offset) &&
                ((b = b.createRange()),
                b.setStart(e.node, e.offset),
                a.removeAllRanges(),
                f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
          b = [];
          for (a = c; (a = a.parentNode); )
            1 === a.nodeType &&
              b.push({
                element: a,
                left: a.scrollLeft,
                top: a.scrollTop,
              });
          'function' === typeof c.focus && c.focus();
          for (c = 0; c < b.length; c++) (a = b[c]), (a.element.scrollLeft = a.left), (a.element.scrollTop = a.top);
        }
      }
      var Pe = ia && 'documentMode' in document && 11 >= document.documentMode,
        Qe = null,
        Re = null,
        Se = null,
        Te = !1;
      function Ue(a, b, c) {
        var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
        Te ||
          null == Qe ||
          Qe !== Xa(d) ||
          ((d = Qe),
          'selectionStart' in d && Ne(d)
            ? (d = {
                start: d.selectionStart,
                end: d.selectionEnd,
              })
            : ((d = ((d.ownerDocument && d.ownerDocument.defaultView) || window).getSelection()),
              (d = {
                anchorNode: d.anchorNode,
                anchorOffset: d.anchorOffset,
                focusNode: d.focusNode,
                focusOffset: d.focusOffset,
              })),
          (Se && Ie(Se, d)) ||
            ((Se = d),
            (d = oe(Re, 'onSelect')),
            0 < d.length &&
              ((b = new td('onSelect', 'select', null, b, c)),
              a.push({
                event: b,
                listeners: d,
              }),
              (b.target = Qe))));
      }
      function Ve(a, b) {
        var c = {};
        c[a.toLowerCase()] = b.toLowerCase();
        c['Webkit' + a] = 'webkit' + b;
        c['Moz' + a] = 'moz' + b;
        return c;
      }
      var We = {
          animationend: Ve('Animation', 'AnimationEnd'),
          animationiteration: Ve('Animation', 'AnimationIteration'),
          animationstart: Ve('Animation', 'AnimationStart'),
          transitionend: Ve('Transition', 'TransitionEnd'),
        },
        Xe = {},
        Ye = {};
      ia &&
        ((Ye = document.createElement('div').style),
        'AnimationEvent' in window ||
          (delete We.animationend.animation,
          delete We.animationiteration.animation,
          delete We.animationstart.animation),
        'TransitionEvent' in window || delete We.transitionend.transition);
      function Ze(a) {
        if (Xe[a]) return Xe[a];
        if (!We[a]) return a;
        var b = We[a],
          c;
        for (c in b) if (b.hasOwnProperty(c) && c in Ye) return (Xe[a] = b[c]);
        return a;
      }
      var $e = Ze('animationend'),
        af = Ze('animationiteration'),
        bf = Ze('animationstart'),
        cf = Ze('transitionend'),
        df = new Map(),
        ef =
          'abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
            ' ',
          );
      function ff(a, b) {
        df.set(a, b);
        fa(b, [a]);
      }
      for (var gf = 0; gf < ef.length; gf++) {
        var hf = ef[gf],
          jf = hf.toLowerCase(),
          kf = hf[0].toUpperCase() + hf.slice(1);
        ff(jf, 'on' + kf);
      }
      ff($e, 'onAnimationEnd');
      ff(af, 'onAnimationIteration');
      ff(bf, 'onAnimationStart');
      ff('dblclick', 'onDoubleClick');
      ff('focusin', 'onFocus');
      ff('focusout', 'onBlur');
      ff(cf, 'onTransitionEnd');
      ha('onMouseEnter', ['mouseout', 'mouseover']);
      ha('onMouseLeave', ['mouseout', 'mouseover']);
      ha('onPointerEnter', ['pointerout', 'pointerover']);
      ha('onPointerLeave', ['pointerout', 'pointerover']);
      fa('onChange', 'change click focusin focusout input keydown keyup selectionchange'.split(' '));
      fa('onSelect', 'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(' '));
      fa('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
      fa('onCompositionEnd', 'compositionend focusout keydown keypress keyup mousedown'.split(' '));
      fa('onCompositionStart', 'compositionstart focusout keydown keypress keyup mousedown'.split(' '));
      fa('onCompositionUpdate', 'compositionupdate focusout keydown keypress keyup mousedown'.split(' '));
      var lf =
          'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
            ' ',
          ),
        mf = new Set('cancel close invalid load scroll toggle'.split(' ').concat(lf));
      function nf(a, b, c) {
        var d = a.type || 'unknown-event';
        a.currentTarget = c;
        Ub(d, b, void 0, a);
        a.currentTarget = null;
      }
      function se(a, b) {
        b = 0 !== (b & 4);
        for (var c = 0; c < a.length; c++) {
          var d = a[c],
            e = d.event;
          d = d.listeners;
          a: {
            var f = void 0;
            if (b)
              for (var g = d.length - 1; 0 <= g; g--) {
                var h = d[g],
                  k = h.instance,
                  l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
              }
            else
              for (g = 0; g < d.length; g++) {
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
              }
          }
        }
        if (Qb) throw ((a = Rb), (Qb = !1), (Rb = null), a);
      }
      function D(a, b) {
        var c = b[of];
        void 0 === c && (c = b[of] = new Set());
        var d = a + '__bubble';
        c.has(d) || (pf(b, a, 2, !1), c.add(d));
      }
      function qf(a, b, c) {
        var d = 0;
        b && (d |= 4);
        pf(c, a, d, b);
      }
      var rf = '_reactListening' + Math.random().toString(36).slice(2);
      function sf(a) {
        if (!a[rf]) {
          a[rf] = !0;
          da.forEach(function (b) {
            'selectionchange' !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
          });
          var b = 9 === a.nodeType ? a : a.ownerDocument;
          null === b || b[rf] || ((b[rf] = !0), qf('selectionchange', !1, b));
        }
      }
      function pf(a, b, c, d) {
        switch (jd(b)) {
          case 1:
            var e = ed;
            break;
          case 4:
            e = gd;
            break;
          default:
            e = fd;
        }
        c = e.bind(null, b, c, a);
        e = void 0;
        !Lb || ('touchstart' !== b && 'touchmove' !== b && 'wheel' !== b) || (e = !0);
        d
          ? void 0 !== e
            ? a.addEventListener(b, c, {
                capture: !0,
                passive: e,
              })
            : a.addEventListener(b, c, !0)
          : void 0 !== e
            ? a.addEventListener(b, c, {
                passive: e,
              })
            : a.addEventListener(b, c, !1);
      }
      function hd(a, b, c, d, e) {
        var f = d;
        if (0 === (b & 1) && 0 === (b & 2) && null !== d)
          a: for (;;) {
            if (null === d) return;
            var g = d.tag;
            if (3 === g || 4 === g) {
              var h = d.stateNode.containerInfo;
              if (h === e || (8 === h.nodeType && h.parentNode === e)) break;
              if (4 === g)
                for (g = d.return; null !== g; ) {
                  var k = g.tag;
                  if (3 === k || 4 === k)
                    if (((k = g.stateNode.containerInfo), k === e || (8 === k.nodeType && k.parentNode === e))) return;
                  g = g.return;
                }
              for (; null !== h; ) {
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                  d = f = g;
                  continue a;
                }
                h = h.parentNode;
              }
            }
            d = d.return;
          }
        Jb(function () {
          var d = f,
            e = xb(c),
            g = [];
          a: {
            var h = df.get(a);
            if (void 0 !== h) {
              var k = td,
                n = a;
              switch (a) {
                case 'keypress':
                  if (0 === od(c)) break a;
                case 'keydown':
                case 'keyup':
                  k = Rd;
                  break;
                case 'focusin':
                  n = 'focus';
                  k = Fd;
                  break;
                case 'focusout':
                  n = 'blur';
                  k = Fd;
                  break;
                case 'beforeblur':
                case 'afterblur':
                  k = Fd;
                  break;
                case 'click':
                  if (2 === c.button) break a;
                case 'auxclick':
                case 'dblclick':
                case 'mousedown':
                case 'mousemove':
                case 'mouseup':
                case 'mouseout':
                case 'mouseover':
                case 'contextmenu':
                  k = Bd;
                  break;
                case 'drag':
                case 'dragend':
                case 'dragenter':
                case 'dragexit':
                case 'dragleave':
                case 'dragover':
                case 'dragstart':
                case 'drop':
                  k = Dd;
                  break;
                case 'touchcancel':
                case 'touchend':
                case 'touchmove':
                case 'touchstart':
                  k = Vd;
                  break;
                case $e:
                case af:
                case bf:
                  k = Hd;
                  break;
                case cf:
                  k = Xd;
                  break;
                case 'scroll':
                  k = vd;
                  break;
                case 'wheel':
                  k = Zd;
                  break;
                case 'copy':
                case 'cut':
                case 'paste':
                  k = Jd;
                  break;
                case 'gotpointercapture':
                case 'lostpointercapture':
                case 'pointercancel':
                case 'pointerdown':
                case 'pointermove':
                case 'pointerout':
                case 'pointerover':
                case 'pointerup':
                  k = Td;
              }
              var t = 0 !== (b & 4),
                J = !t && 'scroll' === a,
                x = t ? (null !== h ? h + 'Capture' : null) : h;
              t = [];
              for (var w = d, u; null !== w; ) {
                u = w;
                var F = u.stateNode;
                5 === u.tag &&
                  null !== F &&
                  ((u = F), null !== x && ((F = Kb(w, x)), null != F && t.push(tf(w, F, u))));
                if (J) break;
                w = w.return;
              }
              0 < t.length &&
                ((h = new k(h, n, null, c, e)),
                g.push({
                  event: h,
                  listeners: t,
                }));
            }
          }
          if (0 === (b & 7)) {
            a: {
              h = 'mouseover' === a || 'pointerover' === a;
              k = 'mouseout' === a || 'pointerout' === a;
              if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
              if (k || h) {
                h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                if (k) {
                  if (
                    ((n = c.relatedTarget || c.toElement),
                    (k = d),
                    (n = n ? Wc(n) : null),
                    null !== n && ((J = Vb(n)), n !== J || (5 !== n.tag && 6 !== n.tag)))
                  )
                    n = null;
                } else (k = null), (n = d);
                if (k !== n) {
                  t = Bd;
                  F = 'onMouseLeave';
                  x = 'onMouseEnter';
                  w = 'mouse';
                  if ('pointerout' === a || 'pointerover' === a)
                    (t = Td), (F = 'onPointerLeave'), (x = 'onPointerEnter'), (w = 'pointer');
                  J = null == k ? h : ue(k);
                  u = null == n ? h : ue(n);
                  h = new t(F, w + 'leave', k, c, e);
                  h.target = J;
                  h.relatedTarget = u;
                  F = null;
                  Wc(e) === d && ((t = new t(x, w + 'enter', n, c, e)), (t.target = u), (t.relatedTarget = J), (F = t));
                  J = F;
                  if (k && n)
                    b: {
                      t = k;
                      x = n;
                      w = 0;
                      for (u = t; u; u = vf(u)) w++;
                      u = 0;
                      for (F = x; F; F = vf(F)) u++;
                      for (; 0 < w - u; ) (t = vf(t)), w--;
                      for (; 0 < u - w; ) (x = vf(x)), u--;
                      for (; w--; ) {
                        if (t === x || (null !== x && t === x.alternate)) break b;
                        t = vf(t);
                        x = vf(x);
                      }
                      t = null;
                    }
                  else t = null;
                  null !== k && wf(g, h, k, t, !1);
                  null !== n && null !== J && wf(g, J, n, t, !0);
                }
              }
            }
            a: {
              h = d ? ue(d) : window;
              k = h.nodeName && h.nodeName.toLowerCase();
              if ('select' === k || ('input' === k && 'file' === h.type)) var na = ve;
              else if (me(h)) {
                if (we) na = Fe;
                else {
                  na = De;
                  var xa = Ce;
                }
              } else
                (k = h.nodeName) &&
                  'input' === k.toLowerCase() &&
                  ('checkbox' === h.type || 'radio' === h.type) &&
                  (na = Ee);
              if (na && (na = na(a, d))) {
                ne(g, na, c, e);
                break a;
              }
              xa && xa(a, h, d);
              'focusout' === a &&
                (xa = h._wrapperState) &&
                xa.controlled &&
                'number' === h.type &&
                cb(h, 'number', h.value);
            }
            xa = d ? ue(d) : window;
            switch (a) {
              case 'focusin':
                if (me(xa) || 'true' === xa.contentEditable) (Qe = xa), (Re = d), (Se = null);
                break;
              case 'focusout':
                Se = Re = Qe = null;
                break;
              case 'mousedown':
                Te = !0;
                break;
              case 'contextmenu':
              case 'mouseup':
              case 'dragend':
                Te = !1;
                Ue(g, c, e);
                break;
              case 'selectionchange':
                if (Pe) break;
              case 'keydown':
              case 'keyup':
                Ue(g, c, e);
            }
            var $a;
            if (ae)
              b: {
                switch (a) {
                  case 'compositionstart':
                    var ba = 'onCompositionStart';
                    break b;
                  case 'compositionend':
                    ba = 'onCompositionEnd';
                    break b;
                  case 'compositionupdate':
                    ba = 'onCompositionUpdate';
                    break b;
                }
                ba = void 0;
              }
            else
              ie
                ? ge(a, c) && (ba = 'onCompositionEnd')
                : 'keydown' === a && 229 === c.keyCode && (ba = 'onCompositionStart');
            ba &&
              (de &&
                'ko' !== c.locale &&
                (ie || 'onCompositionStart' !== ba
                  ? 'onCompositionEnd' === ba && ie && ($a = nd())
                  : ((kd = e), (ld = 'value' in kd ? kd.value : kd.textContent), (ie = !0))),
              (xa = oe(d, ba)),
              0 < xa.length &&
                ((ba = new Ld(ba, a, null, c, e)),
                g.push({
                  event: ba,
                  listeners: xa,
                }),
                $a ? (ba.data = $a) : (($a = he(c)), null !== $a && (ba.data = $a))));
            if (($a = ce ? je(a, c) : ke(a, c)))
              (d = oe(d, 'onBeforeInput')),
                0 < d.length &&
                  ((e = new Ld('onBeforeInput', 'beforeinput', null, c, e)),
                  g.push({
                    event: e,
                    listeners: d,
                  }),
                  (e.data = $a));
          }
          se(g, b);
        });
      }
      function tf(a, b, c) {
        return {
          instance: a,
          listener: b,
          currentTarget: c,
        };
      }
      function oe(a, b) {
        for (var c = b + 'Capture', d = []; null !== a; ) {
          var e = a,
            f = e.stateNode;
          5 === e.tag &&
            null !== f &&
            ((e = f),
            (f = Kb(a, c)),
            null != f && d.unshift(tf(a, f, e)),
            (f = Kb(a, b)),
            null != f && d.push(tf(a, f, e)));
          a = a.return;
        }
        return d;
      }
      function vf(a) {
        if (null === a) return null;
        do a = a.return;
        while (a && 5 !== a.tag);
        return a ? a : null;
      }
      function wf(a, b, c, d, e) {
        for (var f = b._reactName, g = []; null !== c && c !== d; ) {
          var h = c,
            k = h.alternate,
            l = h.stateNode;
          if (null !== k && k === d) break;
          5 === h.tag &&
            null !== l &&
            ((h = l),
            e
              ? ((k = Kb(c, f)), null != k && g.unshift(tf(c, k, h)))
              : e || ((k = Kb(c, f)), null != k && g.push(tf(c, k, h))));
          c = c.return;
        }
        0 !== g.length &&
          a.push({
            event: b,
            listeners: g,
          });
      }
      var xf = /\r\n?/g,
        yf = /\u0000|\uFFFD/g;
      function zf(a) {
        return ('string' === typeof a ? a : '' + a).replace(xf, '\n').replace(yf, '');
      }
      function Af(a, b, c) {
        b = zf(b);
        if (zf(a) !== b && c) throw Error(p(425));
      }
      function Bf() {}
      var Cf = null,
        Df = null;
      function Ef(a, b) {
        return (
          'textarea' === a ||
          'noscript' === a ||
          'string' === typeof b.children ||
          'number' === typeof b.children ||
          ('object' === typeof b.dangerouslySetInnerHTML &&
            null !== b.dangerouslySetInnerHTML &&
            null != b.dangerouslySetInnerHTML.__html)
        );
      }
      var Ff = 'function' === typeof setTimeout ? setTimeout : void 0,
        Gf = 'function' === typeof clearTimeout ? clearTimeout : void 0,
        Hf = 'function' === typeof Promise ? Promise : void 0,
        Jf =
          'function' === typeof queueMicrotask
            ? queueMicrotask
            : 'undefined' !== typeof Hf
              ? function (a) {
                  return Hf.resolve(null).then(a).catch(If);
                }
              : Ff;
      function If(a) {
        setTimeout(function () {
          throw a;
        });
      }
      function Kf(a, b) {
        var c = b,
          d = 0;
        do {
          var e = c.nextSibling;
          a.removeChild(c);
          if (e && 8 === e.nodeType)
            if (((c = e.data), '/$' === c)) {
              if (0 === d) {
                a.removeChild(e);
                bd(b);
                return;
              }
              d--;
            } else ('$' !== c && '$?' !== c && '$!' !== c) || d++;
          c = e;
        } while (c);
        bd(b);
      }
      function Lf(a) {
        for (; null != a; a = a.nextSibling) {
          var b = a.nodeType;
          if (1 === b || 3 === b) break;
          if (8 === b) {
            b = a.data;
            if ('$' === b || '$!' === b || '$?' === b) break;
            if ('/$' === b) return null;
          }
        }
        return a;
      }
      function Mf(a) {
        a = a.previousSibling;
        for (var b = 0; a; ) {
          if (8 === a.nodeType) {
            var c = a.data;
            if ('$' === c || '$!' === c || '$?' === c) {
              if (0 === b) return a;
              b--;
            } else '/$' === c && b++;
          }
          a = a.previousSibling;
        }
        return null;
      }
      var Nf = Math.random().toString(36).slice(2),
        Of = '__reactFiber$' + Nf,
        Pf = '__reactProps$' + Nf,
        uf = '__reactContainer$' + Nf,
        of = '__reactEvents$' + Nf,
        Qf = '__reactListeners$' + Nf,
        Rf = '__reactHandles$' + Nf;
      function Wc(a) {
        var b = a[Of];
        if (b) return b;
        for (var c = a.parentNode; c; ) {
          if ((b = c[uf] || c[Of])) {
            c = b.alternate;
            if (null !== b.child || (null !== c && null !== c.child))
              for (a = Mf(a); null !== a; ) {
                if ((c = a[Of])) return c;
                a = Mf(a);
              }
            return b;
          }
          a = c;
          c = a.parentNode;
        }
        return null;
      }
      function Cb(a) {
        a = a[Of] || a[uf];
        return !a || (5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag) ? null : a;
      }
      function ue(a) {
        if (5 === a.tag || 6 === a.tag) return a.stateNode;
        throw Error(p(33));
      }
      function Db(a) {
        return a[Pf] || null;
      }
      var Sf = [],
        Tf = -1;
      function Uf(a) {
        return {
          current: a,
        };
      }
      function E(a) {
        0 > Tf || ((a.current = Sf[Tf]), (Sf[Tf] = null), Tf--);
      }
      function G(a, b) {
        Tf++;
        Sf[Tf] = a.current;
        a.current = b;
      }
      var Vf = {},
        H = Uf(Vf),
        Wf = Uf(!1),
        Xf = Vf;
      function Yf(a, b) {
        var c = a.type.contextTypes;
        if (!c) return Vf;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b)
          return d.__reactInternalMemoizedMaskedChildContext;
        var e = {},
          f;
        for (f in c) e[f] = b[f];
        d &&
          ((a = a.stateNode),
          (a.__reactInternalMemoizedUnmaskedChildContext = b),
          (a.__reactInternalMemoizedMaskedChildContext = e));
        return e;
      }
      function Zf(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
      }
      function $f() {
        E(Wf);
        E(H);
      }
      function ag(a, b, c) {
        if (H.current !== Vf) throw Error(p(168));
        G(H, b);
        G(Wf, c);
      }
      function bg(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ('function' !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for (var e in d) if (!(e in b)) throw Error(p(108, Ra(a) || 'Unknown', e));
        return A({}, c, d);
      }
      function cg(a) {
        a = ((a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext) || Vf;
        Xf = H.current;
        G(H, a);
        G(Wf, Wf.current);
        return !0;
      }
      function dg(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(p(169));
        c ? ((a = bg(a, b, Xf)), (d.__reactInternalMemoizedMergedChildContext = a), E(Wf), E(H), G(H, a)) : E(Wf);
        G(Wf, c);
      }
      var eg = null,
        fg = !1,
        gg = !1;
      function hg(a) {
        null === eg ? (eg = [a]) : eg.push(a);
      }
      function ig(a) {
        fg = !0;
        hg(a);
      }
      function jg() {
        if (!gg && null !== eg) {
          gg = !0;
          var a = 0,
            b = C;
          try {
            var c = eg;
            for (C = 1; a < c.length; a++) {
              var d = c[a];
              do d = d(!0);
              while (null !== d);
            }
            eg = null;
            fg = !1;
          } catch (e) {
            throw (null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e);
          } finally {
            (C = b), (gg = !1);
          }
        }
        return null;
      }
      var kg = [],
        lg = 0,
        mg = null,
        ng = 0,
        og = [],
        pg = 0,
        qg = null,
        rg = 1,
        sg = '';
      function tg(a, b) {
        kg[lg++] = ng;
        kg[lg++] = mg;
        mg = a;
        ng = b;
      }
      function ug(a, b, c) {
        og[pg++] = rg;
        og[pg++] = sg;
        og[pg++] = qg;
        qg = a;
        var d = rg;
        a = sg;
        var e = 32 - oc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - oc(b) + e;
        if (30 < f) {
          var g = e - (e % 5);
          f = (d & ((1 << g) - 1)).toString(32);
          d >>= g;
          e -= g;
          rg = (1 << (32 - oc(b) + e)) | (c << e) | d;
          sg = f + a;
        } else (rg = (1 << f) | (c << e) | d), (sg = a);
      }
      function vg(a) {
        null !== a.return && (tg(a, 1), ug(a, 1, 0));
      }
      function wg(a) {
        for (; a === mg; ) (mg = kg[--lg]), (kg[lg] = null), (ng = kg[--lg]), (kg[lg] = null);
        for (; a === qg; )
          (qg = og[--pg]), (og[pg] = null), (sg = og[--pg]), (og[pg] = null), (rg = og[--pg]), (og[pg] = null);
      }
      var xg = null,
        yg = null,
        I = !1,
        zg = null;
      function Ag(a, b) {
        var c = Bg(5, null, null, 0);
        c.elementType = 'DELETED';
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? ((a.deletions = [c]), (a.flags |= 16)) : b.push(c);
      }
      function Cg(a, b) {
        switch (a.tag) {
          case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? ((a.stateNode = b), (xg = a), (yg = Lf(b.firstChild)), !0) : !1;
          case 6:
            return (
              (b = '' === a.pendingProps || 3 !== b.nodeType ? null : b),
              null !== b ? ((a.stateNode = b), (xg = a), (yg = null), !0) : !1
            );
          case 13:
            return (
              (b = 8 !== b.nodeType ? null : b),
              null !== b
                ? ((c =
                    null !== qg
                      ? {
                          id: rg,
                          overflow: sg,
                        }
                      : null),
                  (a.memoizedState = {
                    dehydrated: b,
                    treeContext: c,
                    retryLane: 1073741824,
                  }),
                  (c = Bg(18, null, null, 0)),
                  (c.stateNode = b),
                  (c.return = a),
                  (a.child = c),
                  (xg = a),
                  (yg = null),
                  !0)
                : !1
            );
          default:
            return !1;
        }
      }
      function Dg(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
      }
      function Eg(a) {
        if (I) {
          var b = yg;
          if (b) {
            var c = b;
            if (!Cg(a, b)) {
              if (Dg(a)) throw Error(p(418));
              b = Lf(c.nextSibling);
              var d = xg;
              b && Cg(a, b) ? Ag(d, c) : ((a.flags = (a.flags & -4097) | 2), (I = !1), (xg = a));
            }
          } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = (a.flags & -4097) | 2;
            I = !1;
            xg = a;
          }
        }
      }
      function Fg(a) {
        for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; ) a = a.return;
        xg = a;
      }
      function Gg(a) {
        if (a !== xg) return !1;
        if (!I) return Fg(a), (I = !0), !1;
        var b;
        (b = 3 !== a.tag) &&
          !(b = 5 !== a.tag) &&
          ((b = a.type), (b = 'head' !== b && 'body' !== b && !Ef(a.type, a.memoizedProps)));
        if (b && (b = yg)) {
          if (Dg(a)) throw (Hg(), Error(p(418)));
          for (; b; ) Ag(a, b), (b = Lf(b.nextSibling));
        }
        Fg(a);
        if (13 === a.tag) {
          a = a.memoizedState;
          a = null !== a ? a.dehydrated : null;
          if (!a) throw Error(p(317));
          a: {
            a = a.nextSibling;
            for (b = 0; a; ) {
              if (8 === a.nodeType) {
                var c = a.data;
                if ('/$' === c) {
                  if (0 === b) {
                    yg = Lf(a.nextSibling);
                    break a;
                  }
                  b--;
                } else ('$' !== c && '$!' !== c && '$?' !== c) || b++;
              }
              a = a.nextSibling;
            }
            yg = null;
          }
        } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
        return !0;
      }
      function Hg() {
        for (var a = yg; a; ) a = Lf(a.nextSibling);
      }
      function Ig() {
        yg = xg = null;
        I = !1;
      }
      function Jg(a) {
        null === zg ? (zg = [a]) : zg.push(a);
      }
      var Kg = ua.ReactCurrentBatchConfig;
      function Lg(a, b, c) {
        a = c.ref;
        if (null !== a && 'function' !== typeof a && 'object' !== typeof a) {
          if (c._owner) {
            c = c._owner;
            if (c) {
              if (1 !== c.tag) throw Error(p(309));
              var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d,
              f = '' + a;
            if (null !== b && null !== b.ref && 'function' === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function (a) {
              var b = e.refs;
              null === a ? delete b[f] : (b[f] = a);
            };
            b._stringRef = f;
            return b;
          }
          if ('string' !== typeof a) throw Error(p(284));
          if (!c._owner) throw Error(p(290, a));
        }
        return a;
      }
      function Mg(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(p(31, '[object Object]' === a ? 'object with keys {' + Object.keys(b).join(', ') + '}' : a));
      }
      function Ng(a) {
        var b = a._init;
        return b(a._payload);
      }
      function Og(a) {
        function b(b, c) {
          if (a) {
            var d = b.deletions;
            null === d ? ((b.deletions = [c]), (b.flags |= 16)) : d.push(c);
          }
        }
        function c(c, d) {
          if (!a) return null;
          for (; null !== d; ) b(c, d), (d = d.sibling);
          return null;
        }
        function d(a, b) {
          for (a = new Map(); null !== b; ) null !== b.key ? a.set(b.key, b) : a.set(b.index, b), (b = b.sibling);
          return a;
        }
        function e(a, b) {
          a = Pg(a, b);
          a.index = 0;
          a.sibling = null;
          return a;
        }
        function f(b, c, d) {
          b.index = d;
          if (!a) return (b.flags |= 1048576), c;
          d = b.alternate;
          if (null !== d) return (d = d.index), d < c ? ((b.flags |= 2), c) : d;
          b.flags |= 2;
          return c;
        }
        function g(b) {
          a && null === b.alternate && (b.flags |= 2);
          return b;
        }
        function h(a, b, c, d) {
          if (null === b || 6 !== b.tag) return (b = Qg(c, a.mode, d)), (b.return = a), b;
          b = e(b, c);
          b.return = a;
          return b;
        }
        function k(a, b, c, d) {
          var f = c.type;
          if (f === ya) return m(a, b, c.props.children, d, c.key);
          if (
            null !== b &&
            (b.elementType === f || ('object' === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type))
          )
            return (d = e(b, c.props)), (d.ref = Lg(a, b, c)), (d.return = a), d;
          d = Rg(c.type, c.key, c.props, null, a.mode, d);
          d.ref = Lg(a, b, c);
          d.return = a;
          return d;
        }
        function l(a, b, c, d) {
          if (
            null === b ||
            4 !== b.tag ||
            b.stateNode.containerInfo !== c.containerInfo ||
            b.stateNode.implementation !== c.implementation
          )
            return (b = Sg(c, a.mode, d)), (b.return = a), b;
          b = e(b, c.children || []);
          b.return = a;
          return b;
        }
        function m(a, b, c, d, f) {
          if (null === b || 7 !== b.tag) return (b = Tg(c, a.mode, d, f)), (b.return = a), b;
          b = e(b, c);
          b.return = a;
          return b;
        }
        function q(a, b, c) {
          if (('string' === typeof b && '' !== b) || 'number' === typeof b)
            return (b = Qg('' + b, a.mode, c)), (b.return = a), b;
          if ('object' === typeof b && null !== b) {
            switch (b.$$typeof) {
              case va:
                return (c = Rg(b.type, b.key, b.props, null, a.mode, c)), (c.ref = Lg(a, null, b)), (c.return = a), c;
              case wa:
                return (b = Sg(b, a.mode, c)), (b.return = a), b;
              case Ha:
                var d = b._init;
                return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return (b = Tg(b, a.mode, c, null)), (b.return = a), b;
            Mg(a, b);
          }
          return null;
        }
        function r(a, b, c, d) {
          var e = null !== b ? b.key : null;
          if (('string' === typeof c && '' !== c) || 'number' === typeof c)
            return null !== e ? null : h(a, b, '' + c, d);
          if ('object' === typeof c && null !== c) {
            switch (c.$$typeof) {
              case va:
                return c.key === e ? k(a, b, c, d) : null;
              case wa:
                return c.key === e ? l(a, b, c, d) : null;
              case Ha:
                return (e = c._init), r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
          }
          return null;
        }
        function y(a, b, c, d, e) {
          if (('string' === typeof d && '' !== d) || 'number' === typeof d)
            return (a = a.get(c) || null), h(b, a, '' + d, e);
          if ('object' === typeof d && null !== d) {
            switch (d.$$typeof) {
              case va:
                return (a = a.get(null === d.key ? c : d.key) || null), k(b, a, d, e);
              case wa:
                return (a = a.get(null === d.key ? c : d.key) || null), l(b, a, d, e);
              case Ha:
                var f = d._init;
                return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return (a = a.get(c) || null), m(b, a, d, e, null);
            Mg(b, d);
          }
          return null;
        }
        function n(e, g, h, k) {
          for (var l = null, m = null, u = g, w = (g = 0), x = null; null !== u && w < h.length; w++) {
            u.index > w ? ((x = u), (u = null)) : (x = u.sibling);
            var n = r(e, u, h[w], k);
            if (null === n) {
              null === u && (u = x);
              break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? (l = n) : (m.sibling = n);
            m = n;
            u = x;
          }
          if (w === h.length) return c(e, u), I && tg(e, w), l;
          if (null === u) {
            for (; w < h.length; w++)
              (u = q(e, h[w], k)), null !== u && ((g = f(u, g, w)), null === m ? (l = u) : (m.sibling = u), (m = u));
            I && tg(e, w);
            return l;
          }
          for (u = d(e, u); w < h.length; w++)
            (x = y(u, e, w, h[w], k)),
              null !== x &&
                (a && null !== x.alternate && u.delete(null === x.key ? w : x.key),
                (g = f(x, g, w)),
                null === m ? (l = x) : (m.sibling = x),
                (m = x));
          a &&
            u.forEach(function (a) {
              return b(e, a);
            });
          I && tg(e, w);
          return l;
        }
        function t(e, g, h, k) {
          var l = Ka(h);
          if ('function' !== typeof l) throw Error(p(150));
          h = l.call(h);
          if (null == h) throw Error(p(151));
          for (
            var u = (l = null), m = g, w = (g = 0), x = null, n = h.next();
            null !== m && !n.done;
            w++, n = h.next()
          ) {
            m.index > w ? ((x = m), (m = null)) : (x = m.sibling);
            var t = r(e, m, n.value, k);
            if (null === t) {
              null === m && (m = x);
              break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? (l = t) : (u.sibling = t);
            u = t;
            m = x;
          }
          if (n.done) return c(e, m), I && tg(e, w), l;
          if (null === m) {
            for (; !n.done; w++, n = h.next())
              (n = q(e, n.value, k)), null !== n && ((g = f(n, g, w)), null === u ? (l = n) : (u.sibling = n), (u = n));
            I && tg(e, w);
            return l;
          }
          for (m = d(e, m); !n.done; w++, n = h.next())
            (n = y(m, e, w, n.value, k)),
              null !== n &&
                (a && null !== n.alternate && m.delete(null === n.key ? w : n.key),
                (g = f(n, g, w)),
                null === u ? (l = n) : (u.sibling = n),
                (u = n));
          a &&
            m.forEach(function (a) {
              return b(e, a);
            });
          I && tg(e, w);
          return l;
        }
        function J(a, d, f, h) {
          'object' === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
          if ('object' === typeof f && null !== f) {
            switch (f.$$typeof) {
              case va:
                a: {
                  for (var k = f.key, l = d; null !== l; ) {
                    if (l.key === k) {
                      k = f.type;
                      if (k === ya) {
                        if (7 === l.tag) {
                          c(a, l.sibling);
                          d = e(l, f.props.children);
                          d.return = a;
                          a = d;
                          break a;
                        }
                      } else if (
                        l.elementType === k ||
                        ('object' === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type)
                      ) {
                        c(a, l.sibling);
                        d = e(l, f.props);
                        d.ref = Lg(a, l, f);
                        d.return = a;
                        a = d;
                        break a;
                      }
                      c(a, l);
                      break;
                    } else b(a, l);
                    l = l.sibling;
                  }
                  f.type === ya
                    ? ((d = Tg(f.props.children, a.mode, h, f.key)), (d.return = a), (a = d))
                    : ((h = Rg(f.type, f.key, f.props, null, a.mode, h)),
                      (h.ref = Lg(a, d, f)),
                      (h.return = a),
                      (a = h));
                }
                return g(a);
              case wa:
                a: {
                  for (l = f.key; null !== d; ) {
                    if (d.key === l) {
                      if (
                        4 === d.tag &&
                        d.stateNode.containerInfo === f.containerInfo &&
                        d.stateNode.implementation === f.implementation
                      ) {
                        c(a, d.sibling);
                        d = e(d, f.children || []);
                        d.return = a;
                        a = d;
                        break a;
                      } else {
                        c(a, d);
                        break;
                      }
                    } else b(a, d);
                    d = d.sibling;
                  }
                  d = Sg(f, a.mode, h);
                  d.return = a;
                  a = d;
                }
                return g(a);
              case Ha:
                return (l = f._init), J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
          }
          return ('string' === typeof f && '' !== f) || 'number' === typeof f
            ? ((f = '' + f),
              null !== d && 6 === d.tag
                ? (c(a, d.sibling), (d = e(d, f)), (d.return = a), (a = d))
                : (c(a, d), (d = Qg(f, a.mode, h)), (d.return = a), (a = d)),
              g(a))
            : c(a, d);
        }
        return J;
      }
      var Ug = Og(!0),
        Vg = Og(!1),
        Wg = Uf(null),
        Xg = null,
        Yg = null,
        Zg = null;
      function $g() {
        Zg = Yg = Xg = null;
      }
      function ah(a) {
        var b = Wg.current;
        E(Wg);
        a._currentValue = b;
      }
      function bh(a, b, c) {
        for (; null !== a; ) {
          var d = a.alternate;
          (a.childLanes & b) !== b
            ? ((a.childLanes |= b), null !== d && (d.childLanes |= b))
            : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
          if (a === c) break;
          a = a.return;
        }
      }
      function ch(a, b) {
        Xg = a;
        Zg = Yg = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), (a.firstContext = null));
      }
      function eh(a) {
        var b = a._currentValue;
        if (Zg !== a)
          if (
            ((a = {
              context: a,
              memoizedValue: b,
              next: null,
            }),
            null === Yg)
          ) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
              lanes: 0,
              firstContext: a,
            };
          } else Yg = Yg.next = a;
        return b;
      }
      var fh = null;
      function gh(a) {
        null === fh ? (fh = [a]) : fh.push(a);
      }
      function hh(a, b, c, d) {
        var e = b.interleaved;
        null === e ? ((c.next = c), gh(b)) : ((c.next = e.next), (e.next = c));
        b.interleaved = c;
        return ih(a, d);
      }
      function ih(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for (a = a.return; null !== a; )
          (a.childLanes |= b), (c = a.alternate), null !== c && (c.childLanes |= b), (c = a), (a = a.return);
        return 3 === c.tag ? c.stateNode : null;
      }
      var jh = !1;
      function kh(a) {
        a.updateQueue = {
          baseState: a.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: 0,
          },
          effects: null,
        };
      }
      function lh(a, b) {
        a = a.updateQueue;
        b.updateQueue === a &&
          (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects,
          });
      }
      function mh(a, b) {
        return {
          eventTime: a,
          lane: b,
          tag: 0,
          payload: null,
          callback: null,
          next: null,
        };
      }
      function nh(a, b, c) {
        var d = a.updateQueue;
        if (null === d) return null;
        d = d.shared;
        if (0 !== (K & 2)) {
          var e = d.pending;
          null === e ? (b.next = b) : ((b.next = e.next), (e.next = b));
          d.pending = b;
          return ih(a, c);
        }
        e = d.interleaved;
        null === e ? ((b.next = b), gh(d)) : ((b.next = e.next), (e.next = b));
        d.interleaved = b;
        return ih(a, c);
      }
      function oh(a, b, c) {
        b = b.updateQueue;
        if (null !== b && ((b = b.shared), 0 !== (c & 4194240))) {
          var d = b.lanes;
          d &= a.pendingLanes;
          c |= d;
          b.lanes = c;
          Cc(a, c);
        }
      }
      function ph(a, b) {
        var c = a.updateQueue,
          d = a.alternate;
        if (null !== d && ((d = d.updateQueue), c === d)) {
          var e = null,
            f = null;
          c = c.firstBaseUpdate;
          if (null !== c) {
            do {
              var g = {
                eventTime: c.eventTime,
                lane: c.lane,
                tag: c.tag,
                payload: c.payload,
                callback: c.callback,
                next: null,
              };
              null === f ? (e = f = g) : (f = f.next = g);
              c = c.next;
            } while (null !== c);
            null === f ? (e = f = b) : (f = f.next = b);
          } else e = f = b;
          c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects,
          };
          a.updateQueue = c;
          return;
        }
        a = c.lastBaseUpdate;
        null === a ? (c.firstBaseUpdate = b) : (a.next = b);
        c.lastBaseUpdate = b;
      }
      function qh(a, b, c, d) {
        var e = a.updateQueue;
        jh = !1;
        var f = e.firstBaseUpdate,
          g = e.lastBaseUpdate,
          h = e.shared.pending;
        if (null !== h) {
          e.shared.pending = null;
          var k = h,
            l = k.next;
          k.next = null;
          null === g ? (f = l) : (g.next = l);
          g = k;
          var m = a.alternate;
          null !== m &&
            ((m = m.updateQueue),
            (h = m.lastBaseUpdate),
            h !== g && (null === h ? (m.firstBaseUpdate = l) : (h.next = l), (m.lastBaseUpdate = k)));
        }
        if (null !== f) {
          var q = e.baseState;
          g = 0;
          m = l = k = null;
          h = f;
          do {
            var r = h.lane,
              y = h.eventTime;
            if ((d & r) === r) {
              null !== m &&
                (m = m.next =
                  {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null,
                  });
              a: {
                var n = a,
                  t = h;
                r = b;
                y = c;
                switch (t.tag) {
                  case 1:
                    n = t.payload;
                    if ('function' === typeof n) {
                      q = n.call(y, q, r);
                      break a;
                    }
                    q = n;
                    break a;
                  case 3:
                    n.flags = (n.flags & -65537) | 128;
                  case 0:
                    n = t.payload;
                    r = 'function' === typeof n ? n.call(y, q, r) : n;
                    if (null === r || void 0 === r) break a;
                    q = A({}, q, r);
                    break a;
                  case 2:
                    jh = !0;
                }
              }
              null !== h.callback &&
                0 !== h.lane &&
                ((a.flags |= 64), (r = e.effects), null === r ? (e.effects = [h]) : r.push(h));
            } else
              (y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null,
              }),
                null === m ? ((l = m = y), (k = q)) : (m = m.next = y),
                (g |= r);
            h = h.next;
            if (null === h)
              if (((h = e.shared.pending), null === h)) break;
              else (r = h), (h = r.next), (r.next = null), (e.lastBaseUpdate = r), (e.shared.pending = null);
          } while (1);
          null === m && (k = q);
          e.baseState = k;
          e.firstBaseUpdate = l;
          e.lastBaseUpdate = m;
          b = e.shared.interleaved;
          if (null !== b) {
            e = b;
            do (g |= e.lane), (e = e.next);
            while (e !== b);
          } else null === f && (e.shared.lanes = 0);
          rh |= g;
          a.lanes = g;
          a.memoizedState = q;
        }
      }
      function sh(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a)
          for (b = 0; b < a.length; b++) {
            var d = a[b],
              e = d.callback;
            if (null !== e) {
              d.callback = null;
              d = c;
              if ('function' !== typeof e) throw Error(p(191, e));
              e.call(d);
            }
          }
      }
      var th = {},
        uh = Uf(th),
        vh = Uf(th),
        wh = Uf(th);
      function xh(a) {
        if (a === th) throw Error(p(174));
        return a;
      }
      function yh(a, b) {
        G(wh, b);
        G(vh, a);
        G(uh, th);
        a = b.nodeType;
        switch (a) {
          case 9:
          case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, '');
            break;
          default:
            (a = 8 === a ? b.parentNode : b), (b = a.namespaceURI || null), (a = a.tagName), (b = lb(b, a));
        }
        E(uh);
        G(uh, b);
      }
      function zh() {
        E(uh);
        E(vh);
        E(wh);
      }
      function Ah(a) {
        xh(wh.current);
        var b = xh(uh.current);
        var c = lb(b, a.type);
        b !== c && (G(vh, a), G(uh, c));
      }
      function Bh(a) {
        vh.current === a && (E(uh), E(vh));
      }
      var L = Uf(0);
      function Ch(a) {
        for (var b = a; null !== b; ) {
          if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && ((c = c.dehydrated), null === c || '$?' === c.data || '$!' === c.data)) return b;
          } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
          } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
          }
          if (b === a) break;
          for (; null === b.sibling; ) {
            if (null === b.return || b.return === a) return null;
            b = b.return;
          }
          b.sibling.return = b.return;
          b = b.sibling;
        }
        return null;
      }
      var Dh = [];
      function Eh() {
        for (var a = 0; a < Dh.length; a++) Dh[a]._workInProgressVersionPrimary = null;
        Dh.length = 0;
      }
      var Fh = ua.ReactCurrentDispatcher,
        Gh = ua.ReactCurrentBatchConfig,
        Hh = 0,
        M = null,
        N = null,
        O = null,
        Ih = !1,
        Jh = !1,
        Kh = 0,
        Lh = 0;
      function P() {
        throw Error(p(321));
      }
      function Mh(a, b) {
        if (null === b) return !1;
        for (var c = 0; c < b.length && c < a.length; c++) if (!He(a[c], b[c])) return !1;
        return !0;
      }
      function Nh(a, b, c, d, e, f) {
        Hh = f;
        M = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
        a = c(d, e);
        if (Jh) {
          f = 0;
          do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
          } while (Jh);
        }
        Fh.current = Rh;
        b = null !== N && null !== N.next;
        Hh = 0;
        O = N = M = null;
        Ih = !1;
        if (b) throw Error(p(300));
        return a;
      }
      function Sh() {
        var a = 0 !== Kh;
        Kh = 0;
        return a;
      }
      function Th() {
        var a = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null,
        };
        null === O ? (M.memoizedState = O = a) : (O = O.next = a);
        return O;
      }
      function Uh() {
        if (null === N) {
          var a = M.alternate;
          a = null !== a ? a.memoizedState : null;
        } else a = N.next;
        var b = null === O ? M.memoizedState : O.next;
        if (null !== b) (O = b), (N = a);
        else {
          if (null === a) throw Error(p(310));
          N = a;
          a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null,
          };
          null === O ? (M.memoizedState = O = a) : (O = O.next = a);
        }
        return O;
      }
      function Vh(a, b) {
        return 'function' === typeof b ? b(a) : b;
      }
      function Wh(a) {
        var b = Uh(),
          c = b.queue;
        if (null === c) throw Error(p(311));
        c.lastRenderedReducer = a;
        var d = N,
          e = d.baseQueue,
          f = c.pending;
        if (null !== f) {
          if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
          }
          d.baseQueue = e = f;
          c.pending = null;
        }
        if (null !== e) {
          f = e.next;
          d = d.baseState;
          var h = (g = null),
            k = null,
            l = f;
          do {
            var m = l.lane;
            if ((Hh & m) === m)
              null !== k &&
                (k = k.next =
                  {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null,
                  }),
                (d = l.hasEagerState ? l.eagerState : a(d, l.action));
            else {
              var q = {
                lane: m,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null,
              };
              null === k ? ((h = k = q), (g = d)) : (k = k.next = q);
              M.lanes |= m;
              rh |= m;
            }
            l = l.next;
          } while (null !== l && l !== f);
          null === k ? (g = d) : (k.next = h);
          He(d, b.memoizedState) || (dh = !0);
          b.memoizedState = d;
          b.baseState = g;
          b.baseQueue = k;
          c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
          e = a;
          do (f = e.lane), (M.lanes |= f), (rh |= f), (e = e.next);
          while (e !== a);
        } else null === e && (c.lanes = 0);
        return [b.memoizedState, c.dispatch];
      }
      function Xh(a) {
        var b = Uh(),
          c = b.queue;
        if (null === c) throw Error(p(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch,
          e = c.pending,
          f = b.memoizedState;
        if (null !== e) {
          c.pending = null;
          var g = (e = e.next);
          do (f = a(f, g.action)), (g = g.next);
          while (g !== e);
          He(f, b.memoizedState) || (dh = !0);
          b.memoizedState = f;
          null === b.baseQueue && (b.baseState = f);
          c.lastRenderedState = f;
        }
        return [f, d];
      }
      function Yh() {}
      function Zh(a, b) {
        var c = M,
          d = Uh(),
          e = b(),
          f = !He(d.memoizedState, e);
        f && ((d.memoizedState = e), (dh = !0));
        d = d.queue;
        $h(ai.bind(null, c, d, a), [a]);
        if (d.getSnapshot !== b || f || (null !== O && O.memoizedState.tag & 1)) {
          c.flags |= 2048;
          bi(9, ci.bind(null, c, d, e, b), void 0, null);
          if (null === Q) throw Error(p(349));
          0 !== (Hh & 30) || di(c, b, e);
        }
        return e;
      }
      function di(a, b, c) {
        a.flags |= 16384;
        a = {
          getSnapshot: b,
          value: c,
        };
        b = M.updateQueue;
        null === b
          ? ((b = {
              lastEffect: null,
              stores: null,
            }),
            (M.updateQueue = b),
            (b.stores = [a]))
          : ((c = b.stores), null === c ? (b.stores = [a]) : c.push(a));
      }
      function ci(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        ei(b) && fi(a);
      }
      function ai(a, b, c) {
        return c(function () {
          ei(b) && fi(a);
        });
      }
      function ei(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
          var c = b();
          return !He(a, c);
        } catch (d) {
          return !0;
        }
      }
      function fi(a) {
        var b = ih(a, 1);
        null !== b && gi(b, a, 1, -1);
      }
      function hi(a) {
        var b = Th();
        'function' === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: Vh,
          lastRenderedState: a,
        };
        b.queue = a;
        a = a.dispatch = ii.bind(null, M, a);
        return [b.memoizedState, a];
      }
      function bi(a, b, c, d) {
        a = {
          tag: a,
          create: b,
          destroy: c,
          deps: d,
          next: null,
        };
        b = M.updateQueue;
        null === b
          ? ((b = {
              lastEffect: null,
              stores: null,
            }),
            (M.updateQueue = b),
            (b.lastEffect = a.next = a))
          : ((c = b.lastEffect),
            null === c ? (b.lastEffect = a.next = a) : ((d = c.next), (c.next = a), (a.next = d), (b.lastEffect = a)));
        return a;
      }
      function ji() {
        return Uh().memoizedState;
      }
      function ki(a, b, c, d) {
        var e = Th();
        M.flags |= a;
        e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
      }
      function li(a, b, c, d) {
        var e = Uh();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== N) {
          var g = N.memoizedState;
          f = g.destroy;
          if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
          }
        }
        M.flags |= a;
        e.memoizedState = bi(1 | b, c, f, d);
      }
      function mi(a, b) {
        return ki(8390656, 8, a, b);
      }
      function $h(a, b) {
        return li(2048, 8, a, b);
      }
      function ni(a, b) {
        return li(4, 2, a, b);
      }
      function oi(a, b) {
        return li(4, 4, a, b);
      }
      function pi(a, b) {
        if ('function' === typeof b)
          return (
            (a = a()),
            b(a),
            function () {
              b(null);
            }
          );
        if (null !== b && void 0 !== b)
          return (
            (a = a()),
            (b.current = a),
            function () {
              b.current = null;
            }
          );
      }
      function qi(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([a]) : null;
        return li(4, 4, pi.bind(null, b, a), c);
      }
      function ri() {}
      function si(a, b) {
        var c = Uh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Mh(b, d[1])) return d[0];
        c.memoizedState = [a, b];
        return a;
      }
      function ti(a, b) {
        var c = Uh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Mh(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [a, b];
        return a;
      }
      function ui(a, b, c) {
        if (0 === (Hh & 21)) return a.baseState && ((a.baseState = !1), (dh = !0)), (a.memoizedState = c);
        He(c, b) || ((c = yc()), (M.lanes |= c), (rh |= c), (a.baseState = !0));
        return b;
      }
      function vi(a, b) {
        var c = C;
        C = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = Gh.transition;
        Gh.transition = {};
        try {
          a(!1), b();
        } finally {
          (C = c), (Gh.transition = d);
        }
      }
      function wi() {
        return Uh().memoizedState;
      }
      function xi(a, b, c) {
        var d = yi(a);
        c = {
          lane: d,
          action: c,
          hasEagerState: !1,
          eagerState: null,
          next: null,
        };
        if (zi(a)) Ai(b, c);
        else if (((c = hh(a, b, c, d)), null !== c)) {
          var e = R();
          gi(c, a, d, e);
          Bi(c, b, d);
        }
      }
      function ii(a, b, c) {
        var d = yi(a),
          e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
        if (zi(a)) Ai(b, e);
        else {
          var f = a.alternate;
          if (0 === a.lanes && (null === f || 0 === f.lanes) && ((f = b.lastRenderedReducer), null !== f))
            try {
              var g = b.lastRenderedState,
                h = f(g, c);
              e.hasEagerState = !0;
              e.eagerState = h;
              if (He(h, g)) {
                var k = b.interleaved;
                null === k ? ((e.next = e), gh(b)) : ((e.next = k.next), (k.next = e));
                b.interleaved = e;
                return;
              }
            } catch (l) {
            } finally {
            }
          c = hh(a, b, e, d);
          null !== c && ((e = R()), gi(c, a, d, e), Bi(c, b, d));
        }
      }
      function zi(a) {
        var b = a.alternate;
        return a === M || (null !== b && b === M);
      }
      function Ai(a, b) {
        Jh = Ih = !0;
        var c = a.pending;
        null === c ? (b.next = b) : ((b.next = c.next), (c.next = b));
        a.pending = b;
      }
      function Bi(a, b, c) {
        if (0 !== (c & 4194240)) {
          var d = b.lanes;
          d &= a.pendingLanes;
          c |= d;
          b.lanes = c;
          Cc(a, c);
        }
      }
      var Rh = {
          readContext: eh,
          useCallback: P,
          useContext: P,
          useEffect: P,
          useImperativeHandle: P,
          useInsertionEffect: P,
          useLayoutEffect: P,
          useMemo: P,
          useReducer: P,
          useRef: P,
          useState: P,
          useDebugValue: P,
          useDeferredValue: P,
          useTransition: P,
          useMutableSource: P,
          useSyncExternalStore: P,
          useId: P,
          unstable_isNewReconciler: !1,
        },
        Oh = {
          readContext: eh,
          useCallback: function (a, b) {
            Th().memoizedState = [a, void 0 === b ? null : b];
            return a;
          },
          useContext: eh,
          useEffect: mi,
          useImperativeHandle: function (a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([a]) : null;
            return ki(4194308, 4, pi.bind(null, b, a), c);
          },
          useLayoutEffect: function (a, b) {
            return ki(4194308, 4, a, b);
          },
          useInsertionEffect: function (a, b) {
            return ki(4, 2, a, b);
          },
          useMemo: function (a, b) {
            var c = Th();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [a, b];
            return a;
          },
          useReducer: function (a, b, c) {
            var d = Th();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: a,
              lastRenderedState: b,
            };
            d.queue = a;
            a = a.dispatch = xi.bind(null, M, a);
            return [d.memoizedState, a];
          },
          useRef: function (a) {
            var b = Th();
            a = {
              current: a,
            };
            return (b.memoizedState = a);
          },
          useState: hi,
          useDebugValue: ri,
          useDeferredValue: function (a) {
            return (Th().memoizedState = a);
          },
          useTransition: function () {
            var a = hi(!1),
              b = a[0];
            a = vi.bind(null, a[1]);
            Th().memoizedState = a;
            return [b, a];
          },
          useMutableSource: function () {},
          useSyncExternalStore: function (a, b, c) {
            var d = M,
              e = Th();
            if (I) {
              if (void 0 === c) throw Error(p(407));
              c = c();
            } else {
              c = b();
              if (null === Q) throw Error(p(349));
              0 !== (Hh & 30) || di(d, b, c);
            }
            e.memoizedState = c;
            var f = {
              value: c,
              getSnapshot: b,
            };
            e.queue = f;
            mi(ai.bind(null, d, f, a), [a]);
            d.flags |= 2048;
            bi(9, ci.bind(null, d, f, c, b), void 0, null);
            return c;
          },
          useId: function () {
            var a = Th(),
              b = Q.identifierPrefix;
            if (I) {
              var c = sg;
              var d = rg;
              c = (d & ~(1 << (32 - oc(d) - 1))).toString(32) + c;
              b = ':' + b + 'R' + c;
              c = Kh++;
              0 < c && (b += 'H' + c.toString(32));
              b += ':';
            } else (c = Lh++), (b = ':' + b + 'r' + c.toString(32) + ':');
            return (a.memoizedState = b);
          },
          unstable_isNewReconciler: !1,
        },
        Ph = {
          readContext: eh,
          useCallback: si,
          useContext: eh,
          useEffect: $h,
          useImperativeHandle: qi,
          useInsertionEffect: ni,
          useLayoutEffect: oi,
          useMemo: ti,
          useReducer: Wh,
          useRef: ji,
          useState: function () {
            return Wh(Vh);
          },
          useDebugValue: ri,
          useDeferredValue: function (a) {
            var b = Uh();
            return ui(b, N.memoizedState, a);
          },
          useTransition: function () {
            var a = Wh(Vh)[0],
              b = Uh().memoizedState;
            return [a, b];
          },
          useMutableSource: Yh,
          useSyncExternalStore: Zh,
          useId: wi,
          unstable_isNewReconciler: !1,
        },
        Qh = {
          readContext: eh,
          useCallback: si,
          useContext: eh,
          useEffect: $h,
          useImperativeHandle: qi,
          useInsertionEffect: ni,
          useLayoutEffect: oi,
          useMemo: ti,
          useReducer: Xh,
          useRef: ji,
          useState: function () {
            return Xh(Vh);
          },
          useDebugValue: ri,
          useDeferredValue: function (a) {
            var b = Uh();
            return null === N ? (b.memoizedState = a) : ui(b, N.memoizedState, a);
          },
          useTransition: function () {
            var a = Xh(Vh)[0],
              b = Uh().memoizedState;
            return [a, b];
          },
          useMutableSource: Yh,
          useSyncExternalStore: Zh,
          useId: wi,
          unstable_isNewReconciler: !1,
        };
      function Ci(a, b) {
        if (a && a.defaultProps) {
          b = A({}, b);
          a = a.defaultProps;
          for (var c in a) void 0 === b[c] && (b[c] = a[c]);
          return b;
        }
        return b;
      }
      function Di(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : A({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
      }
      var Ei = {
        isMounted: function (a) {
          return (a = a._reactInternals) ? Vb(a) === a : !1;
        },
        enqueueSetState: function (a, b, c) {
          a = a._reactInternals;
          var d = R(),
            e = yi(a),
            f = mh(d, e);
          f.payload = b;
          void 0 !== c && null !== c && (f.callback = c);
          b = nh(a, f, e);
          null !== b && (gi(b, a, e, d), oh(b, a, e));
        },
        enqueueReplaceState: function (a, b, c) {
          a = a._reactInternals;
          var d = R(),
            e = yi(a),
            f = mh(d, e);
          f.tag = 1;
          f.payload = b;
          void 0 !== c && null !== c && (f.callback = c);
          b = nh(a, f, e);
          null !== b && (gi(b, a, e, d), oh(b, a, e));
        },
        enqueueForceUpdate: function (a, b) {
          a = a._reactInternals;
          var c = R(),
            d = yi(a),
            e = mh(c, d);
          e.tag = 2;
          void 0 !== b && null !== b && (e.callback = b);
          b = nh(a, e, d);
          null !== b && (gi(b, a, d, c), oh(b, a, d));
        },
      };
      function Fi(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return 'function' === typeof a.shouldComponentUpdate
          ? a.shouldComponentUpdate(d, f, g)
          : b.prototype && b.prototype.isPureReactComponent
            ? !Ie(c, d) || !Ie(e, f)
            : !0;
      }
      function Gi(a, b, c) {
        var d = !1,
          e = Vf;
        var f = b.contextType;
        'object' === typeof f && null !== f
          ? (f = eh(f))
          : ((e = Zf(b) ? Xf : H.current),
            (d = b.contextTypes),
            (f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf));
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Ei;
        a.stateNode = b;
        b._reactInternals = a;
        d &&
          ((a = a.stateNode),
          (a.__reactInternalMemoizedUnmaskedChildContext = e),
          (a.__reactInternalMemoizedMaskedChildContext = f));
        return b;
      }
      function Hi(a, b, c, d) {
        a = b.state;
        'function' === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        'function' === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
      }
      function Ii(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = {};
        kh(a);
        var f = b.contextType;
        'object' === typeof f && null !== f
          ? (e.context = eh(f))
          : ((f = Zf(b) ? Xf : H.current), (e.context = Yf(a, f)));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        'function' === typeof f && (Di(a, b, f, c), (e.state = a.memoizedState));
        'function' === typeof b.getDerivedStateFromProps ||
          'function' === typeof e.getSnapshotBeforeUpdate ||
          ('function' !== typeof e.UNSAFE_componentWillMount && 'function' !== typeof e.componentWillMount) ||
          ((b = e.state),
          'function' === typeof e.componentWillMount && e.componentWillMount(),
          'function' === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(),
          b !== e.state && Ei.enqueueReplaceState(e, e.state, null),
          qh(a, c, e, d),
          (e.state = a.memoizedState));
        'function' === typeof e.componentDidMount && (a.flags |= 4194308);
      }
      function Ji(a, b) {
        try {
          var c = '',
            d = b;
          do (c += Pa(d)), (d = d.return);
          while (d);
          var e = c;
        } catch (f) {
          e = '\nError generating stack: ' + f.message + '\n' + f.stack;
        }
        return {
          value: a,
          source: b,
          stack: e,
          digest: null,
        };
      }
      function Ki(a, b, c) {
        return {
          value: a,
          source: null,
          stack: null != c ? c : null,
          digest: null != b ? b : null,
        };
      }
      function Li(a, b) {
        try {
          console.error(b.value);
        } catch (c) {
          setTimeout(function () {
            throw c;
          });
        }
      }
      var Mi = 'function' === typeof WeakMap ? WeakMap : Map;
      function Ni(a, b, c) {
        c = mh(-1, c);
        c.tag = 3;
        c.payload = {
          element: null,
        };
        var d = b.value;
        c.callback = function () {
          Oi || ((Oi = !0), (Pi = d));
          Li(a, b);
        };
        return c;
      }
      function Qi(a, b, c) {
        c = mh(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ('function' === typeof d) {
          var e = b.value;
          c.payload = function () {
            return d(e);
          };
          c.callback = function () {
            Li(a, b);
          };
        }
        var f = a.stateNode;
        null !== f &&
          'function' === typeof f.componentDidCatch &&
          (c.callback = function () {
            Li(a, b);
            'function' !== typeof d && (null === Ri ? (Ri = new Set([this])) : Ri.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
              componentStack: null !== c ? c : '',
            });
          });
        return c;
      }
      function Si(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
          d = a.pingCache = new Mi();
          var e = new Set();
          d.set(b, e);
        } else (e = d.get(b)), void 0 === e && ((e = new Set()), d.set(b, e));
        e.has(c) || (e.add(c), (a = Ti.bind(null, a, b, c)), b.then(a, a));
      }
      function Ui(a) {
        do {
          var b;
          if ((b = 13 === a.tag)) (b = a.memoizedState), (b = null !== b ? (null !== b.dehydrated ? !0 : !1) : !0);
          if (b) return a;
          a = a.return;
        } while (null !== a);
        return null;
      }
      function Vi(a, b, c, d, e) {
        if (0 === (a.mode & 1))
          return (
            a === b
              ? (a.flags |= 65536)
              : ((a.flags |= 128),
                (c.flags |= 131072),
                (c.flags &= -52805),
                1 === c.tag && (null === c.alternate ? (c.tag = 17) : ((b = mh(-1, 1)), (b.tag = 2), nh(c, b, 1))),
                (c.lanes |= 1)),
            a
          );
        a.flags |= 65536;
        a.lanes = e;
        return a;
      }
      var Wi = ua.ReactCurrentOwner,
        dh = !1;
      function Xi(a, b, c, d) {
        b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
      }
      function Yi(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        ch(b, e);
        d = Nh(a, b, c, d, f, e);
        c = Sh();
        if (null !== a && !dh) return (b.updateQueue = a.updateQueue), (b.flags &= -2053), (a.lanes &= ~e), Zi(a, b, e);
        I && c && vg(b);
        b.flags |= 1;
        Xi(a, b, d, e);
        return b.child;
      }
      function $i(a, b, c, d, e) {
        if (null === a) {
          var f = c.type;
          if (
            'function' === typeof f &&
            !aj(f) &&
            void 0 === f.defaultProps &&
            null === c.compare &&
            void 0 === c.defaultProps
          )
            return (b.tag = 15), (b.type = f), bj(a, b, f, d, e);
          a = Rg(c.type, null, d, b, b.mode, e);
          a.ref = b.ref;
          a.return = b;
          return (b.child = a);
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
          var g = f.memoizedProps;
          c = c.compare;
          c = null !== c ? c : Ie;
          if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
        }
        b.flags |= 1;
        a = Pg(f, d);
        a.ref = b.ref;
        a.return = b;
        return (b.child = a);
      }
      function bj(a, b, c, d, e) {
        if (null !== a) {
          var f = a.memoizedProps;
          if (Ie(f, d) && a.ref === b.ref)
            if (((dh = !1), (b.pendingProps = d = f), 0 !== (a.lanes & e))) 0 !== (a.flags & 131072) && (dh = !0);
            else return (b.lanes = a.lanes), Zi(a, b, e);
        }
        return cj(a, b, c, d, e);
      }
      function dj(a, b, c) {
        var d = b.pendingProps,
          e = d.children,
          f = null !== a ? a.memoizedState : null;
        if ('hidden' === d.mode) {
          if (0 === (b.mode & 1))
            (b.memoizedState = {
              baseLanes: 0,
              cachePool: null,
              transitions: null,
            }),
              G(ej, fj),
              (fj |= c);
          else {
            if (0 === (c & 1073741824))
              return (
                (a = null !== f ? f.baseLanes | c : c),
                (b.lanes = b.childLanes = 1073741824),
                (b.memoizedState = {
                  baseLanes: a,
                  cachePool: null,
                  transitions: null,
                }),
                (b.updateQueue = null),
                G(ej, fj),
                (fj |= a),
                null
              );
            b.memoizedState = {
              baseLanes: 0,
              cachePool: null,
              transitions: null,
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
          }
        } else null !== f ? ((d = f.baseLanes | c), (b.memoizedState = null)) : (d = c), G(ej, fj), (fj |= d);
        Xi(a, b, e, c);
        return b.child;
      }
      function gj(a, b) {
        var c = b.ref;
        if ((null === a && null !== c) || (null !== a && a.ref !== c)) (b.flags |= 512), (b.flags |= 2097152);
      }
      function cj(a, b, c, d, e) {
        var f = Zf(c) ? Xf : H.current;
        f = Yf(b, f);
        ch(b, e);
        c = Nh(a, b, c, d, f, e);
        d = Sh();
        if (null !== a && !dh) return (b.updateQueue = a.updateQueue), (b.flags &= -2053), (a.lanes &= ~e), Zi(a, b, e);
        I && d && vg(b);
        b.flags |= 1;
        Xi(a, b, c, e);
        return b.child;
      }
      function hj(a, b, c, d, e) {
        if (Zf(c)) {
          var f = !0;
          cg(b);
        } else f = !1;
        ch(b, e);
        if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), (d = !0);
        else if (null === a) {
          var g = b.stateNode,
            h = b.memoizedProps;
          g.props = h;
          var k = g.context,
            l = c.contextType;
          'object' === typeof l && null !== l ? (l = eh(l)) : ((l = Zf(c) ? Xf : H.current), (l = Yf(b, l)));
          var m = c.getDerivedStateFromProps,
            q = 'function' === typeof m || 'function' === typeof g.getSnapshotBeforeUpdate;
          q ||
            ('function' !== typeof g.UNSAFE_componentWillReceiveProps &&
              'function' !== typeof g.componentWillReceiveProps) ||
            ((h !== d || k !== l) && Hi(b, g, d, l));
          jh = !1;
          var r = b.memoizedState;
          g.state = r;
          qh(b, d, g, e);
          k = b.memoizedState;
          h !== d || r !== k || Wf.current || jh
            ? ('function' === typeof m && (Di(b, c, m, d), (k = b.memoizedState)),
              (h = jh || Fi(b, c, h, d, r, k, l))
                ? (q ||
                    ('function' !== typeof g.UNSAFE_componentWillMount && 'function' !== typeof g.componentWillMount) ||
                    ('function' === typeof g.componentWillMount && g.componentWillMount(),
                    'function' === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()),
                  'function' === typeof g.componentDidMount && (b.flags |= 4194308))
                : ('function' === typeof g.componentDidMount && (b.flags |= 4194308),
                  (b.memoizedProps = d),
                  (b.memoizedState = k)),
              (g.props = d),
              (g.state = k),
              (g.context = l),
              (d = h))
            : ('function' === typeof g.componentDidMount && (b.flags |= 4194308), (d = !1));
        } else {
          g = b.stateNode;
          lh(a, b);
          h = b.memoizedProps;
          l = b.type === b.elementType ? h : Ci(b.type, h);
          g.props = l;
          q = b.pendingProps;
          r = g.context;
          k = c.contextType;
          'object' === typeof k && null !== k ? (k = eh(k)) : ((k = Zf(c) ? Xf : H.current), (k = Yf(b, k)));
          var y = c.getDerivedStateFromProps;
          (m = 'function' === typeof y || 'function' === typeof g.getSnapshotBeforeUpdate) ||
            ('function' !== typeof g.UNSAFE_componentWillReceiveProps &&
              'function' !== typeof g.componentWillReceiveProps) ||
            ((h !== q || r !== k) && Hi(b, g, d, k));
          jh = !1;
          r = b.memoizedState;
          g.state = r;
          qh(b, d, g, e);
          var n = b.memoizedState;
          h !== q || r !== n || Wf.current || jh
            ? ('function' === typeof y && (Di(b, c, y, d), (n = b.memoizedState)),
              (l = jh || Fi(b, c, l, d, r, n, k) || !1)
                ? (m ||
                    ('function' !== typeof g.UNSAFE_componentWillUpdate &&
                      'function' !== typeof g.componentWillUpdate) ||
                    ('function' === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k),
                    'function' === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)),
                  'function' === typeof g.componentDidUpdate && (b.flags |= 4),
                  'function' === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024))
                : ('function' !== typeof g.componentDidUpdate ||
                    (h === a.memoizedProps && r === a.memoizedState) ||
                    (b.flags |= 4),
                  'function' !== typeof g.getSnapshotBeforeUpdate ||
                    (h === a.memoizedProps && r === a.memoizedState) ||
                    (b.flags |= 1024),
                  (b.memoizedProps = d),
                  (b.memoizedState = n)),
              (g.props = d),
              (g.state = n),
              (g.context = k),
              (d = l))
            : ('function' !== typeof g.componentDidUpdate ||
                (h === a.memoizedProps && r === a.memoizedState) ||
                (b.flags |= 4),
              'function' !== typeof g.getSnapshotBeforeUpdate ||
                (h === a.memoizedProps && r === a.memoizedState) ||
                (b.flags |= 1024),
              (d = !1));
        }
        return jj(a, b, c, d, f, e);
      }
      function jj(a, b, c, d, e, f) {
        gj(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
        d = b.stateNode;
        Wi.current = b;
        var h = g && 'function' !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? ((b.child = Ug(b, a.child, null, f)), (b.child = Ug(b, null, h, f))) : Xi(a, b, h, f);
        b.memoizedState = d.state;
        e && dg(b, c, !0);
        return b.child;
      }
      function kj(a) {
        var b = a.stateNode;
        b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
        yh(a, b.containerInfo);
      }
      function lj(a, b, c, d, e) {
        Ig();
        Jg(e);
        b.flags |= 256;
        Xi(a, b, c, d);
        return b.child;
      }
      var mj = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
      };
      function nj(a) {
        return {
          baseLanes: a,
          cachePool: null,
          transitions: null,
        };
      }
      function oj(a, b, c) {
        var d = b.pendingProps,
          e = L.current,
          f = !1,
          g = 0 !== (b.flags & 128),
          h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) (f = !0), (b.flags &= -129);
        else if (null === a || null !== a.memoizedState) e |= 1;
        G(L, e & 1);
        if (null === a) {
          Eg(b);
          a = b.memoizedState;
          if (null !== a && ((a = a.dehydrated), null !== a))
            return 0 === (b.mode & 1) ? (b.lanes = 1) : '$!' === a.data ? (b.lanes = 8) : (b.lanes = 1073741824), null;
          g = d.children;
          a = d.fallback;
          return f
            ? ((d = b.mode),
              (f = b.child),
              (g = {
                mode: 'hidden',
                children: g,
              }),
              0 === (d & 1) && null !== f ? ((f.childLanes = 0), (f.pendingProps = g)) : (f = pj(g, d, 0, null)),
              (a = Tg(a, d, c, null)),
              (f.return = b),
              (a.return = b),
              (f.sibling = a),
              (b.child = f),
              (b.child.memoizedState = nj(c)),
              (b.memoizedState = mj),
              a)
            : qj(b, g);
        }
        e = a.memoizedState;
        if (null !== e && ((h = e.dehydrated), null !== h)) return rj(a, b, g, d, h, e, c);
        if (f) {
          f = d.fallback;
          g = b.mode;
          e = a.child;
          h = e.sibling;
          var k = {
            mode: 'hidden',
            children: d.children,
          };
          0 === (g & 1) && b.child !== e
            ? ((d = b.child), (d.childLanes = 0), (d.pendingProps = k), (b.deletions = null))
            : ((d = Pg(e, k)), (d.subtreeFlags = e.subtreeFlags & 14680064));
          null !== h ? (f = Pg(h, f)) : ((f = Tg(f, g, c, null)), (f.flags |= 2));
          f.return = b;
          d.return = b;
          d.sibling = f;
          b.child = d;
          d = f;
          f = b.child;
          g = a.child.memoizedState;
          g =
            null === g
              ? nj(c)
              : {
                  baseLanes: g.baseLanes | c,
                  cachePool: null,
                  transitions: g.transitions,
                };
          f.memoizedState = g;
          f.childLanes = a.childLanes & ~c;
          b.memoizedState = mj;
          return d;
        }
        f = a.child;
        a = f.sibling;
        d = Pg(f, {
          mode: 'visible',
          children: d.children,
        });
        0 === (b.mode & 1) && (d.lanes = c);
        d.return = b;
        d.sibling = null;
        null !== a && ((c = b.deletions), null === c ? ((b.deletions = [a]), (b.flags |= 16)) : c.push(a));
        b.child = d;
        b.memoizedState = null;
        return d;
      }
      function qj(a, b) {
        b = pj(
          {
            mode: 'visible',
            children: b,
          },
          a.mode,
          0,
          null,
        );
        b.return = a;
        return (a.child = b);
      }
      function sj(a, b, c, d) {
        null !== d && Jg(d);
        Ug(b, a.child, null, c);
        a = qj(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
      }
      function rj(a, b, c, d, e, f, g) {
        if (c) {
          if (b.flags & 256) return (b.flags &= -257), (d = Ki(Error(p(422)))), sj(a, b, g, d);
          if (null !== b.memoizedState) return (b.child = a.child), (b.flags |= 128), null;
          f = d.fallback;
          e = b.mode;
          d = pj(
            {
              mode: 'visible',
              children: d.children,
            },
            e,
            0,
            null,
          );
          f = Tg(f, e, g, null);
          f.flags |= 2;
          d.return = b;
          f.return = b;
          d.sibling = f;
          b.child = d;
          0 !== (b.mode & 1) && Ug(b, a.child, null, g);
          b.child.memoizedState = nj(g);
          b.memoizedState = mj;
          return f;
        }
        if (0 === (b.mode & 1)) return sj(a, b, g, null);
        if ('$!' === e.data) {
          d = e.nextSibling && e.nextSibling.dataset;
          if (d) var h = d.dgst;
          d = h;
          f = Error(p(419));
          d = Ki(f, d, void 0);
          return sj(a, b, g, d);
        }
        h = 0 !== (g & a.childLanes);
        if (dh || h) {
          d = Q;
          if (null !== d) {
            switch (g & -g) {
              case 4:
                e = 2;
                break;
              case 16:
                e = 8;
                break;
              case 64:
              case 128:
              case 256:
              case 512:
              case 1024:
              case 2048:
              case 4096:
              case 8192:
              case 16384:
              case 32768:
              case 65536:
              case 131072:
              case 262144:
              case 524288:
              case 1048576:
              case 2097152:
              case 4194304:
              case 8388608:
              case 16777216:
              case 33554432:
              case 67108864:
                e = 32;
                break;
              case 536870912:
                e = 268435456;
                break;
              default:
                e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && ((f.retryLane = e), ih(a, e), gi(d, a, e, -1));
          }
          tj();
          d = Ki(Error(p(421)));
          return sj(a, b, g, d);
        }
        if ('$?' === e.data)
          return (b.flags |= 128), (b.child = a.child), (b = uj.bind(null, a)), (e._reactRetry = b), null;
        a = f.treeContext;
        yg = Lf(e.nextSibling);
        xg = b;
        I = !0;
        zg = null;
        null !== a && ((og[pg++] = rg), (og[pg++] = sg), (og[pg++] = qg), (rg = a.id), (sg = a.overflow), (qg = b));
        b = qj(b, d.children);
        b.flags |= 4096;
        return b;
      }
      function vj(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        bh(a.return, b, c);
      }
      function wj(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f
          ? (a.memoizedState = {
              isBackwards: b,
              rendering: null,
              renderingStartTime: 0,
              last: d,
              tail: c,
              tailMode: e,
            })
          : ((f.isBackwards = b),
            (f.rendering = null),
            (f.renderingStartTime = 0),
            (f.last = d),
            (f.tail = c),
            (f.tailMode = e));
      }
      function xj(a, b, c) {
        var d = b.pendingProps,
          e = d.revealOrder,
          f = d.tail;
        Xi(a, b, d.children, c);
        d = L.current;
        if (0 !== (d & 2)) (d = (d & 1) | 2), (b.flags |= 128);
        else {
          if (null !== a && 0 !== (a.flags & 128))
            a: for (a = b.child; null !== a; ) {
              if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
              else if (19 === a.tag) vj(a, c, b);
              else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
              }
              if (a === b) break a;
              for (; null === a.sibling; ) {
                if (null === a.return || a.return === b) break a;
                a = a.return;
              }
              a.sibling.return = a.return;
              a = a.sibling;
            }
          d &= 1;
        }
        G(L, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else
          switch (e) {
            case 'forwards':
              c = b.child;
              for (e = null; null !== c; ) (a = c.alternate), null !== a && null === Ch(a) && (e = c), (c = c.sibling);
              c = e;
              null === c ? ((e = b.child), (b.child = null)) : ((e = c.sibling), (c.sibling = null));
              wj(b, !1, e, c, f);
              break;
            case 'backwards':
              c = null;
              e = b.child;
              for (b.child = null; null !== e; ) {
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                  b.child = e;
                  break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
              }
              wj(b, !0, c, null, f);
              break;
            case 'together':
              wj(b, !1, null, null, void 0);
              break;
            default:
              b.memoizedState = null;
          }
        return b.child;
      }
      function ij(a, b) {
        0 === (b.mode & 1) && null !== a && ((a.alternate = null), (b.alternate = null), (b.flags |= 2));
      }
      function Zi(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        rh |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(p(153));
        if (null !== b.child) {
          a = b.child;
          c = Pg(a, a.pendingProps);
          b.child = c;
          for (c.return = b; null !== a.sibling; )
            (a = a.sibling), (c = c.sibling = Pg(a, a.pendingProps)), (c.return = b);
          c.sibling = null;
        }
        return b.child;
      }
      function yj(a, b, c) {
        switch (b.tag) {
          case 3:
            kj(b);
            Ig();
            break;
          case 5:
            Ah(b);
            break;
          case 1:
            Zf(b.type) && cg(b);
            break;
          case 4:
            yh(b, b.stateNode.containerInfo);
            break;
          case 10:
            var d = b.type._context,
              e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
          case 13:
            d = b.memoizedState;
            if (null !== d) {
              if (null !== d.dehydrated) return G(L, L.current & 1), (b.flags |= 128), null;
              if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
              G(L, L.current & 1);
              a = Zi(a, b, c);
              return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
          case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
              if (d) return xj(a, b, c);
              b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && ((e.rendering = null), (e.tail = null), (e.lastEffect = null));
            G(L, L.current);
            if (d) break;
            else return null;
          case 22:
          case 23:
            return (b.lanes = 0), dj(a, b, c);
        }
        return Zi(a, b, c);
      }
      var zj, Aj, Bj, Cj;
      zj = function (a, b) {
        for (var c = b.child; null !== c; ) {
          if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
          else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
          }
          if (c === b) break;
          for (; null === c.sibling; ) {
            if (null === c.return || c.return === b) return;
            c = c.return;
          }
          c.sibling.return = c.return;
          c = c.sibling;
        }
      };
      Aj = function () {};
      Bj = function (a, b, c, d) {
        var e = a.memoizedProps;
        if (e !== d) {
          a = b.stateNode;
          xh(uh.current);
          var f = null;
          switch (c) {
            case 'input':
              e = Ya(a, e);
              d = Ya(a, d);
              f = [];
              break;
            case 'select':
              e = A({}, e, {
                value: void 0,
              });
              d = A({}, d, {
                value: void 0,
              });
              f = [];
              break;
            case 'textarea':
              e = gb(a, e);
              d = gb(a, d);
              f = [];
              break;
            default:
              'function' !== typeof e.onClick && 'function' === typeof d.onClick && (a.onclick = Bf);
          }
          ub(c, d);
          var g;
          c = null;
          for (l in e)
            if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l])
              if ('style' === l) {
                var h = e[l];
                for (g in h) h.hasOwnProperty(g) && (c || (c = {}), (c[g] = ''));
              } else
                'dangerouslySetInnerHTML' !== l &&
                  'children' !== l &&
                  'suppressContentEditableWarning' !== l &&
                  'suppressHydrationWarning' !== l &&
                  'autoFocus' !== l &&
                  (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
          for (l in d) {
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h))
              if ('style' === l) {
                if (h) {
                  for (g in h) !h.hasOwnProperty(g) || (k && k.hasOwnProperty(g)) || (c || (c = {}), (c[g] = ''));
                  for (g in k) k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), (c[g] = k[g]));
                } else c || (f || (f = []), f.push(l, c)), (c = k);
              } else
                'dangerouslySetInnerHTML' === l
                  ? ((k = k ? k.__html : void 0),
                    (h = h ? h.__html : void 0),
                    null != k && h !== k && (f = f || []).push(l, k))
                  : 'children' === l
                    ? ('string' !== typeof k && 'number' !== typeof k) || (f = f || []).push(l, '' + k)
                    : 'suppressContentEditableWarning' !== l &&
                      'suppressHydrationWarning' !== l &&
                      (ea.hasOwnProperty(l)
                        ? (null != k && 'onScroll' === l && D('scroll', a), f || h === k || (f = []))
                        : (f = f || []).push(l, k));
          }
          c && (f = f || []).push('style', c);
          var l = f;
          if ((b.updateQueue = l)) b.flags |= 4;
        }
      };
      Cj = function (a, b, c, d) {
        c !== d && (b.flags |= 4);
      };
      function Dj(a, b) {
        if (!I)
          switch (a.tailMode) {
            case 'hidden':
              b = a.tail;
              for (var c = null; null !== b; ) null !== b.alternate && (c = b), (b = b.sibling);
              null === c ? (a.tail = null) : (c.sibling = null);
              break;
            case 'collapsed':
              c = a.tail;
              for (var d = null; null !== c; ) null !== c.alternate && (d = c), (c = c.sibling);
              null === d ? (b || null === a.tail ? (a.tail = null) : (a.tail.sibling = null)) : (d.sibling = null);
          }
      }
      function S(a) {
        var b = null !== a.alternate && a.alternate.child === a.child,
          c = 0,
          d = 0;
        if (b)
          for (var e = a.child; null !== e; )
            (c |= e.lanes | e.childLanes),
              (d |= e.subtreeFlags & 14680064),
              (d |= e.flags & 14680064),
              (e.return = a),
              (e = e.sibling);
        else
          for (e = a.child; null !== e; )
            (c |= e.lanes | e.childLanes), (d |= e.subtreeFlags), (d |= e.flags), (e.return = a), (e = e.sibling);
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
      }
      function Ej(a, b, c) {
        var d = b.pendingProps;
        wg(b);
        switch (b.tag) {
          case 2:
          case 16:
          case 15:
          case 0:
          case 11:
          case 7:
          case 8:
          case 12:
          case 9:
          case 14:
            return S(b), null;
          case 1:
            return Zf(b.type) && $f(), S(b), null;
          case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && ((d.context = d.pendingContext), (d.pendingContext = null));
            if (null === a || null === a.child)
              Gg(b)
                ? (b.flags |= 4)
                : null === a ||
                  (a.memoizedState.isDehydrated && 0 === (b.flags & 256)) ||
                  ((b.flags |= 1024), null !== zg && (Fj(zg), (zg = null)));
            Aj(a, b);
            S(b);
            return null;
          case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode)
              Bj(a, b, c, d, e), a.ref !== b.ref && ((b.flags |= 512), (b.flags |= 2097152));
            else {
              if (!d) {
                if (null === b.stateNode) throw Error(p(166));
                S(b);
                return null;
              }
              a = xh(uh.current);
              if (Gg(b)) {
                d = b.stateNode;
                c = b.type;
                var f = b.memoizedProps;
                d[Of] = b;
                d[Pf] = f;
                a = 0 !== (b.mode & 1);
                switch (c) {
                  case 'dialog':
                    D('cancel', d);
                    D('close', d);
                    break;
                  case 'iframe':
                  case 'object':
                  case 'embed':
                    D('load', d);
                    break;
                  case 'video':
                  case 'audio':
                    for (e = 0; e < lf.length; e++) D(lf[e], d);
                    break;
                  case 'source':
                    D('error', d);
                    break;
                  case 'img':
                  case 'image':
                  case 'link':
                    D('error', d);
                    D('load', d);
                    break;
                  case 'details':
                    D('toggle', d);
                    break;
                  case 'input':
                    Za(d, f);
                    D('invalid', d);
                    break;
                  case 'select':
                    d._wrapperState = {
                      wasMultiple: !!f.multiple,
                    };
                    D('invalid', d);
                    break;
                  case 'textarea':
                    hb(d, f), D('invalid', d);
                }
                ub(c, f);
                e = null;
                for (var g in f)
                  if (f.hasOwnProperty(g)) {
                    var h = f[g];
                    'children' === g
                      ? 'string' === typeof h
                        ? d.textContent !== h &&
                          (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), (e = ['children', h]))
                        : 'number' === typeof h &&
                          d.textContent !== '' + h &&
                          (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), (e = ['children', '' + h]))
                      : ea.hasOwnProperty(g) && null != h && 'onScroll' === g && D('scroll', d);
                  }
                switch (c) {
                  case 'input':
                    Va(d);
                    db(d, f, !0);
                    break;
                  case 'textarea':
                    Va(d);
                    jb(d);
                    break;
                  case 'select':
                  case 'option':
                    break;
                  default:
                    'function' === typeof f.onClick && (d.onclick = Bf);
                }
                d = e;
                b.updateQueue = d;
                null !== d && (b.flags |= 4);
              } else {
                g = 9 === e.nodeType ? e : e.ownerDocument;
                'http://www.w3.org/1999/xhtml' === a && (a = kb(c));
                'http://www.w3.org/1999/xhtml' === a
                  ? 'script' === c
                    ? ((a = g.createElement('div')),
                      (a.innerHTML = '<script>\x3c/script>'),
                      (a = a.removeChild(a.firstChild)))
                    : 'string' === typeof d.is
                      ? (a = g.createElement(c, {
                          is: d.is,
                        }))
                      : ((a = g.createElement(c)),
                        'select' === c && ((g = a), d.multiple ? (g.multiple = !0) : d.size && (g.size = d.size)))
                  : (a = g.createElementNS(a, c));
                a[Of] = b;
                a[Pf] = d;
                zj(a, b, !1, !1);
                b.stateNode = a;
                a: {
                  g = vb(c, d);
                  switch (c) {
                    case 'dialog':
                      D('cancel', a);
                      D('close', a);
                      e = d;
                      break;
                    case 'iframe':
                    case 'object':
                    case 'embed':
                      D('load', a);
                      e = d;
                      break;
                    case 'video':
                    case 'audio':
                      for (e = 0; e < lf.length; e++) D(lf[e], a);
                      e = d;
                      break;
                    case 'source':
                      D('error', a);
                      e = d;
                      break;
                    case 'img':
                    case 'image':
                    case 'link':
                      D('error', a);
                      D('load', a);
                      e = d;
                      break;
                    case 'details':
                      D('toggle', a);
                      e = d;
                      break;
                    case 'input':
                      Za(a, d);
                      e = Ya(a, d);
                      D('invalid', a);
                      break;
                    case 'option':
                      e = d;
                      break;
                    case 'select':
                      a._wrapperState = {
                        wasMultiple: !!d.multiple,
                      };
                      e = A({}, d, {
                        value: void 0,
                      });
                      D('invalid', a);
                      break;
                    case 'textarea':
                      hb(a, d);
                      e = gb(a, d);
                      D('invalid', a);
                      break;
                    default:
                      e = d;
                  }
                  ub(c, e);
                  h = e;
                  for (f in h)
                    if (h.hasOwnProperty(f)) {
                      var k = h[f];
                      'style' === f
                        ? sb(a, k)
                        : 'dangerouslySetInnerHTML' === f
                          ? ((k = k ? k.__html : void 0), null != k && nb(a, k))
                          : 'children' === f
                            ? 'string' === typeof k
                              ? ('textarea' !== c || '' !== k) && ob(a, k)
                              : 'number' === typeof k && ob(a, '' + k)
                            : 'suppressContentEditableWarning' !== f &&
                              'suppressHydrationWarning' !== f &&
                              'autoFocus' !== f &&
                              (ea.hasOwnProperty(f)
                                ? null != k && 'onScroll' === f && D('scroll', a)
                                : null != k && ta(a, f, k, g));
                    }
                  switch (c) {
                    case 'input':
                      Va(a);
                      db(a, d, !1);
                      break;
                    case 'textarea':
                      Va(a);
                      jb(a);
                      break;
                    case 'option':
                      null != d.value && a.setAttribute('value', '' + Sa(d.value));
                      break;
                    case 'select':
                      a.multiple = !!d.multiple;
                      f = d.value;
                      null != f
                        ? fb(a, !!d.multiple, f, !1)
                        : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                      break;
                    default:
                      'function' === typeof e.onClick && (a.onclick = Bf);
                  }
                  switch (c) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      d = !!d.autoFocus;
                      break a;
                    case 'img':
                      d = !0;
                      break a;
                    default:
                      d = !1;
                  }
                }
                d && (b.flags |= 4);
              }
              null !== b.ref && ((b.flags |= 512), (b.flags |= 2097152));
            }
            S(b);
            return null;
          case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
              if ('string' !== typeof d && null === b.stateNode) throw Error(p(166));
              c = xh(wh.current);
              xh(uh.current);
              if (Gg(b)) {
                d = b.stateNode;
                c = b.memoizedProps;
                d[Of] = b;
                if ((f = d.nodeValue !== c))
                  if (((a = xg), null !== a))
                    switch (a.tag) {
                      case 3:
                        Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        break;
                      case 5:
                        !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                    }
                f && (b.flags |= 4);
              } else (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d)), (d[Of] = b), (b.stateNode = d);
            }
            S(b);
            return null;
          case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || (null !== a.memoizedState && null !== a.memoizedState.dehydrated)) {
              if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128))
                Hg(), Ig(), (b.flags |= 98560), (f = !1);
              else if (((f = Gg(b)), null !== d && null !== d.dehydrated)) {
                if (null === a) {
                  if (!f) throw Error(p(318));
                  f = b.memoizedState;
                  f = null !== f ? f.dehydrated : null;
                  if (!f) throw Error(p(317));
                  f[Of] = b;
                } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), (b.flags |= 4);
                S(b);
                f = !1;
              } else null !== zg && (Fj(zg), (zg = null)), (f = !0);
              if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return (b.lanes = c), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) &&
              d &&
              ((b.child.flags |= 8192),
              0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
          case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
          case 10:
            return ah(b.type._context), S(b), null;
          case 17:
            return Zf(b.type) && $f(), S(b), null;
          case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
              if (d) Dj(f, !1);
              else {
                if (0 !== T || (null !== a && 0 !== (a.flags & 128)))
                  for (a = b.child; null !== a; ) {
                    g = Ch(a);
                    if (null !== g) {
                      b.flags |= 128;
                      Dj(f, !1);
                      d = g.updateQueue;
                      null !== d && ((b.updateQueue = d), (b.flags |= 4));
                      b.subtreeFlags = 0;
                      d = c;
                      for (c = b.child; null !== c; )
                        (f = c),
                          (a = d),
                          (f.flags &= 14680066),
                          (g = f.alternate),
                          null === g
                            ? ((f.childLanes = 0),
                              (f.lanes = a),
                              (f.child = null),
                              (f.subtreeFlags = 0),
                              (f.memoizedProps = null),
                              (f.memoizedState = null),
                              (f.updateQueue = null),
                              (f.dependencies = null),
                              (f.stateNode = null))
                            : ((f.childLanes = g.childLanes),
                              (f.lanes = g.lanes),
                              (f.child = g.child),
                              (f.subtreeFlags = 0),
                              (f.deletions = null),
                              (f.memoizedProps = g.memoizedProps),
                              (f.memoizedState = g.memoizedState),
                              (f.updateQueue = g.updateQueue),
                              (f.type = g.type),
                              (a = g.dependencies),
                              (f.dependencies =
                                null === a
                                  ? null
                                  : {
                                      lanes: a.lanes,
                                      firstContext: a.firstContext,
                                    })),
                          (c = c.sibling);
                      G(L, (L.current & 1) | 2);
                      return b.child;
                    }
                    a = a.sibling;
                  }
                null !== f.tail && B() > Gj && ((b.flags |= 128), (d = !0), Dj(f, !1), (b.lanes = 4194304));
              }
            } else {
              if (!d)
                if (((a = Ch(g)), null !== a)) {
                  if (
                    ((b.flags |= 128),
                    (d = !0),
                    (c = a.updateQueue),
                    null !== c && ((b.updateQueue = c), (b.flags |= 4)),
                    Dj(f, !0),
                    null === f.tail && 'hidden' === f.tailMode && !g.alternate && !I)
                  )
                    return S(b), null;
                } else
                  2 * B() - f.renderingStartTime > Gj &&
                    1073741824 !== c &&
                    ((b.flags |= 128), (d = !0), Dj(f, !1), (b.lanes = 4194304));
              f.isBackwards
                ? ((g.sibling = b.child), (b.child = g))
                : ((c = f.last), null !== c ? (c.sibling = g) : (b.child = g), (f.last = g));
            }
            if (null !== f.tail)
              return (
                (b = f.tail),
                (f.rendering = b),
                (f.tail = b.sibling),
                (f.renderingStartTime = B()),
                (b.sibling = null),
                (c = L.current),
                G(L, d ? (c & 1) | 2 : c & 1),
                b
              );
            S(b);
            return null;
          case 22:
          case 23:
            return (
              Hj(),
              (d = null !== b.memoizedState),
              null !== a && (null !== a.memoizedState) !== d && (b.flags |= 8192),
              d && 0 !== (b.mode & 1)
                ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192))
                : S(b),
              null
            );
          case 24:
            return null;
          case 25:
            return null;
        }
        throw Error(p(156, b.tag));
      }
      function Ij(a, b) {
        wg(b);
        switch (b.tag) {
          case 1:
            return Zf(b.type) && $f(), (a = b.flags), a & 65536 ? ((b.flags = (a & -65537) | 128), b) : null;
          case 3:
            return (
              zh(),
              E(Wf),
              E(H),
              Eh(),
              (a = b.flags),
              0 !== (a & 65536) && 0 === (a & 128) ? ((b.flags = (a & -65537) | 128), b) : null
            );
          case 5:
            return Bh(b), null;
          case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
              if (null === b.alternate) throw Error(p(340));
              Ig();
            }
            a = b.flags;
            return a & 65536 ? ((b.flags = (a & -65537) | 128), b) : null;
          case 19:
            return E(L), null;
          case 4:
            return zh(), null;
          case 10:
            return ah(b.type._context), null;
          case 22:
          case 23:
            return Hj(), null;
          case 24:
            return null;
          default:
            return null;
        }
      }
      var Jj = !1,
        U = !1,
        Kj = 'function' === typeof WeakSet ? WeakSet : Set,
        V = null;
      function Lj(a, b) {
        var c = a.ref;
        if (null !== c)
          if ('function' === typeof c)
            try {
              c(null);
            } catch (d) {
              W(a, b, d);
            }
          else c.current = null;
      }
      function Mj(a, b, c) {
        try {
          c();
        } catch (d) {
          W(a, b, d);
        }
      }
      var Nj = !1;
      function Oj(a, b) {
        Cf = dd;
        a = Me();
        if (Ne(a)) {
          if ('selectionStart' in a)
            var c = {
              start: a.selectionStart,
              end: a.selectionEnd,
            };
          else
            a: {
              c = ((c = a.ownerDocument) && c.defaultView) || window;
              var d = c.getSelection && c.getSelection();
              if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset,
                  f = d.focusNode;
                d = d.focusOffset;
                try {
                  c.nodeType, f.nodeType;
                } catch (F) {
                  c = null;
                  break a;
                }
                var g = 0,
                  h = -1,
                  k = -1,
                  l = 0,
                  m = 0,
                  q = a,
                  r = null;
                b: for (;;) {
                  for (var y; ; ) {
                    q !== c || (0 !== e && 3 !== q.nodeType) || (h = g + e);
                    q !== f || (0 !== d && 3 !== q.nodeType) || (k = g + d);
                    3 === q.nodeType && (g += q.nodeValue.length);
                    if (null === (y = q.firstChild)) break;
                    r = q;
                    q = y;
                  }
                  for (;;) {
                    if (q === a) break b;
                    r === c && ++l === e && (h = g);
                    r === f && ++m === d && (k = g);
                    if (null !== (y = q.nextSibling)) break;
                    q = r;
                    r = q.parentNode;
                  }
                  q = y;
                }
                c =
                  -1 === h || -1 === k
                    ? null
                    : {
                        start: h,
                        end: k,
                      };
              } else c = null;
            }
          c = c || {
            start: 0,
            end: 0,
          };
        } else c = null;
        Df = {
          focusedElem: a,
          selectionRange: c,
        };
        dd = !1;
        for (V = b; null !== V; )
          if (((b = V), (a = b.child), 0 !== (b.subtreeFlags & 1028) && null !== a)) (a.return = b), (V = a);
          else
            for (; null !== V; ) {
              b = V;
              try {
                var n = b.alternate;
                if (0 !== (b.flags & 1024))
                  switch (b.tag) {
                    case 0:
                    case 11:
                    case 15:
                      break;
                    case 1:
                      if (null !== n) {
                        var t = n.memoizedProps,
                          J = n.memoizedState,
                          x = b.stateNode,
                          w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                      }
                      break;
                    case 3:
                      var u = b.stateNode.containerInfo;
                      1 === u.nodeType
                        ? (u.textContent = '')
                        : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                      break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                      break;
                    default:
                      throw Error(p(163));
                  }
              } catch (F) {
                W(b, b.return, F);
              }
              a = b.sibling;
              if (null !== a) {
                a.return = b.return;
                V = a;
                break;
              }
              V = b.return;
            }
        n = Nj;
        Nj = !1;
        return n;
      }
      function Pj(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
          var e = (d = d.next);
          do {
            if ((e.tag & a) === a) {
              var f = e.destroy;
              e.destroy = void 0;
              void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
          } while (e !== d);
        }
      }
      function Qj(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
          var c = (b = b.next);
          do {
            if ((c.tag & a) === a) {
              var d = c.create;
              c.destroy = d();
            }
            c = c.next;
          } while (c !== b);
        }
      }
      function Rj(a) {
        var b = a.ref;
        if (null !== b) {
          var c = a.stateNode;
          switch (a.tag) {
            case 5:
              a = c;
              break;
            default:
              a = c;
          }
          'function' === typeof b ? b(a) : (b.current = a);
        }
      }
      function Sj(a) {
        var b = a.alternate;
        null !== b && ((a.alternate = null), Sj(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag &&
          ((b = a.stateNode), null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
      }
      function Tj(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
      }
      function Uj(a) {
        a: for (;;) {
          for (; null === a.sibling; ) {
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
          }
          a.sibling.return = a.return;
          for (a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag; ) {
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else (a.child.return = a), (a = a.child);
          }
          if (!(a.flags & 2)) return a.stateNode;
        }
      }
      function Vj(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d)
          (a = a.stateNode),
            b
              ? 8 === c.nodeType
                ? c.parentNode.insertBefore(a, b)
                : c.insertBefore(a, b)
              : (8 === c.nodeType ? ((b = c.parentNode), b.insertBefore(a, c)) : ((b = c), b.appendChild(a)),
                (c = c._reactRootContainer),
                (null !== c && void 0 !== c) || null !== b.onclick || (b.onclick = Bf));
        else if (4 !== d && ((a = a.child), null !== a))
          for (Vj(a, b, c), a = a.sibling; null !== a; ) Vj(a, b, c), (a = a.sibling);
      }
      function Wj(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) (a = a.stateNode), b ? c.insertBefore(a, b) : c.appendChild(a);
        else if (4 !== d && ((a = a.child), null !== a))
          for (Wj(a, b, c), a = a.sibling; null !== a; ) Wj(a, b, c), (a = a.sibling);
      }
      var X = null,
        Xj = !1;
      function Yj(a, b, c) {
        for (c = c.child; null !== c; ) Zj(a, b, c), (c = c.sibling);
      }
      function Zj(a, b, c) {
        if (lc && 'function' === typeof lc.onCommitFiberUnmount)
          try {
            lc.onCommitFiberUnmount(kc, c);
          } catch (h) {}
        switch (c.tag) {
          case 5:
            U || Lj(c, b);
          case 6:
            var d = X,
              e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X &&
              (Xj
                ? ((a = X), (c = c.stateNode), 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c))
                : X.removeChild(c.stateNode));
            break;
          case 18:
            null !== X &&
              (Xj
                ? ((a = X),
                  (c = c.stateNode),
                  8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c),
                  bd(a))
                : Kf(X, c.stateNode));
            break;
          case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
          case 0:
          case 11:
          case 14:
          case 15:
            if (!U && ((d = c.updateQueue), null !== d && ((d = d.lastEffect), null !== d))) {
              e = d = d.next;
              do {
                var f = e,
                  g = f.destroy;
                f = f.tag;
                void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                e = e.next;
              } while (e !== d);
            }
            Yj(a, b, c);
            break;
          case 1:
            if (!U && (Lj(c, b), (d = c.stateNode), 'function' === typeof d.componentWillUnmount))
              try {
                (d.props = c.memoizedProps), (d.state = c.memoizedState), d.componentWillUnmount();
              } catch (h) {
                W(c, b, h);
              }
            Yj(a, b, c);
            break;
          case 21:
            Yj(a, b, c);
            break;
          case 22:
            c.mode & 1 ? ((U = (d = U) || null !== c.memoizedState), Yj(a, b, c), (U = d)) : Yj(a, b, c);
            break;
          default:
            Yj(a, b, c);
        }
      }
      function ak(a) {
        var b = a.updateQueue;
        if (null !== b) {
          a.updateQueue = null;
          var c = a.stateNode;
          null === c && (c = a.stateNode = new Kj());
          b.forEach(function (b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
          });
        }
      }
      function ck(a, b) {
        var c = b.deletions;
        if (null !== c)
          for (var d = 0; d < c.length; d++) {
            var e = c[d];
            try {
              var f = a,
                g = b,
                h = g;
              a: for (; null !== h; ) {
                switch (h.tag) {
                  case 5:
                    X = h.stateNode;
                    Xj = !1;
                    break a;
                  case 3:
                    X = h.stateNode.containerInfo;
                    Xj = !0;
                    break a;
                  case 4:
                    X = h.stateNode.containerInfo;
                    Xj = !0;
                    break a;
                }
                h = h.return;
              }
              if (null === X) throw Error(p(160));
              Zj(f, g, e);
              X = null;
              Xj = !1;
              var k = e.alternate;
              null !== k && (k.return = null);
              e.return = null;
            } catch (l) {
              W(e, b, l);
            }
          }
        if (b.subtreeFlags & 12854) for (b = b.child; null !== b; ) dk(b, a), (b = b.sibling);
      }
      function dk(a, b) {
        var c = a.alternate,
          d = a.flags;
        switch (a.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
              try {
                Pj(3, a, a.return), Qj(3, a);
              } catch (t) {
                W(a, a.return, t);
              }
              try {
                Pj(5, a, a.return);
              } catch (t) {
                W(a, a.return, t);
              }
            }
            break;
          case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
          case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
              var e = a.stateNode;
              try {
                ob(e, '');
              } catch (t) {
                W(a, a.return, t);
              }
            }
            if (d & 4 && ((e = a.stateNode), null != e)) {
              var f = a.memoizedProps,
                g = null !== c ? c.memoizedProps : f,
                h = a.type,
                k = a.updateQueue;
              a.updateQueue = null;
              if (null !== k)
                try {
                  'input' === h && 'radio' === f.type && null != f.name && ab(e, f);
                  vb(h, g);
                  var l = vb(h, f);
                  for (g = 0; g < k.length; g += 2) {
                    var m = k[g],
                      q = k[g + 1];
                    'style' === m
                      ? sb(e, q)
                      : 'dangerouslySetInnerHTML' === m
                        ? nb(e, q)
                        : 'children' === m
                          ? ob(e, q)
                          : ta(e, m, q, l);
                  }
                  switch (h) {
                    case 'input':
                      bb(e, f);
                      break;
                    case 'textarea':
                      ib(e, f);
                      break;
                    case 'select':
                      var r = e._wrapperState.wasMultiple;
                      e._wrapperState.wasMultiple = !!f.multiple;
                      var y = f.value;
                      null != y
                        ? fb(e, !!f.multiple, y, !1)
                        : r !== !!f.multiple &&
                          (null != f.defaultValue
                            ? fb(e, !!f.multiple, f.defaultValue, !0)
                            : fb(e, !!f.multiple, f.multiple ? [] : '', !1));
                  }
                  e[Pf] = f;
                } catch (t) {
                  W(a, a.return, t);
                }
            }
            break;
          case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
              if (null === a.stateNode) throw Error(p(162));
              e = a.stateNode;
              f = a.memoizedProps;
              try {
                e.nodeValue = f;
              } catch (t) {
                W(a, a.return, t);
              }
            }
            break;
          case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated)
              try {
                bd(b.containerInfo);
              } catch (t) {
                W(a, a.return, t);
              }
            break;
          case 4:
            ck(b, a);
            ek(a);
            break;
          case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 &&
              ((f = null !== e.memoizedState),
              (e.stateNode.isHidden = f),
              !f || (null !== e.alternate && null !== e.alternate.memoizedState) || (fk = B()));
            d & 4 && ak(a);
            break;
          case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ((U = (l = U) || m), ck(b, a), (U = l)) : ck(b, a);
            ek(a);
            if (d & 8192) {
              l = null !== a.memoizedState;
              if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1))
                for (V = a, m = a.child; null !== m; ) {
                  for (q = V = m; null !== V; ) {
                    r = V;
                    y = r.child;
                    switch (r.tag) {
                      case 0:
                      case 11:
                      case 14:
                      case 15:
                        Pj(4, r, r.return);
                        break;
                      case 1:
                        Lj(r, r.return);
                        var n = r.stateNode;
                        if ('function' === typeof n.componentWillUnmount) {
                          d = r;
                          c = r.return;
                          try {
                            (b = d), (n.props = b.memoizedProps), (n.state = b.memoizedState), n.componentWillUnmount();
                          } catch (t) {
                            W(d, c, t);
                          }
                        }
                        break;
                      case 5:
                        Lj(r, r.return);
                        break;
                      case 22:
                        if (null !== r.memoizedState) {
                          gk(q);
                          continue;
                        }
                    }
                    null !== y ? ((y.return = r), (V = y)) : gk(q);
                  }
                  m = m.sibling;
                }
              a: for (m = null, q = a; ; ) {
                if (5 === q.tag) {
                  if (null === m) {
                    m = q;
                    try {
                      (e = q.stateNode),
                        l
                          ? ((f = e.style),
                            'function' === typeof f.setProperty
                              ? f.setProperty('display', 'none', 'important')
                              : (f.display = 'none'))
                          : ((h = q.stateNode),
                            (k = q.memoizedProps.style),
                            (g = void 0 !== k && null !== k && k.hasOwnProperty('display') ? k.display : null),
                            (h.style.display = rb('display', g)));
                    } catch (t) {
                      W(a, a.return, t);
                    }
                  }
                } else if (6 === q.tag) {
                  if (null === m)
                    try {
                      q.stateNode.nodeValue = l ? '' : q.memoizedProps;
                    } catch (t) {
                      W(a, a.return, t);
                    }
                } else if (
                  ((22 !== q.tag && 23 !== q.tag) || null === q.memoizedState || q === a) &&
                  null !== q.child
                ) {
                  q.child.return = q;
                  q = q.child;
                  continue;
                }
                if (q === a) break a;
                for (; null === q.sibling; ) {
                  if (null === q.return || q.return === a) break a;
                  m === q && (m = null);
                  q = q.return;
                }
                m === q && (m = null);
                q.sibling.return = q.return;
                q = q.sibling;
              }
            }
            break;
          case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
          case 21:
            break;
          default:
            ck(b, a), ek(a);
        }
      }
      function ek(a) {
        var b = a.flags;
        if (b & 2) {
          try {
            a: {
              for (var c = a.return; null !== c; ) {
                if (Tj(c)) {
                  var d = c;
                  break a;
                }
                c = c.return;
              }
              throw Error(p(160));
            }
            switch (d.tag) {
              case 5:
                var e = d.stateNode;
                d.flags & 32 && (ob(e, ''), (d.flags &= -33));
                var f = Uj(a);
                Wj(a, f, e);
                break;
              case 3:
              case 4:
                var g = d.stateNode.containerInfo,
                  h = Uj(a);
                Vj(a, h, g);
                break;
              default:
                throw Error(p(161));
            }
          } catch (k) {
            W(a, a.return, k);
          }
          a.flags &= -3;
        }
        b & 4096 && (a.flags &= -4097);
      }
      function hk(a, b, c) {
        V = a;
        ik(a, b, c);
      }
      function ik(a, b, c) {
        for (var d = 0 !== (a.mode & 1); null !== V; ) {
          var e = V,
            f = e.child;
          if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
              var h = e.alternate,
                k = (null !== h && null !== h.memoizedState) || U;
              h = Jj;
              var l = U;
              Jj = g;
              if ((U = k) && !l)
                for (V = e; null !== V; )
                  (g = V),
                    (k = g.child),
                    22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? ((k.return = g), (V = k)) : jk(e);
              for (; null !== f; ) (V = f), ik(f, b, c), (f = f.sibling);
              V = e;
              Jj = h;
              U = l;
            }
            kk(a, b, c);
          } else 0 !== (e.subtreeFlags & 8772) && null !== f ? ((f.return = e), (V = f)) : kk(a, b, c);
        }
      }
      function kk(a) {
        for (; null !== V; ) {
          var b = V;
          if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
              if (0 !== (b.flags & 8772))
                switch (b.tag) {
                  case 0:
                  case 11:
                  case 15:
                    U || Qj(5, b);
                    break;
                  case 1:
                    var d = b.stateNode;
                    if (b.flags & 4 && !U)
                      if (null === c) d.componentDidMount();
                      else {
                        var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                        d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                      }
                    var f = b.updateQueue;
                    null !== f && sh(b, f, d);
                    break;
                  case 3:
                    var g = b.updateQueue;
                    if (null !== g) {
                      c = null;
                      if (null !== b.child)
                        switch (b.child.tag) {
                          case 5:
                            c = b.child.stateNode;
                            break;
                          case 1:
                            c = b.child.stateNode;
                        }
                      sh(b, g, c);
                    }
                    break;
                  case 5:
                    var h = b.stateNode;
                    if (null === c && b.flags & 4) {
                      c = h;
                      var k = b.memoizedProps;
                      switch (b.type) {
                        case 'button':
                        case 'input':
                        case 'select':
                        case 'textarea':
                          k.autoFocus && c.focus();
                          break;
                        case 'img':
                          k.src && (c.src = k.src);
                      }
                    }
                    break;
                  case 6:
                    break;
                  case 4:
                    break;
                  case 12:
                    break;
                  case 13:
                    if (null === b.memoizedState) {
                      var l = b.alternate;
                      if (null !== l) {
                        var m = l.memoizedState;
                        if (null !== m) {
                          var q = m.dehydrated;
                          null !== q && bd(q);
                        }
                      }
                    }
                    break;
                  case 19:
                  case 17:
                  case 21:
                  case 22:
                  case 23:
                  case 25:
                    break;
                  default:
                    throw Error(p(163));
                }
              U || (b.flags & 512 && Rj(b));
            } catch (r) {
              W(b, b.return, r);
            }
          }
          if (b === a) {
            V = null;
            break;
          }
          c = b.sibling;
          if (null !== c) {
            c.return = b.return;
            V = c;
            break;
          }
          V = b.return;
        }
      }
      function gk(a) {
        for (; null !== V; ) {
          var b = V;
          if (b === a) {
            V = null;
            break;
          }
          var c = b.sibling;
          if (null !== c) {
            c.return = b.return;
            V = c;
            break;
          }
          V = b.return;
        }
      }
      function jk(a) {
        for (; null !== V; ) {
          var b = V;
          try {
            switch (b.tag) {
              case 0:
              case 11:
              case 15:
                var c = b.return;
                try {
                  Qj(4, b);
                } catch (k) {
                  W(b, c, k);
                }
                break;
              case 1:
                var d = b.stateNode;
                if ('function' === typeof d.componentDidMount) {
                  var e = b.return;
                  try {
                    d.componentDidMount();
                  } catch (k) {
                    W(b, e, k);
                  }
                }
                var f = b.return;
                try {
                  Rj(b);
                } catch (k) {
                  W(b, f, k);
                }
                break;
              case 5:
                var g = b.return;
                try {
                  Rj(b);
                } catch (k) {
                  W(b, g, k);
                }
            }
          } catch (k) {
            W(b, b.return, k);
          }
          if (b === a) {
            V = null;
            break;
          }
          var h = b.sibling;
          if (null !== h) {
            h.return = b.return;
            V = h;
            break;
          }
          V = b.return;
        }
      }
      var lk = Math.ceil,
        mk = ua.ReactCurrentDispatcher,
        nk = ua.ReactCurrentOwner,
        ok = ua.ReactCurrentBatchConfig,
        K = 0,
        Q = null,
        Y = null,
        Z = 0,
        fj = 0,
        ej = Uf(0),
        T = 0,
        pk = null,
        rh = 0,
        qk = 0,
        rk = 0,
        sk = null,
        tk = null,
        fk = 0,
        Gj = Infinity,
        uk = null,
        Oi = !1,
        Pi = null,
        Ri = null,
        vk = !1,
        wk = null,
        xk = 0,
        yk = 0,
        zk = null,
        Ak = -1,
        Bk = 0;
      function R() {
        return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : (Ak = B());
      }
      function yi(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
        if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
        a = C;
        if (0 !== a) return a;
        a = window.event;
        a = void 0 === a ? 16 : jd(a.type);
        return a;
      }
      function gi(a, b, c, d) {
        if (50 < yk) throw ((yk = 0), (zk = null), Error(p(185)));
        Ac(a, c, d);
        if (0 === (K & 2) || a !== Q)
          a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)),
            Dk(a, d),
            1 === c && 0 === K && 0 === (b.mode & 1) && ((Gj = B() + 500), fg && jg());
      }
      function Dk(a, b) {
        var c = a.callbackNode;
        wc(a, b);
        var d = uc(a, a === Q ? Z : 0);
        if (0 === d) null !== c && bc(c), (a.callbackNode = null), (a.callbackPriority = 0);
        else if (((b = d & -d), a.callbackPriority !== b)) {
          null != c && bc(c);
          if (1 === b)
            0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)),
              Jf(function () {
                0 === (K & 6) && jg();
              }),
              (c = null);
          else {
            switch (Dc(d)) {
              case 1:
                c = fc;
                break;
              case 4:
                c = gc;
                break;
              case 16:
                c = hc;
                break;
              case 536870912:
                c = jc;
                break;
              default:
                c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
          }
          a.callbackPriority = b;
          a.callbackNode = c;
        }
      }
      function Gk(a, b) {
        Ak = -1;
        Bk = 0;
        if (0 !== (K & 6)) throw Error(p(327));
        var c = a.callbackNode;
        if (Hk() && a.callbackNode !== c) return null;
        var d = uc(a, a === Q ? Z : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
        else {
          b = d;
          var e = K;
          K |= 2;
          var f = Jk();
          if (Q !== a || Z !== b) (uk = null), (Gj = B() + 500), Kk(a, b);
          do
            try {
              Lk();
              break;
            } catch (h) {
              Mk(a, h);
            }
          while (1);
          $g();
          mk.current = f;
          K = e;
          null !== Y ? (b = 0) : ((Q = null), (Z = 0), (b = T));
        }
        if (0 !== b) {
          2 === b && ((e = xc(a)), 0 !== e && ((d = e), (b = Nk(a, e))));
          if (1 === b) throw ((c = pk), Kk(a, 0), Ck(a, d), Dk(a, B()), c);
          if (6 === b) Ck(a, d);
          else {
            e = a.current.alternate;
            if (
              0 === (d & 30) &&
              !Ok(e) &&
              ((b = Ik(a, d)), 2 === b && ((f = xc(a)), 0 !== f && ((d = f), (b = Nk(a, f)))), 1 === b)
            )
              throw ((c = pk), Kk(a, 0), Ck(a, d), Dk(a, B()), c);
            a.finishedWork = e;
            a.finishedLanes = d;
            switch (b) {
              case 0:
              case 1:
                throw Error(p(345));
              case 2:
                Pk(a, tk, uk);
                break;
              case 3:
                Ck(a, d);
                if ((d & 130023424) === d && ((b = fk + 500 - B()), 10 < b)) {
                  if (0 !== uc(a, 0)) break;
                  e = a.suspendedLanes;
                  if ((e & d) !== d) {
                    R();
                    a.pingedLanes |= a.suspendedLanes & e;
                    break;
                  }
                  a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                  break;
                }
                Pk(a, tk, uk);
                break;
              case 4:
                Ck(a, d);
                if ((d & 4194240) === d) break;
                b = a.eventTimes;
                for (e = -1; 0 < d; ) {
                  var g = 31 - oc(d);
                  f = 1 << g;
                  g = b[g];
                  g > e && (e = g);
                  d &= ~f;
                }
                d = e;
                d = B() - d;
                d =
                  (120 > d
                    ? 120
                    : 480 > d
                      ? 480
                      : 1080 > d
                        ? 1080
                        : 1920 > d
                          ? 1920
                          : 3e3 > d
                            ? 3e3
                            : 4320 > d
                              ? 4320
                              : 1960 * lk(d / 1960)) - d;
                if (10 < d) {
                  a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                  break;
                }
                Pk(a, tk, uk);
                break;
              case 5:
                Pk(a, tk, uk);
                break;
              default:
                throw Error(p(329));
            }
          }
        }
        Dk(a, B());
        return a.callbackNode === c ? Gk.bind(null, a) : null;
      }
      function Nk(a, b) {
        var c = sk;
        a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
        a = Ik(a, b);
        2 !== a && ((b = tk), (tk = c), null !== b && Fj(b));
        return a;
      }
      function Fj(a) {
        null === tk ? (tk = a) : tk.push.apply(tk, a);
      }
      function Ok(a) {
        for (var b = a; ; ) {
          if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && ((c = c.stores), null !== c))
              for (var d = 0; d < c.length; d++) {
                var e = c[d],
                  f = e.getSnapshot;
                e = e.value;
                try {
                  if (!He(f(), e)) return !1;
                } catch (g) {
                  return !1;
                }
              }
          }
          c = b.child;
          if (b.subtreeFlags & 16384 && null !== c) (c.return = b), (b = c);
          else {
            if (b === a) break;
            for (; null === b.sibling; ) {
              if (null === b.return || b.return === a) return !0;
              b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
          }
        }
        return !0;
      }
      function Ck(a, b) {
        b &= ~rk;
        b &= ~qk;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for (a = a.expirationTimes; 0 < b; ) {
          var c = 31 - oc(b),
            d = 1 << c;
          a[c] = -1;
          b &= ~d;
        }
      }
      function Ek(a) {
        if (0 !== (K & 6)) throw Error(p(327));
        Hk();
        var b = uc(a, 0);
        if (0 === (b & 1)) return Dk(a, B()), null;
        var c = Ik(a, b);
        if (0 !== a.tag && 2 === c) {
          var d = xc(a);
          0 !== d && ((b = d), (c = Nk(a, d)));
        }
        if (1 === c) throw ((c = pk), Kk(a, 0), Ck(a, b), Dk(a, B()), c);
        if (6 === c) throw Error(p(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Pk(a, tk, uk);
        Dk(a, B());
        return null;
      }
      function Qk(a, b) {
        var c = K;
        K |= 1;
        try {
          return a(b);
        } finally {
          (K = c), 0 === K && ((Gj = B() + 500), fg && jg());
        }
      }
      function Rk(a) {
        null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
        var b = K;
        K |= 1;
        var c = ok.transition,
          d = C;
        try {
          if (((ok.transition = null), (C = 1), a)) return a();
        } finally {
          (C = d), (ok.transition = c), (K = b), 0 === (K & 6) && jg();
        }
      }
      function Hj() {
        fj = ej.current;
        E(ej);
      }
      function Kk(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        -1 !== c && ((a.timeoutHandle = -1), Gf(c));
        if (null !== Y)
          for (c = Y.return; null !== c; ) {
            var d = c;
            wg(d);
            switch (d.tag) {
              case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
              case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
              case 5:
                Bh(d);
                break;
              case 4:
                zh();
                break;
              case 13:
                E(L);
                break;
              case 19:
                E(L);
                break;
              case 10:
                ah(d.type._context);
                break;
              case 22:
              case 23:
                Hj();
            }
            c = c.return;
          }
        Q = a;
        Y = a = Pg(a.current, null);
        Z = fj = b;
        T = 0;
        pk = null;
        rk = qk = rh = 0;
        tk = sk = null;
        if (null !== fh) {
          for (b = 0; b < fh.length; b++)
            if (((c = fh[b]), (d = c.interleaved), null !== d)) {
              c.interleaved = null;
              var e = d.next,
                f = c.pending;
              if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
              }
              c.pending = d;
            }
          fh = null;
        }
        return a;
      }
      function Mk(a, b) {
        do {
          var c = Y;
          try {
            $g();
            Fh.current = Rh;
            if (Ih) {
              for (var d = M.memoizedState; null !== d; ) {
                var e = d.queue;
                null !== e && (e.pending = null);
                d = d.next;
              }
              Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
              T = 1;
              pk = b;
              Y = null;
              break;
            }
            a: {
              var f = a,
                g = c.return,
                h = c,
                k = b;
              b = Z;
              h.flags |= 32768;
              if (null !== k && 'object' === typeof k && 'function' === typeof k.then) {
                var l = k,
                  m = h,
                  q = m.tag;
                if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                  var r = m.alternate;
                  r
                    ? ((m.updateQueue = r.updateQueue), (m.memoizedState = r.memoizedState), (m.lanes = r.lanes))
                    : ((m.updateQueue = null), (m.memoizedState = null));
                }
                var y = Ui(g);
                if (null !== y) {
                  y.flags &= -257;
                  Vi(y, g, h, f, b);
                  y.mode & 1 && Si(f, l, b);
                  b = y;
                  k = l;
                  var n = b.updateQueue;
                  if (null === n) {
                    var t = new Set();
                    t.add(k);
                    b.updateQueue = t;
                  } else n.add(k);
                  break a;
                } else {
                  if (0 === (b & 1)) {
                    Si(f, l, b);
                    tj();
                    break a;
                  }
                  k = Error(p(426));
                }
              } else if (I && h.mode & 1) {
                var J = Ui(g);
                if (null !== J) {
                  0 === (J.flags & 65536) && (J.flags |= 256);
                  Vi(J, g, h, f, b);
                  Jg(Ji(k, h));
                  break a;
                }
              }
              f = k = Ji(k, h);
              4 !== T && (T = 2);
              null === sk ? (sk = [f]) : sk.push(f);
              f = g;
              do {
                switch (f.tag) {
                  case 3:
                    f.flags |= 65536;
                    b &= -b;
                    f.lanes |= b;
                    var x = Ni(f, k, b);
                    ph(f, x);
                    break a;
                  case 1:
                    h = k;
                    var w = f.type,
                      u = f.stateNode;
                    if (
                      0 === (f.flags & 128) &&
                      ('function' === typeof w.getDerivedStateFromError ||
                        (null !== u && 'function' === typeof u.componentDidCatch && (null === Ri || !Ri.has(u))))
                    ) {
                      f.flags |= 65536;
                      b &= -b;
                      f.lanes |= b;
                      var F = Qi(f, h, b);
                      ph(f, F);
                      break a;
                    }
                }
                f = f.return;
              } while (null !== f);
            }
            Sk(c);
          } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
          }
          break;
        } while (1);
      }
      function Jk() {
        var a = mk.current;
        mk.current = Rh;
        return null === a ? Rh : a;
      }
      function tj() {
        if (0 === T || 3 === T || 2 === T) T = 4;
        null === Q || (0 === (rh & 268435455) && 0 === (qk & 268435455)) || Ck(Q, Z);
      }
      function Ik(a, b) {
        var c = K;
        K |= 2;
        var d = Jk();
        if (Q !== a || Z !== b) (uk = null), Kk(a, b);
        do
          try {
            Tk();
            break;
          } catch (e) {
            Mk(a, e);
          }
        while (1);
        $g();
        K = c;
        mk.current = d;
        if (null !== Y) throw Error(p(261));
        Q = null;
        Z = 0;
        return T;
      }
      function Tk() {
        for (; null !== Y; ) Uk(Y);
      }
      function Lk() {
        for (; null !== Y && !cc(); ) Uk(Y);
      }
      function Uk(a) {
        var b = Vk(a.alternate, a, fj);
        a.memoizedProps = a.pendingProps;
        null === b ? Sk(a) : (Y = b);
        nk.current = null;
      }
      function Sk(a) {
        var b = a;
        do {
          var c = b.alternate;
          a = b.return;
          if (0 === (b.flags & 32768)) {
            if (((c = Ej(c, b, fj)), null !== c)) {
              Y = c;
              return;
            }
          } else {
            c = Ij(c, b);
            if (null !== c) {
              c.flags &= 32767;
              Y = c;
              return;
            }
            if (null !== a) (a.flags |= 32768), (a.subtreeFlags = 0), (a.deletions = null);
            else {
              T = 6;
              Y = null;
              return;
            }
          }
          b = b.sibling;
          if (null !== b) {
            Y = b;
            return;
          }
          Y = b = a;
        } while (null !== b);
        0 === T && (T = 5);
      }
      function Pk(a, b, c) {
        var d = C,
          e = ok.transition;
        try {
          (ok.transition = null), (C = 1), Wk(a, b, c, d);
        } finally {
          (ok.transition = e), (C = d);
        }
        return null;
      }
      function Wk(a, b, c, d) {
        do Hk();
        while (null !== wk);
        if (0 !== (K & 6)) throw Error(p(327));
        c = a.finishedWork;
        var e = a.finishedLanes;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (c === a.current) throw Error(p(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = c.lanes | c.childLanes;
        Bc(a, f);
        a === Q && ((Y = Q = null), (Z = 0));
        (0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064)) ||
          vk ||
          ((vk = !0),
          Fk(hc, function () {
            Hk();
            return null;
          }));
        f = 0 !== (c.flags & 15990);
        if (0 !== (c.subtreeFlags & 15990) || f) {
          f = ok.transition;
          ok.transition = null;
          var g = C;
          C = 1;
          var h = K;
          K |= 4;
          nk.current = null;
          Oj(a, c);
          dk(c, a);
          Oe(Df);
          dd = !!Cf;
          Df = Cf = null;
          a.current = c;
          hk(c, a, e);
          dc();
          K = h;
          C = g;
          ok.transition = f;
        } else a.current = c;
        vk && ((vk = !1), (wk = a), (xk = e));
        f = a.pendingLanes;
        0 === f && (Ri = null);
        mc(c.stateNode, d);
        Dk(a, B());
        if (null !== b)
          for (d = a.onRecoverableError, c = 0; c < b.length; c++)
            (e = b[c]),
              d(e.value, {
                componentStack: e.stack,
                digest: e.digest,
              });
        if (Oi) throw ((Oi = !1), (a = Pi), (Pi = null), a);
        0 !== (xk & 1) && 0 !== a.tag && Hk();
        f = a.pendingLanes;
        0 !== (f & 1) ? (a === zk ? yk++ : ((yk = 0), (zk = a))) : (yk = 0);
        jg();
        return null;
      }
      function Hk() {
        if (null !== wk) {
          var a = Dc(xk),
            b = ok.transition,
            c = C;
          try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
              a = wk;
              wk = null;
              xk = 0;
              if (0 !== (K & 6)) throw Error(p(331));
              var e = K;
              K |= 4;
              for (V = a.current; null !== V; ) {
                var f = V,
                  g = f.child;
                if (0 !== (V.flags & 16)) {
                  var h = f.deletions;
                  if (null !== h) {
                    for (var k = 0; k < h.length; k++) {
                      var l = h[k];
                      for (V = l; null !== V; ) {
                        var m = V;
                        switch (m.tag) {
                          case 0:
                          case 11:
                          case 15:
                            Pj(8, m, f);
                        }
                        var q = m.child;
                        if (null !== q) (q.return = m), (V = q);
                        else
                          for (; null !== V; ) {
                            m = V;
                            var r = m.sibling,
                              y = m.return;
                            Sj(m);
                            if (m === l) {
                              V = null;
                              break;
                            }
                            if (null !== r) {
                              r.return = y;
                              V = r;
                              break;
                            }
                            V = y;
                          }
                      }
                    }
                    var n = f.alternate;
                    if (null !== n) {
                      var t = n.child;
                      if (null !== t) {
                        n.child = null;
                        do {
                          var J = t.sibling;
                          t.sibling = null;
                          t = J;
                        } while (null !== t);
                      }
                    }
                    V = f;
                  }
                }
                if (0 !== (f.subtreeFlags & 2064) && null !== g) (g.return = f), (V = g);
                else
                  b: for (; null !== V; ) {
                    f = V;
                    if (0 !== (f.flags & 2048))
                      switch (f.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Pj(9, f, f.return);
                      }
                    var x = f.sibling;
                    if (null !== x) {
                      x.return = f.return;
                      V = x;
                      break b;
                    }
                    V = f.return;
                  }
              }
              var w = a.current;
              for (V = w; null !== V; ) {
                g = V;
                var u = g.child;
                if (0 !== (g.subtreeFlags & 2064) && null !== u) (u.return = g), (V = u);
                else
                  b: for (g = w; null !== V; ) {
                    h = V;
                    if (0 !== (h.flags & 2048))
                      try {
                        switch (h.tag) {
                          case 0:
                          case 11:
                          case 15:
                            Qj(9, h);
                        }
                      } catch (na) {
                        W(h, h.return, na);
                      }
                    if (h === g) {
                      V = null;
                      break b;
                    }
                    var F = h.sibling;
                    if (null !== F) {
                      F.return = h.return;
                      V = F;
                      break b;
                    }
                    V = h.return;
                  }
              }
              K = e;
              jg();
              if (lc && 'function' === typeof lc.onPostCommitFiberRoot)
                try {
                  lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
              d = !0;
            }
            return d;
          } finally {
            (C = c), (ok.transition = b);
          }
        }
        return !1;
      }
      function Xk(a, b, c) {
        b = Ji(c, b);
        b = Ni(a, b, 1);
        a = nh(a, b, 1);
        b = R();
        null !== a && (Ac(a, 1, b), Dk(a, b));
      }
      function W(a, b, c) {
        if (3 === a.tag) Xk(a, a, c);
        else
          for (; null !== b; ) {
            if (3 === b.tag) {
              Xk(b, a, c);
              break;
            } else if (1 === b.tag) {
              var d = b.stateNode;
              if (
                'function' === typeof b.type.getDerivedStateFromError ||
                ('function' === typeof d.componentDidCatch && (null === Ri || !Ri.has(d)))
              ) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
              }
            }
            b = b.return;
          }
      }
      function Ti(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = R();
        a.pingedLanes |= a.suspendedLanes & c;
        Q === a &&
          (Z & c) === c &&
          (4 === T || (3 === T && (Z & 130023424) === Z && 500 > B() - fk) ? Kk(a, 0) : (rk |= c));
        Dk(a, b);
      }
      function Yk(a, b) {
        0 === b && (0 === (a.mode & 1) ? (b = 1) : ((b = sc), (sc <<= 1), 0 === (sc & 130023424) && (sc = 4194304)));
        var c = R();
        a = ih(a, b);
        null !== a && (Ac(a, b, c), Dk(a, c));
      }
      function uj(a) {
        var b = a.memoizedState,
          c = 0;
        null !== b && (c = b.retryLane);
        Yk(a, c);
      }
      function bk(a, b) {
        var c = 0;
        switch (a.tag) {
          case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
          case 19:
            d = a.stateNode;
            break;
          default:
            throw Error(p(314));
        }
        null !== d && d.delete(b);
        Yk(a, c);
      }
      var Vk;
      Vk = function (a, b, c) {
        if (null !== a) {
          if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
          else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return (dh = !1), yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
          }
        } else (dh = !1), I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
        b.lanes = 0;
        switch (b.tag) {
          case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            'object' === typeof e && null !== e && 'function' === typeof e.render && void 0 === e.$$typeof
              ? ((b.tag = 1),
                (b.memoizedState = null),
                (b.updateQueue = null),
                Zf(d) ? ((f = !0), cg(b)) : (f = !1),
                (b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null),
                kh(b),
                (e.updater = Ei),
                (b.stateNode = e),
                (e._reactInternals = b),
                Ii(b, d, a, c),
                (b = jj(null, b, d, !0, f, c)))
              : ((b.tag = 0), I && f && vg(b), Xi(null, b, e, c), (b = b.child));
            return b;
          case 16:
            d = b.elementType;
            a: {
              ij(a, b);
              a = b.pendingProps;
              e = d._init;
              d = e(d._payload);
              b.type = d;
              e = b.tag = Zk(d);
              a = Ci(d, a);
              switch (e) {
                case 0:
                  b = cj(null, b, d, a, c);
                  break a;
                case 1:
                  b = hj(null, b, d, a, c);
                  break a;
                case 11:
                  b = Yi(null, b, d, a, c);
                  break a;
                case 14:
                  b = $i(null, b, d, Ci(d.type, a), c);
                  break a;
              }
              throw Error(p(306, d, ''));
            }
            return b;
          case 0:
            return (d = b.type), (e = b.pendingProps), (e = b.elementType === d ? e : Ci(d, e)), cj(a, b, d, e, c);
          case 1:
            return (d = b.type), (e = b.pendingProps), (e = b.elementType === d ? e : Ci(d, e)), hj(a, b, d, e, c);
          case 3:
            a: {
              kj(b);
              if (null === a) throw Error(p(387));
              d = b.pendingProps;
              f = b.memoizedState;
              e = f.element;
              lh(a, b);
              qh(b, d, null, c);
              var g = b.memoizedState;
              d = g.element;
              if (f.isDehydrated) {
                if (
                  ((f = {
                    element: d,
                    isDehydrated: !1,
                    cache: g.cache,
                    pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                    transitions: g.transitions,
                  }),
                  (b.updateQueue.baseState = f),
                  (b.memoizedState = f),
                  b.flags & 256)
                ) {
                  e = Ji(Error(p(423)), b);
                  b = lj(a, b, d, c, e);
                  break a;
                } else if (d !== e) {
                  e = Ji(Error(p(424)), b);
                  b = lj(a, b, d, c, e);
                  break a;
                } else
                  for (
                    yg = Lf(b.stateNode.containerInfo.firstChild),
                      xg = b,
                      I = !0,
                      zg = null,
                      c = Vg(b, null, d, c),
                      b.child = c;
                    c;

                  )
                    (c.flags = (c.flags & -3) | 4096), (c = c.sibling);
              } else {
                Ig();
                if (d === e) {
                  b = Zi(a, b, c);
                  break a;
                }
                Xi(a, b, d, c);
              }
              b = b.child;
            }
            return b;
          case 5:
            return (
              Ah(b),
              null === a && Eg(b),
              (d = b.type),
              (e = b.pendingProps),
              (f = null !== a ? a.memoizedProps : null),
              (g = e.children),
              Ef(d, e) ? (g = null) : null !== f && Ef(d, f) && (b.flags |= 32),
              gj(a, b),
              Xi(a, b, g, c),
              b.child
            );
          case 6:
            return null === a && Eg(b), null;
          case 13:
            return oj(a, b, c);
          case 4:
            return (
              yh(b, b.stateNode.containerInfo),
              (d = b.pendingProps),
              null === a ? (b.child = Ug(b, null, d, c)) : Xi(a, b, d, c),
              b.child
            );
          case 11:
            return (d = b.type), (e = b.pendingProps), (e = b.elementType === d ? e : Ci(d, e)), Yi(a, b, d, e, c);
          case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
          case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
          case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
          case 10:
            a: {
              d = b.type._context;
              e = b.pendingProps;
              f = b.memoizedProps;
              g = e.value;
              G(Wg, d._currentValue);
              d._currentValue = g;
              if (null !== f)
                if (He(f.value, g)) {
                  if (f.children === e.children && !Wf.current) {
                    b = Zi(a, b, c);
                    break a;
                  }
                } else
                  for (f = b.child, null !== f && (f.return = b); null !== f; ) {
                    var h = f.dependencies;
                    if (null !== h) {
                      g = f.child;
                      for (var k = h.firstContext; null !== k; ) {
                        if (k.context === d) {
                          if (1 === f.tag) {
                            k = mh(-1, c & -c);
                            k.tag = 2;
                            var l = f.updateQueue;
                            if (null !== l) {
                              l = l.shared;
                              var m = l.pending;
                              null === m ? (k.next = k) : ((k.next = m.next), (m.next = k));
                              l.pending = k;
                            }
                          }
                          f.lanes |= c;
                          k = f.alternate;
                          null !== k && (k.lanes |= c);
                          bh(f.return, c, b);
                          h.lanes |= c;
                          break;
                        }
                        k = k.next;
                      }
                    } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                    else if (18 === f.tag) {
                      g = f.return;
                      if (null === g) throw Error(p(341));
                      g.lanes |= c;
                      h = g.alternate;
                      null !== h && (h.lanes |= c);
                      bh(g, c, b);
                      g = f.sibling;
                    } else g = f.child;
                    if (null !== g) g.return = f;
                    else
                      for (g = f; null !== g; ) {
                        if (g === b) {
                          g = null;
                          break;
                        }
                        f = g.sibling;
                        if (null !== f) {
                          f.return = g.return;
                          g = f;
                          break;
                        }
                        g = g.return;
                      }
                    f = g;
                  }
              Xi(a, b, e.children, c);
              b = b.child;
            }
            return b;
          case 9:
            return (
              (e = b.type),
              (d = b.pendingProps.children),
              ch(b, c),
              (e = eh(e)),
              (d = d(e)),
              (b.flags |= 1),
              Xi(a, b, d, c),
              b.child
            );
          case 14:
            return (d = b.type), (e = Ci(d, b.pendingProps)), (e = Ci(d.type, e)), $i(a, b, d, e, c);
          case 15:
            return bj(a, b, b.type, b.pendingProps, c);
          case 17:
            return (
              (d = b.type),
              (e = b.pendingProps),
              (e = b.elementType === d ? e : Ci(d, e)),
              ij(a, b),
              (b.tag = 1),
              Zf(d) ? ((a = !0), cg(b)) : (a = !1),
              ch(b, c),
              Gi(b, d, e),
              Ii(b, d, e, c),
              jj(null, b, d, !0, a, c)
            );
          case 19:
            return xj(a, b, c);
          case 22:
            return dj(a, b, c);
        }
        throw Error(p(156, b.tag));
      };
      function Fk(a, b) {
        return ac(a, b);
      }
      function $k(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
      }
      function Bg(a, b, c, d) {
        return new $k(a, b, c, d);
      }
      function aj(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
      }
      function Zk(a) {
        if ('function' === typeof a) return aj(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
          a = a.$$typeof;
          if (a === Da) return 11;
          if (a === Ga) return 14;
        }
        return 2;
      }
      function Pg(a, b) {
        var c = a.alternate;
        null === c
          ? ((c = Bg(a.tag, b, a.key, a.mode)),
            (c.elementType = a.elementType),
            (c.type = a.type),
            (c.stateNode = a.stateNode),
            (c.alternate = a),
            (a.alternate = c))
          : ((c.pendingProps = b), (c.type = a.type), (c.flags = 0), (c.subtreeFlags = 0), (c.deletions = null));
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies =
          null === b
            ? null
            : {
                lanes: b.lanes,
                firstContext: b.firstContext,
              };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
      }
      function Rg(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ('function' === typeof a) aj(a) && (g = 1);
        else if ('string' === typeof a) g = 5;
        else
          a: switch (a) {
            case ya:
              return Tg(c.children, e, f, b);
            case za:
              g = 8;
              e |= 8;
              break;
            case Aa:
              return (a = Bg(12, c, b, e | 2)), (a.elementType = Aa), (a.lanes = f), a;
            case Ea:
              return (a = Bg(13, c, b, e)), (a.elementType = Ea), (a.lanes = f), a;
            case Fa:
              return (a = Bg(19, c, b, e)), (a.elementType = Fa), (a.lanes = f), a;
            case Ia:
              return pj(c, e, f, b);
            default:
              if ('object' === typeof a && null !== a)
                switch (a.$$typeof) {
                  case Ba:
                    g = 10;
                    break a;
                  case Ca:
                    g = 9;
                    break a;
                  case Da:
                    g = 11;
                    break a;
                  case Ga:
                    g = 14;
                    break a;
                  case Ha:
                    g = 16;
                    d = null;
                    break a;
                }
              throw Error(p(130, null == a ? a : typeof a, ''));
          }
        b = Bg(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
      }
      function Tg(a, b, c, d) {
        a = Bg(7, a, d, b);
        a.lanes = c;
        return a;
      }
      function pj(a, b, c, d) {
        a = Bg(22, a, d, b);
        a.elementType = Ia;
        a.lanes = c;
        a.stateNode = {
          isHidden: !1,
        };
        return a;
      }
      function Qg(a, b, c) {
        a = Bg(6, a, null, b);
        a.lanes = c;
        return a;
      }
      function Sg(a, b, c) {
        b = Bg(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
          containerInfo: a.containerInfo,
          pendingChildren: null,
          implementation: a.implementation,
        };
        return b;
      }
      function al(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = -1;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = zc(0);
        this.expirationTimes = zc(-1);
        this.entangledLanes =
          this.finishedLanes =
          this.mutableReadLanes =
          this.expiredLanes =
          this.pingedLanes =
          this.suspendedLanes =
          this.pendingLanes =
            0;
        this.entanglements = zc(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        this.mutableSourceEagerHydrationData = null;
      }
      function bl(a, b, c, d, e, f, g, h, k) {
        a = new al(a, b, c, h, k);
        1 === b ? ((b = 1), !0 === f && (b |= 8)) : (b = 0);
        f = Bg(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
          element: d,
          isDehydrated: c,
          cache: null,
          transitions: null,
          pendingSuspenseBoundaries: null,
        };
        kh(f);
        return a;
      }
      function cl(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
          $$typeof: wa,
          key: null == d ? null : '' + d,
          children: a,
          containerInfo: b,
          implementation: c,
        };
      }
      function dl(a) {
        if (!a) return Vf;
        a = a._reactInternals;
        a: {
          if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
          var b = a;
          do {
            switch (b.tag) {
              case 3:
                b = b.stateNode.context;
                break a;
              case 1:
                if (Zf(b.type)) {
                  b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                  break a;
                }
            }
            b = b.return;
          } while (null !== b);
          throw Error(p(171));
        }
        if (1 === a.tag) {
          var c = a.type;
          if (Zf(c)) return bg(a, c, b);
        }
        return b;
      }
      function el(a, b, c, d, e, f, g, h, k) {
        a = bl(c, d, !0, a, e, f, g, h, k);
        a.context = dl(null);
        c = a.current;
        d = R();
        e = yi(c);
        f = mh(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        nh(c, f, e);
        a.current.lanes = e;
        Ac(a, e, d);
        Dk(a, d);
        return a;
      }
      function fl(a, b, c, d) {
        var e = b.current,
          f = R(),
          g = yi(e);
        c = dl(c);
        null === b.context ? (b.context = c) : (b.pendingContext = c);
        b = mh(f, g);
        b.payload = {
          element: a,
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        a = nh(e, b, g);
        null !== a && (gi(a, e, g, f), oh(a, e, g));
        return g;
      }
      function gl(a) {
        a = a.current;
        if (!a.child) return null;
        switch (a.child.tag) {
          case 5:
            return a.child.stateNode;
          default:
            return a.child.stateNode;
        }
      }
      function hl(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
          var c = a.retryLane;
          a.retryLane = 0 !== c && c < b ? c : b;
        }
      }
      function il(a, b) {
        hl(a, b);
        (a = a.alternate) && hl(a, b);
      }
      function jl() {
        return null;
      }
      var kl =
        'function' === typeof reportError
          ? reportError
          : function (a) {
              console.error(a);
            };
      function ll(a) {
        this._internalRoot = a;
      }
      ml.prototype.render = ll.prototype.render = function (a) {
        var b = this._internalRoot;
        if (null === b) throw Error(p(409));
        fl(a, b, null, null);
      };
      ml.prototype.unmount = ll.prototype.unmount = function () {
        var a = this._internalRoot;
        if (null !== a) {
          this._internalRoot = null;
          var b = a.containerInfo;
          Rk(function () {
            fl(null, a, null, null);
          });
          b[uf] = null;
        }
      };
      function ml(a) {
        this._internalRoot = a;
      }
      ml.prototype.unstable_scheduleHydration = function (a) {
        if (a) {
          var b = Hc();
          a = {
            blockedOn: null,
            target: a,
            priority: b,
          };
          for (var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
          Qc.splice(c, 0, a);
          0 === c && Vc(a);
        }
      };
      function nl(a) {
        return !(!a || (1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType));
      }
      function ol(a) {
        return !(
          !a ||
          (1 !== a.nodeType &&
            9 !== a.nodeType &&
            11 !== a.nodeType &&
            (8 !== a.nodeType || ' react-mount-point-unstable ' !== a.nodeValue))
        );
      }
      function pl() {}
      function ql(a, b, c, d, e) {
        if (e) {
          if ('function' === typeof d) {
            var f = d;
            d = function () {
              var a = gl(g);
              f.call(a);
            };
          }
          var g = el(b, d, a, 0, null, !1, !1, '', pl);
          a._reactRootContainer = g;
          a[uf] = g.current;
          sf(8 === a.nodeType ? a.parentNode : a);
          Rk();
          return g;
        }
        for (; (e = a.lastChild); ) a.removeChild(e);
        if ('function' === typeof d) {
          var h = d;
          d = function () {
            var a = gl(k);
            h.call(a);
          };
        }
        var k = bl(a, 0, !1, null, null, !1, !1, '', pl);
        a._reactRootContainer = k;
        a[uf] = k.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk(function () {
          fl(b, k, c, d);
        });
        return k;
      }
      function rl(a, b, c, d, e) {
        var f = c._reactRootContainer;
        if (f) {
          var g = f;
          if ('function' === typeof e) {
            var h = e;
            e = function () {
              var a = gl(g);
              h.call(a);
            };
          }
          fl(b, g, a, e);
        } else g = ql(c, b, a, e, d);
        return gl(g);
      }
      Ec = function (a) {
        switch (a.tag) {
          case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
              var c = tc(b.pendingLanes);
              0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && ((Gj = B() + 500), jg()));
            }
            break;
          case 13:
            Rk(function () {
              var b = ih(a, 1);
              if (null !== b) {
                var c = R();
                gi(b, a, 1, c);
              }
            }),
              il(a, 1);
        }
      };
      Fc = function (a) {
        if (13 === a.tag) {
          var b = ih(a, 134217728);
          if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
          }
          il(a, 134217728);
        }
      };
      Gc = function (a) {
        if (13 === a.tag) {
          var b = yi(a),
            c = ih(a, b);
          if (null !== c) {
            var d = R();
            gi(c, a, b, d);
          }
          il(a, b);
        }
      };
      Hc = function () {
        return C;
      };
      Ic = function (a, b) {
        var c = C;
        try {
          return (C = a), b();
        } finally {
          C = c;
        }
      };
      yb = function (a, b, c) {
        switch (b) {
          case 'input':
            bb(a, c);
            b = c.name;
            if ('radio' === c.type && null != b) {
              for (c = a; c.parentNode; ) c = c.parentNode;
              c = c.querySelectorAll('input[name=' + JSON.stringify('' + b) + '][type="radio"]');
              for (b = 0; b < c.length; b++) {
                var d = c[b];
                if (d !== a && d.form === a.form) {
                  var e = Db(d);
                  if (!e) throw Error(p(90));
                  Wa(d);
                  bb(d, e);
                }
              }
            }
            break;
          case 'textarea':
            ib(a, c);
            break;
          case 'select':
            (b = c.value), null != b && fb(a, !!c.multiple, b, !1);
        }
      };
      Gb = Qk;
      Hb = Rk;
      var sl = {
          usingClientEntryPoint: !1,
          Events: [Cb, ue, Db, Eb, Fb, Qk],
        },
        tl = {
          findFiberByHostInstance: Wc,
          bundleType: 0,
          version: '18.3.1',
          rendererPackageName: 'react-dom',
        };
      var ul = {
        bundleType: tl.bundleType,
        version: tl.version,
        rendererPackageName: tl.rendererPackageName,
        rendererConfig: tl.rendererConfig,
        overrideHookState: null,
        overrideHookStateDeletePath: null,
        overrideHookStateRenamePath: null,
        overrideProps: null,
        overridePropsDeletePath: null,
        overridePropsRenamePath: null,
        setErrorHandler: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: ua.ReactCurrentDispatcher,
        findHostInstanceByFiber: function (a) {
          a = Zb(a);
          return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: tl.findFiberByHostInstance || jl,
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null,
        reconcilerVersion: '18.3.1-next-f1338f8080-20240426',
      };
      if ('undefined' !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
        var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (!vl.isDisabled && vl.supportsFiber)
          try {
            (kc = vl.inject(ul)), (lc = vl);
          } catch (a) {}
      }
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
      exports.createPortal = function (a, b) {
        var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!nl(b)) throw Error(p(200));
        return cl(a, b, null, c);
      };
      exports.createRoot = function (a, b) {
        if (!nl(a)) throw Error(p(299));
        var c = !1,
          d = '',
          e = kl;
        null !== b &&
          void 0 !== b &&
          (!0 === b.unstable_strictMode && (c = !0),
          void 0 !== b.identifierPrefix && (d = b.identifierPrefix),
          void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
        b = bl(a, 1, !1, null, null, c, !1, d, e);
        a[uf] = b.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        return new ll(b);
      };
      exports.findDOMNode = function (a) {
        if (null == a) return null;
        if (1 === a.nodeType) return a;
        var b = a._reactInternals;
        if (void 0 === b) {
          if ('function' === typeof a.render) throw Error(p(188));
          a = Object.keys(a).join(',');
          throw Error(p(268, a));
        }
        a = Zb(b);
        a = null === a ? null : a.stateNode;
        return a;
      };
      exports.flushSync = function (a) {
        return Rk(a);
      };
      exports.hydrate = function (a, b, c) {
        if (!ol(b)) throw Error(p(200));
        return rl(null, a, b, !0, c);
      };
      exports.hydrateRoot = function (a, b, c) {
        if (!nl(a)) throw Error(p(405));
        var d = (null != c && c.hydratedSources) || null,
          e = !1,
          f = '',
          g = kl;
        null !== c &&
          void 0 !== c &&
          (!0 === c.unstable_strictMode && (e = !0),
          void 0 !== c.identifierPrefix && (f = c.identifierPrefix),
          void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
        b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
        a[uf] = b.current;
        sf(a);
        if (d)
          for (a = 0; a < d.length; a++)
            (c = d[a]),
              (e = c._getVersion),
              (e = e(c._source)),
              null == b.mutableSourceEagerHydrationData
                ? (b.mutableSourceEagerHydrationData = [c, e])
                : b.mutableSourceEagerHydrationData.push(c, e);
        return new ml(b);
      };
      exports.render = function (a, b, c) {
        if (!ol(b)) throw Error(p(200));
        return rl(null, a, b, !1, c);
      };
      exports.unmountComponentAtNode = function (a) {
        if (!ol(a)) throw Error(p(40));
        return a._reactRootContainer
          ? (Rk(function () {
              rl(null, null, a, !1, function () {
                a._reactRootContainer = null;
                a[uf] = null;
              });
            }),
            !0)
          : !1;
      };
      exports.unstable_batchedUpdates = Qk;
      exports.unstable_renderSubtreeIntoContainer = function (a, b, c, d) {
        if (!ol(c)) throw Error(p(200));
        if (null == a || void 0 === a._reactInternals) throw Error(p(38));
        return rl(a, b, c, !1, d);
      };
      exports.version = '18.3.1-next-f1338f8080-20240426';

      /***/
    },

    /***/ 62275: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      function checkDCE() {
        /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
        if (
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
        ) {
          return;
        }
        if (false) {
        }
        try {
          // Verify that the code above has been dead code eliminated (DCE'd).
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
        } catch (err) {
          // DevTools shouldn't crash React, no matter what.
          // We should still report in case we break this code.
          console.error(err);
        }
      }
      if (true) {
        // DCE check should happen before ReactDOM bundle executes so that
        // DevTools can report bad minification during injection.
        checkDCE();
        module.exports = __webpack_require__(50213);
      } else {
      }

      /***/
    },

    /***/ 26341: /***/ (__unused_webpack_module, exports) => {
      'use strict';
      /**
       * @license React
       * scheduler.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      function f(a, b) {
        var c = a.length;
        a.push(b);
        a: for (; 0 < c; ) {
          var d = (c - 1) >>> 1,
            e = a[d];
          if (0 < g(e, b)) (a[d] = b), (a[c] = e), (c = d);
          else break a;
        }
      }
      function h(a) {
        return 0 === a.length ? null : a[0];
      }
      function k(a) {
        if (0 === a.length) return null;
        var b = a[0],
          c = a.pop();
        if (c !== b) {
          a[0] = c;
          a: for (var d = 0, e = a.length, w = e >>> 1; d < w; ) {
            var m = 2 * (d + 1) - 1,
              C = a[m],
              n = m + 1,
              x = a[n];
            if (0 > g(C, c))
              n < e && 0 > g(x, C) ? ((a[d] = x), (a[n] = c), (d = n)) : ((a[d] = C), (a[m] = c), (d = m));
            else if (n < e && 0 > g(x, c)) (a[d] = x), (a[n] = c), (d = n);
            else break a;
          }
        }
        return b;
      }
      function g(a, b) {
        var c = a.sortIndex - b.sortIndex;
        return 0 !== c ? c : a.id - b.id;
      }
      if ('object' === typeof performance && 'function' === typeof performance.now) {
        var l = performance;
        exports.unstable_now = function () {
          return l.now();
        };
      } else {
        var p = Date,
          q = p.now();
        exports.unstable_now = function () {
          return p.now() - q;
        };
      }
      var r = [],
        t = [],
        u = 1,
        v = null,
        y = 3,
        z = !1,
        A = !1,
        B = !1,
        D = 'function' === typeof setTimeout ? setTimeout : null,
        E = 'function' === typeof clearTimeout ? clearTimeout : null,
        F = 'undefined' !== typeof setImmediate ? setImmediate : null;
      'undefined' !== typeof navigator &&
        void 0 !== navigator.scheduling &&
        void 0 !== navigator.scheduling.isInputPending &&
        navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function G(a) {
        for (var b = h(t); null !== b; ) {
          if (null === b.callback) k(t);
          else if (b.startTime <= a) k(t), (b.sortIndex = b.expirationTime), f(r, b);
          else break;
          b = h(t);
        }
      }
      function H(a) {
        B = !1;
        G(a);
        if (!A)
          if (null !== h(r)) (A = !0), I(J);
          else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
          }
      }
      function J(a, b) {
        A = !1;
        B && ((B = !1), E(L), (L = -1));
        z = !0;
        var c = y;
        try {
          G(b);
          for (v = h(r); null !== v && (!(v.expirationTime > b) || (a && !M())); ) {
            var d = v.callback;
            if ('function' === typeof d) {
              v.callback = null;
              y = v.priorityLevel;
              var e = d(v.expirationTime <= b);
              b = exports.unstable_now();
              'function' === typeof e ? (v.callback = e) : v === h(r) && k(r);
              G(b);
            } else k(r);
            v = h(r);
          }
          if (null !== v) var w = !0;
          else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
          }
          return w;
        } finally {
          (v = null), (y = c), (z = !1);
        }
      }
      var N = !1,
        O = null,
        L = -1,
        P = 5,
        Q = -1;
      function M() {
        return exports.unstable_now() - Q < P ? !1 : !0;
      }
      function R() {
        if (null !== O) {
          var a = exports.unstable_now();
          Q = a;
          var b = !0;
          try {
            b = O(!0, a);
          } finally {
            b ? S() : ((N = !1), (O = null));
          }
        } else N = !1;
      }
      var S;
      if ('function' === typeof F)
        S = function () {
          F(R);
        };
      else if ('undefined' !== typeof MessageChannel) {
        var T = new MessageChannel(),
          U = T.port2;
        T.port1.onmessage = R;
        S = function () {
          U.postMessage(null);
        };
      } else
        S = function () {
          D(R, 0);
        };
      function I(a) {
        O = a;
        N || ((N = !0), S());
      }
      function K(a, b) {
        L = D(function () {
          a(exports.unstable_now());
        }, b);
      }
      exports.unstable_IdlePriority = 5;
      exports.unstable_ImmediatePriority = 1;
      exports.unstable_LowPriority = 4;
      exports.unstable_NormalPriority = 3;
      exports.unstable_Profiling = null;
      exports.unstable_UserBlockingPriority = 2;
      exports.unstable_cancelCallback = function (a) {
        a.callback = null;
      };
      exports.unstable_continueExecution = function () {
        A || z || ((A = !0), I(J));
      };
      exports.unstable_forceFrameRate = function (a) {
        0 > a || 125 < a
          ? console.error(
              'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported',
            )
          : (P = 0 < a ? Math.floor(1e3 / a) : 5);
      };
      exports.unstable_getCurrentPriorityLevel = function () {
        return y;
      };
      exports.unstable_getFirstCallbackNode = function () {
        return h(r);
      };
      exports.unstable_next = function (a) {
        switch (y) {
          case 1:
          case 2:
          case 3:
            var b = 3;
            break;
          default:
            b = y;
        }
        var c = y;
        y = b;
        try {
          return a();
        } finally {
          y = c;
        }
      };
      exports.unstable_pauseExecution = function () {};
      exports.unstable_requestPaint = function () {};
      exports.unstable_runWithPriority = function (a, b) {
        switch (a) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            a = 3;
        }
        var c = y;
        y = a;
        try {
          return b();
        } finally {
          y = c;
        }
      };
      exports.unstable_scheduleCallback = function (a, b, c) {
        var d = exports.unstable_now();
        'object' === typeof c && null !== c
          ? ((c = c.delay), (c = 'number' === typeof c && 0 < c ? d + c : d))
          : (c = d);
        switch (a) {
          case 1:
            var e = -1;
            break;
          case 2:
            e = 250;
            break;
          case 5:
            e = 1073741823;
            break;
          case 4:
            e = 1e4;
            break;
          default:
            e = 5e3;
        }
        e = c + e;
        a = {
          id: u++,
          callback: b,
          priorityLevel: a,
          startTime: c,
          expirationTime: e,
          sortIndex: -1,
        };
        c > d
          ? ((a.sortIndex = c), f(t, a), null === h(r) && a === h(t) && (B ? (E(L), (L = -1)) : (B = !0), K(H, c - d)))
          : ((a.sortIndex = e), f(r, a), A || z || ((A = !0), I(J)));
        return a;
      };
      exports.unstable_shouldYield = M;
      exports.unstable_wrapCallback = function (a) {
        var b = y;
        return function () {
          var c = y;
          y = b;
          try {
            return a.apply(this, arguments);
          } finally {
            y = c;
          }
        };
      };

      /***/
    },

    /***/ 46304: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      if (true) {
        module.exports = __webpack_require__(26341);
      } else {
      }

      /***/
    },

    /***/ 10173: /***/ (__unused_webpack_module, exports) => {
      'use strict';
      /** @license React v16.13.1
       * react-is.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var b = 'function' === typeof Symbol && Symbol.for,
        c = b ? Symbol.for('react.element') : 60103,
        d = b ? Symbol.for('react.portal') : 60106,
        e = b ? Symbol.for('react.fragment') : 60107,
        f = b ? Symbol.for('react.strict_mode') : 60108,
        g = b ? Symbol.for('react.profiler') : 60114,
        h = b ? Symbol.for('react.provider') : 60109,
        k = b ? Symbol.for('react.context') : 60110,
        l = b ? Symbol.for('react.async_mode') : 60111,
        m = b ? Symbol.for('react.concurrent_mode') : 60111,
        n = b ? Symbol.for('react.forward_ref') : 60112,
        p = b ? Symbol.for('react.suspense') : 60113,
        q = b ? Symbol.for('react.suspense_list') : 60120,
        r = b ? Symbol.for('react.memo') : 60115,
        t = b ? Symbol.for('react.lazy') : 60116,
        v = b ? Symbol.for('react.block') : 60121,
        w = b ? Symbol.for('react.fundamental') : 60117,
        x = b ? Symbol.for('react.responder') : 60118,
        y = b ? Symbol.for('react.scope') : 60119;
      function z(a) {
        if ('object' === typeof a && null !== a) {
          var u = a.$$typeof;
          switch (u) {
            case c:
              switch (((a = a.type), a)) {
                case l:
                case m:
                case e:
                case g:
                case f:
                case p:
                  return a;
                default:
                  switch (((a = a && a.$$typeof), a)) {
                    case k:
                    case n:
                    case t:
                    case r:
                    case h:
                      return a;
                    default:
                      return u;
                  }
              }
            case d:
              return u;
          }
        }
      }
      function A(a) {
        return z(a) === m;
      }
      exports.AsyncMode = l;
      exports.ConcurrentMode = m;
      exports.ContextConsumer = k;
      exports.ContextProvider = h;
      exports.Element = c;
      exports.ForwardRef = n;
      exports.Fragment = e;
      exports.Lazy = t;
      exports.Memo = r;
      exports.Portal = d;
      exports.Profiler = g;
      exports.StrictMode = f;
      exports.Suspense = p;
      exports.isAsyncMode = function (a) {
        return A(a) || z(a) === l;
      };
      exports.isConcurrentMode = A;
      exports.isContextConsumer = function (a) {
        return z(a) === k;
      };
      exports.isContextProvider = function (a) {
        return z(a) === h;
      };
      exports.isElement = function (a) {
        return 'object' === typeof a && null !== a && a.$$typeof === c;
      };
      exports.isForwardRef = function (a) {
        return z(a) === n;
      };
      exports.isFragment = function (a) {
        return z(a) === e;
      };
      exports.isLazy = function (a) {
        return z(a) === t;
      };
      exports.isMemo = function (a) {
        return z(a) === r;
      };
      exports.isPortal = function (a) {
        return z(a) === d;
      };
      exports.isProfiler = function (a) {
        return z(a) === g;
      };
      exports.isStrictMode = function (a) {
        return z(a) === f;
      };
      exports.isSuspense = function (a) {
        return z(a) === p;
      };
      exports.isValidElementType = function (a) {
        return (
          'string' === typeof a ||
          'function' === typeof a ||
          a === e ||
          a === m ||
          a === g ||
          a === f ||
          a === p ||
          a === q ||
          ('object' === typeof a &&
            null !== a &&
            (a.$$typeof === t ||
              a.$$typeof === r ||
              a.$$typeof === h ||
              a.$$typeof === k ||
              a.$$typeof === n ||
              a.$$typeof === w ||
              a.$$typeof === x ||
              a.$$typeof === y ||
              a.$$typeof === v))
        );
      };
      exports.typeOf = z;

      /***/
    },

    /***/ 52305: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      if (true) {
        module.exports = __webpack_require__(10173);
      } else {
      }

      /***/
    },

    /***/ 62135: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
      'use strict';
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */ __webpack_require__.d(__webpack_exports__, {
        /* harmony export */ polyfill: () => /* binding */ polyfill,
        /* harmony export */
      });
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      function componentWillMount() {
        // Call this.constructor.gDSFP to support sub-classes.
        var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
        if (state !== null && state !== undefined) {
          this.setState(state);
        }
      }
      function componentWillReceiveProps(nextProps) {
        // Call this.constructor.gDSFP to support sub-classes.
        // Use the setState() updater to ensure state isn't stale in certain edge cases.
        function updater(prevState) {
          var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
          return state !== null && state !== undefined ? state : null;
        }
        // Binding "this" is important for shallow renderer support.
        this.setState(updater.bind(this));
      }
      function componentWillUpdate(nextProps, nextState) {
        try {
          var prevProps = this.props;
          var prevState = this.state;
          this.props = nextProps;
          this.state = nextState;
          this.__reactInternalSnapshotFlag = true;
          this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
        } finally {
          this.props = prevProps;
          this.state = prevState;
        }
      }

      // React may warn about cWM/cWRP/cWU methods being deprecated.
      // Add a flag to suppress these warnings for this special case.
      componentWillMount.__suppressDeprecationWarning = true;
      componentWillReceiveProps.__suppressDeprecationWarning = true;
      componentWillUpdate.__suppressDeprecationWarning = true;
      function polyfill(Component) {
        var prototype = Component.prototype;
        if (!prototype || !prototype.isReactComponent) {
          throw new Error('Can only polyfill class components');
        }
        if (
          typeof Component.getDerivedStateFromProps !== 'function' &&
          typeof prototype.getSnapshotBeforeUpdate !== 'function'
        ) {
          return Component;
        }

        // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Error if any of these lifecycles are present,
        // Because they would work differently between older and newer (16.3+) versions of React.
        var foundWillMountName = null;
        var foundWillReceivePropsName = null;
        var foundWillUpdateName = null;
        if (typeof prototype.componentWillMount === 'function') {
          foundWillMountName = 'componentWillMount';
        } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
          foundWillMountName = 'UNSAFE_componentWillMount';
        }
        if (typeof prototype.componentWillReceiveProps === 'function') {
          foundWillReceivePropsName = 'componentWillReceiveProps';
        } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
          foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
        }
        if (typeof prototype.componentWillUpdate === 'function') {
          foundWillUpdateName = 'componentWillUpdate';
        } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
          foundWillUpdateName = 'UNSAFE_componentWillUpdate';
        }
        if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
          var componentName = Component.displayName || Component.name;
          var newApiName =
            typeof Component.getDerivedStateFromProps === 'function'
              ? 'getDerivedStateFromProps()'
              : 'getSnapshotBeforeUpdate()';
          throw Error(
            'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
              componentName +
              ' uses ' +
              newApiName +
              ' but also contains the following legacy lifecycles:' +
              (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
              (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') +
              (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
              '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
              'https://fb.me/react-async-component-lifecycle-hooks',
          );
        }

        // React <= 16.2 does not support static getDerivedStateFromProps.
        // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
        // Newer versions of React will ignore these lifecycles if gDSFP exists.
        if (typeof Component.getDerivedStateFromProps === 'function') {
          prototype.componentWillMount = componentWillMount;
          prototype.componentWillReceiveProps = componentWillReceiveProps;
        }

        // React <= 16.2 does not support getSnapshotBeforeUpdate.
        // As a workaround, use cWU to invoke the new lifecycle.
        // Newer versions of React will ignore that lifecycle if gSBU exists.
        if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
          if (typeof prototype.componentDidUpdate !== 'function') {
            throw new Error(
              'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype',
            );
          }
          prototype.componentWillUpdate = componentWillUpdate;
          var componentDidUpdate = prototype.componentDidUpdate;
          prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
          };
        }
        return Component;
      }

      /***/
    },

    /***/ 69770: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.bodyOpenClassName = exports.portalClassName = undefined;
      var _extends =
        Object.assign ||
        function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
      var _createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();
      var _react = __webpack_require__(1986);
      var _react2 = _interopRequireDefault(_react);
      var _reactDom = __webpack_require__(62275);
      var _reactDom2 = _interopRequireDefault(_reactDom);
      var _propTypes = __webpack_require__(39970);
      var _propTypes2 = _interopRequireDefault(_propTypes);
      var _ModalPortal = __webpack_require__(27044);
      var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
      var _ariaAppHider = __webpack_require__(19188);
      var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
      var _safeHTMLElement = __webpack_require__(37080);
      var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
      var _reactLifecyclesCompat = __webpack_require__(62135);
      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};
          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }
          newObj.default = obj;
          return newObj;
        }
      }
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      }
      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== 'function' && superClass !== null) {
          throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true,
          },
        });
        if (superClass)
          Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
      }
      var portalClassName = (exports.portalClassName = 'ReactModalPortal');
      var bodyOpenClassName = (exports.bodyOpenClassName = 'ReactModal__Body--open');
      var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
      var createHTMLElement = function createHTMLElement(name) {
        return document.createElement(name);
      };
      var getCreatePortal = function getCreatePortal() {
        return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
      };
      function getParentElement(parentSelector) {
        return parentSelector();
      }
      var Modal = (function (_Component) {
        _inherits(Modal, _Component);
        function Modal() {
          var _ref;
          var _temp, _this, _ret;
          _classCallCheck(this, Modal);
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return (
            (_ret =
              ((_temp =
                ((_this = _possibleConstructorReturn(
                  this,
                  (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args)),
                )),
                _this)),
              (_this.removePortal = function () {
                !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
                var parent = getParentElement(_this.props.parentSelector);
                if (parent && parent.contains(_this.node)) {
                  parent.removeChild(_this.node);
                } else {
                  // eslint-disable-next-line no-console
                  console.warn(
                    'React-Modal: "parentSelector" prop did not returned any DOM ' +
                      'element. Make sure that the parent element is unmounted to ' +
                      'avoid any memory leaks.',
                  );
                }
              }),
              (_this.portalRef = function (ref) {
                _this.portal = ref;
              }),
              (_this.renderPortal = function (props) {
                var createPortal = getCreatePortal();
                var portal = createPortal(
                  _this,
                  _react2.default.createElement(
                    _ModalPortal2.default,
                    _extends(
                      {
                        defaultStyles: Modal.defaultStyles,
                      },
                      props,
                    ),
                  ),
                  _this.node,
                );
                _this.portalRef(portal);
              }),
              _temp)),
            _possibleConstructorReturn(_this, _ret)
          );
        }
        _createClass(
          Modal,
          [
            {
              key: 'componentDidMount',
              value: function componentDidMount() {
                if (!_safeHTMLElement.canUseDOM) return;
                if (!isReact16) {
                  this.node = createHTMLElement('div');
                }
                this.node.className = this.props.portalClassName;
                var parent = getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !isReact16 && this.renderPortal(this.props);
              },
            },
            {
              key: 'getSnapshotBeforeUpdate',
              value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = getParentElement(prevProps.parentSelector);
                var nextParent = getParentElement(this.props.parentSelector);
                return {
                  prevParent: prevParent,
                  nextParent: nextParent,
                };
              },
            },
            {
              key: 'componentDidUpdate',
              value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!_safeHTMLElement.canUseDOM) return;
                var _props = this.props,
                  isOpen = _props.isOpen,
                  portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) {
                  this.node.className = portalClassName;
                }
                var prevParent = snapshot.prevParent,
                  nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                  prevParent.removeChild(this.node);
                  nextParent.appendChild(this.node);
                }

                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !isReact16 && this.renderPortal(this.props);
              },
            },
            {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt =
                  state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                  if (!state.beforeClose) {
                    this.portal.closeWithTimeout();
                  }
                  setTimeout(this.removePortal, closesAt - now);
                } else {
                  this.removePortal();
                }
              },
            },
            {
              key: 'render',
              value: function render() {
                if (!_safeHTMLElement.canUseDOM || !isReact16) {
                  return null;
                }
                if (!this.node && isReact16) {
                  this.node = createHTMLElement('div');
                }
                var createPortal = getCreatePortal();
                return createPortal(
                  _react2.default.createElement(
                    _ModalPortal2.default,
                    _extends(
                      {
                        ref: this.portalRef,
                        defaultStyles: Modal.defaultStyles,
                      },
                      this.props,
                    ),
                  ),
                  this.node,
                );
              },
            },
          ],
          [
            {
              key: 'setAppElement',
              value: function setAppElement(element) {
                ariaAppHider.setElement(element);
              },

              /* eslint-disable react/no-unused-prop-types */

              /* eslint-disable react/no-unused-prop-types */
            },
          ],
        );
        return Modal;
      })(_react.Component);
      Modal.propTypes = {
        isOpen: _propTypes2.default.bool.isRequired,
        style: _propTypes2.default.shape({
          content: _propTypes2.default.object,
          overlay: _propTypes2.default.object,
        }),
        portalClassName: _propTypes2.default.string,
        bodyOpenClassName: _propTypes2.default.string,
        htmlOpenClassName: _propTypes2.default.string,
        className: _propTypes2.default.oneOfType([
          _propTypes2.default.string,
          _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired,
          }),
        ]),
        overlayClassName: _propTypes2.default.oneOfType([
          _propTypes2.default.string,
          _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired,
          }),
        ]),
        appElement: _propTypes2.default.oneOfType([
          _propTypes2.default.instanceOf(_safeHTMLElement2.default),
          _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
          _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
          _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default)),
        ]),
        onAfterOpen: _propTypes2.default.func,
        onRequestClose: _propTypes2.default.func,
        closeTimeoutMS: _propTypes2.default.number,
        ariaHideApp: _propTypes2.default.bool,
        shouldFocusAfterRender: _propTypes2.default.bool,
        shouldCloseOnOverlayClick: _propTypes2.default.bool,
        shouldReturnFocusAfterClose: _propTypes2.default.bool,
        preventScroll: _propTypes2.default.bool,
        parentSelector: _propTypes2.default.func,
        aria: _propTypes2.default.object,
        data: _propTypes2.default.object,
        role: _propTypes2.default.string,
        contentLabel: _propTypes2.default.string,
        shouldCloseOnEsc: _propTypes2.default.bool,
        overlayRef: _propTypes2.default.func,
        contentRef: _propTypes2.default.func,
        id: _propTypes2.default.string,
        overlayElement: _propTypes2.default.func,
        contentElement: _propTypes2.default.func,
      };
      Modal.defaultProps = {
        isOpen: false,
        portalClassName: portalClassName,
        bodyOpenClassName: bodyOpenClassName,
        role: 'dialog',
        ariaHideApp: true,
        closeTimeoutMS: 0,
        shouldFocusAfterRender: true,
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        shouldReturnFocusAfterClose: true,
        preventScroll: false,
        parentSelector: function parentSelector() {
          return document.body;
        },
        overlayElement: function overlayElement(props, contentEl) {
          return _react2.default.createElement('div', props, contentEl);
        },
        contentElement: function contentElement(props, children) {
          return _react2.default.createElement('div', props, children);
        },
      };
      Modal.defaultStyles = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
        },
        content: {
          position: 'absolute',
          top: '40px',
          left: '40px',
          right: '40px',
          bottom: '40px',
          border: '1px solid #ccc',
          background: '#fff',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '4px',
          outline: 'none',
          padding: '20px',
        },
      };
      (0, _reactLifecyclesCompat.polyfill)(Modal);
      if (false) {
      }
      exports['default'] = Modal;

      /***/
    },

    /***/ 27044: /***/ (module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      var _extends =
        Object.assign ||
        function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
      var _typeof =
        typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
          ? function (obj) {
              return typeof obj;
            }
          : function (obj) {
              return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
                ? 'symbol'
                : typeof obj;
            };
      var _createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();
      var _react = __webpack_require__(1986);
      var _propTypes = __webpack_require__(39970);
      var _propTypes2 = _interopRequireDefault(_propTypes);
      var _focusManager = __webpack_require__(66177);
      var focusManager = _interopRequireWildcard(_focusManager);
      var _scopeTab = __webpack_require__(48401);
      var _scopeTab2 = _interopRequireDefault(_scopeTab);
      var _ariaAppHider = __webpack_require__(19188);
      var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
      var _classList = __webpack_require__(17536);
      var classList = _interopRequireWildcard(_classList);
      var _safeHTMLElement = __webpack_require__(37080);
      var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
      var _portalOpenInstances = __webpack_require__(27858);
      var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
      __webpack_require__(36145);
      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};
          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }
          newObj.default = obj;
          return newObj;
        }
      }
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      }
      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== 'function' && superClass !== null) {
          throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true,
          },
        });
        if (superClass)
          Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
      }

      // so that our CSS is statically analyzable
      var CLASS_NAMES = {
        overlay: 'ReactModal__Overlay',
        content: 'ReactModal__Content',
      };

      /**
       * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
       * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
       * `react-modal` only supports React >18 (which dropped IE support).
       */
      var isTabKey = function isTabKey(event) {
        return event.code === 'Tab' || event.keyCode === 9;
      };
      var isEscKey = function isEscKey(event) {
        return event.code === 'Escape' || event.keyCode === 27;
      };
      var ariaHiddenInstances = 0;
      var ModalPortal = (function (_Component) {
        _inherits(ModalPortal, _Component);
        function ModalPortal(props) {
          _classCallCheck(this, ModalPortal);
          var _this = _possibleConstructorReturn(
            this,
            (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props),
          );
          _this.setOverlayRef = function (overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
          };
          _this.setContentRef = function (content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
          };
          _this.afterClose = function () {
            var _this$props = _this.props,
              appElement = _this$props.appElement,
              ariaHideApp = _this$props.ariaHideApp,
              htmlOpenClassName = _this$props.htmlOpenClassName,
              bodyOpenClassName = _this$props.bodyOpenClassName,
              parentSelector = _this$props.parentSelector;
            var parentDocument = (parentSelector && parentSelector().ownerDocument) || document;

            // Remove classes.
            bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName('html')[0], htmlOpenClassName);

            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && ariaHiddenInstances > 0) {
              ariaHiddenInstances -= 1;
              if (ariaHiddenInstances === 0) {
                ariaAppHider.show(appElement);
              }
            }
            if (_this.props.shouldFocusAfterRender) {
              if (_this.props.shouldReturnFocusAfterClose) {
                focusManager.returnFocus(_this.props.preventScroll);
                focusManager.teardownScopedFocus();
              } else {
                focusManager.popWithoutFocus();
              }
            }
            if (_this.props.onAfterClose) {
              _this.props.onAfterClose();
            }
            _portalOpenInstances2.default.deregister(_this);
          };
          _this.open = function () {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
              clearTimeout(_this.closeTimer);
              _this.setState({
                beforeClose: false,
              });
            } else {
              if (_this.props.shouldFocusAfterRender) {
                focusManager.setupScopedFocus(_this.node);
                focusManager.markForFocusLater();
              }
              _this.setState(
                {
                  isOpen: true,
                },
                function () {
                  _this.openAnimationFrame = requestAnimationFrame(function () {
                    _this.setState({
                      afterOpen: true,
                    });
                    if (_this.props.isOpen && _this.props.onAfterOpen) {
                      _this.props.onAfterOpen({
                        overlayEl: _this.overlay,
                        contentEl: _this.content,
                      });
                    }
                  });
                },
              );
            }
          };
          _this.close = function () {
            if (_this.props.closeTimeoutMS > 0) {
              _this.closeWithTimeout();
            } else {
              _this.closeWithoutTimeout();
            }
          };
          _this.focusContent = function () {
            return (
              _this.content &&
              !_this.contentHasFocus() &&
              _this.content.focus({
                preventScroll: true,
              })
            );
          };
          _this.closeWithTimeout = function () {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState(
              {
                beforeClose: true,
                closesAt: closesAt,
              },
              function () {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
              },
            );
          };
          _this.closeWithoutTimeout = function () {
            _this.setState(
              {
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null,
              },
              _this.afterClose,
            );
          };
          _this.handleKeyDown = function (event) {
            if (isTabKey(event)) {
              (0, _scopeTab2.default)(_this.content, event);
            }
            if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
              event.stopPropagation();
              _this.requestClose(event);
            }
          };
          _this.handleOverlayOnClick = function (event) {
            if (_this.shouldClose === null) {
              _this.shouldClose = true;
            }
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
              if (_this.ownerHandlesClose()) {
                _this.requestClose(event);
              } else {
                _this.focusContent();
              }
            }
            _this.shouldClose = null;
          };
          _this.handleContentOnMouseUp = function () {
            _this.shouldClose = false;
          };
          _this.handleOverlayOnMouseDown = function (event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
              event.preventDefault();
            }
          };
          _this.handleContentOnClick = function () {
            _this.shouldClose = false;
          };
          _this.handleContentOnMouseDown = function () {
            _this.shouldClose = false;
          };
          _this.requestClose = function (event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
          };
          _this.ownerHandlesClose = function () {
            return _this.props.onRequestClose;
          };
          _this.shouldBeClosed = function () {
            return !_this.state.isOpen && !_this.state.beforeClose;
          };
          _this.contentHasFocus = function () {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
          };
          _this.buildClassName = function (which, additional) {
            var classNames =
              (typeof additional === 'undefined' ? 'undefined' : _typeof(additional)) === 'object'
                ? additional
                : {
                    base: CLASS_NAMES[which],
                    afterOpen: CLASS_NAMES[which] + '--after-open',
                    beforeClose: CLASS_NAMES[which] + '--before-close',
                  };
            var className = classNames.base;
            if (_this.state.afterOpen) {
              className = className + ' ' + classNames.afterOpen;
            }
            if (_this.state.beforeClose) {
              className = className + ' ' + classNames.beforeClose;
            }
            return typeof additional === 'string' && additional ? className + ' ' + additional : className;
          };
          _this.attributesFromObject = function (prefix, items) {
            return Object.keys(items).reduce(function (acc, name) {
              acc[prefix + '-' + name] = items[name];
              return acc;
            }, {});
          };
          _this.state = {
            afterOpen: false,
            beforeClose: false,
          };
          _this.shouldClose = null;
          _this.moveFromContentToOverlay = null;
          return _this;
        }
        _createClass(ModalPortal, [
          {
            key: 'componentDidMount',
            value: function componentDidMount() {
              if (this.props.isOpen) {
                this.open();
              }
            },
          },
          {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
              if (false) {
              }
              if (this.props.isOpen && !prevProps.isOpen) {
                this.open();
              } else if (!this.props.isOpen && prevProps.isOpen) {
                this.close();
              }

              // Focus only needs to be set once when the modal is being opened
              if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
                this.focusContent();
              }
            },
          },
          {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (this.state.isOpen) {
                this.afterClose();
              }
              clearTimeout(this.closeTimer);
              cancelAnimationFrame(this.openAnimationFrame);
            },
          },
          {
            key: 'beforeOpen',
            value: function beforeOpen() {
              var _props = this.props,
                appElement = _props.appElement,
                ariaHideApp = _props.ariaHideApp,
                htmlOpenClassName = _props.htmlOpenClassName,
                bodyOpenClassName = _props.bodyOpenClassName,
                parentSelector = _props.parentSelector;
              var parentDocument = (parentSelector && parentSelector().ownerDocument) || document;

              // Add classes.
              bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);
              htmlOpenClassName && classList.add(parentDocument.getElementsByTagName('html')[0], htmlOpenClassName);
              if (ariaHideApp) {
                ariaHiddenInstances += 1;
                ariaAppHider.hide(appElement);
              }
              _portalOpenInstances2.default.register(this);
            },

            // Don't steal focus from inner elements
          },
          {
            key: 'render',
            value: function render() {
              var _props2 = this.props,
                id = _props2.id,
                className = _props2.className,
                overlayClassName = _props2.overlayClassName,
                defaultStyles = _props2.defaultStyles,
                children = _props2.children;
              var contentStyles = className ? {} : defaultStyles.content;
              var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
              if (this.shouldBeClosed()) {
                return null;
              }
              var overlayProps = {
                ref: this.setOverlayRef,
                className: this.buildClassName('overlay', overlayClassName),
                style: _extends({}, overlayStyles, this.props.style.overlay),
                onClick: this.handleOverlayOnClick,
                onMouseDown: this.handleOverlayOnMouseDown,
              };
              var contentProps = _extends(
                {
                  id: id,
                  ref: this.setContentRef,
                  style: _extends({}, contentStyles, this.props.style.content),
                  className: this.buildClassName('content', className),
                  tabIndex: '-1',
                  onKeyDown: this.handleKeyDown,
                  onMouseDown: this.handleContentOnMouseDown,
                  onMouseUp: this.handleContentOnMouseUp,
                  onClick: this.handleContentOnClick,
                  role: this.props.role,
                  'aria-label': this.props.contentLabel,
                },
                this.attributesFromObject(
                  'aria',
                  _extends(
                    {
                      modal: true,
                    },
                    this.props.aria,
                  ),
                ),
                this.attributesFromObject('data', this.props.data || {}),
                {
                  'data-testid': this.props.testId,
                },
              );
              var contentElement = this.props.contentElement(contentProps, children);
              return this.props.overlayElement(overlayProps, contentElement);
            },
          },
        ]);
        return ModalPortal;
      })(_react.Component);
      ModalPortal.defaultProps = {
        style: {
          overlay: {},
          content: {},
        },
        defaultStyles: {},
      };
      ModalPortal.propTypes = {
        isOpen: _propTypes2.default.bool.isRequired,
        defaultStyles: _propTypes2.default.shape({
          content: _propTypes2.default.object,
          overlay: _propTypes2.default.object,
        }),
        style: _propTypes2.default.shape({
          content: _propTypes2.default.object,
          overlay: _propTypes2.default.object,
        }),
        className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
        overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
        parentSelector: _propTypes2.default.func,
        bodyOpenClassName: _propTypes2.default.string,
        htmlOpenClassName: _propTypes2.default.string,
        ariaHideApp: _propTypes2.default.bool,
        appElement: _propTypes2.default.oneOfType([
          _propTypes2.default.instanceOf(_safeHTMLElement2.default),
          _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
          _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
          _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default)),
        ]),
        onAfterOpen: _propTypes2.default.func,
        onAfterClose: _propTypes2.default.func,
        onRequestClose: _propTypes2.default.func,
        closeTimeoutMS: _propTypes2.default.number,
        shouldFocusAfterRender: _propTypes2.default.bool,
        shouldCloseOnOverlayClick: _propTypes2.default.bool,
        shouldReturnFocusAfterClose: _propTypes2.default.bool,
        preventScroll: _propTypes2.default.bool,
        role: _propTypes2.default.string,
        contentLabel: _propTypes2.default.string,
        aria: _propTypes2.default.object,
        data: _propTypes2.default.object,
        children: _propTypes2.default.node,
        shouldCloseOnEsc: _propTypes2.default.bool,
        overlayRef: _propTypes2.default.func,
        contentRef: _propTypes2.default.func,
        id: _propTypes2.default.string,
        overlayElement: _propTypes2.default.func,
        contentElement: _propTypes2.default.func,
        testId: _propTypes2.default.string,
      };
      exports['default'] = ModalPortal;
      module.exports = exports['default'];

      /***/
    },

    /***/ 19188: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.resetState = resetState;
      exports.log = log;
      exports.assertNodeList = assertNodeList;
      exports.setElement = setElement;
      exports.validateElement = validateElement;
      exports.hide = hide;
      exports.show = show;
      exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
      var _warning = __webpack_require__(73389);
      var _warning2 = _interopRequireDefault(_warning);
      var _safeHTMLElement = __webpack_require__(37080);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      var globalElement = null;

      /* eslint-disable no-console */
      /* istanbul ignore next */
      function resetState() {
        if (globalElement) {
          if (globalElement.removeAttribute) {
            globalElement.removeAttribute('aria-hidden');
          } else if (globalElement.length != null) {
            globalElement.forEach(function (element) {
              return element.removeAttribute('aria-hidden');
            });
          } else {
            document.querySelectorAll(globalElement).forEach(function (element) {
              return element.removeAttribute('aria-hidden');
            });
          }
        }
        globalElement = null;
      }

      /* istanbul ignore next */
      function log() {
        if (false) {
          var check;
        }
      }
      /* eslint-disable no-console */

      function assertNodeList(nodeList, selector) {
        if (!nodeList || !nodeList.length) {
          throw new Error('react-modal: No elements were found for selector ' + selector + '.');
        }
      }
      function setElement(element) {
        var useElement = element;
        if (typeof useElement === 'string' && _safeHTMLElement.canUseDOM) {
          var el = document.querySelectorAll(useElement);
          assertNodeList(el, useElement);
          useElement = el;
        }
        globalElement = useElement || globalElement;
        return globalElement;
      }
      function validateElement(appElement) {
        var el = appElement || globalElement;
        if (el) {
          return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
        } else {
          (0, _warning2.default)(
            false,
            [
              'react-modal: App element is not defined.',
              'Please use `Modal.setAppElement(el)` or set `appElement={el}`.',
              "This is needed so screen readers don't see main content",
              'when modal is opened. It is not recommended, but you can opt-out',
              'by setting `ariaHideApp={false}`.',
            ].join(' '),
          );
          return [];
        }
      }
      function hide(appElement) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
          for (
            var _iterator = validateElement(appElement)[Symbol.iterator](), _step;
            !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
            _iteratorNormalCompletion = true
          ) {
            var el = _step.value;
            el.setAttribute('aria-hidden', 'true');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      function show(appElement) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
          for (
            var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2;
            !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
            _iteratorNormalCompletion2 = true
          ) {
            var el = _step2.value;
            el.removeAttribute('aria-hidden');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      function documentNotReadyOrSSRTesting() {
        globalElement = null;
      }

      /***/
    },

    /***/ 36145: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.resetState = resetState;
      exports.log = log;
      var _portalOpenInstances = __webpack_require__(27858);
      var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }

      // Body focus trap see Issue #742

      var before = void 0,
        after = void 0,
        instances = [];

      /* eslint-disable no-console */
      /* istanbul ignore next */
      function resetState() {
        var _arr = [before, after];
        for (var _i = 0; _i < _arr.length; _i++) {
          var item = _arr[_i];
          if (!item) continue;
          item.parentNode && item.parentNode.removeChild(item);
        }
        before = after = null;
        instances = [];
      }

      /* istanbul ignore next */
      function log() {
        console.log('bodyTrap ----------');
        console.log(instances.length);
        var _arr2 = [before, after];
        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
          var item = _arr2[_i2];
          var check = item || {};
          console.log(check.nodeName, check.className, check.id);
        }
        console.log('edn bodyTrap ----------');
      }
      /* eslint-disable no-console */

      function focusContent() {
        if (instances.length === 0) {
          if (false) {
          }
          return;
        }
        instances[instances.length - 1].focusContent();
      }
      function bodyTrap(eventType, openInstances) {
        if (!before && !after) {
          before = document.createElement('div');
          before.setAttribute('data-react-modal-body-trap', '');
          before.style.position = 'absolute';
          before.style.opacity = '0';
          before.setAttribute('tabindex', '0');
          before.addEventListener('focus', focusContent);
          after = before.cloneNode();
          after.addEventListener('focus', focusContent);
        }
        instances = openInstances;
        if (instances.length > 0) {
          // Add focus trap
          if (document.body.firstChild !== before) {
            document.body.insertBefore(before, document.body.firstChild);
          }
          if (document.body.lastChild !== after) {
            document.body.appendChild(after);
          }
        } else {
          // Remove focus trap
          if (before.parentElement) {
            before.parentElement.removeChild(before);
          }
          if (after.parentElement) {
            after.parentElement.removeChild(after);
          }
        }
      }
      _portalOpenInstances2.default.subscribe(bodyTrap);

      /***/
    },

    /***/ 17536: /***/ (__unused_webpack_module, exports) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.resetState = resetState;
      exports.log = log;
      var htmlClassList = {};
      var docBodyClassList = {};

      /* eslint-disable no-console */
      /* istanbul ignore next */
      function removeClass(at, cls) {
        at.classList.remove(cls);
      }

      /* istanbul ignore next */
      function resetState() {
        var htmlElement = document.getElementsByTagName('html')[0];
        for (var cls in htmlClassList) {
          removeClass(htmlElement, htmlClassList[cls]);
        }
        var body = document.body;
        for (var _cls in docBodyClassList) {
          removeClass(body, docBodyClassList[_cls]);
        }
        htmlClassList = {};
        docBodyClassList = {};
      }

      /* istanbul ignore next */
      function log() {
        if (false) {
          var _x, x, buffer, classes;
        }
      }
      /* eslint-disable no-console */

      /**
       * Track the number of reference of a class.
       * @param {object} poll The poll to receive the reference.
       * @param {string} className The class name.
       * @return {string}
       */
      var incrementReference = function incrementReference(poll, className) {
        if (!poll[className]) {
          poll[className] = 0;
        }
        poll[className] += 1;
        return className;
      };

      /**
       * Drop the reference of a class.
       * @param {object} poll The poll to receive the reference.
       * @param {string} className The class name.
       * @return {string}
       */
      var decrementReference = function decrementReference(poll, className) {
        if (poll[className]) {
          poll[className] -= 1;
        }
        return className;
      };

      /**
       * Track a class and add to the given class list.
       * @param {Object} classListRef A class list of an element.
       * @param {Object} poll         The poll to be used.
       * @param {Array}  classes      The list of classes to be tracked.
       */
      var trackClass = function trackClass(classListRef, poll, classes) {
        classes.forEach(function (className) {
          incrementReference(poll, className);
          classListRef.add(className);
        });
      };

      /**
       * Untrack a class and remove from the given class list if the reference
       * reaches 0.
       * @param {Object} classListRef A class list of an element.
       * @param {Object} poll         The poll to be used.
       * @param {Array}  classes      The list of classes to be untracked.
       */
      var untrackClass = function untrackClass(classListRef, poll, classes) {
        classes.forEach(function (className) {
          decrementReference(poll, className);
          poll[className] === 0 && classListRef.remove(className);
        });
      };

      /**
       * Public inferface to add classes to the document.body.
       * @param {string} bodyClass The class string to be added.
       *                           It may contain more then one class
       *                           with ' ' as separator.
       */
      var add = (exports.add = function add(element, classString) {
        return trackClass(
          element.classList,
          element.nodeName.toLowerCase() == 'html' ? htmlClassList : docBodyClassList,
          classString.split(' '),
        );
      });

      /**
       * Public inferface to remove classes from the document.body.
       * @param {string} bodyClass The class string to be added.
       *                           It may contain more then one class
       *                           with ' ' as separator.
       */
      var remove = (exports.remove = function remove(element, classString) {
        return untrackClass(
          element.classList,
          element.nodeName.toLowerCase() == 'html' ? htmlClassList : docBodyClassList,
          classString.split(' '),
        );
      });

      /***/
    },

    /***/ 66177: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.resetState = resetState;
      exports.log = log;
      exports.handleBlur = handleBlur;
      exports.handleFocus = handleFocus;
      exports.markForFocusLater = markForFocusLater;
      exports.returnFocus = returnFocus;
      exports.popWithoutFocus = popWithoutFocus;
      exports.setupScopedFocus = setupScopedFocus;
      exports.teardownScopedFocus = teardownScopedFocus;
      var _tabbable = __webpack_require__(69333);
      var _tabbable2 = _interopRequireDefault(_tabbable);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      var focusLaterElements = [];
      var modalElement = null;
      var needToFocus = false;

      /* eslint-disable no-console */
      /* istanbul ignore next */
      function resetState() {
        focusLaterElements = [];
      }

      /* istanbul ignore next */
      function log() {
        if (false) {
        }
      }
      /* eslint-disable no-console */

      function handleBlur() {
        needToFocus = true;
      }
      function handleFocus() {
        if (needToFocus) {
          needToFocus = false;
          if (!modalElement) {
            return;
          }
          // need to see how jQuery shims document.on('focusin') so we don't need the
          // setTimeout, firefox doesn't support focusin, if it did, we could focus
          // the element outside of a setTimeout. Side-effect of this implementation
          // is that the document.body gets focus, and then we focus our element right
          // after, seems fine.
          setTimeout(function () {
            if (modalElement.contains(document.activeElement)) {
              return;
            }
            var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
            el.focus();
          }, 0);
        }
      }
      function markForFocusLater() {
        focusLaterElements.push(document.activeElement);
      }

      /* eslint-disable no-console */
      function returnFocus() {
        var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var toFocus = null;
        try {
          if (focusLaterElements.length !== 0) {
            toFocus = focusLaterElements.pop();
            toFocus.focus({
              preventScroll: preventScroll,
            });
          }
          return;
        } catch (e) {
          console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(' '));
        }
      }
      /* eslint-disable no-console */

      function popWithoutFocus() {
        focusLaterElements.length > 0 && focusLaterElements.pop();
      }
      function setupScopedFocus(element) {
        modalElement = element;
        if (window.addEventListener) {
          window.addEventListener('blur', handleBlur, false);
          document.addEventListener('focus', handleFocus, true);
        } else {
          window.attachEvent('onBlur', handleBlur);
          document.attachEvent('onFocus', handleFocus);
        }
      }
      function teardownScopedFocus() {
        modalElement = null;
        if (window.addEventListener) {
          window.removeEventListener('blur', handleBlur);
          document.removeEventListener('focus', handleFocus);
        } else {
          window.detachEvent('onBlur', handleBlur);
          document.detachEvent('onFocus', handleFocus);
        }
      }

      /***/
    },

    /***/ 27858: /***/ (__unused_webpack_module, exports) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.log = log;
      exports.resetState = resetState;
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      }

      // Tracks portals that are open and emits events to subscribers

      var PortalOpenInstances = function PortalOpenInstances() {
        var _this = this;
        _classCallCheck(this, PortalOpenInstances);
        this.register = function (openInstance) {
          if (_this.openInstances.indexOf(openInstance) !== -1) {
            if (false) {
            }
            return;
          }
          _this.openInstances.push(openInstance);
          _this.emit('register');
        };
        this.deregister = function (openInstance) {
          var index = _this.openInstances.indexOf(openInstance);
          if (index === -1) {
            if (false) {
            }
            return;
          }
          _this.openInstances.splice(index, 1);
          _this.emit('deregister');
        };
        this.subscribe = function (callback) {
          _this.subscribers.push(callback);
        };
        this.emit = function (eventType) {
          _this.subscribers.forEach(function (subscriber) {
            return subscriber(
              eventType,
              // shallow copy to avoid accidental mutation
              _this.openInstances.slice(),
            );
          });
        };
        this.openInstances = [];
        this.subscribers = [];
      };
      var portalOpenInstances = new PortalOpenInstances();

      /* eslint-disable no-console */
      /* istanbul ignore next */
      function log() {
        console.log('portalOpenInstances ----------');
        console.log(portalOpenInstances.openInstances.length);
        portalOpenInstances.openInstances.forEach(function (p) {
          return console.log(p);
        });
        console.log('end portalOpenInstances ----------');
      }

      /* istanbul ignore next */
      function resetState() {
        portalOpenInstances = new PortalOpenInstances();
      }
      /* eslint-disable no-console */

      exports['default'] = portalOpenInstances;

      /***/
    },

    /***/ 37080: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
      var _exenv = __webpack_require__(47241);
      var _exenv2 = _interopRequireDefault(_exenv);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      var EE = _exenv2.default;
      var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
      var SafeHTMLCollection = (exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {});
      var SafeNodeList = (exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {});
      var canUseDOM = (exports.canUseDOM = EE.canUseDOM);
      exports['default'] = SafeHTMLElement;

      /***/
    },

    /***/ 48401: /***/ (module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports['default'] = scopeTab;
      var _tabbable = __webpack_require__(69333);
      var _tabbable2 = _interopRequireDefault(_tabbable);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      function getActiveElement() {
        var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
        return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
      }
      function scopeTab(node, event) {
        var tabbable = (0, _tabbable2.default)(node);
        if (!tabbable.length) {
          // Do nothing, since there are no elements that can receive focus.
          event.preventDefault();
          return;
        }
        var target = void 0;
        var shiftKey = event.shiftKey;
        var head = tabbable[0];
        var tail = tabbable[tabbable.length - 1];
        var activeElement = getActiveElement();

        // proceed with default browser behavior on tab.
        // Focus on last element on shift + tab.
        if (node === activeElement) {
          if (!shiftKey) return;
          target = tail;
        }
        if (tail === activeElement && !shiftKey) {
          target = head;
        }
        if (head === activeElement && shiftKey) {
          target = tail;
        }
        if (target) {
          event.preventDefault();
          target.focus();
          return;
        }

        // Safari radio issue.
        //
        // Safari does not move the focus to the radio button,
        // so we need to force it to really walk through all elements.
        //
        // This is very error prone, since we are trying to guess
        // if it is a safari browser from the first occurence between
        // chrome or safari.
        //
        // The chrome user agent contains the first ocurrence
        // as the 'chrome/version' and later the 'safari/version'.
        var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
        var isSafariDesktop =
          checkSafari != null && checkSafari[1] != 'Chrome' && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

        // If we are not in safari desktop, let the browser control
        // the focus
        if (!isSafariDesktop) return;
        var x = tabbable.indexOf(activeElement);
        if (x > -1) {
          x += shiftKey ? -1 : 1;
        }
        target = tabbable[x];

        // If the tabbable element does not exist,
        // focus head/tail based on shiftKey
        if (typeof target === 'undefined') {
          event.preventDefault();
          target = shiftKey ? tail : head;
          target.focus();
          return;
        }
        event.preventDefault();
        target.focus();
      }
      module.exports = exports['default'];

      /***/
    },

    /***/ 69333: /***/ (module, exports) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports['default'] = findTabbableDescendants;
      /*!
       * Adapted from jQuery UI core
       *
       * http://jqueryui.com
       *
       * Copyright 2014 jQuery Foundation and other contributors
       * Released under the MIT license.
       * http://jquery.org/license
       *
       * http://api.jqueryui.com/category/ui-core/
       */

      var DISPLAY_NONE = 'none';
      var DISPLAY_CONTENTS = 'contents';
      var tabbableNode = /input|select|textarea|button|object|iframe/;
      function isNotOverflowing(element, style) {
        return (
          style.getPropertyValue('overflow') !== 'visible' ||
          // if 'overflow: visible' set, check if there is actually any overflow
          (element.scrollWidth <= 0 && element.scrollHeight <= 0)
        );
      }
      function hidesContents(element) {
        var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

        // If the node is empty, this is good enough
        if (zeroSize && !element.innerHTML) return true;
        try {
          // Otherwise we need to check some styles
          var style = window.getComputedStyle(element);
          var displayValue = style.getPropertyValue('display');
          return zeroSize
            ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style)
            : displayValue === DISPLAY_NONE;
        } catch (exception) {
          // eslint-disable-next-line no-console
          console.warn('Failed to inspect element style');
          return false;
        }
      }
      function visible(element) {
        var parentElement = element;
        var rootNode = element.getRootNode && element.getRootNode();
        while (parentElement) {
          if (parentElement === document.body) break;

          // if we are not hidden yet, skip to checking outside the Web Component
          if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
          if (hidesContents(parentElement)) return false;
          parentElement = parentElement.parentNode;
        }
        return true;
      }
      function focusable(element, isTabIndexNotNaN) {
        var nodeName = element.nodeName.toLowerCase();
        var res =
          (tabbableNode.test(nodeName) && !element.disabled) ||
          (nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
        return res && visible(element);
      }
      function tabbable(element) {
        var tabIndex = element.getAttribute('tabindex');
        if (tabIndex === null) tabIndex = undefined;
        var isTabIndexNaN = isNaN(tabIndex);
        return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
      }
      function findTabbableDescendants(element) {
        var descendants = [].slice.call(element.querySelectorAll('*'), 0).reduce(function (finished, el) {
          return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
        }, []);
        return descendants.filter(tabbable);
      }
      module.exports = exports['default'];

      /***/
    },

    /***/ 24082: /***/ (module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      var _Modal = __webpack_require__(69770);
      var _Modal2 = _interopRequireDefault(_Modal);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      exports['default'] = _Modal2.default;
      module.exports = exports['default'];

      /***/
    },

    /***/ 86742: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';

      Object.defineProperty(exports, '__esModule', {
        value: true,
      });
      exports['default'] = void 0;
      var _react = _interopRequireWildcard(__webpack_require__(1986));
      var _propTypes = _interopRequireDefault(__webpack_require__(39970));
      var _reactDom = _interopRequireDefault(__webpack_require__(62275));
      var _tether = _interopRequireDefault(__webpack_require__(88072));
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }
      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};
          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc =
                  Object.defineProperty && Object.getOwnPropertyDescriptor
                    ? Object.getOwnPropertyDescriptor(obj, key)
                    : {};
                if (desc.get || desc.set) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }
          }
          newObj.default = obj;
          return newObj;
        }
      }
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      }
      function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i['return'] != null) _i['return']();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _typeof(obj) {
        if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
              ? 'symbol'
              : typeof obj;
          };
        }
        return _typeof(obj);
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          var ownKeys = Object.keys(source);
          if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(
              Object.getOwnPropertySymbols(source).filter(function (sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
              }),
            );
          }
          ownKeys.forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        }
        return target;
      }
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
      }
      function _nonIterableSpread() {
        throw new TypeError('Invalid attempt to spread non-iterable instance');
      }
      function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === '[object Arguments]')
          return Array.from(iter);
      }
      function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        }
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError('Cannot call a class as a function');
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ('value' in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== 'function' && superClass !== null) {
          throw new TypeError('Super expression must either be null or a function');
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true,
          },
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
        return _setPrototypeOf(o, p);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      if (!_tether.default) {
        console.error(
          'It looks like Tether has not been included. Please load this dependency first https://github.com/HubSpot/tether',
        );
      }
      var hasCreatePortal = _reactDom.default.createPortal !== undefined;
      var renderElementToPropTypes = [
        _propTypes.default.string,
        _propTypes.default.shape({
          appendChild: _propTypes.default.func.isRequired,
        }),
      ];
      var childrenPropType = function childrenPropType(_ref, propName, componentName) {
        var children = _ref.children;
        var childCount = _react.Children.count(children);
        if (childCount <= 0) {
          return new Error(''.concat(componentName, ' expects at least one child to use as the target element.'));
        }
        if (childCount > 2) {
          return new Error('Only a max of two children allowed in '.concat(componentName, '.'));
        }
      };
      var attachmentPositions = [
        'auto auto',
        'top left',
        'top center',
        'top right',
        'middle left',
        'middle center',
        'middle right',
        'bottom left',
        'bottom center',
        'bottom right',
      ];
      var TetherComponent =
        /*#__PURE__*/
        (function (_Component) {
          _inherits(TetherComponent, _Component);
          function TetherComponent(props) {
            var _this;
            _classCallCheck(this, TetherComponent);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(TetherComponent).call(this, props));
            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), '_targetNode', null);
            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), '_elementParentNode', null);
            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), '_tether', null);
            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), '_elementComponent', null);
            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), '_targetComponent', null);
            _this.updateChildrenComponents(_this.props);
            return _this;
          }
          _createClass(TetherComponent, [
            {
              key: 'updateChildrenComponents',
              value: function updateChildrenComponents(props) {
                var childArray = _react.Children.toArray(props.children);
                this._targetComponent = childArray[0];
                this._elementComponent = childArray[1];
                if (this._targetComponent && this._elementComponent) {
                  this._createContainer();
                } // Verify if className props have changed

                if (this._elementParentNode && this.props.className !== props.className) {
                  var _this$_elementParentN, _this$_elementParentN2;

                  // Add a bunch of checks against weird classNames
                  var prevClasses = (this.props.className || '').split(' ').filter(function (value) {
                    return value.length > 0;
                  });
                  var currClasses = (props.className || '').split(' ').filter(function (value) {
                    return value.length > 0;
                  });
                  (_this$_elementParentN = this._elementParentNode.classList).remove.apply(
                    _this$_elementParentN,
                    _toConsumableArray(prevClasses),
                  );
                  (_this$_elementParentN2 = this._elementParentNode.classList).add.apply(
                    _this$_elementParentN2,
                    _toConsumableArray(currClasses),
                  );
                }
              },
            },
            {
              key: 'componentDidMount',
              value: function componentDidMount() {
                this._update();
              },
            },
            {
              key: 'componentDidUpdate',
              value: function componentDidUpdate() {
                this._update();
              },
            },
            {
              key: 'componentWillUnmount',
              value: function componentWillUnmount() {
                this._destroy();
              },
            },
            {
              key: 'getTetherInstance',
              value: function getTetherInstance() {
                return this._tether;
              },
            },
            {
              key: 'disable',
              value: function disable() {
                this._tether.disable();
              },
            },
            {
              key: 'enable',
              value: function enable() {
                this._tether.enable();
              },
            },
            {
              key: 'on',
              value: function on(event, handler, ctx) {
                this._tether.on(event, handler, ctx);
              },
            },
            {
              key: 'once',
              value: function once(event, handler, ctx) {
                this._tether.once(event, handler, ctx);
              },
            },
            {
              key: 'off',
              value: function off(event, handler) {
                this._tether.off(event, handler);
              },
            },
            {
              key: 'position',
              value: function position() {
                this._tether.position();
              },
            },
            {
              key: '_registerEventListeners',
              value: function _registerEventListeners() {
                var _this2 = this;
                this.on('update', function () {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  return _this2.props.onUpdate && _this2.props.onUpdate.apply(_this2, args);
                });
                this.on('repositioned', function () {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }
                  return _this2.props.onRepositioned && _this2.props.onRepositioned.apply(_this2, args);
                });
              },
            },
            {
              key: '_destroy',
              value: function _destroy() {
                if (this._elementParentNode) {
                  if (!hasCreatePortal) {
                    _reactDom.default.unmountComponentAtNode(this._elementParentNode);
                  }
                  this._elementParentNode.parentNode.removeChild(this._elementParentNode);
                }
                if (this._tether) {
                  this._tether.destroy();
                }
                this._elementParentNode = null;
                this._tether = null;
                this._targetNode = null;
                this._targetComponent = null;
                this._elementComponent = null;
              },
            },
            {
              key: '_createContainer',
              value: function _createContainer() {
                // Create element node container if it hasn't been yet
                if (!this._elementParentNode) {
                  var _this$props = this.props,
                    renderElementTag = _this$props.renderElementTag,
                    className = _this$props.className; // Create a node that we can stick our content Component in

                  this._elementParentNode = document.createElement(renderElementTag);
                  this._elementParentNode.className = className || ''; // Append node to the render node

                  this._renderNode.appendChild(this._elementParentNode);
                }
              },
            },
            {
              key: '_update',
              value: function _update() {
                var _this3 = this;

                // If no element component provided, bail out
                var shouldDestroy = !this._elementComponent || !this._targetComponent;
                if (!shouldDestroy) {
                  this._targetNode = _reactDom.default.findDOMNode(this);
                  shouldDestroy = !this._targetNode;
                }
                if (shouldDestroy) {
                  // Destroy Tether element, or parent node, if those has been created
                  this._destroy();
                  return;
                }
                if (hasCreatePortal) {
                  this._updateTether();
                } else {
                  // Render element component into the DOM
                  _reactDom.default.unstable_renderSubtreeIntoContainer(
                    this,
                    this._elementComponent,
                    this._elementParentNode,
                    function () {
                      // If we're not destroyed, update Tether once the subtree has finished rendering
                      if (_this3._elementParentNode) {
                        _this3._updateTether();
                      }
                    },
                  );
                }
              },
            },
            {
              key: '_updateTether',
              value: function _updateTether() {
                var _this$props2 = this.props,
                  children = _this$props2.children,
                  renderElementTag = _this$props2.renderElementTag,
                  renderElementTo = _this$props2.renderElementTo,
                  id = _this$props2.id,
                  className = _this$props2.className,
                  style = _this$props2.style,
                  options = _objectWithoutProperties(_this$props2, [
                    'children',
                    'renderElementTag',
                    'renderElementTo',
                    'id',
                    'className',
                    'style',
                  ]);
                var tetherOptions = _objectSpread(
                  {
                    target: this._targetNode,
                    element: this._elementParentNode,
                  },
                  options,
                );
                var idStr = id || '';
                if (this._elementParentNode.id !== idStr) {
                  this._elementParentNode.id = idStr;
                }
                if (style) {
                  var elementStyle = this._elementParentNode.style;
                  Object.keys(style).forEach(function (key) {
                    if (elementStyle[key] !== style[key]) {
                      elementStyle[key] = style[key];
                    }
                  });
                }
                if (this._tether) {
                  this._tether.setOptions(tetherOptions);
                } else {
                  this._tether = new _tether.default(tetherOptions);
                  this._registerEventListeners();
                }
                this._tether.position();
              },
            },
            {
              key: 'render',
              value: function render() {
                if (!this._targetComponent) {
                  return null;
                }
                if (!hasCreatePortal || !this._elementComponent) {
                  return this._targetComponent;
                }
                return [
                  this._targetComponent,
                  _reactDom.default.createPortal(this._elementComponent, this._elementParentNode),
                ];
              },
            },
            {
              key: '_renderNode',
              get: function get() {
                var renderElementTo = this.props.renderElementTo;
                if (typeof renderElementTo === 'string') {
                  return document.querySelector(renderElementTo);
                }
                return renderElementTo || document.body;
              },
            },
          ]);
          return TetherComponent;
        })(_react.Component);
      _defineProperty(TetherComponent, 'propTypes', {
        renderElementTag: _propTypes.default.string,
        renderElementTo: _propTypes.default.oneOfType(renderElementToPropTypes),
        attachment: _propTypes.default.oneOf(attachmentPositions).isRequired,
        targetAttachment: _propTypes.default.oneOf(attachmentPositions),
        offset: _propTypes.default.string,
        targetOffset: _propTypes.default.string,
        targetModifier: _propTypes.default.string,
        enabled: _propTypes.default.bool,
        classes: _propTypes.default.object,
        classPrefix: _propTypes.default.string,
        optimizations: _propTypes.default.object,
        constraints: _propTypes.default.array,
        id: _propTypes.default.string,
        className: _propTypes.default.string,
        style: _propTypes.default.object,
        onUpdate: _propTypes.default.func,
        onRepositioned: _propTypes.default.func,
        children: childrenPropType,
      });
      _defineProperty(TetherComponent, 'defaultProps', {
        renderElementTag: 'div',
        renderElementTo: null,
      });
      function componentWillUpdate(nextProps) {
        this.updateChildrenComponents(nextProps);
      }
      var _React$version$split$ = _react.default.version.split('.').map(Number),
        _React$version$split$2 = _slicedToArray(_React$version$split$, 2),
        major = _React$version$split$2[0],
        patch = _React$version$split$2[1]; // Prevent deprecation notices in React 16.9+

      if (major < 16 || (major === 16 && patch < 9)) {
        TetherComponent.prototype.componentWillUpdate = componentWillUpdate;
      } else {
        // eslint-disable-next-line camelcase
        TetherComponent.prototype.UNSAFE_componentWillUpdate = componentWillUpdate;
      }
      var _default = TetherComponent;
      exports['default'] = _default;

      /***/
    },

    /***/ 91695: /***/ (__unused_webpack_module, exports, __webpack_require__) => {
      'use strict';
      var __webpack_unused_export__;

      __webpack_unused_export__ = {
        value: true,
      };
      Object.defineProperty(exports, 'A', {
        enumerable: true,
        get: function get() {
          return _TetherComponent.default;
        },
      });
      var _TetherComponent = _interopRequireDefault(__webpack_require__(86742));
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule
          ? obj
          : {
              default: obj,
            };
      }

      /***/
    },

    /***/ 16109: /***/ (__unused_webpack_module, exports) => {
      'use strict';
      /**
       * @license React
       * react.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var l = Symbol.for('react.element'),
        n = Symbol.for('react.portal'),
        p = Symbol.for('react.fragment'),
        q = Symbol.for('react.strict_mode'),
        r = Symbol.for('react.profiler'),
        t = Symbol.for('react.provider'),
        u = Symbol.for('react.context'),
        v = Symbol.for('react.forward_ref'),
        w = Symbol.for('react.suspense'),
        x = Symbol.for('react.memo'),
        y = Symbol.for('react.lazy'),
        z = Symbol.iterator;
      function A(a) {
        if (null === a || 'object' !== typeof a) return null;
        a = (z && a[z]) || a['@@iterator'];
        return 'function' === typeof a ? a : null;
      }
      var B = {
          isMounted: function () {
            return !1;
          },
          enqueueForceUpdate: function () {},
          enqueueReplaceState: function () {},
          enqueueSetState: function () {},
        },
        C = Object.assign,
        D = {};
      function E(a, b, e) {
        this.props = a;
        this.context = b;
        this.refs = D;
        this.updater = e || B;
      }
      E.prototype.isReactComponent = {};
      E.prototype.setState = function (a, b) {
        if ('object' !== typeof a && 'function' !== typeof a && null != a)
          throw Error(
            'setState(...): takes an object of state variables to update or a function which returns an object of state variables.',
          );
        this.updater.enqueueSetState(this, a, b, 'setState');
      };
      E.prototype.forceUpdate = function (a) {
        this.updater.enqueueForceUpdate(this, a, 'forceUpdate');
      };
      function F() {}
      F.prototype = E.prototype;
      function G(a, b, e) {
        this.props = a;
        this.context = b;
        this.refs = D;
        this.updater = e || B;
      }
      var H = (G.prototype = new F());
      H.constructor = G;
      C(H, E.prototype);
      H.isPureReactComponent = !0;
      var I = Array.isArray,
        J = Object.prototype.hasOwnProperty,
        K = {
          current: null,
        },
        L = {
          key: !0,
          ref: !0,
          __self: !0,
          __source: !0,
        };
      function M(a, b, e) {
        var d,
          c = {},
          k = null,
          h = null;
        if (null != b)
          for (d in (void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = '' + b.key), b))
            J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
        var g = arguments.length - 2;
        if (1 === g) c.children = e;
        else if (1 < g) {
          for (var f = Array(g), m = 0; m < g; m++) f[m] = arguments[m + 2];
          c.children = f;
        }
        if (a && a.defaultProps) for (d in ((g = a.defaultProps), g)) void 0 === c[d] && (c[d] = g[d]);
        return {
          $$typeof: l,
          type: a,
          key: k,
          ref: h,
          props: c,
          _owner: K.current,
        };
      }
      function N(a, b) {
        return {
          $$typeof: l,
          type: a.type,
          key: b,
          ref: a.ref,
          props: a.props,
          _owner: a._owner,
        };
      }
      function O(a) {
        return 'object' === typeof a && null !== a && a.$$typeof === l;
      }
      function escape(a) {
        var b = {
          '=': '=0',
          ':': '=2',
        };
        return (
          '$' +
          a.replace(/[=:]/g, function (a) {
            return b[a];
          })
        );
      }
      var P = /\/+/g;
      function Q(a, b) {
        return 'object' === typeof a && null !== a && null != a.key ? escape('' + a.key) : b.toString(36);
      }
      function R(a, b, e, d, c) {
        var k = typeof a;
        if ('undefined' === k || 'boolean' === k) a = null;
        var h = !1;
        if (null === a) h = !0;
        else
          switch (k) {
            case 'string':
            case 'number':
              h = !0;
              break;
            case 'object':
              switch (a.$$typeof) {
                case l:
                case n:
                  h = !0;
              }
          }
        if (h)
          return (
            (h = a),
            (c = c(h)),
            (a = '' === d ? '.' + Q(h, 0) : d),
            I(c)
              ? ((e = ''),
                null != a && (e = a.replace(P, '$&/') + '/'),
                R(c, b, e, '', function (a) {
                  return a;
                }))
              : null != c &&
                (O(c) &&
                  (c = N(c, e + (!c.key || (h && h.key === c.key) ? '' : ('' + c.key).replace(P, '$&/') + '/') + a)),
                b.push(c)),
            1
          );
        h = 0;
        d = '' === d ? '.' : d + ':';
        if (I(a))
          for (var g = 0; g < a.length; g++) {
            k = a[g];
            var f = d + Q(k, g);
            h += R(k, b, e, f, c);
          }
        else if (((f = A(a)), 'function' === typeof f))
          for (a = f.call(a), g = 0; !(k = a.next()).done; )
            (k = k.value), (f = d + Q(k, g++)), (h += R(k, b, e, f, c));
        else if ('object' === k)
          throw (
            ((b = String(a)),
            Error(
              'Objects are not valid as a React child (found: ' +
                ('[object Object]' === b ? 'object with keys {' + Object.keys(a).join(', ') + '}' : b) +
                '). If you meant to render a collection of children, use an array instead.',
            ))
          );
        return h;
      }
      function S(a, b, e) {
        if (null == a) return a;
        var d = [],
          c = 0;
        R(a, d, '', '', function (a) {
          return b.call(e, a, c++);
        });
        return d;
      }
      function T(a) {
        if (-1 === a._status) {
          var b = a._result;
          b = b();
          b.then(
            function (b) {
              if (0 === a._status || -1 === a._status) (a._status = 1), (a._result = b);
            },
            function (b) {
              if (0 === a._status || -1 === a._status) (a._status = 2), (a._result = b);
            },
          );
          -1 === a._status && ((a._status = 0), (a._result = b));
        }
        if (1 === a._status) return a._result.default;
        throw a._result;
      }
      var U = {
          current: null,
        },
        V = {
          transition: null,
        },
        W = {
          ReactCurrentDispatcher: U,
          ReactCurrentBatchConfig: V,
          ReactCurrentOwner: K,
        };
      function X() {
        throw Error('act(...) is not supported in production builds of React.');
      }
      exports.Children = {
        map: S,
        forEach: function (a, b, e) {
          S(
            a,
            function () {
              b.apply(this, arguments);
            },
            e,
          );
        },
        count: function (a) {
          var b = 0;
          S(a, function () {
            b++;
          });
          return b;
        },
        toArray: function (a) {
          return (
            S(a, function (a) {
              return a;
            }) || []
          );
        },
        only: function (a) {
          if (!O(a)) throw Error('React.Children.only expected to receive a single React element child.');
          return a;
        },
      };
      exports.Component = E;
      exports.Fragment = p;
      exports.Profiler = r;
      exports.PureComponent = G;
      exports.StrictMode = q;
      exports.Suspense = w;
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
      exports.act = X;
      exports.cloneElement = function (a, b, e) {
        if (null === a || void 0 === a)
          throw Error('React.cloneElement(...): The argument must be a React element, but you passed ' + a + '.');
        var d = C({}, a.props),
          c = a.key,
          k = a.ref,
          h = a._owner;
        if (null != b) {
          void 0 !== b.ref && ((k = b.ref), (h = K.current));
          void 0 !== b.key && (c = '' + b.key);
          if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
          for (f in b) J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
        }
        var f = arguments.length - 2;
        if (1 === f) d.children = e;
        else if (1 < f) {
          g = Array(f);
          for (var m = 0; m < f; m++) g[m] = arguments[m + 2];
          d.children = g;
        }
        return {
          $$typeof: l,
          type: a.type,
          key: c,
          ref: k,
          props: d,
          _owner: h,
        };
      };
      exports.createContext = function (a) {
        a = {
          $$typeof: u,
          _currentValue: a,
          _currentValue2: a,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
          _defaultValue: null,
          _globalName: null,
        };
        a.Provider = {
          $$typeof: t,
          _context: a,
        };
        return (a.Consumer = a);
      };
      exports.createElement = M;
      exports.createFactory = function (a) {
        var b = M.bind(null, a);
        b.type = a;
        return b;
      };
      exports.createRef = function () {
        return {
          current: null,
        };
      };
      exports.forwardRef = function (a) {
        return {
          $$typeof: v,
          render: a,
        };
      };
      exports.isValidElement = O;
      exports.lazy = function (a) {
        return {
          $$typeof: y,
          _payload: {
            _status: -1,
            _result: a,
          },
          _init: T,
        };
      };
      exports.memo = function (a, b) {
        return {
          $$typeof: x,
          type: a,
          compare: void 0 === b ? null : b,
        };
      };
      exports.startTransition = function (a) {
        var b = V.transition;
        V.transition = {};
        try {
          a();
        } finally {
          V.transition = b;
        }
      };
      exports.unstable_act = X;
      exports.useCallback = function (a, b) {
        return U.current.useCallback(a, b);
      };
      exports.useContext = function (a) {
        return U.current.useContext(a);
      };
      exports.useDebugValue = function () {};
      exports.useDeferredValue = function (a) {
        return U.current.useDeferredValue(a);
      };
      exports.useEffect = function (a, b) {
        return U.current.useEffect(a, b);
      };
      exports.useId = function () {
        return U.current.useId();
      };
      exports.useImperativeHandle = function (a, b, e) {
        return U.current.useImperativeHandle(a, b, e);
      };
      exports.useInsertionEffect = function (a, b) {
        return U.current.useInsertionEffect(a, b);
      };
      exports.useLayoutEffect = function (a, b) {
        return U.current.useLayoutEffect(a, b);
      };
      exports.useMemo = function (a, b) {
        return U.current.useMemo(a, b);
      };
      exports.useReducer = function (a, b, e) {
        return U.current.useReducer(a, b, e);
      };
      exports.useRef = function (a) {
        return U.current.useRef(a);
      };
      exports.useState = function (a) {
        return U.current.useState(a);
      };
      exports.useSyncExternalStore = function (a, b, e) {
        return U.current.useSyncExternalStore(a, b, e);
      };
      exports.useTransition = function () {
        return U.current.useTransition();
      };
      exports.version = '18.3.1';

      /***/
    },

    /***/ 1986: /***/ (module, __unused_webpack_exports, __webpack_require__) => {
      'use strict';

      if (true) {
        module.exports = __webpack_require__(16109);
      } else {
      }

      /***/
    },

    /***/ 46414: /***/ module => {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var runtime = (function (exports) {
        'use strict';

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var defineProperty =
          Object.defineProperty ||
          function (obj, key, desc) {
            obj[key] = desc.value;
          };
        var undefined; // More compressible than void 0.
        var $Symbol = typeof Symbol === 'function' ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || '@@iterator';
        var asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator';
        var toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag';
        function define(obj, key, value) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
          });
          return obj[key];
        }
        try {
          // IE 8 has a broken Object.defineProperty that only works on DOM objects.
          define({}, '');
        } catch (err) {
          define = function (obj, key, value) {
            return (obj[key] = value);
          };
        }
        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []);

          // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.
          defineProperty(generator, '_invoke', {
            value: makeInvokeMethod(innerFn, self, context),
          });
          return generator;
        }
        exports.wrap = wrap;

        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
          try {
            return {
              type: 'normal',
              arg: fn.call(obj, arg),
            };
          } catch (err) {
            return {
              type: 'throw',
              arg: err,
            };
          }
        }
        var GenStateSuspendedStart = 'suspendedStart';
        var GenStateSuspendedYield = 'suspendedYield';
        var GenStateExecuting = 'executing';
        var GenStateCompleted = 'completed';

        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};

        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}

        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        define(IteratorPrototype, iteratorSymbol, function () {
          return this;
        });
        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (
          NativeIteratorPrototype &&
          NativeIteratorPrototype !== Op &&
          hasOwn.call(NativeIteratorPrototype, iteratorSymbol)
        ) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }
        var Gp = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype));
        GeneratorFunction.prototype = GeneratorFunctionPrototype;
        defineProperty(Gp, 'constructor', {
          value: GeneratorFunctionPrototype,
          configurable: true,
        });
        defineProperty(GeneratorFunctionPrototype, 'constructor', {
          value: GeneratorFunction,
          configurable: true,
        });
        GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, 'GeneratorFunction');

        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
          ['next', 'throw', 'return'].forEach(function (method) {
            define(prototype, method, function (arg) {
              return this._invoke(method, arg);
            });
          });
        }
        exports.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === 'function' && genFun.constructor;
          return ctor
            ? ctor === GeneratorFunction ||
                // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (ctor.displayName || ctor.name) === 'GeneratorFunction'
            : false;
        };
        exports.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, 'GeneratorFunction');
          }
          genFun.prototype = Object.create(Gp);
          return genFun;
        };

        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        exports.awrap = function (arg) {
          return {
            __await: arg,
          };
        };
        function AsyncIterator(generator, PromiseImpl) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === 'throw') {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;
              if (value && typeof value === 'object' && hasOwn.call(value, '__await')) {
                return PromiseImpl.resolve(value.__await).then(
                  function (value) {
                    invoke('next', value, resolve, reject);
                  },
                  function (err) {
                    invoke('throw', err, resolve, reject);
                  },
                );
              }
              return PromiseImpl.resolve(value).then(
                function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                },
                function (error) {
                  // If a rejected Promise was yielded, throw the rejection back
                  // into the async generator function so it can be handled there.
                  return invoke('throw', error, resolve, reject);
                },
              );
            }
          }
          var previousPromise;
          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new PromiseImpl(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }
            return (previousPromise =
              // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise
                ? previousPromise.then(
                    callInvokeWithMethodAndArg,
                    // Avoid propagating failures to Promises returned by later
                    // invocations of the iterator.
                    callInvokeWithMethodAndArg,
                  )
                : callInvokeWithMethodAndArg());
          }

          // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).
          defineProperty(this, '_invoke', {
            value: enqueue,
          });
        }
        defineIteratorMethods(AsyncIterator.prototype);
        define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
          return this;
        });
        exports.AsyncIterator = AsyncIterator;

        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
          if (PromiseImpl === void 0) PromiseImpl = Promise;
          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
          return exports.isGeneratorFunction(outerFn)
            ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
                return result.done ? result.value : iter.next();
              });
        };
        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;
          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error('Generator is already running');
            }
            if (state === GenStateCompleted) {
              if (method === 'throw') {
                throw arg;
              }

              // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
              return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while (true) {
              var delegate = context.delegate;
              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);
                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }
              if (context.method === 'next') {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
              } else if (context.method === 'throw') {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }
                context.dispatchException(context.arg);
              } else if (context.method === 'return') {
                context.abrupt('return', context.arg);
              }
              state = GenStateExecuting;
              var record = tryCatch(innerFn, self, context);
              if (record.type === 'normal') {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                if (record.arg === ContinueSentinel) {
                  continue;
                }
                return {
                  value: record.arg,
                  done: context.done,
                };
              } else if (record.type === 'throw') {
                state = GenStateCompleted;
                // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.
                context.method = 'throw';
                context.arg = record.arg;
              }
            }
          };
        }

        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
          var methodName = context.method;
          var method = delegate.iterator[methodName];
          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;

            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === 'throw' && delegate.iterator['return']) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = 'return';
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);
              if (context.method === 'throw') {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }
            if (methodName !== 'return') {
              context.method = 'throw';
              context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
          }
          var record = tryCatch(method, delegate.iterator, context.arg);
          if (record.type === 'throw') {
            context.method = 'throw';
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }
          var info = record.arg;
          if (!info) {
            context.method = 'throw';
            context.arg = new TypeError('iterator result is not an object');
            context.delegate = null;
            return ContinueSentinel;
          }
          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;

            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;

            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== 'return') {
              context.method = 'next';
              context.arg = undefined;
            }
          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          }

          // The delegate iterator is finished, so forget it and continue with
          // the outer generator.
          context.delegate = null;
          return ContinueSentinel;
        }

        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);
        define(Gp, toStringTagSymbol, 'Generator');

        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        define(Gp, iteratorSymbol, function () {
          return this;
        });
        define(Gp, 'toString', function () {
          return '[object Generator]';
        });
        function pushTryEntry(locs) {
          var entry = {
            tryLoc: locs[0],
          };
          if (1 in locs) {
            entry.catchLoc = locs[1];
          }
          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }
          this.tryEntries.push(entry);
        }
        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = 'normal';
          delete record.arg;
          entry.completion = record;
        }
        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [
            {
              tryLoc: 'root',
            },
          ];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }
        exports.keys = function (val) {
          var object = Object(val);
          var keys = [];
          for (var key in object) {
            keys.push(key);
          }
          keys.reverse();

          // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.
          return function next() {
            while (keys.length) {
              var key = keys.pop();
              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            }

            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
          };
        };
        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }
            if (typeof iterable.next === 'function') {
              return iterable;
            }
            if (!isNaN(iterable.length)) {
              var i = -1,
                next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }
                  next.value = undefined;
                  next.done = true;
                  return next;
                };
              return (next.next = next);
            }
          }

          // Return an iterator with no values.
          return {
            next: doneResult,
          };
        }
        exports.values = values;
        function doneResult() {
          return {
            value: undefined,
            done: true,
          };
        }
        Context.prototype = {
          constructor: Context,
          reset: function (skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = 'next';
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === 't' && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },
          stop: function () {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === 'throw') {
              throw rootRecord.arg;
            }
            return this.rval;
          },
          dispatchException: function (exception) {
            if (this.done) {
              throw exception;
            }
            var context = this;
            function handle(loc, caught) {
              record.type = 'throw';
              record.arg = exception;
              context.next = loc;
              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = 'next';
                context.arg = undefined;
              }
              return !!caught;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;
              if (entry.tryLoc === 'root') {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle('end');
              }
              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, 'catchLoc');
                var hasFinally = hasOwn.call(entry, 'finallyLoc');
                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error('try statement without catch or finally');
                }
              }
            }
          },
          abrupt: function (type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc <= this.prev && hasOwn.call(entry, 'finallyLoc') && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }
            if (
              finallyEntry &&
              (type === 'break' || type === 'continue') &&
              finallyEntry.tryLoc <= arg &&
              arg <= finallyEntry.finallyLoc
            ) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
              this.method = 'next';
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }
            return this.complete(record);
          },
          complete: function (record, afterLoc) {
            if (record.type === 'throw') {
              throw record.arg;
            }
            if (record.type === 'break' || record.type === 'continue') {
              this.next = record.arg;
            } else if (record.type === 'return') {
              this.rval = this.arg = record.arg;
              this.method = 'return';
              this.next = 'end';
            } else if (record.type === 'normal' && afterLoc) {
              this.next = afterLoc;
            }
            return ContinueSentinel;
          },
          finish: function (finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },
          catch: function (tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if (record.type === 'throw') {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }
                return thrown;
              }
            }

            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error('illegal catch attempt');
          },
          delegateYield: function (iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc,
            };
            if (this.method === 'next') {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }
            return ContinueSentinel;
          },
        };

        // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.
        return exports;
      })(
        // If this script is executing as a CommonJS module, use module.exports
        // as the regeneratorRuntime namespace. Otherwise create a new empty
        // object. Either way, the resulting object will be used to initialize
        // the regeneratorRuntime variable at the top of this file.
        true ? module.exports : 0,
      );
      try {
        regeneratorRuntime = runtime;
      } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, in modern engines
        // we can explicitly access globalThis. In older engines we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        if (typeof globalThis === 'object') {
          globalThis.regeneratorRuntime = runtime;
        } else {
          Function('r', 'regeneratorRuntime = r')(runtime);
        }
      }

      /***/
    },

    /***/ 12010: /***/ module => {
      'use strict';

      module.exports = function (str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
          return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
      };

      /***/
    },

    /***/ 88072: /***/ function (module, exports) {
      var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__; /*! tether 1.4.7 */

      (function (root, factory) {
        if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(this, function () {
        'use strict';

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ('value' in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        })();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }
        var TetherBase = undefined;
        if (typeof TetherBase === 'undefined') {
          TetherBase = {
            modules: [],
          };
        }
        var zeroElement = null;

        // Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
        // if the element lies within a nested document (<frame> or <iframe>-like).
        function getActualBoundingClientRect(node) {
          var boundingRect = node.getBoundingClientRect();

          // The original object returned by getBoundingClientRect is immutable, so we clone it
          // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
          var rect = {};
          for (var k in boundingRect) {
            rect[k] = boundingRect[k];
          }
          try {
            if (node.ownerDocument !== document) {
              var _frameElement = node.ownerDocument.defaultView.frameElement;
              if (_frameElement) {
                var frameRect = getActualBoundingClientRect(_frameElement);
                rect.top += frameRect.top;
                rect.bottom += frameRect.top;
                rect.left += frameRect.left;
                rect.right += frameRect.left;
              }
            }
          } catch (err) {
            // Ignore "Access is denied" in IE11/Edge
          }
          return rect;
        }
        function getScrollParents(el) {
          // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
          // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
          var computedStyle = getComputedStyle(el) || {};
          var position = computedStyle.position;
          var parents = [];
          if (position === 'fixed') {
            return [el];
          }
          var parent = el;
          while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
            var style = undefined;
            try {
              style = getComputedStyle(parent);
            } catch (err) {}
            if (typeof style === 'undefined' || style === null) {
              parents.push(parent);
              return parents;
            }
            var _style = style;
            var overflow = _style.overflow;
            var overflowX = _style.overflowX;
            var overflowY = _style.overflowY;
            if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
              if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
                parents.push(parent);
              }
            }
          }
          parents.push(el.ownerDocument.body);

          // If the node is within a frame, account for the parent window scroll
          if (el.ownerDocument !== document) {
            parents.push(el.ownerDocument.defaultView);
          }
          return parents;
        }
        var uniqueId = (function () {
          var id = 0;
          return function () {
            return ++id;
          };
        })();
        var zeroPosCache = {};
        var getOrigin = function getOrigin() {
          // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
          // jitter as the user scrolls that messes with our ability to detect if two positions
          // are equivilant or not.  We place an element at the top left of the page that will
          // get the same jitter, so we can cancel the two out.
          var node = zeroElement;
          if (!node || !document.body.contains(node)) {
            node = document.createElement('div');
            node.setAttribute('data-tether-id', uniqueId());
            extend(node.style, {
              top: 0,
              left: 0,
              position: 'absolute',
            });
            document.body.appendChild(node);
            zeroElement = node;
          }
          var id = node.getAttribute('data-tether-id');
          if (typeof zeroPosCache[id] === 'undefined') {
            zeroPosCache[id] = getActualBoundingClientRect(node);

            // Clear the cache when this position call is done
            defer(function () {
              delete zeroPosCache[id];
            });
          }
          return zeroPosCache[id];
        };
        function removeUtilElements() {
          if (zeroElement) {
            document.body.removeChild(zeroElement);
          }
          zeroElement = null;
        }
        function getBounds(el) {
          var doc = undefined;
          if (el === document) {
            doc = document;
            el = document.documentElement;
          } else {
            doc = el.ownerDocument;
          }
          var docEl = doc.documentElement;
          var box = getActualBoundingClientRect(el);
          var origin = getOrigin();
          box.top -= origin.top;
          box.left -= origin.left;
          if (typeof box.width === 'undefined') {
            box.width = document.body.scrollWidth - box.left - box.right;
          }
          if (typeof box.height === 'undefined') {
            box.height = document.body.scrollHeight - box.top - box.bottom;
          }
          box.top = box.top - docEl.clientTop;
          box.left = box.left - docEl.clientLeft;
          box.right = doc.body.clientWidth - box.width - box.left;
          box.bottom = doc.body.clientHeight - box.height - box.top;
          return box;
        }
        function getOffsetParent(el) {
          return el.offsetParent || document.documentElement;
        }
        var _scrollBarSize = null;
        function getScrollBarSize() {
          if (_scrollBarSize) {
            return _scrollBarSize;
          }
          var inner = document.createElement('div');
          inner.style.width = '100%';
          inner.style.height = '200px';
          var outer = document.createElement('div');
          extend(outer.style, {
            position: 'absolute',
            top: 0,
            left: 0,
            pointerEvents: 'none',
            visibility: 'hidden',
            width: '200px',
            height: '150px',
            overflow: 'hidden',
          });
          outer.appendChild(inner);
          document.body.appendChild(outer);
          var widthContained = inner.offsetWidth;
          outer.style.overflow = 'scroll';
          var widthScroll = inner.offsetWidth;
          if (widthContained === widthScroll) {
            widthScroll = outer.clientWidth;
          }
          document.body.removeChild(outer);
          var width = widthContained - widthScroll;
          _scrollBarSize = {
            width: width,
            height: width,
          };
          return _scrollBarSize;
        }
        function extend() {
          var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
          var args = [];
          Array.prototype.push.apply(args, arguments);
          args.slice(1).forEach(function (obj) {
            if (obj) {
              for (var key in obj) {
                if ({}.hasOwnProperty.call(obj, key)) {
                  out[key] = obj[key];
                }
              }
            }
          });
          return out;
        }
        function removeClass(el, name) {
          if (typeof el.classList !== 'undefined') {
            name.split(' ').forEach(function (cls) {
              if (cls.trim()) {
                el.classList.remove(cls);
              }
            });
          } else {
            var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
            var className = getClassName(el).replace(regex, ' ');
            setClassName(el, className);
          }
        }
        function addClass(el, name) {
          if (typeof el.classList !== 'undefined') {
            name.split(' ').forEach(function (cls) {
              if (cls.trim()) {
                el.classList.add(cls);
              }
            });
          } else {
            removeClass(el, name);
            var cls = getClassName(el) + (' ' + name);
            setClassName(el, cls);
          }
        }
        function hasClass(el, name) {
          if (typeof el.classList !== 'undefined') {
            return el.classList.contains(name);
          }
          var className = getClassName(el);
          return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
        }
        function getClassName(el) {
          // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
          // completely separately SVGAnimatedString base classes
          if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
            return el.className.baseVal;
          }
          return el.className;
        }
        function setClassName(el, className) {
          el.setAttribute('class', className);
        }
        function updateClasses(el, add, all) {
          // Of the set of 'all' classes, we need the 'add' classes, and only the
          // 'add' classes to be set.
          all.forEach(function (cls) {
            if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
              removeClass(el, cls);
            }
          });
          add.forEach(function (cls) {
            if (!hasClass(el, cls)) {
              addClass(el, cls);
            }
          });
        }
        var deferred = [];
        var defer = function defer(fn) {
          deferred.push(fn);
        };
        var flush = function flush() {
          var fn = undefined;
          while ((fn = deferred.pop())) {
            fn();
          }
        };
        var Evented = (function () {
          function Evented() {
            _classCallCheck(this, Evented);
          }
          _createClass(Evented, [
            {
              key: 'on',
              value: function on(event, handler, ctx) {
                var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
                if (typeof this.bindings === 'undefined') {
                  this.bindings = {};
                }
                if (typeof this.bindings[event] === 'undefined') {
                  this.bindings[event] = [];
                }
                this.bindings[event].push({
                  handler: handler,
                  ctx: ctx,
                  once: once,
                });
              },
            },
            {
              key: 'once',
              value: function once(event, handler, ctx) {
                this.on(event, handler, ctx, true);
              },
            },
            {
              key: 'off',
              value: function off(event, handler) {
                if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
                  return;
                }
                if (typeof handler === 'undefined') {
                  delete this.bindings[event];
                } else {
                  var i = 0;
                  while (i < this.bindings[event].length) {
                    if (this.bindings[event][i].handler === handler) {
                      this.bindings[event].splice(i, 1);
                    } else {
                      ++i;
                    }
                  }
                }
              },
            },
            {
              key: 'trigger',
              value: function trigger(event) {
                if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
                  var i = 0;
                  for (
                    var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1;
                    _key < _len;
                    _key++
                  ) {
                    args[_key - 1] = arguments[_key];
                  }
                  while (i < this.bindings[event].length) {
                    var _bindings$event$i = this.bindings[event][i];
                    var handler = _bindings$event$i.handler;
                    var ctx = _bindings$event$i.ctx;
                    var once = _bindings$event$i.once;
                    var context = ctx;
                    if (typeof context === 'undefined') {
                      context = this;
                    }
                    handler.apply(context, args);
                    if (once) {
                      this.bindings[event].splice(i, 1);
                    } else {
                      ++i;
                    }
                  }
                }
              },
            },
          ]);
          return Evented;
        })();
        TetherBase.Utils = {
          getActualBoundingClientRect: getActualBoundingClientRect,
          getScrollParents: getScrollParents,
          getBounds: getBounds,
          getOffsetParent: getOffsetParent,
          extend: extend,
          addClass: addClass,
          removeClass: removeClass,
          hasClass: hasClass,
          updateClasses: updateClasses,
          defer: defer,
          flush: flush,
          uniqueId: uniqueId,
          Evented: Evented,
          getScrollBarSize: getScrollBarSize,
          removeUtilElements: removeUtilElements,
        };
        /* globals TetherBase, performance */

        ('use strict');
        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i['return']) _i['return']();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError('Invalid attempt to destructure non-iterable instance');
            }
          };
        })();
        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ('value' in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        })();
        var _get = function get(_x6, _x7, _x8) {
          var _again = true;
          _function: while (_again) {
            var object = _x6,
              property = _x7,
              receiver = _x8;
            _again = false;
            if (object === null) object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === undefined) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return undefined;
              } else {
                _x6 = parent;
                _x7 = property;
                _x8 = receiver;
                _again = true;
                desc = parent = undefined;
                continue _function;
              }
            } else if ('value' in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === undefined) {
                return undefined;
              }
              return getter.call(receiver);
            }
          }
        };
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true,
            },
          });
          if (superClass)
            Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : (subClass.__proto__ = superClass);
        }
        if (typeof TetherBase === 'undefined') {
          throw new Error('You must include the utils.js file before tether.js');
        }
        var _TetherBase$Utils = TetherBase.Utils;
        var getScrollParents = _TetherBase$Utils.getScrollParents;
        var getBounds = _TetherBase$Utils.getBounds;
        var getOffsetParent = _TetherBase$Utils.getOffsetParent;
        var extend = _TetherBase$Utils.extend;
        var addClass = _TetherBase$Utils.addClass;
        var removeClass = _TetherBase$Utils.removeClass;
        var updateClasses = _TetherBase$Utils.updateClasses;
        var defer = _TetherBase$Utils.defer;
        var flush = _TetherBase$Utils.flush;
        var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
        var removeUtilElements = _TetherBase$Utils.removeUtilElements;
        function within(a, b) {
          var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
          return a + diff >= b && b >= a - diff;
        }
        var transformKey = (function () {
          if (typeof document === 'undefined') {
            return '';
          }
          var el = document.createElement('div');
          var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
          for (var i = 0; i < transforms.length; ++i) {
            var key = transforms[i];
            if (el.style[key] !== undefined) {
              return key;
            }
          }
        })();
        var tethers = [];
        var position = function position() {
          tethers.forEach(function (tether) {
            tether.position(false);
          });
          flush();
        };
        function now() {
          if (typeof performance === 'object' && typeof performance.now === 'function') {
            return performance.now();
          }
          return +new Date();
        }
        (function () {
          var lastCall = null;
          var lastDuration = null;
          var pendingTimeout = null;
          var tick = function tick() {
            if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
              // We voluntarily throttle ourselves if we can't manage 60fps
              lastDuration = Math.min(lastDuration - 16, 250);

              // Just in case this is the last event, remember to position just once more
              pendingTimeout = setTimeout(tick, 250);
              return;
            }
            if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
              // Some browsers call events a little too frequently, refuse to run more than is reasonable
              return;
            }
            if (pendingTimeout != null) {
              clearTimeout(pendingTimeout);
              pendingTimeout = null;
            }
            lastCall = now();
            position();
            lastDuration = now() - lastCall;
          };
          if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
            ['resize', 'scroll', 'touchmove'].forEach(function (event) {
              window.addEventListener(event, tick);
            });
          }
        })();
        var MIRROR_LR = {
          center: 'center',
          left: 'right',
          right: 'left',
        };
        var MIRROR_TB = {
          middle: 'middle',
          top: 'bottom',
          bottom: 'top',
        };
        var OFFSET_MAP = {
          top: 0,
          left: 0,
          middle: '50%',
          center: '50%',
          bottom: '100%',
          right: '100%',
        };
        var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
          var left = attachment.left;
          var top = attachment.top;
          if (left === 'auto') {
            left = MIRROR_LR[relativeToAttachment.left];
          }
          if (top === 'auto') {
            top = MIRROR_TB[relativeToAttachment.top];
          }
          return {
            left: left,
            top: top,
          };
        };
        var attachmentToOffset = function attachmentToOffset(attachment) {
          var left = attachment.left;
          var top = attachment.top;
          if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
            left = OFFSET_MAP[attachment.left];
          }
          if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
            top = OFFSET_MAP[attachment.top];
          }
          return {
            left: left,
            top: top,
          };
        };
        function addOffset() {
          var out = {
            top: 0,
            left: 0,
          };
          for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
            offsets[_key] = arguments[_key];
          }
          offsets.forEach(function (_ref) {
            var top = _ref.top;
            var left = _ref.left;
            if (typeof top === 'string') {
              top = parseFloat(top, 10);
            }
            if (typeof left === 'string') {
              left = parseFloat(left, 10);
            }
            out.top += top;
            out.left += left;
          });
          return out;
        }
        function offsetToPx(offset, size) {
          if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
            offset.left = (parseFloat(offset.left, 10) / 100) * size.width;
          }
          if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
            offset.top = (parseFloat(offset.top, 10) / 100) * size.height;
          }
          return offset;
        }
        var parseOffset = function parseOffset(value) {
          var _value$split = value.split(' ');
          var _value$split2 = _slicedToArray(_value$split, 2);
          var top = _value$split2[0];
          var left = _value$split2[1];
          return {
            top: top,
            left: left,
          };
        };
        var parseAttachment = parseOffset;
        var TetherClass = (function (_Evented) {
          _inherits(TetherClass, _Evented);
          function TetherClass(options) {
            var _this = this;
            _classCallCheck(this, TetherClass);
            _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
            this.position = this.position.bind(this);
            tethers.push(this);
            this.history = [];
            this.setOptions(options, false);
            TetherBase.modules.forEach(function (module) {
              if (typeof module.initialize !== 'undefined') {
                module.initialize.call(_this);
              }
            });
            this.position();
          }
          _createClass(TetherClass, [
            {
              key: 'getClass',
              value: function getClass() {
                var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
                var classes = this.options.classes;
                if (typeof classes !== 'undefined' && classes[key]) {
                  return this.options.classes[key];
                } else if (this.options.classPrefix) {
                  return this.options.classPrefix + '-' + key;
                } else {
                  return key;
                }
              },
            },
            {
              key: 'setOptions',
              value: function setOptions(options) {
                var _this2 = this;
                var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
                var defaults = {
                  offset: '0 0',
                  targetOffset: '0 0',
                  targetAttachment: 'auto auto',
                  classPrefix: 'tether',
                };
                this.options = extend(defaults, options);
                var _options = this.options;
                var element = _options.element;
                var target = _options.target;
                var targetModifier = _options.targetModifier;
                this.element = element;
                this.target = target;
                this.targetModifier = targetModifier;
                if (this.target === 'viewport') {
                  this.target = document.body;
                  this.targetModifier = 'visible';
                } else if (this.target === 'scroll-handle') {
                  this.target = document.body;
                  this.targetModifier = 'scroll-handle';
                }
                ['element', 'target'].forEach(function (key) {
                  if (typeof _this2[key] === 'undefined') {
                    throw new Error('Tether Error: Both element and target must be defined');
                  }
                  if (typeof _this2[key].jquery !== 'undefined') {
                    _this2[key] = _this2[key][0];
                  } else if (typeof _this2[key] === 'string') {
                    _this2[key] = document.querySelector(_this2[key]);
                  }
                });
                addClass(this.element, this.getClass('element'));
                if (!(this.options.addTargetClasses === false)) {
                  addClass(this.target, this.getClass('target'));
                }
                if (!this.options.attachment) {
                  throw new Error('Tether Error: You must provide an attachment');
                }
                this.targetAttachment = parseAttachment(this.options.targetAttachment);
                this.attachment = parseAttachment(this.options.attachment);
                this.offset = parseOffset(this.options.offset);
                this.targetOffset = parseOffset(this.options.targetOffset);
                if (typeof this.scrollParents !== 'undefined') {
                  this.disable();
                }
                if (this.targetModifier === 'scroll-handle') {
                  this.scrollParents = [this.target];
                } else {
                  this.scrollParents = getScrollParents(this.target);
                }
                if (!(this.options.enabled === false)) {
                  this.enable(pos);
                }
              },
            },
            {
              key: 'getTargetBounds',
              value: function getTargetBounds() {
                if (typeof this.targetModifier !== 'undefined') {
                  if (this.targetModifier === 'visible') {
                    if (this.target === document.body) {
                      return {
                        top: pageYOffset,
                        left: pageXOffset,
                        height: innerHeight,
                        width: innerWidth,
                      };
                    } else {
                      var bounds = getBounds(this.target);
                      var out = {
                        height: bounds.height,
                        width: bounds.width,
                        top: bounds.top,
                        left: bounds.left,
                      };
                      out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
                      out.height = Math.min(
                        out.height,
                        bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)),
                      );
                      out.height = Math.min(innerHeight, out.height);
                      out.height -= 2;
                      out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
                      out.width = Math.min(
                        out.width,
                        bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)),
                      );
                      out.width = Math.min(innerWidth, out.width);
                      out.width -= 2;
                      if (out.top < pageYOffset) {
                        out.top = pageYOffset;
                      }
                      if (out.left < pageXOffset) {
                        out.left = pageXOffset;
                      }
                      return out;
                    }
                  } else if (this.targetModifier === 'scroll-handle') {
                    var bounds = undefined;
                    var target = this.target;
                    if (target === document.body) {
                      target = document.documentElement;
                      bounds = {
                        left: pageXOffset,
                        top: pageYOffset,
                        height: innerHeight,
                        width: innerWidth,
                      };
                    } else {
                      bounds = getBounds(target);
                    }
                    var style = getComputedStyle(target);
                    var hasBottomScroll =
                      target.scrollWidth > target.clientWidth ||
                      [style.overflow, style.overflowX].indexOf('scroll') >= 0 ||
                      this.target !== document.body;
                    var scrollBottom = 0;
                    if (hasBottomScroll) {
                      scrollBottom = 15;
                    }
                    var height =
                      bounds.height -
                      parseFloat(style.borderTopWidth) -
                      parseFloat(style.borderBottomWidth) -
                      scrollBottom;
                    var out = {
                      width: 15,
                      height: height * 0.975 * (height / target.scrollHeight),
                      left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15,
                    };
                    var fitAdj = 0;
                    if (height < 408 && this.target === document.body) {
                      fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
                    }
                    if (this.target !== document.body) {
                      out.height = Math.max(out.height, 24);
                    }
                    var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
                    out.top =
                      scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
                    if (this.target === document.body) {
                      out.height = Math.max(out.height, 24);
                    }
                    return out;
                  }
                } else {
                  return getBounds(this.target);
                }
              },
            },
            {
              key: 'clearCache',
              value: function clearCache() {
                this._cache = {};
              },
            },
            {
              key: 'cache',
              value: function cache(k, getter) {
                // More than one module will often need the same DOM info, so
                // we keep a cache which is cleared on each position call
                if (typeof this._cache === 'undefined') {
                  this._cache = {};
                }
                if (typeof this._cache[k] === 'undefined') {
                  this._cache[k] = getter.call(this);
                }
                return this._cache[k];
              },
            },
            {
              key: 'enable',
              value: function enable() {
                var _this3 = this;
                var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
                if (!(this.options.addTargetClasses === false)) {
                  addClass(this.target, this.getClass('enabled'));
                }
                addClass(this.element, this.getClass('enabled'));
                this.enabled = true;
                this.scrollParents.forEach(function (parent) {
                  if (parent !== _this3.target.ownerDocument) {
                    parent.addEventListener('scroll', _this3.position);
                  }
                });
                if (pos) {
                  this.position();
                }
              },
            },
            {
              key: 'disable',
              value: function disable() {
                var _this4 = this;
                removeClass(this.target, this.getClass('enabled'));
                removeClass(this.element, this.getClass('enabled'));
                this.enabled = false;
                if (typeof this.scrollParents !== 'undefined') {
                  this.scrollParents.forEach(function (parent) {
                    parent.removeEventListener('scroll', _this4.position);
                  });
                }
              },
            },
            {
              key: 'destroy',
              value: function destroy() {
                var _this5 = this;
                this.disable();
                tethers.forEach(function (tether, i) {
                  if (tether === _this5) {
                    tethers.splice(i, 1);
                  }
                });

                // Remove any elements we were using for convenience from the DOM
                if (tethers.length === 0) {
                  removeUtilElements();
                }
              },
            },
            {
              key: 'updateAttachClasses',
              value: function updateAttachClasses(elementAttach, targetAttach) {
                var _this6 = this;
                elementAttach = elementAttach || this.attachment;
                targetAttach = targetAttach || this.targetAttachment;
                var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
                if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
                  // updateAttachClasses can be called more than once in a position call, so
                  // we need to clean up after ourselves such that when the last defer gets
                  // ran it doesn't add any extra classes from previous calls.
                  this._addAttachClasses.splice(0, this._addAttachClasses.length);
                }
                if (typeof this._addAttachClasses === 'undefined') {
                  this._addAttachClasses = [];
                }
                var add = this._addAttachClasses;
                if (elementAttach.top) {
                  add.push(this.getClass('element-attached') + '-' + elementAttach.top);
                }
                if (elementAttach.left) {
                  add.push(this.getClass('element-attached') + '-' + elementAttach.left);
                }
                if (targetAttach.top) {
                  add.push(this.getClass('target-attached') + '-' + targetAttach.top);
                }
                if (targetAttach.left) {
                  add.push(this.getClass('target-attached') + '-' + targetAttach.left);
                }
                var all = [];
                sides.forEach(function (side) {
                  all.push(_this6.getClass('element-attached') + '-' + side);
                  all.push(_this6.getClass('target-attached') + '-' + side);
                });
                defer(function () {
                  if (!(typeof _this6._addAttachClasses !== 'undefined')) {
                    return;
                  }
                  updateClasses(_this6.element, _this6._addAttachClasses, all);
                  if (!(_this6.options.addTargetClasses === false)) {
                    updateClasses(_this6.target, _this6._addAttachClasses, all);
                  }
                  delete _this6._addAttachClasses;
                });
              },
            },
            {
              key: 'position',
              value: function position() {
                var _this7 = this;
                var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

                // flushChanges commits the changes immediately, leave true unless you are positioning multiple
                // tethers (in which case call Tether.Utils.flush yourself when you're done)

                if (!this.enabled) {
                  return;
                }
                this.clearCache();

                // Turn 'auto' attachments into the appropriate corner or edge
                var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
                this.updateAttachClasses(this.attachment, targetAttachment);
                var elementPos = this.cache('element-bounds', function () {
                  return getBounds(_this7.element);
                });
                var width = elementPos.width;
                var height = elementPos.height;
                if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
                  var _lastSize = this.lastSize;

                  // We cache the height and width to make it possible to position elements that are
                  // getting hidden.
                  width = _lastSize.width;
                  height = _lastSize.height;
                } else {
                  this.lastSize = {
                    width: width,
                    height: height,
                  };
                }
                var targetPos = this.cache('target-bounds', function () {
                  return _this7.getTargetBounds();
                });
                var targetSize = targetPos;

                // Get an actual px offset from the attachment
                var offset = offsetToPx(attachmentToOffset(this.attachment), {
                  width: width,
                  height: height,
                });
                var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
                var manualOffset = offsetToPx(this.offset, {
                  width: width,
                  height: height,
                });
                var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

                // Add the manually provided offset
                offset = addOffset(offset, manualOffset);
                targetOffset = addOffset(targetOffset, manualTargetOffset);

                // It's now our goal to make (element position + offset) == (target position + target offset)
                var left = targetPos.left + targetOffset.left - offset.left;
                var top = targetPos.top + targetOffset.top - offset.top;
                for (var i = 0; i < TetherBase.modules.length; ++i) {
                  var _module2 = TetherBase.modules[i];
                  var ret = _module2.position.call(this, {
                    left: left,
                    top: top,
                    targetAttachment: targetAttachment,
                    targetPos: targetPos,
                    elementPos: elementPos,
                    offset: offset,
                    targetOffset: targetOffset,
                    manualOffset: manualOffset,
                    manualTargetOffset: manualTargetOffset,
                    scrollbarSize: scrollbarSize,
                    attachment: this.attachment,
                  });
                  if (ret === false) {
                    return false;
                  } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
                    continue;
                  } else {
                    top = ret.top;
                    left = ret.left;
                  }
                }

                // We describe the position three different ways to give the optimizer
                // a chance to decide the best possible way to position the element
                // with the fewest repaints.
                var next = {
                  // It's position relative to the page (absolute positioning when
                  // the element is a child of the body)
                  page: {
                    top: top,
                    left: left,
                  },
                  // It's position relative to the viewport (fixed positioning)
                  viewport: {
                    top: top - pageYOffset,
                    bottom: pageYOffset - top - height + innerHeight,
                    left: left - pageXOffset,
                    right: pageXOffset - left - width + innerWidth,
                  },
                };
                var doc = this.target.ownerDocument;
                var win = doc.defaultView;
                var scrollbarSize = undefined;
                if (win.innerHeight > doc.documentElement.clientHeight) {
                  scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
                  next.viewport.bottom -= scrollbarSize.height;
                }
                if (win.innerWidth > doc.documentElement.clientWidth) {
                  scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
                  next.viewport.right -= scrollbarSize.width;
                }
                if (
                  ['', 'static'].indexOf(doc.body.style.position) === -1 ||
                  ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1
                ) {
                  // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
                  next.page.bottom = doc.body.scrollHeight - top - height;
                  next.page.right = doc.body.scrollWidth - left - width;
                }
                if (
                  typeof this.options.optimizations !== 'undefined' &&
                  this.options.optimizations.moveElement !== false &&
                  !(typeof this.targetModifier !== 'undefined')
                ) {
                  (function () {
                    var offsetParent = _this7.cache('target-offsetparent', function () {
                      return getOffsetParent(_this7.target);
                    });
                    var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
                      return getBounds(offsetParent);
                    });
                    var offsetParentStyle = getComputedStyle(offsetParent);
                    var offsetParentSize = offsetPosition;
                    var offsetBorder = {};
                    ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
                      offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
                    });
                    offsetPosition.right =
                      doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
                    offsetPosition.bottom =
                      doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
                    if (
                      next.page.top >= offsetPosition.top + offsetBorder.top &&
                      next.page.bottom >= offsetPosition.bottom
                    ) {
                      if (
                        next.page.left >= offsetPosition.left + offsetBorder.left &&
                        next.page.right >= offsetPosition.right
                      ) {
                        // We're within the visible part of the target's scroll parent
                        var scrollTop = offsetParent.scrollTop;
                        var scrollLeft = offsetParent.scrollLeft;

                        // It's position relative to the target's offset parent (absolute positioning when
                        // the element is moved to be a child of the target's offset parent).
                        next.offset = {
                          top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                          left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left,
                        };
                      }
                    }
                  })();
                }

                // We could also travel up the DOM and try each containing context, rather than only
                // looking at the body, but we're gonna get diminishing returns.

                this.move(next);
                this.history.unshift(next);
                if (this.history.length > 3) {
                  this.history.pop();
                }
                if (flushChanges) {
                  flush();
                }
                return true;
              },

              // THE ISSUE
            },
            {
              key: 'move',
              value: function move(pos) {
                var _this8 = this;
                if (!(typeof this.element.parentNode !== 'undefined')) {
                  return;
                }
                var same = {};
                for (var type in pos) {
                  same[type] = {};
                  for (var key in pos[type]) {
                    var found = false;
                    for (var i = 0; i < this.history.length; ++i) {
                      var point = this.history[i];
                      if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
                        found = true;
                        break;
                      }
                    }
                    if (!found) {
                      same[type][key] = true;
                    }
                  }
                }
                var css = {
                  top: '',
                  left: '',
                  right: '',
                  bottom: '',
                };
                var transcribe = function transcribe(_same, _pos) {
                  var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
                  var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
                  if (gpu !== false) {
                    var yPos = undefined,
                      xPos = undefined;
                    if (_same.top) {
                      css.top = 0;
                      yPos = _pos.top;
                    } else {
                      css.bottom = 0;
                      yPos = -_pos.bottom;
                    }
                    if (_same.left) {
                      css.left = 0;
                      xPos = _pos.left;
                    } else {
                      css.right = 0;
                      xPos = -_pos.right;
                    }
                    if (typeof window.devicePixelRatio === 'number' && devicePixelRatio % 1 === 0) {
                      xPos = Math.round(xPos * devicePixelRatio) / devicePixelRatio;
                      yPos = Math.round(yPos * devicePixelRatio) / devicePixelRatio;
                    }
                    css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';
                    if (transformKey !== 'msTransform') {
                      // The Z transform will keep this in the GPU (faster, and prevents artifacts),
                      // but IE9 doesn't support 3d transforms and will choke.
                      css[transformKey] += ' translateZ(0)';
                    }
                  } else {
                    if (_same.top) {
                      css.top = _pos.top + 'px';
                    } else {
                      css.bottom = _pos.bottom + 'px';
                    }
                    if (_same.left) {
                      css.left = _pos.left + 'px';
                    } else {
                      css.right = _pos.right + 'px';
                    }
                  }
                };
                var moved = false;
                if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
                  css.position = 'absolute';
                  transcribe(same.page, pos.page);
                } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
                  css.position = 'fixed';
                  transcribe(same.viewport, pos.viewport);
                } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
                  (function () {
                    css.position = 'absolute';
                    var offsetParent = _this8.cache('target-offsetparent', function () {
                      return getOffsetParent(_this8.target);
                    });
                    if (getOffsetParent(_this8.element) !== offsetParent) {
                      defer(function () {
                        _this8.element.parentNode.removeChild(_this8.element);
                        offsetParent.appendChild(_this8.element);
                      });
                    }
                    transcribe(same.offset, pos.offset);
                    moved = true;
                  })();
                } else {
                  css.position = 'absolute';
                  transcribe(
                    {
                      top: true,
                      left: true,
                    },
                    pos.page,
                  );
                }
                if (!moved) {
                  if (this.options.bodyElement) {
                    if (this.element.parentNode !== this.options.bodyElement) {
                      this.options.bodyElement.appendChild(this.element);
                    }
                  } else {
                    var isFullscreenElement = function isFullscreenElement(e) {
                      var d = e.ownerDocument;
                      var fe =
                        d.fullscreenElement ||
                        d.webkitFullscreenElement ||
                        d.mozFullScreenElement ||
                        d.msFullscreenElement;
                      return fe === e;
                    };
                    var offsetParentIsBody = true;
                    var currentNode = this.element.parentNode;
                    while (
                      currentNode &&
                      currentNode.nodeType === 1 &&
                      currentNode.tagName !== 'BODY' &&
                      !isFullscreenElement(currentNode)
                    ) {
                      if (getComputedStyle(currentNode).position !== 'static') {
                        offsetParentIsBody = false;
                        break;
                      }
                      currentNode = currentNode.parentNode;
                    }
                    if (!offsetParentIsBody) {
                      this.element.parentNode.removeChild(this.element);
                      this.element.ownerDocument.body.appendChild(this.element);
                    }
                  }
                }

                // Any css change will trigger a repaint, so let's avoid one if nothing changed
                var writeCSS = {};
                var write = false;
                for (var key in css) {
                  var val = css[key];
                  var elVal = this.element.style[key];
                  if (elVal !== val) {
                    write = true;
                    writeCSS[key] = val;
                  }
                }
                if (write) {
                  defer(function () {
                    extend(_this8.element.style, writeCSS);
                    _this8.trigger('repositioned');
                  });
                }
              },
            },
          ]);
          return TetherClass;
        })(Evented);
        TetherClass.modules = [];
        TetherBase.position = position;
        var Tether = extend(TetherClass, TetherBase);
        /* globals TetherBase */

        ('use strict');
        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i['return']) _i['return']();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError('Invalid attempt to destructure non-iterable instance');
            }
          };
        })();
        var _TetherBase$Utils = TetherBase.Utils;
        var getBounds = _TetherBase$Utils.getBounds;
        var extend = _TetherBase$Utils.extend;
        var updateClasses = _TetherBase$Utils.updateClasses;
        var defer = _TetherBase$Utils.defer;
        var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];
        function getBoundingRect(tether, to) {
          if (to === 'scrollParent') {
            to = tether.scrollParents[0];
          } else if (to === 'window') {
            to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
          }
          if (to === document) {
            to = to.documentElement;
          }
          if (typeof to.nodeType !== 'undefined') {
            (function () {
              var node = to;
              var size = getBounds(to);
              var pos = size;
              var style = getComputedStyle(to);
              to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

              // Account any parent Frames scroll offset
              if (node.ownerDocument !== document) {
                var win = node.ownerDocument.defaultView;
                to[0] += win.pageXOffset;
                to[1] += win.pageYOffset;
                to[2] += win.pageXOffset;
                to[3] += win.pageYOffset;
              }
              BOUNDS_FORMAT.forEach(function (side, i) {
                side = side[0].toUpperCase() + side.substr(1);
                if (side === 'Top' || side === 'Left') {
                  to[i] += parseFloat(style['border' + side + 'Width']);
                } else {
                  to[i] -= parseFloat(style['border' + side + 'Width']);
                }
              });
            })();
          }
          return to;
        }
        TetherBase.modules.push({
          position: function position(_ref) {
            var _this = this;
            var top = _ref.top;
            var left = _ref.left;
            var targetAttachment = _ref.targetAttachment;
            if (!this.options.constraints) {
              return true;
            }
            var _cache = this.cache('element-bounds', function () {
              return getBounds(_this.element);
            });
            var height = _cache.height;
            var width = _cache.width;
            if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
              var _lastSize = this.lastSize;

              // Handle the item getting hidden as a result of our positioning without glitching
              // the classes in and out
              width = _lastSize.width;
              height = _lastSize.height;
            }
            var targetSize = this.cache('target-bounds', function () {
              return _this.getTargetBounds();
            });
            var targetHeight = targetSize.height;
            var targetWidth = targetSize.width;
            var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];
            this.options.constraints.forEach(function (constraint) {
              var outOfBoundsClass = constraint.outOfBoundsClass;
              var pinnedClass = constraint.pinnedClass;
              if (outOfBoundsClass) {
                allClasses.push(outOfBoundsClass);
              }
              if (pinnedClass) {
                allClasses.push(pinnedClass);
              }
            });
            allClasses.forEach(function (cls) {
              ['left', 'top', 'right', 'bottom'].forEach(function (side) {
                allClasses.push(cls + '-' + side);
              });
            });
            var addClasses = [];
            var tAttachment = extend({}, targetAttachment);
            var eAttachment = extend({}, this.attachment);
            this.options.constraints.forEach(function (constraint) {
              var to = constraint.to;
              var attachment = constraint.attachment;
              var pin = constraint.pin;
              if (typeof attachment === 'undefined') {
                attachment = '';
              }
              var changeAttachX = undefined,
                changeAttachY = undefined;
              if (attachment.indexOf(' ') >= 0) {
                var _attachment$split = attachment.split(' ');
                var _attachment$split2 = _slicedToArray(_attachment$split, 2);
                changeAttachY = _attachment$split2[0];
                changeAttachX = _attachment$split2[1];
              } else {
                changeAttachX = changeAttachY = attachment;
              }
              var bounds = getBoundingRect(_this, to);
              if (changeAttachY === 'target' || changeAttachY === 'both') {
                if (top < bounds[1] && tAttachment.top === 'top') {
                  top += targetHeight;
                  tAttachment.top = 'bottom';
                }
                if (top + height > bounds[3] && tAttachment.top === 'bottom') {
                  top -= targetHeight;
                  tAttachment.top = 'top';
                }
              }
              if (changeAttachY === 'together') {
                if (tAttachment.top === 'top') {
                  if (eAttachment.top === 'bottom' && top < bounds[1]) {
                    top += targetHeight;
                    tAttachment.top = 'bottom';
                    top += height;
                    eAttachment.top = 'top';
                  } else if (
                    eAttachment.top === 'top' &&
                    top + height > bounds[3] &&
                    top - (height - targetHeight) >= bounds[1]
                  ) {
                    top -= height - targetHeight;
                    tAttachment.top = 'bottom';
                    eAttachment.top = 'bottom';
                  }
                }
                if (tAttachment.top === 'bottom') {
                  if (eAttachment.top === 'top' && top + height > bounds[3]) {
                    top -= targetHeight;
                    tAttachment.top = 'top';
                    top -= height;
                    eAttachment.top = 'bottom';
                  } else if (
                    eAttachment.top === 'bottom' &&
                    top < bounds[1] &&
                    top + (height * 2 - targetHeight) <= bounds[3]
                  ) {
                    top += height - targetHeight;
                    tAttachment.top = 'top';
                    eAttachment.top = 'top';
                  }
                }
                if (tAttachment.top === 'middle') {
                  if (top + height > bounds[3] && eAttachment.top === 'top') {
                    top -= height;
                    eAttachment.top = 'bottom';
                  } else if (top < bounds[1] && eAttachment.top === 'bottom') {
                    top += height;
                    eAttachment.top = 'top';
                  }
                }
              }
              if (changeAttachX === 'target' || changeAttachX === 'both') {
                if (left < bounds[0] && tAttachment.left === 'left') {
                  left += targetWidth;
                  tAttachment.left = 'right';
                }
                if (left + width > bounds[2] && tAttachment.left === 'right') {
                  left -= targetWidth;
                  tAttachment.left = 'left';
                }
              }
              if (changeAttachX === 'together') {
                if (left < bounds[0] && tAttachment.left === 'left') {
                  if (eAttachment.left === 'right') {
                    left += targetWidth;
                    tAttachment.left = 'right';
                    left += width;
                    eAttachment.left = 'left';
                  } else if (eAttachment.left === 'left') {
                    left += targetWidth;
                    tAttachment.left = 'right';
                    left -= width;
                    eAttachment.left = 'right';
                  }
                } else if (left + width > bounds[2] && tAttachment.left === 'right') {
                  if (eAttachment.left === 'left') {
                    left -= targetWidth;
                    tAttachment.left = 'left';
                    left -= width;
                    eAttachment.left = 'right';
                  } else if (eAttachment.left === 'right') {
                    left -= targetWidth;
                    tAttachment.left = 'left';
                    left += width;
                    eAttachment.left = 'left';
                  }
                } else if (tAttachment.left === 'center') {
                  if (left + width > bounds[2] && eAttachment.left === 'left') {
                    left -= width;
                    eAttachment.left = 'right';
                  } else if (left < bounds[0] && eAttachment.left === 'right') {
                    left += width;
                    eAttachment.left = 'left';
                  }
                }
              }
              if (changeAttachY === 'element' || changeAttachY === 'both') {
                if (top < bounds[1] && eAttachment.top === 'bottom') {
                  top += height;
                  eAttachment.top = 'top';
                }
                if (top + height > bounds[3] && eAttachment.top === 'top') {
                  top -= height;
                  eAttachment.top = 'bottom';
                }
              }
              if (changeAttachX === 'element' || changeAttachX === 'both') {
                if (left < bounds[0]) {
                  if (eAttachment.left === 'right') {
                    left += width;
                    eAttachment.left = 'left';
                  } else if (eAttachment.left === 'center') {
                    left += width / 2;
                    eAttachment.left = 'left';
                  }
                }
                if (left + width > bounds[2]) {
                  if (eAttachment.left === 'left') {
                    left -= width;
                    eAttachment.left = 'right';
                  } else if (eAttachment.left === 'center') {
                    left -= width / 2;
                    eAttachment.left = 'right';
                  }
                }
              }
              if (typeof pin === 'string') {
                pin = pin.split(',').map(function (p) {
                  return p.trim();
                });
              } else if (pin === true) {
                pin = ['top', 'left', 'right', 'bottom'];
              }
              pin = pin || [];
              var pinned = [];
              var oob = [];
              if (top < bounds[1]) {
                if (pin.indexOf('top') >= 0) {
                  top = bounds[1];
                  pinned.push('top');
                } else {
                  oob.push('top');
                }
              }
              if (top + height > bounds[3]) {
                if (pin.indexOf('bottom') >= 0) {
                  top = bounds[3] - height;
                  pinned.push('bottom');
                } else {
                  oob.push('bottom');
                }
              }
              if (left < bounds[0]) {
                if (pin.indexOf('left') >= 0) {
                  left = bounds[0];
                  pinned.push('left');
                } else {
                  oob.push('left');
                }
              }
              if (left + width > bounds[2]) {
                if (pin.indexOf('right') >= 0) {
                  left = bounds[2] - width;
                  pinned.push('right');
                } else {
                  oob.push('right');
                }
              }
              if (pinned.length) {
                (function () {
                  var pinnedClass = undefined;
                  if (typeof _this.options.pinnedClass !== 'undefined') {
                    pinnedClass = _this.options.pinnedClass;
                  } else {
                    pinnedClass = _this.getClass('pinned');
                  }
                  addClasses.push(pinnedClass);
                  pinned.forEach(function (side) {
                    addClasses.push(pinnedClass + '-' + side);
                  });
                })();
              }
              if (oob.length) {
                (function () {
                  var oobClass = undefined;
                  if (typeof _this.options.outOfBoundsClass !== 'undefined') {
                    oobClass = _this.options.outOfBoundsClass;
                  } else {
                    oobClass = _this.getClass('out-of-bounds');
                  }
                  addClasses.push(oobClass);
                  oob.forEach(function (side) {
                    addClasses.push(oobClass + '-' + side);
                  });
                })();
              }
              if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
                eAttachment.left = tAttachment.left = false;
              }
              if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
                eAttachment.top = tAttachment.top = false;
              }
              if (
                tAttachment.top !== targetAttachment.top ||
                tAttachment.left !== targetAttachment.left ||
                eAttachment.top !== _this.attachment.top ||
                eAttachment.left !== _this.attachment.left
              ) {
                _this.updateAttachClasses(eAttachment, tAttachment);
                _this.trigger('update', {
                  attachment: eAttachment,
                  targetAttachment: tAttachment,
                });
              }
            });
            defer(function () {
              if (!(_this.options.addTargetClasses === false)) {
                updateClasses(_this.target, addClasses, allClasses);
              }
              updateClasses(_this.element, addClasses, allClasses);
            });
            return {
              top: top,
              left: left,
            };
          },
        });
        /* globals TetherBase */

        ('use strict');
        var _TetherBase$Utils = TetherBase.Utils;
        var getBounds = _TetherBase$Utils.getBounds;
        var updateClasses = _TetherBase$Utils.updateClasses;
        var defer = _TetherBase$Utils.defer;
        TetherBase.modules.push({
          position: function position(_ref) {
            var _this = this;
            var top = _ref.top;
            var left = _ref.left;
            var _cache = this.cache('element-bounds', function () {
              return getBounds(_this.element);
            });
            var height = _cache.height;
            var width = _cache.width;
            var targetPos = this.getTargetBounds();
            var bottom = top + height;
            var right = left + width;
            var abutted = [];
            if (top <= targetPos.bottom && bottom >= targetPos.top) {
              ['left', 'right'].forEach(function (side) {
                var targetPosSide = targetPos[side];
                if (targetPosSide === left || targetPosSide === right) {
                  abutted.push(side);
                }
              });
            }
            if (left <= targetPos.right && right >= targetPos.left) {
              ['top', 'bottom'].forEach(function (side) {
                var targetPosSide = targetPos[side];
                if (targetPosSide === top || targetPosSide === bottom) {
                  abutted.push(side);
                }
              });
            }
            var allClasses = [];
            var addClasses = [];
            var sides = ['left', 'top', 'right', 'bottom'];
            allClasses.push(this.getClass('abutted'));
            sides.forEach(function (side) {
              allClasses.push(_this.getClass('abutted') + '-' + side);
            });
            if (abutted.length) {
              addClasses.push(this.getClass('abutted'));
            }
            abutted.forEach(function (side) {
              addClasses.push(_this.getClass('abutted') + '-' + side);
            });
            defer(function () {
              if (!(_this.options.addTargetClasses === false)) {
                updateClasses(_this.target, addClasses, allClasses);
              }
              updateClasses(_this.element, addClasses, allClasses);
            });
            return true;
          },
        });
        /* globals TetherBase */

        ('use strict');
        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i['return']) _i['return']();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError('Invalid attempt to destructure non-iterable instance');
            }
          };
        })();
        TetherBase.modules.push({
          position: function position(_ref) {
            var top = _ref.top;
            var left = _ref.left;
            if (!this.options.shift) {
              return;
            }
            var shift = this.options.shift;
            if (typeof this.options.shift === 'function') {
              shift = this.options.shift.call(this, {
                top: top,
                left: left,
              });
            }
            var shiftTop = undefined,
              shiftLeft = undefined;
            if (typeof shift === 'string') {
              shift = shift.split(' ');
              shift[1] = shift[1] || shift[0];
              var _shift = shift;
              var _shift2 = _slicedToArray(_shift, 2);
              shiftTop = _shift2[0];
              shiftLeft = _shift2[1];
              shiftTop = parseFloat(shiftTop, 10);
              shiftLeft = parseFloat(shiftLeft, 10);
            } else {
              shiftTop = shift.top;
              shiftLeft = shift.left;
            }
            top += shiftTop;
            left += shiftLeft;
            return {
              top: top,
              left: left,
            };
          },
        });
        return Tether;
      });

      /***/
    },

    /***/ 73389: /***/ module => {
      'use strict';
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */
      var __DEV__ = 'production' !== 'production';
      var warning = function () {};
      if (__DEV__) {
        var printWarning = function printWarning(format, args) {
          var len = arguments.length;
          args = new Array(len > 1 ? len - 1 : 0);
          for (var key = 1; key < len; key++) {
            args[key - 1] = arguments[key];
          }
          var argIndex = 0;
          var message =
            'Warning: ' +
            format.replace(/%s/g, function () {
              return args[argIndex++];
            });
          if (typeof console !== 'undefined') {
            console.error(message);
          }
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };
        warning = function (condition, format, args) {
          var len = arguments.length;
          args = new Array(len > 2 ? len - 2 : 0);
          for (var key = 2; key < len; key++) {
            args[key - 2] = arguments[key];
          }
          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }
          if (!condition) {
            printWarning.apply(null, [format].concat(args));
          }
        };
      }
      module.exports = warning;

      /***/
    },

    /***/ 58631: /***/ () => {
      /**
       * Polyfills the .closest method for ELement
       * Currently being used for scrollIntoView
       * For reference: https://github.com/zloirock/core-js/issues/317
       */
      window.Element.prototype.closest = function closest(s) {
        if (!window.Element.prototype.matches) {
          window.Element.prototype.matches =
            window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
        }
        let el = this;
        do {
          if (el.matches(s)) return el;
          el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
      };

      /***/
    },

    /***/ 78444: /***/ (module, exports) => {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
      /* global define */

      (function () {
        'use strict';

        var hasOwn = {}.hasOwnProperty;
        function classNames() {
          var classes = '';
          for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (arg) {
              classes = appendClass(classes, parseValue(arg));
            }
          }
          return classes;
        }
        function parseValue(arg) {
          if (typeof arg === 'string' || typeof arg === 'number') {
            return arg;
          }
          if (typeof arg !== 'object') {
            return '';
          }
          if (Array.isArray(arg)) {
            return classNames.apply(null, arg);
          }
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            return arg.toString();
          }
          var classes = '';
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes = appendClass(classes, key);
            }
          }
          return classes;
        }
        function appendClass(value, newClass) {
          if (!newClass) {
            return value;
          }
          if (value) {
            return value + ' ' + newClass;
          }
          return value + newClass;
        }
        if (true && module.exports) {
          classNames.default = classNames;
          module.exports = classNames;
        } else if (true) {
          // register as 'classnames', consistent with npm package name
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
          (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return classNames;
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })();

      /***/
    },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ id: moduleId,
      /******/ loaded: false,
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/ module.loaded = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/amd options */
  /******/ (() => {
    /******/ __webpack_require__.amdO = {};
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/compat get default export */
  /******/ (() => {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = module => {
      /******/ var getter = module && module.__esModule ? /******/ () => module['default'] : /******/ () => module;
      /******/ __webpack_require__.d(getter, { a: getter });
      /******/ return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          /******/ Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/global */
  /******/ (() => {
    /******/ __webpack_require__.g = (function () {
      /******/ if (typeof globalThis === 'object') return globalThis;
      /******/ try {
        /******/ return this || new Function('return this')();
        /******/
      } catch (e) {
        /******/ if (typeof window === 'object') return window;
        /******/
      }
      /******/
    })();
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = exports => {
      /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
        /******/
      }
      /******/ Object.defineProperty(exports, '__esModule', { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/node module decorator */
  /******/ (() => {
    /******/ __webpack_require__.nmd = module => {
      /******/ module.paths = [];
      /******/ if (!module.children) module.children = [];
      /******/ return module;
      /******/
    };
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    'use strict';

    // EXTERNAL MODULE: ./node_modules/react/index.js
    var react = __webpack_require__(1986);
    // EXTERNAL MODULE: ./node_modules/react-dom/index.js
    var react_dom = __webpack_require__(62275);
    // EXTERNAL MODULE: ./node_modules/events/events.js
    var events = __webpack_require__(57825);
    var events_default = /*#__PURE__*/ __webpack_require__.n(events); // CONCATENATED MODULE: ./i18n/en-US.js
    /* harmony default export */ const en_US = {
      'be.accessStatsPermissionsError': 'Sorry, you do not have permission to see the access stats for this file.',
      'be.activityFeed.fullDateTime': '{time, date, full} at {time, time, short}',
      'be.activityFeedItemApiError':
        'There was a problem loading the activity feed. Please refresh the page or try again later.',
      'be.activitySidebar.activityFeed.annotationMissingError': 'This comment no longer exists',
      'be.activitySidebar.activityFeed.commentMissingError': 'This comment no longer exists',
      'be.activitySidebar.activityFeed.feedInlineErrorTitle': 'Error',
      'be.activitySidebar.activityFeed.hideReplies': 'Hide replies',
      'be.activitySidebar.activityFeed.reply': 'Reply',
      'be.activitySidebar.activityFeed.replyInThread': 'Reply in thread',
      'be.activitySidebar.activityFeed.showReplies':
        'See {repliesToLoadCount, plural, one {# reply} other {# replies}}',
      'be.activitySidebar.activityFeed.taskMissingError': 'This task no longer exists',
      'be.activitySidebarFilter.status.allActivity': 'All Activity',
      'be.activitySidebarFilter.status.allComments': 'All Comments',
      'be.activitySidebarFilter.status.open': 'Unresolved Comments',
      'be.activitySidebarFilter.status.resolved': 'Resolved Comments',
      'be.activitySidebarFilter.status.tasks': 'Tasks',
      'be.add': 'Add',
      'be.additionalTab.blockedByShieldAccessPolicy': 'Use of this app is blocked due to a security policy.',
      'be.annotationThread.errorDeleteAnnotation': 'There was an error deleting this item.',
      'be.annotationThread.errorEditAnnotation': 'This annotation could not be modified.',
      'be.annotattionThread.errorFetchAnnotation': 'The annotation could not be fetched.',
      'be.api.appActivityDeleteErrorMessage': 'There was an error deleting this item.',
      'be.api.commentCreateConflictMessage': 'This comment already exists.',
      'be.api.commentCreateErrorMessage': 'There was an error creating this comment.',
      'be.api.commentDeleteErrorMessage': 'There was an error deleting this comment.',
      'be.api.commentUpdateErrorMessage': 'This comment could not be modified.',
      'be.api.repliesFetchErrorMessage': 'The replies to this comment could not be loaded.',
      'be.api.taskActionErrorTitle': 'Error',
      'be.api.taskApproveErrorMessage':
        'An error has occurred while approving this task. Please refresh the page and try again.',
      'be.api.taskCompleteErrorMessage':
        'An error has occurred while completing this task. Please refresh the page and try again.',
      'be.api.taskCreateErrorMessage': 'An error occurred while creating this task. Please try again.',
      'be.api.taskDeleteErrorMessage':
        'There was an error while deleting this task. Please refresh the page and try again.',
      'be.api.taskGroupExceedsWarningTitle':
        'One or more groups can not receive this task as a group size cannot exceed the limit of {max} assignees per group.',
      'be.api.taskRejectErrorMessage':
        'An error has occurred while rejecting this task. Please refresh the page and try again.',
      'be.appActivity.altIcon': '{appActivityName} Icon',
      'be.appActivity.deleteMenuItem': 'Delete',
      'be.appActivity.deletePrompt': 'Are you sure you want to permanently delete this app activity?',
      'be.back': 'Back',
      'be.bookmark': 'Bookmark',
      'be.boxEditBlacklistedError': 'This file cannot be opened locally',
      'be.boxEditErrorBlockedByPolicy': 'Local editing of this content has been disabled based on an access policy',
      'be.boxToolsInstallMessage': 'Install {boxTools} to open this file on your desktop',
      'be.cancel': 'Cancel',
      'be.choose': 'Choose',
      'be.close': 'Close',
      'be.collaboratedFolder': 'Collaborated Folder',
      'be.collapse': 'Collapse',
      'be.contentInsights.contentAnalyticsErrorText': 'There was a problem loading content insights. Please try again.',
      'be.contentInsights.contentAnalyticsPermissionError': 'Oops! You no longer have access to view content insights.',
      'be.contentInsights.contentInsightsTitle': 'Content Insights',
      'be.contentInsights.downloadGraphLabel': 'Chart displaying the number of downloads over the selected time period',
      'be.contentInsights.downloadGraphType': 'DOWNLOADS',
      'be.contentInsights.openContentInsightsButton': 'See Details',
      'be.contentInsights.peopleGraphLabel': 'Chart displaying the number of users over the selected time period',
      'be.contentInsights.peopleTitle': 'PEOPLE',
      'be.contentInsights.previewGraphLabel': 'Chart displaying the number of previews over the selected time period',
      'be.contentInsights.previewGraphType': 'PREVIEWS',
      'be.contentInsights.trendDown': 'Trending down',
      'be.contentInsights.trendMonth': 'PAST MONTH',
      'be.contentInsights.trendThreeMonths': 'PAST 3 MONTHS',
      'be.contentInsights.trendUp': 'Trending up',
      'be.contentInsights.trendWeek': 'PAST WEEK',
      'be.contentInsights.trendYear': 'PAST YEAR',
      'be.contentSharing.badRequestError': 'The request for this item was malformed.',
      'be.contentSharing.collaboratorsLoadingError': 'Could not retrieve collaborators for this item.',
      'be.contentSharing.getContactsError': 'Could not retrieve contacts.',
      'be.contentSharing.loadingError': 'Could not load shared link for this item.',
      'be.contentSharing.noAccessError': 'You do not have access to this item.',
      'be.contentSharing.notFoundError': 'Could not find shared link for this item.',
      'be.contentSharing.sendInvitesError': 'Could not send invites.',
      'be.contentSharing.sendInvitesSuccess': 'Successfully invited collaborators.',
      'be.contentSharing.sharedLinkRemovalSuccess': 'The shared link for this item was removed.',
      'be.contentSharing.sharedLinkSettingsUpdateSuccess': 'The shared link for this item was successfully updated.',
      'be.contentSharing.sharedLinkUpdateError': 'Could not update the shared link for this item.',
      'be.contentSidebar.activityFeed.annotationActivity.annotationActivityDeleteMenuItem': 'Delete',
      'be.contentSidebar.activityFeed.annotationActivity.annotationActivityDeletePrompt':
        'Are you sure you want to permanently delete this comment?',
      'be.contentSidebar.activityFeed.annotationActivity.annotationActivityEditMenuItem': 'Modify',
      'be.contentSidebar.activityFeed.annotationActivity.annotationActivityPostedFullDateTime':
        '{time, date, full} at {time, time, short}',
      'be.contentSidebar.activityFeed.annotationActivity.annotationActivityResolveMenuItem': 'Resolve',
      'be.contentSidebar.activityFeed.annotationActivity.annotationActivityUnresolveMenuItem': 'Unresolve',
      'be.contentSidebar.activityFeed.annotationActivityPageItem': 'Page {number}',
      'be.contentSidebar.activityFeed.annotationActivityVersionLink': 'Version {number}',
      'be.contentSidebar.activityFeed.annotationActivityVersionUnavailable': 'Version Unavailable',
      'be.contentSidebar.activityFeed.comment.commentDeleteMenuItem': 'Delete',
      'be.contentSidebar.activityFeed.comment.commentDeletePrompt':
        'Are you sure you want to permanently delete this comment?',
      'be.contentSidebar.activityFeed.comment.commentEditMenuItem': 'Modify',
      'be.contentSidebar.activityFeed.comment.commentPostedFullDateTime': '{time, date, full} at {time, time, short}',
      'be.contentSidebar.activityFeed.comment.commentResolveMenuItem': 'Resolve',
      'be.contentSidebar.activityFeed.comment.commentUnresolveMenuItem': 'Unresolve',
      'be.contentSidebar.activityFeed.comment.hideReplies': 'Hide replies',
      'be.contentSidebar.activityFeed.comment.inlineCommentAnnotationIconTitle': 'Inline Comment',
      'be.contentSidebar.activityFeed.comment.reply': 'Reply',
      'be.contentSidebar.activityFeed.comment.replyInThread': 'Reply in thread',
      'be.contentSidebar.activityFeed.comment.showReplies':
        'See {repliesToLoadCount, plural, one {# reply} other {# replies}}',
      'be.contentSidebar.activityFeed.commentForm.approvalAddAssignee': 'Add an assignee',
      'be.contentSidebar.activityFeed.commentForm.approvalAddTask': 'Add Task',
      'be.contentSidebar.activityFeed.commentForm.approvalAddTaskTooltip':
        'Assigning a task to someone will send them a notification with the message in the comment box and allow them to approve or deny.',
      'be.contentSidebar.activityFeed.commentForm.approvalAssignees': 'Assignees',
      'be.contentSidebar.activityFeed.commentForm.approvalDueDate': 'Due Date',
      'be.contentSidebar.activityFeed.commentForm.approvalSelectDate': 'Select a date',
      'be.contentSidebar.activityFeed.commentForm.atMentionTip': '@mention users to notify them.',
      'be.contentSidebar.activityFeed.commentForm.atMentionTipDescription':
        'Use the @ symbol to mention users and use the up and down arrow keys to scroll through autocomplete suggestions.',
      'be.contentSidebar.activityFeed.commentForm.commentCancel': 'Cancel',
      'be.contentSidebar.activityFeed.commentForm.commentLabel': 'Write a comment',
      'be.contentSidebar.activityFeed.commentForm.commentPost': 'Post',
      'be.contentSidebar.activityFeed.commentForm.commentWrite': 'Write a comment',
      'be.contentSidebar.activityFeed.commmon.showOriginalMessage': 'Show Original',
      'be.contentSidebar.activityFeed.common.activityStatusResolved': 'RESOLVED',
      'be.contentSidebar.activityFeed.common.editedMessage': ' (edited)',
      'be.contentSidebar.activityFeed.common.seeLessMessage': 'See less',
      'be.contentSidebar.activityFeed.common.seeMoreMessage': 'See more',
      'be.contentSidebar.activityFeed.common.translateMessage': 'Translate',
      'be.contentSidebar.activityFeed.task.approvalTaskAnnotationIconTitle': 'Approval Task',
      'be.contentSidebar.activityFeed.task.generalTaskAnnotationIconTitle': 'General Task',
      'be.contentSidebar.activityFeed.task.taskAnyAffordanceTooltip':
        'Only one assignee is required to complete this task',
      'be.contentSidebar.activityFeed.task.taskDeleteMenuItem': 'Delete task',
      'be.contentSidebar.activityFeed.task.taskDeletePrompt': 'Are you sure you want to permanently delete this task?',
      'be.contentSidebar.activityFeed.task.taskEditMenuItem': 'Modify task',
      'be.contentSidebar.activityFeed.task.taskMultipleFilesAffordanceTooltip':
        'There are multiple files associated with this task',
      'be.contentSidebar.activityFeed.taskForm.taskAnyCheckboxLabel':
        'Only one assignee is required to complete this task',
      'be.contentSidebar.activityFeed.taskForm.taskAnyInfoGroupTooltip':
        'Selecting this option will require only one assignee to complete this task. This will include assignees across all groups.',
      'be.contentSidebar.activityFeed.taskForm.taskAnyInfoTooltip':
        'By default, all assignees are required to take action before a task is complete. Selecting this option will require only one assignee to complete this task.',
      'be.contentSidebar.activityFeed.taskForm.taskApprovalAssigneeRemovalWarningMessage':
        'Unable to remove assignee(s) because the task is now approved.',
      'be.contentSidebar.activityFeed.taskForm.taskCreateErrorTitle': 'Error',
      'be.contentSidebar.activityFeed.taskForm.taskCreateGroupLabel': 'Group',
      'be.contentSidebar.activityFeed.taskForm.taskEditWarningTitle': 'Task Updated with Errors',
      'be.contentSidebar.activityFeed.taskForm.taskGeneralAssigneeRemovalWarningMessage':
        'Unable to remove assignee(s) because the task is now completed.',
      'be.contentSidebar.activityFeed.taskForm.taskGroupExceedsWarningTitle': 'Exceeded max assignees per group',
      'be.contentSidebar.activityFeed.taskForm.taskUpdateErrorMessage':
        'An error occurred while modifying this task. Please try again.',
      'be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormCancelLabel': 'Cancel',
      'be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormDueDateLabel': 'Due Date',
      'be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormMessageLabel': 'Message',
      'be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormSelectAssigneesLabel': 'Select Assignees',
      'be.contentSidebar.activityFeed.taskForm.tasksAddTaskFormSubmitLabel': 'Create',
      'be.contentSidebar.activityFeed.taskForm.tasksEditTaskFormSubmitLabel': 'Update',
      'be.contentSidebar.activityFeed.taskNew.taskAssignmentCompleted': 'Completed',
      'be.contentSidebar.activityFeed.taskNew.taskCollaboratorLoadErrorMessage':
        'An error has occurred while loading collaborators for this task. Please try again.',
      'be.contentSidebar.activityFeed.taskNew.taskDueDateLabel': 'Due: {date}',
      'be.contentSidebar.activityFeed.taskNew.taskFeedStatusDue': 'DUE {dateTime}',
      'be.contentSidebar.activityFeed.taskNew.taskShowLessAssignees': 'Show Less',
      'be.contentSidebar.activityFeed.taskNew.taskShowMoreAssignees': 'Show {additionalAssigneeCount} More',
      'be.contentSidebar.activityFeed.taskNew.taskShowMoreAssigneesOverflow':
        '{additionalAssigneeCount, plural, one {Show #+ More} other {Show #+ More}}',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedApproveAction': 'Approve',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedApprovedLabel': 'Approved',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedApprovedUppercaseLabel': 'APPROVED',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedAssigneeListTitle': 'Assignees',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedCompleteAction': 'Mark as Complete',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedCompletedLabel': 'Completed',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedCompletedUppercaseLabel': 'COMPLETED',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineApproval': '{user} assigned an Approval Task',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineApprovalCurrentUser':
        '{user} assigned you an Approval Task',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineGeneral': '{user} assigned a Task',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedHeadlineGeneralCurrentUser': '{user} assigned you a Task',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedInProgressLabel': 'In Progress',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedInProgressUppercaseLabel': 'IN PROGRESS',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedMoreAssigneesLabel': 'See all assignees',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedRejectAction': 'Reject',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedRejectedLabel': 'Rejected',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedRejectedUppercaseLabel': 'REJECTED',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedStatusApproved': 'Approved {dateTime}',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedStatusCompleted': 'Completed {dateTime}',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedStatusRejected': 'Rejected {dateTime}',
      'be.contentSidebar.activityFeed.taskNew.tasksFeedViewDetailsAction': 'View Task Details',
      'be.contentSidebar.addTask': 'Add Task',
      'be.contentSidebar.addTask.approval': 'Approval Task',
      'be.contentSidebar.addTask.approval.description':
        'Assignees will be responsible for approving or rejecting tasks',
      'be.contentSidebar.addTask.approval.title': 'Create Approval Task',
      'be.contentSidebar.addTask.general': 'General Task',
      'be.contentSidebar.addTask.general.description': 'Assignees will be responsible for marking tasks as complete',
      'be.contentSidebar.addTask.general.title': 'Create General Task',
      'be.contentSidebar.boxSignFtuxBody':
        'Sign documents or send signature requests, right from where your content lives',
      'be.contentSidebar.boxSignFtuxTitle': 'Box Sign - Secure, seamless e-signatures in Box',
      'be.contentSidebar.boxSignRequest': 'Request Signature',
      'be.contentSidebar.boxSignRequestSignature': 'Request Signature',
      'be.contentSidebar.boxSignSecurityBlockedTooltip': 'This action is unavailable due to a security policy.',
      'be.contentSidebar.boxSignSignMyself': 'Sign Myself',
      'be.contentSidebar.boxSignSignature': 'Sign',
      'be.contentSidebar.boxSignWatermarkBlockedTooltip':
        'This action is unavailable, because the file is watermarked.',
      'be.contentSidebar.editTask.approval.title': 'Modify Approval Task',
      'be.contentSidebar.editTask.general.title': 'Modify General Task',
      'be.copy': 'Copy',
      'be.create': 'Create',
      'be.createDialogErrorInUse': 'A folder with the same name already exists.',
      'be.createDialogErrorInvalid': 'This is an invalid folder name.',
      'be.createDialogErrorTooLong': 'This folder name is too long.',
      'be.createDialogLabel': 'New Folder',
      'be.createDialogText': 'Please enter a name.',
      'be.currentUserErrorHeaderMessage': 'Something went wrong when fetching the current user.',
      'be.dateASC': 'Date: Oldest → Newest',
      'be.dateDESC': 'Date: Newest → Oldest',
      'be.defaultErrorMaskHeaderMessage': 'We’re sorry, something went wrong.',
      'be.defaultErrorMaskSubHeaderMessage': 'Please refresh the page or try again later.',
      'be.defaultInlineErrorContentMessage': 'Please try again later.',
      'be.defaultOpenWithDescription': 'Open this file with a partner service',
      'be.defaultSkill': 'Skill Card',
      'be.delete': 'Delete',
      'be.deleteDialogFileText': 'Are you sure you want to delete {name}?',
      'be.deleteDialogFolderText': 'Are you sure you want to delete {name} and all its contents?',
      'be.deleteDialogLabel': 'Confirm Delete',
      'be.description': 'Description',
      'be.descriptionPlaceholder': 'Enter a description',
      'be.docGenSidebar.docGenTags': 'Doc Gen Tags',
      'be.docGenSidebar.emptyTags': 'This document has no tags',
      'be.docGenSidebar.errorTags': "We couldn't load the tags",
      'be.docGenSidebar.imageTags': 'Image tags',
      'be.docGenSidebar.refreshButton': 'Refresh',
      'be.docGenSidebar.refreshPrompt': 'Please refresh the list.',
      'be.docGenSidebar.textTags': 'Text tags',
      'be.download': 'Download',
      'be.drawAnnotation': 'Drawing annotation mode',
      'be.editLabel': 'Edit',
      'be.emptyOpenWithDescription': 'No integrations are available for this file',
      'be.error': 'Error',
      'be.errorBreadcrumb': 'Error',
      'be.errorOccured': 'An error occurred',
      'be.errorOpenWithDescription': 'Opening this file with other services is currently unavailable',
      'be.errorState': 'A network error has occurred while trying to load.',
      'be.executeIntegrationOpenWithErrorHeader': 'We’re sorry, this integration is currently unavailable.',
      'be.executeIntegrationOpenWithErrorSubHeader': 'Please try again later.',
      'be.expand': 'Expand',
      'be.externalFolder': 'External Folder',
      'be.faceSkill': 'Faces',
      'be.feedbackCtaText': 'Click to provide feedback',
      'be.feedbackFormDescription': 'Beta Feedback Form',
      'be.file': 'File',
      'be.fileAccessStatsErrorHeaderMessage': 'Something went wrong when fetching the access stats.',
      'be.fileClassificationErrorHeaderMessage': 'Something went wrong when fetching classification.',
      'be.fileDescriptionInlineErrorTitleMessage': 'Something went wrong when saving the description.',
      'be.fileRequestDisplayName': 'File Request',
      'be.folderState': 'There are no items in this folder.',
      'be.getVersionInfo': 'Get version information',
      'be.gridView': 'Switch to Grid View',
      'be.gridView.columnSize': 'Column size',
      'be.gridView.decreaseColumnSize': 'Decrease column size',
      'be.gridView.increaseColumnSize': 'Increase column size',
      'be.in': 'In',
      'be.interactedDate': 'Last accessed on {date}',
      'be.itemCreated': 'Created',
      'be.itemInteracted': 'Last Accessed',
      'be.itemModified': 'Modified',
      'be.itemName': 'Name',
      'be.itemOwner': 'Owner',
      'be.itemSize': 'Size',
      'be.itemUploader': 'Uploader',
      'be.keywordSkill': 'Topics',
      'be.keywordsAppliedList': 'Keywords were applied',
      'be.keywordsList': 'Keywords: {words}',
      'be.listView': 'Switch to List View',
      'be.loadingState': 'Please wait while the items load...',
      'be.logo': 'Logo',
      'be.max': 'max',
      'be.messageCenter.all': 'All',
      'be.messageCenter.boxEducation': 'Box Education',
      'be.messageCenter.errorFetchingPosts':
        'Sorry, we are having trouble showing posts at the moment. It may help to refresh the page.',
      'be.messageCenter.events': 'Events',
      'be.messageCenter.noPosts': 'There are no posts for this category at the moment.',
      'be.messageCenter.previewError': "Sorry, we're having trouble showing this image. ",
      'be.messageCenter.product': 'Product',
      'be.messageCenter.title': "What's New",
      'be.metadataState': 'There are no items in this folder.',
      'be.modifiedDate': 'Modified {date}',
      'be.modifiedDateBy': 'Modified {date} by {name}',
      'be.moreOptions': 'More options',
      'be.nameASC': 'Name: A → Z',
      'be.nameDESC': 'Name: Z → A',
      'be.nameDate': '{date} by {name}',
      'be.newFolder': 'New Folder',
      'be.nextFile': 'Next File',
      'be.nextSegment': 'Next Segment',
      'be.noActivity': 'No activity to show',
      'be.noActivityAnnotationPrompt':
        'Hover over the preview and use the controls at the bottom to annotate the file.',
      'be.noActivityCommentPrompt': 'Comment and @mention people to notify them.',
      'be.open': 'Open',
      'be.pagination.nextPage': 'Next Page',
      'be.pagination.pageStatus': '{pageNumber} of {pageCount}',
      'be.pagination.previousPage': 'Previous Page',
      'be.personalFolder': 'Personal Folder',
      'be.pointAnnotation': 'Point annotation mode',
      'be.preview': 'Preview',
      'be.previewError': 'This preview didn’t load. Please try to open or download the file to view.',
      'be.previewErrorBlockedByPolicy': 'Your access to this content is restricted due to a security policy.',
      'be.previewUpdate': 'A new version of this file is available.',
      'be.previousFile': 'Previous File',
      'be.previousSegment': 'Previous Segment',
      'be.print': 'Print',
      'be.priorCollaborator': 'A Prior Collaborator',
      'be.recentsBreadcrumb': 'Recents',
      'be.recentsState': 'There are no recent items yet.',
      'be.reload': 'Reload',
      'be.remove': 'Remove',
      'be.rename': 'Rename',
      'be.renameDialogErrorInUse': 'An item with the same name already exists.',
      'be.renameDialogErrorInvalid': 'This name is invalid.',
      'be.renameDialogErrorTooLong': 'This name is too long.',
      'be.renameDialogLabel': 'Rename',
      'be.renameDialogText': 'Please enter a new name for {name}:',
      'be.resume': 'Resume',
      'be.resumeAll': 'Resume All',
      'be.retry': 'Retry',
      'be.rootBreadcrumb': 'All Files',
      'be.save': 'Save',
      'be.searchBreadcrumb': 'Search Results',
      'be.searchPlaceholder': 'Search files and folders',
      'be.searchState': 'Sorry, we couldn’t find what you’re looking for.',
      'be.selected': '{count} Selected',
      'be.selectedBreadcrumb': 'Selected Items',
      'be.selectedState': 'You haven’t selected any items yet.',
      'be.share': 'Share',
      'be.shareAccessCollab': 'Access: People in this folder',
      'be.shareAccessCompany': 'People in this company',
      'be.shareAccessNone': 'No shared link',
      'be.shareAccessOpen': 'Access: People with the link',
      'be.shareAccessRemove': 'Remove shared link',
      'be.shareDialogLabel': 'Share',
      'be.shareDialogNone': 'None',
      'be.shareDialogText': 'Shared Link:',
      'be.sidebarAccessStats': 'Access Stats',
      'be.sidebarActivityTitle': 'Activity',
      'be.sidebarContentInsights': 'Content Insights',
      'be.sidebarDetailsTitle': 'Details',
      'be.sidebarDocGenTitle': 'Doc Gen Tags',
      'be.sidebarDocGenTooltip': 'Box Doc Gen',
      'be.sidebarFileFetchingErrorContent':
        'An error has occurred while fetching your Box file. Please refresh the page and try again.',
      'be.sidebarHide': 'Hide Sidebar',
      'be.sidebarMetadataEditingErrorContent':
        'An error has occurred while updating metadata. Please refresh the page and try again.',
      'be.sidebarMetadataFetchingErrorContent':
        'An error has occurred while fetching metadata. Please refresh the page and try again.',
      'be.sidebarMetadataTitle': 'Metadata',
      'be.sidebarNavLabel': 'Sidebar',
      'be.sidebarProperties': 'File Properties',
      'be.sidebarShow': 'Show Sidebar',
      'be.sidebarSkillsErrorContent':
        'An error has occurred while updating skills. Please refresh the page and try again.',
      'be.sidebarSkillsErrorTitle': 'Skills Error',
      'be.sidebarSkillsTitle': 'Skills',
      'be.sidebarVersions.current': 'Current Version',
      'be.sidebarVersions.delete': 'Delete',
      'be.sidebarVersions.deleteError': 'File version could not be deleted.',
      'be.sidebarVersions.deletedBy': 'Deleted by {name}',
      'be.sidebarVersions.disabledByRetention': 'Disabled by retention policy',
      'be.sidebarVersions.download': 'Download',
      'be.sidebarVersions.downloadError': 'File version could not be downloaded.',
      'be.sidebarVersions.empty': 'No prior versions are available for this file.',
      'be.sidebarVersions.fetchError': 'File versions could not be retrieved.',
      'be.sidebarVersions.fileRequestDisplayName': 'File Request',
      'be.sidebarVersions.notAvailable':
        'Sorry, version history is not available with your current account plan. To access versioning, select from one of our paid plans.',
      'be.sidebarVersions.preview': 'Preview',
      'be.sidebarVersions.priorWeek': 'Last Week',
      'be.sidebarVersions.promote': 'Make Current',
      'be.sidebarVersions.promoteError': 'File version could not be made current.',
      'be.sidebarVersions.promotedBy': 'Promoted from v{versionPromoted} by {name}',
      'be.sidebarVersions.restore': 'Restore',
      'be.sidebarVersions.restoreError': 'File version could not be restored.',
      'be.sidebarVersions.restoredBy': 'Restored by {name}',
      'be.sidebarVersions.serverError': 'Server Error',
      'be.sidebarVersions.thisMonth': 'This Month',
      'be.sidebarVersions.title': 'Version History',
      'be.sidebarVersions.today': 'Today',
      'be.sidebarVersions.toggle': 'Toggle Actions Menu',
      'be.sidebarVersions.upgradeButton': 'Upgrade',
      'be.sidebarVersions.upgradeLink': 'Upgrade Now',
      'be.sidebarVersions.uploadedBy': 'Uploaded by {name}',
      'be.sidebarVersions.versionLimitExceeded':
        'You are limited to the last {versionLimit, number} {versionLimit, plural, one {version} other {versions}}.',
      'be.sidebarVersions.versionMaxEntries': 'Version history is limited to the last {maxVersions} entries.',
      'be.sidebarVersions.versionNumberBadge': 'V{versionNumber}',
      'be.sidebarVersions.versionNumberLabel': 'Version number {versionNumber}',
      'be.sidebarVersions.versionRetentionDelete': 'Will be deleted {time} by retention policy.',
      'be.sidebarVersions.versionRetentionIndefinite': 'Retained indefinitely by retention policy.',
      'be.sidebarVersions.versionRetentionRemove': 'Retention policy expires on {time}.',
      'be.sidebarVersions.versionUpsell':
        'Sorry, version history is not available with your current account plan. To access versioning, select from one of our paid plans.',
      'be.sidebarVersions.versionUserUnknown': 'Unknown',
      'be.sidebarVersions.yesterday': 'Yesterday',
      'be.sizeASC': 'Size: Smallest → Largest',
      'be.sizeDESC': 'Size: Largest → Smallest',
      'be.skillFileProcessingError': 'We’re sorry, something went wrong with processing the file.',
      'be.skillInvalidFileExtensionError':
        'We’re sorry, no skills information was found. This file extension is currently not supported.',
      'be.skillInvalidFileSizeError':
        'We’re sorry, no skills information was found. This file size is currently not supported.',
      'be.skillInvokedStatus': 'We’re preparing to process your file - please hold!',
      'be.skillNoInfoFoundError': 'We’re sorry, no skills information was found.',
      'be.skillPendingStatus': 'We’re working on processing your file - please hold!',
      'be.skillUnknownError': 'Something went wrong with running this skill or fetching its data.',
      'be.sort': 'Sort',
      'be.statusSkill': 'Status',
      'be.today': 'today',
      'be.topicsSkill': 'Topics',
      'be.transcriptEdit': 'Click any section to edit.',
      'be.transcriptSkill': 'Transcript',
      'be.upload': 'Upload',
      'be.uploadEmptyFileInput': 'Browse your device',
      'be.uploadEmptyFolderInput': 'Select Folders',
      'be.uploadEmptyWithFolderUploadDisabled': 'Drag and drop files',
      'be.uploadEmptyWithFolderUploadEnabled': 'Drag and drop files and folders',
      'be.uploadError': 'A network error has occurred while trying to upload.',
      'be.uploadErrorTooManyFiles': 'You can only upload up to {fileLimit} file(s) at a time.',
      'be.uploadInProgress': 'Drag and drop to add additional files',
      'be.uploadNoDragDrop': 'Select files from your device',
      'be.uploadOptions': '{option1} or {option2}',
      'be.uploadSuccess': 'Success! Your files have been uploaded.',
      'be.uploadSuccessFileInput': 'Select More Files',
      'be.uploadSuccessFolderInput': 'Select More Folders',
      'be.uploadsCancelButtonTooltip': 'Cancel this upload',
      'be.uploadsDefaultErrorMessage': 'Something went wrong with the upload. Please try again.',
      'be.uploadsFileSizeLimitExceededErrorMessage': 'File size exceeds the folder owner’s file size limit',
      'be.uploadsFileSizeLimitExceededErrorMessageForUpgradeCta':
        'This file exceeds your plan’s upload limit. Upgrade now to store larger files.',
      'be.uploadsFileSizeLimitExceededUpgradeMessageForUpgradeCta': 'Upgrade',
      'be.uploadsItemNameInUseErrorMessage': 'A file with this name already exists.',
      'be.uploadsManagerUploadComplete': 'Completed',
      'be.uploadsManagerUploadFailed': 'Some Uploads Failed',
      'be.uploadsManagerUploadInProgress': 'Uploading',
      'be.uploadsManagerUploadPrompt': 'Drop files on this page to upload them into this folder.',
      'be.uploadsOneOrMoreChildFoldersFailedToUploadMessage': 'One or more child folders failed to upload.',
      'be.uploadsPackageUploadErrorMessage': 'Failed to upload package file. Please retry by saving as a single file.',
      'be.uploadsPendingFolderSizeLimitErrorMessage': 'Pending app folder size limit exceeded',
      'be.uploadsProvidedFolderNameInvalidMessage':
        'Provided folder name, {name}, could not be used to create a folder.',
      'be.uploadsRetryButtonTooltip': 'Retry upload',
      'be.uploadsStorageLimitErrorMessage': 'Account storage limit reached',
      'be.versionDeleted': '{name} deleted v{version_number}',
      'be.versionMultipleUsersUploaded': '{numberOfCollaborators} collaborators uploaded v{versions}',
      'be.versionPromoted': '{name} promoted v{version_promoted} to v{version_number}',
      'be.versionRestored': '{name} restored v{version_number}',
      'be.versionUploadCollapsed': '{name} uploaded v{versions}',
      'be.versionUploaded': '{name} uploaded v{version_number}',
      'be.yesterday': 'yesterday',
      'boxui.accessStats.accessStatsComments': 'Comments',
      'boxui.accessStats.accessStatsDownloads': 'Downloads',
      'boxui.accessStats.accessStatsEdits': 'Edits',
      'boxui.accessStats.accessStatsPreviews': 'Previews',
      'boxui.accessStats.accessStatsViewDetails': 'View Details',
      'boxui.accessStats.accessStatsViews': 'Views',
      'boxui.advancedContentInsights.advancedContentInsightsDescription':
        'Get actionable insights into how viewers are engaging with this content. Measure average time spent, page-by-page engagement, per person and per visit details.',
      'boxui.advancedContentInsights.advancedContentInsightsTitleDisabled': 'Activate Engagement Insights',
      'boxui.advancedContentInsights.advancedContentInsightsTitleEnabled': 'Engagement Insights is activated',
      'boxui.avatar.externalUser': 'External user',
      'boxui.badges.beta': 'BETA',
      'boxui.badges.trial': 'TRIAL',
      'boxui.badges.upgrade': 'UPGRADE',
      'boxui.base.nextMonth': 'Next Month',
      'boxui.base.previousMonth': 'Previous Month',
      'boxui.breadcrumb.breadcrumbLabel': 'Breadcrumb',
      'boxui.categorySelector.label.more': 'More',
      'boxui.checkboxTooltip.iconInfoText': 'Info',
      'boxui.classification.add': 'Add',
      'boxui.classification.classification': 'Classification',
      'boxui.classification.classificationDarkBlue': 'Dark Blue',
      'boxui.classification.classificationGreen': 'Green',
      'boxui.classification.classificationGrey': 'Grey',
      'boxui.classification.classificationLightBlue': 'Light Blue',
      'boxui.classification.classificationOrange': 'Orange',
      'boxui.classification.classificationPurple': 'Purple',
      'boxui.classification.classificationRed': 'Red',
      'boxui.classification.classificationYellow': 'Yellow',
      'boxui.classification.definition': 'Definition',
      'boxui.classification.edit': 'Edit',
      'boxui.classification.importedBy': 'Imported from {modifiedBy} on {modifiedAt}',
      'boxui.classification.missing': 'Not classified',
      'boxui.classification.modifiedBy': 'Applied by {modifiedBy} on {modifiedAt}',
      'boxui.classification.modifiedByLabel': 'Classification Label',
      'boxui.collaboratorAvatars.collaboration.pendingCollabText': 'Pending',
      'boxui.collaboratorAvatars.collaboratorAvatarsLabel': 'Shared with',
      'boxui.collaboratorAvatars.collaborators.expirationTooltipText': 'Access expires on {date}',
      'boxui.collaboratorAvatars.collaborators.externalCollabTooltipText': '{email} is from outside of your company',
      'boxui.collaboratorAvatars.manageAllLinkText': 'Manage All',
      'boxui.collaboratorAvatars.viewAdditionalPeopleText': 'View additional people',
      'boxui.collapsiblesidebar.collapseBtnLabel': 'Collapse',
      'boxui.collapsiblesidebar.expandBtnLabel': 'Expand',
      'boxui.contentAnswers.ask': 'Ask',
      'boxui.contentAnswers.askDisabledTooltip': 'You can submit another question once Box AI has finished responding',
      'boxui.contentAnswers.askQuestionPlaceholder': 'Ask anything about this document',
      'boxui.contentAnswers.contentAnswersTitle': 'Box AI',
      'boxui.contentAnswers.defaultTooltip': 'Get instant answers about this document using Box AI',
      'boxui.contentAnswers.disabledTooltipFileNotCompatible': 'Box AI is not currently supported for this file type',
      'boxui.contentAnswers.hasQuestionsTooltip': 'Return to Box AI',
      'boxui.contentAnswers.inlineErrorText': 'The Box AI service was unavailable.',
      'boxui.contentAnswers.intelligenceUnavailableDescription': 'The Box AI service is not responding.',
      'boxui.contentAnswers.intelligenceUnavailableHeading': 'Box AI is unavailable',
      'boxui.contentAnswers.intelligenceUnavailableTryAgain': 'Please try again later.',
      'boxui.contentAnswers.maxCharactersReachedError': 'Maximum of {characterLimit} characters reached',
      'boxui.contentAnswers.retryResponse': 'Retry',
      'boxui.contentAnswers.welcomeAskQuestionText': 'Ask questions about {name}',
      'boxui.contentAnswers.welcomeClearChatText': 'This chat will be cleared when you close this document',
      'boxui.contentAnswers.welcomeMessageTitle': 'Welcome to Box AI',
      'boxui.contentExplorer.breadcrumb': 'Breadcrumb',
      'boxui.contentExplorer.cancel': 'Cancel',
      'boxui.contentExplorer.choose': 'Choose',
      'boxui.contentExplorer.clickToGoBack': 'Click to go back',
      'boxui.contentExplorer.clickToViewPath': 'Click to view path',
      'boxui.contentExplorer.copy': 'Copy',
      'boxui.contentExplorer.emptyFolder': 'There are no subfolders in this folder.',
      'boxui.contentExplorer.emptySearch': "Sorry, we couldn't find what you're looking for.",
      'boxui.contentExplorer.filepath': 'File path',
      'boxui.contentExplorer.folderTreeBreadcrumbsText': '{folderName} ({totalItems})',
      'boxui.contentExplorer.includeSubfolders': 'Include Subfolders',
      'boxui.contentExplorer.move': 'Move',
      'boxui.contentExplorer.name': 'Name',
      'boxui.contentExplorer.newFolder': 'New Folder',
      'boxui.contentExplorer.numFoldersSelected':
        '{numSelected, plural, =0 {0 folders selected} one {1 folder selected} other {# folders selected} } ',
      'boxui.contentExplorer.numItemsSelected':
        '{numSelected, plural, =0 {0 items selected} one {1 item selected} other {# items selected} } ',
      'boxui.contentExplorer.numSelected': '{numSelected} Selected',
      'boxui.contentExplorer.result': '{itemsCount} result',
      'boxui.contentExplorer.results': '{itemsCount} results',
      'boxui.contentExplorer.searchPlaceholder': 'Search',
      'boxui.contentExplorer.searchResults': 'Search Results',
      'boxui.contentExplorer.selectAll': 'Select All',
      'boxui.contentExplorer.selectItem': 'Select {name}',
      'boxui.contentexplorer.newFolder.forbidden': 'You do not have permission to create a folder here.',
      'boxui.core.cancel': 'Cancel',
      'boxui.core.close': 'Close',
      'boxui.core.copied': 'Copied',
      'boxui.core.copy': 'Copy',
      'boxui.core.done': 'Done',
      'boxui.core.guidetooltip.navigation': '{currentStepIndex} of {totalNumSteps}',
      'boxui.core.hotkeys.altKey': 'Alt',
      'boxui.core.hotkeys.ctrlKey': 'Ctrl',
      'boxui.core.hotkeys.enterKey': 'Enter',
      'boxui.core.hotkeys.escKey': 'Esc',
      'boxui.core.hotkeys.hotkeyModalTitle': 'Keyboard Shortcuts',
      'boxui.core.hotkeys.hotkeySequence': '{key1} then {key2}',
      'boxui.core.hotkeys.shiftKey': 'Shift',
      'boxui.core.hotkeys.spacebarKey': 'Spacebar',
      'boxui.core.okay': 'Okay',
      'boxui.core.optional': 'optional',
      'boxui.core.save': 'Save',
      'boxui.core.selection.deselectAllDescription': 'Deselect all items',
      'boxui.core.selection.downDescription': 'Select next item',
      'boxui.core.selection.selectAllDescription': 'Select all items',
      'boxui.core.selection.shiftDownDescription': 'Add next item to current selection',
      'boxui.core.selection.shiftUpDescription': 'Add previous item to current selection',
      'boxui.core.selection.shiftXDescription': 'Select current item',
      'boxui.core.selection.upDescription': 'Select previous item',
      'boxui.core.send': 'Send',
      'boxui.datePicker.chooseDate': 'Choose Date',
      'boxui.datePicker.dateClearButton': 'Clear Date',
      'boxui.datePicker.dateInputMaxError': 'Please enter a date before {maxLocaleDate}',
      'boxui.datePicker.dateInputMinError': 'Please enter a date after {minLocaleDate}',
      'boxui.datePicker.dateInputRangeError': 'Please enter a date between {minLocaleDate} and {maxLocaleDate}',
      'boxui.datePicker.iconAlertText': 'Invalid Date',
      'boxui.draftjs.mentionSelector.noUsersFound': 'No users found',
      'boxui.draftjs.mentionSelector.startMention': 'Mention someone to notify them',
      'boxui.draftjs.mentionSelector.usersFound':
        '{usersCount, plural, one {one user found} other {{usersCount} users found}}',
      'boxui.errorMask.iconSadCloudText': 'Sad Box Cloud',
      'boxui.features.VirtualizedTableRenderers.allFiles': 'All Files',
      'boxui.features.VirtualizedTableRenderers.anonymousUser': 'Anonymous User',
      'boxui.features.VirtualizedTableRenderers.externalFile': 'External File',
      'boxui.features.VirtualizedTableRenderers.externalFolder': 'External Folder',
      'boxui.features.VirtualizedTableRenderers.lastModifiedBy': '{lastModified} by {user}',
      'boxui.features.VirtualizedTableRenderers.unknownUser': 'Unknown User',
      'boxui.itemDetails.bookmarkExpiration': 'This bookmark will be deleted on {expiration}.',
      'boxui.itemDetails.created': 'Created',
      'boxui.itemDetails.deleted': 'Deleted',
      'boxui.itemDetails.description': 'Description',
      'boxui.itemDetails.descriptionPlaceholder': 'Enter a description',
      'boxui.itemDetails.enterpriseOwner': 'Enterprise Owner',
      'boxui.itemDetails.fileExpiration': 'This file will be deleted on {expiration}.',
      'boxui.itemDetails.folderExpiration': 'This folder will be deleted on {expiration}.',
      'boxui.itemDetails.modified': 'Modified',
      'boxui.itemDetails.owner': 'Owner',
      'boxui.itemDetails.retentionPolicyDescription': 'Policy',
      'boxui.itemDetails.retentionPolicyExpiration': 'Policy Expiration',
      'boxui.itemDetails.retentionPolicyExtend': 'Extend',
      'boxui.itemDetails.savedVersions': '{versionCount, number} Saved Versions',
      'boxui.itemDetails.sharedLinkExpiration': 'This shared link will be disabled on {expiration}.',
      'boxui.itemDetails.size': 'Size',
      'boxui.itemDetails.uploader': 'Uploader',
      'boxui.itemDetails.url': 'URL',
      'boxui.itemDetails.urlPlaceholder': 'Enter a valid url',
      'boxui.media.menuButtonArialLabel': 'Options',
      'boxui.metadataInstanceEditor.allAttributesAreHidden': 'All attributes in this template have been hidden.',
      'boxui.metadataInstanceEditor.applyCascadePolicyText':
        'Apply template and its values to all new and existing items in this folder and its subfolders.',
      'boxui.metadataInstanceEditor.cannotApplyCascadePolicyText':
        'Cascade policy cannot be applied to custom metadata at this time.',
      'boxui.metadataInstanceEditor.cascadePolicyLearnMore': 'Learn more',
      'boxui.metadataInstanceEditor.cascadePolicyModeQuestion':
        'In the case of conflicts when applying this template and its values to existing items, what would you like to do? This is a one time action.',
      'boxui.metadataInstanceEditor.cascadePolicyOverwriteMode': 'Overwrite all existing template values',
      'boxui.metadataInstanceEditor.cascadePolicySkipMode': 'Skip and keep all existing template values',
      'boxui.metadataInstanceEditor.customAdd': 'Add',
      'boxui.metadataInstanceEditor.customErrorDuplicateKey': 'A field with that key already exists.',
      'boxui.metadataInstanceEditor.customErrorInternalKey': 'Keys cannot begin with a $.',
      'boxui.metadataInstanceEditor.customErrorRequired': 'A key is required.',
      'boxui.metadataInstanceEditor.customKey': 'Key',
      'boxui.metadataInstanceEditor.customKeyPlaceholder': 'e.g. Order Number',
      'boxui.metadataInstanceEditor.customNewField': 'New Field',
      'boxui.metadataInstanceEditor.customNewFieldMessage':
        'Add a custom metadata field. Other people will be able to see and search for this field.',
      'boxui.metadataInstanceEditor.customRemove': 'Remove',
      'boxui.metadataInstanceEditor.customTitle': 'Custom Metadata',
      'boxui.metadataInstanceEditor.customValue': 'Value',
      'boxui.metadataInstanceEditor.customValuePlaceholder': 'e.g. 42',
      'boxui.metadataInstanceEditor.editTooltip': 'Edit Metadata',
      'boxui.metadataInstanceEditor.enableCascadePolicy': 'Enable Cascade Policy',
      'boxui.metadataInstanceEditor.fileMetadataRemoveCustomTemplateConfirm':
        'Are you sure you want to delete this custom metadata and all of its values from this file?',
      'boxui.metadataInstanceEditor.fileMetadataRemoveTemplateConfirm':
        'Are you sure you want to delete "{metadataName}" and all of its values from this file?',
      'boxui.metadataInstanceEditor.folderMetadataRemoveCustomTemplateConfirm':
        'Are you sure you want to delete this custom metadata and all of its values? Any metadata template values already applied to files in this folder will not be deleted.',
      'boxui.metadataInstanceEditor.folderMetadataRemoveTemplateConfirm':
        'Are you sure you want to delete "{metadataName}" and all of its values? Any metadata template values already applied to files in this folder will not be deleted.',
      'boxui.metadataInstanceEditor.invalidValue': 'Invalid Input!',
      'boxui.metadataInstanceEditor.metadataCancel': 'Cancel',
      'boxui.metadataInstanceEditor.metadataCascadePolicyEnabledInfo':
        'This template and its values are being cascaded to all items in this folder and its subfolders.',
      'boxui.metadataInstanceEditor.metadataSave': 'Save',
      'boxui.metadataInstanceEditor.noAttributesForTemplate': 'There are no attributes in this template.',
      'boxui.metadataInstanceEditor.noMetadata': 'No Metadata Applied',
      'boxui.metadataInstanceEditor.noMetadataAddTemplate': "Click 'Add' in the top right to add metadata to this item",
      'boxui.metadataInstanceEditor.operationNotImmediate': 'This operation is not immediate and may take some time.',
      'boxui.metadataInstanceEditor.removeTemplate': 'Remove',
      'boxui.metadataInstanceEditor.templateAdd': 'Add',
      'boxui.metadataInstanceEditor.templateSearchPlaceholder': 'Search all templates',
      'boxui.metadataInstanceEditor.templatesFetchFailed':
        'Sorry! We could not fetch templates. Please contact your administrator',
      'boxui.metadataInstanceEditor.templatesNoRemainingTemplates': 'All templates have been added',
      'boxui.metadataInstanceEditor.templatesNoResults': 'No Results',
      'boxui.metadataInstanceEditor.templatesServerHasNoTemplates': 'Zero templates',
      'boxui.metadataInstanceEditor.templatesTitle': 'Templates',
      'boxui.metadataInstanceFields.customAdd': 'Add',
      'boxui.metadataInstanceFields.customRemove': 'Remove',
      'boxui.metadataInstanceFields.fieldMultiSelectValue': 'Select Values',
      'boxui.metadataInstanceFields.fieldNoValue': 'No Value',
      'boxui.metadataInstanceFields.fieldSelectValue': 'Select Value',
      'boxui.metadataInstanceFields.fieldSetDate': 'Set Date',
      'boxui.metadataInstanceFields.fieldSetValue': 'Set Value',
      'boxui.metadataInstanceFields.invalidMetadataFieldType': 'Invalid metadata field type!',
      'boxui.modalDialog.backModalText': 'Back',
      'boxui.modalDialog.closeModalText': 'Close Modal',
      'boxui.newFolderModal.cancel': 'Cancel',
      'boxui.newFolderModal.create': 'Create',
      'boxui.newFolderModal.folderName.label': 'Folder Name',
      'boxui.newFolderModal.folderName.placeholder': 'My New Folder',
      'boxui.newFolderModal.title': 'Create a New Folder in "{parentFolderName}"',
      'boxui.notification.clearNotification': 'Clear Notification',
      'boxui.presence.accessedInTheLastMinute': 'Viewed less than a minute ago',
      'boxui.presence.activeNow': 'Active now',
      'boxui.presence.commentedIntheLastMinute': 'Commented less than a minute ago',
      'boxui.presence.getLinkButton': 'Get Link',
      'boxui.presence.inviteButton': 'Invite People',
      'boxui.presence.modifiedIntheLastMinute': 'Edited less than a minute ago',
      'boxui.presence.previewPresenceFlyoutAccessStatsLink': 'See all activity',
      'boxui.presence.previewPresenceFlyoutActivityCTA': 'View Recent Activity',
      'boxui.presence.previewPresenceFlyoutCopy': 'Quickly see who has commented on, edited, or viewed this file.',
      'boxui.presence.previewedIntheLastMinute': 'Previewed less than a minute ago',
      'boxui.presence.recentActivity': 'Recent Activity',
      'boxui.presence.timeSinceLastAccessed': 'Viewed {timeAgo}',
      'boxui.presence.timeSinceLastCommented': 'Commented {timeAgo}',
      'boxui.presence.timeSinceLastModified': 'Edited {timeAgo}',
      'boxui.presence.timeSinceLastPreviewed': 'Previewed {timeAgo}',
      'boxui.presence.toggleButtonLabel': 'Recent Activity',
      'boxui.queryBar.addFilterButtonText': '+ Add Filter',
      'boxui.queryBar.applyFiltersButtonText': 'Apply',
      'boxui.queryBar.columnsButtonText': 'Columns',
      'boxui.queryBar.columnsHiddenButtonText': '{count, plural, one {1 Column Hidden} other {{count} Columns Hidden}}',
      'boxui.queryBar.connectorAndText': 'AND',
      'boxui.queryBar.connectorOrText': 'OR',
      'boxui.queryBar.connectorWhereText': 'WHERE',
      'boxui.queryBar.filtersButtonText': 'Modify Filters',
      'boxui.queryBar.metadataViewTemplateListHeaderTitle': 'METADATA TEMPLATES',
      'boxui.queryBar.multipleFiltersButtonText': '{number} Filters',
      'boxui.queryBar.noFiltersAppliedText': 'No Filters Applied',
      'boxui.queryBar.noTemplatesText': 'No Templates Available',
      'boxui.queryBar.selectValuePlaceholderText': 'Select value',
      'boxui.queryBar.templatesButtonText': 'Select Metadata',
      'boxui.queryBar.templatesLoadingButtonText': 'Template Name',
      'boxui.queryBar.tooltipEnterValueError': 'Please Enter a Value',
      'boxui.queryBar.tooltipInvalidFloatError': 'Please Enter a Decimal Number',
      'boxui.queryBar.tooltipInvalidNumberError': 'Please Enter an Integer',
      'boxui.queryBar.tooltipSelectDateError': 'Please Select a Date',
      'boxui.queryBar.tooltipSelectValueError': 'Please Select a Value',
      'boxui.quickSearch.bookmark': 'Bookmark',
      'boxui.quickSearch.collaboratedFolder': 'Collaborated Folder',
      'boxui.quickSearch.externalFolder': 'External Folder',
      'boxui.quickSearch.file': 'File',
      'boxui.quickSearch.parentFolder': 'Parent Folder',
      'boxui.quickSearch.personalFolder': 'Personal Folder',
      'boxui.quickSearch.updatedText': '{date, date, medium} by {user}',
      'boxui.quickSearch.updatedTextToday': 'Today by {user}',
      'boxui.quickSearch.updatedTextYesterday': 'Yesterday by {user}',
      'boxui.readableTime.eventTime': '{time, date, medium}',
      'boxui.readableTime.eventTimeDate': '{time, date, medium} at {time, time, short}',
      'boxui.readableTime.eventTimeDateShort': '{date} at {time, time, short}',
      'boxui.readableTime.eventTimeToday': 'Today at {time, time, short}',
      'boxui.readableTime.eventTimeWeekdayLong': '{weekday}, {time, date, medium}',
      'boxui.readableTime.eventTimeYesterday': 'Yesterday at {time, time, short}',
      'boxui.searchForm.clearButtonTitle': 'Clear',
      'boxui.searchForm.searchButtonTitle': 'Search',
      'boxui.searchForm.searchLabel': 'Search query',
      'boxui.securityCloudGame.accessibilityInstructions':
        'For security purposes, please drag the cloud object onto the target. You are on a {row} by {column} grid with a movable cloud object and a target area. Press spacebar to grab the cloud object, arrow keys to move, and spacebar to drop on the target.',
      'boxui.securityCloudGame.cloudDropped': 'Cloud object dropped.',
      'boxui.securityCloudGame.cloudGrabbed': 'Cloud object grabbed.',
      'boxui.securityCloudGame.cloudObject': 'Cloud object',
      'boxui.securityCloudGame.currentPosition': 'Current position: Row {row}, Column {column}.',
      'boxui.securityCloudGame.instructions':
        'For security purposes, please drag the white cloud onto the dark cloud. Keyboard users: Press spacebar to grab the cloud, arrow keys to move, and spacebar to drop.',
      'boxui.securityCloudGame.reachBottomEdge': 'Reached bottom edge of grid.',
      'boxui.securityCloudGame.reachLeftEdge': 'Reached left edge of grid.',
      'boxui.securityCloudGame.reachRightEdge': 'Reached right edge of grid.',
      'boxui.securityCloudGame.reachTopEdge': 'Reached top edge of grid.',
      'boxui.securityCloudGame.success': 'Success!',
      'boxui.securityCloudGame.target': 'Target',
      'boxui.securityCloudGame.targetInRange': 'Target in range, you can drop the cloud object.',
      'boxui.securityCloudGame.targetPosition': 'Target position: Row {row}, Column {column}.',
      'boxui.securityControls.allAppNames': 'All applications: {appsList}',
      'boxui.securityControls.appDownloadBlacklist': 'Download restricted for some applications: {appNames}',
      'boxui.securityControls.appDownloadBlacklistOverflow':
        'Download restricted for some applications: {appNames} +{remainingAppCount} more',
      'boxui.securityControls.appDownloadRestricted': 'Download restricted for some applications.',
      'boxui.securityControls.appDownloadWhitelist': 'Only select applications are allowed: {appNames}',
      'boxui.securityControls.appDownloadWhitelistOverflow':
        'Only select applications are allowed: {appNames} +{remainingAppCount} more',
      'boxui.securityControls.boxSignRequestRestricted': 'Sign restrictions apply.',
      'boxui.securityControls.desktopDownloadExternalOwners':
        'Download restricted on Box Drive, except Owners/Co-Owners. Also restricted for external users.',
      'boxui.securityControls.desktopDownloadExternalOwnersEditors':
        'Download restricted on Box Drive, except Owners/Co-Owners/Editors. Also restricted for external users.',
      'boxui.securityControls.desktopDownloadOwners': 'Download restricted on Box Drive, except Owners/Co-Owners.',
      'boxui.securityControls.desktopDownloadOwnersEditors':
        'Download restricted on Box Drive, except Owners/Co-Owners/Editors.',
      'boxui.securityControls.downloadExternal': 'Download restricted on Box Drive for external users.',
      'boxui.securityControls.externalCollabBlock': 'External collaboration restricted.',
      'boxui.securityControls.externalCollabDomainList': 'External collaboration limited to approved domains.',
      'boxui.securityControls.mobileDownloadExternal': 'Download restricted on mobile for external users.',
      'boxui.securityControls.mobileDownloadExternalOwners':
        'Download restricted on mobile, except Owners/Co-Owners. Also restricted for external users.',
      'boxui.securityControls.mobileDownloadExternalOwnersEditors':
        'Download restricted on mobile, except Owners/Co-Owners/Editors. Also restricted for external users.',
      'boxui.securityControls.mobileDownloadOwners': 'Download restricted on mobile, except Owners/Co-Owners.',
      'boxui.securityControls.mobileDownloadOwnersEditors':
        'Download restricted on mobile, except Owners/Co-Owners/Editors.',
      'boxui.securityControls.modalDescription':
        'Classification labels defined by your administrator can be used to label content and apply security policies.',
      'boxui.securityControls.modalTitle': 'View Classification for “{itemName}”',
      'boxui.securityControls.securityControlsLabel': 'Restrictions',
      'boxui.securityControls.sharingCollabAndCompanyOnly': 'Shared links cannot be made publicly accessible.',
      'boxui.securityControls.sharingCollabOnly': 'Shared links allowed for collaborators only.',
      'boxui.securityControls.shortApp': 'Application restrictions apply',
      'boxui.securityControls.shortAppSign': 'App and Sign restrictions apply',
      'boxui.securityControls.shortDownload': 'Download restrictions apply',
      'boxui.securityControls.shortDownloadApp': 'Download and app restrictions apply',
      'boxui.securityControls.shortDownloadAppSign': 'Download, app and Sign restrictions apply',
      'boxui.securityControls.shortDownloadSign': 'Download and Sign restrictions apply',
      'boxui.securityControls.shortSharing': 'Sharing restriction applies',
      'boxui.securityControls.shortSharingApp': 'Sharing and app restrictions apply',
      'boxui.securityControls.shortSharingAppSign': 'Sharing, app and Sign restrictions apply',
      'boxui.securityControls.shortSharingDownload': 'Sharing and download restrictions apply',
      'boxui.securityControls.shortSharingDownloadApp': 'Sharing, download and app restrictions apply',
      'boxui.securityControls.shortSharingDownloadAppSign': 'Sharing, download, app and Sign restrictions apply',
      'boxui.securityControls.shortSharingDownloadSign': 'Sharing, download and Sign restrictions apply',
      'boxui.securityControls.shortSharingSign': 'Sharing and Sign restrictions apply',
      'boxui.securityControls.shortSign': 'Sign restrictions apply',
      'boxui.securityControls.shortWatermarking': 'Watermarking applies',
      'boxui.securityControls.viewAll': 'View All',
      'boxui.securityControls.watermarkingApplied': 'Watermarking will be applied.',
      'boxui.securityControls.webDownloadExternal': 'Download restricted on web for external users.',
      'boxui.securityControls.webDownloadExternalOwners':
        'Download restricted on web, except Owners/Co-Owners. Also restricted for external users.',
      'boxui.securityControls.webDownloadExternalOwnersEditors':
        'Download restricted on web, except Owners/Co-Owners/Editors. Also restricted for external users.',
      'boxui.securityControls.webDownloadOwners': 'Download restricted on web, except Owners/Co-Owners.',
      'boxui.securityControls.webDownloadOwnersEditors': 'Download restricted on web, except Owners/Co-Owners/Editors.',
      'boxui.select.moreInfo': 'More Info',
      'boxui.selectField.clearAll': 'Clear All',
      'boxui.selectField.noResults': 'No Results',
      'boxui.selectField.searchPlaceholder': 'Search',
      'boxui.share.accessType': 'ACCESS TYPE',
      'boxui.share.canEdit': 'Can edit',
      'boxui.share.canView': 'Can view',
      'boxui.share.coownerLevelText': 'Co-owner',
      'boxui.share.deleteTableHeaderText': 'Delete',
      'boxui.share.downloadTableHeaderText': 'Download',
      'boxui.share.editTableHeaderText': 'Edit',
      'boxui.share.editorLevelText': 'Editor',
      'boxui.share.emailSharedLink': 'Email Shared Link',
      'boxui.share.enterAtLeastOneEmail': 'Enter at least one valid email',
      'boxui.share.getLinkTableHeaderText': 'Get Link',
      'boxui.share.groupLabel': 'Group',
      'boxui.share.inviteCollaboratorsModalCancelButton': 'Cancel',
      'boxui.share.inviteCollaboratorsModalSendInvites': 'Send Invites',
      'boxui.share.inviteCollaboratorsModalTitle': 'Invite to {itemName}',
      'boxui.share.inviteFieldLabel': 'Invite',
      'boxui.share.inviteFileEditorsLabel': 'Invite people to become editors of this file.',
      'boxui.share.inviteePermissionsFieldLabel': 'Invitee Permissions',
      'boxui.share.inviteePermissionsLearnMore': 'Learn More',
      'boxui.share.message': 'Message',
      'boxui.share.messageSelectorPlaceholder': 'Add a message',
      'boxui.share.ownerTableHeaderText': 'Owner',
      'boxui.share.peopleInCompanyCanDownloadFile':
        'Anyone in your company with the link can view and download this file.',
      'boxui.share.peopleInCompanyCanDownloadFolder':
        'Anyone in your company with the link can view this folder and download its contents.',
      'boxui.share.peopleInCompanyCanEditFile': 'Anyone in your company with the link can edit and download this file.',
      'boxui.share.peopleInCompanyCanViewFile': 'Anyone in your company with the link can view this file.',
      'boxui.share.peopleInCompanyCanViewFolder': 'Anyone in your company with the link can view this folder.',
      'boxui.share.peopleInEnterprise': 'People in {enterpriseName}',
      'boxui.share.peopleInItemCanAccessFile': 'Any collaborator on the file with the link can access this file.',
      'boxui.share.peopleInItemCanAccessFolder': 'Any collaborator on the folder with the link can access this folder.',
      'boxui.share.peopleInItemCanDownloadFile': 'Any collaborator on this file with the link can download this file.',
      'boxui.share.peopleInItemCanDownloadFolder':
        'Any collaborator on this folder with the link can download this folder.',
      'boxui.share.peopleInItemCanEditFile':
        'Any collaborator on this file with the link can edit this file and download its contents.',
      'boxui.share.peopleInItemCanPreviewAndDownloadFile':
        'Any collaborator on this file with the link can view this file and download its contents.',
      'boxui.share.peopleInItemCanPreviewAndDownloadFolder':
        'Any collaborator on this folder with the link can view this folder and download its contents.',
      'boxui.share.peopleInItemCanPreviewFile': 'Any collaborator on this file with the link can view this file.',
      'boxui.share.peopleInItemCanPreviewFolder': 'Any collaborator on this folder with the link can view this folder.',
      'boxui.share.peopleInSpecifiedCompanyCanDownloadFile':
        'Anyone in {company} with the link can view and download this file.',
      'boxui.share.peopleInSpecifiedCompanyCanDownloadFolder':
        'Anyone in {company} with the link can view this folder and download its contents.',
      'boxui.share.peopleInSpecifiedCompanyCanEditFile':
        'Anyone in {company} with the link can edit and download this file.',
      'boxui.share.peopleInSpecifiedCompanyCanViewFile': 'Anyone in {company} with the link can view this file.',
      'boxui.share.peopleInSpecifiedCompanyCanViewFolder': 'Anyone in {company} with the link can view this folder.',
      'boxui.share.peopleInThisFile': 'People in this file',
      'boxui.share.peopleInThisFolder': 'People in this folder',
      'boxui.share.peopleInYourCompany': 'People in your company',
      'boxui.share.peopleWithLinkCanDownloadFile': 'Anyone with the link can view and download this file.',
      'boxui.share.peopleWithLinkCanDownloadFolder':
        'Anyone with the link can view this folder and download its contents.',
      'boxui.share.peopleWithLinkCanEditFile': 'Anyone with the link can edit and download this file.',
      'boxui.share.peopleWithLinkCanViewFile': 'Anyone with the link can view this file.',
      'boxui.share.peopleWithLinkCanViewFolder': 'Anyone with the link can view this folder.',
      'boxui.share.peopleWithTheLink': 'People with the link',
      'boxui.share.permissionLevelsTableHeaderText': 'Permission Levels',
      'boxui.share.personalMessageLabel': 'Personal Message',
      'boxui.share.pillSelectorPlaceholder': 'Add names or email addresses',
      'boxui.share.previewTableHeaderText': 'Preview',
      'boxui.share.previewerLevelText': 'Previewer',
      'boxui.share.previewerUploaderLevelText': 'Previewer Uploader',
      'boxui.share.referAFriendBadgeText': 'REFER',
      'boxui.share.referAFriendRewardCenterLinkText': 'Click Here',
      'boxui.share.referAFriendText': 'Want a free month of Box? Refer your friend!',
      'boxui.share.removeLink': 'Remove Link',
      'boxui.share.removeLinkConfirmationDescription':
        'This will permanently remove the shared link. If this item is embedded on other sites it will also become inaccessible. Any custom properties, settings and expirations will be removed as well. Do you want to continue?',
      'boxui.share.removeLinkConfirmationTitle': 'Remove Shared Link',
      'boxui.share.settingsButtonLabel': 'Open shared link settings popup',
      'boxui.share.sharedLinkExpirationTooltip': 'This link will expire on {expiration, date, long}',
      'boxui.share.sharedLinkLabel': 'Shared Link',
      'boxui.share.sharedLinkModalTitle': 'Shared Link for {itemName}',
      'boxui.share.sharedLinkSettings.accessLevel.inCompanyView':
        'This content is available to anyone within your company with the link, and can be viewed.',
      'boxui.share.sharedLinkSettings.accessLevel.inCompanyViewDownload':
        'This content is available to anyone within your company with the link, and can be viewed or downloaded.',
      'boxui.share.sharedLinkSettings.accessLevel.inItem':
        'This content is available to invited collaborators with the link.',
      'boxui.share.sharedLinkSettings.accessLevel.withLinkView':
        'This content is publicly available to anyone with the link, and can be viewed.',
      'boxui.share.sharedLinkSettings.accessLevel.withLinkViewDownload':
        'This content is publicly available to anyone with the link, and can be viewed or downloaded.',
      'boxui.share.sharedLinkSettings.allowDownloadLabel': 'Allow users with the shared link to download this item',
      'boxui.share.sharedLinkSettings.allowDownloadTitle': 'Allow Download',
      'boxui.share.sharedLinkSettings.customURLLabel': 'Non-private custom URL',
      'boxui.share.sharedLinkSettings.directDownloadBlockedByAccessPolicyWithClassification':
        'Download has been disabled for content due to the classification.',
      'boxui.share.sharedLinkSettings.directDownloadBlockedByAccessPolicyWithoutClassification':
        'Download has been disabled for content without classification.',
      'boxui.share.sharedLinkSettings.directDownloadBlockedByMaliciousContent':
        'Download for this content has been disabled due to a security policy.',
      'boxui.share.sharedLinkSettings.directLinkLabel': 'Direct Link',
      'boxui.share.sharedLinkSettings.expirationLabel': 'Disable Shared Link on',
      'boxui.share.sharedLinkSettings.expirationTitle': 'Link Expiration',
      'boxui.share.sharedLinkSettings.inaccessibleSettingsNotice':
        'Certain settings may not be available for this item due to permissions.',
      'boxui.share.sharedLinkSettings.modalTitle': 'Shared Link Settings',
      'boxui.share.sharedLinkSettings.passwordLabel': 'Require password',
      'boxui.share.sharedLinkSettings.passwordPlaceholder': 'Enter a password',
      'boxui.share.sharedLinkSettings.passwordTitle': 'Password Protect',
      'boxui.share.sharedLinkSettings.sharedLinkSettingWarningLinkText': 'Learn more about shared link settings.',
      'boxui.share.sharedLinkSettings.sharedLinkWarningText':
        'This content is publicly available to anyone with the link.',
      'boxui.share.sharedLinkSettings.vanityNameNotSet': 'The custom URL has not been set',
      'boxui.share.sharedLinkSettings.vanityNamePlaceholder': 'Enter a custom path (12 or more characters)',
      'boxui.share.sharedLinkSettings.vanityURLWarning':
        'Custom URLs should not be used when sharing sensitive content.',
      'boxui.share.sharedLinkURLLabel': 'URL',
      'boxui.share.upgradeGetMoreAccessControls': 'Get More Access Controls',
      'boxui.share.uploadTableHeaderText': 'Upload',
      'boxui.share.uploaderLevelText': 'Uploader',
      'boxui.share.vanityURLEnableText': 'Publish content broadly with a custom, non-private URL',
      'boxui.share.viewerLevelText': 'Viewer',
      'boxui.share.viewerUploaderLevelText': 'Viewer Uploader',
      'boxui.shareMenu.downloadOnly': 'Download Only',
      'boxui.shareMenu.editAndComment': 'Edit and Comment',
      'boxui.shareMenu.getSharedLink': 'Get Shared Link',
      'boxui.shareMenu.insufficientPermissionsMenuOption':
        'Insufficient sharing permissions. Please contact the folder owner.',
      'boxui.shareMenu.insufficientPermissionsTooltip': 'You have insufficient permissions to invite collaborators.',
      'boxui.shareMenu.inviteCollabs': 'Invite Collaborators',
      'boxui.shareMenu.ownerCoownerOnlyTooltip':
        'You have insufficient permissions to invite collaborators. Only the owner and co-owners can invite collaborators.',
      'boxui.shareMenu.shortcutOnly': 'Shortcut Only',
      'boxui.shareMenu.viewAndDownload': 'View and Download',
      'boxui.shareMenu.viewOnly': 'View Only',
      'boxui.timeInput.emptyTimeError': 'Required field. Enter a time in the format HH:MM A.',
      'boxui.timeInput.invalidTimeError': 'Invalid time format. Enter a time in the format HH:MM A.',
      'boxui.unifiedShare.collabAccess': 'collaborator access',
      'boxui.unifiedShare.collaboration.groupCollabText': 'Group',
      'boxui.unifiedShare.collaboration.userCollabText': 'User',
      'boxui.unifiedShare.collaboratorListTitle': 'People in ‘{itemName}’',
      'boxui.unifiedShare.collaborators.expirationTooltipClickableText': 'Access expires on {date}. Click for details.',
      'boxui.unifiedShare.contactEmailsTooltipText': '{emails}, and {remainingEmailsCount} more',
      'boxui.unifiedShare.contactRestrictionNotice':
        '{count, plural, one {{count} invitation} other {{count} invitations}} cannot be sent because external collaboration is restricted due to the applied security policy.',
      'boxui.unifiedShare.contactRestrictionNoticeInformationBarrier':
        '{count, plural, one {{count} invitation} other {{count} invitations}} cannot be sent due to a security policy.',
      'boxui.unifiedShare.contactRestrictionNoticeInformationBarrierSingular':
        'Invitations cannot be sent to {email} due to a security policy.',
      'boxui.unifiedShare.contactRestrictionNoticeInformationBarrierSingularGroup':
        'Invitations cannot be sent to "{groupName}" due to a security policy.',
      'boxui.unifiedShare.contactRestrictionNoticeSingular':
        'Invitations cannot be sent to {email} because external collaboration is restricted due to the applied security policy.',
      'boxui.unifiedShare.contactRestrictionRemoveButtonLabel': 'Remove to continue',
      'boxui.unifiedShare.contactsExceedLimitError':
        'Oops! The maximum number of collaborators that can be added at once is {maxContacts} collaborators. Please try again by splitting your invitations into batches.',
      'boxui.unifiedShare.contentSharedWithExternalCollaborators':
        'This content will be shared with external collaborators.',
      'boxui.unifiedShare.coownerLevelButtonLabel': 'Invite as Co-owner',
      'boxui.unifiedShare.coownerLevelDescription':
        'Manage security, upload, download, preview, share, edit, and delete',
      'boxui.unifiedShare.coownerLevelText': 'Co-owner',
      'boxui.unifiedShare.disabledCreateLinkTooltip': 'You do not have permission to create the link.',
      'boxui.unifiedShare.disabledMaliciousContentShareLinkPermission':
        'This option isn’t available for this item due to a security policy.',
      'boxui.unifiedShare.disabledShareLinkPermission': 'This option is not available due to a security policy.',
      'boxui.unifiedShare.editorLevelButtonLabel': 'Invite as Editor',
      'boxui.unifiedShare.editorLevelDescription': 'Upload, download, preview, share, edit, and delete',
      'boxui.unifiedShare.editorLevelFileDescription': 'Upload, download, preview, share, and edit',
      'boxui.unifiedShare.editorLevelText': 'Editor',
      'boxui.unifiedShare.emailModalTitle': 'Send Link to ‘{itemName}’',
      'boxui.unifiedShare.enterAtLeastOneEmail': 'Enter at least one valid email',
      'boxui.unifiedShare.enterEmailAddressesCalloutText':
        'Share this item with coworkers by entering their email addresses',
      'boxui.unifiedShare.expiresMessage': 'Expires',
      'boxui.unifiedShare.ftuxConfirmLabel': 'Got it',
      'boxui.unifiedShare.ftuxEditPermissionTooltipBody':
        'Select the new edit option to easily share your file with people or groups.',
      'boxui.unifiedShare.ftuxEditPermissionTooltipTitle': 'Collaboration made easy',
      'boxui.unifiedShare.ftuxLinkText': 'Read more about shared link security here.',
      'boxui.unifiedShare.ftuxNewUSMUserBody':
        "We’ve simplified the sharing experience when you click 'Share'. Invite people to this item here and toggle the link on or off below for easy sharing.",
      'boxui.unifiedShare.ftuxNewUsmUserTitle': 'Simplified sharing for files and folders',
      'boxui.unifiedShare.ftuxSharedLinkPermissionsEditTag': 'NEW',
      'boxui.unifiedShare.groupLabel': 'Group',
      'boxui.unifiedShare.inviteDisabledTooltip': 'You do not have permission to invite collaborators.',
      'boxui.unifiedShare.inviteDisabledWeblinkTooltip': 'Collaborators cannot be added to bookmarks.',
      'boxui.unifiedShare.inviteFieldLabel': 'Invite People',
      'boxui.unifiedShare.justifiableContactRestrictionNotice':
        'This content requires a business justification for {count, plural, one {{count} invitation} other {{count} invitations}}. Please select a business justification below.',
      'boxui.unifiedShare.justifiableContactRestrictionNoticeSingular':
        'This content requires a business justification to invite {email}. Please select a business justification below.',
      'boxui.unifiedShare.justifiableContactRestrictionRemoveButtonLabel': 'Alternatively, remove to continue',
      'boxui.unifiedShare.justificationRequiredError': 'Select a justification or remove to continue',
      'boxui.unifiedShare.justificationSelectPlaceholder': 'Select Justification',
      'boxui.unifiedShare.levelOfCollabAccess':
        'Set the level of {collaboratorAccess} and increase security through one of our paid plans. {upgradeLink}',
      'boxui.unifiedShare.linkShareOff': 'Create shared link',
      'boxui.unifiedShare.linkShareOn': 'Shared link is created',
      'boxui.unifiedShare.message': 'Message',
      'boxui.unifiedShare.modalTitle': 'Share ‘{itemName}’',
      'boxui.unifiedShare.peopleInCompanyCanAccessFile':
        'Anyone in your company with the link or people invited to this file can access',
      'boxui.unifiedShare.peopleInCompanyCanAccessFolder':
        'Anyone in your company with the link or people invited to this folder can access',
      'boxui.unifiedShare.peopleInCompanyCanAccessHub':
        'Anyone in your company with the link or people invited to this hub can access',
      'boxui.unifiedShare.peopleInEnterpriseName': 'People in {enterpriseName}',
      'boxui.unifiedShare.peopleInItemCanAccessFile': 'Only invited people can access this file',
      'boxui.unifiedShare.peopleInItemCanAccessFolder': 'Only invited people can access this folder',
      'boxui.unifiedShare.peopleInItemCanAccessHub': 'Only invited people can access this hub',
      'boxui.unifiedShare.peopleInSpecifiedCompanyCanAccessFile':
        'Anyone at {company} with the link or people invited to this file can access',
      'boxui.unifiedShare.peopleInSpecifiedCompanyCanAccessFolder':
        'Anyone at {company} with the link or people invited to this folder can access',
      'boxui.unifiedShare.peopleInSpecifiedCompanyCanAccessHub':
        'Anyone at {company} with the link or people invited to this hub can access',
      'boxui.unifiedShare.peopleInThisFile': 'Invited people only',
      'boxui.unifiedShare.peopleInThisFolder': 'Invited people only',
      'boxui.unifiedShare.peopleInYourCompany': 'People in your company',
      'boxui.unifiedShare.peopleWithLinkDescription': 'Publicly accessible and no sign-in required',
      'boxui.unifiedShare.peopleWithLinkSignedInRequiredDescription': 'Publicly accessible, sign-in required',
      'boxui.unifiedShare.peopleWithTheLinkText': 'People with the link',
      'boxui.unifiedShare.previewerLevelButtonLabel': 'Invite as Previewer',
      'boxui.unifiedShare.previewerLevelDescription': 'Preview only',
      'boxui.unifiedShare.previewerLevelText': 'Previewer',
      'boxui.unifiedShare.previewerUploaderLevelButtonLabel': 'Invite as Previewer Uploader',
      'boxui.unifiedShare.previewerUploaderLevelDescription': 'Upload and preview',
      'boxui.unifiedShare.previewerUploaderLevelText': 'Previewer Uploader',
      'boxui.unifiedShare.recommendedSharingTooltipCalloutText':
        'Based on your usage, we think {fullName} would be interested in this file.',
      'boxui.unifiedShare.removeLinkConfirmationDescription':
        'This will permanently remove the shared link. If this item is embedded on other sites it will also become inaccessible. Any custom properties, settings and expirations will be removed as well. Do you want to continue?',
      'boxui.unifiedShare.removeLinkConfirmationTitle': 'Remove Shared Link',
      'boxui.unifiedShare.removeLinkTooltip': 'You do not have permission to remove the link.',
      'boxui.unifiedShare.restrictedContactsError': 'Remove to continue',
      'boxui.unifiedShare.sendSharedLink': 'Send Shared Link',
      'boxui.unifiedShare.sendSharedLinkFieldLabel': 'Email Shared Link',
      'boxui.unifiedShare.sharedLinkDisabledTooltipCopy': 'Create and copy link for sharing',
      'boxui.unifiedShare.sharedLinkEditablePubliclyAvailable':
        'Publicly available for anyone to view and download. Any logged in users with the link can edit.',
      'boxui.unifiedShare.sharedLinkElevatedEditableCompanyAvailable': 'People who have access to this link can edit.',
      'boxui.unifiedShare.sharedLinkExpirationTooltip':
        'This link will expire and be inaccessible on {expiration, date, long}.',
      'boxui.unifiedShare.sharedLinkPermissionsEdit': 'Can edit',
      'boxui.unifiedShare.sharedLinkPermissionsEditTooltip': 'This permission can only be changed in Box Notes',
      'boxui.unifiedShare.sharedLinkPermissionsViewDownload': 'Can view and download',
      'boxui.unifiedShare.sharedLinkPermissionsViewOnly': 'Can view only',
      'boxui.unifiedShare.sharedLinkPubliclyAvailable': 'This content is publicly available to anyone with the link.',
      'boxui.unifiedShare.sharedLinkSectionLabel': 'Share Link',
      'boxui.unifiedShare.sharedLinkSettings': 'Link Settings',
      'boxui.unifiedShare.sharedLinkSettingsCalloutText':
        'Create a custom URL, enable password protection, enable link expiration, and much more',
      'boxui.unifiedShare.suggestedCollabsTitle': 'Suggested',
      'boxui.unifiedShare.upgradeGetMoreAccessControlsDescription':
        '62% of customers on your plan {upgradeGetMoreAccessControlsLink} to manage collaborators’ access and permission settings',
      'boxui.unifiedShare.upgradeGetMoreAccessControlsLink': 'upgrade',
      'boxui.unifiedShare.upgradeInlineNoticeTitle': 'Upgrade Your Plan',
      'boxui.unifiedShare.upgradeLink': 'Upgrade now',
      'boxui.unifiedShare.uploaderLevelButtonLabel': 'Invite as Uploader',
      'boxui.unifiedShare.uploaderLevelDescription': 'Upload only',
      'boxui.unifiedShare.uploaderLevelText': 'Uploader',
      'boxui.unifiedShare.viewerLevelButtonLabel': 'Invite as Viewer',
      'boxui.unifiedShare.viewerLevelDescription': 'Download, preview, and share',
      'boxui.unifiedShare.viewerLevelText': 'Viewer',
      'boxui.unifiedShare.viewerUploaderLevelButtonLabel': 'Invite as Viewer Uploader',
      'boxui.unifiedShare.viewerUploaderLevelDescription': 'Upload, download, preview, share, and edit',
      'boxui.unifiedShare.viewerUploaderLevelText': 'Viewer Uploader',
      'boxui.validation.URLError': 'Invalid URL',
      'boxui.validation.emailError': 'Invalid Email Address',
      'boxui.validation.genericError': 'Invalid Input',
      'boxui.validation.invalidDateError': 'Invalid Date',
      'boxui.validation.invalidUserError': 'Invalid User',
      'boxui.validation.requiredError': 'Required Field',
      'boxui.validation.tooLongError': 'Input cannot exceed {max} characters',
      'boxui.validation.tooShortError': 'Input must be at least {min} characters',
    }; // CONCATENATED MODULE: ./src/elements/common/i18n.js
    function ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? ownKeys(Object(t), !0).forEach(function (r) {
              _defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function _defineProperty(e, r, t) {
      return (
        (r = _toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function _toPropertyKey(t) {
      var i = _toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function _toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Exports language, messages and react-intl language data for internationalization
     * @author Box
     */

    // eslint-disable-line

    const language = 'en-US';
    const messages = _objectSpread({}, en_US);
    /* harmony default export */ const i18n = {
      language,
      messages,
    }; // CONCATENATED MODULE: ./src/utils/Browser.js
    /**
     *
     * @file Helper for some browser utilities
     * @author Box
     */

    let isDashSupported;
    class Browser {
      /**
       * Returns the user agent.
       * Helps in mocking out.
       *
       * @return {String} navigator userAgent
       */
      static getUserAgent() {
        return __webpack_require__.g.navigator.userAgent;
      }

      /**
       * Returns whether browser is mobile, including tablets.
       *
       * We rely on user agent (UA) to avoid matching desktops with touchscreens.
       * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
       *
       * @return {boolean} Whether browser is mobile
       */
      static isMobile() {
        const userAgent = Browser.getUserAgent();
        return (
          /iphone|ipad|ipod|android|blackberry|bb10|mini|windows\sce|palm/i.test(userAgent) || /Mobi/i.test(userAgent)
        );
      }

      /**
       * Returns whether browser is IE.
       *
       * @return {boolena} Whether browser is IE
       */
      static isIE() {
        return /Trident/i.test(Browser.getUserAgent());
      }

      /**
       * Returns whether browser is Firefox.
       *
       * @return {boolean} Whether browser is Firefox
       */
      static isFirefox() {
        const userAgent = Browser.getUserAgent();
        return /Firefox/i.test(userAgent) && !/Seamonkey\//i.test(userAgent);
      }

      /**
       * Returns whether browser is Safari.
       *
       * @return {boolean} Whether browser is Safari
       */
      static isSafari() {
        const userAgent = Browser.getUserAgent();
        return /AppleWebKit/i.test(userAgent) && !/Chrome\//i.test(userAgent);
      }

      /**
       * Returns whether browser is Mobile Safari.
       *
       * @see https://developer.chrome.com/docs/multidevice/user-agent/
       * @return {boolean} Whether browser is Mobile Safari
       */
      static isMobileSafari() {
        return Browser.isMobile() && Browser.isSafari() && !Browser.isMobileChromeOniOS();
      }

      /**
       * Returns whether browser is Mobile Chrome on iOS.
       *
       * @see https://developer.chrome.com/docs/multidevice/user-agent/
       * @return {boolean} Whether browser is Mobile Chrome on iOS
       */
      static isMobileChromeOniOS() {
        const userAgent = Browser.getUserAgent();
        return Browser.isMobile() && /AppleWebKit/i.test(userAgent) && /CriOS\//i.test(userAgent);
      }

      /**
       * Returns whether browser can download via HTML5.
       *
       * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/a/download.js
       * @return {boolean} Whether browser supports downloading
       */
      static canDownload() {
        return !Browser.isMobile() || (!window.externalHost && 'download' in document.createElement('a'));
      }

      /**
       * Checks the browser for Dash support using H264 high.
       * Dash requires MediaSource extensions to exist and be applicable
       * to the H264 container (since we use H264 and not webm)
       *
       * @public
       * @param {boolean} recheck - recheck support
       * @return {boolean} true if dash is usable
       */
      static canPlayDash(recheck = false) {
        if (typeof isDashSupported === 'undefined' || recheck) {
          const mse = __webpack_require__.g.MediaSource;
          isDashSupported =
            !!mse &&
            typeof mse.isTypeSupported === 'function' &&
            mse.isTypeSupported('video/mp4; codecs="avc1.64001E"');
        }
        return isDashSupported;
      }

      /**
       * Checks whether the browser has support for the Clipboard API. This new API supercedes
       * the `execCommand`-based API and uses Promises for detecting whether it works or not.
       *
       * This check determines if the browser can support writing to the clipboard.
       * @see https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
       *
       * @return {boolean} whether writing to the clipboard is possible
       */
      static canWriteToClipboard() {
        return !!(__webpack_require__.g.navigator.clipboard && __webpack_require__.g.navigator.clipboard.writeText);
      }

      /**
       * Checks whether the browser has support for the Clipboard API. This new API supercedes
       * the `execCommand`-based API and uses Promises for detecting whether it works or not.
       *
       * This check determines if the browser can support reading from the clipboard.
       * @see https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
       *
       * @return {boolean} whether reading from the clipboard is possible
       */
      static canReadFromClipboard() {
        return !!(__webpack_require__.g.navigator.clipboard && __webpack_require__.g.navigator.clipboard.readText);
      }
    }
    /* harmony default export */ const utils_Browser = Browser; // CONCATENATED MODULE: ./src/constants.js
    /**
     *
     * @file Global constants
     * @author Box
     */

    /* ------------------------ API ---------------------------- */
    const API_PAGE_LIMIT = 1000; // default limit for paginated api calls

    /* ----------------------- Size ---------------------------- */
    const SIZE_LARGE = 'large';
    const SIZE_MEDIUM = 'medium';
    const SIZE_SMALL = 'small';
    const SIZE_VERY_LARGE = 'very_large';

    /* ----------------------- Views ---------------------------- */
    const VIEW_FOLDER = 'folder';
    const VIEW_SEARCH = 'search';
    const VIEW_SELECTED = 'selected';
    const VIEW_RECENTS = 'recents';
    const VIEW_ERROR = 'error';
    const VIEW_UPLOAD_EMPTY = 'upload-empty';
    const VIEW_UPLOAD_IN_PROGRESS = 'upload-inprogress';
    const VIEW_UPLOAD_SUCCESS = 'upload-success';
    const VIEW_METADATA = 'metadata';

    /* ----------------------- ViewModes ---------------------------- */
    const VIEW_MODE_LIST = 'list';
    const VIEW_MODE_GRID = 'grid';

    /* ----------------------- Types ---------------------------- */
    const constants_TYPE_FOLDER = 'folder';
    const constants_TYPE_FILE = 'file';
    const TYPE_WEBLINK = 'web_link';

    /* ----------------------- Feed Items Types ---------------------------- */
    const FEED_ITEM_TYPE_APP_ACTIVITY = 'app_activity';
    const FEED_ITEM_TYPE_ANNOTATION = 'annotation';
    const FEED_ITEM_TYPE_COMMENT = 'comment';
    const FEED_ITEM_TYPE_TASK = 'task';
    const FEED_ITEM_TYPE_VERSION = 'file_version';

    /* -------------------- Typed Prefix-------------------------- */
    const TYPED_ID_FOLDER_PREFIX = 'folder_';
    const TYPED_ID_FILE_PREFIX = 'file_';
    const TYPED_ID_WEBLINK_PREFIX = 'web_link_';
    const TYPED_ID_FEED_PREFIX = 'feedItems_';

    /* ----------------- Cache Key Prefix ----------------------- */
    const CACHE_PREFIX_FOLDER = TYPED_ID_FOLDER_PREFIX;
    const CACHE_PREFIX_FILE = TYPED_ID_FILE_PREFIX;
    const CACHE_PREFIX_WEBLINK = TYPED_ID_WEBLINK_PREFIX;
    const CACHE_PREFIX_SEARCH = 'search_';
    const CACHE_PREFIX_RECENTS = 'recents_';
    const CACHE_PREFIX_METADATA = 'metadata_';
    const CACHE_PREFIX_METADATA_QUERY = 'metadata_query_';

    /* ----------------------- Sorts ---------------------------- */
    const SORT_ASC = 'ASC';
    const constants_SORT_DESC = 'DESC';

    /* -------------------- Shared access ----------------------- */
    const ACCESS_NONE = 'none';
    const ACCESS_OPEN = 'open';
    const ACCESS_COLLAB = 'collaborators';
    const ACCESS_COMPANY = 'company';

    /* ----------------------- Headers -------------------------- */
    const HEADER_ACCEPT = 'Accept';
    const HEADER_CONTENT_TYPE = 'Content-Type';
    const HEADER_RETRY_AFTER = 'Retry-After';
    const HEADER_CLIENT_NAME = 'X-Box-Client-Name';
    const HEADER_CLIENT_VERSION = 'X-Box-Client-Version';
    const HEADER_ACCEPT_LANGUAGE = 'Accept-Language';

    /* ------------------ Metadata ---------------------- */
    const KEY_CLASSIFICATION_TYPE = 'Box__Security__Classification__Key';
    const METADATA_TEMPLATE_CLASSIFICATION = 'securityClassification-6VMVochwUWo';
    const METADATA_TEMPLATE_SKILLS = 'boxSkillsCards';
    const METADATA_TEMPLATE_PROPERTIES = 'properties';
    const METADATA_SCOPE_GLOBAL = 'global';
    const METADATA_SCOPE_ENTERPRISE = 'enterprise';
    const METADATA_TEMPLATE_FETCH_LIMIT = API_PAGE_LIMIT;

    /* ----------------------- Fields --------------------------- */
    const FIELD_ID = 'id';
    const FIELD_DATE = 'date';
    const constants_FIELD_NAME = 'name';
    const FIELD_TYPE = 'type';
    const constants_FIELD_SIZE = 'size';
    const FIELD_PARENT = 'parent';
    const FIELD_EXTENSION = 'extension';
    const FIELD_ITEM_EXPIRATION = 'expires_at';
    const FIELD_PERMISSIONS = 'permissions';
    const FIELD_PERMISSIONS_CAN_SHARE = `${FIELD_PERMISSIONS}.can_share`;
    const FIELD_PERMISSIONS_CAN_UPLOAD =
      /* unused pure expression or super */ null && `${FIELD_PERMISSIONS}.can_upload`;
    const FIELD_ITEM_COLLECTION = 'item_collection';
    const FIELD_PATH_COLLECTION = 'path_collection';
    const FIELD_CONTENT_CREATED_AT = 'content_created_at';
    const FIELD_CONTENT_MODIFIED_AT = 'content_modified_at';
    const constants_FIELD_MODIFIED_AT = 'modified_at';
    const FIELD_RESTORED_AT = 'restored_at';
    const FIELD_RESTORED_FROM = 'restored_from';
    const FIELD_CREATED_AT = 'created_at';
    const constants_FIELD_INTERACTED_AT = 'interacted_at';
    const FIELD_SHARED_LINK = 'shared_link';
    const FIELD_SHARED_LINK_ACCESS_LEVELS_DISABLED_REASONS = 'allowed_shared_link_access_levels_disabled_reasons';
    const FIELD_SHARED_LINK_FEATURES = 'shared_link_features';
    const FIELD_ALLOWED_INVITEE_ROLES = 'allowed_invitee_roles';
    const FIELD_ALLOWED_SHARED_LINK_ACCESS_LEVELS = 'allowed_shared_link_access_levels';
    const FIELD_HAS_COLLABORATIONS = 'has_collaborations';
    const FIELD_IS_EXTERNALLY_OWNED = 'is_externally_owned';
    const FIELD_TOTAL_COUNT = 'total_count';
    const FIELD_ENTRIES = 'entries';
    const FIELD_DOWNLOAD_URL = 'download_url';
    const FIELD_ACCESS = 'access';
    const FIELD_URL = 'url';
    const FIELD_CREATED_BY = 'created_by';
    const FIELD_MODIFIED_BY = 'modified_by';
    const FIELD_OWNED_BY = 'owned_by';
    const FIELD_PROMOTED_BY = 'promoted_by';
    const FIELD_RESTORED_BY = 'restored_by';
    const FIELD_TRASHED_BY = 'trashed_by';
    const FIELD_DESCRIPTION = 'description';
    const FIELD_REPRESENTATIONS = 'representations';
    const FIELD_SHA1 = 'sha1';
    const FIELD_WATERMARK_INFO = 'watermark_info';
    const FIELD_AUTHENTICATED_DOWNLOAD_URL = 'authenticated_download_url';
    const FIELD_FILE_VERSION = 'file_version';
    const FIELD_IS_DOWNLOAD_AVAILABLE = 'is_download_available';
    const FIELD_VERSION_LIMIT = 'version_limit';
    const FIELD_VERSION_NUMBER = 'version_number';
    const FIELD_METADATA = 'metadata';
    const FIELD_METADATA_SKILLS = `${FIELD_METADATA}.${METADATA_SCOPE_GLOBAL}.${METADATA_TEMPLATE_SKILLS}`;
    const FIELD_METADATA_PROPERTIES =
      /* unused pure expression or super */ null &&
      `${FIELD_METADATA}.${METADATA_SCOPE_GLOBAL}.${METADATA_TEMPLATE_PROPERTIES}`;
    const FIELD_METADATA_CLASSIFICATION =
      /* unused pure expression or super */ null &&
      `${FIELD_METADATA}.${METADATA_SCOPE_ENTERPRISE}.${METADATA_TEMPLATE_CLASSIFICATION}`;
    const FIELD_DUE_AT = 'due_at';
    const FIELD_TASK_ASSIGNMENT_COLLECTION = 'task_assignment_collection';
    const FIELD_TASK_COLLABORATOR_COLLECTION = 'task_collaborator_collection';
    const FIELD_IS_COMPLETED = 'is_completed';
    const FIELD_MESSAGE = 'message';
    const FIELD_TAGGED_MESSAGE = 'tagged_message';
    const FIELD_TRASHED_AT = 'trashed_at';
    const FIELD_ASSIGNED_TO = 'assigned_to';
    const FIELD_RELEVANCE = '';
    const FIELD_STATUS = 'status';
    const FIELD_ACTIVITY_TEMPLATE = 'activity_template';
    const FIELD_APP = 'app';
    const FIELD_OCCURRED_AT = 'occurred_at';
    const FIELD_RENDERED_TEXT = 'rendered_text';
    const FIELD_RETENTION = 'retention';
    const FIELD_UPLOADER_DISPLAY_NAME = 'uploader_display_name';
    const FIELD_CLASSIFICATION = 'classification';
    const FIELD_ENTERPRISE = 'enterprise';
    const FIELD_HOSTNAME = 'hostname';

    /* ----------------------- Permissions --------------------------- */
    const PERMISSION_CAN_COMMENT = 'can_comment';
    const PERMISSION_CAN_CREATE_ANNOTATIONS = 'can_create_annotations';
    const PERMISSION_CAN_DELETE = 'can_delete';
    const PERMISSION_CAN_DOWNLOAD = 'can_download';
    const PERMISSION_CAN_EDIT = 'can_edit';
    const PERMISSION_CAN_PREVIEW = 'can_preview';
    const PERMISSION_CAN_RENAME = 'can_rename';
    const PERMISSION_CAN_RESOLVE = 'can_resolve';
    const PERMISSION_CAN_SET_SHARE_ACCESS = 'can_set_share_access';
    const PERMISSION_CAN_SHARE = 'can_share';
    const PERMISSION_CAN_UPLOAD = 'can_upload';
    const PERMISSION_CAN_VIEW_ANNOTATIONS = 'can_view_annotations';

    /* --------------------- Invitee roles --------------------------- */
    const INVITEE_ROLE_EDITOR = 'editor';

    /* ------------- Delimiters for bread crumbs ---------------- */
    const DELIMITER_SLASH = 'slash';
    const DELIMITER_CARET = 'caret';

    /* ---------------------- Defaults -------------------------- */
    const DEFAULT_PREVIEW_VERSION = '2.106.0';
    const DEFAULT_LOCALE = 'en-US';
    const DEFAULT_PATH_STATIC = 'platform/elements';
    const DEFAULT_PATH_STATIC_PREVIEW = 'platform/preview';
    const DEFAULT_HOSTNAME_API = 'https://api.box.com';
    const DEFAULT_HOSTNAME_STATIC = 'https://cdn01.boxcdn.net';
    const DEFAULT_HOSTNAME_UPLOAD = 'https://upload.box.com';
    const DEFAULT_HOSTNAME_UPLOAD_APP = 'https://upload.app.box.com';
    const DEFAULT_HOSTNAME_UPLOAD_GOV = 'https://upload.app.box-gov.com';
    const DEFAULT_HOSTNAME_APP = 'https://app.box.com';
    const DEFAULT_CONTAINER = 'body';
    const DEFAULT_ROOT = '0';
    const DEFAULT_SEARCH_DEBOUNCE = 500;
    const DEFAULT_COLLAB_DEBOUNCE = 500;
    const DEFAULT_FORMAT_DEBOUNCE = 1000;
    const DEFAULT_MAX_COLLABORATORS = 25;
    const DEFAULT_MAX_CONTACTS = 50;
    const DEFAULT_PAGE_NUMBER = 1;
    const DEFAULT_PAGE_SIZE = 50;
    const DEFAULT_FETCH_START = 0;
    const DEFAULT_FETCH_END = 1000;
    const DEFAULT_VIEW_FILES = 'files';
    const DEFAULT_VIEW_RECENTS = 'recents';
    const DEFAULT_VIEW_METADATA = 'metadata';
    const CLIENT_NAME_CONTENT_EXPLORER = 'ContentExplorer';
    const CLIENT_NAME_OPEN_WITH = 'ContentOpenWith';
    const CLIENT_NAME_CONTENT_PICKER = 'ContentPicker';
    const CLIENT_NAME_CONTENT_PREVIEW = 'ContentPreview';
    const CLIENT_NAME_CONTENT_SHARING = 'ContentSharing';
    const CLIENT_NAME_CONTENT_SIDEBAR = 'ContentSidebar';
    const CLIENT_NAME_CONTENT_UPLOADER = 'ContentUploader';
    const CLIENT_NAME_FILE_PICKER = 'FilePicker';
    const CLIENT_NAME_FOLDER_PICKER = 'FolderPicker';

    /* ---------------------- Statuses -------------------------- */
    const STATUS_PENDING = 'pending';
    const STATUS_IN_PROGRESS = 'inprogress';
    const STATUS_STAGED = 'staged';
    const STATUS_COMPLETE = 'complete';
    const STATUS_ERROR = 'error';
    const STATUS_ACCEPTED = 'accepted';
    const STATUS_INACTIVE = 'inactive';

    /* ------------------- Styles ------------------------ */
    const CLASS_MODAL_CONTENT = 'be-modal-dialog-content';
    const CLASS_MODAL_CONTENT_FULL_BLEED = 'be-modal-dialog-content-full-bleed';
    const CLASS_MODAL_OVERLAY = 'be-modal-dialog-overlay';
    const CLASS_IS_SMALL = 'be-is-small';
    const CLASS_IS_MEDIUM = 'be-is-medium';
    const CLASS_IS_TOUCH = 'be-is-touch';
    const CLASS_MODAL = 'be-modal';
    const CLASS_INTEGRATION_ICON = 'bcow-integration-icon';
    const constants_OVERLAY_WRAPPER_CLASS = 'overlay-wrapper';

    /* ------------------ Error Codes ---------------------- */
    const ERROR_CODE_ITEM_NAME_INVALID = 'item_name_invalid';
    const ERROR_CODE_ITEM_NAME_TOO_LONG = 'item_name_too_long';
    const ERROR_CODE_ITEM_NAME_IN_USE = 'item_name_in_use';
    const ERROR_CODE_UPLOAD_FILE_LIMIT = 'upload_file_limit';
    const ERROR_CODE_UPLOAD_CHILD_FOLDER_FAILED = 'child_folder_failed_upload';
    const ERROR_CODE_UPLOAD_STORAGE_LIMIT_EXCEEDED = 'storage_limit_exceeded';
    const ERROR_CODE_UPLOAD_FILE_SIZE_LIMIT_EXCEEDED = 'file_size_limit_exceeded';
    const ERROR_CODE_UPLOAD_PENDING_APP_FOLDER_SIZE_LIMIT = 'pending_app_folder_size_limit';
    const ERROR_CODE_UPLOAD_BAD_DIGEST = 'bad_digest';
    const ERROR_CODE_UPLOAD_FAILED_PACKAGE = 'failed_package_upload';
    const ERROR_CODE_FETCH_ACTIVITY = 'fetch_activity_error';
    const ERROR_CODE_FETCH_ANNOTATION = 'fetch_annotation_error';
    const ERROR_CODE_FETCH_ANNOTATIONS = 'fetch_annotations_error';
    const ERROR_CODE_FETCH_FILE = 'fetch_file_error';
    const ERROR_CODE_FETCH_FILE_DUE_TO_POLICY = 'forbidden_by_policy';
    const ERROR_CODE_FETCH_FOLDER = 'fetch_folder_error';
    const ERROR_CODE_FETCH_WEBLINK = 'fetch_weblink_error';
    const ERROR_CODE_FETCH_CLASSIFICATION = 'fetch_classification_error';
    const ERROR_CODE_FETCH_COMMENT = 'fetch_comment_error';
    const ERROR_CODE_FETCH_COMMENTS = 'fetch_comments_error';
    const ERROR_CODE_FETCH_REPLIES = 'fetch_replies_error';
    const ERROR_CODE_FETCH_VERSION = 'fetch_version_error';
    const ERROR_CODE_FETCH_VERSIONS = 'fetch_versions_error';
    const ERROR_CODE_FETCH_TASKS = 'fetch_tasks_error';
    const ERROR_CODE_FETCH_CURRENT_USER = 'fetch_current_user_error';
    const ERROR_CODE_FETCH_ENTERPRISE_GROUPS = 'fetch_enterprise_groups_error';
    const ERROR_CODE_FETCH_ENTERPRISE_USERS = 'fetch_enterprise_users_error';
    const ERROR_CODE_FETCH_TASK_ASSIGNMENT = 'fetch_task_assignment_error';
    const ERROR_CODE_FETCH_TASK_COLLABORATOR = 'fetch_task_collaborator_error';
    const ERROR_CODE_FETCH_INTEGRATIONS = 'fetch_integrations_error';
    const ERROR_CODE_FETCH_METADATA = 'fetch_metadata_error';
    const ERROR_CODE_FETCH_METADATA_TEMPLATES = 'fetch_metadata_templates_error';
    const ERROR_CODE_FETCH_ACCESS_STATS = 'fetch_access_stats_error';
    const ERROR_CODE_FETCH_SKILLS = 'fetch_skills_error';
    const ERROR_CODE_FETCH_RECENTS = 'fetch_recents_error';
    const ERROR_CODE_EXECUTE_INTEGRATION = 'execute_integrations_error';
    const ERROR_CODE_CREATE_ANNOTATION = 'create_annotation_error';
    const ERROR_CODE_CREATE_COMMENT = 'create_comment_error';
    const ERROR_CODE_CREATE_REPLY = 'create_reply_error';
    const ERROR_CODE_CREATE_TASK = 'create_task_error';
    const ERROR_CODE_CREATE_TASK_LINK = 'create_task_link_error';
    const ERROR_CODE_CREATE_TASK_ASSIGNMENT = 'create_task_assignment_error';
    const ERROR_CODE_CREATE_TASK_COLLABORATOR = 'create_task_collaborator_error';
    const ERROR_CODE_CREATE_FOLDER = 'create_folder_error';
    const ERROR_CODE_CREATE_METADATA = 'create_metadata_error';
    const ERROR_CODE_DELETE_APP_ACTIVITY = 'delete_app_activity_error';
    const ERROR_CODE_DELETE_ANNOTATION = 'delete_annotation_error';
    const ERROR_CODE_EDIT_ANNOTATION = 'edit_annotation_error';
    const ERROR_CODE_DELETE_COMMENT = 'delete_comment_error';
    const ERROR_CODE_DELETE_TASK = 'delete_task_error';
    const ERROR_CODE_DELETE_TASK_ASSIGNMENT = 'delete_task_assignment_error';
    const ERROR_CODE_DELETE_TASK_COLLABORATOR = 'delete_task_collaborator_error';
    const ERROR_CODE_DELETE_ITEM = 'delete_item_error';
    const ERROR_CODE_DELETE_METADATA = 'delete_metadata_error';
    const ERROR_CODE_DELETE_VERSION = 'delete_version_error';
    const ERROR_CODE_GROUP_EXCEEDS_LIMIT = 'group_exceeds_limit';
    const ERROR_CODE_PROMOTE_VERSION = 'promote_version_error';
    const ERROR_CODE_RESTORE_VERSION = 'restore_version_error';
    const ERROR_CODE_UPDATE_TASK = 'update_task_error';
    const ERROR_CODE_UPDATE_TASK_ASSIGNMENT = 'update_task_assignment_error';
    const ERROR_CODE_UPDATE_TASK_COLLABORATOR = 'update_task_collaborator_error';
    const ERROR_CODE_UPDATE_COMMENT = 'update_comment_error';
    const ERROR_CODE_UPDATE_SKILLS = 'update_skills_error';
    const ERROR_CODE_UPDATE_METADATA = 'update_metadata_error';
    const ERROR_CODE_GET_DOWNLOAD_URL = 'get_download_url_error';
    const ERROR_CODE_RENAME_ITEM = 'rename_item_error';
    const ERROR_CODE_SHARE_ITEM = 'share_item_error';
    const ERROR_CODE_SET_FILE_DESCRIPTION = 'set_file_description_error';
    const ERROR_CODE_UPLOAD = 'upload_error';
    const ERROR_CODE_UNEXPECTED_EXCEPTION = 'unexpected_exception_error';
    const ERROR_CODE_SEARCH = 'search_error';
    const ERROR_CODE_METADATA_QUERY = 'metadata_query_error';
    const ERROR_CODE_UNKNOWN = 'unknown_error';

    /* ------------------ Origins ---------------------- */
    const ORIGIN_CONTENT_PREVIEW = 'content_preview';
    const ORIGIN_CONTENT_SIDEBAR = 'content_sidebar';
    const ORIGIN_ACTIVITY_SIDEBAR = 'activity_sidebar';
    const ORIGIN_DETAILS_SIDEBAR = 'details_sidebar';
    const ORIGIN_DOCGEN_SIDEBAR = 'docgen_sidebar';
    const ORIGIN_METADATA_SIDEBAR = 'metadata_sidebar';
    const ORIGIN_SKILLS_SIDEBAR = 'skills_sidebar';
    const ORIGIN_VERSIONS_SIDEBAR = 'versions_sidebar';
    const ORIGIN_PREVIEW = 'preview';
    const ORIGIN_PREVIEW_SIDEBAR = 'preview_sidebar';
    const ORIGIN_CONTENT_EXPLORER = 'content_explorer';
    const ORIGIN_OPEN_WITH = 'open_with';

    /* ------------------ Metric Types ---------------------- */
    const METRIC_TYPE_PREVIEW = 'preview_metric';
    const METRIC_TYPE_ELEMENTS_PERFORMANCE_METRIC = 'elements_performance_metric';
    const METRIC_TYPE_ELEMENTS_LOAD_METRIC = 'elements_load_metric';

    /* ------------------ Error Keys ---------------------- */
    const IS_ERROR_DISPLAYED = 'isErrorDisplayed'; // used to determine if user will see some error state or message

    /* ------------- Representation Hints ------------------- */
    const X_REP_HINT_BASE = '[3d][pdf][text][mp3][json]';
    const X_REP_HINT_DOC_THUMBNAIL = '[jpg?dimensions=1024x1024&paged=false]';
    const X_REP_HINT_IMAGE = '[jpg?dimensions=2048x2048,png?dimensions=2048x2048]';
    const X_REP_HINT_VIDEO_DASH = '[dash,mp4][filmstrip]';
    const X_REP_HINT_VIDEO_MP4 = '[mp4]';
    const videoHint = utils_Browser.canPlayDash() ? X_REP_HINT_VIDEO_DASH : X_REP_HINT_VIDEO_MP4;
    const X_REP_HINTS = `${X_REP_HINT_BASE}${X_REP_HINT_DOC_THUMBNAIL}${X_REP_HINT_IMAGE}${videoHint}`;

    /* ------------------ Uploader ---------------------- */
    const DEFAULT_RETRY_DELAY_MS = 3000;
    const MS_IN_S = 1000;

    /* ------------------ Colors ---------------------- */
    const COLOR_RED = '#c82341';
    const COLOR_999 = '#999';
    const COLOR_WHITE = '#fff';

    /* ------------------ Skills ---------------------- */
    const SKILLS_TRANSCRIPT = 'transcript';
    const SKILLS_KEYWORD = 'keyword';
    const SKILLS_TIMELINE = 'timeline';
    const SKILLS_FACE = 'face';
    const SKILLS_STATUS = 'status';
    const SKILLS_ERROR_INVOCATIONS = 'skills_invocations_error';
    const SKILLS_ERROR_BILLING = 'skills_billing_error';
    const SKILLS_ERROR_EXTERNAL_AUTH = 'skills_external_auth_error';
    const SKILLS_ERROR_UNKNOWN = 'skills_unknown_error';
    const SKILLS_ERROR_INVALID_FILE_SIZE = 'skills_invalid_file_size_error';
    const SKILLS_ERROR_INVALID_FILE_FORMAT = 'skills_invalid_file_format_error';
    const SKILLS_ERROR_FILE_PROCESSING = 'skills_file_processing_error';
    const SKILLS_STATUS_PENDING = 'skills_pending_status';
    const SKILLS_STATUS_INVOKED = 'skills_invoked_status';

    /* ------------------ File Extensions ---------------------- */
    const constants_FILE_EXTENSION_BOX_CANVAS = 'boxcanvas';
    const constants_FILE_EXTENSION_BOX_NOTE = 'boxnote';
    const constants_FILE_EXTENSION_GOOGLE_DOC = 'gdoc';
    const constants_FILE_EXTENSION_GOOGLE_SHEET = 'gsheet';
    const constants_FILE_EXTENSION_GOOGLE_SLIDE = 'gslides';
    const constants_FILE_EXTENSION_GOOGLE_SLIDE_LEGACY = 'gslide';

    /* ------------------ X-Rep-Hints ---------------------- */
    // available dimensions for JPG: "32x32", "94x94", "160x160", "320x320", "1024x1024", "2048x2048"
    const X_REP_HINT_JPG_DIMENSIONS_DEFAULT = '1024x1024';

    // available dimensions for PNG: "1024x1024", "2048x2048"
    const X_REP_HINT_PNG_DIMENSIONS_DEFAULT = '1024x1024';

    // If unable to fetch jpg thumbnail, grab png rep of first page. Certain file types do not have a thumbnail rep but do have a first page rep.
    // Get the PDF rep as well, which ensures that the Preview SDK loads linearized reps for customers with PDF optimization enabled.
    // Get the text rep as well, which ensures that large text files load in the Preview SDK.
    const X_REP_HINT_HEADER_DIMENSIONS_DEFAULT = `[jpg?dimensions=${X_REP_HINT_JPG_DIMENSIONS_DEFAULT}&paged=false,png?dimensions=${X_REP_HINT_PNG_DIMENSIONS_DEFAULT}][pdf][text]`;

    /* ------------------ Representations Response ---------- */
    const REPRESENTATIONS_RESPONSE_ERROR = 'error';
    const REPRESENTATIONS_RESPONSE_NONE = 'none';
    const REPRESENTATIONS_RESPONSE_PENDING = 'pending';
    const REPRESENTATIONS_RESPONSE_SUCCESS = 'success';
    const REPRESENTATIONS_RESPONSE_VIEWABLE = 'viewable';

    /* ------------------ Sidebar View ---------------------- */
    const SIDEBAR_VIEW_SKILLS = 'skills';
    const SIDEBAR_VIEW_DETAILS = 'details';
    const SIDEBAR_VIEW_METADATA = 'metadata';
    const SIDEBAR_VIEW_ACTIVITY = 'activity';
    const SIDEBAR_VIEW_VERSIONS = 'versions';
    const SIDEBAR_VIEW_DOCGEN = 'docgen';

    /* ------------------ HTTP Requests ---------------------- */
    const HTTP_GET = 'GET';
    const HTTP_POST = 'POST';
    const HTTP_PUT = 'PUT';
    const HTTP_DELETE = 'DELETE';
    const HTTP_OPTIONS = 'OPTIONS';
    const HTTP_HEAD = 'HEAD';

    /* ------------------ HTTP Codes  ---------------------- */
    const HTTP_STATUS_CODE_BAD_REQUEST = 400;
    const HTTP_STATUS_CODE_UNAUTHORIZED = 401;
    const HTTP_STATUS_CODE_FORBIDDEN = 403;
    const HTTP_STATUS_CODE_NOT_FOUND = 404;
    const HTTP_STATUS_CODE_CONFLICT = 409;
    const HTTP_STATUS_CODE_RATE_LIMIT = 429;
    const HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR = 500;
    const HTTP_STATUS_CODE_NOT_IMPLEMENTED = 501;
    const HTTP_STATUS_CODE_BAD_GATEWAY = 502;
    const HTTP_STATUS_CODE_SERVICE_UNAVAILABLE = 503;
    const HTTP_STATUS_CODE_GATEWAY_TIMEOUT = 504;

    /* ------------------ Version Action Types  ---------------------- */
    const VERSION_DELETE_ACTION = 'delete';
    const VERSION_PROMOTE_ACTION = 'promote';
    const VERSION_RESTORE_ACTION = 'restore';
    const VERSION_UPLOAD_ACTION = 'upload';

    /* ------------------ Version Retention Policy Action Types  ---------------------- */
    const VERSION_RETENTION_DELETE_ACTION = 'permanently_delete';
    const VERSION_RETENTION_REMOVE_ACTION = 'remove_retention';
    const VERSION_RETENTION_INDEFINITE = 'indefinite';

    /* ------------------ Placeholder Feed Items ------------------------- */
    const constants_PLACEHOLDER_USER = {
      type: 'user',
      id: '2',
      name: '',
    };
    const FILE_REQUEST_NAME = 'File Request';

    /* ------------------ Open With ------------------------- */
    const APP_INTEGRATION = 'app_integration';
    const BOX_EDIT_INTEGRATION_ID = '1338';
    const BOX_EDIT_SFC_INTEGRATION_ID = '13418';
    const OPEN_WITH_BUTTON_ICON_SIZE = 26;
    const OPEN_WITH_MENU_ITEM_ICON_SIZE = 30;

    /* ------------------ Task Statuses ----------------- */
    const TASK_NEW_APPROVED = 'APPROVED';
    const TASK_NEW_COMPLETED = 'COMPLETED';
    const TASK_NEW_NOT_STARTED = 'NOT_STARTED';
    const TASK_NEW_IN_PROGRESS = 'IN_PROGRESS';
    const TASK_NEW_REJECTED = 'REJECTED';

    /* ------------------ Task types ----------------- */
    const TASK_TYPE_GENERAL = 'GENERAL';
    const TASK_TYPE_APPROVAL = 'APPROVAL';

    /* ----------------- Task Completion Rules ------------ */
    const TASK_COMPLETION_RULE_ALL = 'ALL_ASSIGNEES';
    const TASK_COMPLETION_RULE_ANY = 'ANY_ASSIGNEE';

    /* ----------------- Task Edit modes ---------------- */
    const TASK_EDIT_MODE_CREATE = 'CREATE';
    const TASK_EDIT_MODE_EDIT = 'EDIT';

    /* ----------------- Task Validation ---------------- */
    const TASK_MAX_GROUP_ASSIGNEES = 250;

    /* ------------------ Comment (and Annotation) Statuses ----------------- */
    const COMMENT_STATUS_OPEN = 'open';
    const COMMENT_STATUS_RESOLVED = 'resolved';

    /* ------------------ Activity Filter Options ------------------ */
    const ACTIVITY_FILTER_OPTION_ALL = 'all';
    const ACTIVITY_FILTER_OPTION_RESOLVED = 'resolved';
    const ACTIVITY_FILTER_OPTION_TASKS = 'tasks';
    const ACTIVITY_FILTER_OPTION_UNRESOLVED = 'open';

    /* ------------------ File Activity Action Types ----------- */
    const ACTION_TYPE_CREATED = 'created';
    const ACTION_TYPE_RESTORED = 'restored';
    const ACTION_TYPE_TRASHED = 'trashed';

    /* ------------------ File Activity Types ------------------ */
    const FILE_ACTIVITY_TYPE_ANNOTATION = 'annotation';
    const FILE_ACTIVITY_TYPE_APP_ACTIVITY = 'app_activity';
    const FILE_ACTIVITY_TYPE_COMMENT = 'comment';
    const FILE_ACTIVITY_TYPE_TASK = 'task';
    const FILE_ACTIVITY_TYPE_VERSION = 'versions';

    /* ----------------- Theme ---------------------------*/
    const THEME_VERY_DARK = 'vDark';
    const THEME_DARK = 'dark';
    const THEME_MID_DARK = 'midDark';
    const THEME_MIDTONE = 'midTone';
    const THEME_MID_LIGHT = 'midLight';
    const THEME_VERY_LIGHT = 'vLight';

    /* ------------------ Keyboard Events ----------------- */
    const constants_KEYS = {
      arrowDown: 'ArrowDown',
      arrowLeft: 'ArrowLeft',
      arrowRight: 'ArrowRight',
      arrowUp: 'ArrowUp',
      backspace: 'Backspace',
      enter: 'Enter',
      escape: 'Escape',
      space: ' ',
    };

    /* ----------------- Other ----------------------- */
    const ONE_HOUR_MS = 3600000; // 60 * 60 * 1000
    // CONCATENATED MODULE: ./src/elements/wrappers/ES6Wrapper.js
    function ES6Wrapper_defineProperty(e, r, t) {
      return (
        (r = ES6Wrapper_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ES6Wrapper_toPropertyKey(t) {
      var i = ES6Wrapper_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ES6Wrapper_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Base class for the Box UI Elements ES6 wrapper
     * @author Box
     */

    class ES6Wrapper extends events_default() {
      constructor(...args) {
        super(...args);
        /**
         * @property {Function}
         */
        /**
         * @property {HTMLElement}
         */
        /**
         * @property {string}
         */
        /**
         * @property {string}
         */
        /**
         * @property {string}
         */
        /**
         * @property {string}
         */
        ES6Wrapper_defineProperty(this, 'language', i18n.language);
        /**
         * @property {Object}
         */
        ES6Wrapper_defineProperty(this, 'messages', i18n.messages);
        /**
         * Sets reference to the inner component
         *
         * @protected
         * @return {void}
         */
        ES6Wrapper_defineProperty(this, 'setComponent', component => {
          this.component = component;
        });
        /**
         * Callback for interaction events
         *
         * @return {void}
         */
        ES6Wrapper_defineProperty(this, 'onInteraction', data => {
          this.emit('interaction', data);
        });
      }
      /**
       * @property {Element}
       */

      /**
       * Shows the content picker.
       *
       * @public
       * @param {string} id - The folder or file id.
       * @param {string} token - The API access token.
       * @param {Object|void} [options] Optional options.
       * @return {void}
       */
      show(id, token, options = {}) {
        this.id = id;
        this.token = token;
        this.options = options;
        this.options.version = '0.0.0-semantically-released';
        this.emit = this.emit.bind(this);
        const container = options.container || DEFAULT_CONTAINER;
        this.container = container instanceof HTMLElement ? container : document.querySelector(container);
        this.render();
      }

      /**
       * Hides the content picker.
       * Removes all event listeners.
       * Clears out the DOM inside container.
       *
       * @public
       * @return {void}
       */
      hide() {
        this.removeAllListeners();
        // TODO replace when upgrading to React 18
        // eslint-disable-next-line react/no-deprecated
        react_dom.unmountComponentAtNode(this.container);
        if (this.container) {
          this.container.innerHTML = '';
        }
      }

      /**
       * Renders the component.
       * Should be overriden.
       *
       * @protected
       * @return {void}
       */
      render() {
        throw new Error('Unimplemented!');
      }
      /**
       * Gets reference to the inner component
       *
       * @public
       * @return {Element}
       */
      getComponent() {
        return this.component;
      }

      /**
       * Clears out the cache used by the component
       *
       * @public
       * @return {Element}
       */
      clearCache() {
        const component = this.getComponent();
        if (component && typeof component.clearCache === 'function') {
          component.clearCache();
        }
      }
      /**
       * Wrapper for emit to prevent JS exceptions
       * in the listeners own code.
       *
       * @public
       * @param {string} eventName - name of the event
       * @param {Object} data - event data
       * @return {boolean} true if the event had listeners, false otherwise.
       */
      emit(eventName, data) {
        try {
          return super.emit(eventName, data);
        } catch (e) {
          // do nothing
        }
        return false;
      }
    }
    /* harmony default export */ const wrappers_ES6Wrapper = ES6Wrapper;
    // EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
    var lib = __webpack_require__(24082);
    var lib_default = /*#__PURE__*/ __webpack_require__.n(lib);
    // EXTERNAL MODULE: ./node_modules/lodash/noop.js
    var noop = __webpack_require__(18564);
    var noop_default = /*#__PURE__*/ __webpack_require__.n(noop);
    // EXTERNAL MODULE: ./node_modules/lodash/omit.js
    var lodash_omit = __webpack_require__(64633);
    var omit_default = /*#__PURE__*/ __webpack_require__.n(lodash_omit); // CONCATENATED MODULE: ./src/elements/common/makePopup.js
    const _excluded = ['modal'];
    function _objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = _objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function _objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function makePopup_defineProperty(e, r, t) {
      return (
        (r = makePopup_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function makePopup_toPropertyKey(t) {
      var i = makePopup_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function makePopup_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file HOC to make popup-able Box UI Elements
     * @author Box
     */

    const makePopup = kit => Wrapped =>
      class Wrapper extends react.PureComponent {
        /**
         * [constructor]
         *
         * @param {*} props
         * @return {Wrapper}
         */
        constructor(props) {
          super(props);
          /**
           * Callback for clicking
           *
           * @param {*} data - any callback data
           * @return {void}
           */
          makePopup_defineProperty(this, 'onClick', data => {
            const { onClick = noop_default() } = this.props;
            this.close(onClick, data);
          });
          /**
           * Callback for pressing close
           *
           * @param {*} data - any callback data
           * @return {void}
           */
          makePopup_defineProperty(this, 'onClose', data => {
            const { onClose = noop_default() } = this.props;
            this.close(onClose, data);
          });
          /**
           * Callback for pressing cancel
           *
           * @param {*} data - any callback data
           * @return {void}
           */
          makePopup_defineProperty(this, 'onCancel', data => {
            const { onCancel = noop_default() } = this.props;
            this.close(onCancel, data);
          });
          /**
           * Callback for pressing choose
           *
           * @param {*} data - any callback data
           * @return {void}
           */
          makePopup_defineProperty(this, 'onChoose', data => {
            const { onChoose = noop_default() } = this.props;
            this.close(onChoose, data);
          });
          /**
           * Button click handler
           *
           * @return {void}
           */
          makePopup_defineProperty(this, 'onButtonClick', () => {
            this.setState({
              isOpen: true,
            });
          });
          this.state = {
            isOpen: false,
          };
        }

        /**
         * Hides the modal and call the callback
         *
         * @param {Function} callback - function to call
         * @return {void}
         */
        close(callback, data) {
          this.setState(
            {
              isOpen: false,
            },
            () => callback(data),
          );
        }
        /**
         * Renders the component
         *
         * @return {void}
         */
        render() {
          const { isOpen } = this.state;
          const _this$props = this.props,
            { modal } = _this$props,
            rest = _objectWithoutProperties(_this$props, _excluded);
          const wrappedProps = omit_default()(rest, ['onCancel', 'onChoose', 'onClose', 'modal']);
          const {
            buttonLabel = 'Missing modal.buttonLabel in options',
            buttonClassName = 'btn btn-primary',
            modalClassName = 'be-modal-wrapper-content',
            overlayClassName = 'be-modal-wrapper-overlay',
          } = modal;
          switch (kit) {
            case CLIENT_NAME_CONTENT_PICKER:
              wrappedProps.onCancel = this.onCancel;
              wrappedProps.onChoose = this.onChoose;
              break;
            case CLIENT_NAME_CONTENT_UPLOADER:
              wrappedProps.onClose = this.onClose;
              break;
            default:
              throw new Error('Unknown kit type');
          }
          return /*#__PURE__*/ react.createElement(
            'div',
            null,
            /*#__PURE__*/ react.createElement(
              'button',
              {
                className: buttonClassName,
                onClick: this.onButtonClick,
                type: 'button',
              },
              buttonLabel,
            ),
            /*#__PURE__*/ react.createElement(
              lib_default(),
              {
                className: modalClassName,
                contentLabel: kit,
                isOpen: isOpen,
                overlayClassName: overlayClassName,
              },
              /*#__PURE__*/ react.createElement(Wrapped, wrappedProps),
            ),
          );
        }
      };
    /* harmony default export */ const common_makePopup = makePopup;
    // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
    var runtime = __webpack_require__(46414);
    // EXTERNAL MODULE: ./node_modules/classnames/index.js
    var node_modules_classnames = __webpack_require__(78444);
    var classnames_default = /*#__PURE__*/ __webpack_require__.n(node_modules_classnames);
    // EXTERNAL MODULE: ./node_modules/lodash/debounce.js
    var debounce = __webpack_require__(24551);
    var debounce_default = /*#__PURE__*/ __webpack_require__.n(debounce);
    // EXTERNAL MODULE: ./node_modules/lodash/get.js
    var get = __webpack_require__(25358);
    var get_default = /*#__PURE__*/ __webpack_require__.n(get);
    // EXTERNAL MODULE: ./node_modules/lodash/uniqueId.js
    var uniqueId = __webpack_require__(70406);
    var uniqueId_default = /*#__PURE__*/ __webpack_require__.n(uniqueId); // CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.mjs
    /******************************************************************************
			Copyright (c) Microsoft Corporation.
			
			Permission to use, copy, modify, and/or distribute this software for any
			purpose with or without fee is hereby granted.
			
			THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
			REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
			AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
			INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
			LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
			OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
			PERFORMANCE OF THIS SOFTWARE.
			***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol */

    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({
          __proto__: [],
        } instanceof Array &&
          function (d, b) {
            d.__proto__ = b;
          }) ||
        function (d, b) {
          for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };
    function __extends(d, b) {
      if (typeof b !== 'function' && b !== null)
        throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
    }
    var __assign = function () {
      __assign =
        Object.assign ||
        function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
        };
      return __assign.apply(this, arguments);
    };
    function tslib_es6_rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
        }
      return t;
    }
    function __decorate(decorators, target, key, desc) {
      var c = arguments.length,
        r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
        d;
      if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
        r = Reflect.decorate(decorators, target, key, desc);
      else
        for (var i = decorators.length - 1; i >= 0; i--)
          if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
    }
    function __param(paramIndex, decorator) {
      return function (target, key) {
        decorator(target, key, paramIndex);
      };
    }
    function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
      function accept(f) {
        if (f !== void 0 && typeof f !== 'function') throw new TypeError('Function expected');
        return f;
      }
      var kind = contextIn.kind,
        key = kind === 'getter' ? 'get' : kind === 'setter' ? 'set' : 'value';
      var target = !descriptorIn && ctor ? (contextIn['static'] ? ctor : ctor.prototype) : null;
      var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
      var _,
        done = false;
      for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === 'access' ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) {
          if (done) throw new TypeError('Cannot add initializers after decoration has completed');
          extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(
          kind === 'accessor'
            ? {
                get: descriptor.get,
                set: descriptor.set,
              }
            : descriptor[key],
          context,
        );
        if (kind === 'accessor') {
          if (result === void 0) continue;
          if (result === null || typeof result !== 'object') throw new TypeError('Object expected');
          if ((_ = accept(result.get))) descriptor.get = _;
          if ((_ = accept(result.set))) descriptor.set = _;
          if ((_ = accept(result.init))) initializers.unshift(_);
        } else if ((_ = accept(result))) {
          if (kind === 'field') initializers.unshift(_);
          else descriptor[key] = _;
        }
      }
      if (target) Object.defineProperty(target, contextIn.name, descriptor);
      done = true;
    }
    function __runInitializers(thisArg, initializers, value) {
      var useValue = arguments.length > 2;
      for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
      }
      return useValue ? value : void 0;
    }
    function __propKey(x) {
      return typeof x === 'symbol' ? x : ''.concat(x);
    }
    function __setFunctionName(f, name, prefix) {
      if (typeof name === 'symbol') name = name.description ? '['.concat(name.description, ']') : '';
      return Object.defineProperty(f, 'name', {
        configurable: true,
        value: prefix ? ''.concat(prefix, ' ', name) : name,
      });
    }
    function __metadata(metadataKey, metadataValue) {
      if (typeof Reflect === 'object' && typeof Reflect.metadata === 'function')
        return Reflect.metadata(metadataKey, metadataValue);
    }
    function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P
          ? value
          : new P(function (resolve) {
              resolve(value);
            });
      }
      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator['throw'](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    }
    function __generator(thisArg, body) {
      var _ = {
          label: 0,
          sent: function () {
            if (t[0] & 1) throw t[1];
            return t[1];
          },
          trys: [],
          ops: [],
        },
        f,
        y,
        t,
        g;
      return (
        (g = {
          next: verb(0),
          throw: verb(1),
          return: verb(2),
        }),
        typeof Symbol === 'function' &&
          (g[Symbol.iterator] = function () {
            return this;
          }),
        g
      );
      function verb(n) {
        return function (v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f) throw new TypeError('Generator is already executing.');
        while ((g && ((g = 0), op[0] && (_ = 0)), _))
          try {
            if (
              ((f = 1),
              y &&
                (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) &&
                !(t = t.call(y, op[1])).done)
            )
              return t;
            if (((y = 0), t)) op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return {
                  value: op[1],
                  done: false,
                };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5) throw op[1];
        return {
          value: op[0] ? op[1] : void 0,
          done: true,
        };
      }
    }
    var __createBinding = Object.create
      ? function (o, m, k, k2) {
          if (k2 === undefined) k2 = k;
          var desc = Object.getOwnPropertyDescriptor(m, k);
          if (!desc || ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)) {
            desc = {
              enumerable: true,
              get: function () {
                return m[k];
              },
            };
          }
          Object.defineProperty(o, k2, desc);
        }
      : function (o, m, k, k2) {
          if (k2 === undefined) k2 = k;
          o[k2] = m[k];
        };
    function __exportStar(m, o) {
      for (var p in m) if (p !== 'default' && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
    }
    function __values(o) {
      var s = typeof Symbol === 'function' && Symbol.iterator,
        m = s && o[s],
        i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === 'number')
        return {
          next: function () {
            if (o && i >= o.length) o = void 0;
            return {
              value: o && o[i++],
              done: !o,
            };
          },
        };
      throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    }
    function __read(o, n) {
      var m = typeof Symbol === 'function' && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o),
        r,
        ar = [],
        e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      } catch (error) {
        e = {
          error: error,
        };
      } finally {
        try {
          if (r && !r.done && (m = i['return'])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    }

    /** @deprecated */
    function __spread() {
      for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
      return ar;
    }

    /** @deprecated */
    function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
      return r;
    }
    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    }
    function __await(v) {
      return this instanceof __await ? ((this.v = v), this) : new __await(v);
    }
    function __asyncGenerator(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.');
      var g = generator.apply(thisArg, _arguments || []),
        i,
        q = [];
      return (
        (i = {}),
        verb('next'),
        verb('throw'),
        verb('return', awaitReturn),
        (i[Symbol.asyncIterator] = function () {
          return this;
        }),
        i
      );
      function awaitReturn(f) {
        return function (v) {
          return Promise.resolve(v).then(f, reject);
        };
      }
      function verb(n, f) {
        if (g[n]) {
          i[n] = function (v) {
            return new Promise(function (a, b) {
              q.push([n, v, a, b]) > 1 || resume(n, v);
            });
          };
          if (f) i[n] = f(i[n]);
        }
      }
      function resume(n, v) {
        try {
          step(g[n](v));
        } catch (e) {
          settle(q[0][3], e);
        }
      }
      function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
      }
      function fulfill(value) {
        resume('next', value);
      }
      function reject(value) {
        resume('throw', value);
      }
      function settle(f, v) {
        if ((f(v), q.shift(), q.length)) resume(q[0][0], q[0][1]);
      }
    }
    function __asyncDelegator(o) {
      var i, p;
      return (
        (i = {}),
        verb('next'),
        verb('throw', function (e) {
          throw e;
        }),
        verb('return'),
        (i[Symbol.iterator] = function () {
          return this;
        }),
        i
      );
      function verb(n, f) {
        i[n] = o[n]
          ? function (v) {
              return (p = !p)
                ? {
                    value: __await(o[n](v)),
                    done: false,
                  }
                : f
                  ? f(v)
                  : v;
            }
          : f;
      }
    }
    function __asyncValues(o) {
      if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.');
      var m = o[Symbol.asyncIterator],
        i;
      return m
        ? m.call(o)
        : ((o = typeof __values === 'function' ? __values(o) : o[Symbol.iterator]()),
          (i = {}),
          verb('next'),
          verb('throw'),
          verb('return'),
          (i[Symbol.asyncIterator] = function () {
            return this;
          }),
          i);
      function verb(n) {
        i[n] =
          o[n] &&
          function (v) {
            return new Promise(function (resolve, reject) {
              (v = o[n](v)), settle(resolve, reject, v.done, v.value);
            });
          };
      }
      function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function (v) {
          resolve({
            value: v,
            done: d,
          });
        }, reject);
      }
    }
    function __makeTemplateObject(cooked, raw) {
      if (Object.defineProperty) {
        Object.defineProperty(cooked, 'raw', {
          value: raw,
        });
      } else {
        cooked.raw = raw;
      }
      return cooked;
    }
    var __setModuleDefault = Object.create
      ? function (o, v) {
          Object.defineProperty(o, 'default', {
            enumerable: true,
            value: v,
          });
        }
      : function (o, v) {
          o['default'] = v;
        };
    function __importStar(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null)
        for (var k in mod)
          if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
      __setModuleDefault(result, mod);
      return result;
    }
    function __importDefault(mod) {
      return mod && mod.__esModule
        ? mod
        : {
            default: mod,
          };
    }
    function __classPrivateFieldGet(receiver, state, kind, f) {
      if (kind === 'a' && !f) throw new TypeError('Private accessor was defined without a getter');
      if (typeof state === 'function' ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError('Cannot read private member from an object whose class did not declare it');
      return kind === 'm' ? f : kind === 'a' ? f.call(receiver) : f ? f.value : state.get(receiver);
    }
    function __classPrivateFieldSet(receiver, state, value, kind, f) {
      if (kind === 'm') throw new TypeError('Private method is not writable');
      if (kind === 'a' && !f) throw new TypeError('Private accessor was defined without a setter');
      if (typeof state === 'function' ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError('Cannot write private member to an object whose class did not declare it');
      return kind === 'a' ? f.call(receiver, value) : f ? (f.value = value) : state.set(receiver, value), value;
    }
    function __classPrivateFieldIn(state, receiver) {
      if (receiver === null || (typeof receiver !== 'object' && typeof receiver !== 'function'))
        throw new TypeError("Cannot use 'in' operator on non-object");
      return typeof state === 'function' ? receiver === state : state.has(receiver);
    }
    function __addDisposableResource(env, value, async) {
      if (value !== null && value !== void 0) {
        if (typeof value !== 'object' && typeof value !== 'function') throw new TypeError('Object expected.');
        var dispose, inner;
        if (async) {
          if (!Symbol.asyncDispose) throw new TypeError('Symbol.asyncDispose is not defined.');
          dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
          if (!Symbol.dispose) throw new TypeError('Symbol.dispose is not defined.');
          dispose = value[Symbol.dispose];
          if (async) inner = dispose;
        }
        if (typeof dispose !== 'function') throw new TypeError('Object not disposable.');
        if (inner)
          dispose = function () {
            try {
              inner.call(this);
            } catch (e) {
              return Promise.reject(e);
            }
          };
        env.stack.push({
          value: value,
          dispose: dispose,
          async: async,
        });
      } else if (async) {
        env.stack.push({
          async: true,
        });
      }
      return value;
    }
    var _SuppressedError =
      typeof SuppressedError === 'function'
        ? SuppressedError
        : function (error, suppressed, message) {
            var e = new Error(message);
            return (e.name = 'SuppressedError'), (e.error = error), (e.suppressed = suppressed), e;
          };
    function __disposeResources(env) {
      function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, 'An error was suppressed during disposal.') : e;
        env.hasError = true;
      }
      function next() {
        while (env.stack.length) {
          var rec = env.stack.pop();
          try {
            var result = rec.dispose && rec.dispose.call(rec.value);
            if (rec.async)
              return Promise.resolve(result).then(next, function (e) {
                fail(e);
                return next();
              });
          } catch (e) {
            fail(e);
          }
        }
        if (env.hasError) throw env.error;
      }
      return next();
    }
    /* harmony default export */ const tslib_es6 = {
      __extends,
      __assign,
      __rest: tslib_es6_rest,
      __decorate,
      __param,
      __metadata,
      __awaiter,
      __generator,
      __createBinding,
      __exportStar,
      __values,
      __read,
      __spread,
      __spreadArrays,
      __spreadArray,
      __await,
      __asyncGenerator,
      __asyncDelegator,
      __asyncValues,
      __makeTemplateObject,
      __importStar,
      __importDefault,
      __classPrivateFieldGet,
      __classPrivateFieldSet,
      __classPrivateFieldIn,
      __addDisposableResource,
      __disposeResources,
    };
    // EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
    var hoist_non_react_statics_cjs = __webpack_require__(57160);
    var hoist_non_react_statics_cjs_default = /*#__PURE__*/ __webpack_require__.n(hoist_non_react_statics_cjs); // CONCATENATED MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
    /**
     * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
     * @param x number
     */
    function getMagnitude(x) {
      // Cannot count string length via Number.toString because it may use scientific notation
      // for very small or very large numbers.
      return Math.floor(Math.log(x) * Math.LOG10E);
    }
    function repeat(s, times) {
      if (typeof s.repeat === 'function') {
        return s.repeat(times);
      }
      var arr = new Array(times);
      for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
      }
      return arr.join('');
    }
    function setInternalSlot(map, pl, field, value) {
      if (!map.get(pl)) {
        map.set(pl, Object.create(null));
      }
      var slots = map.get(pl);
      slots[field] = value;
    }
    function setMultiInternalSlots(map, pl, props) {
      for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
      }
    }
    function getInternalSlot(map, pl, field) {
      return getMultiInternalSlots(map, pl, field)[field];
    }
    function getMultiInternalSlots(map, pl) {
      var fields = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
      }
      var slots = map.get(pl);
      if (!slots) {
        throw new TypeError(''.concat(pl, ' InternalSlot has not been initialized'));
      }
      return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
      }, Object.create(null));
    }
    function isLiteralPart(patternPart) {
      return patternPart.type === 'literal';
    }
    /*
			  17 ECMAScript Standard Built-in Objects:
				Every built-in Function object, including constructors, that is not
				identified as an anonymous function has a name property whose value
				is a String.
			
				Unless otherwise specified, the name property of a built-in Function
				object, if it exists, has the attributes { [[Writable]]: false,
				[[Enumerable]]: false, [[Configurable]]: true }.
			*/
    function defineProperty(target, name, _a) {
      var value = _a.value;
      Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
      });
    }
    /**
     * 7.3.5 CreateDataProperty
     * @param target
     * @param name
     * @param value
     */
    function createDataProperty(target, name, value) {
      Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value,
      });
    }
    var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
    function invariant(condition, message, Err) {
      if (Err === void 0) {
        Err = Error;
      }
      if (!condition) {
        throw new Err(message);
      }
    } // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
    var ErrorKind;
    (function (ErrorKind) {
      /** Argument is unclosed (e.g. `{0`) */
      ErrorKind[(ErrorKind['EXPECT_ARGUMENT_CLOSING_BRACE'] = 1)] = 'EXPECT_ARGUMENT_CLOSING_BRACE';
      /** Argument is empty (e.g. `{}`). */
      ErrorKind[(ErrorKind['EMPTY_ARGUMENT'] = 2)] = 'EMPTY_ARGUMENT';
      /** Argument is malformed (e.g. `{foo!}``) */
      ErrorKind[(ErrorKind['MALFORMED_ARGUMENT'] = 3)] = 'MALFORMED_ARGUMENT';
      /** Expect an argument type (e.g. `{foo,}`) */
      ErrorKind[(ErrorKind['EXPECT_ARGUMENT_TYPE'] = 4)] = 'EXPECT_ARGUMENT_TYPE';
      /** Unsupported argument type (e.g. `{foo,foo}`) */
      ErrorKind[(ErrorKind['INVALID_ARGUMENT_TYPE'] = 5)] = 'INVALID_ARGUMENT_TYPE';
      /** Expect an argument style (e.g. `{foo, number, }`) */
      ErrorKind[(ErrorKind['EXPECT_ARGUMENT_STYLE'] = 6)] = 'EXPECT_ARGUMENT_STYLE';
      /** The number skeleton is invalid. */
      ErrorKind[(ErrorKind['INVALID_NUMBER_SKELETON'] = 7)] = 'INVALID_NUMBER_SKELETON';
      /** The date time skeleton is invalid. */
      ErrorKind[(ErrorKind['INVALID_DATE_TIME_SKELETON'] = 8)] = 'INVALID_DATE_TIME_SKELETON';
      /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
      ErrorKind[(ErrorKind['EXPECT_NUMBER_SKELETON'] = 9)] = 'EXPECT_NUMBER_SKELETON';
      /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
      ErrorKind[(ErrorKind['EXPECT_DATE_TIME_SKELETON'] = 10)] = 'EXPECT_DATE_TIME_SKELETON';
      /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
      ErrorKind[(ErrorKind['UNCLOSED_QUOTE_IN_ARGUMENT_STYLE'] = 11)] = 'UNCLOSED_QUOTE_IN_ARGUMENT_STYLE';
      /** Missing select argument options (e.g. `{foo, select}`) */
      ErrorKind[(ErrorKind['EXPECT_SELECT_ARGUMENT_OPTIONS'] = 12)] = 'EXPECT_SELECT_ARGUMENT_OPTIONS';
      /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
      ErrorKind[(ErrorKind['EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE'] = 13)] = 'EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE';
      /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
      ErrorKind[(ErrorKind['INVALID_PLURAL_ARGUMENT_OFFSET_VALUE'] = 14)] = 'INVALID_PLURAL_ARGUMENT_OFFSET_VALUE';
      /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
      ErrorKind[(ErrorKind['EXPECT_SELECT_ARGUMENT_SELECTOR'] = 15)] = 'EXPECT_SELECT_ARGUMENT_SELECTOR';
      /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
      ErrorKind[(ErrorKind['EXPECT_PLURAL_ARGUMENT_SELECTOR'] = 16)] = 'EXPECT_PLURAL_ARGUMENT_SELECTOR';
      /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
      ErrorKind[(ErrorKind['EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT'] = 17)] =
        'EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT';
      /**
       * Expecting a message fragment after the `plural` or `selectordinal` selector
       * (e.g. `{foo, plural, one}`)
       */
      ErrorKind[(ErrorKind['EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT'] = 18)] =
        'EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT';
      /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
      ErrorKind[(ErrorKind['INVALID_PLURAL_ARGUMENT_SELECTOR'] = 19)] = 'INVALID_PLURAL_ARGUMENT_SELECTOR';
      /**
       * Duplicate selectors in `plural` or `selectordinal` argument.
       * (e.g. {foo, plural, one {#} one {#}})
       */
      ErrorKind[(ErrorKind['DUPLICATE_PLURAL_ARGUMENT_SELECTOR'] = 20)] = 'DUPLICATE_PLURAL_ARGUMENT_SELECTOR';
      /** Duplicate selectors in `select` argument.
       * (e.g. {foo, select, apple {apple} apple {apple}})
       */
      ErrorKind[(ErrorKind['DUPLICATE_SELECT_ARGUMENT_SELECTOR'] = 21)] = 'DUPLICATE_SELECT_ARGUMENT_SELECTOR';
      /** Plural or select argument option must have `other` clause. */
      ErrorKind[(ErrorKind['MISSING_OTHER_CLAUSE'] = 22)] = 'MISSING_OTHER_CLAUSE';
      /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
      ErrorKind[(ErrorKind['INVALID_TAG'] = 23)] = 'INVALID_TAG';
      /** The tag name is invalid. (e.g. `<123>foo</123>`) */
      ErrorKind[(ErrorKind['INVALID_TAG_NAME'] = 25)] = 'INVALID_TAG_NAME';
      /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
      ErrorKind[(ErrorKind['UNMATCHED_CLOSING_TAG'] = 26)] = 'UNMATCHED_CLOSING_TAG';
      /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
      ErrorKind[(ErrorKind['UNCLOSED_TAG'] = 27)] = 'UNCLOSED_TAG';
    })(ErrorKind || (ErrorKind = {})); // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
    var TYPE;
    (function (TYPE) {
      /**
       * Raw text
       */
      TYPE[(TYPE['literal'] = 0)] = 'literal';
      /**
       * Variable w/o any format, e.g `var` in `this is a {var}`
       */
      TYPE[(TYPE['argument'] = 1)] = 'argument';
      /**
       * Variable w/ number format
       */
      TYPE[(TYPE['number'] = 2)] = 'number';
      /**
       * Variable w/ date format
       */
      TYPE[(TYPE['date'] = 3)] = 'date';
      /**
       * Variable w/ time format
       */
      TYPE[(TYPE['time'] = 4)] = 'time';
      /**
       * Variable w/ select format
       */
      TYPE[(TYPE['select'] = 5)] = 'select';
      /**
       * Variable w/ plural format
       */
      TYPE[(TYPE['plural'] = 6)] = 'plural';
      /**
       * Only possible within plural argument.
       * This is the `#` symbol that will be substituted with the count.
       */
      TYPE[(TYPE['pound'] = 7)] = 'pound';
      /**
       * XML-like tag
       */
      TYPE[(TYPE['tag'] = 8)] = 'tag';
    })(TYPE || (TYPE = {}));
    var SKELETON_TYPE;
    (function (SKELETON_TYPE) {
      SKELETON_TYPE[(SKELETON_TYPE['number'] = 0)] = 'number';
      SKELETON_TYPE[(SKELETON_TYPE['dateTime'] = 1)] = 'dateTime';
    })(SKELETON_TYPE || (SKELETON_TYPE = {}));
    /**
     * Type Guards
     */
    function types_isLiteralElement(el) {
      return el.type === TYPE.literal;
    }
    function types_isArgumentElement(el) {
      return el.type === TYPE.argument;
    }
    function types_isNumberElement(el) {
      return el.type === TYPE.number;
    }
    function types_isDateElement(el) {
      return el.type === TYPE.date;
    }
    function types_isTimeElement(el) {
      return el.type === TYPE.time;
    }
    function types_isSelectElement(el) {
      return el.type === TYPE.select;
    }
    function types_isPluralElement(el) {
      return el.type === TYPE.plural;
    }
    function types_isPoundElement(el) {
      return el.type === TYPE.pound;
    }
    function types_isTagElement(el) {
      return el.type === TYPE.tag;
    }
    function types_isNumberSkeleton(el) {
      return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
    }
    function types_isDateTimeSkeleton(el) {
      return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
    }
    function createLiteralElement(value) {
      return {
        type: TYPE.literal,
        value: value,
      };
    }
    function createNumberElement(value, style) {
      return {
        type: TYPE.number,
        value: value,
        style: style,
      };
    } // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
    // @generated from regex-gen.ts
    var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
    var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/; // CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
    /**
     * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
     * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
     * with some tweaks
     */
    var DATE_TIME_REGEX =
      /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
    /**
     * Parse Date time skeleton into Intl.DateTimeFormatOptions
     * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
     * @public
     * @param skeleton skeleton string
     */
    function parseDateTimeSkeleton(skeleton) {
      var result = {};
      skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
          // Era
          case 'G':
            result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
            break;
          // Year
          case 'y':
            result.year = len === 2 ? '2-digit' : 'numeric';
            break;
          case 'Y':
          case 'u':
          case 'U':
          case 'r':
            throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
          // Quarter
          case 'q':
          case 'Q':
            throw new RangeError('`q/Q` (quarter) patterns are not supported');
          // Month
          case 'M':
          case 'L':
            result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
            break;
          // Week
          case 'w':
          case 'W':
            throw new RangeError('`w/W` (week) patterns are not supported');
          case 'd':
            result.day = ['numeric', '2-digit'][len - 1];
            break;
          case 'D':
          case 'F':
          case 'g':
            throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
          // Weekday
          case 'E':
            result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
            break;
          case 'e':
            if (len < 4) {
              throw new RangeError('`e..eee` (weekday) patterns are not supported');
            }
            result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
            break;
          case 'c':
            if (len < 4) {
              throw new RangeError('`c..ccc` (weekday) patterns are not supported');
            }
            result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
            break;
          // Period
          case 'a':
            // AM, PM
            result.hour12 = true;
            break;
          case 'b': // am, pm, noon, midnight
          case 'B':
            // flexible day periods
            throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
          // Hour
          case 'h':
            result.hourCycle = 'h12';
            result.hour = ['numeric', '2-digit'][len - 1];
            break;
          case 'H':
            result.hourCycle = 'h23';
            result.hour = ['numeric', '2-digit'][len - 1];
            break;
          case 'K':
            result.hourCycle = 'h11';
            result.hour = ['numeric', '2-digit'][len - 1];
            break;
          case 'k':
            result.hourCycle = 'h24';
            result.hour = ['numeric', '2-digit'][len - 1];
            break;
          case 'j':
          case 'J':
          case 'C':
            throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
          // Minute
          case 'm':
            result.minute = ['numeric', '2-digit'][len - 1];
            break;
          // Second
          case 's':
            result.second = ['numeric', '2-digit'][len - 1];
            break;
          case 'S':
          case 'A':
            throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
          // Zone
          case 'z':
            // 1..3, 4: specific non-location format
            result.timeZoneName = len < 4 ? 'short' : 'long';
            break;
          case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
          case 'O': // 1, 4: milliseconds in day short, long
          case 'v': // 1, 4: generic non-location format
          case 'V': // 1, 2, 3, 4: time zone ID or city
          case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
          case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
      });
      return result;
    } // CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
    // @generated from regex-gen.ts
    var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i; // CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js
    function parseNumberSkeletonFromString(skeleton) {
      if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
      }
      // Parse the skeleton
      var stringTokens = skeleton.split(regex_generated_WHITE_SPACE_REGEX).filter(function (x) {
        return x.length > 0;
      });
      var tokens = [];
      for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
          throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0],
          options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
          var option = options_1[_a];
          if (option.length === 0) {
            throw new Error('Invalid number skeleton');
          }
        }
        tokens.push({
          stem: stem,
          options: options,
        });
      }
      return tokens;
    }
    function icuUnitToEcma(unit) {
      return unit.replace(/^(.*?)-/, '');
    }
    var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
    var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
    var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
    var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
    function parseSignificantPrecision(str) {
      var result = {};
      if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
      } else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
      }
      str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
          result.minimumSignificantDigits = g1.length;
          result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
          result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
          result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
          result.minimumSignificantDigits = g1.length;
          result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
      });
      return result;
    }
    function parseSign(str) {
      switch (str) {
        case 'sign-auto':
          return {
            signDisplay: 'auto',
          };
        case 'sign-accounting':
        case '()':
          return {
            currencySign: 'accounting',
          };
        case 'sign-always':
        case '+!':
          return {
            signDisplay: 'always',
          };
        case 'sign-accounting-always':
        case '()!':
          return {
            signDisplay: 'always',
            currencySign: 'accounting',
          };
        case 'sign-except-zero':
        case '+?':
          return {
            signDisplay: 'exceptZero',
          };
        case 'sign-accounting-except-zero':
        case '()?':
          return {
            signDisplay: 'exceptZero',
            currencySign: 'accounting',
          };
        case 'sign-never':
        case '+_':
          return {
            signDisplay: 'never',
          };
      }
    }
    function parseConciseScientificAndEngineeringStem(stem) {
      // Engineering
      var result;
      if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
          notation: 'engineering',
        };
        stem = stem.slice(2);
      } else if (stem[0] === 'E') {
        result = {
          notation: 'scientific',
        };
        stem = stem.slice(1);
      }
      if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
          result.signDisplay = 'always';
          stem = stem.slice(2);
        } else if (signDisplay === '+?') {
          result.signDisplay = 'exceptZero';
          stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
          throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
      }
      return result;
    }
    function parseNotationOptions(opt) {
      var result = {};
      var signOpts = parseSign(opt);
      if (signOpts) {
        return signOpts;
      }
      return result;
    }
    /**
     * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
     */
    function parseNumberSkeleton(tokens) {
      var result = {};
      for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
          case 'percent':
          case '%':
            result.style = 'percent';
            continue;
          case '%x100':
            result.style = 'percent';
            result.scale = 100;
            continue;
          case 'currency':
            result.style = 'currency';
            result.currency = token.options[0];
            continue;
          case 'group-off':
          case ',_':
            result.useGrouping = false;
            continue;
          case 'precision-integer':
          case '.':
            result.maximumFractionDigits = 0;
            continue;
          case 'measure-unit':
          case 'unit':
            result.style = 'unit';
            result.unit = icuUnitToEcma(token.options[0]);
            continue;
          case 'compact-short':
          case 'K':
            result.notation = 'compact';
            result.compactDisplay = 'short';
            continue;
          case 'compact-long':
          case 'KK':
            result.notation = 'compact';
            result.compactDisplay = 'long';
            continue;
          case 'scientific':
            result = __assign(
              __assign(__assign({}, result), {
                notation: 'scientific',
              }),
              token.options.reduce(function (all, opt) {
                return __assign(__assign({}, all), parseNotationOptions(opt));
              }, {}),
            );
            continue;
          case 'engineering':
            result = __assign(
              __assign(__assign({}, result), {
                notation: 'engineering',
              }),
              token.options.reduce(function (all, opt) {
                return __assign(__assign({}, all), parseNotationOptions(opt));
              }, {}),
            );
            continue;
          case 'notation-simple':
            result.notation = 'standard';
            continue;
          // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
          case 'unit-width-narrow':
            result.currencyDisplay = 'narrowSymbol';
            result.unitDisplay = 'narrow';
            continue;
          case 'unit-width-short':
            result.currencyDisplay = 'code';
            result.unitDisplay = 'short';
            continue;
          case 'unit-width-full-name':
            result.currencyDisplay = 'name';
            result.unitDisplay = 'long';
            continue;
          case 'unit-width-iso-code':
            result.currencyDisplay = 'symbol';
            continue;
          case 'scale':
            result.scale = parseFloat(token.options[0]);
            continue;
          case 'rounding-mode-floor':
            result.roundingMode = 'floor';
            continue;
          case 'rounding-mode-ceiling':
            result.roundingMode = 'ceil';
            continue;
          case 'rounding-mode-down':
            result.roundingMode = 'trunc';
            continue;
          case 'rounding-mode-up':
            result.roundingMode = 'expand';
            continue;
          case 'rounding-mode-half-even':
            result.roundingMode = 'halfEven';
            continue;
          case 'rounding-mode-half-down':
            result.roundingMode = 'halfTrunc';
            continue;
          case 'rounding-mode-half-up':
            result.roundingMode = 'halfExpand';
            continue;
          // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
          case 'integer-width':
            if (token.options.length > 1) {
              throw new RangeError('integer-width stems only accept a single optional option');
            }
            token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
              if (g1) {
                result.minimumIntegerDigits = g2.length;
              } else if (g3 && g4) {
                throw new Error('We currently do not support maximum integer digits');
              } else if (g5) {
                throw new Error('We currently do not support exact integer digits');
              }
              return '';
            });
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
          result.minimumIntegerDigits = token.stem.length;
          continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
          // Precision
          // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
          // precision-integer case
          if (token.options.length > 1) {
            throw new RangeError('Fraction-precision stems only accept a single optional option');
          }
          token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
            // .000* case (before ICU67 it was .000+)
            if (g2 === '*') {
              result.minimumFractionDigits = g1.length;
            }
            // .### case
            else if (g3 && g3[0] === '#') {
              result.maximumFractionDigits = g3.length;
            }
            // .00## case
            else if (g4 && g5) {
              result.minimumFractionDigits = g4.length;
              result.maximumFractionDigits = g4.length + g5.length;
            } else {
              result.minimumFractionDigits = g1.length;
              result.maximumFractionDigits = g1.length;
            }
            return '';
          });
          var opt = token.options[0];
          // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
          if (opt === 'w') {
            result = __assign(__assign({}, result), {
              trailingZeroDisplay: 'stripIfInteger',
            });
          } else if (opt) {
            result = __assign(__assign({}, result), parseSignificantPrecision(opt));
          }
          continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
          result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
          continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
          result = __assign(__assign({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
          result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
        }
      }
      return result;
    } // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
    // @generated from time-data-gen.ts
    // prettier-ignore
    var timeData = {
			"001": ["H", "h"],
			"AC": ["H", "h", "hb", "hB"],
			"AD": ["H", "hB"],
			"AE": ["h", "hB", "hb", "H"],
			"AF": ["H", "hb", "hB", "h"],
			"AG": ["h", "hb", "H", "hB"],
			"AI": ["H", "h", "hb", "hB"],
			"AL": ["h", "H", "hB"],
			"AM": ["H", "hB"],
			"AO": ["H", "hB"],
			"AR": ["H", "h", "hB", "hb"],
			"AS": ["h", "H"],
			"AT": ["H", "hB"],
			"AU": ["h", "hb", "H", "hB"],
			"AW": ["H", "hB"],
			"AX": ["H"],
			"AZ": ["H", "hB", "h"],
			"BA": ["H", "hB", "h"],
			"BB": ["h", "hb", "H", "hB"],
			"BD": ["h", "hB", "H"],
			"BE": ["H", "hB"],
			"BF": ["H", "hB"],
			"BG": ["H", "hB", "h"],
			"BH": ["h", "hB", "hb", "H"],
			"BI": ["H", "h"],
			"BJ": ["H", "hB"],
			"BL": ["H", "hB"],
			"BM": ["h", "hb", "H", "hB"],
			"BN": ["hb", "hB", "h", "H"],
			"BO": ["H", "hB", "h", "hb"],
			"BQ": ["H"],
			"BR": ["H", "hB"],
			"BS": ["h", "hb", "H", "hB"],
			"BT": ["h", "H"],
			"BW": ["H", "h", "hb", "hB"],
			"BY": ["H", "h"],
			"BZ": ["H", "h", "hb", "hB"],
			"CA": ["h", "hb", "H", "hB"],
			"CC": ["H", "h", "hb", "hB"],
			"CD": ["hB", "H"],
			"CF": ["H", "h", "hB"],
			"CG": ["H", "hB"],
			"CH": ["H", "hB", "h"],
			"CI": ["H", "hB"],
			"CK": ["H", "h", "hb", "hB"],
			"CL": ["H", "h", "hB", "hb"],
			"CM": ["H", "h", "hB"],
			"CN": ["H", "hB", "hb", "h"],
			"CO": ["h", "H", "hB", "hb"],
			"CP": ["H"],
			"CR": ["H", "h", "hB", "hb"],
			"CU": ["H", "h", "hB", "hb"],
			"CV": ["H", "hB"],
			"CW": ["H", "hB"],
			"CX": ["H", "h", "hb", "hB"],
			"CY": ["h", "H", "hb", "hB"],
			"CZ": ["H"],
			"DE": ["H", "hB"],
			"DG": ["H", "h", "hb", "hB"],
			"DJ": ["h", "H"],
			"DK": ["H"],
			"DM": ["h", "hb", "H", "hB"],
			"DO": ["h", "H", "hB", "hb"],
			"DZ": ["h", "hB", "hb", "H"],
			"EA": ["H", "h", "hB", "hb"],
			"EC": ["H", "hB", "h", "hb"],
			"EE": ["H", "hB"],
			"EG": ["h", "hB", "hb", "H"],
			"EH": ["h", "hB", "hb", "H"],
			"ER": ["h", "H"],
			"ES": ["H", "hB", "h", "hb"],
			"ET": ["hB", "hb", "h", "H"],
			"FI": ["H"],
			"FJ": ["h", "hb", "H", "hB"],
			"FK": ["H", "h", "hb", "hB"],
			"FM": ["h", "hb", "H", "hB"],
			"FO": ["H", "h"],
			"FR": ["H", "hB"],
			"GA": ["H", "hB"],
			"GB": ["H", "h", "hb", "hB"],
			"GD": ["h", "hb", "H", "hB"],
			"GE": ["H", "hB", "h"],
			"GF": ["H", "hB"],
			"GG": ["H", "h", "hb", "hB"],
			"GH": ["h", "H"],
			"GI": ["H", "h", "hb", "hB"],
			"GL": ["H", "h"],
			"GM": ["h", "hb", "H", "hB"],
			"GN": ["H", "hB"],
			"GP": ["H", "hB"],
			"GQ": ["H", "hB", "h", "hb"],
			"GR": ["h", "H", "hb", "hB"],
			"GT": ["H", "h", "hB", "hb"],
			"GU": ["h", "hb", "H", "hB"],
			"GW": ["H", "hB"],
			"GY": ["h", "hb", "H", "hB"],
			"HK": ["h", "hB", "hb", "H"],
			"HN": ["H", "h", "hB", "hb"],
			"HR": ["H", "hB"],
			"HU": ["H", "h"],
			"IC": ["H", "h", "hB", "hb"],
			"ID": ["H"],
			"IE": ["H", "h", "hb", "hB"],
			"IL": ["H", "hB"],
			"IM": ["H", "h", "hb", "hB"],
			"IN": ["h", "H"],
			"IO": ["H", "h", "hb", "hB"],
			"IQ": ["h", "hB", "hb", "H"],
			"IR": ["hB", "H"],
			"IS": ["H"],
			"IT": ["H", "hB"],
			"JE": ["H", "h", "hb", "hB"],
			"JM": ["h", "hb", "H", "hB"],
			"JO": ["h", "hB", "hb", "H"],
			"JP": ["H", "K", "h"],
			"KE": ["hB", "hb", "H", "h"],
			"KG": ["H", "h", "hB", "hb"],
			"KH": ["hB", "h", "H", "hb"],
			"KI": ["h", "hb", "H", "hB"],
			"KM": ["H", "h", "hB", "hb"],
			"KN": ["h", "hb", "H", "hB"],
			"KP": ["h", "H", "hB", "hb"],
			"KR": ["h", "H", "hB", "hb"],
			"KW": ["h", "hB", "hb", "H"],
			"KY": ["h", "hb", "H", "hB"],
			"KZ": ["H", "hB"],
			"LA": ["H", "hb", "hB", "h"],
			"LB": ["h", "hB", "hb", "H"],
			"LC": ["h", "hb", "H", "hB"],
			"LI": ["H", "hB", "h"],
			"LK": ["H", "h", "hB", "hb"],
			"LR": ["h", "hb", "H", "hB"],
			"LS": ["h", "H"],
			"LT": ["H", "h", "hb", "hB"],
			"LU": ["H", "h", "hB"],
			"LV": ["H", "hB", "hb", "h"],
			"LY": ["h", "hB", "hb", "H"],
			"MA": ["H", "h", "hB", "hb"],
			"MC": ["H", "hB"],
			"MD": ["H", "hB"],
			"ME": ["H", "hB", "h"],
			"MF": ["H", "hB"],
			"MG": ["H", "h"],
			"MH": ["h", "hb", "H", "hB"],
			"MK": ["H", "h", "hb", "hB"],
			"ML": ["H"],
			"MM": ["hB", "hb", "H", "h"],
			"MN": ["H", "h", "hb", "hB"],
			"MO": ["h", "hB", "hb", "H"],
			"MP": ["h", "hb", "H", "hB"],
			"MQ": ["H", "hB"],
			"MR": ["h", "hB", "hb", "H"],
			"MS": ["H", "h", "hb", "hB"],
			"MT": ["H", "h"],
			"MU": ["H", "h"],
			"MV": ["H", "h"],
			"MW": ["h", "hb", "H", "hB"],
			"MX": ["H", "h", "hB", "hb"],
			"MY": ["hb", "hB", "h", "H"],
			"MZ": ["H", "hB"],
			"NA": ["h", "H", "hB", "hb"],
			"NC": ["H", "hB"],
			"NE": ["H"],
			"NF": ["H", "h", "hb", "hB"],
			"NG": ["H", "h", "hb", "hB"],
			"NI": ["H", "h", "hB", "hb"],
			"NL": ["H", "hB"],
			"NO": ["H", "h"],
			"NP": ["H", "h", "hB"],
			"NR": ["H", "h", "hb", "hB"],
			"NU": ["H", "h", "hb", "hB"],
			"NZ": ["h", "hb", "H", "hB"],
			"OM": ["h", "hB", "hb", "H"],
			"PA": ["h", "H", "hB", "hb"],
			"PE": ["H", "hB", "h", "hb"],
			"PF": ["H", "h", "hB"],
			"PG": ["h", "H"],
			"PH": ["h", "hB", "hb", "H"],
			"PK": ["h", "hB", "H"],
			"PL": ["H", "h"],
			"PM": ["H", "hB"],
			"PN": ["H", "h", "hb", "hB"],
			"PR": ["h", "H", "hB", "hb"],
			"PS": ["h", "hB", "hb", "H"],
			"PT": ["H", "hB"],
			"PW": ["h", "H"],
			"PY": ["H", "h", "hB", "hb"],
			"QA": ["h", "hB", "hb", "H"],
			"RE": ["H", "hB"],
			"RO": ["H", "hB"],
			"RS": ["H", "hB", "h"],
			"RU": ["H"],
			"RW": ["H", "h"],
			"SA": ["h", "hB", "hb", "H"],
			"SB": ["h", "hb", "H", "hB"],
			"SC": ["H", "h", "hB"],
			"SD": ["h", "hB", "hb", "H"],
			"SE": ["H"],
			"SG": ["h", "hb", "H", "hB"],
			"SH": ["H", "h", "hb", "hB"],
			"SI": ["H", "hB"],
			"SJ": ["H"],
			"SK": ["H"],
			"SL": ["h", "hb", "H", "hB"],
			"SM": ["H", "h", "hB"],
			"SN": ["H", "h", "hB"],
			"SO": ["h", "H"],
			"SR": ["H", "hB"],
			"SS": ["h", "hb", "H", "hB"],
			"ST": ["H", "hB"],
			"SV": ["H", "h", "hB", "hb"],
			"SX": ["H", "h", "hb", "hB"],
			"SY": ["h", "hB", "hb", "H"],
			"SZ": ["h", "hb", "H", "hB"],
			"TA": ["H", "h", "hb", "hB"],
			"TC": ["h", "hb", "H", "hB"],
			"TD": ["h", "H", "hB"],
			"TF": ["H", "h", "hB"],
			"TG": ["H", "hB"],
			"TH": ["H", "h"],
			"TJ": ["H", "h"],
			"TL": ["H", "hB", "hb", "h"],
			"TM": ["H", "h"],
			"TN": ["h", "hB", "hb", "H"],
			"TO": ["h", "H"],
			"TR": ["H", "hB"],
			"TT": ["h", "hb", "H", "hB"],
			"TW": ["hB", "hb", "h", "H"],
			"TZ": ["hB", "hb", "H", "h"],
			"UA": ["H", "hB", "h"],
			"UG": ["hB", "hb", "H", "h"],
			"UM": ["h", "hb", "H", "hB"],
			"US": ["h", "hb", "H", "hB"],
			"UY": ["H", "h", "hB", "hb"],
			"UZ": ["H", "hB", "h"],
			"VA": ["H", "h", "hB"],
			"VC": ["h", "hb", "H", "hB"],
			"VE": ["h", "H", "hB", "hb"],
			"VG": ["h", "hb", "H", "hB"],
			"VI": ["h", "hb", "H", "hB"],
			"VN": ["H", "h"],
			"VU": ["h", "H"],
			"WF": ["H", "hB"],
			"WS": ["h", "H"],
			"XK": ["H", "hB", "h"],
			"YE": ["h", "hB", "hb", "H"],
			"YT": ["H", "hB"],
			"ZA": ["H", "h", "hb", "hB"],
			"ZM": ["h", "hb", "H", "hB"],
			"ZW": ["H", "h"],
			"af-ZA": ["H", "h", "hB", "hb"],
			"ar-001": ["h", "hB", "hb", "H"],
			"ca-ES": ["H", "h", "hB"],
			"en-001": ["h", "hb", "H", "hB"],
			"es-BO": ["H", "h", "hB", "hb"],
			"es-BR": ["H", "h", "hB", "hb"],
			"es-EC": ["H", "h", "hB", "hb"],
			"es-ES": ["H", "h", "hB", "hb"],
			"es-GQ": ["H", "h", "hB", "hb"],
			"es-PE": ["H", "h", "hB", "hb"],
			"fr-CA": ["H", "h", "hB"],
			"gl-ES": ["H", "h", "hB"],
			"gu-IN": ["hB", "hb", "h", "H"],
			"hi-IN": ["hB", "h", "H"],
			"it-CH": ["H", "h", "hB"],
			"it-IT": ["H", "h", "hB"],
			"kn-IN": ["hB", "h", "H"],
			"ml-IN": ["hB", "h", "H"],
			"mr-IN": ["hB", "hb", "h", "H"],
			"pa-IN": ["hB", "hb", "h", "H"],
			"ta-IN": ["hB", "h", "hb", "H"],
			"te-IN": ["hB", "h", "H"],
			"zu-ZA": ["H", "hB", "hb", "h"]
		}; // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js
    /**
     * Returns the best matching date time pattern if a date time skeleton
     * pattern is provided with a locale. Follows the Unicode specification:
     * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
     * @param skeleton date time skeleton pattern that possibly includes j, J or C
     * @param locale
     */
    function getBestPattern(skeleton, locale) {
      var skeletonCopy = '';
      for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
          var extraLength = 0;
          while (patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar) {
            extraLength++;
            patternPos++;
          }
          var hourLen = 1 + (extraLength & 1);
          var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
          var dayPeriodChar = 'a';
          var hourChar = getDefaultHourSymbolFromLocale(locale);
          if (hourChar == 'H' || hourChar == 'k') {
            dayPeriodLen = 0;
          }
          while (dayPeriodLen-- > 0) {
            skeletonCopy += dayPeriodChar;
          }
          while (hourLen-- > 0) {
            skeletonCopy = hourChar + skeletonCopy;
          }
        } else if (patternChar === 'J') {
          skeletonCopy += 'H';
        } else {
          skeletonCopy += patternChar;
        }
      }
      return skeletonCopy;
    }
    /**
     * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
     * of the given `locale` to the corresponding time pattern.
     * @param locale
     */
    function getDefaultHourSymbolFromLocale(locale) {
      var hourCycle = locale.hourCycle;
      if (
        hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length
      ) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
      }
      if (hourCycle) {
        switch (hourCycle) {
          case 'h24':
            return 'k';
          case 'h23':
            return 'H';
          case 'h12':
            return 'h';
          case 'h11':
            return 'K';
          default:
            throw new Error('Invalid hourCycle');
        }
      }
      // TODO: Once hourCycle is fully supported remove the following with data generation
      var languageTag = locale.language;
      var regionTag;
      if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
      }
      var hourCycles =
        timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData[''.concat(languageTag, '-001')] ||
        timeData['001'];
      return hourCycles[0];
    } // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
    var _a;

    var SPACE_SEPARATOR_START_REGEX = new RegExp('^'.concat(SPACE_SEPARATOR_REGEX.source, '*'));
    var SPACE_SEPARATOR_END_REGEX = new RegExp(''.concat(SPACE_SEPARATOR_REGEX.source, '*$'));
    function createLocation(start, end) {
      return {
        start: start,
        end: end,
      };
    }
    // #region Ponyfills
    // Consolidate these variables up top for easier toggling during debugging
    var hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
    var hasNativeFromCodePoint = !!String.fromCodePoint;
    var hasNativeFromEntries = !!Object.fromEntries;
    var hasNativeCodePointAt = !!String.prototype.codePointAt;
    var hasTrimStart = !!String.prototype.trimStart;
    var hasTrimEnd = !!String.prototype.trimEnd;
    var hasNativeIsSafeInteger = !!Number.isSafeInteger;
    var isSafeInteger = hasNativeIsSafeInteger
      ? Number.isSafeInteger
      : function (n) {
          return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
        };
    // IE11 does not support y and u.
    var REGEX_SUPPORTS_U_AND_Y = true;
    try {
      var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
      /**
       * legacy Edge or Xbox One browser
       * Unicode flag support: supported
       * Pattern_Syntax support: not supported
       * See https://github.com/formatjs/formatjs/issues/2822
       */
      REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
    } catch (_) {
      REGEX_SUPPORTS_U_AND_Y = false;
    }
    var startsWith = hasNativeStartsWith
      ? // Native
        function startsWith(s, search, position) {
          return s.startsWith(search, position);
        }
      : // For IE11
        function startsWith(s, search, position) {
          return s.slice(position, position + search.length) === search;
        };
    var fromCodePoint = hasNativeFromCodePoint
      ? String.fromCodePoint
      : // IE11
        function fromCodePoint() {
          var codePoints = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
          }
          var elements = '';
          var length = codePoints.length;
          var i = 0;
          var code;
          while (length > i) {
            code = codePoints[i++];
            if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
            elements +=
              code < 0x10000
                ? String.fromCharCode(code)
                : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
          }
          return elements;
        };
    var fromEntries =
      // native
      hasNativeFromEntries
        ? Object.fromEntries
        : // Ponyfill
          function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
              var _a = entries_1[_i],
                k = _a[0],
                v = _a[1];
              obj[k] = v;
            }
            return obj;
          };
    var codePointAt = hasNativeCodePointAt
      ? // Native
        function codePointAt(s, index) {
          return s.codePointAt(index);
        }
      : // IE 11
        function codePointAt(s, index) {
          var size = s.length;
          if (index < 0 || index >= size) {
            return undefined;
          }
          var first = s.charCodeAt(index);
          var second;
          return first < 0xd800 ||
            first > 0xdbff ||
            index + 1 === size ||
            (second = s.charCodeAt(index + 1)) < 0xdc00 ||
            second > 0xdfff
            ? first
            : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
    var trimStart = hasTrimStart
      ? // Native
        function trimStart(s) {
          return s.trimStart();
        }
      : // Ponyfill
        function trimStart(s) {
          return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
    var trimEnd = hasTrimEnd
      ? // Native
        function trimEnd(s) {
          return s.trimEnd();
        }
      : // Ponyfill
        function trimEnd(s) {
          return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
    // Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
    function RE(s, flag) {
      return new RegExp(s, flag);
    }
    // #endregion
    var matchIdentifierAtIndex;
    if (REGEX_SUPPORTS_U_AND_Y) {
      // Native
      var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
      matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
      };
    } else {
      // IE11
      matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
          var c = codePointAt(s, index);
          if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
            break;
          }
          match.push(c);
          index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
      };
    }
    var parser_Parser = /** @class */ (function () {
      function Parser(message, options) {
        if (options === void 0) {
          options = {};
        }
        this.message = message;
        this.position = {
          offset: 0,
          line: 1,
          column: 1,
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
      }
      Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
          throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
      };
      Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
          var char = this.char();
          if (char === 123 /* `{` */) {
            var result = this.parseArgument(nestingLevel, expectingCloseTag);
            if (result.err) {
              return result;
            }
            elements.push(result.val);
          } else if (char === 125 /* `}` */ && nestingLevel > 0) {
            break;
          } else if (char === 35 /* `#` */ && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
            var position = this.clonePosition();
            this.bump();
            elements.push({
              type: TYPE.pound,
              location: createLocation(position, this.clonePosition()),
            });
          } else if (
            char === 60 /* `<` */ &&
            !this.ignoreTag &&
            this.peek() === 47 // char code for '/'
          ) {
            if (expectingCloseTag) {
              break;
            } else {
              return this.error(
                ErrorKind.UNMATCHED_CLOSING_TAG,
                createLocation(this.clonePosition(), this.clonePosition()),
              );
            }
          } else if (char === 60 /* `<` */ && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
            var result = this.parseTag(nestingLevel, parentArgType);
            if (result.err) {
              return result;
            }
            elements.push(result.val);
          } else {
            var result = this.parseLiteral(nestingLevel, parentArgType);
            if (result.err) {
              return result;
            }
            elements.push(result.val);
          }
        }
        return {
          val: elements,
          err: null,
        };
      };
      /**
       * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
       * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
       * are accepted:
       *
       * ```
       * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
       * tagName ::= [a-z] (PENChar)*
       * PENChar ::=
       *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
       *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
       *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
       * ```
       *
       * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
       * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
       * since other tag-based engines like React allow it
       */
      Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
          // Self closing tag
          return {
            val: {
              type: TYPE.literal,
              value: '<'.concat(tagName, '/>'),
              location: createLocation(startPosition, this.clonePosition()),
            },
            err: null,
          };
        } else if (this.bumpIf('>')) {
          var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
          if (childrenResult.err) {
            return childrenResult;
          }
          var children = childrenResult.val;
          // Expecting a close tag
          var endTagStartPosition = this.clonePosition();
          if (this.bumpIf('</')) {
            if (this.isEOF() || !_isAlpha(this.char())) {
              return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
            }
            var closingTagNameStartPosition = this.clonePosition();
            var closingTagName = this.parseTagName();
            if (tagName !== closingTagName) {
              return this.error(
                ErrorKind.UNMATCHED_CLOSING_TAG,
                createLocation(closingTagNameStartPosition, this.clonePosition()),
              );
            }
            this.bumpSpace();
            if (!this.bumpIf('>')) {
              return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
            }
            return {
              val: {
                type: TYPE.tag,
                value: tagName,
                children: children,
                location: createLocation(startPosition, this.clonePosition()),
              },
              err: null,
            };
          } else {
            return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
          }
        } else {
          return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
      };
      /**
       * This method assumes that the caller has peeked ahead for the first tag character.
       */
      Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
          this.bump();
        }
        return this.message.slice(startOffset, this.offset());
      };
      Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
          var parseQuoteResult = this.tryParseQuote(parentArgType);
          if (parseQuoteResult) {
            value += parseQuoteResult;
            continue;
          }
          var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
          if (parseUnquotedResult) {
            value += parseUnquotedResult;
            continue;
          }
          var parseLeftAngleResult = this.tryParseLeftAngleBracket();
          if (parseLeftAngleResult) {
            value += parseLeftAngleResult;
            continue;
          }
          break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
          val: {
            type: TYPE.literal,
            value: value,
            location: location,
          },
          err: null,
        };
      };
      Parser.prototype.tryParseLeftAngleBracket = function () {
        if (
          !this.isEOF() &&
          this.char() === 60 /* `<` */ &&
          (this.ignoreTag ||
            // If at the opening tag or closing tag position, bail.
            !_isAlphaOrSlash(this.peek() || 0))
        ) {
          this.bump(); // `<`
          return '<';
        }
        return null;
      };
      /**
       * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
       * a character that requires quoting (that is, "only where needed"), and works the same in
       * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
       */
      Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
          return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
          case 39 /* `'` */:
            // double quote, should return as a single quote.
            this.bump();
            this.bump();
            return "'";
          // '{', '<', '>', '}'
          case 123:
          case 60:
          case 62:
          case 125:
            break;
          case 35:
            // '#'
            if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
              break;
            }
            return null;
          default:
            return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
          var ch = this.char();
          if (ch === 39 /* `'` */) {
            if (this.peek() === 39 /* `'` */) {
              codePoints.push(39);
              // Bump one more time because we need to skip 2 characters.
              this.bump();
            } else {
              // Optional closing apostrophe.
              this.bump();
              break;
            }
          } else {
            codePoints.push(ch);
          }
          this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
      };
      Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
          return null;
        }
        var ch = this.char();
        if (
          ch === 60 /* `<` */ ||
          ch === 123 /* `{` */ ||
          (ch === 35 /* `#` */ && (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
          (ch === 125 /* `}` */ && nestingLevel > 0)
        ) {
          return null;
        } else {
          this.bump();
          return fromCodePoint(ch);
        }
      };
      Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
          return this.error(
            ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE,
            createLocation(openingBracePosition, this.clonePosition()),
          );
        }
        if (this.char() === 125 /* `}` */) {
          this.bump();
          return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
          return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
          return this.error(
            ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE,
            createLocation(openingBracePosition, this.clonePosition()),
          );
        }
        switch (this.char()) {
          // Simple argument: `{name}`
          case 125 /* `}` */: {
            this.bump(); // `}`
            return {
              val: {
                type: TYPE.argument,
                // value does not include the opening and closing braces.
                value: value,
                location: createLocation(openingBracePosition, this.clonePosition()),
              },
              err: null,
            };
          }
          // Argument with options: `{name, format, ...}`
          case 44 /* `,` */: {
            this.bump(); // `,`
            this.bumpSpace();
            if (this.isEOF()) {
              return this.error(
                ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE,
                createLocation(openingBracePosition, this.clonePosition()),
              );
            }
            return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
          }
          default:
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
      };
      /**
       * Advance the parser until the end of the identifier, if it is currently on
       * an identifier character. Return an empty string otherwise.
       */
      Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return {
          value: value,
          location: location,
        };
      };
      Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
          case '':
            // Expecting a style string number, date, time, plural, selectordinal, or select.
            return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
          case 'number':
          case 'date':
          case 'time': {
            // Parse this range:
            // {name, number, style}
            //              ^-------^
            this.bumpSpace();
            var styleAndLocation = null;
            if (this.bumpIf(',')) {
              this.bumpSpace();
              var styleStartPosition = this.clonePosition();
              var result = this.parseSimpleArgStyleIfPossible();
              if (result.err) {
                return result;
              }
              var style = trimEnd(result.val);
              if (style.length === 0) {
                return this.error(
                  ErrorKind.EXPECT_ARGUMENT_STYLE,
                  createLocation(this.clonePosition(), this.clonePosition()),
                );
              }
              var styleLocation = createLocation(styleStartPosition, this.clonePosition());
              styleAndLocation = {
                style: style,
                styleLocation: styleLocation,
              };
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
              return argCloseResult;
            }
            var location_1 = createLocation(openingBracePosition, this.clonePosition());
            // Extract style or skeleton
            if (
              styleAndLocation &&
              startsWith(
                styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style,
                '::',
                0,
              )
            ) {
              // Skeleton starts with `::`.
              var skeleton = trimStart(styleAndLocation.style.slice(2));
              if (argType === 'number') {
                var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                if (result.err) {
                  return result;
                }
                return {
                  val: {
                    type: TYPE.number,
                    value: value,
                    location: location_1,
                    style: result.val,
                  },
                  err: null,
                };
              } else {
                if (skeleton.length === 0) {
                  return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                }
                var dateTimePattern = skeleton;
                // Get "best match" pattern only if locale is passed, if not, let it
                // pass as-is where `parseDateTimeSkeleton()` will throw an error
                // for unsupported patterns.
                if (this.locale) {
                  dateTimePattern = getBestPattern(skeleton, this.locale);
                }
                var style = {
                  type: SKELETON_TYPE.dateTime,
                  pattern: dateTimePattern,
                  location: styleAndLocation.styleLocation,
                  parsedOptions: this.shouldParseSkeletons ? parseDateTimeSkeleton(dateTimePattern) : {},
                };
                var type = argType === 'date' ? TYPE.date : TYPE.time;
                return {
                  val: {
                    type: type,
                    value: value,
                    location: location_1,
                    style: style,
                  },
                  err: null,
                };
              }
            }
            // Regular style or no style.
            return {
              val: {
                type: argType === 'number' ? TYPE.number : argType === 'date' ? TYPE.date : TYPE.time,
                value: value,
                location: location_1,
                style:
                  (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !==
                    null && _a !== void 0
                    ? _a
                    : null,
              },
              err: null,
            };
          }
          case 'plural':
          case 'selectordinal':
          case 'select': {
            // Parse this range:
            // {name, plural, options}
            //              ^---------^
            var typeEndPosition_1 = this.clonePosition();
            this.bumpSpace();
            if (!this.bumpIf(',')) {
              return this.error(
                ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS,
                createLocation(typeEndPosition_1, __assign({}, typeEndPosition_1)),
              );
            }
            this.bumpSpace();
            // Parse offset:
            // {name, plural, offset:1, options}
            //                ^-----^
            //
            // or the first option:
            //
            // {name, plural, one {...} other {...}}
            //                ^--^
            var identifierAndLocation = this.parseIdentifierIfPossible();
            var pluralOffset = 0;
            if (argType !== 'select' && identifierAndLocation.value === 'offset') {
              if (!this.bumpIf(':')) {
                return this.error(
                  ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE,
                  createLocation(this.clonePosition(), this.clonePosition()),
                );
              }
              this.bumpSpace();
              var result = this.tryParseDecimalInteger(
                ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE,
                ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE,
              );
              if (result.err) {
                return result;
              }
              // Parse another identifier for option parsing
              this.bumpSpace();
              identifierAndLocation = this.parseIdentifierIfPossible();
              pluralOffset = result.val;
            }
            var optionsResult = this.tryParsePluralOrSelectOptions(
              nestingLevel,
              argType,
              expectingCloseTag,
              identifierAndLocation,
            );
            if (optionsResult.err) {
              return optionsResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
              return argCloseResult;
            }
            var location_2 = createLocation(openingBracePosition, this.clonePosition());
            if (argType === 'select') {
              return {
                val: {
                  type: TYPE.select,
                  value: value,
                  options: fromEntries(optionsResult.val),
                  location: location_2,
                },
                err: null,
              };
            } else {
              return {
                val: {
                  type: TYPE.plural,
                  value: value,
                  options: fromEntries(optionsResult.val),
                  offset: pluralOffset,
                  pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                  location: location_2,
                },
                err: null,
              };
            }
          }
          default:
            return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
      };
      Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
          return this.error(
            ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE,
            createLocation(openingBracePosition, this.clonePosition()),
          );
        }
        this.bump(); // `}`
        return {
          val: true,
          err: null,
        };
      };
      /**
       * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
       */
      Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
          var ch = this.char();
          switch (ch) {
            case 39 /* `'` */: {
              // Treat apostrophe as quoting but include it in the style part.
              // Find the end of the quoted literal text.
              this.bump();
              var apostrophePosition = this.clonePosition();
              if (!this.bumpUntil("'")) {
                return this.error(
                  ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE,
                  createLocation(apostrophePosition, this.clonePosition()),
                );
              }
              this.bump();
              break;
            }
            case 123 /* `{` */: {
              nestedBraces += 1;
              this.bump();
              break;
            }
            case 125 /* `}` */: {
              if (nestedBraces > 0) {
                nestedBraces -= 1;
              } else {
                return {
                  val: this.message.slice(startPosition.offset, this.offset()),
                  err: null,
                };
              }
              break;
            }
            default:
              this.bump();
              break;
          }
        }
        return {
          val: this.message.slice(startPosition.offset, this.offset()),
          err: null,
        };
      };
      Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
          tokens = parseNumberSkeletonFromString(skeleton);
        } catch (e) {
          return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
          val: {
            type: SKELETON_TYPE.number,
            tokens: tokens,
            location: location,
            parsedOptions: this.shouldParseSkeletons ? parseNumberSkeleton(tokens) : {},
          },
          err: null,
        };
      };
      /**
       * @param nesting_level The current nesting level of messages.
       *     This can be positive when parsing message fragment in select or plural argument options.
       * @param parent_arg_type The parent argument's type.
       * @param parsed_first_identifier If provided, this is the first identifier-like selector of
       *     the argument. It is a by-product of a previous parsing attempt.
       * @param expecting_close_tag If true, this message is directly or indirectly nested inside
       *     between a pair of opening and closing tags. The nested message will not parse beyond
       *     the closing tag boundary.
       */
      Parser.prototype.tryParsePluralOrSelectOptions = function (
        nestingLevel,
        parentArgType,
        expectCloseTag,
        parsedFirstIdentifier,
      ) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value,
          selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
          if (selector.length === 0) {
            var startPosition = this.clonePosition();
            if (parentArgType !== 'select' && this.bumpIf('=')) {
              // Try parse `={number}` selector
              var result = this.tryParseDecimalInteger(
                ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR,
                ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR,
              );
              if (result.err) {
                return result;
              }
              selectorLocation = createLocation(startPosition, this.clonePosition());
              selector = this.message.slice(startPosition.offset, this.offset());
            } else {
              break;
            }
          }
          // Duplicate selector clauses
          if (parsedSelectors.has(selector)) {
            return this.error(
              parentArgType === 'select'
                ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR,
              selectorLocation,
            );
          }
          if (selector === 'other') {
            hasOtherClause = true;
          }
          // Parse:
          // one {one apple}
          //     ^----------^
          this.bumpSpace();
          var openingBracePosition = this.clonePosition();
          if (!this.bumpIf('{')) {
            return this.error(
              parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT,
              createLocation(this.clonePosition(), this.clonePosition()),
            );
          }
          var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
          if (fragmentResult.err) {
            return fragmentResult;
          }
          var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
          if (argCloseResult.err) {
            return argCloseResult;
          }
          options.push([
            selector,
            {
              value: fragmentResult.val,
              location: createLocation(openingBracePosition, this.clonePosition()),
            },
          ]);
          // Keep track of the existing selectors
          parsedSelectors.add(selector);
          // Prep next selector clause.
          this.bumpSpace();
          (_a = this.parseIdentifierIfPossible()), (selector = _a.value), (selectorLocation = _a.location);
        }
        if (options.length === 0) {
          return this.error(
            parentArgType === 'select'
              ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
              : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR,
            createLocation(this.clonePosition(), this.clonePosition()),
          );
        }
        if (this.requiresOtherClause && !hasOtherClause) {
          return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return {
          val: options,
          err: null,
        };
      };
      Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        } else if (this.bumpIf('-')) {
          sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
          var ch = this.char();
          if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
            hasDigits = true;
            decimal = decimal * 10 + (ch - 48);
            this.bump();
          } else {
            break;
          }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
          return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
          return this.error(invalidNumberError, location);
        }
        return {
          val: decimal,
          err: null,
        };
      };
      Parser.prototype.offset = function () {
        return this.position.offset;
      };
      Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
      };
      Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
          offset: this.position.offset,
          line: this.position.line,
          column: this.position.column,
        };
      };
      /**
       * Return the code point at the current position of the parser.
       * Throws if the index is out of bound.
       */
      Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
          throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
          throw Error('Offset '.concat(offset, ' is at invalid UTF-16 code unit boundary'));
        }
        return code;
      };
      Parser.prototype.error = function (kind, location) {
        return {
          val: null,
          err: {
            kind: kind,
            message: this.message,
            location: location,
          },
        };
      };
      /** Bump the parser to the next UTF-16 code unit. */
      Parser.prototype.bump = function () {
        if (this.isEOF()) {
          return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
          this.position.line += 1;
          this.position.column = 1;
          this.position.offset += 1;
        } else {
          this.position.column += 1;
          // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
          this.position.offset += code < 0x10000 ? 1 : 2;
        }
      };
      /**
       * If the substring starting at the current position of the parser has
       * the given prefix, then bump the parser to the character immediately
       * following the prefix and return true. Otherwise, don't bump the parser
       * and return false.
       */
      Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
          for (var i = 0; i < prefix.length; i++) {
            this.bump();
          }
          return true;
        }
        return false;
      };
      /**
       * Bump the parser until the pattern character is found and return `true`.
       * Otherwise bump to the end of the file and return `false`.
       */
      Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
          this.bumpTo(index);
          return true;
        } else {
          this.bumpTo(this.message.length);
          return false;
        }
      };
      /**
       * Bump the parser to the target offset.
       * If target offset is beyond the end of the input, bump the parser to the end of the input.
       */
      Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
          throw Error(
            'targetOffset '
              .concat(targetOffset, ' must be greater than or equal to the current offset ')
              .concat(this.offset()),
          );
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
          var offset = this.offset();
          if (offset === targetOffset) {
            break;
          }
          if (offset > targetOffset) {
            throw Error('targetOffset '.concat(targetOffset, ' is at invalid UTF-16 code unit boundary'));
          }
          this.bump();
          if (this.isEOF()) {
            break;
          }
        }
      };
      /** advance the parser through all whitespace to the next non-whitespace code unit. */
      Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
          this.bump();
        }
      };
      /**
       * Peek at the *next* Unicode codepoint in the input without advancing the parser.
       * If the input has been exhausted, then this returns null.
       */
      Parser.prototype.peek = function () {
        if (this.isEOF()) {
          return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
      };
      return Parser;
    })();

    /**
     * This check if codepoint is alphabet (lower & uppercase)
     * @param codepoint
     * @returns
     */
    function _isAlpha(codepoint) {
      return (codepoint >= 97 && codepoint <= 122) || (codepoint >= 65 && codepoint <= 90);
    }
    function _isAlphaOrSlash(codepoint) {
      return _isAlpha(codepoint) || codepoint === 47; /* '/' */
    }
    /** See `parseTag` function docs. */
    function _isPotentialElementNameChar(c) {
      return (
        c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff)
      );
    }
    /**
     * Code point equivalent of regex `\p{White_Space}`.
     * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
     */
    function _isWhiteSpace(c) {
      return (
        (c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029
      );
    }
    /**
     * Code point equivalent of regex `\p{Pattern_Syntax}`.
     * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
     */
    function _isPatternSyntax(c) {
      return (
        (c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46)
      );
    } // CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js
    function pruneLocation(els) {
      els.forEach(function (el) {
        delete el.location;
        if (types_isSelectElement(el) || types_isPluralElement(el)) {
          for (var k in el.options) {
            delete el.options[k].location;
            pruneLocation(el.options[k].value);
          }
        } else if (types_isNumberElement(el) && types_isNumberSkeleton(el.style)) {
          delete el.style.location;
        } else if ((types_isDateElement(el) || types_isTimeElement(el)) && types_isDateTimeSkeleton(el.style)) {
          delete el.style.location;
        } else if (types_isTagElement(el)) {
          pruneLocation(el.children);
        }
      });
    }
    function parse(message, opts) {
      if (opts === void 0) {
        opts = {};
      }
      opts = __assign(
        {
          shouldParseSkeletons: true,
          requiresOtherClause: true,
        },
        opts,
      );
      var result = new parser_Parser(message, opts).parse();
      if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
      }
      if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
      }
      return result.val;
    }

    // only for testing
    var _Parser = /* unused pure expression or super */ null && Parser; // CONCATENATED MODULE: ./node_modules/@formatjs/fast-memoize/lib/index.js
    //
    // Main
    //
    function memoize(fn, options) {
      var cache = options && options.cache ? options.cache : cacheDefault;
      var serializer = options && options.serializer ? options.serializer : serializerDefault;
      var strategy = options && options.strategy ? options.strategy : strategyDefault;
      return strategy(fn, {
        cache: cache,
        serializer: serializer,
      });
    }
    //
    // Strategy
    //
    function isPrimitive(value) {
      return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
    }
    function monadic(fn, cache, serializer, arg) {
      var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
      var computedValue = cache.get(cacheKey);
      if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
      }
      return computedValue;
    }
    function variadic(fn, cache, serializer) {
      var args = Array.prototype.slice.call(arguments, 3);
      var cacheKey = serializer(args);
      var computedValue = cache.get(cacheKey);
      if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
      }
      return computedValue;
    }
    function assemble(fn, context, strategy, cache, serialize) {
      return strategy.bind(context, fn, cache, serialize);
    }
    function strategyDefault(fn, options) {
      var strategy = fn.length === 1 ? monadic : variadic;
      return assemble(fn, this, strategy, options.cache.create(), options.serializer);
    }
    function strategyVariadic(fn, options) {
      return assemble(fn, this, variadic, options.cache.create(), options.serializer);
    }
    function strategyMonadic(fn, options) {
      return assemble(fn, this, monadic, options.cache.create(), options.serializer);
    }
    //
    // Serializer
    //
    var serializerDefault = function () {
      return JSON.stringify(arguments);
    };
    //
    // Cache
    //
    function ObjectWithoutPrototypeCache() {
      this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function (key) {
      return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
      this.cache[key] = value;
    };
    var cacheDefault = {
      create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
      },
    };
    var strategies = {
      variadic: strategyVariadic,
      monadic: strategyMonadic,
    }; // CONCATENATED MODULE: ./node_modules/@formatjs/intl/node_modules/intl-messageformat/lib/src/error.js
    var error_ErrorCode;
    (function (ErrorCode) {
      // When we have a placeholder but no value to format
      ErrorCode['MISSING_VALUE'] = 'MISSING_VALUE';
      // When value supplied is invalid
      ErrorCode['INVALID_VALUE'] = 'INVALID_VALUE';
      // When we need specific Intl API but it's not available
      ErrorCode['MISSING_INTL_API'] = 'MISSING_INTL_API';
    })(error_ErrorCode || (error_ErrorCode = {}));
    var error_FormatError = /** @class */ (function (_super) {
      __extends(FormatError, _super);
      function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
      }
      FormatError.prototype.toString = function () {
        return '[formatjs Error: '.concat(this.code, '] ').concat(this.message);
      };
      return FormatError;
    })(Error);

    var error_InvalidValueError = /** @class */ (function (_super) {
      __extends(InvalidValueError, _super);
      function InvalidValueError(variableId, value, options, originalMessage) {
        return (
          _super.call(
            this,
            'Invalid values for "'
              .concat(variableId, '": "')
              .concat(value, '". Options are "')
              .concat(Object.keys(options).join('", "'), '"'),
            error_ErrorCode.INVALID_VALUE,
            originalMessage,
          ) || this
        );
      }
      return InvalidValueError;
    })(error_FormatError);

    var error_InvalidValueTypeError = /** @class */ (function (_super) {
      __extends(InvalidValueTypeError, _super);
      function InvalidValueTypeError(value, type, originalMessage) {
        return (
          _super.call(
            this,
            'Value for "'.concat(value, '" must be of type ').concat(type),
            error_ErrorCode.INVALID_VALUE,
            originalMessage,
          ) || this
        );
      }
      return InvalidValueTypeError;
    })(error_FormatError);

    var error_MissingValueError = /** @class */ (function (_super) {
      __extends(MissingValueError, _super);
      function MissingValueError(variableId, originalMessage) {
        return (
          _super.call(
            this,
            'The intl string context variable "'
              .concat(variableId, '" was not provided to the string "')
              .concat(originalMessage, '"'),
            error_ErrorCode.MISSING_VALUE,
            originalMessage,
          ) || this
        );
      }
      return MissingValueError;
    })(error_FormatError); // CONCATENATED MODULE: ./node_modules/@formatjs/intl/node_modules/intl-messageformat/lib/src/formatters.js

    var PART_TYPE;
    (function (PART_TYPE) {
      PART_TYPE[(PART_TYPE['literal'] = 0)] = 'literal';
      PART_TYPE[(PART_TYPE['object'] = 1)] = 'object';
    })(PART_TYPE || (PART_TYPE = {}));
    function mergeLiteral(parts) {
      if (parts.length < 2) {
        return parts;
      }
      return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) {
          all.push(part);
        } else {
          lastPart.value += part.value;
        }
        return all;
      }, []);
    }
    function isFormatXMLElementFn(el) {
      return typeof el === 'function';
    }
    // TODO(skeleton): add skeleton support
    function formatToParts(
      els,
      locales,
      formatters,
      formats,
      values,
      currentPluralValue,
      // For debugging
      originalMessage,
    ) {
      // Hot path for straight simple msg translations
      if (els.length === 1 && types_isLiteralElement(els[0])) {
        return [
          {
            type: PART_TYPE.literal,
            value: els[0].value,
          },
        ];
      }
      var result = [];
      for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (types_isLiteralElement(el)) {
          result.push({
            type: PART_TYPE.literal,
            value: el.value,
          });
          continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (types_isPoundElement(el)) {
          if (typeof currentPluralValue === 'number') {
            result.push({
              type: PART_TYPE.literal,
              value: formatters.getNumberFormat(locales).format(currentPluralValue),
            });
          }
          continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
          throw new error_MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (types_isArgumentElement(el)) {
          if (!value || typeof value === 'string' || typeof value === 'number') {
            value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
          }
          result.push({
            type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
            value: value,
          });
          continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (types_isDateElement(el)) {
          var style =
            typeof el.style === 'string'
              ? formats.date[el.style]
              : types_isDateTimeSkeleton(el.style)
                ? el.style.parsedOptions
                : undefined;
          result.push({
            type: PART_TYPE.literal,
            value: formatters.getDateTimeFormat(locales, style).format(value),
          });
          continue;
        }
        if (types_isTimeElement(el)) {
          var style =
            typeof el.style === 'string'
              ? formats.time[el.style]
              : types_isDateTimeSkeleton(el.style)
                ? el.style.parsedOptions
                : formats.time.medium;
          result.push({
            type: PART_TYPE.literal,
            value: formatters.getDateTimeFormat(locales, style).format(value),
          });
          continue;
        }
        if (types_isNumberElement(el)) {
          var style =
            typeof el.style === 'string'
              ? formats.number[el.style]
              : types_isNumberSkeleton(el.style)
                ? el.style.parsedOptions
                : undefined;
          if (style && style.scale) {
            value = value * (style.scale || 1);
          }
          result.push({
            type: PART_TYPE.literal,
            value: formatters.getNumberFormat(locales, style).format(value),
          });
          continue;
        }
        if (types_isTagElement(el)) {
          var children = el.children,
            value_1 = el.value;
          var formatFn = values[value_1];
          if (!isFormatXMLElementFn(formatFn)) {
            throw new error_InvalidValueTypeError(value_1, 'function', originalMessage);
          }
          var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
          var chunks = formatFn(
            parts.map(function (p) {
              return p.value;
            }),
          );
          if (!Array.isArray(chunks)) {
            chunks = [chunks];
          }
          result.push.apply(
            result,
            chunks.map(function (c) {
              return {
                type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: c,
              };
            }),
          );
        }
        if (types_isSelectElement(el)) {
          var opt = el.options[value] || el.options.other;
          if (!opt) {
            throw new error_InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
          }
          result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
          continue;
        }
        if (types_isPluralElement(el)) {
          var opt = el.options['='.concat(value)];
          if (!opt) {
            if (!Intl.PluralRules) {
              throw new error_FormatError(
                'Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n',
                error_ErrorCode.MISSING_INTL_API,
                originalMessage,
              );
            }
            var rule = formatters
              .getPluralRules(locales, {
                type: el.pluralType,
              })
              .select(value - (el.offset || 0));
            opt = el.options[rule] || el.options.other;
          }
          if (!opt) {
            throw new error_InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
          }
          result.push.apply(
            result,
            formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)),
          );
          continue;
        }
      }
      return mergeLiteral(result);
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/node_modules/intl-messageformat/lib/src/core.js
    /*
			Copyright (c) 2014, Yahoo! Inc. All rights reserved.
			Copyrights licensed under the New BSD License.
			See the accompanying LICENSE file for terms.
			*/

    // -- MessageFormat --------------------------------------------------------
    function mergeConfig(c1, c2) {
      if (!c2) {
        return c1;
      }
      return __assign(
        __assign(__assign({}, c1 || {}), c2 || {}),
        Object.keys(c1).reduce(function (all, k) {
          all[k] = __assign(__assign({}, c1[k]), c2[k] || {});
          return all;
        }, {}),
      );
    }
    function mergeConfigs(defaultConfig, configs) {
      if (!configs) {
        return defaultConfig;
      }
      return Object.keys(defaultConfig).reduce(
        function (all, k) {
          all[k] = mergeConfig(defaultConfig[k], configs[k]);
          return all;
        },
        __assign({}, defaultConfig),
      );
    }
    function createFastMemoizeCache(store) {
      return {
        create: function () {
          return {
            get: function (key) {
              return store[key];
            },
            set: function (key, value) {
              store[key] = value;
            },
          };
        },
      };
    }
    function createDefaultFormatters(cache) {
      if (cache === void 0) {
        cache = {
          number: {},
          dateTime: {},
          pluralRules: {},
        };
      }
      return {
        getNumberFormat: memoize(
          function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
          },
          {
            cache: createFastMemoizeCache(cache.number),
            strategy: strategies.variadic,
          },
        ),
        getDateTimeFormat: memoize(
          function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
          },
          {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: strategies.variadic,
          },
        ),
        getPluralRules: memoize(
          function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
          },
          {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: strategies.variadic,
          },
        ),
      };
    }
    var IntlMessageFormat = /** @class */ (function () {
      function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) {
          locales = IntlMessageFormat.defaultLocale;
        }
        this.formatterCache = {
          number: {},
          dateTime: {},
          pluralRules: {},
        };
        this.format = function (values) {
          var parts = _this.formatToParts(values);
          // Hot path for straight simple msg translations
          if (parts.length === 1) {
            return parts[0].value;
          }
          var result = parts.reduce(function (all, part) {
            if (!all.length || part.type !== PART_TYPE.literal || typeof all[all.length - 1] !== 'string') {
              all.push(part.value);
            } else {
              all[all.length - 1] += part.value;
            }
            return all;
          }, []);
          if (result.length <= 1) {
            return result[0] || '';
          }
          return result;
        };
        this.formatToParts = function (values) {
          return formatToParts(
            _this.ast,
            _this.locales,
            _this.formatters,
            _this.formats,
            values,
            undefined,
            _this.message,
          );
        };
        this.resolvedOptions = function () {
          var _a;
          return {
            locale:
              ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
              Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
          };
        };
        this.getAst = function () {
          return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
          this.message = message;
          if (!IntlMessageFormat.__parse) {
            throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
          }
          var _a = opts || {},
            formatters = _a.formatters,
            parseOpts = tslib_es6_rest(_a, ['formatters']);
          // Parse string messages into an AST.
          this.ast = IntlMessageFormat.__parse(
            message,
            __assign(__assign({}, parseOpts), {
              locale: this.resolvedLocale,
            }),
          );
        } else {
          this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
          throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
      }
      Object.defineProperty(IntlMessageFormat, 'defaultLocale', {
        get: function () {
          if (!IntlMessageFormat.memoizedDefaultLocale) {
            IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
          }
          return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true,
      });
      IntlMessageFormat.memoizedDefaultLocale = null;
      IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
          return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
          return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
      };
      IntlMessageFormat.__parse = parse;
      // Default format options used as the prototype of the `formats` provided to the
      // constructor. These are used when constructing the internal Intl.NumberFormat
      // and Intl.DateTimeFormat instances.
      IntlMessageFormat.formats = {
        number: {
          integer: {
            maximumFractionDigits: 0,
          },
          currency: {
            style: 'currency',
          },
          percent: {
            style: 'percent',
          },
        },
        date: {
          short: {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit',
          },
          medium: {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          },
          long: {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          },
          full: {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          },
        },
        time: {
          short: {
            hour: 'numeric',
            minute: 'numeric',
          },
          medium: {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
          },
          long: {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZoneName: 'short',
          },
          full: {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZoneName: 'short',
          },
        },
      };
      return IntlMessageFormat;
    })(); // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/error.js

    var IntlErrorCode;
    (function (IntlErrorCode) {
      IntlErrorCode['FORMAT_ERROR'] = 'FORMAT_ERROR';
      IntlErrorCode['UNSUPPORTED_FORMATTER'] = 'UNSUPPORTED_FORMATTER';
      IntlErrorCode['INVALID_CONFIG'] = 'INVALID_CONFIG';
      IntlErrorCode['MISSING_DATA'] = 'MISSING_DATA';
      IntlErrorCode['MISSING_TRANSLATION'] = 'MISSING_TRANSLATION';
    })(IntlErrorCode || (IntlErrorCode = {}));
    var IntlError = /** @class */ (function (_super) {
      __extends(IntlError, _super);
      function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? (exception instanceof Error ? exception : new Error(String(exception))) : undefined;
        _this =
          _super.call(
            this,
            '[@formatjs/intl Error '
              .concat(code, '] ')
              .concat(message, '\n')
              .concat(err ? '\n'.concat(err.message, '\n').concat(err.stack) : ''),
          ) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
          // @ts-ignore just so we don't need to declare dep on @types/node
          Error.captureStackTrace(_this, IntlError);
        }
        return _this;
      }
      return IntlError;
    })(Error);

    var UnsupportedFormatterError = /** @class */ (function (_super) {
      __extends(UnsupportedFormatterError, _super);
      function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
      }
      return UnsupportedFormatterError;
    })(IntlError);

    var InvalidConfigError = /** @class */ (function (_super) {
      __extends(InvalidConfigError, _super);
      function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
      }
      return InvalidConfigError;
    })(IntlError);

    var MissingDataError = /** @class */ (function (_super) {
      __extends(MissingDataError, _super);
      function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
      }
      return MissingDataError;
    })(IntlError);

    var IntlFormatError = /** @class */ (function (_super) {
      __extends(IntlFormatError, _super);
      function IntlFormatError(message, locale, exception) {
        var _this =
          _super.call(
            this,
            IntlErrorCode.FORMAT_ERROR,
            ''.concat(message, '\nLocale: ').concat(locale, '\n'),
            exception,
          ) || this;
        _this.locale = locale;
        return _this;
      }
      return IntlFormatError;
    })(IntlError);

    var MessageFormatError = /** @class */ (function (_super) {
      __extends(MessageFormatError, _super);
      function MessageFormatError(message, locale, descriptor, exception) {
        var _this =
          _super.call(
            this,
            ''
              .concat(message, '\nMessageID: ')
              .concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, '\nDefault Message: ')
              .concat(
                descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage,
                '\nDescription: ',
              )
              .concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, '\n'),
            locale,
            exception,
          ) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
      }
      return MessageFormatError;
    })(IntlFormatError);

    var MissingTranslationError = /** @class */ (function (_super) {
      __extends(MissingTranslationError, _super);
      function MissingTranslationError(descriptor, locale) {
        var _this =
          _super.call(
            this,
            IntlErrorCode.MISSING_TRANSLATION,
            'Missing message: "'
              .concat(descriptor.id, '" for locale "')
              .concat(locale, '", using ')
              .concat(
                descriptor.defaultMessage
                  ? 'default message ('.concat(
                      typeof descriptor.defaultMessage === 'string'
                        ? descriptor.defaultMessage
                        : descriptor.defaultMessage
                            .map(function (e) {
                              var _a;
                              return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
                            })
                            .join(),
                      ')',
                    )
                  : 'id',
                ' as fallback.',
              ),
          ) || this;
        _this.descriptor = descriptor;
        return _this;
      }
      return MissingTranslationError;
    })(IntlError); // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js

    function filterProps(props, allowlist, defaults) {
      if (defaults === void 0) {
        defaults = {};
      }
      return allowlist.reduce(function (filtered, name) {
        if (name in props) {
          filtered[name] = props[name];
        } else if (name in defaults) {
          filtered[name] = defaults[name];
        }
        return filtered;
      }, {});
    }
    var defaultErrorHandler = function (error) {
      // @ts-ignore just so we don't need to declare dep on @types/node
      if (false) {
      }
    };
    var defaultWarnHandler = function (warning) {
      // @ts-ignore just so we don't need to declare dep on @types/node
      if (false) {
      }
    };
    var DEFAULT_INTL_CONFIG = {
      formats: {},
      messages: {},
      timeZone: undefined,
      defaultLocale: 'en',
      defaultFormats: {},
      fallbackOnEmptyString: true,
      onError: defaultErrorHandler,
      onWarn: defaultWarnHandler,
    };
    function createIntlCache() {
      return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
      };
    }
    function utils_createFastMemoizeCache(store) {
      return {
        create: function () {
          return {
            get: function (key) {
              return store[key];
            },
            set: function (key, value) {
              store[key] = value;
            },
          };
        },
      };
    }
    /**
     * Create intl formatters and populate cache
     * @param cache explicit cache to prevent leaking memory
     */
    function createFormatters(cache) {
      if (cache === void 0) {
        cache = createIntlCache();
      }
      var RelativeTimeFormat = Intl.RelativeTimeFormat;
      var ListFormat = Intl.ListFormat;
      var DisplayNames = Intl.DisplayNames;
      var getDateTimeFormat = memoize(
        function () {
          var _a;
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        },
        {
          cache: utils_createFastMemoizeCache(cache.dateTime),
          strategy: strategies.variadic,
        },
      );
      var getNumberFormat = memoize(
        function () {
          var _a;
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        },
        {
          cache: utils_createFastMemoizeCache(cache.number),
          strategy: strategies.variadic,
        },
      );
      var getPluralRules = memoize(
        function () {
          var _a;
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
        },
        {
          cache: utils_createFastMemoizeCache(cache.pluralRules),
          strategy: strategies.variadic,
        },
      );
      return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: memoize(
          function (message, locales, overrideFormats, opts) {
            return new IntlMessageFormat(
              message,
              locales,
              overrideFormats,
              __assign(
                {
                  formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                  },
                },
                opts || {},
              ),
            );
          },
          {
            cache: utils_createFastMemoizeCache(cache.message),
            strategy: strategies.variadic,
          },
        ),
        getRelativeTimeFormat: memoize(
          function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, __spreadArray([void 0], args, false)))();
          },
          {
            cache: utils_createFastMemoizeCache(cache.relativeTime),
            strategy: strategies.variadic,
          },
        ),
        getPluralRules: getPluralRules,
        getListFormat: memoize(
          function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, __spreadArray([void 0], args, false)))();
          },
          {
            cache: utils_createFastMemoizeCache(cache.list),
            strategy: strategies.variadic,
          },
        ),
        getDisplayNames: memoize(
          function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, __spreadArray([void 0], args, false)))();
          },
          {
            cache: utils_createFastMemoizeCache(cache.displayNames),
            strategy: strategies.variadic,
          },
        ),
      };
    }
    function getNamedFormat(formats, type, name, onError) {
      var formatType = formats && formats[type];
      var format;
      if (formatType) {
        format = formatType[name];
      }
      if (format) {
        return format;
      }
      onError(new UnsupportedFormatterError('No '.concat(type, ' format named: ').concat(name)));
    } // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/utils.js
    function invariantIntlContext(intl) {
      invariant(
        intl,
        '[React Intl] Could not find required `intl` object. ' +
          '<IntlProvider> needs to exist in the component ancestry.',
      );
    }
    var utils_DEFAULT_INTL_CONFIG = __assign(__assign({}, DEFAULT_INTL_CONFIG), {
      textComponent: react.Fragment,
    });
    /**
     * Takes a `formatXMLElementFn`, and composes it in function, which passes
     * argument `parts` through, assigning unique key to each part, to prevent
     * "Each child in a list should have a unique "key"" React error.
     * @param formatXMLElementFn
     */
    function assignUniqueKeysToParts(formatXMLElementFn) {
      return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react.Children.toArray(parts));
      };
    }
    function shallowEqual(objA, objB) {
      if (objA === objB) {
        return true;
      }
      if (!objA || !objB) {
        return false;
      }
      var aKeys = Object.keys(objA);
      var bKeys = Object.keys(objB);
      var len = aKeys.length;
      if (bKeys.length !== len) {
        return false;
      }
      for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
          return false;
        }
      }
      return true;
    } // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
    function getDisplayName(Component) {
      return Component.displayName || Component.name || 'Component';
    }
    // This is primarily dealing with packaging systems where multiple copies of react-intl
    // might exist
    var IntlContext =
      typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__
        ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = /*#__PURE__*/ react.createContext(null))
        : /*#__PURE__*/ react.createContext(null);
    var IntlConsumer = IntlContext.Consumer,
      IntlProvider = IntlContext.Provider;
    var Provider = IntlProvider;
    var Context = IntlContext;
    function injectIntl(WrappedComponent, options) {
      var _a = options || {},
        _b = _a.intlPropName,
        intlPropName = _b === void 0 ? 'intl' : _b,
        _c = _a.forwardRef,
        forwardRef = _c === void 0 ? false : _c,
        _d = _a.enforceContext,
        enforceContext = _d === void 0 ? true : _d;
      var WithIntl = function (props) {
        return /*#__PURE__*/ react.createElement(IntlConsumer, null, function (intl) {
          var _a;
          if (enforceContext) {
            invariantIntlContext(intl);
          }
          var intlProp = ((_a = {}), (_a[intlPropName] = intl), _a);
          return /*#__PURE__*/ react.createElement(
            WrappedComponent,
            __assign({}, props, intlProp, {
              ref: forwardRef ? props.forwardedRef : null,
            }),
          );
        });
      };
      WithIntl.displayName = 'injectIntl('.concat(getDisplayName(WrappedComponent), ')');
      WithIntl.WrappedComponent = WrappedComponent;
      if (forwardRef) {
        return hoist_non_react_statics_cjs_default()(
          /*#__PURE__*/ react.forwardRef(function (props, ref) {
            return /*#__PURE__*/ react.createElement(
              WithIntl,
              __assign({}, props, {
                forwardedRef: ref,
              }),
            );
          }),
          WrappedComponent,
        );
      }
      return hoist_non_react_statics_cjs_default()(WithIntl, WrappedComponent);
    } // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
    function useIntl_useIntl() {
      var intl = react.useContext(Context);
      invariantIntlContext(intl);
      return intl;
    } // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/message.js
    /*
     * Copyright 2015, Yahoo Inc.
     * Copyrights licensed under the New BSD License.
     * See the accompanying LICENSE file for terms.
     */

    function areEqual(prevProps, nextProps) {
      var values = prevProps.values,
        otherProps = tslib_es6_rest(prevProps, ['values']);
      var nextValues = nextProps.values,
        nextOtherProps = tslib_es6_rest(nextProps, ['values']);
      return shallowEqual(nextValues, values) && shallowEqual(otherProps, nextOtherProps);
    }
    function FormattedMessage(props) {
      var intl = useIntl_useIntl();
      var formatMessage = intl.formatMessage,
        _a = intl.textComponent,
        Text = _a === void 0 ? react.Fragment : _a;
      var id = props.id,
        description = props.description,
        defaultMessage = props.defaultMessage,
        values = props.values,
        children = props.children,
        _b = props.tagName,
        Component = _b === void 0 ? Text : _b,
        ignoreTag = props.ignoreTag;
      var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage,
      };
      var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
      });
      if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
      }
      if (Component) {
        return /*#__PURE__*/ react.createElement(Component, null, react.Children.toArray(nodes));
      }
      return /*#__PURE__*/ react.createElement(react.Fragment, null, nodes);
    }
    FormattedMessage.displayName = 'FormattedMessage';
    var MemoizedFormattedMessage = /*#__PURE__*/ react.memo(FormattedMessage, areEqual);
    MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
    /* harmony default export */ const components_message = MemoizedFormattedMessage; // CONCATENATED MODULE: ./src/icons/accessible-svg/AccessibleSVG.tsx
    const AccessibleSVG_excluded = ['children', 'title'];
    function AccessibleSVG_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = AccessibleSVG_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function AccessibleSVG_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function AccessibleSVG_defineProperty(e, r, t) {
      return (
        (r = AccessibleSVG_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function AccessibleSVG_toPropertyKey(t) {
      var i = AccessibleSVG_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function AccessibleSVG_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    class AccessibleSVG_AccessibleSVG extends react.Component {
      constructor(...args) {
        super(...args);
        AccessibleSVG_defineProperty(this, 'id', uniqueId_default()('icon'));
      }
      render() {
        const _this$props = this.props,
          { children, title } = _this$props,
          rest = AccessibleSVG_objectWithoutProperties(_this$props, AccessibleSVG_excluded);
        const titleID = `${this.id}-title`;

        // Make sure parent doesn't accidentally override these values
        const svgProps = omit_default()(rest, ['role', 'aria-labelledby']);

        // Accessibility fix for IE11, which treats all SVGs as focusable by default
        svgProps.focusable = 'false';
        if (title) {
          svgProps['aria-labelledby'] = titleID;
          svgProps.role = 'img';
        } else {
          svgProps['aria-hidden'] = 'true';
          svgProps.role = 'presentation';
        }
        return /*#__PURE__*/ react.createElement(
          'svg',
          svgProps,
          title
            ? /*#__PURE__*/ react.createElement(
                'title',
                {
                  id: titleID,
                },
                title,
              )
            : null,
          children,
        );
      }
    }
    /* harmony default export */ const accessible_svg_AccessibleSVG = AccessibleSVG_AccessibleSVG; // CONCATENATED MODULE: ./src/icons/accessible-svg/index.ts
    // CONCATENATED MODULE: ./src/styles/variables.ts
    /* File auto-generated */
    const white = '#fff'; // white
    const black = '#000'; // black
    const countBadgeBackground = '#e9163c'; // countBadgeBackground
    const bdlBoxBlue = '#0061d5'; // bdl-box-blue
    const bdlBoxBlue80 = '#3381dd'; // bdl-box-blue-80
    const bdlBoxBlue50 = '#7fb0ea'; // bdl-box-blue-50
    const bdlBoxBlue40 = '#99c0ee'; // bdl-box-blue-40
    const bdlBoxBlue30 = '#b2cff2'; // bdl-box-blue-30
    const bdlBoxBlue20 = '#ccdff7'; // bdl-box-blue-20
    const bdlBoxBlue10 = '#e5effa'; // bdl-box-blue-10
    const bdlBoxBlue05 = '#f2f7fd'; // bdl-box-blue-05
    const bdlBoxBlue02 = '#fafcfe'; // bdl-box-blue-02
    const bdlGray = '#222'; // bdl-gray
    const bdlGray80 = '#4e4e4e'; // bdl-gray-80
    const bdlGray65 = '#6f6f6f'; // bdl-gray-65
    const bdlGray50 = '#909090'; // bdl-gray-50
    const bdlGray40 = '#a7a7a7'; // bdl-gray-40
    const bdlGray30 = '#bcbcbc'; // bdl-gray-30
    const bdlGray20 = '#d3d3d3'; // bdl-gray-20
    const bdlGray10 = '#e8e8e8'; // bdl-gray-10
    const bdlGray05 = '#f4f4f4'; // bdl-gray-05
    const bdlGray02 = '#fbfbfb'; // bdl-gray-02
    const bdlDarkBlue = '#003c84'; // bdl-dark-blue
    const bdlDarkBlue50 = '#7f9dc1'; // bdl-dark-blue-50
    const bdlDarkBlue20 = '#ccd8e6'; // bdl-dark-blue-20
    const bdlDarkBlue10 = '#e5ebf2'; // bdl-dark-blue-10
    const bdlDarkBlue05 = '#f2f5f9'; // bdl-dark-blue-05
    const bdlDarkBlue02 = '#fafbfd'; // bdl-dark-blue-02
    const bdlLightBlue = '#2486fc'; // bdl-light-blue
    const bdlLightBlue50 = '#91c2fd'; // bdl-light-blue-50
    const bdlLightBlue20 = '#d3e7fe'; // bdl-light-blue-20
    const bdlLightBlue10 = '#e9f2fe'; // bdl-light-blue-10
    const bdlLightBlue05 = '#f4f9ff'; // bdl-light-blue-05
    const bdlLightBlue02 = '#fbfdff'; // bdl-light-blue-02
    const bdlYellorange = '#f5b31b'; // bdl-yellorange
    const bdlYellorange50 = '#fad98d'; // bdl-yellorange-50
    const bdlYellorange20 = '#fdf0d1'; // bdl-yellorange-20
    const bdlYellorange10 = '#fef7e8'; // bdl-yellorange-10
    const bdlYellorange05 = '#fefbf3'; // bdl-yellorange-05
    const bdlYellorange02 = '#fffefb'; // bdl-yellorange-02
    const bdlYellow = '#ffd700'; // bdl-yellow
    const bdlYellow50 = '#ffeb7f'; // bdl-yellow-50
    const bdlYellow20 = '#fff7cc'; // bdl-yellow-20
    const bdlYellow10 = '#fffbe5'; // bdl-yellow-10
    const bdlYellow05 = '#fffdf2'; // bdl-yellow-05
    const bdlYellow02 = '#fffefa'; // bdl-yellow-02
    const bdlGreenLight = '#26c281'; // bdl-green-light
    const bdlGreenLight50 = '#92e0c0'; // bdl-green-light-50
    const bdlGreenLight20 = '#d4f3e6'; // bdl-green-light-20
    const bdlGreenLight10 = '#e9f8f2'; // bdl-green-light-10
    const bdlGreenLight05 = '#f4fcf8'; // bdl-green-light-05
    const bdlGreenLight02 = '#fbfefd'; // bdl-green-light-02
    const bdlGrimace = '#4826c2'; // bdl-grimace
    const bdlGrimace50 = '#a392e0'; // bdl-grimace-50
    const bdlGrimace20 = '#dad4f3'; // bdl-grimace-20
    const bdlGrimace10 = '#ece9f8'; // bdl-grimace-10
    const bdlGrimace05 = '#f6f4fc'; // bdl-grimace-05
    const bdlGrimace02 = '#fbfbfe'; // bdl-grimace-02
    const bdlOrange = '#f1811a'; // bdl-orange
    const bdlOrange50 = '#f8c08c'; // bdl-orange-50
    const bdlOrange20 = '#fce6d1'; // bdl-orange-20
    const bdlOrange10 = '#fdf2e8'; // bdl-orange-10
    const bdlOrange05 = '#fef8f3'; // bdl-orange-05
    const bdlOrange02 = '#fffdfb'; // bdl-orange-02
    const bdlPurpleRain = '#9f3fed'; // bdl-purple-rain
    const bdlPurpleRain50 = '#cf9ff6'; // bdl-purple-rain-50
    const bdlPurpleRain20 = '#ecd9fb'; // bdl-purple-rain-20
    const bdlPurpleRain10 = '#f5ebfd'; // bdl-purple-rain-10
    const bdlPurpleRain05 = '#faf5fe'; // bdl-purple-rain-05
    const bdlPurpleRain02 = '#fdfbff'; // bdl-purple-rain-02
    const bdlWatermelonRed = '#ed3757'; // bdl-watermelon-red
    const bdlWatermelonRed50 = '#f69bab'; // bdl-watermelon-red-50
    const bdlWatermelonRed20 = '#fbd7dd'; // bdl-watermelon-red-20
    const bdlWatermelonRed10 = '#fdebee'; // bdl-watermelon-red-10
    const bdlWatermelonRed05 = '#fef5f6'; // bdl-watermelon-red-05
    const bdlWatermelonRed02 = '#fffbfc'; // bdl-watermelon-red-02
    const bdlLineHeight = '20px'; // bdl-line-height
    const bdlFontSize = '13px'; // bdl-fontSize
    const bdlFontSizeMinimum = '11px'; // bdl-fontSize-minimum
    const bdlFontSizeDejaBlue = '14px'; // bdl-fontSize--dejaBlue
    const avatarColors = /* unused pure expression or super */ null && [
      '#0061d5',
      '#003c84',
      '#6f6f6f',
      '#222',
      '#4826c2',
      '#9f3fed',
    ]; // avatar-colors
    const modalDialogZIndex = '160'; // modal-dialog-z-index
    const menuZIndex = '170'; // menu-z-index
    const submenuZIndex = '171'; // submenu-z-index
    const overlayZIndex = '190'; // overlay-z-index
    const tooltipZIndex = '190'; // tooltip-z-index
    const notificationsWrapperZIndex = '200'; // notifications-wrapper-z-index
    const bdlBorderRadiusSize = '4px'; // bdl-border-radius-size
    const bdlBorderRadiusSizeMed = '6px'; // bdl-border-radius-size-med
    const bdlBorderRadiusSizeLarge = '8px'; // bdl-border-radius-size-large
    const bdlBorderRadiusSizeXlarge = '12px'; // bdl-border-radius-size-xlarge
    const bdlHeaderBoxShadow = /* unused pure expression or super */ null && ['0 0 10px 0 rgba(0', '0', '0', '0.05)']; // bdl-header-box-shadow
    const bdlGridUnit = '4px'; // bdl-grid-unit
    const bdlGridUnitPx = '4'; // bdl-grid-unit-px
    const bdlHeaderHeight = '64px'; // bdl-header-height
    const bdlBtnBorderWidth = '1px'; // bdl-btn-border-width
    const bdlBtnHeight = '32px'; // bdl-btn-height
    const bdlBtnHeightLarge = '40px'; // bdl-btn-height-large
    const bdlBtnIconSize = '20px'; // bdl-btn-icon-size
    const bdlBtnTextIconSize = '16px'; // bdl-btn-text-icon-size
    const bdlBtnPaddingHorizontal = '16px'; // bdl-btn-padding-horizontal
    const bdlTransitionDurationBase = '0.15s'; // bdl-transitionDurationBase
    const bdlTimingFunction = /* unused pure expression or super */ null && ['cubic-bezier(0', '0', '0.6', '1)']; // bdl-timingFunction
    const sizeSmallMediumMin = '375px'; // size-small-medium-min
    const sizeMediumMin = '461px'; // size-medium-min
    const sizeLargeMin = '768px'; // size-large-min
    const sizeSmallMax = '374px'; // size-small-max
    const sizeSmallMediumMax = '460px'; // size-small-medium-max
    const sizeMediumMax = '767px'; // size-medium-max
    const sizeLargeMax = '1023px'; // size-large-max
    const sizeXlargeMax = '1219px'; // size-xlarge-max
    const smallScreen = '(max-width: 374px)'; // small-screen
    const smallMediumScreen = '(max-width: 460px)'; // small-medium-screen
    const mediumScreen = '(max-width: 767px)'; // medium-screen
    const largeScreen = '(max-width: 1023px)'; // large-screen
    const xlargeScreen = '(max-width: 1219px)'; // xlarge-screen
    // CONCATENATED MODULE: ./src/icons/general/IconLogo.tsx
    const IconLogo = ({ className = '', color = bdlBoxBlue, height = 25, title, width = 45 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-logo ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 98 52',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M95.34 44.7c1.1 1.53.8 3.66-.75 4.8-1.56 1.13-3.74.84-4.93-.64l-7.8-10.23-7.82 10.23c-1.2 1.48-3.36 1.77-4.9.63-1.55-1.15-1.87-3.28-.75-4.8l9.06-11.86L68.4 21c-1.1-1.54-.8-3.67.75-4.8 1.55-1.14 3.72-.85 4.9.63l7.82 10.23 7.8-10.23c1.2-1.48 3.38-1.77 4.92-.63 1.52 1.13 1.84 3.26.73 4.8L86.3 32.84l9.04 11.85zM53.9 43.22c-5.86 0-10.6-4.65-10.6-10.4 0-5.72 4.74-10.37 10.6-10.37 5.85 0 10.6 4.65 10.6 10.38 0 5.74-4.75 10.4-10.6 10.4zm-31.23 0c-5.85 0-10.6-4.65-10.6-10.4 0-5.72 4.75-10.37 10.6-10.37 5.86 0 10.6 4.65 10.6 10.38 0 5.74-4.74 10.4-10.6 10.4zm31.22-27.7c-6.78 0-12.66 3.73-15.63 9.2-2.97-5.47-8.84-9.2-15.6-9.2-4 0-7.66 1.3-10.6 3.46V4.38C12.02 2.52 10.45 1 8.53 1 6.6 1 5.03 2.5 5 4.4v28.7c.16 9.43 8 17.03 17.67 17.03 6.77 0 12.64-3.73 15.6-9.2 2.98 5.47 8.86 9.2 15.62 9.2 9.74 0 17.66-7.75 17.66-17.32 0-9.55-7.92-17.3-17.68-17.3z',
          fill: color,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconLogo = IconLogo; // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/createFormattedComponent.js
    var DisplayName;
    (function (DisplayName) {
      DisplayName['formatDate'] = 'FormattedDate';
      DisplayName['formatTime'] = 'FormattedTime';
      DisplayName['formatNumber'] = 'FormattedNumber';
      DisplayName['formatList'] = 'FormattedList';
      // Note that this DisplayName is the locale display name, not to be confused with
      // the name of the enum, which is for React component display name in dev tools.
      DisplayName['formatDisplayName'] = 'FormattedDisplayName';
    })(DisplayName || (DisplayName = {}));
    var DisplayNameParts;
    (function (DisplayNameParts) {
      DisplayNameParts['formatDate'] = 'FormattedDateParts';
      DisplayNameParts['formatTime'] = 'FormattedTimeParts';
      DisplayNameParts['formatNumber'] = 'FormattedNumberParts';
      DisplayNameParts['formatList'] = 'FormattedListParts';
    })(DisplayNameParts || (DisplayNameParts = {}));
    var FormattedNumberParts = function (props) {
      var intl = useIntl_useIntl();
      var value = props.value,
        children = props.children,
        formatProps = tslib_es6_rest(props, ['value', 'children']);
      return children(intl.formatNumberToParts(value, formatProps));
    };
    FormattedNumberParts.displayName = 'FormattedNumberParts';
    var FormattedListParts = function (props) {
      var intl = useIntl();
      var value = props.value,
        children = props.children,
        formatProps = __rest(props, ['value', 'children']);
      return children(intl.formatListToParts(value, formatProps));
    };
    FormattedNumberParts.displayName = 'FormattedNumberParts';
    function createFormattedDateTimePartsComponent(name) {
      var ComponentParts = function (props) {
        var intl = useIntl_useIntl();
        var value = props.value,
          children = props.children,
          formatProps = tslib_es6_rest(props, ['value', 'children']);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts =
          name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
      };
      ComponentParts.displayName = DisplayNameParts[name];
      return ComponentParts;
    }
    function createFormattedComponent(name) {
      var Component = function (props) {
        var intl = useIntl_useIntl();
        var value = props.value,
          children = props.children,
          formatProps = tslib_es6_rest(
            props,
            // TODO: fix TS type definition for localeMatcher upstream
            ['value', 'children'],
          );
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') {
          return children(formattedValue);
        }
        var Text = intl.textComponent || react.Fragment;
        return /*#__PURE__*/ react.createElement(Text, null, formattedValue);
      };
      Component.displayName = DisplayName[name];
      return Component;
    } // CONCATENATED MODULE: ./node_modules/react-intl/lib/index.js
    function defineMessages(msgs) {
      return msgs;
    }
    function defineMessage(msg) {
      return msg;
    }
    // IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
    var FormattedDate = createFormattedComponent('formatDate');
    var FormattedTime = createFormattedComponent('formatTime');
    var FormattedNumber = createFormattedComponent('formatNumber');
    var FormattedList = createFormattedComponent('formatList');
    var FormattedDisplayName = createFormattedComponent('formatDisplayName');
    var FormattedDateParts = createFormattedDateTimePartsComponent('formatDate');
    var FormattedTimeParts = createFormattedDateTimePartsComponent('formatTime'); // CONCATENATED MODULE: ./src/elements/common/messages.js

    /**
     *
     * @file i18n messages
     * @author Box
     */

    const messages_messages = defineMessages({
      today: {
        id: 'be.today',
        defaultMessage: 'today',
      },
      yesterday: {
        id: 'be.yesterday',
        defaultMessage: 'yesterday',
      },
      logo: {
        id: 'be.logo',
        defaultMessage: 'Logo',
      },
      error: {
        id: 'be.error',
        defaultMessage: 'Error',
      },
      preview: {
        id: 'be.preview',
        defaultMessage: 'Preview',
      },
      previewError: {
        id: 'be.previewError',
        defaultMessage: 'This preview didn\u2019t load. Please try to open or download the file to view.',
      },
      previewErrorBlockedByPolicy: {
        id: 'be.previewErrorBlockedByPolicy',
        defaultMessage: 'Your access to this content is restricted due to a security policy.',
      },
      boxEditErrorBlockedByPolicy: {
        id: 'be.boxEditErrorBlockedByPolicy',
        defaultMessage: 'Local editing of this content has been disabled based on an access policy',
      },
      previewUpdate: {
        id: 'be.previewUpdate',
        defaultMessage: 'A new version of this file is available.',
      },
      reload: {
        id: 'be.reload',
        defaultMessage: 'Reload',
      },
      open: {
        id: 'be.open',
        defaultMessage: 'Open',
      },
      close: {
        id: 'be.close',
        defaultMessage: 'Close',
      },
      copy: {
        id: 'be.copy',
        defaultMessage: 'Copy',
      },
      delete: {
        id: 'be.delete',
        defaultMessage: 'Delete',
      },
      rename: {
        id: 'be.rename',
        defaultMessage: 'Rename',
      },
      remove: {
        id: 'be.remove',
        defaultMessage: 'Remove',
      },
      resume: {
        id: 'be.resume',
        defaultMessage: 'Resume',
      },
      resumeAll: {
        id: 'be.resumeAll',
        defaultMessage: 'Resume All',
      },
      retry: {
        id: 'be.retry',
        defaultMessage: 'Retry',
      },
      share: {
        id: 'be.share',
        defaultMessage: 'Share',
      },
      download: {
        id: 'be.download',
        defaultMessage: 'Download',
      },
      save: {
        id: 'be.save',
        defaultMessage: 'Save',
      },
      cancel: {
        id: 'be.cancel',
        defaultMessage: 'Cancel',
      },
      create: {
        id: 'be.create',
        defaultMessage: 'Create',
      },
      choose: {
        id: 'be.choose',
        defaultMessage: 'Choose',
      },
      upload: {
        id: 'be.upload',
        defaultMessage: 'Upload',
      },
      add: {
        id: 'be.add',
        defaultMessage: 'Add',
      },
      gridView: {
        id: 'be.gridView',
        defaultMessage: 'Switch to Grid View',
      },
      gridViewColumnSize: {
        id: 'be.gridView.columnSize',
        defaultMessage: 'Column size',
      },
      gridViewIncreaseColumnSize: {
        id: 'be.gridView.increaseColumnSize',
        defaultMessage: 'Increase column size',
      },
      gridViewDecreaseColumnSize: {
        id: 'be.gridView.decreaseColumnSize',
        defaultMessage: 'Decrease column size',
      },
      listView: {
        id: 'be.listView',
        defaultMessage: 'Switch to List View',
      },
      sort: {
        id: 'be.sort',
        defaultMessage: 'Sort',
      },
      newFolder: {
        id: 'be.newFolder',
        defaultMessage: 'New Folder',
      },
      in: {
        id: 'be.in',
        defaultMessage: 'In',
      },
      print: {
        id: 'be.print',
        defaultMessage: 'Print',
      },
      selected: {
        id: 'be.selected',
        defaultMessage: '{count} Selected',
      },
      max: {
        id: 'be.max',
        defaultMessage: 'max',
      },
      nameDate: {
        id: 'be.nameDate',
        defaultMessage: '{date} by {name}',
      },
      modified: {
        id: 'be.itemModified',
        defaultMessage: 'Modified',
      },
      modifiedDateBy: {
        id: 'be.modifiedDateBy',
        defaultMessage: 'Modified {date} by {name}',
      },
      modifiedDate: {
        id: 'be.modifiedDate',
        defaultMessage: 'Modified {date}',
      },
      created: {
        id: 'be.itemCreated',
        defaultMessage: 'Created',
      },
      owner: {
        id: 'be.itemOwner',
        defaultMessage: 'Owner',
      },
      uploader: {
        id: 'be.itemUploader',
        defaultMessage: 'Uploader',
      },
      interacted: {
        id: 'be.itemInteracted',
        defaultMessage: 'Last Accessed',
      },
      interactedDate: {
        id: 'be.interactedDate',
        defaultMessage: 'Last accessed on {date}',
      },
      name: {
        id: 'be.itemName',
        defaultMessage: 'Name',
      },
      size: {
        id: 'be.itemSize',
        defaultMessage: 'Size',
      },
      deleteDialogLabel: {
        id: 'be.deleteDialogLabel',
        defaultMessage: 'Confirm Delete',
      },
      deleteDialogFileText: {
        id: 'be.deleteDialogFileText',
        defaultMessage: 'Are you sure you want to delete {name}?',
      },
      deleteDialogFolderText: {
        id: 'be.deleteDialogFolderText',
        defaultMessage: 'Are you sure you want to delete {name} and all its contents?',
      },
      renameDialogLabel: {
        id: 'be.renameDialogLabel',
        defaultMessage: 'Rename',
      },
      renameDialogText: {
        id: 'be.renameDialogText',
        defaultMessage: 'Please enter a new name for {name}:',
      },
      renameDialogErrorInvalid: {
        id: 'be.renameDialogErrorInvalid',
        defaultMessage: 'This name is invalid.',
      },
      renameDialogErrorInUse: {
        id: 'be.renameDialogErrorInUse',
        defaultMessage: 'An item with the same name already exists.',
      },
      renameDialogErrorTooLong: {
        id: 'be.renameDialogErrorTooLong',
        defaultMessage: 'This name is too long.',
      },
      createDialogLabel: {
        id: 'be.createDialogLabel',
        defaultMessage: 'New Folder',
      },
      createDialogText: {
        id: 'be.createDialogText',
        defaultMessage: 'Please enter a name.',
      },
      createDialogErrorInvalid: {
        id: 'be.createDialogErrorInvalid',
        defaultMessage: 'This is an invalid folder name.',
      },
      createDialogErrorTooLong: {
        id: 'be.createDialogErrorTooLong',
        defaultMessage: 'This folder name is too long.',
      },
      createDialogErrorInUse: {
        id: 'be.createDialogErrorInUse',
        defaultMessage: 'A folder with the same name already exists.',
      },
      shareDialogLabel: {
        id: 'be.shareDialogLabel',
        defaultMessage: 'Share',
      },
      shareDialogText: {
        id: 'be.shareDialogText',
        defaultMessage: 'Shared Link:',
      },
      shareDialogNone: {
        id: 'be.shareDialogNone',
        defaultMessage: 'None',
      },
      shareAccessOpen: {
        id: 'be.shareAccessOpen',
        defaultMessage: 'Access: People with the link',
      },
      shareAccessCollab: {
        id: 'be.shareAccessCollab',
        defaultMessage: 'Access: People in this folder',
      },
      shareAccessCompany: {
        id: 'be.shareAccessCompany',
        defaultMessage: 'People in this company',
      },
      shareAccessNone: {
        id: 'be.shareAccessNone',
        defaultMessage: 'No shared link',
      },
      shareAccessRemove: {
        id: 'be.shareAccessRemove',
        defaultMessage: 'Remove shared link',
      },
      searchPlaceholder: {
        id: 'be.searchPlaceholder',
        defaultMessage: 'Search files and folders',
      },
      sidebarAccessStats: {
        id: 'be.sidebarAccessStats',
        defaultMessage: 'Access Stats',
      },
      sidebarContentInsights: {
        id: 'be.sidebarContentInsights',
        defaultMessage: 'Content Insights',
      },
      sidebarShow: {
        id: 'be.sidebarShow',
        defaultMessage: 'Show Sidebar',
      },
      sidebarHide: {
        id: 'be.sidebarHide',
        defaultMessage: 'Hide Sidebar',
      },
      description: {
        id: 'be.description',
        defaultMessage: 'Description',
      },
      descriptionPlaceholder: {
        id: 'be.descriptionPlaceholder',
        defaultMessage: 'Enter a description',
      },
      sidebarDetailsTitle: {
        id: 'be.sidebarDetailsTitle',
        defaultMessage: 'Details',
      },
      sidebarSkillsTitle: {
        id: 'be.sidebarSkillsTitle',
        defaultMessage: 'Skills',
      },
      sidebarSkillsErrorTitle: {
        id: 'be.sidebarSkillsErrorTitle',
        defaultMessage: 'Skills Error',
      },
      sidebarSkillsErrorContent: {
        id: 'be.sidebarSkillsErrorContent',
        defaultMessage: 'An error has occurred while updating skills. Please refresh the page and try again.',
      },
      sidebarActivityTitle: {
        id: 'be.sidebarActivityTitle',
        defaultMessage: 'Activity',
      },
      sidebarDocGenTitle: {
        id: 'be.sidebarDocGenTitle',
        defaultMessage: 'Doc Gen Tags',
      },
      sidebarMetadataTitle: {
        id: 'be.sidebarMetadataTitle',
        defaultMessage: 'Metadata',
      },
      sidebarMetadataEditingErrorContent: {
        id: 'be.sidebarMetadataEditingErrorContent',
        defaultMessage: 'An error has occurred while updating metadata. Please refresh the page and try again.',
      },
      sidebarMetadataFetchingErrorContent: {
        id: 'be.sidebarMetadataFetchingErrorContent',
        defaultMessage: 'An error has occurred while fetching metadata. Please refresh the page and try again.',
      },
      sidebarFileFetchingErrorContent: {
        id: 'be.sidebarFileFetchingErrorContent',
        defaultMessage: 'An error has occurred while fetching your Box file. Please refresh the page and try again.',
      },
      sidebarProperties: {
        id: 'be.sidebarProperties',
        defaultMessage: 'File Properties',
      },
      sidebarNavLabel: {
        id: 'be.sidebarNavLabel',
        defaultMessage: 'Sidebar',
      },
      defaultSkill: {
        id: 'be.defaultSkill',
        defaultMessage: 'Skill Card',
      },
      statusSkill: {
        id: 'be.statusSkill',
        defaultMessage: 'Status',
      },
      topicsSkill: {
        id: 'be.topicsSkill',
        defaultMessage: 'Topics',
      },
      keywordSkill: {
        id: 'be.keywordSkill',
        defaultMessage: 'Topics',
      },
      faceSkill: {
        id: 'be.faceSkill',
        defaultMessage: 'Faces',
      },
      transcriptSkill: {
        id: 'be.transcriptSkill',
        defaultMessage: 'Transcript',
      },
      skillPendingStatus: {
        id: 'be.skillPendingStatus',
        defaultMessage: 'We\u2019re working on processing your file - please hold!',
      },
      skillInvokedStatus: {
        id: 'be.skillInvokedStatus',
        defaultMessage: 'We\u2019re preparing to process your file - please hold!',
      },
      skillUnknownError: {
        id: 'be.skillUnknownError',
        defaultMessage: 'Something went wrong with running this skill or fetching its data.',
      },
      skillInvalidFileSizeError: {
        id: 'be.skillInvalidFileSizeError',
        defaultMessage: 'We\u2019re sorry, no skills information was found. This file size is currently not supported.',
      },
      skillInvalidFileExtensionError: {
        id: 'be.skillInvalidFileExtensionError',
        defaultMessage:
          'We\u2019re sorry, no skills information was found. This file extension is currently not supported.',
      },
      skillNoInfoFoundError: {
        id: 'be.skillNoInfoFoundError',
        defaultMessage: 'We\u2019re sorry, no skills information was found.',
      },
      skillFileProcessingError: {
        id: 'be.skillFileProcessingError',
        defaultMessage: 'We\u2019re sorry, something went wrong with processing the file.',
      },
      uploadErrorTooManyFiles: {
        id: 'be.uploadErrorTooManyFiles',
        defaultMessage: 'You can only upload up to {fileLimit} file(s) at a time.',
      },
      uploadError: {
        id: 'be.uploadError',
        defaultMessage: 'A network error has occurred while trying to upload.',
      },
      uploadEmptyWithFolderUploadEnabled: {
        id: 'be.uploadEmptyWithFolderUploadEnabled',
        defaultMessage: 'Drag and drop files and folders',
      },
      uploadEmptyWithFolderUploadDisabled: {
        id: 'be.uploadEmptyWithFolderUploadDisabled',
        defaultMessage: 'Drag and drop files',
      },
      uploadEmptyFileInput: {
        id: 'be.uploadEmptyFileInput',
        defaultMessage: 'Browse your device',
      },
      uploadEmptyFolderInput: {
        id: 'be.uploadEmptyFolderInput',
        defaultMessage: 'Select Folders',
      },
      uploadNoDragDrop: {
        id: 'be.uploadNoDragDrop',
        defaultMessage: 'Select files from your device',
      },
      uploadInProgress: {
        id: 'be.uploadInProgress',
        defaultMessage: 'Drag and drop to add additional files',
      },
      uploadSuccess: {
        id: 'be.uploadSuccess',
        defaultMessage: 'Success! Your files have been uploaded.',
      },
      uploadSuccessFileInput: {
        id: 'be.uploadSuccessFileInput',
        defaultMessage: 'Select More Files',
      },
      uploadSuccessFolderInput: {
        id: 'be.uploadSuccessFolderInput',
        defaultMessage: 'Select More Folders',
      },
      uploadOptions: {
        id: 'be.uploadOptions',
        defaultMessage: '{option1} or {option2}',
      },
      nameASC: {
        id: 'be.nameASC',
        defaultMessage: 'Name: A \u2192 Z',
      },
      nameDESC: {
        id: 'be.nameDESC',
        defaultMessage: 'Name: Z \u2192 A',
      },
      dateASC: {
        id: 'be.dateASC',
        defaultMessage: 'Date: Oldest \u2192 Newest',
      },
      dateDESC: {
        id: 'be.dateDESC',
        defaultMessage: 'Date: Newest \u2192 Oldest',
      },
      sizeASC: {
        id: 'be.sizeASC',
        defaultMessage: 'Size: Smallest \u2192 Largest',
      },
      sizeDESC: {
        id: 'be.sizeDESC',
        defaultMessage: 'Size: Largest \u2192 Smallest',
      },
      searchState: {
        id: 'be.searchState',
        defaultMessage: 'Sorry, we couldn\u2019t find what you\u2019re looking for.',
      },
      selectedState: {
        id: 'be.selectedState',
        defaultMessage: 'You haven\u2019t selected any items yet.',
      },
      errorState: {
        id: 'be.errorState',
        defaultMessage: 'A network error has occurred while trying to load.',
      },
      folderState: {
        id: 'be.folderState',
        defaultMessage: 'There are no items in this folder.',
      },
      metadataState: {
        id: 'be.metadataState',
        defaultMessage: 'There are no items in this folder.',
      },
      recentsState: {
        id: 'be.recentsState',
        defaultMessage: 'There are no recent items yet.',
      },
      loadingState: {
        id: 'be.loadingState',
        defaultMessage: 'Please wait while the items load...',
      },
      errorBreadcrumb: {
        id: 'be.errorBreadcrumb',
        defaultMessage: 'Error',
      },
      rootBreadcrumb: {
        id: 'be.rootBreadcrumb',
        defaultMessage: 'All Files',
      },
      searchBreadcrumb: {
        id: 'be.searchBreadcrumb',
        defaultMessage: 'Search Results',
      },
      recentsBreadcrumb: {
        id: 'be.recentsBreadcrumb',
        defaultMessage: 'Recents',
      },
      selectedBreadcrumb: {
        id: 'be.selectedBreadcrumb',
        defaultMessage: 'Selected Items',
      },
      uploadsManagerUploadInProgress: {
        id: 'be.uploadsManagerUploadInProgress',
        defaultMessage: 'Uploading',
      },
      uploadsManagerUploadPrompt: {
        id: 'be.uploadsManagerUploadPrompt',
        defaultMessage: 'Drop files on this page to upload them into this folder.',
      },
      uploadsManagerUploadComplete: {
        id: 'be.uploadsManagerUploadComplete',
        defaultMessage: 'Completed',
      },
      uploadsManagerUploadFailed: {
        id: 'be.uploadsManagerUploadFailed',
        defaultMessage: 'Some Uploads Failed',
      },
      uploadsCancelButtonTooltip: {
        id: 'be.uploadsCancelButtonTooltip',
        defaultMessage: 'Cancel this upload',
      },
      uploadsRetryButtonTooltip: {
        id: 'be.uploadsRetryButtonTooltip',
        defaultMessage: 'Retry upload',
      },
      uploadsFileSizeLimitExceededErrorMessage: {
        id: 'be.uploadsFileSizeLimitExceededErrorMessage',
        defaultMessage: 'File size exceeds the folder owner\u2019s file size limit',
      },
      uploadsFileSizeLimitExceededErrorMessageForUpgradeCta: {
        id: 'be.uploadsFileSizeLimitExceededErrorMessageForUpgradeCta',
        defaultMessage: 'This file exceeds your plan\u2019s upload limit. Upgrade now to store larger files.',
      },
      uploadsFileSizeLimitExceededUpgradeMessageForUpgradeCta: {
        id: 'be.uploadsFileSizeLimitExceededUpgradeMessageForUpgradeCta',
        defaultMessage: 'Upgrade',
      },
      uploadsStorageLimitErrorMessage: {
        id: 'be.uploadsStorageLimitErrorMessage',
        defaultMessage: 'Account storage limit reached',
      },
      uploadsPendingFolderSizeLimitErrorMessage: {
        id: 'be.uploadsPendingFolderSizeLimitErrorMessage',
        defaultMessage: 'Pending app folder size limit exceeded',
      },
      uploadsItemNameInUseErrorMessage: {
        id: 'be.uploadsItemNameInUseErrorMessage',
        defaultMessage: 'A file with this name already exists.',
      },
      uploadsProvidedFolderNameInvalidMessage: {
        id: 'be.uploadsProvidedFolderNameInvalidMessage',
        defaultMessage: 'Provided folder name, {name}, could not be used to create a folder.',
      },
      uploadsOneOrMoreChildFoldersFailedToUploadMessage: {
        id: 'be.uploadsOneOrMoreChildFoldersFailedToUploadMessage',
        defaultMessage: 'One or more child folders failed to upload.',
      },
      uploadsPackageUploadErrorMessage: {
        id: 'be.uploadsPackageUploadErrorMessage',
        defaultMessage: 'Failed to upload package file. Please retry by saving as a single file.',
      },
      uploadsDefaultErrorMessage: {
        id: 'be.uploadsDefaultErrorMessage',
        defaultMessage: 'Something went wrong with the upload. Please try again.',
      },
      errorOccured: {
        id: 'be.errorOccured',
        defaultMessage: 'An error occurred',
      },
      editLabel: {
        id: 'be.editLabel',
        defaultMessage: 'Edit',
      },
      getVersionInfo: {
        id: 'be.getVersionInfo',
        defaultMessage: 'Get version information',
      },
      keywordsApplied: {
        id: 'be.keywordsAppliedList',
        defaultMessage: 'Keywords were applied',
      },
      keywordsList: {
        id: 'be.keywordsList',
        defaultMessage: 'Keywords: {words}',
      },
      noActivity: {
        id: 'be.noActivity',
        defaultMessage: 'No activity to show',
      },
      noActivityAnnotationPrompt: {
        id: 'be.noActivityAnnotationPrompt',
        defaultMessage: 'Hover over the preview and use the controls at the bottom to annotate the file.',
      },
      noActivityCommentPrompt: {
        id: 'be.noActivityCommentPrompt',
        defaultMessage: 'Comment and @mention people to notify them.',
      },
      versionDeleted: {
        id: 'be.versionDeleted',
        defaultMessage: '{name} deleted v{version_number}',
      },
      versionPromoted: {
        id: 'be.versionPromoted',
        defaultMessage: '{name} promoted v{version_promoted} to v{version_number}',
      },
      versionRestored: {
        id: 'be.versionRestored',
        defaultMessage: '{name} restored v{version_number}',
      },
      versionMultipleUsersUploaded: {
        id: 'be.versionMultipleUsersUploaded',
        defaultMessage: '{numberOfCollaborators} collaborators uploaded v{versions}',
      },
      versionUploadCollapsed: {
        id: 'be.versionUploadCollapsed',
        defaultMessage: '{name} uploaded v{versions}',
      },
      versionUploaded: {
        id: 'be.versionUploaded',
        defaultMessage: '{name} uploaded v{version_number}',
      },
      fileRequestDisplayName: {
        id: 'be.fileRequestDisplayName',
        defaultMessage: 'File Request',
      },
      defaultInlineErrorContentMessage: {
        id: 'be.defaultInlineErrorContentMessage',
        defaultMessage: 'Please try again later.',
      },
      fileDescriptionInlineErrorTitleMessage: {
        id: 'be.fileDescriptionInlineErrorTitleMessage',
        defaultMessage: 'Something went wrong when saving the description.',
      },
      defaultErrorMaskHeaderMessage: {
        id: 'be.defaultErrorMaskHeaderMessage',
        defaultMessage: 'We\u2019re sorry, something went wrong.',
      },
      defaultErrorMaskSubHeaderMessage: {
        id: 'be.defaultErrorMaskSubHeaderMessage',
        defaultMessage: 'Please refresh the page or try again later.',
      },
      fileAccessStatsErrorHeaderMessage: {
        id: 'be.fileAccessStatsErrorHeaderMessage',
        defaultMessage: 'Something went wrong when fetching the access stats.',
      },
      fileAccessStatsPermissionsError: {
        id: 'be.accessStatsPermissionsError',
        defaultMessage: 'Sorry, you do not have permission to see the access stats for this file.',
      },
      fileClassificationErrorHeaderMessage: {
        id: 'be.fileClassificationErrorHeaderMessage',
        defaultMessage: 'Something went wrong when fetching classification.',
      },
      currentUserErrorHeaderMessage: {
        id: 'be.currentUserErrorHeaderMessage',
        defaultMessage: 'Something went wrong when fetching the current user.',
      },
      activityFeedItemApiError: {
        id: 'be.activityFeedItemApiError',
        defaultMessage: 'There was a problem loading the activity feed. Please refresh the page or try again later.',
      },
      nextFile: {
        id: 'be.nextFile',
        defaultMessage: 'Next File',
      },
      nextPage: {
        id: 'be.pagination.nextPage',
        defaultMessage: 'Next Page',
      },
      pageStatus: {
        id: 'be.pagination.pageStatus',
        defaultMessage: '{pageNumber} of {pageCount}',
      },
      previousFile: {
        id: 'be.previousFile',
        defaultMessage: 'Previous File',
      },
      previousPage: {
        id: 'be.pagination.previousPage',
        defaultMessage: 'Previous Page',
      },
      previousSegment: {
        id: 'be.previousSegment',
        defaultMessage: 'Previous Segment',
      },
      nextSegment: {
        id: 'be.nextSegment',
        defaultMessage: 'Next Segment',
      },
      transcriptEdit: {
        id: 'be.transcriptEdit',
        defaultMessage: 'Click any section to edit.',
      },
      emptyOpenWithDescription: {
        id: 'be.emptyOpenWithDescription',
        defaultMessage: 'No integrations are available for this file',
      },
      errorOpenWithDescription: {
        id: 'be.errorOpenWithDescription',
        defaultMessage: 'Opening this file with other services is currently unavailable',
      },
      defaultOpenWithDescription: {
        id: 'be.defaultOpenWithDescription',
        defaultMessage: 'Open this file with a partner service',
      },
      executeIntegrationOpenWithErrorHeader: {
        id: 'be.executeIntegrationOpenWithErrorHeader',
        defaultMessage: 'We\u2019re sorry, this integration is currently unavailable.',
      },
      executeIntegrationOpenWithErrorSubHeader: {
        id: 'be.executeIntegrationOpenWithErrorSubHeader',
        defaultMessage: 'Please try again later.',
      },
      boxToolsInstallMessage: {
        id: 'be.boxToolsInstallMessage',
        defaultMessage: 'Install {boxTools} to open this file on your desktop',
      },
      boxToolsBlacklistedError: {
        id: 'be.boxEditBlacklistedError',
        defaultMessage: 'This file cannot be opened locally',
      },
      drawAnnotation: {
        id: 'be.drawAnnotation',
        defaultMessage: 'Drawing annotation mode',
      },
      pointAnnotation: {
        id: 'be.pointAnnotation',
        defaultMessage: 'Point annotation mode',
      },
      expand: {
        id: 'be.expand',
        defaultMessage: 'Expand',
      },
      collapse: {
        id: 'be.collapse',
        defaultMessage: 'Collapse',
      },
      back: {
        id: 'be.back',
        defaultMessage: 'Back',
      },
      priorCollaborator: {
        id: 'be.priorCollaborator',
        defaultMessage: 'A Prior Collaborator',
      },
      moreOptions: {
        id: 'be.moreOptions',
        defaultMessage: 'More options',
      },
      bookmark: {
        id: 'be.bookmark',
        defaultMessage: 'Bookmark',
      },
      collaboratedFolder: {
        id: 'be.collaboratedFolder',
        defaultMessage: 'Collaborated Folder',
      },
      externalFolder: {
        id: 'be.externalFolder',
        defaultMessage: 'External Folder',
      },
      file: {
        id: 'be.file',
        defaultMessage: 'File',
      },
      personalFolder: {
        id: 'be.personalFolder',
        defaultMessage: 'Personal Folder',
      },
      sidebarDocGenTooltip: {
        id: 'be.sidebarDocGenTooltip',
        defaultMessage: 'Box Doc Gen',
      },
    });
    /* harmony default export */ const common_messages = messages_messages; // CONCATENATED MODULE: ./src/elements/common/header/Logo.js
    /**
     *
     * @file Logo for the header
     * @author Box
     */

    function getLogo(url) {
      if (url === 'box') {
        return /*#__PURE__*/ react.createElement(general_IconLogo, null);
      }
      if (typeof url === 'string') {
        return /*#__PURE__*/ react.createElement('img', {
          alt: '',
          className: 'be-logo-custom',
          src: url,
        });
      }
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-logo-placeholder',
        },
        /*#__PURE__*/ react.createElement(components_message, common_messages.logo),
      );
    }
    const Logo = ({ url }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-logo',
          'data-testid': 'be-Logo',
        },
        getLogo(url),
      );
    /* harmony default export */ const header_Logo = Logo; // CONCATENATED MODULE: ./src/elements/common/header/Header.js
    /**
     *
     * @file Header bar
     * @author Box
     */

    // eslint-disable-next-line react/prop-types
    const Header = ({ isHeaderLogoVisible = true, view, isSmall, searchQuery, onSearch, logoUrl, intl }) => {
      const { formatMessage } = intl;
      const search = ({ currentTarget }) => onSearch(currentTarget.value);
      const searchMessage = formatMessage(common_messages.searchPlaceholder);
      const isFolder = view === VIEW_FOLDER;
      const isSearch = view === VIEW_SEARCH;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-header',
        },
        isHeaderLogoVisible &&
          /*#__PURE__*/ react.createElement(header_Logo, {
            isSmall: isSmall,
            url: logoUrl,
          }),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'be-search',
          },
          /*#__PURE__*/ react.createElement('input', {
            'aria-label': searchMessage,
            'data-testid': 'be-Header-searchInput',
            disabled: !isFolder && !isSearch,
            onChange: search,
            placeholder: searchMessage,
            type: 'search',
            value: searchQuery,
          }),
        ),
      );
    };

    /* harmony default export */ const header_Header = injectIntl(Header); // CONCATENATED MODULE: ./src/elements/common/header/index.js
    // CONCATENATED MODULE: ./src/components/loading-indicator/LoadingIndicator.tsx
    let LoadingIndicator_LoadingIndicatorSize = /*#__PURE__*/ (function (LoadingIndicatorSize) {
      LoadingIndicatorSize['SMALL'] = 'small';
      LoadingIndicatorSize['MEDIUM'] = 'medium';
      LoadingIndicatorSize['LARGE'] = 'large';
      LoadingIndicatorSize['DEFAULT'] = 'default';
      return LoadingIndicatorSize;
    })({});
    const LoadingIndicator_LoadingIndicator = ({
      className = '',
      size = LoadingIndicator_LoadingIndicatorSize.DEFAULT,
    }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: `crawler ${className} is-${size}`,
        },
        /*#__PURE__*/ react.createElement('div', null),
        /*#__PURE__*/ react.createElement('div', null),
        /*#__PURE__*/ react.createElement('div', null),
      );
    /* harmony default export */ const loading_indicator_LoadingIndicator = LoadingIndicator_LoadingIndicator; // CONCATENATED MODULE: ./src/components/loading-indicator/makeLoadable.tsx
    const makeLoadable_excluded = /* unused pure expression or super */ null && ['isLoading', 'loadingIndicatorProps'];
    function makeLoadable_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = makeLoadable_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function makeLoadable_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const makeLoadable = BaseComponent => {
      const LoadableComponent = _ref => {
        let { isLoading = false, loadingIndicatorProps = {} } = _ref,
          rest = makeLoadable_objectWithoutProperties(_ref, makeLoadable_excluded);
        return isLoading
          ? /*#__PURE__*/ React.createElement(LoadingIndicator, loadingIndicatorProps)
          : /*#__PURE__*/ React.createElement(BaseComponent, rest);
      };
      LoadableComponent.displayName = `Loadable${BaseComponent.displayName || BaseComponent.name || 'Component'}`;
      return LoadableComponent;
    };
    /* harmony default export */ const loading_indicator_makeLoadable =
      /* unused pure expression or super */ null && makeLoadable; // CONCATENATED MODULE: ./src/components/loading-indicator/LoadingIndicatorWrapper.tsx
    const LoadingIndicatorWrapper_excluded = /* unused pure expression or super */ null && [
      'children',
      'className',
      'crawlerPosition',
      'crawlerSize',
      'isLoading',
      'hideContent',
    ];
    function _extends() {
      return (
        (_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        _extends.apply(null, arguments)
      );
    }
    function LoadingIndicatorWrapper_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = LoadingIndicatorWrapper_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function LoadingIndicatorWrapper_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    let LoadingIndicatorWrapperPosition = /*#__PURE__*/ (function (LoadingIndicatorWrapperPosition) {
      LoadingIndicatorWrapperPosition['CENTER'] = 'center';
      LoadingIndicatorWrapperPosition['TOP'] = 'top';
      return LoadingIndicatorWrapperPosition;
    })({});
    const LoadingIndicatorWrapper = _ref => {
      let {
          children,
          className = '',
          crawlerPosition = LoadingIndicatorWrapperPosition.CENTER,
          crawlerSize = LoadingIndicatorSize.DEFAULT,
          isLoading = false,
          hideContent = false,
        } = _ref,
        rest = LoadingIndicatorWrapper_objectWithoutProperties(_ref, LoadingIndicatorWrapper_excluded);
      const crawlerPositionClassName = classnames(
        'loading-indicator-veil',
        {
          'is-with-top-crawler': crawlerPosition === LoadingIndicatorWrapperPosition.TOP,
          'is-with-center-crawler': crawlerPosition === LoadingIndicatorWrapperPosition.CENTER,
        },
        hideContent ? 'hide-content' : 'blur-content',
      );
      return /*#__PURE__*/ React.createElement(
        'div',
        _extends(
          {
            className: `loading-indicator-wrapper ${className}`,
          },
          rest,
        ),
        children,
        isLoading &&
          /*#__PURE__*/ React.createElement(
            'div',
            {
              className: crawlerPositionClassName,
            },
            /*#__PURE__*/ React.createElement(LoadingIndicator, {
              size: crawlerSize,
            }),
          ),
      );
    };
    /* harmony default export */ const loading_indicator_LoadingIndicatorWrapper =
      /* unused pure expression or super */ null && LoadingIndicatorWrapper; // CONCATENATED MODULE: ./src/components/loading-indicator/index.ts
    // EXTERNAL MODULE: ./node_modules/react-tether/lib/react-tether.js
    var react_tether = __webpack_require__(91695); // CONCATENATED MODULE: ./src/components/radar/RadarAnimation.tsx
    const RadarAnimation_excluded = [
      'children',
      'className',
      'constrainToScrollParent',
      'constrainToWindow',
      'position',
      'isShown',
      'offset',
      'tetherElementClassName',
    ];
    function RadarAnimation_extends() {
      return (
        (RadarAnimation_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        RadarAnimation_extends.apply(null, arguments)
      );
    }
    function RadarAnimation_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = RadarAnimation_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function RadarAnimation_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function RadarAnimation_defineProperty(e, r, t) {
      return (
        (r = RadarAnimation_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function RadarAnimation_toPropertyKey(t) {
      var i = RadarAnimation_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function RadarAnimation_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    let RadarAnimationPosition = /*#__PURE__*/ (function (RadarAnimationPosition) {
      RadarAnimationPosition['BOTTOM_CENTER'] = 'bottom-center';
      RadarAnimationPosition['BOTTOM_LEFT'] = 'bottom-left';
      RadarAnimationPosition['BOTTOM_RIGHT'] = 'bottom-right';
      RadarAnimationPosition['MIDDLE_CENTER'] = 'middle-center';
      RadarAnimationPosition['MIDDLE_LEFT'] = 'middle-left';
      RadarAnimationPosition['MIDDLE_RIGHT'] = 'middle-right';
      RadarAnimationPosition['TOP_CENTER'] = 'top-center';
      RadarAnimationPosition['TOP_LEFT'] = 'top-left';
      RadarAnimationPosition['TOP_RIGHT'] = 'top-right';
      return RadarAnimationPosition;
    })({});
    const positions = {
      [RadarAnimationPosition.BOTTOM_CENTER]: {
        attachment: 'top center',
        targetAttachment: 'bottom center',
      },
      [RadarAnimationPosition.BOTTOM_LEFT]: {
        attachment: 'top left',
        targetAttachment: 'bottom left',
      },
      [RadarAnimationPosition.BOTTOM_RIGHT]: {
        attachment: 'top right',
        targetAttachment: 'bottom right',
      },
      [RadarAnimationPosition.MIDDLE_CENTER]: {
        attachment: 'middle center',
        targetAttachment: 'middle center',
      },
      [RadarAnimationPosition.MIDDLE_LEFT]: {
        attachment: 'middle right',
        targetAttachment: 'middle left',
      },
      [RadarAnimationPosition.MIDDLE_RIGHT]: {
        attachment: 'middle left',
        targetAttachment: 'middle right',
      },
      [RadarAnimationPosition.TOP_CENTER]: {
        attachment: 'bottom center',
        targetAttachment: 'top center',
      },
      [RadarAnimationPosition.TOP_LEFT]: {
        attachment: 'bottom left',
        targetAttachment: 'top left',
      },
      [RadarAnimationPosition.TOP_RIGHT]: {
        attachment: 'bottom right',
        targetAttachment: 'top right',
      },
    };
    class RadarAnimation extends react.Component {
      constructor(...args) {
        super(...args);
        RadarAnimation_defineProperty(this, 'tetherRef', /*#__PURE__*/ react.createRef());
        RadarAnimation_defineProperty(this, 'radarAnimationID', uniqueId_default()('radarAnimation'));
        // Instance API: Forces the radar to be repositioned
        RadarAnimation_defineProperty(this, 'position', () => {
          const { isShown } = this.props;
          if (this.tetherRef.current && isShown) {
            this.tetherRef.current.position();
          }
        });
      }
      render() {
        const _this$props = this.props,
          {
            children,
            className = '',
            constrainToScrollParent,
            constrainToWindow,
            position,
            isShown,
            offset,
            tetherElementClassName,
          } = _this$props,
          rest = RadarAnimation_objectWithoutProperties(_this$props, RadarAnimation_excluded);
        const constraints = [];
        if (constrainToScrollParent) {
          constraints.push({
            to: 'scrollParent',
            attachment: 'together',
          });
        }
        if (constrainToWindow) {
          constraints.push({
            to: 'window',
            attachment: 'together',
          });
        }
        const { attachment, targetAttachment } = positions[position];
        const child = react.Children.only(children);
        const referenceElement = /*#__PURE__*/ react.cloneElement(child, {
          'aria-describedby': this.radarAnimationID,
        });

        // Typescript defs seem busted for older versions of react-tether
        const tetherProps = {
          attachment,
          classPrefix: 'radar-animation',
          constraints,
          targetAttachment,
        };
        if (tetherElementClassName) {
          tetherProps.className = tetherElementClassName;
        }
        if (offset) {
          tetherProps.offset = offset;
        }
        return /*#__PURE__*/ react.createElement(
          react_tether /* default */.A,
          RadarAnimation_extends(
            {
              ref: this.tetherRef,
            },
            tetherProps,
          ),
          referenceElement,
          isShown &&
            /*#__PURE__*/ react.createElement(
              'div',
              RadarAnimation_extends(
                {
                  className: `radar ${className}`,
                  id: this.radarAnimationID,
                },
                rest,
              ),
              /*#__PURE__*/ react.createElement('div', {
                className: 'radar-dot',
              }),
              /*#__PURE__*/ react.createElement('div', {
                className: 'radar-circle',
              }),
            ),
        );
      }
    }
    RadarAnimation_defineProperty(RadarAnimation, 'defaultProps', {
      constrainToScrollParent: false,
      constrainToWindow: true,
      isShown: true,
      position: RadarAnimationPosition.MIDDLE_RIGHT,
    });
    /* harmony default export */ const radar_RadarAnimation = RadarAnimation; // CONCATENATED MODULE: ./src/components/radar/index.ts
    // CONCATENATED MODULE: ./src/components/button/Button.tsx
    const Button_excluded = [
      'children',
      'className',
      'icon',
      'isDisabled',
      'isLoading',
      'isSelected',
      'setRef',
      'size',
      'type',
      'showRadar',
    ];
    function Button_extends() {
      return (
        (Button_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Button_extends.apply(null, arguments)
      );
    }
    function Button_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Button_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Button_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function Button_defineProperty(e, r, t) {
      return (
        (r = Button_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Button_toPropertyKey(t) {
      var i = Button_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Button_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /* eslint-disable react/button-has-type */

    let ButtonType = /*#__PURE__*/ (function (ButtonType) {
      ButtonType['BUTTON'] = 'button';
      ButtonType['RESET'] = 'reset';
      ButtonType['SUBMIT'] = 'submit';
      return ButtonType;
    })({});
    class Button extends react.Component {
      constructor(...args) {
        super(...args);
        Button_defineProperty(this, 'btnElement', null);
        Button_defineProperty(this, 'handleClick', event => {
          const { isDisabled, onClick } = this.props;
          if (isDisabled || (this.btnElement && this.btnElement.classList.contains('is-disabled'))) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          if (onClick) {
            onClick(event);
          }
        });
      }
      render() {
        const _this$props = this.props,
          { children, className, icon, isDisabled, isLoading, isSelected, setRef, size, type, showRadar } = _this$props,
          rest = Button_objectWithoutProperties(_this$props, Button_excluded);
        const buttonProps = omit_default()(rest, ['onClick']);
        if (isDisabled) {
          buttonProps['aria-disabled'] = true;
        }
        const styleClassName = classnames_default()(
          'btn',
          {
            'is-disabled': isDisabled,
            'is-loading': isLoading,
            'is-selected': isSelected,
            'bdl-is-disabled': isDisabled,
            'bdl-btn--large': size === 'large',
            'bdl-has-icon': !!icon,
          },
          className,
        );
        let button = /*#__PURE__*/ react.createElement(
          'button',
          Button_extends(
            {
              ref: element => {
                this.btnElement = element;
                if (setRef) {
                  setRef(element);
                }
              },
              className: styleClassName,
              onClick: this.handleClick,
              type: type,
            },
            buttonProps,
          ),
          children
            ? /*#__PURE__*/ react.createElement(
                'span',
                {
                  className: 'btn-content',
                },
                children,
              )
            : null,
          icon
            ? /*#__PURE__*/ react.createElement(
                'span',
                {
                  className: 'bdl-btn-icon',
                },
                /*#__PURE__*/ react.cloneElement(icon, {
                  width: icon && children ? 16 : 20,
                  height: icon && children ? 16 : 20,
                }),
              )
            : null,
          isLoading &&
            /*#__PURE__*/ react.createElement(loading_indicator_LoadingIndicator, {
              className: 'btn-loading-indicator',
            }),
        );
        if (showRadar) {
          button = /*#__PURE__*/ react.createElement(radar_RadarAnimation, null, button);
        }
        return button;
      }
    }
    Button_defineProperty(Button, 'defaultProps', {
      className: '',
      isLoading: false,
      showRadar: false,
      type: ButtonType.SUBMIT,
    });
    /* harmony default export */ const button_Button = Button; // CONCATENATED MODULE: ./src/components/button/index.ts
    // CONCATENATED MODULE: ./src/components/plain-button/PlainButton.tsx
    const PlainButton_excluded = ['children', 'className', 'getDOMRef', 'isDisabled', 'type'];
    function PlainButton_extends() {
      return (
        (PlainButton_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        PlainButton_extends.apply(null, arguments)
      );
    }
    function PlainButton_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = PlainButton_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function PlainButton_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const PlainButton = _ref => {
      let { children, className = '', getDOMRef = noop_default(), isDisabled = false, type = ButtonType.SUBMIT } = _ref,
        rest = PlainButton_objectWithoutProperties(_ref, PlainButton_excluded);
      const buttonProps = {};
      if (isDisabled) {
        buttonProps['aria-disabled'] = true;
        buttonProps.onClick = event => {
          event.preventDefault();
          event.stopPropagation();
        };
      }
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/button-has-type
        react.createElement(
          'button',
          PlainButton_extends(
            {
              className: `btn-plain ${className}`,
              ref: getDOMRef,
              type: type,
            },
            rest,
            buttonProps,
          ),
          children,
        )
      );
    };
    /* harmony default export */ const plain_button_PlainButton = PlainButton; // CONCATENATED MODULE: ./src/icons/general/IconChevron.tsx
    let DirectionType = /*#__PURE__*/ (function (DirectionType) {
      DirectionType['DOWN'] = 'down';
      DirectionType['LEFT'] = 'left';
      DirectionType['RIGHT'] = 'right';
      DirectionType['UP'] = 'up';
      return DirectionType;
    })({});
    const rotations = {
      [DirectionType.DOWN]: 135,
      [DirectionType.LEFT]: 225,
      [DirectionType.RIGHT]: 45,
      [DirectionType.UP]: 315,
    };
    const IconChevron = ({
      className = '',
      color = '#000',
      direction = DirectionType.UP,
      size = '9px',
      thickness = '2px',
    }) =>
      /*#__PURE__*/ react.createElement('span', {
        className: `icon-chevron icon-chevron-${direction} ${className}`,
        style: {
          borderColor: color,
          borderStyle: 'solid solid none none',
          borderWidth: thickness,
          display: 'inline-block',
          height: size,
          transform: `rotate(${rotations[direction]}deg)`,
          width: size,
        },
      });
    /* harmony default export */ const general_IconChevron = IconChevron; // CONCATENATED MODULE: ./src/elements/common/breadcrumbs/BreadcrumbDelimiter.js
    /**
     *
     * @file Clickable breadcrumb component
     * @author Box
     */

    const BreadcrumbDelimiter = ({ delimiter }) =>
      delimiter === DELIMITER_CARET
        ? /*#__PURE__*/ react.createElement(general_IconChevron, {
            className: 'be-breadcrumb-seperator',
            color: COLOR_999,
            direction: 'right',
            size: '7px',
          })
        : /*#__PURE__*/ react.createElement('span', null, '/');
    /* harmony default export */ const breadcrumbs_BreadcrumbDelimiter = BreadcrumbDelimiter; // CONCATENATED MODULE: ./src/elements/common/breadcrumbs/Breadcrumb.js
    /**
     *
     * @file Clickable breadcrumb component
     * @author Box
     */

    const Breadcrumb = ({ name = '', onClick, isLast, delimiter }) => {
      const title = onClick
        ? /*#__PURE__*/ react.createElement(
            plain_button_PlainButton,
            {
              onClick: onClick,
              type: 'button',
              className: 'bdl-Breadcrumb-title',
            },
            name,
          )
        : /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'bdl-Breadcrumb-title',
            },
            name,
          );
      return /*#__PURE__*/ react.createElement(
        'span',
        {
          className: 'be-breadcrumb',
        },
        title,
        isLast
          ? null
          : /*#__PURE__*/ react.createElement(breadcrumbs_BreadcrumbDelimiter, {
              delimiter: delimiter,
            }),
      );
    };
    /* harmony default export */ const breadcrumbs_Breadcrumb = Breadcrumb; // CONCATENATED MODULE: ./src/components/dropdown-menu/DropdownMenu.js
    function DropdownMenu_defineProperty(e, r, t) {
      return (
        (r = DropdownMenu_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function DropdownMenu_toPropertyKey(t) {
      var i = DropdownMenu_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function DropdownMenu_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    class DropdownMenu extends react.Component {
      constructor(...args) {
        super(...args);
        DropdownMenu_defineProperty(this, 'menuID', uniqueId_default()('menu'));
        DropdownMenu_defineProperty(this, 'menuButtonID', uniqueId_default()('menubutton'));
        DropdownMenu_defineProperty(this, 'state', {
          initialFocusIndex: null,
          isOpen: false,
        });
        DropdownMenu_defineProperty(this, 'openMenuAndSetFocusIndex', initialFocusIndex => {
          this.setState({
            initialFocusIndex,
            isOpen: true,
          });
        });
        DropdownMenu_defineProperty(this, 'closeMenu', event => {
          const { onMenuClose = noop_default() } = this.props;
          this.setState(
            {
              isOpen: false,
            },
            () => onMenuClose(event),
          );
        });
        DropdownMenu_defineProperty(this, 'focusButton', () => {
          // @NOTE: This breaks encapsulation a bit, but the only other way is passing ref functions to unknown children components
          const menuButtonEl = document.getElementById(this.menuButtonID);
          if (menuButtonEl) {
            menuButtonEl.focus();
          }
        });
        DropdownMenu_defineProperty(this, 'handleButtonClick', event => {
          const { isOpen } = this.state;
          event.stopPropagation();
          event.preventDefault();
          if (isOpen) {
            this.closeMenu(event);
          } else {
            this.openMenuAndSetFocusIndex(null);
          }
        });
        DropdownMenu_defineProperty(this, 'handleButtonKeyDown', event => {
          const { isOpen } = this.state;
          switch (event.key) {
            case constants_KEYS.space:
            case constants_KEYS.enter:
            case constants_KEYS.arrowDown:
              event.stopPropagation();
              event.preventDefault();
              this.openMenuAndSetFocusIndex(0);
              break;
            case constants_KEYS.arrowUp:
              event.stopPropagation();
              event.preventDefault();
              this.openMenuAndSetFocusIndex(-1);
              break;
            case constants_KEYS.escape:
              if (isOpen) {
                event.stopPropagation();
              }
              event.preventDefault();
              this.closeMenu(event);
              break;
            default:
              break;
          }
        });
        DropdownMenu_defineProperty(this, 'handleMenuClose', (isKeyboardEvent, event) => {
          this.closeMenu(event);
          this.focusButton();
        });
        DropdownMenu_defineProperty(this, 'handleDocumentClick', event => {
          const menuEl = document.getElementById(this.menuID);
          const menuButtonEl = document.getElementById(this.menuButtonID);

          // Some DOM magic to get global click handlers to close menu when not interacting with menu or associated button
          if (
            menuEl &&
            menuButtonEl &&
            event.target instanceof Node &&
            !menuEl.contains(event.target) &&
            !menuButtonEl.contains(event.target)
          ) {
            this.closeMenu(event);
          }
        });
      }
      componentDidUpdate(prevProps, prevState) {
        const { useBubble } = this.props;
        if (!prevState.isOpen && this.state.isOpen) {
          // When menu is being opened
          document.addEventListener('click', this.handleDocumentClick, !useBubble);
          document.addEventListener('contextmenu', this.handleDocumentClick, !useBubble);
          const { onMenuOpen } = this.props;
          if (onMenuOpen) {
            onMenuOpen();
          }
        } else if (prevState.isOpen && !this.state.isOpen) {
          // When menu is being closed
          document.removeEventListener('contextmenu', this.handleDocumentClick, !useBubble);
          document.removeEventListener('click', this.handleDocumentClick, !useBubble);
        }
      }
      componentWillUnmount() {
        const { useBubble } = this.props;
        if (this.state.isOpen) {
          // Clean-up global click handlers
          document.removeEventListener('contextmenu', this.handleDocumentClick, !useBubble);
          document.removeEventListener('click', this.handleDocumentClick, !useBubble);
        }
      }
      render() {
        const {
          bodyElement,
          children,
          className,
          constrainToScrollParent,
          constrainToWindow,
          constrainToWindowWithPin,
          isResponsive,
          isRightAligned,
          tetherAttachment,
          tetherTargetAttachment,
        } = this.props;
        const { isOpen, initialFocusIndex } = this.state;
        const elements = react.Children.toArray(children);
        if (elements.length !== 2) {
          throw new Error('DropdownMenu must have exactly two children: A button component and a <Menu>');
        }
        const menuButton = elements[0];
        const menu = elements[1];
        const menuButtonProps = {
          id: this.menuButtonID,
          key: this.menuButtonID,
          onClick: this.handleButtonClick,
          // NOTE: Overrides button's handler
          onKeyDown: this.handleButtonKeyDown,
          // NOTE: Overrides button's handler
          'aria-expanded': isOpen ? 'true' : 'false',
        };
        if (menuButton.props['aria-haspopup'] === undefined) {
          menuButtonProps['aria-haspopup'] = 'true';
        }

        // Add this only when its open, otherwise the menuID element isn't rendered
        if (isOpen) {
          menuButtonProps['aria-controls'] = this.menuID;
        }
        const menuProps = {
          id: this.menuID,
          key: this.menuID,
          initialFocusIndex,
          onClose: this.handleMenuClose,
          'aria-labelledby': this.menuButtonID,
        };
        let attachment = 'top left';
        let targetAttachment = 'bottom left';
        if (isRightAligned) {
          attachment = 'top right';
          targetAttachment = 'bottom right';
        }
        const constraints = [];
        if (constrainToScrollParent) {
          constraints.push({
            to: 'scrollParent',
            attachment: 'together',
          });
        }
        if (constrainToWindow) {
          constraints.push({
            to: 'window',
            attachment: 'together',
          });
        }
        if (constrainToWindowWithPin) {
          constraints.push({
            to: 'window',
            attachment: 'together',
            pin: true,
          });
        }
        const bodyEl = bodyElement instanceof HTMLElement ? bodyElement : document.body;
        return /*#__PURE__*/ react.createElement(
          react_tether /* default */.A,
          {
            attachment: tetherAttachment || attachment,
            bodyElement: bodyEl,
            className: classnames_default()(
              {
                'bdl-DropdownMenu--responsive': isResponsive,
              },
              className,
            ),
            classPrefix: 'dropdown-menu',
            constraints: constraints,
            enabled: isOpen,
            targetAttachment: tetherTargetAttachment || targetAttachment,
          },
          /*#__PURE__*/ react.cloneElement(menuButton, menuButtonProps),
          isOpen && /*#__PURE__*/ react.cloneElement(menu, menuProps),
        );
      }
    }
    DropdownMenu_defineProperty(DropdownMenu, 'defaultProps', {
      constrainToScrollParent: false,
      constrainToWindow: false,
      isResponsive: false,
      isRightAligned: false,
    });
    /* harmony default export */ const dropdown_menu_DropdownMenu = DropdownMenu; // CONCATENATED MODULE: ./src/components/menu/MenuContext.tsx
    /* harmony default export */ const menu_MenuContext = /*#__PURE__*/ react.createContext({
      closeMenu: noop_default(),
    }); // CONCATENATED MODULE: ./src/components/menu/Menu.tsx
    const Menu_excluded = ['children', 'className', 'isHidden', 'setRef', 'shouldOutlineFocus'];
    function Menu_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Menu_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Menu_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function Menu_defineProperty(e, r, t) {
      return (
        (r = Menu_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Menu_toPropertyKey(t) {
      var i = Menu_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Menu_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    /**
     * The selectors are used to identify the menu item that is selected. We need to eventually
     * rewrite this logic as there seem to be strong coupling between the selector and MenuItem
     * that we want to decouple. The span is here to allow Menu to recognize MenuItem even if it is
     * wrapped by a span coming from a tooltip.
     */
    const MENU_ITEM_SELECTOR = '.menu-item:not([aria-disabled])';
    const TOP_LEVEL_MENU_ITEM_SELECTOR = `ul:not(.submenu) > ${MENU_ITEM_SELECTOR}, ul:not(.submenu) > li > ${MENU_ITEM_SELECTOR}, ul:not(.submenu) > span > ${MENU_ITEM_SELECTOR}`;
    const SUBMENU_ITEM_SELECTOR = `ul.submenu > ${MENU_ITEM_SELECTOR}, ul.submenu > li > ${MENU_ITEM_SELECTOR}, ul.submenu > span > ${MENU_ITEM_SELECTOR}`;
    function stopPropagationAndPreventDefault(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    class Menu extends react.Component {
      constructor(_props) {
        super(_props);
        Menu_defineProperty(this, 'setInitialFocusIndex', (props = this.props) => {
          const { initialFocusIndex, isHidden } = props;
          if (isHidden || initialFocusIndex === undefined) {
            return;
          }

          // If an initialFocusIndex was specified, attempt to use it to focus
          if (typeof initialFocusIndex === 'number') {
            // We do this after a timeout so that the menu is properly mounted before we attempt to focus it
            setTimeout(() => {
              this.setFocus(initialFocusIndex);
            }, 0);
          } else if (initialFocusIndex === null) {
            // If no initial focus index is set, focus on the menu itself so that keyboard shortcut still works after a mouse click.
            setTimeout(() => {
              if (this.menuEl) {
                this.menuEl.focus();
              }
            }, 0);
          }
        });
        Menu_defineProperty(this, 'setMenuItemEls', () => {
          const { isSubmenu, menuItemSelector } = this.props;
          const selector = menuItemSelector || (isSubmenu ? SUBMENU_ITEM_SELECTOR : TOP_LEVEL_MENU_ITEM_SELECTOR);
          // Keep track of all the valid menu items that were rendered (querySelector since we don't want to pass ref functions to every single child)
          this.menuItemEls = this.menuEl ? [].slice.call(this.menuEl.querySelectorAll(selector)) : [];
        });
        Menu_defineProperty(this, 'getMenuItemElFromEventTarget', target => {
          let menuItemEl = null;
          let menuIndex = -1;
          for (let i = 0; i < this.menuItemEls.length; i += 1) {
            if (this.menuItemEls[i].contains(target)) {
              menuItemEl = this.menuItemEls[i];
              menuIndex = i;
              break;
            }
          }
          return {
            menuItemEl,
            menuIndex,
          };
        });
        Menu_defineProperty(this, 'setFocus', index => {
          if (!this.menuItemEls.length) {
            return;
          }
          const numMenuItems = this.menuItemEls.length;
          if (index >= numMenuItems) {
            this.focusIndex = 0;
          } else if (index < 0) {
            this.focusIndex = numMenuItems - 1;
          } else {
            this.focusIndex = index;
          }
          this.menuItemEls[this.focusIndex].focus();
        });
        Menu_defineProperty(this, 'focusFirstItem', () => {
          this.setFocus(0);
        });
        Menu_defineProperty(this, 'focusLastItem', () => {
          this.setFocus(-1);
        });
        Menu_defineProperty(this, 'focusNextItem', () => {
          this.setFocus(this.focusIndex + 1);
        });
        Menu_defineProperty(this, 'focusPreviousItem', () => {
          this.setFocus(this.focusIndex - 1);
        });
        Menu_defineProperty(this, 'fireOnCloseHandler', (isKeyboardEvent, event) => {
          const { onClose } = this.props;
          if (onClose) {
            // We need to pass the event type so we know which item to focus.
            onClose(isKeyboardEvent, event);
          }
        });
        Menu_defineProperty(this, 'handleClick', event => {
          const { menuItemEl } = event.target instanceof Node ? this.getMenuItemElFromEventTarget(event.target) : {};
          if (!menuItemEl) {
            return;
          }
          this.fireOnCloseHandler(false, event);
        });
        Menu_defineProperty(this, 'handleKeyDown', event => {
          const { isSubmenu, initialFocusIndex } = this.props;
          switch (event.key) {
            case 'ArrowDown':
              stopPropagationAndPreventDefault(event); // If it's first keyboard event, focus on first item.

              if (initialFocusIndex === null && !this.keyboardPressed) {
                this.focusFirstItem();
              } else {
                this.focusNextItem();
              }
              break;
            case 'ArrowUp':
              stopPropagationAndPreventDefault(event);
              this.focusPreviousItem();
              break;
            case 'ArrowLeft':
              // Close submenu when arrow-left is clicked
              if (!isSubmenu) {
                return;
              }
              stopPropagationAndPreventDefault(event);
              this.fireOnCloseHandler(true, event);
              break;
            case 'Home':
            case 'PageUp':
              stopPropagationAndPreventDefault(event);
              this.focusFirstItem();
              break;
            case 'End':
            case 'PageDown':
              stopPropagationAndPreventDefault(event);
              this.focusLastItem();
              break;
            case 'Escape':
              stopPropagationAndPreventDefault(event);
              this.fireOnCloseHandler(true, event);
              break;
            case 'Tab':
              // DO NOT PREVENT DEFAULT OR STOP PROPAGATION - This should move focus natively
              this.fireOnCloseHandler(true, event);
              break;
            case ' ':
            case 'Enter':
              stopPropagationAndPreventDefault(event);
              if (event.target instanceof HTMLElement) {
                event.target.click();
              }
              break;
            default:
              break;
          }
          this.keyboardPressed = true;
        });
        this.focusIndex = 0;
        this.menuEl = null;
        this.menuItemEls = [];
      }
      componentDidMount() {
        this.setMenuItemEls();
        this.setInitialFocusIndex();
      }
      componentDidUpdate({ isHidden: prevIsHidden, children: prevChildren }) {
        const { children, isHidden, isSubmenu } = this.props;
        if (isSubmenu && prevIsHidden && !isHidden) {
          // If updating submenu, use the current props instead of previous props.
          this.setMenuItemEls();
          this.setInitialFocusIndex(this.props);
        }

        // update focus index and menu item elements when the number of children changes
        if (react.Children.toArray(prevChildren).length !== react.Children.toArray(children).length) {
          const focusedMenuItemEl = this.menuItemEls[this.focusIndex];
          this.setMenuItemEls();
          const { menuIndex } = this.getMenuItemElFromEventTarget(focusedMenuItemEl);
          const isFocusedElementMissing = menuIndex === -1;
          const isFocusIndexOutOfBounds = this.focusIndex >= this.menuItemEls.length;
          this.setFocus(isFocusedElementMissing && !isFocusIndexOutOfBounds ? this.focusIndex : menuIndex);
        }
      }
      render() {
        const _this$props = this.props,
          { children, className, isHidden, setRef, shouldOutlineFocus } = _this$props,
          rest = Menu_objectWithoutProperties(_this$props, Menu_excluded);
        const menuProps = omit_default()(rest, ['onClose', 'initialFocusIndex', 'isSubmenu', 'menuItemSelector']);
        menuProps.className = classnames_default()('aria-menu', className, {
          'is-hidden': isHidden,
          'should-outline-focus': shouldOutlineFocus,
        });
        menuProps.ref = ref => {
          this.menuEl = ref;
          if (setRef) {
            setRef(ref);
          }
        };
        if (menuProps.role === undefined) {
          menuProps.role = 'menu';
        }
        menuProps.tabIndex = -1;
        menuProps.onClick = this.handleClick;
        menuProps.onKeyDown = this.handleKeyDown;
        return /*#__PURE__*/ react.createElement(
          'ul',
          menuProps,
          /*#__PURE__*/ react.createElement(
            menu_MenuContext.Provider,
            {
              value: {
                closeMenu: this.fireOnCloseHandler,
              },
            },
            children,
          ),
        );
      }
    }
    Menu_defineProperty(Menu, 'defaultProps', {
      className: '',
      isSubmenu: false,
      isHidden: false,
    });
    /* harmony default export */ const menu_Menu = Menu; // CONCATENATED MODULE: ./src/components/menu/MenuItem.tsx
    const MenuItem_excluded = ['children', 'className', 'isDisabled', 'isSelectItem', 'isSelected', 'showRadar'];
    function MenuItem_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = MenuItem_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function MenuItem_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function MenuItem_defineProperty(e, r, t) {
      return (
        (r = MenuItem_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MenuItem_toPropertyKey(t) {
      var i = MenuItem_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MenuItem_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    class MenuItem_MenuItem extends react.Component {
      constructor(...args) {
        super(...args);
        MenuItem_defineProperty(this, 'onClickHandler', event => {
          const { isDisabled, onClick } = this.props;

          // If aria-disabled is passed as a prop, we should ignore clicks on this menu item
          if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
          }
          if (onClick) {
            onClick(event);
          }
        });
      }
      render() {
        const _this$props = this.props,
          { children, className, isDisabled, isSelectItem, isSelected, showRadar } = _this$props,
          rest = MenuItem_objectWithoutProperties(_this$props, MenuItem_excluded);
        const menuItemProps = omit_default()(rest, ['role', 'tabIndex', 'onClick']);
        menuItemProps.className = classnames_default()('menu-item', className, {
          'is-select-item': isSelectItem,
          'is-selected': isSelected,
        });
        menuItemProps.role = isSelectItem ? 'menuitemradio' : 'menuitem';
        menuItemProps.tabIndex = -1;
        menuItemProps.onClick = this.onClickHandler;
        if (isSelectItem) {
          menuItemProps['aria-checked'] = isSelected;
        }
        if (isDisabled) {
          menuItemProps['aria-disabled'] = 'true';
        }
        let menuItem = /*#__PURE__*/ react.createElement('li', menuItemProps, children);
        if (showRadar) {
          menuItem = /*#__PURE__*/ react.createElement(radar_RadarAnimation, null, menuItem);
        }
        return menuItem;
      }
    }
    /* harmony default export */ const menu_MenuItem = MenuItem_MenuItem; // CONCATENATED MODULE: ./src/elements/common/breadcrumbs/BreadcrumbDropdown.js
    /**
     *
     * @file Drop down part of breadcrumbs
     * @author Box
     */

    const BreadcrumbDropdown = ({ crumbs, onCrumbClick, className = '' }) =>
      /*#__PURE__*/ react.createElement(
        dropdown_menu_DropdownMenu,
        {
          constrainToScrollParent: true,
        },
        /*#__PURE__*/ react.createElement(
          plain_button_PlainButton,
          {
            className: `be-breadcrumbs-drop-down ${className}`,
            type: 'button',
          },
          '\xB7\xB7\xB7',
        ),
        /*#__PURE__*/ react.createElement(
          menu_Menu,
          null,
          crumbs.map(({ id, name }) =>
            /*#__PURE__*/ react.createElement(
              menu_MenuItem,
              {
                key: id,
                onClick: () => onCrumbClick(id),
              },
              name,
            ),
          ),
        ),
      );
    /* harmony default export */ const breadcrumbs_BreadcrumbDropdown = BreadcrumbDropdown; // CONCATENATED MODULE: ./src/elements/common/breadcrumbs/Breadcrumbs.js
    /**
     *
     * @file Component that creates breadcumbs for both the header and name details
     * @author Box
     */

    /**
     * Filters out ancestors to root from the crumbs.
     * This is useful when the root is not All Files.
     *
     * @private
     * @param {string} rootId the root folder id
     * @param {Array} crumbs list of crumbs
     * @return {Array} crumbs
     */
    function filterCrumbs(rootId, crumbs) {
      const rootIndex = crumbs.findIndex(crumb => crumb.id === rootId);
      return rootIndex === -1 ? crumbs : crumbs.slice(rootIndex);
    }

    /**
     * Creates an individual breadcrumb
     *
     * @private
     * @param {Object} crumb single crumb data
     * @param {boolean} isLast is this the last crumb
     * @return {Element}
     */
    function getBreadcrumb(crumbs, isLast, onCrumbClick, delimiter) {
      if (Array.isArray(crumbs)) {
        const condensed = delimiter !== DELIMITER_CARET;
        return /*#__PURE__*/ react.createElement(
          'span',
          {
            className: 'be-breadcrumb-more',
          },
          /*#__PURE__*/ react.createElement(breadcrumbs_BreadcrumbDropdown, {
            className: condensed ? 'be-breadcrumbs-condensed' : '',
            crumbs: crumbs,
            onCrumbClick: onCrumbClick,
          }),
          /*#__PURE__*/ react.createElement(breadcrumbs_BreadcrumbDelimiter, {
            delimiter: condensed ? DELIMITER_SLASH : DELIMITER_CARET,
          }),
        );
      }
      const { id, name } = crumbs;
      return /*#__PURE__*/ react.createElement(breadcrumbs_Breadcrumb, {
        delimiter: delimiter,
        isLast: isLast,
        name: name,
        onClick: () => onCrumbClick(id),
      });
    }
    const Breadcrumbs = ({ rootId, crumbs, onCrumbClick, delimiter, isSmall = false, intl }) => {
      if (!rootId || crumbs.length === 0) {
        return /*#__PURE__*/ react.createElement('span', null);
      }

      // The crumbs given may have ancestors higher than the root. We need to filter them out.
      const filteredCrumbs = filterCrumbs(rootId, crumbs);

      // Make sure "All Files" crumb is localized
      const defaultRootCrumb = filteredCrumbs.find(({ id }) => id === DEFAULT_ROOT);
      if (defaultRootCrumb) {
        defaultRootCrumb.name = intl.formatMessage(common_messages.rootBreadcrumb);
      }
      const { length } = filteredCrumbs;

      // Always show the last/leaf breadcrumb.
      const crumb = filteredCrumbs[length - 1];
      const onClick = crumb.id ? () => onCrumbClick(crumb.id) : undefined;
      const lastBreadcrumb = /*#__PURE__*/ react.createElement(breadcrumbs_Breadcrumb, {
        isLast: true,
        name: crumb.name,
        onClick: onClick,
      });

      // Always show the second last/parent breadcrumb when there are at least 2 crumbs.
      const secondLastBreadcrumb =
        length > 1 ? getBreadcrumb(filteredCrumbs[length - 2], false, onCrumbClick, delimiter) : null;

      // Only show the more dropdown when there were at least 4 crumbs.
      const moreBreadcrumbs =
        length > 3 ? getBreadcrumb(filteredCrumbs.slice(1, length - 2), false, onCrumbClick, delimiter) : null;

      // Only show the root breadcrumb when there are at least 3 crumbs.
      const firstBreadcrumb = length > 2 ? getBreadcrumb(filteredCrumbs[0], false, onCrumbClick, delimiter) : null;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-breadcrumbs',
        },
        isSmall ? null : firstBreadcrumb,
        isSmall ? null : moreBreadcrumbs,
        secondLastBreadcrumb,
        lastBreadcrumb,
      );
    };

    /* harmony default export */ const breadcrumbs_Breadcrumbs = injectIntl(Breadcrumbs); // CONCATENATED MODULE: ./src/elements/common/breadcrumbs/InlineBreadcrumbs.js
    /**
     *
     * @file Component for the details for the item name
     * @author Box
     */

    const InlineBreadcrumbs = ({ item, onItemClick, rootId }) => {
      const { path_collection } = item;
      const { entries: breadcrumbs = [] } = path_collection || {};
      return /*#__PURE__*/ react.createElement(
        'span',
        {
          className: 'be-inline-breadcrumbs',
        },
        /*#__PURE__*/ react.createElement(components_message, common_messages.in),
        '\xA0',
        /*#__PURE__*/ react.createElement(breadcrumbs_Breadcrumbs, {
          crumbs: breadcrumbs,
          delimiter: DELIMITER_SLASH,
          onCrumbClick: onItemClick,
          rootId: rootId,
        }),
      );
    };
    /* harmony default export */ const breadcrumbs_InlineBreadcrumbs = InlineBreadcrumbs; // CONCATENATED MODULE: ./src/elements/common/breadcrumbs/index.js
    // CONCATENATED MODULE: ./src/elements/common/sub-header/SubHeaderLeft.js
    /**
     *
     * @file Content sub header component
     * @author Box
     */

    const SubHeaderLeft = ({ view, isSmall, rootId, rootName, currentCollection, onItemClick, intl }) => {
      let crumbs;
      if (view === VIEW_FOLDER || view === VIEW_SEARCH) {
        const { id, name = '', breadcrumbs = [] } = currentCollection;
        crumbs = breadcrumbs.concat({
          id,
          name,
        });

        // Search results are specific to the current folder
        // hence the breadcrumb is added to the end of the list
        if (view === VIEW_SEARCH) {
          crumbs = crumbs.concat({
            id: undefined,
            name: intl.formatMessage(common_messages.searchBreadcrumb),
          });
        }
      } else {
        crumbs = [
          {
            id: undefined,
            name: intl.formatMessage(common_messages[`${view}Breadcrumb`]),
          },
        ];
        if (view !== VIEW_RECENTS) {
          crumbs.unshift({
            id: rootId,
            name: rootName || intl.formatMessage(common_messages.rootBreadcrumb),
          });
        }
      }
      return /*#__PURE__*/ react.createElement(breadcrumbs_Breadcrumbs, {
        crumbs: crumbs,
        delimiter: DELIMITER_CARET,
        isSmall: isSmall,
        onCrumbClick: onItemClick,
        rootId: rootId,
      });
    };
    /* harmony default export */ const sub_header_SubHeaderLeft = injectIntl(SubHeaderLeft); // CONCATENATED MODULE: ./src/components/menu/SelectMenuItem.tsx
    function SelectMenuItem_extends() {
      return (
        (SelectMenuItem_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        SelectMenuItem_extends.apply(null, arguments)
      );
    }

    const SelectMenuItem = props =>
      /*#__PURE__*/ react.createElement(
        menu_MenuItem,
        SelectMenuItem_extends(
          {
            isSelectItem: true,
          },
          props,
        ),
      );
    /* harmony default export */ const menu_SelectMenuItem = SelectMenuItem; // CONCATENATED MODULE: ./src/icons/general/IconSort.tsx
    const IconSort = ({ className = '', color = '#222222', height = 13, title, width = 17 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-sort ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 17.49 13.49',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M8.48 4.24L4.74.5V.24h-.25L4.24 0 4 .24h-.26V.5L0 4.24l.71.71 3.03-3.04v11.33h1V1.91l3.04 3.04.7-.71m.52 5l3.74 3.74v.26H13l.24.24.24-.24h.26v-.26l3.74-3.74-.7-.7-3.04 3.03V.24h-1v11.33L9.71 8.54l-.71.7',
          fill: color,
        }),
      );
    /* harmony default export */ const general_IconSort = IconSort; // CONCATENATED MODULE: ./src/common/tether-positions.tsx
    var TetherPosition = /*#__PURE__*/ (function (TetherPosition) {
      TetherPosition['TOP_LEFT'] = 'top left';
      TetherPosition['TOP_CENTER'] = 'top center';
      TetherPosition['TOP_RIGHT'] = 'top right';
      TetherPosition['MIDDLE_LEFT'] = 'middle left';
      TetherPosition['MIDDLE_CENTER'] = 'middle center';
      TetherPosition['MIDDLE_RIGHT'] = 'middle right';
      TetherPosition['BOTTOM_LEFT'] = 'bottom left';
      TetherPosition['BOTTOM_CENTER'] = 'bottom center';
      TetherPosition['BOTTOM_RIGHT'] = 'bottom right';
      return TetherPosition;
    })(TetherPosition || {});
    /* harmony default export */ const tether_positions = TetherPosition; // CONCATENATED MODULE: ./src/components/accessible-svg/AccessibleSVG.tsx
    const accessible_svg_AccessibleSVG_excluded = ['children', 'title'];
    function accessible_svg_AccessibleSVG_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = accessible_svg_AccessibleSVG_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function accessible_svg_AccessibleSVG_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function accessible_svg_AccessibleSVG_defineProperty(e, r, t) {
      return (
        (r = accessible_svg_AccessibleSVG_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function accessible_svg_AccessibleSVG_toPropertyKey(t) {
      var i = accessible_svg_AccessibleSVG_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function accessible_svg_AccessibleSVG_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    class accessible_svg_AccessibleSVG_AccessibleSVG extends react.Component {
      constructor(...args) {
        super(...args);
        accessible_svg_AccessibleSVG_defineProperty(this, 'id', uniqueId_default()('icon'));
      }
      render() {
        const _this$props = this.props,
          { children, title } = _this$props,
          rest = accessible_svg_AccessibleSVG_objectWithoutProperties(
            _this$props,
            accessible_svg_AccessibleSVG_excluded,
          );
        const titleID = `${this.id}-title`;

        // Make sure parent doesn't accidentally override these values
        const svgProps = omit_default()(rest, ['role', 'aria-labelledby']);

        // Accessibility fix for IE11, which treats all SVGs as focusable by default
        svgProps.focusable = 'false';
        if (title) {
          svgProps['aria-labelledby'] = titleID;
          svgProps.role = 'img';
        } else {
          svgProps['aria-hidden'] = 'true';
          svgProps.role = 'presentation';
        }
        return /*#__PURE__*/ react.createElement(
          'svg',
          svgProps,
          title
            ? /*#__PURE__*/ react.createElement(
                'title',
                {
                  id: titleID,
                },
                title,
              )
            : null,
          children,
        );
      }
    }
    /* harmony default export */ const components_accessible_svg_AccessibleSVG =
      accessible_svg_AccessibleSVG_AccessibleSVG; // CONCATENATED MODULE: ./src/icon/fill/X16.tsx
    function X16_extends() {
      return (
        (X16_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        X16_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const X16 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        X16_extends(
          {
            width: 16,
            height: 16,
            viewBox: '0 0 16 16',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          fill: bdlGray50,
          fillRule: 'evenodd',
          d: 'M8 6.586l4.182-4.182a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L9.414 8l4.182 4.182a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L8 9.414l-4.182 4.182a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L6.586 8 2.404 3.818a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L8 6.586z',
        }),
      );
    /* harmony default export */ const fill_X16 = X16; // CONCATENATED MODULE: ./src/components/plain-button/index.ts
    // CONCATENATED MODULE: ./src/common/messages.js
    const common_messages_messages = defineMessages({
      cancel: {
        id: 'boxui.core.cancel',
        defaultMessage: 'Cancel',
      },
      close: {
        id: 'boxui.core.close',
        defaultMessage: 'Close',
      },
      copy: {
        id: 'boxui.core.copy',
        defaultMessage: 'Copy',
      },
      copied: {
        id: 'boxui.core.copied',
        defaultMessage: 'Copied',
      },
      done: {
        id: 'boxui.core.done',
        defaultMessage: 'Done',
      },
      okay: {
        id: 'boxui.core.okay',
        defaultMessage: 'Okay',
      },
      save: {
        id: 'boxui.core.save',
        defaultMessage: 'Save',
      },
      send: {
        id: 'boxui.core.send',
        defaultMessage: 'Send',
      },
      optional: {
        id: 'boxui.core.optional',
        defaultMessage: 'optional',
      },
      pillSelectorPlaceholder: {
        id: 'boxui.share.pillSelectorPlaceholder',
        defaultMessage: 'Add names or email addresses',
      },
      messageSelectorPlaceholder: {
        id: 'boxui.share.messageSelectorPlaceholder',
        defaultMessage: 'Add a message',
      },
      invalidInputError: {
        id: 'boxui.validation.genericError',
        defaultMessage: 'Invalid Input',
      },
      minLengthError: {
        id: 'boxui.validation.tooShortError',
        defaultMessage: 'Input must be at least {min} characters',
      },
      maxLengthError: {
        id: 'boxui.validation.tooLongError',
        defaultMessage: 'Input cannot exceed {max} characters',
      },
      invalidEmailError: {
        id: 'boxui.validation.emailError',
        defaultMessage: 'Invalid Email Address',
      },
      invalidURLError: {
        id: 'boxui.validation.URLError',
        defaultMessage: 'Invalid URL',
      },
      invalidUserError: {
        id: 'boxui.validation.invalidUserError',
        defaultMessage: 'Invalid User',
      },
      requiredFieldError: {
        id: 'boxui.validation.requiredError',
        defaultMessage: 'Required Field',
      },
      invalidDateError: {
        id: 'boxui.validation.invalidDateError',
        defaultMessage: 'Invalid Date',
      },
    });
    /* harmony default export */ const src_common_messages = common_messages_messages; // CONCATENATED MODULE: ./src/components/tooltip/CloseButton.tsx
    // @ts-ignore flow import

    const CloseButton_CloseButton = ({ intl, onClick }) =>
      /*#__PURE__*/ react.createElement(
        plain_button_PlainButton,
        {
          'aria-label': intl.formatMessage(src_common_messages.close),
          className: 'tooltip-close-button',
          onClick: onClick,
        },
        /*#__PURE__*/ react.createElement(fill_X16, {
          className: 'bdl-Tooltip-iconClose',
          width: 14,
          height: 14,
        }),
      );

    /* harmony default export */ const tooltip_CloseButton = injectIntl(CloseButton_CloseButton); // CONCATENATED MODULE: ./src/components/tooltip/Tooltip.tsx
    function Tooltip_extends() {
      return (
        (Tooltip_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Tooltip_extends.apply(null, arguments)
      );
    }
    function Tooltip_defineProperty(e, r, t) {
      return (
        (r = Tooltip_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Tooltip_toPropertyKey(t) {
      var i = Tooltip_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Tooltip_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    let TooltipTheme = /*#__PURE__*/ (function (TooltipTheme) {
      TooltipTheme['CALLOUT'] = 'callout';
      TooltipTheme['DEFAULT'] = 'default';
      TooltipTheme['ERROR'] = 'error';
      return TooltipTheme;
    })({});
    let TooltipPosition = /*#__PURE__*/ (function (TooltipPosition) {
      TooltipPosition['BOTTOM_CENTER'] = 'bottom-center';
      TooltipPosition['BOTTOM_LEFT'] = 'bottom-left';
      TooltipPosition['BOTTOM_RIGHT'] = 'bottom-right';
      TooltipPosition['MIDDLE_LEFT'] = 'middle-left';
      TooltipPosition['MIDDLE_RIGHT'] = 'middle-right';
      TooltipPosition['TOP_CENTER'] = 'top-center';
      TooltipPosition['TOP_LEFT'] = 'top-left';
      TooltipPosition['TOP_RIGHT'] = 'top-right';
      return TooltipPosition;
    })({});
    const Tooltip_positions = {
      [TooltipPosition.BOTTOM_CENTER]: {
        attachment: tether_positions.TOP_CENTER,
        targetAttachment: tether_positions.BOTTOM_CENTER,
      },
      [TooltipPosition.BOTTOM_LEFT]: {
        attachment: tether_positions.TOP_RIGHT,
        targetAttachment: tether_positions.BOTTOM_RIGHT,
      },
      [TooltipPosition.BOTTOM_RIGHT]: {
        attachment: tether_positions.TOP_LEFT,
        targetAttachment: tether_positions.BOTTOM_LEFT,
      },
      [TooltipPosition.MIDDLE_LEFT]: {
        attachment: tether_positions.MIDDLE_RIGHT,
        targetAttachment: tether_positions.MIDDLE_LEFT,
      },
      [TooltipPosition.MIDDLE_RIGHT]: {
        attachment: tether_positions.MIDDLE_LEFT,
        targetAttachment: tether_positions.MIDDLE_RIGHT,
      },
      [TooltipPosition.TOP_CENTER]: {
        attachment: tether_positions.BOTTOM_CENTER,
        targetAttachment: tether_positions.TOP_CENTER,
      },
      [TooltipPosition.TOP_LEFT]: {
        attachment: tether_positions.BOTTOM_RIGHT,
        targetAttachment: tether_positions.TOP_RIGHT,
      },
      [TooltipPosition.TOP_RIGHT]: {
        attachment: tether_positions.BOTTOM_LEFT,
        targetAttachment: tether_positions.TOP_LEFT,
      },
    };
    class Tooltip extends react.Component {
      constructor(props) {
        super(props);
        Tooltip_defineProperty(this, 'tooltipID', uniqueId_default()('tooltip'));
        Tooltip_defineProperty(this, 'tetherRef', /*#__PURE__*/ react.createRef());
        // Instance API: Forces the radar to be repositioned
        Tooltip_defineProperty(this, 'position', () => {
          if (this.tetherRef.current && this.isShown()) {
            this.tetherRef.current.position();
          }
        });
        Tooltip_defineProperty(this, 'closeTooltip', () => {
          const { onDismiss } = this.props;
          this.setState({
            wasClosedByUser: true,
          });
          if (onDismiss) {
            onDismiss();
          }
        });
        Tooltip_defineProperty(this, 'fireChildEvent', (type, event) => {
          const { children } = this.props;
          const handler = children.props[type];
          if (handler) {
            handler(event);
          }
        });
        Tooltip_defineProperty(this, 'handleTooltipEvent', event => {
          event.stopPropagation();
          event.nativeEvent.stopImmediatePropagation();
        });
        Tooltip_defineProperty(this, 'handleMouseEnter', event => {
          this.setState({
            isShown: true,
          });
          this.fireChildEvent('onMouseEnter', event);
        });
        Tooltip_defineProperty(this, 'handleMouseLeave', event => {
          this.setState({
            isShown: false,
          });
          this.fireChildEvent('onMouseLeave', event);
        });
        Tooltip_defineProperty(this, 'handleFocus', event => {
          this.setState({
            isShown: true,
          });
          this.fireChildEvent('onFocus', event);
        });
        Tooltip_defineProperty(this, 'handleBlur', event => {
          this.setState({
            isShown: false,
          });
          this.fireChildEvent('onBlur', event);
        });
        Tooltip_defineProperty(this, 'isControlled', () => {
          const { isShown: isShownProp } = this.props;
          return typeof isShownProp !== 'undefined';
        });
        Tooltip_defineProperty(this, 'handleKeyDown', event => {
          if (event.key === 'Escape') {
            event.stopPropagation();
            this.setState({
              isShown: false,
            });
          }
          this.fireChildEvent('onKeyDown', event);
        });
        Tooltip_defineProperty(this, 'isShown', () => {
          const { isShown: isShownProp } = this.props;
          const isControlled = this.isControlled();
          const isShown = isControlled ? isShownProp : this.state.isShown;
          const showTooltip = isShown && !this.state.wasClosedByUser && this.state.hasRendered;
          return showTooltip;
        });
        this.state = {
          isShown: !!props.isShown,
          hasRendered: false,
          wasClosedByUser: false,
        };
      }
      componentDidMount() {
        this.setState({
          hasRendered: true,
        });
      }
      componentDidUpdate(prevProps, prevState) {
        const isControlled = this.isControlled();

        // Reset wasClosedByUser state when isShown transitions from false to true
        if (isControlled) {
          if (!prevProps.isShown && this.props.isShown) {
            this.setState({
              wasClosedByUser: false,
            });
          }
        } else {
          if (!prevState.isShown && this.state.isShown) {
            // capture event so that tooltip closes before any other floating components that can be closed by
            // "Escape" key(e.g. Modal, Menu, etc.)
            document.addEventListener('keydown', this.handleKeyDown, true);
          }
          if (prevState.isShown && !this.state.isShown) {
            document.removeEventListener('keydown', this.handleKeyDown, true);
          }
        }
      }
      componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown, true);
      }
      render() {
        const {
          ariaHidden,
          bodyElement,
          children,
          className,
          constrainToScrollParent,
          constrainToWindow,
          isDisabled,
          isTabbable = true,
          offset,
          position = TooltipPosition.TOP_CENTER,
          showCloseButton,
          stopBubble,
          tetherElementClassName,
          text,
          theme,
        } = this.props;
        const childAriaLabel = get_default()(children, 'props.aria-label');
        const isLabelMatchingTooltipText = !!childAriaLabel && childAriaLabel === text;

        // If the tooltip is disabled just render the children
        if (isDisabled) {
          return react.Children.only(children);
        }
        const isControlled = this.isControlled();
        const showTooltip = this.isShown();
        const withCloseButton = showCloseButton && isControlled;
        const tetherPosition = typeof position === 'string' ? Tooltip_positions[position] : position;
        const constraints = [];
        const componentProps = {};
        if (constrainToScrollParent) {
          constraints.push({
            to: 'scrollParent',
            attachment: 'together',
          });
        }
        if (constrainToWindow) {
          constraints.push({
            to: 'window',
            attachment: 'together',
          });
        }
        if (showTooltip && !ariaHidden) {
          if (!isLabelMatchingTooltipText || childAriaLabel === undefined) {
            componentProps['aria-describedby'] = this.tooltipID;
          }
          if (theme === TooltipTheme.ERROR) {
            componentProps['aria-errormessage'] = this.tooltipID;
          }
        }
        if (!isControlled) {
          componentProps.onBlur = this.handleBlur;
          componentProps.onFocus = this.handleFocus;
          componentProps.onMouseEnter = this.handleMouseEnter;
          componentProps.onMouseLeave = this.handleMouseLeave;
          if (isTabbable) {
            componentProps.tabIndex = '0';
          }
        }
        const bodyEl = bodyElement instanceof HTMLElement ? bodyElement : document.body;
        const classes = classnames_default()('tooltip', 'bdl-Tooltip', className, {
          'is-callout': theme === TooltipTheme.CALLOUT,
          'is-error': theme === TooltipTheme.ERROR,
          'with-close-button': withCloseButton,
        });
        const tetherProps = {
          attachment: tetherPosition.attachment,
          bodyElement: bodyEl,
          classPrefix: 'tooltip',
          constraints,
          enabled: showTooltip,
          targetAttachment: tetherPosition.targetAttachment,
        };
        if (tetherElementClassName) {
          tetherProps.className = tetherElementClassName;
        }
        if (offset) {
          tetherProps.offset = offset;
        }
        const tooltipInner = /*#__PURE__*/ react.createElement(
          react.Fragment,
          null,
          text,
          withCloseButton &&
            /*#__PURE__*/ react.createElement(tooltip_CloseButton, {
              onClick: this.closeTooltip,
            }),
        );
        const tooltip = stopBubble
          ? /*#__PURE__*/ react.createElement(
              'div',
              {
                className: classes,
                id: this.tooltipID,
                onClick: this.handleTooltipEvent,
                onContextMenu: this.handleTooltipEvent,
                onKeyPress: this.handleTooltipEvent,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                role: 'presentation',
              },
              /*#__PURE__*/ react.createElement(
                'div',
                {
                  role: theme === TooltipTheme.ERROR ? undefined : 'tooltip',
                  'aria-live': 'polite',
                  'aria-hidden': ariaHidden || isLabelMatchingTooltipText,
                  'data-testid': 'bdl-Tooltip',
                },
                tooltipInner,
              ),
            )
          : /*#__PURE__*/ react.createElement(
              'div',
              {
                'aria-live': 'polite',
                'aria-hidden': ariaHidden || isLabelMatchingTooltipText,
                className: classes,
                'data-testid': 'bdl-Tooltip',
                id: this.tooltipID,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                role: theme === TooltipTheme.ERROR ? undefined : 'tooltip',
              },
              tooltipInner,
            );
        return /*#__PURE__*/ react.createElement(
          react_tether /* default */.A,
          Tooltip_extends(
            {
              ref: this.tetherRef,
            },
            tetherProps,
          ),
          /*#__PURE__*/ react.cloneElement(react.Children.only(children), componentProps),
          showTooltip && tooltip,
        );
      }
    }
    Tooltip_defineProperty(Tooltip, 'defaultProps', {
      constrainToScrollParent: false,
      constrainToWindow: true,
      isDisabled: false,
      position: TooltipPosition.TOP_CENTER,
      theme: TooltipTheme.DEFAULT,
    });
    /* harmony default export */ const tooltip_Tooltip = Tooltip; // CONCATENATED MODULE: ./src/elements/common/Tooltip.js
    const Tooltip_excluded = ['children', 'isDisabled', 'text'];
    function common_Tooltip_extends() {
      return (
        (common_Tooltip_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        common_Tooltip_extends.apply(null, arguments)
      );
    }
    function Tooltip_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Tooltip_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Tooltip_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    /**
     *
     * @file Wrapper to conditionally add a tooltip
     * @author Box
     */

    const Tooltip_Tooltip = _ref => {
      let { children, isDisabled, text } = _ref,
        rest = Tooltip_objectWithoutProperties(_ref, Tooltip_excluded);
      if (isDisabled || !text) {
        return children;
      }
      return /*#__PURE__*/ react.createElement(
        tooltip_Tooltip,
        common_Tooltip_extends(
          {
            text: text,
          },
          rest,
        ),
        children,
      );
    };
    /* harmony default export */ const common_Tooltip = Tooltip_Tooltip; // CONCATENATED MODULE: ./src/elements/common/sub-header/SortButton.js
    const SortButton_excluded = ['intl'];
    function SortButton_extends() {
      return (
        (SortButton_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        SortButton_extends.apply(null, arguments)
      );
    }
    function SortButton_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = SortButton_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function SortButton_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    /**
     *
     * @file Sort Button component
     * @author Box
     */

    const SortButton = _ref => {
      let { intl } = _ref,
        rest = SortButton_objectWithoutProperties(_ref, SortButton_excluded);
      const sortMessage = intl.formatMessage(common_messages.sort);
      return /*#__PURE__*/ react.createElement(
        common_Tooltip,
        {
          text: sortMessage,
        },
        /*#__PURE__*/ react.createElement(
          button_Button,
          SortButton_extends(
            {
              'aria-label': sortMessage,
              className: 'be-btn-sort',
              type: 'button',
            },
            rest,
          ),
          /*#__PURE__*/ react.createElement(general_IconSort, {
            color: bdlGray65,
          }),
        ),
      );
    };

    /* harmony default export */ const sub_header_SortButton = injectIntl(SortButton); // CONCATENATED MODULE: ./src/elements/common/sub-header/Sort.js
    /**
     *
     * @file Sort component
     * @author Box
     */

    const SORT_ITEMS = [
      [constants_FIELD_NAME, SORT_ASC],
      [constants_FIELD_NAME, constants_SORT_DESC],
      [FIELD_DATE, SORT_ASC],
      [FIELD_DATE, constants_SORT_DESC],
      [constants_FIELD_SIZE, SORT_ASC],
      [constants_FIELD_SIZE, constants_SORT_DESC],
    ];
    const Sort = ({ sortBy, sortDirection, onSortChange }) =>
      /*#__PURE__*/ react.createElement(
        dropdown_menu_DropdownMenu,
        {
          isRightAligned: true,
        },
        /*#__PURE__*/ react.createElement(sub_header_SortButton, null),
        /*#__PURE__*/ react.createElement(
          menu_Menu,
          null,
          SORT_ITEMS.map(([sortByValue, sortDirectionValue]) => {
            const isSelected = sortByValue === sortBy && sortDirectionValue === sortDirection;
            const sortItemKey = `${sortByValue}${sortDirectionValue}`;
            return /*#__PURE__*/ react.createElement(
              menu_SelectMenuItem,
              {
                key: sortItemKey,
                isSelected: isSelected,
                onClick: () => onSortChange(sortByValue, sortDirectionValue),
              },
              /*#__PURE__*/ react.createElement(components_message, common_messages[sortItemKey]),
            );
          }),
        ),
      );
    /* harmony default export */ const sub_header_Sort = Sort; // CONCATENATED MODULE: ./src/icons/general/IconAddThin.tsx
    const IconAddThin = ({ className = '', color = '#222222', height = 17, title, width = 17 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-add-thin ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 17 17',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M8 0h1v17H8z',
          fill: color,
        }),
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M17 8v1H0V8z',
          fill: color,
        }),
      );
    /* harmony default export */ const general_IconAddThin = IconAddThin; // CONCATENATED MODULE: ./src/elements/common/sub-header/AddButton.js
    function AddButton_extends() {
      return (
        (AddButton_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        AddButton_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Add Button component
     * @author Box
     */

    const AddButton = props =>
      /*#__PURE__*/ react.createElement(
        common_Tooltip,
        {
          text: /*#__PURE__*/ react.createElement(components_message, common_messages.add),
        },
        /*#__PURE__*/ react.createElement(
          button_Button,
          AddButton_extends(
            {
              className: 'be-btn-add',
              'aria-label': common_messages.add.defaultMessage,
              type: 'button',
            },
            props,
          ),
          /*#__PURE__*/ react.createElement(general_IconAddThin, {
            color: bdlGray65,
          }),
        ),
      );
    /* harmony default export */ const sub_header_AddButton = AddButton; // CONCATENATED MODULE: ./src/elements/common/sub-header/Add.js
    /**
     *
     * @file Add component
     * @author Box
     */

    const Add = ({ onUpload, onCreate, showUpload = true, showCreate = true }) =>
      /*#__PURE__*/ react.createElement(
        dropdown_menu_DropdownMenu,
        {
          isRightAligned: true,
        },
        /*#__PURE__*/ react.createElement(sub_header_AddButton, null),
        /*#__PURE__*/ react.createElement(
          menu_Menu,
          null,
          showUpload &&
            /*#__PURE__*/ react.createElement(
              menu_MenuItem,
              {
                onClick: onUpload,
              },
              /*#__PURE__*/ react.createElement(components_message, common_messages.upload),
            ),
          showCreate &&
            /*#__PURE__*/ react.createElement(
              menu_MenuItem,
              {
                onClick: onCreate,
              },
              /*#__PURE__*/ react.createElement(components_message, common_messages.newFolder),
            ),
        ),
      );
    /* harmony default export */ const sub_header_Add = Add; // CONCATENATED MODULE: ./src/icons/general/IconPlusThin.tsx
    const IconPlusThin = ({ className = '', color = '#222', height = 9, title, width = 9 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-plus-thin ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 9 9',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M5 4V0H4v4H0v1h4v4h1V5h4V4H5z',
          fill: color,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconPlusThin = IconPlusThin; // CONCATENATED MODULE: ./src/icons/general/IconMinusThin.tsx
    const IconMinusThin = ({ className = '', color = '#222', height = 1, title, width = 9 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-minus-thin ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 9 1',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M0 0h9v1H0z',
          fill: color,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconMinusThin = IconMinusThin; // CONCATENATED MODULE: ./src/components/grid-view/GridViewSlider.js
    const GridViewSlider = ({ columnCount, gridMaxColumns, gridMinColumns, intl, maxColumnCount, onChange }) => {
      const { formatMessage } = intl;
      const RANGE_STEP = 1;

      // This math is necessary since the highest value of the slider should result in
      // the lowest number of columns
      const RANGE_MIN = gridMaxColumns - maxColumnCount + 1;
      const RANGE_MAX = gridMaxColumns - gridMinColumns + 1;
      const sliderValue = RANGE_MAX - columnCount + 1;
      return (
        gridMinColumns < maxColumnCount &&
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bdl-GridViewSlider',
          },
          /*#__PURE__*/ react.createElement(
            plain_button_PlainButton,
            {
              className: 'bdl-GridViewSlider-button',
              onClick: () => {
                onChange(Math.max(RANGE_MIN, sliderValue - RANGE_STEP));
              },
              type: 'button',
              'aria-label': formatMessage(common_messages.gridViewDecreaseColumnSize),
            },
            /*#__PURE__*/ react.createElement(general_IconMinusThin, {
              color: bdlGray50,
              width: 14,
              height: 14,
            }),
          ),
          /*#__PURE__*/ react.createElement('input', {
            'aria-label': formatMessage(common_messages.gridViewColumnSize),
            className: 'bdl-GridViewSlider-range',
            max: RANGE_MAX,
            min: RANGE_MIN,
            onChange: event => {
              onChange(event.currentTarget.valueAsNumber);
            },
            step: RANGE_STEP,
            type: 'range',
            value: sliderValue,
          }),
          /*#__PURE__*/ react.createElement(
            plain_button_PlainButton,
            {
              className: 'bdl-GridViewSlider-button',
              onClick: () => {
                onChange(Math.min(RANGE_MAX, sliderValue + RANGE_STEP));
              },
              type: 'button',
              'aria-label': formatMessage(common_messages.gridViewIncreaseColumnSize),
            },
            /*#__PURE__*/ react.createElement(general_IconPlusThin, {
              color: bdlGray50,
              width: 14,
              height: 14,
            }),
          ),
        )
      );
    };

    /* harmony default export */ const grid_view_GridViewSlider = injectIntl(GridViewSlider); // CONCATENATED MODULE: ./src/icons/general/IconGridViewInverted.tsx
    const IconGridViewInverted = ({ className = '', color = bdlGray50, height = 16, title, width = 16 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-grid-view-inverted ${className}`,
          title: title,
          width: width,
          height: height,
          viewBox: '0 0 16 16',
        },
        /*#__PURE__*/ react.createElement('path', {
          d: 'M2.5 2h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5zm7 0h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5zm-7 7h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5zm7 0h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5z',
          fill: color,
          fillRule: 'nonzero',
        }),
      );
    /* harmony default export */ const general_IconGridViewInverted = IconGridViewInverted; // CONCATENATED MODULE: ./src/icons/general/IconListView.tsx
    const IconListView = ({ className = '', color = '#222', height = 9, opacity = 1, title, width = 9 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-list-view ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 9 9',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M0 5h9V4H0v1zm0 4h9V8H0v1zm0-9v1h9V0H0z',
          fill: color,
          fillOpacity: opacity,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconListView = IconListView; // CONCATENATED MODULE: ./src/elements/common/sub-header/ViewModeChangeButton.js
    const ViewModeChangeButton_excluded = ['className', 'onViewModeChange', 'intl', 'viewMode'];
    function ViewModeChangeButton_extends() {
      return (
        (ViewModeChangeButton_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        ViewModeChangeButton_extends.apply(null, arguments)
      );
    }
    function ViewModeChangeButton_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = ViewModeChangeButton_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function ViewModeChangeButton_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const ViewModeChangeButton = _ref => {
      let { className = '', onViewModeChange = noop_default(), intl, viewMode } = _ref,
        rest = ViewModeChangeButton_objectWithoutProperties(_ref, ViewModeChangeButton_excluded);
      const isGridView = viewMode === VIEW_MODE_GRID;
      const viewMessage = isGridView
        ? intl.formatMessage(common_messages.listView)
        : intl.formatMessage(common_messages.gridView);
      const onClick = () => {
        onViewModeChange(isGridView ? VIEW_MODE_LIST : VIEW_MODE_GRID);
      };
      return /*#__PURE__*/ react.createElement(
        common_Tooltip,
        {
          text: viewMessage,
        },
        /*#__PURE__*/ react.createElement(
          button_Button,
          ViewModeChangeButton_extends(
            {
              'aria-label': viewMessage,
              'data-testid': 'view-mode-change-button',
              className: classnames_default()('bdl-ViewModeChangeButton', className),
              type: 'button',
              onClick: onClick,
            },
            rest,
          ),
          isGridView
            ? /*#__PURE__*/ react.createElement(general_IconListView, {
                color: bdlGray65,
                width: 17,
                height: 17,
              })
            : /*#__PURE__*/ react.createElement(general_IconGridViewInverted, {
                color: bdlGray65,
                width: 17,
                height: 17,
              }),
        ),
      );
    };
    /* harmony default export */ const sub_header_ViewModeChangeButton = injectIntl(ViewModeChangeButton); // CONCATENATED MODULE: ./src/elements/common/sub-header/SubHeaderRight.js
    /**
     *
     * @file Content sub header component
     * @author Box
     */

    const SubHeaderRight = ({
      canCreateNewFolder,
      canUpload,
      currentCollection,
      gridColumnCount,
      gridMaxColumns,
      gridMinColumns,
      maxGridColumnCountForWidth,
      onCreate,
      onGridViewSliderChange,
      onSortChange,
      onUpload,
      onViewModeChange,
      view,
      viewMode,
    }) => {
      // Custom toggle/select all files feature (nelson)
      const toggleAllFiles = async () => {
        const scroller = document.getElementsByClassName('ReactVirtualized__Grid ReactVirtualized__Table__Grid')[0];
        if (!scroller || !items.length) return;

        const originalScroll = scroller.scrollTop;

        scroller.scrollTop = 0;
        await new Promise(res => setTimeout(() => res(), 200));

        const MAX_SCROLLS = 100;
        let i = 0;
        let lastScroll = -1;
        while (i++ < MAX_SCROLLS && lastScroll != scroller.scrollTop) {
          const checkboxes = Array.from(scroller.getElementsByTagName('input')).filter(i => i.type == 'checkbox');
          checkboxes.forEach(checkbox => checkbox.checked || checkbox.click());
          lastScroll = scroller.scrollTop;
          scroller.scrollTop += 100;
          await new Promise(res => setTimeout(() => res(), 200));
        }

        scroller.scrollTop = originalScroll;
      };

      const toggleAllFilesButton = react.createElement(
        'button',
        {
          className: 'btn btn-select-all',
          onClick: toggleAllFiles,
        },
        'All',
      );

      const { sortBy, sortDirection, items = [] } = currentCollection;
      const hasGridView = !!gridColumnCount;
      const hasItems = items.length > 0;
      const isFolder = view === VIEW_FOLDER;
      const showSort = isFolder && hasItems;
      const showAdd = (!!canUpload || !!canCreateNewFolder) && isFolder;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-sub-header-right',
        },
        hasItems &&
          viewMode === VIEW_MODE_GRID &&
          /*#__PURE__*/ react.createElement(grid_view_GridViewSlider, {
            columnCount: gridColumnCount,
            gridMaxColumns: gridMaxColumns,
            gridMinColumns: gridMinColumns,
            maxColumnCount: maxGridColumnCountForWidth,
            onChange: onGridViewSliderChange,
          }),
        hasItems &&
          hasGridView &&
          /*#__PURE__*/ react.createElement(sub_header_ViewModeChangeButton, {
            viewMode: viewMode,
            onViewModeChange: onViewModeChange,
          }),
        showSort &&
          !!sortBy &&
          !!sortDirection &&
          /*#__PURE__*/ react.createElement(sub_header_Sort, {
            onSortChange: onSortChange,
            sortBy: sortBy,
            sortDirection: sortDirection,
          }),
        showAdd &&
          /*#__PURE__*/ react.createElement(sub_header_Add, {
            isDisabled: !isFolder,
            onCreate: onCreate,
            onUpload: onUpload,
            showCreate: canCreateNewFolder,
            showUpload: canUpload,
          }),
        hasItems && toggleAllFilesButton,
      );
    };
    /* harmony default export */ const sub_header_SubHeaderRight = SubHeaderRight; // CONCATENATED MODULE: ./src/elements/common/sub-header/SubHeader.js
    /**
     *
     * @file Content sub header component
     * @author Box
     */

    const SubHeader = ({
      canCreateNewFolder,
      canUpload,
      currentCollection,
      gridColumnCount = 0,
      gridMaxColumns = 0,
      gridMinColumns = 0,
      maxGridColumnCountForWidth = 0,
      onGridViewSliderChange = noop_default(),
      isSmall,
      onCreate,
      onItemClick,
      onSortChange,
      onUpload,
      onViewModeChange,
      rootId,
      rootName,
      view,
      viewMode = VIEW_MODE_LIST,
    }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-sub-header',
          'data-testid': 'be-sub-header',
        },
        /*#__PURE__*/ react.createElement(sub_header_SubHeaderLeft, {
          currentCollection: currentCollection,
          isSmall: isSmall,
          onItemClick: onItemClick,
          rootId: rootId,
          rootName: rootName,
          view: view,
        }),
        /*#__PURE__*/ react.createElement(sub_header_SubHeaderRight, {
          canCreateNewFolder: canCreateNewFolder,
          canUpload: canUpload,
          currentCollection: currentCollection,
          gridColumnCount: gridColumnCount,
          gridMaxColumns: gridMaxColumns,
          gridMinColumns: gridMinColumns,
          maxGridColumnCountForWidth: maxGridColumnCountForWidth,
          onCreate: onCreate,
          onGridViewSliderChange: onGridViewSliderChange,
          onSortChange: onSortChange,
          onUpload: onUpload,
          onViewModeChange: onViewModeChange,
          view: view,
          viewMode: viewMode,
        }),
      );
    /* harmony default export */ const sub_header_SubHeader = SubHeader;
    // EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
    var cloneDeep = __webpack_require__(47217);
    var cloneDeep_default = /*#__PURE__*/ __webpack_require__.n(cloneDeep); // CONCATENATED MODULE: ./src/utils/file.js
    /**
     *
     * @file Helper for throwing errors
     * @author Box
     */

    const FILE_EXT_REGEX = /\.([0-9a-z]+)$/i; // Case insensitive regex to extract file extension without "."

    /**
     * Returns typed id for file. Useful for when
     * making file based XHRs where auth token
     * can be per file as used by Preview.
     * @param {id} id the file id
     * @return {string} typed id for file
     */
    function getTypedFileId(id) {
      return `${TYPED_ID_FILE_PREFIX}${id}`;
    }

    /**
     * Returns typed id for folder.
     * @param {id} id the folder id
     * @return {string} typed id for folder
     */
    function getTypedFolderId(id) {
      return `${TYPED_ID_FOLDER_PREFIX}${id}`;
    }

    /**
     * Determines if the file is a box note
     * @param {Object} file a box file
     * @return boolean true if it is a box note
     */
    function isBoxNote(file) {
      return file.extension === FILE_EXTENSION_BOX_NOTE;
    }

    /**
     * Determines if the file is box canvas
     * @param {Object} file a box file
     * @return boolean true if it is box canvas
     */
    function isBoxCanvas(file) {
      return file.extension === FILE_EXTENSION_BOX_CANVAS;
    }

    /**
     * Determines whether a file extension is associated with a G Suite file.
     * @param {string} extension
     * @return boolean true if the extension is a valid G Suite extension
     */
    function isGSuiteExtension(extension) {
      return (
        extension === FILE_EXTENSION_GOOGLE_DOC ||
        extension === FILE_EXTENSION_GOOGLE_SHEET ||
        extension === FILE_EXTENSION_GOOGLE_SLIDE ||
        extension === FILE_EXTENSION_GOOGLE_SLIDE_LEGACY
      );
    }

    /**
     * Returns the extension from the file name
     * @param {string} filename a Box file
     * @return {string} typed id for file
     */
    function getFileExtension(filename) {
      if (typeof filename !== 'string') {
        return '';
      }
      const result = FILE_EXT_REGEX.exec(filename);
      return getProp(result, '[1]', '');
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
    function extends_extends() {
      return (
        (extends_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        extends_extends.apply(null, arguments)
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js

    function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js

    function _setPrototypeOf(t, e) {
      return (
        (_setPrototypeOf = Object.setPrototypeOf
          ? Object.setPrototypeOf.bind()
          : function (t, e) {
              return (t.__proto__ = e), t;
            }),
        _setPrototypeOf(t, e)
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

    function _inheritsLoose(t, o) {
      (t.prototype = Object.create(o.prototype)), (t.prototype.constructor = t), _setPrototypeOf(t, o);
    }

    // EXTERNAL MODULE: ./node_modules/prop-types/index.js
    var prop_types = __webpack_require__(39970);
    var prop_types_default = /*#__PURE__*/ __webpack_require__.n(prop_types); // CONCATENATED MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
    /**
     * A collection of shims that provide minimal functionality of the ES6 collections.
     *
     * These implementations are not meant to be used outside of the ResizeObserver
     * modules as they cover only a limited range of use cases.
     */
    /* eslint-disable require-jsdoc, valid-jsdoc */
    var MapShim = (function () {
      if (typeof Map !== 'undefined') {
        return Map;
      }
      /**
       * Returns index in provided array that matches the specified key.
       *
       * @param {Array<Array>} arr
       * @param {*} key
       * @returns {number}
       */
      function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
          if (entry[0] === key) {
            result = index;
            return true;
          }
          return false;
        });
        return result;
      }
      return /** @class */ (function () {
        function class_1() {
          this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, 'size', {
          /**
           * @returns {boolean}
           */
          get: function () {
            return this.__entries__.length;
          },
          enumerable: true,
          configurable: true,
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
          var index = getIndex(this.__entries__, key);
          var entry = this.__entries__[index];
          return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
          var index = getIndex(this.__entries__, key);
          if (~index) {
            this.__entries__[index][1] = value;
          } else {
            this.__entries__.push([key, value]);
          }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
          var entries = this.__entries__;
          var index = getIndex(entries, key);
          if (~index) {
            entries.splice(index, 1);
          }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
          return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
          this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
          if (ctx === void 0) {
            ctx = null;
          }
          for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
            var entry = _a[_i];
            callback.call(ctx, entry[1], entry[0]);
          }
        };
        return class_1;
      })();
    })();

    /**
     * Detects whether window and document objects are available in current environment.
     */
    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

    // Returns global object of a current environment.
    var global$1 = (function () {
      if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.Math === Math) {
        return __webpack_require__.g;
      }
      if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
      }
      if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
      }
      // eslint-disable-next-line no-new-func
      return Function('return this')();
    })();

    /**
     * A shim for the requestAnimationFrame which falls back to the setTimeout if
     * first one is not supported.
     *
     * @returns {number} Requests' identifier.
     */
    var requestAnimationFrame$1 = (function () {
      if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
      }
      return function (callback) {
        return setTimeout(function () {
          return callback(Date.now());
        }, 1000 / 60);
      };
    })();

    // Defines minimum timeout before adding a trailing call.
    var trailingTimeout = 2;
    /**
     * Creates a wrapper function which ensures that provided callback will be
     * invoked only once during the specified delay period.
     *
     * @param {Function} callback - Function to be invoked after the delay period.
     * @param {number} delay - Delay after which to invoke callback.
     * @returns {Function}
     */
    function throttle(callback, delay) {
      var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
      /**
       * Invokes the original callback function and schedules new invocation if
       * the "proxy" was called during current request.
       *
       * @returns {void}
       */
      function resolvePending() {
        if (leadingCall) {
          leadingCall = false;
          callback();
        }
        if (trailingCall) {
          proxy();
        }
      }
      /**
       * Callback invoked after the specified delay. It will further postpone
       * invocation of the original function delegating it to the
       * requestAnimationFrame.
       *
       * @returns {void}
       */
      function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
      }
      /**
       * Schedules invocation of the original function.
       *
       * @returns {void}
       */
      function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
          // Reject immediately following calls.
          if (timeStamp - lastCallTime < trailingTimeout) {
            return;
          }
          // Schedule new call to be in invoked when the pending one is resolved.
          // This is important for "transitions" which never actually start
          // immediately so there is a chance that we might miss one if change
          // happens amids the pending invocation.
          trailingCall = true;
        } else {
          leadingCall = true;
          trailingCall = false;
          setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
      }
      return proxy;
    }

    // Minimum delay before invoking the update of observers.
    var REFRESH_DELAY = 20;
    // A list of substrings of CSS properties used to find transition events that
    // might affect dimensions of observed elements.
    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
    // Check if MutationObserver is available.
    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
    /**
     * Singleton controller class which handles updates of ResizeObserver instances.
     */
    var ResizeObserverController = /** @class */ (function () {
      /**
       * Creates a new instance of ResizeObserverController.
       *
       * @private
       */
      function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
      }
      /**
       * Adds observer to observers list.
       *
       * @param {ResizeObserverSPI} observer - Observer to be added.
       * @returns {void}
       */
      ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
          this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
          this.connect_();
        }
      };
      /**
       * Removes observer from observers list.
       *
       * @param {ResizeObserverSPI} observer - Observer to be removed.
       * @returns {void}
       */
      ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
          observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
          this.disconnect_();
        }
      };
      /**
       * Invokes the update of observers. It will continue running updates insofar
       * it detects changes.
       *
       * @returns {void}
       */
      ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
          this.refresh();
        }
      };
      /**
       * Updates every observer from observers list and notifies them of queued
       * entries.
       *
       * @private
       * @returns {boolean} Returns "true" if any observer has detected changes in
       *      dimensions of it's elements.
       */
      ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
          return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
          return observer.broadcastActive();
        });
        return activeObservers.length > 0;
      };
      /**
       * Initializes DOM listeners.
       *
       * @private
       * @returns {void}
       */
      ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
          return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
          this.mutationsObserver_ = new MutationObserver(this.refresh);
          this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
          });
        } else {
          document.addEventListener('DOMSubtreeModified', this.refresh);
          this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
      };
      /**
       * Removes DOM listeners.
       *
       * @private
       * @returns {void}
       */
      ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
          return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
          this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
          document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
      };
      /**
       * "Transitionend" event handler.
       *
       * @private
       * @param {TransitionEvent} event
       * @returns {void}
       */
      ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
          propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
          return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
          this.refresh();
        }
      };
      /**
       * Returns instance of the ResizeObserverController.
       *
       * @returns {ResizeObserverController}
       */
      ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
          this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
      };
      /**
       * Holds reference to the controller's instance.
       *
       * @private {ResizeObserverController}
       */
      ResizeObserverController.instance_ = null;
      return ResizeObserverController;
    })();

    /**
     * Defines non-writable/enumerable properties of the provided target object.
     *
     * @param {Object} target - Object for which to define properties.
     * @param {Object} props - Properties to be defined.
     * @returns {Object} Target object.
     */
    var defineConfigurable = function (target, props) {
      for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
          value: props[key],
          enumerable: false,
          writable: false,
          configurable: true,
        });
      }
      return target;
    };

    /**
     * Returns the global object associated with provided element.
     *
     * @param {Object} target
     * @returns {Object}
     */
    var getWindowOf = function (target) {
      // Assume that the element is an instance of Node, which means that it
      // has the "ownerDocument" property from which we can retrieve a
      // corresponding global object.
      var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
      // Return the local global object if it's not possible extract one from
      // provided element.
      return ownerGlobal || global$1;
    };

    // Placeholder of an empty content rectangle.
    var emptyRect = createRectInit(0, 0, 0, 0);
    /**
     * Converts provided string to a number.
     *
     * @param {number|string} value
     * @returns {number}
     */
    function toFloat(value) {
      return parseFloat(value) || 0;
    }
    /**
     * Extracts borders size from provided styles.
     *
     * @param {CSSStyleDeclaration} styles
     * @param {...string} positions - Borders positions (top, right, ...)
     * @returns {number}
     */
    function getBordersSize(styles) {
      var positions = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
      }
      return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
      }, 0);
    }
    /**
     * Extracts paddings sizes from provided styles.
     *
     * @param {CSSStyleDeclaration} styles
     * @returns {Object} Paddings box.
     */
    function getPaddings(styles) {
      var positions = ['top', 'right', 'bottom', 'left'];
      var paddings = {};
      for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
      }
      return paddings;
    }
    /**
     * Calculates content rectangle of provided SVG element.
     *
     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
     *      to be calculated.
     * @returns {DOMRectInit}
     */
    function getSVGContentRect(target) {
      var bbox = target.getBBox();
      return createRectInit(0, 0, bbox.width, bbox.height);
    }
    /**
     * Calculates content rectangle of provided HTMLElement.
     *
     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
     * @returns {DOMRectInit}
     */
    function getHTMLElementContentRect(target) {
      // Client width & height properties can't be
      // used exclusively as they provide rounded values.
      var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
      // By this condition we can catch all non-replaced inline, hidden and
      // detached elements. Though elements with width & height properties less
      // than 0.5 will be discarded as well.
      //
      // Without it we would need to implement separate methods for each of
      // those cases and it's not possible to perform a precise and performance
      // effective test for hidden elements. E.g. even jQuery's ':visible' filter
      // gives wrong results for elements with width & height less than 0.5.
      if (!clientWidth && !clientHeight) {
        return emptyRect;
      }
      var styles = getWindowOf(target).getComputedStyle(target);
      var paddings = getPaddings(styles);
      var horizPad = paddings.left + paddings.right;
      var vertPad = paddings.top + paddings.bottom;
      // Computed styles of width & height are being used because they are the
      // only dimensions available to JS that contain non-rounded values. It could
      // be possible to utilize the getBoundingClientRect if only it's data wasn't
      // affected by CSS transformations let alone paddings, borders and scroll bars.
      var width = toFloat(styles.width),
        height = toFloat(styles.height);
      // Width & height include paddings and borders when the 'border-box' box
      // model is applied (except for IE).
      if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
          width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
          height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
      }
      // Following steps can't be applied to the document's root element as its
      // client[Width/Height] properties represent viewport area of the window.
      // Besides, it's as well not necessary as the <html> itself neither has
      // rendered scroll bars nor it can be clipped.
      if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
          width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
          height -= horizScrollbar;
        }
      }
      return createRectInit(paddings.left, paddings.top, width, height);
    }
    /**
     * Checks whether provided element is an instance of the SVGGraphicsElement.
     *
     * @param {Element} target - Element to be checked.
     * @returns {boolean}
     */
    var isSVGGraphicsElement = (function () {
      // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
      // interface.
      if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
          return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
      }
      // If it's so, then check that element is at least an instance of the
      // SVGElement and that it has the "getBBox" method.
      // eslint-disable-next-line no-extra-parens
      return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
      };
    })();
    /**
     * Checks whether provided element is a document element (<html>).
     *
     * @param {Element} target - Element to be checked.
     * @returns {boolean}
     */
    function isDocumentElement(target) {
      return target === getWindowOf(target).document.documentElement;
    }
    /**
     * Calculates an appropriate content rectangle for provided html or svg element.
     *
     * @param {Element} target - Element content rectangle of which needs to be calculated.
     * @returns {DOMRectInit}
     */
    function getContentRect(target) {
      if (!isBrowser) {
        return emptyRect;
      }
      if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
      }
      return getHTMLElementContentRect(target);
    }
    /**
     * Creates rectangle with an interface of the DOMRectReadOnly.
     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
     *
     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
     * @returns {DOMRectReadOnly}
     */
    function createReadOnlyRect(_a) {
      var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
      // If DOMRectReadOnly is available use it as a prototype for the rectangle.
      var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
      var rect = Object.create(Constr.prototype);
      // Rectangle's properties are not writable and non-enumerable.
      defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x,
      });
      return rect;
    }
    /**
     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
     *
     * @param {number} x - X coordinate.
     * @param {number} y - Y coordinate.
     * @param {number} width - Rectangle's width.
     * @param {number} height - Rectangle's height.
     * @returns {DOMRectInit}
     */
    function createRectInit(x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height,
      };
    }

    /**
     * Class that is responsible for computations of the content rectangle of
     * provided DOM element and for keeping track of it's changes.
     */
    var ResizeObservation = /** @class */ (function () {
      /**
       * Creates an instance of ResizeObservation.
       *
       * @param {Element} target - Element to be observed.
       */
      function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
      }
      /**
       * Updates content rectangle and tells whether it's width or height properties
       * have changed since the last broadcast.
       *
       * @returns {boolean}
       */
      ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
      };
      /**
       * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
       * from the corresponding properties of the last observed content rectangle.
       *
       * @returns {DOMRectInit} Last observed content rectangle.
       */
      ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
      };
      return ResizeObservation;
    })();
    var ResizeObserverEntry = /** @class */ (function () {
      /**
       * Creates an instance of ResizeObserverEntry.
       *
       * @param {Element} target - Element that is being observed.
       * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
       */
      function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, {
          target: target,
          contentRect: contentRect,
        });
      }
      return ResizeObserverEntry;
    })();
    var ResizeObserverSPI = /** @class */ (function () {
      /**
       * Creates a new instance of ResizeObserver.
       *
       * @param {ResizeObserverCallback} callback - Callback function that is invoked
       *      when one of the observed elements changes it's content dimensions.
       * @param {ResizeObserverController} controller - Controller instance which
       *      is responsible for the updates of observer.
       * @param {ResizeObserver} callbackCtx - Reference to the public
       *      ResizeObserver instance which will be passed to callback function.
       */
      function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
          throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
      }
      /**
       * Starts observing provided element.
       *
       * @param {Element} target - Element to be observed.
       * @returns {void}
       */
      ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
          throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
          return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
          throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
          return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
      };
      /**
       * Stops observing provided element.
       *
       * @param {Element} target - Element to stop observing.
       * @returns {void}
       */
      ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
          throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
          return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
          throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
          return;
        }
        observations.delete(target);
        if (!observations.size) {
          this.controller_.removeObserver(this);
        }
      };
      /**
       * Stops observing all elements.
       *
       * @returns {void}
       */
      ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
      };
      /**
       * Collects observation instances the associated element of which has changed
       * it's content rectangle.
       *
       * @returns {void}
       */
      ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
          if (observation.isActive()) {
            _this.activeObservations_.push(observation);
          }
        });
      };
      /**
       * Invokes initial callback function with a list of ResizeObserverEntry
       * instances collected from active resize observations.
       *
       * @returns {void}
       */
      ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
          return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
          return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
      };
      /**
       * Clears the collection of active observations.
       *
       * @returns {void}
       */
      ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
      };
      /**
       * Tells whether observer has active observations.
       *
       * @returns {boolean}
       */
      ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
      };
      return ResizeObserverSPI;
    })();

    // Registry of internal observers. If WeakMap is not available use current shim
    // for the Map collection as it has all required methods and because WeakMap
    // can't be fully polyfilled anyway.
    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
    /**
     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
     * exposing only those methods and properties that are defined in the spec.
     */
    var ResizeObserver = /** @class */ (function () {
      /**
       * Creates a new instance of ResizeObserver.
       *
       * @param {ResizeObserverCallback} callback - Callback that is invoked when
       *      dimensions of the observed elements change.
       */
      function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
          throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
          throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
      }
      return ResizeObserver;
    })();
    // Expose public methods of ResizeObserver.
    ['observe', 'unobserve', 'disconnect'].forEach(function (method) {
      ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
      };
    });
    var index = (function () {
      // Export existing implementation if available.
      if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
      }
      return ResizeObserver;
    })();
    /* harmony default export */ const ResizeObserver_es = index; // CONCATENATED MODULE: ./node_modules/react-measure/dist/index.esm.js
    var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
    function getTypes(props) {
      var allowedTypes = [];
      types.forEach(function (type) {
        if (props[type]) {
          allowedTypes.push(type);
        }
      });
      return allowedTypes;
    }
    function index_esm_getContentRect(node, types) {
      var calculations = {};
      if (types.indexOf('client') > -1) {
        calculations.client = {
          top: node.clientTop,
          left: node.clientLeft,
          width: node.clientWidth,
          height: node.clientHeight,
        };
      }
      if (types.indexOf('offset') > -1) {
        calculations.offset = {
          top: node.offsetTop,
          left: node.offsetLeft,
          width: node.offsetWidth,
          height: node.offsetHeight,
        };
      }
      if (types.indexOf('scroll') > -1) {
        calculations.scroll = {
          top: node.scrollTop,
          left: node.scrollLeft,
          width: node.scrollWidth,
          height: node.scrollHeight,
        };
      }
      if (types.indexOf('bounds') > -1) {
        var rect = node.getBoundingClientRect();
        calculations.bounds = {
          top: rect.top,
          right: rect.right,
          bottom: rect.bottom,
          left: rect.left,
          width: rect.width,
          height: rect.height,
        };
      }
      if (types.indexOf('margin') > -1) {
        var styles = getComputedStyle(node);
        calculations.margin = {
          top: styles ? parseInt(styles.marginTop) : 0,
          right: styles ? parseInt(styles.marginRight) : 0,
          bottom: styles ? parseInt(styles.marginBottom) : 0,
          left: styles ? parseInt(styles.marginLeft) : 0,
        };
      }
      return calculations;
    }

    /**
     * Returns the global window object associated with provided element.
     */
    function index_esm_getWindowOf(target) {
      // Assume that the element is an instance of Node, which means that it
      // has the "ownerDocument" property from which we can retrieve a
      // corresponding global object.
      var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local window object if it's not possible extract one from
      // provided element.

      return ownerGlobal || window;
    }
    function withContentRect(types) {
      return function (WrappedComponent) {
        var _class, _temp;
        return (
          (_temp = _class =
            /*#__PURE__*/
            (function (_Component) {
              _inheritsLoose(WithContentRect, _Component);
              function WithContentRect() {
                var _this;
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }
                _this = _Component.call.apply(_Component, [this].concat(args)) || this;
                _this.state = {
                  contentRect: {
                    entry: {},
                    client: {},
                    offset: {},
                    scroll: {},
                    bounds: {},
                    margin: {},
                  },
                };
                _this._animationFrameID = null;
                _this._resizeObserver = null;
                _this._node = null;
                _this._window = null;
                _this.measure = function (entries) {
                  var contentRect = index_esm_getContentRect(_this._node, types || getTypes(_this.props));
                  if (entries) {
                    contentRect.entry = entries[0].contentRect;
                  }
                  _this._animationFrameID = _this._window.requestAnimationFrame(function () {
                    if (_this._resizeObserver !== null) {
                      _this.setState({
                        contentRect: contentRect,
                      });
                      if (typeof _this.props.onResize === 'function') {
                        _this.props.onResize(contentRect);
                      }
                    }
                  });
                };
                _this._handleRef = function (node) {
                  if (_this._resizeObserver !== null && _this._node !== null) {
                    _this._resizeObserver.unobserve(_this._node);
                  }
                  _this._node = node;
                  _this._window = index_esm_getWindowOf(_this._node);
                  var innerRef = _this.props.innerRef;
                  if (innerRef) {
                    if (typeof innerRef === 'function') {
                      innerRef(_this._node);
                    } else {
                      innerRef.current = _this._node;
                    }
                  }
                  if (_this._resizeObserver !== null && _this._node !== null) {
                    _this._resizeObserver.observe(_this._node);
                  }
                };
                return _this;
              }
              var _proto = WithContentRect.prototype;
              _proto.componentDidMount = function componentDidMount() {
                this._resizeObserver =
                  this._window !== null && this._window.ResizeObserver
                    ? new this._window.ResizeObserver(this.measure)
                    : new ResizeObserver_es(this.measure);
                if (this._node !== null) {
                  this._resizeObserver.observe(this._node);
                  if (typeof this.props.onResize === 'function') {
                    this.props.onResize(index_esm_getContentRect(this._node, types || getTypes(this.props)));
                  }
                }
              };
              _proto.componentWillUnmount = function componentWillUnmount() {
                if (this._window !== null) {
                  this._window.cancelAnimationFrame(this._animationFrameID);
                }
                if (this._resizeObserver !== null) {
                  this._resizeObserver.disconnect();
                  this._resizeObserver = null;
                }
              };
              _proto.render = function render() {
                var _this$props = this.props,
                  innerRef = _this$props.innerRef,
                  onResize = _this$props.onResize,
                  props = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_this$props, [
                    'innerRef',
                    'onResize',
                  ]);
                return /*#__PURE__*/ (0, react.createElement)(
                  WrappedComponent,
                  extends_extends({}, props, {
                    measureRef: this._handleRef,
                    measure: this.measure,
                    contentRect: this.state.contentRect,
                  }),
                );
              };
              return WithContentRect;
            })(react.Component)),
          (_class.propTypes = {
            client: prop_types_default().bool,
            offset: prop_types_default().bool,
            scroll: prop_types_default().bool,
            bounds: prop_types_default().bool,
            margin: prop_types_default().bool,
            innerRef: prop_types_default().oneOfType([prop_types_default().object, prop_types_default().func]),
            onResize: prop_types_default().func,
          }),
          _temp
        );
      };
    }
    var Measure = withContentRect()(function (_ref) {
      var measure = _ref.measure,
        measureRef = _ref.measureRef,
        contentRect = _ref.contentRect,
        children = _ref.children;
      return children({
        measure: measure,
        measureRef: measureRef,
        contentRect: contentRect,
      });
    });
    Measure.displayName = 'Measure';
    Measure.propTypes.children = prop_types_default().func;
    /* harmony default export */ const index_esm = Measure; // CONCATENATED MODULE: ./src/elements/common/makeResponsive.js

    const makeResponsive_excluded = ['isTouch', 'size', 'className', 'componentRef'];
    function makeResponsive_extends() {
      return (
        (makeResponsive_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        makeResponsive_extends.apply(null, arguments)
      );
    }
    function makeResponsive_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = makeResponsive_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function makeResponsive_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function makeResponsive_defineProperty(e, r, t) {
      return (
        (r = makeResponsive_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function makeResponsive_toPropertyKey(t) {
      var i = makeResponsive_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function makeResponsive_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file HOC to make responsive Box UI Elements
     * @author Box
     */

    const CROSS_OVER_WIDTH_SMALL = 700;
    const CROSS_OVER_WIDTH_MEDIUM = 1000;
    const CROSS_OVER_WIDTH_LARGE = 1500;
    const HAS_TOUCH = !!(
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)
    );
    function makeResponsive(Wrapped) {
      var _Class;
      return (
        (_Class = class extends react.PureComponent {
          /**
           * [constructor]
           *
           * @param {*} data
           * @return {void}
           */
          constructor(props) {
            super(props);
            /**
             * Resizing function
             *
             * @private
             * @param {Component} react component
             * @return {void}
             */
            makeResponsive_defineProperty(
              this,
              'onResize',
              debounce_default()(({ bounds: { width } }) => {
                this.setState({
                  size: this.getSize(width),
                });
              }, 500),
            );
            /**
             * Callback function for setting the ref which measureRef is attached to
             *
             * @return {void}
             */
            makeResponsive_defineProperty(this, 'innerRef', el => {
              this.innerElement = el;
            });
            /**
             * Gets the ref element which measureRef is attached to
             *
             * @return {?HTMLElement} - the HTML element
             */
            makeResponsive_defineProperty(this, 'getInnerElement', () => this.innerElement);
            this.state = {
              size: props.size || this.getSize(window.innerWidth),
            };
          }

          /**
           * Calculates the new size
           *
           * @private
           * @param {Component} react component
           * @return {void}
           */
          getSize(width) {
            let size = SIZE_VERY_LARGE;
            if (width <= CROSS_OVER_WIDTH_SMALL) {
              size = SIZE_SMALL;
            } else if (width <= CROSS_OVER_WIDTH_MEDIUM) {
              size = SIZE_MEDIUM;
            } else if (width <= CROSS_OVER_WIDTH_LARGE) {
              size = SIZE_LARGE;
            }
            return size;
          }
          /**
           * Renders the Box UI Element
           *
           * @private
           * @inheritdoc
           * @return {Element}
           */
          render() {
            const _this$props = this.props,
              { isTouch, size, className, componentRef } = _this$props,
              rest = makeResponsive_objectWithoutProperties(_this$props, makeResponsive_excluded);
            let isLarge = size === SIZE_LARGE;
            let isMedium = size === SIZE_MEDIUM;
            let isSmall = size === SIZE_SMALL;
            let isVeryLarge = size === SIZE_VERY_LARGE;
            const isResponsive = !isSmall && !isLarge && !isMedium && !isVeryLarge;
            if ([isSmall, isMedium, isLarge, isVeryLarge].filter(item => item).length > 1) {
              throw new Error('Box UI Element cannot be small or medium or large or very large at the same time');
            }
            if (!isResponsive) {
              return /*#__PURE__*/ react.createElement(
                Wrapped,
                makeResponsive_extends(
                  {
                    ref: componentRef,
                    className: className,
                    isLarge: isLarge,
                    isMedium: isMedium,
                    isSmall: isSmall,
                    isTouch: isTouch,
                    isVeryLarge: isVeryLarge,
                  },
                  rest,
                ),
              );
            }
            const { size: sizeFromState } = this.state;
            isSmall = sizeFromState === SIZE_SMALL;
            isMedium = sizeFromState === SIZE_MEDIUM;
            isLarge = sizeFromState === SIZE_LARGE;
            isVeryLarge = sizeFromState === SIZE_VERY_LARGE;
            const styleClassName = classnames_default()(
              {
                [CLASS_IS_SMALL]: isSmall,
                [CLASS_IS_MEDIUM]: isMedium,
                [CLASS_IS_TOUCH]: isTouch,
              },
              className,
            );
            return /*#__PURE__*/ react.createElement(
              index_esm,
              {
                bounds: true,
                innerRef: this.innerRef,
                onResize: this.onResize,
              },
              ({ measureRef }) =>
                /*#__PURE__*/ react.createElement(
                  Wrapped,
                  makeResponsive_extends(
                    {
                      ref: componentRef,
                      className: styleClassName,
                      getInnerRef: this.getInnerElement,
                      isLarge: isLarge,
                      isMedium: isMedium,
                      isSmall: isSmall,
                      isTouch: isTouch,
                      isVeryLarge: isVeryLarge,
                      measureRef: measureRef,
                    },
                    rest,
                  ),
                ),
            );
          }
        }),
        makeResponsive_defineProperty(_Class, 'defaultProps', {
          className: '',
          isTouch: HAS_TOUCH,
        }),
        _Class
      );
    }
    /* harmony default export */ const common_makeResponsive = makeResponsive; // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/message.js
    function setTimeZoneInOptions(opts, timeZone) {
      return Object.keys(opts).reduce(function (all, k) {
        all[k] = __assign(
          {
            timeZone: timeZone,
          },
          opts[k],
        );
        return all;
      }, {});
    }
    function deepMergeOptions(opts1, opts2) {
      var keys = Object.keys(__assign(__assign({}, opts1), opts2));
      return keys.reduce(function (all, k) {
        all[k] = __assign(__assign({}, opts1[k] || {}), opts2[k] || {});
        return all;
      }, {});
    }
    function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
      if (!timeZone) {
        return f1;
      }
      var mfFormats = IntlMessageFormat.formats;
      return __assign(__assign(__assign({}, mfFormats), f1), {
        date: deepMergeOptions(
          setTimeZoneInOptions(mfFormats.date, timeZone),
          setTimeZoneInOptions(f1.date || {}, timeZone),
        ),
        time: deepMergeOptions(
          setTimeZoneInOptions(mfFormats.time, timeZone),
          setTimeZoneInOptions(f1.time || {}, timeZone),
        ),
      });
    }
    var formatMessage = function (_a, state, messageDescriptor, values, opts) {
      var locale = _a.locale,
        formats = _a.formats,
        messages = _a.messages,
        defaultLocale = _a.defaultLocale,
        defaultFormats = _a.defaultFormats,
        fallbackOnEmptyString = _a.fallbackOnEmptyString,
        onError = _a.onError,
        timeZone = _a.timeZone,
        defaultRichTextElements = _a.defaultRichTextElements;
      if (messageDescriptor === void 0) {
        messageDescriptor = {
          id: '',
        };
      }
      var msgId = messageDescriptor.id,
        defaultMessage = messageDescriptor.defaultMessage;
      // `id` is a required field of a Message Descriptor.
      invariant(
        !!msgId,
        '[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue',
      );
      var id = String(msgId);
      var message =
        // In case messages is Object.create(null)
        // e.g import('foo.json') from webpack)
        // See https://github.com/formatjs/formatjs/issues/1914
        messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
      // IMPORTANT: Hot path if `message` is AST with a single literal node
      if (Array.isArray(message) && message.length === 1 && message[0].type === TYPE.literal) {
        return message[0].value;
      }
      // IMPORTANT: Hot path straight lookup for performance
      if (!values && message && typeof message === 'string' && !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, '{$1}');
      }
      values = __assign(__assign({}, defaultRichTextElements), values || {});
      formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
      defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
      if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
          return message;
        }
        if (!defaultMessage || (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
          // This prevents warnings from littering the console in development
          // when no `messages` are passed into the <IntlProvider> for the
          // default locale.
          onError(new MissingTranslationError(messageDescriptor, locale));
        }
        if (defaultMessage) {
          try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
          } catch (e) {
            onError(
              new MessageFormatError(
                'Error formatting default message for: "'.concat(id, '", rendering default message verbatim'),
                locale,
                messageDescriptor,
                e,
              ),
            );
            return typeof defaultMessage === 'string' ? defaultMessage : id;
          }
        }
        return id;
      }
      // We have the translated message
      try {
        var formatter = state.getMessageFormat(
          message,
          locale,
          formats,
          __assign(
            {
              formatters: state,
            },
            opts || {},
          ),
        );
        return formatter.format(values);
      } catch (e) {
        onError(
          new MessageFormatError(
            'Error formatting message: "'
              .concat(id, '", using ')
              .concat(defaultMessage ? 'default message' : 'id', ' as fallback.'),
            locale,
            messageDescriptor,
            e,
          ),
        );
      }
      if (defaultMessage) {
        try {
          var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
          return formatter.format(values);
        } catch (e) {
          onError(
            new MessageFormatError(
              'Error formatting the default message for: "'.concat(id, '", rendering message verbatim'),
              locale,
              messageDescriptor,
              e,
            ),
          );
        }
      }
      if (typeof message === 'string') {
        return message;
      }
      if (typeof defaultMessage === 'string') {
        return defaultMessage;
      }
      return id;
    }; // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/number.js
    var NUMBER_FORMAT_OPTIONS = [
      'style',
      'currency',
      'unit',
      'unitDisplay',
      'useGrouping',
      'minimumIntegerDigits',
      'minimumFractionDigits',
      'maximumFractionDigits',
      'minimumSignificantDigits',
      'maximumSignificantDigits',
      // ES2020 NumberFormat
      'compactDisplay',
      'currencyDisplay',
      'currencySign',
      'notation',
      'signDisplay',
      'unit',
      'unitDisplay',
      'numberingSystem',
      // ES2023 NumberFormat
      'trailingZeroDisplay',
      'roundingPriority',
      'roundingIncrement',
      'roundingMode',
    ];
    function getFormatter(_a, getNumberFormat, options) {
      var locale = _a.locale,
        formats = _a.formats,
        onError = _a.onError;
      if (options === void 0) {
        options = {};
      }
      var format = options.format;
      var defaults = (format && getNamedFormat(formats, 'number', format, onError)) || {};
      var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
      return getNumberFormat(locale, filteredOptions);
    }
    function formatNumber(config, getNumberFormat, value, options) {
      if (options === void 0) {
        options = {};
      }
      try {
        return getFormatter(config, getNumberFormat, options).format(value);
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
      }
      return String(value);
    }
    function formatNumberToParts(config, getNumberFormat, value, options) {
      if (options === void 0) {
        options = {};
      }
      try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
      }
      return [];
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/relativeTime.js
    var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
    function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
      var locale = _a.locale,
        formats = _a.formats,
        onError = _a.onError;
      if (options === void 0) {
        options = {};
      }
      var format = options.format;
      var defaults = (!!format && getNamedFormat(formats, 'relative', format, onError)) || {};
      var filteredOptions = filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
      return getRelativeTimeFormat(locale, filteredOptions);
    }
    function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
      if (options === void 0) {
        options = {};
      }
      if (!unit) {
        unit = 'second';
      }
      var RelativeTimeFormat = Intl.RelativeTimeFormat;
      if (!RelativeTimeFormat) {
        config.onError(
          new error_FormatError(
            'Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n',
            error_ErrorCode.MISSING_INTL_API,
          ),
        );
      }
      try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting relative time.', config.locale, e));
      }
      return String(value);
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/dateTime.js
    var DATE_TIME_FORMAT_OPTIONS = [
      'formatMatcher',
      'timeZone',
      'hour12',
      'weekday',
      'era',
      'year',
      'month',
      'day',
      'hour',
      'minute',
      'second',
      'timeZoneName',
      'hourCycle',
      'dateStyle',
      'timeStyle',
      'calendar',
      // 'dayPeriod',
      'numberingSystem',
      'fractionalSecondDigits',
    ];
    function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
      var locale = _a.locale,
        formats = _a.formats,
        onError = _a.onError,
        timeZone = _a.timeZone;
      if (options === void 0) {
        options = {};
      }
      var format = options.format;
      var defaults = __assign(
        __assign(
          {},
          timeZone && {
            timeZone: timeZone,
          },
        ),
        format && getNamedFormat(formats, type, format, onError),
      );
      var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
      if (
        type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle
      ) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = __assign(__assign({}, filteredOptions), {
          hour: 'numeric',
          minute: 'numeric',
        });
      }
      return getDateTimeFormat(locale, filteredOptions);
    }
    function formatDate(config, getDateTimeFormat) {
      var _a = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
      }
      var value = _a[0],
        _b = _a[1],
        options = _b === void 0 ? {} : _b;
      var date = typeof value === 'string' ? new Date(value || 0) : value;
      try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting date.', config.locale, e));
      }
      return String(date);
    }
    function formatTime(config, getDateTimeFormat) {
      var _a = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
      }
      var value = _a[0],
        _b = _a[1],
        options = _b === void 0 ? {} : _b;
      var date = typeof value === 'string' ? new Date(value || 0) : value;
      try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting time.', config.locale, e));
      }
      return String(date);
    }
    function formatDateTimeRange(config, getDateTimeFormat) {
      var _a = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
      }
      var from = _a[0],
        to = _a[1],
        _b = _a[2],
        options = _b === void 0 ? {} : _b;
      var timeZone = config.timeZone,
        locale = config.locale,
        onError = config.onError;
      var filteredOptions = filterProps(
        options,
        DATE_TIME_FORMAT_OPTIONS,
        timeZone
          ? {
              timeZone: timeZone,
            }
          : {},
      );
      try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
      } catch (e) {
        onError(new IntlFormatError('Error formatting date time range.', config.locale, e));
      }
      return String(from);
    }
    function formatDateToParts(config, getDateTimeFormat) {
      var _a = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
      }
      var value = _a[0],
        _b = _a[1],
        options = _b === void 0 ? {} : _b;
      var date = typeof value === 'string' ? new Date(value || 0) : value;
      try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting date.', config.locale, e));
      }
      return [];
    }
    function formatTimeToParts(config, getDateTimeFormat) {
      var _a = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
      }
      var value = _a[0],
        _b = _a[1],
        options = _b === void 0 ? {} : _b;
      var date = typeof value === 'string' ? new Date(value || 0) : value;
      try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
      } catch (e) {
        config.onError(new IntlFormatError('Error formatting time.', config.locale, e));
      }
      return [];
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/plural.js
    var PLURAL_FORMAT_OPTIONS = ['type'];
    function formatPlural(_a, getPluralRules, value, options) {
      var locale = _a.locale,
        onError = _a.onError;
      if (options === void 0) {
        options = {};
      }
      if (!Intl.PluralRules) {
        onError(
          new error_FormatError(
            'Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n',
            error_ErrorCode.MISSING_INTL_API,
          ),
        );
      }
      var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
      try {
        return getPluralRules(locale, filteredOptions).select(value);
      } catch (e) {
        onError(new IntlFormatError('Error formatting plural.', locale, e));
      }
      return 'other';
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/list.js
    var LIST_FORMAT_OPTIONS = ['type', 'style'];
    var now = Date.now();
    function generateToken(i) {
      return ''.concat(now, '_').concat(i, '_').concat(now);
    }
    function formatList(opts, getListFormat, values, options) {
      if (options === void 0) {
        options = {};
      }
      var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
          all.push(val);
        } else if (typeof all[all.length - 1] === 'string') {
          all[all.length - 1] += val;
        } else {
          all.push(val);
        }
        return all;
      }, []);
      return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
    }
    function formatListToParts(_a, getListFormat, values, options) {
      var locale = _a.locale,
        onError = _a.onError;
      if (options === void 0) {
        options = {};
      }
      var ListFormat = Intl.ListFormat;
      if (!ListFormat) {
        onError(
          new error_FormatError(
            'Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n',
            error_ErrorCode.MISSING_INTL_API,
          ),
        );
      }
      var filteredOptions = filterProps(options, LIST_FORMAT_OPTIONS);
      try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
          if (typeof v === 'object') {
            var id = generateToken(i);
            richValues_1[id] = v;
            return id;
          }
          return String(v);
        });
        return getListFormat(locale, filteredOptions)
          .formatToParts(serializedValues)
          .map(function (part) {
            return part.type === 'literal'
              ? part
              : __assign(__assign({}, part), {
                  value: richValues_1[part.value] || part.value,
                });
          });
      } catch (e) {
        onError(new IntlFormatError('Error formatting list.', locale, e));
      }
      // @ts-ignore
      return values;
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/displayName.js
    var DISPLAY_NAMES_OPTONS = ['style', 'type', 'fallback', 'languageDisplay'];
    function formatDisplayName(_a, getDisplayNames, value, options) {
      var locale = _a.locale,
        onError = _a.onError;
      var DisplayNames = Intl.DisplayNames;
      if (!DisplayNames) {
        onError(
          new error_FormatError(
            'Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n',
            error_ErrorCode.MISSING_INTL_API,
          ),
        );
      }
      var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);
      try {
        return getDisplayNames(locale, filteredOptions).of(value);
      } catch (e) {
        onError(new IntlFormatError('Error formatting display name.', locale, e));
      }
    } // CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/create-intl.js
    function messagesContainString(messages) {
      var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
      return typeof firstMessage === 'string';
    }
    function verifyConfigMessages(config) {
      if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {})) {
        config.onWarn(
          '[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution',
        );
      }
    }
    /**
     * Create intl object
     * @param config intl config
     * @param cache cache for formatter instances to prevent memory leak
     */
    function createIntl(config, cache) {
      var formatters = createFormatters(cache);
      var resolvedConfig = __assign(__assign({}, DEFAULT_INTL_CONFIG), config);
      var locale = resolvedConfig.locale,
        defaultLocale = resolvedConfig.defaultLocale,
        onError = resolvedConfig.onError;
      if (!locale) {
        if (onError) {
          onError(
            new InvalidConfigError(
              '"locale" was not configured, using "'.concat(
                defaultLocale,
                '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details',
              ),
            ),
          );
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
      } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(
          new MissingDataError(
            'Missing locale data for locale: "'
              .concat(locale, '" in Intl.NumberFormat. Using default locale: "')
              .concat(
                defaultLocale,
                '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details',
              ),
          ),
        );
      } else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) {
        onError(
          new MissingDataError(
            'Missing locale data for locale: "'
              .concat(locale, '" in Intl.DateTimeFormat. Using default locale: "')
              .concat(
                defaultLocale,
                '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details',
              ),
          ),
        );
      }
      verifyConfigMessages(resolvedConfig);
      return __assign(__assign({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: formatMessage.bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: formatMessage.bind(null, resolvedConfig, formatters),
        formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames),
      });
    } // CONCATENATED MODULE: ./node_modules/react-intl/node_modules/intl-messageformat/lib/src/formatters.js
    var formatters_PART_TYPE;
    (function (PART_TYPE) {
      PART_TYPE[(PART_TYPE['literal'] = 0)] = 'literal';
      PART_TYPE[(PART_TYPE['object'] = 1)] = 'object';
    })(formatters_PART_TYPE || (formatters_PART_TYPE = {}));
    function formatters_mergeLiteral(parts) {
      if (parts.length < 2) {
        return parts;
      }
      return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== formatters_PART_TYPE.literal || part.type !== formatters_PART_TYPE.literal) {
          all.push(part);
        } else {
          lastPart.value += part.value;
        }
        return all;
      }, []);
    }
    function formatters_isFormatXMLElementFn(el) {
      return typeof el === 'function';
    }
    // TODO(skeleton): add skeleton support
    function formatters_formatToParts(
      els,
      locales,
      formatters,
      formats,
      values,
      currentPluralValue,
      // For debugging
      originalMessage,
    ) {
      // Hot path for straight simple msg translations
      if (els.length === 1 && isLiteralElement(els[0])) {
        return [
          {
            type: formatters_PART_TYPE.literal,
            value: els[0].value,
          },
        ];
      }
      var result = [];
      for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
          result.push({
            type: formatters_PART_TYPE.literal,
            value: el.value,
          });
          continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
          if (typeof currentPluralValue === 'number') {
            result.push({
              type: formatters_PART_TYPE.literal,
              value: formatters.getNumberFormat(locales).format(currentPluralValue),
            });
          }
          continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
          throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
          if (!value || typeof value === 'string' || typeof value === 'number') {
            value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
          }
          result.push({
            type: typeof value === 'string' ? formatters_PART_TYPE.literal : formatters_PART_TYPE.object,
            value: value,
          });
          continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
          var style =
            typeof el.style === 'string'
              ? formats.date[el.style]
              : isDateTimeSkeleton(el.style)
                ? el.style.parsedOptions
                : undefined;
          result.push({
            type: formatters_PART_TYPE.literal,
            value: formatters.getDateTimeFormat(locales, style).format(value),
          });
          continue;
        }
        if (isTimeElement(el)) {
          var style =
            typeof el.style === 'string'
              ? formats.time[el.style]
              : isDateTimeSkeleton(el.style)
                ? el.style.parsedOptions
                : formats.time.medium;
          result.push({
            type: formatters_PART_TYPE.literal,
            value: formatters.getDateTimeFormat(locales, style).format(value),
          });
          continue;
        }
        if (isNumberElement(el)) {
          var style =
            typeof el.style === 'string'
              ? formats.number[el.style]
              : isNumberSkeleton(el.style)
                ? el.style.parsedOptions
                : undefined;
          if (style && style.scale) {
            value = value * (style.scale || 1);
          }
          result.push({
            type: formatters_PART_TYPE.literal,
            value: formatters.getNumberFormat(locales, style).format(value),
          });
          continue;
        }
        if (isTagElement(el)) {
          var children = el.children,
            value_1 = el.value;
          var formatFn = values[value_1];
          if (!formatters_isFormatXMLElementFn(formatFn)) {
            throw new InvalidValueTypeError(value_1, 'function', originalMessage);
          }
          var parts = formatters_formatToParts(children, locales, formatters, formats, values, currentPluralValue);
          var chunks = formatFn(
            parts.map(function (p) {
              return p.value;
            }),
          );
          if (!Array.isArray(chunks)) {
            chunks = [chunks];
          }
          result.push.apply(
            result,
            chunks.map(function (c) {
              return {
                type: typeof c === 'string' ? formatters_PART_TYPE.literal : formatters_PART_TYPE.object,
                value: c,
              };
            }),
          );
        }
        if (isSelectElement(el)) {
          var opt = el.options[value] || el.options.other;
          if (!opt) {
            throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
          }
          result.push.apply(result, formatters_formatToParts(opt.value, locales, formatters, formats, values));
          continue;
        }
        if (isPluralElement(el)) {
          var opt = el.options['='.concat(value)];
          if (!opt) {
            if (!Intl.PluralRules) {
              throw new FormatError(
                'Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n',
                ErrorCode.MISSING_INTL_API,
                originalMessage,
              );
            }
            var rule = formatters
              .getPluralRules(locales, {
                type: el.pluralType,
              })
              .select(value - (el.offset || 0));
            opt = el.options[rule] || el.options.other;
          }
          if (!opt) {
            throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
          }
          result.push.apply(
            result,
            formatters_formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)),
          );
          continue;
        }
      }
      return formatters_mergeLiteral(result);
    } // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/createIntl.js
    /*
     * Copyright 2015, Yahoo Inc.
     * Copyrights licensed under the New BSD License.
     * See the accompanying LICENSE file for terms.
     */

    function assignUniqueKeysToFormatXMLElementFnArgument(values) {
      if (!values) {
        return values;
      }
      return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = formatters_isFormatXMLElementFn(v) ? assignUniqueKeysToParts(v) : v;
        return acc;
      }, {});
    }
    var createIntl_formatMessage = function (config, formatters, descriptor, rawValues) {
      var rest = [];
      for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
      }
      var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
      var chunks = formatMessage.apply(void 0, __spreadArray([config, formatters, descriptor, values], rest, false));
      if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
      }
      return chunks;
    };
    /**
     * Create intl object
     * @param config intl config
     * @param cache cache for formatter instances to prevent memory leak
     */
    var createIntl_createIntl = function (_a, cache) {
      var rawDefaultRichTextElements = _a.defaultRichTextElements,
        config = tslib_es6_rest(_a, ['defaultRichTextElements']);
      var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
      var coreIntl = createIntl(
        __assign(__assign(__assign({}, utils_DEFAULT_INTL_CONFIG), config), {
          defaultRichTextElements: defaultRichTextElements,
        }),
        cache,
      );
      var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements,
      };
      return __assign(__assign({}, coreIntl), {
        formatMessage: createIntl_formatMessage.bind(
          null,
          resolvedConfig,
          // @ts-expect-error fix this
          coreIntl.formatters,
        ),
        // @ts-expect-error fix this
        $t: createIntl_formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
      });
    }; // CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/provider.js
    /*
     * Copyright 2015, Yahoo Inc.
     * Copyrights licensed under the New BSD License.
     * See the accompanying LICENSE file for terms.
     */

    function processIntlConfig(config) {
      return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
      };
    }
    var provider_IntlProvider = /** @class */ (function (_super) {
      __extends(IntlProvider, _super);
      function IntlProvider() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.cache = createIntlCache();
        _this.state = {
          cache: _this.cache,
          intl: createIntl_createIntl(processIntlConfig(_this.props), _this.cache),
          prevConfig: processIntlConfig(_this.props),
        };
        return _this;
      }
      IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig,
          cache = _a.cache;
        var config = processIntlConfig(props);
        if (!shallowEqual(prevConfig, config)) {
          return {
            intl: createIntl_createIntl(config, cache),
            prevConfig: config,
          };
        }
        return null;
      };
      IntlProvider.prototype.render = function () {
        invariantIntlContext(this.state.intl);
        return /*#__PURE__*/ react.createElement(
          Provider,
          {
            value: this.state.intl,
          },
          this.props.children,
        );
      };
      IntlProvider.displayName = 'IntlProvider';
      IntlProvider.defaultProps = utils_DEFAULT_INTL_CONFIG;
      return IntlProvider;
    })(react.PureComponent);
    /* harmony default export */ const provider = provider_IntlProvider; // CONCATENATED MODULE: ./src/elements/common/Internationalize.js
    /**
     *
     * @file Wraps a component in an IntlProvider
     * @author Box
     */

    const Internationalize = ({ language, messages, children }) => {
      const shouldInternationalize = !!language && !!messages;
      if (shouldInternationalize) {
        return /*#__PURE__*/ react.createElement(
          provider,
          {
            locale: language,
            messages: messages,
          },
          children,
        );
      }
      return react.Children.only(children);
    };
    /* harmony default export */ const common_Internationalize = Internationalize; // CONCATENATED MODULE: ./src/utils/uploads.js
    /**
     *
     * @file Utility functions for uploads
     * @author Box
     */

    const DEFAULT_API_OPTIONS = {};

    /**
     * Returns true if file contains API options
     *
     * @param {UploadFile | UploadFileWithAPIOptions} item
     * @returns {boolean}
     */
    function doesFileContainAPIOptions(file) {
      // $FlowFixMe UploadFileWithAPIOptions has `file` and `options` properties
      return !!(file.options && file.file);
    }

    /**
     * Returns true if item contains API options
     *
     * @param {DataTransferItem | UploadDataTransferItemWithAPIOptions} item
     * @returns {boolean}
     */
    function doesDataTransferItemContainAPIOptions(item) {
      // $FlowFixMe UploadDataTransferItemWithAPIOptions has `item` and `options` properties
      return !!(item.options && item.item);
    }

    /**
     * Converts UploadFile or UploadFileWithAPIOptions to UploadFile
     *
     * @param {UploadFile | UploadFileWithAPIOptions} file
     * @returns {UploadFile}
     */
    function getFile(file) {
      if (doesFileContainAPIOptions(file)) {
        return file.file;
      }
      return file;
    }

    /**
     * Converts DataTransferItem or UploadDataTransferItemWithAPIOptions to DataTransferItem
     *
     * @param {DataTransferItem | UploadDataTransferItemWithAPIOptions} item
     * @returns {DataTransferItem}
     */
    function getDataTransferItem(item) {
      if (doesDataTransferItemContainAPIOptions(item)) {
        return item.item;
      }
      return item;
    }

    /**
     * Get API Options from file
     *
     * @param {UploadFile | UploadFileWithAPIOptions} file
     * @returns {UploadItemAPIOptions}
     */
    function getFileAPIOptions(file) {
      if (doesFileContainAPIOptions(file)) {
        return file.options || DEFAULT_API_OPTIONS;
      }
      return DEFAULT_API_OPTIONS;
    }

    /**
     * Get API Options from item
     *
     * @param {DataTransferItem | UploadDataTransferItemWithAPIOptions} item
     * @returns {UploadItemAPIOptions}
     */
    function getDataTransferItemAPIOptions(item) {
      if (doesDataTransferItemContainAPIOptions(item)) {
        return item.options || DEFAULT_API_OPTIONS;
      }
      return DEFAULT_API_OPTIONS;
    }

    /**
     * Returns true if the given object is a Date instance encoding a valid date
     * (i.e. new Date('this is not a timestamp') should return false).
     *
     * Code adapted from
     * http://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
     *
     * @param {Date} date
     * @return {boolean}
     */
    function isValidDateObject(date) {
      return Object.prototype.toString.call(date) === '[object Date]' && !Number.isNaN(date.getTime());
    }

    /**
     * Remove milliseconds from date time string
     *
     * @param {Date} date
     * @return {string}
     */
    function toISOStringNoMS(date) {
      return date.toISOString().replace(/\.[0-9]{3}/, '');
    }

    /**
     * Returns the file's last modified date as an ISO string with no MS component (e.g.
     * '2017-04-18T17:14:27Z'), or null if no such date can be extracted from the file object.
     * (Nothing on the Internet guarantees that the file object has this info.)
     *
     * @param {UploadFile} file
     * @return {?string}
     */
    function getFileLastModifiedAsISONoMSIfPossible(file) {
      // The compatibility chart at https://developer.mozilla.org/en-US/docs/Web/API/File/lastModified#Browser_compatibility
      // is not up to date as of 12-13-2018. Edge & ie11 do not support lastModified, but support lastModifiedDate.
      const lastModified = file.lastModified || file.lastModifiedDate;
      if (
        lastModified &&
        (typeof lastModified === 'string' || typeof lastModified === 'number' || lastModified instanceof Date)
      ) {
        const lastModifiedDate = new Date(lastModified);
        if (isValidDateObject(lastModifiedDate)) {
          return toISOStringNoMS(lastModifiedDate);
        }
      }
      return null;
    }

    /**
     * If maybeJson is valid JSON string, return the result of calling JSON.parse
     * on it.  Otherwise, return null.
     *
     * @param {string} maybeJson
     * @return {?Object}
     */
    function tryParseJson(maybeJson) {
      try {
        return JSON.parse(maybeJson);
      } catch (e) {
        return null;
      }
    }

    /**
     * Get bounded exponential backoff retry delay
     *
     * @param {number} initialRetryDelay
     * @param {number} maxRetryDelay
     * @param {number} retryNum - Current retry number (first retry will have value of 0).
     * @return {number}
     */
    function getBoundedExpBackoffRetryDelay(initialRetryDelay, maxRetryDelay, retryNum) {
      const delay = initialRetryDelay * retryNum ** 2;
      return delay > maxRetryDelay ? maxRetryDelay : delay;
    }

    /**
     * Get entry from dataTransferItem
     *
     * @param {DataTransferItem} item
     * @returns {FileSystemFileEntry}
     */
    function getEntryFromDataTransferItem(item) {
      const entry =
        // $FlowFixMe
        item.webkitGetAsEntry || item.mozGetAsEntry || item.getAsEntry;
      return entry.call(item);
    }

    /**
     * Check if a dataTransferItem is a folder
     *
     * @param {UploadDataTransferItemWithAPIOptions | DataTransferItem} itemData
     * @returns {boolean}
     */
    function isDataTransferItemAFolder(itemData) {
      const item = getDataTransferItem(itemData);
      const entry = getEntryFromDataTransferItem(item);
      if (!entry) {
        return false;
      }
      return entry.isDirectory;
    }

    /**
     * Check if a dataTransfer item is a macOS "package file"
     * @see https://en.wikipedia.org/wiki/Package_(macOS)
     *
     * @returns {boolean}
     */
    function isDataTransferItemAPackage(itemData) {
      const item = getDataTransferItem(itemData);
      const isDirectory = isDataTransferItemAFolder(item);
      return isDirectory && item.type === 'application/zip' && item.kind === 'file';
    }

    /**
     * Get file from FileSystemFileEntry
     *
     * @param {FileSystemFileEntry} entry
     * @returns {Promise<UploadFile>}
     */
    function getFileFromEntry(entry) {
      return new Promise(resolve => {
        entry.file(file => {
          resolve(file);
        });
      });
    }

    /**
     * Get file from DataTransferItem or UploadDataTransferItemWithAPIOptions
     *
     * @param {UploadDataTransferItemWithAPIOptions | DataTransferItem} itemData
     * @returns {Promise<UploadFile | UploadFileWithAPIOptions | null>}
     */
    async function getFileFromDataTransferItem(itemData) {
      const item = getDataTransferItem(itemData);
      const entry = getEntryFromDataTransferItem(item);
      if (!entry) {
        return null;
      }
      const file = await getFileFromEntry(entry);
      if (doesDataTransferItemContainAPIOptions(itemData)) {
        return {
          file: file,
          options: getDataTransferItemAPIOptions(itemData),
        };
      }
      return file;
    }

    /**
     * Get file from DataTransferItem or UploadDataTransferItemWithAPIOptions
     * Uses `entry`'s `getAsFile` method for retrieving package information as a single file.
     * @see https://en.wikipedia.org/wiki/Package_(macOS)
     *
     * @param {UploadDataTransferItemWithAPIOptions | DataTransferItem} itemData
     * @returns {?UploadFile | ?UploadFileWithAPIOptions | null}
     */
    function getPackageFileFromDataTransferItem(itemData) {
      const item = getDataTransferItem(itemData);
      const entry = getEntryFromDataTransferItem(item);
      if (!entry) {
        return null;
      }
      const itemFile = item.getAsFile();
      if (doesDataTransferItemContainAPIOptions(itemData)) {
        return {
          file: itemFile,
          options: getDataTransferItemAPIOptions(itemData),
        };
      }
      return itemFile;
    }

    /**
     * Generates file id based on file properties
     *
     * When folderId or uploadInitTimestamp is missing from file options, file name is returned as file id.
     * Otherwise, fileName_folderId_uploadInitTimestamp is used as file id.
     *
     * @param {UploadFileWithAPIOptions | UploadFile} file
     * @param {string} rootFolderId
     * @returns {string}
     */
    function getFileId(file, rootFolderId) {
      if (!doesFileContainAPIOptions(file)) {
        return file.name;
      }
      const fileWithOptions = file;
      const folderId = get_default()(fileWithOptions, 'options.folderId', rootFolderId);
      const uploadInitTimestamp = get_default()(fileWithOptions, 'options.uploadInitTimestamp', Date.now());
      const fileName = fileWithOptions.file.webkitRelativePath || fileWithOptions.file.name;
      return `${fileName}_${folderId}_${uploadInitTimestamp}`;
    }

    /**
     * Generates item id based on item properties
     *
     * When item options including folderId or uploadInitTimestamp are missing, item name is returned as item id.
     * Otherwise, item properties are used as item id.
     * E.g., folder1_0_123124124
     *
     * @param {DataTransferItem | UploadDataTransferItemWithAPIOptions} itemData
     * @param {string} rootFolderId
     * @returns {string}
     */
    function getDataTransferItemId(itemData, rootFolderId) {
      const item = getDataTransferItem(itemData);
      const { name } = getEntryFromDataTransferItem(item);
      if (!doesDataTransferItemContainAPIOptions(itemData)) {
        return name;
      }
      const { folderId = rootFolderId, uploadInitTimestamp = Date.now() } = getDataTransferItemAPIOptions(itemData);
      return `${name}_${folderId}_${uploadInitTimestamp}`;
    }

    /**
     * Multiput uploads require the use of crypto, which is only supported in secure contexts.
     * Multiput uploads is not supported on mobile iOS Safari.
     */
    function isMultiputSupported() {
      const cryptoObj = window.crypto || window.msCrypto;
      if (utils_Browser.isMobileSafari()) {
        return false;
      }
      return window.location.protocol === 'https:' && cryptoObj && cryptoObj.subtle;
    } // CONCATENATED MODULE: ./src/utils/error.js

    /**
     *
     * @file Helper functions for errors
     * @author Box
     */

    function error_getBadItemError() {
      return new Error('Bad box item!');
    }
    function getBadPermissionsError() {
      return new Error('Insufficient Permissions!');
    }
    function getBadUserError() {
      return new Error('Bad box user!');
    }
    function getMissingItemTextOrStatus() {
      return new Error('Missing text or status!');
    }
    function isUserCorrectableError(status) {
      return (
        status === HTTP_STATUS_CODE_RATE_LIMIT ||
        status === HTTP_STATUS_CODE_UNAUTHORIZED ||
        status === HTTP_STATUS_CODE_CONFLICT ||
        status >= HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR
      );
    } // CONCATENATED MODULE: ./src/utils/flatten.js

    /**
     *
     * @file Function to flatten an item list
     * @author Box
     */

    /**
     * Takes an item list and flattens it by moving
     * all item entries into the cache and replacing the list
     * entries with references to those items in the cache.
     * Web links are trated as files.
     *
     * @param {Array} list to flatten
     * @param {Folder} folderAPI api for files
     * @param {File} fileAPI api for files
     * @param {WebLink} weblinkAPI api for web links
     * @return {Array} list with items replaced with reference keys
     */
    function flatten(list, folderAPI, fileAPI, weblinkAPI) {
      const items = [];
      list.forEach(item => {
        const { id, type } = item;
        if (!id || !type) {
          throw error_getBadItemError();
        }
        let api;
        switch (type) {
          case constants_TYPE_FOLDER:
            api = folderAPI;
            break;
          case constants_TYPE_FILE:
            api = fileAPI;
            break;
          case TYPE_WEBLINK:
            api = weblinkAPI;
            break;
          default:
            throw new Error('Unknown Type!');
        }
        const cache = api.getCache();
        const key = api.getCacheKey(id);
        if (cache.has(key)) {
          cache.merge(key, item);
        } else {
          cache.set(key, item);
        }
        items.push(key);
      });
      return items;
    }
    // EXTERNAL MODULE: ./node_modules/lodash/has.js
    var lodash_has = __webpack_require__(75322);
    var has_default = /*#__PURE__*/ __webpack_require__.n(lodash_has);
    // EXTERNAL MODULE: ./node_modules/lodash/set.js
    var set = __webpack_require__(19170);
    var set_default = /*#__PURE__*/ __webpack_require__.n(set); // CONCATENATED MODULE: ./src/utils/fields.js
    function fields_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function fields_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? fields_ownKeys(Object(t), !0).forEach(function (r) {
              fields_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : fields_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function fields_defineProperty(e, r, t) {
      return (
        (r = fields_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function fields_toPropertyKey(t) {
      var i = fields_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function fields_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Utility to combine API fields needed
     * @author Box
     */

    // Minimum set of fields needed for folder requests
    const FOLDER_FIELDS_TO_FETCH = [
      FIELD_ID,
      constants_FIELD_NAME,
      FIELD_TYPE,
      constants_FIELD_SIZE,
      FIELD_PARENT,
      FIELD_EXTENSION,
      FIELD_PERMISSIONS,
      FIELD_PATH_COLLECTION,
      constants_FIELD_MODIFIED_AT,
      FIELD_CREATED_AT,
      FIELD_MODIFIED_BY,
      FIELD_HAS_COLLABORATIONS,
      FIELD_IS_EXTERNALLY_OWNED,
      FIELD_ITEM_COLLECTION,
      FIELD_AUTHENTICATED_DOWNLOAD_URL,
      FIELD_IS_DOWNLOAD_AVAILABLE,
      FIELD_REPRESENTATIONS,
      FIELD_URL,
    ];

    // Fields needed for the sidebar
    const SIDEBAR_FIELDS_TO_FETCH = [
      FIELD_ID,
      constants_FIELD_NAME,
      constants_FIELD_SIZE,
      FIELD_EXTENSION,
      FIELD_FILE_VERSION,
      FIELD_SHARED_LINK,
      FIELD_PERMISSIONS,
      FIELD_CONTENT_CREATED_AT,
      FIELD_CONTENT_MODIFIED_AT,
      FIELD_CREATED_AT,
      FIELD_CREATED_BY,
      constants_FIELD_MODIFIED_AT,
      FIELD_MODIFIED_BY,
      FIELD_OWNED_BY,
      FIELD_DESCRIPTION,
      FIELD_METADATA_SKILLS,
      FIELD_ITEM_EXPIRATION,
      FIELD_VERSION_LIMIT,
      FIELD_VERSION_NUMBER,
      FIELD_IS_EXTERNALLY_OWNED,
      FIELD_RESTORED_FROM,
      FIELD_AUTHENTICATED_DOWNLOAD_URL,
      FIELD_IS_DOWNLOAD_AVAILABLE,
      FIELD_UPLOADER_DISPLAY_NAME,
    ];

    // Fields needed for preview
    const PREVIEW_FIELDS_TO_FETCH = [
      FIELD_ID,
      FIELD_PERMISSIONS,
      FIELD_SHARED_LINK,
      FIELD_SHA1,
      FIELD_FILE_VERSION,
      constants_FIELD_NAME,
      constants_FIELD_SIZE,
      FIELD_EXTENSION,
      FIELD_REPRESENTATIONS,
      FIELD_WATERMARK_INFO,
      FIELD_AUTHENTICATED_DOWNLOAD_URL,
      FIELD_IS_DOWNLOAD_AVAILABLE,
    ];

    // Fields needed to get versions for a file in activity feed
    const FEED_FILE_VERSIONS_FIELDS_TO_FETCH = [
      FIELD_CREATED_AT,
      FIELD_EXTENSION,
      FIELD_IS_DOWNLOAD_AVAILABLE,
      constants_FIELD_MODIFIED_AT,
      FIELD_MODIFIED_BY,
      constants_FIELD_NAME,
      FIELD_RESTORED_AT,
      FIELD_RESTORED_BY,
      constants_FIELD_SIZE,
      FIELD_TRASHED_AT,
      FIELD_TRASHED_BY,
      FIELD_UPLOADER_DISPLAY_NAME,
      FIELD_VERSION_NUMBER,
    ];

    // Fields needed to get information on the current version of a file
    const FILE_VERSION_FIELDS_TO_FETCH = [
      FIELD_FILE_VERSION,
      constants_FIELD_MODIFIED_AT,
      FIELD_MODIFIED_BY,
      FIELD_RESTORED_FROM,
      constants_FIELD_SIZE,
      FIELD_PROMOTED_BY,
      FIELD_UPLOADER_DISPLAY_NAME,
      FIELD_VERSION_NUMBER,
    ];

    // Fields needed to get versions for a file
    const FILE_VERSIONS_FIELDS_TO_FETCH = [
      FIELD_AUTHENTICATED_DOWNLOAD_URL,
      // Expensive field to fetch
      FIELD_CREATED_AT,
      FIELD_EXTENSION,
      FIELD_IS_DOWNLOAD_AVAILABLE,
      constants_FIELD_MODIFIED_AT,
      FIELD_MODIFIED_BY,
      constants_FIELD_NAME,
      FIELD_PERMISSIONS,
      // Expensive field to fetch
      FIELD_PROMOTED_BY,
      FIELD_RESTORED_AT,
      FIELD_RESTORED_BY,
      FIELD_RETENTION,
      // Expensive field to fetch
      constants_FIELD_SIZE,
      FIELD_TRASHED_AT,
      FIELD_TRASHED_BY,
      FIELD_UPLOADER_DISPLAY_NAME,
      FIELD_VERSION_NUMBER,
    ];

    // Fields needed to show shared link permissions
    const FILE_SHARED_LINK_FIELDS_TO_FETCH = [FIELD_ALLOWED_SHARED_LINK_ACCESS_LEVELS, FIELD_SHARED_LINK];

    // Fields needed to get tasks data
    const TASKS_FIELDS_TO_FETCH = [
      FIELD_TASK_ASSIGNMENT_COLLECTION,
      FIELD_IS_COMPLETED,
      FIELD_CREATED_AT,
      FIELD_CREATED_BY,
      FIELD_DUE_AT,
      FIELD_MESSAGE,
    ];

    // Fields needed to get task assignments data
    const TASK_ASSIGNMENTS_FIELDS_TO_FETCH = [FIELD_ASSIGNED_TO, FIELD_STATUS];

    // Fields needed to get tasks data
    const COMMENTS_FIELDS_TO_FETCH = [
      FIELD_TAGGED_MESSAGE,
      FIELD_MESSAGE,
      FIELD_CREATED_AT,
      FIELD_CREATED_BY,
      constants_FIELD_MODIFIED_AT,
      FIELD_PERMISSIONS,
    ];

    // Fields that represent users
    const USER_FIELDS = [FIELD_CREATED_BY, FIELD_MODIFIED_BY, FIELD_OWNED_BY, FIELD_ASSIGNED_TO];

    // Fields required to fetch app activity
    const APP_ACTIVITY_FIELDS_TO_FETCH = [
      FIELD_ACTIVITY_TEMPLATE,
      FIELD_APP,
      FIELD_CREATED_BY,
      FIELD_OCCURRED_AT,
      FIELD_RENDERED_TEXT,
    ];

    /**
     * Finds properties missing in an object
     *
     * @param {Object} obj - some object
     * @param {Array<string>|void} [properties] - object properties to check
     * @return {Array<string>} comma seperated list of properties missing
     */
    function findMissingProperties(obj, properties = []) {
      // If file doesn't exist or is an empty object, we should fetch all fields
      if (!obj || typeof obj !== 'object' || Object.keys(obj).length === 0) {
        return properties;
      }
      return properties.filter(field => !has_default()(obj, field));
    }

    /**
     * Fill properties missing in an object
     *
     * @param {Object} obj - some object
     * @param {Array<string>|void} [properties] - some properties to check
     * @return {Object} new object with missing fields
     */
    function fillMissingProperties(obj = {}, properties) {
      // If file doesn't exist or is an empty object, we should fetch all fields
      if (!Array.isArray(properties) || properties.length === 0) {
        return obj;
      }
      const newObj = fields_objectSpread({}, obj);
      const missingProperties = findMissingProperties(obj, properties);
      missingProperties.forEach(field => {
        // @Note: This will overwrite non object fields
        // @Note: We don't know the type of the field
        set_default()(newObj, field, null);
      });
      return newObj;
    }

    /**
     * Fill user properties that are null in an object
     *
     * @param {Object} obj - some object
     * @return {Object} new object with user placeholder
     */
    function fillUserPlaceholder(obj) {
      const newObj = fields_objectSpread({}, obj);
      USER_FIELDS.forEach(field => {
        if (has(newObj, field) && newObj[field] === null) {
          setProp(newObj, field, PLACEHOLDER_USER);
        }
      });
      return newObj;
    }

    // EXTERNAL MODULE: ./node_modules/axios/index.js
    var axios = __webpack_require__(53095);
    var axios_default = /*#__PURE__*/ __webpack_require__.n(axios);
    // EXTERNAL MODULE: ./node_modules/lodash/includes.js
    var includes = __webpack_require__(69849);
    var includes_default = /*#__PURE__*/ __webpack_require__.n(includes);
    // EXTERNAL MODULE: ./node_modules/lodash/lowerCase.js
    var lowerCase = __webpack_require__(59315);
    var lowerCase_default = /*#__PURE__*/ __webpack_require__.n(lowerCase); // CONCATENATED MODULE: ./src/utils/TokenService.js
    /**
     *
     * @file An example of a token managing service
     * @author Box
     */

    const error = new Error(
      'Bad id or auth token. ID should be typed id like file_123 or folder_123! Token should be a string or function.',
    );
    class TokenService {
      /**
       * Function to fetch a single token. The user supplied token can either
       * itself be a simple token or instead be a function that returns a promise.
       * This promise then resolves to either a string/null/undefined token or
       * a read/write token pair.
       *
       * @private
       * @param {string} id - box item typed id
       * @param {string} tokenOrTokenFunction - Optional token or token function
       * @return {Promise} that resolves to a token
       */
      static async getToken(id, tokenOrTokenFunction) {
        // Make sure we are getting typed ids
        // Tokens should either be null or undefined or string or functions
        // Anything else is not supported and throw error
        if (
          (tokenOrTokenFunction !== null &&
            tokenOrTokenFunction !== undefined &&
            typeof tokenOrTokenFunction !== 'string' &&
            typeof tokenOrTokenFunction !== 'function') ||
          (!id.startsWith(TYPED_ID_FOLDER_PREFIX) && !id.startsWith(TYPED_ID_FILE_PREFIX))
        ) {
          throw error;
        }

        // Token is a simple string or null or undefined
        if (!tokenOrTokenFunction || typeof tokenOrTokenFunction === 'string') {
          return tokenOrTokenFunction;
        }

        // Token is a function which returns a promise.
        // Promise on resolution returns a string/null/undefined token or token pair.
        const token = await tokenOrTokenFunction(id);
        if (!token || typeof token === 'string' || (typeof token === 'object' && (token.read || token.write))) {
          return token;
        }
        throw error;
      }

      /**
       * Gets a string read token.
       * Defaults to a simple token string.
       *
       * @public
       * @param {string} id - box item typed id
       * @param {Token} tokenOrTokenFunction - Optional token or token function
       * @return {Promise} that resolves to a token
       */
      static async getReadToken(id, tokenOrTokenFunction) {
        const token = await TokenService.getToken(id, tokenOrTokenFunction);
        if (token && typeof token === 'object') {
          return token.read;
        }
        return token;
      }

      /**
       * Gets read tokens.
       *
       * @public
       * @param {string|string[]} id - box item typed id(s)
       * @param {Token} tokenOrTokenFunction - Token to use or token generation function
       * @return {Promise} Promise that resolves with id to token map
       */
      static async getReadTokens(id, tokenOrTokenFunction) {
        const ids = Array.isArray(id) ? id : [id];
        const promises = ids.map(typedId => TokenService.getReadToken(typedId, tokenOrTokenFunction));
        const tokens = await Promise.all(promises);
        const tokenMap = {};
        tokens.forEach((token, index) => {
          tokenMap[ids[index]] = token;
        });
        return Promise.resolve(tokenMap);
      }

      /**
       * Gets a string write token.
       * Defaults to either the read token or a simple token string.
       *
       * @public
       * @param {string} id - box item typed id
       * @param {string} tokenOrTokenFunction - Optional token or token function
       * @return {Promise} that resolves to a token
       */
      static async getWriteToken(id, tokenOrTokenFunction) {
        const token = await TokenService.getToken(id, tokenOrTokenFunction);
        if (token && typeof token === 'object') {
          return token.write || token.read;
        }
        return token;
      }

      /**
       * Function to fetch and cache multiple tokens. The user supplied token can either
       * itself be a simple token or instead be a function that returns a promise.
       * This promise then resolves signifying requested tokens were cached.
       *
       * This function however does not return tokens as it is expected to only be used
       * by the token generator to cache all tokens that may be needed in the future.
       *
       * @public
       * @param {Array<string>} idd - box item typed ids
       * @param {string} tokenOrTokenFunction - Optional token or token function
       * @return {Promise<TokenMap>} that resolves to a token map
       */
      static async cacheTokens(ids, tokenOrTokenFunction) {
        // Make sure we are getting typed ids
        // Tokens should either be null or undefined or string or functions
        // Anything else is not supported and throw error
        if (
          (tokenOrTokenFunction !== null &&
            tokenOrTokenFunction !== undefined &&
            typeof tokenOrTokenFunction !== 'string' &&
            typeof tokenOrTokenFunction !== 'function') ||
          !ids.every(itemId => itemId.startsWith(TYPED_ID_FOLDER_PREFIX) || itemId.startsWith(TYPED_ID_FILE_PREFIX))
        ) {
          throw error;
        }

        // Only need to fetch and cache multiple tokens when the user supplied token was a
        // token function. This function should internally cache the tokens for future use.
        if (typeof tokenOrTokenFunction === 'function') {
          await tokenOrTokenFunction(ids);
        }
        return Promise.resolve();
      }
    }
    /* harmony default export */ const utils_TokenService = TokenService; // CONCATENATED MODULE: ./src/utils/Xhr.js
    function Xhr_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Xhr_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Xhr_ownKeys(Object(t), !0).forEach(function (r) {
              Xhr_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Xhr_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Xhr_defineProperty(e, r, t) {
      return (
        (r = Xhr_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Xhr_toPropertyKey(t) {
      var i = Xhr_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Xhr_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Network utilities
     * @author Box
     */

    const DEFAULT_UPLOAD_TIMEOUT_MS = 120000;
    const MAX_NUM_RETRIES = 3;
    const RETRYABLE_HTTP_METHODS = [HTTP_GET, HTTP_OPTIONS, HTTP_HEAD].map(lowerCase_default());
    class Xhr {
      /**
       * [constructor]
       *
       * @param {Object} options
       * @param {string} options.id - item id
       * @param {string} options.clientName - Client Name
       * @param {string|function} options.token - Auth token
       * @param {string} [options.language] - Accept-Language header value
       * @param {string} [options.sharedLink] - Shared link
       * @param {string} [options.sharedLinkPassword] - Shared link password
       * @param {string} [options.requestInterceptor] - Request interceptor
       * @param {string} [options.responseInterceptor] - Response interceptor
       * @param {number[]} [options.retryableStatusCodes] - Response codes to retry
       * @param {boolean} [options.shouldRetry] - Should retry failed requests
       * @return {Xhr} Cache instance
       */
      constructor({
        id,
        clientName,
        language,
        token,
        version,
        sharedLink,
        sharedLinkPassword,
        responseInterceptor,
        requestInterceptor,
        retryableStatusCodes = [HTTP_STATUS_CODE_RATE_LIMIT],
        shouldRetry: _shouldRetry = true,
      } = {}) {
        Xhr_defineProperty(this, 'retryCount', 0);
        /**
         * Error interceptor that wraps the passed in responseInterceptor
         *
         * @param {Object} error - Error object from axios
         * @return {Promise} rejected promise with error info
         */
        Xhr_defineProperty(this, 'errorInterceptor', error => {
          const shouldRetry = this.shouldRetryRequest(error);
          if (shouldRetry) {
            this.retryCount += 1;
            const delay = this.getExponentialRetryTimeoutInMs(this.retryCount);
            return new Promise((resolve, reject) => {
              this.retryTimeout = setTimeout(() => {
                this.axios(error.config).then(resolve, reject);
              }, delay);
            });
          }
          const errorObject = get_default()(error, 'response.data') || error; // In the case of 401, response.data is empty so fall back to error
          this.responseInterceptor(errorObject);
          return Promise.reject(error);
        });
        this.clientName = clientName;
        this.id = id;
        this.language = language;
        this.responseInterceptor = responseInterceptor || this.defaultResponseInterceptor;
        this.retryableStatusCodes = retryableStatusCodes;
        this.sharedLink = sharedLink;
        this.sharedLinkPassword = sharedLinkPassword;
        this.shouldRetry = _shouldRetry;
        this.token = token;
        this.version = version;
        this.axios = axios_default().create();
        this.axiosSource = axios_default().CancelToken.source();
        this.axios.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
        if (typeof requestInterceptor === 'function') {
          this.axios.interceptors.request.use(requestInterceptor);
        }
      }

      /**
       * Default response interceptor which just returns the response
       *
       * @param {Object} response - the axios response
       * @return the response
       */
      defaultResponseInterceptor(response) {
        return response;
      }

      /**
       * Determines if a request should be retried
       *
       * @param {Object} error - Error object from axios
       * @return {boolean} true if the request should be retried
       */
      shouldRetryRequest(error) {
        if (!this.shouldRetry || this.retryCount >= MAX_NUM_RETRIES) {
          return false;
        }
        const { response, request, config } = error;
        // Retry if there is a network error (e.g. ECONNRESET) or rate limited
        const status = get_default()(response, 'status');
        const method = get_default()(config, 'method');
        const isNetworkError = request && !response;
        const isRateLimitError = status === HTTP_STATUS_CODE_RATE_LIMIT;
        const isOtherRetryableError =
          includes_default()(this.retryableStatusCodes, status) && includes_default()(RETRYABLE_HTTP_METHODS, method);
        return isNetworkError || isRateLimitError || isOtherRetryableError;
      }

      /**
       * Calculate the exponential backoff time with randomized jitter.
       *
       * @param {number} numRetries Which retry number this one will be. Must be > 0
       * @returns {number} The number of milliseconds after which to retry
       */
      getExponentialRetryTimeoutInMs(numRetries) {
        const randomizationMs = Math.ceil(Math.random() * 1000);
        const exponentialMs = 2 ** (numRetries - 1) * 1000;
        return exponentialMs + randomizationMs;
      }
      /**
       * Utility to parse a URL.
       *
       * @param {string} url - Url to parse
       * @return {Object} parsed url
       */
      getParsedUrl(url) {
        const a = document.createElement('a');
        a.href = url;
        return {
          api: url.replace(`${a.origin}/2.0`, ''),
          host: a.host,
          hostname: a.hostname,
          pathname: a.pathname,
          origin: a.origin,
          protocol: a.protocol,
          hash: a.hash,
          port: a.port,
        };
      }

      /**
       * Builds a list of required XHR headers.
       *
       * @param {string} [id] - Optional box item id
       * @param {Object} [args] - Optional existing headers
       * @return {Object} Headers
       */
      async getHeaders(id, args = {}) {
        const headers = Xhr_objectSpread(
          {
            Accept: 'application/json',
            [HEADER_CONTENT_TYPE]: 'application/json',
          },
          args,
        );
        if (this.language && !headers[HEADER_ACCEPT_LANGUAGE]) {
          headers[HEADER_ACCEPT_LANGUAGE] = this.language;
        }
        if (this.sharedLink) {
          headers.BoxApi = `shared_link=${this.sharedLink}`;
          if (this.sharedLinkPassword) {
            headers.BoxApi = `${headers.BoxApi}&shared_link_password=${this.sharedLinkPassword}`;
          }
        }
        if (this.clientName) {
          headers[HEADER_CLIENT_NAME] = this.clientName;
        }
        if (this.version) {
          headers[HEADER_CLIENT_VERSION] = this.version;
        }

        // If id is passed in, use that, otherwise default to this.id
        const itemId = id || this.id || '';
        const token = await utils_TokenService.getWriteToken(itemId, this.token);
        if (token) {
          // Only add a token when there was one found
          headers.Authorization = `Bearer ${token}`;
        }
        return headers;
      }

      /**
       * HTTP GETs a URL
       *
       * @param {string} id - Box item id
       * @param {string} url - The URL to fetch
       * @param {Object} [headers] - Key-value map of headers
       * @param {Object} [params] - Key-value map of querystring params
       * @return {Promise} - HTTP response
       */
      get({ url, id, params = {}, headers = {} }) {
        return this.getHeaders(id, headers).then(hdrs =>
          this.axios.get(url, {
            cancelToken: this.axiosSource.token,
            params,
            headers: hdrs,
            parsedUrl: this.getParsedUrl(url),
          }),
        );
      }

      /**
       * HTTP POSTs a URL with JSON data
       *
       * @param {string} id - Box item id
       * @param {string} url - The URL to fetch
       * @param {Object} data - JS Object representation of JSON data to send
       * @param {Object} params - Optional query params for the request
       * @param {Object} [headers] - Key-value map of headers
       * @param {string} [method] - xhr type
       * @return {Promise} - HTTP response
       */
      post({ url, id, data, params, headers = {}, method = HTTP_POST }) {
        return this.getHeaders(id, headers).then(hdrs =>
          this.axios({
            url,
            data,
            params,
            method,
            parsedUrl: this.getParsedUrl(url),
            headers: hdrs,
          }),
        );
      }

      /**
       * HTTP PUTs a URL with JSON data
       *
       * @param {string} id - Box item id
       * @param {string} url - The URL to fetch
       * @param {Object} data - JS Object representation of JSON data to send
       * @param {Object} params - Optional query params for the request
       * @param {Object} [headers] - Key-value map of headers
       * @return {Promise} - HTTP response
       */
      put({ url, id, data, params, headers = {} }) {
        return this.post({
          id,
          url,
          data,
          params,
          headers,
          method: HTTP_PUT,
        });
      }

      /**
       * HTTP DELETEs a URL with JSON data
       *
       * @param {string} id - Box item id
       * @param {string} url - The URL to fetch
       * @param {Object} data - JS Object representation of JSON data to send
       * @param {Object} [headers] - Key-value map of headers
       * @return {Promise} - HTTP response
       */
      delete({ url, id, data = {}, headers = {} }) {
        return this.post({
          id,
          url,
          data,
          headers,
          method: HTTP_DELETE,
        });
      }

      /**
       * HTTP OPTIONs a URL with JSON data.
       *
       * @param {string} id - Box item id
       * @param {string} url - The URL to post to
       * @param {Object} data - The non-file post data that should accompany the post
       * @param {Object} [headers] - Key-value map of headers
       * @param {Function} successHandler - Load success handler
       * @param {Function} errorHandler - Error handler
       * @return {void}
       */
      options({ id, url, data, headers = {}, successHandler, errorHandler }) {
        return this.getHeaders(id, headers)
          .then(hdrs =>
            this.axios({
              url,
              data,
              method: HTTP_OPTIONS,
              headers: hdrs,
            })
              .then(successHandler)
              .catch(errorHandler),
          )
          .catch(errorHandler);
      }

      /**
       * HTTP POST or PUT a URL with File data. Uses native XHR for progress event.
       *
       * @param {string} id - Box item id
       * @param {string} url - The URL to post to
       * @param {Object} [data] - File data and attributes
       * @param {Object} [headers] - Key-value map of headers
       * @param {string} [method] - XHR method, supports 'POST' and 'PUT'
       * @param {Function} successHandler - Load success handler
       * @param {Function} errorHandler - Error handler
       * @param {Function} progressHandler - Progress handler
       * @param {boolean} [withIdleTimeout] - enable idle timeout
       * @param {number} [idleTimeoutDuration] - idle timeout duration
       * @param {Function} [idleTimeoutHandler]
       * @return {void}
       */
      uploadFile({
        id,
        url,
        data,
        headers = {},
        method = HTTP_POST,
        successHandler,
        errorHandler,
        progressHandler,
        withIdleTimeout = false,
        idleTimeoutDuration = DEFAULT_UPLOAD_TIMEOUT_MS,
        idleTimeoutHandler,
      }) {
        return this.getHeaders(id, headers)
          .then(hdrs => {
            let idleTimeout;
            let progressHandlerToUse = progressHandler;
            if (withIdleTimeout) {
              // Func that aborts upload and executes timeout callback
              const idleTimeoutFunc = () => {
                this.abort();
                if (idleTimeoutHandler) {
                  idleTimeoutHandler();
                }
              };
              idleTimeout = setTimeout(idleTimeoutFunc, idleTimeoutDuration);

              // Progress handler that aborts upload if there has been no progress for >= timeoutMs
              progressHandlerToUse = event => {
                clearTimeout(idleTimeout);
                idleTimeout = setTimeout(idleTimeoutFunc, idleTimeoutDuration);
                progressHandler(event);
              };
            }
            this.axios({
              url,
              data,
              transformRequest: (reqData, reqHeaders) => {
                // Remove Accept & Content-Type added by getHeaders()
                delete reqHeaders[HEADER_ACCEPT];
                delete reqHeaders[HEADER_CONTENT_TYPE];
                if (headers[HEADER_CONTENT_TYPE]) {
                  reqHeaders[HEADER_CONTENT_TYPE] = headers[HEADER_CONTENT_TYPE];
                }

                // Convert to FormData if needed
                if (reqData && !(reqData instanceof Blob) && reqData.attributes) {
                  const formData = new FormData();
                  Object.keys(reqData).forEach(key => {
                    formData.append(key, reqData[key]);
                  });
                  return formData;
                }
                return reqData;
              },
              method,
              headers: hdrs,
              onUploadProgress: progressHandlerToUse,
              cancelToken: this.axiosSource.token,
            })
              .then(response => {
                clearTimeout(idleTimeout);
                successHandler(response);
              })
              .catch(error => {
                clearTimeout(idleTimeout);
                errorHandler(error);
              });
          })
          .catch(errorHandler);
      }

      /**
       * Aborts an axios request.
       *
       * @return {void}
       */
      abort() {
        if (this.retryTimeout) {
          clearTimeout(this.retryTimeout);
        }
        if (this.axiosSource) {
          this.axiosSource.cancel();
          this.axiosSource = axios_default().CancelToken.source();
        }
      }
    }
    /* harmony default export */ const utils_Xhr = Xhr;
    // EXTERNAL MODULE: ./node_modules/lodash/merge.js
    var merge = __webpack_require__(19474);
    var merge_default = /*#__PURE__*/ __webpack_require__.n(merge); // CONCATENATED MODULE: ./src/utils/Cache.js
    /**
     *
     * @file A simple in-memory cache
     * @author Box
     */

    class Cache {
      /**
       * @property {*}
       */

      /**
       * [constructor]
       *
       * @return {Cache} Cache instance
       */
      constructor() {
        this.cache = {};
      }

      /**
       * Caches a simple object in memory.
       *
       * @param {string} key The cache key
       * @param {*} value The cache value
       * @return {void}
       */
      set(key, value) {
        this.cache[key] = value;
      }

      /**
       * Merges cached values for objects.
       *
       * @param {string} key The cache key
       * @param {*} value The cache value
       * @return {void}
       */
      merge(key, value) {
        if (this.has(key)) {
          this.set(key, merge_default()({}, this.get(key), value));
        } else {
          throw new Error(`Key ${key} not in cache!`);
        }
      }

      /**
       * Deletes object from in-memory cache.
       *
       * @param {string} key The cache key
       * @return {void}
       */
      unset(key) {
        delete this.cache[key];
      }

      /**
       * Deletes all object from in-memory cache
       * that match the key as prefix.
       *
       * @param {string} prefix The cache key prefix
       * @return {void}
       */
      unsetAll(prefix) {
        Object.keys(this.cache).forEach(key => {
          if (key.startsWith(prefix)) {
            delete this.cache[key];
          }
        });
      }

      /**
       * Checks if cache has provided key.
       *
       * @param {string} key The cache key
       * @return {boolean} Whether the cache has key
       */
      has(key) {
        return {}.hasOwnProperty.call(this.cache, key);
      }

      /**
       * Fetches a cached object from in-memory cache if available.
       *
       * @param {string} key Key of cached object
       * @return {*} Cached object
       */
      get(key) {
        if (this.has(key)) {
          return this.cache[key];
        }
        return undefined;
      }
    }
    /* harmony default export */ const utils_Cache = Cache; // CONCATENATED MODULE: ./src/utils/LocalStore.js
    /**
     *
     * @file Local storage wrapper that falls back to an in memory store
     * @author Box
     */

    const KEY_PREFIX = 'localStore';
    const SERVICE_VERSION = '0';
    class LocalStore {
      /**
       * [constructor]
       *
       * @return {void}
       */
      constructor() {
        this.memoryStore = new utils_Cache();
        try {
          this.localStorage = window.localStorage;
          this.isLocalStorageAvailable = this.canUseLocalStorage();
        } catch (e) {
          this.isLocalStorageAvailable = false;
        }
      }

      /**
       * Builds a key for the session store
       * @private
       * @param  {string} key
       *
       * @return {string}
       */
      buildKey(key) {
        return `${KEY_PREFIX}/${SERVICE_VERSION}/${key}`;
      }

      /**
       * Test to see browser can use local storage.
       * See http://stackoverflow.com/questions/14555347
       * Note that this will return false if we are actually hitting the maximum localStorage
       * size (5MB / 2.5M chars)
       *
       * @private
       * @return {boolean} True if browser can use localStore
       */
      canUseLocalStorage() {
        if (!this.localStorage) {
          return false;
        }
        try {
          this.localStorage.setItem(this.buildKey('TestKey'), 'testValue');
          this.localStorage.removeItem(this.buildKey('TestKey'));
          return true;
        } catch (e) {
          return false;
        }
      }

      /**
       * Set an item
       *
       * @param {string} key
       * @param {*} value
       *
       * @return {void}
       */
      setItem(key, value) {
        if (this.isLocalStorageAvailable) {
          try {
            this.localStorage.setItem(this.buildKey(key), JSON.stringify(value));
          } catch (e) {
            // no-op
          }
        } else {
          this.memoryStore.set(key, value);
        }
      }

      /**
       * Get an item
       *
       * @param  {string} key
       *
       * @return {*}
       */
      getItem(key) {
        if (this.isLocalStorageAvailable) {
          try {
            const item = this.localStorage.getItem(this.buildKey(key));
            if (!item) {
              return null;
            }
            return JSON.parse(item);
          } catch (e) {
            return null;
          }
        } else {
          return this.memoryStore.get(key);
        }
      }

      /**
       * Remove an item
       *
       * @param  {string} key
       *
       * @return {void}
       */
      removeItem(key) {
        if (this.isLocalStorageAvailable) {
          try {
            this.localStorage.removeItem(this.buildKey(key));
          } catch (e) {
            // no-op
          }
          return;
        }
        this.memoryStore.unset(key);
      }
    }
    /* harmony default export */ const utils_LocalStore = LocalStore; // CONCATENATED MODULE: ./src/api/uploads/UploadsReachability.js
    /**
     *
     * @file Helper for Box uploads reachability test
     * @author Box
     */

    const CACHED_RESULTS_LOCAL_STORE_KEY = 'bcu-uploads-reachability-cached-results';
    class UploadsReachability {
      /**
       * [constructor]
       */
      constructor() {
        this.localStore = new utils_LocalStore();
        this.cachedResults = {};

        // Populate cachedResults with valid values from the local store, and then save the new
        // cachedResults back to local store.
        // This cleanup of invalid entries is not strictly necessary to maintain correctness,
        // but if we don't do this cleanup results may accumulate in local storage forever.
        this.populateCachedResultsWithValidLocalStoreValues();
        this.saveCachedResultsToLocalStore();
      }

      /**
       * Returns existing reachability results from local store
       *
       * @private
       * @return {?Object} The results, or null if there was a problem reading the value from local store
       */
      getCachedResultsFromLocalStore() {
        return this.localStore.getItem(CACHED_RESULTS_LOCAL_STORE_KEY);
      }

      /**
       * Saves the cachedResults variable as a JSON string in local store.
       *
       * @private
       * @return {void}
       */
      saveCachedResultsToLocalStore() {
        this.localStore.setItem(CACHED_RESULTS_LOCAL_STORE_KEY, this.cachedResults);
      }

      /**
       * Returns true if the given cached result is still valid (i.e. it has not expired yet)
       *
       * @private
       * @param {StringAnyMap} result - A result object for one host
       * @return {boolean} Whether or not the result is valid
       */
      isCachedHostValid(result) {
        return result.expirationTimestampMS > Date.now();
      }

      /**
       * Returns the cached result for the given uploadHost
       *
       * @private
       * @param {string} uploadHost - The host URL
       * @return {null|StringAnyMap} The result object or null if there isn't one
       */
      getCachedResult(uploadHost) {
        if (uploadHost in this.cachedResults) {
          const result = this.cachedResults[uploadHost];
          if (this.isCachedHostValid(result)) {
            return result;
          }
        }
        return null;
      }

      /**
       * Updates a cached result. Changes both the in-memory cachedResult variable and what's stored in local store
       *
       * @private
       * @param {string} uploadHost - The host URL that was tested
       * @param {boolean} isHostReachable - Whether or not the host was reachable
       * @return {void}
       */
      updateCachedResult(uploadHost, isHostReachable) {
        this.cachedResults[uploadHost] = {
          isReachable: isHostReachable,
          expirationTimestampMS: Date.now() + 1000 * 86400,
        };
        this.saveCachedResultsToLocalStore();
      }

      /**
       * Adds to the cachedResults object with valid entries from local storage
       *
       * @private
       * @return {void}
       */
      populateCachedResultsWithValidLocalStoreValues() {
        const localStoreResults = this.getCachedResultsFromLocalStore();
        if (!localStoreResults) {
          return;
        }
        Object.keys(localStoreResults).forEach(uploadHost => {
          const result = localStoreResults[uploadHost];
          if (this.isCachedHostValid(result)) {
            this.cachedResults[uploadHost] = result;
          }
        });
      }

      /**
       * Returns the host URLs that, according to the cached reachability test results, are unreachable
       *
       * @return {Array} The unreachable host URLs
       */
      getUnreachableHostsUrls() {
        const unreachableHosts = [];
        if (!this.cachedResults) {
          return unreachableHosts;
        }
        Object.keys(this.cachedResults).forEach(uploadHost => {
          const value = this.cachedResults[uploadHost];
          if (this.isCachedHostValid(value) && !value.isReachable) {
            unreachableHosts.push(uploadHost);
          }
        });
        return unreachableHosts;
      }

      /**
       * Determines whether the given host is reachable by either making a test request to the uploadHost
       * or returning the result of the last reachability test it did
       *
       * @param {string} uploadHost - The upload host URL that will be stored in the cached test result and returned in
       * getUnreachableHostsUrls() if test fails (this is usually a prefix of the uploadUrl)
       * @return {Promise<boolean>} Promise that resolved to true if the host is reachable, false if it is not
       */
      async isReachable(uploadHost) {
        // The default upload host should always reachable
        if (uploadHost === `${DEFAULT_HOSTNAME_UPLOAD}/` || uploadHost === `${DEFAULT_HOSTNAME_UPLOAD_APP}/`) {
          return true;
        }
        const cachedResult = this.getCachedResult(uploadHost);
        if (cachedResult) {
          return cachedResult.isReachable;
        }
        const isHostReachable = await this.makeReachabilityRequest(uploadHost);
        this.updateCachedResult(uploadHost, isHostReachable);
        return isHostReachable;
      }

      /**
       * Determines if the given uploadHost is reachable by making a test upload request to it.
       * Does not read or modify any cached results.
       *
       * @param {string} uploadHost - The upload host url to make a test request against
       * @return {Promise<boolean>}
       */
      async makeReachabilityRequest(uploadHost) {
        const url = `${uploadHost}html5?reachability_test=run`;
        const headers = {
          [HEADER_CONTENT_TYPE]: 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-File-Name': 'reachability_pseudofile.txt',
          'X-File-Size': '1234',
        };
        const data = 'reachability_file=test_file_data';
        try {
          await axios_default().post(url, data, {
            headers,
          });
        } catch (error) {
          return false;
        }
        return true;
      }
    }
    /* harmony default export */ const uploads_UploadsReachability = UploadsReachability; // CONCATENATED MODULE: ./src/api/Base.js
    function Base_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Base_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Base_ownKeys(Object(t), !0).forEach(function (r) {
              Base_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Base_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Base_defineProperty(e, r, t) {
      return (
        (r = Base_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Base_toPropertyKey(t) {
      var i = Base_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Base_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Base class with utility methods for API calls
     * @author Box
     */

    class Base {
      /**
       * @property {Cache}
       */

      /**
       * @property {boolean}
       */

      /**
       * @property {Xhr}
       */

      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {*}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {string}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {UploadsReachability}
       */

      /**
       * [constructor]
       *
       * @param {Object} [options]
       * @param {string} [options.token] - Auth token
       * @param {string} [options.sharedLink] - Shared link
       * @param {string} [options.sharedLinkPassword] - Shared link password
       * @param {string} [options.apiHost] - Api host
       * @param {string} [options.uploadHost] - Upload host name
       * @return {Base} Base instance
       */
      constructor(options) {
        /**
         * Generic success handler
         *
         * @param {Object} data - The response data
         */
        Base_defineProperty(this, 'successHandler', data => {
          if (!this.isDestroyed() && typeof this.successCallback === 'function') {
            this.successCallback(data);
          }
        });
        /**
         * Generic error handler
         *
         * @param {Object} data - The response data
         * @param {Function} errorCallback the error callback
         */
        Base_defineProperty(this, 'errorHandler', error => {
          if (!this.isDestroyed() && typeof this.errorCallback === 'function') {
            const { response } = error;
            if (response && response.data) {
              this.errorCallback(response.data, this.errorCode);
            } else {
              this.errorCallback(error, this.errorCode);
            }
          }
        });
        this.cache = options.cache || new utils_Cache();
        this.apiHost = options.apiHost || DEFAULT_HOSTNAME_API;
        this.uploadHost = options.uploadHost || DEFAULT_HOSTNAME_UPLOAD;
        // @TODO: avoid keeping another copy of data in this.options
        this.options = Base_objectSpread(
          Base_objectSpread({}, options),
          {},
          {
            apiHost: this.apiHost,
            uploadHost: this.uploadHost,
            cache: this.cache,
          },
        );
        this.xhr = new utils_Xhr(this.options);
        this.destroyed = false;
        this.consoleLog =
          !!options.consoleLog && !!window.console ? window.console.log || noop_default() : noop_default();
        this.consoleError =
          !!options.consoleError && !!window.console ? window.console.error || noop_default() : noop_default();
        this.uploadsReachability = new uploads_UploadsReachability();
      }

      /**
       * [destructor]
       *
       * @return {void}
       */
      destroy() {
        this.xhr.abort();
        this.destroyed = true;
      }

      /**
       * Asks the API if its destructor has been called
       *
       * @return {void}
       */
      isDestroyed() {
        return this.destroyed;
      }

      /**
       * Checks that our desired API call has sufficient permissions and an item ID
       *
       * @param {string} permissionToCheck - Permission to check
       * @param {Object} permissions - Permissions object
       * @param {string} id - Item id
       * @return {void}
       */
      checkApiCallValidity(permissionToCheck, permissions, id) {
        if (!id || !permissions) {
          throw error_getBadItemError();
        }
        const permission = permissions[permissionToCheck];
        if (!permission) {
          throw getBadPermissionsError();
        }
      }

      /**
       * Base URL for api
       *
       * @return {string} base url
       */
      getBaseApiUrl() {
        const suffix = this.apiHost.endsWith('/') ? '2.0' : '/2.0';
        return `${this.apiHost}${suffix}`;
      }

      /**
       * Base URL for api uploads
       *
       * @return {string} base url
       */
      getBaseUploadUrl() {
        const suffix = this.uploadHost.endsWith('/') ? 'api/2.0' : '/api/2.0';
        return `${this.uploadHost}${suffix}`;
      }

      /**
       * Gets the cache instance
       *
       * @return {Cache} cache instance
       */
      getCache() {
        return this.cache;
      }
      /**
       * Gets the URL for the API, meant to be overridden
       * @param {string} id - The item id
       */
      /* eslint-disable no-unused-vars */
      getUrl(id) {
        /* eslint-disable no-unused-vars */
        throw new Error('Implement me!');
      }

      /**
       * Formats an API entry for use in components
       * @param {string} entry - an API response entry
       */
      /* eslint-disable no-unused-vars */
      format(entry) {
        /* eslint-disable no-unused-vars */
        throw new Error('Implement me!');
      }

      /**
       * Generic API GET
       *
       * @param {string} id - The file id
       * @param {Function} successCallback - The success callback
       * @param {Function} errorCallback - The error callback
       * @param {Object} requestData - additional request data
       * @param {string} url - API url
       * @returns {Promise}
       */
      get({
        id,
        successCallback,
        errorCallback,
        requestData,
        // Note: this is inconsistent, other methods use `data`
        url,
      }) {
        const apiUrl = url || this.getUrl(id);
        return this.makeRequest(HTTP_GET, id, apiUrl, successCallback, errorCallback, requestData);
      }

      /**
       * Generic API POST
       *
       * @param {string} id - The file id
       * @param {string} url - The url to post to
       * @param {Object} data - The data to post
       * @param {Function} successCallback - The success callback
       * @param {Function} errorCallback - The error callback
       */
      post({ id, url, data, successCallback, errorCallback }) {
        return this.makeRequest(HTTP_POST, id, url, successCallback, errorCallback, data);
      }

      /**
       * Generic API PUT
       *
       * @param {string} id - The file id
       * @param {string} url - The url to put to
       * @param {Object} data - The data to put
       * @param {Function} successCallback - The success callback
       * @param {Function} errorCallback - The error callback
       */
      put({ id, url, data, successCallback, errorCallback }) {
        return this.makeRequest(HTTP_PUT, id, url, successCallback, errorCallback, data);
      }

      /**
       * Generic API DELETE
       *
       * @param {string} id - The file id
       * @param {string} url - The url of the item to delete
       * @param {Function} successCallback - The success callback
       * @param {Function} errorCallback - The error callback
       * @param {Object} data optional data to delete
       */
      delete({ id, url, data, successCallback, errorCallback }) {
        return this.makeRequest(HTTP_DELETE, id, url, successCallback, errorCallback, data);
      }

      /**
       * Generic API CRUD operations
       *
       * @param {string} method - which REST method to execute (GET, POST, PUT, DELETE)
       * @param {string} id - The file id
       * @param {string} url - The url of the item to operate on
       * @param {Function} successCallback - The success callback
       * @param {Function} errorCallback - The error callback
       * @param {Object} requestData - Optional info to be added to the API call such as params or request body data
       */
      async makeRequest(method, id, url, successCallback, errorCallback, requestData = {}) {
        if (this.isDestroyed()) {
          return;
        }
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // $FlowFixMe
        const xhrMethod = this.xhr[method.toLowerCase()].bind(this.xhr);
        try {
          const { data } = await xhrMethod(
            Base_objectSpread(
              {
                id: getTypedFileId(id),
                url,
              },
              requestData,
            ),
          );
          this.successHandler(data);
        } catch (error) {
          this.errorHandler(error);
        }
      }
    }
    /* harmony default export */ const api_Base = Base; // CONCATENATED MODULE: ./src/api/Item.js
    function Item_extends() {
      return (
        (Item_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Item_extends.apply(null, arguments)
      );
    }
    function Item_defineProperty(e, r, t) {
      return (
        (r = Item_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Item_toPropertyKey(t) {
      var i = Item_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Item_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box item API
     * @author Box
     */

    class Item extends api_Base {
      constructor(...args) {
        super(...args);
        /**
         * Handles response for deletion
         *
         * @return {void}
         */
        Item_defineProperty(this, 'deleteSuccessHandler', () => {
          if (this.isDestroyed()) {
            return;
          }

          // When fetching the parent folder from the cache
          // we have no guarantees that it will be there since
          // search results happen across folders and we only
          // add those folders to cache that have been navigated to.
          const parentKey = this.getParentCacheKey(this.parentId);
          const folder = this.getCache().get(parentKey);
          if (!folder) {
            this.postDeleteCleanup();
            return;
          }

          // Same logic as above but in this case we may have the parent
          // folders meta data in cache but not its contents.
          const { item_collection } = folder;
          if (!item_collection) {
            this.postDeleteCleanup();
            return;
          }
          const { entries, total_count } = item_collection;
          if (!Array.isArray(entries) || typeof total_count !== 'number') {
            throw error_getBadItemError();
          }
          const childKey = this.getCacheKey(this.id);
          const oldCount = entries.length;
          const newEntries = entries.filter(entry => entry !== childKey);
          const newCount = newEntries.length;
          const updatedObject = this.merge(
            parentKey,
            'item_collection',
            Item_extends(item_collection, {
              entries: newEntries,
              total_count: total_count - (oldCount - newCount),
            }),
          );
          this.successCallback(updatedObject);
          this.postDeleteCleanup();
        });
        /**
         * Handles response for rename
         *
         * @param {BoxItem} data - The updated item
         * @return {void}
         */
        Item_defineProperty(this, 'renameSuccessHandler', ({ data }) => {
          if (!this.isDestroyed()) {
            // Get rid of all searches
            this.getCache().unsetAll(CACHE_PREFIX_SEARCH);
            const updatedObject = this.merge(this.getCacheKey(this.id), 'name', data.name);
            this.successCallback(updatedObject);
          }
        });
        /**
         * Handles response for shared link
         *
         * @param {BoxItem} data - The updated item
         * @param {Array<string>} [fields] - Optional fields from request
         * @return {void}
         */
        Item_defineProperty(this, 'shareSuccessHandler', (data, fields) => {
          if (!this.isDestroyed()) {
            // Add fields that were requested but not returned
            const dataWithMissingFields = fields ? fillMissingProperties(data, fields) : data;
            const cache = this.getCache();
            const key = this.getCacheKey(this.id);
            if (cache.has(key)) {
              cache.merge(key, dataWithMissingFields);
            } else {
              cache.set(key, dataWithMissingFields);
            }
            this.successCallback(cache.get(key));
          }
        });
      }
      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * Creates a key for the item's parent
       * This is always a folder
       *
       * @param {string} Id - folder id
       * @return {string} Key
       */
      getParentCacheKey(id) {
        return `${CACHE_PREFIX_FOLDER}${id}`;
      }

      /**
       * Creates a key for the cache
       *
       * @param {string} Id - Folder id
       * @return {string} Key
       */
      getCacheKey(id) {
        return `getCacheKey(${id}) should be overriden`;
      }

      /**
       * API URL for items
       *
       * @param {string} id - Item id
       * @protected
       * @return {string} Base url for files
       */
      getUrl(id) {
        return `getUrl(${id}) should be overriden`;
      }

      /**
       * Merges new data with old data and returns new data
       *
       * @param {String} cacheKey - The cache key of item to merge
       * @param {String} key - The attribute to merge
       * @param {Object} value - The value to merge
       * @return {BoxItem} The newly updated object from the cache
       */
      merge(cacheKey, key, value) {
        const cache = this.getCache();
        cache.merge(cacheKey, set_default()({}, key, value));
        return cache.get(cacheKey);
      }

      /**
       * Steps to do after deletion
       *
       * @return {void}
       */
      postDeleteCleanup() {
        if (this.isDestroyed()) {
          return;
        }

        // Get rid of all searches
        this.getCache().unsetAll(CACHE_PREFIX_SEARCH);
        this.successCallback();
      }
      /**
       * API to delete an Item
       *
       * @param {BoxItem} item - Item to delete
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      deleteItem(item, successCallback, errorCallback = noop_default()) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        this.errorCode = ERROR_CODE_DELETE_ITEM;
        const { id, permissions, parent, type } = item;
        if (!id || !permissions || !parent || !type) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return Promise.reject();
        }
        const { id: parentId } = parent;
        const { can_delete } = permissions;
        if (!can_delete || !parentId) {
          errorCallback(getBadPermissionsError(), this.errorCode);
          return Promise.reject();
        }
        this.id = id;
        this.parentId = parentId;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        const url = `${this.getUrl(id)}${type === constants_TYPE_FOLDER ? '?recursive=true' : ''}`;
        return this.xhr
          .delete({
            url,
          })
          .then(this.deleteSuccessHandler)
          .catch(e => {
            this.errorHandler(e);
          });
      }
      /**
       * API to rename an Item
       *
       * @param {BoxItem} item - Item to rename
       * @param {string} name - Item new name
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      rename(item, name, successCallback, errorCallback = noop_default()) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        this.errorCode = ERROR_CODE_RENAME_ITEM;
        const { id, permissions } = item;
        if (!id || !permissions) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return Promise.reject();
        }
        const { can_rename } = permissions;
        if (!can_rename) {
          errorCallback(getBadPermissionsError(), this.errorCode);
          return Promise.reject();
        }
        this.id = id;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        return this.xhr
          .put({
            url: `${this.getUrl(id)}`,
            data: {
              name,
            },
          })
          .then(this.renameSuccessHandler)
          .catch(e => {
            this.errorHandler(e);
          });
      }
      /**
       * Validate request to update an item shared link
       *
       * @param {string|void} itemID - ID of item to share
       * @param {BoxItemPermission|void} itemPermissions - Permissions for item
       * @param {boolean|void} canSkipSetShareAccessPermission - skip `can_set_share_access` permission check
       * @throws {Error}
       * @return {void}
       */
      validateSharedLinkRequest(itemID, itemPermissions, canSkipSetShareAccessPermission = false) {
        if (!itemID || !itemPermissions) {
          this.errorCode = ERROR_CODE_SHARE_ITEM;
          throw error_getBadItemError();
        }

        // It is sometimes necessary to skip `can_set_share_access` permission check
        // e.g. Viewer permission can create shared links but cannot update access level
        const { can_share, can_set_share_access } = itemPermissions;
        if (!can_share || (!canSkipSetShareAccessPermission && !can_set_share_access)) {
          this.errorCode = ERROR_CODE_SHARE_ITEM;
          throw getBadPermissionsError();
        }
      }

      /**
       * API to create, modify (change access), or remove a shared link
       *
       * @param {BoxItem} item - Item to share
       * @param {Access} access - Shared access level
       * @param {Function} successCallback - Success callback
       * @param {Function|void} errorCallback - Error callback
       * @param {Array<string>|void} [options.fields] - Optionally include specific fields
       * @return {Promise<void>}
       */
      async share(
        item,
        access,
        // if "access" is undefined, the backend will set the default access level for the shared link
        successCallback,
        errorCallback = noop_default(),
        options = {},
      ) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        try {
          const { id, permissions, shared_link: sharedLink } = item;
          this.id = id;
          this.successCallback = successCallback;
          this.errorCallback = errorCallback;

          // skip permission check when creating links with default access level
          const canSkipSetShareAccessPermission = !sharedLink && access === undefined;
          this.validateSharedLinkRequest(id, permissions, canSkipSetShareAccessPermission);
          const { fields } = options;
          const requestData = {
            url: this.getUrl(this.id),
            data: {
              shared_link:
                access === ACCESS_NONE
                  ? null
                  : {
                      access,
                    },
            },
          };
          if (fields) {
            requestData.params = {
              fields: fields.toString(),
            };
          }
          const { data } = await this.xhr.put(requestData);
          return this.shareSuccessHandler(data, fields);
        } catch (e) {
          return this.errorHandler(e);
        }
      }

      /**
       * API to update a shared link
       *
       * @param {BoxItem} item - Item to update
       * @param {$Shape<SharedLink>} sharedLinkParams - New shared link parameters
       * @param {Function} successCallback - Success callback
       * @param {Function|void} errorCallback - Error callback
       * @param {Array<string>|void} [options.fields] - Optionally include specific fields
       * @return {Promise<void>}
       */
      async updateSharedLink(item, sharedLinkParams, successCallback, errorCallback = noop_default(), options = {}) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        try {
          const { id, permissions } = item;
          this.id = id;
          this.successCallback = successCallback;
          this.errorCallback = errorCallback;
          this.validateSharedLinkRequest(id, permissions);
          const { fields } = options;
          const requestData = {
            url: this.getUrl(this.id),
            data: {
              shared_link: sharedLinkParams,
            },
          };
          if (fields) {
            requestData.params = {
              fields: fields.toString(),
            };
          }
          const { data } = await this.xhr.put(requestData);
          return this.shareSuccessHandler(data, fields);
        } catch (e) {
          return this.errorHandler(e);
        }
      }
    }
    /* harmony default export */ const api_Item = Item;
    // EXTERNAL MODULE: ./node_modules/query-string/index.js
    var query_string = __webpack_require__(43165); // CONCATENATED MODULE: ./src/utils/function.js
    /**
     *
     * @file Function utilities
     * @author Box
     */

    /**
     * Wrapper around the promises.create() method to allow a promise to retry
     * multiple times. A third parameter (besides resolve and reject) is passed
     * that allows the function to cancel retrying and immediately reject.
     *
     * @param {function} func - The function that performs the operation as a promise.
     * @param {number} times - Maximum number of times the operation should be attempted.
     * @param {number} [initialTimeout] - Optional timeout to retry the promise with after it fails, in milliseconds.
     * Otherwise, the input `func` is invoked after 1 event loop.
     * @param {number} [backoffFactor] - Optional exponential backoff factor to retry the promise with after it fails
     * @return {Promise} Promise - proxies the promise of the passed function.
     */

    function retryNumOfTimes(func, times, initialTimeout = 0, backoffFactor = 1) {
      let tries = 0;
      let timeout = initialTimeout;
      return new Promise((resolve, hardReject) => {
        function doTry() {
          tries += 1;
          new Promise((tryResolve, tryReject) => {
            func(tryResolve, tryReject, hardReject);
          })
            .then(resolve)
            .catch(reason => {
              if (tries < times) {
                timeout *= backoffFactor;
                // eslint-disable-next-line no-use-before-define
                executeAfterTimeout(timeout);
                return;
              }
              hardReject(reason);
            });
        }
        function executeAfterTimeout(time) {
          setTimeout(() => {
            doTry();
          }, time);
        }
        executeAfterTimeout(timeout);
      });
    } // CONCATENATED MODULE: ./src/api/File.js

    // eslint-disable-next-line import/prefer-default-export

    function File_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function File_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? File_ownKeys(Object(t), !0).forEach(function (r) {
              File_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : File_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function File_defineProperty(e, r, t) {
      return (
        (r = File_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function File_toPropertyKey(t) {
      var i = File_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function File_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box file API
     * @author Box
     */

    class File extends api_Item {
      /**
       * Creates a key for the cache
       *
       * @param {string} id - Folder id
       * @return {string} key
       */
      getCacheKey(id) {
        return `${CACHE_PREFIX_FILE}${id}`;
      }

      /**
       * API URL for files
       *
       * @param {string} [id] - Optional file id
       * @return {string} base url for files
       */
      getUrl(id) {
        const suffix = id ? `/${id}` : '';
        return `${this.getBaseApiUrl()}/files${suffix}`;
      }

      /**
       * API for getting download URL for files and file versions
       *
       * @param {string} fileId - File id
       * @param {BoxItem|BoxItemVersion} fileOrFileVersion - File or file version to download
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      async getDownloadUrl(fileId, fileOrFileVersion, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_GET_DOWNLOAD_URL;
        this.errorCallback = errorCallback;
        this.successCallback = successCallback;
        const downloadAvailable = fileOrFileVersion[FIELD_IS_DOWNLOAD_AVAILABLE];
        const downloadUrl = fileOrFileVersion[FIELD_AUTHENTICATED_DOWNLOAD_URL];
        const token = await utils_TokenService.getReadToken(getTypedFileId(fileId), this.options.token);
        if (!downloadAvailable || !downloadUrl || !token) {
          this.errorHandler(new Error('Download is missing required fields or token.'));
          return;
        }
        const { query, url: downloadBaseUrl } = query_string.parseUrl(downloadUrl);
        const downloadUrlParams = File_objectSpread(
          File_objectSpread({}, query),
          {},
          {
            access_token: token,
          },
        );
        const downloadUrlQuery = query_string.stringify(downloadUrlParams);
        this.successHandler(`${downloadBaseUrl}?${downloadUrlQuery}`);
      }

      /**
       * Determines whether the call to the file representations API has completed
       *
       * @param {data: { FileRepresentation }} response
       * @return {boolean}
       */
      isRepresentationsCallComplete(response) {
        const status = get_default()(response, 'data.status.state');
        return (
          !status ||
          status === REPRESENTATIONS_RESPONSE_ERROR ||
          status === REPRESENTATIONS_RESPONSE_SUCCESS ||
          status === REPRESENTATIONS_RESPONSE_VIEWABLE
        );
      }

      /**
       * Polls a representation's infoUrl, attempting to generate a representation
       *
       * @param {FileRepresentation} representation - representation that should have its info.url polled
       * @return {Promise<FileRepresentation>} - representation updated with most current status
       */
      async generateRepresentation(representation) {
        const infoUrl = get_default()(representation, 'info.url');
        if (!infoUrl) {
          return representation;
        }
        return retryNumOfTimes(
          (successCallback, errorCallback) =>
            this.xhr
              .get({
                successCallback,
                errorCallback,
                url: infoUrl,
              })
              .then(response =>
                this.isRepresentationsCallComplete(response)
                  ? successCallback(response.data)
                  : errorCallback(response.data),
              )
              .catch(e => {
                errorCallback(e);
              }),
          4,
          2000,
          2,
        );
      }

      /**
       * API for getting a thumbnail URL for a BoxItem
       *
       * @param {BoxItem} item - BoxItem to get the thumbnail URL for
       * @return {Promise<?string>} - the url for the item's thumbnail, or null
       */
      async getThumbnailUrl(item) {
        const entry = get_default()(item, 'representations.entries[0]');
        const extension = get_default()(entry, 'representation');
        const template = get_default()(entry, 'content.url_template');
        const token = await utils_TokenService.getReadToken(getTypedFileId(item.id), this.options.token);
        if (!extension || !template || !token) {
          return null;
        }
        const thumbnailUrl = template.replace('{+asset_path}', extension === 'jpg' ? '' : '1.png');
        const { query, url: thumbnailBaseUrl } = query_string.parseUrl(thumbnailUrl);
        const thumbnailUrlParams = File_objectSpread(
          File_objectSpread({}, query),
          {},
          {
            access_token: token,
          },
        );
        const thumbnailUrlQuery = query_string.stringify(thumbnailUrlParams);
        return `${thumbnailBaseUrl}?${thumbnailUrlQuery}`;
      }

      /**
       * API for setting the description of a file
       *
       * @param {BoxItem} file - File object for which we are changing the description
       * @param {string} description - New file description
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {Promise}
       */
      setFileDescription(file, description, successCallback, errorCallback) {
        const { id, permissions } = file;
        if (!id || !permissions) {
          errorCallback(error_getBadItemError());
          return Promise.reject();
        }
        if (!permissions.can_rename) {
          errorCallback(getBadPermissionsError());
          return Promise.reject();
        }
        return this.xhr
          .put({
            id: getTypedFileId(id),
            url: this.getUrl(id),
            data: {
              description,
            },
          })
          .then(({ data }) => {
            if (!this.isDestroyed()) {
              const updatedFile = this.merge(this.getCacheKey(id), 'description', data.description);
              successCallback(updatedFile);
            }
          })
          .catch(() => {
            if (!this.isDestroyed()) {
              const originalFile = this.merge(this.getCacheKey(id), 'description', file.description);
              errorCallback(originalFile);
            }
          });
      }

      /**
       * Gets a box file
       *
       * @param {string} id - File id
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {boolean|void} [options.fields] - Optionally include specific fields
       * @param {boolean|void} [options.forceFetch] - Optionally Bypasses the cache
       * @param {boolean|void} [options.refreshCache] - Optionally Updates the cache
       * @return {Promise}
       */
      async getFile(id, successCallback, errorCallback, options = {}) {
        if (this.isDestroyed()) {
          return;
        }
        const cache = this.getCache();
        const key = this.getCacheKey(id);
        const isCached = !options.forceFetch && cache.has(key);
        const file = isCached
          ? cache.get(key)
          : {
              id,
            };
        let missingFields = findMissingProperties(file, options.fields);
        const xhrOptions = {
          id: getTypedFileId(id),
          url: this.getUrl(id),
          headers: {
            'X-Rep-Hints': X_REP_HINTS,
          },
        };
        this.errorCode = ERROR_CODE_FETCH_FILE;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // If the file was cached and there are no missing fields
        // then just return the cached file and optionally refresh
        // the cache with new data if required
        if (isCached && missingFields.length === 0) {
          successCallback(file);
          missingFields = options.fields || [];
          if (!options.refreshCache) {
            return;
          }
        }

        // If there are missing fields to fetch, add it to the params
        if (missingFields.length > 0) {
          xhrOptions.params = {
            fields: missingFields.toString(),
          };
        }
        try {
          const { data } = await this.xhr.get(xhrOptions);
          if (this.isDestroyed()) {
            return;
          }

          // Merge fields that were requested but were actually not returned.
          // This part is mostly useful for metadata.foo.bar fields since the API
          // returns { metadata: null } instead of { metadata: { foo: { bar: null } } }
          const dataWithMissingFields = fillMissingProperties(data, missingFields);

          // Cache check is again done since this code is executed async
          if (cache.has(key)) {
            cache.merge(key, dataWithMissingFields);
          } else {
            // If there was nothing in the cache
            cache.set(key, dataWithMissingFields);
          }
          this.successHandler(cache.get(key));
        } catch (e) {
          this.errorHandler(e);
        }
      }

      /**
       * Gets the extension of a box file.
       *
       * @param {string} id - File id
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @return {Promise}
       */
      getFileExtension(id, successCallback, errorCallback) {
        if (this.isDestroyed()) {
          return;
        }
        this.getFile(id, successCallback, errorCallback, {
          fields: [FIELD_EXTENSION],
        });
      }
    }
    /* harmony default export */ const api_File = File; // CONCATENATED MODULE: ./src/api/WebLink.js
    /**
     *
     * @file Helper for the box web link api
     * @author Box
     */

    class WebLink extends api_Item {
      /**
       * Creates a key for the cache
       *
       * @param {string} id folder id
       * @return {string} key
       */
      getCacheKey(id) {
        return `${CACHE_PREFIX_WEBLINK}${id}`;
      }

      /**
       * URL for weblink api
       *
       * @param {string} [id] optional file id
       * @return {string} base url for files
       */
      getUrl(id) {
        const suffix = id ? `/${id}` : '';
        return `${this.getBaseApiUrl()}/web_links${suffix}`;
      }

      /**
       * Gets a Box weblink
       *
       * @param {string} id - Weblink id
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {Array<string>|void} fields - Optionally include specific fields
       * @returns {Promise}
       */
      async getWeblink(id, successCallback, errorCallback, { fields } = {}) {
        if (this.isDestroyed()) {
          return;
        }
        const cache = this.getCache();
        const key = this.getCacheKey(id);
        this.errorCode = ERROR_CODE_FETCH_WEBLINK;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        if (cache.has(key)) {
          const missingFields = findMissingProperties(cache.get(key), fields);
          if (missingFields.length === 0) {
            successCallback(cache.get(key));
            return;
          }
        }
        const xhrOptions = {
          url: this.getUrl(id),
        };
        if (fields) {
          xhrOptions.params = {
            fields: fields.toString(),
          };
        }
        try {
          const { data } = await this.xhr.get(xhrOptions);
          if (this.isDestroyed()) {
            return;
          }

          // Cache check is again done since this code is executed async
          if (cache.has(key)) {
            cache.merge(key, data);
          } else {
            // If there was nothing in the cache
            cache.set(key, data);
          }
          this.successHandler(cache.get(key));
        } catch (e) {
          this.errorHandler(e);
        }
      }
    }
    /* harmony default export */ const api_WebLink = WebLink; // CONCATENATED MODULE: ./src/api/Folder.js
    function Folder_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Folder_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Folder_ownKeys(Object(t), !0).forEach(function (r) {
              Folder_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Folder_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Folder_defineProperty(e, r, t) {
      return (
        (r = Folder_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Folder_toPropertyKey(t) {
      var i = Folder_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Folder_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box folder api
     * @author Box
     */

    class Folder extends api_Item {
      constructor(...args) {
        super(...args);
        /**
         * Handles the folder fetch response
         *
         * @param {Object} response
         * @return {void}
         */
        Folder_defineProperty(this, 'folderSuccessHandler', ({ data }) => {
          if (this.isDestroyed()) {
            return;
          }
          const { item_collection } = data;
          if (!item_collection) {
            throw error_getBadItemError();
          }
          const { entries, total_count, limit, offset } = item_collection;
          if (
            !Array.isArray(entries) ||
            typeof total_count !== 'number' ||
            typeof limit !== 'number' ||
            typeof offset !== 'number'
          ) {
            throw error_getBadItemError();
          }
          const flattened = flatten(
            entries,
            new Folder(this.options),
            new api_File(this.options),
            new api_WebLink(this.options),
          );
          this.itemCache = (this.itemCache || []).concat(flattened);
          this.getCache().set(
            this.key,
            Folder_objectSpread(
              Folder_objectSpread({}, data),
              {},
              {
                item_collection: Folder_objectSpread(
                  Folder_objectSpread({}, item_collection),
                  {},
                  {
                    entries: this.itemCache,
                  },
                ),
              },
            ),
          );
          this.finish();
        });
        /**
         * Handles a request for folder details
         *
         * @param {Object} data - XHR response data
         * @returns {void}
         */
        Folder_defineProperty(this, 'folderDetailsSuccessHandler', ({ data }) => {
          if (this.isDestroyed()) {
            return;
          }
          const cachedEntry = this.getCache().get(this.key);
          const updatedCacheEntry = Folder_objectSpread(Folder_objectSpread({}, cachedEntry), data);
          this.getCache().set(this.key, updatedCacheEntry);
          this.successCallback(updatedCacheEntry);
        });
        /**
         * API to rename an Item
         *
         * @param {string} id - parent folder id
         * @param {string} name - new folder name
         * @param {Function} successCallback - success callback
         * @param {Function} errorCallback - error callback
         * @return {void}
         */
        Folder_defineProperty(this, 'createSuccessHandler', ({ data }) => {
          const { id: childId } = data;
          if (this.isDestroyed() || !childId) {
            return;
          }
          const childKey = this.getCacheKey(childId);
          const cache = this.getCache();
          const parent = cache.get(this.key);
          if (!parent) {
            this.successCallback(data);
            return;
          }
          const { item_collection } = parent;
          if (!item_collection) {
            throw error_getBadItemError();
          }
          const { total_count, entries } = item_collection;
          if (!Array.isArray(entries) || typeof total_count !== 'number') {
            throw error_getBadItemError();
          }
          cache.set(childKey, data);
          item_collection.entries = [childKey].concat(entries);
          item_collection.total_count = total_count + 1;
          this.successCallback(data);
        });
      }
      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {number}
       */

      /**
       * @property {number}
       */

      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {Array}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * Creates a key for the cache
       *
       * @param {string} id folder id
       * @return {string} key
       */
      getCacheKey(id) {
        return `${CACHE_PREFIX_FOLDER}${id}`;
      }

      /**
       * Base URL for folder api
       *
       * @param {string} [id] optional file id
       * @return {string} base url for files
       */
      getUrl(id) {
        const suffix = id ? `/${id}` : '';
        return `${this.getBaseApiUrl()}/folders${suffix}`;
      }

      /**
       * Tells if a folder has its items all loaded
       *
       * @return {boolean} if items are loaded
       */
      isLoaded() {
        const cache = this.getCache();
        return cache.has(this.key);
      }

      /**
       * Composes and returns the results
       *
       * @return {void}
       */
      finish() {
        if (this.isDestroyed()) {
          return;
        }
        const cache = this.getCache();
        const folder = cache.get(this.key);
        const { id, name, permissions, path_collection, item_collection } = folder;
        if (!item_collection || !path_collection) {
          throw error_getBadItemError();
        }
        const { entries, offset, total_count } = item_collection;
        if (!Array.isArray(entries) || typeof total_count !== 'number') {
          throw error_getBadItemError();
        }
        const collection = {
          id,
          name,
          offset,
          percentLoaded: 100,
          permissions,
          boxItem: folder,
          breadcrumbs: path_collection.entries,
          items: entries.map(key => cache.get(key)),
          sortBy: this.sortBy,
          sortDirection: this.sortDirection,
          totalCount: total_count,
        };
        this.successCallback(collection);
      }
      /**
       * Does the network request for fetching a folder
       *
       * @param {Array<string>|void} fields - Optionally include specific fields
       * @return {Promise}
       */
      folderRequest({ fields, noPagination } = {}, successHandler = this.folderSuccessHandler) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        const requestFields = fields || FOLDER_FIELDS_TO_FETCH;
        this.errorCode = ERROR_CODE_FETCH_FOLDER;
        let params = {
          fields: requestFields.toString(),
        };
        if (!noPagination) {
          params = Folder_objectSpread(
            Folder_objectSpread({}, params),
            {},
            {
              direction: this.sortDirection.toLowerCase(),
              limit: this.limit,
              offset: this.offset,
              fields: requestFields.toString(),
              sort: this.sortBy.toLowerCase(),
            },
          );
        }
        return this.xhr
          .get({
            url: this.getUrl(this.id),
            params,
            headers: requestFields.includes(FIELD_REPRESENTATIONS)
              ? {
                  'X-Rep-Hints': X_REP_HINT_HEADER_DIMENSIONS_DEFAULT,
                }
              : {},
          })
          .then(successHandler)
          .catch(this.errorHandler);
      }

      /**
       * Gets a box folder properties. If you want to get the items, you should use `getFolder`
       *
       * @param {string} id - Folder id
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {Object} options - Options
       * @returns {void}
       */
      getFolderFields(id, successCallback, errorCallback, options = {}) {
        if (this.isDestroyed()) {
          return;
        }

        // Save references
        this.id = id;
        this.key = this.getCacheKey(id);
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        this.folderRequest(
          Folder_objectSpread(
            Folder_objectSpread({}, options),
            {},
            {
              noPagination: true,
            },
          ),
          this.folderDetailsSuccessHandler,
        );
      }

      /**
       * Gets a box folder and its items
       *
       * @param {string} id - Folder id
       * @param {number} limit - maximum number of items to retrieve
       * @param {number} offset - starting index from which to retrieve items
       * @param {string} sortBy - sort by field
       * @param {string} sortDirection - sort direction
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {boolean|void} [options.fields] - Optionally include specific fields
       * @param {boolean|void} [options.forceFetch] - Optionally Bypasses the cache
       * @param {boolean|void} [options.refreshCache] - Optionally Updates the cache
       * @return {void}
       */
      getFolder(id, limit, offset, sortBy, sortDirection, successCallback, errorCallback, options = {}) {
        if (this.isDestroyed()) {
          return;
        }

        // Save references
        this.id = id;
        this.key = this.getCacheKey(id);
        this.limit = limit;
        this.offset = offset;
        this.sortBy = sortBy;
        this.sortDirection = sortDirection;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // Clear the cache if needed
        if (options.forceFetch) {
          this.getCache().unset(this.key);
        }

        // Return the Cache value if it exists
        if (this.isLoaded()) {
          this.finish();
          return;
        }

        // Make the XHR request
        this.folderRequest(options);
      }
      /**
       * Does the network request for fetching a folder
       *
       * @return {void}
       */
      folderCreateRequest(name) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        this.errorCode = ERROR_CODE_CREATE_FOLDER;
        const url = `${this.getUrl()}?fields=${FOLDER_FIELDS_TO_FETCH.toString()}`;
        return this.xhr
          .post({
            url,
            data: {
              name,
              parent: {
                id: this.id,
              },
            },
          })
          .then(this.createSuccessHandler)
          .catch(this.errorHandler);
      }

      /**
       * API to create a folder
       *
       * @param {string} id - parent folder id
       * @param {string} name - new folder name
       * @param {Function} successCallback - success callback
       * @param {Function} errorCallback - error callback
       * @return {void}
       */
      create(id, name, successCallback, errorCallback = noop_default()) {
        if (this.isDestroyed()) {
          return;
        }
        this.id = id;
        this.key = this.getCacheKey(id);
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        this.folderCreateRequest(name);
      }
    }
    /* harmony default export */ const api_Folder = Folder; // CONCATENATED MODULE: ./src/api/uploads/FolderUploadNode.js
    function FolderUploadNode_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function FolderUploadNode_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? FolderUploadNode_ownKeys(Object(t), !0).forEach(function (r) {
              FolderUploadNode_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : FolderUploadNode_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function FolderUploadNode_defineProperty(e, r, t) {
      return (
        (r = FolderUploadNode_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function FolderUploadNode_toPropertyKey(t) {
      var i = FolderUploadNode_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function FolderUploadNode_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Recursively create folder and upload files
     * @author Box
     */

    class FolderUploadNode {
      /**
       * [constructor]
       *
       * @param {string} name
       * @param {Function} addFilesToUploadQueue
       * @param {Function} addFolderToUploadQueue
       * @returns {void}
       */
      constructor(_name, addFilesToUploadQueue, addFolderToUploadQueue, fileAPIOptions, baseAPIOptions, _entry) {
        FolderUploadNode_defineProperty(this, 'files', []);
        FolderUploadNode_defineProperty(this, 'folders', {});
        /**
         * Upload all child folders
         *
         * @private
         * @param {Function} errorCallback
         * @returns {Promise}
         */
        FolderUploadNode_defineProperty(this, 'uploadChildFolders', async errorCallback => {
          // $FlowFixMe
          const folders = Object.values(this.folders);
          const promises = folders.map(folder => folder.upload(this.folderId, errorCallback));
          await Promise.all(promises);
        });
        /**
         * Create folder and add it to the upload queue
         *
         * @private
         * @param {Function} errorCallback
         * @param {boolean} isRoot
         * @returns {Promise}
         */
        FolderUploadNode_defineProperty(this, 'createAndUploadFolder', async (errorCallback, isRoot) => {
          await this.buildCurrentFolderFromEntry();
          let errorEncountered = false;
          let errorCode = '';
          try {
            const data = await this.createFolder();
            this.folderId = data.id;
          } catch (error) {
            // @TODO: Handle 429
            if (error.code === ERROR_CODE_ITEM_NAME_IN_USE) {
              this.folderId = error.context_info.conflicts[0].id;
            } else if (isRoot) {
              errorCallback(error);
            } else {
              // If this is a child folder of the folder being uploaded, this errorCallback will set
              // an error message on the root folder being uploaded. Set a generic messages saying that a
              // child has caused the error. The child folder will be tagged with the error message in
              // the call to this.addFolderToUploadQueue below
              errorEncountered = true;
              errorCode = error.code;
              errorCallback({
                code: ERROR_CODE_UPLOAD_CHILD_FOLDER_FAILED,
              });
            }
          }

          // The root folder has already been added to the upload queue in ContentUploader
          if (isRoot) {
            return;
          }
          const folderObject = {
            extension: '',
            name: this.name,
            status: STATUS_COMPLETE,
            isFolder: true,
            size: 1,
            progress: 100,
          };
          if (errorEncountered) {
            folderObject.status = STATUS_ERROR;
            folderObject.error = {
              code: errorCode,
            };
          }
          this.addFolderToUploadQueue(folderObject);
        });
        /**
         * Format files to Array<UploadFileWithAPIOptions> for upload
         *
         * @private
         * @returns {Array<UploadFileWithAPIOptions>}
         */
        FolderUploadNode_defineProperty(this, 'getFormattedFiles', () =>
          this.files.map(file => ({
            file,
            options: FolderUploadNode_objectSpread(
              FolderUploadNode_objectSpread({}, this.fileAPIOptions),
              {},
              {
                folderId: this.folderId,
                uploadInitTimestamp: Date.now(),
              },
            ),
          })),
        );
        /**
         * Create FolderUploadNode instances from entries
         *
         * @private
         * @param {Array<FileSystemFileEntry>} entries
         * @returns {Promise<any>}
         */
        FolderUploadNode_defineProperty(this, 'createFolderUploadNodesFromEntries', async entries => {
          await Promise.all(
            entries.map(async entry => {
              const { isFile, name } = entry;
              if (isFile) {
                const file = await getFileFromEntry(entry);
                this.files.push(file);
                return;
              }
              this.folders[name] = new FolderUploadNode(
                name,
                this.addFilesToUploadQueue,
                this.addFolderToUploadQueue,
                this.fileAPIOptions,
                FolderUploadNode_objectSpread(
                  FolderUploadNode_objectSpread({}, this.baseAPIOptions),
                  this.fileAPIOptions,
                ),
                entry,
              );
            }),
          );
        });
        /**
         * Recursively read an entry
         *
         * @private
         * @param {DirectoryReader} reader
         * @param {Function} resolve
         * @returns {void}
         */
        FolderUploadNode_defineProperty(this, 'readEntry', (reader, resolve) => {
          reader.readEntries(async entries => {
            // Quit recursing when there are no remaining entries.
            if (!entries.length) {
              resolve();
              return;
            }
            await this.createFolderUploadNodesFromEntries(entries);
            this.readEntry(reader, resolve);
          }, noop_default());
        });
        /**
         * Build current folder from entry
         *
         * @private
         * @returns {Promise<any>}
         */
        FolderUploadNode_defineProperty(this, 'buildCurrentFolderFromEntry', () => {
          if (!this.entry) {
            return Promise.resolve();
          }
          return new Promise(resolve => {
            // $FlowFixMe entry is not empty
            const reader = this.entry.createReader();
            this.readEntry(reader, resolve);
          });
        });
        /**
         * Returns the folderId
         * @returns {string}
         */
        FolderUploadNode_defineProperty(this, 'getFolderId', () => {
          return this.folderId;
        });
        this.name = _name;
        this.addFilesToUploadQueue = addFilesToUploadQueue;
        this.addFolderToUploadQueue = addFolderToUploadQueue;
        this.fileAPIOptions = fileAPIOptions;
        this.baseAPIOptions = baseAPIOptions;
        this.entry = _entry;
      }

      /**
       * Upload a folder
       *
       * @public
       * @param {string} parentFolderId
       * @param {Function} errorCallback
       * @param {boolean} isRoot
       * @returns {Promise}
       */
      async upload(parentFolderId, errorCallback, isRoot = false) {
        this.parentFolderId = parentFolderId;
        await this.createAndUploadFolder(errorCallback, isRoot);

        // Check if folder was successfully created before we attempt to upload its contents.
        if (this.getFolderId()) {
          this.addFilesToUploadQueue(this.getFormattedFiles(), noop_default(), true);
          await this.uploadChildFolders(errorCallback);
        }
      }
      /**
       * Promisify create folder
       *
       * @private
       * @returns {Promise}
       */
      createFolder() {
        const folderAPI = new api_Folder(
          FolderUploadNode_objectSpread(
            FolderUploadNode_objectSpread({}, this.baseAPIOptions),
            {},
            {
              id: `folder_${this.parentFolderId}`,
            },
          ),
        );
        return new Promise((resolve, reject) => {
          folderAPI.create(this.parentFolderId, this.name, resolve, reject);
        });
      }
    }
    /* harmony default export */ const uploads_FolderUploadNode = FolderUploadNode; // CONCATENATED MODULE: ./src/api/uploads/FolderUpload.js
    function FolderUpload_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function FolderUpload_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? FolderUpload_ownKeys(Object(t), !0).forEach(function (r) {
              FolderUpload_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : FolderUpload_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function FolderUpload_defineProperty(e, r, t) {
      return (
        (r = FolderUpload_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function FolderUpload_toPropertyKey(t) {
      var i = FolderUpload_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function FolderUpload_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Folder upload bootstrapping
     * @author Box
     */

    const PATH_DELIMITER = '/';
    class FolderUpload {
      /**
       * [constructor]
       *
       * @param {Function} addFilesToUploadQueue
       * @param {string} destinationFolderId
       * @param {Function} addFolderToUploadQueue
       * @param {Object} baseAPIOptions
       * @return {void}
       */
      constructor(addFilesToUploadQueue, destinationFolderId, addFolderToUploadQueue, baseAPIOptions) {
        FolderUpload_defineProperty(this, 'files', []);
        this.addFilesToUploadQueue = addFilesToUploadQueue;
        this.destinationFolderId = destinationFolderId;
        this.addFolderToUploadQueue = addFolderToUploadQueue;
        this.baseAPIOptions = baseAPIOptions;
      }

      /**
       * Create a folder tree from fileList wekbkitRelativePath
       *
       * @public
       * @param  {Array} Array<UploadFileWithAPIOptions | UploadFile> | FileList
       * @returns {void}
       */
      buildFolderTreeFromWebkitRelativePath(fileList) {
        Array.from(fileList).forEach(fileData => {
          const file = getFile(fileData);
          const { webkitRelativePath } = file;
          if (!webkitRelativePath) {
            return;
          }
          const fileAPIOptions = getFileAPIOptions(fileData);
          const pathArray = webkitRelativePath.split(PATH_DELIMITER).slice(0, -1);
          if (pathArray.length <= 0) {
            return;
          }

          // Since only 1 folder tree can be uploaded a time with using webkitRelativePath, the root folder name
          // of all the files should be the same.
          if (!this.folder) {
            const rootFolderName = pathArray[0];
            this.folder = this.createFolderUploadNode(rootFolderName, fileAPIOptions);
          }

          // Add file to the root folder
          if (pathArray.length === 1) {
            this.folder.files.push(file);
          }
          let subTree = this.folder.folders;
          // Walk the path after the root folder
          const pathArryAfterRoot = pathArray.slice(1);
          pathArryAfterRoot.forEach((folderName, index) => {
            // Create new child folder
            if (!subTree[folderName]) {
              subTree[folderName] = this.createFolderUploadNode(folderName, fileAPIOptions);
            }
            if (index === pathArryAfterRoot.length - 1) {
              // end of path, push the file
              subTree[folderName].files.push(file);
            } else {
              // walk the tree
              subTree = subTree[folderName].folders;
            }
          });
        });
      }

      /**
       * Build folder tree from dataTransferItem, which can only represent 1 folder tree
       *
       * @param {DataTransferItem | UploadDataTransferItemWithAPIOptions} dataTransferItem
       * @returns {Promise<any>}
       */
      async buildFolderTreeFromDataTransferItem(dataTransferItem) {
        const item = getDataTransferItem(dataTransferItem);
        const apiOptions = getDataTransferItemAPIOptions(dataTransferItem);
        const entry = getEntryFromDataTransferItem(item);
        const { name } = entry;
        this.folder = this.createFolderUploadNode(name, apiOptions, entry);
      }

      /**
       * Create a FolderUploadNode instance
       *
       * @param {string} name
       * @param {Object} apiOptions
       * @param {FileSystemFileEntry} [entry]
       * @returns {FolderUploadNode}
       */
      createFolderUploadNode(name, apiOptions, entry) {
        return new uploads_FolderUploadNode(
          name,
          this.addFilesToUploadQueue,
          this.addFolderToUploadQueue,
          apiOptions,
          FolderUpload_objectSpread(FolderUpload_objectSpread({}, this.baseAPIOptions), apiOptions),
          entry,
        );
      }

      /**
       * Upload folders
       *
       * @public
       * @param {Object} Options
       * @param {Function} options.errorCallback
       * @returns {Promise<any>}
       */
      async upload({ errorCallback, successCallback }) {
        await this.folder.upload(this.destinationFolderId, errorCallback, true);
        // If the folder upload failed then a folderID will not be set
        const newFolderId = this.folder.getFolderId();
        if (newFolderId) {
          successCallback([
            {
              id: newFolderId,
            },
          ]);
        }
      }

      /**
       * Noop cancel
       *
       * @public
       */
      cancel() {}
    }
    /* harmony default export */ const uploads_FolderUpload = FolderUpload;
    // EXTERNAL MODULE: ./node_modules/lodash/isNaN.js
    var lodash_isNaN = __webpack_require__(76519);
    var isNaN_default = /*#__PURE__*/ __webpack_require__.n(lodash_isNaN);
    // EXTERNAL MODULE: ./node_modules/js-sha1/src/sha1.js
    var sha1 = __webpack_require__(5026);
    var sha1_default = /*#__PURE__*/ __webpack_require__.n(sha1); // CONCATENATED MODULE: ./src/utils/webcrypto.js
    /**
     *
     * @file Wrapper to provide a consistent interface for the webcrypto API
     * @author Box
     */

    /**
     * Returns the correct crypto library based on browser implementation
     *
     * @return {Object}
     */
    function getCrypto() {
      return window.crypto || window.msCrypto;
    }

    /**
     * Returns a Promise of a digest generated from the
     * hash function and text given as parameters
     *
     * @param {string} algorithm
     * @param {ArrayBuffer} buffer
     * @return {Promise} Promise - resolves with an ArrayBuffer containing the digest result
     */
    function digest(algorithm, buffer) {
      const cryptoRef = getCrypto();
      if (cryptoRef !== window.msCrypto) {
        return cryptoRef.subtle.digest(algorithm, buffer);
      }

      // IE11 implements an early version of the SubtleCrypto interface which doesn't use Promises
      // See http://web-developer-articles.blogspot.com/2015/05/web-cryptography-api.html
      return new Promise((resolve, reject) => {
        // Microsoft has dropped support for SHA-1 and so SHA-1 needs to be calculated differently
        if (algorithm === 'SHA-1') {
          try {
            const hashBuffer = sha1_default().arrayBuffer(buffer);
            resolve(hashBuffer);
          } catch (e) {
            reject(e);
          }
        } else {
          const cryptoOperation = cryptoRef.subtle.digest(
            {
              name: algorithm,
            },
            buffer,
          );
          cryptoOperation.oncomplete = event => {
            resolve(event.target.result);
          };
          cryptoOperation.onerror = reject;
        }
      });
    }

    /**
     * Given a buffer/byteArray fills it with random values and returns the same array
     *
     * @param {Uint8Array} buffer
     * @return {Uint8Array}
     */
    function getRandomValues(buffer) {
      const cryptoRef = getCrypto();
      const copy = new Uint8Array(buffer);
      cryptoRef.getRandomValues(copy);
      return copy;
    } // CONCATENATED MODULE: ./src/utils/base64.js

    /**
     *
     * @file Function to convert Int32Array to Base64 for SHA1 digest
     * @author Box
     */

    /**
     * Converts hex to Base 64. Adapted from
     * https://stackoverflow.com/questions/23190056/hex-to-base64-converter-for-javascript.
     *
     * @param {string} str - Hex string to convert
     * @return {string}
     */
    function hexToBase64(str) {
      return btoa(
        String.fromCharCode.apply(
          null,
          str
            .replace(/\r|\n/g, '')
            .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
            .replace(/ +$/, '')
            .split(' '),
        ),
      );
    } // CONCATENATED MODULE: ./src/utils/uploadsSHA1Worker.js
    /* eslint-disable */
    /*
     * Rusha, a JavaScript implementation of the Secure Hash Algorithm, SHA-1,
     * as defined in FIPS PUB 180-1, tuned for high performance with large inputs.
     * (http://github.com/srijs/rusha)
     *
     * Inspired by Paul Johnstons implementation (http://pajhome.org.uk/crypt/md5).
     *
     * Copyright (c) 2013 Sam Rijs (http://awesam.de).
     * Released under the terms of the MIT license as follows:
     *
     * Permission is hereby granted, free of charge, to any person obtaining a
     * copy of this software and associated documentation files (the "Software"),
     * to deal in the Software without restriction, including without limitation
     * the rights to use, copy, modify, merge, publish, distribute, sublicense,
     * and/or sell copies of the Software, and to permit persons to whom the
     * Software is furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
     * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
     * IN THE SOFTWARE.
     */

    // The low-level RushCore module provides the heart of Rusha,
    // a high-speed sha1 implementation working on an Int32Array heap.
    // At first glance, the implementation seems complicated, however
    // with the SHA1 spec at hand, it is obvious this almost a textbook
    // implementation that has a few functions hand-inlined and a few loops
    // hand-unrolled.
    function RushaCore(stdlib, foreign, heap) {
      'use asm';

      var H = new stdlib.Int32Array(heap);
      function hash(k, x) {
        // k in bytes
        k = k | 0;
        x = x | 0;
        var i = 0,
          j = 0,
          y0 = 0,
          z0 = 0,
          y1 = 0,
          z1 = 0,
          y2 = 0,
          z2 = 0,
          y3 = 0,
          z3 = 0,
          y4 = 0,
          z4 = 0,
          t0 = 0,
          t1 = 0;
        y0 = H[(x + 320) >> 2] | 0;
        y1 = H[(x + 324) >> 2] | 0;
        y2 = H[(x + 328) >> 2] | 0;
        y3 = H[(x + 332) >> 2] | 0;
        y4 = H[(x + 336) >> 2] | 0;
        for (i = 0; (i | 0) < (k | 0); i = (i + 64) | 0) {
          z0 = y0;
          z1 = y1;
          z2 = y2;
          z3 = y3;
          z4 = y4;
          for (j = 0; (j | 0) < 64; j = (j + 4) | 0) {
            t1 = H[(i + j) >> 2] | 0;
            t0 =
              (((((y0 << 5) | (y0 >>> 27)) + ((y1 & y2) | (~y1 & y3))) | 0) + ((((t1 + y4) | 0) + 1518500249) | 0)) | 0;
            y4 = y3;
            y3 = y2;
            y2 = (y1 << 30) | (y1 >>> 2);
            y1 = y0;
            y0 = t0;
            H[(k + j) >> 2] = t1;
          }
          for (j = (k + 64) | 0; (j | 0) < ((k + 80) | 0); j = (j + 4) | 0) {
            t1 =
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) << 1) |
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) >>> 31);
            t0 =
              (((((y0 << 5) | (y0 >>> 27)) + ((y1 & y2) | (~y1 & y3))) | 0) + ((((t1 + y4) | 0) + 1518500249) | 0)) | 0;
            y4 = y3;
            y3 = y2;
            y2 = (y1 << 30) | (y1 >>> 2);
            y1 = y0;
            y0 = t0;
            H[j >> 2] = t1;
          }
          for (j = (k + 80) | 0; (j | 0) < ((k + 160) | 0); j = (j + 4) | 0) {
            t1 =
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) << 1) |
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) >>> 31);
            t0 = (((((y0 << 5) | (y0 >>> 27)) + (y1 ^ y2 ^ y3)) | 0) + ((((t1 + y4) | 0) + 1859775393) | 0)) | 0;
            y4 = y3;
            y3 = y2;
            y2 = (y1 << 30) | (y1 >>> 2);
            y1 = y0;
            y0 = t0;
            H[j >> 2] = t1;
          }
          for (j = (k + 160) | 0; (j | 0) < ((k + 240) | 0); j = (j + 4) | 0) {
            t1 =
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) << 1) |
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) >>> 31);
            t0 =
              (((((y0 << 5) | (y0 >>> 27)) + ((y1 & y2) | (y1 & y3) | (y2 & y3))) | 0) +
                ((((t1 + y4) | 0) - 1894007588) | 0)) |
              0;
            y4 = y3;
            y3 = y2;
            y2 = (y1 << 30) | (y1 >>> 2);
            y1 = y0;
            y0 = t0;
            H[j >> 2] = t1;
          }
          for (j = (k + 240) | 0; (j | 0) < ((k + 320) | 0); j = (j + 4) | 0) {
            t1 =
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) << 1) |
              ((H[(j - 12) >> 2] ^ H[(j - 32) >> 2] ^ H[(j - 56) >> 2] ^ H[(j - 64) >> 2]) >>> 31);
            t0 = (((((y0 << 5) | (y0 >>> 27)) + (y1 ^ y2 ^ y3)) | 0) + ((((t1 + y4) | 0) - 899497514) | 0)) | 0;
            y4 = y3;
            y3 = y2;
            y2 = (y1 << 30) | (y1 >>> 2);
            y1 = y0;
            y0 = t0;
            H[j >> 2] = t1;
          }
          y0 = (y0 + z0) | 0;
          y1 = (y1 + z1) | 0;
          y2 = (y2 + z2) | 0;
          y3 = (y3 + z3) | 0;
          y4 = (y4 + z4) | 0;
        }
        H[(x + 320) >> 2] = y0;
        H[(x + 324) >> 2] = y1;
        H[(x + 328) >> 2] = y2;
        H[(x + 332) >> 2] = y3;
        H[(x + 336) >> 2] = y4;
      }
      return {
        hash: hash,
      };
    }
    // @NOTE: This function shouldn't be processed by UglifyJsPlugin, related to https://github.com/mishoo/UglifyJS2/issues/2011
    const RushaString = `function Rusha(e){for(var r=function(e){if("string"==typeof e)return"string";if(e instanceof Array)return"array";if("undefined"!=typeof global&&global.Buffer&&global.Buffer.isBuffer(e))return"buffer";if(e instanceof ArrayBuffer)return"arraybuffer";if(e.buffer instanceof ArrayBuffer)return"view";if(e instanceof Blob)return"blob";throw new Error("Unsupported data type.")},n={fill:0},t=function(e){for(e+=9;e%64>0;e+=1);return e},a=function(e,r,n,t,a){var f,s=this,i=a%4,h=(t+i)%4,u=t-h;switch(i){case 0:e[a]=s[n+3];case 1:e[a+1-(i<<1)|0]=s[n+2];case 2:e[a+2-(i<<1)|0]=s[n+1];case 3:e[a+3-(i<<1)|0]=s[n]}if(!(t<h+i)){for(f=4-i;f<u;f=f+4|0)r[a+f>>2|0]=s[n+f]<<24|s[n+f+1]<<16|s[n+f+2]<<8|s[n+f+3];switch(h){case 3:e[a+u+1|0]=s[n+u+2];case 2:e[a+u+2|0]=s[n+u+1];case 1:e[a+u+3|0]=s[n+u]}}},f=function(e){switch(r(e)){case"string":return function(e,r,n,t,a){var f,s=this,i=a%4,h=(t+i)%4,u=t-h;switch(i){case 0:e[a]=s.charCodeAt(n+3);case 1:e[a+1-(i<<1)|0]=s.charCodeAt(n+2);case 2:e[a+2-(i<<1)|0]=s.charCodeAt(n+1);case 3:e[a+3-(i<<1)|0]=s.charCodeAt(n)}if(!(t<h+i)){for(f=4-i;f<u;f=f+4|0)r[a+f>>2]=s.charCodeAt(n+f)<<24|s.charCodeAt(n+f+1)<<16|s.charCodeAt(n+f+2)<<8|s.charCodeAt(n+f+3);switch(h){case 3:e[a+u+1|0]=s.charCodeAt(n+u+2);case 2:e[a+u+2|0]=s.charCodeAt(n+u+1);case 1:e[a+u+3|0]=s.charCodeAt(n+u)}}}.bind(e);case"array":case"buffer":return a.bind(e);case"arraybuffer":return a.bind(new Uint8Array(e));case"view":return a.bind(new Uint8Array(e.buffer,e.byteOffset,e.byteLength));case"blob":return function(e,r,n,t,a){var f,s=a%4,i=(t+s)%4,h=t-i,u=new Uint8Array(reader.readAsArrayBuffer(this.slice(n,n+t)));switch(s){case 0:e[a]=u[3];case 1:e[a+1-(s<<1)|0]=u[2];case 2:e[a+2-(s<<1)|0]=u[1];case 3:e[a+3-(s<<1)|0]=u[0]}if(!(t<i+s)){for(f=4-s;f<h;f=f+4|0)r[a+f>>2|0]=u[f]<<24|u[f+1]<<16|u[f+2]<<8|u[f+3];switch(i){case 3:e[a+h+1|0]=u[h+2];case 2:e[a+h+2|0]=u[h+1];case 1:e[a+h+3|0]=u[h]}}}.bind(e)}},s=new Array(256),i=0;i<256;i++)s[i]=(i<16?"0":"")+i.toString(16);var h=function(e){for(var r=new Uint8Array(e),n=new Array(e.byteLength),t=0;t<n.length;t++)n[t]=s[r[t]];return n.join("")};!function(e){if(e%64>0)throw new Error("Chunk size must be a multiple of 128 bit");n.offset=0,n.maxChunkLen=e,n.padMaxChunkLen=t(e),n.heap=new ArrayBuffer(function(e){var r;if(e<=65536)return 65536;if(e<16777216)for(r=1;r<e;r<<=1);else for(r=16777216;r<e;r+=16777216);return r}(n.padMaxChunkLen+320+20)),n.h32=new Int32Array(n.heap),n.h8=new Int8Array(n.heap),n.core=new RushaCore({Int32Array:Int32Array,DataView:DataView},{},n.heap),n.buffer=null}(e||65536);var u=function(e,r){n.offset=0;var t=new Int32Array(e,r+320,5);t[0]=1732584193,t[1]=-271733879,t[2]=-1732584194,t[3]=271733878,t[4]=-1009589776},c=function(e,r){var a,f,s,i=t(e),h=new Int32Array(n.heap,0,i>>2);return function(e,r){var n=new Uint8Array(e.buffer),t=r%4,a=r-t;switch(t){case 0:n[a+3]=0;case 1:n[a+2]=0;case 2:n[a+1]=0;case 3:n[a+0]=0}for(var f=1+(r>>2);f<e.length;f++)e[f]=0}(h,e),s=r,(a=h)[(f=e)>>2]|=128<<24-(f%4<<3),a[14+(2+(f>>2)&-16)]=s/(1<<29)|0,a[15+(2+(f>>2)&-16)]=s<<3,i},o=function(e,r,t,a){f(e)(n.h8,n.h32,r,t,a||0)},d=function(e,r,t,a,f){var s=t;o(e,r,t),f&&(s=c(t,a)),n.core.hash(s,n.padMaxChunkLen)},y=function(e,r){var n=new Int32Array(e,r+320,5),t=new Int32Array(5),a=new DataView(t.buffer);return a.setInt32(0,n[0],!1),a.setInt32(4,n[1],!1),a.setInt32(8,n[2],!1),a.setInt32(12,n[3],!1),a.setInt32(16,n[4],!1),t},w=this.rawDigest=function(e){var r=e.byteLength||e.length||e.size||0;u(n.heap,n.padMaxChunkLen);var t=0,a=n.maxChunkLen;for(t=0;r>t+a;t+=a)d(e,t,a,r,!1);return d(e,t,r-t,r,!0),y(n.heap,n.padMaxChunkLen)};this.digest=this.digestFromString=this.digestFromBuffer=this.digestFromArrayBuffer=function(e){return h(w(e).buffer)},this.resetState=function(){return u(n.heap,n.padMaxChunkLen),this},this.append=function(e){var r,t=0,a=e.byteLength||e.length||e.size||0,f=n.offset%n.maxChunkLen;for(n.offset+=a;t<a;)r=Math.min(a-t,n.maxChunkLen-f),o(e,t,r,f),t+=r,(f+=r)===n.maxChunkLen&&(n.core.hash(n.maxChunkLen,n.padMaxChunkLen),f=0);return this},this.getState=function(){var e;if(n.offset%n.maxChunkLen)e=n.heap.slice(0);else{var r=new Int32Array(n.heap,n.padMaxChunkLen+320,5);e=r.buffer.slice(r.byteOffset,r.byteOffset+r.byteLength)}return{offset:n.offset,heap:e}},this.setState=function(e){(n.offset=e.offset,20===e.heap.byteLength)?new Int32Array(n.heap,n.padMaxChunkLen+320,5).set(new Int32Array(e.heap)):n.h32.set(new Int32Array(e.heap));return this};var p=this.rawEnd=function(){var e=n.offset,r=e%n.maxChunkLen,t=c(r,e);n.core.hash(t,n.padMaxChunkLen);var a=y(n.heap,n.padMaxChunkLen);return u(n.heap,n.padMaxChunkLen),a};this.end=function(){return h(p().buffer)}}`;

    /**
     * @returns {Worker} Web worker
     */
    const createWorker = () => {
      /**
       * The contents of this function are what execute when the worker is loaded.  It
       * defines SHA-1 logic, and registers a handler for receiving messages from the window
       * that created the worker.
       * @returns {void}
       */
      function workerBase() {
        const fileSha1 = new Rusha();
        fileSha1.resetState();
        let expectedOffset = 0;

        // self inside a worker refers to a DedicatedWorkerGlobalScope
        // https://developer.mozilla.org/en-US/docs/Web/API/DedicatedWorkerGlobalScope
        self.onmessage = event => {
          const { data } = event;
          const { part, fileSize, partContents } = data;
          const startTimestamp = Date.now();
          try {
            // Validate that we are receiving parts in order
            if (part.offset !== expectedOffset) {
              throw new Error('Out of order parts given to worker');
            }
            fileSha1.append(partContents);

            // We send the partContents back to the main thread because, at least in Chrome v62, we see
            // that this ArrayBuffer is not garbage collected as promptly when left in the web worker
            // context
            self.postMessage(
              {
                type: 'partDone',
                part: data.part,
                duration: Date.now() - startTimestamp,
                partContents,
              },
              [partContents],
            );
            expectedOffset += part.size;
            if (part.offset + part.size === fileSize) {
              const hash = fileSha1.end();
              self.postMessage({
                type: 'done',
                sha1: hash,
              });
            }
          } catch (err) {
            const message = {
              type: 'error',
              name: err.name,
              message: err.message,
              part,
            };
            self.postMessage(message);
          }
        };
      }
      /* eslint-disable */

      const workerCodeBlob = new Blob(
        [
          // RushaCore loses its function name when uglified
          `const RushaCore = ${RushaCore.toString()}`,
          ';\n',
          RushaString,
          ';\n',
          'var setupWorker = ',
          workerBase.toString(),
          ';\n',
          'setupWorker();', // This explicit reassigned name is necessary because workerBase
          // gets renamed during JS minification.
        ],
        {
          type: 'text/javascript',
        },
      );
      const workerUrl = (window.URL || window.webkitURL).createObjectURL(workerCodeBlob);
      const worker = new Worker(workerUrl);
      worker.oldTerminate = worker.terminate;
      worker.terminate = () => {
        (window.URL || window.webkitURL).revokeObjectURL(workerUrl);
        worker.oldTerminate();
      };
      return worker;
    };
    /* harmony default export */ const uploadsSHA1Worker = createWorker;
    // EXTERNAL MODULE: ./node_modules/jsuri/Uri.js
    var Uri = __webpack_require__(84708);
    var Uri_default = /*#__PURE__*/ __webpack_require__.n(Uri); // CONCATENATED MODULE: ./src/utils/url.js
    /**
     *
     * @file Utility functions for urls
     * @author Box
     */

    /**
     * Update URL query parameters
     *
     * @param {string} url - the url that contains the potential query parameter string
     * @param {Object} queryParams
     * @return {string}
     */
    function updateQueryParameters(url, queryParams) {
      if (!queryParams) {
        return url;
      }
      const uri = new (Uri_default())(url);
      Object.keys(queryParams).forEach(key => {
        const value = queryParams[key];
        if (!value) {
          return;
        }
        if (uri.hasQueryParam(key)) {
          uri.replaceQueryParam(key, value);
          return;
        }
        uri.addQueryParam(key, value);
      });
      return uri.toString();
    } // CONCATENATED MODULE: ./src/api/uploads/BaseUpload.js

    // eslint-disable-next-line import/prefer-default-export

    function BaseUpload_defineProperty(e, r, t) {
      return (
        (r = BaseUpload_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function BaseUpload_toPropertyKey(t) {
      var i = BaseUpload_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function BaseUpload_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Base helper for the Box Upload APIs
     * @author Box
     */

    const MAX_RETRY = 5;
    // Note: We may have to change this number if we add a lot more fast upload hosts.
    const MAX_REACHABILITY_RETRY = 10;
    class BaseUpload extends api_Base {
      constructor(...args) {
        super(...args);
        BaseUpload_defineProperty(this, 'retryCount', 0);
        BaseUpload_defineProperty(this, 'reachabilityRetryCount', 0);
        BaseUpload_defineProperty(this, 'isUploadFallbackLogicEnabled', false);
        /**
         * Sends an upload pre-flight request. If a file ID is available,
         * send a pre-flight request to that file version.
         *
         * @private
         * @return {void}
         */
        BaseUpload_defineProperty(this, 'makePreflightRequest', () => {
          if (this.isDestroyed()) {
            return;
          }
          let url = `${this.getBaseApiUrl()}/files/content`;
          if (this.fileId) {
            url = url.replace('content', `${this.fileId}/content`);
          }
          if (this.isUploadFallbackLogicEnabled) {
            // Add unreachable hosts to url
            const unreachableHostUrls = this.uploadsReachability.getUnreachableHostsUrls();
            if (unreachableHostUrls.length !== 0) {
              url += `?unreachable_hosts=${unreachableHostUrls.join(',')}`;
            }
          }
          const { size, name } = this.file;
          const attributes = {
            name: this.fileName || name,
            parent: {
              id: this.folderId,
            },
            description: this.fileDescription,
            size,
          };
          this.xhr.options({
            url,
            data: attributes,
            successHandler: response => {
              if (this.isUploadFallbackLogicEnabled) {
                this.preflightSuccessReachabilityHandler(response);
              } else {
                this.preflightSuccessHandler(response);
              }
            },
            errorHandler: this.preflightErrorHandler,
          });
        });
        /**
         * Handles successful preflight response.
         * Performs a upload reachability test before calling preflightSuccessHandler.
         *
         * @param {Object} - Request options
         * @return {Promise} Async function promise
         */
        BaseUpload_defineProperty(this, 'preflightSuccessReachabilityHandler', async ({ data }) => {
          if (this.isDestroyed()) {
            return;
          }
          const { upload_url } = data;
          // If upload_url is not available, don't make reachability test
          if (!upload_url) {
            this.preflightSuccessHandler({
              data,
            });
            return;
          }
          const uploadHost = this.getUploadHostFromUrl(upload_url);
          // The default upload host should always be reachable
          // DEFAULT_HOSTNAME_UPLOAD is the original default upload host, while DEFAULT_HOSTNAME_UPLOAD_APP is recent.
          // Both of these hosts will resolve to the same IP so they are interchangeable.
          if (
            uploadHost === `${DEFAULT_HOSTNAME_UPLOAD}/` ||
            uploadHost === `${DEFAULT_HOSTNAME_UPLOAD_APP}/` ||
            uploadHost === `${DEFAULT_HOSTNAME_UPLOAD_GOV}/`
          ) {
            this.preflightSuccessHandler({
              data,
            });
            return;
          }

          // If upload host reachable upload file, else make a new preflight request
          const isHostReachable = await this.uploadsReachability.isReachable(uploadHost);
          if (isHostReachable) {
            this.preflightSuccessHandler({
              data,
            });
          } else if (this.reachabilityRetryCount >= MAX_REACHABILITY_RETRY) {
            this.preflightSuccessHandler({
              data: {},
            });
          } else {
            this.reachabilityRetryCount += 1;
            this.makePreflightRequest();
          }
        });
        /**
         * Handles a preflight error
         *
         * @param {Object} error - preflight error
         * @return {void}
         */
        BaseUpload_defineProperty(this, 'preflightErrorHandler', error => {
          if (this.isDestroyed()) {
            return;
          }
          this.fileName = this.file ? this.file.name : '';

          // TODO: Normalize error object and clean up error handling
          let errorData = error;
          const { response } = error;
          if (response && response.data) {
            errorData = response.data;
          }
          if (this.retryCount >= MAX_RETRY) {
            this.errorCallback(errorData);
            // Automatically handle name conflict errors
          } else if (errorData && errorData.status === 409) {
            if (this.overwrite) {
              // Error response contains file ID to upload a new file version for
              const conflictFileId = errorData.context_info.conflicts.id;
              if (!this.fileId && !!conflictFileId) {
                this.fileId = conflictFileId;
              }
            } else if (this.conflictCallback) {
              // conflictCallback handler for setting new file name
              this.fileName = this.conflictCallback(this.fileName);
            } else {
              // Otherwise, reupload and append timestamp
              // 'test.jpg' becomes 'test-TIMESTAMP.jpg'
              const extension = this.fileName.substr(this.fileName.lastIndexOf('.')) || '';
              this.fileName = `${this.fileName.substr(0, this.fileName.lastIndexOf('.'))}-${Date.now()}${extension}`;
            }
            this.makePreflightRequest();
            this.retryCount += 1;

            // When rate limited, retry after interval defined in header
          } else if (errorData && (errorData.status === 429 || errorData.code === 'too_many_requests')) {
            let retryAfterMs = DEFAULT_RETRY_DELAY_MS;
            if (errorData.headers) {
              const retryAfterSec = parseInt(
                errorData.headers['retry-after'] || errorData.headers.get('Retry-After'),
                10,
              );
              if (!Number.isNaN(retryAfterSec)) {
                retryAfterMs = retryAfterSec * MS_IN_S;
              }
            }
            this.retryTimeout = setTimeout(this.makePreflightRequest, retryAfterMs);
            this.retryCount += 1;

            // If another error status that isn't name conflict or rate limiting, fail upload
          } else if (
            errorData &&
            (errorData.status || errorData.message === 'Failed to fetch') &&
            typeof this.errorCallback === 'function'
          ) {
            this.errorCallback(errorData);
            // Retry with exponential backoff for other failures since these are likely to be network errors
          } else {
            this.retryTimeout = setTimeout(this.makePreflightRequest, 2 ** this.retryCount * MS_IN_S);
            this.retryCount += 1;
          }
        });
      }
      /**
       * Read a blob with FileReader
       *
       * @param {FileReader} reader
       * @param {Blob} blob
       * @return {Promise}
       */
      readFile(reader, blob) {
        return new Promise((resolve, reject) => {
          reader.readAsArrayBuffer(blob);
          reader.onload = () => {
            resolve({
              buffer: reader.result,
              readCompleteTimestamp: Date.now(),
            });
          };
          reader.onerror = reject;
        });
      }

      /**
       * Parse uploadHost from uploadUrl
       *
       * @param uploadUrl - uploadUrl from preflight response
       * @return {string}
       */
      getUploadHostFromUrl(uploadUrl) {
        const splitUrl = uploadUrl.split('/');
        const uploadHost = `${splitUrl[0]}//${splitUrl[2]}/`;
        return uploadHost;
      }
    }
    /* harmony default export */ const uploads_BaseUpload = BaseUpload; // CONCATENATED MODULE: ./src/api/uploads/BaseMultiput.js
    function BaseMultiput_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function BaseMultiput_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? BaseMultiput_ownKeys(Object(t), !0).forEach(function (r) {
              BaseMultiput_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : BaseMultiput_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function BaseMultiput_defineProperty(e, r, t) {
      return (
        (r = BaseMultiput_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function BaseMultiput_toPropertyKey(t) {
      var i = BaseMultiput_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function BaseMultiput_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Multiput upload base class
     * @author Box
     */

    const DEFAULT_MULTIPUT_CONFIG = {
      digestReadahead: 5,
      // How many parts past those currently uploading to precompute digest for
      initialRetryDelayMs: 5000,
      // Base for exponential backoff on retries
      maxRetryDelayMs: 60000,
      // Upper bound for time between retries
      parallelism: 4,
      // Maximum number of parts to upload at a time
      requestTimeoutMs: 120000,
      // Idle timeout on part upload, overall request timeout on other requests
      retries: 5, // How many times to retry requests such as upload part or commit. Note that total number of attempts will be retries + 1 in worst case where all attempts fail.
    };
    class BaseMultiput extends uploads_BaseUpload {
      /**
       * [constructor]
       *
       * @param {Options} options
       * @param {Object} sessionEndpoints
       * @param {MultiputConfig} [config]
       * @return {void}
       */
      constructor(options, sessionEndpoints, config) {
        super(
          BaseMultiput_objectSpread(
            BaseMultiput_objectSpread({}, options),
            {},
            {
              shouldRetry: false, // disable XHR retries as there is already retry logic
            },
          ),
        );
        /**
         * POST log event
         *
         * @param {string} eventType
         * @param {string} [eventInfo]
         * @return {Promise}
         */
        BaseMultiput_defineProperty(this, 'logEvent', (eventType, eventInfo) => {
          const data = {
            event_type: eventType,
          };
          if (eventInfo) {
            data.event_info = eventInfo;
          }
          return this.xhr.post({
            url: this.sessionEndpoints.logEvent,
            data,
          });
        });
        this.config = config || DEFAULT_MULTIPUT_CONFIG;
        this.sessionEndpoints = sessionEndpoints;
      }
    }
    /* harmony default export */ const uploads_BaseMultiput = BaseMultiput; // CONCATENATED MODULE: ./src/api/uploads/MultiputPart.js
    function MultiputPart_defineProperty(e, r, t) {
      return (
        (r = MultiputPart_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MultiputPart_toPropertyKey(t) {
      var i = MultiputPart_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MultiputPart_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Multiput upload part
     * @author Box
     */

    const PART_STATE_NOT_STARTED = 0;
    const PART_STATE_DIGEST_READY = 1;
    const PART_STATE_UPLOADING = 2;
    const PART_STATE_UPLOADED = 3;
    class MultiputPart extends uploads_BaseMultiput {
      // For resumable uploads.  When an error happens, all parts for an upload get paused.  This
      // is not a separate state because a paused upload transitions to the DIGEST_READY state immediately
      // so MultiputUpload can upload the part again.

      /**
       * [constructor]
       *
       * @param {Options} options
       * @param {number} index - 0-based index of this part in array of all parts
       * @param {number} offset - Starting byte offset of this part's range
       * @param {number} partSize - Size of this part in bytes
       * @param {number} sessionId
       * @param {Object} sessionEndpoints
       * @param {MultiputConfig} config
       * @param {Function} getNumPartsUploading
       * @param {Function} [onSuccess]
       * @param {Function} [onProgress]
       * @param {Function} [onError]
       * @return {void}
       */
      constructor(
        options,
        index,
        offset,
        partSize,
        fileSize,
        sessionId,
        sessionEndpoints,
        config,
        getNumPartsUploading,
        onSuccess,
        onProgress,
        onError,
      ) {
        super(options, sessionEndpoints, config);
        MultiputPart_defineProperty(this, 'toJSON', () =>
          JSON.stringify({
            index: this.index,
            offset: this.offset,
            partSize: this.partSize,
            state: this.state,
            uploadedBytes: this.uploadedBytes,
            numUploadRetriesPerformed: this.numUploadRetriesPerformed,
            numDigestRetriesPerformed: this.numDigestRetriesPerformed,
            sha1: this.sha1,
            timing: this.timing,
          }),
        );
        /**
         * Returns file part information from the server after part upload is successful
         *
         * @return {Object}
         */
        MultiputPart_defineProperty(this, 'getPart', () => this.data.part || {});
        /**
         * Uploads this Part via the API. Will retry on network failures.
         *
         * @return {void}
         */
        MultiputPart_defineProperty(this, 'upload', () => {
          if (this.isDestroyedOrPaused()) {
            return;
          }
          if (!this.sha1) {
            throw new Error('Part SHA-1 unavailable');
          }
          if (!this.blob) {
            throw new Error('Part blob unavailable');
          }
          const clientEventInfo = {
            documentHidden: document.hidden,
            digest_retries: this.numDigestRetriesPerformed,
            timing: this.timing,
            parts_uploading: this.getNumPartsUploading(),
          };
          const headers = {
            'Content-Type': 'application/octet-stream',
            Digest: `sha=${this.sha1}`,
            'Content-Range': `bytes ${this.offset}-${this.rangeEnd}/${this.fileSize}`,
            'X-Box-Client-Event-Info': JSON.stringify(clientEventInfo),
          };
          this.state = PART_STATE_UPLOADING;
          this.startTimestamp = Date.now();
          this.xhr.uploadFile({
            url: this.sessionEndpoints.uploadPart,
            data: this.blob,
            headers,
            method: HTTP_PUT,
            successHandler: this.uploadSuccessHandler,
            errorHandler: this.uploadErrorHandler,
            progressHandler: this.uploadProgressHandler,
            withIdleTimeout: true,
            idleTimeoutDuration: this.config.requestTimeoutMs,
          });
        });
        /**
         * Handler for upload part success
         *
         * @param {Object} data
         * @return {void}
         */
        MultiputPart_defineProperty(this, 'uploadSuccessHandler', ({ data }) => {
          if (this.isDestroyedOrPaused()) {
            return;
          }
          this.state = PART_STATE_UPLOADED;
          this.consoleLog(`Upload completed: ${this.toJSON()}.`);
          this.data = data;
          this.blob = null;
          this.timing.uploadTime = Date.now() - this.startTimestamp;
          this.onSuccess(this);
          this.uploadedBytes = this.partSize;
        });
        /**
         * Handler for upload part progress event
         *
         * @param {ProgressEvent} data
         * @return {void}
         */
        MultiputPart_defineProperty(this, 'uploadProgressHandler', event => {
          if (this.isDestroyedOrPaused()) {
            return;
          }
          const newUploadedBytes = parseInt(event.loaded, 10);
          const prevUploadedBytes = this.uploadedBytes;
          this.uploadedBytes = newUploadedBytes;
          this.onProgress(prevUploadedBytes, newUploadedBytes);
        });
        /**
         * Handler for upload part error
         *
         * @param {Error} error
         * @return {void}
         */
        MultiputPart_defineProperty(this, 'uploadErrorHandler', async error => {
          if (this.isDestroyedOrPaused()) {
            // Ignore abort() error by checking this.isPaused
            return;
          }
          const xhr_ready_state = get_default()(this.xhr, 'xhr.readyState', null);
          const xhr_status_text = get_default()(this.xhr, 'xhr.statusText', '');
          this.consoleLog(`Upload failure ${error.message} for part ${this.toJSON()}. XHR state: ${xhr_ready_state}.`);
          const eventInfo = {
            message: error.message,
            part: {
              uploadedBytes: this.uploadedBytes,
              id: this.id,
              index: this.index,
              offset: this.offset,
            },
            xhr_ready_state,
            xhr_status_text,
          };
          const eventInfoString = JSON.stringify(eventInfo);
          if (this.sessionEndpoints.logEvent) {
            retryNumOfTimes(
              (resolve, reject) => {
                this.logEvent('part_failure', eventInfoString).then(resolve).catch(reject);
              },
              this.config.retries,
              this.config.initialRetryDelayMs,
            ).catch(e => this.consoleLog(`Failure in logEvent: ${e.message}`));
          } else {
            this.consoleLog('logEvent endpoint not found');
          }
          if (this.numUploadRetriesPerformed >= this.config.retries) {
            this.onError(error, eventInfoString);
            return;
          }
          const retryDelayMs = getBoundedExpBackoffRetryDelay(
            this.config.initialRetryDelayMs,
            this.config.maxRetryDelayMs,
            this.numUploadRetriesPerformed,
          );
          this.numUploadRetriesPerformed += 1;
          this.consoleLog(`Retrying uploading part ${this.toJSON()} in ${retryDelayMs} ms`);
          this.retryTimeout = setTimeout(this.retryUpload, retryDelayMs);
        });
        /**
         * Retry uploading part
         *
         * @return {Promise}
         */
        MultiputPart_defineProperty(this, 'retryUpload', async () => {
          if (this.isDestroyedOrPaused()) {
            return;
          }
          try {
            const parts = await this.listParts(this.index, 1);
            if (parts && parts.length === 1 && parts[0].offset === this.offset && parts[0].part_id) {
              this.consoleLog(`Part ${this.toJSON()} is available on server. Not re-uploading.`);
              this.id = parts[0].part_id;
              this.uploadSuccessHandler({
                data: {
                  part: parts[0],
                },
              });
              return;
            }
            this.consoleLog(`Part ${this.toJSON()} is not available on server. Re-uploading.`);
            throw new Error('Part not found on the server');
          } catch (error) {
            const { response } = error;
            if (response && response.status) {
              this.consoleLog(`Error ${response.status} while listing part ${this.toJSON()}. Re-uploading.`);
            }
            this.numUploadRetriesPerformed += 1;
            this.upload();
          }
        });
        /**
         * List specified parts
         *
         * @param {number} partIndex - Index of starting part. Optional.
         * @param {number} limit - Number of parts to be listed. Optional.
         * @return {Promise<Array<Object>>} Array of parts
         */
        MultiputPart_defineProperty(this, 'listParts', async (partIndex, limit) => {
          const params = {
            offset: partIndex,
            limit,
          };
          const endpoint = updateQueryParameters(this.sessionEndpoints.listParts, params);
          const response = await this.xhr.get({
            url: endpoint,
          });
          return response.data.entries;
        });
        this.index = index;
        this.numDigestRetriesPerformed = 0;
        this.numUploadRetriesPerformed = 0;
        this.offset = offset;
        this.partSize = partSize;
        this.fileSize = fileSize;
        this.state = PART_STATE_NOT_STARTED;
        this.timing = {};
        this.uploadedBytes = 0;
        this.data = {};
        this.config = config;
        this.rangeEnd = offset + partSize - 1;
        if (this.rangeEnd > fileSize - 1) {
          this.rangeEnd = fileSize - 1;
        }
        this.isPaused = false;
        this.onSuccess = onSuccess || noop_default();
        this.onError = onError || noop_default();
        this.onProgress = onProgress || noop_default();
        this.getNumPartsUploading = getNumPartsUploading;
      }
      /**
       * Cancels upload for this Part.
       *
       * @return {void}
       */
      cancel() {
        clearTimeout(this.retryTimeout);
        this.blob = null;
        this.data = {};
        this.destroy();
      }

      /**
       * Pauses upload for this Part.
       *
       * @return {void}
       */
      pause() {
        clearTimeout(this.retryTimeout); // Cancel timeout so that we don't keep retrying while paused
        this.isPaused = true;
        this.state = PART_STATE_DIGEST_READY;
        this.xhr.abort(); //  This calls the error handler.
      }

      /**
       * Unpauses upload for this Part.
       *
       * @return {void}
       */
      unpause() {
        this.isPaused = false;
        this.state = PART_STATE_UPLOADING;
        this.retryUpload();
      }

      /**
       * Resets upload for this Part.
       *
       * @return {void}
       */
      reset() {
        this.numUploadRetriesPerformed = 0;
        this.timing = {};
        this.uploadedBytes = 0;
      }

      /**
       * Checks if this Part is destroyed or paused
       *
       * @return {boolean}
       */
      isDestroyedOrPaused() {
        return this.isDestroyed() || this.isPaused;
      }
    }
    /* harmony default export */ const uploads_MultiputPart = MultiputPart; // CONCATENATED MODULE: ./src/api/uploads/MultiputUpload.js

    function MultiputUpload_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function MultiputUpload_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? MultiputUpload_ownKeys(Object(t), !0).forEach(function (r) {
              MultiputUpload_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : MultiputUpload_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function MultiputUpload_defineProperty(e, r, t) {
      return (
        (r = MultiputUpload_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MultiputUpload_toPropertyKey(t) {
      var i = MultiputUpload_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MultiputUpload_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Multiput upload
     * @author Box
     */

    // Constants used for specifying log event types.

    // This type is a catch-all for create session errors that aren't 5xx's (for which we'll do
    // retries) and aren't specific 4xx's we know how to specifically handle (e.g. out of storage).
    const LOG_EVENT_TYPE_CREATE_SESSION_MISC_ERROR = 'create_session_misc_error';
    const LOG_EVENT_TYPE_CREATE_SESSION_RETRIES_EXCEEDED = 'create_session_retries_exceeded';
    const LOG_EVENT_TYPE_FILE_CHANGED_DURING_UPLOAD = 'file_changed_during_upload';
    const LOG_EVENT_TYPE_PART_UPLOAD_RETRIES_EXCEEDED = 'part_upload_retries_exceeded';
    const LOG_EVENT_TYPE_COMMIT_RETRIES_EXCEEDED = 'commit_retries_exceeded';
    const LOG_EVENT_TYPE_WEB_WORKER_ERROR = 'web_worker_error';
    const LOG_EVENT_TYPE_FILE_READER_RECEIVED_NOT_FOUND_ERROR = 'file_reader_received_not_found_error';
    const LOG_EVENT_TYPE_PART_DIGEST_RETRIES_EXCEEDED = 'part_digest_retries_exceeded';
    class MultiputUpload extends uploads_BaseMultiput {
      /**
       * [constructor]
       *
       * @param {Options} options
       * @param {MultiputConfig} [config]
       */
      constructor(options, config) {
        super(
          options,
          {
            createSession: null,
            uploadPart: null,
            listParts: null,
            commit: null,
            abort: null,
            logEvent: null,
          },
          config,
        );
        /**
         * Update uploadHost with preflight response and return the base uploadUrl
         *
         * @private
         * @param {Object} response
         * @param {Object} [response.data]
         * @return {string}
         */
        MultiputUpload_defineProperty(this, 'getBaseUploadUrlFromPreflightResponse', ({ data }) => {
          if (!data || !data.upload_url) {
            return this.getBaseUploadUrl();
          }
          const splitUrl = data.upload_url.split('/');
          // splitUrl[0] is the protocol (e.g., https:), splitUrl[2] is hostname (e.g., www.box.com)
          this.uploadHost = `${splitUrl[0]}//${splitUrl[2]}`;
          return this.getBaseUploadUrl();
        });
        /**
         * Creates upload session. If a file ID is supplied, use the Chunked Upload File Version
         * API to replace the file.
         *
         * @private
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'preflightSuccessHandler', async preflightResponse => {
          if (this.isDestroyed()) {
            return;
          }
          const uploadUrl = this.getBaseUploadUrlFromPreflightResponse(preflightResponse);
          let createSessionUrl = `${uploadUrl}/files/upload_sessions`;

          // Parallelism is currently detrimental to multiput upload performance in Zones, so set it to 1.
          if (createSessionUrl.includes('fupload-ec2')) {
            this.config.parallelism = 1;
          }

          // Set up post body
          const postData = {
            file_size: this.file.size,
            file_name: this.fileName,
          };
          if (this.fileId) {
            createSessionUrl = createSessionUrl.replace('upload_sessions', `${this.fileId}/upload_sessions`);
          } else {
            postData.folder_id = this.folderId;
          }
          try {
            const response = await this.xhr.post({
              url: createSessionUrl,
              data: postData,
            });
            this.createSessionSuccessHandler(response.data);
          } catch (error) {
            const errorData = this.getErrorResponse(error);
            if (errorData && errorData.status >= 500 && errorData.status < 600) {
              this.createSessionErrorHandler(error);
              return;
            }

            // Recover from 409 session_conflict.  The server will return the session information
            // in context_info, so treat it as a success.
            if (errorData && errorData.status === 409 && errorData.code === 'session_conflict') {
              this.createSessionSuccessHandler(errorData.context_info.session);
              return;
            }
            if (
              (errorData &&
                errorData.status === HTTP_STATUS_CODE_FORBIDDEN &&
                errorData.code === ERROR_CODE_UPLOAD_STORAGE_LIMIT_EXCEEDED) ||
              (errorData.status === HTTP_STATUS_CODE_FORBIDDEN &&
                errorData.code === 'access_denied_insufficient_permissions')
            ) {
              this.errorCallback(errorData);
              return;
            }
            if (errorData && errorData.status === 409) {
              this.resolveConflict(errorData);
              this.createSessionRetry();
              return;
            }

            // All other cases get treated as an upload failure.
            this.sessionErrorHandler(error, LOG_EVENT_TYPE_CREATE_SESSION_MISC_ERROR, JSON.stringify(error));
          }
        });
        /**
         * Create session error handler.
         * Retries the create session request or fails the upload.
         *
         * @private
         * @param {Error} error
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'createSessionErrorHandler', error => {
          if (this.isDestroyed()) {
            return;
          }
          if (this.createSessionNumRetriesPerformed < this.config.retries) {
            this.createSessionRetry();
            return;
          }
          this.consoleLog('Too many create session failures, failing upload');
          this.sessionErrorHandler(error, LOG_EVENT_TYPE_CREATE_SESSION_RETRIES_EXCEEDED, JSON.stringify(error));
        });
        /**
         * Get session information from API.
         * Uses session info to commit a complete session or continue an in-progress session.
         *
         * @private
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'getSessionInfo', async () => {
          const uploadUrl = this.getBaseUploadUrl();
          const sessionUrl = `${uploadUrl}/files/upload_sessions/${this.sessionId}`;
          try {
            const response = await this.xhr.get({
              url: sessionUrl,
            });
            this.getSessionSuccessHandler(response.data);
          } catch (error) {
            this.getSessionErrorHandler(error);
          }
        });
        /**
         * Part upload success handler
         *
         * @private
         * @param {MultiputPart} part
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'partUploadSuccessHandler', part => {
          this.numPartsUploading -= 1;
          this.numPartsUploaded += 1;
          this.updateProgress(part.uploadedBytes, this.partSize);
          this.processNextParts();
        });
        /**
         * Part upload error handler
         *
         * @private
         * @param {Error} error
         * @param {string} eventInfo
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'partUploadErrorHandler', (error, eventInfo) => {
          this.sessionErrorHandler(error, LOG_EVENT_TYPE_PART_UPLOAD_RETRIES_EXCEEDED, eventInfo);
          // Pause the rest of the parts.
          // can't cancel parts because cancel destroys the part and parts are only created in createSession call
          if (this.isResumableUploadsEnabled) {
            // Reset uploading process for parts that were in progress when the upload failed
            let nextUploadIndex = this.firstUnuploadedPartIndex;
            while (this.numPartsUploading > 0) {
              const part = this.parts[nextUploadIndex];
              if (part && part.state === PART_STATE_UPLOADING) {
                part.reset();
                part.pause();
                this.numPartsUploading -= 1;
                this.numPartsDigestReady += 1;
              }
              nextUploadIndex += 1;
            }
          }
        });
        /**
         * Update upload progress
         *
         * @private
         * @param {number} prevUploadedBytes
         * @param {number} newUploadedBytes
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'updateProgress', (prevUploadedBytes, newUploadedBytes) => {
          if (this.isDestroyed()) {
            return;
          }
          this.totalUploadedBytes += newUploadedBytes - prevUploadedBytes;
          this.progressCallback({
            loaded: this.totalUploadedBytes,
            total: this.file.size,
          });
        });
        /**
         * Attempts to process more parts, except in the case where everything is done or we detect
         * a file change (in which case we want to abort and not process more parts).
         *
         * @private
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'processNextParts', () => {
          if (this.failSessionIfFileChangeDetected()) {
            return;
          }
          if (this.numPartsUploaded === this.parts.length && this.fileSha1) {
            this.commitSession();
            return;
          }
          this.updateFirstUnuploadedPartIndex();
          while (this.canStartMorePartUploads()) {
            this.uploadNextPart();
          }
          if (this.shouldComputeDigestForNextPart()) {
            this.computeDigestForNextPart();
          }
        });
        /**
         * Deal with a message from the worker (either a part sha-1 ready, file sha-1 ready, or error).
         *
         * @private
         * @param {object} event
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'onWorkerMessage', event => {
          if (this.isDestroyed()) {
            return;
          }
          const { data } = event;
          if (data.type === 'partDone') {
            const { part } = data;
            this.parts[part.index].timing.fileDigestTime = data.duration;
            this.processNextParts();
          } else if (data.type === 'done') {
            this.fileSha1 = hexToBase64(data.sha1);
            this.sha1Worker.terminate();
            this.processNextParts();
          } else if (data.type === 'error') {
            this.sessionErrorHandler(null, LOG_EVENT_TYPE_WEB_WORKER_ERROR, JSON.stringify(data));
          }
        });
        /**
         * Sends a part to the sha1Worker
         *
         * @private
         * @param {MultiputPart} part
         * @param {ArrayBuffer} buffer
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'sendPartToWorker', (part, buffer) => {
          if (this.isDestroyed()) {
            return;
          }

          // Don't send entire part since XHR can't be cloned
          const partInformation = {
            index: part.index,
            offset: part.offset,
            size: part.partSize,
          };
          this.sha1Worker.postMessage(
            {
              part: partInformation,
              fileSize: this.file.size,
              partContents: buffer,
            },
            [buffer], // This transfers the ArrayBuffer to the worker context without copying contents.
          );
          this.consoleLog(`Part sent to worker: ${JSON.stringify(part)}.}`);
        });
        /**
         * Error handler for part digest computation
         *
         * @private
         * @param {Error} error
         * @param {MultiputPart} part
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'onPartDigestError', (error, part) => {
          this.consoleLog(`Error computing digest for part ${JSON.stringify(part)}: ${JSON.stringify(error)}`);

          // When a FileReader is processing a file that changes on disk, Chrome reports a 'NotFoundError'
          // and Safari reports a 'NOT_FOUND_ERR'. (Other browsers seem to allow the reader to keep
          // going, either with the old version of the new file or the new one.) Since the error name
          // implies that retrying will not help, we fail the session.
          if (error.name === 'NotFoundError' || error.name === 'NOT_FOUND_ERR') {
            this.sessionErrorHandler(null, LOG_EVENT_TYPE_FILE_READER_RECEIVED_NOT_FOUND_ERROR, JSON.stringify(error));
            return;
          }
          if (this.failSessionIfFileChangeDetected()) {
            return;
          }
          if (part.numDigestRetriesPerformed >= this.config.retries) {
            this.sessionErrorHandler(null, LOG_EVENT_TYPE_PART_DIGEST_RETRIES_EXCEEDED, JSON.stringify(error));
            return;
          }
          const retryDelayMs = getBoundedExpBackoffRetryDelay(
            this.config.initialRetryDelayMs,
            this.config.maxRetryDelayMs,
            part.numDigestRetriesPerformed,
          );
          part.numDigestRetriesPerformed += 1;
          this.consoleLog(`Retrying digest work for part ${JSON.stringify(part)} in ${retryDelayMs} ms`);
          setTimeout(() => {
            this.computeDigestForPart(part);
          }, retryDelayMs);
        });
        /**
         * Send a request to commit the upload.
         *
         * @private
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'commitSession', () => {
          if (this.isDestroyed()) {
            return;
          }
          const stats = {
            totalPartReadTime: 0,
            totalPartDigestTime: 0,
            totalFileDigestTime: 0,
            totalPartUploadTime: 0,
          };
          const data = {
            parts: this.parts
              .map(part => {
                stats.totalPartReadTime += part.timing.readTime;
                stats.totalPartDigestTime += part.timing.subtleCryptoTime;
                stats.totalFileDigestTime += part.timing.fileDigestTime;
                stats.totalPartUploadTime += part.timing.uploadTime;
                return part.getPart();
              })
              .sort((part1, part2) => part1.offset - part2.offset),
            attributes: {},
          };
          const fileLastModified = getFileLastModifiedAsISONoMSIfPossible(this.file);
          if (fileLastModified) {
            data.attributes.content_modified_at = fileLastModified;
          }
          if (this.fileDescription) {
            data.attributes.description = this.fileDescription;
          }
          const clientEventInfo = {
            avg_part_read_time: Math.round(stats.totalPartReadTime / this.parts.length),
            avg_part_digest_time: Math.round(stats.totalPartDigestTime / this.parts.length),
            avg_file_digest_time: Math.round(stats.totalFileDigestTime / this.parts.length),
            avg_part_upload_time: Math.round(stats.totalPartUploadTime / this.parts.length),
          };

          // To make flow stop complaining about this.fileSha1 could potentially be undefined/null
          const fileSha1 = this.fileSha1;
          const headers = {
            Digest: `sha=${fileSha1}`,
            'X-Box-Client-Event-Info': JSON.stringify(clientEventInfo),
          };
          this.xhr
            .post({
              url: this.sessionEndpoints.commit,
              data,
              headers,
            })
            .then(this.commitSessionSuccessHandler)
            .catch(this.commitSessionErrorHandler);
        });
        /**
         * Commit response handler.  Succeeds the upload, retries the commit on 202
         *
         * @private
         * @param {Object} response
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'commitSessionSuccessHandler', response => {
          if (this.isDestroyed()) {
            return;
          }
          const { status, data } = response;
          if (status === 202) {
            this.commitSessionRetry(response);
            return;
          }
          let { entries } = data;
          // v2.1 API response format is different from v2.0. v2.1 returns individual upload entry directly inside data,
          // while v2.0 returns a collection of entries under data.entries
          if (!entries && data.id) {
            entries = [data];
          }
          this.destroy();
          if (this.successCallback && entries) {
            this.successCallback(entries);
          }
        });
        /**
         * Commit error handler.
         * Retries the commit or fails the multiput session.
         *
         * @private
         * @param {Object} error
         * @return {void}
         */
        MultiputUpload_defineProperty(this, 'commitSessionErrorHandler', error => {
          if (this.isDestroyed()) {
            return;
          }
          const { response } = error;
          if (!response) {
            // Some random error happened
            this.consoleError(error);
            return;
          }
          if (this.commitRetryCount >= this.config.retries) {
            this.consoleLog('Too many commit failures, failing upload');
            this.sessionErrorHandler(error, LOG_EVENT_TYPE_COMMIT_RETRIES_EXCEEDED, JSON.stringify(error));
            return;
          }
          this.commitSessionRetry(response);
        });
        /**
         * Get number of parts being uploaded
         *
         * @return {number}
         */
        MultiputUpload_defineProperty(this, 'getNumPartsUploading', () => this.numPartsUploading);
        this.parts = [];
        this.options = options;
        this.fileSha1 = null;
        this.totalUploadedBytes = 0;
        this.numPartsNotStarted = 0; // # of parts yet to be processed
        this.numPartsDigestComputing = 0; // # of parts sent to the digest worker
        this.numPartsDigestReady = 0; // # of parts with digest finished that are waiting to be uploaded.
        this.numPartsUploading = 0; // # of parts with upload requests currently inflight
        this.numPartsUploaded = 0; // # of parts successfully uploaded
        this.firstUnuploadedPartIndex = 0; // Index of first part that hasn't been uploaded yet.
        this.createSessionNumRetriesPerformed = 0;
        this.partSize = 0;
        this.commitRetryCount = 0;
        this.clientId = null;
        this.isResumableUploadsEnabled = false;
        this.numResumeRetries = 0;
      }

      /**
       * Reset values for uploading process.
       */
      reset() {
        this.parts = [];
        this.fileSha1 = null;
        this.totalUploadedBytes = 0;
        this.numPartsNotStarted = 0; // # of parts yet to be processed
        this.numPartsDigestComputing = 0; // # of parts sent to the digest worker
        this.numPartsDigestReady = 0; // # of parts with digest finished that are waiting to be uploaded.
        this.numPartsUploading = 0; // # of parts with upload requests currently inflight
        this.numPartsUploaded = 0; // # of parts successfully uploaded
        this.firstUnuploadedPartIndex = 0; // Index of first part that hasn't been uploaded yet.
        this.createSessionNumRetriesPerformed = 0;
        this.partSize = 0;
        this.commitRetryCount = 0;
        this.numResumeRetries = 0;
      }

      /**
       * Set information about file being uploaded
       *
       *
       * @param {Object} options
       * @param {File} options.file
       * @param {string} options.folderId - Untyped folder id (e.g. no "folder_" prefix)
       * @param {string} [options.fileId] - Untyped file id (e.g. no "file_" prefix)
       * @param {string} options.sessionId
       * @param {Function} [options.errorCallback]
       * @param {Function} [options.progressCallback]
       * @param {Function} [options.successCallback]
       * @return {void}
       */
      setFileInfo({
        file,
        folderId,
        errorCallback,
        progressCallback,
        successCallback,
        overwrite = true,
        conflictCallback,
        fileId,
      }) {
        this.file = file;
        this.fileName = this.file.name;
        this.folderId = folderId;
        this.errorCallback = errorCallback || noop_default();
        this.progressCallback = progressCallback || noop_default();
        this.successCallback = successCallback || noop_default();
        this.overwrite = overwrite;
        this.conflictCallback = conflictCallback;
        this.fileId = fileId;
      }

      /**
       * Upload a given file
       *
       *
       * @param {Object} options
       * @param {File} options.file
       * @param {string} options.folderId - Untyped folder id (e.g. no "folder_" prefix)
       * @param {string} [options.fileId] - Untyped file id (e.g. no "file_" prefix)
       * @param {Function} [options.errorCallback]
       * @param {Function} [options.progressCallback]
       * @param {Function} [options.successCallback]
       * @return {void}
       */
      upload({
        file,
        fileDescription,
        folderId,
        errorCallback,
        progressCallback,
        successCallback,
        overwrite = true,
        conflictCallback,
        fileId,
      }) {
        this.file = file;
        this.fileName = this.file.name;
        // These values are used as part of our (best effort) attempt to abort uploads if we detect
        // a file change during the upload.
        this.initialFileSize = this.file.size;
        this.initialFileLastModified = getFileLastModifiedAsISONoMSIfPossible(this.file);
        this.folderId = folderId;
        this.errorCallback = errorCallback || noop_default();
        this.progressCallback = progressCallback || noop_default();
        this.successCallback = successCallback || noop_default();
        this.sha1Worker = uploadsSHA1Worker();
        this.sha1Worker.addEventListener('message', this.onWorkerMessage);
        this.conflictCallback = conflictCallback;
        this.overwrite = overwrite;
        this.fileId = fileId;
        this.fileDescription = fileDescription;
        this.makePreflightRequest();
      }
      /**
       * Schedule a retry for create session request upon failure
       *
       * @private
       * @return {void}
       */
      createSessionRetry() {
        const retryDelayMs = getBoundedExpBackoffRetryDelay(
          this.config.initialRetryDelayMs,
          this.config.maxRetryDelayMs,
          this.createSessionNumRetriesPerformed,
        );
        this.createSessionNumRetriesPerformed += 1;
        this.consoleLog(`Retrying create session in ${retryDelayMs} ms`);
        this.createSessionTimeout = setTimeout(this.makePreflightRequest, retryDelayMs);
      }

      /**
       * Handles a upload session success response
       *
       * @private
       * @param {Object} data - Upload session creation success data
       * @return {void}
       */
      createSessionSuccessHandler(data) {
        if (this.isDestroyed()) {
          return;
        }
        const { id, part_size, session_endpoints } = data;
        this.sessionId = id;
        this.partSize = part_size;
        this.sessionEndpoints = MultiputUpload_objectSpread(
          MultiputUpload_objectSpread({}, this.sessionEndpoints),
          {},
          {
            uploadPart: session_endpoints.upload_part,
            listParts: session_endpoints.list_parts,
            commit: session_endpoints.commit,
            abort: session_endpoints.abort,
            logEvent: session_endpoints.log_event,
          },
        );
        this.populateParts();
        this.processNextParts();
      }

      /**
       * Resume uploading the given file
       *
       *
       * @param {Object} options
       * @param {File} options.file
       * @param {string} options.folderId - Untyped folder id (e.g. no "folder_" prefix)
       * @param {string} [options.fileId] - Untyped file id (e.g. no "file_" prefix)
       * @param {string} options.sessionId
       * @param {Function} [options.errorCallback]
       * @param {Function} [options.progressCallback]
       * @param {Function} [options.successCallback]
       * @param {Function} [options.conflictCallback]
       * @return {void}
       */
      resume({
        file,
        folderId,
        errorCallback,
        progressCallback,
        sessionId,
        successCallback,
        overwrite = true,
        conflictCallback,
        fileId,
      }) {
        this.setFileInfo({
          file,
          folderId,
          errorCallback,
          progressCallback,
          successCallback,
          conflictCallback,
          overwrite,
          fileId,
        });
        this.sessionId = sessionId;
        if (!this.sha1Worker) {
          this.sha1Worker = uploadsSHA1Worker();
        }
        this.sha1Worker.addEventListener('message', this.onWorkerMessage);
        this.getSessionInfo();
      }
      /**
       * Handles a getSessionInfo success and either commits the session or continues to process
       * the parts that still need to be uploaded.
       *
       * @param response
       * @return {void}
       */
      getSessionSuccessHandler(data) {
        const { part_size, session_endpoints } = data;

        // Set session information gotten from API response
        this.partSize = part_size;
        this.sessionEndpoints = MultiputUpload_objectSpread(
          MultiputUpload_objectSpread({}, this.sessionEndpoints),
          {},
          {
            uploadPart: session_endpoints.upload_part,
            listParts: session_endpoints.list_parts,
            commit: session_endpoints.commit,
            abort: session_endpoints.abort,
            logEvent: session_endpoints.log_event,
          },
        );
        this.processNextParts();
      }

      /**
       * Handle error from getting upload session.
       * Restart uploads without valid sessions from the beginning of the upload process.
       *
       * @param error
       * @return {void}
       */
      getSessionErrorHandler(error) {
        if (this.isDestroyed()) {
          return;
        }
        const errorData = this.getErrorResponse(error);
        if (this.numResumeRetries > this.config.retries) {
          this.errorCallback(errorData);
          return;
        }
        if (errorData && errorData.status === 429) {
          let retryAfterMs = DEFAULT_RETRY_DELAY_MS;
          if (errorData.headers) {
            const retryAfterSec = parseInt(
              errorData.headers['retry-after'] || errorData.headers.get('Retry-After'),
              10,
            );
            if (!isNaN_default()(retryAfterSec)) {
              retryAfterMs = retryAfterSec * MS_IN_S;
            }
          }
          this.retryTimeout = setTimeout(this.getSessionInfo, retryAfterMs);
          this.numResumeRetries += 1;
        } else if (errorData && errorData.status >= 400 && errorData.status < 500) {
          // Restart upload process for errors resulting from invalid/expired session or no permission
          this.parts.forEach(part => {
            part.cancel();
          });
          this.reset();

          // Abort session
          clearTimeout(this.createSessionTimeout);
          clearTimeout(this.commitSessionTimeout);
          this.abortSession();
          // Restart the uploading process from the beginning
          const uploadOptions = {
            file: this.file,
            folderId: this.folderId,
            errorCallback: this.errorCallback,
            progressCallback: this.progressCallback,
            successCallback: this.successCallback,
            overwrite: this.overwrite,
            fileId: this.fileId,
          };
          this.upload(uploadOptions);
        } else {
          // Handle internet disconnects (error.request && !error.response) and (!error.request)
          // Also handle any 500 error messages
          this.retryTimeout = setTimeout(this.getSessionInfo, 2 ** this.numResumeRetries * MS_IN_S);
          this.numResumeRetries += 1;
        }
      }

      /**
       * Session error handler.
       * Retries the create session request or fails the upload.
       *
       * @private
       * @param {?Error} error
       * @param {string} logEventType
       * @param {string} [logMessage]
       * @return {Promise}
       */
      async sessionErrorHandler(error, logEventType, logMessage) {
        if (!this.isResumableUploadsEnabled) {
          this.destroy();
        }
        const errorData = this.getErrorResponse(error);
        this.errorCallback(errorData);
        try {
          if (!this.sessionEndpoints.logEvent) {
            throw new Error('logEvent endpoint not found');
          }
          await retryNumOfTimes(
            (resolve, reject) => {
              this.logEvent(logEventType, logMessage).then(resolve).catch(reject);
            },
            this.config.retries,
            this.config.initialRetryDelayMs,
          );
          if (!this.isResumableUploadsEnabled) {
            this.abortSession();
          }
        } catch (err) {
          if (!this.isResumableUploadsEnabled) {
            this.abortSession();
          }
        }
      }

      /**
       * Aborts the upload session
       *
       * @private
       * @return {void}
       */
      abortSession() {
        if (this.sha1Worker) {
          this.sha1Worker.terminate();
        }
        if (this.sessionEndpoints.abort && this.sessionId) {
          this.xhr
            .delete({
              url: this.sessionEndpoints.abort,
            })
            .then(() => {
              this.sessionId = '';
            });
        }
      }
      /**
       * We compute digest for parts one at a time.  This is done for simplicity and also to guarantee that
       * we send parts in order to the web sha1Worker (which is computing the digest for the entire file).
       *
       * @private
       * @return {boolean} true if there is work to do, false otherwise.
       */
      shouldComputeDigestForNextPart() {
        return (
          !this.isDestroyed() &&
          this.numPartsDigestComputing === 0 &&
          this.numPartsNotStarted > 0 &&
          this.numPartsDigestReady < this.config.digestReadahead
        );
      }

      /**
       * Find first part in parts array that doesn't have a digest, and compute its digest.
       * @private
       * @return {void}
       */
      computeDigestForNextPart() {
        for (let i = this.firstUnuploadedPartIndex; i < this.parts.length; i += 1) {
          const part = this.parts[i];
          if (part.state === PART_STATE_NOT_STARTED) {
            // Update the counters here instead of computeDigestForPart because computeDigestForPart
            // can get called on retries
            this.numPartsNotStarted -= 1;
            this.numPartsDigestComputing += 1;
            this.computeDigestForPart(part);
            return;
          }
        }
      }

      /**
       * Compute digest for this part
       *
       * @private
       * @param {MultiputPart} part
       * @return {Promise}
       */
      async computeDigestForPart(part) {
        const blob = this.file.slice(part.offset, part.offset + this.partSize);
        const reader = new window.FileReader();
        const startTimestamp = Date.now();
        try {
          const { buffer, readCompleteTimestamp } = await this.readFile(reader, blob);
          const sha1ArrayBuffer = await digest('SHA-1', buffer);
          const sha1 = btoa(
            [].reduce.call(new Uint8Array(sha1ArrayBuffer), (data, byte) => data + String.fromCharCode(byte), ''),
          );
          this.sendPartToWorker(part, buffer);
          part.sha1 = sha1;
          part.state = PART_STATE_DIGEST_READY;
          part.blob = blob;
          this.numPartsDigestReady += 1;
          // This will trigger the next digest computation
          this.numPartsDigestComputing -= 1;
          const digestCompleteTimestamp = Date.now();
          part.timing = {
            partDigestTime: digestCompleteTimestamp - startTimestamp,
            readTime: readCompleteTimestamp - startTimestamp,
            subtleCryptoTime: digestCompleteTimestamp - readCompleteTimestamp,
          };
          this.processNextParts();
        } catch (error) {
          this.onPartDigestError(error, part);
        }
      }
      /**
       * Retry commit.
       * Retries the commit or fails the multiput session.
       *
       * @private
       * @param {Object} response
       * @return {void}
       */
      commitSessionRetry(response) {
        const { status, headers } = response;
        let retryAfterMs = DEFAULT_RETRY_DELAY_MS;
        if (headers) {
          const retryAfterSec = parseInt(headers['retry-after'], 10);
          if (!Number.isNaN(retryAfterSec)) {
            retryAfterMs = retryAfterSec * 1000;
          }
        }
        const defaultRetryDelayMs = getBoundedExpBackoffRetryDelay(
          this.config.initialRetryDelayMs,
          this.config.maxRetryDelayMs,
          this.commitRetryCount,
        );
        // If status is 202 then don't increment the retry count.
        // In this case, frontend will keep retrying until it gets another status code.
        // Retry interval = value specified for the Retry-After header in 202 response.
        if (status !== 202) {
          this.commitRetryCount += 1;
        }
        const retryDelayMs = retryAfterMs || defaultRetryDelayMs;
        this.consoleLog(`Retrying commit in ${retryDelayMs} ms`);
        this.commitSessionTimeout = setTimeout(this.commitSession, retryDelayMs);
      }

      /**
       * Find first part in parts array that we can upload, and upload it.
       *
       * @private
       * @return {void}
       */
      uploadNextPart() {
        for (let i = this.firstUnuploadedPartIndex; i < this.parts.length; i += 1) {
          const part = this.parts[i];
          if (part.state === PART_STATE_DIGEST_READY) {
            // Update the counters here instead of uploadPart because uploadPart
            // can get called on retries
            this.numPartsDigestReady -= 1;
            this.numPartsUploading += 1;
            if (part.isPaused) {
              part.unpause();
            } else {
              part.upload();
            }
            break;
          }
        }
      }

      /**
       * Checks if upload pipeline is full
       *
       * @private
       * @return {boolean}
       */
      canStartMorePartUploads() {
        return !this.isDestroyed() && this.numPartsUploading < this.config.parallelism && this.numPartsDigestReady > 0;
      }

      /**
       * Functions that walk the parts array get called a lot, so we cache which part we should
       * start work at to avoid always iterating through entire parts list.
       *
       * @private
       * @return {void}
       */
      updateFirstUnuploadedPartIndex() {
        let part = this.parts[this.firstUnuploadedPartIndex];
        while (part && part.state === PART_STATE_UPLOADED) {
          this.firstUnuploadedPartIndex += 1;
          part = this.parts[this.firstUnuploadedPartIndex];
        }
      }
      /**
       * After session is created and we know the part size, populate the parts
       * array.
       *
       * @private
       * @return {void}
       */
      populateParts() {
        this.numPartsNotStarted = Math.ceil(this.file.size / this.partSize);
        for (let i = 0; i < this.numPartsNotStarted; i += 1) {
          const offset = i * this.partSize;
          const currentPartSize = Math.min(offset + this.partSize, this.file.size) - offset;
          const part = new uploads_MultiputPart(
            this.options,
            i,
            offset,
            currentPartSize,
            this.file.size,
            this.sessionId,
            this.sessionEndpoints,
            this.config,
            this.getNumPartsUploading,
            this.partUploadSuccessHandler,
            this.updateProgress,
            this.partUploadErrorHandler,
          );
          this.parts.push(part);
        }
      }

      /**
       * Fails the session if the file's size or last modified has changed since the upload process
       * began.
       *
       * This ensures that we don't upload a file that has parts from one file version and parts from
       * another file version.
       *
       * This logic + the "not found" error logic in onWorkerError() is best effort and will not
       * detect all possible file changes. This is because of browser differences. For example,
       * -- In Safari, size and last modified will update when a file changes, and workers will
       * get "not found" errors.
       * -- In Chrome, size and last modified will update, but not in legacy drag and drop (that
       * code path constructs a different file object). Workers will still get "not found" errors,
       * though, so we can still detect changes even in legacy drag and drop.
       * -- In IE 11/Edge, size will update but last modified will not. Workers will not get
       * "not found" errors, but they may get a generic error saying that some bytes failed to be
       * read.
       * -- In Firefox, neither last modified nor size will update. Workers don't seem to get errors.
       * (Not a whole lot we can do here...)
       *
       * Unfortunately, alternative solutions to catch more cases don't have a clear ROI (for
       * example, doing a SHA-1 of the file before and after the upload is very expensive), so
       * this is the best solution we have. We can revisit this if data shows that we need a better
       * solution.
       *
       * @private
       * @return {boolean} True if the session was failed, false if no action was taken
       */
      failSessionIfFileChangeDetected() {
        const currentFileSize = this.file.size;
        const currentFileLastModified = getFileLastModifiedAsISONoMSIfPossible(this.file);
        if (currentFileSize !== this.initialFileSize || currentFileLastModified !== this.initialFileLastModified) {
          const changeJSON = JSON.stringify({
            oldSize: this.initialFileSize,
            newSize: currentFileSize,
            oldLastModified: this.initialFileLastModified,
            newLastModified: currentFileLastModified,
          });
          // Leave IE with old behavior and kill upload
          if (utils_Browser.isIE()) {
            this.sessionErrorHandler(null, LOG_EVENT_TYPE_FILE_CHANGED_DURING_UPLOAD, changeJSON);
            return true;
          }
          // for evergreen browsers where the file change check does not work, log and continue with upload
          // https://w3c.github.io/FileAPI/#file-section
          this.consoleLog(`file properties changed during upload: ${changeJSON}`);
          return false;
        }
        return false;
      }

      /**
       * Cancels an upload in progress by cancelling all upload parts.
       * This cannot be undone or resumed.
       *
       * @private
       * @return {void}
       */
      cancel() {
        if (this.isDestroyed()) {
          return;
        }

        // Cancel individual upload parts
        this.parts.forEach(part => {
          part.cancel();
        });
        this.parts = [];
        clearTimeout(this.createSessionTimeout);
        clearTimeout(this.commitSessionTimeout);
        this.abortSession();
        this.destroy();
      }

      /**
       * Resolves upload conflict by overwriting or renaming
       *
       * @param {Object} response data
       * @return {Promise}
       */
      async resolveConflict(data) {
        if (this.overwrite && data.context_info) {
          this.fileId = data.context_info.conflicts.id;
          return;
        }
        if (this.conflictCallback) {
          this.fileName = this.conflictCallback(this.fileName);
          return;
        }
        const extension = this.fileName.substr(this.fileName.lastIndexOf('.')) || '';
        // foo.txt => foo-1513385827917.txt
        this.fileName = `${this.fileName.substr(0, this.fileName.lastIndexOf('.'))}-${Date.now()}${extension}`;
      }

      /**
       * Returns detailed error response
       *
       * @param {Object} error
       * @return {Object}
       */
      getErrorResponse(error) {
        if (!error) {
          return {};
        }
        const { response } = error;
        if (!response) {
          return {};
        }
        if (response.status === 401) {
          return response;
        }
        return response.data;
      }
    }
    /* harmony default export */ const uploads_MultiputUpload = MultiputUpload; // CONCATENATED MODULE: ./src/api/uploads/PlainUpload.js
    function PlainUpload_defineProperty(e, r, t) {
      return (
        (r = PlainUpload_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function PlainUpload_toPropertyKey(t) {
      var i = PlainUpload_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function PlainUpload_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the plain Box Upload API
     * @author Box
     */

    const CONTENT_MD5_HEADER = 'Content-MD5';
    class PlainUpload extends uploads_BaseUpload {
      constructor(...args) {
        super(...args);
        /**
         * Handles an upload success response
         *
         * @param {Object} data - Upload success data
         * @return {void}
         */
        PlainUpload_defineProperty(this, 'uploadSuccessHandler', ({ data }) => {
          const { entries } = data;
          if (this.isDestroyed()) {
            return;
          }
          if (typeof this.successCallback === 'function') {
            // Response entries are the successfully created Box File objects
            this.successCallback(entries);
          }
        });
        /**
         * Handles an upload progress event
         *
         * @param {Object} event - Progress event
         * @return {void}
         */
        PlainUpload_defineProperty(this, 'uploadProgressHandler', event => {
          if (this.isDestroyed()) {
            return;
          }
          if (typeof this.progressCallback === 'function') {
            this.progressCallback(event);
          }
        });
        /**
         * Uploads a file. If a file ID is supplied, use the Upload File
         * Version API to replace the file.
         *
         * @param {Object} - Request options
         * @param {boolean} [options.url] - Upload URL to use
         * @return {Promise} Async function promise
         */
        PlainUpload_defineProperty(this, 'preflightSuccessHandler', async ({ data }) => {
          if (this.isDestroyed()) {
            return;
          }

          // Use provided upload URL if passed in, otherwise construct
          let uploadUrl = data.upload_url;
          if (!uploadUrl) {
            uploadUrl = `${this.getBaseUploadUrl()}/files/content`;
            if (this.fileId) {
              uploadUrl = uploadUrl.replace('content', `${this.fileId}/content`);
            }
          }
          const attributes = JSON.stringify({
            name: this.fileName,
            parent: {
              id: this.folderId,
            },
            description: this.fileDescription,
            content_modified_at: getFileLastModifiedAsISONoMSIfPossible(this.file),
          });
          const options = {
            url: uploadUrl,
            data: {
              attributes,
              file: this.file,
            },
            headers: {},
            successHandler: this.uploadSuccessHandler,
            errorHandler: this.preflightErrorHandler,
            progressHandler: this.uploadProgressHandler,
          };

          // Calculate SHA1 for file consistency check
          const sha1 = await this.computeSHA1(this.file);
          if (sha1) {
            options.headers = {
              [CONTENT_MD5_HEADER]: sha1,
            };
          }
          this.xhr.uploadFile(options);
        });
      }
      /**
       * Uploads a file. If there is a conflict and overwrite is true, replace the file.
       * Otherwise, re-upload with a different name.
       *
       * @param {Object} options - Upload options
       * @param {string} options.folderId - untyped folder id
       * @param {string} [options.fileId] - Untyped file id (e.g. no "file_" prefix)
       * @param {File} options.file - File blob object
       * @param {Function} [options.successCallback] - Function to call with response
       * @param {Function} [options.errorCallback] - Function to call with errors
       * @param {Function} [options.progressCallback] - Function to call with progress
       * @param {Function} [options.conflictCallback] - Function to call on conflicting file names
       * @param {boolean} [overwrite] - Should upload overwrite file with same name
       * @return {void}
       */
      upload({
        folderId,
        fileId,
        file,
        fileDescription,
        successCallback = noop_default(),
        errorCallback = noop_default(),
        progressCallback = noop_default(),
        conflictCallback,
        overwrite = true,
      }) {
        if (this.isDestroyed()) {
          return;
        }

        // Save references
        this.folderId = folderId;
        this.fileId = fileId;
        this.file = file;
        this.fileDescription = fileDescription;
        this.fileName = this.file.name;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        this.progressCallback = progressCallback;
        this.overwrite = overwrite;
        this.conflictCallback = conflictCallback;
        this.makePreflightRequest();
      }

      /**
       * Cancels upload of a file.
       *
       * @return {void}
       */
      cancel() {
        if (this.isDestroyed()) {
          return;
        }
        clearTimeout(this.retryTimeout);
        this.destroy();
      }

      /**
       * Calculates SHA1 of a file
       *
       * @param {File} file
       * @return {Promise} Promise that resolves with SHA1 digest
       */
      async computeSHA1(file) {
        let sha1 = '';
        try {
          // Adapted from https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
          const reader = new window.FileReader();
          const { buffer } = await this.readFile(reader, file);
          const hashBuffer = await digest('SHA-1', buffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          sha1 = hashArray.map(b => `00${b.toString(16)}`.slice(-2)).join('');
        } catch (e) {
          // Return empty sha1 if hashing fails
        }
        return sha1;
      }
    }
    /* harmony default export */ const uploads_PlainUpload = PlainUpload; // CONCATENATED MODULE: ./src/api/Search.js
    function Search_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Search_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Search_ownKeys(Object(t), !0).forEach(function (r) {
              Search_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Search_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Search_defineProperty(e, r, t) {
      return (
        (r = Search_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Search_toPropertyKey(t) {
      var i = Search_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Search_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box search api
     * @author Box
     */

    class Search extends api_Base {
      constructor(...args) {
        super(...args);
        /**
         * Handles the folder search response
         *
         * @param {Object} response
         * @return {void}
         */
        Search_defineProperty(this, 'searchSuccessHandler', ({ data }) => {
          if (this.isDestroyed()) {
            return;
          }
          const { entries, total_count, limit, offset } = data;
          if (
            !Array.isArray(entries) ||
            typeof total_count !== 'number' ||
            typeof limit !== 'number' ||
            typeof offset !== 'number'
          ) {
            throw error_getBadItemError();
          }
          const flattened = flatten(
            entries,
            new api_Folder(this.options),
            new api_File(this.options),
            new api_WebLink(this.options),
          );
          this.itemCache = (this.itemCache || []).concat(flattened);
          this.getCache().set(this.key, {
            item_collection: Search_objectSpread(
              Search_objectSpread({}, data),
              {},
              {
                entries: this.itemCache,
              },
            ),
          });
          this.finish();
        });
        /**
         * Handles the search error
         *
         * @param {Error} error fetch error
         * @return {void}
         */
        Search_defineProperty(this, 'searchErrorHandler', error => {
          if (this.isDestroyed()) {
            return;
          }
          this.errorCallback(error, this.errorCode);
        });
      }
      /**
       * @property {number}
       */

      /**
       * @property {number}
       */

      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Array}
       */

      /**
       * Creates a key for the cache
       *
       * @param {string} id folder id
       * @param {string} query search string
       * @return {string} key
       */
      getEncodedQuery(query) {
        return encodeURIComponent(query);
      }

      /**
       * Creates a key for the cache
       *
       * @param {string} id folder id
       * @param {string} query search string
       * @return {string} key
       */
      getCacheKey(id, query) {
        return `${CACHE_PREFIX_SEARCH}${id}|${query}`;
      }

      /**
       * URL for search api
       *
       * @param {string} [id] optional file id
       * @return {string} base url for files
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/search`;
      }

      /**
       * Tells if a search results has its items all loaded
       *
       * @return {boolean} if items are loaded
       */
      isLoaded() {
        const cache = this.getCache();
        return cache.has(this.key);
      }

      /**
       * Returns the results
       *
       * @return {void}
       */
      finish() {
        if (this.isDestroyed()) {
          return;
        }
        const cache = this.getCache();
        const search = cache.get(this.key);
        const { item_collection } = search;
        if (!item_collection) {
          throw error_getBadItemError();
        }
        const { entries, total_count } = item_collection;
        if (!Array.isArray(entries) || typeof total_count !== 'number') {
          throw error_getBadItemError();
        }
        const collection = {
          id: this.id,
          items: entries.map(key => cache.get(key)),
          offset: this.offset,
          percentLoaded: 100,
          sortBy: FIELD_RELEVANCE,
          // Results are always sorted by relevance
          sortDirection: constants_SORT_DESC,
          // Results are always sorted descending
          totalCount: total_count,
        };
        this.successCallback(collection);
      }
      /**
       * Does the network request
       *
       * @param {RequestOptions} options - options for request
       * @return {void}
       */
      searchRequest(options = {}) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        const { fields } = options;
        const requestFields = fields || FOLDER_FIELDS_TO_FETCH;
        this.errorCode = ERROR_CODE_SEARCH;
        return this.xhr
          .get({
            url: this.getUrl(),
            params: {
              offset: this.offset,
              query: this.query,
              ancestor_folder_ids: this.id,
              limit: this.limit,
              fields: requestFields.toString(),
            },
            headers: requestFields.includes(FIELD_REPRESENTATIONS)
              ? {
                  'X-Rep-Hints': X_REP_HINT_HEADER_DIMENSIONS_DEFAULT,
                }
              : {},
          })
          .then(this.searchSuccessHandler)
          .catch(this.searchErrorHandler);
      }

      /**
       * Gets search results
       *
       * @param {string} id - folder id
       * @param {string} query - search string
       * @param {number} limit - maximum number of items to retrieve
       * @param {number} offset - starting index from which to retrieve items
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {boolean|void} [options.forceFetch] - Bypasses the cache
       * @return {void}
       */
      search(id, query, limit, offset, successCallback, errorCallback, options = {}) {
        if (this.isDestroyed()) {
          return;
        }

        // Save references
        this.limit = limit;
        this.offset = offset;
        this.query = query;
        this.id = id;
        this.key = this.getCacheKey(id, this.getEncodedQuery(this.query));
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // Clear the cache if needed
        if (options.forceFetch) {
          this.getCache().unset(this.key);
        }

        // Return the Cache value if it exists
        if (this.isLoaded()) {
          this.finish();
          return;
        }

        // Make the XHR request
        this.searchRequest(options);
      }
    }
    /* harmony default export */ const api_Search = Search; // CONCATENATED MODULE: ./src/api/Recents.js
    function Recents_extends() {
      return (
        (Recents_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Recents_extends.apply(null, arguments)
      );
    }
    function Recents_defineProperty(e, r, t) {
      return (
        (r = Recents_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Recents_toPropertyKey(t) {
      var i = Recents_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Recents_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box recents api
     * @author Box
     */

    class Recents extends api_Base {
      constructor(...args) {
        super(...args);
        /**
         * Handles the folder Recents response
         *
         * @param {Object} response
         * @return {void}
         */
        Recents_defineProperty(this, 'recentsSuccessHandler', ({ data }) => {
          if (this.isDestroyed()) {
            return;
          }
          const {
            entries,
            order: { by, direction },
          } = data;
          const items = [];
          entries.forEach(({ item, interacted_at }) => {
            const { path_collection } = item;
            const shouldInclude =
              this.id === DEFAULT_ROOT ||
              (!!path_collection && path_collection.entries.findIndex(crumb => crumb.id === this.id) !== -1);
            if (shouldInclude) {
              items.push(
                Recents_extends(item, {
                  interacted_at,
                }),
              );
            }
          });
          const flattenedItems = flatten(
            items,
            new api_Folder(this.options),
            new api_File(this.options),
            new api_WebLink(this.options),
          );
          this.getCache().set(this.key, {
            item_collection: {
              entries: flattenedItems,
              order: [
                {
                  by,
                  direction,
                },
              ],
            },
          });
          this.finish();
        });
        /**
         * Handles the Recents error
         *
         * @param {Error} error fetch error
         * @return {void}
         */
        Recents_defineProperty(this, 'recentsErrorHandler', error => {
          if (this.isDestroyed()) {
            return;
          }
          this.errorCallback(error, this.errorCode);
        });
      }
      /**
       * @property {string}
       */

      /**
       * @property {string}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * Creates a key for the cache
       *
       * @param {string} id folder id
       * @return {string} key
       */
      getCacheKey(id) {
        return `${CACHE_PREFIX_RECENTS}${id}`;
      }

      /**
       * URL for recents api
       *
       * @return {string} base url for files
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/recent_items`;
      }

      /**
       * Returns the results
       *
       * @return {void}
       */
      finish() {
        if (this.isDestroyed()) {
          return;
        }
        const cache = this.getCache();
        const recents = cache.get(this.key);
        const { item_collection } = recents;
        if (!item_collection) {
          throw error_getBadItemError();
        }
        const { entries } = item_collection;
        if (!Array.isArray(entries)) {
          throw error_getBadItemError();
        }
        const collection = {
          id: this.id,
          items: entries.map(key => cache.get(key)),
          percentLoaded: 100,
          sortBy: FIELD_DATE,
          // Results are always sorted by date
          sortDirection: constants_SORT_DESC, // Results are always sorted descending
        };
        this.successCallback(collection);
      }
      /**
       * Does the network request
       *
       * @param {RequestOptions} options - options for request
       * @return {Promise}
       */
      recentsRequest(options = {}) {
        if (this.isDestroyed()) {
          return Promise.reject();
        }
        const { fields } = options;
        const requestFields = fields || FOLDER_FIELDS_TO_FETCH;
        this.errorCode = ERROR_CODE_FETCH_RECENTS;
        return this.xhr
          .get({
            url: this.getUrl(),
            params: {
              fields: requestFields.toString(),
            },
            headers: requestFields.includes(FIELD_REPRESENTATIONS)
              ? {
                  'X-Rep-Hints': X_REP_HINT_HEADER_DIMENSIONS_DEFAULT,
                }
              : {},
          })
          .then(this.recentsSuccessHandler)
          .catch(this.recentsErrorHandler);
      }

      /**
       * Gets recent files
       *
       * @param {string} id - parent folder id
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {boolean|void} [options.forceFetch] - Bypasses the cache
       * @return {void}
       */
      recents(id, successCallback, errorCallback, options = {}) {
        if (this.isDestroyed()) {
          return;
        }

        // Save references
        this.id = id;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        const cache = this.getCache();
        this.key = this.getCacheKey(this.id);

        // Clear the cache if needed
        if (options.forceFetch) {
          cache.unset(this.key);
        }

        // Return the Cache value if it exists
        if (cache.has(this.key)) {
          this.finish();
          return;
        }

        // Make the XHR request
        this.recentsRequest(options);
      }
    }
    /* harmony default export */ const api_Recents = Recents; // CONCATENATED MODULE: ./src/api/OffsetBasedAPI.js
    function OffsetBasedAPI_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function OffsetBasedAPI_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? OffsetBasedAPI_ownKeys(Object(t), !0).forEach(function (r) {
              OffsetBasedAPI_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : OffsetBasedAPI_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function OffsetBasedAPI_defineProperty(e, r, t) {
      return (
        (r = OffsetBasedAPI_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function OffsetBasedAPI_toPropertyKey(t) {
      var i = OffsetBasedAPI_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function OffsetBasedAPI_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file class for Box offset based API's to inherit common functionality from
     * @author Box
     */

    class OffsetBasedApi extends api_Base {
      /**
       * @property {Data}
       */

      /**
       * Gets query params for the API
       *
       * @param {number} offset the offset from the start to start fetching at
       * @param {number} limit the number of items to fetch
       * @param {array} fields the fields to fetch
       * @return the query params object
       */
      getQueryParameters(offset, limit, fields) {
        const queryParams = {
          offset,
          limit,
        };
        if (fields && fields.length > 0) {
          queryParams.fields = fields.toString();
        }
        return queryParams;
      }

      /**
       * Determines if the API has more items to fetch
       *
       * @param {number} offset the offset from the start to start fetching at
       * @param {number} totalCount the total number of items
       * @return {boolean} true if there are more items
       */
      hasMoreItems(offset, totalCount) {
        return totalCount === undefined || offset < totalCount;
      }

      /**
       * Helper for get
       *
       * @param {string} id the file id
       * @param {number} offset the offset from the start to start fetching at
       * @param {number} limit the number of items to fetch
       * @param {array} fields the fields to fetch
       * @param {boolean} shouldFetchAll true if should get all the pages before calling the sucessCallback
       * @private
       */
      async offsetGetRequest(id, offset, limit, shouldFetchAll, fields) {
        if (this.isDestroyed()) {
          return;
        }

        // Make the XHR request
        try {
          const params = this.getQueryParameters(offset, limit, fields);
          const url = this.getUrl(id);
          const { data } = await this.xhr.get({
            url,
            id: getTypedFileId(id),
            params,
          });
          const entries = this.data ? this.data.entries : [];
          this.data = OffsetBasedAPI_objectSpread(
            OffsetBasedAPI_objectSpread({}, data),
            {},
            {
              entries: entries.concat(data.entries),
            },
          );
          const totalCount = data.total_count;
          const nextOffset = offset + limit;
          if (shouldFetchAll && this.hasMoreItems(nextOffset, totalCount)) {
            this.offsetGetRequest(id, nextOffset, limit, shouldFetchAll, fields);
            return;
          }
          this.successHandler(this.data);
        } catch (error) {
          this.errorHandler(error);
        }
      }

      /**
       * Offset based API get
       *
       * @param {string} id the file id
       * @param {Function} successCallback the success callback
       * @param {Function} errorCallback the error callback
       * @param {number} offset the offset from the start to start fetching at
       * @param {number} limit the number of items to fetch
       * @param {array} fields the fields to fetch
       * @param {boolean} shouldFetchAll true if should get all the pages before calling the sucessCallback
       */
      async offsetGet(
        id,
        successCallback,
        errorCallback,
        offset = DEFAULT_FETCH_START,
        limit = DEFAULT_FETCH_END,
        fields,
        shouldFetchAll = true,
      ) {
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        return this.offsetGetRequest(id, offset, limit, shouldFetchAll, fields);
      }
    }
    /* harmony default export */ const OffsetBasedAPI = OffsetBasedApi; // CONCATENATED MODULE: ./src/api/Versions.js
    const Versions_excluded = ['permissions'];
    function Versions_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Versions_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Versions_ownKeys(Object(t), !0).forEach(function (r) {
              Versions_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Versions_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Versions_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Versions_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Versions_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function Versions_defineProperty(e, r, t) {
      return (
        (r = Versions_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Versions_toPropertyKey(t) {
      var i = Versions_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Versions_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box versions API
     * @author Box
     */

    class Versions extends OffsetBasedAPI {
      constructor(...args) {
        super(...args);
        /**
         * Returns the versions api response data
         * @param {Object} data the api response data
         */
        Versions_defineProperty(this, 'successHandler', data => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }
          this.successCallback(data);
        });
      }
      /**
       * API URL for file versions
       *
       * @param {string} id - a box file id
       * @return {string} base url for file versions
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing file id!');
        }
        return `${this.getBaseApiUrl()}/files/${id}/versions`;
      }

      /**
       * API URL for version info endpoint
       *
       * @param {string} id - a box file id
       * @param {string} versionId - a box file version id
       * @return {string} url for version info
       */
      getVersionUrl(id, versionId) {
        if (!versionId) {
          throw new Error('Missing version id!');
        }
        return `${this.getUrl(id)}/${versionId}`;
      }
      /**
       * Helper to add associated permissions from the file to the version objects
       *
       * @param {FileVersions} versions - API returned file versions for this file
       * @param {BoxItem} file - The parent file object
       * @return {FileVersions} modified versions array including associated file permissions
       */
      addPermissions(versions, file) {
        if (!versions) {
          return versions;
        }

        // Versions defer to the parent file for upload (promote) permissions
        const { entries, total_count } = versions;
        const can_upload = get_default()(file, ['permissions', PERMISSION_CAN_UPLOAD], false);
        return {
          entries: entries.map(_ref => {
            let { permissions } = _ref,
              version = Versions_objectWithoutProperties(_ref, Versions_excluded);
            return Versions_objectSpread(
              Versions_objectSpread({}, version),
              {},
              {
                permissions: Versions_objectSpread(
                  {
                    can_upload,
                  },
                  permissions,
                ),
              },
            );
          }),
          total_count,
        };
      }

      /**
       * API for deleting a version of a file
       *
       * @param {Object} options - the request options
       * @param {string} options.fileId - a box file id
       * @param {string} options.versionId - a box file version id
       * @param {BoxItemVersionPermission} options.permissions - the permissions for the file
       * @param {Function} options.successCallback - the success callback
       * @param {Function} options.errorCallback - the error callback
       * @returns {void}
       */
      deleteVersion({ errorCallback, fileId, permissions, successCallback, versionId }) {
        this.errorCode = ERROR_CODE_DELETE_VERSION;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_DELETE, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.delete({
          id: fileId,
          url: this.getVersionUrl(fileId, versionId),
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for fetching versions on a file
       *
       * @param {string} fileId - a box file id
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @param {number} offset - the offset of the starting version index
       * @param {number} limit - the max number of versions to fetch
       * @param {Array} fields - the fields to fetch
       * @param {boolean} shouldFetchAll - true if all versions should be fetched
       * @returns {void}
       */
      getVersions(
        fileId,
        successCallback,
        errorCallback,
        offset = DEFAULT_FETCH_START,
        limit = DEFAULT_FETCH_END,
        fields = FILE_VERSIONS_FIELDS_TO_FETCH,
        shouldFetchAll = true,
      ) {
        this.errorCode = ERROR_CODE_FETCH_VERSIONS;
        this.offsetGet(fileId, successCallback, errorCallback, offset, limit, fields, shouldFetchAll);
      }

      /**
       * API for fetching a certain version for a file
       *
       * @param {string} fileId - a box file id
       * @param {string} fileVersionId - a box file version id
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @returns {void}
       */
      getVersion(fileId, fileVersionId, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_FETCH_VERSION;
        this.get({
          id: fileId,
          successCallback,
          errorCallback,
          url: this.getVersionUrl(fileId, fileVersionId),
          requestData: {
            params: {
              fields: FILE_VERSIONS_FIELDS_TO_FETCH.toString(),
            },
          },
        });
      }

      /**
       * Decorates the current version and adds it to an existing FileVersions object
       *
       * @param {BoxItemVersion} currentVersion - a box version
       * @param {FileVersions} versions - versions response
       * @param {BoxItem} file - a box file
       * @returns {FileVersions} - a FileVersions object containing the decorated current version
       */
      addCurrentVersion(currentVersion, versions, file) {
        if (!currentVersion) {
          return (
            versions || {
              entries: [],
              total_count: 0,
            }
          );
        }
        if (!versions) {
          return {
            entries: [currentVersion],
            total_count: 1,
          };
        }
        const promotedFromId = get_default()(file, 'restored_from.id');
        const promotedVersion = versions.entries.find(version => version.id === promotedFromId);
        if (promotedVersion) {
          currentVersion.version_promoted = promotedVersion.version_number;
        }
        return {
          entries: [...versions.entries, currentVersion],
          total_count: versions.total_count + 1,
        };
      }

      /**
       * API for promoting a version of a file to current
       *
       * @param {Object} options - the request options
       * @param {string} options.fileId - a box file id
       * @param {string} options.versionId - a box file version id
       * @param {BoxItemVersionPermission} options.permissions - the permissions for the file
       * @param {Function} options.successCallback - the success callback
       * @param {Function} options.errorCallback - the error callback
       * @returns {void}
       */
      promoteVersion({ errorCallback, fileId, permissions, successCallback, versionId }) {
        this.errorCode = ERROR_CODE_PROMOTE_VERSION;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_UPLOAD, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.post({
          id: fileId,
          data: {
            data: {
              id: versionId,
              type: 'file_version',
            },
          },
          url: this.getVersionUrl(fileId, 'current'),
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for restoring a deleted version of a file
       *
       * @param {Object} options - the request options
       * @param {string} options.fileId - a box file id
       * @param {string} options.versionId - a box file version id
       * @param {BoxItemVersionPermission} options.permissions - the permissions for the file
       * @param {Function} options.successCallback - the success callback
       * @param {Function} options.errorCallback - the error callback
       * @returns {void}
       */
      restoreVersion({ errorCallback, fileId, permissions, successCallback, versionId }) {
        this.errorCode = ERROR_CODE_RESTORE_VERSION;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_DELETE, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.put({
          id: fileId,
          data: {
            data: {
              trashed_at: null,
            },
          },
          url: this.getVersionUrl(fileId, versionId),
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const api_Versions = Versions; // CONCATENATED MODULE: ./src/api/Comments.js
    function Comments_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Comments_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Comments_ownKeys(Object(t), !0).forEach(function (r) {
              Comments_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Comments_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Comments_defineProperty(e, r, t) {
      return (
        (r = Comments_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Comments_toPropertyKey(t) {
      var i = Comments_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Comments_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box comments API
     * @author Box
     */

    class Comments extends OffsetBasedAPI {
      constructor(...args) {
        super(...args);
        /**
         * Formats the comments api response to usable data
         * @param {Object} data the api response data
         */
        Comments_defineProperty(this, 'successHandler', data => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }

          // There is no response data when deleting a comment
          if (!data) {
            this.successCallback();
            return;
          }

          // We don't have entries when updating/creating a comment
          if (!data.entries) {
            this.successCallback(this.format(data));
            return;
          }
          const comments = data.entries.map(this.format);
          this.successCallback(
            Comments_objectSpread(
              Comments_objectSpread({}, data),
              {},
              {
                entries: comments,
              },
            ),
          );
        });
      }
      /**
       * API URL for comments on a file
       *
       * @param {string} id - A box file id
       * @return {string} base url for files
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing file id!');
        }
        return `${this.getBaseApiUrl()}/files/${id}/comments`;
      }

      /**
       * API URL for comments endpoint
       *
       * @param {string} [id] - A box comment id
       * @return {string} base url for comments
       */
      commentsUrl(id) {
        const baseUrl = `${this.getBaseApiUrl()}/comments`;
        return id ? `${baseUrl}/${id}` : baseUrl;
      }

      /**
       * Formats comment data for use in components.
       *
       * @param {string} [id] - An individual comment entry from the API
       * @return {Task} A task
       */
      format(comment) {
        return Comments_objectSpread(
          Comments_objectSpread({}, comment),
          {},
          {
            tagged_message: comment.tagged_message !== '' ? comment.tagged_message : comment.message,
          },
        );
      }
      /**
       * API for creating a comment on a file
       *
       * @param {BoxItem} file - File object for which we are creating a comment
       * @param {string} message - Comment message
       * @param {string} taggedMessage - Comment message with @mentions
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      createComment({ file, message, taggedMessage, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_CREATE_COMMENT;
        const { id = '', permissions } = file;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, id);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        const requestData = {
          data: {
            item: {
              id,
              type: 'file',
            },
            message,
            tagged_message: taggedMessage,
          },
          params: {
            fields: COMMENTS_FIELDS_TO_FETCH.toString(),
          },
        };
        this.post({
          id,
          url: this.commentsUrl(),
          data: requestData,
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for updating a comment on a file
       *
       * @param {BoxItem} file - File object for which we are updating a comment
       * @param {string} commentId - Comment to be edited
       * @param {string} message - Comment message
       * @param {BoxCommentPermission} permissions - The known permissions of the comment we're updating
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      updateComment({ file, commentId, message, tagged_message, permissions, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_UPDATE_COMMENT;
        const { id = '' } = file;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_EDIT, permissions, id);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        const requestData = {
          data: {
            message,
            tagged_message,
          },
        };
        this.put({
          id,
          url: this.commentsUrl(commentId),
          data: requestData,
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for deleting a comment on a file
       *
       * @param {BoxItem} file - File object for which we are deleting a comment
       * @param {string} commentId - Id of the comment we are deleting
       * @param {BoxCommentPermission} permissions - The known permissions of the comment we're deleting
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      deleteComment({ file, commentId, permissions, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_DELETE_COMMENT;
        const { id = '' } = file;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_DELETE, permissions, id);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.delete({
          id,
          url: this.commentsUrl(commentId),
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for fetching comments on a file
       *
       * @param {string} fileId - the file id
       * @param {BoxItemPermission} permissions - the permissions for the file
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @param {array} fields - the fields to fetch
       * @param {number} offset - the offset from the start to start fetching at
       * @param {number} limit - the number of items to fetch
       * @param {boolean} shouldFetchAll - true if should get all the pages before calling the sucessCallback
       * @returns {void}
       */
      getComments(
        fileId,
        permissions,
        successCallback,
        errorCallback,
        fields = COMMENTS_FIELDS_TO_FETCH,
        offset,
        limit,
        shouldFetchAll,
      ) {
        this.errorCode = ERROR_CODE_FETCH_COMMENTS;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.offsetGet(fileId, successCallback, errorCallback, offset, limit, fields, shouldFetchAll);
      }
    }
    /* harmony default export */ const api_Comments = Comments; // CONCATENATED MODULE: ./src/api/tasks/TasksBase.js
    const TasksBase_excluded = ['retryableStatusCodes'];
    function TasksBase_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function TasksBase_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? TasksBase_ownKeys(Object(t), !0).forEach(function (r) {
              TasksBase_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : TasksBase_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function TasksBase_defineProperty(e, r, t) {
      return (
        (r = TasksBase_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function TasksBase_toPropertyKey(t) {
      var i = TasksBase_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function TasksBase_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    function TasksBase_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = TasksBase_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function TasksBase_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    /**
     *
     * @file Base class for Tasks APIs
     * @author Box
     */

    const RETRYABLE = [
      HTTP_STATUS_CODE_RATE_LIMIT,
      HTTP_STATUS_CODE_INTERNAL_SERVER_ERROR,
      HTTP_STATUS_CODE_NOT_IMPLEMENTED,
      HTTP_STATUS_CODE_BAD_GATEWAY,
      HTTP_STATUS_CODE_SERVICE_UNAVAILABLE,
      HTTP_STATUS_CODE_GATEWAY_TIMEOUT,
    ];
    class TasksBase extends api_Base {
      constructor(_ref) {
        let { retryableStatusCodes = RETRYABLE } = _ref,
          options = TasksBase_objectWithoutProperties(_ref, TasksBase_excluded);
        super(
          TasksBase_objectSpread(
            TasksBase_objectSpread({}, options),
            {},
            {
              retryableStatusCodes,
            },
          ),
        );
      }
    }
    /* harmony default export */ const tasks_TasksBase = TasksBase; // CONCATENATED MODULE: ./src/api/tasks/TasksNew.js
    const TasksNew_excluded = ['id', 'addedAssignees', 'removedAssignees'];
    function TasksNew_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function TasksNew_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? TasksNew_ownKeys(Object(t), !0).forEach(function (r) {
              TasksNew_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : TasksNew_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function TasksNew_defineProperty(e, r, t) {
      return (
        (r = TasksNew_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function TasksNew_toPropertyKey(t) {
      var i = TasksNew_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function TasksNew_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    function TasksNew_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = TasksNew_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function TasksNew_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    /**
     *
     * @file Helper for the box Tasks API
     * @author Box
     */

    class TasksNew extends tasks_TasksBase {
      getUrlForFileTasks(id) {
        return `${this.getBaseApiUrl()}/undoc/files/${id}/linked_tasks?limit=${API_PAGE_LIMIT}`;
      }
      getUrlForTaskCreateWithDeps() {
        return `${this.getBaseApiUrl()}/undoc/tasks/with_dependencies`;
      }
      getUrlForTask(id) {
        return `${this.getBaseApiUrl()}/undoc/tasks/${id}`;
      }
      getUrlForTaskWithDeps(id) {
        return `${this.getBaseApiUrl()}/undoc/tasks/${id}/with_dependencies`;
      }
      updateTaskWithDeps({ errorCallback, file, successCallback, task }) {
        this.errorCode = ERROR_CODE_UPDATE_TASK;
        const createTaskCollabsPayload = task.addedAssignees.map(assignee => {
          return {
            op:
              assignee.item && assignee.item.type === 'group'
                ? 'add_task_collaborators_expand_group'
                : 'add_task_collaborator',
            payload: {
              target: {
                type: assignee.item && assignee.item.type === 'group' ? 'group' : 'user',
                id: assignee.id,
              },
            },
          };
        });
        const deleteTaskCollabsPayload = task.removedAssignees.map(assignee => {
          return {
            op: 'delete_task_collaborator',
            id: assignee.id,
          };
        });
        const { id, addedAssignees, removedAssignees } = task,
          updateTaskPayload = TasksNew_objectWithoutProperties(task, TasksNew_excluded);
        this.put({
          id: file.id,
          url: this.getUrlForTaskWithDeps(task.id),
          data: {
            data: [
              {
                op: 'update_task',
                payload: TasksNew_objectSpread({}, updateTaskPayload),
              },
              ...createTaskCollabsPayload,
              ...deleteTaskCollabsPayload,
            ],
          },
          successCallback,
          errorCallback,
        });
      }
      deleteTask({ errorCallback, file, successCallback, task }) {
        this.errorCode = ERROR_CODE_DELETE_TASK;
        this.delete({
          id: file.id,
          url: this.getUrlForTask(task.id),
          successCallback,
          errorCallback,
        });
      }
      getTasksForFile({ errorCallback, file, successCallback }) {
        this.errorCode = ERROR_CODE_FETCH_TASKS;
        this.get({
          id: file.id,
          url: this.getUrlForFileTasks(file.id),
          successCallback,
          errorCallback,
        });
      }
      getTask({ errorCallback, file, id, successCallback }) {
        this.errorCode = ERROR_CODE_FETCH_TASKS;
        this.get({
          id: file.id,
          url: this.getUrlForTask(id),
          successCallback,
          errorCallback,
        });
      }
      createTaskWithDeps({ errorCallback, file, successCallback, task, assignees }) {
        this.errorCode = ERROR_CODE_CREATE_TASK;
        const createTaskCollabsPayload = assignees.map(assignee => {
          return {
            target: {
              type: assignee.item && assignee.item.type === 'group' ? 'group' : 'user',
              id: assignee.id,
            },
          };
        });
        const createTaskLinksPayload = [
          {
            target: {
              id: file.id,
              type: 'file',
            },
          },
        ];
        const createTaskWithDepsPayload = {
          task: TasksNew_objectSpread({}, task),
          assigned_to: createTaskCollabsPayload,
          task_links: createTaskLinksPayload,
        };
        this.post({
          id: file.id,
          url: this.getUrlForTaskCreateWithDeps(),
          data: {
            data: TasksNew_objectSpread({}, createTaskWithDepsPayload),
          },
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const tasks_TasksNew = TasksNew; // CONCATENATED MODULE: ./src/api/tasks/TaskCollaborators.js
    function TaskCollaborators_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function TaskCollaborators_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? TaskCollaborators_ownKeys(Object(t), !0).forEach(function (r) {
              TaskCollaborators_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : TaskCollaborators_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function TaskCollaborators_defineProperty(e, r, t) {
      return (
        (r = TaskCollaborators_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function TaskCollaborators_toPropertyKey(t) {
      var i = TaskCollaborators_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function TaskCollaborators_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box Task Collaborators API
     * @author Box
     */

    class TaskCollaborators extends tasks_TasksBase {
      getUrlForTaskCollaborators(taskId) {
        return `${this.getBaseApiUrl()}/undoc/tasks/${taskId}/task_collaborators?role=ASSIGNEE&limit=${API_PAGE_LIMIT}`;
      }
      getUrlForTaskCollaboratorCreate() {
        return `${this.getBaseApiUrl()}/undoc/task_collaborators`;
      }
      getUrlForTaskCollaborator(id) {
        return `${this.getBaseApiUrl()}/undoc/task_collaborators/${id}`;
      }
      getUrlForTaskGroupCreate() {
        return `${this.getBaseApiUrl()}/undoc/task_collaborators/expand_group`;
      }
      createTaskCollaborator({ errorCallback, file, successCallback, task, user }) {
        this.errorCode = ERROR_CODE_CREATE_TASK_COLLABORATOR;
        const requestData = {
          data: {
            task: {
              type: 'task',
              id: task.id,
            },
            target: {
              type: 'user',
              id: user.id,
            },
          },
        };
        this.post({
          id: file.id,
          url: this.getUrlForTaskCollaboratorCreate(),
          data: TaskCollaborators_objectSpread({}, requestData),
          successCallback,
          errorCallback,
        });
      }
      createTaskCollaboratorsforGroup({ errorCallback, file, successCallback, task, group }) {
        this.errorCode = ERROR_CODE_CREATE_TASK_COLLABORATOR;
        const requestData = {
          data: {
            task: {
              type: 'task',
              id: task.id,
            },
            target: {
              type: 'group',
              id: group.id,
            },
          },
        };
        this.post({
          id: file.id,
          url: this.getUrlForTaskGroupCreate(),
          data: TaskCollaborators_objectSpread({}, requestData),
          successCallback,
          errorCallback,
        });
      }
      getTaskCollaborators({ errorCallback, file, successCallback, task }) {
        this.errorCode = ERROR_CODE_FETCH_TASK_COLLABORATOR;
        const url = this.getUrlForTaskCollaborators(task.id);
        this.get({
          id: file.id,
          successCallback,
          errorCallback,
          url,
        });
      }
      updateTaskCollaborator({ errorCallback, file, successCallback, taskCollaborator }) {
        this.errorCode = ERROR_CODE_UPDATE_TASK_COLLABORATOR;
        const requestData = {
          data: omit_default()(taskCollaborator, 'id'),
        };
        this.put({
          id: file.id,
          url: this.getUrlForTaskCollaborator(taskCollaborator.id),
          data: TaskCollaborators_objectSpread({}, requestData),
          successCallback,
          errorCallback,
        });
      }
      deleteTaskCollaborator({ errorCallback, file, successCallback, taskCollaborator }) {
        this.errorCode = ERROR_CODE_DELETE_TASK_COLLABORATOR;
        this.delete({
          id: file.id,
          url: this.getUrlForTaskCollaborator(taskCollaborator.id),
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const tasks_TaskCollaborators = TaskCollaborators; // CONCATENATED MODULE: ./src/api/tasks/TaskLinks.js
    function TaskLinks_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function TaskLinks_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? TaskLinks_ownKeys(Object(t), !0).forEach(function (r) {
              TaskLinks_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : TaskLinks_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function TaskLinks_defineProperty(e, r, t) {
      return (
        (r = TaskLinks_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function TaskLinks_toPropertyKey(t) {
      var i = TaskLinks_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function TaskLinks_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box TaskLinks API
     * @author Box
     */

    class TaskLinks extends tasks_TasksBase {
      getUrlForTaskLinkCreate() {
        return `${this.getBaseApiUrl()}/undoc/task_links`;
      }
      createTaskLink({ errorCallback, file, successCallback, task }) {
        this.errorCode = ERROR_CODE_CREATE_TASK_LINK;
        const requestData = {
          data: {
            target: {
              id: file.id,
              type: 'file',
            },
            task: {
              id: task.id,
              type: 'task',
            },
          },
        };
        this.post({
          id: file.id,
          url: this.getUrlForTaskLinkCreate(),
          data: TaskLinks_objectSpread({}, requestData),
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const tasks_TaskLinks = TaskLinks; // CONCATENATED MODULE: ./src/api/MarkerBasedAPI.js
    function MarkerBasedAPI_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function MarkerBasedAPI_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? MarkerBasedAPI_ownKeys(Object(t), !0).forEach(function (r) {
              MarkerBasedAPI_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : MarkerBasedAPI_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function MarkerBasedAPI_defineProperty(e, r, t) {
      return (
        (r = MarkerBasedAPI_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MarkerBasedAPI_toPropertyKey(t) {
      var i = MarkerBasedAPI_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MarkerBasedAPI_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file class for Box marker based API's to inherit common functionality from
     * @author Box
     */

    class MarkerBasedApi extends api_Base {
      /**
       * @property {Data}
       */

      /**
       * Determines if the API has more items to fetch
       *
       * @param {string} marker the marker from the start to start fetching at
       * @return {boolean} true if there are more items
       */
      hasMoreItems(marker) {
        return marker !== null && marker !== '';
      }

      /**
       * Helper for get
       *
       * @param {string} id the file id
       * @param {string} marker the marker from the start to start fetching at
       * @param {number} limit the number of items to fetch
       * @param {Object} requestData the request query params
       * @param {boolean} shouldFetchAll true if should get all the pages before calling
       * @private
       */
      async markerGetRequest(id, marker, limit, shouldFetchAll, requestData = {}) {
        if (this.isDestroyed()) {
          return;
        }

        // Make the XHR request
        try {
          const url = this.getUrl(id);
          const queryParams = MarkerBasedAPI_objectSpread(
            MarkerBasedAPI_objectSpread({}, requestData),
            {},
            {
              marker,
              limit,
            },
          );
          const { data } = await this.xhr.get({
            url,
            id: getTypedFileId(id),
            params: queryParams,
          });
          const entries = this.data ? this.data.entries : [];
          this.data = MarkerBasedAPI_objectSpread(
            MarkerBasedAPI_objectSpread({}, data),
            {},
            {
              entries: entries.concat(data.entries),
            },
          );
          const nextMarker = data.next_marker;
          if (shouldFetchAll && this.hasMoreItems(nextMarker)) {
            this.markerGetRequest(id, nextMarker, limit, shouldFetchAll, requestData);
            return;
          }
          this.successHandler(this.data);
        } catch (error) {
          this.errorHandler(error);
        }
      }

      /**
       * Marker based API get
       * @param {Object} options
       * @param {string} options.id the file id
       * @param {Function} options.successCallback the success callback
       * @param {Function} options.errorCallback the error callback
       * @param {string} [options.marker] the marker from the start to start fetching at
       * @param {number} [options.limit] the number of items to fetch
       * @param {Object} options.requestData the request query params
       * @param {boolean} [options.shouldFetchAll] true if should get all the pages before calling the sucessCallback
       */
      async markerGet({
        id,
        successCallback,
        errorCallback,
        marker = '',
        limit = 1000,
        requestData,
        shouldFetchAll = true,
      }) {
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        return this.markerGetRequest(id, marker, limit, shouldFetchAll, requestData);
      }
    }
    /* harmony default export */ const MarkerBasedAPI = MarkerBasedApi; // CONCATENATED MODULE: ./src/api/utils.js
    function utils_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function utils_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? utils_ownKeys(Object(t), !0).forEach(function (r) {
              utils_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : utils_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function utils_defineProperty(e, r, t) {
      return (
        (r = utils_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function utils_toPropertyKey(t) {
      var i = utils_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function utils_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Utils for the box APIs
     * @author Box
     */

    /**
     * Formats comment data (including replies) for use in components.
     *
     * @param {Comment} comment - An individual comment entry from the API
     * @return {Comment} Updated comment
     */
    const formatComment = comment => {
      const formattedComment = utils_objectSpread(
        utils_objectSpread({}, comment),
        {},
        {
          tagged_message: comment.message,
        },
      );
      if (comment.replies && comment.replies.length) {
        formattedComment.replies = comment.replies.map(formatComment);
      }
      return formattedComment;
    };
    /* harmony default export */ const utils = {
      formatComment,
    }; // CONCATENATED MODULE: ./src/api/ThreadedComments.js
    function ThreadedComments_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function ThreadedComments_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? ThreadedComments_ownKeys(Object(t), !0).forEach(function (r) {
              ThreadedComments_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : ThreadedComments_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function ThreadedComments_defineProperty(e, r, t) {
      return (
        (r = ThreadedComments_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ThreadedComments_toPropertyKey(t) {
      var i = ThreadedComments_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ThreadedComments_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box threadedComments API
     * @author Box
     */

    class ThreadedComments extends MarkerBasedAPI {
      constructor(...args) {
        super(...args);
        /**
         * Formats the threaded comments api response to usable data
         * @param {Object} data the api response data
         */
        ThreadedComments_defineProperty(this, 'successHandler', data => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }

          // There is no response data when deleting a comment
          if (!data) {
            this.successCallback();
            return;
          }

          // We don't have entries when updating/creating a comment
          if (!data.entries) {
            this.successCallback(formatComment(data));
            return;
          }
          const comments = data.entries.map(formatComment);
          this.successCallback(
            ThreadedComments_objectSpread(
              ThreadedComments_objectSpread({}, data),
              {},
              {
                entries: comments,
              },
            ),
          );
        });
      }
      /**
       * API URL for comments
       *
       * @param {string} [fileId]
       * @return {string} base url for comments
       */
      getUrl(fileId) {
        return `${this.getBaseApiUrl()}/undoc/comments${fileId ? `?file_id=${fileId}` : ''}`;
      }

      /**
       * API URL for specific comment
       *
       * @param {string} [commentId]
       * @return {string} base url for specific comment
       */
      getUrlForId(commentId) {
        return `${this.getUrl()}/${commentId}`;
      }

      /**
       * API URL for specific comment
       *
       * @param {string} commentId
       * @param {string} [fileId]
       * @return {string}  base url for specific comment replies
       */
      getUrlWithRepliesForId(commentId, fileId) {
        return `${this.getUrlForId(commentId)}/replies${fileId ? `?file_id=${fileId}` : ''}`;
      }
      /**
       * API for creating a comment on a file
       *
       * @param {BoxItem} file - File object for which we are creating a comment
       * @param {string} message - Comment message
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      createComment({ file, message, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_CREATE_COMMENT;
        const { id, permissions } = file;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, id);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.post({
          id,
          url: this.getUrl(id),
          data: {
            data: {
              message,
            },
          },
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for updating a comment
       *
       * @param {string} fileId - File id for which we are updating a comment
       * @param {string} commentId - Comment to be edited
       * @param {FeedItemStatus} status - Comment status
       * @param {string} message - Comment message
       * @param {BoxCommentPermission} permissions - The known permissions of the comment we're updating
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      updateComment({ fileId, commentId, status, message, permissions, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_UPDATE_COMMENT;
        if (message) {
          try {
            this.checkApiCallValidity(PERMISSION_CAN_EDIT, permissions, fileId);
          } catch (e) {
            errorCallback(e, this.errorCode);
            return;
          }
        }
        if (status) {
          try {
            this.checkApiCallValidity(PERMISSION_CAN_RESOLVE, permissions, fileId);
          } catch (e) {
            errorCallback(e, this.errorCode);
            return;
          }
        }
        const requestData = {
          data: {
            status,
            message,
          },
        };
        this.put({
          id: fileId,
          url: this.getUrlForId(commentId),
          data: requestData,
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for deleting a comment or reply
       *
       * @param {string} fileId - Id of an object for which we are deleting a comment
       * @param {string} commentId - Id of the comment we are deleting
       * @param {BoxCommentPermission} permissions - The known permissions of the comment we're deleting
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      deleteComment({ fileId, commentId, permissions, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_DELETE_COMMENT;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_DELETE, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.delete({
          id: fileId,
          url: this.getUrlForId(commentId),
          successCallback,
          errorCallback,
        });
      }

      /**
       * API for fetching comment
       *
       * @param {string} commentId - comment id
       * @param {string} fileId - the file id
       * @param {BoxItemPermission} permissions - the permissions for the file
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @returns {void}
       */
      getComment({ commentId, errorCallback, fileId, permissions, successCallback }) {
        this.errorCode = ERROR_CODE_FETCH_COMMENT;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.get({
          id: fileId,
          errorCallback,
          successCallback,
          url: this.getUrlForId(commentId),
        });
      }

      /**
       * API for fetching comments
       *
       * @param {string} fileId - the file id
       * @param {BoxItemPermission} permissions - the permissions for the file
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @param {array} fields - the fields to fetch
       * @param {string} marker the marker from the start to start fetching at
       * @param {number} limit - the number of items to fetch
       * @param {boolean} shouldFetchAll - true if should get all the pages before calling the sucessCallback
       * @param {number} repliesCount - number of replies to return, by deafult all replies all returned
       *  @returns {void}
       */
      getComments({
        fileId,
        permissions,
        successCallback,
        errorCallback,
        marker,
        limit,
        shouldFetchAll,
        repliesCount,
      }) {
        this.errorCode = ERROR_CODE_FETCH_COMMENTS;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.markerGet({
          id: fileId,
          successCallback,
          errorCallback,
          marker,
          limit,
          requestData: ThreadedComments_objectSpread(
            {},
            repliesCount
              ? {
                  replies_count: repliesCount,
                }
              : null,
          ),
          shouldFetchAll,
        });
      }

      /**
       * @param {string} fileId - the file id
       * @param {string} commentId - id of a Comment
       * @param {BoxItemPermission} permissions - The known permissions of the comment
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       */
      getCommentReplies({ fileId, commentId, permissions, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_FETCH_REPLIES;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.get({
          id: fileId,
          errorCallback,
          successCallback,
          url: this.getUrlWithRepliesForId(commentId),
        });
      }

      /**
       * @param {string} fileId - the file id
       * @param {string} commentId - id of a Comment for which we createing Reply
       * @param {BoxItemPermission} permissions - The known permissions of the comment
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @param {string} message - message of the Reply
       */
      createCommentReply({ fileId, commentId, permissions, successCallback, errorCallback, message }) {
        this.errorCode = ERROR_CODE_CREATE_REPLY;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.post({
          id: fileId,
          data: {
            data: {
              message,
            },
          },
          errorCallback,
          successCallback,
          url: this.getUrlWithRepliesForId(commentId, fileId),
        });
      }
    }
    /* harmony default export */ const api_ThreadedComments = ThreadedComments; // CONCATENATED MODULE: ./src/api/FileAccessStats.js
    /**
     *
     * @file Helper for the box versions API
     * @author Box
     */

    class FileAccessStats extends api_Base {
      /**
       * API URL for access stats
       *
       * @param {string} [id] - a box file id
       * @return {string} base url for files
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing file id!');
        }
        return `${this.getBaseApiUrl()}/file_access_stats/${id}`;
      }

      /**
       * API for fetching access stats on a file
       *
       * @param {string} id - a box file id
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void>}
       */
      getFileAccessStats(id, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_FETCH_ACCESS_STATS;
        this.get({
          id,
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const api_FileAccessStats = FileAccessStats; // CONCATENATED MODULE: ./src/api/FileActivities.js
    function FileActivities_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function FileActivities_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? FileActivities_ownKeys(Object(t), !0).forEach(function (r) {
              FileActivities_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : FileActivities_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function FileActivities_defineProperty(e, r, t) {
      return (
        (r = FileActivities_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function FileActivities_toPropertyKey(t) {
      var i = FileActivities_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function FileActivities_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box File Activity API
     * @author Box
     */

    // We only show the latest reply in the UI
    const REPLY_LIMIT = 1;
    const getFileActivityQueryParams = (fileID, activityTypes = [], shouldShowReplies = false) => {
      const baseEndpoint = `/file_activities?file_id=${fileID}`;
      const hasActivityTypes = !!activityTypes && !!activityTypes.length;
      const enableReplies = shouldShowReplies ? 'true' : 'false';
      const enabledRepliesQueryParam = `&enable_replies=${enableReplies}&reply_limit=${REPLY_LIMIT}`;
      const activityTypeQueryParam = hasActivityTypes ? `&activity_types=${activityTypes.join()}` : '';
      return `${baseEndpoint}${activityTypeQueryParam}${enabledRepliesQueryParam}`;
    };
    class FileActivities extends api_Base {
      /**
       * API URL for filtered file activities
       *
       * @param {string} [id] - a box file id
       * @param {Array<FileActivityTypes>} activityTypes - optional. Array of File Activity types to filter by, returns all Activity Types if omitted.
       * @param {boolean} shouldShowReplies - optional. Specify if replies should be included in the response
       * @return {string} base url for files
       */
      getFilteredUrl(id, activityTypes, shouldShowReplies) {
        return `${this.getBaseApiUrl()}${getFileActivityQueryParams(id, activityTypes, shouldShowReplies)}`;
      }

      /**
       * API for fetching file activities
       *
       * @param {Array<FileActivityTypes>} activityTypes - optional. Array of File Activity types to filter by, returns all Activity Types if omitted.
       * @param {Function} errorCallback - the error callback
       * @param {string} fileId - the file id
       * @param {BoxItemPermission} permissions - the permissions for the file
       * @param {number} repliesCount - number of replies to return, by default all replies are returned
       * @param {boolean} shouldShowReplies - specify if replies should be included in the response
       * @param {Function} successCallback - the success callback
       * @returns {void}
       */
      getActivities({
        activityTypes,
        errorCallback,
        fileID,
        permissions,
        repliesCount,
        shouldShowReplies,
        successCallback,
      }) {
        this.errorCode = ERROR_CODE_FETCH_ACTIVITY;
        try {
          if (!fileID) {
            throw new Error('Missing file id!');
          }
          if (activityTypes.includes(FILE_ACTIVITY_TYPE_COMMENT)) {
            this.checkApiCallValidity(PERMISSION_CAN_COMMENT, permissions, fileID);
          }
          if (activityTypes.includes(FILE_ACTIVITY_TYPE_ANNOTATION)) {
            this.checkApiCallValidity(PERMISSION_CAN_VIEW_ANNOTATIONS, permissions, fileID);
          }
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.get({
          id: fileID,
          successCallback,
          errorCallback,
          requestData: FileActivities_objectSpread(
            {},
            repliesCount
              ? {
                  replies_count: repliesCount,
                }
              : null,
          ),
          url: this.getFilteredUrl(fileID, activityTypes, shouldShowReplies),
        });
      }
    }
    /* harmony default export */ const api_FileActivities = FileActivities; // CONCATENATED MODULE: ./src/api/MarkerBasedGroups.js
    function MarkerBasedGroups_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function MarkerBasedGroups_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? MarkerBasedGroups_ownKeys(Object(t), !0).forEach(function (r) {
              MarkerBasedGroups_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : MarkerBasedGroups_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function MarkerBasedGroups_defineProperty(e, r, t) {
      return (
        (r = MarkerBasedGroups_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MarkerBasedGroups_toPropertyKey(t) {
      var i = MarkerBasedGroups_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MarkerBasedGroups_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Marker-based helper for the Box Groups API
     * @author Box
     */

    class MarkerBasedGroups extends MarkerBasedAPI {
      /**
       * API URL for fetching all groups that are visible to the current user
       *
       * @returns {string} URL for fetching groups
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/groups`;
      }

      /**
       * API for fetching all groups in the current user's enterprise
       *
       * @param {string} id - Box item ID
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @param {Object} [requestData] - Opitional additional request data
       * @param {Object} [limit] - Max number of groups to return
       * @returns {void}
       */
      getGroupsInEnterprise(id, successCallback, errorCallback, requestData, limit = DEFAULT_MAX_CONTACTS) {
        this.errorCode = ERROR_CODE_FETCH_ENTERPRISE_GROUPS;
        this.markerGet({
          id,
          limit,
          successCallback,
          errorCallback,
          requestData: MarkerBasedGroups_objectSpread(
            {
              usemarker: true,
            },
            requestData,
          ),
          shouldFetchAll: false,
        });
      }
    }
    /* harmony default export */ const api_MarkerBasedGroups = MarkerBasedGroups; // CONCATENATED MODULE: ./src/api/MarkerBasedUsers.js
    function MarkerBasedUsers_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function MarkerBasedUsers_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? MarkerBasedUsers_ownKeys(Object(t), !0).forEach(function (r) {
              MarkerBasedUsers_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : MarkerBasedUsers_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function MarkerBasedUsers_defineProperty(e, r, t) {
      return (
        (r = MarkerBasedUsers_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MarkerBasedUsers_toPropertyKey(t) {
      var i = MarkerBasedUsers_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MarkerBasedUsers_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Marker-based helper for the Box Users API
     * @author Box
     */

    class MarkerBasedUsers extends MarkerBasedAPI {
      /**
       * API URL for fetching all users who are visible to the current user
       *
       * @returns {string} URL for fetching users
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/users`;
      }

      /**
       * API for fetching all users in the current user's enterprise
       *
       * @param {string} id - Box item ID
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @param {Object} [requestData] - Opitional additional request data
       * @param {Object} [limit] - Max number of groups to return
       * @returns {void}
       */
      getUsersInEnterprise(id, successCallback, errorCallback, requestData, limit = DEFAULT_MAX_CONTACTS) {
        this.errorCode = ERROR_CODE_FETCH_ENTERPRISE_USERS;
        this.markerGet({
          id,
          limit,
          successCallback,
          errorCallback,
          requestData: MarkerBasedUsers_objectSpread(
            {
              usemarker: true,
            },
            requestData,
          ),
          shouldFetchAll: false,
        });
      }
    }
    /* harmony default export */ const api_MarkerBasedUsers = MarkerBasedUsers; // CONCATENATED MODULE: ./src/api/Groups.js
    /**
     *
     * @file Helper for the box Groups API
     * @author Box
     */

    class Groups extends api_Base {
      /**
       * API URL to get group count
       *
       * @param {string} id a box group ID
       * @return {string} formatted URL for retrieving the membership information
       */
      getUrlForGroupCount(id) {
        return `${this.getBaseApiUrl()}/groups/${id}/memberships`;
      }

      /**
       * API for creating a comment on a file
       *
       * @param {string} id a box group ID
       * @param {Function} [successCallback] callback for handling a valid server response
       * @param {Function} [errorCallback] handle errors raised by backend or connection errors
       * @return {Promise<{}>} Promise which resolves with the payload, including the total_count
       */
      getGroupCount({ errorCallback = noop_default(), successCallback = noop_default(), group, file }) {
        return new Promise((resolve, reject) =>
          this.get({
            id: file.id,
            url: this.getUrlForGroupCount(group.id),
            successCallback: (...args) => {
              successCallback(...args);
              resolve(...args);
            },
            errorCallback: (...args) => {
              errorCallback(...args);
              reject();
            },
            requestData: {
              params: {
                limit: 1,
              },
            },
          }),
        );
      }
    }
    /* harmony default export */ const api_Groups = Groups; // CONCATENATED MODULE: ./src/api/Users.js
    /**
     *
     * @file Helper for the box Users API
     * @author Box
     */

    class Users extends api_Base {
      /**
       * API URL for Users
       *
       * @returns {string} base url for users
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/users/me`;
      }

      /**
       * API URL for Users avatar
       *
       * @param {string} id - A box user id.
       * @returns {string} base url for users
       */
      getAvatarUrl(id) {
        if (!id) {
          throw new Error('Missing user id');
        }
        return `${this.getBaseApiUrl()}/users/${id}/avatar`;
      }

      /**
       * Gets authenticated user avatar URL from cache or by getting new token
       *
       * @param {string} userId the user id
       * @param {string} fileId the file id
       * @returns {string} the user avatar URL string for a given user with access token attached
       */
      async getAvatarUrlWithAccessToken(userId, fileId) {
        if (!userId) {
          return null;
        }

        // treat cache as key-value pairs of { userId: avatarUrl }
        const cache = this.getCache();
        if (cache.has(userId)) {
          return cache.get(userId);
        }
        const accessToken = await utils_TokenService.getReadToken(getTypedFileId(fileId), this.options.token);
        if (typeof accessToken === 'string') {
          const options = {
            access_token: accessToken,
            pic_type: 'large',
          };
          const urlParams = query_string.stringify(options);
          const url = `${this.getAvatarUrl(userId)}?${urlParams}`;
          cache.set(userId, url);
          return url;
        }
        return null;
      }

      /**
       * API for fetching a user
       *
       * @param {string} id - a Box item id
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @param {Object} requestData - additional request data
       * @returns {Promise<void>}
       */
      getUser(id, successCallback, errorCallback, requestData = {}) {
        this.errorCode = ERROR_CODE_FETCH_CURRENT_USER;
        this.get({
          id,
          successCallback,
          errorCallback,
          requestData,
        });
      }
    }
    /* harmony default export */ const api_Users = Users; // CONCATENATED MODULE: ./src/api/Metadata.js
    /**
     *
     * @file Helper for the Box metadata related API
     * @author Box
     */

    class Metadata extends api_File {
      /**
       * Creates a key for the metadata cache
       *
       * @param {string} id - Folder id
       * @return {string} key
       */
      getMetadataCacheKey(id) {
        return `${CACHE_PREFIX_METADATA}${id}`;
      }

      /**
       * Creates a key for the skills cache
       *
       * @param {string} id - Folder id
       * @return {string} key
       */
      getSkillsCacheKey(id) {
        return `${this.getMetadataCacheKey(id)}_skills`;
      }

      /**
       * Creates a key for the classification cache
       *
       * @param {string} id - Folder id
       * @return {string} key
       */
      getClassificationCacheKey(id) {
        return `${this.getMetadataCacheKey(id)}_classification`;
      }

      /**
       * API URL for metadata
       *
       * @param {string} id - a Box file id
       * @param {string} field - metadata field
       * @return {string} base url for files
       */
      getMetadataUrl(id, scope, template) {
        const baseUrl = `${this.getUrl(id)}/metadata`;
        if (scope && template) {
          return `${baseUrl}/${scope}/${template}`;
        }
        return baseUrl;
      }

      /**
       * API URL for metadata templates for a scope
       *
       * @param {string} scope - metadata scope
       * @return {string} base url for files
       */
      getMetadataTemplateUrl() {
        return `${this.getBaseApiUrl()}/metadata_templates`;
      }

      /**
       * API URL for metadata template for an instance
       *
       * @param {string} id - metadata instance id
       * @return {string} base url for files
       */
      getMetadataTemplateUrlForInstance(id) {
        return `${this.getMetadataTemplateUrl()}?metadata_instance_id=${id}`;
      }

      /**
       * API URL for getting metadata template schema by template key
       *
       * @param {string} templateKey - metadata template key
       * @return {string} API url for getting template schema by template key
       */
      getMetadataTemplateSchemaUrl(templateKey) {
        return `${this.getMetadataTemplateUrl()}/enterprise/${templateKey}/schema`;
      }

      /**
       * API URL for metadata templates
       *
       * @param {string} scope - metadata scope or id
       * @return {string} base url for files
       */
      getMetadataTemplateUrlForScope(scope) {
        return `${this.getMetadataTemplateUrl()}/${scope}`;
      }

      /**
       * Returns the custom properties template
       *
       * @return {Object} template for custom properties
       */
      getCustomPropertiesTemplate() {
        return {
          id: uniqueId_default()('metadata_template_'),
          scope: METADATA_SCOPE_GLOBAL,
          templateKey: METADATA_TEMPLATE_PROPERTIES,
          hidden: false,
        };
      }

      /**
       * Utility to create editors from metadata instances
       * and metadata templates.
       *
       * @param {Object} instance - metadata instance
       * @param {Object} template - metadata template
       * @param {boolean} canEdit - is instance editable
       * @return {Object} metadata editor
       */
      createEditor(instance, template, canEdit) {
        const data = {};
        Object.keys(instance).forEach(key => {
          if (!key.startsWith('$')) {
            // $FlowFixMe
            data[key] = instance[key];
          }
        });
        return {
          template,
          instance: {
            id: instance.$id,
            canEdit: instance.$canEdit && canEdit,
            data,
          },
        };
      }

      /**
       * Gets metadata templates for enterprise
       *
       * @param {string} id - file id
       * @param {string} scope - metadata scope
       * @param {string|void} [instanceId] - metadata instance id
       * @return {Object} array of metadata templates
       */
      async getTemplates(id, scope, instanceId) {
        this.errorCode = ERROR_CODE_FETCH_METADATA_TEMPLATES;
        let templates = {};
        const url = instanceId
          ? this.getMetadataTemplateUrlForInstance(instanceId)
          : this.getMetadataTemplateUrlForScope(scope);
        try {
          templates = await this.xhr.get({
            url,
            id: getTypedFileId(id),
            params: {
              limit: METADATA_TEMPLATE_FETCH_LIMIT, // internal hard limit is 500
            },
          });
        } catch (e) {
          const { status } = e;
          if (isUserCorrectableError(status)) {
            throw e;
          }
        }
        return get_default()(templates, 'data.entries', []);
      }

      /**
       * Gets metadata template schema by template key
       *
       * @param {string} templateKey - template key
       * @return {Promise} Promise object of metadata template
       */
      getSchemaByTemplateKey(templateKey) {
        const url = this.getMetadataTemplateSchemaUrl(templateKey);
        return this.xhr.get({
          url,
        });
      }

      /**
       * Gets metadata instances for a Box file
       *
       * @param {string} id - file id
       * @return {Object} array of metadata instances
       */
      async getInstances(id) {
        this.errorCode = ERROR_CODE_FETCH_METADATA;
        let instances = {};
        try {
          instances = await this.xhr.get({
            url: this.getMetadataUrl(id),
            id: getTypedFileId(id),
          });
        } catch (e) {
          const { status } = e;
          if (isUserCorrectableError(status)) {
            throw e;
          }
        }
        return get_default()(instances, 'data.entries', []);
      }

      /**
       * Returns a list of templates that can be added by the user.
       * For collabed files, only custom properties is allowed.
       *
       * @return {Object} template for custom properties
       */
      getUserAddableTemplates(customPropertiesTemplate, enterpriseTemplates, hasMetadataFeature, isExternallyOwned) {
        let userAddableTemplates = [];
        if (hasMetadataFeature) {
          userAddableTemplates = isExternallyOwned
            ? [customPropertiesTemplate]
            : [customPropertiesTemplate].concat(enterpriseTemplates);
        }
        // Only templates that are not hidden and not classification
        return userAddableTemplates.filter(
          template => !template.hidden && template.templateKey !== METADATA_TEMPLATE_CLASSIFICATION,
        );
      }

      /**
       * Extracts classification for different representation in the UI.
       *
       * @param {string} id - Box file id
       * @param {Array} instances - metadata instances
       * @return {Array} metadata instances without classification
       */
      extractClassification(id, instances) {
        const classification = instances.find(instance => instance.$template === METADATA_TEMPLATE_CLASSIFICATION);
        if (classification) {
          instances.splice(instances.indexOf(classification), 1);
          const cache = this.getCache();
          const key = this.getClassificationCacheKey(id);
          cache.set(key, classification);
        }
        return instances;
      }

      /**
       * Finds template for a given metadata instance.
       *
       * @param {string} id - Box file id
       * @param {Object} instance - metadata instance
       * @param {Array} templates - metadata templates
       * @return {Object|undefined} template for metadata instance
       */
      async getTemplateForInstance(id, instance, templates) {
        const instanceId = instance.$id;
        const templateKey = instance.$template;
        const scope = instance.$scope;
        let template = templates.find(t => t.templateKey === templateKey && t.scope === scope);

        // Enterprise scopes are always enterprise_XXXXX
        if (!template && scope.startsWith(METADATA_SCOPE_ENTERPRISE)) {
          // If the template does not exist, it can be a template from another
          // enterprise because the user is viewing a collaborated file.
          const crossEnterpriseTemplate = await this.getTemplates(id, scope, instanceId);
          // The API always returns an array of at most one item
          template = crossEnterpriseTemplate[0]; // eslint-disable-line
        }
        return template;
      }

      /**
       * Creates and returns metadata editors.
       *
       * @param {string} id - Box file id
       * @param {Array} instances - metadata instances
       * @param {Object} customPropertiesTemplate - custom properties template
       * @param {Array} enterpriseTemplates - enterprise templates
       * @param {Array} globalTemplates - global templates
       * @param {boolean} canEdit - metadata editability
       * @return {Array} metadata editors
       */
      async getEditors(id, instances, customPropertiesTemplate, enterpriseTemplates, globalTemplates, canEdit) {
        // All usable templates for metadata instances
        const templates = [customPropertiesTemplate].concat(enterpriseTemplates, globalTemplates);

        // Filter out skills and classification
        // let filteredInstances = this.extractSkills(id, instances);
        const filteredInstances = this.extractClassification(id, instances);

        // Create editors from each instance
        const editors = [];
        await Promise.all(
          filteredInstances.map(async instance => {
            const template = await this.getTemplateForInstance(id, instance, templates);
            if (template) {
              editors.push(this.createEditor(instance, template, canEdit));
            }
          }),
        );
        return editors;
      }

      /**
       * API for getting metadata editors
       *
       * @param {string} fileId - Box file id
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @param {boolean} hasMetadataFeature - metadata feature check
       * @param {Object} options - fetch options
       * @return {Promise}
       */
      async getMetadata(file, successCallback, errorCallback, hasMetadataFeature, options = {}) {
        const { id, permissions, is_externally_owned } = file;
        this.errorCode = ERROR_CODE_FETCH_METADATA;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // Check for valid file object.
        // Need to eventually check for upload permission.
        if (!id || !permissions) {
          this.errorHandler(error_getBadItemError());
          return;
        }
        const cache = this.getCache();
        const key = this.getMetadataCacheKey(id);

        // Clear the cache if needed
        if (options.forceFetch) {
          cache.unset(key);
        }

        // Return the cached value if it exists
        if (cache.has(key)) {
          this.successHandler(cache.get(key));
          if (!options.refreshCache) {
            return;
          }
        }
        try {
          const customPropertiesTemplate = this.getCustomPropertiesTemplate();
          const [instances, globalTemplates, enterpriseTemplates] = await Promise.all([
            this.getInstances(id),
            this.getTemplates(id, METADATA_SCOPE_GLOBAL),
            hasMetadataFeature ? this.getTemplates(id, METADATA_SCOPE_ENTERPRISE) : Promise.resolve([]),
          ]);
          const editors = await this.getEditors(
            id,
            instances,
            customPropertiesTemplate,
            enterpriseTemplates,
            globalTemplates,
            !!permissions.can_upload,
          );
          const metadata = {
            editors,
            templates: this.getUserAddableTemplates(
              customPropertiesTemplate,
              enterpriseTemplates,
              hasMetadataFeature,
              is_externally_owned,
            ),
          };
          cache.set(key, metadata);
          if (!this.isDestroyed()) {
            this.successHandler(metadata);
          }
        } catch (e) {
          this.errorHandler(e);
        }
      }

      /**
       * Gets skills for file
       *
       * @param {string} id - file id
       * @return {Object} array of metadata instances
       */
      async getSkills(file, successCallback, errorCallback, forceFetch = false) {
        this.errorCode = ERROR_CODE_FETCH_SKILLS;
        const { id } = file;
        if (!id) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return;
        }
        const cache = this.getCache();
        const key = this.getSkillsCacheKey(id);
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // Clear the cache if needed
        if (forceFetch) {
          cache.unset(key);
        }

        // Return the Cache value if it exists
        if (cache.has(key)) {
          this.successHandler(cache.get(key));
          return;
        }

        // The file object may already have skills in it
        let skills = {
          data: get_default()(file, FIELD_METADATA_SKILLS),
        };
        try {
          if (!skills.data) {
            skills = await this.xhr.get({
              url: this.getMetadataUrl(id, METADATA_SCOPE_GLOBAL, METADATA_TEMPLATE_SKILLS),
              id: getTypedFileId(id),
            });
          }
          if (!this.isDestroyed()) {
            const cards = skills.data.cards || [];
            cache.set(key, cards);
            this.successHandler(cards);
          }
        } catch (e) {
          this.errorHandler(e);
        }
      }

      /**
       * API for patching skills on a file
       *
       * @param {BoxItem} file - File object for which we are changing the description
       * @param {string} field - Metadata field to patch
       * @param {Array} operations - Array of JSON patch operations
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {Promise}
       */
      async updateSkills(file, operations, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_UPDATE_SKILLS;
        const { id, permissions } = file;
        if (!id || !permissions) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return;
        }
        if (!permissions.can_upload) {
          errorCallback(getBadPermissionsError(), this.errorCode);
          return;
        }
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        try {
          const metadata = await this.xhr.put({
            url: this.getMetadataUrl(id, METADATA_SCOPE_GLOBAL, METADATA_TEMPLATE_SKILLS),
            headers: {
              [HEADER_CONTENT_TYPE]: 'application/json-patch+json',
            },
            id: getTypedFileId(id),
            data: operations,
          });
          if (!this.isDestroyed()) {
            const cards = metadata.data.cards || [];
            this.merge(this.getCacheKey(id), FIELD_METADATA_SKILLS, metadata.data);
            this.getCache().set(this.getSkillsCacheKey(id), cards);
            this.successHandler(cards);
          }
        } catch (e) {
          this.errorHandler(e);
        }
      }

      /**
       * API for patching metadata on file
       *
       * @param {BoxItem} file - File object for which we are changing the description
       * @param {Object} template - Metadata template
       * @param {Array} operations - Array of JSON patch operations
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {Promise}
       */
      async updateMetadata(file, template, operations, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_UPDATE_METADATA;
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        const { id, permissions } = file;
        if (!id || !permissions) {
          this.errorHandler(error_getBadItemError());
          return;
        }
        const canEdit = !!permissions.can_upload;
        if (!canEdit) {
          this.errorHandler(getBadPermissionsError());
          return;
        }
        try {
          const metadata = await this.xhr.put({
            url: this.getMetadataUrl(id, template.scope, template.templateKey),
            headers: {
              [HEADER_CONTENT_TYPE]: 'application/json-patch+json',
            },
            id: getTypedFileId(id),
            data: operations,
          });
          if (!this.isDestroyed()) {
            const cache = this.getCache();
            const key = this.getMetadataCacheKey(id);
            const cachedMetadata = cache.get(key);
            const editor = this.createEditor(metadata.data, template, canEdit);
            if (cachedMetadata && cachedMetadata.editors) {
              cachedMetadata.editors.splice(
                cachedMetadata.editors.findIndex(({ instance }) => instance.id === editor.instance.id),
                1,
                editor,
              );
            }
            this.successHandler(editor);
          }
        } catch (e) {
          this.errorHandler(e);
        }
      }

      /**
       * API for creating metadata on file
       *
       * @param {BoxItem} file - File object for which we are changing the description
       * @param {Object} template - Metadata template
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {Promise}
       */
      async createMetadata(file, template, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_CREATE_METADATA;
        if (!file || !template) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return;
        }
        const { id, permissions, is_externally_owned } = file;
        if (!id || !permissions) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return;
        }
        const canEdit = !!permissions.can_upload;
        const isProperties =
          template.templateKey === METADATA_TEMPLATE_PROPERTIES && template.scope === METADATA_SCOPE_GLOBAL;
        if (!canEdit || (is_externally_owned && !isProperties)) {
          errorCallback(getBadPermissionsError(), this.errorCode);
          return;
        }
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        try {
          const metadata = await this.xhr.post({
            url: this.getMetadataUrl(id, template.scope, template.templateKey),
            id: getTypedFileId(id),
            data: {},
          });
          if (!this.isDestroyed()) {
            const cache = this.getCache();
            const key = this.getMetadataCacheKey(id);
            const cachedMetadata = cache.get(key);
            const editor = this.createEditor(metadata.data, template, canEdit);
            cachedMetadata.editors.push(editor);
            this.successHandler(editor);
          }
        } catch (e) {
          this.errorHandler(e);
        }
      }

      /**
       * API for deleting metadata on file
       *
       * @param {BoxItem} file - File object for which we are changing the description
       * @param {string} scope - Metadata instance scope
       * @param {string} template - Metadata template key
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {Promise}
       */
      async deleteMetadata(file, template, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_DELETE_METADATA;
        if (!file || !template) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return;
        }
        const { scope, templateKey } = template;
        const { id, permissions } = file;
        if (!id || !permissions) {
          errorCallback(error_getBadItemError(), this.errorCode);
          return;
        }
        if (!permissions.can_upload) {
          errorCallback(getBadPermissionsError(), this.errorCode);
          return;
        }
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;
        try {
          await this.xhr.delete({
            url: this.getMetadataUrl(id, scope, templateKey),
            id: getTypedFileId(id),
          });
          if (!this.isDestroyed()) {
            const cache = this.getCache();
            const key = this.getMetadataCacheKey(id);
            const metadata = cache.get(key);
            metadata.editors.splice(
              metadata.editors.findIndex(
                editor => editor.template.scope === scope && editor.template.templateKey === templateKey,
              ),
              1,
            );
            this.successHandler();
          }
        } catch (e) {
          this.errorHandler(e);
        }
      }
    }
    /* harmony default export */ const api_Metadata = Metadata; // CONCATENATED MODULE: ./src/api/FileCollaborators.js
    function FileCollaborators_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function FileCollaborators_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? FileCollaborators_ownKeys(Object(t), !0).forEach(function (r) {
              FileCollaborators_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : FileCollaborators_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function FileCollaborators_defineProperty(e, r, t) {
      return (
        (r = FileCollaborators_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function FileCollaborators_toPropertyKey(t) {
      var i = FileCollaborators_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function FileCollaborators_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box collaborators API
     * @author Box
     */

    class FileCollaborators extends MarkerBasedAPI {
      constructor(...args) {
        super(...args);
        /**
         * Transform result of API response
         *
         * @param {Object} data the response data
         */
        FileCollaborators_defineProperty(this, 'successHandler', data => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }

          // Transform into "mention selector" format:
          const collaboratorSelectorItems = data.entries.map(collab => {
            let item;
            if (collab.type === 'group') {
              item = collab; // flow needs assignment to happen after type refinement
            } else {
              item = collab;
              item.email = item.login; // transform user object
            }
            return {
              id: collab.id,
              name: collab.name,
              item,
            };
          });
          this.successCallback(
            FileCollaborators_objectSpread(
              FileCollaborators_objectSpread({}, data),
              {},
              {
                entries: collaboratorSelectorItems,
              },
            ),
          );
        });
        /**
         * Fetches file @mention's
         *
         * @oaram {string} fileId
         * @param {Function} successCallback
         * @param {Function} errorCallback
         * @param {string} searchStr - Search string to filter file collaborators by
         * @param {Object} [options]
         * @param {boolean} [options.includeGroups] - return groups as well as users
         * @return {void}
         */
        FileCollaborators_defineProperty(
          this,
          'getCollaboratorsWithQuery',
          (fileId, successCallback, errorCallback, searchStr, { includeGroups = false } = {}) => {
            // Do not fetch without filter
            if (!searchStr || searchStr.trim() === '') {
              return;
            }
            this.getFileCollaborators(fileId, successCallback, errorCallback, {
              filter_term: searchStr,
              include_groups: includeGroups,
              include_uploader_collabs: false,
            });
          },
        );
      }
      /**
       * API URL for comments
       *
       * @param {string} [id] - a box file id
       * @return {string} base url for files
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing file id!');
        }
        return `${this.getBaseApiUrl()}/files/${id}/collaborators`;
      }
      /**
       * API for fetching collaborators on a file
       *
       * @param {string} id - the file id
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @param {Object} requestData - any additional request data
       * @param {number} limit - the max number of collaborators to return
       * @returns {void}
       */
      getFileCollaborators(id, successCallback, errorCallback, requestData = {}, limit = DEFAULT_MAX_COLLABORATORS) {
        // NOTE: successCallback is called with the result
        // of this.successHandler, not the API response!
        this.markerGet({
          id,
          limit,
          successCallback,
          errorCallback,
          requestData,
        });
      }
    }
    /* harmony default export */ const api_FileCollaborators = FileCollaborators; // CONCATENATED MODULE: ./src/api/ItemCollaborations.js
    function ItemCollaborations_defineProperty(e, r, t) {
      return (
        (r = ItemCollaborations_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ItemCollaborations_toPropertyKey(t) {
      var i = ItemCollaborations_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ItemCollaborations_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the Box Item (File/Folder) Collaborations API
     * @author Box
     */

    class ItemCollaborations extends MarkerBasedAPI {
      constructor(...args) {
        super(...args);
        /**
         * API for fetching collaborations on a Box item
         *
         * @param {string} id - Item ID
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @param {Object} [requestData] - Optional additional request data
         * @param {number} [limit] - Max number of collaborations to return
         * @returns {void}
         */
        ItemCollaborations_defineProperty(
          this,
          'getCollaborations',
          (id, successCallback, errorCallback, requestData = {}, limit = DEFAULT_MAX_COLLABORATORS) => {
            this.markerGet({
              id,
              limit,
              successCallback,
              errorCallback,
              requestData,
            });
          },
        );
        /**
         * Used by the MarkerBasedAPI after a successful call
         *
         * @param {Object} data - Response data
         */
        ItemCollaborations_defineProperty(this, 'successHandler', data => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }
          this.successCallback(data); // defined in this.markerGet()
        });
      }
      /**
       * API URL for collaborations
       *
       * @param {string} id - Item ID
       * @protected
       * @return {string} Base URL for collaborations
       */
      getUrl(id) {
        return `getUrl(${id}) should be overridden`;
      }
    }
    /* harmony default export */ const api_ItemCollaborations = ItemCollaborations; // CONCATENATED MODULE: ./src/api/FileCollaborations.js
    /**
     *
     * @file Helper for the Box File Collaborations API
     * @author Box
     *
     * This API is different from the File *Collaborators* API, which is referenced in ./FileCollaborators
     * and used in the ContentSidebar UI Element.
     *
     * While the two APIs have very similar names and purposes, they return collaborated user data in
     * significantly different formats. The data format for the File *Collaborations* API is documented here:
     * https://developer.box.com/reference/get-files-id-collaborations.
     */

    class FileCollaborations extends api_ItemCollaborations {
      /**
       * API URL for retrieving file collaborations
       *
       * @param {string} id - Box file ID
       * @return {string} Base URL for files
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing file ID!');
        }
        return `${this.getBaseApiUrl()}/files/${id}/collaborations`;
      }
    }
    /* harmony default export */ const api_FileCollaborations = FileCollaborations; // CONCATENATED MODULE: ./src/api/FolderCollaborations.js
    /**
     *
     * @file Helper for the Box Folder Collaborations API
     * @author Box
     */

    class FolderCollaborations extends api_ItemCollaborations {
      /**
       * API URL for retrieving folder collaborations
       *
       * @param {string} id - Box folder ID
       * @return {string} Base URL for folders
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing folder ID!');
        }
        return `${this.getBaseApiUrl()}/folders/${id}/collaborations`;
      }
    }
    /* harmony default export */ const api_FolderCollaborations = FolderCollaborations; // CONCATENATED MODULE: ./src/api/Collaborations.js
    function Collaborations_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Collaborations_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Collaborations_ownKeys(Object(t), !0).forEach(function (r) {
              Collaborations_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Collaborations_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Collaborations_defineProperty(e, r, t) {
      return (
        (r = Collaborations_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Collaborations_toPropertyKey(t) {
      var i = Collaborations_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Collaborations_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the Box Collaborations API
     * @author Box
     *
     * The Collaborations API is different from the other APIs related to collaborations/collaborators.
     * - The Item Collaborations (File Collaborations and Folder Collaborations) API only accepts GET requests for a single item;
     *   it returns an object containing all the users who are collaborated on that item.
     * - The File Collaborators API is used exclusively in the ContentSidebar UI Element.
     * - This API enables CRUD actions on a single collaboration for a single item. For more information, see the API docs at
     *   https://developer.box.com/reference/resources/collaboration/.
     */

    class Collaborations extends api_Base {
      constructor(...args) {
        super(...args);
        /**
         * Add a collaboration for a single user or a single group to a file or folder.
         * Users can be added by ID or login (email); groups can only be added by ID.
         *
         * @param {BoxItem} item
         * @param {$Shape<Collaboration>} collaboration
         * @param {(data?: Object) => void} successCallback
         * @param {ElementsErrorCallback} errorCallback
         */
        Collaborations_defineProperty(
          this,
          'addCollaboration',
          (item, collaboration, successCallback, errorCallback) => {
            const { id } = item;
            this.post({
              id,
              data: {
                data: Collaborations_objectSpread(
                  {
                    item,
                  },
                  collaboration,
                ),
              },
              errorCallback,
              successCallback,
              url: this.getUrl(),
            });
          },
        );
      }
      /**
       * API URL for collaborations
       *
       * @return {string} Base URL for collaborations
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/collaborations`;
      }
    }
    /* harmony default export */ const api_Collaborations = Collaborations; // CONCATENATED MODULE: ./src/api/messages.js
    /**
     *
     * @file i18n messages
     * @author Box
     */

    const api_messages_messages = defineMessages({
      appActivityDeleteErrorMessage: {
        id: 'be.api.appActivityDeleteErrorMessage',
        defaultMessage: 'There was an error deleting this item.',
      },
      commentCreateErrorMessage: {
        id: 'be.api.commentCreateErrorMessage',
        defaultMessage: 'There was an error creating this comment.',
      },
      commentCreateConflictMessage: {
        id: 'be.api.commentCreateConflictMessage',
        defaultMessage: 'This comment already exists.',
      },
      commentDeleteErrorMessage: {
        id: 'be.api.commentDeleteErrorMessage',
        defaultMessage: 'There was an error deleting this comment.',
      },
      commentUpdateErrorMessage: {
        id: 'be.api.commentUpdateErrorMessage',
        defaultMessage: 'This comment could not be modified.',
      },
      repliesFetchErrorMessage: {
        id: 'be.api.repliesFetchErrorMessage',
        defaultMessage: 'The replies to this comment could not be loaded.',
      },
      taskActionErrorTitle: {
        id: 'be.api.taskActionErrorTitle',
        defaultMessage: 'Error',
      },
      taskApproveErrorMessage: {
        id: 'be.api.taskApproveErrorMessage',
        defaultMessage: 'An error has occurred while approving this task. Please refresh the page and try again.',
      },
      taskCompleteErrorMessage: {
        id: 'be.api.taskCompleteErrorMessage',
        defaultMessage: 'An error has occurred while completing this task. Please refresh the page and try again.',
      },
      taskRejectErrorMessage: {
        id: 'be.api.taskRejectErrorMessage',
        defaultMessage: 'An error has occurred while rejecting this task. Please refresh the page and try again.',
      },
      taskDeleteErrorMessage: {
        id: 'be.api.taskDeleteErrorMessage',
        defaultMessage: 'There was an error while deleting this task. Please refresh the page and try again.',
      },
      taskCreateErrorMessage: {
        id: 'be.api.taskCreateErrorMessage',
        defaultMessage: 'An error occurred while creating this task. Please try again.',
      },
      taskGroupExceedsLimitWarningMessage: {
        id: 'be.api.taskGroupExceedsWarningTitle',
        defaultMessage:
          'One or more groups can not receive this task as a group size cannot exceed the limit of {max} assignees per group.',
      },
    });
    /* harmony default export */ const api_messages = api_messages_messages; // CONCATENATED MODULE: ./src/utils/comparator.js
    /**
     *
     * @file Function to sort item list
     * @author Box
     */

    /**
     * Comparator function for sorting files and folders
     *
     * @param {string} sortBy field to sort by
     * @param {string} sortDirection desc or asc
     * @return {Function} comparator function
     */
    function comparator_comparator(sortBy, sortDirection, cache) {
      const invert = sortDirection === SORT_DESC ? 1 : -1;
      return (a, b) => {
        const itemA = cache.get(a);
        const itemB = cache.get(b);
        const itemAType = itemA.type || TYPE_FILE;
        const itemBType = itemB.type || TYPE_FILE;
        const itemAName = itemA.name || '';
        const itemBName = itemB.name || '';
        const itemADate = Date.parse(itemA.modified_at || '0');
        const itemBDate = Date.parse(itemB.modified_at || '0');
        const itemAInteractedDate = Date.parse(itemA.interacted_at || itemA.modified_at || '0');
        const itemBInteractedDate = Date.parse(itemB.interacted_at || itemB.modified_at || '0');
        const itemASize = itemA.size || 0;
        const itemBSize = itemB.size || 0;

        // If a and b are of the same type, then use sortBy
        if (itemAType === itemBType) {
          if (sortBy === FIELD_NAME) {
            if (itemAName.toLowerCase() > itemBName.toLowerCase()) return -1 * invert;
            if (itemAName.toLowerCase() < itemBName.toLowerCase()) return 1 * invert;
          } else if (sortBy === FIELD_MODIFIED_AT) {
            if (itemADate > itemBDate) return -1 * invert;
            if (itemADate < itemBDate) return 1 * invert;
          } else if (sortBy === FIELD_INTERACTED_AT) {
            if (itemAInteractedDate > itemBInteractedDate) return -1 * invert;
            if (itemAInteractedDate < itemBInteractedDate) return 1 * invert;
          } else if (sortBy === FIELD_SIZE) {
            if (itemASize > itemBSize) return -1 * invert;
            if (itemASize < itemBSize) return 1 * invert;
          } else {
            // Should never reach here
            throw new Error('Unsupported sort field!');
          }
          return 0;
        }

        // If a and b are of different types, then use type to sort
        // Folder > File > WebLink
        if (itemAType === TYPE_FOLDER) return -1;
        if (itemBType === TYPE_FOLDER) return 1;
        if (itemAType === TYPE_FILE) return -1;
        if (itemBType === TYPE_FILE) return 1;

        // Should never reach here
        throw new Error('Error in sort comparator!');
      };
    } // CONCATENATED MODULE: ./src/utils/sorter.js
    /**
     *
     * @file Function to sort the item list
     * @author Box
     */

    function isSortingNeeded(order, sortBy, sortDirection) {
      return !Array.isArray(order) || !order.some(entry => entry.by === sortBy && entry.direction === sortDirection);
    }

    /**
     * Sorts items in place
     *
     * @param {Object} item box item object
     * @param {string} sortBy sort by field
     * @param {string} sortDirection the sort direction
     * @param {Cache} cache item cache
     * @return {void}
     */
    function sorter(item, sortBy, sortDirection, cache) {
      const { item_collection } = item;
      if (!item_collection) {
        throw getBadItemError();
      }
      const { entries, order } = item_collection;
      if (!Array.isArray(entries)) {
        throw getBadItemError();
      }
      if (isSortingNeeded(order, sortBy, sortDirection)) {
        entries.sort(comparator(sortBy, sortDirection, cache));
        item_collection.order = [
          {
            by: sortBy,
            direction: sortDirection,
          },
        ];
      }
      return item;
    }

    /**
     * Sort valid feed items, descending by created_at time.
     *
     * @param {Array<?Comments | ?Tasks | ?FileVersions>} args - Arguments list of each item container
     * type that is allowed in the feed.
     * @return {Array<?Comments | ?Tasks | ?FileVersions>} the sorted feed items
     */
    function sortFeedItems(...args) {
      const feedItems = args
        .reduce((items, itemContainer) => {
          if (itemContainer) {
            return items.concat(itemContainer.entries);
          }
          return items;
        }, [])
        .sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at));
      return feedItems;
    } // CONCATENATED MODULE: ./src/api/Annotations.js
    function Annotations_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Annotations_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Annotations_ownKeys(Object(t), !0).forEach(function (r) {
              Annotations_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Annotations_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Annotations_defineProperty(e, r, t) {
      return (
        (r = Annotations_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Annotations_toPropertyKey(t) {
      var i = Annotations_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Annotations_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    class Annotations extends MarkerBasedAPI {
      constructor(...args) {
        super(...args);
        /**
         * Formats the annotations api response to usable data
         * @param {Object} data the api response data
         */
        Annotations_defineProperty(this, 'successHandler', data => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }

          // There is no response data when deleting an annotation
          if (!data) {
            this.successCallback();
            return;
          }

          // We don't have entries when updating/creating an annotation
          if (!data.entries) {
            // Check if the response is a comment (result of createAnnotationReply)
            if (data.type && data.type === 'comment') {
              this.successCallback(formatComment(data));
              return;
            }
            this.successCallback(this.formatReplies(data));
            return;
          }

          // Check if the response is the replies of an annotation (result of getAnnotationReplies)
          if (data.entries.length && data.entries[0].type === 'comment') {
            const replies = data.entries.map(formatComment);
            this.successCallback(
              Annotations_objectSpread(
                Annotations_objectSpread({}, data),
                {},
                {
                  entries: replies,
                },
              ),
            );
            return;
          }
          const annotations = data.entries.map(this.formatReplies);
          this.successCallback(
            Annotations_objectSpread(
              Annotations_objectSpread({}, data),
              {},
              {
                entries: annotations,
              },
            ),
          );
        });
      }
      /**
       * Formats annotation replies' comment data for use in components.
       *
       * @param {Annotation} annotation - An individual annotation entry from the API
       * @return {Annotation} Updated annotation
       */
      formatReplies(annotation) {
        if (!annotation.replies || !annotation.replies.length) {
          return annotation;
        }
        return Annotations_objectSpread(
          Annotations_objectSpread({}, annotation),
          {},
          {
            replies: annotation.replies.map(formatComment),
          },
        );
      }
      getUrl() {
        return `${this.getBaseApiUrl()}/undoc/annotations`;
      }
      getUrlForId(annotationId) {
        return `${this.getUrl()}/${annotationId}`;
      }
      getUrlWithRepliesForId(annotationId) {
        return `${this.getUrlForId(annotationId)}/replies`;
      }
      createAnnotation(fileId, fileVersionId, payload, permissions, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_CREATE_ANNOTATION;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_CREATE_ANNOTATIONS, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        const defaults = {
          description: {
            type: 'reply',
          },
          file_version: {
            id: fileVersionId,
            type: 'file_version',
          },
        };
        this.post({
          id: fileId,
          data: {
            data: merge_default()(defaults, payload),
          },
          errorCallback,
          successCallback,
          url: this.getUrl(),
        });
      }
      updateAnnotation(fileId, annotationId, permissions, payload, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_EDIT_ANNOTATION;
        const { message, status } = payload;
        if (message) {
          try {
            this.checkApiCallValidity(PERMISSION_CAN_EDIT, permissions, fileId);
          } catch (e) {
            errorCallback(e, this.errorCode);
            return;
          }
        }
        if (status) {
          try {
            this.checkApiCallValidity(PERMISSION_CAN_RESOLVE, permissions, fileId);
          } catch (e) {
            errorCallback(e, this.errorCode);
            return;
          }
        }
        this.put({
          id: fileId,
          data: {
            data: {
              description: message
                ? {
                    message,
                  }
                : undefined,
              status,
            },
          },
          errorCallback,
          successCallback,
          url: this.getUrlForId(annotationId),
        });
      }
      deleteAnnotation(fileId, annotationId, permissions, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_DELETE_ANNOTATION;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_DELETE, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.delete({
          id: fileId,
          errorCallback,
          successCallback,
          url: this.getUrlForId(annotationId),
        });
      }
      getAnnotation(fileId, annotationId, permissions, successCallback, errorCallback, shouldFetchReplies) {
        this.errorCode = ERROR_CODE_FETCH_ANNOTATION;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_VIEW_ANNOTATIONS, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        const requestData = shouldFetchReplies
          ? {
              params: {
                fields: 'replies',
              },
            }
          : undefined;
        this.get({
          id: fileId,
          errorCallback,
          successCallback,
          url: this.getUrlForId(annotationId),
          requestData,
        });
      }
      getAnnotations(
        fileId,
        fileVersionId,
        permissions,
        successCallback,
        errorCallback,
        limit,
        shouldFetchAll,
        shouldFetchReplies,
      ) {
        this.errorCode = ERROR_CODE_FETCH_ANNOTATIONS;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_VIEW_ANNOTATIONS, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        const requestData = Annotations_objectSpread(
          {
            file_id: fileId,
            file_version_id: fileVersionId,
          },
          shouldFetchReplies
            ? {
                fields: 'replies',
              }
            : null,
        );
        this.markerGet({
          id: fileId,
          errorCallback,
          limit,
          requestData,
          shouldFetchAll,
          successCallback,
        });
      }
      getAnnotationReplies(fileId, annotationId, permissions, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_FETCH_REPLIES;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_VIEW_ANNOTATIONS, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.get({
          id: fileId,
          errorCallback,
          successCallback,
          url: this.getUrlWithRepliesForId(annotationId),
        });
      }
      createAnnotationReply(fileId, annotationId, permissions, message, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_CREATE_REPLY;
        try {
          this.checkApiCallValidity(PERMISSION_CAN_CREATE_ANNOTATIONS, permissions, fileId);
        } catch (e) {
          errorCallback(e, this.errorCode);
          return;
        }
        this.post({
          id: fileId,
          data: {
            data: {
              message,
            },
          },
          errorCallback,
          successCallback,
          url: `${this.getUrlWithRepliesForId(annotationId)}?file_id=${fileId}`,
        });
      }
    } // CONCATENATED MODULE: ./src/api/AppActivity.js
    function AppActivity_defineProperty(e, r, t) {
      return (
        (r = AppActivity_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function AppActivity_toPropertyKey(t) {
      var i = AppActivity_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function AppActivity_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box App Activity API
     * @author Box
     */

    class AppActivity extends MarkerBasedAPI {
      constructor(...args) {
        super(...args);
        /** @property {BoxItemPermission} - Placeholder permissions object to determine if app activity can be deleted */
        AppActivity_defineProperty(this, 'permissions', {});
        /**
         * Map an entry from the AppActivityAPIItem to an AppActivityItem.
         * occurred_at -> created_at
         * Adds permissions to item
         *
         * @param {AppActivityAPIItem} item - A single entry in the AppActivity API entries list
         *
         * @return {AppActivityItem}
         */
        AppActivity_defineProperty(this, 'mapAppActivityItem', item => {
          const { activity_template, app, created_by, id, occurred_at, rendered_text, type } = item;
          const { can_delete } = this.permissions;
          return {
            activity_template,
            app,
            created_at: occurred_at,
            created_by,
            id,
            permissions: {
              can_delete,
            },
            rendered_text,
            type,
          };
        });
        /**
         * Generic success handler
         *
         * @param {AppActivityAPIItems} data - the response data
         */
        AppActivity_defineProperty(this, 'successHandler', ({ entries = [] }) => {
          if (this.isDestroyed() || typeof this.successCallback !== 'function') {
            return;
          }
          const activityEntries = entries.map(this.mapAppActivityItem);
          this.successCallback({
            entries: activityEntries,
            total_count: activityEntries.length,
          });
        });
        /**
         * Generic error handler
         *
         * @param {AxiosError} error - the error response
         */
        AppActivity_defineProperty(this, 'errorHandler', error => {
          if (this.isDestroyed() && typeof this.errorCallback !== 'function') {
            return;
          }
          const { response } = error;

          // In the case of a 404, the enterprise does not have App Activities enabled.
          // Show no App Activity
          if (response.status === HTTP_STATUS_CODE_NOT_FOUND) {
            this.successHandler({
              entries: [],
              total_count: 0,
            });
          } else {
            this.errorCallback(error, response.status);
          }
        });
      }
      /**
       * API URL for getting App Activity on a file
       *
       * @return {string} Url for all app activity on a file
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/app_activities`;
      }

      /**
       * API URL for deleting app activity from a file
       *
       * @param id - ID of an app activity item
       * @return {string} - URL to delete app activity
       */
      getDeleteUrl(id) {
        if (!id) {
          throw new Error('Missing file id!');
        }
        return `${this.getUrl()}/${id}`;
      }
      /**
       * API for fetching App Activity on a file
       *
       * @param {string} id - the file id
       * @param {BoxItemPermission} permissions - Permissions to attach to the app activity items. Determines if it can be deleted.
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @param {number} [limit] - the max number of app activity items to return.
       *
       * @returns {void}
       */
      getAppActivity(id, permissions, successCallback, errorCallback) {
        const requestData = {
          item_id: id,
          item_type: 'file',
          fields: APP_ACTIVITY_FIELDS_TO_FETCH.toString(),
        };
        this.permissions = permissions;
        this.markerGet({
          id,
          successCallback,
          errorCallback,
          requestData,
        });
      }

      /**
       * Delete an app activity item
       *
       * @param {string} id - The ID of the Box file that App Activity is on
       * @param {string} appActivityId - An AppActivity item id
       * @param {Function} successCallback - The success callback
       * @param {Function} errorCallback - The error callback
       */
      deleteAppActivity({ id, appActivityId, successCallback, errorCallback }) {
        this.errorCode = ERROR_CODE_DELETE_APP_ACTIVITY;
        this.delete({
          id,
          url: this.getDeleteUrl(appActivityId),
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const api_AppActivity = AppActivity; // CONCATENATED MODULE: ./src/api/Feed.js
    const Feed_excluded = ['replies'],
      _excluded2 = ['replies'],
      _excluded3 = ['replies', 'total_reply_count'],
      _excluded4 = ['replies', 'total_reply_count'];
    function Feed_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Feed_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Feed_ownKeys(Object(t), !0).forEach(function (r) {
              Feed_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Feed_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Feed_defineProperty(e, r, t) {
      return (
        (r = Feed_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Feed_toPropertyKey(t) {
      var i = Feed_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Feed_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    function Feed_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Feed_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Feed_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    /**
     *
     * @file Helper for activity feed API's
     * @author Box
     */

    const TASK_NEW_INITIAL_STATUS = TASK_NEW_NOT_STARTED;
    const getItemWithFilteredReplies = (item, replyId) => {
      const { replies = [] } = item,
        rest = Feed_objectWithoutProperties(item, Feed_excluded);
      return Feed_objectSpread(
        {
          replies: replies.filter(({ id }) => id !== replyId),
        },
        rest,
      );
    };
    const getItemWithPendingReply = (item, reply) => {
      const { replies = [] } = item,
        rest = Feed_objectWithoutProperties(item, _excluded2);
      return Feed_objectSpread(
        {
          replies: [...replies, reply],
        },
        rest,
      );
    };
    const parseReplies = replies => {
      const parsedReplies = [...replies];
      return parsedReplies.map(reply => {
        return Feed_objectSpread(
          Feed_objectSpread({}, reply),
          {},
          {
            tagged_message: reply.tagged_message || reply.message || '',
          },
        );
      });
    };
    const getParsedFileActivitiesResponse = response => {
      if (!response || !response.entries || !response.entries.length) {
        return [];
      }
      const data = response.entries;
      const parsedData = data
        .map(item => {
          if (!item.source) {
            return null;
          }
          const source = Feed_objectSpread({}, item.source);
          switch (item.activity_type) {
            case FILE_ACTIVITY_TYPE_TASK: {
              const taskItem = Feed_objectSpread({}, source[FILE_ACTIVITY_TYPE_TASK]);
              // UAA follows a lowercased enum naming convention, convert to uppercase to align with task api
              if (taskItem.assigned_to?.entries) {
                const assignedToEntries = taskItem.assigned_to.entries.map(entry => {
                  const assignedToEntry = Feed_objectSpread({}, entry);
                  assignedToEntry.role = entry.role.toUpperCase();
                  assignedToEntry.status = entry.status.toUpperCase();
                  return assignedToEntry;
                });
                // $FlowFixMe Using the toUpperCase method makes Flow assume role and status is a string type, which is incompatible with string literal
                taskItem.assigned_to.entries = assignedToEntries;
              }
              if (taskItem.completion_rule) {
                taskItem.completion_rule = taskItem.completion_rule.toUpperCase();
              }
              if (taskItem.status) {
                taskItem.status = taskItem.status.toUpperCase();
              }
              if (taskItem.task_type) {
                taskItem.task_type = taskItem.task_type.toUpperCase();
              }
              // $FlowFixMe File Activities only returns a created_by user, Flow type fix is needed
              taskItem.created_by = {
                target: taskItem.created_by,
              };
              return taskItem;
            }
            case FILE_ACTIVITY_TYPE_COMMENT: {
              const commentItem = Feed_objectSpread({}, source[FILE_ACTIVITY_TYPE_COMMENT]);
              if (commentItem.replies && commentItem.replies.length) {
                const replies = parseReplies(commentItem.replies);
                commentItem.replies = replies;
              }
              commentItem.tagged_message = commentItem.tagged_message || commentItem.message || '';
              return commentItem;
            }
            case FILE_ACTIVITY_TYPE_ANNOTATION: {
              const annotationItem = Feed_objectSpread({}, source[FILE_ACTIVITY_TYPE_ANNOTATION]);
              if (annotationItem.replies && annotationItem.replies.length) {
                const replies = parseReplies(annotationItem.replies);
                annotationItem.replies = replies;
              }
              return annotationItem;
            }
            case FILE_ACTIVITY_TYPE_APP_ACTIVITY: {
              const appActivityItem = Feed_objectSpread({}, source[FILE_ACTIVITY_TYPE_APP_ACTIVITY]);
              appActivityItem.created_at = appActivityItem.occurred_at;
              return appActivityItem;
            }
            case FILE_ACTIVITY_TYPE_VERSION: {
              const versionsItem = Feed_objectSpread({}, source[FILE_ACTIVITY_TYPE_VERSION]);
              versionsItem.type = FEED_ITEM_TYPE_VERSION;
              if (versionsItem.action_by) {
                const collaborators = {};
                if (versionsItem.action_by.length === 1) {
                  versionsItem.uploader_display_name = versionsItem.action_by[0].name;
                }
                versionsItem.action_by.map(collaborator => {
                  collaborators[collaborator.id] = Feed_objectSpread({}, collaborator);
                  return collaborator;
                });
                versionsItem.collaborators = collaborators;
              }
              if (versionsItem.end?.number) {
                versionsItem.version_end = versionsItem.end.number;
                versionsItem.id = versionsItem.end.id;
              }
              if (versionsItem.start?.number) {
                versionsItem.version_start = versionsItem.start.number;
              }
              if (versionsItem.version_start === versionsItem.version_end) {
                versionsItem.version_number = versionsItem.version_start;
                if (
                  versionsItem.action_type === ACTION_TYPE_CREATED &&
                  versionsItem.start?.created_at &&
                  versionsItem.start?.created_by
                ) {
                  versionsItem.modified_at = versionsItem.start.created_at;
                  versionsItem.modified_by = Feed_objectSpread({}, versionsItem.start.created_by);
                }
                if (
                  versionsItem.action_type === ACTION_TYPE_TRASHED &&
                  versionsItem.start?.trashed_at &&
                  versionsItem.start?.trashed_by
                ) {
                  versionsItem.trashed_at = versionsItem.start.trashed_at;
                  versionsItem.trashed_by = Feed_objectSpread({}, versionsItem.start.trashed_by);
                }
                if (
                  versionsItem.action_type === ACTION_TYPE_RESTORED &&
                  versionsItem.start?.restored_at &&
                  versionsItem.start?.restored_by
                ) {
                  versionsItem.restored_at = versionsItem.start.restored_at;
                  versionsItem.restored_by = Feed_objectSpread({}, versionsItem.start.restored_by);
                }
              }
              return versionsItem;
            }
            default: {
              return null;
            }
          }
        })
        .filter(item => !!item)
        .reverse();
      return parsedData;
    };
    class Feed extends api_Base {
      /**
       * @property {AnnotationsAPI}
       */

      /**
       * @property {VersionsAPI}
       */

      /**
       * @property {CommentsAPI}
       */

      /**
       * @property {AppActivityAPI}
       */

      /**
       * @property {TasksNewAPI}
       */

      /**
       * @property {TaskCollaboratorsAPI}
       */

      /**
       * @property {TaskLinksAPI}
       */

      /**
       * @property {ThreadedCommentsAPI}
       */

      /**
       * @property {FileActivitiesAPI}
       */

      /**
       * @property {BoxItem}
       */

      /**
       * @property {ElementsXhrError}
       */

      constructor(options) {
        super(options);
        Feed_defineProperty(
          this,
          'updateAnnotation',
          (file, annotationId, text, status, permissions, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            if (!text && !status) {
              throw getMissingItemTextOrStatus();
            }
            this.annotationsAPI = new Annotations(this.options);
            this.file = file;
            this.errorCallback = errorCallback;
            const feedItemChanges = {};
            if (text) {
              feedItemChanges.message = text;
            }
            if (status) {
              feedItemChanges.status = status;
            }
            this.updateFeedItem(
              Feed_objectSpread(
                Feed_objectSpread({}, feedItemChanges),
                {},
                {
                  isPending: true,
                },
              ),
              annotationId,
            );
            this.annotationsAPI.updateAnnotation(
              this.file.id,
              annotationId,
              permissions,
              feedItemChanges,
              annotation => {
                const { replies, total_reply_count } = annotation,
                  annotationBase = Feed_objectWithoutProperties(annotation, _excluded3);
                this.updateFeedItem(
                  Feed_objectSpread(
                    Feed_objectSpread({}, annotationBase),
                    {},
                    {
                      isPending: false,
                    },
                  ),
                  annotationId,
                );
                if (!this.isDestroyed()) {
                  successCallback(annotation);
                }
              },
              (e, code) => {
                this.updateCommentErrorCallback(e, code, annotationId);
              },
            );
          },
        );
        /**
         * Error callback for updating a comment
         *
         * @param {ElementsXhrError} e - the error returned by the API
         * @param {string} code - the error code
         * @param {string} id - the id of either an annotation or comment
         * @return {void}
         */
        Feed_defineProperty(this, 'updateCommentErrorCallback', (e, code, id) => {
          this.updateFeedItem(this.createFeedError(api_messages.commentUpdateErrorMessage), id);
          this.feedErrorCallback(true, e, code);
        });
        /**
         * Error callback for updating a reply
         *
         * @param {ElementsXhrError} error - the error returned by the API
         * @param {string} code - the error code
         * @param {string} id - the id of the reply (comment)
         * @param {string} parentId - the id of either the parent item (an annotation or comment)
         * @return {void}
         */
        Feed_defineProperty(this, 'updateReplyErrorCallback', (error, code, id, parentId) => {
          this.updateReplyItem(this.createFeedError(api_messages.commentUpdateErrorMessage), parentId, id);
          this.feedErrorCallback(true, error, code);
        });
        /**
         * Error callback for fetching replies
         *
         * @param {ElementsXhrError} error - the error returned by the API
         * @param {string} code - the error code
         * @param {string} id - the id of either an annotation or comment
         * @return {void}
         */
        Feed_defineProperty(this, 'fetchRepliesErrorCallback', (error, code, id) => {
          this.updateFeedItem(this.createFeedError(api_messages.repliesFetchErrorMessage), id);
          this.feedErrorCallback(true, error, code);
        });
        Feed_defineProperty(
          this,
          'deleteAnnotation',
          (file, annotationId, permissions, successCallBack, errorCallback) => {
            this.annotationsAPI = new Annotations(this.options);
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.updateFeedItem(
              {
                isPending: true,
              },
              annotationId,
            );
            this.annotationsAPI.deleteAnnotation(
              this.file.id,
              annotationId,
              permissions,
              this.deleteFeedItem.bind(this, annotationId, successCallBack),
              (error, code) => {
                // Reusing comment error handler since annotations are treated as comments to user
                this.deleteCommentErrorCallback(error, code, annotationId);
              },
            );
          },
        );
        /**
         * Callback for successful fetch of a comment
         *
         * @param {Function} resolve - resolve function
         * @param {Function} successCallback - success callback
         * @param {Comment} comment - comment data
         * @return {void}
         */
        Feed_defineProperty(this, 'fetchThreadedCommentSuccessCallback', (resolve, successCallback, comment) => {
          successCallback(comment);
          resolve();
        });
        /**
         * Updates a task assignment
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {string} taskId - ID of task to be updated
         * @param {string} taskCollaboratorId - Task assignment ID
         * @param {TaskCollabStatus} taskCollaboratorStatus - New task assignment status
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'updateTaskCollaborator',
          (file, taskId, taskCollaboratorId, taskCollaboratorStatus, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.updateFeedItem(
              {
                isPending: true,
              },
              taskId,
            );
            const collaboratorsApi = new tasks_TaskCollaborators(this.options);
            this.taskCollaboratorsAPI.push(collaboratorsApi);
            const taskCollaboratorPayload = {
              id: taskCollaboratorId,
              status: taskCollaboratorStatus,
            };
            const handleError = (e, code) => {
              let errorMessage;
              switch (taskCollaboratorStatus) {
                case TASK_NEW_APPROVED:
                  errorMessage = api_messages.taskApproveErrorMessage;
                  break;
                case TASK_NEW_COMPLETED:
                  errorMessage = api_messages.taskCompleteErrorMessage;
                  break;
                case TASK_NEW_REJECTED:
                  errorMessage = api_messages.taskRejectErrorMessage;
                  break;
                default:
                  errorMessage = api_messages.taskCompleteErrorMessage;
              }
              this.updateFeedItem(this.createFeedError(errorMessage, api_messages.taskActionErrorTitle), taskId);
              this.feedErrorCallback(true, e, code);
            };
            collaboratorsApi.updateTaskCollaborator({
              file,
              taskCollaborator: taskCollaboratorPayload,
              successCallback: taskCollab => {
                this.updateTaskCollaboratorSuccessCallback(taskId, file, taskCollab, successCallback, handleError);
              },
              errorCallback: handleError,
            });
          },
        );
        /**
         * Updates the task assignment state of the updated task
         *
         * @param {string} taskId - Box task id
         * @param {TaskAssignment} updatedCollaborator - New task assignment from API
         * @param {Function} successCallback - the function which will be called on success
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'updateTaskCollaboratorSuccessCallback',
          (taskId, file, updatedCollaborator, successCallback, errorCallback) => {
            this.tasksNewAPI = new tasks_TasksNew(this.options);
            this.tasksNewAPI.getTask({
              id: taskId,
              file,
              successCallback: task => {
                this.updateFeedItem(
                  Feed_objectSpread(
                    Feed_objectSpread({}, task),
                    {},
                    {
                      isPending: false,
                    },
                  ),
                  taskId,
                );
                successCallback(updatedCollaborator);
              },
              errorCallback,
            });
          },
        );
        /**
         * Updates a task in the new API
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {string} task - The update task payload object
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'updateTaskNew',
          async (file, task, successCallback = noop_default(), errorCallback = noop_default()) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.tasksNewAPI = new tasks_TasksNew(this.options);
            this.updateFeedItem(
              {
                isPending: true,
              },
              task.id,
            );
            try {
              // create request for the size of each group by ID
              // TODO: use async/await for both creating and editing tasks
              const groupInfoPromises = task.addedAssignees
                .filter(assignee => assignee.item && assignee.item.type === 'group')
                .map(assignee => assignee.id)
                .map(groupId => {
                  return new api_Groups(this.options).getGroupCount({
                    file,
                    group: {
                      id: groupId,
                    },
                  });
                });
              const groupCounts = await Promise.all(groupInfoPromises);
              const hasAnyGroupCountExceeded = groupCounts.some(
                groupInfo => groupInfo.total_count > TASK_MAX_GROUP_ASSIGNEES,
              );
              const warning = {
                code: ERROR_CODE_GROUP_EXCEEDS_LIMIT,
                type: 'warning',
              };
              if (hasAnyGroupCountExceeded) {
                this.feedErrorCallback(false, warning, ERROR_CODE_GROUP_EXCEEDS_LIMIT);
                return;
              }
              await new Promise((resolve, reject) => {
                this.tasksNewAPI.updateTaskWithDeps({
                  file,
                  task,
                  successCallback: resolve,
                  errorCallback: reject,
                });
              });
              await new Promise((resolve, reject) => {
                this.tasksNewAPI.getTask({
                  file,
                  id: task.id,
                  successCallback: taskData => {
                    this.updateFeedItem(
                      Feed_objectSpread(
                        Feed_objectSpread({}, taskData),
                        {},
                        {
                          isPending: false,
                        },
                      ),
                      task.id,
                    );
                    resolve();
                  },
                  errorCallback: e => {
                    this.updateFeedItem(
                      {
                        isPending: false,
                      },
                      task.id,
                    );
                    this.feedErrorCallback(false, e, ERROR_CODE_UPDATE_TASK);
                    reject();
                  },
                });
              });

              // everything succeeded, so call the passed in success callback
              if (!this.isDestroyed()) {
                successCallback();
              }
            } catch (e) {
              this.updateFeedItem(
                {
                  isPending: false,
                },
                task.id,
              );
              this.feedErrorCallback(false, e, ERROR_CODE_UPDATE_TASK);
            }
          },
        );
        /**
         * Deletes a comment.
         *
         * @param {BoxItem} file - The file to which the comment belongs to
         * @param {string} commentId - Comment ID
         * @param {BoxCommentPermission} permissions - Permissions for the comment
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteComment', (file, commentId, permissions, successCallback, errorCallback) => {
          this.commentsAPI = new api_Comments(this.options);
          if (!file.id) {
            throw error_getBadItemError();
          }
          this.file = file;
          this.errorCallback = errorCallback;
          this.updateFeedItem(
            {
              isPending: true,
            },
            commentId,
          );
          this.commentsAPI.deleteComment({
            file,
            commentId,
            permissions,
            successCallback: this.deleteFeedItem.bind(this, commentId, successCallback),
            errorCallback: (e, code) => {
              this.deleteCommentErrorCallback(e, code, commentId);
            },
          });
        });
        /**
         * Deletes a threaded comment (using ThreadedComments API).
         *
         * @param {BoxItem} file - The file to which the comment belongs to
         * @param {string} commentId - Comment ID
         * @param {BoxCommentPermission} permissions - Permissions for the comment
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'deleteThreadedComment',
          (file, commentId, permissions, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.updateFeedItem(
              {
                isPending: true,
              },
              commentId,
            );
            this.threadedCommentsAPI = new api_ThreadedComments(this.options);
            this.threadedCommentsAPI.deleteComment({
              fileId: file.id,
              commentId,
              permissions,
              successCallback: this.deleteFeedItem.bind(this, commentId, successCallback),
              errorCallback: (e, code) => {
                this.deleteCommentErrorCallback(e, code, commentId);
              },
            });
          },
        );
        /**
         * Deletes a reply (using ThreadedComments API).
         *
         * @param {BoxItem} file - The file to which the comment belongs to
         * @param {string} id - id of the reply (comment)
         * @param {string} parentId - id of the parent feed item
         * @param {BoxCommentPermission} permissions - Permissions for the comment
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteReply', (file, id, parentId, permissions, successCallback, errorCallback) => {
          if (!file.id) {
            throw error_getBadItemError();
          }
          this.file = file;
          this.errorCallback = errorCallback;
          this.updateReplyItem(
            {
              isPending: true,
            },
            parentId,
            id,
          );
          this.threadedCommentsAPI = new api_ThreadedComments(this.options);
          this.threadedCommentsAPI.deleteComment({
            fileId: file.id,
            commentId: id,
            permissions,
            successCallback: this.deleteReplySuccessCallback.bind(this, id, parentId, successCallback),
            errorCallback: (e, code) => {
              this.deleteReplyErrorCallback(e, code, id, parentId);
            },
          });
        });
        /**
         * Callback for successful deletion of a reply.
         *
         * @param {string} id - ID of the reply
         * @param {string} parentId - ID of the parent feed item
         * @param {Function} successCallback - success callback
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteReplySuccessCallback', (id, parentId, successCallback) => {
          this.modifyFeedItemRepliesCountBy(parentId, -1);
          this.deleteReplyItem(id, parentId, successCallback);
        });
        /**
         * Error callback for deleting a comment
         *
         * @param {ElementsXhrError} e - the error returned by the API
         * @param {string} code - the error code
         * @param {string} commentId - the comment id
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteCommentErrorCallback', (e, code, commentId) => {
          this.updateFeedItem(this.createFeedError(api_messages.commentDeleteErrorMessage), commentId);
          this.feedErrorCallback(true, e, code);
        });
        /**
         * Error callback for deleting a reply
         *
         * @param {ElementsXhrError} error - the error returned by the API
         * @param {string} code - the error code
         * @param {string} id - the reply (comment) id
         * @param {string} parentId - the comment id of the parent feed item
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteReplyErrorCallback', (error, code, id, parentId) => {
          this.updateReplyItem(this.createFeedError(api_messages.commentDeleteErrorMessage), parentId, id);
          this.feedErrorCallback(true, error, code);
        });
        /**
         * Creates a task.
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {Object} currentUser - the user who performed the action
         * @param {string} message - Task text
         * @param {Array} assignees - List of assignees
         * @param {number} dueAt - Task's due date
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'createTaskNew',
          (file, currentUser, message, assignees, taskType, dueAt, completionRule, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            const uuid = uniqueId_default()('task_');
            let dueAtString;
            if (dueAt) {
              const dueAtDate = new Date(dueAt);
              dueAtString = dueAtDate.toISOString();
            }

            // TODO: make pending task generator a function
            const pendingTask = {
              created_by: {
                type: 'task_collaborator',
                target: currentUser,
                id: uniqueId_default()(),
                role: 'CREATOR',
                status: TASK_NEW_INITIAL_STATUS,
              },
              completion_rule: completionRule,
              created_at: new Date().toISOString(),
              due_at: dueAtString,
              id: uuid,
              description: message,
              type: FEED_ITEM_TYPE_TASK,
              assigned_to: {
                entries: assignees.map(assignee => ({
                  id: uniqueId_default()(),
                  target: Feed_objectSpread(
                    Feed_objectSpread({}, assignee),
                    {},
                    {
                      avatar_url: '',
                      type: 'user',
                    },
                  ),
                  status: TASK_NEW_INITIAL_STATUS,
                  permissions: {
                    can_delete: false,
                    can_update: false,
                  },
                  role: 'ASSIGNEE',
                  type: 'task_collaborator',
                })),
                limit: 10,
                next_marker: null,
              },
              permissions: {
                can_update: false,
                can_delete: false,
                can_create_task_collaborator: false,
                can_create_task_link: false,
              },
              task_links: {
                entries: [
                  {
                    id: uniqueId_default()(),
                    type: 'task_link',
                    target: Feed_objectSpread(
                      {
                        type: 'file',
                      },
                      file,
                    ),
                    permissions: {
                      can_delete: false,
                      can_update: false,
                    },
                  },
                ],
                limit: 1,
                next_marker: null,
              },
              task_type: taskType,
              status: TASK_NEW_NOT_STARTED,
            };
            const taskPayload = {
              description: message,
              due_at: dueAtString,
              task_type: taskType,
              completion_rule: completionRule,
            };

            // create request for the size of each group by ID
            const groupInfoPromises = assignees
              .filter(assignee => (assignee.item && assignee.item.type) === 'group')
              .map(assignee => assignee.id)
              .map(groupId => {
                return new api_Groups(this.options).getGroupCount({
                  file,
                  group: {
                    id: groupId,
                  },
                });
              });

            // Fetch each group size in parallel --> return an array of group sizes
            Promise.all(groupInfoPromises)
              .then(groupCounts => {
                const hasAnyGroupCountExceeded = groupCounts.some(
                  groupInfo => groupInfo.total_count > TASK_MAX_GROUP_ASSIGNEES,
                );
                const warning = {
                  code: ERROR_CODE_GROUP_EXCEEDS_LIMIT,
                  type: 'warning',
                };
                if (hasAnyGroupCountExceeded) {
                  this.feedErrorCallback(false, warning, ERROR_CODE_GROUP_EXCEEDS_LIMIT);
                  return;
                }
                this.tasksNewAPI = new tasks_TasksNew(this.options);
                this.tasksNewAPI.createTaskWithDeps({
                  file,
                  task: taskPayload,
                  assignees,
                  successCallback: taskWithDepsData => {
                    this.addPendingItem(this.file.id, currentUser, pendingTask);
                    this.updateFeedItem(
                      Feed_objectSpread(
                        Feed_objectSpread({}, taskWithDepsData),
                        {},
                        {
                          task_links: {
                            entries: taskWithDepsData.task_links,
                            next_marker: null,
                            limit: 1,
                          },
                          assigned_to: {
                            entries: taskWithDepsData.assigned_to,
                            next_marker: null,
                            limit: taskWithDepsData.assigned_to.length,
                          },
                          isPending: false,
                        },
                      ),
                      uuid,
                    );
                    successCallback(taskWithDepsData);
                  },
                  errorCallback: (e, code) => {
                    this.feedErrorCallback(false, e, code);
                  },
                });
              })
              .catch(error => {
                this.feedErrorCallback(false, error, ERROR_CODE_CREATE_TASK);
              });
          },
        );
        /**
         * Deletes a task in the new API
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {string} taskId - The task's id
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'deleteTaskNew',
          (file, task, successCallback = noop_default(), errorCallback = noop_default()) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.tasksNewAPI = new tasks_TasksNew(this.options);
            this.updateFeedItem(
              {
                isPending: true,
              },
              task.id,
            );
            this.tasksNewAPI.deleteTask({
              file,
              task,
              successCallback: this.deleteFeedItem.bind(this, task.id, successCallback),
              errorCallback: (e, code) => {
                this.updateFeedItem(this.createFeedError(api_messages.taskDeleteErrorMessage), task.id);
                this.feedErrorCallback(true, e, code);
              },
            });
          },
        );
        /**
         * Deletes a feed item from the cache
         *
         * @param {string} id - The id of the feed item to be deleted
         * @param {Function} successCallback - function to be called after the delete
         */
        Feed_defineProperty(this, 'deleteFeedItem', (id, successCallback = noop_default()) => {
          const cachedItems = this.getCachedItems(this.file.id);
          if (cachedItems) {
            const feedItems = cachedItems.items.filter(feedItem => feedItem.id !== id);
            this.setCachedItems(this.file.id, feedItems);
            if (!this.isDestroyed()) {
              successCallback(id);
            }
          }
        });
        /**
         * Deletes a reply from the cache
         *
         * @param {string} id - The id of the feed item to be deleted
         * @param {string} parentId - The id of the parent feed item
         * @param {Function} successCallback - function to be called after the delete
         */
        Feed_defineProperty(this, 'deleteReplyItem', (id, parentId, successCallback = noop_default()) => {
          const cachedItems = this.getCachedItems(this.file.id) || {
            items: [],
            errors: [],
          };
          const feedItems = cachedItems.items.map(item => {
            if (item.id !== parentId) {
              return item;
            }
            if (item.type === FEED_ITEM_TYPE_ANNOTATION) {
              return getItemWithFilteredReplies(item, id);
            }
            if (item.type === FEED_ITEM_TYPE_COMMENT) {
              return getItemWithFilteredReplies(item, id);
            }
            return item;
          });
          this.setCachedItems(this.file.id, feedItems);
          if (!this.isDestroyed()) {
            successCallback(id, parentId);
          }
        });
        /**
         * Network error callback
         *
         * @param {boolean} hasError - true if the UI should display an error
         * @param {ElementsXhrError} e - the error returned by the API
         * @param {string} code - the error code for the error which occured
         * @return {void}
         */
        Feed_defineProperty(this, 'feedErrorCallback', (hasError = false, e, code) => {
          if (hasError) {
            this.errors.push(
              Feed_objectSpread(
                Feed_objectSpread({}, e),
                {},
                {
                  code,
                },
              ),
            );
          }
          if (!this.isDestroyed() && this.errorCallback) {
            this.errorCallback(e, code, {
              error: e,
              [IS_ERROR_DISPLAYED]: hasError,
            });
          }
          console.error(e); // eslint-disable-line no-console
        });
        /**
         * Add a placeholder pending feed item.
         *
         * @param {string} id - the file id
         * @param {Object} currentUser - the user who performed the action
         * @param {Object} itemBase - Base properties for item to be added to the feed as pending.
         * @return {void}
         */
        Feed_defineProperty(this, 'addPendingItem', (id, currentUser, itemBase) => {
          if (!currentUser) {
            throw getBadUserError();
          }
          const date = new Date().toISOString();
          const pendingFeedItem = Feed_objectSpread(
            {
              created_at: date,
              created_by: currentUser,
              modified_at: date,
              isPending: true,
            },
            itemBase,
          );
          const cachedItems = this.getCachedItems(this.file.id);
          const feedItems = cachedItems ? cachedItems.items : [];
          const feedItemsWithPendingItem = [...feedItems, pendingFeedItem];
          this.setCachedItems(id, feedItemsWithPendingItem);
          return pendingFeedItem;
        });
        /**
         * Add a placeholder pending comment (reply).
         *
         * @param {string} parentId - id of parent comment or annotation
         * @param {Object} currentUser - the user who performed the action
         * @param {Object} commentBase - Base properties for reply (comment) to be added to the feed as pending.
         * @return {Comment} - newly created pending reply
         */
        Feed_defineProperty(this, 'addPendingReply', (parentId, currentUser, commentBase) => {
          if (!this.file.id) {
            throw error_getBadItemError();
          }
          if (!currentUser) {
            throw getBadUserError();
          }
          const date = new Date().toISOString();
          const pendingReply = Feed_objectSpread(
            {
              created_at: date,
              created_by: currentUser,
              modified_at: date,
              isPending: true,
            },
            commentBase,
          );
          const cachedItems = this.getCachedItems(this.file.id);
          if (cachedItems) {
            const updatedFeedItems = cachedItems.items.map(item => {
              if (item.id === parentId && item.type === FEED_ITEM_TYPE_COMMENT) {
                return getItemWithPendingReply(item, pendingReply);
              }
              if (item.id === parentId && item.type === FEED_ITEM_TYPE_ANNOTATION) {
                return getItemWithPendingReply(item, pendingReply);
              }
              return item;
            });
            this.setCachedItems(this.file.id, updatedFeedItems);
          }
          return pendingReply;
        });
        /**
         * Callback for successful creation of a Comment.
         *
         * @param {Comment} commentData - API returned Comment
         * @param {string} id - ID of the feed item to update with the new comment data
         * @return {void}
         */
        Feed_defineProperty(this, 'createCommentSuccessCallback', (commentData, id, successCallback) => {
          const { message = '', tagged_message = '' } = commentData;
          // Comment component uses tagged_message only
          commentData.tagged_message = tagged_message || message;
          this.updateFeedItem(
            Feed_objectSpread(
              Feed_objectSpread({}, commentData),
              {},
              {
                isPending: false,
              },
            ),
            id,
          );
          if (!this.isDestroyed()) {
            successCallback(commentData);
          }
        });
        /**
         * Callback for failed creation of a Comment.
         *
         * @param {Object} e - The axios error
         * @param {string} code - the error code
         * @param {string} id - ID of the feed item to update
         * @return {void}
         */
        Feed_defineProperty(this, 'createCommentErrorCallback', (e, code, id) => {
          const errorMessage =
            e.status === HTTP_STATUS_CODE_CONFLICT
              ? api_messages.commentCreateConflictMessage
              : api_messages.commentCreateErrorMessage;
          this.updateFeedItem(this.createFeedError(errorMessage), id);
          this.feedErrorCallback(false, e, code);
        });
        /**
         * Callback for successful creation of a Comment.
         *
         * @param {Comment} commentData - API returned Comment
         * @param {string} parentId - ID of the parent feed item
         * @param {string} id - ID of the reply to update with the new comment data
         * @param {Function} successCallback - success callback
         * @return {void}
         */
        Feed_defineProperty(this, 'createReplySuccessCallback', (commentData, parentId, id, successCallback) => {
          this.updateReplyItem(
            Feed_objectSpread(
              Feed_objectSpread({}, commentData),
              {},
              {
                isPending: false,
              },
            ),
            parentId,
            id,
          );
          if (!this.isDestroyed()) {
            successCallback(commentData);
          }
        });
        /**
         * Callback for failed creation of a reply.
         *
         * @param {ElementsXhrError} error - The axios error
         * @param {string} code - the error code
         * @param {string} parentId - ID of the parent feed item
         * @param {string} id - ID of the feed item to update
         * @return {void}
         */
        Feed_defineProperty(this, 'createReplyErrorCallback', (error, code, parentId, id) => {
          const errorMessage =
            error.status === HTTP_STATUS_CODE_CONFLICT
              ? api_messages.commentCreateConflictMessage
              : api_messages.commentCreateErrorMessage;
          this.updateReplyItem(this.createFeedError(errorMessage), parentId, id);
          this.feedErrorCallback(false, error, code);
        });
        /**
         * Replace a feed item with new feed item data.
         *
         * @param {Object} updates - The new data to be applied to the feed item.
         * @param {string} id - ID of the feed item to replace.
         * @return {void}
         */
        Feed_defineProperty(this, 'updateFeedItem', (updates, id) => {
          if (!this.file.id) {
            throw error_getBadItemError();
          }
          const cachedItems = this.getCachedItems(this.file.id);
          if (cachedItems) {
            const updatedFeedItems = cachedItems.items.map(item => {
              if (item.id === id) {
                return Feed_objectSpread(Feed_objectSpread({}, item), updates);
              }
              return item;
            });
            this.setCachedItems(this.file.id, updatedFeedItems);
            return updatedFeedItems;
          }
          return null;
        });
        /**
         * Replace a reply of feed item with new comment data.
         *
         * @param {Object} replyUpdates - New data to be applied to the reply.
         * @param {string} parentId - ID of the parent feed item.
         * @param {string} id - ID of the reply to replace.
         * @return {void}
         */
        Feed_defineProperty(this, 'updateReplyItem', (replyUpdates, parentId, id) => {
          if (!this.file.id) {
            throw error_getBadItemError();
          }
          const getItemWithUpdatedReply = (item, replyId, updates) => {
            const updatedItem = Feed_objectSpread({}, item);
            if (updatedItem.replies) {
              updatedItem.replies = updatedItem.replies.map(reply => {
                if (reply.id === replyId) {
                  return Feed_objectSpread(Feed_objectSpread({}, reply), updates);
                }
                return reply;
              });
            }
            return updatedItem;
          };
          const cachedItems = this.getCachedItems(this.file.id);
          if (cachedItems) {
            const updatedFeedItems = cachedItems.items.map(item => {
              if (item.id === parentId && item.type === FEED_ITEM_TYPE_COMMENT) {
                return getItemWithUpdatedReply(item, id, replyUpdates);
              }
              if (item.id === parentId && item.type === FEED_ITEM_TYPE_ANNOTATION) {
                return getItemWithUpdatedReply(item, id, replyUpdates);
              }
              return item;
            });
            this.setCachedItems(this.file.id, updatedFeedItems);
          }
        });
        /**
         * Create a comment, and make a pending item to be replaced once the API is successful.
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {Object} currentUser - the user who performed the action
         * @param {string} text - the comment text
         * @param {boolean} hasMention - true if there is an @mention in the text
         * @param {Function} successCallback - the success callback
         * @param {Function} errorCallback - the error callback
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'createComment',
          (file, currentUser, text, hasMention, successCallback, errorCallback) => {
            const uuid = uniqueId_default()('comment_');
            const commentData = {
              id: uuid,
              tagged_message: text,
              type: FEED_ITEM_TYPE_COMMENT,
            };
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.addPendingItem(this.file.id, currentUser, commentData);
            const message = {};
            if (hasMention) {
              message.taggedMessage = text;
            } else {
              message.message = text;
            }
            this.commentsAPI = new api_Comments(this.options);
            this.commentsAPI.createComment(
              Feed_objectSpread(
                Feed_objectSpread(
                  {
                    file,
                  },
                  message,
                ),
                {},
                {
                  successCallback: comment => {
                    this.createCommentSuccessCallback(comment, uuid, successCallback);
                  },
                  errorCallback: (e, code) => {
                    this.createCommentErrorCallback(e, code, uuid);
                  },
                },
              ),
            );
          },
        );
        /**
         * Create a threaded comment (using ThreadedComments API),
         * and make a pending item to be replaced once the API is successful.
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {Object} currentUser - the user who performed the action
         * @param {string} text - the comment text
         * @param {Function} successCallback - the success callback
         * @param {Function} errorCallback - the error callback
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'createThreadedComment',
          (file, currentUser, text, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            const uuid = uniqueId_default()('comment_');
            const commentData = {
              id: uuid,
              tagged_message: text,
              type: FEED_ITEM_TYPE_COMMENT,
            };
            this.file = file;
            this.errorCallback = errorCallback;
            this.addPendingItem(this.file.id, currentUser, commentData);
            this.threadedCommentsAPI = new api_ThreadedComments(this.options);
            this.threadedCommentsAPI.createComment({
              file,
              message: text,
              successCallback: comment => {
                this.createCommentSuccessCallback(comment, uuid, successCallback);
              },
              errorCallback: (e, code) => {
                this.createCommentErrorCallback(e, code, uuid);
              },
            });
          },
        );
        /**
         * Update a comment
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {string} commentId - Comment ID
         * @param {string} text - the comment text
         * @param {boolean} hasMention - true if there is an @mention in the text
         * @param {BoxCommentPermission} permissions - Permissions to attach to the app activity items
         * @param {Function} successCallback - the success callback
         * @param {Function} errorCallback - the error callback
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'updateComment',
          (file, commentId, text, hasMention, permissions, successCallback, errorCallback) => {
            const commentData = {
              tagged_message: text,
            };
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.updateFeedItem(
              Feed_objectSpread(
                Feed_objectSpread({}, commentData),
                {},
                {
                  isPending: true,
                },
              ),
              commentId,
            );
            const message = {};
            if (hasMention) {
              message.tagged_message = text;
            } else {
              message.message = text;
            }
            this.commentsAPI = new api_Comments(this.options);
            this.commentsAPI.updateComment(
              Feed_objectSpread(
                Feed_objectSpread(
                  {
                    file,
                    commentId,
                    permissions,
                  },
                  message,
                ),
                {},
                {
                  successCallback: comment => {
                    // use the request payload instead of response in the
                    // feed item update because response may not contain
                    // the tagged version of the message
                    this.updateFeedItem(
                      Feed_objectSpread(
                        Feed_objectSpread({}, message),
                        {},
                        {
                          isPending: false,
                        },
                      ),
                      commentId,
                    );
                    if (!this.isDestroyed()) {
                      successCallback(comment);
                    }
                  },
                  errorCallback: (e, code) => {
                    this.updateCommentErrorCallback(e, code, commentId);
                  },
                },
              ),
            );
          },
        );
        /**
         * Update a threaded comment
         *
         * @param {BoxItem} file - The file to which the task is assigned
         * @param {string} commentId - Comment ID
         * @param {string} text - the comment text
         * @param {FeedItemStatus} status - status of the comment
         * @param {BoxCommentPermission} permissions - Permissions to attach to the app activity items
         * @param {Function} successCallback - the success callback
         * @param {Function} errorCallback - the error callback
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'updateThreadedComment',
          (file, commentId, text, status, permissions, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            if (!text && !status) {
              throw getMissingItemTextOrStatus();
            }
            const commentData = {};
            if (text) {
              commentData.tagged_message = text;
            }
            if (status) {
              commentData.status = status;
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.updateFeedItem(
              Feed_objectSpread(
                Feed_objectSpread({}, commentData),
                {},
                {
                  isPending: true,
                },
              ),
              commentId,
            );
            this.threadedCommentsAPI = new api_ThreadedComments(this.options);
            this.threadedCommentsAPI.updateComment({
              fileId: file.id,
              commentId,
              permissions,
              message: text,
              status,
              successCallback: comment => {
                const { replies, total_reply_count } = comment,
                  commentBase = Feed_objectWithoutProperties(comment, _excluded4);
                this.updateFeedItem(
                  Feed_objectSpread(
                    Feed_objectSpread({}, commentBase),
                    {},
                    {
                      isPending: false,
                    },
                  ),
                  commentId,
                );
                if (!this.isDestroyed()) {
                  successCallback(comment);
                }
              },
              errorCallback: (e, code) => {
                this.updateCommentErrorCallback(e, code, commentId);
              },
            });
          },
        );
        /**
         * Update a reply
         *
         * @param {BoxItem} file - The file to which the reply with its parent is assigned
         * @param {string} id - id of the reply
         * @param {string} parentId - id of the parent item
         * @param {string} text - the updated text
         * @param {BoxCommentPermission} permissions - Permissions to attach to the app activity items
         * @param {Function} successCallback - the success callback
         * @param {Function} errorCallback - the error callback
         * @return {void}
         */
        Feed_defineProperty(
          this,
          'updateReply',
          (file, id, parentId, text, permissions, successCallback, errorCallback) => {
            if (!file.id) {
              throw error_getBadItemError();
            }
            this.file = file;
            this.errorCallback = errorCallback;
            this.updateReplyItem(
              {
                tagged_message: text,
                isPending: true,
              },
              parentId,
              id,
            );
            this.threadedCommentsAPI = new api_ThreadedComments(this.options);
            this.threadedCommentsAPI.updateComment({
              fileId: file.id,
              commentId: id,
              permissions,
              message: text,
              undefined,
              successCallback: comment => {
                this.updateReplyItem(
                  Feed_objectSpread(
                    Feed_objectSpread({}, comment),
                    {},
                    {
                      isPending: false,
                    },
                  ),
                  parentId,
                  id,
                );
                if (!this.isDestroyed()) {
                  successCallback(comment);
                }
              },
              errorCallback: (error, code) => {
                this.updateReplyErrorCallback(error, code, id, parentId);
              },
            });
          },
        );
        /**
         * Modify feed item replies count
         *
         * @param {string} id - id of the item
         * @param {number} n - number to modify the count by
         * @return {void}
         */
        Feed_defineProperty(this, 'modifyFeedItemRepliesCountBy', (id, n) => {
          if (!this.file.id) {
            throw error_getBadItemError();
          }
          const { items: feedItems = [] } = this.getCachedItems(this.file.id) || {};
          const feedItem = feedItems.find(({ id: itemId }) => itemId === id);
          if (!feedItem || (feedItem.type !== 'annotation' && feedItem.type !== 'comment')) {
            return;
          }
          const newReplyCount = (feedItem.total_reply_count || 0) + n;
          if (newReplyCount >= 0) {
            this.updateFeedItem(
              {
                total_reply_count: newReplyCount,
              },
              id,
            );
          }
        });
        /**
         * Deletes an app activity item.
         *
         * @param {BoxItem} file - The file to which the app activity belongs to
         * @param {string} appActivityId - The app activity item id to delete
         * @param {Function} successCallback - the function which will be called on success
         * @param {Function} errorCallback - the function which will be called on error
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteAppActivity', (file, appActivityId, successCallback, errorCallback) => {
          const { id } = file;
          if (!id) {
            throw error_getBadItemError();
          }
          this.appActivityAPI = new api_AppActivity(this.options);
          this.file = file;
          this.errorCallback = errorCallback;
          this.updateFeedItem(
            {
              isPending: true,
            },
            appActivityId,
          );
          this.appActivityAPI.deleteAppActivity({
            id,
            appActivityId,
            successCallback: this.deleteFeedItem.bind(this, appActivityId, successCallback),
            errorCallback: (e, code) => {
              this.deleteAppActivityErrorCallback(e, code, appActivityId);
            },
          });
        });
        /**
         * Error callback for deleting an app activity item
         *
         * @param {ElementsXhrError} e - the error returned by the API
         * @param {string} code - the error code
         * @param {string} id - the app activity id
         * @return {void}
         */
        Feed_defineProperty(this, 'deleteAppActivityErrorCallback', (e, code, id) => {
          this.updateFeedItem(this.createFeedError(api_messages.appActivityDeleteErrorMessage), id);
          this.feedErrorCallback(true, e, code);
        });
        this.taskCollaboratorsAPI = [];
        this.taskLinksAPI = [];
        this.errors = [];
      }

      /**
       * Creates pending card on create_start action, then updates card on next call
       * @param {BoxItem} file - The file to which the annotation is assigned
       * @param {Object} currentUser - the user who performed the action
       * @param {Annotation} annotation - the current annotation to be created
       * @param {string} id - unique id for the incoming annotation
       * @param {boolean} isPending - indicates the current creation process of the annotation
       */
      addAnnotation(file, currentUser, annotation, id, isPending) {
        if (!file.id) {
          throw error_getBadItemError();
        }
        this.file = file;

        // Add the pending interstitial card
        if (isPending) {
          const newAnnotation = Feed_objectSpread(
            Feed_objectSpread({}, annotation),
            {},
            {
              created_by: currentUser,
              id,
              type: FEED_ITEM_TYPE_ANNOTATION,
            },
          );
          this.addPendingItem(this.file.id, currentUser, newAnnotation);
          return;
        }
        // Create action has completed, so update the existing pending item
        this.updateFeedItem(
          Feed_objectSpread(
            Feed_objectSpread({}, annotation),
            {},
            {
              isPending: false,
            },
          ),
          id,
        );
      }
      /**
       * Creates a key for the cache
       *
       * @param {string} id folder id
       * @return {string} key
       */
      getCacheKey(id) {
        return `${TYPED_ID_FEED_PREFIX}${id}`;
      }

      /**
       * Gets the items from the cache
       *
       * @param {string} id the cache id
       */
      getCachedItems(id) {
        const cache = this.getCache();
        const cacheKey = this.getCacheKey(id);
        return cache.get(cacheKey);
      }

      /**
       * Sets the items in the cache
       *
       * @param {string} id - the cache id
       * @param {Array} items - the feed items to cache
       */
      setCachedItems(id, items) {
        const cache = this.getCache();
        const cacheKey = this.getCacheKey(id);
        cache.set(cacheKey, {
          errors: this.errors,
          items,
        });
      }

      /**
       * Gets the feed items
       *
       * @param {BoxItem} file - The file to which the task is assigned
       * @param {boolean} shouldRefreshCache - Optionally updates the cache
       * @param {Function} successCallback - the success callback  which is called after data fetching is complete
       * @param {Function} errorCallback - the error callback which is called after data fetching is complete if there was an error
       * @param {Function} onError - the function to be called immediately after an error occurs
       * @param {Object} [options]- feature flips, etc
       * @param {Object} [options.shouldShowAppActivity] - feature flip the new app activity api
       */
      feedItems(
        file,
        shouldRefreshCache,
        successCallback,
        errorCallback,
        onError,
        {
          shouldShowAnnotations = false,
          shouldShowAppActivity = false,
          shouldShowReplies = false,
          shouldShowTasks = true,
          shouldShowVersions = true,
          shouldUseUAA = false,
        } = {},
      ) {
        const { id, permissions = {} } = file;
        const cachedItems = this.getCachedItems(id);
        if (cachedItems) {
          const { errors, items } = cachedItems;
          if (errors.length) {
            errorCallback(items, errors);
          } else {
            successCallback(items);
          }
          if (!shouldRefreshCache) {
            return;
          }
        }
        this.file = file;
        this.errors = [];
        this.errorCallback = onError;

        // Using the UAA File Activities endpoint replaces the need for these calls
        const annotationsPromise =
          !shouldUseUAA && shouldShowAnnotations
            ? this.fetchAnnotations(permissions, shouldShowReplies)
            : Promise.resolve();
        const commentsPromise = () => {
          if (shouldUseUAA) {
            return Promise.resolve();
          }
          return shouldShowReplies ? this.fetchThreadedComments(permissions) : this.fetchComments(permissions);
        };
        const tasksPromise = !shouldUseUAA && shouldShowTasks ? this.fetchTasksNew() : Promise.resolve();
        const appActivityPromise =
          !shouldUseUAA && shouldShowAppActivity ? this.fetchAppActivity(permissions) : Promise.resolve();
        const versionsPromise = !shouldUseUAA && shouldShowVersions ? this.fetchVersions() : Promise.resolve();
        const currentVersionPromise =
          !shouldUseUAA && shouldShowVersions ? this.fetchCurrentVersion() : Promise.resolve();
        const annotationActivityType =
          shouldShowAnnotations && permissions[PERMISSION_CAN_VIEW_ANNOTATIONS] ? [FILE_ACTIVITY_TYPE_ANNOTATION] : [];
        const appActivityActivityType = shouldShowAppActivity ? [FILE_ACTIVITY_TYPE_APP_ACTIVITY] : [];
        const taskActivityType = shouldShowTasks ? [FILE_ACTIVITY_TYPE_TASK] : [];
        const versionsActivityType = shouldShowVersions ? [FILE_ACTIVITY_TYPE_VERSION] : [];
        const commentActivityType = permissions[PERMISSION_CAN_COMMENT] ? [FILE_ACTIVITY_TYPE_COMMENT] : [];
        const filteredActivityTypes = [
          ...annotationActivityType,
          ...appActivityActivityType,
          ...commentActivityType,
          ...taskActivityType,
          ...versionsActivityType,
        ];
        const fileActivitiesPromise =
          // Only fetch when activity types are explicitly stated
          shouldUseUAA && filteredActivityTypes.length
            ? this.fetchFileActivities(permissions, filteredActivityTypes, shouldShowReplies)
            : Promise.resolve();
        const handleFeedItems = feedItems => {
          if (!this.isDestroyed()) {
            this.setCachedItems(id, feedItems);
            if (this.errors.length) {
              errorCallback(feedItems, this.errors);
            } else {
              successCallback(feedItems);
            }
          }
        };
        if (shouldUseUAA) {
          fileActivitiesPromise.then(response => {
            if (!response) {
              return;
            }
            const parsedFeedItems = getParsedFileActivitiesResponse(response);
            handleFeedItems(parsedFeedItems);
          });
        } else {
          Promise.all([
            versionsPromise,
            currentVersionPromise,
            commentsPromise(),
            tasksPromise,
            appActivityPromise,
            annotationsPromise,
          ]).then(([versions, currentVersion, ...feedItems]) => {
            const versionsWithCurrent = currentVersion
              ? this.versionsAPI.addCurrentVersion(currentVersion, versions, this.file)
              : undefined;
            const sortedFeedItems = sortFeedItems(versionsWithCurrent, ...feedItems);
            handleFeedItems(sortedFeedItems);
          });
        }
      }
      fetchAnnotations(permissions, shouldFetchReplies) {
        this.annotationsAPI = new Annotations(this.options);
        return new Promise(resolve => {
          this.annotationsAPI.getAnnotations(
            this.file.id,
            undefined,
            permissions,
            resolve,
            this.fetchFeedItemErrorCallback.bind(this, resolve),
            undefined,
            undefined,
            shouldFetchReplies,
          );
        });
      }

      /**
       * Fetches the comments for a file
       *
       * @param {Object} permissions - the file permissions
       * @return {Promise} - the file comments
       */
      fetchComments(permissions) {
        this.commentsAPI = new api_Comments(this.options);
        return new Promise(resolve => {
          this.commentsAPI.getComments(
            this.file.id,
            permissions,
            resolve,
            this.fetchFeedItemErrorCallback.bind(this, resolve),
          );
        });
      }

      /**
       * Fetches a comment for a file
       *
       * @param {BoxItem} file - The file to which the comment belongs to
       * @param {string} commentId - comment id
       * @param {Function} successCallback
       * @param {ErrorCallback} errorCallback
       * @return {Promise} - the file comments
       */
      fetchThreadedComment(file, commentId, successCallback, errorCallback) {
        const { id, permissions } = file;
        if (!id || !permissions) {
          throw error_getBadItemError();
        }
        this.threadedCommentsAPI = new api_ThreadedComments(this.options);
        return new Promise(resolve => {
          this.threadedCommentsAPI.getComment({
            commentId,
            errorCallback,
            fileId: id,
            permissions,
            successCallback: this.fetchThreadedCommentSuccessCallback.bind(this, resolve, successCallback),
          });
        });
      }
      /**
       * Fetches the comments with replies for a file
       *
       * @param {Object} permissions - the file permissions
       * @return {Promise} - the file comments
       */
      fetchThreadedComments(permissions) {
        this.threadedCommentsAPI = new api_ThreadedComments(this.options);
        return new Promise(resolve => {
          this.threadedCommentsAPI.getComments({
            errorCallback: this.fetchFeedItemErrorCallback.bind(this, resolve),
            fileId: this.file.id,
            permissions,
            successCallback: resolve,
          });
        });
      }

      /**
       * Fetches the file activities for a file
       *
       * @param {BoxItemPermission} permissions - the file permissions
       * @param {FileActivityTypes[]} activityTypes - the activity types to filter by
       * @param {boolean} shouldShowReplies - specify if replies should be included in the response
       * @return {Promise} - the file comments
       */
      fetchFileActivities(permissions, activityTypes, shouldShowReplies = false) {
        this.fileActivitiesAPI = new api_FileActivities(this.options);
        return new Promise(resolve => {
          this.fileActivitiesAPI.getActivities({
            errorCallback: this.fetchFeedItemErrorCallback.bind(this, resolve),
            fileID: this.file.id,
            permissions,
            successCallback: resolve,
            activityTypes,
            shouldShowReplies,
          });
        });
      }

      /**
       * Fetches replies (comments) of a comment or annotation
       *
       * @param {BoxItem} file - The file to which the comment or annotation belongs to
       * @param {string} commentFeedItemId - ID of the comment or annotation
       * @param {CommentFeedItemType} commentFeedItemType - Type of the comment or annotation
       * @param {Function} successCallback
       * @param {ErrorCallback} errorCallback
       * @return {void}
       */
      fetchReplies(file, commentFeedItemId, commentFeedItemType, successCallback, errorCallback) {
        const { id, permissions } = file;
        if (!id || !permissions) {
          throw error_getBadItemError();
        }
        this.file = file;
        this.errorCallback = errorCallback;
        this.updateFeedItem(
          {
            isRepliesLoading: true,
          },
          commentFeedItemId,
        );
        const successCallbackFn = ({ entries }) => {
          this.updateFeedItem(
            {
              isRepliesLoading: false,
              replies: entries,
              total_reply_count: entries.length,
            },
            commentFeedItemId,
          );
          successCallback(entries);
        };
        const errorCallbackFn = (error, code) => {
          this.fetchRepliesErrorCallback(error, code, commentFeedItemId);
        };
        if (commentFeedItemType === FEED_ITEM_TYPE_ANNOTATION) {
          this.annotationsAPI = new Annotations(this.options);
          this.annotationsAPI.getAnnotationReplies(
            file.id,
            commentFeedItemId,
            permissions,
            successCallbackFn,
            errorCallbackFn,
          );
        } else if (commentFeedItemType === FEED_ITEM_TYPE_COMMENT) {
          this.threadedCommentsAPI = new api_ThreadedComments(this.options);
          this.threadedCommentsAPI.getCommentReplies({
            fileId: file.id,
            commentId: commentFeedItemId,
            permissions,
            successCallback: successCallbackFn,
            errorCallback: errorCallbackFn,
          });
        }
      }

      /**
       * Fetches the versions for a file
       *
       * @return {Promise} - the file versions
       */
      fetchVersions() {
        this.versionsAPI = new api_Versions(this.options);
        return new Promise(resolve => {
          this.versionsAPI.getVersions(
            this.file.id,
            resolve,
            this.fetchFeedItemErrorCallback.bind(this, resolve),
            undefined,
            undefined,
            FEED_FILE_VERSIONS_FIELDS_TO_FETCH,
          );
        });
      }

      /**
       * Fetches the current version for a file
       *
       * @return {Promise} - the file versions
       */
      fetchCurrentVersion() {
        this.versionsAPI = new api_Versions(this.options);
        return new Promise(resolve => {
          const { file_version = {} } = this.file;
          this.versionsAPI.getVersion(
            this.file.id,
            file_version.id,
            resolve,
            this.fetchFeedItemErrorCallback.bind(this, resolve),
          );
        });
      }

      /**
       * Fetches the tasks for a file
       *
       * @return {Promise} - the feed items
       */
      fetchTasksNew() {
        this.tasksNewAPI = new tasks_TasksNew(this.options);
        return new Promise(resolve => {
          this.tasksNewAPI.getTasksForFile({
            file: {
              id: this.file.id,
            },
            successCallback: resolve,
            errorCallback: (err, code) => this.fetchFeedItemErrorCallback(resolve, err, code),
          });
        });
      }

      /**
       * Error callback for fetching feed items.
       * Should only call the error callback if the response is a 401, 429 or >= 500
       *
       * @param {Function} resolve - the function which will be called on error
       * @param {Object} e - the axios error
       * @param {string} code - the error code
       * @return {void}
       */
      fetchFeedItemErrorCallback(resolve, e, code) {
        const { status } = e;
        const shouldDisplayError = isUserCorrectableError(status);
        this.feedErrorCallback(shouldDisplayError, e, code);
        resolve();
      }
      /**
       * Creates a task group via the API.
       *
       * @param {BoxItem} file - The file to which the task is assigned
       * @param {Task|TaskUpdatePayload} task - The newly created or existing task from the API
       * @param {SelectorItem} assignee - The user assigned to this task
       * @param {Function} errorCallback - Task create error callback
       * @return {Promise<TaskAssignment>}
       */
      createTaskCollaboratorsforGroup(file, task, assignee) {
        if (!file.id) {
          throw error_getBadItemError();
        }
        this.file = file;
        return new Promise((resolve, reject) => {
          const taskCollaboratorsAPI = new tasks_TaskCollaborators(this.options);
          this.taskCollaboratorsAPI.push(taskCollaboratorsAPI);
          taskCollaboratorsAPI.createTaskCollaboratorsforGroup({
            file,
            task,
            group: assignee,
            successCallback: resolve,
            errorCallback: e => {
              reject(e);
            },
          });
        });
      }

      /**
       * Creates a task collaborator via the API.
       *
       * @param {BoxItem} file - The file to which the task is assigned
       * @param {Task|TaskUpdatePayload} task - The newly created or existing task from the API
       * @param {SelectorItem} assignee - The user assigned to this task
       * @param {Function} errorCallback - Task create error callback
       * @return {Promise<TaskAssignment>}
       */
      createTaskCollaborator(file, task, assignee) {
        if (!file.id) {
          throw error_getBadItemError();
        }
        this.file = file;
        return new Promise((resolve, reject) => {
          const taskCollaboratorsAPI = new tasks_TaskCollaborators(this.options);
          this.taskCollaboratorsAPI.push(taskCollaboratorsAPI);
          taskCollaboratorsAPI.createTaskCollaborator({
            file,
            task,
            user: assignee,
            successCallback: resolve,
            errorCallback: e => {
              reject(e);
            },
          });
        });
      }

      /**
       * Deletes a task collaborator via the API.
       *
       * @param {BoxItem} file - The file to which the task is assigned
       * @param {Task|TaskUpdatePayload} task - The newly deleted or existing task from the API
       * @param {TaskCollabAssignee} assignee - The user assigned to this task
       * @param {Function} errorCallback - Task delete error callback
       * @return {Promise<TaskAssignment>}
       */
      deleteTaskCollaborator(file, task, assignee) {
        if (!file.id) {
          throw error_getBadItemError();
        }
        this.file.id = file.id;
        return new Promise((resolve, reject) => {
          const taskCollaboratorsAPI = new tasks_TaskCollaborators(this.options);
          this.taskCollaboratorsAPI.push(taskCollaboratorsAPI);
          taskCollaboratorsAPI.deleteTaskCollaborator({
            file,
            task,
            taskCollaborator: {
              id: assignee.id,
            },
            successCallback: resolve,
            errorCallback: e => {
              reject(e);
            },
          });
        });
      }

      /**
       * Creates a task link via the API.
       *
       * @param {BoxItem} file - The file to which the task is assigned
       * @param {Task} task - The newly created task from the API
       * @param {Function} errorCallback - Task create error callback
       * @return {Promise<TaskAssignment}
       */
      createTaskLink(file, task) {
        if (!file.id) {
          throw error_getBadItemError();
        }
        this.file = file;
        return new Promise((resolve, reject) => {
          const taskLinksAPI = new tasks_TaskLinks(this.options);
          this.taskLinksAPI.push(taskLinksAPI);
          taskLinksAPI.createTaskLink({
            file,
            task,
            successCallback: resolve,
            errorCallback: reject,
          });
        });
      }
      /**
       * Constructs an error object that renders to an inline feed error
       *
       * @param {string} message - The error message body.
       * @param {string} title - The error message title.
       * @return {Object} An error message object
       */
      createFeedError(message, title = common_messages.errorOccured) {
        return {
          error: {
            message,
            title,
          },
        };
      }
      /**
       * Create a reply to annotation or comment, and make a pending item to be replaced once the API is successful.
       *
       * @param {BoxItem} file - The file to which the task is assigned
       * @param {Object} currentUser - the user who performed the action
       * @param {string} parentId - id of the parent item
       * @param {CommentFeedItemType} parentType - type of the parent item
       * @param {string} text - the comment text
       * @param {Function} successCallback - the success callback
       * @param {Function} errorCallback - the error callback
       * @return {void}
       */
      createReply(file, currentUser, parentId, parentType, text, successCallback, errorCallback) {
        const { id, permissions } = file;
        if (!id || !permissions) {
          throw error_getBadItemError();
        }
        const uuid = uniqueId_default()('comment_');
        const commentData = {
          id: uuid,
          tagged_message: text,
          type: FEED_ITEM_TYPE_COMMENT,
        };
        this.file = file;
        this.errorCallback = errorCallback;
        this.addPendingReply(parentId, currentUser, commentData);
        this.modifyFeedItemRepliesCountBy(parentId, 1);
        const successCallbackFn = comment => {
          this.createReplySuccessCallback(comment, parentId, uuid, successCallback);
        };
        const errorCallbackFn = (error, code) => {
          this.createReplyErrorCallback(error, code, parentId, uuid);
        };
        if (parentType === FEED_ITEM_TYPE_ANNOTATION) {
          this.annotationsAPI = new Annotations(this.options);
          this.annotationsAPI.createAnnotationReply(
            file.id,
            parentId,
            permissions,
            text,
            successCallbackFn,
            errorCallbackFn,
          );
        } else if (parentType === FEED_ITEM_TYPE_COMMENT) {
          this.threadedCommentsAPI = new api_ThreadedComments(this.options);
          this.threadedCommentsAPI.createCommentReply({
            fileId: file.id,
            commentId: parentId,
            permissions,
            message: text,
            successCallback: successCallbackFn,
            errorCallback: errorCallbackFn,
          });
        }
      }
      destroyTaskCollaborators() {
        if (Array.isArray(this.taskCollaboratorsAPI)) {
          this.taskCollaboratorsAPI.forEach(api => api.destroy());
          this.taskCollaboratorsAPI = [];
        }
      }
      destroyTaskLinks() {
        if (Array.isArray(this.taskLinksAPI)) {
          this.taskLinksAPI.forEach(api => api.destroy());
          this.taskLinksAPI = [];
        }
      }

      /**
       * Fetches app activities for a file
       * @param {BoxItemPermission} permissions - Permissions to attach to the app activity items
       *
       * @return {Promise} - the feed items
       */
      fetchAppActivity(permissions) {
        this.appActivityAPI = new api_AppActivity(this.options);
        return new Promise(resolve => {
          this.appActivityAPI.getAppActivity(
            this.file.id,
            permissions,
            resolve,
            this.fetchFeedItemErrorCallback.bind(this, resolve),
          );
        });
      }
      /**
       * Destroys all the task feed API's
       *
       * @return {void}
       */
      destroy() {
        super.destroy();
        if (this.annotationsAPI) {
          this.annotationsAPI.destroy();
          delete this.annotationsAPI;
        }
        if (this.commentsAPI) {
          this.commentsAPI.destroy();
          delete this.commentsAPI;
        }
        if (this.threadedCommentsAPI) {
          this.threadedCommentsAPI.destroy();
          delete this.threadedCommentsAPI;
        }
        if (this.versionsAPI) {
          this.versionsAPI.destroy();
          delete this.versionsAPI;
        }
        if (this.appActivityAPI) {
          this.appActivityAPI.destroy();
          delete this.appActivityAPI;
        }
        if (this.tasksNewAPI) {
          this.tasksNewAPI.destroy();
          delete this.tasksNewAPI;
        }
        this.destroyTaskCollaborators();
        this.destroyTaskLinks();
      }
    }
    /* harmony default export */ const api_Feed = Feed; // CONCATENATED MODULE: ./src/api/AppIntegrations.js
    /**
     *
     * @file Helper for the app_integrations API endpoint
     * @author Box
     */

    class AppIntegrations extends api_Base {
      /**
       * API URL for Open With
       *
       * @param {string} [integrationId] - a box integration app ID
       * @return {string} base url for app integrations
       */
      getUrl(integrationId) {
        if (!integrationId) {
          throw new Error('Missing app integration id!');
        }
        return `${this.getBaseApiUrl()}/app_integrations/${integrationId}`;
      }

      /**
       * API endpoint to execute an integration, given an ID
       *
       * @param {string} integrationID - An app integration ID
       * @param {string} fileID - A file ID
       * @return {string} base url for files
       */
      execute(integrationId, fileId, successCallback, errorCallback) {
        if (!integrationId) {
          throw new Error('Missing integration id!');
        }
        if (!fileId) {
          throw new Error('Missing file id!');
        }
        this.errorCode = ERROR_CODE_EXECUTE_INTEGRATION;
        const executeURL = `${this.getUrl(integrationId)}/execute`;
        const body = {
          data: {
            item: {
              id: fileId,
              type: constants_TYPE_FILE,
            },
          },
        };
        this.post({
          id: fileId,
          url: executeURL,
          data: body,
          successCallback,
          errorCallback,
        });
      }
    }
    /* harmony default export */ const api_AppIntegrations = AppIntegrations; // CONCATENATED MODULE: ./src/api/OpenWith.js
    /**
     *
     * @file Helper for the open_with_integrations API endpoint
     * @author Box
     */

    class OpenWith extends api_Base {
      /**
       * API URL for Open With
       *
       * @param {string} [id] - a box file id
       * @return {string} base url for files
       */
      getUrl(id) {
        if (!id) {
          throw new Error('Missing file id!');
        }
        return `${this.getBaseApiUrl()}/files/${id}/open_with_integrations`;
      }

      /**
       * Gets Open With integration data
       *
       * @param {string} fileId - Box file ID
       * @param {Function} successCallback - Success callback
       * @param {Function} errorCallback - Error callback
       * @return {void}
       */
      getOpenWithIntegrations(fileId, successCallback, errorCallback) {
        this.errorCode = ERROR_CODE_FETCH_INTEGRATIONS;
        this.get({
          id: fileId,
          successCallback: openWithIntegrations => {
            const formattedOpenWithData = this.formatOpenWithData(openWithIntegrations);
            const consolidatedOpenWithIntegrations = this.consolidateBoxEditIntegrations(formattedOpenWithData);
            successCallback(consolidatedOpenWithIntegrations);
          },
          errorCallback,
        });
      }

      /**
       * Removes the Box Edit SFC integration if the higher scoped Box Edit integration is present.
       * Box Edit and SFC Box Edit are considered separate integrations by the API. We only want to show one,
       * even if both are enabled and returned from the API.
       *
       * @param {Array<Integration>} integrations - List of integrations
       * @return {Array<Integration>} Integrations with only one Box Edit integration
       */
      consolidateBoxEditIntegrations(integrations) {
        let consolidatedIntegrations = [...integrations];
        const boxEditIntegration = integrations.some(item => item.appIntegrationId === BOX_EDIT_INTEGRATION_ID);
        if (boxEditIntegration) {
          consolidatedIntegrations = integrations.filter(item => item.appIntegrationId !== BOX_EDIT_SFC_INTEGRATION_ID);
        }
        return consolidatedIntegrations;
      }

      /**
       * Formats Open With data conveniently for the client
       *
       * @param {Array<Object>} openWithIntegrations - The modified Open With integration objects
       * @return {Array<Integration>} formatted Open With integrations
       */
      formatOpenWithData(openWithIntegrations) {
        const { items, default_app_integration: defaultIntegration } = openWithIntegrations;
        const integrations = items.map(
          ({
            app_integration,
            disabled_reasons,
            display_name,
            display_description,
            display_order,
            is_disabled,
            should_show_consent_popup,
          }) => {
            const { id, type } = app_integration;
            return {
              appIntegrationId: id,
              displayDescription: display_description,
              disabledReasons: disabled_reasons || [],
              displayOrder: display_order,
              isDefault: !!defaultIntegration && id === defaultIntegration.id,
              isDisabled: is_disabled,
              displayName: display_name,
              requiresConsent: should_show_consent_popup,
              type,
            };
          },
        );

        // Sort integrations by displayOrder
        return integrations.sort((integrationA, integrationB) => integrationA.displayOrder - integrationB.displayOrder);
      }
    }
    /* harmony default export */ const api_OpenWith = OpenWith; // CONCATENATED MODULE: ./src/api/MetadataQuery.js
    function MetadataQuery_defineProperty(e, r, t) {
      return (
        (r = MetadataQuery_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function MetadataQuery_toPropertyKey(t) {
      var i = MetadataQuery_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function MetadataQuery_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Helper for the box metadata query API
     * @author Box
     */

    class MetadataQuery extends api_Base {
      constructor(...args) {
        super(...args);
        /**
         * @param {Object} response
         */
        MetadataQuery_defineProperty(this, 'queryMetadataSuccessHandler', ({ data }) => {
          const cache = this.getCache();
          cache.set(this.key, data);
          this.finish();
        });
      }
      /**
       * @property {string}
       */

      /**
       * @property {Function}
       */

      /**
       * @property {Function}
       */

      /**
       * Creates a key for the metadata cache
       *
       * @param {string} id - metadata template
       * @return {string} key
       */
      getCacheKey(id) {
        return `${CACHE_PREFIX_METADATA_QUERY}${id}`;
      }

      /**
       * API URL for metadata query
       * @return {string} base url for files
       */
      getUrl() {
        return `${this.getBaseApiUrl()}/metadata_queries/execute_read`;
      }

      /**
       * Returns true for cache hit for metadata query results
       *
       * @return {boolean} if query results are loaded
       */
      isLoaded() {
        const cache = this.getCache();
        return cache.has(this.key);
      }

      /**
       * Returns the results using successCallback
       *
       * @return {void}
       */
      finish() {
        if (this.isDestroyed()) {
          return;
        }
        const cache = this.getCache();
        const metadataQueryData = cache.get(this.key);
        this.successCallback(metadataQueryData);
      }
      /**
       * Does the network request to metadata query API
       * @param {Object} query query object with SQL Clauses like properties
       * @return {void}
       */
      queryMetadataRequest(query) {
        if (this.isDestroyed()) {
          return;
        }
        this.errorCode = ERROR_CODE_METADATA_QUERY;
        this.xhr
          .post({
            url: this.getUrl(),
            data: query,
          })
          .then(this.queryMetadataSuccessHandler)
          .catch(this.errorHandler);
      }

      /**
       * API for querying enterprise metadata
       * @param {Object} query - metadata query object
       * @param {Function} successCallback - Function to call with results
       * @param {Function} errorCallback - Function to call with errors
       * @param {boolean|void} [options.forceFetch] - Bypasses the cache
       * @return {void}
       */
      queryMetadata(query, successCallback, errorCallback, options = {}) {
        if (this.isDestroyed()) {
          return;
        }
        const { context = {} } = options;
        this.key = this.getCacheKey(context.id);
        this.successCallback = successCallback;
        this.errorCallback = errorCallback;

        // Clear the cache if needed
        if (options.forceFetch) {
          this.getCache().unset(this.key);
        }

        // Return the Cache value if it exists
        if (this.isLoaded()) {
          this.finish();
          return;
        }

        // Make the XHR request
        this.queryMetadataRequest(query);
      }
    }
    /* harmony default export */ const api_MetadataQuery = MetadataQuery; // CONCATENATED MODULE: ./src/api/box-edit/BrowserUtils.js
    const BROWSER_CONSTANTS = {
      CHROME: 'Chrome',
      EDGE: 'Edge',
      FIREFOX: 'Firefox',
      MAC: 'Mac',
      SAFARI: 'Safari',
      IE: 'Explorer',
    };
    const MIN_FOLDER_UPLOAD_CHROME = '21';
    const MIN_FOLDER_UPLOAD_EDGE = '14';
    const MIN_FOLDER_UPLOAD_FIREFOX = '50';
    const MIN_FOLDER_UPLOAD_SAFARI = '11.1';
    const BROWSER_DATA = [
      {
        key: 'userAgent',
        subString: BROWSER_CONSTANTS.EDGE,
        identity: BROWSER_CONSTANTS.EDGE,
      },
      {
        key: 'userAgent',
        subString: BROWSER_CONSTANTS.CHROME,
        identity: BROWSER_CONSTANTS.CHROME,
      },
      {
        // Chrome on iOS uses criOS to indicate that it is a chrome browser
        // https://developer.chrome.com/multidevice/user-agent
        key: 'userAgent',
        subString: 'criOS',
        identity: BROWSER_CONSTANTS.CHROME,
        versionSearch: 'criOS',
      },
      {
        key: 'vendor',
        subString: 'Apple',
        identity: BROWSER_CONSTANTS.SAFARI,
        versionSearch: 'Version',
      },
      {
        key: 'userAgent',
        subString: BROWSER_CONSTANTS.FIREFOX,
        identity: BROWSER_CONSTANTS.FIREFOX,
      },
      {
        key: 'userAgent',
        subString: 'MSIE',
        identity: 'Explorer',
        versionSearch: 'MSIE',
      },
      {
        key: 'userAgent',
        subString: 'Trident',
        identity: 'Explorer',
        versionSearch: 'rv',
      },
      {
        key: 'userAgent',
        subString: 'Gecko',
        identity: 'Mozilla',
        versionSearch: 'rv',
      },
    ];
    const OS_DATA = [
      {
        key: 'platform',
        subString: 'Win',
        identity: 'Windows',
      },
      {
        key: 'userAgent',
        subString: 'iPod',
        identity: 'iOS',
        device: 'iPod',
      },
      {
        key: 'userAgent',
        subString: 'iPhone',
        identity: 'iOS',
        device: 'iPhone',
      },
      {
        key: 'userAgent',
        subString: 'iPad',
        identity: 'iOS',
        device: 'iPad',
      },
      {
        // Make sure Mac is lower than iPhone/iPad/iPod in the array order as iOS user agent also includes 'Mac'
        key: 'platform',
        subString: BROWSER_CONSTANTS.MAC,
        identity: BROWSER_CONSTANTS.MAC,
      },
      {
        // Make sure Android is above Linux, as Android user agent also includes 'Linux'
        key: 'userAgent',
        subString: 'Android',
        identity: 'Android',
      },
      {
        key: 'platform',
        subString: 'Linux',
        identity: 'Linux',
      },
    ];

    /**
     * Searches for the identity of the browser in the provided array or known browsers.
     * @param {Object} navigator
     * @param {Array} data - list of supported browsers, filled with browser information
     * to determine the current browser identity
     * @returns {Object} - the identity of the browser
     */
    function getBrowserData(navigator, data) {
      let dataString;
      let identity = null;
      let device = null;
      let versionSearchString = '';
      for (let i = 0, len = data.length; i < len; i += 1) {
        dataString = navigator[data[i].key];
        versionSearchString = data[i].versionSearch || data[i].identity;
        if (dataString && dataString.indexOf(data[i].subString) !== -1) {
          /* eslint-disable prefer-destructuring */
          identity = data[i].identity;
          device = data[i].device;
          /* eslint-disable prefer-destructuring */
          break;
        }
      }
      return {
        identity,
        device,
        versionSearchString,
      };
    }

    /**
     * searches for the version of the browser in the provided array
     *
     * @param {string} dataString - a string that contains the version information,
     *        either navigator.userAgent or navigator.appVersion
     * @param {string} versionSearchString
     * @returns {string} - empty if versionString does not exist in dataString, else the version as a string.
     */
    function getBrowserVersion(dataString, versionSearchString) {
      const index = dataString.indexOf(versionSearchString);
      if (index === -1) {
        return '';
      }

      // This regex grabs the decimal value of the version
      const versionArr = dataString.substring(index + versionSearchString.length + 1).match(/[0-9]+(?:\.[0-9]*)?/);
      if (versionArr && versionArr.length) {
        return versionArr[0];
      }
      return '';
    }

    /**
     * @param {string} [objectID] optional. Defaults to a random string, just to validate
     * the ability of creating the ActiveXObject on the browser
     * @returns {boolean}
     */
    function isActiveXObjectEnabledForIE(objectID) {
      const objectIdentifier = objectID || 'htmlfile';
      let enabled = false;
      try {
        if ('ActiveXObject' in window) {
          const { ActiveXObject } = window;
          enabled = !!new ActiveXObject(objectIdentifier);
        }
      } catch (exception) {
        enabled = false;
      }
      return enabled;
    }
    class BrowserUtils {
      constructor() {
        const { navigator } = window;
        const browserData = getBrowserData(navigator, BROWSER_DATA);
        const osInfo = getBrowserData(navigator, OS_DATA);
        this.browser = browserData.identity || 'unknown';
        this.version =
          getBrowserVersion(navigator.userAgent, browserData.versionSearchString) ||
          getBrowserVersion(navigator.appVersion, browserData.versionSearchString) ||
          'unknown';
        this.OS = osInfo.identity || 'unknown';
        this.device = osInfo.device || 'unknown';
      }

      /**
       * Returns the browser name as a string if recognized, else 'an unknown browser'.
       * @returns {string} browser name
       */
      getName() {
        return this.browser;
      }

      /**
       * Returns the browser version as a string.
       * @returns {string} version string
       */
      getVersion() {
        return this.version;
      }

      /**
       * Returns true if the browser is of type 'type' and the version of browser >= 'min' parameter.
       *
       * @param {string} name - The name of the browser
       * @param {string | number} minVersion - The version number to be equal to or greater than.
       * @returns {boolean} - true if current browser name is same as passed in and
       *     browser version greater or equal to minVersion
       */
      isMinBrowser(name, minVersion) {
        return this.browser.toLowerCase() === name.toLowerCase() && parseFloat(this.version) >= parseFloat(minVersion);
      }

      /**
       * Returns true if the current browser is Safari.
       * @returns {boolean} True if browser is Safari
       */
      isSafari() {
        return this.browser === BROWSER_CONSTANTS.SAFARI;
      }

      /**
       * Returns true if the current browser is firefox.
       * @returns {boolean}
       */
      isFirefox() {
        return this.browser === BROWSER_CONSTANTS.FIREFOX;
      }

      /**
       * Returns true if the current browser is chrome.
       * @returns {boolean}
       */
      isChrome() {
        return this.browser === BROWSER_CONSTANTS.CHROME;
      }

      /**
       * Returns true if the current browser is internet explorer (ie).
       * @returns {boolean}
       */
      isIE() {
        return this.browser === BROWSER_CONSTANTS.IE;
      }

      /**
       * Returns true if the current browser is microsoft edge.
       * @returns {boolean}
       */
      isEdge() {
        return this.browser === BROWSER_CONSTANTS.EDGE;
      }

      /**
       * Checks if a specific plugin is supported and does not realy on
       * plugins generally being supported.
       * @param {string} [pluginID] optional. The specific plugin which should be checked for support
       * @returns {boolean}
       */
      isIEAndSpecificBrowserPluginSupported(pluginID) {
        return this.isIE() && isActiveXObjectEnabledForIE(pluginID);
      }
    }
    const BrowserInstance = new BrowserUtils();

    // for testing only

    // export as a singleton
    /* harmony default export */ const box_edit_BrowserUtils = BrowserInstance; // CONCATENATED MODULE: ./src/api/box-edit/promise.js
    /**
     * NOTE: we don't use the NPM package directly because it has an unnecessary dependency on es6-promise + its commonjs format.
     * Returns the first promise in `promises` to successfully resolve.
     * If all fail, reject.
     * @see {@link https://github.com/jarofghosts/promise-one}
     */
    function promiseOne(promises) {
      const errors = [];
      let errorCount = 0;
      let error;
      return new Promise((resolve, reject) => {
        const pushErrors = idx => err => {
          errors[idx] = err;
          errorCount += 1;
          if (errorCount === promises.length) {
            error = new Error('no promises resolved');
            reject(error);
          }
        };
        promises.forEach((promise, idx) => {
          promise.then(resolve).catch(pushErrors(idx));
        });
      });
    }
    /* harmony default export */ const promise = promiseOne; // CONCATENATED MODULE: ./src/api/box-edit/constants.js
    const BOX_TOOLS_PLUGIN_NAME = 'Box.BoxTools'; // @TODO Should be passed as a config
    const BOX_SECURE_LOCAL_BASE_URL = 'https://edit.boxlocalhost.com:';
    const BOX_UNSECURE_LOCAL_BASE_URL = 'http://127.0.0.1:';
    const ACTIVEX_CHANNEL_NAME = 'activex_channel';
    const HTTP_CHANNEL_NAME = 'http_channel';
    const HTTPS_CHANNEL_NAME = 'https_channel';
    const SAFARI_CHANNEL_NAME = 'safari_channel';
    const OPERATION_STATUS = 'status';
    const OPERATION_REQUEST = 'application_request';
    const OPERATION_COMMAND = 'application_command';
    const UNCREATED_STATUS = 'uncreated';
    const CREATED_STATUS = 'created';
    const ACTIVE_STATUS = 'active';
    const HIVE_TABLE_WEBAPP_BOXTOOLS_ANALYTICS = 'webapp_boxtools_analytics';
    const SECRET_STORE_COOKIE_NAME = 'box-edit-secret-cookie-name';
    const BOX_EDIT_APP_NAME = 'BoxEdit';
    const REQUEST_ID_PRE = 'BOX-EXT-REQ-ID-';
    const REQUEST_TIMEOUT_RESPONSE_CODE = 408;
    const OUTPUT_EVENT = 'box_extension_output';
    const BOX_EDIT_NOT_SUPPORTED_ERROR = 'box_edit_not_supported_error';
    const BOX_EDIT_UNINSTALLED_ERROR = 'box_edit_uninstalled_error';
    const BOX_EDIT_UPGRADE_BROWSER_ERROR = 'box_edit_upgrade_browser_error';
    const BOX_EDIT_SAFARI_ERROR = 'box_edit_safari_error';
    const BOX_EDIT_INSECURE_REQUESTS_UPGRADED_ERROR = 'box_edit_insecure_requests_upgraded_error';
    const KEY_LENGTH = 16;
    const KEY_ID_LENGTH = 8;
    const IV = '75392C57F66CE7E7EF47110410280DD7';
    const EXTENSION_BLACKLIST = {
      A6P: 1,
      AC: 1,
      AS: 1,
      ACR: 1,
      ACTION: 1,
      AIR: 1,
      APP: 1,
      AWK: 1,
      BAT: 1,
      BOXNOTE: 1,
      CGI: 1,
      CHM: 1,
      CMD: 1,
      COM: 1,
      CSH: 1,
      DEK: 1,
      DLD: 1,
      DS: 1,
      EBM: 1,
      ESH: 1,
      EXE: 1,
      EZS: 1,
      FKY: 1,
      FRS: 1,
      FXP: 1,
      GADGET: 1,
      HMS: 1,
      HTA: 1,
      ICD: 1,
      INX: 1,
      IPF: 1,
      ISU: 1,
      JAR: 1,
      JS: 1,
      JSE: 1,
      JSX: 1,
      KIX: 1,
      LNK: 1,
      LUA: 1,
      MCR: 1,
      MEM: 1,
      MPX: 1,
      MS: 1,
      MSI: 1,
      MST: 1,
      OBS: 1,
      PAF: 1,
      PEX: 1,
      PIF: 1,
      PL: 1,
      PRC: 1,
      PRG: 1,
      PVD: 1,
      PWC: 1,
      PY: 1,
      PYC: 1,
      PYO: 1,
      QPX: 1,
      RBX: 1,
      REG: 1,
      RGS: 1,
      ROX: 1,
      RPJ: 1,
      SCAR: 1,
      SCR: 1,
      SCRIPT: 1,
      SCPT: 1,
      SCT: 1,
      SH: 1,
      SHB: 1,
      SHS: 1,
      SPR: 1,
      TLB: 1,
      TMS: 1,
      U3P: 1,
      UDF: 1,
      URL: 1,
      VB: 1,
      VBE: 1,
      VBS: 1,
      VBSCRIPT: 1,
      WCM: 1,
      WPK: 1,
      WS: 1,
      WSF: 1,
      XQT: 1,
    };
    /* harmony default export */ const constants = {
      SAFARI_CHANNEL_NAME,
      SECRET_STORE_COOKIE_NAME,
      BOX_EDIT_APP_NAME,
      BOX_EDIT_NOT_SUPPORTED_ERROR,
      BOX_EDIT_UNINSTALLED_ERROR,
      BOX_EDIT_UPGRADE_BROWSER_ERROR,
      BOX_EDIT_SAFARI_ERROR,
      BOX_EDIT_INSECURE_REQUESTS_UPGRADED_ERROR,
      BOX_TOOLS_PLUGIN_NAME,
      BOX_SECURE_LOCAL_BASE_URL,
      BOX_UNSECURE_LOCAL_BASE_URL,
      ACTIVEX_CHANNEL_NAME,
      HTTP_CHANNEL_NAME,
      HTTPS_CHANNEL_NAME,
      OPERATION_STATUS,
      OPERATION_REQUEST,
      OPERATION_COMMAND,
      UNCREATED_STATUS,
      CREATED_STATUS,
      ACTIVE_STATUS,
      HIVE_TABLE_WEBAPP_BOXTOOLS_ANALYTICS,
      KEY_LENGTH,
      KEY_ID_LENGTH,
      IV,
      OUTPUT_EVENT,
      REQUEST_ID_PRE,
      REQUEST_TIMEOUT_RESPONSE_CODE,
      EXTENSION_BLACKLIST,
    }; // CONCATENATED MODULE: ./src/api/box-edit/Channel.js
    function Channel_defineProperty(e, r, t) {
      return (
        (r = Channel_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function Channel_toPropertyKey(t) {
      var i = Channel_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function Channel_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    /* eslint-disable*/
    class Channel {
      constructor(appName) {
        Channel_defineProperty(
          this,
          'buildNextRequestID',
          () => `${constants.REQUEST_ID_PRE}${this.window.performance.now()}`,
        );
        Channel_defineProperty(this, 'buildDetailsObj', (operationType, data, comServerToApplicationTimeoutSec) => {
          const timeoutSecString = comServerToApplicationTimeoutSec.toString();
          const details = {
            data: undefined,
            operation: operationType,
            properties: {
              application: this.appName,
              timeout: timeoutSecString,
            },
            // eslint-disable-next-line camelcase
            req_id: this.buildNextRequestID(),
          };
          if (operationType !== constants.OPERATION_STATUS) {
            if (!data) {
              throw new TypeError(`Data cannot be undefined for ${operationType}`);
            }
            details.data = data;
          }
          return details;
        });
        this.appName = appName;
        this.window = window;
      }
      sendCommand(requestData, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) {
        return Promise.resolve('TODO');
      }
      sendRequest(requestData, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) {
        return Promise.resolve('TODO');
      }
      getComServerStatus(browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) {
        return Promise.resolve('TODO');
      }
      destroy() {}
    }
    /* harmony default export */ const box_edit_Channel = Channel; // CONCATENATED MODULE: ./src/api/box-edit/ActiveXChannel.js
    function ActiveXChannel_defineProperty(e, r, t) {
      return (
        (r = ActiveXChannel_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ActiveXChannel_toPropertyKey(t) {
      var i = ActiveXChannel_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ActiveXChannel_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    const MAX_RETRY_ATTEMPTS = 2;
    class ActiveXChannel extends box_edit_Channel {
      constructor(appName, isSynchronous) {
        super(appName);
        ActiveXChannel_defineProperty(
          this,
          'executeOperation',
          (operationType = '', data = {}, browserToComServerTimeoutMS = 0, comServerToApplicationTimeoutSec = 0) => {
            return new Promise((resolve, reject) => {
              const details = this.buildDetailsObj(operationType, data, comServerToApplicationTimeoutSec);
              const timeoutId = setTimeout(() => {
                reject(
                  new Error({
                    status_code: constants.REQUEST_TIMEOUT_RESPONSE_CODE,
                  }),
                );
              }, browserToComServerTimeoutMS);
              this.reqIdToPromiseMap.set(details.req_id, {
                resolve,
                rejectTimeout: timeoutId,
              });
              this.executeActiveXEvent({
                detail: details,
              });
            });
          },
        );
        ActiveXChannel_defineProperty(this, 'repairActiveXConnection', payload => {
          if (!box_edit_BrowserUtils.isIEAndSpecificBrowserPluginSupported(constants.BOX_TOOLS_PLUGIN_NAME)) {
            return;
          }
          if (this.retryAttempt >= MAX_RETRY_ATTEMPTS) {
            return;
          }
          this.retryAttempt += 1;
          setTimeout(() => {
            this.executeActiveXEvent(payload);
          }, 100);
        });
        ActiveXChannel_defineProperty(this, 'executeActiveXEvent', payload => {
          const activeX = this.createActiveXObjectJSRef();
          const hasExecuteSyncAPI = 'ExecuteSync' in activeX;
          try {
            if (this.isSynchronous && hasExecuteSyncAPI) {
              activeX.ExecuteSync(JSON.stringify(payload));
            } else {
              activeX.Execute(JSON.stringify(payload));
            }
          } catch (ex) {
            this.repairActiveXConnection(payload);
          }
        });
        ActiveXChannel_defineProperty(this, 'createActiveXObjectJSRef', () => {
          const { ActiveXObject } = this.window;
          return new ActiveXObject(constants.BOX_TOOLS_PLUGIN_NAME);
        });
        ActiveXChannel_defineProperty(this, 'setupActiveXCommunication', () => {
          if (!this.isActiveXExtensionListenerAttached) {
            // attach the event listener to App Extension output events
            this.document.addEventListener(constants.OUTPUT_EVENT, this.appExtensionEventResponseHandler);
            this.isActiveXExtensionListenerAttached = true;
          }
        });
        ActiveXChannel_defineProperty(this, 'tearDownActiveXCommunication', () => {
          if (this.isActiveXExtensionListenerAttached) {
            // remove the event listener for App Extension output events
            this.document.removeEventListener(constants.OUTPUT_EVENT, this.appExtensionEventResponseHandler);
            this.isActiveXExtensionListenerAttached = false;
          }
        });
        ActiveXChannel_defineProperty(this, 'appExtensionEventResponseHandler', responseVal => {
          if (this.retryAttempt > 0) {
            this.retryAttempt = 0;
          }
          const response = typeof responseVal.detail === 'string' ? JSON.parse(responseVal.detail) : responseVal.detail;
          if (this.reqIdToPromiseMap.has(response.req_id)) {
            const resolveObj = this.reqIdToPromiseMap.get(response.req_id);
            if (resolveObj) {
              clearTimeout(resolveObj.rejectTimeout);
              this.reqIdToPromiseMap.delete(response.req_id);
              const responseData =
                typeof response.com_server_response.data === 'string'
                  ? JSON.parse(response.com_server_response.data)
                  : response.com_server_response.data;
              resolveObj.resolve(responseData);
            }
          }
        });
        ActiveXChannel_defineProperty(
          this,
          'getComServerStatus',
          (browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            return this.executeOperation(
              constants.OPERATION_STATUS,
              null,
              browserToComServerTimeoutMS,
              comServerToApplicationTimeoutSec,
            );
          },
        );
        ActiveXChannel_defineProperty(
          this,
          'sendRequest',
          (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            return this.executeOperation(
              constants.OPERATION_REQUEST,
              data,
              browserToComServerTimeoutMS,
              comServerToApplicationTimeoutSec,
            );
          },
        );
        ActiveXChannel_defineProperty(
          this,
          'sendCommand',
          (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            return this.executeOperation(
              constants.OPERATION_COMMAND,
              data,
              browserToComServerTimeoutMS,
              comServerToApplicationTimeoutSec,
            );
          },
        );
        ActiveXChannel_defineProperty(this, 'destroy', () => {
          this.tearDownActiveXCommunication();
        });
        this.isSynchronous = isSynchronous;
        this.channelName = constants.ACTIVEX_CHANNEL_NAME;
        this.reqIdToPromiseMap = new Map();
        this.isActiveXExtensionListenerAttached = false;
        this.retryAttempt = 0;
        this.document = document;
        this.window = window;
        this.setupActiveXCommunication();
      }
    }

    /* harmony default export */ const box_edit_ActiveXChannel = ActiveXChannel; // CONCATENATED MODULE: ./src/api/box-edit/cookies.js
    /**
     * Gets a cookie by name
     *
     * @param {string} name Cookie name.
     * @returns {string} Cookie value
     */
    function cookies_get(name) {
      const { document } = window;
      const cookies = document.cookie.split('; ');
      const len = cookies.length;
      let pair;
      let i;
      for (i = 0; i < len; i += 1) {
        pair = cookies[i].split('=');
        if (pair[0] === name) {
          if (pair[1]) {
            // Internet Explorer doesn't set a = on empty cookie values, therefore pair[1] is undefined
            return decodeURIComponent(pair[1]);
          }
          return '';
        }
      }
      return '';
    }

    /**
     * Sets a cookie. The name and value are required, and all other params have default values.
     * It is recommended to use the default values unless you have a specific reason to override them.
     *
     * @param {string} name - Cookie name.
     * @param {mixed} value - Cookie value.
     * @param {int} expires - (Optional) Expiration date in UNIX time. Defaults to 2 months in the future. 0 for session cookies.
     * @param {string} path - (Optional) Cookie path. Defaults to the root path '/'.
     * @param {string} domain - (Optional) Cookie domain. Defaults to the cookie_domain used server-side.
     * @returns {void}
     */
    function cookies_set(name, value, expires, path = '/', domain = '') {
      const { document } = window;
      const expiresDate = new Date();
      const cookie = [];
      if (typeof expires === 'undefined') {
        expires = expiresDate.getTime() + 1000 * 3600 * 24 * 60; // two months;
      }
      expiresDate.setTime(expires);
      cookie.push(`${name}=${encodeURIComponent(value)}`);
      if (expires !== 0) {
        // do not add "expires" when creating a session cookie
        cookie.push(`; expires=${expiresDate.toUTCString()}`);
      }
      cookie.push(`; path=${path}`);
      if (domain) {
        cookie.push(`; domain=${domain}`);
      }
      cookie.push('; secure');
      document.cookie = cookie.join('');
    }

    /**
     * Deletes a cookie by name.
     *
     * @param {string} name Cookie name.
     * @returns {void}
     */
    function remove(name) {
      cookies_set(name, '', new Date(0).getTime());
    }

    /**
     * Checks if cookies are enabled for this browser
     * This is useful when treating Box as a 3rd party (iframed)
     * @returns {boolean} True if cookies are enabled, false if not.
     */
    function isEnabled() {
      const { document } = window;
      const theCookie = document.cookie;
      return !!(theCookie && theCookie.length > 0);
    } // CONCATENATED MODULE: ./src/api/box-edit/HTTPChannel.js

    function HTTPChannel_defineProperty(e, r, t) {
      return (
        (r = HTTPChannel_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function HTTPChannel_toPropertyKey(t) {
      var i = HTTPChannel_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function HTTPChannel_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    const GET = 'GET';
    const POST = 'POST';
    const YEAR_MS = 31536000000;
    const DEFAULT_PRIMARY_PORT = 17223;
    const DEFAULT_FALLBACK_PORT = 17224;
    const CONTENT_TYPE_HEADER = 'Content-Type';
    const CONTENT_TYPE_VALUE = 'text/plain; charset=UTF-8';
    const STATUS_NOT_RUNNING = 'notrunning';
    const localStore = new utils_LocalStore();
    function shouldUseFallbackFirst() {
      return !!localStore.getItem('comUseFallback');
    }
    function saveFallbackPortPreference() {
      localStore.setItem('comUseFallback', 1);
    }
    function clearFallbackPortPreference() {
      localStore.removeItem('comUseFallback');
    }
    function getPreferredPortOrdering() {
      if (shouldUseFallbackFirst()) {
        return {
          primary: DEFAULT_FALLBACK_PORT,
          fallback: DEFAULT_PRIMARY_PORT,
        };
      }
      return {
        primary: DEFAULT_PRIMARY_PORT,
        fallback: DEFAULT_FALLBACK_PORT,
      };
    }
    class HTTPChannel extends box_edit_Channel {
      constructor(_appName, _url, channelName) {
        super(_appName);
        HTTPChannel_defineProperty(this, 'createCORSRequest', (method, url) => {
          let xhr;
          try {
            const { XMLHttpRequest } = this.window;
            xhr = new XMLHttpRequest();
            xhr.open(method, url, true);
            return xhr;
          } catch (ex) {
            if (this.retryCounter < 3) {
              this.retryCounter += 1;
              return this.createCORSRequest(method, url);
            }
            throw new Error('could not create xhr');
          }
        });
        HTTPChannel_defineProperty(this, 'getComServerStatusInstallationPromise', timeoutMS => {
          let resolve;
          let reject;
          const comServerInstallationPromise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
          });
          const resolveWithValidPort = (port, res) => {
            this.currentPort = port;
            if (port === DEFAULT_PRIMARY_PORT) {
              clearFallbackPortPreference();
            } else {
              saveFallbackPortPreference();
            }
            this.comServerInstallationPromiseRejected = false;
            resolve(res);
          };
          const portPreferences = getPreferredPortOrdering();
          const primaryPort = portPreferences.primary;
          const fallbackPort = portPreferences.fallback;

          // Try primary port first
          this.checkInstallStatus(primaryPort, timeoutMS)
            .then(resolveWithValidPort.bind(this, primaryPort))
            .catch(err => {
              // If com server returned that the port is available but the app is not running, reject
              if (err === STATUS_NOT_RUNNING) {
                this.comServerInstallationPromiseRejected = true;
                reject();
                return;
              }

              // Only check secondary, if necessary, otherwise this throws a browser error in console
              this.checkInstallStatus(fallbackPort, timeoutMS)
                .then(resolveWithValidPort.bind(this, fallbackPort))
                .catch(() => {
                  this.comServerInstallationPromiseRejected = true;
                  reject();
                });
            });
          return comServerInstallationPromise;
        });
        HTTPChannel_defineProperty(this, 'sendComServerRequest', (method, url, data, timeoutMS) => {
          return new Promise((resolve, reject) => {
            try {
              const request = this.createCORSRequest(method, url);
              request.setRequestHeader(CONTENT_TYPE_HEADER, CONTENT_TYPE_VALUE);
              request.onload = () => {
                resolve(request);
              };
              request.onerror = () => {
                reject(request);
              };
              if (timeoutMS > 0) {
                request.timeout = timeoutMS;
                request.ontimeout = () => {
                  reject(request);
                };
              }
              setTimeout(() => {
                request.send(data);
              }, 0);
            } catch (err) {
              reject();
            }
          });
        });
        HTTPChannel_defineProperty(this, 'checkInstallStatus', (port, timeoutMS) => {
          return this.sendComServerRequest(GET, `${this.url}${port}/status`, null, timeoutMS).then(request => {
            const response = JSON.parse(request.responseText);
            if (response.running) {
              return response;
            }
            this.comServerInstallationPromiseRejected = true;
            throw new Error(STATUS_NOT_RUNNING);
          });
        });
        HTTPChannel_defineProperty(this, 'getComChannel', appName => cookies_get(`${appName}-bgp-id`));
        HTTPChannel_defineProperty(this, 'setComChannel', appName => {
          const bgpId = this.getComChannel(appName) || this.generateId();
          const comChannelName = `bgp-${bgpId}`;
          const aYearFromNow = new Date().getTime() + YEAR_MS;
          cookies_set(`${appName}-bgp-id`, bgpId, aYearFromNow);
          cookies_set(`bgp-${bgpId}`, 'generic', aYearFromNow);
          return comChannelName;
        });
        HTTPChannel_defineProperty(this, 'getComServerStatus', timeoutMS => {
          if (!this.comServerInstallationPromise || this.comServerInstallationPromiseRejected) {
            // Null out the promise and fetch status again (handles the case where user installed box edit within the same page load)
            this.comServerInstallationPromise = null;
            this.comServerInstallationPromise = this.getComServerStatusInstallationPromise(timeoutMS);
            return this.comServerInstallationPromise;
          }
          return this.comServerInstallationPromise;
        });
        HTTPChannel_defineProperty(
          this,
          'sendRequest',
          (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            const url = `${this.url}${this.currentPort}/application_request?application=${this.appName}&com=${this.comChannelName}&timeout=${comServerToApplicationTimeoutSec}`;
            return this.sendComServerRequest(POST, url, data, browserToComServerTimeoutMS).then(results => {
              // TODO: does the error object need to be richer?
              const response = JSON.parse(results.responseText);
              if (response.response_type && response.response_type === 'error') {
                throw new Error(`Communication error: ${response.message}`);
              }
              return response;
            });
          },
        );
        HTTPChannel_defineProperty(
          this,
          'sendCommand',
          (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            const url = `${this.url}${this.currentPort}/application_command?application=${this.appName}&com=${this.comChannelName}&timeout=${comServerToApplicationTimeoutSec}`;
            return this.sendComServerRequest(POST, url, data, browserToComServerTimeoutMS).then(results => {
              return JSON.parse(results.responseText);
            });
          },
        );
        HTTPChannel_defineProperty(this, 'generateId', () => {
          const time = new Date().getTime();
          return 'xxxxxxxx'.replace(/x/g, () => {
            // Generate random number between 1 and 16.
            // Using time for added entropy.
            const rand = Math.floor((time + Math.random() * 16) % 16);
            // Convert number to a HEX
            return rand.toString(16);
          });
        });
        this.url = _url;
        this.comChannelName = this.setComChannel(_appName);
        this.channelName = channelName;
        this.comServerInstallationPromise = null;
        this.comServerInstallationPromiseRejected = false;
        this.retryCounter = 0;
        this.sendCount = 0;
        this.currentPort = getPreferredPortOrdering().primary;
        this.window = window;
      }
    }
    /* harmony default export */ const box_edit_HTTPChannel = HTTPChannel; // CONCATENATED MODULE: ./src/api/box-edit/SafariChannel.js
    function SafariChannel_defineProperty(e, r, t) {
      return (
        (r = SafariChannel_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function SafariChannel_toPropertyKey(t) {
      var i = SafariChannel_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function SafariChannel_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    const INPUT_EVENT = 'box_extension_input';
    const SafariChannel_OUTPUT_EVENT = 'box_extension_output';
    class SafariChannel extends box_edit_Channel {
      constructor(appName) {
        super(appName);
        SafariChannel_defineProperty(
          this,
          'executeOperation',
          (operationType = '', data = {}, browserToComServerTimeoutMS = 0, comServerToApplicationTimeoutSec = 0) => {
            return new Promise((resolve, reject) => {
              const details = this.buildDetailsObj(operationType, data, comServerToApplicationTimeoutSec);
              const timeoutId = setTimeout(() => {
                reject(
                  new Error({
                    status_code: constants.REQUEST_TIMEOUT_RESPONSE_CODE,
                  }),
                );
              }, browserToComServerTimeoutMS);
              this.reqIdToPromiseMap.set(details.req_id, {
                resolve,
                rejectTimeout: timeoutId,
              });
              this.createAndDispatchAppExtensionEvent({
                detail: details,
              });
            });
          },
        );
        SafariChannel_defineProperty(this, 'setupSafariExtensionCommunication', () => {
          if (!this.isAppExtensionListenerAttached) {
            this.isAppExtensionListenerAttached = true;
            this.document.addEventListener(SafariChannel_OUTPUT_EVENT, this.appExtensionEventResponseHandler);
          }
        });
        SafariChannel_defineProperty(this, 'tearDownSafariExtensionCommunication', () => {
          if (this.isAppExtensionListenerAttached) {
            this.isAppExtensionListenerAttached = false;
            this.document.removeEventListener(SafariChannel_OUTPUT_EVENT, this.appExtensionEventResponseHandler);
          }
        });
        SafariChannel_defineProperty(this, 'appExtensionEventResponseHandler', responseVal => {
          const response = typeof responseVal.detail === 'string' ? JSON.parse(responseVal.detail) : responseVal.detail;
          if (this.reqIdToPromiseMap.has(response.req_id)) {
            const resolveObj = this.reqIdToPromiseMap.get(response.req_id);
            if (resolveObj) {
              clearTimeout(resolveObj.rejectTimeout);
              this.reqIdToPromiseMap.delete(response.req_id);
              const responseData =
                typeof response.com_server_response.data === 'string'
                  ? JSON.parse(response.com_server_response.data)
                  : response.com_server_response.data;
              resolveObj.resolve(responseData);
            }
          }
        });
        SafariChannel_defineProperty(this, 'createAndDispatchAppExtensionEvent', payload => {
          const { CustomEvent } = this.window;
          const eventInstance = new CustomEvent(INPUT_EVENT, payload);
          this.document.dispatchEvent(eventInstance);
        });
        SafariChannel_defineProperty(
          this,
          'getComServerStatus',
          (browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            return this.executeOperation(
              constants.OPERATION_STATUS,
              null,
              browserToComServerTimeoutMS,
              comServerToApplicationTimeoutSec,
            );
          },
        );
        SafariChannel_defineProperty(
          this,
          'sendRequest',
          (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            return this.executeOperation(
              constants.OPERATION_REQUEST,
              data,
              browserToComServerTimeoutMS,
              comServerToApplicationTimeoutSec,
            );
          },
        );
        SafariChannel_defineProperty(
          this,
          'sendCommand',
          (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
            return this.executeOperation(
              constants.OPERATION_COMMAND,
              data,
              browserToComServerTimeoutMS,
              comServerToApplicationTimeoutSec,
            );
          },
        );
        SafariChannel_defineProperty(this, 'destroy', () => {
          this.tearDownSafariExtensionCommunication();
        });
        this.reqIdToPromiseMap = new Map();
        this.channelName = constants.SAFARI_CHANNEL_NAME;
        this.window = window;
        this.document = document;
        this.setupSafariExtensionCommunication();
      }
    }
    /* harmony default export */ const box_edit_SafariChannel = SafariChannel; // CONCATENATED MODULE: ./src/api/box-edit/ComServerClient.js
    function ComServerClient_defineProperty(e, r, t) {
      return (
        (r = ComServerClient_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ComServerClient_toPropertyKey(t) {
      var i = ComServerClient_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ComServerClient_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    const MIN_FIREFOX_VERSION_FOR_MIXED_CONTENT = 55;
    const MIN_EDGE_16_VERSION_FOR_MIXED_CONTENT = '16.16299';
    const MIN_EDGE_VERSION_FOR_MIXED_CONTENT = '17.17134';
    const REQUEST_TIMEOUT_MS = 5000;
    let boxToolsLogData;
    function createHTTPChannel(appName) {
      const { BOX_UNSECURE_LOCAL_BASE_URL, CREATED_STATUS, HTTP_CHANNEL_NAME } = constants;
      boxToolsLogData.http_channel_status = CREATED_STATUS;
      return new box_edit_HTTPChannel(appName, BOX_UNSECURE_LOCAL_BASE_URL, HTTP_CHANNEL_NAME);
    }
    function createSafariChannel(appName) {
      const { CREATED_STATUS } = constants;
      boxToolsLogData.safari_channel_status = CREATED_STATUS;
      return new box_edit_SafariChannel(appName);
    }
    function createActiveXChannel(appName) {
      const { CREATED_STATUS } = constants;
      boxToolsLogData.activex_channel_status = CREATED_STATUS;
      return new box_edit_ActiveXChannel(appName, false);
    }

    /**
     * Returns an instance of the ActiveX Channel that runs commands in the ActiveX process synchronously.
     * This is required for running in certain embedded IE-based webviews.
     */
    function createSynchronousActiveXChannel(appName) {
      const { CREATED_STATUS } = constants;
      boxToolsLogData.activex_channel_status = CREATED_STATUS;
      return new box_edit_ActiveXChannel(appName, true);
    }

    /**
     * Returns TRUE for MS Edge versions 17.17692+ OR
     * Returns TRUE for MS Edge version 16 greater than 16.16299
     * @returns {boolean}
     */
    function isSupportedMSEdgeVersion() {
      const { EDGE } = BROWSER_CONSTANTS;
      return (
        box_edit_BrowserUtils.isMinBrowser(EDGE, MIN_EDGE_VERSION_FOR_MIXED_CONTENT) ||
        (box_edit_BrowserUtils.isMinBrowser(EDGE, MIN_EDGE_16_VERSION_FOR_MIXED_CONTENT) &&
          box_edit_BrowserUtils.getVersion().startsWith('16.'))
      );
    }
    function isUnsupportedMSEdgeVersion() {
      return box_edit_BrowserUtils.isEdge() && !isSupportedMSEdgeVersion();
    }
    function isMixedContentAllowedOnLocalhost() {
      const { CHROME, FIREFOX } = BROWSER_CONSTANTS;
      // TODO can we do this with feature detection rather than sniffing?
      return (
        box_edit_BrowserUtils.isMinBrowser(CHROME, 53) ||
        box_edit_BrowserUtils.isMinBrowser(FIREFOX, MIN_FIREFOX_VERSION_FOR_MIXED_CONTENT) ||
        isSupportedMSEdgeVersion()
      );
    }
    function isSupportedSafariVersion() {
      return box_edit_BrowserUtils.isMinBrowser(BROWSER_CONSTANTS.SAFARI, 10);
    }
    function isUnsupportedSafariVersion() {
      return box_edit_BrowserUtils.isSafari() && !isSupportedSafariVersion();
    }

    /**
     * @TODO: (2018-07-24) Rename this to isFirefoxWithoutMixedContentCapability
     * since we do not have an Extension planned for the Firefox versions below 55.
     */
    function isFirefoxWithExtensionsCapability() {
      return (
        box_edit_BrowserUtils.isFirefox() &&
        !box_edit_BrowserUtils.isMinBrowser(BROWSER_CONSTANTS.FIREFOX, MIN_FIREFOX_VERSION_FOR_MIXED_CONTENT)
      );
    }

    /**
     * Checks if the IE version is supported
     * @returns {boolean}
     */
    function isSupportedIEVersion() {
      return box_edit_BrowserUtils.isMinBrowser(BROWSER_CONSTANTS.IE, 11);
    }

    /**
     * Checks if the user is on IE 11 and has a specific ActiveXObject plugin loaded on the page
     */
    function isSupportedIEAndBoxToolsPluginAvailable() {
      // Browser Plugins Support is the check for ActiveX-like plugins
      return (
        isSupportedIEVersion() &&
        box_edit_BrowserUtils.isIEAndSpecificBrowserPluginSupported(constants.BOX_TOOLS_PLUGIN_NAME)
      );
    }

    /**
     * Analyze the cause of Channel failure and return a rejected Promise with an error message
     */
    function comServerErrorGenerator(reject) {
      const {
        BOX_EDIT_NOT_SUPPORTED_ERROR,
        BOX_EDIT_SAFARI_ERROR,
        BOX_EDIT_UNINSTALLED_ERROR,
        BOX_EDIT_UPGRADE_BROWSER_ERROR,
      } = constants;
      let errorMessageID = BOX_EDIT_NOT_SUPPORTED_ERROR;
      if (isMixedContentAllowedOnLocalhost()) {
        errorMessageID = BOX_EDIT_UNINSTALLED_ERROR;
      } else if (isSupportedIEVersion()) {
        errorMessageID = BOX_EDIT_UNINSTALLED_ERROR;
      } else if (
        box_edit_BrowserUtils.isFirefox() ||
        box_edit_BrowserUtils.isChrome() ||
        isUnsupportedSafariVersion() ||
        isUnsupportedMSEdgeVersion()
        // Show UPGRADE message when MS Edge support has been enabled
      ) {
        errorMessageID = BOX_EDIT_UPGRADE_BROWSER_ERROR;
      } else if (isSupportedSafariVersion()) {
        errorMessageID = BOX_EDIT_SAFARI_ERROR;
      }
      boxToolsLogData.error_message = errorMessageID;
      return reject(new Error(errorMessageID));
    }

    /**
     * Default returns the timeout value of 5000ms, if a timeout is not passed.
     * When passed validates it to be a number and parse it to the lower integer value
     *
     * @param {number} [customTimeoutMS] optional field to override the timeout value passed in miliseconds
     * @returns {number}
     */
    function validateAndReturnBrowserToComServerTimeout(customTimeoutMS) {
      let timeoutMS = REQUEST_TIMEOUT_MS;

      // validate timeout is a positive number
      if (typeof customTimeoutMS === 'number' && customTimeoutMS >= 0) {
        timeoutMS = Math.floor(customTimeoutMS);
      }
      return timeoutMS;
    }

    /**
     * Returns reduced timeout converted to seconds
     * We need to use a shortened timeout for the connection between local com server and application,
     * so that we will receive a message that that connection has timed out,
     * before the connection between the browser and the local com server itself times out.
     */
    function shortenAndReturnComServerToApplicationTimeout(browserToComServerTimeoutMS) {
      let timeoutSec = +(browserToComServerTimeoutMS / 1000).toFixed(2);
      if (browserToComServerTimeoutMS < 2) {
        timeoutSec /= 2;
      } else {
        timeoutSec -= 1;
      }
      return timeoutSec;
    }
    function initBoxToolsLogData() {
      const browserName = box_edit_BrowserUtils.getName();
      const browserVersion = box_edit_BrowserUtils.getVersion();
      const { UNCREATED_STATUS } = constants;
      boxToolsLogData = {
        box_tools_version: null,
        browser_name: browserName,
        browser_version: browserVersion,
        error_message: null,
        installation_type: null,
        http_channel_status: UNCREATED_STATUS,
        https_channel_status: UNCREATED_STATUS,
        activex_channel_status: UNCREATED_STATUS,
        safari_channel_status: UNCREATED_STATUS,
      };
    }
    class ComServerClient {
      constructor(appName) {
        ComServerClient_defineProperty(this, 'isInitialized', false);
        this.channels = [];
        this.isInitialized = true;
        initBoxToolsLogData();
        if (isMixedContentAllowedOnLocalhost()) {
          this.channels.push(createHTTPChannel(appName));
        } else if (isSupportedSafariVersion()) {
          this.channels.push(createSafariChannel(appName));
        } else if (isSupportedIEAndBoxToolsPluginAvailable()) {
          this.channels.push(createActiveXChannel(appName));
        } else if (isFirefoxWithExtensionsCapability() || isUnsupportedMSEdgeVersion()) {
          // @NOTE (2018-07-24) No Action - Trying all channels is not an option in this case
          // @TODO (2018-07-24) Remove this empty case from here?
        } else {
          // @NOTE: (2018-01-16) Trying all channels in case of custom useragent
          this.channels = this.channels.concat([
            createHTTPChannel(appName),
            createSafariChannel(appName),
            createSynchronousActiveXChannel(appName),
          ]);
        }
      }
      getComServerStatus(customTimeoutMS) {
        const { ACTIVE_STATUS } = constants;
        const browserToComServerTimeoutMS = validateAndReturnBrowserToComServerTimeout(customTimeoutMS);
        const comServerToApplicationTimeoutSec =
          shortenAndReturnComServerToApplicationTimeout(browserToComServerTimeoutMS);
        const shouldRejectPromiseDueToUnSupportedMSEdgeOrVersion = isUnsupportedMSEdgeVersion();
        return new Promise((resolve, reject) => {
          if (shouldRejectPromiseDueToUnSupportedMSEdgeOrVersion) {
            return comServerErrorGenerator.call(null, reject);
          }
          if (!this.channels.length) {
            return comServerErrorGenerator.call(null, reject);
          }
          return promise(
            this.channels.map(channel => {
              return channel
                .getComServerStatus(browserToComServerTimeoutMS, comServerToApplicationTimeoutSec)
                .then(res => {
                  this.activeChannel = channel;
                  if (res) {
                    boxToolsLogData.installation_type = res.installation_type;
                    boxToolsLogData.box_tools_version = res.version;
                  }
                  boxToolsLogData[`${channel.channelName}_status`] = ACTIVE_STATUS;
                  return resolve(res);
                });
            }),
          ).catch(comServerErrorGenerator.bind(null, reject));
        });
      }

      // TODO isSynchronous? do we need it?
      sendRequest(requestData, isSynchronous, customTimeoutMS) {
        const browserToComServerTimeoutMS = validateAndReturnBrowserToComServerTimeout(customTimeoutMS);
        const comServerToApplicationTimeoutSec =
          shortenAndReturnComServerToApplicationTimeout(browserToComServerTimeoutMS);
        if (this.activeChannel) {
          return this.activeChannel.sendRequest(
            requestData,
            browserToComServerTimeoutMS,
            comServerToApplicationTimeoutSec,
          );
        }
        return this.getComServerStatus().then(() => {
          return this.activeChannel.sendRequest(
            requestData,
            browserToComServerTimeoutMS,
            comServerToApplicationTimeoutSec,
          );
        });
      }
      sendCommand(data, customTimeoutMS) {
        const browserToComServerTimeoutMS = validateAndReturnBrowserToComServerTimeout(customTimeoutMS);
        const comServerToApplicationTimeoutSec =
          shortenAndReturnComServerToApplicationTimeout(browserToComServerTimeoutMS);
        if (this.activeChannel) {
          return this.activeChannel.sendCommand(data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec);
        }
        return this.getComServerStatus().then(() => {
          return this.activeChannel.sendCommand(data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec);
        });
      }
    }
    /* harmony default export */ const box_edit_ComServerClient = ComServerClient; // CONCATENATED MODULE: ./src/api/box-edit/BoxEdit.js
    const TIMEOUT_MS = 5000;
    const EXTENSION_CHECK_DEBOUNCE_TIME = 100;
    let extensionRequestTimeout;
    function createRequestData(extensions) {
      return JSON.stringify({
        request_type: 'get_default_application',
        extension: extensions,
      });
    }
    function createExecuteData(fileId, token, authCode, tokenScope) {
      const execData = JSON.stringify({
        auth_code: authCode,
        auth_token: token,
        browser_type: box_edit_BrowserUtils.getName(),
        command_type: 'launch_application',
        file_id: fileId.toString(),
        token_scope: tokenScope,
      });
      return execData;
    }
    function isBlacklistedExtension(extension) {
      const { EXTENSION_BLACKLIST } = constants;
      let uppercaseExt = extension.toUpperCase();

      // if ext has a leading ., strip it
      if (uppercaseExt.charAt(0) === '.') {
        uppercaseExt = uppercaseExt.substr(1);
      }
      return uppercaseExt in EXTENSION_BLACKLIST;
    }
    let BoxEditInstance = null;
    class BoxEdit {
      constructor() {
        if (!(BoxEditInstance instanceof BoxEdit)) {
          BoxEditInstance = this;
        }
        this.extensionRequestQueue = new Map();
        // eslint-disable-next-line no-constructor-return
        return BoxEditInstance;
      }
      queueGetNativeAppNameFromLocal(extension) {
        // There's already a pending or fulfilled request for the appname
        if (this.extensionRequestQueue.has(extension)) {
          const queueItem = this.extensionRequestQueue.get(extension);
          if (!queueItem) {
            throw new Error('Race condition re: queueGetNativeAppNameFromLocal');
          }
          return queueItem.promise;
        }
        const extensionRequest = {};
        const appNameRequestPromise = new Promise((resolve, reject) => {
          extensionRequest.resolve = resolve;
          extensionRequest.reject = reject;
        });
        extensionRequest.promise = appNameRequestPromise;
        this.extensionRequestQueue.set(extension, extensionRequest);
        return appNameRequestPromise;
      }
      checkBoxEditAvailability() {
        return this.getBoxEditAvailability();
      }
      getBoxEditAvailability() {
        this.client = new box_edit_ComServerClient(constants.BOX_EDIT_APP_NAME);
        return this.client.getComServerStatus();
      }
      async canOpenWithBoxEdit(extensions) {
        const extensionToAppTuples = await Promise.all(
          extensions.map(async ext => {
            try {
              const appName = await this.getAppForExtension(ext);
              const result = [ext, appName];
              return result;
            } catch (err) {
              const result = [ext, ''];
              return result;
            }
          }),
        );
        const resultMap = new Map();
        extensionToAppTuples.forEach(tuple => resultMap.set(...tuple));
        return Promise.resolve(resultMap);
      }
      openFile(fileID, token) {
        // @NOTE. canOpenWithBoxEdit, create token taken care of higher levels
        // therefore not ported into React library

        // TODO is token the right name?
        const executeDataAsString = createExecuteData(
          fileID,
          token.data.token,
          token.data.auth_code,
          token.data.token_scope,
        );
        return this.client.sendCommand(executeDataAsString, TIMEOUT_MS);
      }
      getAppForExtension(extension) {
        try {
          if (isBlacklistedExtension(extension)) {
            throw new Error('blacklisted');
          }
          const applicationSupportRequest = this.queueGetNativeAppNameFromLocal(extension);
          if (!extensionRequestTimeout) {
            extensionRequestTimeout = setTimeout(() => {
              this.processExtensionRequestQueue();
            }, EXTENSION_CHECK_DEBOUNCE_TIME);
          }
          return applicationSupportRequest;
        } catch (err) {
          return Promise.reject();
        }
      }
      processExtensionRequestQueue() {
        const copyQueue = new Map();
        const extensions = [];
        this.extensionRequestQueue.forEach((value, key) => {
          copyQueue.set(key, value);
          extensions.push(key);
        });
        this.extensionRequestQueue.clear();
        extensionRequestTimeout = null;
        const requestData = createRequestData(extensions);
        return this.client.sendRequest(requestData).then(data => {
          if (data && data.default_application_name) {
            let defaultApplicationName = data.default_application_name;

            // @TODO. Reassess.
            // This is an odd construction that may not be necessary.
            if (Object.prototype.toString.call(defaultApplicationName) === '[object Object]') {
              defaultApplicationName = [defaultApplicationName];
            }
            defaultApplicationName.forEach(extensionAppObj => {
              const extension = Object.keys(extensionAppObj)[0];
              const appName = decodeURIComponent(extensionAppObj[extension]);
              if (appName) {
                const queueItem = copyQueue.get(extension);
                if (queueItem) {
                  queueItem.resolve(appName);
                  copyQueue.delete(extension);
                }
              }
            });
          }

          // Reject all remaining items in the queue
          extensions.forEach(extension => {
            const queueItem = copyQueue.get(extension);
            if (queueItem) {
              queueItem.reject();
            }
          });
        });
      }
    }
    /* harmony default export */ const box_edit_BoxEdit = BoxEdit; // CONCATENATED MODULE: ./src/api/box-edit/index.js
    // CONCATENATED MODULE: ./src/api/Intelligence.js
    /**
     *
     * @file Helper for the Box AI API endpoint
     * @author Box
     */

    class Intelligence extends api_Base {
      /**
       * API endpoint to ask ai a question
       *
       * @param {string} prompt - Question
       * @param {Array<object>} items - Array of items to ask about
       * @return {Promise}
       */
      async ask(prompt, items) {
        if (!prompt) {
          throw new Error('Missing prompt!');
        }
        if (!items || items.length === 0) {
          throw new Error('Missing items!');
        }
        items.forEach(item => {
          if (!item.id || !item.type) {
            throw new Error('Invalid item!');
          }
        });
        const url = `${this.getBaseApiUrl()}/ai/ask`;
        return this.xhr.post({
          url,
          id: `file_${items[0].id}`,
          data: {
            mode: 'single_item_qa',
            prompt,
            items,
          },
        });
      }
    }
    /* harmony default export */ const api_Intelligence = Intelligence; // CONCATENATED MODULE: ./src/api/APIFactory.js
    function APIFactory_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function APIFactory_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? APIFactory_ownKeys(Object(t), !0).forEach(function (r) {
              APIFactory_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : APIFactory_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function APIFactory_defineProperty(e, r, t) {
      return (
        (r = APIFactory_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function APIFactory_toPropertyKey(t) {
      var i = APIFactory_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function APIFactory_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Main entry point for the box api
     * @author Box
     */

    class APIFactory {
      /**
       * @property {*}
       */

      /**
       * @property {FileAPI}
       */

      /**
       * @property {WebLink}
       */

      /**
       * @property {FolderAPI}
       */

      /**
       * @property {PlainUploadAPI}
       */

      /**
       * @property {ChunkedUploadAPI}
       */

      /**
       * @property {SearchAPI}
       */

      /**
       * @property {RecentsAPI}
       */

      /**
       * @property {VersionsAPI}
       */

      /**
       * @property {CommentsAPI}
       */

      /**
       * @property {ThreadedCommentsAPI}
       */

      /**
       * @property {TasksNewAPI}
       */

      /**
       * @property {TaskCollaboratorsAPI}
       */

      /**
       * @property {TaskLinksAPI}
       */

      /*
       * @property {FileAccessStatsAPI}
       */

      /*
       * @property {FileActivitiesAPI}
       */

      /*
       * @property {MarkerBasedGroupsAPI}
       */

      /*
       * @property {MarkerBasedUsersAPI}
       */

      /**
       * @property {GroupsAPI}
       */

      /*
       * @property {UsersAPI}
       */

      /*
       * @property {MetadataAPI}
       */

      /**
       * @property {FileCollaboratorsAPI}
       */

      /**
       * @property {FileCollaborationsAPI}
       */

      /**
       * @property {FolderCollaborationsAPI}
       */

      /**
       * @property {CollaborationsAPI}
       */

      /**
       * @property {FeedAPI}
       */

      /**
       * @property {OpenWithAPI}
       */

      /**
       * @property {AppIntegrationsAPI}
       */

      /**
       * @property {MetadataQueryAPI}
       */

      /** @property {BoxEditAPI}
       *
       */

      /**
       * @property {AnnotationsAPI}
       */

      /**
       * @property {IntelligenceAPI}
       */

      /**
       * [constructor]
       *
       * @param {Object} options
       * @param {string} options.id - item id
       * @param {string|function} options.token - Auth token
       * @param {string} [options.sharedLink] - Shared link
       * @param {string} [options.sharedLinkPassword] - Shared link password
       * @param {string} [options.apiHost] - Api host
       * @param {string} [options.uploadHost] - Upload host name
       * @return {API} Api instance
       */
      constructor(options) {
        this.options = APIFactory_objectSpread(
          APIFactory_objectSpread({}, options),
          {},
          {
            apiHost: options.apiHost || DEFAULT_HOSTNAME_API,
            uploadHost: options.uploadHost || DEFAULT_HOSTNAME_UPLOAD,
            cache: options.cache || new utils_Cache(),
            language: options.language,
          },
        );
      }

      /**
       * [destructor]
       *
       * @param {boolean} destroyCache - true to destroy cache
       * @return {void}
       */
      destroy(destroyCache = false) {
        if (this.fileAPI) {
          this.fileAPI.destroy();
          delete this.fileAPI;
        }
        if (this.weblinkAPI) {
          this.weblinkAPI.destroy();
          delete this.weblinkAPI;
        }
        if (this.plainUploadAPI) {
          this.plainUploadAPI.destroy();
          delete this.plainUploadAPI;
        }
        if (this.chunkedUploadAPI) {
          this.chunkedUploadAPI.destroy();
          delete this.chunkedUploadAPI;
        }
        if (this.folderAPI) {
          this.folderAPI.destroy();
          delete this.folderAPI;
        }
        if (this.searchAPI) {
          this.searchAPI.destroy();
          delete this.searchAPI;
        }
        if (this.recentsAPI) {
          this.recentsAPI.destroy();
          delete this.recentsAPI;
        }
        if (this.versionsAPI) {
          this.versionsAPI.destroy();
          delete this.versionsAPI;
        }
        if (this.fileAccessStatsAPI) {
          this.fileAccessStatsAPI.destroy();
          delete this.fileAccessStatsAPI;
        }
        if (this.fileActivitiesAPI) {
          this.fileActivitiesAPI.destroy();
          delete this.fileActivitiesAPI;
        }
        if (this.tasksNewAPI) {
          this.tasksNewAPI.destroy();
          delete this.tasksNewAPI;
        }
        if (this.taskCollaboratorsAPI) {
          this.taskCollaboratorsAPI.destroy();
          delete this.taskCollaboratorsAPI;
        }
        if (this.taskLinksAPI) {
          this.taskLinksAPI.destroy();
          delete this.taskLinksAPI;
        }
        if (this.commentsAPI) {
          this.commentsAPI.destroy();
          delete this.commentsAPI;
        }
        if (this.threadedCommentsAPI) {
          this.threadedCommentsAPI.destroy();
          delete this.threadedCommentsAPI;
        }
        if (this.markerBasedGroupsAPI) {
          this.markerBasedGroupsAPI.destroy();
          delete this.markerBasedGroupsAPI;
        }
        if (this.markerBasedUsersAPI) {
          this.markerBasedUsersAPI.destroy();
          delete this.markerBasedUsersAPI;
        }
        if (this.groupsAPI) {
          this.groupsAPI.destroy();
          delete this.groupsAPI;
        }
        if (this.usersAPI) {
          this.usersAPI.destroy();
          delete this.usersAPI;
        }
        if (this.metadataAPI) {
          this.metadataAPI.destroy();
          delete this.metadataAPI;
        }
        if (this.fileCollaboratorsAPI) {
          this.fileCollaboratorsAPI.destroy();
          delete this.fileCollaboratorsAPI;
        }
        if (this.fileCollaborationsAPI) {
          this.fileCollaborationsAPI.destroy();
          delete this.fileCollaborationsAPI;
        }
        if (this.folderCollaborationsAPI) {
          this.folderCollaborationsAPI.destroy();
          delete this.folderCollaborationsAPI;
        }
        if (this.collaborationsAPI) {
          this.collaborationsAPI.destroy();
          delete this.collaborationsAPI;
        }
        if (this.appIntegrationsAPI) {
          this.appIntegrationsAPI.destroy();
          delete this.appIntegrationsAPI;
        }
        if (this.metadataQueryAPI) {
          this.metadataQueryAPI.destroy();
          delete this.metadataQueryAPI;
        }
        if (this.openWithAPI) {
          this.openWithAPI.destroy();
          delete this.openWithAPI;
        }
        if (this.annotationsAPI) {
          this.annotationsAPI.destroy();
          delete this.annotationsAPI;
        }
        if (this.intelligenceAPI) {
          this.intelligenceAPI.destroy();
          delete this.intelligenceAPI;
        }
        if (destroyCache) {
          this.options.cache = new utils_Cache();
        }
      }

      /**
       * Gets the cache instance
       *
       * @return {Cache} cache instance
       */
      getCache() {
        return this.options.cache;
      }

      /**
       * Returns the API based on type of item
       *
       * @private
       * @param {String} type - item type
       * @return {ItemAPI} api
       */
      getAPI(type) {
        let api;
        switch (type) {
          case constants_TYPE_FOLDER:
            api = this.getFolderAPI();
            break;
          case constants_TYPE_FILE:
            api = this.getFileAPI();
            break;
          case TYPE_WEBLINK:
            api = this.getWebLinkAPI();
            break;
          default:
            throw new Error('Unknown Type!');
        }
        return api;
      }

      /**
       * API for file
       *
       * @return {FileAPI} FileAPI instance
       */
      getFileAPI(shouldDestroy = true) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.fileAPI = new api_File(this.options);
        return this.fileAPI;
      }

      /**
       * API for web links
       *
       * @return {WebLinkAPI} WebLinkAPI instance
       */
      getWebLinkAPI() {
        this.destroy();
        this.weblinkAPI = new api_WebLink(this.options);
        return this.weblinkAPI;
      }

      /**
       * API for plain uploads
       *
       * @return {UploadAPI} UploadAPI instance
       */
      getPlainUploadAPI() {
        this.destroy();
        this.plainUploadAPI = new uploads_PlainUpload(this.options);
        return this.plainUploadAPI;
      }

      /**
       * API for chunked uploads
       *
       * @return {UploadAPI} UploadAPI instance
       */
      getChunkedUploadAPI() {
        this.destroy();
        this.chunkedUploadAPI = new uploads_MultiputUpload(this.options);
        return this.chunkedUploadAPI;
      }

      /**
       * API for folder
       *
       * @return {FolderAPI} FolderAPI instance
       */
      getFolderAPI() {
        this.destroy();
        this.folderAPI = new api_Folder(this.options);
        return this.folderAPI;
      }

      /**
       * API for search
       *
       * @return {SearchAPI} SearchAPI instance
       */
      getSearchAPI() {
        this.destroy();
        this.searchAPI = new api_Search(this.options);
        return this.searchAPI;
      }

      /**
       * API for recents
       *
       * @return {RecentsAPI} RecentsAPI instance
       */
      getRecentsAPI() {
        this.destroy();
        this.recentsAPI = new api_Recents(this.options);
        return this.recentsAPI;
      }

      /**
       * API for metadata
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {MetadataAPI} MetadataAPI instance
       */
      getMetadataAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.metadataAPI = new api_Metadata(this.options);
        return this.metadataAPI;
      }

      /**
       * API for versions
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {VersionsAPI} VersionsAPI instance
       */
      getVersionsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.versionsAPI = new api_Versions(this.options);
        return this.versionsAPI;
      }

      /**
       * API for comments
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {CommentsAPI} CommentsAPI instance
       */
      getCommentsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.commentsAPI = new api_Comments(this.options);
        return this.commentsAPI;
      }

      /**
       * API for threaded comments
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {ThreadedCommentsAPI} ThreadedCommentsAPI instance
       */
      getThreadedCommentsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.threadedCommentsAPI = new api_ThreadedComments(this.options);
        return this.threadedCommentsAPI;
      }

      /**
       * API for tasks
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {TasksAPI} TaskAssignmentsAPI instance
       */
      getTasksNewAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.tasksNewAPI = new tasks_TasksNew(this.options);
        return this.tasksNewAPI;
      }

      /**
       * API for taskCollaborators
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {TaskCollaboratorsAPI} TaskCollaboratorsAPI instance
       */
      getTaskCollaboratorsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.taskCollaboratorsAPI = new tasks_TaskCollaborators(this.options);
        return this.taskCollaboratorsAPI;
      }

      /**
       * API for taskLinks
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {TasksAPI} TaskLinksAPI instance
       */
      getTaskLinksAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.taskLinksAPI = new tasks_TaskLinks(this.options);
        return this.taskLinksAPI;
      }

      /**
       * API for file access stats
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {FileAccessStatsAPI} FileAccessStatsAPI instance
       */
      getFileAccessStatsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.fileAccessStatsAPI = new api_FileAccessStats(this.options);
        return this.fileAccessStatsAPI;
      }

      /**
       * API for file access stats
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {FileActivitiesAPI} FileActivitiesAPI instance
       */
      getFileActivitiesAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.fileActivitiesAPI = new api_FileActivities(this.options);
        return this.fileActivitiesAPI;
      }

      /**
       * API for file collaborators
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {FileCollaboratorsAPI} FileCollaboratorsAPI instance
       */
      getFileCollaboratorsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.fileCollaboratorsAPI = new api_FileCollaborators(this.options);
        return this.fileCollaboratorsAPI;
      }

      /**
       * API for file collaborations
       *
       * This is different from the FileCollaboratorsAPI! See ./FileCollaborations for more information.
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {FileCollaborationsAPI} FileCollaborationsAPI instance
       */
      getFileCollaborationsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.fileCollaborationsAPI = new api_FileCollaborations(this.options);
        return this.fileCollaborationsAPI;
      }

      /**
       * API for folder collaborations
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {FolderCollaborationsAPI} FolderCollaborationsAPI instance
       */
      getFolderCollaborationsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.folderCollaborationsAPI = new api_FolderCollaborations(this.options);
        return this.folderCollaborationsAPI;
      }

      /**
       * API for collaborations
       *
       * This is different from the other collaboration/collaborator APIs!
       * See ./Collaborations for more information.
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {CollaborationsAPI} CollaborationsAPI instance
       */
      getCollaborationsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.collaborationsAPI = new api_Collaborations(this.options);
        return this.collaborationsAPI;
      }

      /**
       * API for Groups (marker-based paging)
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {MarkerBasedGroupsAPI} MarkerBasedGroupsAPI instance
       */
      getMarkerBasedGroupsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.markerBasedGroupsAPI = new api_MarkerBasedGroups(this.options);
        return this.markerBasedGroupsAPI;
      }

      /**
       * API for Users (marker-based paging)
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {MarkerBasedUsersAPI} MarkerBasedUsersAPI instance
       */
      getMarkerBasedUsersAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.markerBasedUsersAPI = new api_MarkerBasedUsers(this.options);
        return this.markerBasedUsersAPI;
      }

      /**
       * API for Groups (offset-based paging)
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {GroupsAPI} GroupsAPI instance
       */
      getGroupsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.groupsAPI = new api_Groups(this.options);
        return this.groupsAPI;
      }

      /**
       * API for Users (offset-based paging)
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {UsersAPI} UsersAPI instance
       */
      getUsersAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.usersAPI = new api_Users(this.options);
        return this.usersAPI;
      }

      /**
       * API for Feed Items
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {FeedAPI} FeedAPI instance
       */
      getFeedAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.feedItemsAPI = new api_Feed(this.options);
        return this.feedItemsAPI;
      }

      /**
       * API for Open With
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {OpenWithAPI} OpenWithAPI instance
       */
      getOpenWithAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.openWithAPI = new api_OpenWith(this.options);
        return this.openWithAPI;
      }

      /**
       * API for the App Integrations endpoint
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {AppIntegrationsAPI} AppIntegrationsAPI instance
       */
      getAppIntegrationsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.appIntegrationsAPI = new api_AppIntegrations(this.options);
        return this.appIntegrationsAPI;
      }

      /**
       * API for Metadata Query
       *
       * @param {boolean} shouldDestroy - true if the factory should destroy before returning the call
       * @return {MetadataQuery} MetadataQuery instance
       */
      getMetadataQueryAPI(shouldDestroy = false) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.metadataQueryAPI = new api_MetadataQuery(this.options);
        return this.metadataQueryAPI;
      }

      /**
       * API for Box Edit
       *
       * @return {BoxEditAPI} BoxEditAPI instance
       */
      getBoxEditAPI() {
        this.boxEditAPI = new box_edit_BoxEdit();
        return this.boxEditAPI;
      }

      /**
       * API for Annotations
       *
       * @return {AnnotationsAPI} AnnotationsAPI instance
       */
      getAnnotationsAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.annotationsAPI = new Annotations(this.options);
        return this.annotationsAPI;
      }

      /**
       * API for Intelligence
       *
       * @return {IntelligenceAPI} IntelligenceAPI instance
       */
      getIntelligenceAPI(shouldDestroy) {
        if (shouldDestroy) {
          this.destroy();
        }
        this.intelligenceAPI = new api_Intelligence(this.options);
        return this.intelligenceAPI;
      }
    }
    /* harmony default export */ const api_APIFactory = APIFactory; // CONCATENATED MODULE: ./src/api/index.js
    // CONCATENATED MODULE: ./src/elements/common/droppable/makeDroppable.js
    const makeDroppable_excluded = ['className'];
    function makeDroppable_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function makeDroppable_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? makeDroppable_ownKeys(Object(t), !0).forEach(function (r) {
              makeDroppable_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : makeDroppable_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function makeDroppable_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = makeDroppable_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function makeDroppable_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function makeDroppable_defineProperty(e, r, t) {
      return (
        (r = makeDroppable_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function makeDroppable_toPropertyKey(t) {
      var i = makeDroppable_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function makeDroppable_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file HOC for drag drop
     * @author Box
     */

    /* eslint-disable no-plusplus */
    const makeDroppable =
      ({ dropValidator, onDrop }) =>
      Wrapped => {
        var _DroppableComponent;
        return (
          (_DroppableComponent = class DroppableComponent extends react.PureComponent {
            /**
             * [constructor]
             *
             * @param {*} props
             * @return {DroppableComponent}
             */
            constructor(props) {
              super(props);
              /**
               * Function that removes the drag and drop related event listeners on the input element
               *
               * @param {Element} element
               * @return {void}
               */
              makeDroppable_defineProperty(this, 'removeEventListeners', element => {
                element.removeEventListener('dragenter', this.handleDragEnter);
                element.removeEventListener('dragover', this.handleDragOver);
                element.removeEventListener('dragleave', this.handleDragLeave);
                element.removeEventListener('drop', this.handleDrop);
              });
              /**
               * Bind drag and drop event handlers to the droppableEl, when the wrapped element
               * is changed, remove the event listeners on the previous droppableEl and add
               * event listeners on the new droppableEl
               */
              makeDroppable_defineProperty(this, 'bindDragDropHandlers', () => {
                const droppableEl = (0, react_dom.findDOMNode)(this); // eslint-disable-line react/no-find-dom-node
                if (!droppableEl || !(droppableEl instanceof Element)) {
                  return;
                }

                // add event listeners directly on the element
                droppableEl.addEventListener('dragenter', this.handleDragEnter);
                droppableEl.addEventListener('dragover', this.handleDragOver);
                droppableEl.addEventListener('dragleave', this.handleDragLeave);
                droppableEl.addEventListener('drop', this.handleDrop);
                this.droppableEl = droppableEl;
              });
              /**
               * Function that gets called when an item is dragged into the drop zone
               *
               * @param {SyntheticEvent} event - The dragenter event
               * @return {void}
               */
              makeDroppable_defineProperty(this, 'handleDragEnter', event => {
                // This allows onDrop to be fired
                event.preventDefault();

                // Use this to track the number of drag enters and leaves.
                // This is used to normalize enters/leaves between parent/child elements

                // we only want to do things in dragenter when the counter === 1
                if (++this.enterLeaveCounter === 1) {
                  const { dataTransfer } = event;

                  // if we don't have a dropValidator, we just default canDrop to true
                  const canDrop = dropValidator ? dropValidator(this.props, dataTransfer) : true;
                  this.setState({
                    isOver: true,
                    canDrop,
                  });
                }
              });
              /**
               * Function that gets called when an item is dragged over the drop zone
               *
               * @param {DragEvent} event - The dragover event
               * @return {void}
               */
              makeDroppable_defineProperty(this, 'handleDragOver', event => {
                // This allows onDrop to be fired
                event.preventDefault();
                const { canDrop } = this.state;
                const { dataTransfer } = event;
                if (!dataTransfer) {
                  return;
                }
                if (!canDrop) {
                  dataTransfer.dropEffect = 'none';
                } else if (dataTransfer.effectAllowed) {
                  // Set the drop effect if it was defined
                  dataTransfer.dropEffect = dataTransfer.effectAllowed;
                }
              });
              /**
               * Function that gets called when an item is drop onto the drop zone
               *
               * @param {DragEvent} event - The drop event
               * @return {void}
               */
              makeDroppable_defineProperty(this, 'handleDrop', event => {
                event.preventDefault();

                // reset enterLeaveCounter
                this.enterLeaveCounter = 0;
                const { canDrop } = this.state;
                this.setState({
                  canDrop: false,
                  isDragging: false,
                  isOver: false,
                });
                if (canDrop && onDrop) {
                  onDrop(event, this.props);
                }
              });
              /**
               * Function that gets called when an item is dragged out of the drop zone
               *
               * @param {DragEvent} event - The dragleave event
               * @return {void}
               */
              makeDroppable_defineProperty(this, 'handleDragLeave', event => {
                event.preventDefault();

                // if enterLeaveCounter is zero, it means that we're actually leaving the item
                if (--this.enterLeaveCounter > 0) {
                  return;
                }
                this.setState({
                  canDrop: false,
                  isDragging: false,
                  isOver: false,
                });
              });
              this.enterLeaveCounter = 0;
              this.state = {
                canDrop: false,
                isDragging: false,
                isOver: false,
              };
            }

            /**
             * Adds event listeners once the component mounts
             * @inheritdoc
             */
            componentDidMount() {
              this.bindDragDropHandlers();
            }
            componentDidUpdate() {
              if (!this.droppableEl) {
                this.bindDragDropHandlers();
                return;
              }
              // eslint-disable-next-line react/no-find-dom-node
              if ((0, react_dom.findDOMNode)(this) !== this.droppableEl) {
                this.removeEventListeners(this.droppableEl);
                this.bindDragDropHandlers();
              }
            }
            /**
             * Removes event listeners when the component is going to unmount
             * @inheritdoc
             */
            componentWillUnmount() {
              if (!this.droppableEl || !(this.droppableEl instanceof Element)) {
                return;
              }
              this.removeEventListeners(this.droppableEl);
            }
            /**
             * Renders the HOC
             *
             * @private
             * @inheritdoc
             * @return {Element}
             */
            render() {
              const _this$props = this.props,
                { className } = _this$props,
                rest = makeDroppable_objectWithoutProperties(_this$props, makeDroppable_excluded);
              const { canDrop, isOver } = this.state;
              const classes = classnames_default()(className, {
                'is-droppable': canDrop,
                'is-over': isOver,
              });
              const mergedProps = makeDroppable_objectSpread(
                makeDroppable_objectSpread(makeDroppable_objectSpread({}, rest), this.state),
                {},
                {
                  className: classes,
                },
              );
              return /*#__PURE__*/ react.createElement(Wrapped, mergedProps);
            }
          }),
          makeDroppable_defineProperty(_DroppableComponent, 'defaultProps', {
            className: '',
          }),
          _DroppableComponent
        );
      };
    /* harmony default export */ const droppable_makeDroppable = makeDroppable; // CONCATENATED MODULE: ./src/elements/common/droppable/index.js
    // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/defaultHeaderRowRenderer.js
    /*:: import type {HeaderRowRendererParams} from './types';*/
    function defaultHeaderRowRenderer(_ref /*:: */) {
      var className = _ref /*:: */.className,
        columns = _ref /*:: */.columns,
        style = _ref /*:: */.style;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          role: 'rowgroup',
          className: 'ReactVirtualized__Table__headerRowGroup',
        },
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: className,
            role: 'row',
            style: style,
          },
          columns,
        ),
      );
    } // CONCATENATED MODULE: ./node_modules/clsx/dist/clsx.m.js
    function r(e) {
      var t,
        f,
        n = '';
      if ('string' == typeof e || 'number' == typeof e) n += e;
      else if ('object' == typeof e)
        if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += ' '), (n += f));
        else for (t in e) e[t] && (n && (n += ' '), (n += t));
      return n;
    }
    function clsx() {
      for (var e, t, f = 0, n = ''; f < arguments.length; )
        (e = arguments[f++]) && (t = r(e)) && (n && (n += ' '), (n += t));
      return n;
    }
    /* harmony default export */ const clsx_m = clsx; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/SortDirection.js
    var SortDirection = {
      /**
       * Sort items in ascending order.
       * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
       */
      ASC: 'ASC',
      /**
       * Sort items in descending order.
       * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
       */
      DESC: 'DESC',
    };
    /* harmony default export */ const Table_SortDirection = SortDirection; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/SortIndicator.js
    /**
     * Displayed beside a header to indicate that a Table is currently sorted by this column.
     */
    function SortIndicator(_ref) {
      var sortDirection = _ref.sortDirection;
      var classNames = clsx_m('ReactVirtualized__Table__sortableHeaderIcon', {
        'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === Table_SortDirection.ASC,
        'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === Table_SortDirection.DESC,
      });
      return /*#__PURE__*/ react.createElement(
        'svg',
        {
          className: classNames,
          width: 18,
          height: 18,
          viewBox: '0 0 24 24',
        },
        sortDirection === Table_SortDirection.ASC
          ? /*#__PURE__*/ react.createElement('path', {
              d: 'M7 14l5-5 5 5z',
            })
          : /*#__PURE__*/ react.createElement('path', {
              d: 'M7 10l5 5 5-5z',
            }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M0 0h24v24H0z',
          fill: 'none',
        }),
      );
    }
    SortIndicator.propTypes = false ? 0 : {}; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/defaultHeaderRenderer.js
    /*:: import type {HeaderRendererParams} from './types';*/
    /**
     * Default table header renderer.
     */
    function defaultHeaderRenderer(_ref /*:: */) {
      var dataKey = _ref /*:: */.dataKey,
        label = _ref /*:: */.label,
        sortBy = _ref /*:: */.sortBy,
        sortDirection = _ref /*:: */.sortDirection;
      var showSortIndicator = sortBy === dataKey;
      var children = [
        /*#__PURE__*/ react.createElement(
          'span',
          {
            className: 'ReactVirtualized__Table__headerTruncatedText',
            key: 'label',
            title: typeof label === 'string' ? label : null,
          },
          label,
        ),
      ];
      if (showSortIndicator) {
        children.push(
          /*#__PURE__*/ react.createElement(SortIndicator, {
            key: 'SortIndicator',
            sortDirection: sortDirection,
          }),
        );
      }
      return children;
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/defaultRowRenderer.js
    /*:: import type {RowRendererParams} from './types';*/
    /**
     * Default row renderer for Table.
     */
    function defaultRowRenderer(_ref /*:: */) {
      var className = _ref /*:: */.className,
        columns = _ref /*:: */.columns,
        index = _ref /*:: */.index,
        key = _ref /*:: */.key,
        onRowClick = _ref /*:: */.onRowClick,
        onRowDoubleClick = _ref /*:: */.onRowDoubleClick,
        onRowMouseOut = _ref /*:: */.onRowMouseOut,
        onRowMouseOver = _ref /*:: */.onRowMouseOver,
        onRowRightClick = _ref /*:: */.onRowRightClick,
        rowData = _ref /*:: */.rowData,
        style = _ref /*:: */.style;
      var a11yProps = {
        'aria-rowindex': index + 1,
      };
      if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
        a11yProps.tabIndex = 0;
        if (onRowClick) {
          a11yProps.onClick = function (event) {
            return onRowClick({
              event: event,
              index: index,
              rowData: rowData,
            });
          };
        }
        if (onRowDoubleClick) {
          a11yProps.onDoubleClick = function (event) {
            return onRowDoubleClick({
              event: event,
              index: index,
              rowData: rowData,
            });
          };
        }
        if (onRowMouseOut) {
          a11yProps.onMouseOut = function (event) {
            return onRowMouseOut({
              event: event,
              index: index,
              rowData: rowData,
            });
          };
        }
        if (onRowMouseOver) {
          a11yProps.onMouseOver = function (event) {
            return onRowMouseOver({
              event: event,
              index: index,
              rowData: rowData,
            });
          };
        }
        if (onRowRightClick) {
          a11yProps.onContextMenu = function (event) {
            return onRowRightClick({
              event: event,
              index: index,
              rowData: rowData,
            });
          };
        }
      }
      return /*#__PURE__*/ react.createElement(
        'div',
        extends_extends({}, a11yProps, {
          className: className,
          key: key,
          role: 'row',
          style: style,
        }),
        columns,
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
    function _typeof(o) {
      '@babel/helpers - typeof';

      return (
        (_typeof =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (o) {
                return typeof o;
              }
            : function (o) {
                return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype
                  ? 'symbol'
                  : typeof o;
              }),
        _typeof(o)
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

    function toPrimitive(t, r) {
      if ('object' != _typeof(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i)) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js

    function toPropertyKey(t) {
      var i = toPrimitive(t, 'string');
      return 'symbol' == _typeof(i) ? i : i + '';
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

    function _defineProperties(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        (o.enumerable = o.enumerable || !1),
          (o.configurable = !0),
          'value' in o && (o.writable = !0),
          Object.defineProperty(e, toPropertyKey(o.key), o);
      }
    }
    function _createClass(e, r, t) {
      return (
        r && _defineProperties(e.prototype, r),
        t && _defineProperties(e, t),
        Object.defineProperty(e, 'prototype', {
          writable: !1,
        }),
        e
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

    function _classCallCheck(a, n) {
      if (!(a instanceof n)) throw new TypeError('Cannot call a class as a function');
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js

    function _assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js

    function _possibleConstructorReturn(t, e) {
      if (e && ('object' == _typeof(e) || 'function' == typeof e)) return e;
      if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
      return _assertThisInitialized(t);
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

    function _getPrototypeOf(t) {
      return (
        (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf.bind()
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        _getPrototypeOf(t)
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

    function _inherits(t, e) {
      if ('function' != typeof e && null !== e)
        throw new TypeError('Super expression must either be null or a function');
      (t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0,
        },
      })),
        Object.defineProperty(t, 'prototype', {
          writable: !1,
        }),
        e && _setPrototypeOf(t, e);
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

    function defineProperty_defineProperty(e, r, t) {
      return (
        (r = toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, {
              value: t,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[r] = t),
        e
      );
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/defaultCellRenderer.js

    /*:: import type {CellRendererParams} from './types';*/
    /**
     * Default cell renderer that displays an attribute as a simple string
     * You should override the column's cellRenderer if your data is some other type of object.
     */
    function defaultCellRenderer(_ref /*:: */) /*: string*/ {
      var cellData = _ref /*:: */.cellData;
      if (cellData == null) {
        return '';
      } else {
        return String(cellData);
      }
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/defaultCellDataGetter.js
    /*:: import type {CellDataGetterParams} from './types';*/
    /**
     * Default accessor for returning a cell value for a given attribute.
     * This function expects to operate on either a vanilla Object or an Immutable Map.
     * You should override the column's cellDataGetter if your data is some other type of object.
     */
    function defaultCellDataGetter(_ref /*:: */) {
      var dataKey = _ref /*:: */.dataKey,
        rowData = _ref /*:: */.rowData;
      if (typeof rowData.get === 'function') {
        return rowData.get(dataKey);
      } else {
        return rowData[dataKey];
      }
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/Column.js
    function _callSuper(t, o, e) {
      return (
        (o = _getPrototypeOf(o)),
        _possibleConstructorReturn(
          t,
          _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e),
        )
      );
    }
    function _isNativeReflectConstruct() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (t) {}
      return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
      })();
    }

    /**
     * Describes the header and cell contents of a table column.
     */
    var Column = /*#__PURE__*/ (function (_React$Component) {
      function Column() {
        _classCallCheck(this, Column);
        return _callSuper(this, Column, arguments);
      }
      _inherits(Column, _React$Component);
      return _createClass(Column);
    })(react.Component);
    defineProperty_defineProperty(Column, 'defaultProps', {
      cellDataGetter: defaultCellDataGetter,
      cellRenderer: defaultCellRenderer,
      defaultSortDirection: Table_SortDirection.ASC,
      flexGrow: 0,
      flexShrink: 1,
      headerRenderer: defaultHeaderRenderer,
      headerRole: 'columnheader',
      role: 'gridcell',
      style: {},
    });

    Column.propTypes = false ? 0 : {}; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/utils/calculateSizeAndPositionDataAndUpdateScrollOffset.js
    /**
     * Helper method that determines when to recalculate row or column metadata.
     */
    /*:: type Params<T> = {
			  // Number of rows or columns in the current axis
			  cellCount: number,
			
			  // Width or height of cells for the current axis
			  cellSize: ?number,
			
			  // Method to invoke if cell metadata should be recalculated
			  computeMetadataCallback: (props: T) => void,
			
			  // Parameters to pass to :computeMetadataCallback
			  computeMetadataCallbackProps: T,
			
			  // Newly updated number of rows or columns in the current axis
			  nextCellsCount: number,
			
			  // Newly updated width or height of cells for the current axis
			  nextCellSize: ?number,
			
			  // Newly updated scroll-to-index
			  nextScrollToIndex: number,
			
			  // Scroll-to-index
			  scrollToIndex: number,
			
			  // Callback to invoke if the scroll position should be recalculated
			  updateScrollOffsetForScrollToIndex: () => void,
			};*/
    function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref /*:: */) {
      var cellCount = _ref /*:: */.cellCount,
        cellSize = _ref /*:: */.cellSize,
        computeMetadataCallback = _ref /*:: */.computeMetadataCallback,
        computeMetadataCallbackProps = _ref /*:: */.computeMetadataCallbackProps,
        nextCellsCount = _ref /*:: */.nextCellsCount,
        nextCellSize = _ref /*:: */.nextCellSize,
        nextScrollToIndex = _ref /*:: */.nextScrollToIndex,
        scrollToIndex = _ref /*:: */.scrollToIndex,
        updateScrollOffsetForScrollToIndex = _ref /*:: */.updateScrollOffsetForScrollToIndex;
      // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
      // In that event users should use the manual recompute methods to inform of changes.
      if (
        cellCount !== nextCellsCount ||
        ((typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize)
      ) {
        computeMetadataCallback(computeMetadataCallbackProps);

        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
          updateScrollOffsetForScrollToIndex();
        }
      }
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
    function objectWithoutProperties_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/utils/CellSizeAndPositionManager.js

    /*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/
    /*:: type CellSizeAndPositionManagerParams = {
			  cellCount: number,
			  cellSizeGetter: CellSizeGetter,
			  estimatedCellSize: number,
			};*/
    /*:: type ConfigureParams = {
			  cellCount: number,
			  estimatedCellSize: number,
			  cellSizeGetter: CellSizeGetter,
			};*/
    /*:: type GetUpdatedOffsetForIndex = {
			  align: Alignment,
			  containerSize: number,
			  currentOffset: number,
			  targetIndex: number,
			};*/
    /*:: type GetVisibleCellRangeParams = {
			  containerSize: number,
			  offset: number,
			};*/
    /*:: type SizeAndPositionData = {
			  offset: number,
			  size: number,
			};*/
    /**
     * Just-in-time calculates and caches size and position information for a collection of cells.
     */
    var CellSizeAndPositionManager = /*#__PURE__*/ (function () {
      function CellSizeAndPositionManager(_ref /*:: */) {
        var cellCount = _ref /*:: */.cellCount,
          cellSizeGetter = _ref /*:: */.cellSizeGetter,
          estimatedCellSize = _ref /*:: */.estimatedCellSize;
        _classCallCheck(this, CellSizeAndPositionManager);
        // Cache of size and position data for cells, mapped by cell index.
        // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
        defineProperty_defineProperty(this, '_cellSizeAndPositionData', {});
        // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
        defineProperty_defineProperty(this, '_lastMeasuredIndex', -1);
        // Used in deferred mode to track which cells have been queued for measurement.
        defineProperty_defineProperty(this, '_lastBatchedIndex', -1);
        defineProperty_defineProperty(this, '_cellCount', void 0);
        defineProperty_defineProperty(this, '_cellSizeGetter', void 0);
        defineProperty_defineProperty(this, '_estimatedCellSize', void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
      }
      return _createClass(CellSizeAndPositionManager, [
        {
          key: 'areOffsetsAdjusted',
          value: function areOffsetsAdjusted() {
            return false;
          },
        },
        {
          key: 'configure',
          value: function configure(_ref2 /*:: */) {
            var cellCount = _ref2 /*:: */.cellCount,
              estimatedCellSize = _ref2 /*:: */.estimatedCellSize,
              cellSizeGetter = _ref2 /*:: */.cellSizeGetter;
            this._cellCount = cellCount;
            this._estimatedCellSize = estimatedCellSize;
            this._cellSizeGetter = cellSizeGetter;
          },
        },
        {
          key: 'getCellCount',
          value: function getCellCount() /*: number*/ {
            return this._cellCount;
          },
        },
        {
          key: 'getEstimatedCellSize',
          value: function getEstimatedCellSize() /*: number*/ {
            return this._estimatedCellSize;
          },
        },
        {
          key: 'getLastMeasuredIndex',
          value: function getLastMeasuredIndex() /*: number*/ {
            return this._lastMeasuredIndex;
          },
        },
        {
          key: 'getOffsetAdjustment',
          value: function getOffsetAdjustment() {
            return 0;
          },

          /**
           * This method returns the size and position for the cell at the specified index.
           * It just-in-time calculates (or used cached values) for cells leading up to the index.
           */
        },
        {
          key: 'getSizeAndPositionOfCell',
          value: function getSizeAndPositionOfCell(index /*: number*/) /*: SizeAndPositionData*/ {
            if (index < 0 || index >= this._cellCount) {
              throw Error('Requested index '.concat(index, ' is outside of range 0..').concat(this._cellCount));
            }
            if (index > this._lastMeasuredIndex) {
              var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
              var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
              for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
                var size = this._cellSizeGetter({
                  index: i,
                });

                // undefined or NaN probably means a logic error in the size getter.
                // null means we're using CellMeasurer and haven't yet measured a given index.
                if (size === undefined || isNaN(size)) {
                  throw Error('Invalid size returned for cell '.concat(i, ' of value ').concat(size));
                } else if (size === null) {
                  this._cellSizeAndPositionData[i] = {
                    offset: offset,
                    size: 0,
                  };
                  this._lastBatchedIndex = index;
                } else {
                  this._cellSizeAndPositionData[i] = {
                    offset: offset,
                    size: size,
                  };
                  offset += size;
                  this._lastMeasuredIndex = index;
                }
              }
            }
            return this._cellSizeAndPositionData[index];
          },
        },
        {
          key: 'getSizeAndPositionOfLastMeasuredCell',
          value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/ {
            return this._lastMeasuredIndex >= 0
              ? this._cellSizeAndPositionData[this._lastMeasuredIndex]
              : {
                  offset: 0,
                  size: 0,
                };
          },

          /**
           * Total size of all cells being measured.
           * This value will be completely estimated initially.
           * As cells are measured, the estimate will be updated.
           */
        },
        {
          key: 'getTotalSize',
          value: function getTotalSize() /*: number*/ {
            var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
            var totalSizeOfMeasuredCells =
              lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
            var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
            var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
            return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
          },

          /**
           * Determines a new offset that ensures a certain cell is visible, given the current offset.
           * If the cell is already visible then the current offset will be returned.
           * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
           *
           * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
           * @param containerSize Size (width or height) of the container viewport
           * @param currentOffset Container's current (x or y) offset
           * @param totalSize Total size (width or height) of all cells
           * @return Offset to use to ensure the specified cell is visible
           */
        },
        {
          key: 'getUpdatedOffsetForIndex',
          value: function getUpdatedOffsetForIndex(_ref3 /*:: */) /*: number*/ {
            var _ref3$align = _ref3 /*:: */.align,
              align = _ref3$align === void 0 ? 'auto' : _ref3$align,
              containerSize = _ref3 /*:: */.containerSize,
              currentOffset = _ref3 /*:: */.currentOffset,
              targetIndex = _ref3 /*:: */.targetIndex;
            if (containerSize <= 0) {
              return 0;
            }
            var datum = this.getSizeAndPositionOfCell(targetIndex);
            var maxOffset = datum.offset;
            var minOffset = maxOffset - containerSize + datum.size;
            var idealOffset;
            switch (align) {
              case 'start':
                idealOffset = maxOffset;
                break;
              case 'end':
                idealOffset = minOffset;
                break;
              case 'center':
                idealOffset = maxOffset - (containerSize - datum.size) / 2;
                break;
              default:
                idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                break;
            }
            var totalSize = this.getTotalSize();
            return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
          },
        },
        {
          key: 'getVisibleCellRange',
          value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/) /*: VisibleCellRange*/ {
            var containerSize = params.containerSize,
              offset = params.offset;
            var totalSize = this.getTotalSize();
            if (totalSize === 0) {
              return {};
            }
            var maxOffset = offset + containerSize;
            var start = this._findNearestCell(offset);
            var datum = this.getSizeAndPositionOfCell(start);
            offset = datum.offset + datum.size;
            var stop = start;
            while (offset < maxOffset && stop < this._cellCount - 1) {
              stop++;
              offset += this.getSizeAndPositionOfCell(stop).size;
            }
            return {
              start: start,
              stop: stop,
            };
          },

          /**
           * Clear all cached values for cells after the specified index.
           * This method should be called for any cell that has changed its size.
           * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
           */
        },
        {
          key: 'resetCell',
          value: function resetCell(index /*: number*/) /*: void*/ {
            this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
          },
        },
        {
          key: '_binarySearch',
          value: function _binarySearch(high /*: number*/, low /*: number*/, offset /*: number*/) /*: number*/ {
            while (low <= high) {
              var middle = low + Math.floor((high - low) / 2);
              var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
              if (currentOffset === offset) {
                return middle;
              } else if (currentOffset < offset) {
                low = middle + 1;
              } else if (currentOffset > offset) {
                high = middle - 1;
              }
            }
            if (low > 0) {
              return low - 1;
            } else {
              return 0;
            }
          },
        },
        {
          key: '_exponentialSearch',
          value: function _exponentialSearch(index /*: number*/, offset /*: number*/) /*: number*/ {
            var interval = 1;
            while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
              index += interval;
              interval *= 2;
            }
            return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
          },

          /**
           * Searches for the cell (index) nearest the specified offset.
           *
           * If no exact match is found the next lowest cell index will be returned.
           * This allows partially visible cells (with offsets just before/above the fold) to be visible.
           */
        },
        {
          key: '_findNearestCell',
          value: function _findNearestCell(offset /*: number*/) /*: number*/ {
            if (isNaN(offset)) {
              throw Error('Invalid offset '.concat(offset, ' specified'));
            }

            // Our search algorithms find the nearest match at or below the specified offset.
            // So make sure the offset is at least 0 or no match will be found.
            offset = Math.max(0, offset);
            var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
            var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
            if (lastMeasuredCellSizeAndPosition.offset >= offset) {
              // If we've already measured cells within this range just use a binary search as it's faster.
              return this._binarySearch(lastMeasuredIndex, 0, offset);
            } else {
              // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
              // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
              // The overall complexity for this approach is O(log n).
              return this._exponentialSearch(lastMeasuredIndex, offset);
            }
          },
        },
      ]);
    })(); // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/utils/maxElementSize.js

    var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
    var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
    var maxElementSize_isBrowser = function isBrowser() {
      return typeof window !== 'undefined';
    };
    var isChrome = function isChrome() {
      return !!window.chrome;
    };
    var getMaxElementSize = function getMaxElementSize() /*: number*/ {
      if (maxElementSize_isBrowser()) {
        if (isChrome()) {
          return CHROME_MAX_ELEMENT_SIZE;
        }
      }
      return DEFAULT_MAX_ELEMENT_SIZE;
    }; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/utils/ScalingCellSizeAndPositionManager.js
    var ScalingCellSizeAndPositionManager_excluded = ['maxScrollSize'];
    /*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/

    /*:: type ContainerSizeAndOffset = {
			  containerSize: number,
			  offset: number,
			};*/
    /*:: type Params = {
			  maxScrollSize?: number,
			  cellCount: number,
			  cellSizeGetter: CellSizeGetter,
			  estimatedCellSize: number,
			};*/
    /**
     * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
     * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
     * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
     */
    /**
     * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
     */
    var ScalingCellSizeAndPositionManager = /*#__PURE__*/ (function () {
      function ScalingCellSizeAndPositionManager(_ref /*:: */) {
        var _ref$maxScrollSize = _ref /*:: */.maxScrollSize,
          maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize,
          params = objectWithoutProperties_objectWithoutProperties(
            _ref /*:: */,
            ScalingCellSizeAndPositionManager_excluded,
          );
        _classCallCheck(this, ScalingCellSizeAndPositionManager);
        defineProperty_defineProperty(this, '_cellSizeAndPositionManager', void 0);
        defineProperty_defineProperty(this, '_maxScrollSize', void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new CellSizeAndPositionManager(params);
        this._maxScrollSize = maxScrollSize;
      }
      return _createClass(ScalingCellSizeAndPositionManager, [
        {
          key: 'areOffsetsAdjusted',
          value: function areOffsetsAdjusted() /*: boolean*/ {
            return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
          },
        },
        {
          key: 'configure',
          value: function configure(
            params,
            /*: {
						cellCount: number,
						estimatedCellSize: number,
						cellSizeGetter: CellSizeGetter,
					  }*/
          ) {
            this._cellSizeAndPositionManager.configure(params);
          },
        },
        {
          key: 'getCellCount',
          value: function getCellCount() /*: number*/ {
            return this._cellSizeAndPositionManager.getCellCount();
          },
        },
        {
          key: 'getEstimatedCellSize',
          value: function getEstimatedCellSize() /*: number*/ {
            return this._cellSizeAndPositionManager.getEstimatedCellSize();
          },
        },
        {
          key: 'getLastMeasuredIndex',
          value: function getLastMeasuredIndex() /*: number*/ {
            return this._cellSizeAndPositionManager.getLastMeasuredIndex();
          },

          /**
           * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
           * The offset passed to this function is scaled (safe) as well.
           */
        },
        {
          key: 'getOffsetAdjustment',
          value: function getOffsetAdjustment(_ref2 /*:: */) /*: number*/ {
            var containerSize = _ref2 /*:: */.containerSize,
              offset = _ref2 /*:: */.offset;
            var totalSize = this._cellSizeAndPositionManager.getTotalSize();
            var safeTotalSize = this.getTotalSize();
            var offsetPercentage = this._getOffsetPercentage({
              containerSize: containerSize,
              offset: offset,
              totalSize: safeTotalSize,
            });
            return Math.round(offsetPercentage * (safeTotalSize - totalSize));
          },
        },
        {
          key: 'getSizeAndPositionOfCell',
          value: function getSizeAndPositionOfCell(index /*: number*/) {
            return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
          },
        },
        {
          key: 'getSizeAndPositionOfLastMeasuredCell',
          value: function getSizeAndPositionOfLastMeasuredCell() {
            return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
          },

          /** See CellSizeAndPositionManager#getTotalSize */
        },
        {
          key: 'getTotalSize',
          value: function getTotalSize() /*: number*/ {
            return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
          },

          /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
        },
        {
          key: 'getUpdatedOffsetForIndex',
          value: function getUpdatedOffsetForIndex(_ref3 /*:: */) {
            var _ref3$align = _ref3 /*:: */.align,
              align = _ref3$align === void 0 ? 'auto' : _ref3$align,
              containerSize = _ref3 /*:: */.containerSize,
              currentOffset = _ref3 /*:: */.currentOffset,
              targetIndex = _ref3 /*:: */.targetIndex;
            currentOffset = this._safeOffsetToOffset({
              containerSize: containerSize,
              offset: currentOffset,
            });
            var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
              align: align,
              containerSize: containerSize,
              currentOffset: currentOffset,
              targetIndex: targetIndex,
            });
            return this._offsetToSafeOffset({
              containerSize: containerSize,
              offset: offset,
            });
          },

          /** See CellSizeAndPositionManager#getVisibleCellRange */
        },
        {
          key: 'getVisibleCellRange',
          value: function getVisibleCellRange(_ref4 /*:: */) /*: VisibleCellRange*/ {
            var containerSize = _ref4 /*:: */.containerSize,
              offset = _ref4 /*:: */.offset;
            offset = this._safeOffsetToOffset({
              containerSize: containerSize,
              offset: offset,
            });
            return this._cellSizeAndPositionManager.getVisibleCellRange({
              containerSize: containerSize,
              offset: offset,
            });
          },
        },
        {
          key: 'resetCell',
          value: function resetCell(index /*: number*/) /*: void*/ {
            this._cellSizeAndPositionManager.resetCell(index);
          },
        },
        {
          key: '_getOffsetPercentage',
          value: function _getOffsetPercentage(_ref5 /*:: */) {
            var containerSize = _ref5 /*:: */.containerSize,
              offset = _ref5 /*:: */.offset,
              totalSize = _ref5 /*:: */.totalSize;
            return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
          },
        },
        {
          key: '_offsetToSafeOffset',
          value: function _offsetToSafeOffset(_ref6 /*:: */) /*: number*/ {
            var containerSize = _ref6 /*:: */.containerSize,
              offset = _ref6 /*:: */.offset;
            var totalSize = this._cellSizeAndPositionManager.getTotalSize();
            var safeTotalSize = this.getTotalSize();
            if (totalSize === safeTotalSize) {
              return offset;
            } else {
              var offsetPercentage = this._getOffsetPercentage({
                containerSize: containerSize,
                offset: offset,
                totalSize: totalSize,
              });
              return Math.round(offsetPercentage * (safeTotalSize - containerSize));
            }
          },
        },
        {
          key: '_safeOffsetToOffset',
          value: function _safeOffsetToOffset(_ref7 /*:: */) /*: number*/ {
            var containerSize = _ref7 /*:: */.containerSize,
              offset = _ref7 /*:: */.offset;
            var totalSize = this._cellSizeAndPositionManager.getTotalSize();
            var safeTotalSize = this.getTotalSize();
            if (totalSize === safeTotalSize) {
              return offset;
            } else {
              var offsetPercentage = this._getOffsetPercentage({
                containerSize: containerSize,
                offset: offset,
                totalSize: safeTotalSize,
              });
              return Math.round(offsetPercentage * (totalSize - containerSize));
            }
          },
        },
      ]);
    })(); // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/utils/createCallbackMemoizer.js

    /**
     * Helper utility that updates the specified callback whenever any of the specified indices have changed.
     */
    function createCallbackMemoizer() {
      var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var cachedIndices = {};
      return function (_ref) {
        var callback = _ref.callback,
          indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized =
          !requireAllKeys ||
          keys.every(function (key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
          });
        var indexChanged =
          keys.length !== Object.keys(cachedIndices).length ||
          keys.some(function (key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
          });
        cachedIndices = indices;
        if (allInitialized && indexChanged) {
          callback(indices);
        }
      };
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/defaultOverscanIndicesGetter.js
    /*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/
    var SCROLL_DIRECTION_BACKWARD = -1;
    var SCROLL_DIRECTION_FORWARD = 1;
    var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
    var SCROLL_DIRECTION_VERTICAL = 'vertical';

    /**
     * Calculates the number of cells to overscan before and after a specified range.
     * This function ensures that overscanning doesn't exceed the available cells.
     */

    function defaultOverscanIndicesGetter(_ref /*:: */) /*: OverscanIndices*/ {
      var cellCount = _ref /*:: */.cellCount,
        overscanCellsCount = _ref /*:: */.overscanCellsCount,
        scrollDirection = _ref /*:: */.scrollDirection,
        startIndex = _ref /*:: */.startIndex,
        stopIndex = _ref /*:: */.stopIndex;
      if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
        return {
          overscanStartIndex: Math.max(0, startIndex),
          overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount),
        };
      } else {
        return {
          overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
          overscanStopIndex: Math.min(cellCount - 1, stopIndex),
        };
      }
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/utils/updateScrollIndexHelper.js
    /*:: import type {Alignment, CellSize} from '../types';*/

    /**
     * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
     * This function also ensures that the scroll ofset isn't past the last column/row of cells.
     */
    /*:: type Params = {
			  // Width or height of cells for the current axis
			  cellSize?: CellSize,
			
			  // Manages size and position metadata of cells
			  cellSizeAndPositionManager: ScalingCellSizeAndPositionManager,
			
			  // Previous number of rows or columns
			  previousCellsCount: number,
			
			  // Previous width or height of cells
			  previousCellSize: CellSize,
			
			  previousScrollToAlignment: Alignment,
			
			  // Previous scroll-to-index
			  previousScrollToIndex: number,
			
			  // Previous width or height of the virtualized container
			  previousSize: number,
			
			  // Current scrollLeft or scrollTop
			  scrollOffset: number,
			
			  scrollToAlignment: Alignment,
			
			  // Scroll-to-index
			  scrollToIndex: number,
			
			  // Width or height of the virtualized container
			  size: number,
			
			  sizeJustIncreasedFromZero: boolean,
			
			  // Callback to invoke with an scroll-to-index value
			  updateScrollIndexCallback: (index: number) => void,
			};*/
    function updateScrollIndexHelper(_ref /*:: */) {
      var cellSize = _ref /*:: */.cellSize,
        cellSizeAndPositionManager = _ref /*:: */.cellSizeAndPositionManager,
        previousCellsCount = _ref /*:: */.previousCellsCount,
        previousCellSize = _ref /*:: */.previousCellSize,
        previousScrollToAlignment = _ref /*:: */.previousScrollToAlignment,
        previousScrollToIndex = _ref /*:: */.previousScrollToIndex,
        previousSize = _ref /*:: */.previousSize,
        scrollOffset = _ref /*:: */.scrollOffset,
        scrollToAlignment = _ref /*:: */.scrollToAlignment,
        scrollToIndex = _ref /*:: */.scrollToIndex,
        size = _ref /*:: */.size,
        sizeJustIncreasedFromZero = _ref /*:: */.sizeJustIncreasedFromZero,
        updateScrollIndexCallback = _ref /*:: */.updateScrollIndexCallback;
      var cellCount = cellSizeAndPositionManager.getCellCount();
      var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
      var sizeHasChanged =
        size !== previousSize ||
        sizeJustIncreasedFromZero ||
        !previousCellSize ||
        (typeof cellSize === 'number' && cellSize !== previousCellSize);

      // If we have a new scroll target OR if height/row-height has changed,
      // We should ensure that the scroll target is visible.
      if (
        hasScrollToIndex &&
        (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)
      ) {
        updateScrollIndexCallback(scrollToIndex);

        // If we don't have a selected item but list size or number of children have decreased,
        // Make sure we aren't scrolled too far past the current content.
      } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
        // We need to ensure that the current scroll offset is still within the collection's range.
        // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
        // Just check to make sure we're still okay.
        // Only adjust the scroll position if we've scrolled below the last set of rows.
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
          updateScrollIndexCallback(cellCount - 1);
        }
      }
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/defaultCellRangeRenderer.js
    /*:: import type {CellRangeRendererParams} from './types';*/

    /**
     * Default implementation of cellRangeRenderer used by Grid.
     * This renderer supports cell-caching while the user is scrolling.
     */

    function defaultCellRangeRenderer(_ref /*:: */) {
      var cellCache = _ref /*:: */.cellCache,
        cellRenderer = _ref /*:: */.cellRenderer,
        columnSizeAndPositionManager = _ref /*:: */.columnSizeAndPositionManager,
        columnStartIndex = _ref /*:: */.columnStartIndex,
        columnStopIndex = _ref /*:: */.columnStopIndex,
        deferredMeasurementCache = _ref /*:: */.deferredMeasurementCache,
        horizontalOffsetAdjustment = _ref /*:: */.horizontalOffsetAdjustment,
        isScrolling = _ref /*:: */.isScrolling,
        isScrollingOptOut = _ref /*:: */.isScrollingOptOut,
        parent = _ref /*:: */.parent,
        rowSizeAndPositionManager = _ref /*:: */.rowSizeAndPositionManager,
        rowStartIndex = _ref /*:: */.rowStartIndex,
        rowStopIndex = _ref /*:: */.rowStopIndex,
        styleCache = _ref /*:: */.styleCache,
        verticalOffsetAdjustment = _ref /*:: */.verticalOffsetAdjustment,
        visibleColumnIndices = _ref /*:: */.visibleColumnIndices,
        visibleRowIndices = _ref /*:: */.visibleRowIndices;
      var renderedCells = [];

      // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
      // User cannot scroll beyond these size limitations.
      // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
      // We should never cache styles for compressed offsets though as this can lead to bugs.
      // See issue #576 for more.
      var areOffsetsAdjusted =
        columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
      var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
      for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
          var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
          var isVisible =
            columnIndex >= visibleColumnIndices.start &&
            columnIndex <= visibleColumnIndices.stop &&
            rowIndex >= visibleRowIndices.start &&
            rowIndex <= visibleRowIndices.stop;
          var key = ''.concat(rowIndex, '-').concat(columnIndex);
          var style = void 0;

          // Cache style objects so shallow-compare doesn't re-render unnecessarily.
          if (canCacheStyle && styleCache[key]) {
            style = styleCache[key];
          } else {
            // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
              // Position not-yet-measured cells at top/left 0,0,
              // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
              // Positioning them further to the right/bottom influences their measured size.
              style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto',
              };
            } else {
              style = {
                height: rowDatum.size,
                left: columnDatum.offset + horizontalOffsetAdjustment,
                position: 'absolute',
                top: rowDatum.offset + verticalOffsetAdjustment,
                width: columnDatum.size,
              };
              styleCache[key] = style;
            }
          }
          var cellRendererParams = {
            columnIndex: columnIndex,
            isScrolling: isScrolling,
            isVisible: isVisible,
            key: key,
            parent: parent,
            rowIndex: rowIndex,
            style: style,
          };
          var renderedCell = void 0;

          // Avoid re-creating cells while scrolling.
          // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
          // If a scroll is in progress- cache and reuse cells.
          // This cache will be thrown away once scrolling completes.
          // However if we are scaling scroll positions and sizes, we should also avoid caching.
          // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
          // For more info refer to issue #395
          //
          // If isScrollingOptOut is specified, we always cache cells.
          // For more info refer to issue #1028
          if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
            if (!cellCache[key]) {
              cellCache[key] = cellRenderer(cellRendererParams);
            }
            renderedCell = cellCache[key];

            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
          } else {
            renderedCell = cellRenderer(cellRendererParams);
          }
          if (renderedCell == null || renderedCell === false) {
            continue;
          }
          if (false) {
          }
          if (!renderedCell.props.role) {
            renderedCell = /*#__PURE__*/ react.cloneElement(renderedCell, {
              role: 'gridcell',
            });
          }
          renderedCells.push(renderedCell);
        }
      }
      return renderedCells;
    }
    function warnAboutMissingStyle(parent, renderedCell) {
      if (false) {
      }
    } // CONCATENATED MODULE: ./node_modules/dom-helpers/esm/canUseDOM.js
    /* harmony default export */ const canUseDOM = !!(
      typeof window !== 'undefined' &&
      window.document &&
      window.document.createElement
    ); // CONCATENATED MODULE: ./node_modules/dom-helpers/esm/scrollbarSize.js
    var size;
    function scrollbarSize(recalc) {
      if ((!size && size !== 0) || recalc) {
        if (canUseDOM) {
          var scrollDiv = document.createElement('div');
          scrollDiv.style.position = 'absolute';
          scrollDiv.style.top = '-9999px';
          scrollDiv.style.width = '50px';
          scrollDiv.style.height = '50px';
          scrollDiv.style.overflow = 'scroll';
          document.body.appendChild(scrollDiv);
          size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
          document.body.removeChild(scrollDiv);
        }
      }
      return size;
    }
    // EXTERNAL MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
    var react_lifecycles_compat_es = __webpack_require__(62135); // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/utils/animationFrame.js
    /*:: type Callback = (timestamp: number) => void;*/
    /*:: type CancelAnimationFrame = (requestId: number) => void;*/
    /*:: type RequestAnimationFrame = (callback: Callback) => number;*/
    // Properly handle server-side rendering.
    var win;
    if (typeof window !== 'undefined') {
      win = window;
    } else if (typeof self !== 'undefined') {
      win = self;
    } else {
      win = {};
    }

    // requestAnimationFrame() shim by Paul Irish
    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    var request =
      win.requestAnimationFrame ||
      win.webkitRequestAnimationFrame ||
      win.mozRequestAnimationFrame ||
      win.oRequestAnimationFrame ||
      win.msRequestAnimationFrame ||
      function (callback /*: Callback*/) /*: RequestAnimationFrame*/ {
        return win /*: any*/
          .setTimeout(callback, 1000 / 60);
      };
    var cancel =
      win.cancelAnimationFrame ||
      win.webkitCancelAnimationFrame ||
      win.mozCancelAnimationFrame ||
      win.oCancelAnimationFrame ||
      win.msCancelAnimationFrame ||
      function (id /*: number*/) {
        win /*: any*/
          .clearTimeout(id);
      };
    var raf /*: RequestAnimationFrame*/ = request; /*: any*/
    var caf /*: CancelAnimationFrame*/ = cancel; /*: any*/ // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/utils/requestAnimationTimeout.js
    /*:: export type AnimationTimeoutId = {
			  id: number,
			};*/
    var cancelAnimationTimeout = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/) {
      return caf(frame.id);
    };

    /**
     * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
     * When the delay time has been reached the function you're timing out will be called.
     *
     * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
     */
    var requestAnimationTimeout = function requestAnimationTimeout(
      callback /*: Function*/,
      delay /*: number*/,
    ) /*: AnimationTimeoutId*/ {
      var start;
      // wait for end of processing current event handler, because event handler may be long
      Promise.resolve().then(function () {
        start = Date.now();
      });
      var timeout = function timeout() {
        if (Date.now() - start >= delay) {
          callback.call();
        } else {
          frame.id = raf(timeout);
        }
      };
      var frame /*: AnimationTimeoutId*/ = {
        id: raf(timeout),
      };
      return frame;
    }; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/Grid.js
    function _extends2() {
      return (
        (_extends2 = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        _extends2.apply(null, arguments)
      );
    }

    function Grid_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Grid_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Grid_ownKeys(Object(t), !0).forEach(function (r) {
              defineProperty_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Grid_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Grid_callSuper(t, o, e) {
      return (
        (o = _getPrototypeOf(o)),
        _possibleConstructorReturn(
          t,
          Grid_isNativeReflectConstruct()
            ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
            : o.apply(t, e),
        )
      );
    }
    function Grid_isNativeReflectConstruct() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (t) {}
      return (Grid_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
      })();
    }
    /*:: import type {
			  CellRenderer,
			  CellRangeRenderer,
			  CellPosition,
			  CellSize,
			  CellSizeGetter,
			  NoContentRenderer,
			  Scroll,
			  ScrollbarPresenceChange,
			  RenderedSection,
			  OverscanIndicesGetter,
			  Alignment,
			  CellCache,
			  StyleCache,
			} from './types';*/
    /*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/

    /**
     * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
     * This improves performance and makes scrolling smoother.
     */
    var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

    /**
     * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
     * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
     */
    var SCROLL_POSITION_CHANGE_REASONS = {
      OBSERVED: 'observed',
      REQUESTED: 'requested',
    };
    var renderNull /*: NoContentRenderer*/ = function renderNull /*: NoContentRenderer*/() {
      return null;
    };
    /*:: type ScrollPosition = {
			  scrollTop?: number,
			  scrollLeft?: number,
			};*/
    /*:: type Props = {
			  'aria-label': string,
			  'aria-readonly'?: boolean,
			
			  /**
			   * Set the width of the inner scrollable container to 'auto'.
			   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
			   *-/
			  autoContainerWidth: boolean,
			
			  /**
			   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
			   * Intended for use with WindowScroller
			   *-/
			  autoHeight: boolean,
			
			  /**
			   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
			   * Intended for use with WindowScroller
			   *-/
			  autoWidth: boolean,
			
			  /** Responsible for rendering a cell given an row and column index.  *-/
			  cellRenderer: CellRenderer,
			
			  /** Responsible for rendering a group of cells given their index ranges.  *-/
			  cellRangeRenderer: CellRangeRenderer,
			
			  /** Optional custom CSS class name to attach to root Grid element.  *-/
			  className?: string,
			
			  /** Number of columns in grid.  *-/
			  columnCount: number,
			
			  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
			  columnWidth: CellSize,
			
			  /** Unfiltered props for the Grid container. *-/
			  containerProps?: Object,
			
			  /** ARIA role for the cell-container.  *-/
			  containerRole: string,
			
			  /** Optional inline style applied to inner cell-container *-/
			  containerStyle: Object,
			
			  /**
			   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
			   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
			   *-/
			  deferredMeasurementCache?: Object,
			
			  /**
			   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
			   * The estimated total width is adjusted as columns are rendered.
			   *-/
			  estimatedColumnSize: number,
			
			  /**
			   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
			   * The estimated total height is adjusted as rows are rendered.
			   *-/
			  estimatedRowSize: number,
			
			  /** Exposed for testing purposes only.  *-/
			  getScrollbarSize: () => number,
			
			  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
			  height: number,
			
			  /** Optional custom id to attach to root Grid element.  *-/
			  id?: string,
			
			  /**
			   * Override internal is-scrolling state tracking.
			   * This property is primarily intended for use with the WindowScroller component.
			   *-/
			  isScrolling?: boolean,
			
			  /**
			   * Opt-out of isScrolling param passed to cellRangeRenderer.
			   * To avoid the extra render when scroll stops.
			   *-/
			  isScrollingOptOut: boolean,
			
			  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
			  noContentRenderer: NoContentRenderer,
			
			  /**
			   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
			   * This callback can be used to sync scrolling between lists, tables, or grids.
			   *-/
			  onScroll: (params: Scroll) => void,
			
			  /**
			   * Called whenever a horizontal or vertical scrollbar is added or removed.
			   * This prop is not intended for end-user use;
			   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
			   *-/
			  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,
			
			  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
			  onSectionRendered: (params: RenderedSection) => void,
			
			  /**
			   * Number of columns to render before/after the visible section of the grid.
			   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
			   *-/
			  overscanColumnCount: number,
			
			  /**
			   * Calculates the number of cells to overscan before and after a specified range.
			   * This function ensures that overscanning doesn't exceed the available cells.
			   *-/
			  overscanIndicesGetter: OverscanIndicesGetter,
			
			  /**
			   * Number of rows to render above/below the visible section of the grid.
			   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
			   *-/
			  overscanRowCount: number,
			
			  /** ARIA role for the grid element.  *-/
			  role: string,
			
			  /**
			   * Either a fixed row height (number) or a function that returns the height of a row given its index.
			   * Should implement the following interface: ({ index: number }): number
			   *-/
			  rowHeight: CellSize,
			
			  /** Number of rows in grid.  *-/
			  rowCount: number,
			
			  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
			  scrollingResetTimeInterval: number,
			
			  /** Horizontal offset. *-/
			  scrollLeft?: number,
			
			  /**
			   * Controls scroll-to-cell behavior of the Grid.
			   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
			   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
			   *-/
			  scrollToAlignment: Alignment,
			
			  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
			  scrollToColumn: number,
			
			  /** Vertical offset. *-/
			  scrollTop?: number,
			
			  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
			  scrollToRow: number,
			
			  /** Optional inline style *-/
			  style: Object,
			
			  /** Tab index for focus *-/
			  tabIndex: ?number,
			
			  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
			  width: number,
			};*/
    /*:: type InstanceProps = {
			  prevColumnWidth: CellSize,
			  prevRowHeight: CellSize,
			
			  prevColumnCount: number,
			  prevRowCount: number,
			  prevIsScrolling: boolean,
			  prevScrollToColumn: number,
			  prevScrollToRow: number,
			
			  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
			  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,
			
			  scrollbarSize: number,
			  scrollbarSizeMeasured: boolean,
			};*/
    /*:: type State = {
			  instanceProps: InstanceProps,
			  isScrolling: boolean,
			  scrollDirectionHorizontal: -1 | 1,
			  scrollDirectionVertical: -1 | 1,
			  scrollLeft: number,
			  scrollTop: number,
			  scrollPositionChangeReason: 'observed' | 'requested' | null,
			  needToResetStyleCache: boolean,
			};*/
    /**
     * Renders tabular data with virtualization along the vertical and horizontal axes.
     * Row heights and column widths must be known ahead of time and specified as properties.
     */
    var Grid = /*#__PURE__*/ (function (_React$PureComponent) {
      function Grid(props /*: Props*/) {
        var _this;
        _classCallCheck(this, Grid);
        _this = Grid_callSuper(this, Grid, [props]);
        // Invokes onSectionRendered callback only when start/stop row or column indices change
        defineProperty_defineProperty(_this, '_onGridRenderedMemoizer', createCallbackMemoizer());
        defineProperty_defineProperty(_this, '_onScrollMemoizer', createCallbackMemoizer(false));
        defineProperty_defineProperty(_this, '_deferredInvalidateColumnIndex', null);
        defineProperty_defineProperty(_this, '_deferredInvalidateRowIndex', null);
        defineProperty_defineProperty(_this, '_recomputeScrollLeftFlag', false);
        defineProperty_defineProperty(_this, '_recomputeScrollTopFlag', false);
        defineProperty_defineProperty(_this, '_horizontalScrollBarSize', 0);
        defineProperty_defineProperty(_this, '_verticalScrollBarSize', 0);
        defineProperty_defineProperty(_this, '_scrollbarPresenceChanged', false);
        defineProperty_defineProperty(_this, '_scrollingContainer', void 0);
        defineProperty_defineProperty(_this, '_childrenToDisplay', void 0);
        defineProperty_defineProperty(_this, '_columnStartIndex', void 0);
        defineProperty_defineProperty(_this, '_columnStopIndex', void 0);
        defineProperty_defineProperty(_this, '_rowStartIndex', void 0);
        defineProperty_defineProperty(_this, '_rowStopIndex', void 0);
        defineProperty_defineProperty(_this, '_renderedColumnStartIndex', 0);
        defineProperty_defineProperty(_this, '_renderedColumnStopIndex', 0);
        defineProperty_defineProperty(_this, '_renderedRowStartIndex', 0);
        defineProperty_defineProperty(_this, '_renderedRowStopIndex', 0);
        defineProperty_defineProperty(_this, '_initialScrollTop', void 0);
        defineProperty_defineProperty(_this, '_initialScrollLeft', void 0);
        defineProperty_defineProperty(_this, '_disablePointerEventsTimeoutId', void 0);
        defineProperty_defineProperty(_this, '_styleCache', {});
        defineProperty_defineProperty(_this, '_cellCache', {});
        defineProperty_defineProperty(_this, '_debounceScrollEndedCallback', function () {
          _this._disablePointerEventsTimeoutId = null;
          // isScrolling is used to determine if we reset styleCache
          _this.setState({
            isScrolling: false,
            needToResetStyleCache: false,
          });
        });
        defineProperty_defineProperty(_this, '_invokeOnGridRenderedHelper', function () {
          var onSectionRendered = _this.props.onSectionRendered;
          _this._onGridRenderedMemoizer({
            callback: onSectionRendered,
            indices: {
              columnOverscanStartIndex: _this._columnStartIndex,
              columnOverscanStopIndex: _this._columnStopIndex,
              columnStartIndex: _this._renderedColumnStartIndex,
              columnStopIndex: _this._renderedColumnStopIndex,
              rowOverscanStartIndex: _this._rowStartIndex,
              rowOverscanStopIndex: _this._rowStopIndex,
              rowStartIndex: _this._renderedRowStartIndex,
              rowStopIndex: _this._renderedRowStopIndex,
            },
          });
        });
        defineProperty_defineProperty(_this, '_setScrollingContainerRef', function (ref /*: Element*/) {
          _this._scrollingContainer = ref;
        });
        defineProperty_defineProperty(_this, '_onScroll', function (event /*: Event*/) {
          // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
          // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
          // See issue #404 for more information.
          if (event.target === _this._scrollingContainer) {
            _this.handleScrollEvent(event.target /*: any*/);
          }
        });
        var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
          cellCount: props.columnCount,
          cellSizeGetter: function cellSizeGetter(params) {
            return Grid._wrapSizeGetter(props.columnWidth)(params);
          },
          estimatedCellSize: Grid._getEstimatedColumnSize(props),
        });
        var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
          cellCount: props.rowCount,
          cellSizeGetter: function cellSizeGetter(params) {
            return Grid._wrapSizeGetter(props.rowHeight)(params);
          },
          estimatedCellSize: Grid._getEstimatedRowSize(props),
        });
        _this.state = {
          instanceProps: {
            columnSizeAndPositionManager: columnSizeAndPositionManager,
            rowSizeAndPositionManager: rowSizeAndPositionManager,
            prevColumnWidth: props.columnWidth,
            prevRowHeight: props.rowHeight,
            prevColumnCount: props.columnCount,
            prevRowCount: props.rowCount,
            prevIsScrolling: props.isScrolling === true,
            prevScrollToColumn: props.scrollToColumn,
            prevScrollToRow: props.scrollToRow,
            scrollbarSize: 0,
            scrollbarSizeMeasured: false,
          },
          isScrolling: false,
          scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD,
          scrollDirectionVertical: SCROLL_DIRECTION_FORWARD,
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: null,
          needToResetStyleCache: false,
        };
        if (props.scrollToRow > 0) {
          _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        }
        if (props.scrollToColumn > 0) {
          _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        }
        return _this;
      }

      /**
       * Gets offsets for a given cell and alignment.
       */
      _inherits(Grid, _React$PureComponent);
      return _createClass(
        Grid,
        [
          {
            key: 'getOffsetForCell',
            value: function getOffsetForCell() {
              var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref$alignment = _ref.alignment,
                alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
                _ref$columnIndex = _ref.columnIndex,
                columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
                _ref$rowIndex = _ref.rowIndex,
                rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
              var offsetProps = Grid_objectSpread(
                Grid_objectSpread({}, this.props),
                {},
                {
                  scrollToAlignment: alignment,
                  scrollToColumn: columnIndex,
                  scrollToRow: rowIndex,
                },
              );
              return {
                scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                scrollTop: this._getCalculatedScrollTop(offsetProps),
              };
            },

            /**
             * Gets estimated total rows' height.
             */
          },
          {
            key: 'getTotalRowsHeight',
            value: function getTotalRowsHeight() {
              return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            },

            /**
             * Gets estimated total columns' width.
             */
          },
          {
            key: 'getTotalColumnsWidth',
            value: function getTotalColumnsWidth() {
              return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            },

            /**
             * This method handles a scroll event originating from an external scroll control.
             * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
             */
          },
          {
            key: 'handleScrollEvent',
            value: function handleScrollEvent(_ref2 /*:: */) {
              var _ref2$scrollLeft = _ref2 /*:: */.scrollLeft,
                scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2 /*:: */.scrollTop,
                scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
              // On iOS, we can arrive at negative offsets by swiping past the start.
              // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
              if (scrollTopParam < 0) {
                return;
              }

              // Prevent pointer events from interrupting a smooth scroll
              this._debounceScrollEnded();
              var _this$props = this.props,
                autoHeight = _this$props.autoHeight,
                autoWidth = _this$props.autoWidth,
                height = _this$props.height,
                width = _this$props.width;
              var instanceProps = this.state.instanceProps;

              // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
              // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
              // This causes a series of rapid renders that is slow for long lists.
              // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
              var scrollbarSize = instanceProps.scrollbarSize;
              var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
              var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
              var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
              var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

              // Certain devices (like Apple touchpad) rapid-fire duplicate events.
              // Don't force a re-render if this is the case.
              // The mouse may move faster then the animation frame does.
              // Use requestAnimationFrame to avoid over-updating.
              if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                // Don't change direction for an axis unless scroll offset has changed.
                var scrollDirectionHorizontal =
                  scrollLeft !== this.state.scrollLeft
                    ? scrollLeft > this.state.scrollLeft
                      ? SCROLL_DIRECTION_FORWARD
                      : SCROLL_DIRECTION_BACKWARD
                    : this.state.scrollDirectionHorizontal;
                var scrollDirectionVertical =
                  scrollTop !== this.state.scrollTop
                    ? scrollTop > this.state.scrollTop
                      ? SCROLL_DIRECTION_FORWARD
                      : SCROLL_DIRECTION_BACKWARD
                    : this.state.scrollDirectionVertical;
                var newState /*: $Shape<State>*/ = {
                  isScrolling: true,
                  scrollDirectionHorizontal: scrollDirectionHorizontal,
                  scrollDirectionVertical: scrollDirectionVertical,
                  scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED,
                };
                if (!autoHeight) {
                  newState.scrollTop = scrollTop;
                }
                if (!autoWidth) {
                  newState.scrollLeft = scrollLeft;
                }
                newState.needToResetStyleCache = false;
                this.setState(newState);
              }
              this._invokeOnScrollMemoizer({
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                totalColumnsWidth: totalColumnsWidth,
                totalRowsHeight: totalRowsHeight,
              });
            },

            /**
             * Invalidate Grid size and recompute visible cells.
             * This is a deferred wrapper for recomputeGridSize().
             * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
             * This method is intended for advanced use-cases like CellMeasurer.
             */
            // @TODO (bvaughn) Add automated test coverage for this.
          },
          {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref3 /*:: */) {
              var columnIndex = _ref3 /*:: */.columnIndex,
                rowIndex = _ref3 /*:: */.rowIndex;
              this._deferredInvalidateColumnIndex =
                typeof this._deferredInvalidateColumnIndex === 'number'
                  ? Math.min(this._deferredInvalidateColumnIndex, columnIndex)
                  : columnIndex;
              this._deferredInvalidateRowIndex =
                typeof this._deferredInvalidateRowIndex === 'number'
                  ? Math.min(this._deferredInvalidateRowIndex, rowIndex)
                  : rowIndex;
            },

            /**
             * Pre-measure all columns and rows in a Grid.
             * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
             * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
             */
          },
          {
            key: 'measureAllCells',
            value: function measureAllCells() {
              var _this$props2 = this.props,
                columnCount = _this$props2.columnCount,
                rowCount = _this$props2.rowCount;
              var instanceProps = this.state.instanceProps;
              instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
              instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            },

            /**
             * Forced recompute of row heights and column widths.
             * This function should be called if dynamic column or row sizes have changed but nothing else has.
             * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
             */
          },
          {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
              var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$columnIndex = _ref4.columnIndex,
                columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
                _ref4$rowIndex = _ref4.rowIndex,
                rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
              var _this$props3 = this.props,
                scrollToColumn = _this$props3.scrollToColumn,
                scrollToRow = _this$props3.scrollToRow;
              var instanceProps = this.state.instanceProps;
              instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
              instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

              // Cell sizes may be determined by a function property.
              // In this case the cDU handler can't know if they changed.
              // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
              this._recomputeScrollLeftFlag =
                scrollToColumn >= 0 &&
                (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD
                  ? columnIndex <= scrollToColumn
                  : columnIndex >= scrollToColumn);
              this._recomputeScrollTopFlag =
                scrollToRow >= 0 &&
                (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD
                  ? rowIndex <= scrollToRow
                  : rowIndex >= scrollToRow);

              // Clear cell cache in case we are scrolling;
              // Invalid row heights likely mean invalid cached content as well.
              this._styleCache = {};
              this._cellCache = {};
              this.forceUpdate();
            },

            /**
             * Ensure column and row are visible.
             */
          },
          {
            key: 'scrollToCell',
            value: function scrollToCell(_ref5 /*:: */) {
              var columnIndex = _ref5 /*:: */.columnIndex,
                rowIndex = _ref5 /*:: */.rowIndex;
              var columnCount = this.props.columnCount;
              var props = this.props;

              // Don't adjust scroll offset for single-column grids (eg List, Table).
              // This can cause a funky scroll offset because of the vertical scrollbar width.
              if (columnCount > 1 && columnIndex !== undefined) {
                this._updateScrollLeftForScrollToColumn(
                  Grid_objectSpread(
                    Grid_objectSpread({}, props),
                    {},
                    {
                      scrollToColumn: columnIndex,
                    },
                  ),
                );
              }
              if (rowIndex !== undefined) {
                this._updateScrollTopForScrollToRow(
                  Grid_objectSpread(
                    Grid_objectSpread({}, props),
                    {},
                    {
                      scrollToRow: rowIndex,
                    },
                  ),
                );
              }
            },
          },
          {
            key: 'componentDidMount',
            value: function componentDidMount() {
              var _this$props4 = this.props,
                getScrollbarSize = _this$props4.getScrollbarSize,
                height = _this$props4.height,
                scrollLeft = _this$props4.scrollLeft,
                scrollToColumn = _this$props4.scrollToColumn,
                scrollTop = _this$props4.scrollTop,
                scrollToRow = _this$props4.scrollToRow,
                width = _this$props4.width;
              var instanceProps = this.state.instanceProps;

              // Reset initial offsets to be ignored in browser
              this._initialScrollTop = 0;
              this._initialScrollLeft = 0;

              // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
              // We must do this at the start of the method as we may calculate and update scroll position below.
              this._handleInvalidatedGridSize();

              // If this component was first rendered server-side, scrollbar size will be undefined.
              // In that event we need to remeasure.
              if (!instanceProps.scrollbarSizeMeasured) {
                this.setState(function (prevState) {
                  var stateUpdate = Grid_objectSpread(
                    Grid_objectSpread({}, prevState),
                    {},
                    {
                      needToResetStyleCache: false,
                    },
                  );
                  stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                  stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                  return stateUpdate;
                });
              }
              if (
                (typeof scrollLeft === 'number' && scrollLeft >= 0) ||
                (typeof scrollTop === 'number' && scrollTop >= 0)
              ) {
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                  prevState: this.state,
                  scrollLeft: scrollLeft,
                  scrollTop: scrollTop,
                });
                if (stateUpdate) {
                  stateUpdate.needToResetStyleCache = false;
                  this.setState(stateUpdate);
                }
              }

              // refs don't work in `react-test-renderer`
              if (this._scrollingContainer) {
                // setting the ref's scrollLeft and scrollTop.
                // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
                  this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                }
                if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
                  this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
              }

              // Don't update scroll offset if the size is 0; we don't render any cells in this case.
              // Setting a state may cause us to later thing we've updated the offce when we haven't.
              var sizeIsBiggerThanZero = height > 0 && width > 0;
              if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
                this._updateScrollLeftForScrollToColumn();
              }
              if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
                this._updateScrollTopForScrollToRow();
              }

              // Update onRowsRendered callback
              this._invokeOnGridRenderedHelper();

              // Initialize onScroll callback
              this._invokeOnScrollMemoizer({
                scrollLeft: scrollLeft || 0,
                scrollTop: scrollTop || 0,
                totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize(),
              });
              this._maybeCallOnScrollbarPresenceChange();
            },

            /**
             * @private
             * This method updates scrollLeft/scrollTop in state for the following conditions:
             * 1) New scroll-to-cell props have been set
             */
          },
          {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps /*: Props*/, prevState /*: State*/) {
              var _this2 = this;
              var _this$props5 = this.props,
                autoHeight = _this$props5.autoHeight,
                autoWidth = _this$props5.autoWidth,
                columnCount = _this$props5.columnCount,
                height = _this$props5.height,
                rowCount = _this$props5.rowCount,
                scrollToAlignment = _this$props5.scrollToAlignment,
                scrollToColumn = _this$props5.scrollToColumn,
                scrollToRow = _this$props5.scrollToRow,
                width = _this$props5.width;
              var _this$state = this.state,
                scrollLeft = _this$state.scrollLeft,
                scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
                scrollTop = _this$state.scrollTop,
                instanceProps = _this$state.instanceProps;
              // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
              // We must do this at the start of the method as we may calculate and update scroll position below.
              this._handleInvalidatedGridSize();

              // Handle edge case where column or row count has only just increased over 0.
              // In this case we may have to restore a previously-specified scroll offset.
              // For more info see bvaughn/react-virtualized/issues/218
              var columnOrRowCountJustIncreasedFromZero =
                (columnCount > 0 && prevProps.columnCount === 0) || (rowCount > 0 && prevProps.rowCount === 0);

              // Make sure requested changes to :scrollLeft or :scrollTop get applied.
              // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
              // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
              // So we only set these when we require an adjustment of the scroll position.
              // See issue #2 for more information.
              if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                if (
                  !autoWidth &&
                  scrollLeft >= 0 &&
                  (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)
                ) {
                  this._scrollingContainer.scrollLeft = scrollLeft;
                }
                if (
                  !autoHeight &&
                  scrollTop >= 0 &&
                  (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)
                ) {
                  this._scrollingContainer.scrollTop = scrollTop;
                }
              }

              // Special case where the previous size was 0:
              // In this case we don't show any windowed cells at all.
              // So we should always recalculate offset afterwards.
              var sizeJustIncreasedFromZero =
                (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

              // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
              // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
              if (this._recomputeScrollLeftFlag) {
                this._recomputeScrollLeftFlag = false;
                this._updateScrollLeftForScrollToColumn(this.props);
              } else {
                updateScrollIndexHelper({
                  cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                  previousCellsCount: prevProps.columnCount,
                  previousCellSize: prevProps.columnWidth,
                  previousScrollToAlignment: prevProps.scrollToAlignment,
                  previousScrollToIndex: prevProps.scrollToColumn,
                  previousSize: prevProps.width,
                  scrollOffset: scrollLeft,
                  scrollToAlignment: scrollToAlignment,
                  scrollToIndex: scrollToColumn,
                  size: width,
                  sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                  updateScrollIndexCallback: function updateScrollIndexCallback() {
                    return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                  },
                });
              }
              if (this._recomputeScrollTopFlag) {
                this._recomputeScrollTopFlag = false;
                this._updateScrollTopForScrollToRow(this.props);
              } else {
                updateScrollIndexHelper({
                  cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                  previousCellsCount: prevProps.rowCount,
                  previousCellSize: prevProps.rowHeight,
                  previousScrollToAlignment: prevProps.scrollToAlignment,
                  previousScrollToIndex: prevProps.scrollToRow,
                  previousSize: prevProps.height,
                  scrollOffset: scrollTop,
                  scrollToAlignment: scrollToAlignment,
                  scrollToIndex: scrollToRow,
                  size: height,
                  sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                  updateScrollIndexCallback: function updateScrollIndexCallback() {
                    return _this2._updateScrollTopForScrollToRow(_this2.props);
                  },
                });
              }

              // Update onRowsRendered callback if start/stop indices have changed
              this._invokeOnGridRenderedHelper();

              // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
              if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                this._invokeOnScrollMemoizer({
                  scrollLeft: scrollLeft,
                  scrollTop: scrollTop,
                  totalColumnsWidth: totalColumnsWidth,
                  totalRowsHeight: totalRowsHeight,
                });
              }
              this._maybeCallOnScrollbarPresenceChange();
            },
          },
          {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              if (this._disablePointerEventsTimeoutId) {
                cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
              }
            },

            /**
             * This method updates scrollLeft/scrollTop in state for the following conditions:
             * 1) Empty content (0 rows or columns)
             * 2) New scroll props overriding the current state
             * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
             */
          },
          {
            key: 'render',
            value: function render() {
              var _this$props6 = this.props,
                autoContainerWidth = _this$props6.autoContainerWidth,
                autoHeight = _this$props6.autoHeight,
                autoWidth = _this$props6.autoWidth,
                className = _this$props6.className,
                containerProps = _this$props6.containerProps,
                containerRole = _this$props6.containerRole,
                containerStyle = _this$props6.containerStyle,
                height = _this$props6.height,
                id = _this$props6.id,
                noContentRenderer = _this$props6.noContentRenderer,
                role = _this$props6.role,
                style = _this$props6.style,
                tabIndex = _this$props6.tabIndex,
                width = _this$props6.width;
              var _this$state2 = this.state,
                instanceProps = _this$state2.instanceProps,
                needToResetStyleCache = _this$state2.needToResetStyleCache;
              var isScrolling = this._isScrolling();
              var gridStyle /*: Object*/ = {
                boxSizing: 'border-box',
                direction: 'ltr',
                height: autoHeight ? 'auto' : height,
                position: 'relative',
                width: autoWidth ? 'auto' : width,
                WebkitOverflowScrolling: 'touch',
                willChange: 'transform',
              };
              if (needToResetStyleCache) {
                this._styleCache = {};
              }

              // calculate _styleCache here
              // if state.isScrolling (not from _isScrolling) then reset
              if (!this.state.isScrolling) {
                this._resetStyleCache();
              }

              // calculate children to render here
              this._calculateChildrenToRender(this.props, this.state);
              var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
              var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

              // Force browser to hide scrollbars when we know they aren't necessary.
              // Otherwise once scrollbars appear they may not disappear again.
              // For more info see issue #116
              var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
              var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
              if (
                horizontalScrollBarSize !== this._horizontalScrollBarSize ||
                verticalScrollBarSize !== this._verticalScrollBarSize
              ) {
                this._horizontalScrollBarSize = horizontalScrollBarSize;
                this._verticalScrollBarSize = verticalScrollBarSize;
                this._scrollbarPresenceChanged = true;
              }

              // Also explicitly init styles to 'auto' if scrollbars are required.
              // This works around an obscure edge case where external CSS styles have not yet been loaded,
              // But an initial scroll index of offset is set as an external prop.
              // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
              // This was originally reported via clauderic/react-infinite-calendar/issues/23
              gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
              gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
              var childrenToDisplay = this._childrenToDisplay;
              var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
              return /*#__PURE__*/ react.createElement(
                'div',
                extends_extends(
                  {
                    ref: this._setScrollingContainerRef,
                  },
                  containerProps,
                  {
                    'aria-label': this.props['aria-label'],
                    'aria-readonly': this.props['aria-readonly'],
                    className: clsx_m('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: Grid_objectSpread(Grid_objectSpread({}, gridStyle), style),
                    tabIndex: tabIndex,
                  },
                ),
                childrenToDisplay.length > 0 &&
                  /*#__PURE__*/ react.createElement(
                    'div',
                    {
                      className: 'ReactVirtualized__Grid__innerScrollContainer',
                      role: containerRole,
                      style: Grid_objectSpread(
                        {
                          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                          height: totalRowsHeight,
                          maxWidth: totalColumnsWidth,
                          maxHeight: totalRowsHeight,
                          overflow: 'hidden',
                          pointerEvents: isScrolling ? 'none' : '',
                          position: 'relative',
                        },
                        containerStyle,
                      ),
                    },
                    childrenToDisplay,
                  ),
                showNoContentRenderer && noContentRenderer(),
              );
            },

            /* ---------------------------- Helper methods ---------------------------- */
          },
          {
            key: '_calculateChildrenToRender',
            value: function _calculateChildrenToRender() {
              var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
              var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
              var cellRenderer = props.cellRenderer,
                cellRangeRenderer = props.cellRangeRenderer,
                columnCount = props.columnCount,
                deferredMeasurementCache = props.deferredMeasurementCache,
                height = props.height,
                overscanColumnCount = props.overscanColumnCount,
                overscanIndicesGetter = props.overscanIndicesGetter,
                overscanRowCount = props.overscanRowCount,
                rowCount = props.rowCount,
                width = props.width,
                isScrollingOptOut = props.isScrollingOptOut;
              var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
                scrollDirectionVertical = state.scrollDirectionVertical,
                instanceProps = state.instanceProps;
              var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
              var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
              var isScrolling = this._isScrolling(props, state);
              this._childrenToDisplay = [];

              // Render only enough columns and rows to cover the visible area of the grid.
              if (height > 0 && width > 0) {
                var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                  containerSize: width,
                  offset: scrollLeft,
                });
                var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                  containerSize: height,
                  offset: scrollTop,
                });
                var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                  containerSize: width,
                  offset: scrollLeft,
                });
                var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                  containerSize: height,
                  offset: scrollTop,
                });

                // Store for _invokeOnGridRenderedHelper()
                this._renderedColumnStartIndex = visibleColumnIndices.start;
                this._renderedColumnStopIndex = visibleColumnIndices.stop;
                this._renderedRowStartIndex = visibleRowIndices.start;
                this._renderedRowStopIndex = visibleRowIndices.stop;
                var overscanColumnIndices = overscanIndicesGetter({
                  direction: 'horizontal',
                  cellCount: columnCount,
                  overscanCellsCount: overscanColumnCount,
                  scrollDirection: scrollDirectionHorizontal,
                  startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                  stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1,
                });
                var overscanRowIndices = overscanIndicesGetter({
                  direction: 'vertical',
                  cellCount: rowCount,
                  overscanCellsCount: overscanRowCount,
                  scrollDirection: scrollDirectionVertical,
                  startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                  stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1,
                });

                // Store for _invokeOnGridRenderedHelper()
                var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                var rowStartIndex = overscanRowIndices.overscanStartIndex;
                var rowStopIndex = overscanRowIndices.overscanStopIndex;

                // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                if (deferredMeasurementCache) {
                  // If rows have a dynamic height, scan the rows we are about to render.
                  // If any have not yet been measured, then we need to render all columns initially,
                  // Because the height of the row is equal to the tallest cell within that row,
                  // (And so we can't know the height without measuring all column-cells first).
                  if (!deferredMeasurementCache.hasFixedHeight()) {
                    for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
                      if (!deferredMeasurementCache.has(rowIndex, 0)) {
                        columnStartIndex = 0;
                        columnStopIndex = columnCount - 1;
                        break;
                      }
                    }
                  }

                  // If columns have a dynamic width, scan the columns we are about to render.
                  // If any have not yet been measured, then we need to render all rows initially,
                  // Because the width of the column is equal to the widest cell within that column,
                  // (And so we can't know the width without measuring all row-cells first).
                  if (!deferredMeasurementCache.hasFixedWidth()) {
                    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
                      if (!deferredMeasurementCache.has(0, columnIndex)) {
                        rowStartIndex = 0;
                        rowStopIndex = rowCount - 1;
                        break;
                      }
                    }
                  }
                }
                this._childrenToDisplay = cellRangeRenderer({
                  cellCache: this._cellCache,
                  cellRenderer: cellRenderer,
                  columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                  columnStartIndex: columnStartIndex,
                  columnStopIndex: columnStopIndex,
                  deferredMeasurementCache: deferredMeasurementCache,
                  horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                  isScrolling: isScrolling,
                  isScrollingOptOut: isScrollingOptOut,
                  parent: this,
                  rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                  rowStartIndex: rowStartIndex,
                  rowStopIndex: rowStopIndex,
                  scrollLeft: scrollLeft,
                  scrollTop: scrollTop,
                  styleCache: this._styleCache,
                  verticalOffsetAdjustment: verticalOffsetAdjustment,
                  visibleColumnIndices: visibleColumnIndices,
                  visibleRowIndices: visibleRowIndices,
                });

                // update the indices
                this._columnStartIndex = columnStartIndex;
                this._columnStopIndex = columnStopIndex;
                this._rowStartIndex = rowStartIndex;
                this._rowStopIndex = rowStopIndex;
              }
            },

            /**
             * Sets an :isScrolling flag for a small window of time.
             * This flag is used to disable pointer events on the scrollable portion of the Grid.
             * This prevents jerky/stuttery mouse-wheel scrolling.
             */
          },
          {
            key: '_debounceScrollEnded',
            value: function _debounceScrollEnded() {
              var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
              if (this._disablePointerEventsTimeoutId) {
                cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
              }
              this._disablePointerEventsTimeoutId = requestAnimationTimeout(
                this._debounceScrollEndedCallback,
                scrollingResetTimeInterval,
              );
            },
          },
          {
            key: '_handleInvalidatedGridSize',
            value:
              /**
               * Check for batched CellMeasurer size invalidations.
               * This will occur the first time one or more previously unmeasured cells are rendered.
               */
              function _handleInvalidatedGridSize() {
                if (
                  typeof this._deferredInvalidateColumnIndex === 'number' &&
                  typeof this._deferredInvalidateRowIndex === 'number'
                ) {
                  var columnIndex = this._deferredInvalidateColumnIndex;
                  var rowIndex = this._deferredInvalidateRowIndex;
                  this._deferredInvalidateColumnIndex = null;
                  this._deferredInvalidateRowIndex = null;
                  this.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex,
                  });
                }
              },
          },
          {
            key: '_invokeOnScrollMemoizer',
            value: function _invokeOnScrollMemoizer(_ref6 /*:: */) {
              var _this3 = this;
              var scrollLeft = _ref6 /*:: */.scrollLeft,
                scrollTop = _ref6 /*:: */.scrollTop,
                totalColumnsWidth = _ref6 /*:: */.totalColumnsWidth,
                totalRowsHeight = _ref6 /*:: */.totalRowsHeight;
              this._onScrollMemoizer({
                callback: function callback(_ref7) {
                  var scrollLeft = _ref7.scrollLeft,
                    scrollTop = _ref7.scrollTop;
                  var _this3$props = _this3.props,
                    height = _this3$props.height,
                    onScroll = _this3$props.onScroll,
                    width = _this3$props.width;
                  onScroll({
                    clientHeight: height,
                    clientWidth: width,
                    scrollHeight: totalRowsHeight,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: totalColumnsWidth,
                  });
                },
                indices: {
                  scrollLeft: scrollLeft,
                  scrollTop: scrollTop,
                },
              });
            },
          },
          {
            key: '_isScrolling',
            value: function _isScrolling() /*: boolean*/ {
              var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
              var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
              // If isScrolling is defined in props, use it to override the value in state
              // This is a performance optimization for WindowScroller + Grid
              return Object.hasOwnProperty.call(props, 'isScrolling')
                ? Boolean(props.isScrolling)
                : Boolean(state.isScrolling);
            },
          },
          {
            key: '_maybeCallOnScrollbarPresenceChange',
            value: function _maybeCallOnScrollbarPresenceChange() {
              if (this._scrollbarPresenceChanged) {
                var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                this._scrollbarPresenceChanged = false;
                onScrollbarPresenceChange({
                  horizontal: this._horizontalScrollBarSize > 0,
                  size: this.state.instanceProps.scrollbarSize,
                  vertical: this._verticalScrollBarSize > 0,
                });
              }
            },
          },
          {
            key: 'scrollToPosition',
            value:
              /**
               * Scroll to the specified offset(s).
               * Useful for animating position changes.
               */
              function scrollToPosition(_ref8 /*:: */) {
                var scrollLeft = _ref8 /*:: */.scrollLeft,
                  scrollTop = _ref8 /*:: */.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                  prevState: this.state,
                  scrollLeft: scrollLeft,
                  scrollTop: scrollTop,
                });
                if (stateUpdate) {
                  stateUpdate.needToResetStyleCache = false;
                  this.setState(stateUpdate);
                }
              },
          },
          {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft() {
              var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
              var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
              return Grid._getCalculatedScrollLeft(props, state);
            },
          },
          {
            key: '_updateScrollLeftForScrollToColumn',
            value: function _updateScrollLeftForScrollToColumn() {
              var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
              var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
              var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
              if (stateUpdate) {
                stateUpdate.needToResetStyleCache = false;
                this.setState(stateUpdate);
              }
            },
          },
          {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop() {
              var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
              var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
              return Grid._getCalculatedScrollTop(props, state);
            },
          },
          {
            key: '_resetStyleCache',
            value: function _resetStyleCache() {
              var styleCache = this._styleCache;
              var cellCache = this._cellCache;
              var isScrollingOptOut = this.props.isScrollingOptOut;

              // Reset cell and style caches once scrolling stops.
              // This makes Grid simpler to use (since cells commonly change).
              // And it keeps the caches from growing too large.
              // Performance is most sensitive when a user is scrolling.
              // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
              // This keeps the cellCache to a resonable size.
              this._cellCache = {};
              this._styleCache = {};

              // Copy over the visible cell styles so avoid unnecessary re-render.
              for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
                for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
                  var key = ''.concat(rowIndex, '-').concat(columnIndex);
                  this._styleCache[key] = styleCache[key];
                  if (isScrollingOptOut) {
                    this._cellCache[key] = cellCache[key];
                  }
                }
              }
            },
          },
          {
            key: '_updateScrollTopForScrollToRow',
            value: function _updateScrollTopForScrollToRow() {
              var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
              var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
              var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
              if (stateUpdate) {
                stateUpdate.needToResetStyleCache = false;
                this.setState(stateUpdate);
              }
            },
          },
        ],
        [
          {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps /*: Props*/, prevState /*: State*/) /*: $Shape<State>*/ {
              var newState = {};
              if (
                (nextProps.columnCount === 0 && prevState.scrollLeft !== 0) ||
                (nextProps.rowCount === 0 && prevState.scrollTop !== 0)
              ) {
                newState.scrollLeft = 0;
                newState.scrollTop = 0;

                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
              } else if (
                (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0) ||
                (nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0)
              ) {
                _extends2(
                  newState,
                  Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop,
                  }),
                );
              }
              var instanceProps = prevState.instanceProps;

              // Initially we should not clearStyleCache
              newState.needToResetStyleCache = false;
              if (
                nextProps.columnWidth !== instanceProps.prevColumnWidth ||
                nextProps.rowHeight !== instanceProps.prevRowHeight
              ) {
                // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
              }
              instanceProps.columnSizeAndPositionManager.configure({
                cellCount: nextProps.columnCount,
                estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth),
              });
              instanceProps.rowSizeAndPositionManager.configure({
                cellCount: nextProps.rowCount,
                estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight),
              });
              if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                instanceProps.prevColumnCount = 0;
                instanceProps.prevRowCount = 0;
              }

              // If scrolling is controlled outside this component, clear cache when scrolling stops
              if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
                _extends2(newState, {
                  isScrolling: false,
                });
              }
              var maybeStateA;
              var maybeStateB;
              calculateSizeAndPositionDataAndUpdateScrollOffset({
                cellCount: instanceProps.prevColumnCount,
                cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                computeMetadataCallback: function computeMetadataCallback() {
                  return instanceProps.columnSizeAndPositionManager.resetCell(0);
                },
                computeMetadataCallbackProps: nextProps,
                nextCellsCount: nextProps.columnCount,
                nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                nextScrollToIndex: nextProps.scrollToColumn,
                scrollToIndex: instanceProps.prevScrollToColumn,
                updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                  maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                },
              });
              calculateSizeAndPositionDataAndUpdateScrollOffset({
                cellCount: instanceProps.prevRowCount,
                cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                computeMetadataCallback: function computeMetadataCallback() {
                  return instanceProps.rowSizeAndPositionManager.resetCell(0);
                },
                computeMetadataCallbackProps: nextProps,
                nextCellsCount: nextProps.rowCount,
                nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                nextScrollToIndex: nextProps.scrollToRow,
                scrollToIndex: instanceProps.prevScrollToRow,
                updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                  maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                },
              });
              instanceProps.prevColumnCount = nextProps.columnCount;
              instanceProps.prevColumnWidth = nextProps.columnWidth;
              instanceProps.prevIsScrolling = nextProps.isScrolling === true;
              instanceProps.prevRowCount = nextProps.rowCount;
              instanceProps.prevRowHeight = nextProps.rowHeight;
              instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
              instanceProps.prevScrollToRow = nextProps.scrollToRow;

              // getting scrollBarSize (moved from componentWillMount)
              instanceProps.scrollbarSize = nextProps.getScrollbarSize();
              if (instanceProps.scrollbarSize === undefined) {
                instanceProps.scrollbarSizeMeasured = false;
                instanceProps.scrollbarSize = 0;
              } else {
                instanceProps.scrollbarSizeMeasured = true;
              }
              newState.instanceProps = instanceProps;
              return Grid_objectSpread(Grid_objectSpread(Grid_objectSpread({}, newState), maybeStateA), maybeStateB);
            },
          },
          {
            key: '_getEstimatedColumnSize',
            value: function _getEstimatedColumnSize(props /*: Props*/) {
              return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            },
          },
          {
            key: '_getEstimatedRowSize',
            value: function _getEstimatedRowSize(props /*: Props*/) {
              return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            },
          },
          {
            key: '_getScrollToPositionStateUpdate',
            value:
              /**
               * Get the updated state after scrolling to
               * scrollLeft and scrollTop
               */
              function _getScrollToPositionStateUpdate(_ref9 /*:: */) /*: $Shape<State>*/ {
                var prevState = _ref9 /*:: */.prevState,
                  scrollLeft = _ref9 /*:: */.scrollLeft,
                  scrollTop = _ref9 /*:: */.scrollTop;
                var newState /*: Object*/ = {
                  scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED,
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                  newState.scrollDirectionHorizontal =
                    scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
                  newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                  newState.scrollDirectionVertical =
                    scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_BACKWARD;
                  newState.scrollTop = scrollTop;
                }
                if (
                  (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft) ||
                  (typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop)
                ) {
                  return newState;
                }
                return {};
              },
          },
          {
            key: '_wrapSizeGetter',
            value: function _wrapSizeGetter(value /*: CellSize*/) /*: CellSizeGetter*/ {
              return typeof value === 'function'
                ? value
                : function () {
                    return value /*: any*/;
                  };
            },
          },
          {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft(nextProps /*: Props*/, prevState /*: State*/) {
              var columnCount = nextProps.columnCount,
                height = nextProps.height,
                scrollToAlignment = nextProps.scrollToAlignment,
                scrollToColumn = nextProps.scrollToColumn,
                width = nextProps.width;
              var scrollLeft = prevState.scrollLeft,
                instanceProps = prevState.instanceProps;
              if (columnCount > 0) {
                var finalColumn = columnCount - 1;
                var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var scrollBarSize =
                  instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                  align: scrollToAlignment,
                  containerSize: width - scrollBarSize,
                  currentOffset: scrollLeft,
                  targetIndex: targetIndex,
                });
              }
              return 0;
            },
          },
          {
            key: '_getScrollLeftForScrollToColumnStateUpdate',
            value: function _getScrollLeftForScrollToColumnStateUpdate(
              nextProps /*: Props*/,
              prevState /*: State*/,
            ) /*: $Shape<State>*/ {
              var scrollLeft = prevState.scrollLeft;
              var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
              if (
                typeof calculatedScrollLeft === 'number' &&
                calculatedScrollLeft >= 0 &&
                scrollLeft !== calculatedScrollLeft
              ) {
                return Grid._getScrollToPositionStateUpdate({
                  prevState: prevState,
                  scrollLeft: calculatedScrollLeft,
                  scrollTop: -1,
                });
              }
              return {};
            },
          },
          {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop(nextProps /*: Props*/, prevState /*: State*/) {
              var height = nextProps.height,
                rowCount = nextProps.rowCount,
                scrollToAlignment = nextProps.scrollToAlignment,
                scrollToRow = nextProps.scrollToRow,
                width = nextProps.width;
              var scrollTop = prevState.scrollTop,
                instanceProps = prevState.instanceProps;
              if (rowCount > 0) {
                var finalRow = rowCount - 1;
                var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollBarSize =
                  instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                  align: scrollToAlignment,
                  containerSize: height - scrollBarSize,
                  currentOffset: scrollTop,
                  targetIndex: targetIndex,
                });
              }
              return 0;
            },
          },
          {
            key: '_getScrollTopForScrollToRowStateUpdate',
            value: function _getScrollTopForScrollToRowStateUpdate(
              nextProps /*: Props*/,
              prevState /*: State*/,
            ) /*: $Shape<State>*/ {
              var scrollTop = prevState.scrollTop;
              var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
              if (
                typeof calculatedScrollTop === 'number' &&
                calculatedScrollTop >= 0 &&
                scrollTop !== calculatedScrollTop
              ) {
                return Grid._getScrollToPositionStateUpdate({
                  prevState: prevState,
                  scrollLeft: -1,
                  scrollTop: calculatedScrollTop,
                });
              }
              return {};
            },
          },
        ],
      );
    })(react.PureComponent);
    defineProperty_defineProperty(Grid, 'defaultProps', {
      'aria-label': 'grid',
      'aria-readonly': true,
      autoContainerWidth: false,
      autoHeight: false,
      autoWidth: false,
      cellRangeRenderer: defaultCellRangeRenderer,
      containerRole: 'row',
      containerStyle: {},
      estimatedColumnSize: 100,
      estimatedRowSize: 30,
      getScrollbarSize: scrollbarSize,
      noContentRenderer: renderNull,
      onScroll: function onScroll() {},
      onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
      onSectionRendered: function onSectionRendered() {},
      overscanColumnCount: 0,
      overscanIndicesGetter: defaultOverscanIndicesGetter,
      overscanRowCount: 10,
      role: 'grid',
      scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
      scrollToAlignment: 'auto',
      scrollToColumn: -1,
      scrollToRow: -1,
      style: {},
      tabIndex: 0,
      isScrollingOptOut: false,
    });
    (0, react_lifecycles_compat_es.polyfill)(Grid);
    /* harmony default export */ const Grid_Grid = Grid; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/accessibilityOverscanIndicesGetter.js
    /*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/
    var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_BACKWARD = /* unused pure expression or super */ null && -1;
    var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD = 1;
    var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
    var accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_VERTICAL = 'vertical';

    /**
     * Calculates the number of cells to overscan before and after a specified range.
     * This function ensures that overscanning doesn't exceed the available cells.
     */

    function accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter(_ref /*:: */) /*: OverscanIndices*/ {
      var cellCount = _ref /*:: */.cellCount,
        overscanCellsCount = _ref /*:: */.overscanCellsCount,
        scrollDirection = _ref /*:: */.scrollDirection,
        startIndex = _ref /*:: */.startIndex,
        stopIndex = _ref /*:: */.stopIndex;
      // Make sure we render at least 1 cell extra before and after (except near boundaries)
      // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
      // For more info see issues #625
      overscanCellsCount = Math.max(1, overscanCellsCount);
      if (scrollDirection === accessibilityOverscanIndicesGetter_SCROLL_DIRECTION_FORWARD) {
        return {
          overscanStartIndex: Math.max(0, startIndex - 1),
          overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount),
        };
      } else {
        return {
          overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
          overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1),
        };
      }
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Grid/index.js
    // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/Table.js
    /*:: export type {
			  NoContentRenderer,
			  Alignment,
			  CellPosition,
			  CellSize,
			  OverscanIndicesGetter,
			  RenderedSection,
			  CellRendererParams,
			  Scroll,
			} from './types';*/

    function Table_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function Table_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? Table_ownKeys(Object(t), !0).forEach(function (r) {
              defineProperty_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : Table_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function Table_callSuper(t, o, e) {
      return (
        (o = _getPrototypeOf(o)),
        _possibleConstructorReturn(
          t,
          Table_isNativeReflectConstruct()
            ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
            : o.apply(t, e),
        )
      );
    }
    function Table_isNativeReflectConstruct() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (t) {}
      return (Table_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
      })();
    }
    /*:: import type {CellPosition} from '../Grid';*/

    /**
     * Table component with fixed headers and virtualized rows for improved performance with large data sets.
     * This component expects explicit width, height, and padding parameters.
     */
    var Table_Table = /*#__PURE__*/ (function (_React$PureComponent) {
      function Table(props) {
        var _this;
        _classCallCheck(this, Table);
        _this = Table_callSuper(this, Table, [props]);
        _this.state = {
          scrollbarWidth: 0,
        };
        _this._createColumn = _this._createColumn.bind(_this);
        _this._createRow = _this._createRow.bind(_this);
        _this._onScroll = _this._onScroll.bind(_this);
        _this._onSectionRendered = _this._onSectionRendered.bind(_this);
        _this._setRef = _this._setRef.bind(_this);
        return _this;
      }
      _inherits(Table, _React$PureComponent);
      return _createClass(Table, [
        {
          key: 'forceUpdateGrid',
          value: function forceUpdateGrid() {
            if (this.Grid) {
              this.Grid.forceUpdate();
            }
          },

          /** See Grid#getOffsetForCell */
        },
        {
          key: 'getOffsetForRow',
          value: function getOffsetForRow(_ref) {
            var alignment = _ref.alignment,
              index = _ref.index;
            if (this.Grid) {
              var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                  alignment: alignment,
                  rowIndex: index,
                }),
                scrollTop = _this$Grid$getOffsetF.scrollTop;
              return scrollTop;
            }
            return 0;
          },

          /** CellMeasurer compatibility */
        },
        {
          key: 'invalidateCellSizeAfterRender',
          value: function invalidateCellSizeAfterRender(_ref2 /*:: */) {
            var columnIndex = _ref2 /*:: */.columnIndex,
              rowIndex = _ref2 /*:: */.rowIndex;
            if (this.Grid) {
              this.Grid.invalidateCellSizeAfterRender({
                rowIndex: rowIndex,
                columnIndex: columnIndex,
              });
            }
          },

          /** See Grid#measureAllCells */
        },
        {
          key: 'measureAllRows',
          value: function measureAllRows() {
            if (this.Grid) {
              this.Grid.measureAllCells();
            }
          },

          /** CellMeasurer compatibility */
        },
        {
          key: 'recomputeGridSize',
          value: function recomputeGridSize() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref3$columnIndex = _ref3.columnIndex,
              columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
              _ref3$rowIndex = _ref3.rowIndex,
              rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;
            if (this.Grid) {
              this.Grid.recomputeGridSize({
                rowIndex: rowIndex,
                columnIndex: columnIndex,
              });
            }
          },

          /** See Grid#recomputeGridSize */
        },
        {
          key: 'recomputeRowHeights',
          value: function recomputeRowHeights() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            if (this.Grid) {
              this.Grid.recomputeGridSize({
                rowIndex: index,
              });
            }
          },

          /** See Grid#scrollToPosition */
        },
        {
          key: 'scrollToPosition',
          value: function scrollToPosition() {
            var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            if (this.Grid) {
              this.Grid.scrollToPosition({
                scrollTop: scrollTop,
              });
            }
          },

          /** See Grid#scrollToCell */
        },
        {
          key: 'scrollToRow',
          value: function scrollToRow() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            if (this.Grid) {
              this.Grid.scrollToCell({
                columnIndex: 0,
                rowIndex: index,
              });
            }
          },
        },
        {
          key: 'getScrollbarWidth',
          value: function getScrollbarWidth() {
            if (this.Grid) {
              var _Grid = (0, react_dom.findDOMNode)(this.Grid);
              var clientWidth = _Grid.clientWidth || 0;
              var offsetWidth = _Grid.offsetWidth || 0;
              return offsetWidth - clientWidth;
            }
            return 0;
          },
        },
        {
          key: 'componentDidMount',
          value: function componentDidMount() {
            this._setScrollbarWidth();
          },
        },
        {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this._setScrollbarWidth();
          },
        },
        {
          key: 'render',
          value: function render() {
            var _this2 = this;
            var _this$props = this.props,
              children = _this$props.children,
              className = _this$props.className,
              disableHeader = _this$props.disableHeader,
              gridClassName = _this$props.gridClassName,
              gridContainerRole = _this$props.gridContainerRole,
              gridStyle = _this$props.gridStyle,
              headerHeight = _this$props.headerHeight,
              headerRowRenderer = _this$props.headerRowRenderer,
              height = _this$props.height,
              id = _this$props.id,
              noRowsRenderer = _this$props.noRowsRenderer,
              role = _this$props.role,
              rowClassName = _this$props.rowClassName,
              rowStyle = _this$props.rowStyle,
              scrollToIndex = _this$props.scrollToIndex,
              style = _this$props.style,
              width = _this$props.width;
            var scrollbarWidth = this.state.scrollbarWidth;
            var availableRowsHeight = disableHeader ? height : height - headerHeight;
            var rowClass =
              typeof rowClassName === 'function'
                ? rowClassName({
                    index: -1,
                  })
                : rowClassName;
            var rowStyleObject =
              typeof rowStyle === 'function'
                ? rowStyle({
                    index: -1,
                  })
                : rowStyle;

            // Precompute and cache column styles before rendering rows and columns to speed things up
            this._cachedColumnStyles = [];
            react.Children.toArray(children).forEach(function (column, index) {
              var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
              _this2._cachedColumnStyles[index] = Table_objectSpread(
                {
                  overflow: 'hidden',
                },
                flexStyles,
              );
            });

            // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
            // This is done because Grid is a pure component and won't update unless its properties or state has changed.
            // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
            return /*#__PURE__*/ react.createElement(
              'div',
              {
                'aria-label': this.props['aria-label'],
                'aria-labelledby': this.props['aria-labelledby'],
                'aria-colcount': react.Children.toArray(children).length,
                'aria-rowcount': this.props.rowCount,
                className: clsx_m('ReactVirtualized__Table', className),
                id: id,
                role: role,
                style: style,
              },
              !disableHeader &&
                headerRowRenderer({
                  className: clsx_m('ReactVirtualized__Table__headerRow', rowClass),
                  columns: this._getHeaderColumns(),
                  style: Table_objectSpread(
                    {
                      height: headerHeight,
                      overflow: 'hidden',
                      paddingRight: scrollbarWidth,
                      width: width,
                    },
                    rowStyleObject,
                  ),
                }),
              /*#__PURE__*/ react.createElement(
                Grid_Grid,
                extends_extends({}, this.props, {
                  'aria-readonly': null,
                  autoContainerWidth: true,
                  className: clsx_m('ReactVirtualized__Table__Grid', gridClassName),
                  cellRenderer: this._createRow,
                  columnWidth: width,
                  columnCount: 1,
                  containerRole: gridContainerRole,
                  height: availableRowsHeight,
                  id: undefined,
                  noContentRenderer: noRowsRenderer,
                  onScroll: this._onScroll,
                  onSectionRendered: this._onSectionRendered,
                  ref: this._setRef,
                  role: 'rowgroup',
                  scrollbarWidth: scrollbarWidth,
                  scrollToRow: scrollToIndex,
                  style: Table_objectSpread(
                    Table_objectSpread({}, gridStyle),
                    {},
                    {
                      overflowX: 'hidden',
                    },
                  ),
                }),
              ),
            );
          },
        },
        {
          key: '_createColumn',
          value: function _createColumn(_ref4) {
            var column = _ref4.column,
              columnIndex = _ref4.columnIndex,
              isScrolling = _ref4.isScrolling,
              parent = _ref4.parent,
              rowData = _ref4.rowData,
              rowIndex = _ref4.rowIndex;
            var onColumnClick = this.props.onColumnClick;
            var _column$props = column.props,
              cellDataGetter = _column$props.cellDataGetter,
              cellRenderer = _column$props.cellRenderer,
              className = _column$props.className,
              columnData = _column$props.columnData,
              dataKey = _column$props.dataKey,
              id = _column$props.id,
              role = _column$props.role;
            var cellData = cellDataGetter({
              columnData: columnData,
              dataKey: dataKey,
              rowData: rowData,
            });
            var renderedCell = cellRenderer({
              cellData: cellData,
              columnData: columnData,
              columnIndex: columnIndex,
              dataKey: dataKey,
              isScrolling: isScrolling,
              parent: parent,
              rowData: rowData,
              rowIndex: rowIndex,
            });
            var onClick = function onClick(event) {
              onColumnClick &&
                onColumnClick({
                  columnData: columnData,
                  dataKey: dataKey,
                  event: event,
                });
            };
            var style = this._cachedColumnStyles[columnIndex];
            var title = typeof renderedCell === 'string' ? renderedCell : null;

            // Avoid using object-spread syntax with multiple objects here,
            // Since it results in an extra method call to 'babel-runtime/helpers/extends'
            // See PR https://github.com/bvaughn/react-virtualized/pull/942
            return /*#__PURE__*/ react.createElement(
              'div',
              {
                'aria-colindex': columnIndex + 1,
                'aria-describedby': id,
                className: clsx_m('ReactVirtualized__Table__rowColumn', className),
                key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
                onClick: onClick,
                role: role,
                style: style,
                title: title,
              },
              renderedCell,
            );
          },
        },
        {
          key: '_createHeader',
          value: function _createHeader(_ref5) {
            var column = _ref5.column,
              index = _ref5.index;
            var _this$props2 = this.props,
              headerClassName = _this$props2.headerClassName,
              headerStyle = _this$props2.headerStyle,
              onHeaderClick = _this$props2.onHeaderClick,
              sort = _this$props2.sort,
              sortBy = _this$props2.sortBy,
              sortDirection = _this$props2.sortDirection;
            var _column$props2 = column.props,
              columnData = _column$props2.columnData,
              dataKey = _column$props2.dataKey,
              defaultSortDirection = _column$props2.defaultSortDirection,
              disableSort = _column$props2.disableSort,
              headerRenderer = _column$props2.headerRenderer,
              headerRole = _column$props2.headerRole,
              id = _column$props2.id,
              label = _column$props2.label,
              preventAriaLabel = _column$props2.preventAriaLabel;
            var sortEnabled = !disableSort && sort;
            var classNames = clsx_m(
              'ReactVirtualized__Table__headerColumn',
              headerClassName,
              column.props.headerClassName,
              {
                ReactVirtualized__Table__sortableHeaderColumn: sortEnabled,
              },
            );
            var style = this._getFlexStyleForColumn(
              column,
              Table_objectSpread(Table_objectSpread({}, headerStyle), column.props.headerStyle),
            );
            var renderedHeader = headerRenderer({
              columnData: columnData,
              dataKey: dataKey,
              disableSort: disableSort,
              label: label,
              sortBy: sortBy,
              sortDirection: sortDirection,
            });
            var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort;
            var headerAriaLabel = preventAriaLabel ? undefined : column.props['aria-label'] || label || dataKey;
            if (sortEnabled || onHeaderClick) {
              // If this is a sortable header, clicking it should update the table data's sorting.
              var isFirstTimeSort = sortBy !== dataKey;

              // If this is the firstTime sort of this column, use the column default sort order.
              // Otherwise, invert the direction of the sort.
              var newSortDirection;
              if (isFirstTimeSort) {
                newSortDirection = defaultSortDirection;
              } else if (sortDirection === Table_SortDirection.DESC) {
                newSortDirection = Table_SortDirection.ASC;
              } else {
                newSortDirection = Table_SortDirection.DESC;
              }
              var onClick = function onClick(event) {
                sortEnabled &&
                  sort({
                    defaultSortDirection: defaultSortDirection,
                    event: event,
                    sortBy: dataKey,
                    sortDirection: newSortDirection,
                  });
                onHeaderClick &&
                  onHeaderClick({
                    columnData: columnData,
                    dataKey: dataKey,
                    event: event,
                  });
              };
              var onKeyDown = function onKeyDown(event) {
                if (event.key === 'Enter' || event.key === ' ') {
                  onClick(event);
                }
              };
              headerAriaSort = 'none';
              headerTabIndex = 0;
              headerOnClick = onClick;
              headerOnKeyDown = onKeyDown;
            }
            if (sortBy === dataKey) {
              headerAriaSort = sortDirection === Table_SortDirection.ASC ? 'ascending' : 'descending';
            }

            // Avoid using object-spread syntax with multiple objects here,
            // Since it results in an extra method call to 'babel-runtime/helpers/extends'
            // See PR https://github.com/bvaughn/react-virtualized/pull/942
            return /*#__PURE__*/ react.createElement(
              'div',
              {
                'aria-label': headerAriaLabel,
                'aria-sort': headerAriaSort,
                className: classNames,
                id: id,
                key: 'Header-Col' + index,
                onClick: headerOnClick,
                onKeyDown: headerOnKeyDown,
                role: headerRole,
                style: style,
                tabIndex: headerTabIndex,
              },
              renderedHeader,
            );
          },
        },
        {
          key: '_createRow',
          value: function _createRow(_ref6) {
            var _this3 = this;
            var index = _ref6.rowIndex,
              isScrolling = _ref6.isScrolling,
              key = _ref6.key,
              parent = _ref6.parent,
              style = _ref6.style;
            var _this$props3 = this.props,
              children = _this$props3.children,
              onRowClick = _this$props3.onRowClick,
              onRowDoubleClick = _this$props3.onRowDoubleClick,
              onRowRightClick = _this$props3.onRowRightClick,
              onRowMouseOver = _this$props3.onRowMouseOver,
              onRowMouseOut = _this$props3.onRowMouseOut,
              rowClassName = _this$props3.rowClassName,
              rowGetter = _this$props3.rowGetter,
              rowRenderer = _this$props3.rowRenderer,
              rowStyle = _this$props3.rowStyle;
            var scrollbarWidth = this.state.scrollbarWidth;
            var rowClass =
              typeof rowClassName === 'function'
                ? rowClassName({
                    index: index,
                  })
                : rowClassName;
            var rowStyleObject =
              typeof rowStyle === 'function'
                ? rowStyle({
                    index: index,
                  })
                : rowStyle;
            var rowData = rowGetter({
              index: index,
            });
            var columns = react.Children.toArray(children).map(function (column, columnIndex) {
              return _this3._createColumn({
                column: column,
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                parent: parent,
                rowData: rowData,
                rowIndex: index,
                scrollbarWidth: scrollbarWidth,
              });
            });
            var className = clsx_m('ReactVirtualized__Table__row', rowClass);
            var flattenedStyle = Table_objectSpread(
              Table_objectSpread({}, style),
              {},
              {
                height: this._getRowHeight(index),
                overflow: 'hidden',
                paddingRight: scrollbarWidth,
              },
              rowStyleObject,
            );
            return rowRenderer({
              className: className,
              columns: columns,
              index: index,
              isScrolling: isScrolling,
              key: key,
              onRowClick: onRowClick,
              onRowDoubleClick: onRowDoubleClick,
              onRowRightClick: onRowRightClick,
              onRowMouseOver: onRowMouseOver,
              onRowMouseOut: onRowMouseOut,
              rowData: rowData,
              style: flattenedStyle,
            });
          },

          /**
           * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
           */
        },
        {
          key: '_getFlexStyleForColumn',
          value: function _getFlexStyleForColumn(column) {
            var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var flexValue = ''
              .concat(column.props.flexGrow, ' ')
              .concat(column.props.flexShrink, ' ')
              .concat(column.props.width, 'px');
            var style = Table_objectSpread(
              Table_objectSpread({}, customStyle),
              {},
              {
                flex: flexValue,
                msFlex: flexValue,
                WebkitFlex: flexValue,
              },
            );
            if (column.props.maxWidth) {
              style.maxWidth = column.props.maxWidth;
            }
            if (column.props.minWidth) {
              style.minWidth = column.props.minWidth;
            }
            return style;
          },
        },
        {
          key: '_getHeaderColumns',
          value: function _getHeaderColumns() {
            var _this4 = this;
            var _this$props4 = this.props,
              children = _this$props4.children,
              disableHeader = _this$props4.disableHeader;
            var items = disableHeader ? [] : react.Children.toArray(children);
            return items.map(function (column, index) {
              return _this4._createHeader({
                column: column,
                index: index,
              });
            });
          },
        },
        {
          key: '_getRowHeight',
          value: function _getRowHeight(rowIndex) {
            var rowHeight = this.props.rowHeight;
            return typeof rowHeight === 'function'
              ? rowHeight({
                  index: rowIndex,
                })
              : rowHeight;
          },
        },
        {
          key: '_onScroll',
          value: function _onScroll(_ref7) {
            var clientHeight = _ref7.clientHeight,
              scrollHeight = _ref7.scrollHeight,
              scrollTop = _ref7.scrollTop;
            var onScroll = this.props.onScroll;
            onScroll({
              clientHeight: clientHeight,
              scrollHeight: scrollHeight,
              scrollTop: scrollTop,
            });
          },
        },
        {
          key: '_onSectionRendered',
          value: function _onSectionRendered(_ref8) {
            var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
              rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
              rowStartIndex = _ref8.rowStartIndex,
              rowStopIndex = _ref8.rowStopIndex;
            var onRowsRendered = this.props.onRowsRendered;
            onRowsRendered({
              overscanStartIndex: rowOverscanStartIndex,
              overscanStopIndex: rowOverscanStopIndex,
              startIndex: rowStartIndex,
              stopIndex: rowStopIndex,
            });
          },
        },
        {
          key: '_setRef',
          value: function _setRef(ref) {
            this.Grid = ref;
          },
        },
        {
          key: '_setScrollbarWidth',
          value: function _setScrollbarWidth() {
            var scrollbarWidth = this.getScrollbarWidth();
            this.setState({
              scrollbarWidth: scrollbarWidth,
            });
          },
        },
      ]);
    })(react.PureComponent);
    defineProperty_defineProperty(Table_Table, 'defaultProps', {
      disableHeader: false,
      estimatedRowSize: 30,
      gridContainerRole: '',
      headerHeight: 0,
      headerStyle: {},
      noRowsRenderer: function noRowsRenderer() {
        return null;
      },
      onRowsRendered: function onRowsRendered() {
        return null;
      },
      onScroll: function onScroll() {
        return null;
      },
      overscanIndicesGetter: accessibilityOverscanIndicesGetter_defaultOverscanIndicesGetter,
      overscanRowCount: 10,
      role: 'grid',
      rowRenderer: defaultRowRenderer,
      headerRowRenderer: defaultHeaderRowRenderer,
      rowStyle: {},
      scrollToAlignment: 'auto',
      scrollToIndex: -1,
      style: {},
    });

    Table_Table.propTypes = false ? 0 : {}; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/Table/index.js
    /* harmony default export */ const es_Table = /* unused pure expression or super */ null && Table; // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/vendor/detectElementResize.js

    /**
     * Detect Element Resize.
     * https://github.com/sdecima/javascript-detect-element-resize
     * Sebastian Decima
     *
     * Forked from version 0.5.3; includes the following modifications:
     * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
     * 2) Defer initialization code via a top-level function wrapper (to support SSR).
     * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
     * 4) Add nonce for style element.
     * 5) Added support for injecting custom window object
     **/

    function createDetectElementResize(nonce, hostWindow) {
      // Check `document` and `window` in case of server-side rendering
      var _window;
      if (typeof hostWindow !== 'undefined') {
        _window = hostWindow;
      } else if (typeof window !== 'undefined') {
        _window = window;
      } else if (typeof self !== 'undefined') {
        _window = self;
      } else {
        _window = __webpack_require__.g;
      }
      var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
      if (!attachEvent) {
        var requestFrame = (function () {
          var raf =
            _window.requestAnimationFrame ||
            _window.mozRequestAnimationFrame ||
            _window.webkitRequestAnimationFrame ||
            function (fn) {
              return _window.setTimeout(fn, 20);
            };
          return function (fn) {
            return raf(fn);
          };
        })();
        var cancelFrame = (function () {
          var cancel =
            _window.cancelAnimationFrame ||
            _window.mozCancelAnimationFrame ||
            _window.webkitCancelAnimationFrame ||
            _window.clearTimeout;
          return function (id) {
            return cancel(id);
          };
        })();
        var resetTriggers = function resetTriggers(element) {
          var triggers = element.__resizeTriggers__,
            expand = triggers.firstElementChild,
            contract = triggers.lastElementChild,
            expandChild = expand.firstElementChild;
          contract.scrollLeft = contract.scrollWidth;
          contract.scrollTop = contract.scrollHeight;
          expandChild.style.width = expand.offsetWidth + 1 + 'px';
          expandChild.style.height = expand.offsetHeight + 1 + 'px';
          expand.scrollLeft = expand.scrollWidth;
          expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
          return (
            element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height
          );
        };
        var scrollListener = function scrollListener(e) {
          // Don't measure (which forces) reflow for scrolls that happen inside of children!
          if (
            e.target.className &&
            typeof e.target.className.indexOf === 'function' &&
            e.target.className.indexOf('contract-trigger') < 0 &&
            e.target.className.indexOf('expand-trigger') < 0
          ) {
            return;
          }
          var element = this;
          resetTriggers(this);
          if (this.__resizeRAF__) {
            cancelFrame(this.__resizeRAF__);
          }
          this.__resizeRAF__ = requestFrame(function () {
            if (checkTriggers(element)) {
              element.__resizeLast__.width = element.offsetWidth;
              element.__resizeLast__.height = element.offsetHeight;
              element.__resizeListeners__.forEach(function (fn) {
                fn.call(element, e);
              });
            }
          });
        };

        /* Detect CSS Animations support to detect element display/re-attach */
        var animation = false,
          keyframeprefix = '',
          animationstartevent = 'animationstart',
          domPrefixes = 'Webkit Moz O ms'.split(' '),
          startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
          pfx = '';
        {
          var elm = _window.document.createElement('fakeelement');
          if (elm.style.animationName !== undefined) {
            animation = true;
          }
          if (animation === false) {
            for (var i = 0; i < domPrefixes.length; i++) {
              if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
              }
            }
          }
        }
        var animationName = 'resizeanim';
        var animationKeyframes =
          '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
      }
      var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
          //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
          var css =
              (animationKeyframes ? animationKeyframes : '') +
              '.resize-triggers { ' +
              (animationStyle ? animationStyle : '') +
              'visibility: hidden; opacity: 0; } ' +
              '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
            head = doc.head || doc.getElementsByTagName('head')[0],
            style = doc.createElement('style');
          style.id = 'detectElementResize';
          style.type = 'text/css';
          if (nonce != null) {
            style.setAttribute('nonce', nonce);
          }
          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            style.appendChild(doc.createTextNode(css));
          }
          head.appendChild(style);
        }
      };
      var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) {
          element.attachEvent('onresize', fn);
        } else {
          if (!element.__resizeTriggers__) {
            var doc = element.ownerDocument;
            var elementStyle = _window.getComputedStyle(element);
            if (elementStyle && elementStyle.position == 'static') {
              element.style.position = 'relative';
            }
            createStyles(doc);
            element.__resizeLast__ = {};
            element.__resizeListeners__ = [];
            (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
            var expandTrigger = doc.createElement('div');
            expandTrigger.className = 'expand-trigger';
            expandTrigger.appendChild(doc.createElement('div'));
            var contractTrigger = doc.createElement('div');
            contractTrigger.className = 'contract-trigger';
            element.__resizeTriggers__.appendChild(expandTrigger);
            element.__resizeTriggers__.appendChild(contractTrigger);
            element.appendChild(element.__resizeTriggers__);
            resetTriggers(element);
            element.addEventListener('scroll', scrollListener, true);

            /* Listen for a css animation to detect element display/re-attach */
            if (animationstartevent) {
              element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                if (e.animationName == animationName) {
                  resetTriggers(element);
                }
              };
              element.__resizeTriggers__.addEventListener(
                animationstartevent,
                element.__resizeTriggers__.__animationListener__,
              );
            }
          }
          element.__resizeListeners__.push(fn);
        }
      };
      var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) {
          element.detachEvent('onresize', fn);
        } else {
          element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
          if (!element.__resizeListeners__.length) {
            element.removeEventListener('scroll', scrollListener, true);
            if (element.__resizeTriggers__.__animationListener__) {
              element.__resizeTriggers__.removeEventListener(
                animationstartevent,
                element.__resizeTriggers__.__animationListener__,
              );
              element.__resizeTriggers__.__animationListener__ = null;
            }
            try {
              element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
            } catch (e) {
              // Preact compat; see developit/preact-compat/issues/228
            }
          }
        }
      };
      return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener,
      };
    } // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/AutoSizer/AutoSizer.js
    function AutoSizer_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function AutoSizer_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? AutoSizer_ownKeys(Object(t), !0).forEach(function (r) {
              defineProperty_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : AutoSizer_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function AutoSizer_callSuper(t, o, e) {
      return (
        (o = _getPrototypeOf(o)),
        _possibleConstructorReturn(
          t,
          AutoSizer_isNativeReflectConstruct()
            ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor)
            : o.apply(t, e),
        )
      );
    }
    function AutoSizer_isNativeReflectConstruct() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (t) {}
      return (AutoSizer_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
      })();
    }

    /*:: type Size = {
			  height: number,
			  width: number,
			};*/
    /*:: type Props = {
			  /** Function responsible for rendering children.*-/
			  children: Size => React.Element<*>,
			
			  /** Optional custom CSS class name to attach to root AutoSizer element.  *-/
			  className?: string,
			
			  /** Default height to use for initial render; useful for SSR *-/
			  defaultHeight?: number,
			
			  /** Default width to use for initial render; useful for SSR *-/
			  defaultWidth?: number,
			
			  /** Disable dynamic :height property *-/
			  disableHeight: boolean,
			
			  /** Disable dynamic :width property *-/
			  disableWidth: boolean,
			
			  /** Nonce of the inlined stylesheet for Content Security Policy *-/
			  nonce?: string,
			
			  /** Callback to be invoked on-resize *-/
			  onResize: Size => void,
			
			  /** Optional inline style *-/
			  style: ?Object,
			};*/
    /*:: type State = {
			  height: number,
			  width: number,
			};*/
    /*:: type ResizeHandler = (element: HTMLElement, onResize: () => void) => void;*/
    /*:: type DetectElementResize = {
			  addResizeListener: ResizeHandler,
			  removeResizeListener: ResizeHandler,
			};*/
    var AutoSizer = /*#__PURE__*/ (function (_React$Component) {
      function AutoSizer() {
        var _this;
        _classCallCheck(this, AutoSizer);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = AutoSizer_callSuper(this, AutoSizer, [].concat(args));
        defineProperty_defineProperty(_this, 'state', {
          height: _this.props.defaultHeight || 0,
          width: _this.props.defaultWidth || 0,
        });
        defineProperty_defineProperty(_this, '_parentNode', void 0);
        defineProperty_defineProperty(_this, '_autoSizer', void 0);
        defineProperty_defineProperty(_this, '_window', void 0);
        // uses any instead of Window because Flow doesn't have window type
        defineProperty_defineProperty(_this, '_detectElementResize', void 0);
        defineProperty_defineProperty(_this, '_onResize', function () {
          var _this$props = _this.props,
            disableHeight = _this$props.disableHeight,
            disableWidth = _this$props.disableWidth,
            onResize = _this$props.onResize;
          if (_this._parentNode) {
            // Guard against AutoSizer component being removed from the DOM immediately after being added.
            // This can result in invalid style values which can result in NaN values if we don't handle them.
            // See issue #150 for more context.

            var height = _this._parentNode.offsetHeight || 0;
            var width = _this._parentNode.offsetWidth || 0;
            var win = _this._window || window;
            var style = win.getComputedStyle(_this._parentNode) || {};
            var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
            var paddingRight = parseInt(style.paddingRight, 10) || 0;
            var paddingTop = parseInt(style.paddingTop, 10) || 0;
            var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
            var newHeight = height - paddingTop - paddingBottom;
            var newWidth = width - paddingLeft - paddingRight;
            if (
              (!disableHeight && _this.state.height !== newHeight) ||
              (!disableWidth && _this.state.width !== newWidth)
            ) {
              _this.setState({
                height: height - paddingTop - paddingBottom,
                width: width - paddingLeft - paddingRight,
              });
              onResize({
                height: height,
                width: width,
              });
            }
          }
        });
        defineProperty_defineProperty(_this, '_setRef', function (autoSizer /*: ?HTMLElement*/) {
          _this._autoSizer = autoSizer;
        });
        return _this;
      }
      _inherits(AutoSizer, _React$Component);
      return _createClass(AutoSizer, [
        {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var nonce = this.props.nonce;
            if (
              this._autoSizer &&
              this._autoSizer.parentNode &&
              this._autoSizer.parentNode.ownerDocument &&
              this._autoSizer.parentNode.ownerDocument.defaultView &&
              this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement
            ) {
              // Delay access of parentNode until mount.
              // This handles edge-cases where the component has already been unmounted before its ref has been set,
              // As well as libraries like react-lite which have a slightly different lifecycle.
              this._parentNode = this._autoSizer.parentNode;
              this._window = this._autoSizer.parentNode.ownerDocument.defaultView;

              // Defer requiring resize handler in order to support server-side rendering.
              // See issue #41
              this._detectElementResize = createDetectElementResize(nonce, this._window);
              this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
              this._onResize();
            }
          },
        },
        {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this._detectElementResize && this._parentNode) {
              this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
          },
        },
        {
          key: 'render',
          value: function render() {
            var _this$props2 = this.props,
              children = _this$props2.children,
              className = _this$props2.className,
              disableHeight = _this$props2.disableHeight,
              disableWidth = _this$props2.disableWidth,
              style = _this$props2.style;
            var _this$state = this.state,
              height = _this$state.height,
              width = _this$state.width;

            // Outer div should not force width/height since that may prevent containers from shrinking.
            // Inner component should overflow and use calculated width/height.
            // See issue #68 for more information.
            var outerStyle /*: Object*/ = {
              overflow: 'visible',
            };
            var childParams /*: Object*/ = {};
            if (!disableHeight) {
              outerStyle.height = 0;
              childParams.height = height;
            }
            if (!disableWidth) {
              outerStyle.width = 0;
              childParams.width = width;
            }

            /**
								 * TODO: Avoid rendering children before the initial measurements have been collected.
								 * At best this would just be wasting cycles.
								 * Add this check into version 10 though as it could break too many ref callbacks in version 9.
								 * Note that if default width/height props were provided this would still work with SSR.
								if (
								  height !== 0 &&
								  width !== 0
								) {
								  child = children({ height, width })
								}
								*/

            return /*#__PURE__*/ react.createElement(
              'div',
              {
                className: className,
                ref: this._setRef,
                style: AutoSizer_objectSpread(AutoSizer_objectSpread({}, outerStyle), style),
              },
              children(childParams),
            );
          },
        },
      ]);
    })(react.Component);
    defineProperty_defineProperty(AutoSizer, 'defaultProps', {
      onResize: function onResize() {},
      disableHeight: false,
      disableWidth: false,
      style: {},
    }); // CONCATENATED MODULE: ./node_modules/@box/react-virtualized/dist/es/AutoSizer/index.js
    // CONCATENATED MODULE: ./src/components/badgeable/Badgeable.tsx

    const Badgeable = props => {
      const {
        children,
        className = '',
        topLeft = null,
        topRight = null,
        bottomLeft = null,
        bottomRight = null,
      } = props;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: classnames_default()('badgeable-container', className),
        },
        children,
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'badges',
          },
          topLeft &&
            /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'top-left-badge',
              },
              topLeft,
            ),
          topRight &&
            /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'top-right-badge',
              },
              topRight,
            ),
          bottomLeft &&
            /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'bottom-left-badge',
              },
              bottomLeft,
            ),
          bottomRight &&
            /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'bottom-right-badge',
              },
              bottomRight,
            ),
        ),
      );
    };
    /* harmony default export */ const badgeable_Badgeable = Badgeable; // CONCATENATED MODULE: ./src/components/badgeable/index.ts
    // CONCATENATED MODULE: ./src/icon/content/FileAudio32.tsx
    function FileAudio32_extends() {
      return (
        (FileAudio32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileAudio32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileAudio32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileAudio32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlPurpleRain,
            d: 'M9 3h9.172a2 2 0 011.414.586l5.83 5.828A2 2 0 0126 10.83V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M18.75 17h-5.5a.25.25 0 00-.25.25v4.25a1.5 1.5 0 11-1.5-1.5.9.9 0 01.5.1v-6.35a.75.75 0 01.75-.75h6.5a.75.75 0 01.75.75v7.75a1.5 1.5 0 11-1.5-1.5.9.9 0 01.5.1v-2.85a.25.25 0 00-.25-.25zm-5.5-1h5.5a.25.25 0 00.25-.25V14.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v1.25c0 .138.112.25.25.25z',
          }),
        ),
      );
    /* harmony default export */ const content_FileAudio32 = FileAudio32; // CONCATENATED MODULE: ./src/icon/content/FileCanvas32.tsx
    function FileCanvas32_extends() {
      return (
        (FileCanvas32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileCanvas32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileCanvas32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileCanvas32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M9 3h9.585a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          fill: bdlOrange,
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M15 15.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm3.729 4.521c.125-.016.44-.059.912.059l.09.022c.674.164 2.394.583 4.48 2.218.196.167.697.602.78.675.038.034.214.211.411.41.24.242.51.515.6.598V26a65.511 65.511 0 01-1.164-1.172c-.521-.541-.876-.87-1.345-1.3-.469-.43-1.733-1.361-2.488-1.675-.756-.313-1.08-.444-1.398-.49l.007.021a1.28 1.28 0 00.068.172c.016.034.028.06.039.104l.238.524.031.067.009.02.006.012.01.026.183.422c.266.613.465 1.108.594 1.473.177.502.27.925.153 1.285-.116.36-.398.508-.754.508-.537 0-1.303-.421-1.543-.567l-.086-.052a7.211 7.211 0 01-.621-.413c-.327-.234-.444-.362-.53-.455a2.335 2.335 0 00-.045-.049c-.094-.097-.319-.333-.359-.657-.023-.183.001-.398.107-.55.062-.088.16-.215.44-.25a.649.649 0 01.436.133c.051.036.151.137.27.255a6.17 6.17 0 00.608.555c.203.166.445.364.603.425-.032-.072-.09-.195-.147-.318v-.001a18.603 18.603 0 01-.137-.297 11.247 11.247 0 00-.194-.41c-.333-.684-.663-1.381-.807-1.814l-.024-.073c-.13-.387-.205-.612-.129-.884.052-.185.111-.32.337-.438.09-.047.23-.098.348-.113l.01-.002zm.71-6.778l2.483 3.974a.511.511 0 01-.44.783h-4.966a.515.515 0 01-.44-.783l2.484-3.974a.519.519 0 01.878 0zm-9.44 7.579c0-.454.368-.822.822-.822h3.356c.454 0 .822.368.822.822v3.356a.822.822 0 01-.822.822h-3.356a.822.822 0 01-.822-.822v-3.356z',
          fill: '#fff',
        }),
        /*#__PURE__*/ react.createElement('path', {
          opacity: 0.5,
          d: 'M19.285 3.286l6.421 6.421a1 1 0 01.204.293h-4.911a2 2 0 01-1.995-1.85L19 8V3.09a1 1 0 01.286.196z',
          fill: '#fff',
        }),
      );
    /* harmony default export */ const content_FileCanvas32 = FileCanvas32; // CONCATENATED MODULE: ./src/icon/content/FileBoxNote32.tsx
    function FileBoxNote32_extends() {
      return (
        (FileBoxNote32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileBoxNote32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileBoxNote32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileBoxNote32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlGray20,
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#9725DD',
            d: 'M18.526 14.146l-.92 1.375h-6.92a.685.685 0 01-.686-.688c0-.38.31-.687.687-.687h7.839z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlBoxBlue,
            d: 'M16.379 17.583l-.92 1.375h-4.762a.69.69 0 01-.697-.687c0-.38.31-.688.697-.688h5.682z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#00C8C0',
            d: 'M14.231 21.02l-.424.637a2.166 2.166 0 00-.229.493l-.031.118-.028.127H10.69a.687.687 0 110-1.374h3.541z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: black,
            d: 'M14.841 21.332l4.64-6.72.053.092c.074.114.235.322.538.541.456.329.797.374.797.374l-4.64 6.72a2.558 2.558 0 01-.461.483l-1.373 1.037c-.146.11-.234.054-.193-.14l.372-1.764c.04-.187.156-.46.267-.623zm6.648-8.163c.373.272.407.704.407.704a3.57 3.57 0 01-.314.607l-.28.417-.09-.016a1.714 1.714 0 01-.632-.282c-.35-.255-.628-.687-.628-.687l.28-.418c.106-.158.284-.397.448-.51l.074-.009c.14-.012.456-.01.735.194z',
          }),
        ),
      );
    /* harmony default export */ const content_FileBoxNote32 = FileBoxNote32; // CONCATENATED MODULE: ./src/icon/content/FileCode32.tsx
    function FileCode32_extends() {
      return (
        (FileCode32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileCode32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileCode32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileCode32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#E33D55',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M17.553 13.776a.5.5 0 01.894.448l-4 8a.5.5 0 01-.894-.448zm-4.83 1.808a.5.5 0 11.554.832L10.901 18l2.376 1.584a.5.5 0 11-.554.832l-3-2a.5.5 0 010-.832zm6.554 0l3 2a.5.5 0 010 .832l-3 2a.5.5 0 11-.554-.832L21.099 18l-2.376-1.584a.5.5 0 01.554-.832z',
          }),
        ),
      );
    /* harmony default export */ const content_FileCode32 = FileCode32; // CONCATENATED MODULE: ./src/icon/content/FileDefault32.tsx
    function FileDefault32_extends() {
      return (
        (FileDefault32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileDefault32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileDefault32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileDefault32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlGray20,
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
        ),
      );
    /* harmony default export */ const content_FileDefault32 = FileDefault32; // CONCATENATED MODULE: ./src/icon/content/FileDwg32.tsx
    function FileDwg32_extends() {
      return (
        (FileDwg32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileDwg32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileDwg32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileDwg32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#009AED',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M18 18v-2h-2v-4h-1v4h-2v2H9v1h4v2h2v4h1v-4h2v-2h4v-1h-4zm-1 2h-3v-3h3v3z',
          }),
        ),
      );
    /* harmony default export */ const content_FileDwg32 = FileDwg32; // CONCATENATED MODULE: ./src/icon/content/FileExcel32.tsx
    function FileExcel32_extends() {
      return (
        (FileExcel32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileExcel32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileExcel32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileExcel32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#107C41',
            d: 'M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#87BDA0',
            d: 'M19.286 3.286l6.422 6.421a.994.994 0 01.203.293H21a2.001 2.001 0 01-1.995-1.85L19 8V3.09c.105.048.202.114.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M20.25 25a.748.748 0 00.75-.75v-10.5a.748.748 0 00-.75-.75H12a.748.748 0 00-.75.75v1.5h-1.5A.748.748 0 009 16v6a.748.748 0 00.75.75h1.5v1.5A.748.748 0 0012 25h8.25zm-4.5-9.75H12v-1.5h3.75v1.5zm4.5 0H16.5v-1.5h3.75v1.5zm0 3H16.5V16h3.75v2.25zm-8.344 3.188h-1.511l1.582-2.45-1.442-2.425h1.518l.756 1.494.82-1.494h1.43l-1.483 2.42 1.518 2.454H13.6l-.838-1.564-.856 1.564zm8.344-.188H16.5V19h3.75v2.25zm0 3H16.5V22h3.75v2.25zm-4.5 0H12v-1.5h3.75v1.5z',
          }),
        ),
      );
    /* harmony default export */ const content_FileExcel32 = FileExcel32; // CONCATENATED MODULE: ./src/icon/content/FileDocs32.tsx
    function FileDocs32_extends() {
      return (
        (FileDocs32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileDocs32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileDocs32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileDocs32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#4083F7',
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M16 23v1h-6v-1h6zm5-3v1H10v-1h11zm0-3v1H10v-1h11zm0-3v1H10v-1h11z',
          }),
        ),
      );
    /* harmony default export */ const content_FileDocs32 = FileDocs32; // CONCATENATED MODULE: ./src/icon/content/FileSheets32.tsx
    function FileSheets32_extends() {
      return (
        (FileSheets32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileSheets32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileSheets32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileSheets32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#21A464',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M20.499 14c.277 0 .501.228.501.51v8.98c0 .282-.23.51-.501.51H10.5a.505.505 0 01-.501-.51v-8.98c0-.282.23-.51.501-.51h10zM11 21v2h4v-2.001L11 21zm5 0v2h4v-2h-4zm4-3h-4v2h4v-2zm0-3h-4v2h4v-2zm-5 0h-4v2l4-.001V15zm-4 5l4-.001v-2L11 18v2z',
          }),
        ),
      );
    /* harmony default export */ const content_FileSheets32 = FileSheets32; // CONCATENATED MODULE: ./src/icon/content/FileSlides32.tsx
    function FileSlides32_extends() {
      return (
        (FileSlides32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileSlides32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileSlides32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileSlides32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#F7BA00',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M10 14v9c0 .6.4 1 1 1h9c.6 0 1-.4 1-1v-9c0-.6-.4-1-1-1h-9c-.6 0-1 .4-1 1zm10 7h-9v-5h9v5z',
          }),
        ),
      );
    /* harmony default export */ const content_FileSlides32 = FileSlides32; // CONCATENATED MODULE: ./src/icon/content/FileIllustrator32.tsx
    function FileIllustrator32_extends() {
      return (
        (FileIllustrator32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileIllustrator32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileIllustrator32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileIllustrator32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#051E25',
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#FF9400',
            d: 'M20.42 15.805c.072 0 .108.027.108.107v6.982c0 .07-.018.106-.107.106h-1.393c-.09 0-.117-.044-.117-.115v-6.973h-.009c0-.071.027-.107.108-.107h1.41zm-5.813-2.557c.063 0 .09.017.108.088l2.857 9.549c.018.07 0 .115-.072.115h-1.49c-.072 0-.117-.018-.135-.08l-.737-2.663h-2.875l-.71 2.655c-.018.07-.045.088-.135.088h-1.32c-.09 0-.109-.027-.09-.133l2.551-8.796c.045-.16.072-.301.09-.735 0-.062.027-.088.072-.088h1.887zm-.917 1.416h-.018c-.188 1.035-.665 2.787-1.042 4.159h2.13c-.252-.982-.845-3.124-1.07-4.16zM19.72 13c.548 0 .916.363.916.903 0 .584-.386.902-.934.902-.521 0-.899-.318-.899-.902 0-.567.404-.903.917-.903z',
          }),
        ),
      );
    /* harmony default export */ const content_FileIllustrator32 = FileIllustrator32; // CONCATENATED MODULE: ./src/icon/content/FileImage32.tsx
    function FileImage32_extends() {
      return (
        (FileImage32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileImage32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileImage32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileImage32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#3FB87F',
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M14.754 18.128l3.102 3.204 1.327-1.625c.158-.193.415-.193.575 0l2.06 2.485c.37.446.159.808-.472.808H10.63c-.633 0-.82-.341-.414-.767a72386.439 72386.439 0 013.9-4.089.444.444 0 01.64-.016zM17.5 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3z',
          }),
        ),
      );
    /* harmony default export */ const content_FileImage32 = FileImage32; // CONCATENATED MODULE: ./src/icon/content/FileIndesign32.tsx
    function FileIndesign32_extends() {
      return (
        (FileIndesign32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileIndesign32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileIndesign32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileIndesign32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#051E25',
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#FF57A1',
            d: 'M19.866 13c.071 0 .09.027.09.072v8.385c0 .251 0 .565.044.906 0 .063-.018.072-.08.108a5.449 5.449 0 01-2.342.529c-1.975 0-3.387-1.229-3.387-3.73-.01-2.144 1.403-3.813 3.664-3.813.188 0 .295 0 .474.018V13.09c0-.063.044-.09.09-.09h1.447zm-7.364 0c.071 0 .107.027.107.108v9.64c0 .09-.018.117-.116.117h-1.377c-.09 0-.116-.044-.116-.116v-9.632c0-.09.045-.117.116-.117h1.386zm5.3 3.83c-1.154 0-1.958.888-1.958 2.367 0 1.686.822 2.368 1.85 2.368.224 0 .456-.027.635-.108V16.92a1.282 1.282 0 00-.528-.09z',
          }),
        ),
      );
    /* harmony default export */ const content_FileIndesign32 = FileIndesign32; // CONCATENATED MODULE: ./src/icon/content/FileKeynote32.tsx
    function FileKeynote32_extends() {
      return (
        (FileKeynote32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileKeynote32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileKeynote32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileKeynote32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          fill: '#1A66EF',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          fill: '#fff',
          fillOpacity: 0.5,
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M20.991 16.925l-.697-4.338a.697.697 0 00-.688-.587h-8.212a.697.697 0 00-.688.587l-.697 4.338a.698.698 0 00.688.807h9.606a.698.698 0 00.688-.807zM17.979 24.225h-2.092V18.2h-.774v6.025H13.02c-.31 0-.465.155-.465.387 0 .233.155.388.465.388h4.958c.31 0 .465-.155.465-.387 0-.233-.155-.388-.465-.388z',
          fill: '#fff',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M15.5 14.169l-1.047 1.253c.294.186.656.296 1.047.296.391 0 .753-.11 1.047-.296.301-.19.53-.46.648-.774l-1.695-.479z',
          fill: '#66C155',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M13.805 14.648a1.365 1.365 0 010-.958l1.695.479-1.695.479z',
          fill: '#FA9E27',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M14.453 12.916a1.958 1.958 0 011.047-.296v1.549l-1.047-1.253z',
          fill: '#AB4287',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M17.195 13.69a1.584 1.584 0 00-.648-.774 1.957 1.957 0 00-1.047-.296v1.549l1.695.479a1.365 1.365 0 000-.958z',
          fill: '#61D9FE',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M14.453 15.422c-.301-.19-.53-.46-.648-.774l1.695-.479-1.047 1.253z',
          fill: '#FBCE5A',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M13.805 13.69c.117-.314.347-.584.648-.774l1.047 1.253-1.695-.479z',
          fill: '#E85A5E',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M19.311 16.338H11.69c-.248 0-.372.124-.372.31s.124.31.372.31h7.622c.248 0 .372-.124.372-.31s-.124-.31-.372-.31z',
          fill: '#C7E8FD',
        }),
      );
    /* harmony default export */ const content_FileKeynote32 = FileKeynote32; // CONCATENATED MODULE: ./src/icon/content/FileNumbers32.tsx
    function FileNumbers32_extends() {
      return (
        (FileNumbers32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileNumbers32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileNumbers32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileNumbers32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          fill: '#18D31D',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          fill: '#fff',
          fillOpacity: 0.5,
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M10 21.529v-.1l.001-.084c.002-.062.006-.123.017-.184a.616.616 0 01.164-.322.584.584 0 01.322-.165c.06-.011.123-.015.184-.017h.084l.1-.001h.47a16.617 16.617 0 01.185.001c.06.002.122.006.183.017a.616.616 0 01.322.165.585.585 0 01.165.322c.01.06.014.122.016.183a3.95 3.95 0 01.001.185v2.003l-.001.084a1.224 1.224 0 01-.016.183.618.618 0 01-.165.323.584.584 0 01-.322.165 1.21 1.21 0 01-.183.016l-.084.001H10.77l-.084-.001a1.207 1.207 0 01-.182-.016.616.616 0 01-.323-.165.587.587 0 01-.165-.323 1.24 1.24 0 01-.016-.183v-.084l-.001-.1v-1.903zM12.928 18.453v-.1l.002-.085c.001-.06.005-.122.016-.183a.62.62 0 01.165-.322.587.587 0 01.322-.166c.06-.01.122-.014.183-.016h.084l.1-.001h.471a16.584 16.584 0 01.184.001c.061.002.123.006.183.017a.616.616 0 01.322.165.588.588 0 01.165.322c.01.06.014.122.016.183l.001.085V23.616a1.237 1.237 0 01-.017.183.618.618 0 01-.165.323.585.585 0 01-.322.165 1.21 1.21 0 01-.183.016 3.93 3.93 0 01-.084.001H13.7l-.084-.001a1.208 1.208 0 01-.183-.016.616.616 0 01-.322-.165.585.585 0 01-.165-.323 1.212 1.212 0 01-.016-.183 3.93 3.93 0 01-.002-.084v-5.08zM15.857 12.873v-.1c0-.028 0-.056.002-.084.001-.062.005-.123.016-.184a.62.62 0 01.165-.322.586.586 0 01.322-.165c.06-.011.122-.015.183-.017h.084l.1-.001h.471a16.584 16.584 0 01.184.001c.06.002.122.006.183.017a.619.619 0 01.322.165.588.588 0 01.165.322c.01.06.014.122.016.184l.001.084V23.532l-.001.084a1.238 1.238 0 01-.016.183.62.62 0 01-.165.323.585.585 0 01-.322.165c-.06.01-.122.014-.183.016a3.93 3.93 0 01-.084.001H16.629l-.084-.001a1.234 1.234 0 01-.183-.016.619.619 0 01-.322-.165.585.585 0 01-.165-.323 1.21 1.21 0 01-.016-.183 3.93 3.93 0 01-.002-.084v-10.66zM18.785 16.02v-.1l.002-.084a1.21 1.21 0 01.016-.183.62.62 0 01.165-.323.587.587 0 01.322-.165c.06-.01.122-.014.183-.016l.084-.001h.571a16.584 16.584 0 01.184.001c.061.002.123.005.183.016a.615.615 0 01.322.165.587.587 0 01.165.323c.011.06.015.122.016.183l.002.085V23.53c0 .029 0 .057-.002.085a1.224 1.224 0 01-.016.183.62.62 0 01-.165.323.585.585 0 01-.322.165c-.06.01-.122.014-.183.016a3.92 3.92 0 01-.084.001H19.557l-.084-.001a1.208 1.208 0 01-.183-.016.617.617 0 01-.322-.165.585.585 0 01-.165-.323 1.213 1.213 0 01-.016-.183 3.94 3.94 0 01-.001-.084V16.02z',
          fill: '#fff',
        }),
      );
    /* harmony default export */ const content_FileNumbers32 = FileNumbers32; // CONCATENATED MODULE: ./src/icon/content/FilePages32.tsx
    function FilePages32_extends() {
      return (
        (FilePages32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FilePages32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FilePages32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FilePages32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M9 3h9.586a1 1 0 01.707.293l6.414 6.414a1 1 0 01.293.707V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          fill: '#FB8517',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          fill: '#fff',
          fillOpacity: 0.5,
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M21.686 24.179H11.52l-1.418.63h11.583c.173 0 .314-.14.314-.314v-.002a.314.314 0 00-.314-.314z',
          fill: '#FFC78A',
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M9.42 23.653l-.399.683a.158.158 0 00.216.216l.683-.399-.5-.5zM9.653 23.256l.664.664c.049.05.124.06.185.028a7.674 7.674 0 001.863-1.368l3.427-3.427-1.372-1.372-3.427 3.427a7.677 7.677 0 00-1.368 1.863.158.158 0 00.028.185zM16.107 18.838a.158.158 0 00.223 0l.785-.804c4.412-4.412 4.727-5.515 4.333-5.91-.394-.393-1.497-.078-5.909 4.334l-.804.785a.158.158 0 000 .223l1.372 1.372z',
          fill: '#fff',
        }),
      );
    /* harmony default export */ const content_FilePages32 = FilePages32; // CONCATENATED MODULE: ./src/icon/content/FilePdf32.tsx
    function FilePdf32_extends() {
      return (
        (FilePdf32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FilePdf32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FilePdf32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FilePdf32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#D0021B',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M13.133 16.998c0 .354-.054.66-.162.918a1.745 1.745 0 01-1.044 1.012 2.057 2.057 0 01-.693.122h-.621v2.322H9.2V15h1.98c.228 0 .457.033.688.099a1.655 1.655 0 011.089.945c.118.258.176.576.176.954zm-1.35.027c0-.288-.069-.495-.207-.621a.72.72 0 00-.504-.189h-.459v1.665h.459a.665.665 0 00.504-.22c.138-.148.207-.359.207-.635zm6.854 1.179c0 .48-.052.915-.157 1.305-.106.39-.266.723-.482.999a2.14 2.14 0 01-.824.639c-.333.15-.727.225-1.183.225H14.2V15h1.791c.456 0 .85.075 1.183.225.334.15.608.364.824.643.216.28.376.615.482 1.008.105.394.157.836.157 1.328zm-1.449 0c0-.642-.11-1.126-.328-1.454-.22-.327-.503-.49-.851-.49h-.351v3.852h.351c.348 0 .631-.163.85-.49.22-.328.329-.8.329-1.418zm3.961-1.899v1.296h1.521v1.233h-1.512v2.538H19.7V15h3.105v1.305h-1.656z',
          }),
        ),
      );
    /* harmony default export */ const content_FilePdf32 = FilePdf32; // CONCATENATED MODULE: ./src/icon/content/FilePhotoshop32.tsx
    function FilePhotoshop32_extends() {
      return (
        (FilePhotoshop32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FilePhotoshop32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FilePhotoshop32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FilePhotoshop32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#051E25',
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#26C9FF',
            d: 'M19.527 15.491c.79 0 1.34.116 1.643.25.074.045.092.116.092.179v1.223c0 .071-.046.116-.138.09-.403-.25-1-.403-1.597-.403-.725 0-.973.358-.973.652 0 .322.166.545 1.139 1.036 1.44.678 1.89 1.33 1.89 2.286 0 1.428-1.12 2.196-2.634 2.196-.798 0-1.487-.16-1.881-.384-.065-.027-.074-.071-.074-.143v-1.312c0-.09.046-.116.11-.072.579.366 1.24.527 1.845.527.725 0 1.028-.295 1.028-.696 0-.322-.211-.607-1.138-1.072-1.303-.607-1.845-1.223-1.845-2.25 0-1.152.927-2.107 2.533-2.107zM12.57 13c2.542 0 3.534 1.357 3.534 3.09 0 2.267-1.69 3.24-3.763 3.24-.35 0-.469-.017-.716-.017v3.428c0 .071-.028.107-.11.107H10.11c-.073 0-.11-.027-.11-.107v-9.59c0-.062.129-.106.202-.106.587-.027 1.46-.045 2.368-.045zm-.055 1.42c-.367 0-.716.018-.881.026v3.447c.21.018.376.018.743.018 1.074 0 2.084-.366 2.084-1.786 0-1.134-.725-1.705-1.946-1.705z',
          }),
        ),
      );
    /* harmony default export */ const content_FilePhotoshop32 = FilePhotoshop32; // CONCATENATED MODULE: ./src/icon/content/FilePowerpoint32.tsx
    function FilePowerpoint32_extends() {
      return (
        (FilePowerpoint32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FilePowerpoint32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FilePowerpoint32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FilePowerpoint32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#C43E1C',
            d: 'M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#E19E8D',
            d: 'M19.286 3.286l6.422 6.421a.994.994 0 01.203.293H21a2.001 2.001 0 01-1.995-1.85L19 8V3.09c.105.048.202.114.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M16 24a5.947 5.947 0 004.239-1.76 6.07 6.07 0 00.94-1.214c.262-.443.465-.92.607-1.432A5.862 5.862 0 0022 18a5.947 5.947 0 00-1.76-4.239 6.07 6.07 0 00-1.214-.94 5.894 5.894 0 00-1.432-.607A5.862 5.862 0 0016 12c-.457 0-.904.05-1.342.152a6.123 6.123 0 00-1.257.44c-.4.191-.776.427-1.128.706-.351.28-.67.597-.955.952h-.568A.748.748 0 0010 15v6a.748.748 0 00.75.75h.568c.286.355.604.673.955.952.352.28.728.515 1.128.706.4.192.82.338 1.257.44.438.101.885.152 1.342.152zm0-9.75h-3.668A5.186 5.186 0 0116 12.75v1.5zm5.197 3H17.5V15a.73.73 0 00-.219-.527.847.847 0 00-.241-.161.703.703 0 00-.29-.062v-1.447a5.086 5.086 0 011.617.512c.504.26.951.585 1.342.976.39.39.716.838.976 1.342.26.504.43 1.043.512 1.617zm-7.869 3.188h-1.213v-4.875h1.887c.258 0 .495.03.712.093.217.063.402.16.557.29.154.131.275.297.363.498.088.202.132.439.132.712 0 .266-.047.503-.141.712-.094.21-.223.386-.387.53a1.688 1.688 0 01-.577.331c-.22.077-.458.115-.712.115h-.62v1.593zm.527-2.655c.207 0 .369-.043.484-.129.115-.086.173-.24.173-.463 0-.214-.056-.36-.167-.439-.112-.078-.267-.117-.466-.117h-.55v1.148h.526zM16 23.25a5.186 5.186 0 01-3.668-1.5h4.418a.748.748 0 00.75-.75v-3.006h3.75c0 .485-.063.95-.188 1.395a5.251 5.251 0 01-1.353 2.32 5.258 5.258 0 01-2.317 1.353A5.155 5.155 0 0116 23.25z',
          }),
        ),
      );
    /* harmony default export */ const content_FilePowerpoint32 = FilePowerpoint32; // CONCATENATED MODULE: ./src/icon/content/FilePresentation32.tsx
    function FilePresentation32_extends() {
      return (
        (FilePresentation32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FilePresentation32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FilePresentation32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FilePresentation32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#F7931D',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M15.643 20.354a.5.5 0 00.707 0l5.003-5a.5.5 0 10-.706-.708l-4.65 4.647-1.647-1.647a.5.5 0 00-.707 0L9.646 21.65a.5.5 0 10.708.707l3.643-3.649 1.646 1.647z',
          }),
        ),
      );
    /* harmony default export */ const content_FilePresentation32 = FilePresentation32; // CONCATENATED MODULE: ./src/icon/content/FileSpreadsheet32.tsx
    function FileSpreadsheet32_extends() {
      return (
        (FileSpreadsheet32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileSpreadsheet32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileSpreadsheet32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileSpreadsheet32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#3FB87F',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M22 23.49c0 .282-.229.51-.5.51h-11a.505.505 0 01-.5-.51v-8.98c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98zM11 23h2v-2h-2v2zm10-2h-7v2h7v-2zm0-1v-2h-7v2h7zm-10 0h2v-2h-2v2zm10-3v-2h-7v2h7zm-8-2h-2v2h2v-2z',
          }),
        ),
      );
    /* harmony default export */ const content_FileSpreadsheet32 = FileSpreadsheet32; // CONCATENATED MODULE: ./src/icon/content/FileText32.tsx
    function FileText32_extends() {
      return (
        (FileText32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileText32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileText32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileText32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlBoxBlue,
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M17.5 21c.245 0 .45.183.492.412L18 21.5c0 .276-.23.5-.5.5h-7a.505.505 0 01-.5-.5c0-.276.23-.5.5-.5h7zm4-3c.245 0 .45.183.492.412L22 18.5c0 .276-.229.5-.5.5h-11a.505.505 0 01-.5-.5c0-.276.229-.5.5-.5h11zm-1.001-3c.246 0 .45.183.493.412L21 15.5c0 .276-.23.5-.501.5H10.5a.506.506 0 01-.501-.5c0-.276.23-.5.501-.5h10z',
          }),
        ),
      );
    /* harmony default export */ const content_FileText32 = FileText32; // CONCATENATED MODULE: ./src/icon/content/FileThreeD32.tsx
    function FileThreeD32_extends() {
      return (
        (FileThreeD32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileThreeD32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileThreeD32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileThreeD32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#F7931D',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M20 14.068l-3.6-1.85c-.5-.291-1.3-.291-1.8 0l-3.6 1.85c-.6.292-1 .973-1 1.556v4.768c0 .681.4 1.265 1 1.557l3.6 1.849c.496.27 1.234.27 1.8 0l3.6-1.849c.6-.292 1-.973 1-1.557v-4.768c0-.583-.4-1.264-1-1.556zm-8.6 7.103c-.2-.098-.4-.487-.4-.681v-4.768c0-.292.2-.584.4-.681l3.6-1.85c.2-.096.6-.096.9 0l3.6 1.85c.1.061.154.134.2.194l-4.2 1.761v6.12c-.2 0-.282-.05-.4-.097l-3.7-1.848z',
          }),
        ),
      );
    /* harmony default export */ const content_FileThreeD32 = FileThreeD32; // CONCATENATED MODULE: ./src/icon/content/FileVector32.tsx
    function FileVector32_extends() {
      return (
        (FileVector32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileVector32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileVector32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileVector32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#F7931D',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M13.195 17.07l.005.01c.12.312.292.6.504.851l-.424.254c-1.414.847-2.452 2.33-2.715 3.992a1 1 0 11-.999-.078c.289-1.994 1.516-3.763 3.2-4.772l.43-.257zm5.618.003l.429.256c1.687 1.008 2.91 2.77 3.197 4.77a1 1 0 11-1.002.073c-.26-1.664-1.293-3.14-2.708-3.985l-.43-.256.013-.019c.194-.235.354-.5.47-.787l.03-.052zM16 14a2 2 0 011.937 1.5h4.592c.26 0 .471.21.471.47v.06c0 .26-.21.47-.47.47l-4.593.001a2 2 0 01-3.874 0L9.471 16.5a.47.47 0 01-.47-.47v-.06c0-.26.21-.47.47-.47h4.592A2 2 0 0116 14zm0 1a1 1 0 00-1 .98v.039l.007.098A1 1 0 1016 15z',
          }),
        ),
      );
    /* harmony default export */ const content_FileVector32 = FileVector32; // CONCATENATED MODULE: ./src/icon/content/FileVideo32.tsx
    function FileVideo32_extends() {
      return (
        (FileVideo32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileVideo32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileVideo32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileVideo32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#009AED',
            fillRule: 'nonzero',
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            fillRule: 'nonzero',
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M19.723 18.973l-5.914 3.957a.543.543 0 01-.809-.473v-7.914a.543.543 0 01.809-.473l5.914 3.957a.543.543 0 010 .946z',
          }),
        ),
      );
    /* harmony default export */ const content_FileVideo32 = FileVideo32; // CONCATENATED MODULE: ./src/icon/content/FileWord32.tsx
    function FileWord32_extends() {
      return (
        (FileWord32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileWord32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileWord32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileWord32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#185ABD',
            d: 'M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#8BACDE',
            d: 'M19.286 3.286l6.422 6.421a.994.994 0 01.203.293H21a2.001 2.001 0 01-1.995-1.85L19 8V3.09c.105.048.202.114.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            d: 'M20.25 25a.748.748 0 00.75-.75v-10.5a.748.748 0 00-.75-.75H12a.748.748 0 00-.75.75v1.5h-1.5A.748.748 0 009 16v6a.748.748 0 00.75.75h1.5v1.5A.748.748 0 0012 25h8.25zm0-9.75H12v-1.5h8.25v1.5zm0 3H16.5V16h3.75v2.25zm-8.104 3.188h-1.26l-1.083-4.875h1.207l.55 2.8.61-2.8h1.184l.638 2.783.51-2.784h1.195l-1.078 4.875h-1.242l-.633-2.8-.598 2.8zm8.104-.188H16.5V19h3.75v2.25zm0 3H12v-1.5h3.75a.748.748 0 00.75-.75h3.75v2.25z',
          }),
        ),
      );
    /* harmony default export */ const content_FileWord32 = FileWord32; // CONCATENATED MODULE: ./src/icon/content/FileXbd32.tsx
    function FileXbd32_extends() {
      return (
        (FileXbd32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileXbd32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileXbd32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileXbd32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          fill: '#00838D',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          fill: white,
          fillOpacity: 0.5,
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M14.583 16v5h2.122c.498 0 .913-.137 1.205-.395.294-.259.452-.63.452-1.076v-.007c0-.565-.34-1.026-.84-1.186.372-.18.625-.588.625-1.034v-.007c0-.394-.14-.722-.404-.95-.263-.227-.638-.345-1.09-.345h-2.07zm4.594 0v5h1.872c.697 0 1.255-.228 1.637-.667.38-.438.575-1.071.575-1.861v-.007c0-.767-.197-1.386-.58-1.813-.383-.429-.94-.652-1.632-.652h-1.872zm-2.765.948c.208 0 .358.054.455.14.095.084.15.21.15.38v.007c0 .171-.058.295-.163.38-.108.086-.279.14-.52.14h-.605v-1.047h.683zm.031 1.911c.265 0 .453.058.573.154.117.092.182.232.182.43v.006c0 .205-.064.348-.178.443-.116.098-.297.157-.555.157h-.737v-1.19h.715zm3.879 1.11V17.03h.578c.383 0 .677.132.878.37.203.24.32.602.32 1.08v.007c0 .498-.114.868-.315 1.11-.198.24-.492.37-.883.37h-.578zM9 20.996h1.35l1.033-1.62 1.035 1.62h1.415l-1.656-2.503L13.858 16H12.46l-.996 1.665L10.461 16H9.005l1.62 2.475L9 20.995z',
          fill: white,
        }),
      );
    /* harmony default export */ const content_FileXbd32 = FileXbd32; // CONCATENATED MODULE: ./src/icon/content/FileXdw32.tsx
    function FileXdw32_extends() {
      return (
        (FileXdw32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileXdw32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileXdw32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileXdw32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          fill: '#00838D',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          fill: white,
          fillOpacity: 0.5,
        }),
        /*#__PURE__*/ react.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M9.352 21H8l1.627-2.523L8.005 16h1.457l1.004 1.666.997-1.666h1.4l-1.683 2.495L12.837 21H11.42l-1.036-1.62L9.352 21zm3.918 0v-5h2.035c.75 0 1.354.222 1.771.649.417.427.634 1.046.634 1.816v.007c0 .792-.214 1.427-.629 1.864-.416.438-1.021.664-1.776.664H13.27zm6.01 0l-1.356-5h1.283l.717 3.208.838-3.208h1.024l.854 3.21.71-3.21h1.277l-1.358 5h-1.117l-.88-3.057L20.405 21h-1.125zM14.5 17.031v2.938h.64c.433 0 .757-.133.975-.374.218-.243.342-.61.342-1.107v-.006c0-.476-.127-.837-.348-1.078-.22-.239-.545-.373-.969-.373h-.64z',
          fill: white,
        }),
      );
    /* harmony default export */ const content_FileXdw32 = FileXdw32; // CONCATENATED MODULE: ./src/icon/content/FileZip32.tsx
    function FileZip32_extends() {
      return (
        (FileZip32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FileZip32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FileZip32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FileZip32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlGray20,
            d: 'M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlGray80,
            d: 'M10 24h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1V8zm1 15h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1v-1zm0-2h1v1h-1V9z',
          }),
        ),
      );
    /* harmony default export */ const content_FileZip32 = FileZip32; // CONCATENATED MODULE: ./src/icons/file-icon/FileIcon.tsx
    const Components = {
      IconFileAudio: content_FileAudio32,
      IconFileBoxCanvas: content_FileCanvas32,
      IconFileBoxNote: content_FileBoxNote32,
      IconFileCode: content_FileCode32,
      IconFileDefault: content_FileDefault32,
      IconFileDocument: content_FileText32,
      IconFileDwg: content_FileDwg32,
      IconFileExcelSpreadsheet: content_FileExcel32,
      IconFileGoogleDocs: content_FileDocs32,
      IconFileGoogleSheets: content_FileSheets32,
      IconFileGoogleSlides: content_FileSlides32,
      IconFileIllustrator: content_FileIllustrator32,
      IconFileImage: content_FileImage32,
      IconFileIndesign: content_FileIndesign32,
      IconFileKeynote: content_FileKeynote32,
      IconFileNumbers: content_FileNumbers32,
      IconFilePages: content_FilePages32,
      IconFilePDF: content_FilePdf32,
      IconFilePhotoshop: content_FilePhotoshop32,
      IconFilePowerpointPresentation: content_FilePowerpoint32,
      IconFilePresentation: content_FilePresentation32,
      IconFileSpreadsheet: content_FileSpreadsheet32,
      IconFileText: content_FileText32,
      IconFileThreeD: content_FileThreeD32,
      IconFileVector: content_FileVector32,
      IconFileVideo: content_FileVideo32,
      IconFileWordDocument: content_FileWord32,
      IconFileXbd: content_FileXbd32,
      IconFileXdw: content_FileXdw32,
      IconFileZip: content_FileZip32,
    };
    const mirror = values =>
      values.reduce((prev, cur) => {
        prev[cur] = cur;
        return prev;
      }, {});
    const EXTENSIONS = {
      IconFileAudio: mirror([
        'aac',
        'aif',
        'aifc',
        'aiff',
        'amr',
        'au',
        'flac',
        'm3u',
        'm4a',
        'mid',
        'mp3',
        'ra',
        'wav',
        'wma',
        'wpl',
      ]),
      IconFileBoxCanvas: mirror(['boxcanvas']),
      IconFileBoxNote: mirror(['boxnote']),
      IconFileCode: mirror([
        'as',
        'as3',
        'asm',
        'aspx',
        'c',
        'cpp',
        'bat',
        'c',
        'cc',
        'cmake',
        'cs',
        'css',
        'cxx',
        'db',
        'diff',
        'erb',
        'groovy',
        'h',
        'haml',
        'hh',
        'htm',
        'html',
        'java',
        'js',
        'less',
        'm',
        'make',
        'md',
        'ml',
        'mm',
        'php',
        'pl',
        'plist',
        'properties',
        'py',
        'rb',
        'sass',
        'scala',
        'script',
        'scm',
        'sml',
        'sql',
        'sh',
        'wabba',
        'yaml',
      ]),
      IconFileDocument: mirror(['dot', 'dotx', 'msg', 'odt', 'rtf', 'wpd', 'xhtml', 'xml', 'xsd', 'xsl']),
      IconFileDwg: mirror(['dwg', 'dwgzip']),
      IconFileExcelSpreadsheet: mirror(['xls', 'xlsx', 'xlsm', 'xlsb']),
      IconFileGoogleDocs: mirror(['gdoc']),
      IconFileGoogleSheets: mirror(['gsheet']),
      IconFileGoogleSlides: mirror(['gslide', 'gslides']),
      IconFileVector: mirror(['eps']),
      IconFileIllustrator: mirror(['ai']),
      IconFileIndesign: mirror(['idml', 'indd', 'indt', 'inx']),
      IconFileKeynote: mirror(['key']),
      IconFileNumbers: mirror(['numbers']),
      IconFilePages: mirror(['pages']),
      IconFileImage: mirror([
        'bmp',
        'gif',
        'gdraw',
        'jpeg',
        'jpg',
        'png',
        'ps',
        'svs',
        'svg',
        'tif',
        'tiff',
        'heic',
        'heif',
      ]),
      IconFilePDF: mirror(['pdf']),
      IconFilePresentation: mirror(['odp', 'otp', 'pot', 'potx']),
      IconFilePowerpointPresentation: mirror(['ppt', 'pptx', 'pptm']),
      IconFilePhotoshop: mirror(['psd']),
      IconFileSpreadsheet: mirror(['csv', 'ods', 'tsv', 'xlt', 'xltx']),
      IconFileText: mirror(['txt', 'vi', 'vim', 'webdoc']),
      IconFileThreeD: mirror(['3ds', 'dae', 'fbx', 'obj', 'ply', 'stl']),
      IconFileVideo: mirror([
        '3g2',
        '3gp',
        'avi',
        'flv',
        'm2v',
        'm2ts',
        'm4v',
        'mkv',
        'mov',
        'mp4',
        'mpeg',
        'mpg',
        'ogg',
        'mts',
        'qt',
        'wmv',
      ]),
      IconFileWordDocument: mirror(['docx', 'doc', 'docm']),
      IconFileXbd: mirror(['xbd']),
      IconFileXdw: mirror(['xdw']),
      IconFileZip: mirror(['rar', 'tgz', 'zip']),
    };
    const getFileIconComponent = (extension = '') => {
      const extensionComponentName = Object.keys(EXTENSIONS).filter(
        extensionComponent => !!EXTENSIONS[extensionComponent][extension.toLowerCase()],
      )[0];
      return extensionComponentName || 'IconFileDefault';
    };
    const FileIcon = ({ dimension = 32, extension = '', title }) => {
      const IconComponent = Components[getFileIconComponent(extension)];
      return /*#__PURE__*/ react.createElement(IconComponent, {
        height: dimension,
        title: title,
        width: dimension,
      });
    };
    /* harmony default export */ const file_icon_FileIcon = FileIcon; // CONCATENATED MODULE: ./src/icons/general/IconAlertDefault.tsx
    const IconAlertDefault = ({ className = '', color = '#F7931D', height = 26, title, width = 26 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-alert-default ${className}`,
          title: title,
          height: height,
          width: width,
          viewBox: '0 0 26 26',
        },
        /*#__PURE__*/ react.createElement(
          'defs',
          null,
          /*#__PURE__*/ react.createElement('circle', {
            id: 'b',
            cx: '8',
            cy: '8',
            r: '8',
          }),
          /*#__PURE__*/ react.createElement(
            'filter',
            {
              x: '-46.9%',
              y: '-46.9%',
              width: '193.8%',
              height: '193.8%',
              filterUnits: 'objectBoundingBox',
              id: 'a',
            },
            /*#__PURE__*/ react.createElement('feMorphology', {
              radius: '.5',
              operator: 'dilate',
              in: 'SourceAlpha',
              result: 'shadowSpreadOuter1',
            }),
            /*#__PURE__*/ react.createElement('feOffset', {
              in: 'shadowSpreadOuter1',
              result: 'shadowOffsetOuter1',
            }),
            /*#__PURE__*/ react.createElement('feGaussianBlur', {
              stdDeviation: '2',
              in: 'shadowOffsetOuter1',
              result: 'shadowBlurOuter1',
            }),
            /*#__PURE__*/ react.createElement('feColorMatrix', {
              values: '0 0 0 0 0.733285502 0 0 0 0 0.733285502 0 0 0 0 0.733285502 0 0 0 0.5 0',
              in: 'shadowBlurOuter1',
            }),
          ),
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            transform: 'translate(5 5)',
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('use', {
            fill: '#000',
            filter: 'url(#a)',
            xlinkHref: '#b',
          }),
          /*#__PURE__*/ react.createElement('use', {
            fill: color,
            xlinkHref: '#b',
          }),
          /*#__PURE__*/ react.createElement('path', {
            d: 'M8.047 4.706v4.111',
            stroke: '#FFF',
            strokeWidth: '1.412',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }),
          /*#__PURE__*/ react.createElement('circle', {
            fill: '#FFF',
            cx: '8.047',
            cy: '11.294',
            r: '1',
          }),
        ),
      );
    /* harmony default export */ const general_IconAlertDefault = IconAlertDefault; // CONCATENATED MODULE: ./src/icons/folder/IconFolderPersonal.tsx
    const IconFolderPersonal = ({ className = '', height = 32, title, width = 32 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-folder-personal ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 32 32',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          d: 'M27,25H5c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h8.6L16,9h11c0.6,0,1,0.4,1,1v14C28,24.6,27.6,25,27,25z',
          fill: '#EFD289',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M26.5,24h-21C5.2,24,5,23.8,5,23.5V12h22v11.6C27,23.8,26.8,24,26.5,24z',
          fill: '#FDEFC1',
        }),
      );
    /* harmony default export */ const folder_IconFolderPersonal = IconFolderPersonal; // CONCATENATED MODULE: ./src/elements/content-uploader/ItemName.js
    /**
     *
     * @file Item name component
     */

    const ItemName = ({ name }) =>
      /*#__PURE__*/ react.createElement(
        'span',
        {
          className: 'bcu-item-label',
        },
        name,
      );
    /* harmony default export */ const content_uploader_ItemName = ItemName; // CONCATENATED MODULE: ./src/elements/content-uploader/IconName.js
    /**
     *
     * @file Component for file icon and name
     */

    const IconName = ({ name, extension, isFolder = false, isResumableUploadsEnabled, status }) => {
      let icon = isFolder
        ? /*#__PURE__*/ react.createElement(folder_IconFolderPersonal, null)
        : /*#__PURE__*/ react.createElement(file_icon_FileIcon, {
            extension: extension,
          });
      if (isResumableUploadsEnabled && status === STATUS_ERROR) {
        icon = /*#__PURE__*/ react.createElement(
          badgeable_Badgeable,
          {
            className: 'bcu-icon-badge',
            bottomRight: /*#__PURE__*/ react.createElement(general_IconAlertDefault, {
              height: 18,
              width: 18,
            }),
          },
          icon,
        );
      }
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-item-icon-name',
        },
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-item-icon',
          },
          icon,
        ),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-item-name',
          },
          /*#__PURE__*/ react.createElement(content_uploader_ItemName, {
            name: name,
          }),
        ),
      );
    };
    /* harmony default export */ const content_uploader_IconName = IconName; // CONCATENATED MODULE: ./src/elements/content-uploader/nameCellRenderer.js
    function nameCellRenderer_extends() {
      return (
        (nameCellRenderer_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        nameCellRenderer_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Function to render the name table cell
     */

    /* harmony default export */ const nameCellRenderer =
      isResumableUploadsEnabled =>
      ({ rowData }) =>
        /*#__PURE__*/ react.createElement(
          content_uploader_IconName,
          nameCellRenderer_extends(
            {
              isResumableUploadsEnabled: isResumableUploadsEnabled,
            },
            rowData,
          ),
        ); // CONCATENATED MODULE: ./src/elements/content-uploader/ProgressBar.js
    function ProgressBar_defineProperty(e, r, t) {
      return (
        (r = ProgressBar_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ProgressBar_toPropertyKey(t) {
      var i = ProgressBar_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ProgressBar_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Component for a progress bar
     */

    class ProgressBar extends react.PureComponent {
      static getDerivedStateFromProps({ percent }, state) {
        if (percent !== state.percent) {
          return {
            percent,
          };
        }
        return null;
      }

      /**
       * [constructor]
       *
       * @return {ProgressBar}
       */
      constructor(props) {
        super(props);
        const { percent } = props;
        this.state = {
          percent,
        };
      }

      /**
       * Renders the progress bar
       *
       * @return {void}
       */
      render() {
        const { percent } = this.state;
        const containerStyle = {
          transitionDelay: percent > 0 && percent < 100 ? '0' : '0.4s',
        };
        return /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-progress-container',
            style: containerStyle,
          },
          /*#__PURE__*/ react.createElement('div', {
            className: 'bcu-progress',
            style: {
              width: `${percent}%`,
            },
          }),
        );
      }
    }
    ProgressBar_defineProperty(ProgressBar, 'defaultProps', {
      percent: 0,
    });
    /* harmony default export */ const content_uploader_ProgressBar = ProgressBar; // CONCATENATED MODULE: ./src/elements/content-uploader/ItemProgress.js
    /**
     *
     * @file Upload item progress component
     */

    const ItemProgress = ({ progress }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-item-progress',
        },
        /*#__PURE__*/ react.createElement(content_uploader_ProgressBar, {
          percent: progress,
        }),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-progress-label',
          },
          progress,
          '%',
        ),
      );
    /* harmony default export */ const content_uploader_ItemProgress = ItemProgress; // CONCATENATED MODULE: ./src/elements/content-uploader/progressCellRenderer.js
    function progressCellRenderer_extends() {
      return (
        (progressCellRenderer_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        progressCellRenderer_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Function to render the progress table cell
     */

    /**
     * Get error message for a specific error code
     *
     * @param {string} [errorCode]
     * @param {string} [itemName]
     * @returns {FormattedMessage}
     */
    const getErrorMessage = (errorCode, itemName, shouldShowUpgradeCTAMessage) => {
      switch (errorCode) {
        case ERROR_CODE_UPLOAD_CHILD_FOLDER_FAILED:
          return /*#__PURE__*/ react.createElement(
            components_message,
            common_messages.uploadsOneOrMoreChildFoldersFailedToUploadMessage,
          );
        case ERROR_CODE_UPLOAD_FILE_SIZE_LIMIT_EXCEEDED:
          if (shouldShowUpgradeCTAMessage) {
            return /*#__PURE__*/ react.createElement(
              components_message,
              common_messages.uploadsFileSizeLimitExceededErrorMessageForUpgradeCta,
            );
          }
          return /*#__PURE__*/ react.createElement(
            components_message,
            common_messages.uploadsFileSizeLimitExceededErrorMessage,
          );
        case ERROR_CODE_ITEM_NAME_IN_USE:
          return /*#__PURE__*/ react.createElement(
            components_message,
            common_messages.uploadsItemNameInUseErrorMessage,
          );
        case ERROR_CODE_ITEM_NAME_INVALID:
          return /*#__PURE__*/ react.createElement(
            components_message,
            progressCellRenderer_extends({}, common_messages.uploadsProvidedFolderNameInvalidMessage, {
              values: {
                name: itemName,
              },
            }),
          );
        case ERROR_CODE_UPLOAD_STORAGE_LIMIT_EXCEEDED:
          return /*#__PURE__*/ react.createElement(components_message, common_messages.uploadsStorageLimitErrorMessage);
        case ERROR_CODE_UPLOAD_PENDING_APP_FOLDER_SIZE_LIMIT:
          return /*#__PURE__*/ react.createElement(
            components_message,
            common_messages.uploadsPendingFolderSizeLimitErrorMessage,
          );
        case ERROR_CODE_UPLOAD_FAILED_PACKAGE:
          return /*#__PURE__*/ react.createElement(
            components_message,
            common_messages.uploadsPackageUploadErrorMessage,
          );
        default:
          return /*#__PURE__*/ react.createElement(components_message, common_messages.uploadsDefaultErrorMessage);
      }
    };
    /* harmony default export */ const progressCellRenderer =
      shouldShowUpgradeCTAMessage =>
      ({ rowData }) => {
        const { status, error = {}, name, isFolder, file } = rowData;
        const { code } = error;
        if (isFolder && status !== STATUS_ERROR) {
          return null;
        }
        switch (status) {
          case STATUS_IN_PROGRESS:
          case STATUS_STAGED:
            return /*#__PURE__*/ react.createElement(content_uploader_ItemProgress, rowData);
          case STATUS_ERROR:
            if (utils_Browser.isSafari() && code === ERROR_CODE_UPLOAD_BAD_DIGEST && file.name.indexOf('.zip') !== -1) {
              return getErrorMessage(ERROR_CODE_UPLOAD_FAILED_PACKAGE, file.name);
            }
            return getErrorMessage(code, name, shouldShowUpgradeCTAMessage);
          default:
            return null;
        }
      }; // CONCATENATED MODULE: ./src/icons/general/IconCheck.tsx
    const IconCheck = ({ className = '', color = '#000000', height = 24, title, width = 24 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-check ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 24 24',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          d: 'M0 0h24v24H0z',
          fill: 'none',
        }),
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
          fill: color,
        }),
      );
    /* harmony default export */ const general_IconCheck = IconCheck; // CONCATENATED MODULE: ./src/icons/general/IconClose.tsx
    const IconClose = ({ className = '', color = '#000000', height = 24, title, width = 24 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-close ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 24 24',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
          fill: color,
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M0 0h24v24H0z',
          fill: 'none',
        }),
      );
    /* harmony default export */ const general_IconClose = IconClose; // CONCATENATED MODULE: ./src/elements/content-uploader/IconInProgress.js
    /**
     *
     * @file Icon
     * @author Box
     */

    const IconInProgress = () =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-icon-in-progress',
        },
        /*#__PURE__*/ react.createElement(general_IconClose, null),
        /*#__PURE__*/ react.createElement(loading_indicator_LoadingIndicator, null),
      );
    /* harmony default export */ const content_uploader_IconInProgress = IconInProgress; // CONCATENATED MODULE: ./src/icons/general/IconRetry.tsx
    const IconRetry = ({ className = '', color = bdlGray, height = 32, title, width = 32 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `bdl-IconRetry ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 32 32',
          width: width,
        },
        /*#__PURE__*/ react.createElement(
          'g',
          {
            className: 'fill-color',
            fill: color,
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            d: 'M25.023 16c0-6.075-4.925-11-11-11s-11 4.925-11 11 4.925 11 11 11c2.601 0 5.06-.904 7.02-2.53a1 1 0 1 1 1.278 1.538A12.949 12.949 0 0 1 14.023 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13a1 1 0 0 1-2 0z',
            fillRule: 'nonzero',
          }),
          /*#__PURE__*/ react.createElement('path', {
            d: 'M20 14l6 6 6-6z',
          }),
        ),
      );
    /* harmony default export */ const general_IconRetry = IconRetry; // CONCATENATED MODULE: ./src/components/primary-button/PrimaryButton.tsx
    const PrimaryButton_excluded = ['children', 'className'];
    function PrimaryButton_extends() {
      return (
        (PrimaryButton_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        PrimaryButton_extends.apply(null, arguments)
      );
    }
    function PrimaryButton_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = PrimaryButton_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function PrimaryButton_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const PrimaryButton = _ref => {
      let { children, className = '' } = _ref,
        rest = PrimaryButton_objectWithoutProperties(_ref, PrimaryButton_excluded);
      return /*#__PURE__*/ react.createElement(
        button_Button,
        PrimaryButton_extends(
          {
            className: `btn-primary ${className}`,
          },
          rest,
        ),
        children,
      );
    };
    /* harmony default export */ const primary_button_PrimaryButton = PrimaryButton; // CONCATENATED MODULE: ./src/components/tooltip/index.ts
    // CONCATENATED MODULE: ./src/elements/content-uploader/ItemAction.js
    // Need to import and re-export the type to be shared in another component.
    // https://github.com/babel/babel-loader/issues/603#issuecomment-418472968

    /**
     *
     * @file Item action component displayed on the upload toast, e.g. cancel/resume
     */

    const ICON_CHECK_COLOR = '#26C281';
    const ItemAction = ({
      error = {},
      intl,
      isFolder = false,
      isResumableUploadsEnabled,
      onClick,
      onUpgradeCTAClick,
      status,
    }) => {
      let icon = /*#__PURE__*/ react.createElement(general_IconClose, null);
      let tooltip;
      const { code } = error;
      const { formatMessage } = intl;
      if (isFolder && status !== STATUS_PENDING) {
        return null;
      }
      switch (status) {
        case STATUS_COMPLETE:
          icon = /*#__PURE__*/ react.createElement(general_IconCheck, {
            color: ICON_CHECK_COLOR,
          });
          if (!isResumableUploadsEnabled) {
            tooltip = common_messages.remove;
          }
          break;
        case STATUS_ERROR:
          icon = /*#__PURE__*/ react.createElement(general_IconRetry, {
            height: 24,
            width: 24,
          });
          tooltip = isResumableUploadsEnabled ? common_messages.resume : common_messages.retry;
          break;
        case STATUS_IN_PROGRESS:
        case STATUS_STAGED:
          if (isResumableUploadsEnabled) {
            icon = /*#__PURE__*/ react.createElement(loading_indicator_LoadingIndicator, null);
          } else {
            icon = /*#__PURE__*/ react.createElement(content_uploader_IconInProgress, null);
            tooltip = common_messages.uploadsCancelButtonTooltip;
          }
          break;
        case STATUS_PENDING:
        default:
          if (isResumableUploadsEnabled) {
            icon = /*#__PURE__*/ react.createElement(loading_indicator_LoadingIndicator, null);
          } else {
            tooltip = common_messages.uploadsCancelButtonTooltip;
          }
          break;
      }
      if (status === STATUS_ERROR && code === ERROR_CODE_UPLOAD_FILE_SIZE_LIMIT_EXCEEDED && !!onUpgradeCTAClick) {
        return /*#__PURE__*/ react.createElement(
          primary_button_PrimaryButton,
          {
            onClick: onUpgradeCTAClick,
            type: 'button',
          },
          /*#__PURE__*/ react.createElement(
            components_message,
            common_messages.uploadsFileSizeLimitExceededUpgradeMessageForUpgradeCta,
          ),
        );
      }
      const isDisabled = status === STATUS_STAGED;
      const tooltipText = tooltip && formatMessage(tooltip);
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-item-action',
        },
        tooltip
          ? /*#__PURE__*/ react.createElement(
              tooltip_Tooltip,
              {
                position: 'top-left',
                text: tooltipText,
              },
              /*#__PURE__*/ react.createElement(
                plain_button_PlainButton,
                {
                  'aria-label': tooltipText,
                  isDisabled: isDisabled,
                  onClick: onClick,
                  type: 'button',
                },
                icon,
              ),
            )
          : icon,
      );
    };

    /* harmony default export */ const content_uploader_ItemAction = injectIntl(ItemAction); // CONCATENATED MODULE: ./src/elements/content-uploader/actionCellRenderer.js
    function actionCellRenderer_extends() {
      return (
        (actionCellRenderer_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        actionCellRenderer_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Function to render the action table cell
     */

    /* harmony default export */ const actionCellRenderer =
      (isResumableUploadsEnabled, onClick, onUpgradeCTAClick) =>
      ({ rowData }) =>
        /*#__PURE__*/ react.createElement(
          content_uploader_ItemAction,
          actionCellRenderer_extends({}, rowData, {
            isResumableUploadsEnabled: isResumableUploadsEnabled,
            onClick: () => onClick(rowData),
            onUpgradeCTAClick: onUpgradeCTAClick,
          }),
        ); // CONCATENATED MODULE: ./src/elements/content-uploader/ItemRemove.js
    function ItemRemove_extends() {
      return (
        (ItemRemove_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        ItemRemove_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Item remove component
     */

    const ItemRemove = ({ intl, onClick, status }) => {
      const resin = {};
      let target = null;
      if (status === STATUS_IN_PROGRESS) {
        target = 'uploadcancel';
      } else if (status === STATUS_ERROR) {
        target = 'remove-failed';
      }
      if (target) {
        resin['data-resin-target'] = target;
      }
      const isDisabled = status === STATUS_STAGED;
      const tooltipText = intl.formatMessage(common_messages.remove);
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-item-action',
        },
        /*#__PURE__*/ react.createElement(
          tooltip_Tooltip,
          {
            position: 'top-left',
            text: tooltipText,
          },
          /*#__PURE__*/ react.createElement(
            plain_button_PlainButton,
            ItemRemove_extends(
              {
                'aria-label': tooltipText,
                isDisabled: isDisabled,
                onClick: onClick,
                type: 'button',
              },
              resin,
            ),
            /*#__PURE__*/ react.createElement(general_IconClose, null),
          ),
        ),
      );
    };

    /* harmony default export */ const content_uploader_ItemRemove = injectIntl(ItemRemove); // CONCATENATED MODULE: ./src/elements/content-uploader/removeCellRenderer.js
    /**
     *
     * @file Function to render the remove table cell
     */

    /* harmony default export */ const removeCellRenderer =
      onClick =>
      ({ rowData }) => {
        if (rowData.isFolder) {
          return null;
        }
        return /*#__PURE__*/ react.createElement(content_uploader_ItemRemove, {
          status: rowData.status,
          onClick: () => onClick(rowData),
        });
      }; // CONCATENATED MODULE: ./src/elements/content-uploader/ItemList.js
    /**
     *
     * @file Item list component
     */

    const ItemList = ({
      isResumableUploadsEnabled = false,
      items,
      onClick,
      onRemoveClick = noop_default(),
      onUpgradeCTAClick,
    }) =>
      /*#__PURE__*/ react.createElement(AutoSizer, null, ({ width, height }) => {
        const nameCell = nameCellRenderer(isResumableUploadsEnabled);
        const progressCell = progressCellRenderer(!!onUpgradeCTAClick);
        const actionCell = actionCellRenderer(isResumableUploadsEnabled, onClick, onUpgradeCTAClick);
        const removeCell = removeCellRenderer(onRemoveClick);
        return /*#__PURE__*/ react.createElement(
          Table_Table,
          {
            className: 'bcu-item-list',
            disableHeader: true,
            headerHeight: 0,
            height: height,
            rowClassName: 'bcu-item-row',
            rowCount: items.length,
            rowGetter: ({ index }) => items[index],
            rowHeight: 50,
            width: width,
          },
          /*#__PURE__*/ react.createElement(Column, {
            cellRenderer: nameCell,
            dataKey: 'name',
            flexGrow: 1,
            flexShrink: 1,
            width: 300,
          }),
          /*#__PURE__*/ react.createElement(Column, {
            cellRenderer: progressCell,
            dataKey: 'progress',
            flexGrow: 1,
            flexShrink: 1,
            style: {
              textAlign: 'right',
            },
            width: 300,
          }),
          /*#__PURE__*/ react.createElement(Column, {
            className: isResumableUploadsEnabled ? '' : 'bcu-item-list-action-column',
            cellRenderer: actionCell,
            dataKey: 'status',
            flexShrink: 0,
            width: onUpgradeCTAClick ? 100 : 25,
          }),
          isResumableUploadsEnabled &&
            /*#__PURE__*/ react.createElement(Column, {
              className: 'bcu-item-list-action-column',
              cellRenderer: removeCell,
              dataKey: 'remove',
              flexShrink: 0,
              width: 25,
            }),
        );
      });
    /* harmony default export */ const content_uploader_ItemList = ItemList; // CONCATENATED MODULE: ./src/icons/states/ErrorEmptyState.tsx
    const ErrorEmptyState = ({ className = '', color = bdlBoxBlue, height = 126, title, width = 130 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `error-empty-state ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 150 150',
          width: width,
        },
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
            stroke: 'none',
            strokeWidth: '1',
          },
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M75.5,6.1337822 L75.5,5.49178758 C75.5,5.2201808 75.7319336,5 76,5 C76.2761424,5 76.5,5.21505737 76.5,5.49047852 L76.5,6.1337822 C76.651814,6.22160185 76.7783981,6.348186 76.8662178,6.5 L77.5095215,6.5 C77.7804053,6.5 78,6.73193359 78,7 C78,7.27614237 77.7849426,7.5 77.5095215,7.5 L76.8662178,7.5 C76.7783981,7.651814 76.651814,7.77839815 76.5,7.8662178 L76.5,8.50952148 C76.5,8.78040529 76.2680664,9 76,9 C75.7238576,9 75.5,8.76897915 75.5,8.49525623 L75.5,7.8662178 C75.348186,7.77839815 75.2216019,7.651814 75.1337822,7.5 L74.4904785,7.5 C74.2195947,7.5 74,7.26806641 74,7 C74,6.72385763 74.2150574,6.5 74.4904785,6.5 L75.1337822,6.5 C75.2216019,6.348186 75.348186,6.22160185 75.5,6.1337822 Z M16,73.6337822 L16,72.9917876 C16,72.7201808 16.2319336,72.5 16.5,72.5 C16.7761424,72.5 17,72.7150574 17,72.9904785 L17,73.6337822 C17.151814,73.7216019 17.2783981,73.848186 17.3662178,74 L18.0095215,74 C18.2804053,74 18.5,74.2319336 18.5,74.5 C18.5,74.7761424 18.2849426,75 18.0095215,75 L17.3662178,75 C17.2783981,75.151814 17.151814,75.2783981 17,75.3662178 L17,76.0095215 C17,76.2804053 16.7680664,76.5 16.5,76.5 C16.2238576,76.5 16,76.2689791 16,75.9952562 L16,75.3662178 C15.848186,75.2783981 15.7216019,75.151814 15.6337822,75 L14.9904785,75 C14.7195947,75 14.5,74.7680664 14.5,74.5 C14.5,74.2238576 14.7150574,74 14.9904785,74 L15.6337822,74 C15.7216019,73.848186 15.848186,73.7216019 16,73.6337822 Z M132.5,81.6337822 L132.5,80.9917876 C132.5,80.7201808 132.731934,80.5 133,80.5 C133.276142,80.5 133.5,80.7150574 133.5,80.9904785 L133.5,81.6337822 C133.651814,81.7216019 133.778398,81.848186 133.866218,82 L134.509521,82 C134.780405,82 135,82.2319336 135,82.5 C135,82.7761424 134.784943,83 134.509521,83 L133.866218,83 C133.778398,83.151814 133.651814,83.2783981 133.5,83.3662178 L133.5,84.0095215 C133.5,84.2804053 133.268066,84.5 133,84.5 C132.723858,84.5 132.5,84.2689791 132.5,83.9952562 L132.5,83.3662178 C132.348186,83.2783981 132.221602,83.151814 132.133782,83 L131.490479,83 C131.219595,83 131,82.7680664 131,82.5 C131,82.2238576 131.215057,82 131.490479,82 L132.133782,82 C132.221602,81.848186 132.348186,81.7216019 132.5,81.6337822 Z M47,23.1337822 L47,22.4917876 C47,22.2201808 47.2319336,22 47.5,22 C47.7761424,22 48,22.2150574 48,22.4904785 L48,23.1337822 C48.151814,23.2216019 48.2783981,23.348186 48.3662178,23.5 L49.0095215,23.5 C49.2804053,23.5 49.5,23.7319336 49.5,24 C49.5,24.2761424 49.2849426,24.5 49.0095215,24.5 L48.3662178,24.5 C48.2783981,24.651814 48.151814,24.7783981 48,24.8662178 L48,25.5095215 C48,25.7804053 47.7680664,26 47.5,26 C47.2238576,26 47,25.7689791 47,25.4952562 L47,24.8662178 C46.848186,24.7783981 46.7216019,24.651814 46.6337822,24.5 L45.9904785,24.5 C45.7195947,24.5 45.5,24.2680664 45.5,24 C45.5,23.7238576 45.7150574,23.5 45.9904785,23.5 L46.6337822,23.5 C46.7216019,23.348186 46.848186,23.2216019 47,23.1337822 Z M107,24.6337822 L107,23.9917876 C107,23.7201808 107.231934,23.5 107.5,23.5 C107.776142,23.5 108,23.7150574 108,23.9904785 L108,24.6337822 C108.151814,24.7216019 108.278398,24.848186 108.366218,25 L109.009521,25 C109.280405,25 109.5,25.2319336 109.5,25.5 C109.5,25.7761424 109.284943,26 109.009521,26 L108.366218,26 C108.278398,26.151814 108.151814,26.2783981 108,26.3662178 L108,27.0095215 C108,27.2804053 107.768066,27.5 107.5,27.5 C107.223858,27.5 107,27.2689791 107,26.9952562 L107,26.3662178 C106.848186,26.2783981 106.721602,26.151814 106.633782,26 L105.990479,26 C105.719595,26 105.5,25.7680664 105.5,25.5 C105.5,25.2238576 105.715057,25 105.990479,25 L106.633782,25 C106.721602,24.848186 106.848186,24.7216019 107,24.6337822 Z M142.5,44.6337822 L142.5,43.9917876 C142.5,43.7201808 142.731934,43.5 143,43.5 C143.276142,43.5 143.5,43.7150574 143.5,43.9904785 L143.5,44.6337822 C143.651814,44.7216019 143.778398,44.848186 143.866218,45 L144.509521,45 C144.780405,45 145,45.2319336 145,45.5 C145,45.7761424 144.784943,46 144.509521,46 L143.866218,46 C143.778398,46.151814 143.651814,46.2783981 143.5,46.3662178 L143.5,47.0095215 C143.5,47.2804053 143.268066,47.5 143,47.5 C142.723858,47.5 142.5,47.2689791 142.5,46.9952562 L142.5,46.3662178 C142.348186,46.2783981 142.221602,46.151814 142.133782,46 L141.490479,46 C141.219595,46 141,45.7680664 141,45.5 C141,45.2238576 141.215057,45 141.490479,45 L142.133782,45 C142.221602,44.848186 142.348186,44.7216019 142.5,44.6337822 Z M26.4375,26.7086139 L26.4375,26.3073672 C26.4375,26.137613 26.5824585,26 26.75,26 C26.922589,26 27.0625,26.1344109 27.0625,26.3065491 L27.0625,26.7086139 C27.1573838,26.7635012 27.2364988,26.8426162 27.2913861,26.9375 L27.6934509,26.9375 C27.8627533,26.9375 28,27.0824585 28,27.25 C28,27.422589 27.8655891,27.5625 27.6934509,27.5625 L27.2913861,27.5625 C27.2364988,27.6573838 27.1573838,27.7364988 27.0625,27.7913861 L27.0625,28.1934509 C27.0625,28.3627533 26.9175415,28.5 26.75,28.5 C26.577411,28.5 26.4375,28.355612 26.4375,28.1974433 L26.4375,27.7913861 C26.3426162,27.7364988 26.2635012,27.6573838 26.2086139,27.5625 L25.8065491,27.5625 C25.6372467,27.5625 25.5,27.4175415 25.5,27.25 C25.5,27.077411 25.6344109,26.9375 25.8065491,26.9375 L26.2086139,26.9375 C26.2635012,26.8426162 26.3426162,26.7635012 26.4375,26.7086139 Z M5.9375,66.7086139 L5.9375,66.3073672 C5.9375,66.137613 6.0824585,66 6.25,66 C6.42258898,66 6.5625,66.1344109 6.5625,66.3065491 L6.5625,66.7086139 C6.65738375,66.7635012 6.73649884,66.8426162 6.79138613,66.9375 L7.19345093,66.9375 C7.36275331,66.9375 7.5,67.0824585 7.5,67.25 C7.5,67.422589 7.36558914,67.5625 7.19345093,67.5625 L6.79138613,67.5625 C6.73649884,67.6573838 6.65738375,67.7364988 6.5625,67.7913861 L6.5625,68.1934509 C6.5625,68.3627533 6.4175415,68.5 6.25,68.5 C6.07741102,68.5 5.9375,68.355612 5.9375,68.1974433 L5.9375,67.7913861 C5.84261625,67.7364988 5.76350116,67.6573838 5.70861387,67.5625 L5.30654907,67.5625 C5.13724669,67.5625 5,67.4175415 5,67.25 C5,67.077411 5.13441086,66.9375 5.30654907,66.9375 L5.70861387,66.9375 C5.76350116,66.8426162 5.84261625,66.7635012 5.9375,66.7086139 Z M128.4375,35.2086139 L128.4375,34.8073672 C128.4375,34.637613 128.582458,34.5 128.75,34.5 C128.922589,34.5 129.0625,34.6344109 129.0625,34.8065491 L129.0625,35.2086139 C129.157384,35.2635012 129.236499,35.3426162 129.291386,35.4375 L129.693451,35.4375 C129.862753,35.4375 130,35.5824585 130,35.75 C130,35.922589 129.865589,36.0625 129.693451,36.0625 L129.291386,36.0625 C129.236499,36.1573838 129.157384,36.2364988 129.0625,36.2913861 L129.0625,36.6934509 C129.0625,36.8627533 128.917542,37 128.75,37 C128.577411,37 128.4375,36.855612 128.4375,36.6974433 L128.4375,36.2913861 C128.342616,36.2364988 128.263501,36.1573838 128.208614,36.0625 L127.806549,36.0625 C127.637247,36.0625 127.5,35.9175415 127.5,35.75 C127.5,35.577411 127.634411,35.4375 127.806549,35.4375 L128.208614,35.4375 C128.263501,35.3426162 128.342616,35.2635012 128.4375,35.2086139 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M22.7914692,53.0566298 C22.7914692,44.2833882 29.9045187,37.1712707 38.67891,37.1712707 C45.7737865,37.1712707 51.7824509,41.8212886 53.8227562,48.239555 C55.2405695,47.3058073 56.9383368,46.7624309 58.7630332,46.7624309 C60.5666328,46.7624309 62.2462216,47.2933152 63.654021,48.2073246 L63.654021,48.2073246 C64.4190329,41.9873442 69.7216602,37.1712707 76.1492891,37.1712707 C83.1025803,37.1712707 88.7393365,42.8072884 88.7393365,49.7596685',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
            transform: 'translate(55.765403, 45.113950) rotate(-16.000000) translate(-55.765403, -45.113950) ',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M83.943128,54.2555249 C83.943128,45.4822833 91.0561775,38.3701657 99.8305687,38.3701657 C108.60496,38.3701657 115.718009,45.4822833 115.718009,54.2555249 C115.718009,54.3264389 115.717545,54.3972444 115.716618,54.4679385 C116.654607,54.136276 117.664045,53.9558011 118.71564,53.9558011 C123.682276,53.9558011 127.708531,57.981528 127.708531,62.9475138',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
            transform: 'translate(105.825829, 52.277119) rotate(12.000000) translate(-105.825829, -52.277119) ',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M50.9395397,69.2196888 C50.9559175,68.4219236 51.610933,67.7752072 52.4046043,67.7752072 L97.4958697,67.7752072 C98.2886247,67.7752072 98.9444823,68.4183107 98.9609042,69.2182265 L99.4445195,92.7751921 L99.7620359,108.24146 C99.7783805,109.037607 99.1770355,109.912104 98.4076164,110.184881 C98.4076164,110.184881 87.4203791,114.5 74.950237,114.5 C62.4800948,114.5 51.4928575,110.184881 51.4928575,110.184881 C50.7283448,109.907706 50.1221794,109.033417 50.1385386,108.236558 L50.4774294,91.7291413 L50.9395397,69.2196888 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('ellipse', {
            className: 'fill-color fill-opacity',
            cx: '74.950237',
            cy: '78.3725829',
            fill: color,
            fillOpacity: '0.1',
            rx: '23.0218009',
            ry: '4.33529006',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M74.950237,79.8176796 C97.465656,79.8176796 115.718009,75.5044007 115.718009,70.1837017 C115.718009,64.8630026 97.465656,60.5497238 74.950237,60.5497238 C52.4348179,60.5497238 34.1824645,64.8630026 34.1824645,70.1837017 C34.1824645,75.5044007 52.4348179,79.8176796 74.950237,79.8176796 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('ellipse', {
            className: 'stroke-color fill-white',
            cx: '74.950237',
            cy: '68.4977555',
            fill: '#FFFFFF',
            rx: '24.4606635',
            ry: '4.09444061',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color fill-opacity',
            d: 'M75,145 C92.9492544,145 107.5,143.656854 107.5,142 C107.5,140.343146 92.9492544,139 75,139 C57.0507456,139 42.5,140.343146 42.5,142 C42.5,143.656854 57.0507456,145 75,145 Z M52.8509947,83.1913741 C52.8712542,82.3922739 53.1310662,82.3484877 53.4058629,83.0830098 C53.4058629,83.0830098 54.9449475,86.510498 55.7326913,92.6144423 C56.1527728,95.8695035 53.9282708,103.074457 55.7326913,105.159127 C57.3617489,107.041199 60.8117179,105.68032 64.1108787,107.455589 C67.4100395,109.230858 72.2793624,112.331621 70.2784638,112.127382 C61.553615,111.236802 53.5881693,108.414342 53.5881693,108.414342 C52.8342042,108.164383 52.2394252,107.313681 52.2596778,106.514853 L52.8509947,83.1913741 Z M74.950237,71.6141582 C83.2980852,71.6141582 97.0127962,70.1313923 97.0127962,68.8551108 C95.6484975,68.0340868 84.2687795,66.59622 74.9502365,66.59622 C65.6316935,66.59622 54.8064568,67.6979178 52.8876777,68.8551108 C52.8876777,70.1313923 66.6023888,71.6141582 74.950237,71.6141582 Z',
            fill: color,
            fillOpacity: '0.1',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M59.7884631,63.0000267 L152.135708,63.5798175 C153.123448,63.5860189 153.924171,64.4019833 153.924171,65.3977901 C153.924171,66.3956273 153.123712,67.2095597 152.135708,67.2157627 L59.7884631,67.7955534 C58.8007222,67.8017549 58,66.7255324 58,65.3977901 C58,64.0673406 58.8004581,62.9938237 59.7884631,63.0000267 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
            transform: 'translate(105.962085, 65.397790) rotate(70.000000) translate(-105.962085, -65.397790) ',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M96.0000002,31 L92.2294151,32.3351735',
            stroke: color,
            strokeLinecap: 'square',
            strokeWidth: '2',
          }),
        ),
      );
    /* harmony default export */ const states_ErrorEmptyState = ErrorEmptyState; // CONCATENATED MODULE: ./src/icons/states/UploadEmptyState.tsx
    const UploadEmptyState = ({ className = '', color = bdlBoxBlue, height = 55, title, width = 46 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `upload-empty-state ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 46 55',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          d: 'M1,52V3A2,2,0,0,1,3,1H30.91a2,2,0,0,1,1.41.59L44.41,13.68A2,2,0,0,1,45,15.09V52a2,2,0,0,1-2,2H3A2,2,0,0,1,1,52Z',
          fill: '#fff',
        }),
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M45.12,13,33,.88A3,3,0,0,0,30.91,0H3A3,3,0,0,0,0,3V52a3,3,0,0,0,3,3H43a3,3,0,0,0,3-3V15.09A3,3,0,0,0,45.12,13ZM43,53H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H30V13a3,3,0,0,0,3,3H44V52A1,1,0,0,1,43,53Z',
          fill: color,
        }),
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M21,29v4a1,1,0,0,0,.91,1h2.18A1,1,0,0,0,25,33V29h2.74a1,1,0,0,0,.76-1.65l-4.83-5.62a1,1,0,0,0-1.41-.11l-.11.11-4.82,5.62A1,1,0,0,0,18.09,29Z',
          fill: color,
        }),
        /*#__PURE__*/ react.createElement('polyline', {
          className: 'stroke-color',
          fill: 'none',
          points: '13 36 13 39 33 39 33 36',
          stroke: color,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2',
        }),
      );
    /* harmony default export */ const states_UploadEmptyState = UploadEmptyState; // CONCATENATED MODULE: ./src/icons/states/UploadSuccessState.tsx
    const UploadSuccessState = ({ className = '', color = bdlBoxBlue, height = 49, title, width = 50 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `upload-success-state ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 50 49',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M41.88,4.39l4,4.53L17,38.73,4.24,26,9,21.28l5.89,6.09L17,29.57l2.16-2.18,22.74-23M42,0,17,25.28,9,17,0,26,17,43,50,9,42,0Z',
          fill: color,
        }),
        /*#__PURE__*/ react.createElement('rect', {
          className: 'fill-color',
          fill: color,
          fillOpacity: '0.2',
          height: '3',
          rx: '1.5',
          ry: '1.5',
          width: '6',
          x: '4',
          y: '46',
        }),
        /*#__PURE__*/ react.createElement('rect', {
          className: 'fill-color',
          fill: color,
          fillOpacity: '0.2',
          height: '3',
          rx: '1.5',
          ry: '1.5',
          width: '6',
          x: '33',
          y: '46',
        }),
        /*#__PURE__*/ react.createElement('rect', {
          className: 'fill-color',
          fill: color,
          fillOpacity: '0.2',
          height: '3',
          rx: '1.5',
          ry: '1.5',
          width: '21',
          x: '11',
          y: '46',
        }),
      );
    /* harmony default export */ const states_UploadSuccessState = UploadSuccessState; // CONCATENATED MODULE: ./src/elements/content-uploader/UploadInput.js
    /**
     *
     * @file Input element for folder/file upload
     * @author Box
     */

    /* eslint-disable */

    const UploadInput = ({
      handleChange,
      inputLabel,
      inputLabelClass = '',
      isFolderUpload = false,
      isMultiple = true,
    }) => {
      const inputRef = react.useRef(null);
      const onKeyDown = e => {
        if (e.key === 'Enter' || e.key === ' ') {
          if (inputRef.current) {
            inputRef.current.click();
          }
        }
      };
      return inputLabel
        ? /*#__PURE__*/ react.createElement(
            'label',
            {
              className: inputLabelClass,
              onKeyDown: onKeyDown,
              tabIndex: 0,
            },
            inputLabel,
            /*#__PURE__*/ react.createElement('input', {
              ref: inputRef,
              directory: isFolderUpload ? '' : undefined,
              multiple: isMultiple,
              onChange: handleChange,
              type: 'file',
              webkitdirectory: isFolderUpload ? '' : undefined,
            }),
          )
        : null;
    };
    /* harmony default export */ const content_uploader_UploadInput = UploadInput; // CONCATENATED MODULE: ./src/elements/content-uploader/UploadStateContent.js
    function UploadStateContent_extends() {
      return (
        (UploadStateContent_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        UploadStateContent_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Upload state content component
     */

    const UploadStateContent = ({ fileInputLabel, folderInputLabel, message, onChange, useButton = false }) => {
      const messageContent = message
        ? /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'bcu-upload-state-message',
            },
            message,
          )
        : null;
      const inputLabelClass = useButton ? 'btn btn-primary be-input-btn' : 'be-input-link';
      const shouldShowFolderUploadInput = !useButton && !!folderInputLabel;
      const handleChange = event => {
        if (!onChange) {
          return;
        }
        onChange(event);
        const currentTarget = event.currentTarget;
        // resets the file input selection
        currentTarget.value = '';
      };
      const fileInputContent = /*#__PURE__*/ react.createElement(content_uploader_UploadInput, {
        handleChange: handleChange,
        inputLabel: fileInputLabel,
        inputLabelClass: inputLabelClass,
      });
      const folderInputContent = shouldShowFolderUploadInput
        ? /*#__PURE__*/ react.createElement(content_uploader_UploadInput, {
            handleChange: handleChange,
            inputLabel: folderInputLabel,
            inputLabelClass: inputLabelClass,
            isFolderUpload: true,
          })
        : null;
      let inputsContent;
      if (fileInputContent && folderInputContent) {
        inputsContent = /*#__PURE__*/ react.createElement(
          components_message,
          UploadStateContent_extends({}, common_messages.uploadOptions, {
            values: {
              option1: fileInputContent,
              option2: folderInputContent,
            },
          }),
        );
      } else if (fileInputContent) {
        inputsContent = fileInputContent;
      }
      return /*#__PURE__*/ react.createElement(
        'div',
        null,
        messageContent,
        inputsContent &&
          /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'bcu-upload-input-container',
            },
            inputsContent,
          ),
      );
    };
    /* harmony default export */ const content_uploader_UploadStateContent = UploadStateContent; // CONCATENATED MODULE: ./src/elements/content-uploader/UploadState.js
    /**
     *
     * @file Upload state component
     */

    const UploadState = ({ canDrop, hasItems, isOver, isTouch, view, onSelect, isFolderUploadEnabled }) => {
      let icon;
      let content;
      switch (view) {
        case VIEW_ERROR:
          icon = /*#__PURE__*/ react.createElement(states_ErrorEmptyState, null);
          content = /*#__PURE__*/ react.createElement(content_uploader_UploadStateContent, {
            message: /*#__PURE__*/ react.createElement(components_message, common_messages.uploadError),
          });
          break;
        case VIEW_UPLOAD_EMPTY:
          icon = /*#__PURE__*/ react.createElement(states_UploadEmptyState, null);
          /* eslint-disable no-nested-ternary */
          content =
            canDrop && hasItems
              ? /*#__PURE__*/ react.createElement(content_uploader_UploadStateContent, {
                  message: /*#__PURE__*/ react.createElement(components_message, common_messages.uploadInProgress),
                })
              : isTouch
                ? /*#__PURE__*/ react.createElement(content_uploader_UploadStateContent, {
                    fileInputLabel: /*#__PURE__*/ react.createElement(
                      components_message,
                      common_messages.uploadNoDragDrop,
                    ),
                    onChange: onSelect,
                    useButton: true,
                  })
                : /*#__PURE__*/ react.createElement(content_uploader_UploadStateContent, {
                    fileInputLabel: /*#__PURE__*/ react.createElement(
                      components_message,
                      common_messages.uploadEmptyFileInput,
                    ),
                    folderInputLabel:
                      isFolderUploadEnabled &&
                      /*#__PURE__*/ react.createElement(components_message, common_messages.uploadEmptyFolderInput),
                    message: isFolderUploadEnabled
                      ? /*#__PURE__*/ react.createElement(
                          components_message,
                          common_messages.uploadEmptyWithFolderUploadEnabled,
                        )
                      : /*#__PURE__*/ react.createElement(
                          components_message,
                          common_messages.uploadEmptyWithFolderUploadDisabled,
                        ),
                    onChange: onSelect,
                  });
          /* eslint-disable no-nested-ternary */
          break;
        case VIEW_UPLOAD_IN_PROGRESS:
          icon = /*#__PURE__*/ react.createElement(states_UploadEmptyState, null);
          content = /*#__PURE__*/ react.createElement(content_uploader_UploadStateContent, {
            message: /*#__PURE__*/ react.createElement(components_message, common_messages.uploadInProgress),
          });
          break;
        case VIEW_UPLOAD_SUCCESS:
          icon = /*#__PURE__*/ react.createElement(states_UploadSuccessState, null);
          content = /*#__PURE__*/ react.createElement(content_uploader_UploadStateContent, {
            fileInputLabel: /*#__PURE__*/ react.createElement(
              components_message,
              common_messages.uploadSuccessFileInput,
            ),
            folderInputLabel:
              isFolderUploadEnabled &&
              /*#__PURE__*/ react.createElement(components_message, common_messages.uploadSuccessFolderInput),
            message: /*#__PURE__*/ react.createElement(components_message, common_messages.uploadSuccess),
            onChange: onSelect,
            useButton: isTouch,
          });
          break;
        default:
          break;
        /* eslint-disable jsx-a11y/label-has-for */
      }
      const className = classnames_default()('bcu-upload-state', {
        'bcu-is-droppable': isOver && canDrop,
        'bcu-is-not-droppable': isOver && !canDrop,
        'bcu-has-items': hasItems,
      });
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: className,
        },
        /*#__PURE__*/ react.createElement('div', null, icon, content),
        /*#__PURE__*/ react.createElement('div', {
          className: 'bcu-drag-drop-overlay',
        }),
      );
    };
    /* harmony default export */ const content_uploader_UploadState = UploadState; // CONCATENATED MODULE: ./src/elements/content-uploader/DroppableContent.js
    /**
     *
     * @file Droppable area containing upload item list
     */

    /**
     * Definition for drag and drop behavior.
     */
    const dropDefinition = {
      /**
       * Validates whether a file can be dropped or not.
       */
      dropValidator: ({ allowedTypes }, { types }) => {
        if (types instanceof Array) {
          return Array.from(types).some(type => allowedTypes.indexOf(type) > -1);
        }
        const allowedList = allowedTypes.filter(allowed => types.contains(allowed));
        return allowedList.length > 0;
      },
      /**
       * Determines what happens after a file is dropped
       */
      onDrop: (event, { addDataTransferItemsToUploadQueue }) => {
        const { dataTransfer } = event;
        addDataTransferItemsToUploadQueue(dataTransfer);
      },
    };
    const DroppableContent = droppable_makeDroppable(dropDefinition)(({
      canDrop,
      isOver,
      isTouch,
      view,
      items,
      addFiles,
      onClick,
      isFolderUploadEnabled,
    }) => {
      const handleSelectFiles = ({ target: { files } }) => addFiles(files);
      const hasItems = items.length > 0;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-droppable-content',
        },
        /*#__PURE__*/ react.createElement(content_uploader_ItemList, {
          items: items,
          onClick: onClick,
          view: view,
        }),
        /*#__PURE__*/ react.createElement(content_uploader_UploadState, {
          canDrop: canDrop,
          hasItems: hasItems,
          isFolderUploadEnabled: isFolderUploadEnabled,
          isOver: isOver,
          isTouch: isTouch,
          onSelect: handleSelectFiles,
          view: view,
        }),
      );
    });
    /* harmony default export */ const content_uploader_DroppableContent = DroppableContent; // CONCATENATED MODULE: ./src/components/primary-button/index.ts
    // CONCATENATED MODULE: ./src/common/variables.js
    const BOX_BLUE = '#0061d5';
    const SEESEE = '#ccc';
    const RESIN_TAG_TARGET = 'data-resin-target'; // CONCATENATED MODULE: ./src/elements/content-uploader/UploadsManagerAction.js

    function UploadsManagerAction_extends() {
      return (
        (UploadsManagerAction_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        UploadsManagerAction_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Uploads Manager action component
     */

    const UploadsManagerAction = ({ onClick, hasMultipleFailedUploads }) => {
      const handleResumeClick = event => {
        event.stopPropagation();
        onClick(STATUS_ERROR);
      };
      const resumeMessage = hasMultipleFailedUploads ? common_messages.resumeAll : common_messages.resume;
      const resin = {
        [RESIN_TAG_TARGET]: 'uploadresumeheader',
      };
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-uploads-manager-action',
        },
        /*#__PURE__*/ react.createElement(
          primary_button_PrimaryButton,
          UploadsManagerAction_extends(
            {
              onClick: handleResumeClick,
              type: 'button',
            },
            resin,
          ),
          /*#__PURE__*/ react.createElement(components_message, resumeMessage),
        ),
      );
    };
    /* harmony default export */ const content_uploader_UploadsManagerAction = UploadsManagerAction; // CONCATENATED MODULE: ./src/elements/content-uploader/OverallUploadsProgressBar.js
    /**
     *
     * @file Overall uploads progress bar
     */

    /**
     * Get upload status
     *
     * @param {View} view
     * @return {FormattedMessage|string}
     */
    const getUploadStatus = view => {
      switch (view) {
        case VIEW_UPLOAD_IN_PROGRESS:
          return /*#__PURE__*/ react.createElement(components_message, common_messages.uploadsManagerUploadInProgress);
        case VIEW_UPLOAD_SUCCESS:
          return /*#__PURE__*/ react.createElement(components_message, common_messages.uploadsManagerUploadComplete);
        case VIEW_UPLOAD_EMPTY:
          return /*#__PURE__*/ react.createElement(components_message, common_messages.uploadsManagerUploadPrompt);
        case VIEW_ERROR:
          return /*#__PURE__*/ react.createElement(components_message, common_messages.uploadsManagerUploadFailed);
        default:
          return '';
      }
    };

    /**
     * Get overall upload progress percentage
     *
     * @param {string} view
     * @param {number} percent
     */
    const getPercent = (view, percent) => {
      switch (view) {
        case VIEW_UPLOAD_SUCCESS:
          return 100;
        case VIEW_UPLOAD_EMPTY:
        case VIEW_ERROR:
          return 0;
        default:
          return percent;
      }
    };
    const OverallUploadsProgressBar = ({
      customPrompt,
      hasMultipleFailedUploads,
      isDragging,
      isExpanded,
      isResumeVisible,
      isVisible,
      onClick,
      onKeyDown,
      onUploadsManagerActionClick,
      percent,
      view,
    }) => {
      // Show the upload prompt and set progress to 0 when the uploads manager
      // is invisible or is having files dragged to it
      const shouldShowPrompt = isDragging || !isVisible;
      const message = customPrompt || common_messages.uploadsManagerUploadPrompt;
      const status = shouldShowPrompt
        ? /*#__PURE__*/ react.createElement(components_message, message)
        : getUploadStatus(view);
      const updatedPercent = shouldShowPrompt ? 0 : getPercent(view, percent);
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          'aria-hidden': !isVisible,
          className: 'bcu-overall-progress-bar',
          onClick: onClick,
          onKeyDown: onKeyDown,
          role: 'button',
          tabIndex: isVisible ? '0' : '-1',
        },
        /*#__PURE__*/ react.createElement(
          'span',
          {
            className: 'bcu-upload-status',
          },
          status,
        ),
        /*#__PURE__*/ react.createElement(content_uploader_ProgressBar, {
          percent: updatedPercent,
        }),
        isResumeVisible &&
          /*#__PURE__*/ react.createElement(content_uploader_UploadsManagerAction, {
            hasMultipleFailedUploads: hasMultipleFailedUploads,
            onClick: onUploadsManagerActionClick,
          }),
        /*#__PURE__*/ react.createElement('span', {
          className: 'bcu-uploads-manager-toggle',
        }),
      );
    };
    /* harmony default export */ const content_uploader_OverallUploadsProgressBar = OverallUploadsProgressBar; // CONCATENATED MODULE: ./src/elements/content-uploader/UploadsManager.js
    /**
     *
     * @file Uploads manager
     */

    const UploadsManager = ({
      isExpanded,
      isVisible,
      isResumableUploadsEnabled,
      isDragging,
      items,
      onItemActionClick,
      onRemoveActionClick,
      onUpgradeCTAClick,
      onUploadsManagerActionClick,
      toggleUploadsManager,
      view,
    }) => {
      /**
       * Keydown handler for progress bar
       *
       * @param {SyntheticKeyboardEvent} event
       * @return {void}
       */
      const handleProgressBarKeyDown = event => {
        switch (event.key) {
          case 'Enter':
          case 'Space':
            toggleUploadsManager();
            break;
          default:
          // noop
        }
      };
      let numFailedUploads = 0;
      let totalSize = 0;
      let totalUploaded = 0;
      items.forEach(item => {
        if (item.status !== STATUS_ERROR && !item.isFolder) {
          totalSize += item.size;
          totalUploaded += (item.size * item.progress) / 100.0;
        } else if (item.status === STATUS_ERROR) {
          numFailedUploads += 1;
        }
      });
      const percent = (totalUploaded / totalSize) * 100;
      const isResumeVisible = isResumableUploadsEnabled && numFailedUploads > 0;
      const hasMultipleFailedUploads = numFailedUploads > 1;
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          'data-resin-component': 'uploadsmanager',
          'data-resin-feature': 'uploads',
          className: classnames_default()('be bcu-uploads-manager-container', {
            'bcu-is-expanded': isExpanded,
            'bcu-is-visible': isVisible,
          }),
        },
        /*#__PURE__*/ react.createElement(content_uploader_OverallUploadsProgressBar, {
          isDragging: isDragging,
          isExpanded: isExpanded,
          isResumeVisible: isResumeVisible,
          isVisible: isVisible,
          hasMultipleFailedUploads: hasMultipleFailedUploads,
          onClick: toggleUploadsManager,
          onKeyDown: handleProgressBarKeyDown,
          onUploadsManagerActionClick: onUploadsManagerActionClick,
          percent: percent,
          view: view,
        }),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-uploads-manager-item-list',
          },
          /*#__PURE__*/ react.createElement(content_uploader_ItemList, {
            isResumableUploadsEnabled: isResumableUploadsEnabled,
            items: items,
            onClick: onItemActionClick,
            onRemoveClick: onRemoveActionClick,
            onUpgradeCTAClick: onUpgradeCTAClick,
            view: view,
          }),
        ),
      );
    };
    /* harmony default export */ const content_uploader_UploadsManager = UploadsManager; // CONCATENATED MODULE: ./src/elements/content-uploader/Footer.js
    function Footer_extends() {
      return (
        (Footer_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Footer_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Footer component
     */

    const Footer = ({ isLoading, hasFiles, errorCode, onCancel, onClose, onUpload, fileLimit, isDone }) => {
      const isCloseButtonDisabled = hasFiles;
      const isCancelButtonDisabled = !hasFiles || isDone;
      const isUploadButtonDisabled = !hasFiles;
      let message;
      switch (errorCode) {
        case ERROR_CODE_UPLOAD_FILE_LIMIT:
          message = /*#__PURE__*/ react.createElement(
            components_message,
            Footer_extends({}, common_messages.uploadErrorTooManyFiles, {
              values: {
                fileLimit,
              },
            }),
          );
          break;
        default:
        // ignore
      }
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcu-footer',
        },
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-footer-left',
          },
          onClose
            ? /*#__PURE__*/ react.createElement(
                button_Button,
                {
                  disabled: isCloseButtonDisabled,
                  isDisabled: isCloseButtonDisabled,
                  onClick: onClose,
                  type: 'button',
                },
                /*#__PURE__*/ react.createElement(components_message, common_messages.close),
              )
            : null,
        ),
        message &&
          /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'bcu-footer-message',
            },
            message,
          ),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcu-footer-right',
          },
          /*#__PURE__*/ react.createElement(
            button_Button,
            {
              disabled: isCancelButtonDisabled,
              isDisabled: isCancelButtonDisabled,
              onClick: onCancel,
              type: 'button',
            },
            /*#__PURE__*/ react.createElement(components_message, common_messages.cancel),
          ),
          /*#__PURE__*/ react.createElement(
            primary_button_PrimaryButton,
            {
              disabled: isUploadButtonDisabled,
              isDisabled: isUploadButtonDisabled,
              isLoading: isLoading,
              onClick: onUpload,
              type: 'button',
            },
            /*#__PURE__*/ react.createElement(components_message, common_messages.upload),
          ),
        ),
      );
    };
    /* harmony default export */ const content_uploader_Footer = Footer; // CONCATENATED MODULE: ./src/elements/content-uploader/ContentUploader.js
    function ContentUploader_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function ContentUploader_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? ContentUploader_ownKeys(Object(t), !0).forEach(function (r) {
              ContentUploader_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : ContentUploader_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function ContentUploader_defineProperty(e, r, t) {
      return (
        (r = ContentUploader_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ContentUploader_toPropertyKey(t) {
      var i = ContentUploader_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ContentUploader_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Content Uploader component
     * @author Box
     */

    const CHUNKED_UPLOAD_MIN_SIZE_BYTES = 104857600; // 100MB
    const FILE_LIMIT_DEFAULT = 100; // Upload at most 100 files at once by default
    const HIDE_UPLOAD_MANAGER_DELAY_MS_DEFAULT = 8000;
    const EXPAND_UPLOADS_MANAGER_ITEMS_NUM_THRESHOLD = 5;
    const UPLOAD_CONCURRENCY = 6;
    class ContentUploader extends react.Component {
      /**
       * [constructor]
       *
       * @return {ContentUploader}
       */
      constructor(props) {
        super(props);
        ContentUploader_defineProperty(this, 'isAutoExpanded', false);
        /**
         * Return base API options from props
         *
         * @private
         * @returns {Object}
         */
        ContentUploader_defineProperty(this, 'getBaseAPIOptions', () => {
          const {
            token,
            sharedLink,
            sharedLinkPassword,
            apiHost,
            uploadHost,
            clientName,
            requestInterceptor,
            responseInterceptor,
          } = this.props;
          return {
            token,
            sharedLink,
            sharedLinkPassword,
            apiHost,
            uploadHost,
            clientName,
            requestInterceptor,
            responseInterceptor,
          };
        });
        /**
         * Given an array of files, return the files that are new to the Content Uploader
         *
         * @param {Array<UploadFileWithAPIOptions | File>} files
         */
        ContentUploader_defineProperty(this, 'getNewFiles', files => {
          const { rootFolderId } = this.props;
          const { itemIds } = this.state;
          return Array.from(files).filter(file => !itemIds[getFileId(file, rootFolderId)]);
        });
        /**
         * Given an array of files, return the files that are new to the Content Uploader
         *
         * @param {Array<UploadFileWithAPIOptions | File>} files
         */
        ContentUploader_defineProperty(this, 'getNewDataTransferItems', items => {
          const { rootFolderId } = this.props;
          const { itemIds } = this.state;
          return Array.from(items).filter(item => !itemIds[getDataTransferItemId(item, rootFolderId)]);
        });
        /**
         * Converts File API to upload items and adds to upload queue.
         *
         * @private
         * @param {Array<UploadFileWithAPIOptions | UploadFile>} files - Files to be added to upload queue
         * @param {Function} itemUpdateCallback - function to be invoked after items status are updated
         * @param {boolean} [isRelativePathIgnored] - if true webkitRelativePath property is ignored
         * @return {void}
         */
        ContentUploader_defineProperty(
          this,
          'addFilesToUploadQueue',
          (files, itemUpdateCallback, isRelativePathIgnored = false) => {
            const { onBeforeUpload, rootFolderId, isPrepopulateFilesEnabled } = this.props;
            if (!files || files.length === 0) {
              return;
            }
            const newFiles = this.getNewFiles(files);
            if (newFiles.length === 0) {
              return;
            }
            const newItemIds = {};
            newFiles.forEach(file => {
              newItemIds[getFileId(file, rootFolderId)] = true;
            });
            clearTimeout(this.resetItemsTimeout);
            const firstFile = getFile(newFiles[0]);
            this.setState(
              state => ({
                itemIds: ContentUploader_objectSpread(ContentUploader_objectSpread({}, state.itemIds), newItemIds),
              }),
              () => {
                onBeforeUpload(newFiles);
                if (firstFile.webkitRelativePath && !isRelativePathIgnored) {
                  // webkitRelativePath should be ignored when the upload destination folder is known
                  this.addFilesWithRelativePathToQueue(newFiles, itemUpdateCallback);
                } else {
                  this.addFilesWithoutRelativePathToQueue(
                    newFiles,
                    isPrepopulateFilesEnabled ? this.upload : itemUpdateCallback,
                  );
                }
              },
            );
          },
        );
        /**
         * Add dropped items to the upload queue
         *
         * @private
         * @param {DataTransfer} droppedItems
         * @param {Function} itemUpdateCallback
         * @returns {Promise<any>}
         */
        ContentUploader_defineProperty(this, 'addDroppedItemsToUploadQueue', (droppedItems, itemUpdateCallback) => {
          if (droppedItems.items) {
            this.addDataTransferItemsToUploadQueue(droppedItems.items, itemUpdateCallback);
          } else {
            this.addFilesToUploadQueue(Array.from(droppedItems.files), itemUpdateCallback);
          }
        });
        /**
         * Add dataTransferItems to the upload queue
         *
         * @private
         * @param {DataTransferItemList} dataTransferItems
         * @param {Function} itemUpdateCallback
         * @returns {Promise<any>}
         */
        ContentUploader_defineProperty(
          this,
          'addDataTransferItemsToUploadQueue',
          (dataTransferItems, itemUpdateCallback) => {
            const { isFolderUploadEnabled } = this.props;
            if (!dataTransferItems || dataTransferItems.length === 0) {
              return;
            }
            const folderItems = [];
            const fileItems = [];
            const packageItems = [];
            Array.from(dataTransferItems).forEach(item => {
              const isDirectory = isDataTransferItemAFolder(item);
              if (utils_Browser.isSafari() && isDataTransferItemAPackage(item)) {
                packageItems.push(item);
              } else if (isDirectory && isFolderUploadEnabled) {
                folderItems.push(item);
              } else if (!isDirectory) {
                fileItems.push(item);
              }
            });
            this.addFileDataTransferItemsToUploadQueue(fileItems, itemUpdateCallback);
            this.addPackageDataTransferItemsToUploadQueue(packageItems, itemUpdateCallback);
            this.addFolderDataTransferItemsToUploadQueue(folderItems, itemUpdateCallback);
          },
        );
        /**
         * Add dataTransferItem of file type to the upload queue
         *
         * @private
         * @param {Array<DataTransferItem | UploadDataTransferItemWithAPIOptions>} dataTransferItems
         * @param {Function} itemUpdateCallback
         * @returns {Promise<any>}
         */
        ContentUploader_defineProperty(
          this,
          'addFileDataTransferItemsToUploadQueue',
          async (dataTransferItems, itemUpdateCallback) => {
            const files = await Promise.all(dataTransferItems.map(async item => getFileFromDataTransferItem(item)));
            const filesArray = [];
            files.forEach(file => {
              if (file) {
                filesArray.push(file);
              }
            });
            this.addFilesToUploadQueue(filesArray, itemUpdateCallback);
          },
        );
        /**
         * Add dataTransferItem of package type to the upload queue
         *
         * @private
         * @param {Array<DataTransferItem | UploadDataTransferItemWithAPIOptions>} dataTransferItems
         * @param {Function} itemUpdateCallback
         * @returns {Promise<any>}
         */
        ContentUploader_defineProperty(
          this,
          'addPackageDataTransferItemsToUploadQueue',
          async (dataTransferItems, itemUpdateCallback) => {
            const packageFiles = await Promise.all(
              dataTransferItems.map(async item => getPackageFileFromDataTransferItem(item)),
            );
            const packageFilesArray = [];
            packageFiles.forEach(packageFile => {
              if (packageFile) {
                packageFilesArray.push(packageFile);
              }
            });
            this.addFilesToUploadQueue(packageFilesArray, itemUpdateCallback);
          },
        );
        /**
         * Add dataTransferItem of folder type to the upload queue
         *
         * @private
         * @param {Array<DataTransferItem | UploadDataTransferItemWithAPIOptions>} dataTransferItems
         * @param {Function} itemUpdateCallback
         * @returns {Promise<any>}
         */
        ContentUploader_defineProperty(
          this,
          'addFolderDataTransferItemsToUploadQueue',
          async (dataTransferItems, itemUpdateCallback) => {
            const { rootFolderId } = this.props;
            const { itemIds } = this.state;
            if (dataTransferItems.length === 0) {
              return;
            }
            const newItems = this.getNewDataTransferItems(dataTransferItems);
            newItems.forEach(item => {
              itemIds[getDataTransferItemId(item, rootFolderId)] = true;
            });
            if (newItems.length === 0) {
              return;
            }
            const fileAPIOptions = getDataTransferItemAPIOptions(newItems[0]);
            const { folderId = rootFolderId } = fileAPIOptions;
            const folderUploads = await Promise.all(
              newItems.map(async item => {
                const folderUpload = this.getFolderUploadAPI(folderId);
                await folderUpload.buildFolderTreeFromDataTransferItem(item);
                return folderUpload;
              }),
            );
            const folderUploadsArray = [];
            folderUploads.forEach(folderUpload => {
              // $FlowFixMe no file property
              folderUploadsArray.push({
                api: folderUpload,
                extension: '',
                isFolder: true,
                name: folderUpload.folder.name,
                options: fileAPIOptions,
                progress: 0,
                size: 1,
                status: STATUS_PENDING,
              });
            });
            this.addToQueue(folderUploadsArray, itemUpdateCallback);
          },
        );
        /**
         * Get folder upload API instance
         *
         * @private
         * @param {string} folderId
         * @return {FolderUpload}
         */
        ContentUploader_defineProperty(this, 'getFolderUploadAPI', folderId => {
          const uploadBaseAPIOptions = this.getBaseAPIOptions();
          return new uploads_FolderUpload(this.addFilesToUploadQueue, folderId, this.addToQueue, uploadBaseAPIOptions);
        });
        /**
         * Add folder to upload queue
         *
         * @private
         * @param {FolderUpload} folderUpload
         * @param {Function} itemUpdateCallback
         * @param {Object} apiOptions
         * @return {void}
         */
        ContentUploader_defineProperty(
          this,
          'addFolderToUploadQueue',
          (folderUpload, itemUpdateCallback, apiOptions) => {
            this.addToQueue(
              [
                // $FlowFixMe no file property
                {
                  api: folderUpload,
                  extension: '',
                  isFolder: true,
                  name: folderUpload.folder.name,
                  options: apiOptions,
                  progress: 0,
                  size: 1,
                  status: STATUS_PENDING,
                },
              ],
              itemUpdateCallback,
            );
          },
        );
        /**
         * Converts File API to upload items and adds to upload queue for files with webkitRelativePath missing or ignored.
         *
         * @private
         * @param {Array<UploadFileWithAPIOptions | File>} files - Files to be added to upload queue
         * @param {Function} itemUpdateCallback - function to be invoked after items status are updated
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'addFilesWithoutRelativePathToQueue', (files, itemUpdateCallback) => {
          const { itemIds } = this.state;
          const { rootFolderId } = this.props;

          // Convert files from the file API to upload items
          const newItems = files.map(file => {
            const uploadFile = getFile(file);
            const uploadAPIOptions = getFileAPIOptions(file);
            const { name, size } = uploadFile;

            // Extract extension or use empty string if file has no extension
            let extension = name.substr(name.lastIndexOf('.') + 1);
            if (extension.length === name.length) {
              extension = '';
            }
            const api = this.getUploadAPI(uploadFile, uploadAPIOptions);
            const uploadItem = {
              api,
              extension,
              file: uploadFile,
              name,
              progress: 0,
              size,
              status: STATUS_PENDING,
            };
            if (uploadAPIOptions) {
              uploadItem.options = uploadAPIOptions;
            }
            itemIds[getFileId(uploadItem, rootFolderId)] = true;
            return uploadItem;
          });
          if (newItems.length === 0) {
            return;
          }
          this.setState({
            itemIds,
          });
          this.addToQueue(newItems, itemUpdateCallback);
        });
        /**
         * Add new items to the upload queue
         *
         * @private
         * @param {Array<UploadFileWithAPIOptions | File>} newItems - Files to be added to upload queue
         * @param {Function} itemUpdateCallback - function to be invoked after items status are updated
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'addToQueue', (newItems, itemUpdateCallback) => {
          const { fileLimit, useUploadsManager } = this.props;
          const { items, isUploadsManagerExpanded } = this.state;
          let updatedItems = [];
          const prevItemsNum = items.length;
          const totalNumOfItems = prevItemsNum + newItems.length;

          // Don't add more than fileLimit # of items
          if (totalNumOfItems > fileLimit) {
            updatedItems = items.concat(newItems.slice(0, fileLimit - items.length));
            this.setState({
              errorCode: ERROR_CODE_UPLOAD_FILE_LIMIT,
            });
          } else {
            updatedItems = items.concat(newItems);
            this.setState({
              errorCode: '',
            });

            // If the number of items being uploaded passes the threshold, expand the upload manager
            if (
              prevItemsNum < EXPAND_UPLOADS_MANAGER_ITEMS_NUM_THRESHOLD &&
              totalNumOfItems >= EXPAND_UPLOADS_MANAGER_ITEMS_NUM_THRESHOLD &&
              useUploadsManager &&
              !isUploadsManagerExpanded
            ) {
              this.isAutoExpanded = true;
              this.expandUploadsManager();
            }
          }
          this.updateViewAndCollection(updatedItems, () => {
            if (itemUpdateCallback) {
              itemUpdateCallback();
            }
            const { view } = this.state;
            // Automatically start upload if other files are being uploaded
            if (view === VIEW_UPLOAD_IN_PROGRESS) {
              this.upload();
            }
          });
        });
        /**
         * Removes an item from the upload queue. Cancels upload if in progress.
         *
         * @param {UploadItem} item - Item to remove
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'removeFileFromUploadQueue', item => {
          const { onCancel, useUploadsManager } = this.props;
          const { items } = this.state;
          // Clear any error errorCode in footer
          this.setState({
            errorCode: '',
          });
          const { api } = item;
          api.cancel();
          items.splice(items.indexOf(item), 1);
          onCancel([item]);
          this.updateViewAndCollection(items, () => {
            // Minimize uploads manager if there are no more items
            if (useUploadsManager && !items.length) {
              this.minimizeUploadsManager();
            }
            const { view } = this.state;
            if (view === VIEW_UPLOAD_IN_PROGRESS) {
              this.upload();
            }
          });
        });
        /**
         * Aborts uploads in progress and clears upload list.
         *
         * @private
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'cancel', () => {
          const { items } = this.state;
          items.forEach(uploadItem => {
            const { api, status } = uploadItem;
            if (status === STATUS_IN_PROGRESS) {
              api.cancel();
            }
          });

          // Reset upload collection
          this.updateViewAndCollection([]);
        });
        /**
         * Uploads all items in the upload collection.
         *
         * @private
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'upload', () => {
          const { items } = this.state;
          items.forEach(uploadItem => {
            if (uploadItem.status === STATUS_PENDING) {
              this.uploadFile(uploadItem);
            }
          });
        });
        /**
         * Handles a successful upload.
         *
         * @private
         * @param {UploadItem} item - Upload item corresponding to success event
         * @param {BoxItem[]} entries - Successfully uploaded Box File objects
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'handleUploadSuccess', (item, entries) => {
          const { onUpload, useUploadsManager } = this.props;
          item.progress = 100;
          if (!item.error) {
            item.status = STATUS_COMPLETE;
          }

          // Cache Box File object of successfully uploaded item
          if (entries && entries.length === 1) {
            const [boxFile] = entries;
            item.boxFile = boxFile;
          }
          const { items } = this.state;
          items[items.indexOf(item)] = item;

          // Broadcast that a file has been uploaded
          if (useUploadsManager) {
            onUpload(item);
            this.checkClearUploadItems();
          } else {
            onUpload(item.boxFile);
          }
          this.updateViewAndCollection(items, () => {
            const { view } = this.state;
            if (view === VIEW_UPLOAD_IN_PROGRESS) {
              this.upload();
            }
          });
        });
        ContentUploader_defineProperty(this, 'resetUploadManagerExpandState', () => {
          this.isAutoExpanded = false;
          this.setState({
            isUploadsManagerExpanded: false,
          });
        });
        /**
         * Handles an upload error.
         *
         * @private
         * @param {UploadItem} item - Upload item corresponding to error
         * @param {Error} error - Upload error
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'handleUploadError', (item, error) => {
          const { onError, useUploadsManager } = this.props;
          const { file } = item;
          const { items } = this.state;
          item.status = STATUS_ERROR;
          item.error = error;
          const newItems = [...items];
          const index = newItems.findIndex(singleItem => singleItem === item);
          if (index !== -1) {
            newItems[index] = item;
          }

          // Broadcast that there was an error uploading a file
          const errorData = useUploadsManager
            ? {
                item,
                error,
              }
            : {
                file,
                error,
              };
          onError(errorData);
          this.updateViewAndCollection(newItems, () => {
            if (useUploadsManager) {
              this.isAutoExpanded = true;
              this.expandUploadsManager();
            }
            const { view } = this.state;
            if (view === VIEW_UPLOAD_IN_PROGRESS) {
              this.upload();
            }
          });
        });
        /**
         * Handles an upload progress event.
         *
         * @private
         * @param {UploadItem} item - Upload item corresponding to progress event
         * @param {ProgressEvent} event - Progress event
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'handleUploadProgress', (item, event) => {
          if (!event.total || item.status === STATUS_COMPLETE || item.status === STATUS_STAGED) {
            return;
          }
          item.progress = Math.min(Math.round((event.loaded / event.total) * 100), 100);
          item.status = item.progress === 100 ? STATUS_STAGED : STATUS_IN_PROGRESS;
          const { onProgress } = this.props;
          onProgress(item);
          const { items } = this.state;
          items[items.indexOf(item)] = item;
          this.updateViewAndCollection(items);
        });
        /**
         * Updates item based on its status.
         *
         * @private
         * @param {UploadItem} item - The upload item to update
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'onClick', item => {
          const { chunked, isResumableUploadsEnabled, onClickCancel, onClickResume, onClickRetry } = this.props;
          const { status, file } = item;
          const isChunkedUpload =
            chunked && !item.isFolder && file.size > CHUNKED_UPLOAD_MIN_SIZE_BYTES && isMultiputSupported();
          const isResumable = isResumableUploadsEnabled && isChunkedUpload && item.api.sessionId;
          switch (status) {
            case STATUS_IN_PROGRESS:
            case STATUS_STAGED:
            case STATUS_COMPLETE:
            case STATUS_PENDING:
              this.removeFileFromUploadQueue(item);
              onClickCancel(item);
              break;
            case STATUS_ERROR:
              if (isResumable) {
                item.bytesUploadedOnLastResume = item.api.totalUploadedBytes;
                this.resumeFile(item);
                onClickResume(item);
              } else {
                this.resetFile(item);
                this.uploadFile(item);
                onClickRetry(item);
              }
              break;
            default:
              break;
          }
        });
        /**
         * Click action button for all uploads in the Uploads Manager with the given status.
         *
         * @private
         * @param {UploadStatus} - the status that items should have for their action button to be clicked
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'clickAllWithStatus', status => {
          const { items } = this.state;
          items.forEach(item => {
            if (!status || item.status === status) {
              this.onClick(item);
            }
          });
        });
        /**
         * Expands the upload manager
         *
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'expandUploadsManager', () => {
          const { useUploadsManager } = this.props;
          if (!useUploadsManager) {
            return;
          }
          clearTimeout(this.resetItemsTimeout);
          this.setState({
            isUploadsManagerExpanded: true,
          });
        });
        /**
         * Minimizes the upload manager
         *
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'minimizeUploadsManager', () => {
          const { useUploadsManager, onMinimize } = this.props;
          if (!useUploadsManager || !onMinimize) {
            return;
          }
          clearTimeout(this.resetItemsTimeout);
          onMinimize();
          this.resetUploadManagerExpandState();
          this.checkClearUploadItems();
        });
        /**
         * Checks if the upload items should be cleared after a timeout
         *
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'checkClearUploadItems', () => {
          this.resetItemsTimeout = setTimeout(
            this.resetUploadsManagerItemsWhenUploadsComplete,
            HIDE_UPLOAD_MANAGER_DELAY_MS_DEFAULT,
          );
        });
        /**
         * Toggles the upload manager
         *
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'toggleUploadsManager', () => {
          const { isUploadsManagerExpanded } = this.state;
          if (isUploadsManagerExpanded) {
            this.minimizeUploadsManager();
          } else {
            this.expandUploadsManager();
          }
        });
        /**
         * Empties the items queue
         *
         * @return {void}
         */
        ContentUploader_defineProperty(this, 'resetUploadsManagerItemsWhenUploadsComplete', () => {
          const { view, items, isUploadsManagerExpanded } = this.state;
          const { useUploadsManager, onCancel } = this.props;

          // Do not reset items when upload manger is expanded or there're uploads in progress
          if ((isUploadsManagerExpanded && useUploadsManager && !!items.length) || view === VIEW_UPLOAD_IN_PROGRESS) {
            return;
          }
          onCancel(items);
          this.setState({
            items: [],
            itemIds: {},
          });
        });
        /**
         * Adds file to the upload queue and starts upload immediately
         *
         * @param {Array<UploadFileWithAPIOptions | File>} files - Files to be added to upload queue
         * @return {void}
         */
        ContentUploader_defineProperty(
          this,
          'addFilesWithOptionsToUploadQueueAndStartUpload',
          (files, dataTransferItems) => {
            this.addFilesToUploadQueue(files, this.upload);
            this.addDataTransferItemsToUploadQueue(dataTransferItems, this.upload);
          },
        );
        const { rootFolderId: _rootFolderId, token: _token, useUploadsManager: _useUploadsManager } = props;
        this.state = {
          view: (_rootFolderId && _token) || _useUploadsManager ? VIEW_UPLOAD_EMPTY : VIEW_ERROR,
          items: [],
          errorCode: '',
          itemIds: {},
          isUploadsManagerExpanded: false,
        };
        this.id = uniqueId_default()('bcu_');
      }

      /**
       * Fetches the root folder on load
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      componentDidMount() {
        this.rootElement = document.getElementById(this.id);
        this.appElement = this.rootElement;
        const { files, isPrepopulateFilesEnabled } = this.props;
        // isPrepopulateFilesEnabled is a prop used to pre-populate files without clicking upload button.
        if (isPrepopulateFilesEnabled && files && files.length > 0) {
          this.addFilesToUploadQueue(files, this.upload);
        }
      }

      /**
       * Cancels pending uploads
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      componentWillUnmount() {
        this.cancel();
      }

      /**
       * Adds new items to the queue when files prop gets updated in window view
       *
       * @return {void}
       */
      componentDidUpdate() {
        const { files, dataTransferItems, useUploadsManager } = this.props;
        const hasFiles = Array.isArray(files) && files.length > 0;
        const hasItems = Array.isArray(dataTransferItems) && dataTransferItems.length > 0;
        const hasUploads = hasFiles || hasItems;
        if (!useUploadsManager || !hasUploads) {
          return;
        }

        // TODO: this gets called unnecessarily (upon each render regardless of the queue not changing)
        this.addFilesWithOptionsToUploadQueueAndStartUpload(files, dataTransferItems);
      }

      /**
       * Create and return new instance of API creator
       *
       * @param {UploadItemAPIOptions} [uploadAPIOptions]
       * @return {API}
       */
      createAPIFactory(uploadAPIOptions) {
        const { rootFolderId } = this.props;
        const folderId = get_default()(uploadAPIOptions, 'folderId') || rootFolderId;
        const fileId = get_default()(uploadAPIOptions, 'fileId');
        const itemFolderId = getTypedFolderId(folderId);
        const itemFileId = fileId ? getTypedFileId(fileId) : null;
        return new api_APIFactory(
          ContentUploader_objectSpread(
            ContentUploader_objectSpread({}, this.getBaseAPIOptions()),
            {},
            {
              id: itemFileId || itemFolderId,
            },
            uploadAPIOptions,
          ),
        );
      }
      /**
       * Converts File API to upload items and adds to upload queue for files with webkitRelativePath.
       *
       * @private
       * @param {Array<UploadFileWithAPIOptions | File>} files - Files to be added to upload queue
       * @param {Function} itemUpdateCallback - function to be invoked after items status are updated
       * @return {void}
       */
      addFilesWithRelativePathToQueue(files, itemUpdateCallback) {
        if (files.length === 0) {
          return;
        }
        const { rootFolderId } = this.props;
        const fileAPIOptions = getFileAPIOptions(files[0]);
        const { folderId = rootFolderId } = fileAPIOptions;
        const folderUpload = this.getFolderUploadAPI(folderId);

        // Only 1 folder tree can be built with files having webkitRelativePath properties
        folderUpload.buildFolderTreeFromWebkitRelativePath(files);
        this.addFolderToUploadQueue(folderUpload, itemUpdateCallback, fileAPIOptions);
      }
      /**
       * Returns a new API instance for the given file.
       *
       * @private
       * @param {File} file - File to get a new API instance for
       * @param {UploadItemAPIOptions} [uploadAPIOptions]
       * @return {UploadAPI} - Instance of Upload API
       */
      getUploadAPI(file, uploadAPIOptions) {
        const { chunked, isResumableUploadsEnabled, isUploadFallbackLogicEnabled } = this.props;
        const { size } = file;
        const factory = this.createAPIFactory(uploadAPIOptions);
        if (chunked && size > CHUNKED_UPLOAD_MIN_SIZE_BYTES) {
          if (isMultiputSupported()) {
            const chunkedUploadAPI = factory.getChunkedUploadAPI();
            if (isResumableUploadsEnabled) {
              chunkedUploadAPI.isResumableUploadsEnabled = true;
            }
            if (isUploadFallbackLogicEnabled) {
              chunkedUploadAPI.isUploadFallbackLogicEnabled = true;
            }
            return chunkedUploadAPI;
          }

          /* eslint-disable no-console */
          console.warn(
            'Chunked uploading is enabled, but not supported by your browser. You may need to enable HTTPS.',
          );
          /* eslint-disable no-console */
        }
        const plainUploadAPI = factory.getPlainUploadAPI();
        if (isUploadFallbackLogicEnabled) {
          plainUploadAPI.isUploadFallbackLogicEnabled = true;
        }
        return plainUploadAPI;
      }
      /**
       * Helper to upload a single file.
       *
       * @param {UploadItem} item - Upload item object
       * @return {void}
       */
      uploadFile(item) {
        const { overwrite, rootFolderId } = this.props;
        const { api, file, options } = item;
        const { items } = this.state;
        const numItemsUploading = items.filter(item_t => item_t.status === STATUS_IN_PROGRESS).length;
        if (numItemsUploading >= UPLOAD_CONCURRENCY) {
          return;
        }
        const uploadOptions = {
          file,
          folderId: options && options.folderId ? options.folderId : rootFolderId,
          errorCallback: error => this.handleUploadError(item, error),
          progressCallback: event => this.handleUploadProgress(item, event),
          successCallback: entries => this.handleUploadSuccess(item, entries),
          overwrite,
          fileId: options && options.fileId ? options.fileId : null,
        };
        item.status = STATUS_IN_PROGRESS;
        items[items.indexOf(item)] = item;
        api.upload(uploadOptions);
        this.updateViewAndCollection(items);
      }

      /**
       * Helper to resume uploading a single file.
       *
       * @param {UploadItem} item - Upload item object
       * @return {void}
       */
      resumeFile(item) {
        const { overwrite, rootFolderId, onResume } = this.props;
        const { api, file, options } = item;
        const { items } = this.state;
        const numItemsUploading = items.filter(item_t => item_t.status === STATUS_IN_PROGRESS).length;
        if (numItemsUploading >= UPLOAD_CONCURRENCY) {
          return;
        }
        const resumeOptions = {
          file,
          folderId: options && options.folderId ? options.folderId : rootFolderId,
          errorCallback: error => this.handleUploadError(item, error),
          progressCallback: event => this.handleUploadProgress(item, event),
          successCallback: entries => this.handleUploadSuccess(item, entries),
          overwrite,
          sessionId: api && api.sessionId ? api.sessionId : null,
          fileId: options && options.fileId ? options.fileId : null,
        };
        item.status = STATUS_IN_PROGRESS;
        delete item.error;
        items[items.indexOf(item)] = item;
        onResume(item);
        api.resume(resumeOptions);
        this.updateViewAndCollection(items);
      }

      /**
       * Helper to reset a file. Cancels any current upload and resets progress.
       *
       * @param {UploadItem} item - Upload item to reset
       * @return {void}
       */
      resetFile(item) {
        const { api, file, options } = item;
        if (api && typeof api.cancel === 'function') {
          api.cancel();
        }

        // Reset API, progress & status
        item.api = this.getUploadAPI(file, options);
        item.progress = 0;
        item.status = STATUS_PENDING;
        delete item.error;
        const { items } = this.state;
        items[items.indexOf(item)] = item;
        this.updateViewAndCollection(items);
      }
      /**
       * Updates view and internal upload collection with provided items.
       *
       * @private
       * @param {UploadItem[]} item - Items to update collection with
       * @param {Function} callback
       * @return {void}
       */
      updateViewAndCollection(items, callback) {
        const { onComplete, useUploadsManager, isResumableUploadsEnabled, isPartialUploadEnabled } = this.props;
        const someUploadIsInProgress = items.some(uploadItem => uploadItem.status !== STATUS_COMPLETE);
        const someUploadHasFailed = items.some(uploadItem => uploadItem.status === STATUS_ERROR);
        const allItemsArePending = !items.some(uploadItem => uploadItem.status !== STATUS_PENDING);
        const noFileIsPendingOrInProgress = items.every(
          uploadItem => uploadItem.status !== STATUS_PENDING && uploadItem.status !== STATUS_IN_PROGRESS,
        );
        const areAllItemsFinished = items.every(
          uploadItem => uploadItem.status === STATUS_COMPLETE || uploadItem.status === STATUS_ERROR,
        );
        const uploadItemsStatus = isResumableUploadsEnabled ? areAllItemsFinished : noFileIsPendingOrInProgress;
        let view = '';
        if ((items && items.length === 0) || allItemsArePending) {
          view = VIEW_UPLOAD_EMPTY;
        } else if (isPartialUploadEnabled && areAllItemsFinished) {
          const filesToBeUploaded = items.filter(item => item.status === STATUS_COMPLETE);
          view = VIEW_UPLOAD_SUCCESS;
          if (!useUploadsManager) {
            onComplete(cloneDeep_default()(filesToBeUploaded.map(item => item.boxFile)));
            // Reset item collection after successful upload
            items = [];
          }
        } else if (someUploadHasFailed && useUploadsManager) {
          view = VIEW_ERROR;
        } else if (someUploadIsInProgress) {
          view = VIEW_UPLOAD_IN_PROGRESS;
        } else {
          view = VIEW_UPLOAD_SUCCESS;
          if (!useUploadsManager) {
            onComplete(cloneDeep_default()(items.map(item => item.boxFile)));
            // Reset item collection after successful upload
            items = [];
          }
        }
        if (uploadItemsStatus && useUploadsManager) {
          if (this.isAutoExpanded) {
            this.resetUploadManagerExpandState();
          } // Else manually expanded so don't close
          onComplete(items);
        }
        const state = {
          items,
          view,
        };
        if (items.length === 0) {
          state.itemIds = {};
          state.errorCode = '';
        }
        this.setState(state, callback);
      }
      /**
       * Renders the content uploader
       *
       * @inheritdoc
       * @return {Component}
       */
      render() {
        const {
          className,
          fileLimit,
          isDraggingItemsToUploadsManager = false,
          isFolderUploadEnabled,
          isResumableUploadsEnabled,
          isTouch,
          language,
          measureRef,
          messages,
          onClose,
          onUpgradeCTAClick,
          useUploadsManager,
        } = this.props;
        const { view, items, errorCode, isUploadsManagerExpanded } = this.state;
        const isEmpty = items.length === 0;
        const isVisible = !isEmpty || !!isDraggingItemsToUploadsManager;
        const hasFiles = items.length !== 0;
        const isLoading = items.some(item => item.status === STATUS_IN_PROGRESS);
        const isDone = items.every(item => item.status === STATUS_COMPLETE || item.status === STATUS_STAGED);
        const styleClassName = classnames_default()('bcu', className, {
          'be-app-element': !useUploadsManager,
          be: !useUploadsManager,
        });
        return /*#__PURE__*/ react.createElement(
          common_Internationalize,
          {
            language: language,
            messages: messages,
          },
          useUploadsManager
            ? /*#__PURE__*/ react.createElement(
                'div',
                {
                  ref: measureRef,
                  className: styleClassName,
                  id: this.id,
                },
                /*#__PURE__*/ react.createElement(content_uploader_UploadsManager, {
                  isDragging: isDraggingItemsToUploadsManager,
                  isExpanded: isUploadsManagerExpanded,
                  isResumableUploadsEnabled: isResumableUploadsEnabled,
                  isVisible: isVisible,
                  items: items,
                  onItemActionClick: this.onClick,
                  onRemoveActionClick: this.removeFileFromUploadQueue,
                  onUpgradeCTAClick: onUpgradeCTAClick,
                  onUploadsManagerActionClick: this.clickAllWithStatus,
                  toggleUploadsManager: this.toggleUploadsManager,
                  view: view,
                }),
              )
            : /*#__PURE__*/ react.createElement(
                'div',
                {
                  ref: measureRef,
                  className: styleClassName,
                  id: this.id,
                },
                /*#__PURE__*/ react.createElement(content_uploader_DroppableContent, {
                  addDataTransferItemsToUploadQueue: this.addDroppedItemsToUploadQueue,
                  addFiles: this.addFilesToUploadQueue,
                  allowedTypes: ['Files'],
                  isFolderUploadEnabled: isFolderUploadEnabled,
                  isTouch: isTouch,
                  items: items,
                  onClick: this.onClick,
                  view: view,
                }),
                /*#__PURE__*/ react.createElement(content_uploader_Footer, {
                  errorCode: errorCode,
                  fileLimit: fileLimit,
                  hasFiles: hasFiles,
                  isLoading: isLoading,
                  onCancel: this.cancel,
                  onClose: onClose,
                  onUpload: this.upload,
                  isDone: isDone,
                }),
              ),
        );
      }
    }
    ContentUploader_defineProperty(ContentUploader, 'defaultProps', {
      rootFolderId: DEFAULT_ROOT,
      apiHost: DEFAULT_HOSTNAME_API,
      chunked: true,
      className: '',
      clientName: CLIENT_NAME_CONTENT_UPLOADER,
      fileLimit: FILE_LIMIT_DEFAULT,
      uploadHost: DEFAULT_HOSTNAME_UPLOAD,
      onBeforeUpload: noop_default(),
      onClickCancel: noop_default(),
      onClickResume: noop_default(),
      onClickRetry: noop_default(),
      onClose: noop_default(),
      onComplete: noop_default(),
      onError: noop_default(),
      onResume: noop_default(),
      onUpload: noop_default(),
      onProgress: noop_default(),
      overwrite: true,
      useUploadsManager: false,
      files: [],
      onMinimize: noop_default(),
      onCancel: noop_default(),
      isFolderUploadEnabled: false,
      isResumableUploadsEnabled: false,
      isUploadFallbackLogicEnabled: false,
      dataTransferItems: [],
      isDraggingItemsToUploadsManager: false,
      isPartialUploadEnabled: false,
      isPrepopulateFilesEnabled: false,
    });
    /* harmony default export */ const content_uploader_ContentUploader = common_makeResponsive(ContentUploader); // CONCATENATED MODULE: ./src/elements/content-uploader/ContentUploaderPopup.js

    /**
     *
     * @file Content Uploader Popup Component
     * @author Box
     */

    /* harmony default export */ const ContentUploaderPopup = common_makePopup(CLIENT_NAME_CONTENT_UPLOADER)(
      content_uploader_ContentUploader,
    ); // CONCATENATED MODULE: ./src/elements/content-uploader/index.js
    // CONCATENATED MODULE: ./src/elements/common/upload-dialog/UploadDialog.js
    function UploadDialog_extends() {
      return (
        (UploadDialog_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        UploadDialog_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Content Explorer Delete Confirmation Dialog
     * @author Box
     */

    const UploadDialog = ({
      isOpen,
      currentFolderId,
      token,
      sharedLink,
      sharedLinkPassword,
      apiHost,
      uploadHost,
      onClose,
      parentElement,
      appElement,
      onUpload,
      contentUploaderProps,
      requestInterceptor,
      responseInterceptor,
      intl,
    }) =>
      /*#__PURE__*/ react.createElement(
        lib_default(),
        {
          appElement: appElement,
          className: CLASS_MODAL_CONTENT_FULL_BLEED,
          contentLabel: intl.formatMessage(common_messages.upload),
          isOpen: isOpen,
          onRequestClose: onClose,
          overlayClassName: CLASS_MODAL_OVERLAY,
          parentSelector: () => parentElement,
          portalClassName: `${CLASS_MODAL} be-modal-upload`,
        },
        /*#__PURE__*/ react.createElement(
          content_uploader_ContentUploader,
          UploadDialog_extends({}, contentUploaderProps, {
            apiHost: apiHost,
            onClose: onClose,
            onComplete: onUpload,
            requestInterceptor: requestInterceptor,
            responseInterceptor: responseInterceptor,
            rootFolderId: currentFolderId,
            sharedLink: sharedLink,
            sharedLinkPassword: sharedLinkPassword,
            token: token,
            uploadHost: uploadHost,
          }),
        ),
      );
    /* harmony default export */ const upload_dialog_UploadDialog = injectIntl(UploadDialog); // CONCATENATED MODULE: ./src/elements/common/upload-dialog/index.js
    // CONCATENATED MODULE: ./src/elements/common/create-folder-dialog/CreateFolderDialog.js
    function CreateFolderDialog_extends() {
      return (
        (CreateFolderDialog_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        CreateFolderDialog_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Content Explorer Create Folder Dialog
     * @author Box
     */

    /* eslint-disable jsx-a11y/label-has-for */
    const CreateFolderDialog = ({
      isOpen,
      onCreate,
      onCancel,
      isLoading,
      errorCode,
      parentElement,
      appElement,
      intl,
    }) => {
      let textInput = null;
      let error;

      /**
       * Appends the extension and calls rename function
       */
      const create = () => {
        if (textInput && textInput.value) {
          onCreate(textInput.value);
        }
      };

      /**
       * Grabs reference to the input element
       */
      const ref = input => {
        textInput = input;
        if (textInput instanceof HTMLInputElement) {
          textInput.focus();
          textInput.select();
        }
      };

      /**
       * Handles enter key down
       */
      const onKeyDown = ({ key }) => {
        switch (key) {
          case 'Enter':
            create();
            break;
          default:
            break;
        }
      };
      switch (errorCode) {
        case ERROR_CODE_ITEM_NAME_IN_USE:
          error = common_messages.createDialogErrorInUse;
          break;
        case ERROR_CODE_ITEM_NAME_TOO_LONG:
          error = common_messages.createDialogErrorTooLong;
          break;
        default:
          error = errorCode ? common_messages.createDialogErrorInvalid : null;
          break;
      }
      return /*#__PURE__*/ react.createElement(
        lib_default(),
        {
          appElement: appElement,
          className: CLASS_MODAL_CONTENT,
          contentLabel: intl.formatMessage(common_messages.createDialogLabel),
          isOpen: isOpen,
          onRequestClose: onCancel,
          overlayClassName: CLASS_MODAL_OVERLAY,
          parentSelector: () => parentElement,
          portalClassName: CLASS_MODAL,
        },
        /*#__PURE__*/ react.createElement(
          'label',
          null,
          error
            ? /*#__PURE__*/ react.createElement(
                'div',
                {
                  className: 'be-modal-error',
                },
                /*#__PURE__*/ react.createElement(components_message, error),
              )
            : null,
          /*#__PURE__*/ react.createElement(
            components_message,
            CreateFolderDialog_extends(
              {
                tagName: 'div',
              },
              common_messages.createDialogText,
            ),
          ),
          /*#__PURE__*/ react.createElement('input', {
            ref: ref,
            onKeyDown: onKeyDown,
            required: true,
            type: 'text',
          }),
        ),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'be-modal-btns',
          },
          /*#__PURE__*/ react.createElement(
            primary_button_PrimaryButton,
            {
              'data-testid': 'be-btn-create-folder',
              isLoading: isLoading,
              onClick: create,
              type: 'button',
            },
            /*#__PURE__*/ react.createElement(components_message, common_messages.create),
          ),
          /*#__PURE__*/ react.createElement(
            button_Button,
            {
              'data-testid': 'be-btn-create-folder-cancel',
              isDisabled: isLoading,
              onClick: onCancel,
              type: 'button',
            },
            /*#__PURE__*/ react.createElement(components_message, common_messages.cancel),
          ),
        ),
      );
    };
    /* harmony default export */ const create_folder_dialog_CreateFolderDialog = injectIntl(CreateFolderDialog); // CONCATENATED MODULE: ./src/elements/common/create-folder-dialog/index.js
    // EXTERNAL MODULE: ./node_modules/lodash/range.js
    var range = __webpack_require__(99351);
    var range_default = /*#__PURE__*/ __webpack_require__.n(range); // CONCATENATED MODULE: ./src/icons/general/IconCaretDown.tsx
    const IconCaretDown_IconCaretDown = ({ className = '', color = '#000', height = 6, title, width = 10 }) =>
      /*#__PURE__*/ React.createElement(
        AccessibleSVG,
        {
          className: `icon-caret-down ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 10 6',
          width: width,
        },
        /*#__PURE__*/ React.createElement('path', {
          className: 'fill-color',
          d: 'M0 .5l5 5 5-5H0z',
          fill: color,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconCaretDown =
      /* unused pure expression or super */ null && IconCaretDown_IconCaretDown; // CONCATENATED MODULE: ./src/components/dropdown-menu/MenuToggle.js
    const MenuToggle = ({ children }) =>
      /*#__PURE__*/ React.createElement(
        'span',
        {
          className: 'menu-toggle',
        },
        children,
        /*#__PURE__*/ React.createElement(IconCaretDown, {
          className: 'toggle-arrow',
          width: 7,
        }),
      );
    /* harmony default export */ const dropdown_menu_MenuToggle =
      /* unused pure expression or super */ null && MenuToggle; // CONCATENATED MODULE: ./src/components/dropdown-menu/index.js
    // CONCATENATED MODULE: ./src/components/close-button/CloseButton.tsx
    // @ts-ignore flow import

    const close_button_CloseButton_CloseButton = ({ className, intl, onClick }) => {
      return /*#__PURE__*/ react.createElement(
        button_Button,
        {
          'aria-label': intl.formatMessage(src_common_messages.close),
          className: classnames_default()('bdl-CloseButton', className),
          'data-testid': 'bdl-CloseButton',
          onClick: onClick,
          type: ButtonType.BUTTON,
        },
        /*#__PURE__*/ react.createElement(general_IconClose, {
          color: bdlGray65,
          height: 18,
          width: 18,
        }),
      );
    };
    /* harmony default export */ const close_button_CloseButton = injectIntl(close_button_CloseButton_CloseButton); // CONCATENATED MODULE: ./src/components/close-button/index.ts
    // CONCATENATED MODULE: ./src/components/menu/MenuHeader.tsx
    const MenuHeader_excluded = /* unused pure expression or super */ null && [
      'className',
      'children',
      'subtitle',
      'title',
    ];
    function MenuHeader_extends() {
      return (
        (MenuHeader_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        MenuHeader_extends.apply(null, arguments)
      );
    }
    function MenuHeader_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = MenuHeader_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function MenuHeader_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const MenuHeader = _ref => {
      let { className, children, subtitle, title } = _ref,
        rest = MenuHeader_objectWithoutProperties(_ref, MenuHeader_excluded);
      const { closeMenu } = React.useContext(MenuContext);
      return /*#__PURE__*/ React.createElement(
        'div',
        MenuHeader_extends(
          {
            className: classNames('bdl-MenuHeader', className),
            'data-testid': 'bdl-MenuHeader',
            role: 'presentation',
          },
          rest,
        ),
        /*#__PURE__*/ React.createElement(
          'div',
          {
            className: 'bdl-MenuHeader-content',
          },
          /*#__PURE__*/ React.createElement(
            'div',
            {
              className: 'bdl-MenuHeader-title-container',
            },
            title &&
              /*#__PURE__*/ React.createElement(
                'div',
                {
                  className: 'bdl-MenuHeader-title',
                },
                title,
              ),
            subtitle &&
              /*#__PURE__*/ React.createElement(
                'div',
                {
                  className: 'bdl-MenuHeader-subtitle',
                },
                subtitle,
              ),
          ),
          children,
        ),
        /*#__PURE__*/ React.createElement(CloseButton, {
          className: 'bdl-MenuHeader-close-button',
          onClick: closeMenu,
        }),
      );
    };
    /* harmony default export */ const menu_MenuHeader = /* unused pure expression or super */ null && MenuHeader; // CONCATENATED MODULE: ./src/components/menu/MenuLinkItem.tsx
    const MenuLinkItem_excluded = /* unused pure expression or super */ null && [
      'children',
      'isSelected',
      'isSelectItem',
    ];
    function MenuLinkItem_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = MenuLinkItem_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function MenuLinkItem_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const MenuLinkItem_MenuLinkItem = _ref => {
      let { children, isSelected = false, isSelectItem = false } = _ref,
        rest = MenuLinkItem_objectWithoutProperties(_ref, MenuLinkItem_excluded);
      const linkEl = React.Children.only(children);
      const listItemProps = omit(rest, ['role', 'tabIndex']);
      listItemProps.role = 'none';
      const linkProps = {
        className: classNames('menu-item', linkEl ? linkEl.props.className : '', {
          'is-select-item': isSelectItem,
          'is-selected': isSelected,
        }),
        role: isSelectItem ? 'menuitemradio' : 'menuitem',
        tabIndex: -1,
      };
      if (isSelectItem) {
        linkProps['aria-checked'] = isSelected;
      }
      return /*#__PURE__*/ React.createElement(
        'li',
        listItemProps,
        /*#__PURE__*/ React.cloneElement(linkEl, linkProps),
      );
    };
    /* harmony default export */ const menu_MenuLinkItem =
      /* unused pure expression or super */ null && MenuLinkItem_MenuLinkItem; // CONCATENATED MODULE: ./src/components/menu/MenuSectionHeader.tsx
    const MenuSectionHeader_excluded = /* unused pure expression or super */ null && ['className'];
    function MenuSectionHeader_extends() {
      return (
        (MenuSectionHeader_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        MenuSectionHeader_extends.apply(null, arguments)
      );
    }
    function MenuSectionHeader_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = MenuSectionHeader_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function MenuSectionHeader_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const MenuSectionHeader = _ref => {
      let { className = '' } = _ref,
        rest = MenuSectionHeader_objectWithoutProperties(_ref, MenuSectionHeader_excluded);
      return /*#__PURE__*/ React.createElement(
        MenuItem,
        MenuSectionHeader_extends(
          {
            className: `menu-section-header ${className}`,
            isDisabled: true,
          },
          rest,
        ),
      );
    };
    /* harmony default export */ const menu_MenuSectionHeader =
      /* unused pure expression or super */ null && MenuSectionHeader; // CONCATENATED MODULE: ./src/components/menu/MenuSeparator.tsx
    const MenuSeparator = ({ className }) =>
      /*#__PURE__*/ React.createElement('li', {
        className: classNames('bdl-MenuSeparator', className),
        role: 'separator',
      });
    /* harmony default export */ const menu_MenuSeparator = /* unused pure expression or super */ null && MenuSeparator; // CONCATENATED MODULE: ./src/components/menu/SelectMenuLinkItem.tsx
    function SelectMenuLinkItem_extends() {
      return (
        (SelectMenuLinkItem_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        SelectMenuLinkItem_extends.apply(null, arguments)
      );
    }

    const SelectMenuLinkItem = props =>
      /*#__PURE__*/ React.createElement(
        MenuLinkItem,
        SelectMenuLinkItem_extends(
          {
            isSelectItem: true,
          },
          props,
        ),
      );
    /* harmony default export */ const menu_SelectMenuLinkItem =
      /* unused pure expression or super */ null && SelectMenuLinkItem; // CONCATENATED MODULE: ./src/icon/fill/Arrow16.tsx
    function Arrow16_extends() {
      return (
        (Arrow16_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Arrow16_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const Arrow16 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        Arrow16_extends(
          {
            width: 16,
            height: 16,
            viewBox: '0 0 16 16',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement('path', {
          fill: bdlGray50,
          fillRule: 'evenodd',
          d: 'M7.646 7.646L4.354 4.354a.5.5 0 010-.708l1.292-1.292a.5.5 0 01.708 0l5.292 5.292a.5.5 0 010 .708l-5.292 5.292a.5.5 0 01-.708 0l-1.292-1.292a.5.5 0 010-.708l3.292-3.292a.5.5 0 000-.708z',
        }),
      );
    /* harmony default export */ const fill_Arrow16 = Arrow16; // CONCATENATED MODULE: ./src/components/menu/SubmenuItem.tsx
    const SubmenuItem_excluded = ['children', 'className', 'isDisabled'];
    function SubmenuItem_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function SubmenuItem_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? SubmenuItem_ownKeys(Object(t), !0).forEach(function (r) {
              SubmenuItem_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : SubmenuItem_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function SubmenuItem_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = SubmenuItem_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function SubmenuItem_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function SubmenuItem_defineProperty(e, r, t) {
      return (
        (r = SubmenuItem_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function SubmenuItem_toPropertyKey(t) {
      var i = SubmenuItem_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function SubmenuItem_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }

    const SUBMENU_LEFT_ALIGNED_CLASS = 'is-left-aligned';
    const SUBMENU_BOTTOM_ALIGNED_CLASS = 'is-bottom-aligned';
    const SUBMENU_RIGHT_BOTTOM_ALIGNED_CLASS = 'is-right-bottom-aligned';
    /**
     * A menu-item component which triggers open a submenu
     *
     * @NOTE: Nested submenus are NOT currently supported, switching
     * focus with arrow keys in the subsubmenu is not working properly.
     */
    class SubmenuItem extends react.Component {
      constructor(...args) {
        super(...args);
        SubmenuItem_defineProperty(this, 'state', {
          isSubmenuOpen: false,
          submenuFocusIndex: null,
        });
        SubmenuItem_defineProperty(this, 'getMenuAlignmentClasses', () => {
          if (!this.submenuTriggerEl || !this.submenuEl) {
            return {};
          }
          const { rightBoundaryElement, bottomBoundaryElement } = this.props;
          const submenuElBounding = this.submenuEl.getBoundingClientRect();
          const submenuTriggerElBounding = this.submenuTriggerEl.getBoundingClientRect();
          const rightBoundaryElementBounding = rightBoundaryElement
            ? rightBoundaryElement.getBoundingClientRect()
            : {
                right: window.innerWidth,
              };
          const bottomBoundaryElementBounding = bottomBoundaryElement
            ? bottomBoundaryElement.getBoundingClientRect()
            : {
                bottom: window.innerHeight,
              };
          const isLeftAligned =
            submenuTriggerElBounding.right + submenuElBounding.width > rightBoundaryElementBounding.right;
          const isBottomAligned =
            submenuTriggerElBounding.top + submenuElBounding.height > bottomBoundaryElementBounding.bottom;
          const isRightBottomAligned =
            submenuTriggerElBounding.bottom + submenuElBounding.height > bottomBoundaryElementBounding.bottom;
          return {
            [SUBMENU_LEFT_ALIGNED_CLASS]: isLeftAligned,
            [SUBMENU_BOTTOM_ALIGNED_CLASS]: isBottomAligned,
            [SUBMENU_RIGHT_BOTTOM_ALIGNED_CLASS]: isRightBottomAligned, // Used only in medium-screen viewport sizes
          };
        });
        SubmenuItem_defineProperty(this, 'handleMenuItemClick', event => {
          const { isDisabled, onClick } = this.props;

          // If aria-disabled is passed as a prop, we should ignore clicks on this menu item
          if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
          }
          if (onClick) {
            onClick(event);
          }

          // If event target is triggering submenu element, do not propagate to close menu
          if (this.submenuEl && !this.submenuEl.contains(event.target)) {
            event.stopPropagation();
            event.preventDefault();
          }
        });
        SubmenuItem_defineProperty(this, 'handleKeyDown', event => {
          switch (event.key) {
            case ' ':
            case 'Enter':
            case 'ArrowRight':
              event.stopPropagation();
              event.preventDefault();
              this.openSubmenuAndFocus();
              break;
            default:
              break;
          }
        });
        SubmenuItem_defineProperty(
          this,
          'closeSubmenu',
          debounce_default()(() => {
            this.setState({
              isSubmenuOpen: false,
            });
          }, 50),
        );
        SubmenuItem_defineProperty(this, 'closeSubmenuAndFocusTrigger', isKeyboardEvent => {
          this.closeSubmenu();
          if (this.submenuTriggerEl && isKeyboardEvent) {
            this.submenuTriggerEl.focus();
          }
        });
        SubmenuItem_defineProperty(this, 'openSubmenu', () => {
          this.closeSubmenu.cancel();
          const { onOpen } = this.props;
          if (onOpen) {
            onOpen();
          }
          this.setState({
            isSubmenuOpen: true,
            submenuFocusIndex: null,
          });
        });
        SubmenuItem_defineProperty(this, 'openSubmenuAndFocus', () => {
          const { onOpen } = this.props;
          if (onOpen) {
            onOpen();
          }
          this.setState({
            isSubmenuOpen: true,
            submenuFocusIndex: 0,
          });
        });
      }
      render() {
        const _this$props = this.props,
          { children, className, isDisabled } = _this$props,
          rest = SubmenuItem_objectWithoutProperties(_this$props, SubmenuItem_excluded);
        const { isSubmenuOpen, submenuFocusIndex } = this.state;
        const elements = react.Children.toArray(children);
        const submenuTriggerContent = elements[0];
        const submenu = elements[1];
        if (elements.length !== 2 || !submenuTriggerContent || !submenu) {
          throw new Error('SubmenuItem must have exactly two children, a trigger component and a <Menu>');
        }
        const chevron = /*#__PURE__*/ react.createElement(fill_Arrow16, {
          className: 'menu-item-arrow',
          width: 12,
          height: 12,
        });
        const menuItemProps = SubmenuItem_objectSpread(
          SubmenuItem_objectSpread(
            {},
            omit_default()(rest, [
              'bottomBoundaryElement',
              'onClick',
              'onOpen',
              'rightBoundaryElement',
              'role',
              'tabIndex',
            ]),
          ),
          {},
          {
            'aria-disabled': isDisabled ? 'true' : undefined,
            'aria-expanded': isSubmenuOpen ? 'true' : 'false',
            'aria-haspopup': 'true',
            className: classnames_default()('menu-item', 'submenu-target', className),
            onClick: this.handleMenuItemClick,
            onMouseLeave: this.closeSubmenu,
            onMouseEnter: this.openSubmenu,
            onKeyDown: this.handleKeyDown,
            ref: ref => {
              this.submenuTriggerEl = ref;
            },
            role: 'menuitem',
            tabIndex: -1,
          },
        );
        const submenuProps = {
          className: classnames_default()(submenu.props.className, 'submenu', this.getMenuAlignmentClasses()),
          initialFocusIndex: submenuFocusIndex,
          // Hide the menu instead of unmounting it. Otherwise onMouseLeave won't work.
          isHidden: !isSubmenuOpen,
          isSubmenu: true,
          onClose: this.closeSubmenuAndFocusTrigger,
          setRef: ref => {
            this.submenuEl = ref;
          },
        };
        return /*#__PURE__*/ react.createElement(
          'li',
          menuItemProps,
          submenuTriggerContent,
          chevron,
          /*#__PURE__*/ react.cloneElement(submenu, submenuProps),
        );
      }
    }
    /* harmony default export */ const menu_SubmenuItem = /* unused pure expression or super */ null && SubmenuItem; // CONCATENATED MODULE: ./src/components/menu/index.ts
    // CONCATENATED MODULE: ./src/features/pagination/PaginationMenu.js
    function PaginationMenu_extends() {
      return (
        (PaginationMenu_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        PaginationMenu_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file PaginationMenu component
     * @author Box
     */

    const PaginationMenu = ({ onPageClick, pageCount = 0, pageNumber = 0 }) =>
      /*#__PURE__*/ react.createElement(
        dropdown_menu_DropdownMenu,
        {
          className: 'bdl-Pagination-dropdown',
          constrainToWindow: true,
          isRightAligned: true,
        },
        /*#__PURE__*/ react.createElement(
          button_Button,
          {
            className: 'bdl-Pagination-toggle',
          },
          /*#__PURE__*/ react.createElement(
            components_message,
            PaginationMenu_extends({}, common_messages.pageStatus, {
              values: {
                pageNumber,
                pageCount,
              },
            }),
          ),
        ),
        /*#__PURE__*/ react.createElement(
          menu_Menu,
          {
            className: 'bdl-Pagination-dropdownMenu',
          },
          range_default()(1, pageCount + 1).map(page =>
            /*#__PURE__*/ react.createElement(
              menu_MenuItem,
              {
                key: page,
                isDisabled: page === pageNumber,
                onClick: () => onPageClick(page),
              },
              page,
            ),
          ),
        ),
      );
    /* harmony default export */ const pagination_PaginationMenu = PaginationMenu; // CONCATENATED MODULE: ./src/components/button-group/ButtonGroup.tsx
    const ButtonGroup = ({ children, className = '', isDisabled }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: `btn-group ${className} ${isDisabled ? 'is-disabled' : ''}`,
        },
        children,
      );
    /* harmony default export */ const button_group_ButtonGroup = ButtonGroup; // CONCATENATED MODULE: ./src/components/button-group/index.ts
    // CONCATENATED MODULE: ./src/icons/general/IconPageBack.tsx
    const IconPageBack = ({ className = '', color = '#000000', height = 13, title, width = 8 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-page-back ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 8 13',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M.1 11.3l4.6-4.5L.1 2.2 1.5.8l6 6-6 6-1.4-1.5z',
          fill: color,
          fillRule: 'evenodd',
          transform: 'rotate(180 4 7)',
        }),
      );
    /* harmony default export */ const general_IconPageBack = IconPageBack; // CONCATENATED MODULE: ./src/icons/general/IconPageForward.tsx
    const IconPageForward = ({ className = '', color = '#000000', height = 13, title, width = 8 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-page-forward ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 8 13',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M.1 11.3l4.6-4.5L.1 2.2 1.5.8l6 6-6 6-1.4-1.5z',
          fill: color,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconPageForward = IconPageForward; // CONCATENATED MODULE: ./src/features/pagination/PaginationControls.js
    /**
     *
     * @file Pagination controls for navigation
     * @author Box
     */

    const PAGE_ICON_STYLE = {
      height: 9,
      width: 6,
    };
    const PaginationControls = ({
      handleNextClick,
      handlePreviousClick,
      hasNextPage,
      hasPreviousPage,
      isOffsetBasedPagination = true,
      onPageClick,
      pageCount = 0,
      pageNumber = 0,
    }) => {
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bdl-Pagination',
        },
        isOffsetBasedPagination &&
          /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'bdl-Pagination-count',
            },
            /*#__PURE__*/ react.createElement(pagination_PaginationMenu, {
              onPageClick: onPageClick,
              pageCount: pageCount,
              pageNumber: pageNumber,
            }),
          ),
        /*#__PURE__*/ react.createElement(
          button_group_ButtonGroup,
          {
            className: 'bdl-Pagination-nav',
          },
          /*#__PURE__*/ react.createElement(
            common_Tooltip,
            {
              isDisabled: !hasPreviousPage,
              text: /*#__PURE__*/ react.createElement(components_message, common_messages.previousPage),
            },
            /*#__PURE__*/ react.createElement(
              button_Button,
              {
                isDisabled: !hasPreviousPage,
                onClick: handlePreviousClick,
              },
              /*#__PURE__*/ react.createElement(general_IconPageBack, PAGE_ICON_STYLE),
            ),
          ),
          /*#__PURE__*/ react.createElement(
            common_Tooltip,
            {
              isDisabled: !hasNextPage,
              text: /*#__PURE__*/ react.createElement(components_message, common_messages.nextPage),
            },
            /*#__PURE__*/ react.createElement(
              button_Button,
              {
                isDisabled: !hasNextPage,
                onClick: handleNextClick,
              },
              /*#__PURE__*/ react.createElement(general_IconPageForward, PAGE_ICON_STYLE),
            ),
          ),
        ),
      );
    };
    /* harmony default export */ const pagination_PaginationControls = PaginationControls; // CONCATENATED MODULE: ./src/features/pagination/MarkerBasedPagination.js
    /**
     *
     * @file Offset Based Pagination component
     * @author Box
     */

    const MarkerBasedPagination = ({
      hasNextMarker = false,
      hasPrevMarker = false,
      onMarkerBasedPageChange = noop_default(),
    }) => {
      if (!hasNextMarker && !hasPrevMarker) {
        return null;
      }
      const handleNextClick = () => {
        onMarkerBasedPageChange(1);
      };
      const handlePreviousClick = () => {
        onMarkerBasedPageChange(-1);
      };
      return /*#__PURE__*/ react.createElement(pagination_PaginationControls, {
        handleNextClick: handleNextClick,
        handlePreviousClick: handlePreviousClick,
        hasNextPage: hasNextMarker,
        hasPreviousPage: hasPrevMarker,
        isOffsetBasedPagination: false,
      });
    };
    /* harmony default export */ const pagination_MarkerBasedPagination = MarkerBasedPagination; // CONCATENATED MODULE: ./src/features/pagination/OffsetBasedPagination.js
    /**
     *
     * @file Offset Based Pagination component
     * @author Box
     */

    const OffsetBasedPagination = ({
      offset = 0,
      onOffsetChange = noop_default(),
      pageSize = DEFAULT_PAGE_SIZE,
      totalCount = 0,
    }) => {
      const pageCount = Math.ceil(totalCount / pageSize);
      if (pageCount <= 1) return null;
      const pageByOffset = Math.floor(offset / pageSize) + 1;
      const pageNumber = pageByOffset > 0 ? Math.min(pageCount, pageByOffset) : 1;
      const hasNextPage = pageNumber < pageCount;
      const hasPreviousPage = pageNumber > 1;
      const updateOffset = newPageNumber => {
        let newOffset = (newPageNumber - 1) * pageSize;
        if (newOffset <= 0) {
          newOffset = 0;
        }
        if (newOffset >= totalCount) {
          newOffset = totalCount - pageSize;
        }
        onOffsetChange(newOffset);
      };
      const handleNextClick = () => {
        updateOffset(pageNumber + 1);
      };
      const handlePreviousClick = () => {
        updateOffset(pageNumber - 1);
      };
      return /*#__PURE__*/ react.createElement(pagination_PaginationControls, {
        handleNextClick: handleNextClick,
        handlePreviousClick: handlePreviousClick,
        hasNextPage: hasNextPage,
        hasPreviousPage: hasPreviousPage,
        isOffsetBasedPagination: true,
        onPageClick: updateOffset,
        pageCount: pageCount,
        pageNumber: pageNumber,
      });
    };
    /* harmony default export */ const pagination_OffsetBasedPagination = OffsetBasedPagination; // CONCATENATED MODULE: ./src/features/pagination/Pagination.js
    const Pagination_excluded = ['hasNextMarker', 'hasPrevMarker', 'onMarkerBasedPageChange'];
    function Pagination_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Pagination_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Pagination_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    /**
     *
     * @file Pagination component
     * @author Box
     */

    const Pagination = _ref => {
      let { hasNextMarker, hasPrevMarker, onMarkerBasedPageChange } = _ref,
        rest = Pagination_objectWithoutProperties(_ref, Pagination_excluded);
      if (hasNextMarker || hasPrevMarker) {
        return /*#__PURE__*/ react.createElement(pagination_MarkerBasedPagination, {
          hasNextMarker: hasNextMarker,
          hasPrevMarker: hasPrevMarker,
          onMarkerBasedPageChange: onMarkerBasedPageChange,
        });
      }
      return /*#__PURE__*/ react.createElement(pagination_OffsetBasedPagination, rest);
    };
    /* harmony default export */ const pagination_Pagination = Pagination; // CONCATENATED MODULE: ./src/features/pagination/index.js
    // EXTERNAL MODULE: ./src/utils/domPolyfill.js
    var domPolyfill = __webpack_require__(58631); // CONCATENATED MODULE: ./src/utils/dom.js
    function dom_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function dom_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? dom_ownKeys(Object(t), !0).forEach(function (r) {
              dom_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : dom_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function dom_defineProperty(e, r, t) {
      return (
        (r = dom_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function dom_toPropertyKey(t) {
      var i = dom_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function dom_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file File for some simple dom utilities
     * @author Box
     */

    /**
     * Checks if an html element is some type of input-able
     * element or text area type where characters can be typed.
     *
     * @param {HTMLElement|null} element - the dom element to check
     * @return {boolean} true if its one of the above elements
     */
    function isInputElement(element) {
      if (!element || !(element instanceof HTMLElement)) {
        return false;
      }
      const tag = element.tagName.toLowerCase();
      return (
        tag === 'input' ||
        tag === 'select' ||
        tag === 'textarea' ||
        (tag === 'div' && !!element.getAttribute('contenteditable'))
      );
    }

    /**
     * Checks if an html element is some kind of element
     * that the user would want to keep their focus on.
     *
     * @param {HTMLElement|null} element - the dom element to check
     * @return {boolean} true if its one of the above elements
     */
    function isFocusableElement(element) {
      if (!element || !(element instanceof HTMLElement)) {
        return false;
      }
      const tag = element.tagName.toLowerCase();

      // Box React UI sensitive checks
      const isCheckbox =
        element.classList.contains('checkbox-pointer-target') ||
        (element.parentElement instanceof HTMLElement
          ? element.parentElement.classList.contains('checkbox-label')
          : false);
      const isButton =
        element.classList.contains('btn-content') ||
        (element.parentElement instanceof HTMLElement && element.parentElement.classList.contains('btn')) ||
        (element.parentElement instanceof HTMLElement && element.parentElement.classList.contains('bdl-Button')) ||
        false;
      return isInputElement(element) || tag === 'button' || tag === 'a' || tag === 'option' || isCheckbox || isButton;
    }

    /**
     * Checks if a keyboard event is intended to activate an element.
     *
     * @param {SyntheticKeyboardEvent<HTMLElement>} event - The keyboard event
     * @returns {boolean} true if the event is intended to activate the element
     */
    function isActivateKey(event) {
      return event.key === KEYS.enter || event.key === KEYS.space;
    }

    /**
     * Checks if a mouse event is an unmodified left click.
     *
     * @param {SyntheticMouseEvent<HTMLElement>} event - The mouse event
     * @returns {boolean} true if the event is an unmodified left click
     */
    function isLeftClick(event) {
      return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
    }

    /**
     * Focuses a DOM element if it exists.
     *
     * @param {HTMLElement} root - the root dom element to search
     * @param {string} selector - the query selector
     * @param {boolean|void} [focusRoot] - if root should be focused
     * @return {void}
     */
    function dom_focus(root, selector, focusRoot = true) {
      if (!root) {
        return;
      }
      if (!selector) {
        root.focus();
        return;
      }
      const element = root.querySelector(selector);
      if (element && typeof element.focus === 'function') {
        element.focus();
      } else if (focusRoot) {
        root.focus();
      }
    }

    /**
     * Scrolls the container / modal / wrapper instead of the body
     *
     * @param {HTMLElement} itemEl - the base dom element to search
     * @param {Object} options - scroll into view options to override
     * @return {void}
     */
    function scrollIntoView(itemEl, options = {}) {
      // @NOTE: breaks encapsulation but alternative is unknown child ref
      if (itemEl) {
        const parentEl = itemEl.closest(`.body, .modal, .${OVERLAY_WRAPPER_CLASS}`);
        scrollIntoViewIfNeeded(
          itemEl,
          dom_objectSpread(
            {
              scrollMode: 'if-needed',
              boundary: parentEl,
            },
            options,
          ),
        );
      }
    }

    /**
     *
     * A React hook that tells you if an element (passed in as a ref) has content that overflows its container,
     * i.e., if the text is wider than the box around it.
     *
     * @param {{ current: null | HTMLElement }} contentRef
     * @return {boolean}
     */
    function useIsContentOverflowed(contentRef) {
      const [isContentOverflowed, setIsContentOverflowed] = React.useState(false);

      // This function should be set as the ref prop for the measured component.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      React.useLayoutEffect(() => {
        const { current } = contentRef;
        if (!current) {
          return;
        }
        const { offsetWidth, scrollWidth } = current;
        const willOverflow = offsetWidth < scrollWidth;
        if (willOverflow !== isContentOverflowed) {
          setIsContentOverflowed(willOverflow);
        }
      });
      return isContentOverflowed;
    } // CONCATENATED MODULE: ./src/icons/states/FolderEmptyState.tsx
    const FolderEmptyState = ({ className = '', color = bdlBoxBlue, height = 126, title, width = 130 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `folder-empty-state ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 150 150',
          width: width,
        },
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
            stroke: 'none',
            strokeWidth: '1',
          },
          /*#__PURE__*/ react.createElement('ellipse', {
            className: 'fill-color fill-opacity',
            cx: '75',
            cy: '142',
            fill: color,
            fillOpacity: '0.1',
            rx: '32.5',
            ry: '3',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M97,6.1337822 L97,5.49178758 C97,5.2201808 97.2319336,5 97.5,5 C97.7761424,5 98,5.21505737 98,5.49047852 L98,6.1337822 C98.151814,6.22160185 98.2783981,6.348186 98.3662178,6.5 L99.0095215,6.5 C99.2804053,6.5 99.5,6.73193359 99.5,7 C99.5,7.27614237 99.2849426,7.5 99.0095215,7.5 L98.3662178,7.5 C98.2783981,7.651814 98.151814,7.77839815 98,7.8662178 L98,8.50952148 C98,8.78040529 97.7680664,9 97.5,9 C97.2238576,9 97,8.76897915 97,8.49525623 L97,7.8662178 C96.848186,7.77839815 96.7216019,7.651814 96.6337822,7.5 L95.9904785,7.5 C95.7195947,7.5 95.5,7.26806641 95.5,7 C95.5,6.72385763 95.7150574,6.5 95.9904785,6.5 L96.6337822,6.5 C96.7216019,6.348186 96.848186,6.22160185 97,6.1337822 Z M9.5,89.6337822 L9.5,88.9917876 C9.5,88.7201808 9.73193359,88.5 10,88.5 C10.2761424,88.5 10.5,88.7150574 10.5,88.9904785 L10.5,89.6337822 C10.651814,89.7216019 10.7783981,89.848186 10.8662178,90 L11.5095215,90 C11.7804053,90 12,90.2319336 12,90.5 C12,90.7761424 11.7849426,91 11.5095215,91 L10.8662178,91 C10.7783981,91.151814 10.651814,91.2783981 10.5,91.3662178 L10.5,92.0095215 C10.5,92.2804053 10.2680664,92.5 10,92.5 C9.72385763,92.5 9.5,92.2689791 9.5,91.9952562 L9.5,91.3662178 C9.348186,91.2783981 9.22160185,91.151814 9.1337822,91 L8.49047852,91 C8.21959471,91 8,90.7680664 8,90.5 C8,90.2238576 8.21505737,90 8.49047852,90 L9.1337822,90 C9.22160185,89.848186 9.348186,89.7216019 9.5,89.6337822 Z M137.5,84.6337822 L137.5,83.9917876 C137.5,83.7201808 137.731934,83.5 138,83.5 C138.276142,83.5 138.5,83.7150574 138.5,83.9904785 L138.5,84.6337822 C138.651814,84.7216019 138.778398,84.848186 138.866218,85 L139.509521,85 C139.780405,85 140,85.2319336 140,85.5 C140,85.7761424 139.784943,86 139.509521,86 L138.866218,86 C138.778398,86.151814 138.651814,86.2783981 138.5,86.3662178 L138.5,87.0095215 C138.5,87.2804053 138.268066,87.5 138,87.5 C137.723858,87.5 137.5,87.2689791 137.5,86.9952562 L137.5,86.3662178 C137.348186,86.2783981 137.221602,86.151814 137.133782,86 L136.490479,86 C136.219595,86 136,85.7680664 136,85.5 C136,85.2238576 136.215057,85 136.490479,85 L137.133782,85 C137.221602,84.848186 137.348186,84.7216019 137.5,84.6337822 Z M113.5,23.1337822 L113.5,22.4917876 C113.5,22.2201808 113.731934,22 114,22 C114.276142,22 114.5,22.2150574 114.5,22.4904785 L114.5,23.1337822 C114.651814,23.2216019 114.778398,23.348186 114.866218,23.5 L115.509521,23.5 C115.780405,23.5 116,23.7319336 116,24 C116,24.2761424 115.784943,24.5 115.509521,24.5 L114.866218,24.5 C114.778398,24.651814 114.651814,24.7783981 114.5,24.8662178 L114.5,25.5095215 C114.5,25.7804053 114.268066,26 114,26 C113.723858,26 113.5,25.7689791 113.5,25.4952562 L113.5,24.8662178 C113.348186,24.7783981 113.221602,24.651814 113.133782,24.5 L112.490479,24.5 C112.219595,24.5 112,24.2680664 112,24 C112,23.7238576 112.215057,23.5 112.490479,23.5 L113.133782,23.5 C113.221602,23.348186 113.348186,23.2216019 113.5,23.1337822 Z M33.5,20.6337822 L33.5,19.9917876 C33.5,19.7201808 33.7319336,19.5 34,19.5 C34.2761424,19.5 34.5,19.7150574 34.5,19.9904785 L34.5,20.6337822 C34.651814,20.7216019 34.7783981,20.848186 34.8662178,21 L35.5095215,21 C35.7804053,21 36,21.2319336 36,21.5 C36,21.7761424 35.7849426,22 35.5095215,22 L34.8662178,22 C34.7783981,22.151814 34.651814,22.2783981 34.5,22.3662178 L34.5,23.0095215 C34.5,23.2804053 34.2680664,23.5 34,23.5 C33.7238576,23.5 33.5,23.2689791 33.5,22.9952562 L33.5,22.3662178 C33.348186,22.2783981 33.2216019,22.151814 33.1337822,22 L32.4904785,22 C32.2195947,22 32,21.7680664 32,21.5 C32,21.2238576 32.2150574,21 32.4904785,21 L33.1337822,21 C33.2216019,20.848186 33.348186,20.7216019 33.5,20.6337822 Z M132.5,52.6337822 L132.5,51.9917876 C132.5,51.7201808 132.731934,51.5 133,51.5 C133.276142,51.5 133.5,51.7150574 133.5,51.9904785 L133.5,52.6337822 C133.651814,52.7216019 133.778398,52.848186 133.866218,53 L134.509521,53 C134.780405,53 135,53.2319336 135,53.5 C135,53.7761424 134.784943,54 134.509521,54 L133.866218,54 C133.778398,54.151814 133.651814,54.2783981 133.5,54.3662178 L133.5,55.0095215 C133.5,55.2804053 133.268066,55.5 133,55.5 C132.723858,55.5 132.5,55.2689791 132.5,54.9952562 L132.5,54.3662178 C132.348186,54.2783981 132.221602,54.151814 132.133782,54 L131.490479,54 C131.219595,54 131,53.7680664 131,53.5 C131,53.2238576 131.215057,53 131.490479,53 L132.133782,53 C132.221602,52.848186 132.348186,52.7216019 132.5,52.6337822 Z M27.9375,28.7086139 L27.9375,28.3073672 C27.9375,28.137613 28.0824585,28 28.25,28 C28.422589,28 28.5625,28.1344109 28.5625,28.3065491 L28.5625,28.7086139 C28.6573838,28.7635012 28.7364988,28.8426162 28.7913861,28.9375 L29.1934509,28.9375 C29.3627533,28.9375 29.5,29.0824585 29.5,29.25 C29.5,29.422589 29.3655891,29.5625 29.1934509,29.5625 L28.7913861,29.5625 C28.7364988,29.6573838 28.6573838,29.7364988 28.5625,29.7913861 L28.5625,30.1934509 C28.5625,30.3627533 28.4175415,30.5 28.25,30.5 C28.077411,30.5 27.9375,30.355612 27.9375,30.1974433 L27.9375,29.7913861 C27.8426162,29.7364988 27.7635012,29.6573838 27.7086139,29.5625 L27.3065491,29.5625 C27.1372467,29.5625 27,29.4175415 27,29.25 C27,29.077411 27.1344109,28.9375 27.3065491,28.9375 L27.7086139,28.9375 C27.7635012,28.8426162 27.8426162,28.7635012 27.9375,28.7086139 Z M16.4375,83.7086139 L16.4375,83.3073672 C16.4375,83.137613 16.5824585,83 16.75,83 C16.922589,83 17.0625,83.1344109 17.0625,83.3065491 L17.0625,83.7086139 C17.1573838,83.7635012 17.2364988,83.8426162 17.2913861,83.9375 L17.6934509,83.9375 C17.8627533,83.9375 18,84.0824585 18,84.25 C18,84.422589 17.8655891,84.5625 17.6934509,84.5625 L17.2913861,84.5625 C17.2364988,84.6573838 17.1573838,84.7364988 17.0625,84.7913861 L17.0625,85.1934509 C17.0625,85.3627533 16.9175415,85.5 16.75,85.5 C16.577411,85.5 16.4375,85.355612 16.4375,85.1974433 L16.4375,84.7913861 C16.3426162,84.7364988 16.2635012,84.6573838 16.2086139,84.5625 L15.8065491,84.5625 C15.6372467,84.5625 15.5,84.4175415 15.5,84.25 C15.5,84.077411 15.6344109,83.9375 15.8065491,83.9375 L16.2086139,83.9375 C16.2635012,83.8426162 16.3426162,83.7635012 16.4375,83.7086139 Z M123.4375,48.2086139 L123.4375,47.8073672 C123.4375,47.637613 123.582458,47.5 123.75,47.5 C123.922589,47.5 124.0625,47.6344109 124.0625,47.8065491 L124.0625,48.2086139 C124.157384,48.2635012 124.236499,48.3426162 124.291386,48.4375 L124.693451,48.4375 C124.862753,48.4375 125,48.5824585 125,48.75 C125,48.922589 124.865589,49.0625 124.693451,49.0625 L124.291386,49.0625 C124.236499,49.1573838 124.157384,49.2364988 124.0625,49.2913861 L124.0625,49.6934509 C124.0625,49.8627533 123.917542,50 123.75,50 C123.577411,50 123.4375,49.855612 123.4375,49.6974433 L123.4375,49.2913861 C123.342616,49.2364988 123.263501,49.1573838 123.208614,49.0625 L122.806549,49.0625 C122.637247,49.0625 122.5,48.9175415 122.5,48.75 C122.5,48.577411 122.634411,48.4375 122.806549,48.4375 L123.208614,48.4375 C123.263501,48.3426162 123.342616,48.2635012 123.4375,48.2086139 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M68.8246342,87.5 C76.40963,91.8231286 93.0935221,92.3842512 94.8471309,98.1662993 C96.6007397,103.948347 51.5,108.892186 51.5,108.892186 L56.3324509,114.952313',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M109.403973,65.6681213 C121.308377,94.6323489 136.937803,71.8237566 136.937803,71.8237566',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M135,69.348975 C137.383789,74.3303392 145.105602,69 145.105602,69',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M81.0723406,87.5 C73.4873447,91.8231286 56.8034526,92.3842512 55.0498438,98.1662993 C53.296235,103.948347 98.3969748,108.892186 98.3969748,108.892186 L93.5645239,114.952313',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M13.0621966,65.6681213 C24.9666013,94.6323489 40.5960273,71.8237566 40.5960273,71.8237566',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
            transform: 'translate(26.829112, 73.012365) scale(-1, 1) translate(-26.829112, -73.012365) ',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M5,69.348975 C7.38378882,74.3303392 15.1056022,69 15.1056022,69',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
            transform: 'translate(10.052801, 70.237963) scale(-1, 1) translate(-10.052801, -70.237963) ',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M35,37.9900737 C35,37.1671287 35.6677833,36.5 36.5086652,36.5 L64.7706257,36.5 C65.6038385,36.5 66.5588137,37.1050351 66.9100361,37.8652661 L70.1170158,44.806865 C70.4653667,45.5608807 70.0812601,46.1721311 69.2572363,46.1721311 L36.4905247,46.1721311 C35.6673306,46.1721311 35,45.5073264 35,44.6820574 L35,37.9900737 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color fill-opacity',
            d: 'M36.7873881,39.9245 C36.7873881,39.101555 37.4555019,38.4344262 38.2810514,38.4344262 L63.4450865,38.4344262 C64.270014,38.4344262 65.1964383,39.054175 65.5149504,39.8202068 L68.3841724,46.7207768 C68.7023992,47.4861223 68.2883944,48.1065574 67.4517556,48.1065574 L38.2960054,48.1065574 C37.462819,48.1065574 36.7873881,47.4417526 36.7873881,46.6164836 L36.7873881,39.9245 Z',
            fill: color,
            fillOpacity: '0.1',
          }),
          /*#__PURE__*/ react.createElement('rect', {
            className: 'stroke-color fill-white',
            fill: '#FFFFFF',
            height: '53.1967213',
            rx: '1.5',
            stroke: color,
            strokeWidth: '2',
            width: '80',
            x: '35',
            y: '42.3032787',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color fill-opacity',
            d: 'M37,81.7185235 C37,80.8915052 37.6574211,80.3784293 38.4748917,80.5333945 C38.4748917,80.5333945 42.0893396,81.8018989 62.3333333,81.8018989 C74.9176315,81.8018989 80.4976661,85.1139445 87.6666667,85.1139445 C102.165889,85.1139445 111.621106,80.7823489 111.621106,80.7823489 C112.382648,80.4723656 113,80.8978342 113,81.7185235 L113,92.0025509 C113,92.8295692 112.319761,93.5 111.498955,93.5 L38.5010449,93.5 C37.6720407,93.5 37,92.8232402 37,92.0025509 L37,81.7185235 Z',
            fill: color,
            fillOpacity: '0.1',
          }),
        ),
      );
    /* harmony default export */ const states_FolderEmptyState = FolderEmptyState; // CONCATENATED MODULE: ./src/icons/states/SelectedItemsEmptyState.tsx
    const SelectedItemsEmptyState = ({ className = '', color = bdlBoxBlue, height = 126, title, width = 130 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `selected-items-empty-state ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 150 150',
          width: width,
        },
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
            id: 'Export',
            stroke: 'none',
            strokeWidth: '1',
          },
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M97,6.1337822 L97,5.49178758 C97,5.2201808 97.2319336,5 97.5,5 C97.7761424,5 98,5.21505737 98,5.49047852 L98,6.1337822 C98.151814,6.22160185 98.2783981,6.348186 98.3662178,6.5 L99.0095215,6.5 C99.2804053,6.5 99.5,6.73193359 99.5,7 C99.5,7.27614237 99.2849426,7.5 99.0095215,7.5 L98.3662178,7.5 C98.2783981,7.651814 98.151814,7.77839815 98,7.8662178 L98,8.50952148 C98,8.78040529 97.7680664,9 97.5,9 C97.2238576,9 97,8.76897915 97,8.49525623 L97,7.8662178 C96.848186,7.77839815 96.7216019,7.651814 96.6337822,7.5 L95.9904785,7.5 C95.7195947,7.5 95.5,7.26806641 95.5,7 C95.5,6.72385763 95.7150574,6.5 95.9904785,6.5 L96.6337822,6.5 C96.7216019,6.348186 96.848186,6.22160185 97,6.1337822 Z M6.5,89.6337822 L6.5,88.9917876 C6.5,88.7201808 6.73193359,88.5 7,88.5 C7.27614237,88.5 7.5,88.7150574 7.5,88.9904785 L7.5,89.6337822 C7.651814,89.7216019 7.77839815,89.848186 7.8662178,90 L8.50952148,90 C8.78040529,90 9,90.2319336 9,90.5 C9,90.7761424 8.78494263,91 8.50952148,91 L7.8662178,91 C7.77839815,91.151814 7.651814,91.2783981 7.5,91.3662178 L7.5,92.0095215 C7.5,92.2804053 7.26806641,92.5 7,92.5 C6.72385763,92.5 6.5,92.2689791 6.5,91.9952562 L6.5,91.3662178 C6.348186,91.2783981 6.22160185,91.151814 6.1337822,91 L5.49047852,91 C5.21959471,91 5,90.7680664 5,90.5 C5,90.2238576 5.21505737,90 5.49047852,90 L6.1337822,90 C6.22160185,89.848186 6.348186,89.7216019 6.5,89.6337822 Z M142.5,95.1337822 L142.5,94.4917876 C142.5,94.2201808 142.731934,94 143,94 C143.276142,94 143.5,94.2150574 143.5,94.4904785 L143.5,95.1337822 C143.651814,95.2216019 143.778398,95.348186 143.866218,95.5 L144.509521,95.5 C144.780405,95.5 145,95.7319336 145,96 C145,96.2761424 144.784943,96.5 144.509521,96.5 L143.866218,96.5 C143.778398,96.651814 143.651814,96.7783981 143.5,96.8662178 L143.5,97.5095215 C143.5,97.7804053 143.268066,98 143,98 C142.723858,98 142.5,97.7689791 142.5,97.4952562 L142.5,96.8662178 C142.348186,96.7783981 142.221602,96.651814 142.133782,96.5 L141.490479,96.5 C141.219595,96.5 141,96.2680664 141,96 C141,95.7238576 141.215057,95.5 141.490479,95.5 L142.133782,95.5 C142.221602,95.348186 142.348186,95.2216019 142.5,95.1337822 Z M113.5,17.1337822 L113.5,16.4917876 C113.5,16.2201808 113.731934,16 114,16 C114.276142,16 114.5,16.2150574 114.5,16.4904785 L114.5,17.1337822 C114.651814,17.2216019 114.778398,17.348186 114.866218,17.5 L115.509521,17.5 C115.780405,17.5 116,17.7319336 116,18 C116,18.2761424 115.784943,18.5 115.509521,18.5 L114.866218,18.5 C114.778398,18.651814 114.651814,18.7783981 114.5,18.8662178 L114.5,19.5095215 C114.5,19.7804053 114.268066,20 114,20 C113.723858,20 113.5,19.7689791 113.5,19.4952562 L113.5,18.8662178 C113.348186,18.7783981 113.221602,18.651814 113.133782,18.5 L112.490479,18.5 C112.219595,18.5 112,18.2680664 112,18 C112,17.7238576 112.215057,17.5 112.490479,17.5 L113.133782,17.5 C113.221602,17.348186 113.348186,17.2216019 113.5,17.1337822 Z M39.5,30.6337822 L39.5,29.9917876 C39.5,29.7201808 39.7319336,29.5 40,29.5 C40.2761424,29.5 40.5,29.7150574 40.5,29.9904785 L40.5,30.6337822 C40.651814,30.7216019 40.7783981,30.848186 40.8662178,31 L41.5095215,31 C41.7804053,31 42,31.2319336 42,31.5 C42,31.7761424 41.7849426,32 41.5095215,32 L40.8662178,32 C40.7783981,32.151814 40.651814,32.2783981 40.5,32.3662178 L40.5,33.0095215 C40.5,33.2804053 40.2680664,33.5 40,33.5 C39.7238576,33.5 39.5,33.2689791 39.5,32.9952562 L39.5,32.3662178 C39.348186,32.2783981 39.2216019,32.151814 39.1337822,32 L38.4904785,32 C38.2195947,32 38,31.7680664 38,31.5 C38,31.2238576 38.2150574,31 38.4904785,31 L39.1337822,31 C39.2216019,30.848186 39.348186,30.7216019 39.5,30.6337822 Z M42.5,142.133782 L42.5,141.491788 C42.5,141.220181 42.7319336,141 43,141 C43.2761424,141 43.5,141.215057 43.5,141.490479 L43.5,142.133782 C43.651814,142.221602 43.7783981,142.348186 43.8662178,142.5 L44.5095215,142.5 C44.7804053,142.5 45,142.731934 45,143 C45,143.276142 44.7849426,143.5 44.5095215,143.5 L43.8662178,143.5 C43.7783981,143.651814 43.651814,143.778398 43.5,143.866218 L43.5,144.509521 C43.5,144.780405 43.2680664,145 43,145 C42.7238576,145 42.5,144.768979 42.5,144.495256 L42.5,143.866218 C42.348186,143.778398 42.2216019,143.651814 42.1337822,143.5 L41.4904785,143.5 C41.2195947,143.5 41,143.268066 41,143 C41,142.723858 41.2150574,142.5 41.4904785,142.5 L42.1337822,142.5 C42.2216019,142.348186 42.348186,142.221602 42.5,142.133782 Z M63.4375,128.208614 L63.4375,127.807367 C63.4375,127.637613 63.5824585,127.5 63.75,127.5 C63.922589,127.5 64.0625,127.634411 64.0625,127.806549 L64.0625,128.208614 C64.1573838,128.263501 64.2364988,128.342616 64.2913861,128.4375 L64.6934509,128.4375 C64.8627533,128.4375 65,128.582458 65,128.75 C65,128.922589 64.8655891,129.0625 64.6934509,129.0625 L64.2913861,129.0625 C64.2364988,129.157384 64.1573838,129.236499 64.0625,129.291386 L64.0625,129.693451 C64.0625,129.862753 63.9175415,130 63.75,130 C63.577411,130 63.4375,129.855612 63.4375,129.697443 L63.4375,129.291386 C63.3426162,129.236499 63.2635012,129.157384 63.2086139,129.0625 L62.8065491,129.0625 C62.6372467,129.0625 62.5,128.917542 62.5,128.75 C62.5,128.577411 62.6344109,128.4375 62.8065491,128.4375 L63.2086139,128.4375 C63.2635012,128.342616 63.3426162,128.263501 63.4375,128.208614 Z M132.5,122.633782 L132.5,121.991788 C132.5,121.720181 132.731934,121.5 133,121.5 C133.276142,121.5 133.5,121.715057 133.5,121.990479 L133.5,122.633782 C133.651814,122.721602 133.778398,122.848186 133.866218,123 L134.509521,123 C134.780405,123 135,123.231934 135,123.5 C135,123.776142 134.784943,124 134.509521,124 L133.866218,124 C133.778398,124.151814 133.651814,124.278398 133.5,124.366218 L133.5,125.009521 C133.5,125.280405 133.268066,125.5 133,125.5 C132.723858,125.5 132.5,125.268979 132.5,124.995256 L132.5,124.366218 C132.348186,124.278398 132.221602,124.151814 132.133782,124 L131.490479,124 C131.219595,124 131,123.768066 131,123.5 C131,123.223858 131.215057,123 131.490479,123 L132.133782,123 C132.221602,122.848186 132.348186,122.721602 132.5,122.633782 Z M33.9375,38.7086139 L33.9375,38.3073672 C33.9375,38.137613 34.0824585,38 34.25,38 C34.422589,38 34.5625,38.1344109 34.5625,38.3065491 L34.5625,38.7086139 C34.6573838,38.7635012 34.7364988,38.8426162 34.7913861,38.9375 L35.1934509,38.9375 C35.3627533,38.9375 35.5,39.0824585 35.5,39.25 C35.5,39.422589 35.3655891,39.5625 35.1934509,39.5625 L34.7913861,39.5625 C34.7364988,39.6573838 34.6573838,39.7364988 34.5625,39.7913861 L34.5625,40.1934509 C34.5625,40.3627533 34.4175415,40.5 34.25,40.5 C34.077411,40.5 33.9375,40.355612 33.9375,40.1974433 L33.9375,39.7913861 C33.8426162,39.7364988 33.7635012,39.6573838 33.7086139,39.5625 L33.3065491,39.5625 C33.1372467,39.5625 33,39.4175415 33,39.25 C33,39.077411 33.1344109,38.9375 33.3065491,38.9375 L33.7086139,38.9375 C33.7635012,38.8426162 33.8426162,38.7635012 33.9375,38.7086139 Z M16.4375,107.708614 L16.4375,107.307367 C16.4375,107.137613 16.5824585,107 16.75,107 C16.922589,107 17.0625,107.134411 17.0625,107.306549 L17.0625,107.708614 C17.1573838,107.763501 17.2364988,107.842616 17.2913861,107.9375 L17.6934509,107.9375 C17.8627533,107.9375 18,108.082458 18,108.25 C18,108.422589 17.8655891,108.5625 17.6934509,108.5625 L17.2913861,108.5625 C17.2364988,108.657384 17.1573838,108.736499 17.0625,108.791386 L17.0625,109.193451 C17.0625,109.362753 16.9175415,109.5 16.75,109.5 C16.577411,109.5 16.4375,109.355612 16.4375,109.197443 L16.4375,108.791386 C16.3426162,108.736499 16.2635012,108.657384 16.2086139,108.5625 L15.8065491,108.5625 C15.6372467,108.5625 15.5,108.417542 15.5,108.25 C15.5,108.077411 15.6344109,107.9375 15.8065491,107.9375 L16.2086139,107.9375 C16.2635012,107.842616 16.3426162,107.763501 16.4375,107.708614 Z M123.4375,118.208614 L123.4375,117.807367 C123.4375,117.637613 123.582458,117.5 123.75,117.5 C123.922589,117.5 124.0625,117.634411 124.0625,117.806549 L124.0625,118.208614 C124.157384,118.263501 124.236499,118.342616 124.291386,118.4375 L124.693451,118.4375 C124.862753,118.4375 125,118.582458 125,118.75 C125,118.922589 124.865589,119.0625 124.693451,119.0625 L124.291386,119.0625 C124.236499,119.157384 124.157384,119.236499 124.0625,119.291386 L124.0625,119.693451 C124.0625,119.862753 123.917542,120 123.75,120 C123.577411,120 123.4375,119.855612 123.4375,119.697443 L123.4375,119.291386 C123.342616,119.236499 123.263501,119.157384 123.208614,119.0625 L122.806549,119.0625 C122.637247,119.0625 122.5,118.917542 122.5,118.75 C122.5,118.577411 122.634411,118.4375 122.806549,118.4375 L123.208614,118.4375 C123.263501,118.342616 123.342616,118.263501 123.4375,118.208614 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M43.4804692,103.174876 L41.1752714,101.240586 C40.7617585,100.893607 40.1285056,100.946696 39.7735038,101.369771 C39.416027,101.795795 39.4705231,102.420947 39.8896962,102.772675 L42.9680029,105.355681 C43.1743888,105.528859 43.4355129,105.602379 43.6894604,105.57998 C43.9483712,105.55797 44.1918657,105.438515 44.3678615,105.228771 L48.2284051,100.627954 C48.5780776,100.211231 48.526314,99.5763992 48.1032393,99.2213974 C47.6772151,98.8639206 47.0502638,98.920561 46.6963163,99.3423792 L43.4804692,103.174876 Z M37,102 C37,98.1340068 40.1350851,95 44.0024366,95 L94.9975634,95 C98.8649024,95 102,98.1418733 102,102 C102,105.865993 98.8649149,109 94.9975634,109 L44.0024366,109 C40.1350976,109 37,105.858127 37,102 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('rect', {
            className: 'stroke-color fill-white',
            fill: '#FFFFFF',
            height: '60',
            rx: '1.5',
            stroke: color,
            strokeWidth: '2',
            width: '40',
            x: '62',
            y: '53',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M33.4804692,85.1748765 L31.1752714,83.2405859 C30.7617585,82.8936073 30.1285056,82.9466958 29.7735038,83.3697705 C29.416027,83.7957948 29.4705231,84.4209468 29.8896962,84.7726747 L32.9680029,87.3556808 C33.1743888,87.5288591 33.4355129,87.6023789 33.6894604,87.57998 C33.9483712,87.5579702 34.1918657,87.4385148 34.3678615,87.2287712 L38.2284051,82.6279545 C38.5780776,82.211231 38.526314,81.5763992 38.1032393,81.2213974 C37.6772151,80.8639206 37.0502638,80.920561 36.6963163,81.3423792 L33.4804692,85.1748765 Z M27,84 C27,80.1340068 30.1350851,77 34.0024366,77 L84.9975634,77 C88.8649024,77 92,80.1418733 92,84 C92,87.8659932 88.8649149,91 84.9975634,91 L34.0024366,91 C30.1350976,91 27,87.8581267 27,84 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('rect', {
            className: 'stroke-color fill-white',
            fill: '#FFFFFF',
            height: '60',
            rx: '1.5',
            stroke: color,
            strokeWidth: '2',
            width: '40',
            x: '70',
            y: '37',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M79,46.4981237 C79,45.6707328 79.6757415,45 80.4989041,45 L112.911044,45 C113.738866,45 114.834395,45.5280187 115.346944,46.1656381 L123.063004,55.7645454 C123.580493,56.4083096 124,57.6097136 124,58.4215292 L124,103.508654 C124,104.332302 123.328952,105 122.502769,105 L80.4972305,105 C79.6703329,105 79,104.326172 79,103.501876 L79,46.4981237 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M86.5,70 C86.5,69.4477153 86.9473652,69 87.4981537,69 L115.501846,69 C116.053111,69 116.5,69.4438648 116.5,70 C116.5,70.5522847 116.052635,71 115.501846,71 L87.4981537,71 C86.9468886,71 86.5,70.5561352 86.5,70 Z M86.5,75 C86.5,74.4477153 86.9473652,74 87.4981537,74 L115.501846,74 C116.053111,74 116.5,74.4438648 116.5,75 C116.5,75.5522847 116.052635,76 115.501846,76 L87.4981537,76 C86.9468886,76 86.5,75.5561352 86.5,75 Z M86.5,80 C86.5,79.4477153 86.9449463,79 87.4933977,79 L103.506602,79 C104.055241,79 104.5,79.4438648 104.5,80 C104.5,80.5522847 104.055054,81 103.506602,81 L87.4933977,81 C86.9447593,81 86.5,80.5561352 86.5,80 Z M106.9,80 C106.9,79.4477153 107.350975,79 107.890778,79 L111.909222,79 C112.456414,79 112.9,79.4438648 112.9,80 C112.9,80.5522847 112.449025,81 111.909222,81 L107.890778,81 C107.343586,81 106.9,80.5561352 106.9,80 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color fill-opacity',
            d: 'M81,93.0952639 C81,92.2673619 81.6405192,91.819868 82.4446313,92.0247586 C82.4446313,92.0247586 83.7455648,92.9506249 94.6666667,92.9506249 C101.455564,92.9506249 104.465846,95.7883014 108.333333,95.7883014 C116.155282,95.7883014 120.733786,92.3847142 120.733786,92.3847142 C121.433097,91.949238 122,92.2738296 122,93.0952639 L122,101.474211 C122,102.302113 121.322576,102.973261 120.492164,102.973261 L82.5078364,102.973261 C81.6750814,102.973261 81,102.295646 81,101.474211 L81,93.0952639 Z',
            fill: color,
            fillOpacity: '0.1',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M123,56 L114.615019,56 C113.723068,56 113,55.2734286 113,54.3849814 L113,46',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M51.4997804,57 C51.5159706,57 58.357785,57.0000513 62,57.0001537 M62,71 L50.5002196,71 C46.3579627,71 42.8594173,70.1626263 42.8594173,66.0195799',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M42.860937,66.126647 C42.860937,63.7364857 44.5317428,61.2152184 47.5857812,61 L81.4999054,61 C83.4329543,61 85,61.5709366 85,63.5 C85,65.4329966 83.4293087,66 81.4999054,66 L51.887125,66',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
        ),
      );
    /* harmony default export */ const states_SelectedItemsEmptyState = SelectedItemsEmptyState; // CONCATENATED MODULE: ./src/icons/states/SearchEmptyState.tsx
    const SearchEmptyState = ({ className = '', color = bdlBoxBlue, height = 180, title, width = 180 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `search-empty-state ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 150 150',
          width: width,
        },
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
            stroke: 'none',
            strokeWidth: '1',
          },
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M65.5,6.1337822 L65.5,5.49178758 C65.5,5.2201808 65.7319336,5 66,5 C66.2761424,5 66.5,5.21505737 66.5,5.49047852 L66.5,6.1337822 C66.651814,6.22160185 66.7783981,6.348186 66.8662178,6.5 L67.5095215,6.5 C67.7804053,6.5 68,6.73193359 68,7 C68,7.27614237 67.7849426,7.5 67.5095215,7.5 L66.8662178,7.5 C66.7783981,7.651814 66.651814,7.77839815 66.5,7.8662178 L66.5,8.50952148 C66.5,8.78040529 66.2680664,9 66,9 C65.7238576,9 65.5,8.76897915 65.5,8.49525623 L65.5,7.8662178 C65.348186,7.77839815 65.2216019,7.651814 65.1337822,7.5 L64.4904785,7.5 C64.2195947,7.5 64,7.26806641 64,7 C64,6.72385763 64.2150574,6.5 64.4904785,6.5 L65.1337822,6.5 C65.2216019,6.348186 65.348186,6.22160185 65.5,6.1337822 Z M11,78.6337822 L11,77.9917876 C11,77.7201808 11.2319336,77.5 11.5,77.5 C11.7761424,77.5 12,77.7150574 12,77.9904785 L12,78.6337822 C12.151814,78.7216019 12.2783981,78.848186 12.3662178,79 L13.0095215,79 C13.2804053,79 13.5,79.2319336 13.5,79.5 C13.5,79.7761424 13.2849426,80 13.0095215,80 L12.3662178,80 C12.2783981,80.151814 12.151814,80.2783981 12,80.3662178 L12,81.0095215 C12,81.2804053 11.7680664,81.5 11.5,81.5 C11.2238576,81.5 11,81.2689791 11,80.9952562 L11,80.3662178 C10.848186,80.2783981 10.7216019,80.151814 10.6337822,80 L9.99047852,80 C9.71959471,80 9.5,79.7680664 9.5,79.5 C9.5,79.2238576 9.71505737,79 9.99047852,79 L10.6337822,79 C10.7216019,78.848186 10.848186,78.7216019 11,78.6337822 Z M142.5,81.6337822 L142.5,80.9917876 C142.5,80.7201808 142.731934,80.5 143,80.5 C143.276142,80.5 143.5,80.7150574 143.5,80.9904785 L143.5,81.6337822 C143.651814,81.7216019 143.778398,81.848186 143.866218,82 L144.509521,82 C144.780405,82 145,82.2319336 145,82.5 C145,82.7761424 144.784943,83 144.509521,83 L143.866218,83 C143.778398,83.151814 143.651814,83.2783981 143.5,83.3662178 L143.5,84.0095215 C143.5,84.2804053 143.268066,84.5 143,84.5 C142.723858,84.5 142.5,84.2689791 142.5,83.9952562 L142.5,83.3662178 C142.348186,83.2783981 142.221602,83.151814 142.133782,83 L141.490479,83 C141.219595,83 141,82.7680664 141,82.5 C141,82.2238576 141.215057,82 141.490479,82 L142.133782,82 C142.221602,81.848186 142.348186,81.7216019 142.5,81.6337822 Z M47,23.1337822 L47,22.4917876 C47,22.2201808 47.2319336,22 47.5,22 C47.7761424,22 48,22.2150574 48,22.4904785 L48,23.1337822 C48.151814,23.2216019 48.2783981,23.348186 48.3662178,23.5 L49.0095215,23.5 C49.2804053,23.5 49.5,23.7319336 49.5,24 C49.5,24.2761424 49.2849426,24.5 49.0095215,24.5 L48.3662178,24.5 C48.2783981,24.651814 48.151814,24.7783981 48,24.8662178 L48,25.5095215 C48,25.7804053 47.7680664,26 47.5,26 C47.2238576,26 47,25.7689791 47,25.4952562 L47,24.8662178 C46.848186,24.7783981 46.7216019,24.651814 46.6337822,24.5 L45.9904785,24.5 C45.7195947,24.5 45.5,24.2680664 45.5,24 C45.5,23.7238576 45.7150574,23.5 45.9904785,23.5 L46.6337822,23.5 C46.7216019,23.348186 46.848186,23.2216019 47,23.1337822 Z M92,24.6337822 L92,23.9917876 C92,23.7201808 92.2319336,23.5 92.5,23.5 C92.7761424,23.5 93,23.7150574 93,23.9904785 L93,24.6337822 C93.151814,24.7216019 93.2783981,24.848186 93.3662178,25 L94.0095215,25 C94.2804053,25 94.5,25.2319336 94.5,25.5 C94.5,25.7761424 94.2849426,26 94.0095215,26 L93.3662178,26 C93.2783981,26.151814 93.151814,26.2783981 93,26.3662178 L93,27.0095215 C93,27.2804053 92.7680664,27.5 92.5,27.5 C92.2238576,27.5 92,27.2689791 92,26.9952562 L92,26.3662178 C91.848186,26.2783981 91.7216019,26.151814 91.6337822,26 L90.9904785,26 C90.7195947,26 90.5,25.7680664 90.5,25.5 C90.5,25.2238576 90.7150574,25 90.9904785,25 L91.6337822,25 C91.7216019,24.848186 91.848186,24.7216019 92,24.6337822 Z M137,44.6337822 L137,43.9917876 C137,43.7201808 137.231934,43.5 137.5,43.5 C137.776142,43.5 138,43.7150574 138,43.9904785 L138,44.6337822 C138.151814,44.7216019 138.278398,44.848186 138.366218,45 L139.009521,45 C139.280405,45 139.5,45.2319336 139.5,45.5 C139.5,45.7761424 139.284943,46 139.009521,46 L138.366218,46 C138.278398,46.151814 138.151814,46.2783981 138,46.3662178 L138,47.0095215 C138,47.2804053 137.768066,47.5 137.5,47.5 C137.223858,47.5 137,47.2689791 137,46.9952562 L137,46.3662178 C136.848186,46.2783981 136.721602,46.151814 136.633782,46 L135.990479,46 C135.719595,46 135.5,45.7680664 135.5,45.5 C135.5,45.2238576 135.715057,45 135.990479,45 L136.633782,45 C136.721602,44.848186 136.848186,44.7216019 137,44.6337822 Z M26.4375,26.7086139 L26.4375,26.3073672 C26.4375,26.137613 26.5824585,26 26.75,26 C26.922589,26 27.0625,26.1344109 27.0625,26.3065491 L27.0625,26.7086139 C27.1573838,26.7635012 27.2364988,26.8426162 27.2913861,26.9375 L27.6934509,26.9375 C27.8627533,26.9375 28,27.0824585 28,27.25 C28,27.422589 27.8655891,27.5625 27.6934509,27.5625 L27.2913861,27.5625 C27.2364988,27.6573838 27.1573838,27.7364988 27.0625,27.7913861 L27.0625,28.1934509 C27.0625,28.3627533 26.9175415,28.5 26.75,28.5 C26.577411,28.5 26.4375,28.355612 26.4375,28.1974433 L26.4375,27.7913861 C26.3426162,27.7364988 26.2635012,27.6573838 26.2086139,27.5625 L25.8065491,27.5625 C25.6372467,27.5625 25.5,27.4175415 25.5,27.25 C25.5,27.077411 25.6344109,26.9375 25.8065491,26.9375 L26.2086139,26.9375 C26.2635012,26.8426162 26.3426162,26.7635012 26.4375,26.7086139 Z M5.9375,66.7086139 L5.9375,66.3073672 C5.9375,66.137613 6.0824585,66 6.25,66 C6.42258898,66 6.5625,66.1344109 6.5625,66.3065491 L6.5625,66.7086139 C6.65738375,66.7635012 6.73649884,66.8426162 6.79138613,66.9375 L7.19345093,66.9375 C7.36275331,66.9375 7.5,67.0824585 7.5,67.25 C7.5,67.422589 7.36558914,67.5625 7.19345093,67.5625 L6.79138613,67.5625 C6.73649884,67.6573838 6.65738375,67.7364988 6.5625,67.7913861 L6.5625,68.1934509 C6.5625,68.3627533 6.4175415,68.5 6.25,68.5 C6.07741102,68.5 5.9375,68.355612 5.9375,68.1974433 L5.9375,67.7913861 C5.84261625,67.7364988 5.76350116,67.6573838 5.70861387,67.5625 L5.30654907,67.5625 C5.13724669,67.5625 5,67.4175415 5,67.25 C5,67.077411 5.13441086,66.9375 5.30654907,66.9375 L5.70861387,66.9375 C5.76350116,66.8426162 5.84261625,66.7635012 5.9375,66.7086139 Z M128.4375,35.2086139 L128.4375,34.8073672 C128.4375,34.637613 128.582458,34.5 128.75,34.5 C128.922589,34.5 129.0625,34.6344109 129.0625,34.8065491 L129.0625,35.2086139 C129.157384,35.2635012 129.236499,35.3426162 129.291386,35.4375 L129.693451,35.4375 C129.862753,35.4375 130,35.5824585 130,35.75 C130,35.922589 129.865589,36.0625 129.693451,36.0625 L129.291386,36.0625 C129.236499,36.1573838 129.157384,36.2364988 129.0625,36.2913861 L129.0625,36.6934509 C129.0625,36.8627533 128.917542,37 128.75,37 C128.577411,37 128.4375,36.855612 128.4375,36.6974433 L128.4375,36.2913861 C128.342616,36.2364988 128.263501,36.1573838 128.208614,36.0625 L127.806549,36.0625 C127.637247,36.0625 127.5,35.9175415 127.5,35.75 C127.5,35.577411 127.634411,35.4375 127.806549,35.4375 L128.208614,35.4375 C128.263501,35.3426162 128.342616,35.2635012 128.4375,35.2086139 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M28.6960227,56.1349895 C28.6960227,55.1429691 29.4786923,54.1926774 30.4600887,54.0260004 C30.4600887,54.0260004 36.4804935,52.7556391 46.2317709,52.7556391 C57.3677087,52.7556391 66.0324375,54.0948818 66.0324375,54.0948818 C67.0148852,54.2295817 67.8113164,55.1487922 67.8113164,56.1438829 L67.8113164,104.101951 C67.8113164,105.098883 67.0004601,105.966124 66.0231367,106.037317 C66.0231367,106.037317 57.0783775,106.688942 48.2536696,107.331436 C39.4289616,107.97393 30.4312685,110.298757 30.4312685,110.298757 C29.4729187,110.530897 28.6960227,109.922074 28.6960227,108.922872 L28.6960227,56.1349895 Z M107.774385,56.1349895 C107.774385,55.1429691 106.991715,54.1926774 106.010319,54.0260004 C106.010319,54.0260004 99.9899138,52.7556391 90.2386364,52.7556391 C79.1026986,52.7556391 70.4379698,54.0948818 70.4379698,54.0948818 C69.4555221,54.2295817 68.6590909,55.1487922 68.6590909,56.1438829 L68.6590909,104.101951 C68.6590909,105.098883 69.4699472,105.966124 70.4472706,106.037317 C70.4472706,106.037317 79.3920298,106.688942 88.2167377,107.331436 C97.0414457,107.97393 106.039139,110.298757 106.039139,110.298757 C106.997489,110.530897 107.774385,109.922074 107.774385,108.922872 L107.774385,56.1349895 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M24.5,55.5385148 C24.5,54.5437169 25.2937254,53.6358332 26.2842442,53.5154783 C26.2842442,53.5154783 36.328268,52.1541353 46.0795455,52.1541353 C57.2154833,52.1541353 65.880212,53.493378 65.880212,53.493378 C66.8626597,53.628078 67.6590909,54.5450678 67.6590909,55.5385148 L67.6590909,104.707319 C67.6590909,105.702117 66.854409,106.397236 65.873167,106.269834 C65.873167,106.269834 56.8693182,104.925421 46.0795455,104.925421 C35.2897727,104.925421 26.2723499,106.271548 26.2723499,106.271548 C25.2935081,106.402446 24.5,105.700766 24.5,104.707319 L24.5,55.5385148 Z M67.6590909,55.5385148 C67.6590909,54.5437169 68.4528163,53.6358332 69.4433351,53.5154783 C69.4433351,53.5154783 79.4873589,52.1541353 89.2386364,52.1541353 C100.374574,52.1541353 109.039303,53.493378 109.039303,53.493378 C110.021751,53.628078 110.818182,54.5450678 110.818182,55.5385148 L110.818182,104.707319 C110.818182,105.702117 110.0135,106.397236 109.032258,106.269834 C109.032258,106.269834 100.028409,104.925421 89.2386364,104.925421 C78.4488636,104.925421 69.4314408,106.271548 69.4314408,106.271548 C68.452599,106.402446 67.6590909,105.700766 67.6590909,104.707319 L67.6590909,55.5385148 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color fill-opacity',
            d: 'M75,145 C92.9492544,145 107.5,143.656854 107.5,142 C107.5,140.343146 92.9492544,139 75,139 C57.0507456,139 42.5,140.343146 42.5,142 C42.5,143.656854 57.0507456,145 75,145 Z M73.6534091,56.1363656 C73.6534091,55.1435852 74.4449488,54.4789956 75.4238059,54.652396 L80.3251831,55.5206542 L78.9752933,58.7180233 C78.5889267,59.633177 78.8348134,60.9519608 79.5331474,61.6725356 L85.4008667,67.7271331 L80.3251831,79.4305004 L85.4008667,90.8693423 L79.566026,96.600942 C78.8534067,97.3009522 78.8094216,98.4791911 79.4650655,99.2295031 L82.628255,102.849424 L75.4265498,104.11876 C74.4472712,104.291362 73.6534091,103.624162 73.6534091,102.633696 L73.6534091,56.1363656 Z',
            fill: color,
            fillOpacity: '0.1',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M67.6590909,55.5385148 C67.6590909,54.5437169 68.4398495,53.9274678 69.410837,54.1640018 L76.6339368,55.9235594 L74.2082646,59.7351425 C73.6771908,60.569646 73.8423899,61.7847372 74.579969,62.4515857 L81.0026388,68.2583499 L75.4517045,79.7540898 L81.0026388,89.9057851 L74.5014209,96.5802373 C73.8084414,97.2916823 73.8804366,98.3579493 74.6693627,98.9673234 L77.9459525,101.498192 L69.2777292,105.720178 C68.38378,106.155589 67.6590909,105.700766 67.6590909,104.707319 L67.6590909,55.5385148 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color',
            d: 'M31.09375,74.8061271 C31.09375,74.2550262 31.5411152,73.8082707 32.0919037,73.8082707 L60.0955963,73.8082707 C60.6468614,73.8082707 61.09375,74.251184 61.09375,74.8061271 C61.09375,75.3572279 60.6463848,75.8039834 60.0955963,75.8039834 L32.0919037,75.8039834 C31.5406386,75.8039834 31.09375,75.3610701 31.09375,74.8061271 Z M31.09375,80.8082707 C31.09375,80.2571698 31.5411152,79.8104143 32.0919037,79.8104143 L60.0955963,79.8104143 C60.6468614,79.8104143 61.09375,80.2533276 61.09375,80.8082707 C61.09375,81.3593715 60.6463848,81.8061271 60.0955963,81.8061271 L32.0919037,81.8061271 C31.5406386,81.8061271 31.09375,81.3632137 31.09375,80.8082707 Z M31.09375,86.8104143 C31.09375,86.2593134 31.5386963,85.8125579 32.0871477,85.8125579 L48.1003523,85.8125579 C48.6489907,85.8125579 49.09375,86.2554713 49.09375,86.8104143 C49.09375,87.3615152 48.6488037,87.8082707 48.1003523,87.8082707 L32.0871477,87.8082707 C31.5385093,87.8082707 31.09375,87.3653573 31.09375,86.8104143 Z M51.49375,86.8104143 C51.49375,86.2593134 51.9447252,85.8125579 52.484528,85.8125579 L56.502972,85.8125579 C57.0501636,85.8125579 57.49375,86.2554713 57.49375,86.8104143 C57.49375,87.3615152 57.0427748,87.8082707 56.502972,87.8082707 L52.484528,87.8082707 C51.9373364,87.8082707 51.49375,87.3653573 51.49375,86.8104143 Z',
            fill: color,
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M48.5273522,34.7647694 C48.5467621,34.7647694 49.5559827,34.7648311 53.5032935,34.7649543 M53.7433867,52.8098822 C48.8081991,52.8098822 47.3290151,52.8098822 47.3290151,52.8098822 C42.3630139,52.8098822 38.168735,50.5995078 38.168735,45.6153919',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
            transform: 'translate(45.956061, 43.787326) rotate(90.000000) translate(-45.956061, -43.787326) ',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M29.9425084,54.2248865 C29.9425084,51.3495045 31.9455767,48.3164009 35.6069523,48.0574916 L58.2824081,48.0574916 C60.5998701,48.0574916 62.4785442,49.9473402 62.4785442,52.2680179 C62.4785442,54.5934274 60.5954995,56.4785442 58.2824081,56.4785442 L39.5648134,56.4785442',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
            transform: 'translate(46.210526, 52.268018) rotate(90.000000) translate(-46.210526, -52.268018) ',
          }),
          /*#__PURE__*/ react.createElement('rect', {
            className: 'stroke-color fill-white',
            fill: '#FFFFFF',
            height: '8.42105263',
            rx: '1',
            stroke: color,
            strokeWidth: '2',
            transform:
              'translate(116.761439, 60.552519) scale(-1, 1) rotate(45.000000) translate(-116.761439, -60.552519) ',
            width: '4.79545455',
            x: '114.363712',
            y: '56.3419929',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color fill-white',
            d: 'M123.539164,61.3515768 C123.147424,60.9598368 122.510815,60.9613104 122.125838,61.3462876 L117.599803,65.8723224 C117.210984,66.2611412 117.214326,66.8948826 117.605092,67.285649 L128.095643,77.7762001 C128.487383,78.16794 129.123992,78.1664665 129.50897,77.7814893 L134.035004,73.2554545 C134.423823,72.8666357 134.420482,72.2328943 134.029715,71.8421279 L123.539164,61.3515768 Z M103.329545,63.481203 C112.268086,63.481203 119.514205,56.210038 119.514205,47.2406015 C119.514205,38.271165 112.268086,31 103.329545,31 C94.3910051,31 87.1448864,38.271165 87.1448864,47.2406015 C87.1448864,56.210038 94.3910051,63.481203 103.329545,63.481203 Z',
            fill: '#FFFFFF',
            stroke: color,
            strokeWidth: '2',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'fill-color fill-opacity',
            d: 'M121.963311,65.663821 C121.727831,65.4283409 121.342447,65.4319361 121.109104,65.66528 L120.269321,66.5050623 C120.033035,66.7413482 120.036926,67.1283342 120.267862,67.3592702 L128.772316,75.8637239 C129.007796,76.099204 129.39318,76.0956087 129.626524,75.8622649 L130.466306,75.0224825 C130.702592,74.7861966 130.698701,74.3992106 130.467765,74.1682747 L121.963311,65.663821 Z M96.3596054,58.705387 C98.3267224,59.8307464 91.7811151,47.2744178 98.1580266,40.8099242 C104.534938,34.3454307 115.990851,42.6502669 115.057515,40.8099242 C114.701837,40.1086033 114.287033,39.4425406 113.819691,38.8183475 C111.359011,35.5318067 107.441818,33.406015 103.02983,33.406015 C95.5810459,33.406015 89.5426136,39.4653192 89.5426136,46.9398496 C89.5426136,51.9796152 92.2878329,56.3759843 96.3596054,58.705387 Z',
            fill: color,
            fillOpacity: '0.1',
          }),
          /*#__PURE__*/ react.createElement('path', {
            className: 'stroke-color',
            d: 'M103.329545,36.4135338 C97.3705185,36.4135338 92.5397727,41.2609771 92.5397727,47.2406015 C92.5397727,48.6694994 92.81562,50.033747 93.3167936,51.2826485',
            stroke: color,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2',
          }),
        ),
      );
    /* harmony default export */ const states_SearchEmptyState = SearchEmptyState; // CONCATENATED MODULE: ./src/elements/common/empty-state/EmptyState.js
    /**
     *
     * @file Empty state component
     * @author Box
     */

    const EmptyState = ({ view, isLoading }) => {
      let type;
      const message =
        isLoading && (view === VIEW_FOLDER || view === VIEW_METADATA)
          ? /*#__PURE__*/ react.createElement(components_message, common_messages.loadingState)
          : /*#__PURE__*/ react.createElement(components_message, common_messages[`${view}State`]);
      switch (view) {
        case VIEW_ERROR:
          type = /*#__PURE__*/ react.createElement(states_ErrorEmptyState, null);
          break;
        case VIEW_SELECTED:
          type = /*#__PURE__*/ react.createElement(states_SelectedItemsEmptyState, null);
          break;
        case VIEW_SEARCH:
          type = /*#__PURE__*/ react.createElement(states_SearchEmptyState, null);
          break;
        default:
          type = /*#__PURE__*/ react.createElement(states_FolderEmptyState, null);
          break;
      }
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-empty',
        },
        type,
        /*#__PURE__*/ react.createElement('div', null, message),
      );
    };
    /* harmony default export */ const empty_state_EmptyState = EmptyState; // CONCATENATED MODULE: ./src/elements/common/empty-state/index.js
    // CONCATENATED MODULE: ./src/elements/common/progress-bar/ProgressBar.js
    function progress_bar_ProgressBar_defineProperty(e, r, t) {
      return (
        (r = progress_bar_ProgressBar_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function progress_bar_ProgressBar_toPropertyKey(t) {
      var i = progress_bar_ProgressBar_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function progress_bar_ProgressBar_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Progress Bar component
     * @author Box
     */

    class ProgressBar_ProgressBar extends react.PureComponent {
      /**
       * [constructor]
       *
       * @return {ProgressBar}
       */
      constructor(props) {
        super(props);
        /**
         * Increaments the progress or resets it
         * depending upon the edge conditions.
         *
         * @return {void}
         */
        progress_bar_ProgressBar_defineProperty(this, 'startProgress', () => {
          const { percent } = this.state;
          if (percent === 0) {
            this.interval = setInterval(this.incrementProgress, 100);
          } else if (percent === 100) {
            // Timeout helps transition of hiding the bar to finish
            this.timeout = setTimeout(this.resetProgress, 600);
          }
        });
        /**
         * Increaments the progress very slowly
         *
         * @return {void}
         */
        progress_bar_ProgressBar_defineProperty(this, 'incrementProgress', () => {
          const { percent } = this.state;
          this.setState({
            percent: percent + 2 / (percent || 1),
          });
        });
        /**
         * Resets the progress to 0
         *
         * @return {void}
         */
        progress_bar_ProgressBar_defineProperty(this, 'resetProgress', () => {
          this.setState(ProgressBar_ProgressBar.defaultProps);
        });
        const { percent: _percent } = props;
        this.state = {
          percent: _percent,
        };
      }

      /**
       * Clears any timeouts and intervals
       *
       * @return {void}
       */
      clearTimeoutAndInterval() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
      }

      /**
       * Starts progress on mount
       */

      componentDidMount() {
        this.startProgress();
      }

      /**
       * Updates state from new props
       *
       * @return {void}
       */
      componentDidUpdate(prevProps) {
        const { percent } = this.props;
        if (prevProps.percent !== percent) {
          this.clearTimeoutAndInterval();
          this.setState(
            {
              percent,
            },
            this.startProgress,
          );
        }
      }

      /**
       * Clears time out
       *
       * @return {void}
       */
      componentWillUnmount() {
        this.clearTimeoutAndInterval();
      }
      /**
       * Renders the progress bar
       *
       * @return {void}
       */
      render() {
        const { percent } = this.state;
        const containerStyle = {
          opacity: percent > 0 && percent < 100 ? 1 : 0,
          transitionDelay: percent > 0 && percent < 100 ? '0' : '0.4s',
        };
        return /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'be-progress-container',
            style: containerStyle,
          },
          /*#__PURE__*/ react.createElement('div', {
            className: 'be-progress',
            style: {
              width: `${percent}%`,
            },
          }),
        );
      }
    }
    progress_bar_ProgressBar_defineProperty(ProgressBar_ProgressBar, 'defaultProps', {
      percent: 0,
    });
    /* harmony default export */ const progress_bar_ProgressBar = ProgressBar_ProgressBar; // CONCATENATED MODULE: ./src/elements/common/progress-bar/index.js
    // CONCATENATED MODULE: ./src/elements/common/KeyBinder.js
    function KeyBinder_defineProperty(e, r, t) {
      return (
        (r = KeyBinder_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function KeyBinder_toPropertyKey(t) {
      var i = KeyBinder_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function KeyBinder_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Item List Key bindings
     * @author Box
     */

    class KeyBinder extends react.PureComponent {
      /**
       * Resets scroll position if props change
       * @private
       * @inheritdoc
       * @return {State|null}
       */
      static getDerivedStateFromProps(props, state) {
        const { prevId, prevScrollToColumn, prevScrollToRow } = state;
        const { id, scrollToColumn: scrollToColumnProp, scrollToRow: scrollToRowProp } = props;
        if (id !== prevId) {
          return {
            focusOnRender: false,
            prevId: id,
            prevScrollToColumn: 0,
            prevScrollToRow: 0,
            scrollToColumn: 0,
            scrollToRow: 0,
          };
        }
        const newState = {};
        if (prevScrollToColumn !== scrollToColumnProp && prevScrollToRow !== scrollToRowProp) {
          newState.prevScrollToColumn = scrollToColumnProp;
          newState.prevScrollToRow = scrollToRowProp;
          newState.scrollToColumn = scrollToColumnProp;
          newState.scrollToRow = scrollToRowProp;
        } else if (scrollToRowProp !== prevScrollToRow) {
          newState.prevScrollToRow = scrollToRowProp;
          newState.scrollToRow = scrollToRowProp;
        } else if (scrollToColumnProp !== prevScrollToColumn) {
          newState.prevScrollToColumn = scrollToColumnProp;
          newState.scrollToColumn = scrollToColumnProp;
        }
        return Object.keys(newState).length ? newState : null;
      }

      /**
       * [constructor]
       *
       * @private
       * @return {KeyBinder}
       */
      constructor(props) {
        super(props);
        /**
         * Keyboard events
         *
         * @private
         * @inheritdoc
         * @return {void}
         */
        KeyBinder_defineProperty(this, 'onKeyDown', event => {
          if (isInputElement(event.target)) {
            return;
          }
          const { columnCount, rowCount, onSelect, onRename, onDownload, onShare, onDelete, onOpen, items } =
            this.props;
          const { scrollToColumn: scrollToColumnPrevious, scrollToRow: scrollToRowPrevious } = this.state;
          let { scrollToColumn, scrollToRow } = this.state;
          const currentItem = items[scrollToRow];
          const ctrlMeta = event.metaKey || event.ctrlKey;

          // The above cases all prevent default event event behavior.
          // This is to keep the grid from scrolling after the snap-to update.
          switch (event.key) {
            case 'ArrowDown':
              scrollToRow = ctrlMeta ? rowCount - 1 : Math.min(scrollToRow + 1, rowCount - 1);
              event.stopPropagation(); // To prevent the arrow down capture of parent
              break;
            case 'ArrowLeft':
              scrollToColumn = ctrlMeta ? 0 : Math.max(scrollToColumn - 1, 0);
              break;
            case 'ArrowRight':
              scrollToColumn = ctrlMeta ? columnCount - 1 : Math.min(scrollToColumn + 1, columnCount - 1);
              break;
            case 'ArrowUp':
              scrollToRow = ctrlMeta ? 0 : Math.max(scrollToRow - 1, 0);
              break;
            case 'Enter':
              onOpen(currentItem);
              event.preventDefault();
              break;
            case 'Delete':
              onDelete(currentItem);
              event.preventDefault();
              break;
            case 'X':
              onSelect(currentItem);
              event.preventDefault();
              break;
            case 'D':
              onDownload(currentItem);
              event.preventDefault();
              break;
            case 'S':
              onShare(currentItem);
              event.preventDefault();
              break;
            case 'R':
              onRename(currentItem);
              event.preventDefault();
              break;
            default:
              return;
          }
          if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
            event.preventDefault();
            this.updateScrollState({
              scrollToColumn,
              scrollToRow,
            });
          }
        });
        /**
         * Callback for set of rows rendered
         *
         * @private
         * @inheritdoc
         * @return {void}
         */
        KeyBinder_defineProperty(
          this,
          'onSectionRendered',
          ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }) => {
            this.columnStartIndex = columnStartIndex;
            this.columnStopIndex = columnStopIndex;
            this.rowStartIndex = rowStartIndex;
            this.rowStopIndex = rowStopIndex;
          },
        );
        const { id, scrollToRow: _scrollToRow, scrollToColumn: _scrollToColumn } = props;
        this.state = {
          focusOnRender: false,
          prevId: id,
          prevScrollToColumn: _scrollToColumn,
          prevScrollToRow: _scrollToRow,
          scrollToColumn: _scrollToColumn,
          scrollToRow: _scrollToRow,
        };
        this.columnStartIndex = 0;
        this.columnStopIndex = 0;
        this.rowStartIndex = 0;
        this.rowStopIndex = 0;
      }
      /**
       * Updates the scroll states
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      updateScrollState({ scrollToColumn, scrollToRow }) {
        const { onScrollToChange } = this.props;
        onScrollToChange({
          scrollToColumn,
          scrollToRow,
        });
        this.setState({
          scrollToColumn,
          scrollToRow,
          focusOnRender: true,
        });
      }

      /**
       * Renders the HOC
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      render() {
        const { className, children } = this.props;
        const { scrollToColumn, scrollToRow, focusOnRender } = this.state;

        /* eslint-disable jsx-a11y/no-static-element-interactions */
        return /*#__PURE__*/ react.createElement(
          'div',
          {
            className: className,
            onKeyDown: this.onKeyDown,
          },
          children({
            onSectionRendered: this.onSectionRendered,
            scrollToColumn,
            scrollToRow,
            focusOnRender,
          }),
        );
        /* eslint-disable jsx-a11y/no-static-element-interactions */
      }
    }
    KeyBinder_defineProperty(KeyBinder, 'defaultProps', {
      scrollToColumn: 0,
      scrollToRow: 0,
      onRename: noop_default(),
      onShare: noop_default(),
      onDownload: noop_default(),
      onOpen: noop_default(),
      onSelect: noop_default(),
      onDelete: noop_default(),
    });
    /* harmony default export */ const common_KeyBinder = KeyBinder; // CONCATENATED MODULE: ./src/elements/common/item/ItemName.js
    /**
     *
     * @file Component for the details for the item name
     * @author Box
     */

    const ItemName_ItemName = ({ item, onClick, onFocus, canPreview, isTouch }) => {
      const { name, type } = item;
      const onItemFocus = onFocus ? () => onFocus(item) : null;
      const onItemClick = () => onClick(item);
      return type === constants_TYPE_FOLDER || (!isTouch && (type === TYPE_WEBLINK || canPreview))
        ? /*#__PURE__*/ react.createElement(
            plain_button_PlainButton,
            {
              className: 'be-item-label',
              'data-testid': 'be-item-name',
              onClick: onItemClick,
              onFocus: onItemFocus,
              type: 'button',
            },
            name,
          )
        : /*#__PURE__*/ react.createElement(
            'span',
            {
              className: 'be-item-label',
            },
            name,
          );
    };
    /* harmony default export */ const item_ItemName = ItemName_ItemName; // CONCATENATED MODULE: ./src/utils/size.js
    /**
     *
     * @file Function to create size in words out of number
     * @author Box
     */

    /**
     * Gets the size in words
     *
     * @param {number} value in bytes
     * @return {string} size in words
     */
    function size_size(value) {
      if (!value) return '0 Byte';
      const kilo = 1024;
      const decimals = 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
      const exp = Math.floor(Math.log(value) / Math.log(kilo));
      return `${parseFloat((value / kilo ** exp).toFixed(decimals))} ${sizes[exp]}`;
    } // CONCATENATED MODULE: ./src/utils/datetime.js
    /**
     *
     * @file Date and time utilities
     * @author Box
     */

    const MILLISECONDS_PER_SECOND = 1000;
    // 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
    const MILLISECONDS_PER_DAY = 24 * 60 * 60 * MILLISECONDS_PER_SECOND;
    // 60 sec * 1000
    const MILLISECONDS_PER_MINUTE = 60 * MILLISECONDS_PER_SECOND;

    /**
     * RegExp matcher for acceptable ISO 8601 date formats w/ timezone (see below)
     * Capture groups structured as follows:
     * 1) the date/time portion (2018-06-13T00:00:00.000)
     * 2) the milliseconds (if matched)
     * 3) the timezone portion (e.g., Z, +03, -0400, +05:00)
     * 4) the Z format for timezone (if matched)
     * 5) the short format for timezone (if matched)
     * 6) the colon-less format for timezone (if matched)
     * 7) the colon long format for timezone (if matched)
     */
    const RE_ISO8601_DATE =
      /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?)?((Z$)|(?:[+-](?:([0-2]\d$)|([0-2]\d(?:00|30)$)|([0-2]\d:(?:00|30)$))))$/;
    const ISO8601_DATETIME = 1;
    const ISO8601_MILLISECONDS = 2;
    const ISO8601_TIMEZONE = 3;
    const ISO8601_Z_FMT = 4;
    const ISO8601_SHORT_FMT = 5;
    const ISO8601_MEDIUM_FMT = 6;
    const ISO8601_LONG_FMT = 7;

    /**
     * Helper to normalize a date value to a date object
     * @param dateValue - Date number, string, or object
     * @returns {date} the normalized date object
     */
    function convertToDate(dateValue) {
      return dateValue instanceof Date ? dateValue : new Date(dateValue);
    }

    /**
     * Converts an integer value in seconds to milliseconds.
     * @param {number} seconds - The value in seconds
     * @returns {number} the value in milliseconds
     */
    function convertToMs(seconds) {
      return seconds * MILLISECONDS_PER_SECOND;
    }

    /**
     * Checks whether the given date value (in unix milliseconds) is today.
     * @param {number|string|Date} dateValue - Date object or integer representing the number of milliseconds since 1/1/1970 UTC
     * @returns {boolean} whether the given value is today
     */
    function isToday(dateValue) {
      return new Date().toDateString() === convertToDate(dateValue).toDateString();
    }

    /**
     * Checks whether the given date value (in unix milliseconds) is yesterday.
     * @param {number|string|Date} dateValue - Date object or integer or representing the number of milliseconds since 1/1/1970 UTC
     * @returns {boolean} whether the given value is yesterday
     */
    function isYesterday(dateValue) {
      return isToday(convertToDate(dateValue).getTime() + MILLISECONDS_PER_DAY);
    }

    /**
     * Checks whether the given date value (in unix milliseconds) is tomorrow.
     * @param {number|string|Date} dateValue - Date object or integer or representing the number of milliseconds since 1/1/1970 UTC
     * @returns {boolean} whether the given value is tomorrow
     */
    function isTomorrow(dateValue) {
      return isToday(convertToDate(dateValue).getTime() - MILLISECONDS_PER_DAY);
    }

    /**
     * Checks whether the given date value (in unix milliseconds) is in the current month.
     * @param {number|string|Date} dateValue - Date object or integer representing the number of milliseconds since 1/1/1970 UTC
     * @returns {boolean} whether the given value is in the current month
     */
    function isCurrentMonth(dateValue) {
      return new Date().getMonth() === convertToDate(dateValue).getMonth();
    }

    /**
     * Checks whether the given date value (in unix milliseconds) is in the current year.
     * @param {number|string|Date} dateValue - Date object or integer representing the number of milliseconds since 1/1/1970 UTC
     * @returns {boolean} whether the given value is in the current year
     */
    function isCurrentYear(dateValue) {
      return new Date().getFullYear() === convertToDate(dateValue).getFullYear();
    }

    /**
     * Formats a number of seconds as a time string
     *
     * @param {number} seconds - seconds
     * @return {string} a string formatted like 3:57:35
     */
    function datetime_formatTime(seconds) {
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = Math.floor((seconds % 3600) % 60);
      const hour = h > 0 ? `${h.toString()}:` : '';
      const sec = s < 10 ? `0${s.toString()}` : s.toString();
      let min = m.toString();
      if (h > 0 && m < 10) {
        min = `0${min}`;
      }
      return `${hour}${min}:${sec}`;
    }

    /**
     * Adds time to a given dateValue
     *
     * @param {number|Date} dateValue - date or integer value to add time to
     * @param {number} timeToAdd - amount of time to add in ms
     * @return {number|Date} the modified date or integer
     */
    function addTime(dateValue, timeToAdd) {
      if (dateValue instanceof Date) {
        return new Date(dateValue.getTime() + timeToAdd);
      }
      return dateValue + timeToAdd;
    }

    /**
     * Will convert
     *      2018-06-13T07:00:00.000Z
     * to
     *      2018-06-13T00:00:00.000Z
     *
     * This is the opposite of convertISOStringToUTCDate
     *
     * @param {Date} date
     * @return {number}
     */
    function convertDateToUnixMidnightTime(date) {
      // date is localized to 00:00:00 at system/browser timezone
      const utcUnixTimeInMs = date.getTime();

      // timezone an integer offset; minutes behind GMT
      // we use the browser timezone offset instead of the user's,
      // because the datepicker uses the browser to get the "midnight"
      // time in the user's timezone with getTime()
      const timezoneOffsetInMins = date.getTimezoneOffset();
      const timezoneOffsetInMs = timezoneOffsetInMins * MILLISECONDS_PER_MINUTE;

      // we need the unix/epoch time for midnight on the date selected
      const unixDayMidnightTime = utcUnixTimeInMs - timezoneOffsetInMs;
      return unixDayMidnightTime;
    }

    /**
     * Will check to see if a date object is not valid, according to the browser
     * JS engine.
     *
     * @param {Date} date
     * @return {boolean} whether the date value passes validation
     */
    function isValidDate(date) {
      return !isNaN(date.getTime());
    }

    /**
     * Will convert ISO8601-compatible dates (with zone designators)
     *      2018-06-13T00:00:00.000-0500
     *      or
     *      2018-06-13T00:00:00.000-05
     *
     * to
     *      2018-06-13T00:00:00.000-05:00
     *
     * Equivalent formats between the two (e.g., uzing 'Z') will remain unchanged.
     * If the date format cannot be converted, it will pass along the existing value
     * @param {string} isoString
     * @return {string} converted date format, if applicable
     */
    function convertISOStringtoRFC3339String(isoString) {
      // test that the date format inbound is ISO8601-compatible
      if (RE_ISO8601_DATE.test(isoString)) {
        // if it is, parse out the timezone part if it's in a longer format
        // use the capture groups instead of the split result for the datetime and the time zone
        const parseDate = isoString.split(RE_ISO8601_DATE);
        let dateTime = parseDate[ISO8601_DATETIME];
        const milliseconds = parseDate[ISO8601_MILLISECONDS];
        const timeZone = parseDate[ISO8601_TIMEZONE];

        // add milliseconds if missing, to standardize output
        if (!milliseconds) {
          dateTime += '.000';
        }
        if (parseDate[ISO8601_Z_FMT]) {
          return isoString;
        }
        if (parseDate[ISO8601_SHORT_FMT]) {
          return `${dateTime + timeZone}:00`;
        }
        if (parseDate[ISO8601_MEDIUM_FMT]) {
          return `${dateTime + timeZone.substr(0, 3)}:${timeZone.substr(3)}`;
        }
        if (parseDate[ISO8601_LONG_FMT]) {
          return isoString;
        }
      }
      return isoString;
    }

    /**
     * Will convert
     *      2018-06-13T00:00:00.000Z
     * to
     *      2018-06-13T07:00:00.000Z
     *
     * This is the opposite of convertDateToUnixMidnightTime
     *
     * @param {string} isoString - ISO string in UTC time zone
     */
    function convertISOStringToUTCDate(isoString) {
      // get date in UTC midnight time
      const utcDate = new Date(convertISOStringtoRFC3339String(isoString));
      const utcTime = utcDate.getTime();

      // get browser's timezone
      const timezoneOffsetInMins = utcDate.getTimezoneOffset();
      const timezoneOffsetInMs = timezoneOffsetInMins * MILLISECONDS_PER_MINUTE;

      // return date in utc timezone
      const localizedUnixTimeInMs = utcTime + timezoneOffsetInMs;
      return new Date(localizedUnixTimeInMs);
    } // CONCATENATED MODULE: ./src/elements/common/date/DateField.js

    /**
     *
     * @file Function to render the date table cell
     * @author Box
     */

    const DEFAULT_DATE_FORMAT = {
      weekday: 'short',
      month: 'short',
      year: 'numeric',
      day: 'numeric',
    };
    const DateField = ({
      date,
      dateFormat = DEFAULT_DATE_FORMAT,
      omitCommas = false,
      intl,
      relative = true,
      capitalize = false,
    }) => {
      const d = new Date(date);
      const isTodaysDate = isToday(d);
      const isYesterdaysDate = isYesterday(d);
      if (relative && (isTodaysDate || isYesterdaysDate)) {
        let Message = /*#__PURE__*/ react.createElement(components_message, common_messages.today);
        if (isYesterdaysDate) {
          Message = /*#__PURE__*/ react.createElement(components_message, common_messages.yesterday);
        }
        if (capitalize) {
          return /*#__PURE__*/ react.createElement(
            'span',
            {
              className: 'be-date-capitalize',
            },
            Message,
          );
        }
        return Message;
      }
      let formattedDate = intl.formatDate(d, dateFormat);
      formattedDate = omitCommas ? formattedDate.replace(/,/g, '') : formattedDate;
      return formattedDate;
    };
    /* harmony default export */ const date_DateField = injectIntl(DateField); // CONCATENATED MODULE: ./src/elements/common/date/index.js
    // CONCATENATED MODULE: ./src/elements/common/item/ItemSubDetails.js
    function ItemSubDetails_extends() {
      return (
        (ItemSubDetails_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        ItemSubDetails_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Component for the sub details for the item name
     * @author Box
     */

    const ItemSubDetails = ({ item, view }) => {
      const { modified_at = '', interacted_at = '', modified_by } = item;
      const modifiedBy = modified_by ? modified_by.name || '' : '';
      const isRecents = view === VIEW_RECENTS;
      const date = isRecents ? interacted_at || modified_at : modified_at;
      const { size } = item;
      const DateValue = /*#__PURE__*/ react.createElement(date_DateField, {
        date: date,
        omitCommas: true,
      });
      let message = common_messages.modifiedDateBy;
      if (isRecents) {
        message = common_messages.interactedDate;
      } else if (!modifiedBy) {
        message = common_messages.modifiedDate;
      }
      return /*#__PURE__*/ react.createElement(
        'span',
        null,
        /*#__PURE__*/ react.createElement(
          'span',
          {
            className: 'bdl-ItemSubDetails-modifiedBy',
          },
          /*#__PURE__*/ react.createElement(
            components_message,
            ItemSubDetails_extends({}, message, {
              values: {
                date: DateValue,
                name: modifiedBy,
              },
            }),
          ),
        ),
        /*#__PURE__*/ react.createElement(
          'span',
          {
            className: 'bdl-ItemSubDetails-size',
          },
          size_size(size),
        ),
      );
    };
    /* harmony default export */ const item_ItemSubDetails = ItemSubDetails; // CONCATENATED MODULE: ./src/elements/common/item/ItemDetails.js
    /**
     *
     * @file Component for the details for the item name
     * @author Box
     */

    const ItemDetails = ({ view, rootId, item, onItemClick }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-item-details',
        },
        view === VIEW_SELECTED || view === VIEW_SEARCH
          ? /*#__PURE__*/ react.createElement(breadcrumbs_InlineBreadcrumbs, {
              item: item,
              onItemClick: onItemClick,
              rootId: rootId,
            })
          : /*#__PURE__*/ react.createElement(item_ItemSubDetails, {
              item: item,
              view: view,
            }),
      );
    /* harmony default export */ const item_ItemDetails = ItemDetails; // CONCATENATED MODULE: ./src/elements/common/item/Name.js
    const Name = ({
      canPreview = false,
      isTouch = false,
      item,
      onItemClick,
      onItemSelect,
      showDetails = true,
      rootId,
      view,
    }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'be-item-name',
        },
        /*#__PURE__*/ react.createElement(item_ItemName, {
          canPreview: canPreview,
          isTouch: isTouch,
          item: item,
          onClick: onItemClick,
          onFocus: onItemSelect,
        }),
        view === VIEW_SEARCH || showDetails
          ? /*#__PURE__*/ react.createElement(item_ItemDetails, {
              item: item,
              onItemClick: onItemClick,
              rootId: rootId,
              view: view,
            })
          : null,
      );
    /* harmony default export */ const item_Name = Name; // CONCATENATED MODULE: ./src/elements/common/item/nameCellRenderer.js
    /**
     *
     * @file Function to render the name table cell
     * @author Box
     */

    /* harmony default export */ const item_nameCellRenderer =
      (rootId, view, onItemClick, onItemSelect, canPreview = false, showDetails = true, isTouch = false) =>
      ({ rowData }) =>
        /*#__PURE__*/ react.createElement(item_Name, {
          canPreview: canPreview,
          isTouch: isTouch,
          item: rowData,
          onItemClick: onItemClick,
          onItemSelect: onItemSelect,
          rootId: rootId,
          showDetails: showDetails,
          view: view,
        }); // CONCATENATED MODULE: ./src/icon/content/FolderShared32.tsx
    function FolderShared32_extends() {
      return (
        (FolderShared32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FolderShared32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FolderShared32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FolderShared32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#2687FC',
            d: 'M6 6h6c2 0 1.5 2 4 2h10a3 3 0 013 3v13a3 3 0 01-3 3H6a3 3 0 01-3-3V9a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: bdlLightBlue50,
            d: 'M26 11a3 3 0 013 3v10a3 3 0 01-3 3H6a3 3 0 01-3-3V14a3 3 0 013-3h20zm-6.999 8c-1.117 0-1.933.543-2.439 1.401a6.024 6.024 0 01.414 1.45c.066.42.003.809-.165 1.138a1.7 1.7 0 00.193.011h4.002l.14-.006c.63-.054.924-.476.844-.988a5.028 5.028 0 00-.258-.997c-.453-1.2-1.367-2.009-2.73-2.009zM13 19c-1.364 0-2.278.81-2.731 2.01a4.774 4.774 0 00-.185.62c-.028.123-.053.25-.073.378-.084.54.258.992.992.992h4.002l.14-.006c.63-.054.924-.476.843-.988a5.028 5.028 0 00-.257-.997C15.277 19.81 14.363 19 13 19zm0-4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.001 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z',
          }),
        ),
      );
    /* harmony default export */ const content_FolderShared32 = FolderShared32; // CONCATENATED MODULE: ./src/icon/content/FolderExternal32.tsx
    function FolderExternal32_extends() {
      return (
        (FolderExternal32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FolderExternal32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FolderExternal32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FolderExternal32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: '#737E88',
            d: 'M6 6h6c2 0 1.5 2 4 2h10a3 3 0 013 3v13a3 3 0 01-3 3H6a3 3 0 01-3-3V9a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: '#B8BEC3',
            d: 'M26 11a3 3 0 013 3v10a3 3 0 01-3 3H6a3 3 0 01-3-3V14a3 3 0 013-3h20zm-10 3c-2.77 0-5 2.23-5 5s2.23 5 5 5 5-2.23 5-5-2.23-5-5-5zm-3.923 4.077l2.385 2.385V21c0 .538.461 1 1 1v1C13.538 22.692 12 21.077 12 19c0-.308.077-.615.077-.923zm5.461-2.77C19 15.924 20 17.308 20 19c0 1.077-.385 2-1.077 2.692C18.77 21.308 18.385 21 18 21h-.538v-1.538c0-.231-.154-.462-.462-.462h-3v-1h1c.308 0 .538-.23.538-.538v-.924h1c.539 0 1-.461 1-1v-.23z',
          }),
        ),
      );
    /* harmony default export */ const content_FolderExternal32 = FolderExternal32; // CONCATENATED MODULE: ./src/icon/content/FolderPersonal32.tsx
    function FolderPersonal32_extends() {
      return (
        (FolderPersonal32_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        FolderPersonal32_extends.apply(null, arguments)
      );
    }
    /* eslint-disable react/jsx-sort-props */

    /**
     * This is an auto-generated component and should not be edited
     * manually in contributor pull requests.
     *
     * If you have problems with this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
     *
     * If there are missing features in this component:
     * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
     */

    const FolderPersonal32 = props =>
      /*#__PURE__*/ react.createElement(
        components_accessible_svg_AccessibleSVG,
        FolderPersonal32_extends(
          {
            width: 32,
            height: 32,
            viewBox: '0 0 32 32',
          },
          props,
        ),
        /*#__PURE__*/ react.createElement(
          'g',
          {
            fill: 'none',
            fillRule: 'evenodd',
          },
          /*#__PURE__*/ react.createElement('path', {
            fill: 'gold',
            d: 'M6 6h6c2 0 1.5 2 4 2h10a3 3 0 013 3v13a3 3 0 01-3 3H6a3 3 0 01-3-3V9a3 3 0 013-3z',
          }),
          /*#__PURE__*/ react.createElement('path', {
            fill: white,
            fillOpacity: 0.5,
            d: 'M6 11h20a3 3 0 013 3v10a3 3 0 01-3 3H6a3 3 0 01-3-3V14a3 3 0 013-3z',
          }),
        ),
      );
    /* harmony default export */ const content_FolderPersonal32 = FolderPersonal32; // CONCATENATED MODULE: ./src/icons/folder-icon/FolderIcon.tsx
    const FolderIcon = ({ dimension = 32, isCollab = false, isExternal = false, title }) => {
      if (isExternal) {
        return /*#__PURE__*/ react.createElement(content_FolderExternal32, {
          height: dimension,
          title: title,
          width: dimension,
        });
      }
      if (isCollab) {
        return /*#__PURE__*/ react.createElement(content_FolderShared32, {
          height: dimension,
          title: title,
          width: dimension,
        });
      }
      return /*#__PURE__*/ react.createElement(content_FolderPersonal32, {
        height: dimension,
        title: title,
        width: dimension,
      });
    };
    /* harmony default export */ const folder_icon_FolderIcon = FolderIcon; // CONCATENATED MODULE: ./src/icons/bookmark-icon/BookmarkIcon.tsx
    const BookmarkIcon = ({ className = '', height = 32, title, width = 32 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-bookmark ${className}`,
          height: height,
          title: title,
          viewBox: '0 0 32 32',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          clipRule: 'evenodd',
          d: 'M24.5 27.5h-17c-.6 0-1-.4-1-1v-21c0-.6.4-1 1-1h17c.6 0 1 .4 1 1v21c0 .6-.4 1-1 1z',
          fill: '#75818C',
          fillRule: 'evenodd',
        }),
        /*#__PURE__*/ react.createElement('path', {
          clipRule: 'evenodd',
          d: 'M24.5 9.5V26c0 .3-.2.5-.5.5H8c-.3 0-.5-.2-.5-.5V9.5h17zM7.5 6.5h1v1h-1zM9.5 6.5h1v1h-1zM11.5 6.5h1v1h-1z',
          fill: '#FFF',
          fillRule: 'evenodd',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M16.4 21.9c-1.1 1.1-3.1 1.1-4.2 0-.6-.6-.9-1.3-.9-2.1s.3-1.6.9-2.1l1.4-1.4-.7-.7-1.4 1.4c-.8.8-1.2 1.8-1.2 2.8 0 1.1.4 2.1 1.2 2.8.8.8 1.8 1.2 2.8 1.2 1.1 0 2.1-.4 2.8-1.2l1.4-1.4-.7-.7-1.4 1.4zM20.6 13.4c-1.6-1.6-4.1-1.6-5.7 0l-1.4 1.4.7.7 1.4-1.4c.6-.6 1.4-.9 2.1-.9.8 0 1.5.3 2.1.9 1.2 1.2 1.2 3.1 0 4.2l-1.4 1.4.7.7 1.4-1.4c1.7-1.5 1.7-4 .1-5.6z',
          fill: '#75818C',
        }),
        /*#__PURE__*/ react.createElement('path', {
          d: 'M17.06 16.232l.708.707-2.83 2.828-.706-.708z',
          fill: '#75818C',
        }),
      );
    /* harmony default export */ const bookmark_icon_BookmarkIcon = BookmarkIcon; // CONCATENATED MODULE: ./src/elements/common/item/IconCell.js
    /**
     *
     * @author Box
     */

    const IconCell = ({ intl, rowData, dimension }) => {
      const { type, extension, has_collaborations, is_externally_owned } = rowData;
      let title;
      switch (type) {
        case constants_TYPE_FILE:
          title = intl.formatMessage(common_messages.file);
          return /*#__PURE__*/ react.createElement(file_icon_FileIcon, {
            dimension: dimension,
            extension: extension,
            title: title,
          });
        case constants_TYPE_FOLDER:
          if (has_collaborations) {
            title = intl.formatMessage(common_messages.collaboratedFolder);
          } else if (is_externally_owned) {
            title = intl.formatMessage(common_messages.externalFolder);
          } else {
            title = intl.formatMessage(common_messages.personalFolder);
          }
          return /*#__PURE__*/ react.createElement(folder_icon_FolderIcon, {
            dimension: dimension,
            isCollab: has_collaborations,
            isExternal: is_externally_owned,
            title: title,
          });
        case TYPE_WEBLINK:
          title = intl.formatMessage(common_messages.bookmark);
          return /*#__PURE__*/ react.createElement(bookmark_icon_BookmarkIcon, {
            height: dimension,
            width: dimension,
            title: title,
          });
        default:
          title = intl.formatMessage(common_messages.file);
          return /*#__PURE__*/ react.createElement(file_icon_FileIcon, {
            dimension: dimension,
            title: title,
          });
      }
    };

    /* harmony default export */ const item_IconCell = injectIntl(IconCell); // CONCATENATED MODULE: ./src/elements/common/item/iconCellRenderer.js
    /**
     *
     * @file Function to render the icon table cell
     * @author Box
     */

    /* harmony default export */ const iconCellRenderer =
      (dimension = 32) =>
      ({ rowData }) =>
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'be-item-icon',
          },
          /*#__PURE__*/ react.createElement(item_IconCell, {
            rowData: rowData,
            dimension: dimension,
          }),
        ); // CONCATENATED MODULE: ./src/elements/common/share-access-select/ShareAccessSelect.js
    /**
     *
     * @file Content Explorer Delete Confirmation Dialog
     * @author Box
     */

    const ShareAccessSelect = ({ className, canSetShareAccess, onChange, item, intl }) => {
      const {
        allowed_shared_link_access_levels: allowedSharedAccessLevels,
        permissions,
        shared_link: sharedLink,
      } = item;
      if (!allowedSharedAccessLevels) {
        return /*#__PURE__*/ react.createElement('span', null);
      }
      const { access = ACCESS_NONE } = sharedLink || {};
      const { can_set_share_access: allowShareAccessChange } = permissions || {};
      const changeHandler = ({ target }) => onChange(target.value, item);
      const allowOpen = allowedSharedAccessLevels.indexOf(ACCESS_OPEN) > -1;
      const allowCollab = allowedSharedAccessLevels.indexOf(ACCESS_COLLAB) > -1;
      const allowCompany = allowedSharedAccessLevels.indexOf(ACCESS_COMPANY) > -1;
      const allowed = canSetShareAccess && allowShareAccessChange && (allowOpen || allowCompany || allowCollab);
      if (!allowed) {
        return /*#__PURE__*/ react.createElement('span', null);
      }

      /* eslint-disable jsx-a11y/no-onchange */
      return /*#__PURE__*/ react.createElement(
        'select',
        {
          className: `be-share-access-select ${className}`,
          onChange: changeHandler,
          value: access,
        },
        allowOpen
          ? /*#__PURE__*/ react.createElement(
              'option',
              {
                value: ACCESS_OPEN,
              },
              intl.formatMessage(common_messages.shareAccessOpen),
            )
          : null,
        allowCollab
          ? /*#__PURE__*/ react.createElement(
              'option',
              {
                value: ACCESS_COLLAB,
              },
              intl.formatMessage(common_messages.shareAccessCollab),
            )
          : null,
        allowCompany
          ? /*#__PURE__*/ react.createElement(
              'option',
              {
                value: ACCESS_COMPANY,
              },
              intl.formatMessage(common_messages.shareAccessCompany),
            )
          : null,
        /*#__PURE__*/ react.createElement(
          'option',
          {
            value: ACCESS_NONE,
          },
          access === ACCESS_NONE
            ? intl.formatMessage(common_messages.shareAccessNone)
            : intl.formatMessage(common_messages.shareAccessRemove),
        ),
      );
    };
    /* harmony default export */ const share_access_select_ShareAccessSelect = injectIntl(ShareAccessSelect); // CONCATENATED MODULE: ./src/elements/common/share-access-select/index.js
    // CONCATENATED MODULE: ./src/elements/content-picker/cellRendererHelper.js
    /**
     *
     * @file Function to filter cells from being selected
     * @author Box
     */

    function isRowSelectable(selectableType, extensionsWhitelist, hasHitSelectionLimit, rowData) {
      const { type, extension = '', selected } = rowData;
      const shouldAllowSelection = hasHitSelectionLimit ? !!selected : true;
      const isTypeSelectable = !!type && selectableType.indexOf(type) > -1;
      const isFilePicker = selectableType.indexOf(constants_TYPE_FILE) > -1;
      const isExtensionWhitelisted =
        isFilePicker && extensionsWhitelist.length ? extensionsWhitelist.indexOf(extension) > -1 : true;
      return shouldAllowSelection && isTypeSelectable && isExtensionWhitelisted;
    }
    /* harmony default export */ const cellRendererHelper = isRowSelectable; // CONCATENATED MODULE: ./src/elements/content-picker/shareAccessCellRenderer.js
    /**
     *
     * @file Function to render the share access table cell
     * @author Box
     */

    /* harmony default export */ const shareAccessCellRenderer =
      (onChange, canSetShareAccess, selectableType, extensionsWhitelist, hasHitSelectionLimit) =>
      ({ rowData }) => {
        const itemCanSetShareAccess = get_default()(rowData, 'permissions.can_set_share_access', false);
        if (
          !canSetShareAccess ||
          !itemCanSetShareAccess ||
          !cellRendererHelper(selectableType, extensionsWhitelist, hasHitSelectionLimit, rowData) ||
          !rowData.selected
        ) {
          return /*#__PURE__*/ react.createElement('span', null);
        }
        const { allowed_shared_link_access_levels } = rowData;
        const isLoading = !allowed_shared_link_access_levels;
        return isLoading
          ? /*#__PURE__*/ react.createElement(loading_indicator_LoadingIndicator, {
              className: 'bcp-share-access-loading',
            })
          : /*#__PURE__*/ react.createElement(share_access_select_ShareAccessSelect, {
              canSetShareAccess: canSetShareAccess,
              className: 'bcp-shared-access-select',
              item: rowData,
              onChange: onChange,
            });
      }; // CONCATENATED MODULE: ./src/icons/general/IconInfo.tsx
    const IconInfo = ({ className = '', color = '#000000', height = 24, title, width = 24 }) =>
      /*#__PURE__*/ react.createElement(
        accessible_svg_AccessibleSVG,
        {
          className: `icon-info ${className}`,
          height: height,
          title: title,
          viewBox: '-603 389 16 16',
          width: width,
        },
        /*#__PURE__*/ react.createElement('path', {
          className: 'fill-color',
          d: 'M-595 403c5.5 0 8-7.1 3.9-10.6-4.2-3.6-10.8.3-9.8 5.7.5 2.8 3 4.9 5.9 4.9zm.9-6.7v3.7h-1.4v-3.7h1.4zm.1-2.2c0 1-1.7 1.1-1.7 0 .1-1.1 1.7-1.1 1.7 0z',
          fill: color,
          fillRule: 'evenodd',
        }),
      );
    /* harmony default export */ const general_IconInfo = IconInfo; // CONCATENATED MODULE: ./src/components/checkbox/CheckboxTooltip.tsx
    const CheckboxTooltip_messages = defineMessages({
      checkboxTooltipIconInfoText: {
        id: 'boxui.checkboxTooltip.iconInfoText',
        defaultMessage: 'Info',
      },
    });
    const CheckboxTooltip = ({ tooltip }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'checkbox-tooltip-wrapper',
        },
        /*#__PURE__*/ react.createElement(
          tooltip_Tooltip,
          {
            text: tooltip,
          },
          /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'info-tooltip',
            },
            /*#__PURE__*/ react.createElement(general_IconInfo, {
              height: 16,
              title: /*#__PURE__*/ react.createElement(
                components_message,
                CheckboxTooltip_messages.checkboxTooltipIconInfoText,
              ),
              width: 16,
            }),
          ),
        ),
      );
    /* harmony default export */ const checkbox_CheckboxTooltip = CheckboxTooltip; // CONCATENATED MODULE: ./src/components/checkbox/Checkbox.tsx
    const Checkbox_excluded = [
      'className',
      'description',
      'fieldLabel',
      'hideLabel',
      'id',
      'inputClassName',
      'isChecked',
      'isDisabled',
      'label',
      'name',
      'onFocus',
      'onChange',
      'subsection',
      'tooltip',
    ];
    function Checkbox_extends() {
      return (
        (Checkbox_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        Checkbox_extends.apply(null, arguments)
      );
    }
    function Checkbox_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = Checkbox_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function Checkbox_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const Checkbox = _ref => {
      let {
          className = '',
          description,
          fieldLabel,
          hideLabel,
          id,
          inputClassName,
          isChecked,
          isDisabled,
          label,
          name,
          onFocus,
          onChange,
          subsection,
          tooltip,
          // @TODO: eventually remove `rest` in favor of explicit props
        } = _ref,
        rest = Checkbox_objectWithoutProperties(_ref, Checkbox_excluded);
      const generatedID = react.useRef(uniqueId_default()('checkbox')).current;
      // use passed-in ID from props; otherwise generate one
      const inputID = id || generatedID;
      const checkboxAndLabel = /*#__PURE__*/ react.createElement(
        'span',
        {
          className: 'checkbox-label',
        },
        /*#__PURE__*/ react.createElement(
          'input',
          Checkbox_extends(
            {
              'aria-describedby': description ? `description_${inputID}` : '',
              checked: isChecked,
              className: inputClassName,
              disabled: isDisabled,
              id: inputID,
              name: name,
              onFocus: onFocus,
              onChange: onChange,
              type: 'checkbox',
            },
            rest,
          ),
        ),
        /*#__PURE__*/ react.createElement('span', {
          className: 'checkbox-pointer-target',
        }),
        /*#__PURE__*/ react.createElement(
          'span',
          {
            className: classnames_default()('bdl-Checkbox-labelTooltipWrapper', {
              'accessibility-hidden': hideLabel,
            }),
          },
          label &&
            /*#__PURE__*/ react.createElement(
              'label',
              {
                htmlFor: inputID,
              },
              label,
            ),
          tooltip &&
            /*#__PURE__*/ react.createElement(checkbox_CheckboxTooltip, {
              tooltip: tooltip,
            }),
        ),
      );
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: classnames_default()('checkbox-container', className, {
            'is-disabled bdl-is-disabled': isDisabled,
          }),
        },
        fieldLabel &&
          /*#__PURE__*/ react.createElement(
            'div',
            {
              className: 'label',
            },
            fieldLabel,
          ),
        checkboxAndLabel,
        description
          ? /*#__PURE__*/ react.createElement(
              'div',
              {
                id: `description_${inputID}`,
                className: 'checkbox-description',
              },
              description,
            )
          : null,
        subsection
          ? /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'checkbox-subsection',
              },
              subsection,
            )
          : null,
      );
    };
    /* harmony default export */ const checkbox_Checkbox = Checkbox; // CONCATENATED MODULE: ./src/components/checkbox/CheckboxField.tsx
    const CheckboxField_excluded = /* unused pure expression or super */ null && ['field'];
    function CheckboxField_extends() {
      return (
        (CheckboxField_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        CheckboxField_extends.apply(null, arguments)
      );
    }
    function CheckboxField_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = CheckboxField_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function CheckboxField_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    const CheckboxField = _ref => {
      let { field } = _ref,
        rest = CheckboxField_objectWithoutProperties(_ref, CheckboxField_excluded);
      if (!field) {
        return /*#__PURE__*/ React.createElement(CheckboxPrimitive, rest);
      }
      const { value } = field;
      return /*#__PURE__*/ React.createElement(
        CheckboxPrimitive,
        CheckboxField_extends({}, field, rest, {
          isChecked: !!value,
        }),
      );
    };
    /* harmony default export */ const checkbox_CheckboxField =
      /* unused pure expression or super */ null && CheckboxField; // CONCATENATED MODULE: ./src/components/checkbox/index.ts
    // CONCATENATED MODULE: ./src/components/radio/RadioButton.tsx
    const RadioButton_excluded = ['isDisabled', 'isSelected', 'description', 'hideLabel', 'label', 'name', 'value'];
    function RadioButton_extends() {
      return (
        (RadioButton_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        RadioButton_extends.apply(null, arguments)
      );
    }
    function RadioButton_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = RadioButton_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function RadioButton_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }

    // @NOTE: readonly is not a valid attribute for input type radio so
    // this avoids the propType error that "checked" is set without "onChange"
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const onChangeStub = () => {};
    const RadioButton = _ref => {
      let { isDisabled, isSelected = false, description, hideLabel = false, label, name, value } = _ref,
        rest = RadioButton_objectWithoutProperties(_ref, RadioButton_excluded);
      return /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'radio-container',
        },
        /*#__PURE__*/ react.createElement(
          'label',
          {
            className: 'radio-label',
          },
          /*#__PURE__*/ react.createElement(
            'input',
            RadioButton_extends(
              {
                checked: isSelected,
                disabled: isDisabled,
                name: name,
                onChange: onChangeStub,
                type: 'radio',
                value: value,
              },
              rest,
            ),
          ),
          /*#__PURE__*/ react.createElement('span', null),
          /*#__PURE__*/ react.createElement(
            'span',
            {
              className: hideLabel ? 'accessibility-hidden' : '',
            },
            label,
          ),
        ),
        description
          ? /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'radio-description',
              },
              description,
            )
          : null,
      );
    };
    /* harmony default export */ const radio_RadioButton = RadioButton; // CONCATENATED MODULE: ./src/elements/content-picker/selectionCellRenderer.js
    /**
     *
     * @file Function to render the checkbox or radio table cell
     * @author Box
     */

    /* harmony default export */ const selectionCellRenderer =
      (onItemSelect, selectableType, extensionsWhitelist, hasHitSelectionLimit, isRadio) =>
      ({ rowData }) => {
        const { name = '', selected = false } = rowData;
        const Component = isRadio ? radio_RadioButton : checkbox_Checkbox;
        if (!cellRendererHelper(selectableType, extensionsWhitelist, hasHitSelectionLimit, rowData)) {
          return /*#__PURE__*/ react.createElement('span', null);
        }
        return /*#__PURE__*/ react.createElement(Component, {
          hideLabel: true,
          label: name,
          name: name,
          onChange: () => onItemSelect(rowData),
          value: name,
          [isRadio ? 'isSelected' : 'isChecked']: selected,
        });
      }; // CONCATENATED MODULE: ./src/elements/content-picker/ItemList.js
    /**
     *
     * @file Item list component
     * @author Box
     */

    const ItemList_ItemList = ({
      view,
      rootId,
      isSmall,
      rootElement,
      focusedRow,
      selectableType,
      canSetShareAccess,
      hasHitSelectionLimit,
      isSingleSelect,
      extensionsWhitelist,
      onItemSelect,
      onItemClick,
      onShareAccessChange,
      onFocusChange,
      currentCollection,
      tableRef,
    }) => {
      const iconCell = iconCellRenderer();
      const nameCell = item_nameCellRenderer(rootId, view, onItemClick);
      const selectionCell = selectionCellRenderer(
        onItemSelect,
        selectableType,
        extensionsWhitelist,
        hasHitSelectionLimit,
        isSingleSelect,
      );
      const shareAccessCell = shareAccessCellRenderer(
        onShareAccessChange,
        canSetShareAccess,
        selectableType,
        extensionsWhitelist,
        hasHitSelectionLimit,
      );
      const { id, items = [] } = currentCollection;
      const rowCount = items.length;
      const rowClassName = ({ index }) => {
        if (index === -1) {
          return '';
        }
        const { selected, type } = items[index];
        const isSelectable = cellRendererHelper(
          selectableType,
          extensionsWhitelist,
          hasHitSelectionLimit,
          items[index],
        );
        return classnames_default()(`bcp-item-row bcp-item-row-${index}`, {
          'bcp-item-row-selected': selected && view !== VIEW_SELECTED,
          'bcp-item-row-unselectable': type !== constants_TYPE_FOLDER && !isSelectable, // folder row should never dim
        });
      };
      const onRowClick = ({ event, rowData, index }) => {
        // If the click is happening on a clickable element on the item row, ignore row selection
        if (
          cellRendererHelper(selectableType, extensionsWhitelist, hasHitSelectionLimit, rowData) &&
          !isFocusableElement(event.target)
        ) {
          onItemSelect(rowData);
        } else {
          onFocusChange(index);
        }
      };
      return /*#__PURE__*/ react.createElement(
        common_KeyBinder,
        {
          columnCount: 1,
          rowCount: rowCount,
          className: 'bcp-item-grid',
          id: id,
          items: items,
          onSelect: onItemSelect,
          onOpen: onItemClick,
          scrollToRow: focusedRow,
          onScrollToChange: ({ scrollToRow }) => dom_focus(rootElement, `.bcp-item-row-${scrollToRow}`),
        },
        ({ onSectionRendered, scrollToRow, focusOnRender }) =>
          /*#__PURE__*/ react.createElement(AutoSizer, null, ({ width, height }) =>
            /*#__PURE__*/ react.createElement(
              Table_Table,
              {
                width: width,
                height: height,
                disableHeader: true,
                headerHeight: 0,
                rowHeight: isSmall ? 70 : 50,
                rowCount: rowCount,
                rowGetter: ({ index }) => items[index],
                ref: tableRef,
                rowClassName: rowClassName,
                onRowClick: onRowClick,
                scrollToIndex: scrollToRow,
                onRowsRendered: ({ startIndex, stopIndex }) => {
                  onSectionRendered({
                    rowStartIndex: startIndex,
                    rowStopIndex: stopIndex,
                  });
                  if (focusOnRender) {
                    dom_focus(rootElement, `.bcp-item-row-${scrollToRow}`);
                  }
                },
              },
              /*#__PURE__*/ react.createElement(Column, {
                dataKey: FIELD_ID,
                cellRenderer: iconCell,
                width: isSmall ? 30 : 50,
                flexShrink: 0,
              }),
              /*#__PURE__*/ react.createElement(Column, {
                dataKey: constants_FIELD_NAME,
                cellRenderer: nameCell,
                width: 300,
                flexGrow: 1,
              }),
              isSmall
                ? null
                : /*#__PURE__*/ react.createElement(Column, {
                    dataKey: FIELD_SHARED_LINK,
                    cellRenderer: shareAccessCell,
                    width: 260,
                    flexShrink: 0,
                  }),
              /*#__PURE__*/ react.createElement(Column, {
                dataKey: FIELD_ID,
                cellRenderer: selectionCell,
                width: isSmall ? 20 : 30,
                flexShrink: 0,
              }),
            ),
          ),
      );
    };
    /* harmony default export */ const content_picker_ItemList = ItemList_ItemList; // CONCATENATED MODULE: ./src/elements/content-picker/Content.js
    /**
     *
     * @file File picker header and list component
     * @author Box
     */

    /**
     * Determines if we should show the empty state
     *
     * @param {string} view the current view
     * @param {Object} currentCollection the current collection
     * @return {boolean} empty or not
     */
    function isEmpty(view, currentCollection) {
      const { items = [] } = currentCollection;
      return view === VIEW_ERROR || items.length === 0;
    }
    const Content = ({
      view,
      rootId,
      isSmall,
      rootElement,
      focusedRow,
      hasHitSelectionLimit,
      selectableType,
      currentCollection,
      tableRef,
      canSetShareAccess,
      isSingleSelect,
      onItemClick,
      onItemSelect,
      onShareAccessChange,
      onFocusChange,
      extensionsWhitelist,
    }) =>
      /*#__PURE__*/ react.createElement(
        'div',
        {
          className: 'bcp-content',
        },
        view === VIEW_ERROR || view === VIEW_SELECTED
          ? null
          : /*#__PURE__*/ react.createElement(progress_bar_ProgressBar, {
              percent: currentCollection.percentLoaded,
            }),
        isEmpty(view, currentCollection)
          ? /*#__PURE__*/ react.createElement(empty_state_EmptyState, {
              view: view,
              isLoading: currentCollection.percentLoaded !== 100,
            })
          : /*#__PURE__*/ react.createElement(content_picker_ItemList, {
              view: view,
              rootId: rootId,
              isSmall: isSmall,
              rootElement: rootElement,
              focusedRow: focusedRow,
              currentCollection: currentCollection,
              tableRef: tableRef,
              canSetShareAccess: canSetShareAccess,
              hasHitSelectionLimit: hasHitSelectionLimit,
              isSingleSelect: isSingleSelect,
              selectableType: selectableType,
              onItemSelect: onItemSelect,
              onItemClick: onItemClick,
              onFocusChange: onFocusChange,
              onShareAccessChange: onShareAccessChange,
              extensionsWhitelist: extensionsWhitelist,
            }),
      );
    /* harmony default export */ const content_picker_Content = Content; // CONCATENATED MODULE: ./src/elements/content-picker/Footer.js
    function content_picker_Footer_extends() {
      return (
        (content_picker_Footer_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        content_picker_Footer_extends.apply(null, arguments)
      );
    }
    /**
     *
     * @file Footer list component
     * @author Box
     */

    const Footer_Footer = ({
      currentCollection,
      selectedCount,
      selectedItems,
      onSelectedClick,
      hasHitSelectionLimit,
      intl,
      isSingleSelect,
      onCancel,
      onChoose,
      chooseButtonLabel,
      cancelButtonLabel,
      children,
      renderCustomActionButtons,
      showSelectedButton,
    }) => {
      const cancelMessage = intl.formatMessage(common_messages.cancel);
      const chooseMessage = intl.formatMessage(common_messages.choose);
      const isChooseButtonDisabled = !selectedCount;
      return /*#__PURE__*/ react.createElement(
        'footer',
        {
          className: 'bcp-footer',
        },
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcp-footer-left',
          },
          showSelectedButton &&
            !isSingleSelect &&
            /*#__PURE__*/ react.createElement(
              button_Button,
              {
                className: 'bcp-selected',
                onClick: onSelectedClick,
                type: 'button',
              },
              /*#__PURE__*/ react.createElement(
                components_message,
                content_picker_Footer_extends(
                  {
                    className: 'bcp-selected-count',
                  },
                  common_messages.selected,
                  {
                    values: {
                      count: selectedCount,
                    },
                  },
                ),
              ),
              hasHitSelectionLimit &&
                /*#__PURE__*/ react.createElement(
                  'span',
                  {
                    className: 'bcp-selected-max',
                  },
                  '(',
                  /*#__PURE__*/ react.createElement(components_message, common_messages.max),
                  ')',
                ),
            ),
        ),
        /*#__PURE__*/ react.createElement(
          'div',
          {
            className: 'bcp-footer-right',
          },
          children,
          renderCustomActionButtons
            ? renderCustomActionButtons({
                currentFolderId: currentCollection.id,
                currentFolderName: currentCollection.name,
                onCancel,
                onChoose,
                selectedCount,
                selectedItems,
              })
            : /*#__PURE__*/ react.createElement(
                button_group_ButtonGroup,
                {
                  className: 'bcp-footer-actions',
                },
                /*#__PURE__*/ react.createElement(
                  common_Tooltip,
                  {
                    text: cancelButtonLabel || cancelMessage,
                  },
                  /*#__PURE__*/ react.createElement(
                    button_Button,
                    {
                      'aria-label': cancelMessage,
                      onClick: onCancel,
                      type: 'button',
                    },
                    /*#__PURE__*/ react.createElement(general_IconClose, {
                      height: 16,
                      width: 16,
                    }),
                  ),
                ),
                /*#__PURE__*/ react.createElement(
                  common_Tooltip,
                  {
                    isDisabled: isChooseButtonDisabled,
                    text: chooseButtonLabel || chooseMessage,
                  },
                  /*#__PURE__*/ react.createElement(
                    primary_button_PrimaryButton,
                    {
                      'aria-label': chooseMessage,
                      disabled: isChooseButtonDisabled, // sets disabled attribute
                      isDisabled: isChooseButtonDisabled, // used in Button component
                      onClick: onChoose,
                      type: 'button',
                    },
                    /*#__PURE__*/ react.createElement(general_IconCheck, {
                      color: '#fff',
                      height: 16,
                      width: 16,
                    }),
                  ),
                ),
              ),
        ),
      );
    };
    /* harmony default export */ const content_picker_Footer = injectIntl(Footer_Footer); // CONCATENATED MODULE: ./src/elements/content-picker/ContentPicker.js
    function ContentPicker_extends() {
      return (
        (ContentPicker_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        ContentPicker_extends.apply(null, arguments)
      );
    }
    function ContentPicker_ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r &&
          (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
          })),
          t.push.apply(t, o);
      }
      return t;
    }
    function ContentPicker_objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2
          ? ContentPicker_ownKeys(Object(t), !0).forEach(function (r) {
              ContentPicker_defineProperty(e, r, t[r]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
            : ContentPicker_ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
              });
      }
      return e;
    }
    function ContentPicker_defineProperty(e, r, t) {
      return (
        (r = ContentPicker_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function ContentPicker_toPropertyKey(t) {
      var i = ContentPicker_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function ContentPicker_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Content Picker Component
     * @author Box
     */

    const defaultType = `${constants_TYPE_FILE},${TYPE_WEBLINK}`;
    class ContentPicker extends react.Component {
      /**
       * [constructor]
       *
       * @private
       * @return {ContentPicker}
       */
      constructor(props) {
        super(props);
        ContentPicker_defineProperty(this, 'firstLoad', true);
        /**
         * Gets selected items from state.
         * Clones values before returning so that
         * object references are broken. Also cleans
         * up the selected attribute since it was
         * added by the file picker.
         *
         * @private
         * @return {BoxItem[]}
         */
        ContentPicker_defineProperty(this, 'getSelectedItems', () => {
          const { selected } = this.state;
          return Object.keys(selected).map(key => {
            const clone = ContentPicker_objectSpread({}, selected[key]);
            delete clone.selected;
            return clone;
          });
        });
        /**
         * Choose button action.
         *
         * @private
         * @fires choose
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'choose', () => {
          const { onChoose } = this.props;
          const results = this.getSelectedItems();
          onChoose(results);
        });
        /**
         * Deletes selected keys off of selected items in state.
         *
         * @private
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'deleteSelectedKeys', () => {
          const { selected } = this.state;

          // Clear out the selected field
          Object.keys(selected).forEach(key => delete selected[key].selected);
        });
        /**
         * Cancel button action
         *
         * @private
         * @fires cancel
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'cancel', () => {
          const { onCancel } = this.props;
          this.deleteSelectedKeys();

          // Reset the selected state
          this.setState(
            {
              selected: {},
            },
            () => onCancel(),
          );
        });
        /**
         * Refreshing the item collection depending
         * upon the view. Collection is gotten from cache.
         * Navigation event is prevented.
         *
         * @private
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'refreshCollection', () => {
          const {
            currentCollection: { id },
            view,
            searchQuery,
          } = this.state;
          if (view === VIEW_FOLDER && id) {
            this.fetchFolder(id, false);
          } else if (view === VIEW_RECENTS) {
            this.showRecents(false);
          } else if (view === VIEW_SEARCH && searchQuery) {
            this.search(searchQuery);
          } else if (view === VIEW_SELECTED) {
            this.showSelected();
          } else {
            throw new Error('Cannot refresh incompatible view!');
          }
        });
        /**
         * Network error callback
         *
         * @private
         * @param {Error} error error object
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'errorCallback', (error, code) => {
          this.setState({
            view: VIEW_ERROR,
          });
          /* eslint-disable no-console */
          console.error(error, code);
          /* eslint-disable no-console */
        });
        /**
         * Action performed when clicking on an item
         *
         * @private
         * @param {Object|string} item - the clicked box item
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'onItemClick', item => {
          // If the id was passed in, just use that
          if (typeof item === 'string') {
            this.fetchFolder(item);
            return;
          }

          // If the item was passed in
          const { id, type } = item;
          if (type === constants_TYPE_FOLDER) {
            this.fetchFolder(id);
          }
        });
        /**
         * Fetches a folder, defaults to fetching root folder
         *
         * @private
         * @param {string|void} [id] folder id
         * @param {Boolean|void} [triggerNavigationEvent] - To focus the grid
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'fetchFolder', (id, triggerNavigationEvent = true) => {
          const { rootFolderId } = this.props;
          const {
            currentCollection: { id: currentId },
            currentOffset,
            currentPageSize: limit,
            searchQuery = '',
            sortBy,
            sortDirection,
          } = this.state;
          const folderId = typeof id === 'string' ? id : rootFolderId;
          const hasFolderChanged = currentId && currentId !== folderId;
          const hasSearchQuery = !!searchQuery.trim().length;
          const offset = hasFolderChanged || hasSearchQuery ? 0 : currentOffset; // Reset offset on folder or mode change

          // If we are navigating around, aka not first load
          // then reset the focus to the root so that after
          // the collection loads the activeElement is not the
          // button that was clicked to fetch the folder
          if (!this.firstLoad) {
            this.rootElement.focus();
          }

          // Reset search state, the view and show busy indicator
          this.setState({
            searchQuery: '',
            view: VIEW_FOLDER,
            currentCollection: this.currentUnloadedCollection(),
            currentOffset: offset,
          });

          // Fetch the folder using folder API
          this.api.getFolderAPI().getFolder(
            folderId,
            limit,
            offset,
            sortBy,
            sortDirection,
            collection => {
              this.fetchFolderSuccessCallback(collection, triggerNavigationEvent);
            },
            this.errorCallback,
            {
              forceFetch: true,
            },
          );
        });
        /**
         * Shows the selected items
         *
         * @private
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'showSelected', () => {
          const { selected, sortBy, sortDirection } = this.state;
          this.setState(
            {
              searchQuery: '',
              view: VIEW_SELECTED,
              currentCollection: {
                sortBy,
                sortDirection,
                percentLoaded: 100,
                items: Object.keys(selected).map(key => this.api.getCache().get(key)),
              },
            },
            this.finishNavigation,
          );
        });
        /**
         * Search success callback
         *
         * @private
         * @param {Object} collection item collection object
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'searchSuccessCallback', collection => {
          const { currentCollection } = this.state;
          this.setState({
            currentCollection: ContentPicker_extends(currentCollection, collection),
          });
        });
        /**
         * Debounced searching
         *
         * @private
         * @param {string} id folder id
         * @param {string} query search string
         * @param {Boolean|void} [forceFetch] To void cache
         * @return {void}
         */
        ContentPicker_defineProperty(
          this,
          'debouncedSearch',
          debounce_default()((id, query) => {
            const { currentOffset, currentPageSize } = this.state;
            this.api
              .getSearchAPI()
              .search(id, query, currentPageSize, currentOffset, this.searchSuccessCallback, this.errorCallback, {
                forceFetch: true,
              });
          }, DEFAULT_SEARCH_DEBOUNCE),
        );
        /**
         * Searches
         *
         * @private
         * @param {string} query search string
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'search', query => {
          const { rootFolderId } = this.props;
          const {
            currentCollection: { id },
            currentOffset,
            searchQuery,
          } = this.state;
          const folderId = typeof id === 'string' ? id : rootFolderId;
          const trimmedQuery = query.trim();
          if (!query) {
            // Cancel the debounce so we don't search on a previous query
            this.debouncedSearch.cancel();

            // Query was cleared out, load the prior folder
            // The prior folder is always the parent folder for search
            this.setState(
              {
                currentOffset: 0,
              },
              () => {
                this.fetchFolder(folderId, false);
              },
            );
            return;
          }
          if (!trimmedQuery) {
            // Query now only has bunch of spaces
            // do nothing and but update prior state
            this.setState({
              searchQuery: query,
            });
            return;
          }
          this.setState({
            searchQuery: query,
            view: VIEW_SEARCH,
            currentCollection: this.currentUnloadedCollection(),
            currentOffset: trimmedQuery === searchQuery ? currentOffset : 0,
          });
          this.debouncedSearch(folderId, query);
        });
        /**
         * Uploads
         *
         * @private
         * @param {File} file dom file object
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'upload', () => {
          const {
            currentCollection: { id, permissions },
          } = this.state;
          const { canUpload } = this.props;
          if (!id || !permissions) {
            return;
          }
          const { can_upload: canUploadPermission } = permissions;
          if (!canUpload || !canUploadPermission) {
            return;
          }
          this.setState({
            isUploadModalOpen: true,
          });
        });
        /**
         * Upload success handler
         *
         * @private
         * @param {File} file dom file object
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'uploadSuccessHandler', () => {
          const {
            currentCollection: { id },
          } = this.state;
          this.fetchFolder(id, false);
        });
        /**
         * Creates a new folder
         *
         * @private
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'createFolder', () => {
          this.createFolderCallback();
        });
        /**
         * New folder callback
         *
         * @private
         * @param {string} name - folder name
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'createFolderCallback', name => {
          const { isCreateFolderModalOpen, currentCollection } = this.state;
          const { canCreateNewFolder } = this.props;
          if (!canCreateNewFolder) {
            return;
          }
          const { id, permissions } = currentCollection;
          if (!id || !permissions) {
            return;
          }
          const { can_upload } = permissions;
          if (!can_upload) {
            return;
          }
          if (!isCreateFolderModalOpen || !name) {
            this.setState({
              isCreateFolderModalOpen: true,
              errorCode: '',
            });
            return;
          }
          if (!name.trim()) {
            this.setState({
              errorCode: ERROR_CODE_ITEM_NAME_INVALID,
              isLoading: false,
            });
            return;
          }
          if (name.length > 255) {
            this.setState({
              errorCode: ERROR_CODE_ITEM_NAME_TOO_LONG,
              isLoading: false,
            });
            return;
          }
          this.setState({
            isLoading: true,
          });
          this.api.getFolderAPI().create(
            id,
            name.trim(),
            () => {
              this.fetchFolder(id);
            },
            ({ response: { status } }) => {
              this.setState({
                errorCode: status === 409 ? ERROR_CODE_ITEM_NAME_IN_USE : ERROR_CODE_ITEM_NAME_INVALID,
                isLoading: false,
              });
            },
          );
        });
        /**
         * Selects or unselects an item
         *
         * @private
         * @param {Object} item file or folder object
         * @param {boolean} options.forceSharedLink Force a shared link if no link exists
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'select', (item, { forceSharedLink = true } = {}) => {
          const { canSetShareAccess, type: selectableType, maxSelectable } = this.props;
          const {
            view,
            selected,
            currentCollection: { items = [] },
          } = this.state;
          const { id, type } = item;
          if (!id || !type || selectableType.indexOf(type) === -1) {
            return;
          }
          const selectedKeys = Object.keys(selected);
          const selectedCount = selectedKeys.length;
          const hasHitSelectionLimit = selectedCount === maxSelectable;
          const isSingleFileSelection = maxSelectable === 1;
          const cacheKey = this.api.getAPI(type).getCacheKey(id);
          const existing = selected[cacheKey];
          const existingFromCache = this.api.getCache().get(cacheKey);
          const existInSelected = selectedKeys.indexOf(cacheKey) !== -1;

          // Existing object could have mutated and we just need to update the
          // reference in the selected map. In that case treat it like a new selection.
          if (existing && existing === existingFromCache) {
            // We are selecting the same item that was already
            // selected. Unselect it in this case. Toggle case.
            delete existing.selected;
            delete selected[cacheKey];
          } else {
            // We are selecting a new item that was never
            // selected before. However if we are in a single
            // item selection mode, we should also unselect any
            // prior item that was selected.

            // Check if we hit the selection limit and if selection
            // is not already currently in the selected data structure.
            // Ignore when in single file selection mode.
            if (hasHitSelectionLimit && !isSingleFileSelection && !existInSelected) {
              return;
            }

            // Clear out the prior item for single file selection mode
            if (selectedCount > 0 && isSingleFileSelection) {
              const prior = selectedKeys[0]; // only one item
              delete selected[prior].selected;
              delete selected[prior];
            }

            // Select the new item
            item.selected = true;
            selected[cacheKey] = item;

            // If can set share access, fetch the shared link properties of the item
            // In the case where another item is selected, any in flight XHR will get
            // cancelled
            if (canSetShareAccess && forceSharedLink) {
              this.fetchSharedLinkInfo(item);
            }
          }
          const focusedRow = items.findIndex(i => i.id === item.id);
          this.setState(
            {
              selected,
              focusedRow,
            },
            () => {
              if (view === VIEW_SELECTED) {
                // Need to refresh the selected view
                this.showSelected();
              }
            },
          );
        });
        /**
         * Fetch the shared link info
         * @param {BoxItem} item - The item (folder, file, weblink)
         * @returns {void}
         */
        ContentPicker_defineProperty(this, 'fetchSharedLinkInfo', item => {
          const { id, type } = item;
          switch (type) {
            case constants_TYPE_FOLDER:
              this.api.getFolderAPI().getFolderFields(id, this.handleSharedLinkSuccess, noop_default(), {
                fields: FILE_SHARED_LINK_FIELDS_TO_FETCH,
              });
              break;
            case constants_TYPE_FILE:
              this.api.getFileAPI().getFile(id, this.handleSharedLinkSuccess, noop_default(), {
                fields: FILE_SHARED_LINK_FIELDS_TO_FETCH,
              });
              break;
            case TYPE_WEBLINK:
              this.api.getWebLinkAPI().getWeblink(id, this.handleSharedLinkSuccess, noop_default(), {
                fields: FILE_SHARED_LINK_FIELDS_TO_FETCH,
              });
              break;
            default:
              throw new Error('Unknown Type');
          }
        });
        /**
         * Handles the shared link info by either creating a share link using enterprise defaults if
         * it does not already exist, otherwise update the item in the state currentCollection.
         *
         * @param {Object} item file or folder
         * @returns {void}
         */
        ContentPicker_defineProperty(this, 'handleSharedLinkSuccess', async item => {
          const { selected } = this.state;
          const { id, type } = item;
          // $FlowFixMe
          const cacheKey = this.api.getAPI(type).getCacheKey(id);
          let updatedItem = item;

          // if there is no shared link, create one with enterprise default access
          if (!item[FIELD_SHARED_LINK] && get_default()(item, FIELD_PERMISSIONS_CAN_SHARE, false)) {
            // $FlowFixMe
            await this.api.getAPI(item.type).share(item, undefined, sharedItem => {
              updatedItem = sharedItem;
            });
          }
          this.updateItemInCollection(updatedItem);
          if (updatedItem.selected && updatedItem !== selected[cacheKey]) {
            this.select(updatedItem, {
              forceSharedLink: false,
            });
          }
        });
        /**
         * Changes the share access of an item
         *
         * @private
         * @param {string} access share access
         * @param {Object} item file or folder object
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'changeShareAccess', (access, item) => {
          const { canSetShareAccess } = this.props;
          if (!item || !canSetShareAccess) {
            return;
          }
          const { permissions, type } = item;
          if (!permissions || !type) {
            return;
          }
          const { can_set_share_access } = permissions;
          if (!can_set_share_access) {
            return;
          }
          this.api.getAPI(type).share(item, access, updatedItem => {
            this.updateItemInCollection(updatedItem);
            if (item.selected) {
              this.select(updatedItem, {
                forceSharedLink: false,
              });
            }
          });
        });
        /**
         * Updates the BoxItem in the state's currentCollection
         *
         * @param {Object} item file or folder object
         * @returns {void}
         */
        ContentPicker_defineProperty(this, 'updateItemInCollection', item => {
          const { currentCollection } = this.state;
          const { items = [] } = currentCollection;
          const newState = {
            currentCollection: ContentPicker_objectSpread(
              ContentPicker_objectSpread({}, currentCollection),
              {},
              {
                items: items.map(collectionItem => (collectionItem.id === item.id ? item : collectionItem)),
              },
            ),
          };
          this.setState(newState);
        });
        /**
         * Changes the sort by and sort direction
         *
         * @private
         * @param {string} sortBy - field to sorty by
         * @param {string} sortDirection - sort direction
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'sort', (sortBy, sortDirection) => {
          const {
            currentCollection: { id },
          } = this.state;
          if (id) {
            this.setState(
              {
                sortBy,
                sortDirection,
              },
              this.refreshCollection,
            );
          }
        });
        /**
         * Saves reference to table component
         *
         * @private
         * @param {Component} react component
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'tableRef', table => {
          this.table = table;
        });
        /**
         * Closes the modal dialogs that may be open
         *
         * @private
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'closeModals', () => {
          const { focusedRow } = this.state;
          this.setState({
            isLoading: false,
            isCreateFolderModalOpen: false,
            isUploadModalOpen: false,
          });
          const {
            selected,
            currentCollection: { items = [] },
          } = this.state;
          if (selected && items.length > 0) {
            dom_focus(this.rootElement, `.bcp-item-row-${focusedRow}`);
          }
        });
        /**
         * Keyboard events
         *
         * @private
         * @inheritdoc
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'onKeyDown', event => {
          if (isInputElement(event.target)) {
            return;
          }
          const { rootFolderId } = this.props;
          const key = event.key.toLowerCase();
          switch (key) {
            case '/':
              dom_focus(this.rootElement, '.be-search input[type="search"]', false);
              event.preventDefault();
              break;
            case 'arrowdown':
              dom_focus(this.rootElement, '.bcp-item-row', false);
              this.setState({
                focusedRow: 0,
              });
              event.preventDefault();
              break;
            case 'g':
              break;
            case 'b':
              if (this.globalModifier) {
                dom_focus(this.rootElement, '.be-breadcrumb button', false);
                event.preventDefault();
              }
              break;
            case 'f':
              if (this.globalModifier) {
                this.fetchFolder(rootFolderId);
                event.preventDefault();
              }
              break;
            case 'c':
              if (this.globalModifier) {
                this.choose();
                event.preventDefault();
              }
              break;
            case 'x':
              if (this.globalModifier) {
                this.cancel();
                event.preventDefault();
              }
              break;
            case 's':
              if (this.globalModifier) {
                this.showSelected();
                event.preventDefault();
              }
              break;
            case 'u':
              if (this.globalModifier) {
                this.upload();
                event.preventDefault();
              }
              break;
            case 'r':
              if (this.globalModifier) {
                this.showRecents();
                event.preventDefault();
              }
              break;
            case 'n':
              if (this.globalModifier) {
                this.createFolder();
                event.preventDefault();
              }
              break;
            default:
              this.globalModifier = false;
              return;
          }
          this.globalModifier = key === 'g';
        });
        /**
         * Updates the focused row based on key binder
         *
         * @private
         * @param {number} focusedRow - the row index thats focused
         * @return {void}
         */
        ContentPicker_defineProperty(this, 'onFocusChange', focusedRow => {
          this.setState({
            focusedRow,
          });
        });
        /**
         * Handle pagination changes
         *
         * @param {number} newOffset - the new page offset value
         */
        ContentPicker_defineProperty(this, 'paginate', newOffset => {
          this.setState(
            {
              currentOffset: newOffset,
            },
            this.refreshCollection,
          );
        });
        const {
          apiHost,
          clientName,
          initialPage,
          initialPageSize,
          language,
          requestInterceptor,
          responseInterceptor,
          rootFolderId: _rootFolderId,
          sharedLink,
          sharedLinkPassword,
          sortBy: _sortBy,
          sortDirection: _sortDirection,
          token,
          uploadHost,
        } = props;
        this.api = new api_APIFactory({
          apiHost,
          clientName,
          id: `${TYPED_ID_FOLDER_PREFIX}${_rootFolderId}`,
          language,
          requestInterceptor,
          responseInterceptor,
          sharedLink,
          sharedLinkPassword,
          token,
          uploadHost,
        });
        this.id = uniqueId_default()('bcp_');
        this.state = {
          sortBy: _sortBy,
          sortDirection: _sortDirection,
          rootName: '',
          currentCollection: {},
          currentOffset: initialPageSize * (initialPage - 1),
          currentPageSize: initialPageSize,
          selected: {},
          searchQuery: '',
          view: VIEW_FOLDER,
          isCreateFolderModalOpen: false,
          isUploadModalOpen: false,
          focusedRow: 0,
          isLoading: false,
          errorCode: '',
        };
      }

      /**
       * Destroys api instances
       *
       * @private
       * @return {void}
       */
      clearCache() {
        this.api.destroy(true);
      }

      /**
       * Cleanup
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      componentWillUnmount() {
        this.clearCache();
      }

      /**
       * Fetches the root folder on load
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      componentDidMount() {
        const { defaultView, currentFolderId } = this.props;
        this.rootElement = document.getElementById(this.id);
        this.appElement = this.rootElement.firstElementChild;
        if (defaultView === DEFAULT_VIEW_RECENTS) {
          this.showRecents();
        } else {
          this.fetchFolder(currentFolderId);
        }
      }

      /**
       * Fetches the current folder if different
       * from what was already fetched before.
       *
       * @private
       * @inheritdoc
       * @return {void}
       */
      componentDidUpdate({ currentFolderId: prevFolderId }, prevState) {
        const { currentFolderId } = this.props;
        const {
          currentCollection: { id },
        } = prevState;
        if (prevFolderId === currentFolderId) {
          return;
        }
        if (typeof currentFolderId === 'string' && id !== currentFolderId) {
          this.fetchFolder(currentFolderId);
        }
      }
      /**
       * Resets the percentLoaded in the collection
       * so that the loading bar starts showing
       *
       * @private
       * @return {Collection}
       */
      currentUnloadedCollection() {
        const { currentCollection } = this.state;
        return ContentPicker_extends(currentCollection, {
          percentLoaded: 0,
        });
      }
      /**
       * Focuses the grid
       *
       * @private
       * @return {void}
       */
      finishNavigation() {
        const { autoFocus } = this.props;
        const {
          currentCollection: { percentLoaded },
        } = this.state;

        // If loading for the very first time, only allow focus if autoFocus is true
        if (this.firstLoad && !autoFocus) {
          this.firstLoad = false;
          return;
        }

        // Don't focus the grid until its loaded and user is not already on an interactable element
        if (percentLoaded === 100 && !isFocusableElement(document.activeElement)) {
          dom_focus(this.rootElement, '.bcp-item-row');
          this.setState({
            focusedRow: 0,
          });
        }
        this.firstLoad = false;
      }

      /**
       * Folder fetch success callback
       *
       * @private
       * @param {Object} collection item collection object
       * @param {Boolean|void} triggerNavigationEvent - To focus the grid
       * @return {void}
       */
      fetchFolderSuccessCallback(collection, triggerNavigationEvent) {
        const { clearSelectedItemsOnNavigation, rootFolderId } = this.props;
        const { id, name } = collection;
        const commonState = {
          currentCollection: collection,
          rootName: id === rootFolderId ? name : '',
        };

        // New folder state
        const newState = clearSelectedItemsOnNavigation
          ? ContentPicker_objectSpread(
              ContentPicker_objectSpread({}, commonState),
              {},
              {
                selected: {},
              },
            )
          : commonState;

        // Close any open modals
        this.closeModals();

        // Deletes selected keys
        if (clearSelectedItemsOnNavigation) {
          this.deleteSelectedKeys();
        }
        if (triggerNavigationEvent) {
          // Fire folder navigation event
          this.setState(newState, this.finishNavigation);
        } else {
          this.setState(newState);
        }
      }
      /**
       * Recents fetch success callback
       *
       * @private
       * @param {Object} collection item collection object
       * @param {Boolean|void} [triggerNavigationEvent] To trigger navigate event
       * @return {void}
       */
      recentsSuccessCallback(collection, triggerNavigationEvent) {
        const newState = {
          currentCollection: collection,
        };
        if (triggerNavigationEvent) {
          this.setState(newState, this.finishNavigation);
        } else {
          this.setState(newState);
        }
      }

      /**
       * Shows recents.
       * We always try to force fetch recents.
       *
       * @private
       * @param {Boolean|void} [triggerNavigationEvent] To trigger navigate event
       * @param {Boolean|void} [forceFetch] To void cache
       * @return {void}
       */
      showRecents(triggerNavigationEvent = true) {
        const { rootFolderId } = this.props;

        // Reset search state, the view and show busy indicator
        this.setState({
          searchQuery: '',
          view: VIEW_RECENTS,
          currentCollection: this.currentUnloadedCollection(),
          currentOffset: 0,
        });

        // Fetch the folder using folder API
        this.api.getRecentsAPI().recents(
          rootFolderId,
          collection => {
            this.recentsSuccessCallback(collection, triggerNavigationEvent);
          },
          this.errorCallback,
          {
            forceFetch: true,
          },
        );
      }
      /**
       * Renders the file picker
       *
       * @private
       * @inheritdoc
       * @return {Element}
       */
      render() {
        const {
          language,
          messages,
          rootFolderId,
          logoUrl,
          canUpload,
          canSetShareAccess,
          canCreateNewFolder,
          contentUploaderProps,
          extensions,
          maxSelectable,
          type,
          token,
          sharedLink,
          sharedLinkPassword,
          apiHost,
          uploadHost,
          isHeaderLogoVisible,
          isPaginationVisible,
          isSmall,
          className,
          measureRef,
          chooseButtonLabel,
          cancelButtonLabel,
          requestInterceptor,
          responseInterceptor,
          renderCustomActionButtons,
          showSelectedButton,
        } = this.props;
        const {
          view,
          rootName,
          selected,
          currentCollection,
          currentPageSize,
          searchQuery,
          isCreateFolderModalOpen,
          isUploadModalOpen,
          isLoading,
          errorCode,
          focusedRow,
        } = this.state;
        const { id, offset, permissions, totalCount } = currentCollection;
        const { can_upload } = permissions || {};
        const selectedCount = Object.keys(selected).length;
        const isSingleSelect = maxSelectable === 1;
        const hasHitSelectionLimit = selectedCount === maxSelectable && !isSingleSelect;
        const allowUpload = canUpload && !!can_upload;
        const allowCreate = canCreateNewFolder && !!can_upload;
        const styleClassName = classnames_default()('be bcp', className);

        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
        return /*#__PURE__*/ react.createElement(
          common_Internationalize,
          {
            language: language,
            messages: messages,
          },
          /*#__PURE__*/ react.createElement(
            'div',
            {
              id: this.id,
              className: styleClassName,
              ref: measureRef,
              'data-testid': 'content-picker',
            },
            /*#__PURE__*/ react.createElement(
              'div',
              {
                className: 'be-app-element',
                onKeyDown: this.onKeyDown,
                tabIndex: 0,
              },
              /*#__PURE__*/ react.createElement(header_Header, {
                view: view,
                isHeaderLogoVisible: isHeaderLogoVisible,
                isSmall: isSmall,
                searchQuery: searchQuery,
                logoUrl: logoUrl,
                onSearch: this.search,
              }),
              /*#__PURE__*/ react.createElement(sub_header_SubHeader, {
                view: view,
                rootId: rootFolderId,
                isSmall: isSmall,
                rootName: rootName,
                currentCollection: currentCollection,
                canUpload: allowUpload,
                canCreateNewFolder: allowCreate,
                onUpload: this.upload,
                onCreate: this.createFolder,
                onItemClick: this.fetchFolder,
                onSortChange: this.sort,
              }),
              /*#__PURE__*/ react.createElement(content_picker_Content, {
                view: view,
                isSmall: isSmall,
                rootId: rootFolderId,
                rootElement: this.rootElement,
                focusedRow: focusedRow,
                selectableType: type,
                canSetShareAccess: canSetShareAccess,
                extensionsWhitelist: extensions,
                hasHitSelectionLimit: hasHitSelectionLimit,
                currentCollection: currentCollection,
                isSingleSelect: isSingleSelect,
                tableRef: this.tableRef,
                onItemSelect: this.select,
                onItemClick: this.onItemClick,
                onFocusChange: this.onFocusChange,
                onShareAccessChange: this.changeShareAccess,
              }),
              /*#__PURE__*/ react.createElement(
                content_picker_Footer,
                {
                  currentCollection: currentCollection,
                  selectedCount: selectedCount,
                  selectedItems: this.getSelectedItems(),
                  showSelectedButton: showSelectedButton,
                  hasHitSelectionLimit: hasHitSelectionLimit,
                  isSingleSelect: isSingleSelect,
                  onSelectedClick: this.showSelected,
                  onChoose: this.choose,
                  onCancel: this.cancel,
                  chooseButtonLabel: chooseButtonLabel,
                  cancelButtonLabel: cancelButtonLabel,
                  renderCustomActionButtons: renderCustomActionButtons,
                },
                isPaginationVisible
                  ? /*#__PURE__*/ react.createElement(pagination_Pagination, {
                      offset: offset,
                      onOffsetChange: this.paginate,
                      pageSize: currentPageSize,
                      totalCount: totalCount,
                    })
                  : null,
              ),
            ),
            allowUpload && !!this.appElement
              ? /*#__PURE__*/ react.createElement(upload_dialog_UploadDialog, {
                  isOpen: isUploadModalOpen,
                  currentFolderId: id,
                  token: token,
                  sharedLink: sharedLink,
                  sharedLinkPassword: sharedLinkPassword,
                  apiHost: apiHost,
                  uploadHost: uploadHost,
                  onClose: this.uploadSuccessHandler,
                  parentElement: this.rootElement,
                  appElement: this.appElement,
                  contentUploaderProps: contentUploaderProps,
                  requestInterceptor: requestInterceptor,
                  responseInterceptor: responseInterceptor,
                })
              : null,
            allowCreate && !!this.appElement
              ? /*#__PURE__*/ react.createElement(create_folder_dialog_CreateFolderDialog, {
                  isOpen: isCreateFolderModalOpen,
                  onCreate: this.createFolderCallback,
                  onCancel: this.closeModals,
                  isLoading: isLoading,
                  errorCode: errorCode,
                  parentElement: this.rootElement,
                  appElement: this.appElement,
                })
              : null,
          ),
        );
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      }
    }
    // Keeps track of very 1st load
    ContentPicker_defineProperty(ContentPicker, 'defaultProps', {
      type: defaultType,
      rootFolderId: DEFAULT_ROOT,
      onChoose: noop_default(),
      onCancel: noop_default(),
      initialPage: DEFAULT_PAGE_NUMBER,
      initialPageSize: DEFAULT_PAGE_SIZE,
      sortBy: constants_FIELD_NAME,
      sortDirection: SORT_ASC,
      extensions: [],
      maxSelectable: Infinity,
      canUpload: true,
      canSetShareAccess: true,
      canCreateNewFolder: true,
      autoFocus: false,
      className: '',
      apiHost: DEFAULT_HOSTNAME_API,
      uploadHost: DEFAULT_HOSTNAME_UPLOAD,
      clientName: CLIENT_NAME_CONTENT_PICKER,
      defaultView: DEFAULT_VIEW_FILES,
      contentUploaderProps: {},
      showSelectedButton: true,
      clearSelectedItemsOnNavigation: false,
      isHeaderLogoVisible: true,
      isPaginationVisible: true,
    });

    /* harmony default export */ const content_picker_ContentPicker = common_makeResponsive(ContentPicker); // CONCATENATED MODULE: ./src/elements/content-picker/ContentPickerPopup.js
    /**
     *
     * @file Content Picker Popup Component
     * @author Box
     */

    /* harmony default export */ const ContentPickerPopup =
      common_makePopup(CLIENT_NAME_CONTENT_PICKER)(content_picker_ContentPicker); // CONCATENATED MODULE: ./src/elements/wrappers/ContentPicker.js
    const ContentPicker_excluded = ['modal'];
    function wrappers_ContentPicker_extends() {
      return (
        (wrappers_ContentPicker_extends = Object.assign
          ? Object.assign.bind()
          : function (n) {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
              }
              return n;
            }),
        wrappers_ContentPicker_extends.apply(null, arguments)
      );
    }
    function ContentPicker_objectWithoutProperties(e, t) {
      if (null == e) return {};
      var o,
        r,
        i = ContentPicker_objectWithoutPropertiesLoose(e, t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for (r = 0; r < s.length; r++)
          (o = s[r]), t.includes(o) || ({}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]));
      }
      return i;
    }
    function ContentPicker_objectWithoutPropertiesLoose(r, e) {
      if (null == r) return {};
      var t = {};
      for (var n in r)
        if ({}.hasOwnProperty.call(r, n)) {
          if (e.includes(n)) continue;
          t[n] = r[n];
        }
      return t;
    }
    function wrappers_ContentPicker_defineProperty(e, r, t) {
      return (
        (r = wrappers_ContentPicker_toPropertyKey(r)) in e
          ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 })
          : (e[r] = t),
        e
      );
    }
    function wrappers_ContentPicker_toPropertyKey(t) {
      var i = wrappers_ContentPicker_toPrimitive(t, 'string');
      return 'symbol' == typeof i ? i : i + '';
    }
    function wrappers_ContentPicker_toPrimitive(t, r) {
      if ('object' != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != typeof i) return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return ('string' === r ? String : Number)(t);
    }
    /**
     *
     * @file Base class for the Content Picker ES6 wrapper
     * @author Box
     */

    // TODO switch to createRoot when upgrading to React 18
    // eslint-disable-next-line react/no-deprecated

    class ContentPicker_ContentPicker extends wrappers_ES6Wrapper {
      constructor(...args) {
        super(...args);
        /**
         * Callback for pressing choose
         *
         * @param {Array} data - chosen box items
         * @return {void}
         */
        wrappers_ContentPicker_defineProperty(this, 'onChoose', data => {
          this.emit('choose', data);
        });
        /**
         * Callback for pressing cancel
         *
         * @return {void}
         */
        wrappers_ContentPicker_defineProperty(this, 'onCancel', () => {
          this.emit('cancel');
        });
      }
      /**
       * Returns the type of content picker
       *
       * @return {void}
       */
      getType() {
        const { type } = this.options || {};
        return type || `${constants_TYPE_FOLDER},${constants_TYPE_FILE},${TYPE_WEBLINK}`;
      }

      /**
       * Returns the name for content picker
       *
       * @return {void}
       */
      getClientName() {
        return CLIENT_NAME_CONTENT_PICKER;
      }

      /** @inheritdoc */
      render() {
        const _this$options = this.options,
          { modal } = _this$options,
          rest = ContentPicker_objectWithoutProperties(_this$options, ContentPicker_excluded);
        const PickerComponent = modal ? ContentPickerPopup : content_picker_ContentPicker;
        (0, react_dom.render)(
          /*#__PURE__*/ react.createElement(
            PickerComponent,
            wrappers_ContentPicker_extends(
              {
                clientName: this.getClientName(),
                componentRef: this.setComponent,
                language: this.language,
                messages: this.messages,
                modal: modal,
                onCancel: this.onCancel,
                onChoose: this.onChoose,
                rootFolderId: this.id,
                token: this.token,
                type: this.getType(),
              },
              rest,
            ),
          ),
          this.container,
        );
      }
    }
    /* harmony default export */ const wrappers_ContentPicker = ContentPicker_ContentPicker; // CONCATENATED MODULE: ./src/elements/wrappers/FilePicker.js
    /**
     *
     * @file Main entry point for the File Picker ES6 wrapper
     * @author Box
     */

    class FilePicker extends wrappers_ContentPicker {
      /** @inheritdoc */
      getType() {
        return `${constants_TYPE_FILE},${TYPE_WEBLINK}`;
      }

      /** @inheritdoc */
      getClientName() {
        return CLIENT_NAME_FILE_PICKER;
      }
    }
    /* harmony default export */ const wrappers_FilePicker = FilePicker; // CONCATENATED MODULE: ./src/elements/wrappers/FolderPicker.js
    /**
     *
     * @file Main entry point for the Folder Picker ES6 wrapper
     * @author Box
     */

    class FolderPicker extends wrappers_ContentPicker {
      /** @inheritdoc */
      getType() {
        return constants_TYPE_FOLDER;
      }

      /** @inheritdoc */
      getClientName() {
        return CLIENT_NAME_FOLDER_PICKER;
      }
    }
    /* harmony default export */ const wrappers_FolderPicker = FolderPicker; // CONCATENATED MODULE: ./src/elements/wrappers/ContentPickers.js
    /**
     * @file Main entry point for the Content Pickers ES6 wrapper
     * @author Box
     */

    __webpack_require__.g.Box = __webpack_require__.g.Box || {};
    __webpack_require__.g.Box.FilePicker = wrappers_FilePicker;
    __webpack_require__.g.Box.FolderPicker = wrappers_FolderPicker;
    __webpack_require__.g.Box.ContentPicker = wrappers_ContentPicker;
  })();

  /******/
})();
